// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"7iKr0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "i18n", ()=>i18n);
var _jsxRuntime = require("react/jsx-runtime");
var _coreApplication = require("@form-engine/core-application");
var _coreApplicationDefault = parcelHelpers.interopDefault(_coreApplication);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _plugins = require("./plugins");
var _app = require("./components/app");
var _appDefault = parcelHelpers.interopDefault(_app);
var _themeScss = require("./style/theme.scss");
var _registerPlugin = require("@form-engine/core-util/register-plugin");
var _i18N = require("@form-engine/core-application/utilities/i18n");
var _builderTranslations = require("./builder-translations");
const Builder = {
    apiBaseUrl: location.origin,
    basename: '/',
    renderFormRoute: '/form/:formId',
    loginMethods: [
        'credentials'
    ],
    oidcRoute: '/msal',
    sessionMaxAge: 7200000,
    autoload: true,
    selector: '#app-root',
    keybindings: {},
    initDocument (doc = document) {
        return Array.from(doc.querySelectorAll((0, _coreApplicationDefault.default).Builder.selector)).map((0, _coreApplicationDefault.default).Builder.initUi);
    },
    initUi (rootElement) {
        const root = (0, _client.createRoot)(rootElement);
        root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).StrictMode, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appDefault.default), {})
        }));
    },
    getComponentExtensions (componentName, filter) {
        let extensions = {
            ...Builder?.componentExtensions?.[componentName] ?? {}
        };
        if (filter) extensions = Object.fromEntries(Object.entries(extensions).filter(([, def])=>filter(def)));
        return extensions;
    },
    renderComponentExtensions (componentName, filter) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: Object.entries(Builder.getComponentExtensions(componentName, filter)).map(([key, def])=>{
                const { component: Component } = def;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {}, key);
            })
        });
    },
    ...(0, _coreApplicationDefault.default)?.Builder || {},
    elements: Object.fromEntries(Object.entries({
        ...(0, _coreApplicationDefault.default)?.Builder?.elements || {}
    }).map(([key, def])=>[
            def?.Element?.apiName || key,
            def
        ])),
    datasources: Object.fromEntries(Object.entries({
        ...(0, _coreApplicationDefault.default)?.Builder?.datasources || {}
    }).map(([key, def])=>[
            def?.Datasource?.apiName || key,
            def
        ])),
    workflowLayers: Object.fromEntries(Object.entries({
        ...(0, _coreApplicationDefault.default)?.Builder?.workflowLayers || {}
    }).map(([key, def])=>[
            def?.WorkflowLayer?.apiName || key,
            def
        ])),
    translations: {
        ..._builderTranslations,
        ...(0, _coreApplicationDefault.default)?.Builder?.translations ?? {}
    },
    // null is only a placeholder here, to supress the ts error. i18n is initialized at the bottom of the file
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    i18n: null,
    formEmbeds: {},
    formStudioViews: {},
    formPresets: {},
    componentExtensions: {},
    maskConfigurations: {}
};
(0, _registerPlugin.registerImportedPluginModules)(Builder, _plugins);
(0, _coreApplicationDefault.default).Builder = Builder;
(0, _coreApplicationDefault.default).isBuilder = true;
Builder.i18n = new (0, _i18N.I18n)({
    data: Builder.translations
});
const i18n = Builder.i18n;
exports.default = Builder;
window.addEventListener('DOMContentLoaded', ()=>{
    if (Builder.autoload) Builder.initDocument();
});

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application":"fjN6J","react":"9njXz","react-dom/client":"hx7eL","./plugins":"ajEzA","./components/app":"duaVn","./style/theme.scss":"kzXu8","@form-engine/core-util/register-plugin":"45jyA","@form-engine/core-application/utilities/i18n":"9DQ3u","./builder-translations":"1py55","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1dlk8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"8eUfv"}],"8eUfv":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"9njXz"}],"9njXz":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"kgZgX"}],"kgZgX":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"fjN6J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "i18n", ()=>i18n);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _embeddedApplication = require("./components/embedded-application");
var _embeddedApplicationDefault = parcelHelpers.interopDefault(_embeddedApplication);
// workaround to only import stylesheets with parcel, not with storybook
// import(/* webpackIgnore: true */'./style/theme.scss');
var _themeScss = require("./style/theme.scss");
var _coreTranslations = require("./core-translations");
var _plugins = require("./plugins");
var _validations = require("./validation/validations");
var _registerPlugin = require("@form-engine/core-util/register-plugin");
var _i18N = require("./utilities/i18n");
const prevFormEngine = window.FormEngine ?? {};
const FormEngine = {
    environment: 'dev',
    version: 'alpha',
    wflBackendRoute: `/form/:formId/workflow/:wflId`,
    datasourceBackendRoute: `/form/:formId/datasource/:datasourceId`,
    elementControllerBackendRoute: `/form/:formId/element/:elementId`,
    autoload: true,
    selector: 'script[type="application/form-engine-configuration"]',
    isBuilder: false,
    initDocument (doc = document) {
        return Array.from(doc.querySelectorAll(FormEngine.selector)).map((node)=>FormEngine.initFormFromConstructorNode(node));
    },
    initFormFromConstructorNode (constructorNode) {
        let options = {};
        try {
            options = JSON.parse(constructorNode.textContent ?? '');
        } catch (e) {
            console.error(e);
            return null;
        }
        return FormEngine.initForm(constructorNode, options);
    },
    initForm (siblingNode, options) {
        const rootElement = document.createElement('div');
        rootElement.className = 'fe-root';
        siblingNode?.parentNode?.insertBefore(rootElement, siblingNode.nextSibling);
        if (!options?.form) throw new Error(`invalid form constructor, missing form definition`);
        const root = (0, _client.createRoot)(rootElement);
        root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).StrictMode, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _embeddedApplicationDefault.default), {
                ...options
            })
        }));
        return root;
    },
    destroyForm (root) {
        root.unmount();
    },
    getFieldElements () {
        return Object.fromEntries(Object.entries(FormEngine?.elements ?? {}).filter((entry)=>Boolean(entry[1].isField)));
    },
    getContainerElements () {
        return Object.fromEntries(Object.entries(FormEngine?.elements ?? {}).filter((entry)=>Boolean(entry[1].isContainer)));
    },
    ...prevFormEngine ?? {},
    elements: {
        ...prevFormEngine?.elements ?? {}
    },
    datasources: {
        ...prevFormEngine?.datasources ?? {}
    },
    workflowLayers: {
        ...prevFormEngine?.workflowLayers ?? {}
    },
    validations: {
        ..._validations,
        ...prevFormEngine?.validations ?? {}
    },
    translations: {
        ..._coreTranslations,
        ...prevFormEngine?.translations ?? {}
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    i18n: null
};
window.FormEngine = FormEngine;
(0, _registerPlugin.registerImportedPluginModules)(FormEngine, _plugins);
FormEngine.i18n = new (0, _i18N.I18n)({
    data: FormEngine.translations
});
const i18n = FormEngine.i18n;
exports.default = FormEngine;
window.addEventListener('DOMContentLoaded', ()=>{
    if (FormEngine.autoload) FormEngine.initDocument();
});

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-dom/client":"hx7eL","./components/embedded-application":"2lW8g","./style/theme.scss":"hkAR3","./core-translations":"lLUIH","./plugins":"efQsn","./validation/validations":"bJfzW","@form-engine/core-util/register-plugin":"45jyA","./utilities/i18n":"9DQ3u","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hx7eL":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"2ApDx"}],"2ApDx":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"3ekrv"}],"3ekrv":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"9njXz","ece50e903283a22f":"eTyLO"}],"eTyLO":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"i8Rha"}],"i8Rha":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"2lW8g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FormEngineEmbeddedApplication);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _engine = require("./engine");
var _engineDefault = parcelHelpers.interopDefault(_engine);
var _useForm = require("../hooks/use-form");
function FormEngineEmbeddedApplication({ form, session }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useForm.FormProvider), {
        value: form,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _engineDefault.default), {
            value: session || {}
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./engine":"8IyYu","../hooks/use-form":"5PZyy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8IyYu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormEngineGlobalDatasource", ()=>FormEngineGlobalDatasource);
parcelHelpers.export(exports, "FormEngineGlobalDatasourceLoader", ()=>FormEngineGlobalDatasourceLoader);
parcelHelpers.export(exports, "FormEngineRenderer", ()=>FormEngineRenderer);
parcelHelpers.export(exports, "default", ()=>FormEngine);
parcelHelpers.export(exports, "FormEngineStateProvider", ()=>FormEngineStateProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _useForm = require("../hooks/use-form");
var _element = require("./element");
var _elementDefault = parcelHelpers.interopDefault(_element);
var _container = require("./container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _useFormsession = require("../hooks/use-formsession");
var _useWorkflow = require("../hooks/use-workflow");
var _useWorkflowDefault = parcelHelpers.interopDefault(_useWorkflow);
var _shadowPortal = require("./shadow-portal");
var _shadowPortalDefault = parcelHelpers.interopDefault(_shadowPortal);
var _useFormResources = require("../hooks/use-form-resources");
var _useFormResourcesDefault = parcelHelpers.interopDefault(_useFormResources);
var _useDatasource = require("../hooks/use-datasource");
var _ = require("..");
var _Default = parcelHelpers.interopDefault(_);
var _errorAlert = require("./error-alert");
var _errorAlertDefault = parcelHelpers.interopDefault(_errorAlert);
var _useLoadqueue = require("../hooks/use-loadqueue");
var _useLoadqueueDefault = parcelHelpers.interopDefault(_useLoadqueue);
var _engineSpinnerBoundary = require("./engine-spinner-boundary");
var _engineSpinnerBoundaryDefault = parcelHelpers.interopDefault(_engineSpinnerBoundary);
var _useInert = require("../hooks/use-inert");
function FormEngineGlobalDatasource({ id, onComplete }) {
    const { loading } = (0, _useDatasource.useDatasourceData)(id);
    const { enqueue, dequeue, queue } = (0, _useLoadqueueDefault.default)();
    const [loaded, setLoaded] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (!id) return;
        if (loading) enqueue(id);
        else dequeue(id);
    }, [
        loading,
        id,
        queue
    ]);
    (0, _react.useEffect)(()=>{
        if (!loading && !loaded) {
            setLoaded(true);
            onComplete?.();
        }
    }, [
        loading,
        loaded,
        setLoaded,
        onComplete
    ]);
    return null;
}
function FormEngineGlobalDatasourceLoader() {
    const { state: datasources } = (0, _useForm.useFormDatasources)();
    const { ready: emitReady, initialized } = (0, _useWorkflowDefault.default)();
    // track datasources that have been loaded
    const [loaded, setLoaded] = (0, _react.useState)([]);
    // track if ready was emitted
    const [isReady, setIsReady] = (0, _react.useState)(false);
    // force to remount loaders when form reset function is used
    const [forceRenderKey, setForceRenderKey] = (0, _react.useState)(0);
    const globalDatasources = (0, _react.useMemo)(()=>datasources.filter((def)=>(0, _Default.default).datasources[def.type]?.isGlobal), [
        datasources
    ]);
    (0, _react.useEffect)(()=>{
        // reset load process when form is reinitialized (form reset function was used)
        if (initialized) return;
        setIsReady(false);
        setForceRenderKey((c)=>c + 1);
        setLoaded([]);
    }, [
        initialized,
        setIsReady,
        setForceRenderKey
    ]);
    (0, _react.useEffect)(()=>{
        // if not already emitted, emit ready workflow when all global datasources are loaded
        if (initialized && !isReady && globalDatasources.length === loaded.length) {
            setIsReady(true);
            emitReady();
        }
    }, [
        globalDatasources,
        loaded,
        isReady,
        setIsReady,
        emitReady,
        initialized
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: globalDatasources.map(({ id })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(FormEngineGlobalDatasource, {
                onComplete: ()=>setLoaded([
                        ...loaded,
                        id
                    ]),
                id: id
            }, `${forceRenderKey}:${id}`))
    });
}
function FormEngineRenderer({ elementComponent: ElementComponent = (0, _elementDefault.default), containerComponent = (0, _containerDefault.default), formComponent: FormComponent = (0, _reactBootstrap.Form), children, remote, onSubmit, onReset, ...props }) {
    const customResources = props.editMode !== 'edit';
    const editable = props.editMode === 'edit' || props.editMode === 'translate';
    delete props.editMode;
    const formContext = (0, _useForm.useFormContext)();
    const sessionContext = (0, _useFormsession.useFormSessionContext)();
    const workflowContext = (0, _useWorkflowDefault.default)(editable);
    const { state } = formContext;
    const { submit: emitSubmit, init: emitInit, initialized, loading, isSubmitting, isInitializing, isReady } = workflowContext;
    const ref = (0, _react.useRef)(undefined);
    const [, setIsInert] = (0, _useInert.useInert)(ref, loading);
    (0, _react.useEffect)(()=>{
        setIsInert(loading);
    }, [
        loading,
        setIsInert
    ]);
    (0, _react.useEffect)(()=>{
        if (editable) return;
        if (!loading && !initialized) emitInit();
    }, [
        editable,
        loading,
        initialized
    ]);
    const handleSubmit = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        if (editable || isSubmitting) return;
        onSubmit?.(e);
        emitSubmit();
    }, [
        emitSubmit,
        onSubmit,
        editable,
        isSubmitting
    ]);
    const reset = (0, _react.useCallback)(()=>{
        workflowContext.clearAll();
        emitInit(sessionContext.clearAll());
        onReset?.();
    }, [
        sessionContext,
        workflowContext,
        emitInit,
        onReset
    ]);
    (0, _react.useEffect)(()=>{
        if (typeof remote !== 'object') return;
        // inherit listeners of previous forms of the same remote ref
        const $listeners = [
            ...remote?.current?.$listeners ?? []
        ];
        remote.current = {
            $listeners,
            subscribe: (listener)=>{
                if (!$listeners.includes(listener)) $listeners.push(listener);
            },
            unsubscribe: (listener)=>{
                const index = $listeners.indexOf(listener);
                if (index > -1) $listeners.splice(index, 1);
            },
            emit: (value)=>{
                $listeners.forEach((l)=>l(value));
            },
            form: formContext,
            session: sessionContext,
            workflow: workflowContext,
            reset
        };
        return ()=>{
            remote?.current?.emit(undefined);
        };
    }, [
        remote
    ]);
    (0, _react.useEffect)(()=>{
        if (typeof remote !== 'object' || !remote.current) return;
        Object.assign(remote.current, {
            form: formContext,
            session: sessionContext,
            workflow: workflowContext,
            reset
        });
        remote.current.emit(remote?.current);
    }, [
        remote?.current,
        formContext,
        sessionContext,
        workflowContext,
        reset
    ]);
    const resources = (0, _useFormResourcesDefault.default)();
    const Wrap = customResources ? (0, _shadowPortalDefault.default) : (0, _react.Fragment);
    const errors = Object.entries(sessionContext?.state?.errors ?? {});
    const showSpinner = !editable && (isSubmitting || isInitializing || !isReady);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Wrap, {
        children: [
            customResources && resources,
            customResources && /*#__PURE__*/ (0, _jsxRuntime.jsx)("style", {
                type: "text/css",
                dangerouslySetInnerHTML: {
                    __html: state?.stylesheet || ''
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormEngineGlobalDatasourceLoader, {}),
            errors.map(([id, error])=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorAlertDefault.default), {
                    error: error
                }, id);
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FormComponent, {
                ...props,
                className: `fe ${editable ? 'feb' : ''} ${initialized || editable ? 'is-initialized' : ''} ${loading ? 'is-loading' : ''} ${props.className || ''}`,
                onSubmit: handleSubmit,
                ref: ref,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _engineSpinnerBoundaryDefault.default), {
                        bar: false,
                        show: showSpinner
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "fe-elements",
                        style: {
                            display: errors.length ? 'none' : undefined
                        },
                        children: [
                            (state?.elements || []).filter((element)=>!element.parent).map((element)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ElementComponent, {
                                    id: element.id,
                                    elementComponent: ElementComponent,
                                    containerComponent: containerComponent
                                }, element.id)),
                            children
                        ]
                    })
                ]
            })
        ]
    });
}
function FormEngine({ value: session, workflow, ...props }) {
    const [initialSession] = (0, _react.useState)(session || {});
    const Comp = (0, _react.useMemo)(()=>(0, _Default.default)?.rendererComponent ?? FormEngineRenderer, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useFormsession.FormSessionProvider), {
        value: initialSession,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useWorkflow.WorkflowProvider), {
            value: workflow,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Comp, {
                ...props
            })
        })
    });
}
function FormEngineStateProvider({ form: formValue, session: initialSession, workflow: initialWorkflow, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useForm.FormProvider), {
        value: formValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useFormsession.FormSessionProvider), {
            value: initialSession,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useWorkflow.WorkflowProvider), {
                value: initialWorkflow,
                children: children
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","../hooks/use-form":"5PZyy","./element":"dt2u8","./container":"hxA8J","../hooks/use-formsession":"2Th33","../hooks/use-workflow":"guNxk","./shadow-portal":"dcQs3","../hooks/use-form-resources":"5sq5X","../hooks/use-datasource":"lz7AL","..":"fjN6J","./error-alert":"8dB1t","../hooks/use-loadqueue":"3WYQI","./engine-spinner-boundary":"8Dluo","../hooks/use-inert":"hPYJl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f5rnA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Accordion", ()=>(0, _accordionDefault.default));
parcelHelpers.export(exports, "AccordionContext", ()=>(0, _accordionContextDefault.default));
parcelHelpers.export(exports, "AccordionCollapse", ()=>(0, _accordionCollapseDefault.default));
parcelHelpers.export(exports, "AccordionButton", ()=>(0, _accordionButtonDefault.default));
parcelHelpers.export(exports, "useAccordionButton", ()=>(0, _accordionButton.useAccordionButton));
parcelHelpers.export(exports, "AccordionBody", ()=>(0, _accordionBodyDefault.default));
parcelHelpers.export(exports, "AccordionHeader", ()=>(0, _accordionHeaderDefault.default));
parcelHelpers.export(exports, "AccordionItem", ()=>(0, _accordionItemDefault.default));
parcelHelpers.export(exports, "Alert", ()=>(0, _alertDefault.default));
parcelHelpers.export(exports, "AlertHeading", ()=>(0, _alertHeadingDefault.default));
parcelHelpers.export(exports, "AlertLink", ()=>(0, _alertLinkDefault.default));
parcelHelpers.export(exports, "Anchor", ()=>(0, _anchorDefault.default));
parcelHelpers.export(exports, "Badge", ()=>(0, _badgeDefault.default));
parcelHelpers.export(exports, "Breadcrumb", ()=>(0, _breadcrumbDefault.default));
parcelHelpers.export(exports, "BreadcrumbItem", ()=>(0, _breadcrumbItemDefault.default));
parcelHelpers.export(exports, "Button", ()=>(0, _buttonDefault.default));
parcelHelpers.export(exports, "ButtonGroup", ()=>(0, _buttonGroupDefault.default));
parcelHelpers.export(exports, "ButtonToolbar", ()=>(0, _buttonToolbarDefault.default));
parcelHelpers.export(exports, "Card", ()=>(0, _cardDefault.default));
parcelHelpers.export(exports, "CardBody", ()=>(0, _cardBodyDefault.default));
parcelHelpers.export(exports, "CardFooter", ()=>(0, _cardFooterDefault.default));
parcelHelpers.export(exports, "CardGroup", ()=>(0, _cardGroupDefault.default));
parcelHelpers.export(exports, "CardHeader", ()=>(0, _cardHeaderDefault.default));
parcelHelpers.export(exports, "CardImg", ()=>(0, _cardImgDefault.default));
parcelHelpers.export(exports, "CardImgOverlay", ()=>(0, _cardImgOverlayDefault.default));
parcelHelpers.export(exports, "CardLink", ()=>(0, _cardLinkDefault.default));
parcelHelpers.export(exports, "CardSubtitle", ()=>(0, _cardSubtitleDefault.default));
parcelHelpers.export(exports, "CardText", ()=>(0, _cardTextDefault.default));
parcelHelpers.export(exports, "CardTitle", ()=>(0, _cardTitleDefault.default));
parcelHelpers.export(exports, "Carousel", ()=>(0, _carouselDefault.default));
parcelHelpers.export(exports, "CarouselCaption", ()=>(0, _carouselCaptionDefault.default));
parcelHelpers.export(exports, "CarouselItem", ()=>(0, _carouselItemDefault.default));
parcelHelpers.export(exports, "CloseButton", ()=>(0, _closeButtonDefault.default));
parcelHelpers.export(exports, "Col", ()=>(0, _colDefault.default));
parcelHelpers.export(exports, "Collapse", ()=>(0, _collapseDefault.default));
parcelHelpers.export(exports, "Container", ()=>(0, _containerDefault.default));
parcelHelpers.export(exports, "Dropdown", ()=>(0, _dropdownDefault.default));
parcelHelpers.export(exports, "DropdownButton", ()=>(0, _dropdownButtonDefault.default));
parcelHelpers.export(exports, "DropdownDivider", ()=>(0, _dropdownDividerDefault.default));
parcelHelpers.export(exports, "DropdownHeader", ()=>(0, _dropdownHeaderDefault.default));
parcelHelpers.export(exports, "DropdownItem", ()=>(0, _dropdownItemDefault.default));
parcelHelpers.export(exports, "DropdownItemText", ()=>(0, _dropdownItemTextDefault.default));
parcelHelpers.export(exports, "DropdownMenu", ()=>(0, _dropdownMenuDefault.default));
parcelHelpers.export(exports, "DropdownToggle", ()=>(0, _dropdownToggleDefault.default));
parcelHelpers.export(exports, "Fade", ()=>(0, _fadeDefault.default));
parcelHelpers.export(exports, "Figure", ()=>(0, _figureDefault.default));
parcelHelpers.export(exports, "FigureCaption", ()=>(0, _figureCaptionDefault.default));
parcelHelpers.export(exports, "FigureImage", ()=>(0, _figureImageDefault.default));
parcelHelpers.export(exports, "Form", ()=>(0, _formDefault.default));
parcelHelpers.export(exports, "FormControl", ()=>(0, _formControlDefault.default));
parcelHelpers.export(exports, "FormCheck", ()=>(0, _formCheckDefault.default));
parcelHelpers.export(exports, "FormFloating", ()=>(0, _formFloatingDefault.default));
parcelHelpers.export(exports, "FloatingLabel", ()=>(0, _floatingLabelDefault.default));
parcelHelpers.export(exports, "FormGroup", ()=>(0, _formGroupDefault.default));
parcelHelpers.export(exports, "FormLabel", ()=>(0, _formLabelDefault.default));
parcelHelpers.export(exports, "FormText", ()=>(0, _formTextDefault.default));
parcelHelpers.export(exports, "FormSelect", ()=>(0, _formSelectDefault.default));
parcelHelpers.export(exports, "Image", ()=>(0, _imageDefault.default));
parcelHelpers.export(exports, "InputGroup", ()=>(0, _inputGroupDefault.default));
parcelHelpers.export(exports, "ListGroup", ()=>(0, _listGroupDefault.default));
parcelHelpers.export(exports, "ListGroupItem", ()=>(0, _listGroupItemDefault.default));
parcelHelpers.export(exports, "Modal", ()=>(0, _modalDefault.default));
parcelHelpers.export(exports, "ModalBody", ()=>(0, _modalBodyDefault.default));
parcelHelpers.export(exports, "ModalDialog", ()=>(0, _modalDialogDefault.default));
parcelHelpers.export(exports, "ModalFooter", ()=>(0, _modalFooterDefault.default));
parcelHelpers.export(exports, "ModalHeader", ()=>(0, _modalHeaderDefault.default));
parcelHelpers.export(exports, "ModalTitle", ()=>(0, _modalTitleDefault.default));
parcelHelpers.export(exports, "Nav", ()=>(0, _navDefault.default));
parcelHelpers.export(exports, "Navbar", ()=>(0, _navbarDefault.default));
parcelHelpers.export(exports, "NavbarBrand", ()=>(0, _navbarBrandDefault.default));
parcelHelpers.export(exports, "NavbarCollapse", ()=>(0, _navbarCollapseDefault.default));
parcelHelpers.export(exports, "NavbarOffcanvas", ()=>(0, _navbarOffcanvasDefault.default));
parcelHelpers.export(exports, "NavbarText", ()=>(0, _navbarTextDefault.default));
parcelHelpers.export(exports, "NavbarToggle", ()=>(0, _navbarToggleDefault.default));
parcelHelpers.export(exports, "NavDropdown", ()=>(0, _navDropdownDefault.default));
parcelHelpers.export(exports, "NavItem", ()=>(0, _navItemDefault.default));
parcelHelpers.export(exports, "NavLink", ()=>(0, _navLinkDefault.default));
parcelHelpers.export(exports, "Offcanvas", ()=>(0, _offcanvasDefault.default));
parcelHelpers.export(exports, "OffcanvasBody", ()=>(0, _offcanvasBodyDefault.default));
parcelHelpers.export(exports, "OffcanvasHeader", ()=>(0, _offcanvasHeaderDefault.default));
parcelHelpers.export(exports, "OffcanvasTitle", ()=>(0, _offcanvasTitleDefault.default));
parcelHelpers.export(exports, "OffcanvasToggling", ()=>(0, _offcanvasTogglingDefault.default));
parcelHelpers.export(exports, "Overlay", ()=>(0, _overlayDefault.default));
parcelHelpers.export(exports, "OverlayTrigger", ()=>(0, _overlayTriggerDefault.default));
parcelHelpers.export(exports, "PageItem", ()=>(0, _pageItemDefault.default));
parcelHelpers.export(exports, "Pagination", ()=>(0, _paginationDefault.default));
parcelHelpers.export(exports, "Placeholder", ()=>(0, _placeholderDefault.default));
parcelHelpers.export(exports, "PlaceholderButton", ()=>(0, _placeholderButtonDefault.default));
parcelHelpers.export(exports, "Popover", ()=>(0, _popoverDefault.default));
parcelHelpers.export(exports, "PopoverBody", ()=>(0, _popoverBodyDefault.default));
parcelHelpers.export(exports, "PopoverHeader", ()=>(0, _popoverHeaderDefault.default));
parcelHelpers.export(exports, "ProgressBar", ()=>(0, _progressBarDefault.default));
parcelHelpers.export(exports, "Ratio", ()=>(0, _ratioDefault.default));
parcelHelpers.export(exports, "Row", ()=>(0, _rowDefault.default));
parcelHelpers.export(exports, "Spinner", ()=>(0, _spinnerDefault.default));
parcelHelpers.export(exports, "SplitButton", ()=>(0, _splitButtonDefault.default));
parcelHelpers.export(exports, "SSRProvider", ()=>(0, _ssrproviderDefault.default));
parcelHelpers.export(exports, "Stack", ()=>(0, _stackDefault.default));
parcelHelpers.export(exports, "Tab", ()=>(0, _tabDefault.default));
parcelHelpers.export(exports, "TabContainer", ()=>(0, _tabContainerDefault.default));
parcelHelpers.export(exports, "TabContent", ()=>(0, _tabContentDefault.default));
parcelHelpers.export(exports, "Table", ()=>(0, _tableDefault.default));
parcelHelpers.export(exports, "TabPane", ()=>(0, _tabPaneDefault.default));
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabsDefault.default));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "Toast", ()=>(0, _toastDefault.default));
parcelHelpers.export(exports, "ToastBody", ()=>(0, _toastBodyDefault.default));
parcelHelpers.export(exports, "ToastContainer", ()=>(0, _toastContainerDefault.default));
parcelHelpers.export(exports, "ToastHeader", ()=>(0, _toastHeaderDefault.default));
parcelHelpers.export(exports, "ToggleButton", ()=>(0, _toggleButtonDefault.default));
parcelHelpers.export(exports, "ToggleButtonGroup", ()=>(0, _toggleButtonGroupDefault.default));
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltipDefault.default));
var _accordion = require("./Accordion");
var _accordionDefault = parcelHelpers.interopDefault(_accordion);
var _accordionContext = require("./AccordionContext");
var _accordionContextDefault = parcelHelpers.interopDefault(_accordionContext);
var _accordionCollapse = require("./AccordionCollapse");
var _accordionCollapseDefault = parcelHelpers.interopDefault(_accordionCollapse);
var _accordionButton = require("./AccordionButton");
var _accordionButtonDefault = parcelHelpers.interopDefault(_accordionButton);
var _accordionBody = require("./AccordionBody");
var _accordionBodyDefault = parcelHelpers.interopDefault(_accordionBody);
var _accordionHeader = require("./AccordionHeader");
var _accordionHeaderDefault = parcelHelpers.interopDefault(_accordionHeader);
var _accordionItem = require("./AccordionItem");
var _accordionItemDefault = parcelHelpers.interopDefault(_accordionItem);
var _alert = require("./Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _alertHeading = require("./AlertHeading");
var _alertHeadingDefault = parcelHelpers.interopDefault(_alertHeading);
var _alertLink = require("./AlertLink");
var _alertLinkDefault = parcelHelpers.interopDefault(_alertLink);
var _anchor = require("./Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _badge = require("./Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _breadcrumb = require("./Breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _breadcrumbItem = require("./BreadcrumbItem");
var _breadcrumbItemDefault = parcelHelpers.interopDefault(_breadcrumbItem);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _buttonGroup = require("./ButtonGroup");
var _buttonGroupDefault = parcelHelpers.interopDefault(_buttonGroup);
var _buttonToolbar = require("./ButtonToolbar");
var _buttonToolbarDefault = parcelHelpers.interopDefault(_buttonToolbar);
var _card = require("./Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardBody = require("./CardBody");
var _cardBodyDefault = parcelHelpers.interopDefault(_cardBody);
var _cardFooter = require("./CardFooter");
var _cardFooterDefault = parcelHelpers.interopDefault(_cardFooter);
var _cardGroup = require("./CardGroup");
var _cardGroupDefault = parcelHelpers.interopDefault(_cardGroup);
var _cardHeader = require("./CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardImg = require("./CardImg");
var _cardImgDefault = parcelHelpers.interopDefault(_cardImg);
var _cardImgOverlay = require("./CardImgOverlay");
var _cardImgOverlayDefault = parcelHelpers.interopDefault(_cardImgOverlay);
var _cardLink = require("./CardLink");
var _cardLinkDefault = parcelHelpers.interopDefault(_cardLink);
var _cardSubtitle = require("./CardSubtitle");
var _cardSubtitleDefault = parcelHelpers.interopDefault(_cardSubtitle);
var _cardText = require("./CardText");
var _cardTextDefault = parcelHelpers.interopDefault(_cardText);
var _cardTitle = require("./CardTitle");
var _cardTitleDefault = parcelHelpers.interopDefault(_cardTitle);
var _carousel = require("./Carousel");
var _carouselDefault = parcelHelpers.interopDefault(_carousel);
var _carouselCaption = require("./CarouselCaption");
var _carouselCaptionDefault = parcelHelpers.interopDefault(_carouselCaption);
var _carouselItem = require("./CarouselItem");
var _carouselItemDefault = parcelHelpers.interopDefault(_carouselItem);
var _closeButton = require("./CloseButton");
var _closeButtonDefault = parcelHelpers.interopDefault(_closeButton);
var _col = require("./Col");
var _colDefault = parcelHelpers.interopDefault(_col);
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _container = require("./Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _dropdown = require("./Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _dropdownButton = require("./DropdownButton");
var _dropdownButtonDefault = parcelHelpers.interopDefault(_dropdownButton);
var _dropdownDivider = require("./DropdownDivider");
var _dropdownDividerDefault = parcelHelpers.interopDefault(_dropdownDivider);
var _dropdownHeader = require("./DropdownHeader");
var _dropdownHeaderDefault = parcelHelpers.interopDefault(_dropdownHeader);
var _dropdownItem = require("./DropdownItem");
var _dropdownItemDefault = parcelHelpers.interopDefault(_dropdownItem);
var _dropdownItemText = require("./DropdownItemText");
var _dropdownItemTextDefault = parcelHelpers.interopDefault(_dropdownItemText);
var _dropdownMenu = require("./DropdownMenu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _dropdownToggle = require("./DropdownToggle");
var _dropdownToggleDefault = parcelHelpers.interopDefault(_dropdownToggle);
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _figure = require("./Figure");
var _figureDefault = parcelHelpers.interopDefault(_figure);
var _figureCaption = require("./FigureCaption");
var _figureCaptionDefault = parcelHelpers.interopDefault(_figureCaption);
var _figureImage = require("./FigureImage");
var _figureImageDefault = parcelHelpers.interopDefault(_figureImage);
var _form = require("./Form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _formControl = require("./FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formCheck = require("./FormCheck");
var _formCheckDefault = parcelHelpers.interopDefault(_formCheck);
var _formFloating = require("./FormFloating");
var _formFloatingDefault = parcelHelpers.interopDefault(_formFloating);
var _floatingLabel = require("./FloatingLabel");
var _floatingLabelDefault = parcelHelpers.interopDefault(_floatingLabel);
var _formGroup = require("./FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _formLabel = require("./FormLabel");
var _formLabelDefault = parcelHelpers.interopDefault(_formLabel);
var _formText = require("./FormText");
var _formTextDefault = parcelHelpers.interopDefault(_formText);
var _formSelect = require("./FormSelect");
var _formSelectDefault = parcelHelpers.interopDefault(_formSelect);
var _image = require("./Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _inputGroup = require("./InputGroup");
var _inputGroupDefault = parcelHelpers.interopDefault(_inputGroup);
var _listGroup = require("./ListGroup");
var _listGroupDefault = parcelHelpers.interopDefault(_listGroup);
var _listGroupItem = require("./ListGroupItem");
var _listGroupItemDefault = parcelHelpers.interopDefault(_listGroupItem);
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _modalBody = require("./ModalBody");
var _modalBodyDefault = parcelHelpers.interopDefault(_modalBody);
var _modalDialog = require("./ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _modalFooter = require("./ModalFooter");
var _modalFooterDefault = parcelHelpers.interopDefault(_modalFooter);
var _modalHeader = require("./ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _modalTitle = require("./ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _nav = require("./Nav");
var _navDefault = parcelHelpers.interopDefault(_nav);
var _navbar = require("./Navbar");
var _navbarDefault = parcelHelpers.interopDefault(_navbar);
var _navbarBrand = require("./NavbarBrand");
var _navbarBrandDefault = parcelHelpers.interopDefault(_navbarBrand);
var _navbarCollapse = require("./NavbarCollapse");
var _navbarCollapseDefault = parcelHelpers.interopDefault(_navbarCollapse);
var _navbarOffcanvas = require("./NavbarOffcanvas");
var _navbarOffcanvasDefault = parcelHelpers.interopDefault(_navbarOffcanvas);
var _navbarText = require("./NavbarText");
var _navbarTextDefault = parcelHelpers.interopDefault(_navbarText);
var _navbarToggle = require("./NavbarToggle");
var _navbarToggleDefault = parcelHelpers.interopDefault(_navbarToggle);
var _navDropdown = require("./NavDropdown");
var _navDropdownDefault = parcelHelpers.interopDefault(_navDropdown);
var _navItem = require("./NavItem");
var _navItemDefault = parcelHelpers.interopDefault(_navItem);
var _navLink = require("./NavLink");
var _navLinkDefault = parcelHelpers.interopDefault(_navLink);
var _offcanvas = require("./Offcanvas");
var _offcanvasDefault = parcelHelpers.interopDefault(_offcanvas);
var _offcanvasBody = require("./OffcanvasBody");
var _offcanvasBodyDefault = parcelHelpers.interopDefault(_offcanvasBody);
var _offcanvasHeader = require("./OffcanvasHeader");
var _offcanvasHeaderDefault = parcelHelpers.interopDefault(_offcanvasHeader);
var _offcanvasTitle = require("./OffcanvasTitle");
var _offcanvasTitleDefault = parcelHelpers.interopDefault(_offcanvasTitle);
var _offcanvasToggling = require("./OffcanvasToggling");
var _offcanvasTogglingDefault = parcelHelpers.interopDefault(_offcanvasToggling);
var _overlay = require("./Overlay");
var _overlayDefault = parcelHelpers.interopDefault(_overlay);
var _overlayTrigger = require("./OverlayTrigger");
var _overlayTriggerDefault = parcelHelpers.interopDefault(_overlayTrigger);
var _pageItem = require("./PageItem");
var _pageItemDefault = parcelHelpers.interopDefault(_pageItem);
var _pagination = require("./Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _placeholder = require("./Placeholder");
var _placeholderDefault = parcelHelpers.interopDefault(_placeholder);
var _placeholderButton = require("./PlaceholderButton");
var _placeholderButtonDefault = parcelHelpers.interopDefault(_placeholderButton);
var _popover = require("./Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
var _popoverBody = require("./PopoverBody");
var _popoverBodyDefault = parcelHelpers.interopDefault(_popoverBody);
var _popoverHeader = require("./PopoverHeader");
var _popoverHeaderDefault = parcelHelpers.interopDefault(_popoverHeader);
var _progressBar = require("./ProgressBar");
var _progressBarDefault = parcelHelpers.interopDefault(_progressBar);
var _ratio = require("./Ratio");
var _ratioDefault = parcelHelpers.interopDefault(_ratio);
var _row = require("./Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _spinner = require("./Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _splitButton = require("./SplitButton");
var _splitButtonDefault = parcelHelpers.interopDefault(_splitButton);
var _ssrprovider = require("./SSRProvider");
var _ssrproviderDefault = parcelHelpers.interopDefault(_ssrprovider);
var _stack = require("./Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _tab = require("./Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _tabContainer = require("./TabContainer");
var _tabContainerDefault = parcelHelpers.interopDefault(_tabContainer);
var _tabContent = require("./TabContent");
var _tabContentDefault = parcelHelpers.interopDefault(_tabContent);
var _table = require("./Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tabPane = require("./TabPane");
var _tabPaneDefault = parcelHelpers.interopDefault(_tabPane);
var _tabs = require("./Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _toast = require("./Toast");
var _toastDefault = parcelHelpers.interopDefault(_toast);
var _toastBody = require("./ToastBody");
var _toastBodyDefault = parcelHelpers.interopDefault(_toastBody);
var _toastContainer = require("./ToastContainer");
var _toastContainerDefault = parcelHelpers.interopDefault(_toastContainer);
var _toastHeader = require("./ToastHeader");
var _toastHeaderDefault = parcelHelpers.interopDefault(_toastHeader);
var _toggleButton = require("./ToggleButton");
var _toggleButtonDefault = parcelHelpers.interopDefault(_toggleButton);
var _toggleButtonGroup = require("./ToggleButtonGroup");
var _toggleButtonGroupDefault = parcelHelpers.interopDefault(_toggleButtonGroup);
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);

},{"./Accordion":false,"./AccordionContext":false,"./AccordionCollapse":false,"./AccordionButton":false,"./AccordionBody":false,"./AccordionHeader":false,"./AccordionItem":false,"./Alert":false,"./AlertHeading":false,"./AlertLink":false,"./Anchor":false,"./Badge":"lFInU","./Breadcrumb":false,"./BreadcrumbItem":false,"./Button":"2TJC6","./ButtonGroup":"kYs3W","./ButtonToolbar":false,"./Card":"6wRtx","./CardBody":false,"./CardFooter":false,"./CardGroup":false,"./CardHeader":false,"./CardImg":false,"./CardImgOverlay":false,"./CardLink":false,"./CardSubtitle":false,"./CardText":false,"./CardTitle":false,"./Carousel":false,"./CarouselCaption":false,"./CarouselItem":false,"./CloseButton":false,"./Col":"aPBtB","./Collapse":false,"./Container":"1vqMI","./Dropdown":"gNoAC","./DropdownButton":false,"./DropdownDivider":false,"./DropdownHeader":false,"./DropdownItem":false,"./DropdownItemText":false,"./DropdownMenu":false,"./DropdownToggle":false,"./Fade":false,"./Figure":false,"./FigureCaption":false,"./FigureImage":false,"./Form":"j4K62","./FormControl":"9lN0O","./FormCheck":"htLFH","./FormFloating":false,"./FloatingLabel":"4JRQj","./FormGroup":"gsqum","./FormLabel":"55u89","./FormText":false,"./FormSelect":"f1nIg","./Image":false,"./InputGroup":"3cBFx","./ListGroup":"bkane","./ListGroupItem":false,"./Modal":"dAasA","./ModalBody":false,"./ModalDialog":false,"./ModalFooter":false,"./ModalHeader":false,"./ModalTitle":false,"./Nav":"iXM49","./Navbar":"jKK7g","./NavbarBrand":false,"./NavbarCollapse":false,"./NavbarOffcanvas":false,"./NavbarText":false,"./NavbarToggle":false,"./NavDropdown":"7N5GY","./NavItem":false,"./NavLink":false,"./Offcanvas":false,"./OffcanvasBody":false,"./OffcanvasHeader":false,"./OffcanvasTitle":false,"./OffcanvasToggling":false,"./Overlay":false,"./OverlayTrigger":"jtT2y","./PageItem":false,"./Pagination":false,"./Placeholder":false,"./PlaceholderButton":false,"./Popover":"jhMQy","./PopoverBody":false,"./PopoverHeader":false,"./ProgressBar":"9JK0h","./Ratio":false,"./Row":"gBOje","./Spinner":"3XOxF","./SplitButton":false,"./SSRProvider":false,"./Stack":"azk83","./Tab":false,"./TabContainer":false,"./TabContent":false,"./Table":"kqOLP","./TabPane":false,"./Tabs":false,"./ThemeProvider":false,"./Toast":false,"./ToastBody":false,"./ToastContainer":false,"./ToastHeader":false,"./ToggleButton":false,"./ToggleButtonGroup":false,"./Tooltip":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lFInU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Badge = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, bg = 'primary', pill = false, text, className, as: Component = 'span', ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
Badge.displayName = 'Badge';
exports.default = Badge;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Een2":[function(require,module,exports,__globalThis) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"t5pcW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_BREAKPOINTS", ()=>DEFAULT_BREAKPOINTS);
parcelHelpers.export(exports, "DEFAULT_MIN_BREAKPOINT", ()=>DEFAULT_MIN_BREAKPOINT);
parcelHelpers.export(exports, "useBootstrapPrefix", ()=>useBootstrapPrefix);
parcelHelpers.export(exports, "useBootstrapBreakpoints", ()=>useBootstrapBreakpoints);
parcelHelpers.export(exports, "useBootstrapMinBreakpoint", ()=>useBootstrapMinBreakpoint);
parcelHelpers.export(exports, "useIsRTL", ()=>useIsRTL);
parcelHelpers.export(exports, "createBootstrapComponent", ()=>createBootstrapComponent);
parcelHelpers.export(exports, "ThemeConsumer", ()=>Consumer);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DEFAULT_BREAKPOINTS = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const DEFAULT_MIN_BREAKPOINT = 'xs';
const ThemeContext = /*#__PURE__*/ _react.createContext({
    prefixes: {},
    breakpoints: DEFAULT_BREAKPOINTS,
    minBreakpoint: DEFAULT_MIN_BREAKPOINT
});
const { Consumer, Provider } = ThemeContext;
function ThemeProvider({ prefixes = {}, breakpoints = DEFAULT_BREAKPOINTS, minBreakpoint = DEFAULT_MIN_BREAKPOINT, dir, children }) {
    const contextValue = (0, _react.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints,
            minBreakpoint,
            dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Provider, {
        value: contextValue,
        children: children
    });
}
function useBootstrapPrefix(prefix, defaultPrefix) {
    const { prefixes } = (0, _react.useContext)(ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function useBootstrapBreakpoints() {
    const { breakpoints } = (0, _react.useContext)(ThemeContext);
    return breakpoints;
}
function useBootstrapMinBreakpoint() {
    const { minBreakpoint } = (0, _react.useContext)(ThemeContext);
    return minBreakpoint;
}
function useIsRTL() {
    const { dir } = (0, _react.useContext)(ThemeContext);
    return dir === 'rtl';
}
function createBootstrapComponent(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix, forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ _react.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
exports.default = ThemeProvider;

},{"react":"9njXz","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jiucr":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"2TJC6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _button = require("@restart/ui/Button");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Button = /*#__PURE__*/ _react.forwardRef(({ as, bsPrefix, variant = 'primary', size, active = false, disabled = false, className, ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'btn');
    const [buttonProps, { tagName }] = (0, _button.useButtonProps)({
        tagName: as,
        disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, _classnamesDefault.default)(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
Button.displayName = 'Button';
exports.default = Button;

},{"classnames":"5Een2","react":"9njXz","@restart/ui/Button":"jYGKr","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jYGKr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTrivialHref", ()=>isTrivialHref);
parcelHelpers.export(exports, "useButtonProps", ()=>useButtonProps);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "as",
    "disabled"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function isTrivialHref(href) {
    return !href || href.trim() === '#';
}
function useButtonProps({ tagName, disabled, href, target, rel, role, onClick, tabIndex = 0, type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && isTrivialHref(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const Button = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [buttonProps, { tagName: Component }] = useButtonProps(Object.assign({
        tagName: asProp,
        disabled
    }, props));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
Button.displayName = 'Button';
exports.default = Button;

},{"react":"9njXz","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kYs3W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ButtonGroup = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, size, vertical = false, className, role = 'group', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...rest }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'btn-group');
    let baseClass = prefix;
    if (vertical) baseClass = `${prefix}-vertical`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...rest,
        ref: ref,
        role: role,
        className: (0, _classnamesDefault.default)(className, baseClass, size && `${prefix}-${size}`)
    });
});
ButtonGroup.displayName = 'ButtonGroup';
exports.default = ButtonGroup;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6wRtx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _cardBody = require("./CardBody");
var _cardBodyDefault = parcelHelpers.interopDefault(_cardBody);
var _cardFooter = require("./CardFooter");
var _cardFooterDefault = parcelHelpers.interopDefault(_cardFooter);
var _cardHeader = require("./CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardImg = require("./CardImg");
var _cardImgDefault = parcelHelpers.interopDefault(_cardImg);
var _cardImgOverlay = require("./CardImgOverlay");
var _cardImgOverlayDefault = parcelHelpers.interopDefault(_cardImgOverlay);
var _cardLink = require("./CardLink");
var _cardLinkDefault = parcelHelpers.interopDefault(_cardLink);
var _cardSubtitle = require("./CardSubtitle");
var _cardSubtitleDefault = parcelHelpers.interopDefault(_cardSubtitle);
var _cardText = require("./CardText");
var _cardTextDefault = parcelHelpers.interopDefault(_cardText);
var _cardTitle = require("./CardTitle");
var _cardTitleDefault = parcelHelpers.interopDefault(_cardTitle);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Card = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, bg, text, border, body = false, children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBodyDefault.default), {
            children: children
        }) : children
    });
});
Card.displayName = 'Card';
exports.default = Object.assign(Card, {
    Img: (0, _cardImgDefault.default),
    Title: (0, _cardTitleDefault.default),
    Subtitle: (0, _cardSubtitleDefault.default),
    Body: (0, _cardBodyDefault.default),
    Link: (0, _cardLinkDefault.default),
    Text: (0, _cardTextDefault.default),
    Header: (0, _cardHeaderDefault.default),
    Footer: (0, _cardFooterDefault.default),
    ImgOverlay: (0, _cardImgOverlayDefault.default)
});

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./CardBody":"hq2rx","./CardFooter":"cHRZt","./CardHeader":"csAMr","./CardImg":"1I73B","./CardImgOverlay":"iz6al","./CardLink":"aAZtG","./CardSubtitle":"iXmsL","./CardText":"js8fa","./CardTitle":"4OwFJ","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hq2rx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardBody = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardBody.displayName = 'CardBody';
exports.default = CardBody;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cHRZt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardFooter = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardFooter.displayName = 'CardFooter';
exports.default = CardFooter;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"csAMr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _cardHeaderContext = require("./CardHeaderContext");
var _cardHeaderContextDefault = parcelHelpers.interopDefault(_cardHeaderContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardHeader = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-header');
    const contextValue = (0, _react.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderContextDefault.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, _classnamesDefault.default)(className, prefix)
        })
    });
});
CardHeader.displayName = 'CardHeader';
exports.default = CardHeader;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./CardHeaderContext":"lHQZO","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lHQZO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const context = /*#__PURE__*/ _react.createContext(null);
context.displayName = 'CardHeaderContext';
exports.default = context;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1I73B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardImg = /*#__PURE__*/ _react.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix, className, variant, as: Component = 'img', ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
CardImg.displayName = 'CardImg';
exports.default = CardImg;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iz6al":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardImgOverlay = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardImgOverlay.displayName = 'CardImgOverlay';
exports.default = CardImgOverlay;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aAZtG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardLink = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'a', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardLink.displayName = 'CardLink';
exports.default = CardLink;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iXmsL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _divWithClassName = require("./divWithClassName");
var _divWithClassNameDefault = parcelHelpers.interopDefault(_divWithClassName);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DivStyledAsH6 = (0, _divWithClassNameDefault.default)('h6');
const CardSubtitle = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardSubtitle.displayName = 'CardSubtitle';
exports.default = CardSubtitle;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","./divWithClassName":"7vB9M","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7vB9M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _jsxRuntime = require("react/jsx-runtime");
exports.default = (className)=>/*#__PURE__*/ _react.forwardRef((p, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, _classnamesDefault.default)(p.className, className)
        }));

},{"react":"9njXz","classnames":"5Een2","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"js8fa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardText = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'p', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardText.displayName = 'CardText';
exports.default = CardText;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4OwFJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _divWithClassName = require("./divWithClassName");
var _divWithClassNameDefault = parcelHelpers.interopDefault(_divWithClassName);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DivStyledAsH5 = (0, _divWithClassNameDefault.default)('h5');
const CardTitle = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardTitle.displayName = 'CardTitle';
exports.default = CardTitle;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","./divWithClassName":"7vB9M","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dT7Bb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _jsxRuntime = require("react/jsx-runtime");
const propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, _propTypesDefault.default).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, _propTypesDefault.default).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, _propTypesDefault.default).oneOf([
        'white'
    ])
};
const CloseButton = /*#__PURE__*/ _react.forwardRef(({ className, variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, _classnamesDefault.default)('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = propTypes;
exports.default = CloseButton;

},{"prop-types":"bnNSm","react":"9njXz","classnames":"5Een2","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bnNSm":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"aLk8j"}],"aLk8j":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"di8d9"}],"di8d9":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"aPBtB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCol", ()=>useCol);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function useCol({ as, bsPrefix, className, ...props }) {
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'col');
    const breakpoints = (0, _themeProvider.useBootstrapBreakpoints)();
    const minBreakpoint = (0, _themeProvider.useBootstrapMinBreakpoint)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span, offset, order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, _classnamesDefault.default)(className, ...spans, ...classes)
        },
        {
            as,
            bsPrefix,
            spans
        }
    ];
}
const Col = /*#__PURE__*/ _react.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className, ...colProps }, { as: Component = 'div', bsPrefix, spans }] = useCol(props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, !spans.length && bsPrefix)
    });
});
Col.displayName = 'Col';
exports.default = Col;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"juTQl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _css = require("dom-helpers/css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("react-transition-group/Transition");
var _transitionEndListener = require("./transitionEndListener");
var _transitionEndListenerDefault = parcelHelpers.interopDefault(_transitionEndListener);
var _createChainedFunction = require("./createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);
var _triggerBrowserReflow = require("./triggerBrowserReflow");
var _triggerBrowserReflowDefault = parcelHelpers.interopDefault(_triggerBrowserReflow);
var _transitionWrapper = require("./TransitionWrapper");
var _transitionWrapperDefault = parcelHelpers.interopDefault(_transitionWrapper);
var _jsxRuntime = require("react/jsx-runtime");
const MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = MARGINS[dimension];
    return value + // @ts-ignore
    parseInt((0, _cssDefault.default)(elem, margins[0]), 10) + // @ts-ignore
    parseInt((0, _cssDefault.default)(elem, margins[1]), 10);
}
const collapseStyles = {
    [(0, _transition.EXITED)]: 'collapse',
    [(0, _transition.EXITING)]: 'collapsing',
    [(0, _transition.ENTERING)]: 'collapsing',
    [(0, _transition.ENTERED)]: 'collapse show'
};
const Collapse = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(({ onEnter, onEntering, onEntered, onExit, onExiting, className, children, dimension = 'height', in: inProp = false, timeout = 300, mountOnEnter = false, unmountOnExit = false, appear = false, getDimensionValue = getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, _react.useMemo)(()=>(0, _createChainedFunctionDefault.default)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, _react.useMemo)(()=>(0, _createChainedFunctionDefault.default)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, _react.useMemo)(()=>(0, _createChainedFunctionDefault.default)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, _react.useMemo)(()=>(0, _createChainedFunctionDefault.default)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, _triggerBrowserReflowDefault.default)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, _react.useMemo)(()=>(0, _createChainedFunctionDefault.default)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transitionWrapperDefault.default), {
        ref: ref,
        addEndListener: (0, _transitionEndListenerDefault.default),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: children.ref,
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, _reactDefault.default).cloneElement(children, {
                ...innerProps,
                className: (0, _classnamesDefault.default)(className, children.props.className, collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
// @ts-ignore
exports.default = Collapse;

},{"classnames":"5Een2","dom-helpers/css":"2nGUd","react":"9njXz","react-transition-group/Transition":"6LVcl","./transitionEndListener":"cbuHm","./createChainedFunction":"i4IJD","./triggerBrowserReflow":"cZXZ6","./TransitionWrapper":"jxF2v","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2nGUd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getComputedStyle = require("./getComputedStyle");
var _getComputedStyleDefault = parcelHelpers.interopDefault(_getComputedStyle);
var _hyphenateStyle = require("./hyphenateStyle");
var _hyphenateStyleDefault = parcelHelpers.interopDefault(_hyphenateStyle);
var _isTransform = require("./isTransform");
var _isTransformDefault = parcelHelpers.interopDefault(_isTransform);
function style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, _hyphenateStyleDefault.default)(property)) || (0, _getComputedStyleDefault.default)(node).getPropertyValue((0, _hyphenateStyleDefault.default)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, _hyphenateStyleDefault.default)(key));
        else if ((0, _isTransformDefault.default)(key)) transforms += key + "(" + value + ") ";
        else css += (0, _hyphenateStyleDefault.default)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
exports.default = style;

},{"./getComputedStyle":"jBpff","./hyphenateStyle":"hWlqW","./isTransform":"308as","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jBpff":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _ownerWindow = require("./ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
function getComputedStyle(node, psuedoElement) {
    return (0, _ownerWindowDefault.default)(node).getComputedStyle(node, psuedoElement);
}

},{"./ownerWindow":"foj4A","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"foj4A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ownerWindow);
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
function ownerWindow(node) {
    var doc = (0, _ownerDocumentDefault.default)(node);
    return doc && doc.defaultView || window;
}

},{"./ownerDocument":"dYqIu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dYqIu":[function(require,module,exports,__globalThis) {
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ownerDocument);
function ownerDocument(node) {
    return node && node.ownerDocument || document;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hWlqW":[function(require,module,exports,__globalThis) {
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hyphenateStyleName);
var _hyphenate = require("./hyphenate");
var _hyphenateDefault = parcelHelpers.interopDefault(_hyphenate);
var msPattern = /^ms-/;
function hyphenateStyleName(string) {
    return (0, _hyphenateDefault.default)(string).replace(msPattern, '-ms-');
}

},{"./hyphenate":"4Twlo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Twlo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hyphenate);
var rUpper = /([A-Z])/g;
function hyphenate(string) {
    return string.replace(rUpper, '-$1').toLowerCase();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"308as":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTransform);
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function isTransform(value) {
    return !!(value && supportedTransforms.test(value));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6LVcl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNMOUNTED", ()=>UNMOUNTED);
parcelHelpers.export(exports, "EXITED", ()=>EXITED);
parcelHelpers.export(exports, "ENTERING", ()=>ENTERING);
parcelHelpers.export(exports, "ENTERED", ()=>ENTERED);
parcelHelpers.export(exports, "EXITING", ()=>EXITING);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _propTypes1 = require("./utils/PropTypes");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _reflow = require("./utils/reflow");
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var Transition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, _reflow.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, _reactDomDefault.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, _reactDefault.default).Component);
Transition.contextType = (0, _transitionGroupContextDefault.default);
Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
exports.default = Transition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","react":"9njXz","react-dom":"2ApDx","./config":"7vGu2","./utils/PropTypes":"8gMVu","./TransitionGroupContext":"162y0","./utils/reflow":"8V7Al","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jGdYV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6cnxy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"9UMxe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9UMxe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7vGu2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    disabled: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8gMVu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutsShape", ()=>timeoutsShape);
parcelHelpers.export(exports, "classNamesShape", ()=>classNamesShape);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var timeoutsShape = null;
var classNamesShape = null;

},{"prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"162y0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = (0, _reactDefault.default).createContext(null);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8V7Al":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceReflow", ()=>forceReflow);
var forceReflow = function forceReflow(node) {
    return node.scrollTop;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cbuHm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transitionEndListener);
var _css = require("dom-helpers/css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _transitionEnd = require("dom-helpers/transitionEnd");
var _transitionEndDefault = parcelHelpers.interopDefault(_transitionEnd);
function parseDuration(node, property) {
    const str = (0, _cssDefault.default)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function transitionEndListener(element, handler) {
    const duration = parseDuration(element, 'transitionDuration');
    const delay = parseDuration(element, 'transitionDelay');
    const remove = (0, _transitionEndDefault.default)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}

},{"dom-helpers/css":"2nGUd","dom-helpers/transitionEnd":"cOav3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cOav3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transitionEnd);
var _css = require("./css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _listen = require("./listen");
var _listenDefault = parcelHelpers.interopDefault(_listen);
var _triggerEvent = require("./triggerEvent");
var _triggerEventDefault = parcelHelpers.interopDefault(_triggerEvent);
function parseDuration(node) {
    var str = (0, _cssDefault.default)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, _triggerEventDefault.default)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, _listenDefault.default)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function transitionEnd(element, handler, duration, padding) {
    if (duration == null) duration = parseDuration(element) || 0;
    var removeEmulate = emulateTransitionEnd(element, duration, padding);
    var remove = (0, _listenDefault.default)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}

},{"./css":"2nGUd","./listen":"bQcJW","./triggerEvent":"93u22","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bQcJW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addEventListener = require("./addEventListener");
var _addEventListenerDefault = parcelHelpers.interopDefault(_addEventListener);
var _removeEventListener = require("./removeEventListener");
var _removeEventListenerDefault = parcelHelpers.interopDefault(_removeEventListener);
function listen(node, eventName, handler, options) {
    (0, _addEventListenerDefault.default)(node, eventName, handler, options);
    return function() {
        (0, _removeEventListenerDefault.default)(node, eventName, handler, options);
    };
}
exports.default = listen;

},{"./addEventListener":"avJ0E","./removeEventListener":"5Dy7j","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avJ0E":[function(require,module,exports,__globalThis) {
/* eslint-disable no-return-assign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optionsSupported", ()=>optionsSupported);
parcelHelpers.export(exports, "onceSupported", ()=>onceSupported);
var _canUseDOM = require("./canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
var optionsSupported = false;
var onceSupported = false;
try {
    var options = {
        get passive () {
            return optionsSupported = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return onceSupported = optionsSupported = true;
        }
    };
    if (0, _canUseDOMDefault.default) {
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !onceSupported) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!onceSupported && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
exports.default = addEventListener;

},{"./canUseDOM":"5QOsw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5QOsw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Dy7j":[function(require,module,exports,__globalThis) {
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
exports.default = removeEventListener;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"93u22":[function(require,module,exports,__globalThis) {
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>triggerEvent);
function triggerEvent(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i4IJD":[function(require,module,exports,__globalThis) {
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-ignore
            acc.apply(this, args);
            // @ts-ignore
            f.apply(this, args);
        };
    }, null);
}
exports.default = createChainedFunction;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cZXZ6":[function(require,module,exports,__globalThis) {
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>triggerBrowserReflow);
function triggerBrowserReflow(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jxF2v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("react-transition-group/Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _safeFindDOMNode = require("./safeFindDOMNode");
var _safeFindDOMNodeDefault = parcelHelpers.interopDefault(_safeFindDOMNode);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
// Normalizes Transition callbacks when nodeRef is used.
const TransitionWrapper = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(({ onEnter, onEntering, onEntered, onExit, onExiting, onExited, addEndListener, children, childRef, ...props }, ref)=>{
    const nodeRef = (0, _react.useRef)(null);
    const mergedRef = (0, _useMergedRefsDefault.default)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, _safeFindDOMNodeDefault.default)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, _react.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, _react.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, _react.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, _react.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, _react.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, _react.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, _react.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transitionDefault.default), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, _reactDefault.default).cloneElement(children, {
            ref: attachRef
        })
    });
});
exports.default = TransitionWrapper;

},{"react":"9njXz","react-transition-group/Transition":"6LVcl","@restart/hooks/useMergedRefs":"cU99Q","./safeFindDOMNode":"c96Ll","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cU99Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeRefs", ()=>mergeRefs);
var _react = require("react");
const toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function mergeRefs(refA, refB) {
    const a = toFnRef(refA);
    const b = toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function useMergedRefs(refA, refB) {
    return (0, _react.useMemo)(()=>mergeRefs(refA, refB), [
        refA,
        refB
    ]);
}
exports.default = useMergedRefs;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c96Ll":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>safeFindDOMNode);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
function safeFindDOMNode(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) return (0, _reactDomDefault.default).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}

},{"react-dom":"2ApDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1vqMI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Container = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className, ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
Container.displayName = 'Container';
exports.default = Container;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gNoAC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _dropdown = require("@restart/ui/Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _uncontrollable = require("uncontrollable");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _dropdownContext = require("./DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _dropdownDivider = require("./DropdownDivider");
var _dropdownDividerDefault = parcelHelpers.interopDefault(_dropdownDivider);
var _dropdownHeader = require("./DropdownHeader");
var _dropdownHeaderDefault = parcelHelpers.interopDefault(_dropdownHeader);
var _dropdownItem = require("./DropdownItem");
var _dropdownItemDefault = parcelHelpers.interopDefault(_dropdownItem);
var _dropdownItemText = require("./DropdownItemText");
var _dropdownItemTextDefault = parcelHelpers.interopDefault(_dropdownItemText);
var _dropdownMenu = require("./DropdownMenu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _dropdownToggle = require("./DropdownToggle");
var _dropdownToggleDefault = parcelHelpers.interopDefault(_dropdownToggle);
var _inputGroupContext = require("./InputGroupContext");
var _inputGroupContextDefault = parcelHelpers.interopDefault(_inputGroupContext);
var _themeProvider = require("./ThemeProvider");
var _types = require("./types");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Dropdown = /*#__PURE__*/ _react.forwardRef((pProps, ref)=>{
    const { bsPrefix, drop = 'down', show, className, align = 'start', onSelect, onToggle, focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', navbar: _4, autoClose = true, ...props } = (0, _uncontrollable.useUncontrolled)(pProps, {
        show: 'onToggle'
    });
    const isInputGroup = (0, _react.useContext)((0, _inputGroupContextDefault.default));
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown');
    const isRTL = (0, _themeProvider.useIsRTL)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    const handleToggle = (0, _useEventCallbackDefault.default)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === 'end';
    const placement = (0, _dropdownMenu.getDropdownMenuPlacement)(alignEnd, drop, isRTL);
    const contextValue = (0, _react.useMemo)(()=>({
            align,
            drop,
            isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        'down-centered': `${prefix}-center`,
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownContextDefault.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownDefault.default), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, _classnamesDefault.default)(className, show && 'show', directionClasses[drop])
            })
        })
    });
});
Dropdown.displayName = 'Dropdown';
exports.default = Object.assign(Dropdown, {
    Toggle: (0, _dropdownToggleDefault.default),
    Menu: (0, _dropdownMenuDefault.default),
    Item: (0, _dropdownItemDefault.default),
    ItemText: (0, _dropdownItemTextDefault.default),
    Divider: (0, _dropdownDividerDefault.default),
    Header: (0, _dropdownHeaderDefault.default)
});

},{"classnames":"5Een2","react":"9njXz","@restart/ui/Dropdown":"cMilE","uncontrollable":"c40ge","@restart/hooks/useEventCallback":"3MIRo","./DropdownContext":"1OlZ9","./DropdownDivider":"dv1O6","./DropdownHeader":"fxhzi","./DropdownItem":"8Sdmp","./DropdownItemText":"aEmjc","./DropdownMenu":"8cCR3","./DropdownToggle":"gk26n","./InputGroupContext":"4oqFY","./ThemeProvider":"t5pcW","./types":"esAMz","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cMilE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _querySelectorAll = require("dom-helpers/querySelectorAll");
var _querySelectorAllDefault = parcelHelpers.interopDefault(_querySelectorAll);
var _addEventListener = require("dom-helpers/addEventListener");
var _addEventListenerDefault = parcelHelpers.interopDefault(_addEventListener);
var _react = require("react");
var _uncontrollable = require("uncontrollable");
var _usePrevious = require("@restart/hooks/usePrevious");
var _usePreviousDefault = parcelHelpers.interopDefault(_usePrevious);
var _useForceUpdate = require("@restart/hooks/useForceUpdate");
var _useForceUpdateDefault = parcelHelpers.interopDefault(_useForceUpdate);
var _useEventListener = require("@restart/hooks/useEventListener");
var _useEventListenerDefault = parcelHelpers.interopDefault(_useEventListener);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _dropdownContext = require("./DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _dropdownMenu = require("./DropdownMenu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _dropdownToggle = require("./DropdownToggle");
var _dropdownToggleDefault = parcelHelpers.interopDefault(_dropdownToggle);
var _dropdownItem = require("./DropdownItem");
var _dropdownItemDefault = parcelHelpers.interopDefault(_dropdownItem);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _dataKey = require("./DataKey");
var _useWindow = require("./useWindow");
var _useWindowDefault = parcelHelpers.interopDefault(_useWindow);
var _jsxRuntime = require("react/jsx-runtime");
function useRefWithUpdate() {
    const forceUpdate = (0, _useForceUpdateDefault.default)();
    const ref = (0, _react.useRef)(null);
    const attachRef = (0, _react.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function Dropdown({ defaultShow, show: rawShow, onSelect, onToggle: rawOnToggle, itemSelector = `* [${(0, _dataKey.dataAttr)('dropdown-item')}]`, focusFirstItemOnShow, placement = 'bottom-start', children }) {
    const window = (0, _useWindowDefault.default)();
    const [show, onToggle] = (0, _uncontrollable.useUncontrolledProp)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, _usePreviousDefault.default)(show);
    const lastSourceEvent = (0, _react.useRef)(null);
    const focusInDropdown = (0, _react.useRef)(false);
    const onSelectCtx = (0, _react.useContext)((0, _selectableContextDefault.default));
    const toggle = (0, _react.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, _useEventCallbackDefault.default)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, _react.useMemo)(()=>({
            toggle,
            placement,
            show,
            menuElement,
            toggleElement,
            setMenu,
            setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, _useEventCallbackDefault.default)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, _useEventCallbackDefault.default)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, _dropdownToggle.isRoleMenu)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        const first = (0, _querySelectorAllDefault.default)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, _react.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, _react.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, _querySelectorAllDefault.default)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, _useEventListenerDefault.default)((0, _react.useCallback)(()=>window.document, [
        window
    ]), 'keydown', (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, _addEventListenerDefault.default)(target.ownerDocument, 'keyup', (e)=>{
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectableContextDefault.default).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownContextDefault.default).Provider, {
            value: context,
            children: children
        })
    });
}
Dropdown.displayName = 'Dropdown';
Dropdown.Menu = (0, _dropdownMenuDefault.default);
Dropdown.Toggle = (0, _dropdownToggleDefault.default);
Dropdown.Item = (0, _dropdownItemDefault.default);
exports.default = Dropdown;

},{"dom-helpers/querySelectorAll":"gZHK3","dom-helpers/addEventListener":"avJ0E","react":"9njXz","uncontrollable":"74N91","@restart/hooks/usePrevious":"3j5PE","@restart/hooks/useForceUpdate":"j5gAr","@restart/hooks/useEventListener":"hnYlw","@restart/hooks/useEventCallback":"c26h1","./DropdownContext":"hxKWL","./DropdownMenu":"iWmjp","./DropdownToggle":"7snx4","./DropdownItem":"hheT8","./SelectableContext":"7v5if","./DataKey":"bOKZf","./useWindow":"kl9Hc","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gZHK3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>qsa);
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function qsa(element, selector) {
    return toArray(element.querySelectorAll(selector));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"74N91":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultKey", ()=>defaultKey);
parcelHelpers.export(exports, "useUncontrolledProp", ()=>useUncontrolledProp);
parcelHelpers.export(exports, "useUncontrolled", ()=>useUncontrolled);
var _react = require("react");
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function defaultKey(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function useUncontrolledProp(propValue, defaultValue, handler) {
    const wasPropRef = (0, _react.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, _react.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, _react.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function useUncontrolled(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = defaultKey(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = _objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map(_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = useUncontrolledProp(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3j5PE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePrevious);
var _react = require("react");
function usePrevious(value) {
    const ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j5gAr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useForceUpdate);
var _react = require("react");
function useForceUpdate() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, _react.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hnYlw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useEventListener);
var _react = require("react");
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
function useEventListener(eventTarget, event, listener, capture = false) {
    const handler = (0, _useEventCallbackDefault.default)(listener);
    (0, _react.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}

},{"react":"9njXz","./useEventCallback":"c26h1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c26h1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useEventCallback);
var _react = require("react");
var _useCommittedRef = require("./useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
function useEventCallback(fn) {
    const ref = (0, _useCommittedRefDefault.default)(fn);
    return (0, _react.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

},{"react":"9njXz","./useCommittedRef":"eY6zG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eY6zG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function useCommittedRef(value) {
    const ref = (0, _react.useRef)(value);
    (0, _react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
exports.default = useCommittedRef;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hxKWL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const DropdownContext = /*#__PURE__*/ _react.createContext(null);
exports.default = DropdownContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iWmjp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @memberOf Dropdown
 * @param {object}  options
 * @param {boolean} options.flip Automatically adjust the menu `drop` position based on viewport edge detection
 * @param {[number, number]} options.offset Define an offset distance between the Menu and the Toggle
 * @param {boolean} options.show Display the menu manually, ignored in the context of a `Dropdown`
 * @param {boolean} options.usePopper opt in/out of using PopperJS to position menus. When disabled you must position it yourself.
 * @param {string}  options.rootCloseEvent The pointer event to listen for when determining "clicks outside" the menu for triggering a close.
 * @param {object}  options.popperConfig Options passed to the [`usePopper`](/api/usePopper) hook.
 */ parcelHelpers.export(exports, "useDropdownMenu", ()=>useDropdownMenu);
var _react = require("react");
var _useCallbackRef = require("@restart/hooks/useCallbackRef");
var _useCallbackRefDefault = parcelHelpers.interopDefault(_useCallbackRef);
var _dropdownContext = require("./DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _usePopper = require("./usePopper");
var _usePopperDefault = parcelHelpers.interopDefault(_usePopper);
var _useClickOutside = require("./useClickOutside");
var _useClickOutsideDefault = parcelHelpers.interopDefault(_useClickOutside);
var _mergeOptionsWithPopperConfig = require("./mergeOptionsWithPopperConfig");
var _mergeOptionsWithPopperConfigDefault = parcelHelpers.interopDefault(_mergeOptionsWithPopperConfig);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children",
    "usePopper"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const noop = ()=>{};
function useDropdownMenu(options = {}) {
    const context = (0, _react.useContext)((0, _dropdownContextDefault.default));
    const [arrowElement, attachArrowRef] = (0, _useCallbackRefDefault.default)();
    const hasShownRef = (0, _react.useRef)(false);
    const { flip, offset, rootCloseEvent, fixed = false, placement: placementOverride, popperConfig = {}, enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement, setMenu, menuElement, toggleElement } = context || {};
    const popper = (0, _usePopperDefault.default)(toggleElement, menuElement, (0, _mergeOptionsWithPopperConfigDefault.default)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset,
        flip,
        fixed,
        arrowElement,
        popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show,
        placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, _useClickOutsideDefault.default)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function DropdownMenu(_ref) {
    let { children, usePopper: usePopperProp = true } = _ref, options = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [props, meta] = useDropdownMenu(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children(props, meta)
    });
}
DropdownMenu.displayName = 'DropdownMenu';
/** @component */ exports.default = DropdownMenu;

},{"react":"9njXz","@restart/hooks/useCallbackRef":"jw9sZ","./DropdownContext":"hxKWL","./usePopper":"7MsdQ","./useClickOutside":"4Hdqf","./mergeOptionsWithPopperConfig":"5mUS1","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jw9sZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCallbackRef);
var _react = require("react");
function useCallbackRef() {
    return (0, _react.useState)(null);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7MsdQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _dequal = require("dequal");
var _useSafeState = require("@restart/hooks/useSafeState");
var _useSafeStateDefault = parcelHelpers.interopDefault(_useSafeState);
var _popper = require("./popper");
const _excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state })=>()=>{
            const { reference, popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state })=>{
        var _popper$getAttribute;
        const { popper, reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled = true, placement = 'bottom', strategy = 'absolute', modifiers = EMPTY_MODIFIERS } = _ref, config = _objectWithoutPropertiesLoose(_ref, _excluded);
    const prevModifiers = (0, _react.useRef)(modifiers);
    const popperInstanceRef = (0, _react.useRef)();
    const update = (0, _react.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, _react.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, _useSafeStateDefault.default)((0, _react.useState)({
        placement,
        update,
        forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, _react.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state,
                    styles,
                    attributes,
                    update,
                    forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, _react.useMemo)(()=>{
        if (!(0, _dequal.dequal)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, _react.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement,
            strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, _react.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, _popper.createPopper)(referenceElement, popperElement, Object.assign({}, config, {
            placement,
            strategy,
            modifiers: [
                ...nextModifiers,
                ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
exports.default = usePopper;

},{"react":"9njXz","dequal":"6p9iP","@restart/hooks/useSafeState":"lPcEZ","./popper":"fpAki","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6p9iP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dequal", ()=>dequal);
var has = Object.prototype.hasOwnProperty;
function find(iter, tar, key) {
    for (key of iter.keys()){
        if (dequal(key, tar)) return key;
    }
}
function dequal(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && dequal(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!dequal(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if (has.call(foo, ctor) && ++len && !has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lPcEZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useMounted = require("./useMounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function useSafeState(state) {
    const isMounted = (0, _useMountedDefault.default)();
    return [
        state[0],
        (0, _react.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
exports.default = useSafeState;

},{"react":"9njXz","./useMounted":"3668D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3668D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMounted);
var _react = require("react");
function useMounted() {
    const mounted = (0, _react.useRef)(true);
    const isMounted = (0, _react.useRef)(()=>mounted.current);
    (0, _react.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fpAki":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "placements", ()=>(0, _enums.placements));
var _arrow = require("@popperjs/core/lib/modifiers/arrow");
var _arrowDefault = parcelHelpers.interopDefault(_arrow);
var _computeStyles = require("@popperjs/core/lib/modifiers/computeStyles");
var _computeStylesDefault = parcelHelpers.interopDefault(_computeStyles);
var _eventListeners = require("@popperjs/core/lib/modifiers/eventListeners");
var _eventListenersDefault = parcelHelpers.interopDefault(_eventListeners);
var _flip = require("@popperjs/core/lib/modifiers/flip");
var _flipDefault = parcelHelpers.interopDefault(_flip);
var _hide = require("@popperjs/core/lib/modifiers/hide");
var _hideDefault = parcelHelpers.interopDefault(_hide);
var _offset = require("@popperjs/core/lib/modifiers/offset");
var _offsetDefault = parcelHelpers.interopDefault(_offset);
var _popperOffsets = require("@popperjs/core/lib/modifiers/popperOffsets");
var _popperOffsetsDefault = parcelHelpers.interopDefault(_popperOffsets);
var _preventOverflow = require("@popperjs/core/lib/modifiers/preventOverflow");
var _preventOverflowDefault = parcelHelpers.interopDefault(_preventOverflow);
var _enums = require("@popperjs/core/lib/enums");
var _popperBase = require("@popperjs/core/lib/popper-base");
const createPopper = (0, _popperBase.popperGenerator)({
    defaultModifiers: [
        (0, _hideDefault.default),
        (0, _popperOffsetsDefault.default),
        (0, _computeStylesDefault.default),
        (0, _eventListenersDefault.default),
        (0, _offsetDefault.default),
        (0, _flipDefault.default),
        (0, _preventOverflowDefault.default),
        (0, _arrowDefault.default)
    ]
});

},{"@popperjs/core/lib/modifiers/arrow":"5Trmz","@popperjs/core/lib/modifiers/computeStyles":"jvHvj","@popperjs/core/lib/modifiers/eventListeners":"5tT8s","@popperjs/core/lib/modifiers/flip":"8WVPr","@popperjs/core/lib/modifiers/hide":"6kFua","@popperjs/core/lib/modifiers/offset":"2lcLd","@popperjs/core/lib/modifiers/popperOffsets":"hVDuj","@popperjs/core/lib/modifiers/preventOverflow":"jUko2","@popperjs/core/lib/enums":false,"@popperjs/core/lib/popper-base":"c5XtZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Trmz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

},{"../utils/getBasePlacement.js":"5S4fc","../dom-utils/getLayoutRect.js":"bweSm","../dom-utils/contains.js":"eGlaM","../dom-utils/getOffsetParent.js":"bLvkb","../utils/getMainAxisFromPlacement.js":"avEhJ","../utils/within.js":"cdkh1","../utils/mergePaddingObject.js":"43lYJ","../utils/expandToHashMap.js":"16QKI","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5S4fc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBasePlacement);
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split('-')[0];
}

},{"../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gVkdf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "left", ()=>left);
parcelHelpers.export(exports, "auto", ()=>auto);
parcelHelpers.export(exports, "basePlacements", ()=>basePlacements);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "end", ()=>end);
parcelHelpers.export(exports, "clippingParents", ()=>clippingParents);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "popper", ()=>popper);
parcelHelpers.export(exports, "reference", ()=>reference);
parcelHelpers.export(exports, "variationPlacements", ()=>variationPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "beforeRead", ()=>beforeRead);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "afterRead", ()=>afterRead);
parcelHelpers.export(exports, "beforeMain", ()=>beforeMain);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "afterMain", ()=>afterMain);
parcelHelpers.export(exports, "beforeWrite", ()=>beforeWrite);
parcelHelpers.export(exports, "write", ()=>write);
parcelHelpers.export(exports, "afterWrite", ()=>afterWrite);
parcelHelpers.export(exports, "modifierPhases", ()=>modifierPhases);
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers
var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bweSm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLayoutRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"4XyXs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XyXs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBoundingClientRect);
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"1bDAn","../utils/math.js":"8B7aS","./getWindow.js":"3ynkX","./isLayoutViewport.js":"hAhTK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1bDAn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ynkX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindow);
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8B7aS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "round", ()=>round);
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hAhTK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLayoutViewport);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"6fpMW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6fpMW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUAString);
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eGlaM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bLvkb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOffsetParent);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === 'html' || (0, _getNodeNameJsDefault.default)(offsetParent) === 'body' && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"3ynkX","./getNodeName.js":"jyQUh","./getComputedStyle.js":"5uZSa","./instanceOf.js":"1bDAn","./isTableElement.js":"btBRX","./getParentNode.js":"k0cfu","../utils/userAgent.js":"6fpMW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jyQUh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeName);
function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5uZSa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btBRX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTableElement);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"jyQUh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k0cfu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getParentNode);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"jyQUh","./getDocumentElement.js":"gcVmr","./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcVmr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentElement);
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avEhJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMainAxisFromPlacement);
function getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cdkh1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "withinMaxClamp", ()=>withinMaxClamp);
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"43lYJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergePaddingObject);
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"gtdyp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gtdyp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFreshSideObject);
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16QKI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>expandToHashMap);
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jvHvj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", ()=>mapToStyles);
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"gVkdf","../dom-utils/getOffsetParent.js":"bLvkb","../dom-utils/getWindow.js":"3ynkX","../dom-utils/getDocumentElement.js":"gcVmr","../dom-utils/getComputedStyle.js":"5uZSa","../utils/getBasePlacement.js":"5S4fc","../utils/getVariation.js":"4BYPr","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4BYPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getVariation);
function getVariation(placement) {
    return placement.split('-')[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5tT8s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
    });
    if (resize) window.addEventListener('resize', instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8WVPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"htgah","../utils/getBasePlacement.js":"5S4fc","../utils/getOppositeVariationPlacement.js":"3n1hw","../utils/detectOverflow.js":"6v2ts","../utils/computeAutoPlacement.js":"clJeY","../enums.js":"gVkdf","../utils/getVariation.js":"4BYPr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htgah":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositePlacement);
var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3n1hw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositeVariationPlacement);
var hash = {
    start: 'end',
    end: 'start'
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6v2ts":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectOverflow);
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"YPNSr","../dom-utils/getDocumentElement.js":"gcVmr","../dom-utils/getBoundingClientRect.js":"4XyXs","./computeOffsets.js":"gnv44","./rectToClientRect.js":"5PWlE","../enums.js":"gVkdf","../dom-utils/instanceOf.js":"1bDAn","./mergePaddingObject.js":"43lYJ","./expandToHashMap.js":"16QKI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"YPNSr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getClippingRect);
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"gVkdf","./getViewportRect.js":"2wQ5y","./getDocumentRect.js":"3LAyO","./listScrollParents.js":"1qClO","./getOffsetParent.js":"bLvkb","./getDocumentElement.js":"gcVmr","./getComputedStyle.js":"5uZSa","./instanceOf.js":"1bDAn","./getBoundingClientRect.js":"4XyXs","./getParentNode.js":"k0cfu","./contains.js":"eGlaM","./getNodeName.js":"jyQUh","../utils/rectToClientRect.js":"5PWlE","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2wQ5y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getViewportRect);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"3ynkX","./getDocumentElement.js":"gcVmr","./getWindowScrollBarX.js":"kaNJ3","./isLayoutViewport.js":"hAhTK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kaNJ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScrollBarX);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"4XyXs","./getDocumentElement.js":"gcVmr","./getWindowScroll.js":"btekq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btekq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScroll);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3LAyO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentRect);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === 'rtl') x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"gcVmr","./getComputedStyle.js":"5uZSa","./getWindowScrollBarX.js":"kaNJ3","./getWindowScroll.js":"btekq","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1qClO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>listScrollParents);
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"1igW6","./getParentNode.js":"k0cfu","./getWindow.js":"3ynkX","./isScrollParent.js":"eD7m7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1igW6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollParent);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"k0cfu","./isScrollParent.js":"eD7m7","./getNodeName.js":"jyQUh","./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eD7m7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isScrollParent);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"5uZSa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5PWlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rectToClientRect);
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gnv44":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeOffsets);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"5S4fc","./getVariation.js":"4BYPr","./getMainAxisFromPlacement.js":"avEhJ","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"clJeY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeAutoPlacement);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"4BYPr","../enums.js":"gVkdf","./detectOverflow.js":"6v2ts","./getBasePlacement.js":"5S4fc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kFua":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: hide
};

},{"../enums.js":"gVkdf","../utils/detectOverflow.js":"6v2ts","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2lcLd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", ()=>distanceAndSkiddingToXY);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"5S4fc","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hVDuj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"gnv44","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jUko2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === 'x' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

},{"../enums.js":"gVkdf","../utils/getBasePlacement.js":"5S4fc","../utils/getMainAxisFromPlacement.js":"avEhJ","../utils/getAltAxis.js":"l4M4a","../utils/within.js":"cdkh1","../dom-utils/getLayoutRect.js":"bweSm","../dom-utils/getOffsetParent.js":"bLvkb","../utils/detectOverflow.js":"6v2ts","../utils/getVariation.js":"4BYPr","../utils/getFreshSideObject.js":"gtdyp","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l4M4a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getAltAxis);
function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c5XtZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line import/no-unused-modules
parcelHelpers.export(exports, "createPopper", ()=>(0, _createPopperJs.createPopper));
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");

},{"./createPopper.js":"b4uCU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b4uCU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>popperGenerator);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _detectOverflowJsDefault.default));
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(reference, (0, _getOffsetParentJsDefault.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, _getLayoutRectJsDefault.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"4mQXp","./dom-utils/getLayoutRect.js":"bweSm","./dom-utils/listScrollParents.js":"1qClO","./dom-utils/getOffsetParent.js":"bLvkb","./utils/orderModifiers.js":"4RWkj","./utils/debounce.js":"gcfKw","./utils/mergeByName.js":"kcmZR","./utils/detectOverflow.js":false,"./dom-utils/instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4mQXp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCompositeRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"4XyXs","./getNodeScroll.js":"8P5ka","./getNodeName.js":"jyQUh","./instanceOf.js":"1bDAn","./getWindowScrollBarX.js":"kaNJ3","./getDocumentElement.js":"gcVmr","./isScrollParent.js":"eD7m7","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8P5ka":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeScroll);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"btekq","./getWindow.js":"3ynkX","./instanceOf.js":"1bDAn","./getHTMLElementScroll.js":"hYXUH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYXUH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHTMLElementScroll);
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4RWkj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderModifiers);
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcfKw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kcmZR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeByName);
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Hdqf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRefTarget", ()=>getRefTarget);
var _contains = require("dom-helpers/contains");
var _containsDefault = parcelHelpers.interopDefault(_contains);
var _listen = require("dom-helpers/listen");
var _listenDefault = parcelHelpers.interopDefault(_listen);
var _ownerDocument = require("dom-helpers/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
const noop = ()=>{};
function isLeftClickEvent(event) {
    return event.button === 0;
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const getRefTarget = (ref)=>ref && ('current' in ref ? ref.current : ref);
const InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function useClickOutside(ref, onClickOutside = noop, { disabled, clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, _react.useRef)(false);
    const waitingForTrigger = (0, _react.useRef)(false);
    const handleMouseCapture = (0, _react.useCallback)((e)=>{
        const currentTarget = getRefTarget(ref);
        (0, _warningDefault.default)(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || !!(0, _containsDefault.default)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, _useEventCallbackDefault.default)((e)=>{
        const currentTarget = getRefTarget(ref);
        if (currentTarget && (0, _containsDefault.default)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, _useEventCallbackDefault.default)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, _react.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, _ownerDocumentDefault.default)(getRefTarget(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if (InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, _listenDefault.default)(doc, InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, _listenDefault.default)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, _listenDefault.default)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, _listenDefault.default)(el, 'mousemove', noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
exports.default = useClickOutside;

},{"dom-helpers/contains":"9MLeA","dom-helpers/listen":"bQcJW","dom-helpers/ownerDocument":"dYqIu","react":"9njXz","@restart/hooks/useEventCallback":"c26h1","warning":"4kUCc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9MLeA":[function(require,module,exports,__globalThis) {
/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
function contains(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kUCc":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = false;
var warning = function() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"5mUS1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toModifierMap", ()=>toModifierMap);
parcelHelpers.export(exports, "toModifierArray", ()=>toModifierArray);
parcelHelpers.export(exports, "default", ()=>mergeOptionsWithPopperConfig);
function toModifierMap(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function toModifierArray(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function mergeOptionsWithPopperConfig({ enabled, enableEvents, placement, flip, offset, fixed, containerPadding, arrowElement, popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = toModifierMap(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement,
        enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: toModifierArray(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7snx4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRoleMenu", ()=>isRoleMenu);
/**
 * Wires up Dropdown toggle functionality, returning a set a props to attach
 * to the element that functions as the dropdown toggle (generally a button).
 *
 * @memberOf Dropdown
 */ parcelHelpers.export(exports, "useDropdownToggle", ()=>useDropdownToggle);
var _react = require("react");
var _ssr = require("./ssr");
var _dropdownContext = require("./DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _jsxRuntime = require("react/jsx-runtime");
const isRoleMenu = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const noop = ()=>{};
function useDropdownToggle() {
    const id = (0, _ssr.useSSRSafeId)();
    const { show = false, toggle = noop, setToggle, menuElement } = (0, _react.useContext)((0, _dropdownContextDefault.default)) || {};
    const handleClick = (0, _react.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id,
        ref: setToggle || noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && isRoleMenu(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show,
            toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function DropdownToggle({ children }) {
    const [props, meta] = useDropdownToggle();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children(props, meta)
    });
}
DropdownToggle.displayName = 'DropdownToggle';
/** @component */ exports.default = DropdownToggle;

},{"react":"9njXz","./ssr":"kaaZ9","./DropdownContext":"hxKWL","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kaaZ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSSRSafeId", ()=>(0, _ssr.useSSRSafeId));
parcelHelpers.export(exports, "useIsSSR", ()=>(0, _ssr.useIsSSR));
parcelHelpers.export(exports, "SSRProvider", ()=>(0, _ssr.SSRProvider));
var _ssr = require("@react-aria/ssr");

},{"@react-aria/ssr":"jG1RP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jG1RP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ parcelHelpers.export(exports, "SSRProvider", ()=>(0, _ssrproviderModuleJs.SSRProvider));
parcelHelpers.export(exports, "useSSRSafeId", ()=>(0, _ssrproviderModuleJs.useSSRSafeId));
parcelHelpers.export(exports, "useIsSSR", ()=>(0, _ssrproviderModuleJs.useIsSSR));
var _ssrproviderModuleJs = require("./SSRProvider.module.js");

},{"./SSRProvider.module.js":"bCYBc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bCYBc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SSRProvider", ()=>$b5e257d569688ac6$export$9f8ac96af4b1b2ae);
parcelHelpers.export(exports, "useIsSSR", ()=>$b5e257d569688ac6$export$535bd6ca7f90a273);
parcelHelpers.export(exports, "useSSRSafeId", ()=>$b5e257d569688ac6$export$619500959fc48b26);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $b5e257d569688ac6$var$SSRContext = (0, _reactDefault.default).createContext($b5e257d569688ac6$var$defaultContext);
const $b5e257d569688ac6$var$IsSSRContext = (0, _reactDefault.default).createContext(false);
// This is only used in React < 18.
function $b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, _react.useContext)($b5e257d569688ac6$var$SSRContext);
    let counter = $b5e257d569688ac6$var$useCounter(cur === $b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, _react.useState)(true);
    let value = (0, _react.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $b5e257d569688ac6$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, _react.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, _reactDefault.default).createElement($b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, _reactDefault.default).createElement($b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $b5e257d569688ac6$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, _reactDefault.default)['useId'] === 'function') {
        if (!$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn('In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.');
            $b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, props.children);
    }
    return (0, _reactDefault.default).createElement($b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $b5e257d569688ac6$var$componentIds = new WeakMap();
function $b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, _react.useContext)($b5e257d569688ac6$var$SSRContext);
    let ref = (0, _react.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, _reactDefault.default).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, _react.useContext)($b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $b5e257d569688ac6$var$defaultContext && !$b5e257d569688ac6$var$canUseDOM) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
    let counter = $b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    let id = (0, _reactDefault.default).useId();
    let [didSSR] = (0, _react.useState)($b5e257d569688ac6$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $b5e257d569688ac6$export$619500959fc48b26 = typeof (0, _reactDefault.default)['useId'] === 'function' ? $b5e257d569688ac6$var$useModernSSRSafeId : $b5e257d569688ac6$var$useLegacySSRSafeId;
function $b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $b5e257d569688ac6$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, _reactDefault.default)['useSyncExternalStore'] === 'function') return (0, _reactDefault.default)['useSyncExternalStore']($b5e257d569688ac6$var$subscribe, $b5e257d569688ac6$var$getSnapshot, $b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, _react.useContext)($b5e257d569688ac6$var$IsSSRContext);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hheT8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a dropdown item. Returns a set of props for the dropdown item component
 * including an `onClick` handler that prevents selection when the item is disabled
 */ parcelHelpers.export(exports, "useDropdownItem", ()=>useDropdownItem);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _navContext = require("./NavContext");
var _navContextDefault = parcelHelpers.interopDefault(_navContext);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dataKey = require("./DataKey");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function useDropdownItem({ key, href, active, disabled, onClick }) {
    const onSelectCtx = (0, _react.useContext)((0, _selectableContextDefault.default));
    const navContext = (0, _react.useContext)((0, _navContextDefault.default));
    const { activeKey } = navContext || {};
    const eventKey = (0, _selectableContext.makeEventKey)(key, href);
    const isActive = active == null && key != null ? (0, _selectableContext.makeEventKey)(activeKey) === eventKey : active;
    const handleClick = (0, _useEventCallbackDefault.default)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive,
            [(0, _dataKey.dataAttr)('dropdown-item')]: ''
        },
        {
            isActive
        }
    ];
}
const DropdownItem = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { eventKey, disabled, onClick, active, as: Component = (0, _buttonDefault.default) } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [dropdownItemProps] = useDropdownItem({
        key: eventKey,
        href: props.href,
        disabled,
        onClick,
        active
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
DropdownItem.displayName = 'DropdownItem';
exports.default = DropdownItem;

},{"react":"9njXz","@restart/hooks/useEventCallback":"c26h1","./SelectableContext":"7v5if","./NavContext":"67k7w","./Button":"jYGKr","./DataKey":"bOKZf","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7v5if":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeEventKey", ()=>makeEventKey);
var _react = require("react");
const SelectableContext = /*#__PURE__*/ _react.createContext(null);
const makeEventKey = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
exports.default = SelectableContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67k7w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const NavContext = /*#__PURE__*/ _react.createContext(null);
NavContext.displayName = 'NavContext';
exports.default = NavContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bOKZf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ATTRIBUTE_PREFIX", ()=>ATTRIBUTE_PREFIX);
parcelHelpers.export(exports, "PROPERTY_PREFIX", ()=>PROPERTY_PREFIX);
parcelHelpers.export(exports, "dataAttr", ()=>dataAttr);
parcelHelpers.export(exports, "dataProp", ()=>dataProp);
const ATTRIBUTE_PREFIX = `data-rr-ui-`;
const PROPERTY_PREFIX = `rrUi`;
function dataAttr(property) {
    return `${ATTRIBUTE_PREFIX}${property}`;
}
function dataProp(property) {
    return `${PROPERTY_PREFIX}${property}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kl9Hc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WindowProvider", ()=>WindowProvider);
parcelHelpers.export(exports, "default", ()=>useWindow);
var _react = require("react");
var _canUseDOM = require("dom-helpers/canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
const Context = /*#__PURE__*/ (0, _react.createContext)((0, _canUseDOMDefault.default) ? window : undefined);
const WindowProvider = Context.Provider;
function useWindow() {
    return (0, _react.useContext)(Context);
}

},{"react":"9njXz","dom-helpers/canUseDOM":"5QOsw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c40ge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUncontrolled", ()=>(0, _hookDefault.default));
parcelHelpers.export(exports, "useUncontrolledProp", ()=>(0, _hook.useUncontrolledProp));
parcelHelpers.export(exports, "uncontrollable", ()=>(0, _uncontrollableDefault.default));
var _hook = require("./hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _uncontrollable = require("./uncontrollable");
var _uncontrollableDefault = parcelHelpers.interopDefault(_uncontrollable);

},{"./hook":"3IxN9","./uncontrollable":"6dISo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3IxN9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUncontrolledProp", ()=>useUncontrolledProp);
parcelHelpers.export(exports, "default", ()=>useUncontrolled);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _utils = require("./utils");
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function useUncontrolledProp(propValue, defaultValue, handler) {
    var wasPropRef = (0, _react.useRef)(propValue !== undefined);
    var _useState = (0, _react.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, _react.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function useUncontrolled(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[_utils.defaultKey(fieldName)], propsValue = _ref[fieldName], rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
            _utils.defaultKey(fieldName),
            fieldName
        ].map(_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = useUncontrolledProp(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, _extendsDefault.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","./utils":"ecpNS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aAOJb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ecpNS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uncontrolledPropTypes", ()=>uncontrolledPropTypes);
parcelHelpers.export(exports, "isProp", ()=>isProp);
parcelHelpers.export(exports, "defaultKey", ()=>defaultKey);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ parcelHelpers.export(exports, "canAcceptRef", ()=>canAcceptRef);
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var noop = function noop() {};
function readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function uncontrolledPropTypes(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[defaultKey(prop)] = noop;
        var handler;
    });
    return propTypes;
}
function isProp(props, prop) {
    return props[prop] !== undefined;
}
function defaultKey(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function canAcceptRef(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}

},{"invariant":"eNRZI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eNRZI":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = invariant;

},{}],"6dISo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>uncontrollable);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactLifecyclesCompat = require("react-lifecycles-compat");
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _utils = require("./utils");
var _jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function uncontrollable(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = _utils.canAcceptRef(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map(_utils.defaultKey);
    !(canAcceptRef || !methods.length) && (0, _invariantDefault.default)(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLooseDefault.default)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, _extendsDefault.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[_utils.defaultKey(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, _extendsDefault.default)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!_utils.isProp(props, key) && _utils.isProp(prevProps, key)) nextState.values[key] = props[_utils.defaultKey(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, _reactDefault.default).Component);
    (0, _reactLifecyclesCompat.polyfill)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, _extendsDefault.default)({
        innerRef: function innerRef() {}
    }, _utils.uncontrolledPropTypes(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, _reactDefault.default).forwardRef) {
        WrappedComponent = (0, _reactDefault.default).forwardRef(function(props, ref) {
            return (0, _reactDefault.default).createElement(UncontrolledComponent, (0, _extendsDefault.default)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: _jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return uncontrollable(newComponent, (0, _extendsDefault.default)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","react-lifecycles-compat":"9jQEY","invariant":"eNRZI","./utils":"ecpNS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9jQEY":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyfill", ()=>polyfill);
function componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = componentWillMount;
        prototype.componentWillReceiveProps = componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3MIRo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useEventCallback);
var _react = require("react");
var _useCommittedRef = require("./useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
function useEventCallback(fn) {
    const ref = (0, _useCommittedRefDefault.default)(fn);
    return (0, _react.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

},{"react":"9njXz","./useCommittedRef":"ak3vi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ak3vi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function useCommittedRef(value) {
    const ref = (0, _react.useRef)(value);
    (0, _react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
exports.default = useCommittedRef;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1OlZ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const DropdownContext = /*#__PURE__*/ _react.createContext({});
DropdownContext.displayName = 'DropdownContext';
exports.default = DropdownContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dv1O6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DropdownDivider = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'hr', role = 'separator', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        role: role,
        ...props
    });
});
DropdownDivider.displayName = 'DropdownDivider';
exports.default = DropdownDivider;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fxhzi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DropdownHeader = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', role = 'heading', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        role: role,
        ...props
    });
});
DropdownHeader.displayName = 'DropdownHeader';
exports.default = DropdownHeader;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Sdmp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _dropdownItem = require("@restart/ui/DropdownItem");
var _anchor = require("@restart/ui/Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DropdownItem = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, eventKey, disabled = false, onClick, active, as: Component = (0, _anchorDefault.default), ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-item');
    const [dropdownItemProps, meta] = (0, _dropdownItem.useDropdownItem)({
        key: eventKey,
        href: props.href,
        disabled,
        onClick,
        active
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    });
});
DropdownItem.displayName = 'DropdownItem';
exports.default = DropdownItem;

},{"classnames":"5Een2","react":"9njXz","@restart/ui/DropdownItem":"hheT8","@restart/ui/Anchor":"f7VPb","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f7VPb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTrivialHref", ()=>isTrivialHref);
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/anchor-has-content */ var _react = require("react");
var _hooks = require("@restart/hooks");
var _button = require("./Button");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "onKeyDown"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function isTrivialHref(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const Anchor = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { onKeyDown } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [buttonProps] = (0, _button.useButtonProps)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, _hooks.useEventCallback)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if (isTrivialHref(props.href) || props.role === 'button') return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
Anchor.displayName = 'Anchor';
exports.default = Anchor;

},{"react":"9njXz","@restart/hooks":"eXoLy","./Button":"jYGKr","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eXoLy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallbackRef", ()=>(0, _useCallbackRefDefault.default));
parcelHelpers.export(exports, "useCommittedRef", ()=>(0, _useCommittedRefDefault.default));
parcelHelpers.export(exports, "useEventCallback", ()=>(0, _useEventCallbackDefault.default));
parcelHelpers.export(exports, "useEventListener", ()=>(0, _useEventListenerDefault.default));
parcelHelpers.export(exports, "useGlobalListener", ()=>(0, _useGlobalListenerDefault.default));
parcelHelpers.export(exports, "useInterval", ()=>(0, _useIntervalDefault.default));
parcelHelpers.export(exports, "useRafInterval", ()=>(0, _useRafIntervalDefault.default));
parcelHelpers.export(exports, "useMergeState", ()=>(0, _useMergeStateDefault.default));
parcelHelpers.export(exports, "useMergeStateFromProps", ()=>(0, _useMergeStateFromPropsDefault.default));
parcelHelpers.export(exports, "useMounted", ()=>(0, _useMountedDefault.default));
parcelHelpers.export(exports, "usePrevious", ()=>(0, _usePreviousDefault.default));
parcelHelpers.export(exports, "useImage", ()=>(0, _useImageDefault.default));
parcelHelpers.export(exports, "useResizeObserver", ()=>(0, _useResizeObserverDefault.default));
var _useCallbackRef = require("./useCallbackRef");
var _useCallbackRefDefault = parcelHelpers.interopDefault(_useCallbackRef);
var _useCommittedRef = require("./useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useEventListener = require("./useEventListener");
var _useEventListenerDefault = parcelHelpers.interopDefault(_useEventListener);
var _useGlobalListener = require("./useGlobalListener");
var _useGlobalListenerDefault = parcelHelpers.interopDefault(_useGlobalListener);
var _useInterval = require("./useInterval");
var _useIntervalDefault = parcelHelpers.interopDefault(_useInterval);
var _useRafInterval = require("./useRafInterval");
var _useRafIntervalDefault = parcelHelpers.interopDefault(_useRafInterval);
var _useMergeState = require("./useMergeState");
var _useMergeStateDefault = parcelHelpers.interopDefault(_useMergeState);
var _useMergeStateFromProps = require("./useMergeStateFromProps");
var _useMergeStateFromPropsDefault = parcelHelpers.interopDefault(_useMergeStateFromProps);
var _useMounted = require("./useMounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _usePrevious = require("./usePrevious");
var _usePreviousDefault = parcelHelpers.interopDefault(_usePrevious);
var _useImage = require("./useImage");
var _useImageDefault = parcelHelpers.interopDefault(_useImage);
var _useResizeObserver = require("./useResizeObserver");
var _useResizeObserverDefault = parcelHelpers.interopDefault(_useResizeObserver);

},{"./useCallbackRef":"jw9sZ","./useCommittedRef":"eY6zG","./useEventCallback":"c26h1","./useEventListener":"hnYlw","./useGlobalListener":"9QsA9","./useInterval":"5Kexb","./useRafInterval":"i5oFz","./useMergeState":"8PAc7","./useMergeStateFromProps":"aUm9L","./useMounted":"3668D","./usePrevious":"3j5PE","./useImage":"2rpOv","./useResizeObserver":"6ahxy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9QsA9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useGlobalListener);
var _useEventListener = require("./useEventListener");
var _useEventListenerDefault = parcelHelpers.interopDefault(_useEventListener);
var _react = require("react");
function useGlobalListener(event, handler, capture = false) {
    const documentTarget = (0, _react.useCallback)(()=>document, []);
    return (0, _useEventListenerDefault.default)(documentTarget, event, handler, capture);
}

},{"./useEventListener":"hnYlw","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Kexb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useCommittedRef = require("./useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, _useCommittedRefDefault.default)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, _useCommittedRefDefault.default)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, _react.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
exports.default = useInterval;

},{"react":"9njXz","./useCommittedRef":"eY6zG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i5oFz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useCommittedRef = require("./useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
function useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, _useCommittedRefDefault.default)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, _useCommittedRefDefault.default)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, _react.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
exports.default = useRafInterval;

},{"react":"9njXz","./useCommittedRef":"eY6zG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8PAc7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMergeState);
var _react = require("react");
function useMergeState(initialState) {
    const [state, setState] = (0, _react.useState)(initialState);
    const updater = (0, _react.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aUm9L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMergeStateFromProps);
var _useMergeState = require("./useMergeState");
var _useMergeStateDefault = parcelHelpers.interopDefault(_useMergeState);
function useMergeStateFromProps(props, gDSFP, initialState) {
    const [state, setState] = (0, _useMergeStateDefault.default)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}

},{"./useMergeState":"8PAc7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2rpOv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useImage);
var _react = require("react");
function useImage(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, _react.useState)({
        image: null,
        error: null
    });
    (0, _react.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image,
                error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6ahxy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useResizeObserver);
var _react = require("react");
var _useIsomorphicEffect = require("./useIsomorphicEffect");
var _useIsomorphicEffectDefault = parcelHelpers.interopDefault(_useIsomorphicEffect);
const targetMap = new WeakMap();
let resizeObserver;
function getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return resizeObserver = resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function useResizeObserver(element) {
    const [rect, setRect] = (0, _react.useState)(null);
    (0, _useIsomorphicEffectDefault.default)(()=>{
        if (!element) return;
        getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}

},{"react":"9njXz","./useIsomorphicEffect":"8bm5s","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8bm5s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var global = arguments[3];
const isReactNative = typeof global !== 'undefined' && // @ts-ignore
global.navigator && // @ts-ignore
global.navigator.product === 'ReactNative';
const isDOM = typeof document !== 'undefined';
/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ exports.default = isDOM || isReactNative ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aEmjc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DropdownItemText = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
DropdownItemText.displayName = 'DropdownItemText';
exports.default = DropdownItemText;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8cCR3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDropdownMenuPlacement", ()=>getDropdownMenuPlacement);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _dropdownMenu = require("@restart/ui/DropdownMenu");
var _useIsomorphicEffect = require("@restart/hooks/useIsomorphicEffect");
var _useIsomorphicEffectDefault = parcelHelpers.interopDefault(_useIsomorphicEffect);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _dropdownContext = require("./DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _inputGroupContext = require("./InputGroupContext");
var _inputGroupContextDefault = parcelHelpers.interopDefault(_inputGroupContext);
var _navbarContext = require("./NavbarContext");
var _navbarContextDefault = parcelHelpers.interopDefault(_navbarContext);
var _themeProvider = require("./ThemeProvider");
var _useWrappedRefWithWarning = require("./useWrappedRefWithWarning");
var _useWrappedRefWithWarningDefault = parcelHelpers.interopDefault(_useWrappedRefWithWarning);
var _types = require("./types");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function getDropdownMenuPlacement(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? 'top-end' : 'top-start';
    const topEnd = isRTL ? 'top-start' : 'top-end';
    const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    const leftStart = isRTL ? 'right-start' : 'left-start';
    const leftEnd = isRTL ? 'right-end' : 'left-end';
    const rightStart = isRTL ? 'left-start' : 'right-start';
    const rightEnd = isRTL ? 'left-end' : 'right-end';
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
const DropdownMenu = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, align, rootCloseEvent, flip = true, show: showProps, renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', popperConfig, variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, _react.useContext)((0, _navbarContextDefault.default));
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-menu');
    const { align: contextAlign, drop, isRTL } = (0, _react.useContext)((0, _dropdownContextDefault.default));
    align = align || contextAlign;
    const isInputGroup = (0, _react.useContext)((0, _inputGroupContextDefault.default));
    const alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === 'end') alignEnd = true;
    }
    const placement = getDropdownMenuPlacement(alignEnd, drop, isRTL);
    const [menuProps, { hasShown, popper, show, toggle }] = (0, _dropdownMenu.useDropdownMenu)({
        flip,
        rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig,
        placement
    });
    menuProps.ref = (0, _useMergedRefsDefault.default)((0, _useWrappedRefWithWarningDefault.default)(ref, 'DropdownMenu'), menuProps.ref);
    (0, _useIsomorphicEffectDefault.default)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            'data-bs-popper': 'static'
        },
        className: (0, _classnamesDefault.default)(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
DropdownMenu.displayName = 'DropdownMenu';
exports.default = DropdownMenu;

},{"classnames":"5Een2","react":"9njXz","@restart/ui/DropdownMenu":"iWmjp","@restart/hooks/useIsomorphicEffect":"7BtXW","@restart/hooks/useMergedRefs":"cU99Q","warning":"4kUCc","./DropdownContext":"1OlZ9","./InputGroupContext":"4oqFY","./NavbarContext":"a9ajw","./ThemeProvider":"t5pcW","./useWrappedRefWithWarning":"lrJmu","./types":"esAMz","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7BtXW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var global = arguments[3];
const isReactNative = typeof global !== 'undefined' && // @ts-ignore
global.navigator && // @ts-ignore
global.navigator.product === 'ReactNative';
const isDOM = typeof document !== 'undefined';
/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ exports.default = isDOM || isReactNative ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4oqFY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const context = /*#__PURE__*/ _react.createContext(null);
context.displayName = 'InputGroupContext';
exports.default = context;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a9ajw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
// TODO: check
const context = /*#__PURE__*/ _react.createContext(null);
context.displayName = 'NavbarContext';
exports.default = context;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lrJmu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useWrappedRefWithWarning);
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _react = require("react");
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
function useWrappedRefWithWarning(ref, componentName) {
    return ref;
}

},{"invariant":"eNRZI","react":"9njXz","@restart/hooks/useMergedRefs":"cU99Q","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"esAMz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignPropType", ()=>alignPropType);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const alignDirection = (0, _propTypesDefault.default).oneOf([
    'start',
    'end'
]);
const alignPropType = (0, _propTypesDefault.default).oneOfType([
    alignDirection,
    (0, _propTypesDefault.default).shape({
        sm: alignDirection
    }),
    (0, _propTypesDefault.default).shape({
        md: alignDirection
    }),
    (0, _propTypesDefault.default).shape({
        lg: alignDirection
    }),
    (0, _propTypesDefault.default).shape({
        xl: alignDirection
    }),
    (0, _propTypesDefault.default).shape({
        xxl: alignDirection
    }),
    (0, _propTypesDefault.default).object
]);

},{"prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gk26n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _dropdownContext = require("@restart/ui/DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _dropdownToggle = require("@restart/ui/DropdownToggle");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _themeProvider = require("./ThemeProvider");
var _useWrappedRefWithWarning = require("./useWrappedRefWithWarning");
var _useWrappedRefWithWarningDefault = parcelHelpers.interopDefault(_useWrappedRefWithWarning);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DropdownToggle = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, split, className, childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, _buttonDefault.default), ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-toggle');
    const dropdownContext = (0, _react.useContext)((0, _dropdownContextDefault.default));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, _dropdownToggle.useDropdownToggle)();
    toggleProps.ref = (0, _useMergedRefsDefault.default)(toggleProps.ref, (0, _useWrappedRefWithWarningDefault.default)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        className: (0, _classnamesDefault.default)(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
        ...toggleProps,
        ...props
    });
});
DropdownToggle.displayName = 'DropdownToggle';
exports.default = DropdownToggle;

},{"@restart/hooks/useMergedRefs":"cU99Q","@restart/ui/DropdownContext":"hxKWL","@restart/ui/DropdownToggle":"7snx4","classnames":"5Een2","react":"9njXz","./Button":"2TJC6","./ThemeProvider":"t5pcW","./useWrappedRefWithWarning":"lrJmu","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fXf7Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _transition = require("react-transition-group/Transition");
var _transitionEndListener = require("./transitionEndListener");
var _transitionEndListenerDefault = parcelHelpers.interopDefault(_transitionEndListener);
var _triggerBrowserReflow = require("./triggerBrowserReflow");
var _triggerBrowserReflowDefault = parcelHelpers.interopDefault(_triggerBrowserReflow);
var _transitionWrapper = require("./TransitionWrapper");
var _transitionWrapperDefault = parcelHelpers.interopDefault(_transitionWrapper);
var _jsxRuntime = require("react/jsx-runtime");
const fadeStyles = {
    [(0, _transition.ENTERING)]: 'show',
    [(0, _transition.ENTERED)]: 'show'
};
const Fade = /*#__PURE__*/ _react.forwardRef(({ className, children, transitionClasses = {}, onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, _react.useCallback)((node, isAppearing)=>{
        (0, _triggerBrowserReflowDefault.default)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transitionWrapperDefault.default), {
        ref: ref,
        addEndListener: (0, _transitionEndListenerDefault.default),
        ...props,
        onEnter: handleEnter,
        childRef: children.ref,
        children: (status, innerProps)=>/*#__PURE__*/ _react.cloneElement(children, {
                ...innerProps,
                className: (0, _classnamesDefault.default)('fade', className, children.props.className, fadeStyles[status], transitionClasses[status])
            })
    });
});
Fade.displayName = 'Fade';
exports.default = Fade;

},{"classnames":"5Een2","react":"9njXz","react-transition-group/Transition":"6LVcl","./transitionEndListener":"cbuHm","./triggerBrowserReflow":"cZXZ6","./TransitionWrapper":"jxF2v","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j4K62":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _formCheck = require("./FormCheck");
var _formCheckDefault = parcelHelpers.interopDefault(_formCheck);
var _formControl = require("./FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formFloating = require("./FormFloating");
var _formFloatingDefault = parcelHelpers.interopDefault(_formFloating);
var _formGroup = require("./FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _formLabel = require("./FormLabel");
var _formLabelDefault = parcelHelpers.interopDefault(_formLabel);
var _formRange = require("./FormRange");
var _formRangeDefault = parcelHelpers.interopDefault(_formRange);
var _formSelect = require("./FormSelect");
var _formSelectDefault = parcelHelpers.interopDefault(_formSelect);
var _formText = require("./FormText");
var _formTextDefault = parcelHelpers.interopDefault(_formText);
var _switch = require("./Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _floatingLabel = require("./FloatingLabel");
var _floatingLabelDefault = parcelHelpers.interopDefault(_floatingLabel);
var _jsxRuntime = require("react/jsx-runtime");
const propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, _propTypesDefault.default).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, _propTypesDefault.default).bool,
    as: (0, _propTypesDefault.default).elementType
};
const Form = /*#__PURE__*/ _react.forwardRef(({ className, validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, validated && 'was-validated')
    }));
Form.displayName = 'Form';
Form.propTypes = propTypes;
exports.default = Object.assign(Form, {
    Group: (0, _formGroupDefault.default),
    Control: (0, _formControlDefault.default),
    Floating: (0, _formFloatingDefault.default),
    Check: (0, _formCheckDefault.default),
    Switch: (0, _switchDefault.default),
    Label: (0, _formLabelDefault.default),
    Text: (0, _formTextDefault.default),
    Range: (0, _formRangeDefault.default),
    Select: (0, _formSelectDefault.default),
    FloatingLabel: (0, _floatingLabelDefault.default)
});

},{"classnames":"5Een2","prop-types":"bnNSm","react":"9njXz","./FormCheck":"htLFH","./FormControl":"9lN0O","./FormFloating":"jCzko","./FormGroup":"gsqum","./FormLabel":"55u89","./FormRange":"7rmLr","./FormSelect":"f1nIg","./FormText":"lxOxd","./Switch":"4SYah","./FloatingLabel":"4JRQj","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htLFH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _feedback = require("./Feedback");
var _feedbackDefault = parcelHelpers.interopDefault(_feedback);
var _formCheckInput = require("./FormCheckInput");
var _formCheckInputDefault = parcelHelpers.interopDefault(_formCheckInput);
var _formCheckLabel = require("./FormCheckLabel");
var _formCheckLabelDefault = parcelHelpers.interopDefault(_formCheckLabel);
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _themeProvider = require("./ThemeProvider");
var _elementChildren = require("./ElementChildren");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormCheck = /*#__PURE__*/ _react.forwardRef(({ id, bsPrefix, bsSwitchPrefix, inline = false, reverse = false, disabled = false, isValid = false, isInvalid = false, feedbackTooltip = false, feedback, feedbackType, className, style, title = '', type = 'checkbox', label, children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, _themeProvider.useBootstrapPrefix)(bsSwitchPrefix, 'form-switch');
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    const innerFormContext = (0, _react.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, _elementChildren.hasChildOfType)(children, (0, _formCheckLabelDefault.default));
    const input = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formCheckInputDefault.default), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formContextDefault.default).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: style,
            className: (0, _classnamesDefault.default)(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formCheckLabelDefault.default), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _feedbackDefault.default), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
FormCheck.displayName = 'FormCheck';
exports.default = Object.assign(FormCheck, {
    Input: (0, _formCheckInputDefault.default),
    Label: (0, _formCheckLabelDefault.default)
});

},{"classnames":"5Een2","react":"9njXz","./Feedback":"emJBq","./FormCheckInput":"aMgAd","./FormCheckLabel":"fw9o6","./FormContext":"4PwAV","./ThemeProvider":"t5pcW","./ElementChildren":"1QKQY","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"emJBq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _jsxRuntime = require("react/jsx-runtime");
const propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, _propTypesDefault.default).string,
    /** Display feedback as a tooltip. */ tooltip: (0, _propTypesDefault.default).bool,
    as: (0, _propTypesDefault.default).elementType
};
const Feedback = /*#__PURE__*/ _react.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className, type = 'valid', tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
Feedback.displayName = 'Feedback';
Feedback.propTypes = propTypes;
exports.default = Feedback;

},{"classnames":"5Een2","react":"9njXz","prop-types":"bnNSm","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aMgAd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormCheckInput = /*#__PURE__*/ _react.forwardRef(({ id, bsPrefix, className, type = 'checkbox', isValid = false, isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, _classnamesDefault.default)(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
FormCheckInput.displayName = 'FormCheckInput';
exports.default = FormCheckInput;

},{"classnames":"5Een2","react":"9njXz","./FormContext":"4PwAV","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4PwAV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
// TODO
const FormContext = /*#__PURE__*/ _react.createContext({});
exports.default = FormContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fw9o6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormCheckLabel = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, htmlFor, ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, _classnamesDefault.default)(className, bsPrefix)
    });
});
FormCheckLabel.displayName = 'FormCheckLabel';
exports.default = FormCheckLabel;

},{"classnames":"5Een2","react":"9njXz","./FormContext":"4PwAV","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1QKQY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "forEach", ()=>forEach);
parcelHelpers.export(exports, "hasChildOfType", ()=>hasChildOfType);
var _react = require("react");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function map(children, func) {
    let index = 0;
    return _react.Children.map(children, (child)=>/*#__PURE__*/ _react.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function forEach(children, func) {
    let index = 0;
    _react.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ _react.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function hasChildOfType(children, type) {
    return _react.Children.toArray(children).some((child)=>/*#__PURE__*/ _react.isValidElement(child) && child.type === type);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9lN0O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _feedback = require("./Feedback");
var _feedbackDefault = parcelHelpers.interopDefault(_feedback);
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormControl = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, type, size, htmlSize, id, className, isValid = false, isInvalid = false, plaintext, readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, _classnamesDefault.default)(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
FormControl.displayName = 'FormControl';
exports.default = Object.assign(FormControl, {
    Feedback: (0, _feedbackDefault.default)
});

},{"classnames":"5Een2","react":"9njXz","warning":"4kUCc","./Feedback":"emJBq","./FormContext":"4PwAV","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jCzko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormFloating = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
FormFloating.displayName = 'FormFloating';
exports.default = FormFloating;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gsqum":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _jsxRuntime = require("react/jsx-runtime");
const FormGroup = /*#__PURE__*/ _react.forwardRef(({ controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, _react.useMemo)(()=>({
            controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formContextDefault.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
FormGroup.displayName = 'FormGroup';
exports.default = FormGroup;

},{"react":"9njXz","./FormContext":"4PwAV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"55u89":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _col = require("./Col");
var _colDefault = parcelHelpers.interopDefault(_col);
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormLabel = /*#__PURE__*/ _react.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix, column = false, visuallyHidden = false, className, htmlFor, ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, _classnamesDefault.default)(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colDefault.default), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    }));
});
FormLabel.displayName = 'FormLabel';
exports.default = FormLabel;

},{"classnames":"5Een2","react":"9njXz","warning":"4kUCc","./Col":"aPBtB","./FormContext":"4PwAV","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7rmLr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormRange = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, id, ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        id: id || controlId
    });
});
FormRange.displayName = 'FormRange';
exports.default = FormRange;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./FormContext":"4PwAV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f1nIg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormSelect = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, size, htmlSize, className, isValid = false, isInvalid = false, id, ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
FormSelect.displayName = 'FormSelect';
exports.default = FormSelect;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./FormContext":"4PwAV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lxOxd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormText = /*#__PURE__*/ _react.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix, className, as: Component = 'small', muted, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix, muted && 'text-muted')
    });
});
FormText.displayName = 'FormText';
exports.default = FormText;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4SYah":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _formCheck = require("./FormCheck");
var _formCheckDefault = parcelHelpers.interopDefault(_formCheck);
var _jsxRuntime = require("react/jsx-runtime");
const Switch = /*#__PURE__*/ _react.forwardRef((props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formCheckDefault.default), {
        ...props,
        ref: ref,
        type: "switch"
    }));
Switch.displayName = 'Switch';
exports.default = Object.assign(Switch, {
    Input: (0, _formCheckDefault.default).Input,
    Label: (0, _formCheckDefault.default).Label
});

},{"react":"9njXz","./FormCheck":"htLFH","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4JRQj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _formGroup = require("./FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FloatingLabel = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, children, controlId, label, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formGroupDefault.default), {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
FloatingLabel.displayName = 'FloatingLabel';
exports.default = FloatingLabel;

},{"classnames":"5Een2","react":"9njXz","./FormGroup":"gsqum","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3cBFx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _formCheckInput = require("./FormCheckInput");
var _formCheckInputDefault = parcelHelpers.interopDefault(_formCheckInput);
var _inputGroupContext = require("./InputGroupContext");
var _inputGroupContextDefault = parcelHelpers.interopDefault(_inputGroupContext);
var _inputGroupText = require("./InputGroupText");
var _inputGroupTextDefault = parcelHelpers.interopDefault(_inputGroupText);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const InputGroupCheckbox = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputGroupTextDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formCheckInputDefault.default), {
            type: "checkbox",
            ...props
        })
    });
const InputGroupRadio = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputGroupTextDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formCheckInputDefault.default), {
            type: "radio",
            ...props
        })
    });
const InputGroup = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, size, hasValidation, className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'input-group');
    // Intentionally an empty object. Used in detecting if a dropdown
    // exists under an input group.
    const contextValue = (0, _react.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputGroupContextDefault.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, _classnamesDefault.default)(className, bsPrefix, size && `${bsPrefix}-${size}`, hasValidation && 'has-validation')
        })
    });
});
InputGroup.displayName = 'InputGroup';
exports.default = Object.assign(InputGroup, {
    Text: (0, _inputGroupTextDefault.default),
    Radio: InputGroupRadio,
    Checkbox: InputGroupCheckbox
});

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./FormCheckInput":"aMgAd","./InputGroupContext":"4oqFY","./InputGroupText":"d32nn","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d32nn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const InputGroupText = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'input-group-text');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
InputGroupText.displayName = 'InputGroupText';
exports.default = InputGroupText;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bkane":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _uncontrollable = require("uncontrollable");
var _nav = require("@restart/ui/Nav");
var _navDefault = parcelHelpers.interopDefault(_nav);
var _themeProvider = require("./ThemeProvider");
var _listGroupItem = require("./ListGroupItem");
var _listGroupItemDefault = parcelHelpers.interopDefault(_listGroupItem);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ListGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { className, bsPrefix: initialBsPrefix, variant, horizontal, numbered, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as = 'div', ...controlledProps } = (0, _uncontrollable.useUncontrolled)(props, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, _themeProvider.useBootstrapPrefix)(initialBsPrefix, 'list-group');
    let horizontalVariant;
    if (horizontal) horizontalVariant = horizontal === true ? 'horizontal' : `horizontal-${horizontal}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navDefault.default), {
        ref: ref,
        ...controlledProps,
        as: as,
        className: (0, _classnamesDefault.default)(className, bsPrefix, variant && `${bsPrefix}-${variant}`, horizontalVariant && `${bsPrefix}-${horizontalVariant}`, numbered && `${bsPrefix}-numbered`)
    });
});
ListGroup.displayName = 'ListGroup';
exports.default = Object.assign(ListGroup, {
    Item: (0, _listGroupItemDefault.default)
});

},{"classnames":"5Een2","react":"9njXz","warning":"4kUCc","uncontrollable":"c40ge","@restart/ui/Nav":"aBPog","./ThemeProvider":"t5pcW","./ListGroupItem":"d4tdZ","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aBPog":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _querySelectorAll = require("dom-helpers/querySelectorAll");
var _querySelectorAllDefault = parcelHelpers.interopDefault(_querySelectorAll);
var _react = require("react");
var _useForceUpdate = require("@restart/hooks/useForceUpdate");
var _useForceUpdateDefault = parcelHelpers.interopDefault(_useForceUpdate);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _navContext = require("./NavContext");
var _navContextDefault = parcelHelpers.interopDefault(_navContext);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _tabContext = require("./TabContext");
var _tabContextDefault = parcelHelpers.interopDefault(_tabContext);
var _dataKey = require("./DataKey");
var _navItem = require("./NavItem");
var _navItemDefault = parcelHelpers.interopDefault(_navItem);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = ()=>{};
const EVENT_KEY_ATTR = (0, _dataKey.dataAttr)('event-key');
const Nav = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect, activeKey, role, onKeyDown } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, _useForceUpdateDefault.default)();
    const needsRefocusRef = (0, _react.useRef)(false);
    const parentOnSelect = (0, _react.useContext)((0, _selectableContextDefault.default));
    const tabContext = (0, _react.useContext)((0, _tabContextDefault.default));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, _react.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, _querySelectorAllDefault.default)(currentListNode, `[${EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, _dataKey.dataProp)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, _react.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, _useMergedRefsDefault.default)(ref, listNode);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectableContextDefault.default).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navContextDefault.default).Provider, {
            value: {
                role,
                // used by NavLink to determine it's role
                activeKey: (0, _selectableContext.makeEventKey)(activeKey),
                getControlledId: getControlledId || noop,
                getControllerId: getControllerId || noop
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
Nav.displayName = 'Nav';
exports.default = Object.assign(Nav, {
    Item: (0, _navItemDefault.default)
});

},{"dom-helpers/querySelectorAll":"gZHK3","react":"9njXz","@restart/hooks/useForceUpdate":"j5gAr","@restart/hooks/useMergedRefs":"eqVs8","./NavContext":"67k7w","./SelectableContext":"7v5if","./TabContext":"2mDhT","./DataKey":"bOKZf","./NavItem":"bche0","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eqVs8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeRefs", ()=>mergeRefs);
var _react = require("react");
const toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function mergeRefs(refA, refB) {
    const a = toFnRef(refA);
    const b = toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function useMergedRefs(refA, refB) {
    return (0, _react.useMemo)(()=>mergeRefs(refA, refB), [
        refA,
        refB
    ]);
}
exports.default = useMergedRefs;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2mDhT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const TabContext = /*#__PURE__*/ _react.createContext(null);
exports.default = TabContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bche0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useNavItem", ()=>useNavItem);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _navContext = require("./NavContext");
var _navContextDefault = parcelHelpers.interopDefault(_navContext);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dataKey = require("./DataKey");
var _tabContext = require("./TabContext");
var _tabContextDefault = parcelHelpers.interopDefault(_tabContext);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "as",
    "active",
    "eventKey"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function useNavItem({ key, onClick, active, id, role, disabled }) {
    const parentOnSelect = (0, _react.useContext)((0, _selectableContextDefault.default));
    const navContext = (0, _react.useContext)((0, _navContextDefault.default));
    const tabContext = (0, _react.useContext)((0, _tabContextDefault.default));
    let isActive = active;
    const props = {
        role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, _dataKey.dataAttr)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, _useEventCallbackDefault.default)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive
        }
    ];
}
const NavItem = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { as: Component = (0, _buttonDefault.default), active, eventKey } = _ref, options = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [props, meta] = useNavItem(Object.assign({
        key: (0, _selectableContext.makeEventKey)(eventKey, options.href),
        active
    }, options));
    // @ts-ignore
    props[(0, _dataKey.dataAttr)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
NavItem.displayName = 'NavItem';
exports.default = NavItem;

},{"react":"9njXz","@restart/hooks/useEventCallback":"c26h1","./NavContext":"67k7w","./SelectableContext":"7v5if","./Button":"jYGKr","./DataKey":"bOKZf","./TabContext":"2mDhT","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d4tdZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _navItem = require("@restart/ui/NavItem");
var _selectableContext = require("@restart/ui/SelectableContext");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ListGroupItem = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, active, disabled, eventKey, className, variant, action, as, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'list-group-item');
    const [navItemProps, meta] = (0, _navItem.useNavItem)({
        key: (0, _selectableContext.makeEventKey)(eventKey, props.href),
        active,
        ...props
    });
    const handleClick = (0, _useEventCallbackDefault.default)((event)=>{
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        navItemProps.onClick(event);
    });
    if (disabled && props.tabIndex === undefined) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    // eslint-disable-next-line no-nested-ternary
    const Component = as || (action ? props.href ? 'a' : 'button' : 'div');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        ...navItemProps,
        onClick: handleClick,
        className: (0, _classnamesDefault.default)(className, bsPrefix, meta.isActive && 'active', disabled && 'disabled', variant && `${bsPrefix}-${variant}`, action && `${bsPrefix}-action`)
    });
});
ListGroupItem.displayName = 'ListGroupItem';
exports.default = ListGroupItem;

},{"classnames":"5Een2","react":"9njXz","warning":"4kUCc","@restart/hooks/useEventCallback":"3MIRo","@restart/ui/NavItem":"bche0","@restart/ui/SelectableContext":"7v5if","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dAasA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _addEventListener = require("dom-helpers/addEventListener");
var _addEventListenerDefault = parcelHelpers.interopDefault(_addEventListener);
var _canUseDOM = require("dom-helpers/canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
var _ownerDocument = require("dom-helpers/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _removeEventListener = require("dom-helpers/removeEventListener");
var _removeEventListenerDefault = parcelHelpers.interopDefault(_removeEventListener);
var _scrollbarSize = require("dom-helpers/scrollbarSize");
var _scrollbarSizeDefault = parcelHelpers.interopDefault(_scrollbarSize);
var _useCallbackRef = require("@restart/hooks/useCallbackRef");
var _useCallbackRefDefault = parcelHelpers.interopDefault(_useCallbackRef);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _useWillUnmount = require("@restart/hooks/useWillUnmount");
var _useWillUnmountDefault = parcelHelpers.interopDefault(_useWillUnmount);
var _transitionEnd = require("dom-helpers/transitionEnd");
var _transitionEndDefault = parcelHelpers.interopDefault(_transitionEnd);
var _react = require("react");
var _modal = require("@restart/ui/Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _bootstrapModalManager = require("./BootstrapModalManager");
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _modalBody = require("./ModalBody");
var _modalBodyDefault = parcelHelpers.interopDefault(_modalBody);
var _modalContext = require("./ModalContext");
var _modalContextDefault = parcelHelpers.interopDefault(_modalContext);
var _modalDialog = require("./ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _modalFooter = require("./ModalFooter");
var _modalFooterDefault = parcelHelpers.interopDefault(_modalFooter);
var _modalHeader = require("./ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _modalTitle = require("./ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
/* eslint-disable no-use-before-define, react/no-multi-comp */ function DialogTransition(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
        ...props,
        timeout: null
    });
}
function BackdropTransition(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
        ...props,
        timeout: null
    });
}
/* eslint-enable no-use-before-define */ const Modal = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, style, dialogClassName, contentClassName, children, dialogAs: Dialog = (0, _modalDialogDefault.default), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, /* BaseModal props */ show = false, animation = true, backdrop = true, keyboard = true, onEscapeKeyDown, onShow, onHide, container, autoFocus = true, enforceFocus = true, restoreFocus = true, restoreFocusOptions, onEntered, onExit, onExiting, onEnter, onEntering, onExited, backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, _react.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, _react.useState)(false);
    const waitingForMouseUpRef = (0, _react.useRef)(false);
    const ignoreBackdropClickRef = (0, _react.useRef)(false);
    const removeStaticModalAnimationRef = (0, _react.useRef)(null);
    const [modal, setModalRef] = (0, _useCallbackRefDefault.default)();
    const mergedRef = (0, _useMergedRefsDefault.default)(ref, setModalRef);
    const handleHide = (0, _useEventCallbackDefault.default)(onHide);
    const isRTL = (0, _themeProvider.useIsRTL)();
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal');
    const modalContext = (0, _react.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, _bootstrapModalManager.getSharedManager)({
            isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, _canUseDOMDefault.default)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, _ownerDocumentDefault.default)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSizeDefault.default)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, _scrollbarSizeDefault.default)() : undefined
        });
    }
    const handleWindowResize = (0, _useEventCallbackDefault.default)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, _useWillUnmountDefault.default)(()=>{
        (0, _removeEventListenerDefault.default)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, _transitionEndDefault.default)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, _addEventListenerDefault.default)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, _removeEventListenerDefault.default)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, _react.useCallback)((backdropProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ...backdropProps,
            className: (0, _classnamesDefault.default)(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, _classnamesDefault.default)(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalContextDefault.default).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? DialogTransition : undefined,
            backdropTransition: animation ? BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
Modal.displayName = 'Modal';
exports.default = Object.assign(Modal, {
    Body: (0, _modalBodyDefault.default),
    Header: (0, _modalHeaderDefault.default),
    Title: (0, _modalTitleDefault.default),
    Footer: (0, _modalFooterDefault.default),
    Dialog: (0, _modalDialogDefault.default),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});

},{"classnames":"5Een2","dom-helpers/addEventListener":"avJ0E","dom-helpers/canUseDOM":"5QOsw","dom-helpers/ownerDocument":"dYqIu","dom-helpers/removeEventListener":"5Dy7j","dom-helpers/scrollbarSize":"5JWeg","@restart/hooks/useCallbackRef":"grmD6","@restart/hooks/useEventCallback":"3MIRo","@restart/hooks/useMergedRefs":"cU99Q","@restart/hooks/useWillUnmount":"hRbyz","dom-helpers/transitionEnd":"cOav3","react":"9njXz","@restart/ui/Modal":"5Yzsg","./BootstrapModalManager":"kAoPB","./Fade":"fXf7Q","./ModalBody":"kdcAl","./ModalContext":"5jB7t","./ModalDialog":"hgJO8","./ModalFooter":"j8rD6","./ModalHeader":"fIJA9","./ModalTitle":"jXE6T","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5JWeg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>scrollbarSize);
var _canUseDOM = require("./canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
var size;
function scrollbarSize(recalc) {
    if (!size && size !== 0 || recalc) {
        if (0, _canUseDOMDefault.default) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return size;
}

},{"./canUseDOM":"5QOsw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"grmD6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCallbackRef);
var _react = require("react");
function useCallbackRef() {
    return (0, _react.useState)(null);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hRbyz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useWillUnmount);
var _useUpdatedRef = require("./useUpdatedRef");
var _useUpdatedRefDefault = parcelHelpers.interopDefault(_useUpdatedRef);
var _react = require("react");
function useWillUnmount(fn) {
    const onUnmount = (0, _useUpdatedRefDefault.default)(fn);
    (0, _react.useEffect)(()=>()=>onUnmount.current(), []);
}

},{"./useUpdatedRef":"fBxt4","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fBxt4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUpdatedRef);
var _react = require("react");
function useUpdatedRef(value) {
    const valueRef = (0, _react.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Yzsg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable @typescript-eslint/no-use-before-define, react/prop-types */ var _activeElement = require("dom-helpers/activeElement");
var _activeElementDefault = parcelHelpers.interopDefault(_activeElement);
var _contains = require("dom-helpers/contains");
var _containsDefault = parcelHelpers.interopDefault(_contains);
var _canUseDOM = require("dom-helpers/canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
var _listen = require("dom-helpers/listen");
var _listenDefault = parcelHelpers.interopDefault(_listen);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _useMounted = require("@restart/hooks/useMounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _useWillUnmount = require("@restart/hooks/useWillUnmount");
var _useWillUnmountDefault = parcelHelpers.interopDefault(_useWillUnmount);
var _usePrevious = require("@restart/hooks/usePrevious");
var _usePreviousDefault = parcelHelpers.interopDefault(_usePrevious);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _modalManager = require("./ModalManager");
var _modalManagerDefault = parcelHelpers.interopDefault(_modalManager);
var _useWaitForDOMRef = require("./useWaitForDOMRef");
var _useWaitForDOMRefDefault = parcelHelpers.interopDefault(_useWaitForDOMRef);
var _useWindow = require("./useWindow");
var _useWindowDefault = parcelHelpers.interopDefault(_useWindow);
var _imperativeTransition = require("./ImperativeTransition");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function getManager(window) {
    if (!manager) manager = new (0, _modalManagerDefault.default)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return manager;
}
function useModalManager(provided) {
    const window = (0, _useWindowDefault.default)();
    const modalManager = provided || getManager(window);
    const modal = (0, _react.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, _react.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, _react.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const Modal = /*#__PURE__*/ (0, _react.forwardRef)((_ref, ref)=>{
    let { show = false, role = 'dialog', className, style, children, backdrop = true, keyboard = true, onBackdropClick, onEscapeKeyDown, transition, runTransition, backdropTransition, runBackdropTransition, autoFocus = true, enforceFocus = true, restoreFocus = true, restoreFocusOptions, renderDialog, renderBackdrop = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow, onHide = ()=>{}, onExit, onExited, onExiting, onEnter, onEntering, onEntered } = _ref, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    const ownerWindow = (0, _useWindowDefault.default)();
    const container = (0, _useWaitForDOMRefDefault.default)(containerRef);
    const modal = useModalManager(providedManager);
    const isMounted = (0, _useMountedDefault.default)();
    const prevShow = (0, _usePreviousDefault.default)(show);
    const [exited, setExited] = (0, _react.useState)(!show);
    const lastFocusRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, _canUseDOMDefault.default) && !prevShow && show) lastFocusRef.current = (0, _activeElementDefault.default)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, _useEventCallbackDefault.default)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, _listenDefault.default)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, _listenDefault.default)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, _activeElementDefault.default)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, _containsDefault.default)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, _useEventCallbackDefault.default)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, _react.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, _react.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, _useWillUnmountDefault.default)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, _useEventCallbackDefault.default)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, _activeElementDefault.default)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, _containsDefault.default)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, _useEventCallbackDefault.default)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, _useEventCallbackDefault.default)((e)=>{
        if (keyboard && (0, _utils.isEscKey)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, _react.useRef)();
    const removeKeydownListenerRef = (0, _react.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style,
        className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ _react.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, _imperativeTransition.renderTransition)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit,
        onExiting,
        onExited: handleHidden,
        onEnter,
        onEntering,
        onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, _imperativeTransition.renderTransition)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
Modal.displayName = 'Modal';
exports.default = Object.assign(Modal, {
    Manager: (0, _modalManagerDefault.default)
});

},{"dom-helpers/activeElement":"h7UXc","dom-helpers/contains":"9MLeA","dom-helpers/canUseDOM":"5QOsw","dom-helpers/listen":"bQcJW","react":"9njXz","react-dom":"2ApDx","@restart/hooks/useMounted":"3668D","@restart/hooks/useWillUnmount":"bPMnG","@restart/hooks/usePrevious":"3j5PE","@restart/hooks/useEventCallback":"c26h1","./ModalManager":"94NM8","./useWaitForDOMRef":"jJO5R","./useWindow":"kl9Hc","./ImperativeTransition":"iWxJ1","./utils":"lH0qp","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h7UXc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>activeElement);
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
function activeElement(doc) {
    if (doc === void 0) doc = (0, _ownerDocumentDefault.default)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}

},{"./ownerDocument":"dYqIu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bPMnG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useWillUnmount);
var _useUpdatedRef = require("./useUpdatedRef");
var _useUpdatedRefDefault = parcelHelpers.interopDefault(_useUpdatedRef);
var _react = require("react");
function useWillUnmount(fn) {
    const onUnmount = (0, _useUpdatedRefDefault.default)(fn);
    (0, _react.useEffect)(()=>()=>onUnmount.current(), []);
}

},{"./useUpdatedRef":"fvFQD","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fvFQD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUpdatedRef);
var _react = require("react");
function useUpdatedRef(value) {
    const valueRef = (0, _react.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"94NM8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OPEN_DATA_ATTRIBUTE", ()=>OPEN_DATA_ATTRIBUTE);
var _css = require("dom-helpers/css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _dataKey = require("./DataKey");
var _getScrollbarWidth = require("./getScrollbarWidth");
var _getScrollbarWidthDefault = parcelHelpers.interopDefault(_getScrollbarWidth);
const OPEN_DATA_ATTRIBUTE = (0, _dataKey.dataAttr)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class ModalManager {
    constructor({ ownerDocument, handleContainerOverflow = true, isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, _getScrollbarWidthDefault.default)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, _cssDefault.default)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute(OPEN_DATA_ATTRIBUTE, '');
        (0, _cssDefault.default)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute(OPEN_DATA_ATTRIBUTE);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
exports.default = ModalManager;

},{"dom-helpers/css":"2nGUd","./DataKey":"bOKZf","./getScrollbarWidth":"hQums","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hQums":[function(require,module,exports,__globalThis) {
/**
 * Get the width of the vertical window scrollbar if it's visible
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBodyScrollbarWidth);
function getBodyScrollbarWidth(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jJO5R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveContainerRef", ()=>resolveContainerRef);
parcelHelpers.export(exports, "default", ()=>useWaitForDOMRef);
var _ownerDocument = require("dom-helpers/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _canUseDOM = require("dom-helpers/canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
var _react = require("react");
var _useWindow = require("./useWindow");
var _useWindowDefault = parcelHelpers.interopDefault(_useWindow);
const resolveContainerRef = (ref, document)=>{
    if (!(0, _canUseDOMDefault.default)) return null;
    if (ref == null) return (document || (0, _ownerDocumentDefault.default)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function useWaitForDOMRef(ref, onResolved) {
    const window = (0, _useWindowDefault.default)();
    const [resolvedRef, setRef] = (0, _react.useState)(()=>resolveContainerRef(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = resolveContainerRef(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, _react.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, _react.useEffect)(()=>{
        const nextRef = resolveContainerRef(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}

},{"dom-helpers/ownerDocument":"dYqIu","dom-helpers/canUseDOM":"5QOsw","react":"9njXz","./useWindow":"kl9Hc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iWxJ1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTransition", ()=>useTransition);
parcelHelpers.export(exports, "default", ()=>ImperativeTransition);
parcelHelpers.export(exports, "renderTransition", ()=>renderTransition);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useIsomorphicEffect = require("@restart/hooks/useIsomorphicEffect");
var _useIsomorphicEffectDefault = parcelHelpers.interopDefault(_useIsomorphicEffect);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _noopTransition = require("./NoopTransition");
var _noopTransitionDefault = parcelHelpers.interopDefault(_noopTransition);
var _rtgtransition = require("./RTGTransition");
var _rtgtransitionDefault = parcelHelpers.interopDefault(_rtgtransition);
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function useTransition({ in: inProp, onTransition }) {
    const ref = (0, _react.useRef)(null);
    const isInitialRef = (0, _react.useRef)(true);
    const handleTransition = (0, _useEventCallbackDefault.default)(onTransition);
    (0, _useIsomorphicEffectDefault.default)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, _useIsomorphicEffectDefault.default)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function ImperativeTransition({ children, in: inProp, onExited, onEntered, transition }) {
    const [exited, setExited] = (0, _react.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = useTransition({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, _useMergedRefsDefault.default)(ref, (0, _utils.getChildRef)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, _react.cloneElement)(children, {
        ref: combinedRef
    });
}
function renderTransition(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rtgtransitionDefault.default), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ImperativeTransition, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noopTransitionDefault.default), Object.assign({}, props));
}

},{"@restart/hooks/useMergedRefs":"eqVs8","@restart/hooks/useEventCallback":"c26h1","@restart/hooks/useIsomorphicEffect":"8bm5s","react":"9njXz","./NoopTransition":"8Sbaq","./RTGTransition":"902WH","./utils":"lH0qp","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Sbaq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _react = require("react");
var _utils = require("./utils");
function NoopTransition({ children, in: inProp, onExited, mountOnEnter, unmountOnExit }) {
    const ref = (0, _react.useRef)(null);
    const hasEnteredRef = (0, _react.useRef)(inProp);
    const handleExited = (0, _useEventCallbackDefault.default)(onExited);
    (0, _react.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, _useMergedRefsDefault.default)(ref, (0, _utils.getChildRef)(children));
    const child = /*#__PURE__*/ (0, _react.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
exports.default = NoopTransition;

},{"@restart/hooks/useEventCallback":"c26h1","@restart/hooks/useMergedRefs":"eqVs8","react":"9njXz","./utils":"lH0qp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lH0qp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEscKey", ()=>isEscKey);
parcelHelpers.export(exports, "getReactVersion", ()=>getReactVersion);
parcelHelpers.export(exports, "getChildRef", ()=>getChildRef);
var _react = require("react");
function isEscKey(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function getReactVersion() {
    const parts = _react.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function getChildRef(element) {
    if (!element || typeof element === 'function') return null;
    const { major } = getReactVersion();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"902WH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useRTGTransitionProps = require("./useRTGTransitionProps");
var _useRTGTransitionPropsDefault = parcelHelpers.interopDefault(_useRTGTransitionProps);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "component"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const RTGTransition = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const transitionProps = (0, _useRTGTransitionPropsDefault.default)(props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
exports.default = RTGTransition;

},{"react":"9njXz","./useRTGTransitionProps":"djLnS","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"djLnS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useRTGTransitionProps);
var _react = require("react");
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _utils = require("./utils");
const _excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function useRTGTransitionProps(_ref) {
    let { onEnter, onEntering, onEntered, onExit, onExiting, onExited, addEndListener, children } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const nodeRef = (0, _react.useRef)(null);
    const mergedRef = (0, _useMergedRefsDefault.default)(nodeRef, (0, _utils.getChildRef)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, _react.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, _react.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, _react.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, _react.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, _react.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, _react.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, _react.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, _react.cloneElement)(children, {
            ref: mergedRef
        })
    });
}

},{"react":"9njXz","@restart/hooks/useMergedRefs":"eqVs8","./utils":"lH0qp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kAoPB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSharedManager", ()=>getSharedManager);
var _addClass = require("dom-helpers/addClass");
var _addClassDefault = parcelHelpers.interopDefault(_addClass);
var _css = require("dom-helpers/css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _querySelectorAll = require("dom-helpers/querySelectorAll");
var _querySelectorAllDefault = parcelHelpers.interopDefault(_querySelectorAll);
var _removeClass = require("dom-helpers/removeClass");
var _removeClassDefault = parcelHelpers.interopDefault(_removeClass);
var _modalManager = require("@restart/ui/ModalManager");
var _modalManagerDefault = parcelHelpers.interopDefault(_modalManager);
const Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class BootstrapModalManager extends (0, _modalManagerDefault.default) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, _cssDefault.default)(element, {
            [prop]: `${parseFloat((0, _cssDefault.default)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, _cssDefault.default)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, _addClassDefault.default)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, _querySelectorAllDefault.default)(container, Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, _querySelectorAllDefault.default)(container, Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, _querySelectorAllDefault.default)(container, Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, _removeClassDefault.default)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, _querySelectorAllDefault.default)(container, Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, _querySelectorAllDefault.default)(container, Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, _querySelectorAllDefault.default)(container, Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let sharedManager;
function getSharedManager(options) {
    if (!sharedManager) sharedManager = new BootstrapModalManager(options);
    return sharedManager;
}
exports.default = BootstrapModalManager;

},{"dom-helpers/addClass":"16v5y","dom-helpers/css":"2nGUd","dom-helpers/querySelectorAll":"gZHK3","dom-helpers/removeClass":"cUvLe","@restart/ui/ModalManager":"94NM8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16v5y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addClass);
var _hasClass = require("./hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClassDefault.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

},{"./hasClass":"3I5QN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3I5QN":[function(require,module,exports,__globalThis) {
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hasClass);
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cUvLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeClass);
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);
    else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kdcAl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ModalBody = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
ModalBody.displayName = 'ModalBody';
exports.default = ModalBody;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5jB7t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const ModalContext = /*#__PURE__*/ _react.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide () {}
});
exports.default = ModalContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hgJO8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ModalDialog = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, contentClassName, centered, size, fullscreen, children, scrollable, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: (0, _classnamesDefault.default)(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
ModalDialog.displayName = 'ModalDialog';
exports.default = ModalDialog;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j8rD6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ModalFooter = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
ModalFooter.displayName = 'ModalFooter';
exports.default = ModalFooter;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fIJA9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _abstractModalHeader = require("./AbstractModalHeader");
var _abstractModalHeaderDefault = parcelHelpers.interopDefault(_abstractModalHeader);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ModalHeader = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, closeLabel = 'Close', closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _abstractModalHeaderDefault.default), {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
ModalHeader.displayName = 'ModalHeader';
exports.default = ModalHeader;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./AbstractModalHeader":"9nfuk","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9nfuk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _closeButton = require("./CloseButton");
var _closeButtonDefault = parcelHelpers.interopDefault(_closeButton);
var _modalContext = require("./ModalContext");
var _modalContextDefault = parcelHelpers.interopDefault(_modalContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const AbstractModalHeader = /*#__PURE__*/ _react.forwardRef(({ closeLabel = 'Close', closeVariant, closeButton = false, onHide, children, ...props }, ref)=>{
    const context = (0, _react.useContext)((0, _modalContextDefault.default));
    const handleClick = (0, _useEventCallbackDefault.default)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButtonDefault.default), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
exports.default = AbstractModalHeader;

},{"react":"9njXz","@restart/hooks/useEventCallback":"3MIRo","./CloseButton":"dT7Bb","./ModalContext":"5jB7t","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jXE6T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _divWithClassName = require("./divWithClassName");
var _divWithClassNameDefault = parcelHelpers.interopDefault(_divWithClassName);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DivStyledAsH4 = (0, _divWithClassNameDefault.default)('h4');
const ModalTitle = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
ModalTitle.displayName = 'ModalTitle';
exports.default = ModalTitle;

},{"react":"9njXz","classnames":"5Een2","./divWithClassName":"7vB9M","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iXM49":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _all = require("prop-types-extra/lib/all");
var _allDefault = parcelHelpers.interopDefault(_all);
var _react = require("react");
var _uncontrollable = require("uncontrollable");
var _nav = require("@restart/ui/Nav");
var _navDefault = parcelHelpers.interopDefault(_nav);
var _themeProvider = require("./ThemeProvider");
var _navbarContext = require("./NavbarContext");
var _navbarContextDefault = parcelHelpers.interopDefault(_navbarContext);
var _cardHeaderContext = require("./CardHeaderContext");
var _cardHeaderContextDefault = parcelHelpers.interopDefault(_cardHeaderContext);
var _navItem = require("./NavItem");
var _navItemDefault = parcelHelpers.interopDefault(_navItem);
var _navLink = require("./NavLink");
var _navLinkDefault = parcelHelpers.interopDefault(_navLink);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Nav = /*#__PURE__*/ _react.forwardRef((uncontrolledProps, ref)=>{
    const { as = 'div', bsPrefix: initialBsPrefix, variant, fill = false, justify = false, navbar, navbarScroll, className, activeKey, ...props } = (0, _uncontrollable.useUncontrolled)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, _themeProvider.useBootstrapPrefix)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, _react.useContext)((0, _navbarContextDefault.default));
    const cardHeaderContext = (0, _react.useContext)((0, _cardHeaderContextDefault.default));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navDefault.default), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, _classnamesDefault.default)(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
Nav.displayName = 'Nav';
exports.default = Object.assign(Nav, {
    Item: (0, _navItemDefault.default),
    Link: (0, _navLinkDefault.default)
});

},{"classnames":"5Een2","prop-types-extra/lib/all":"3GxAy","react":"9njXz","uncontrollable":"c40ge","@restart/ui/Nav":"aBPog","./ThemeProvider":"t5pcW","./NavbarContext":"a9ajw","./CardHeaderContext":"lHQZO","./NavItem":"7IC9t","./NavLink":"kAcSd","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3GxAy":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = all;
var _createChainableTypeChecker = require("d69c03d3e91a1136");
var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function all() {
    for(var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++)validators[_key] = arguments[_key];
    function allPropTypes() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var error = null;
        validators.forEach(function(validator) {
            if (error != null) return;
            var result = validator.apply(undefined, args);
            if (result != null) error = result;
        });
        return error;
    }
    return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

},{"d69c03d3e91a1136":"BDWv4"}],"BDWv4":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ // Mostly taken from ReactPropTypes.
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || '<<anonymous>>';
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
            if (isRequired) return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
            return null;
        }
        for(var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)args[_key - 6] = arguments[_key];
        return validate.apply(undefined, [
            props,
            propName,
            componentNameSafe,
            location,
            propFullNameSafe
        ].concat(args));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
module.exports = exports['default'];

},{}],"7IC9t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavItem = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
NavItem.displayName = 'NavItem';
exports.default = NavItem;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kAcSd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _anchor = require("@restart/ui/Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _navItem = require("@restart/ui/NavItem");
var _selectableContext = require("@restart/ui/SelectableContext");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavLink = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, as: Component = (0, _anchorDefault.default), active, eventKey, disabled = false, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, _navItem.useNavItem)({
        key: (0, _selectableContext.makeEventKey)(eventKey, props.href),
        active,
        disabled,
        ...props
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, _classnamesDefault.default)(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
NavLink.displayName = 'NavLink';
exports.default = NavLink;

},{"classnames":"5Een2","react":"9njXz","@restart/ui/Anchor":"f7VPb","@restart/ui/NavItem":"bche0","@restart/ui/SelectableContext":"7v5if","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jKK7g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _selectableContext = require("@restart/ui/SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _uncontrollable = require("uncontrollable");
var _navbarBrand = require("./NavbarBrand");
var _navbarBrandDefault = parcelHelpers.interopDefault(_navbarBrand);
var _navbarCollapse = require("./NavbarCollapse");
var _navbarCollapseDefault = parcelHelpers.interopDefault(_navbarCollapse);
var _navbarToggle = require("./NavbarToggle");
var _navbarToggleDefault = parcelHelpers.interopDefault(_navbarToggle);
var _navbarOffcanvas = require("./NavbarOffcanvas");
var _navbarOffcanvasDefault = parcelHelpers.interopDefault(_navbarOffcanvas);
var _themeProvider = require("./ThemeProvider");
var _navbarContext = require("./NavbarContext");
var _navbarContextDefault = parcelHelpers.interopDefault(_navbarContext);
var _navbarText = require("./NavbarText");
var _navbarTextDefault = parcelHelpers.interopDefault(_navbarText);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Navbar = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand = true, variant = 'light', bg, fixed, sticky, className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded, onToggle, onSelect, collapseOnSelect = false, ...controlledProps } = (0, _uncontrollable.useUncontrolled)(props, {
        expanded: 'onToggle'
    });
    const bsPrefix = (0, _themeProvider.useBootstrapPrefix)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, _react.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, _react.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix,
            expanded: !!expanded,
            expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navbarContextDefault.default).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectableContextDefault.default).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, _classnamesDefault.default)(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
Navbar.displayName = 'Navbar';
exports.default = Object.assign(Navbar, {
    Brand: (0, _navbarBrandDefault.default),
    Collapse: (0, _navbarCollapseDefault.default),
    Offcanvas: (0, _navbarOffcanvasDefault.default),
    Text: (0, _navbarTextDefault.default),
    Toggle: (0, _navbarToggleDefault.default)
});

},{"classnames":"5Een2","react":"9njXz","@restart/ui/SelectableContext":"7v5if","uncontrollable":"c40ge","./NavbarBrand":"gY115","./NavbarCollapse":"3QK2V","./NavbarToggle":"29A9C","./NavbarOffcanvas":"e1RGp","./ThemeProvider":"t5pcW","./NavbarContext":"a9ajw","./NavbarText":"7xHlT","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gY115":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavbarBrand = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, as, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix)
    });
});
NavbarBrand.displayName = 'NavbarBrand';
exports.default = NavbarBrand;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3QK2V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _themeProvider = require("./ThemeProvider");
var _navbarContext = require("./NavbarContext");
var _navbarContextDefault = parcelHelpers.interopDefault(_navbarContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavbarCollapse = /*#__PURE__*/ _react.forwardRef(({ children, bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'navbar-collapse');
    const context = (0, _react.useContext)((0, _navbarContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapseDefault.default), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
NavbarCollapse.displayName = 'NavbarCollapse';
exports.default = NavbarCollapse;

},{"react":"9njXz","./Collapse":"juTQl","./ThemeProvider":"t5pcW","./NavbarContext":"a9ajw","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"29A9C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _themeProvider = require("./ThemeProvider");
var _navbarContext = require("./NavbarContext");
var _navbarContextDefault = parcelHelpers.interopDefault(_navbarContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavbarToggle = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, children, label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', onClick, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'navbar-toggler');
    const { onToggle, expanded } = (0, _react.useContext)((0, _navbarContextDefault.default)) || {};
    const handleClick = (0, _useEventCallbackDefault.default)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, _classnamesDefault.default)(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
NavbarToggle.displayName = 'NavbarToggle';
exports.default = NavbarToggle;

},{"classnames":"5Een2","react":"9njXz","@restart/hooks/useEventCallback":"3MIRo","./ThemeProvider":"t5pcW","./NavbarContext":"a9ajw","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e1RGp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _offcanvas = require("./Offcanvas");
var _offcanvasDefault = parcelHelpers.interopDefault(_offcanvas);
var _navbarContext = require("./NavbarContext");
var _navbarContextDefault = parcelHelpers.interopDefault(_navbarContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavbarOffcanvas = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const context = (0, _react.useContext)((0, _navbarContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offcanvasDefault.default), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true
    });
});
NavbarOffcanvas.displayName = 'NavbarOffcanvas';
exports.default = NavbarOffcanvas;

},{"react":"9njXz","./Offcanvas":"3kK4v","./NavbarContext":"a9ajw","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3kK4v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _useBreakpoint = require("@restart/hooks/useBreakpoint");
var _useBreakpointDefault = parcelHelpers.interopDefault(_useBreakpoint);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _react = require("react");
var _modal = require("@restart/ui/Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _offcanvasBody = require("./OffcanvasBody");
var _offcanvasBodyDefault = parcelHelpers.interopDefault(_offcanvasBody);
var _offcanvasToggling = require("./OffcanvasToggling");
var _offcanvasTogglingDefault = parcelHelpers.interopDefault(_offcanvasToggling);
var _modalContext = require("./ModalContext");
var _modalContextDefault = parcelHelpers.interopDefault(_modalContext);
var _navbarContext = require("./NavbarContext");
var _navbarContextDefault = parcelHelpers.interopDefault(_navbarContext);
var _offcanvasHeader = require("./OffcanvasHeader");
var _offcanvasHeaderDefault = parcelHelpers.interopDefault(_offcanvasHeader);
var _offcanvasTitle = require("./OffcanvasTitle");
var _offcanvasTitleDefault = parcelHelpers.interopDefault(_offcanvasTitle);
var _themeProvider = require("./ThemeProvider");
var _bootstrapModalManager = require("./BootstrapModalManager");
var _bootstrapModalManagerDefault = parcelHelpers.interopDefault(_bootstrapModalManager);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function DialogTransition(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offcanvasTogglingDefault.default), {
        ...props
    });
}
function BackdropTransition(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
        ...props
    });
}
const Offcanvas = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, children, 'aria-labelledby': ariaLabelledby, placement = 'start', responsive, /* BaseModal props */ show = false, backdrop = true, keyboard = true, scroll = false, onEscapeKeyDown, onShow, onHide, container, autoFocus = true, enforceFocus = true, restoreFocus = true, restoreFocusOptions, onEntered, onExit, onExiting, onEnter, onEntering, onExited, backdropClassName, manager: propsManager, renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, _react.useRef)();
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'offcanvas');
    const { onToggle } = (0, _react.useContext)((0, _navbarContextDefault.default)) || {};
    const [showOffcanvas, setShowOffcanvas] = (0, _react.useState)(false);
    const hideResponsiveOffcanvas = (0, _useBreakpointDefault.default)(responsive || 'xs', 'up');
    (0, _react.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const handleHide = (0, _useEventCallbackDefault.default)(()=>{
        onToggle == null || onToggle();
        onHide == null || onHide();
    });
    const modalContext = (0, _react.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, _bootstrapModalManagerDefault.default)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, _bootstrapModalManager.getSharedManager)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, _react.useCallback)((backdropProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ...backdropProps,
            className: (0, _classnamesDefault.default)(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, _classnamesDefault.default)(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalContextDefault.default).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: DialogTransition,
                    backdropTransition: BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
Offcanvas.displayName = 'Offcanvas';
exports.default = Object.assign(Offcanvas, {
    Body: (0, _offcanvasBodyDefault.default),
    Header: (0, _offcanvasHeaderDefault.default),
    Title: (0, _offcanvasTitleDefault.default)
});

},{"classnames":"5Een2","@restart/hooks/useBreakpoint":"k9sUC","@restart/hooks/useEventCallback":"3MIRo","react":"9njXz","@restart/ui/Modal":"5Yzsg","./Fade":"fXf7Q","./OffcanvasBody":"iR00U","./OffcanvasToggling":"4gBCA","./ModalContext":"5jB7t","./NavbarContext":"a9ajw","./OffcanvasHeader":"ecsxp","./OffcanvasTitle":"cw493","./ThemeProvider":"t5pcW","./BootstrapModalManager":"kAoPB","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k9sUC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a responsive hook we a set of breakpoint names and widths.
 * You can use any valid css units as well as a numbers (for pixels).
 *
 * **NOTE:** The object key order is important! it's assumed to be in order from smallest to largest
 *
 * ```ts
 * const useBreakpoint = createBreakpointHook({
 *  xs: 0,
 *  sm: 576,
 *  md: 768,
 *  lg: 992,
 *  xl: 1200,
 * })
 * ```
 *
 * **Watch out!** using string values will sometimes construct media queries using css `calc()` which
 * is NOT supported in media queries by all browsers at the moment. use numbers for
 * the widest range of browser support.
 *
 * @param breakpointValues A object hash of names to breakpoint dimensions
 */ parcelHelpers.export(exports, "createBreakpointHook", ()=>createBreakpointHook);
var _useMediaQuery = require("./useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
var _react = require("react");
function createBreakpointHook(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, _react.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, _useMediaQueryDefault.default)(query, window);
    }
    return useBreakpoint;
}
const useBreakpoint = createBreakpointHook({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
exports.default = useBreakpoint;

},{"./useMediaQuery":"14Q3k","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"14Q3k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMediaQuery);
var _useIsomorphicEffect = require("./useIsomorphicEffect");
var _useIsomorphicEffectDefault = parcelHelpers.interopDefault(_useIsomorphicEffect);
var _react = require("react");
const matchersByWindow = new WeakMap();
const getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = matchersByWindow.get(targetWindow) || new Map();
    matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function useMediaQuery(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, _react.useState)(()=>mql ? mql.matches : false);
    (0, _useIsomorphicEffectDefault.default)(()=>{
        let mql = getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}

},{"./useIsomorphicEffect":"7BtXW","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iR00U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const OffcanvasBody = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
OffcanvasBody.displayName = 'OffcanvasBody';
exports.default = OffcanvasBody;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4gBCA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _transition = require("react-transition-group/Transition");
var _transitionEndListener = require("./transitionEndListener");
var _transitionEndListenerDefault = parcelHelpers.interopDefault(_transitionEndListener);
var _transitionWrapper = require("./TransitionWrapper");
var _transitionWrapperDefault = parcelHelpers.interopDefault(_transitionWrapper);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const transitionStyles = {
    [(0, _transition.ENTERING)]: 'show',
    [(0, _transition.ENTERED)]: 'show'
};
const OffcanvasToggling = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, children, in: inProp = false, mountOnEnter = false, unmountOnExit = false, appear = false, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transitionWrapperDefault.default), {
        ref: ref,
        addEndListener: (0, _transitionEndListenerDefault.default),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: children.ref,
        children: (status, innerProps)=>/*#__PURE__*/ _react.cloneElement(children, {
                ...innerProps,
                className: (0, _classnamesDefault.default)(className, children.props.className, (status === (0, _transition.ENTERING) || status === (0, _transition.EXITING)) && `${bsPrefix}-toggling`, transitionStyles[status])
            })
    });
});
OffcanvasToggling.displayName = 'OffcanvasToggling';
exports.default = OffcanvasToggling;

},{"classnames":"5Een2","react":"9njXz","react-transition-group/Transition":"6LVcl","./transitionEndListener":"cbuHm","./TransitionWrapper":"jxF2v","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ecsxp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _abstractModalHeader = require("./AbstractModalHeader");
var _abstractModalHeaderDefault = parcelHelpers.interopDefault(_abstractModalHeader);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const OffcanvasHeader = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, closeLabel = 'Close', closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _abstractModalHeaderDefault.default), {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
OffcanvasHeader.displayName = 'OffcanvasHeader';
exports.default = OffcanvasHeader;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./AbstractModalHeader":"9nfuk","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cw493":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _divWithClassName = require("./divWithClassName");
var _divWithClassNameDefault = parcelHelpers.interopDefault(_divWithClassName);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DivStyledAsH5 = (0, _divWithClassNameDefault.default)('h5');
const OffcanvasTitle = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
OffcanvasTitle.displayName = 'OffcanvasTitle';
exports.default = OffcanvasTitle;

},{"react":"9njXz","classnames":"5Een2","./divWithClassName":"7vB9M","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7xHlT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavbarText = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
NavbarText.displayName = 'NavbarText';
exports.default = NavbarText;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7N5GY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _dropdown = require("./Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _navLink = require("./NavLink");
var _navLinkDefault = parcelHelpers.interopDefault(_navLink);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavDropdown = /*#__PURE__*/ _react.forwardRef(({ id, title, children, bsPrefix, className, rootCloseEvent, menuRole, disabled, active, renderMenuOnMount, menuVariant, ...props }, ref)=>{
    /* NavItem has no additional logic, it's purely presentational. Can set nav item class here to support "as" */ const navItemPrefix = (0, _themeProvider.useBootstrapPrefix)(undefined, 'nav-item');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownDefault.default), {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, navItemPrefix),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownDefault.default).Toggle, {
                id: id,
                eventKey: null,
                active: active,
                disabled: disabled,
                childBsPrefix: bsPrefix,
                as: (0, _navLinkDefault.default),
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownDefault.default).Menu, {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                variant: menuVariant,
                children: children
            })
        ]
    });
});
NavDropdown.displayName = 'NavDropdown';
exports.default = Object.assign(NavDropdown, {
    Item: (0, _dropdownDefault.default).Item,
    ItemText: (0, _dropdownDefault.default).ItemText,
    Divider: (0, _dropdownDefault.default).Divider,
    Header: (0, _dropdownDefault.default).Header
});

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./Dropdown":"gNoAC","./NavLink":"kAcSd","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cdIGB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _overlay = require("@restart/ui/Overlay");
var _overlayDefault = parcelHelpers.interopDefault(_overlay);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useIsomorphicEffect = require("@restart/hooks/useIsomorphicEffect");
var _useIsomorphicEffectDefault = parcelHelpers.interopDefault(_useIsomorphicEffect);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _useOverlayOffset = require("./useOverlayOffset");
var _useOverlayOffsetDefault = parcelHelpers.interopDefault(_useOverlayOffset);
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _safeFindDOMNode = require("./safeFindDOMNode");
var _safeFindDOMNodeDefault = parcelHelpers.interopDefault(_safeFindDOMNode);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function wrapRefs(props, arrowProps) {
    const { ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, _safeFindDOMNodeDefault.default)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, _safeFindDOMNodeDefault.default)(r)));
}
const Overlay = /*#__PURE__*/ _react.forwardRef(({ children: overlay, transition = (0, _fadeDefault.default), popperConfig = {}, rootClose = false, placement = 'top', show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, _react.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, _react.useState)(null);
    const [ref, modifiers] = (0, _useOverlayOffsetDefault.default)(outerProps.offset);
    const mergedRef = (0, _useMergedRefsDefault.default)(outerRef, ref);
    const actualTransition = transition === true ? (0, _fadeDefault.default) : transition || undefined;
    const handleFirstUpdate = (0, _useEventCallbackDefault.default)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, _useIsomorphicEffectDefault.default)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, _react.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overlayDefault.default), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps, popper: popperObj, show })=>{
            var _popperObj$state;
            wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === 'function') return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show,
                ...!transition && show && {
                    className: 'show'
                },
                popper,
                arrowProps,
                hasDoneInitialMeasure
            });
            return /*#__PURE__*/ _react.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps,
                popper,
                hasDoneInitialMeasure,
                className: (0, _classnamesDefault.default)(overlay.props.className, !transition && show && 'show'),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
Overlay.displayName = 'Overlay';
exports.default = Overlay;

},{"react":"9njXz","classnames":"5Een2","@restart/ui/Overlay":"tKgZS","@restart/hooks/useEventCallback":"3MIRo","@restart/hooks/useIsomorphicEffect":"7BtXW","@restart/hooks/useMergedRefs":"cU99Q","./useOverlayOffset":"lbLAL","./Fade":"fXf7Q","./safeFindDOMNode":"c96Ll","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"tKgZS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _useCallbackRef = require("@restart/hooks/useCallbackRef");
var _useCallbackRefDefault = parcelHelpers.interopDefault(_useCallbackRef);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _usePopper = require("./usePopper");
var _usePopperDefault = parcelHelpers.interopDefault(_usePopper);
var _useRootClose = require("./useRootClose");
var _useRootCloseDefault = parcelHelpers.interopDefault(_useRootClose);
var _useWaitForDOMRef = require("./useWaitForDOMRef");
var _useWaitForDOMRefDefault = parcelHelpers.interopDefault(_useWaitForDOMRef);
var _mergeOptionsWithPopperConfig = require("./mergeOptionsWithPopperConfig");
var _mergeOptionsWithPopperConfigDefault = parcelHelpers.interopDefault(_mergeOptionsWithPopperConfig);
var _imperativeTransition = require("./ImperativeTransition");
/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const Overlay = /*#__PURE__*/ _react.forwardRef((props, outerRef)=>{
    const { flip, offset, placement, containerPadding, popperConfig = {}, transition: Transition, runTransition } = props;
    const [rootElement, attachRef] = (0, _useCallbackRefDefault.default)();
    const [arrowElement, attachArrowRef] = (0, _useCallbackRefDefault.default)();
    const mergedRef = (0, _useMergedRefsDefault.default)(attachRef, outerRef);
    const container = (0, _useWaitForDOMRefDefault.default)(props.container);
    const target = (0, _useWaitForDOMRefDefault.default)(props.target);
    const [exited, setExited] = (0, _react.useState)(!props.show);
    const popper = (0, _usePopperDefault.default)(target, rootElement, (0, _mergeOptionsWithPopperConfigDefault.default)({
        placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip,
        offset,
        arrowElement,
        popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, _useRootCloseDefault.default)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit, onExiting, onEnter, onEntering, onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper,
        placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, _imperativeTransition.renderTransition)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit,
        onExiting,
        onExited: handleHidden,
        onEnter,
        onEntering,
        onEntered
    });
    return container ? /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(child, container) : null;
});
Overlay.displayName = 'Overlay';
exports.default = Overlay;

},{"react":"9njXz","react-dom":"2ApDx","@restart/hooks/useCallbackRef":"jw9sZ","@restart/hooks/useMergedRefs":"eqVs8","./usePopper":"7MsdQ","./useRootClose":"eLZix","./useWaitForDOMRef":"jJO5R","./mergeOptionsWithPopperConfig":"5mUS1","./ImperativeTransition":"iWxJ1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eLZix":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listen = require("dom-helpers/listen");
var _listenDefault = parcelHelpers.interopDefault(_listen);
var _ownerDocument = require("dom-helpers/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useClickOutside = require("./useClickOutside");
var _useClickOutsideDefault = parcelHelpers.interopDefault(_useClickOutside);
var _utils = require("./utils");
const noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function useRootClose(ref, onRootClose, { disabled, clickTrigger } = {}) {
    const onClose = onRootClose || noop;
    (0, _useClickOutsideDefault.default)(ref, onClose, {
        disabled,
        clickTrigger
    });
    const handleKeyUp = (0, _useEventCallbackDefault.default)((e)=>{
        if ((0, _utils.isEscKey)(e)) onClose(e);
    });
    (0, _react.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, _ownerDocumentDefault.default)((0, _useClickOutside.getRefTarget)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, _listenDefault.default)(doc, 'keyup', (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
exports.default = useRootClose;

},{"dom-helpers/listen":"bQcJW","dom-helpers/ownerDocument":"dYqIu","react":"9njXz","@restart/hooks/useEventCallback":"c26h1","./useClickOutside":"4Hdqf","./utils":"lH0qp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lbLAL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useOverlayOffset);
var _react = require("react");
var _hasClass = require("dom-helpers/hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
var _themeProvider = require("./ThemeProvider");
var _popover = require("./Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
"use client";
function useOverlayOffset(customOffset) {
    const overlayRef = (0, _react.useRef)(null);
    const popoverClass = (0, _themeProvider.useBootstrapPrefix)(undefined, 'popover');
    const tooltipClass = (0, _themeProvider.useBootstrapPrefix)(undefined, 'tooltip');
    const offset = (0, _react.useMemo)(()=>({
            name: 'offset',
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, _hasClassDefault.default)(overlayRef.current, popoverClass)) return (0, _popoverDefault.default).POPPER_OFFSET;
                        if ((0, _hasClassDefault.default)(overlayRef.current, tooltipClass)) return (0, _tooltipDefault.default).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}

},{"react":"9njXz","dom-helpers/hasClass":"3I5QN","./ThemeProvider":"t5pcW","./Popover":"jhMQy","./Tooltip":"26for","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jhMQy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _popoverHeader = require("./PopoverHeader");
var _popoverHeaderDefault = parcelHelpers.interopDefault(_popoverHeader);
var _popoverBody = require("./PopoverBody");
var _popoverBodyDefault = parcelHelpers.interopDefault(_popoverBody);
var _helpers = require("./helpers");
var _getInitialPopperStyles = require("./getInitialPopperStyles");
var _getInitialPopperStylesDefault = parcelHelpers.interopDefault(_getInitialPopperStyles);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Popover = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, placement = 'right', className, style, children, body, arrowProps, hasDoneInitialMeasure, popper, show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'popover');
    const isRTL = (0, _themeProvider.useIsRTL)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, _helpers.getOverlayDirection)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, _getInitialPopperStylesDefault.default)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, _classnamesDefault.default)(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverBodyDefault.default), {
                children: children
            }) : children
        ]
    });
});
exports.default = Object.assign(Popover, {
    Header: (0, _popoverHeaderDefault.default),
    Body: (0, _popoverBodyDefault.default),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./PopoverHeader":"8eigV","./PopoverBody":"8Czyv","./helpers":"Fe5z7","./getInitialPopperStyles":"hZhRJ","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8eigV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const PopoverHeader = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
PopoverHeader.displayName = 'PopoverHeader';
exports.default = PopoverHeader;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Czyv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const PopoverBody = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
PopoverBody.displayName = 'PopoverBody';
exports.default = PopoverBody;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Fe5z7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BsPrefixComponent", ()=>BsPrefixComponent);
// Need to use this instead of typeof Component to get proper type checking.
parcelHelpers.export(exports, "getOverlayDirection", ()=>getOverlayDirection);
var _react = require("react");
class BsPrefixComponent extends _react.Component {
}
function getOverlayDirection(placement, isRTL) {
    let bsDirection = placement;
    if (placement === 'left') bsDirection = isRTL ? 'end' : 'start';
    else if (placement === 'right') bsDirection = isRTL ? 'start' : 'end';
    return bsDirection;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hZhRJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getInitialPopperStyles);
function getInitialPopperStyles(position = 'absolute') {
    return {
        position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"26for":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _helpers = require("./helpers");
var _getInitialPopperStyles = require("./getInitialPopperStyles");
var _getInitialPopperStylesDefault = parcelHelpers.interopDefault(_getInitialPopperStyles);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Tooltip = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, placement = 'right', className, style, children, arrowProps, hasDoneInitialMeasure, popper, show, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'tooltip');
    const isRTL = (0, _themeProvider.useIsRTL)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, _helpers.getOverlayDirection)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, _getInitialPopperStylesDefault.default)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, _classnamesDefault.default)(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
Tooltip.displayName = 'Tooltip';
exports.default = Object.assign(Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./helpers":"Fe5z7","./getInitialPopperStyles":"hZhRJ","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jtT2y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _contains = require("dom-helpers/contains");
var _containsDefault = parcelHelpers.interopDefault(_contains);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _useTimeout = require("@restart/hooks/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _uncontrollable = require("uncontrollable");
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _overlay = require("./Overlay");
var _overlayDefault = parcelHelpers.interopDefault(_overlay);
var _safeFindDOMNode = require("./safeFindDOMNode");
var _safeFindDOMNodeDefault = parcelHelpers.interopDefault(_safeFindDOMNode);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function normalizeDelay(delay) {
    return delay && typeof delay === 'object' ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function handleMouseOverOut(// eslint-disable-next-line @typescript-eslint/no-shadow
handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, _containsDefault.default)(target, related)) handler(...args);
}
const triggerType = (0, _propTypesDefault.default).oneOf([
    'click',
    'hover',
    'focus'
]);
const OverlayTrigger = ({ trigger = [
    'hover',
    'focus'
], overlay, children, popperConfig = {}, show: propsShow, defaultShow = false, onToggle, delay: propsDelay, placement, flip = placement && placement.indexOf('auto') !== -1, ...props })=>{
    const triggerNodeRef = (0, _react.useRef)(null);
    const mergedRef = (0, _useMergedRefsDefault.default)(triggerNodeRef, children.ref);
    const timeout = (0, _useTimeoutDefault.default)();
    const hoverStateRef = (0, _react.useRef)('');
    const [show, setShow] = (0, _uncontrollable.useUncontrolledProp)(propsShow, defaultShow, onToggle);
    const delay = normalizeDelay(propsDelay);
    const { onFocus, onBlur, onClick } = typeof children !== 'function' ? _react.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, _safeFindDOMNodeDefault.default)(r));
    };
    const handleShow = (0, _react.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'show';
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'show') setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, _react.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'hide';
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'hide') setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, _react.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, _react.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, _react.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, _react.useCallback)((...args)=>{
        handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, _react.useCallback)((...args)=>{
        handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf('click') !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf('focus') !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf('hover') !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/ (0, _react.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overlayDefault.default), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
};
exports.default = OverlayTrigger;

},{"dom-helpers/contains":"9MLeA","prop-types":"bnNSm","react":"9njXz","@restart/hooks/useTimeout":"5H3Sh","warning":"4kUCc","uncontrollable":"c40ge","@restart/hooks/useMergedRefs":"cU99Q","./Overlay":"cdIGB","./safeFindDOMNode":"c96Ll","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5H3Sh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTimeout);
var _react = require("react");
var _useMounted = require("./useMounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _useWillUnmount = require("./useWillUnmount");
var _useWillUnmountDefault = parcelHelpers.interopDefault(_useWillUnmount);
/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const MAX_DELAY_MS = 2 ** 31 - 1;
function setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>setChainedTimeout(handleRef, fn, timeoutAtMs), MAX_DELAY_MS);
}
function useTimeout() {
    const isMounted = (0, _useMountedDefault.default)();
    // types are confused between node and web here IDK
    const handleRef = (0, _react.useRef)();
    (0, _useWillUnmountDefault.default)(()=>clearTimeout(handleRef.current));
    return (0, _react.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set,
            clear,
            handleRef
        };
    }, []);
}

},{"react":"9njXz","./useMounted":"bRTJo","./useWillUnmount":"hRbyz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bRTJo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMounted);
var _react = require("react");
function useMounted() {
    const mounted = (0, _react.useRef)(true);
    const isMounted = (0, _react.useRef)(()=>mounted.current);
    (0, _react.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9JK0h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _elementChildren = require("./ElementChildren");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `ProgressBar`.
 */ function onlyProgressBar(props, propName, componentName) {
    const children = props[propName];
    if (!children) return null;
    let error = null;
    _react.Children.forEach(children, (child)=>{
        if (error) return;
        /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */ // eslint-disable-next-line @typescript-eslint/no-use-before-define
        const element = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProgressBar, {});
        if (child.type === element.type) return;
        const childType = child.type;
        const childIdentifier = /*#__PURE__*/ _react.isValidElement(child) ? childType.displayName || childType.name || childType : child;
        error = new Error(`Children of ${componentName} can contain only ProgressBar ` + `components. Found ${childIdentifier}.`);
    });
    return error;
}
function getPercentage(now, min, max) {
    const percentage = (now - min) / (max - min) * 100;
    return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}
function renderProgressBar({ min, now, max, label, visuallyHidden, striped, animated, className, style, variant, bsPrefix, ...props }, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        ...props,
        role: "progressbar",
        className: (0, _classnamesDefault.default)(className, `${bsPrefix}-bar`, {
            [`bg-${variant}`]: variant,
            [`${bsPrefix}-bar-animated`]: animated,
            [`${bsPrefix}-bar-striped`]: animated || striped
        }),
        style: {
            width: `${getPercentage(now, min, max)}%`,
            ...style
        },
        "aria-valuenow": now,
        "aria-valuemin": min,
        "aria-valuemax": max,
        children: visuallyHidden ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "visually-hidden",
            children: label
        }) : label
    });
}
const ProgressBar = /*#__PURE__*/ _react.forwardRef(({ isChild = false, ...rest }, ref)=>{
    const props = {
        min: 0,
        max: 100,
        animated: false,
        visuallyHidden: false,
        striped: false,
        ...rest
    };
    props.bsPrefix = (0, _themeProvider.useBootstrapPrefix)(props.bsPrefix, 'progress');
    if (isChild) return renderProgressBar(props, ref);
    const { min, now, max, label, visuallyHidden, striped, animated, bsPrefix, variant, className, children, ...wrapperProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        ...wrapperProps,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        children: children ? (0, _elementChildren.map)(children, (child)=>/*#__PURE__*/ (0, _react.cloneElement)(child, {
                isChild: true
            })) : renderProgressBar({
            min,
            now,
            max,
            label,
            visuallyHidden,
            striped,
            animated,
            bsPrefix,
            variant
        }, ref)
    });
});
ProgressBar.displayName = 'ProgressBar';
exports.default = ProgressBar;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./ElementChildren":"1QKQY","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gBOje":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Row = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'row');
    const breakpoints = (0, _themeProvider.useBootstrapBreakpoints)();
    const minBreakpoint = (0, _themeProvider.useBootstrapMinBreakpoint)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, decoratedBsPrefix, ...classes)
    });
});
Row.displayName = 'Row';
exports.default = Row;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3XOxF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Spinner = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, variant, animation = 'border', size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
Spinner.displayName = 'Spinner';
exports.default = Spinner;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"azk83":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _createUtilityClasses = require("./createUtilityClasses");
var _createUtilityClassesDefault = parcelHelpers.interopDefault(_createUtilityClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Stack = /*#__PURE__*/ _react.forwardRef(({ as: Component = 'div', bsPrefix, className, direction, gap, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, direction === 'horizontal' ? 'hstack' : 'vstack');
    const breakpoints = (0, _themeProvider.useBootstrapBreakpoints)();
    const minBreakpoint = (0, _themeProvider.useBootstrapMinBreakpoint)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix, ...(0, _createUtilityClassesDefault.default)({
            gap
        }, breakpoints, minBreakpoint))
    });
});
Stack.displayName = 'Stack';
exports.default = Stack;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./createUtilityClasses":"5op9I","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5op9I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "responsivePropType", ()=>responsivePropType);
parcelHelpers.export(exports, "default", ()=>createUtilityClassName);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _themeProvider = require("./ThemeProvider");
function responsivePropType(propType) {
    return (0, _propTypesDefault.default).oneOfType([
        propType,
        (0, _propTypesDefault.default).shape({
            xs: propType,
            sm: propType,
            md: propType,
            lg: propType,
            xl: propType,
            xxl: propType
        })
    ]);
}
function createUtilityClassName(utilityValues, breakpoints = (0, _themeProvider.DEFAULT_BREAKPOINTS), minBreakpoint = (0, _themeProvider.DEFAULT_MIN_BREAKPOINT)) {
    const classes = [];
    Object.entries(utilityValues).forEach(([utilName, utilValue])=>{
        if (utilValue != null) {
            if (typeof utilValue === 'object') breakpoints.forEach((brkPoint)=>{
                const bpValue = utilValue[brkPoint];
                if (bpValue != null) {
                    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
                    classes.push(`${utilName}${infix}-${bpValue}`);
                }
            });
            else classes.push(`${utilName}-${utilValue}`);
        }
    });
    return classes;
}

},{"prop-types":"bnNSm","./ThemeProvider":"t5pcW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kqOLP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Table = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, striped, bordered, borderless, hover, size, variant, responsive, ...props }, ref)=>{
    const decoratedBsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'table');
    const classes = (0, _classnamesDefault.default)(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === 'string' ? `striped-${striped}` : 'striped'}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
    const table = /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
        ...props,
        className: classes,
        ref: ref
    });
    if (responsive) {
        let responsiveClass = `${decoratedBsPrefix}-responsive`;
        if (typeof responsive === 'string') responsiveClass = `${responsiveClass}-${responsive}`;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
exports.default = Table;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5PZyy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormOfflineStorage", ()=>FormOfflineStorage);
parcelHelpers.export(exports, "FormContext", ()=>FormContext);
parcelHelpers.export(exports, "FormStoreReferenceProvider", ()=>FormStoreReferenceProvider);
parcelHelpers.export(exports, "FormProvider", ()=>FormProvider);
parcelHelpers.export(exports, "useFormContext", ()=>useFormContext);
parcelHelpers.export(exports, "useFormCollection", ()=>useFormCollection);
parcelHelpers.export(exports, "useFormCollectionItem", ()=>useFormCollectionItem);
parcelHelpers.export(exports, "useFormElements", ()=>useFormElements);
parcelHelpers.export(exports, "useFormElement", ()=>useFormElement);
parcelHelpers.export(exports, "useFormDatasources", ()=>useFormDatasources);
parcelHelpers.export(exports, "useFormDatasource", ()=>useFormDatasource);
parcelHelpers.export(exports, "useFormWorkflowLayers", ()=>useFormWorkflowLayers);
parcelHelpers.export(exports, "useFormWorkflowLayer", ()=>useFormWorkflowLayer);
parcelHelpers.export(exports, "useFormConstants", ()=>useFormConstants);
parcelHelpers.export(exports, "useFormEngineElementStateParentFormPage", ()=>useFormEngineElementStateParentFormPage);
parcelHelpers.export(exports, "useFormEngineElementParentFormPage", ()=>useFormEngineElementParentFormPage);
parcelHelpers.export(exports, "useFormEngineElementStateChildren", ()=>useFormEngineElementStateChildren);
parcelHelpers.export(exports, "useFormEngineElementChildren", ()=>useFormEngineElementChildren);
var _jsxRuntime = require("react/jsx-runtime");
var _memoryStorage = require("@form-engine/core-util/memory-storage");
var _template = require("@form-engine/core-util/template");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useElement = require("./use-element");
var _useStore = require("./use-store");
const FormOfflineStorage = (0, _memoryStorage.getMemoryStorageNamespace)('form');
const FormContext = /*#__PURE__*/ (0, _react.createContext)(null);
function FormStoreReferenceProvider({ value, children }) {
    if (!value) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormContext.Provider, {
        value: value,
        children: typeof children === 'function' ? children(value) : children
    });
}
function FormProvider({ value: initialState, children }) {
    const store = (0, _useStore.useStore)(initialState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormStoreReferenceProvider, {
        value: store,
        children: children
    });
}
function useFormContext() {
    const value = (0, _react.useContext)(FormContext);
    if (!value) throw new Error('tried to use form context without provider');
    return value;
}
function useFormCollection(propName) {
    const { state, setItem } = useFormContext();
    const collection = state?.[propName] || [];
    const setCollectionItem = (0, _react.useCallback)((index, value)=>{
        if (index < 0) return;
        const copy = [
            ...collection
        ];
        copy[index] = value;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setItem(propName, copy);
    }, [
        collection,
        setItem,
        propName
    ]);
    const unsetCollectionItem = (0, _react.useCallback)((index)=>{
        if (index < 0 || !collection.length) return;
        const omit = [
            index
        ];
        const copy = [];
        for(let i = 0; i < collection.length; ++i)if (!omit.includes(i)) copy.push(collection[i]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setItem(propName, copy);
    }, [
        propName,
        collection,
        setItem
    ]);
    const setCollection = (0, _react.useCallback)((value)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setItem(propName, value);
    }, [
        setItem,
        propName
    ]);
    return {
        state: collection,
        set: setCollection,
        setItem: setCollectionItem,
        unsetItem: unsetCollectionItem
    };
}
function useFormCollectionItem(propName, id) {
    const { state, setItem } = useFormContext();
    const collection = state?.[propName] || [];
    const index = (0, _react.useMemo)(()=>id && collection.length ? collection.findIndex((element)=>element.id === id) : -1, [
        collection,
        id
    ]);
    const traverse = (0, _react.useCallback)((fn)=>{
        if (!id || !collection.length) return;
        const visited = [];
        function t(parent) {
            for(let i = 0; i < collection.length; ++i)if (!visited.includes(collection[i].id) && collection[i].parent === parent) {
                visited.push(collection[i].id);
                fn(collection[i], i);
                t(collection[i].id);
            }
        }
        t(id);
    }, [
        collection,
        id
    ]);
    const unsetCollectionItem = (0, _react.useCallback)(()=>{
        if (index < 0 || !collection.length) return;
        const omit = [
            index
        ];
        traverse((_child, childIndex)=>{
            omit.push(childIndex);
        });
        const copy = [];
        for(let i = 0; i < collection.length; ++i)if (!omit.includes(i)) copy.push(collection[i]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setItem(propName, copy);
    }, [
        id,
        index,
        propName,
        collection,
        setItem,
        traverse
    ]);
    const setCollectionItem = (0, _react.useCallback)((value)=>{
        if (index < 0 || !collection.length) return;
        if (!value) unsetCollectionItem();
        else {
            const copy = [
                ...collection
            ];
            copy[index] = value;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            setItem(propName, copy);
        }
    }, [
        collection,
        index,
        setItem,
        propName,
        unsetCollectionItem
    ]);
    const setCollectionItemProperty = (0, _react.useCallback)((itemPropertyName, value)=>{
        if (index < 0 || !collection.length || !collection[index]) return;
        if (value === undefined) {
            const itemUpdate = {
                ...collection[index]
            };
            delete itemUpdate[itemPropertyName];
            setCollectionItem(itemUpdate);
        } else if (collection[index][itemPropertyName] !== value) {
            const itemUpdate = {
                ...collection[index],
                [itemPropertyName]: value
            };
            setCollectionItem(itemUpdate);
        }
    }, [
        collection,
        index,
        setCollectionItem,
        propName,
        unsetCollectionItem
    ]);
    return {
        index,
        state: index > -1 ? collection[index] : undefined,
        setItem: setCollectionItem,
        unsetItem: unsetCollectionItem,
        setItemProperty: setCollectionItemProperty,
        traverse
    };
}
function useFormElements() {
    return useFormCollection('elements');
}
function useFormElement(id) {
    return useFormCollectionItem('elements', id);
}
function useFormDatasources() {
    return useFormCollection('datasources');
}
function useFormDatasource(id) {
    return useFormCollectionItem('datasources', id);
}
function useFormWorkflowLayers() {
    return useFormCollection('workflowLayers');
}
function useFormWorkflowLayer(id) {
    return useFormCollectionItem('workflowLayers', id);
}
function useFormConstants() {
    const { state = [], ...api } = useFormCollection('constants');
    const constants = (0, _react.useMemo)(()=>{
        const result = {};
        state.forEach((def)=>{
            const key = (def.id || '').trim();
            if (!key) return;
            result[key] = (0, _template.compile)(def.value || '', result, '');
        });
        return result;
    }, [
        JSON.stringify(state)
    ]);
    return {
        ...api,
        constants,
        state
    };
}
function useFormEngineElementStateParentFormPage(id) {
    const { state: elements = [] } = useFormElements();
    return (0, _react.useMemo)(()=>{
        if (!id) return null;
        function traverse(targetId) {
            for (const element of elements)if (element.id === targetId) {
                if (element.type === 'FormEnginePageElement') return element;
                else if (element.parent) return traverse(element.parent);
                else return null;
            }
            return null;
        }
        return traverse(id);
    }, [
        id,
        elements
    ]);
}
function useFormEngineElementParentFormPage() {
    return useFormEngineElementStateParentFormPage((0, _useElement.useFormEngineElementId)());
}
function useFormEngineElementStateChildren(id, deep = true) {
    const { state: elements = [] } = useFormElements();
    return (0, _react.useMemo)(()=>{
        if (!id) return [];
        function traverse(parentId, result = []) {
            for (const element of elements)if (element.parent === parentId) {
                result.push(element);
                if (deep) traverse(element.id, result);
            }
            return result;
        }
        return traverse(id);
    }, [
        id,
        elements,
        deep
    ]);
}
function useFormEngineElementChildren(deep = true) {
    return useFormEngineElementStateChildren((0, _useElement.useFormEngineElementId)(), deep);
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-util/memory-storage":"i0cxS","@form-engine/core-util/template":"bKMue","react":"9njXz","./use-element":"ehckF","./use-store":"llHXk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i0cxS":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMemoryStorage", ()=>getMemoryStorage);
parcelHelpers.export(exports, "setMemoryStorage", ()=>setMemoryStorage);
parcelHelpers.export(exports, "getMemoryStorageNamespace", ()=>getMemoryStorageNamespace);
const storage = {};
function getMemoryStorage(key, fallback = null) {
    const raw = storage[key];
    if (raw) return JSON.parse(raw);
    return fallback;
}
function setMemoryStorage(key, value) {
    storage[key] = JSON.stringify(value);
}
function getMemoryStorageNamespace(namespace) {
    const getKeys = ()=>{
        const prefix = `${namespace}/`;
        return Object.keys(storage).filter((key)=>key.startsWith(prefix)).map((key)=>key.slice(prefix.length));
    };
    const getItem = (key, fallback = null)=>{
        return getMemoryStorage(`${namespace}/${key}`, fallback);
    };
    return {
        getKeys,
        getAll () {
            const result = {};
            getKeys().forEach((key)=>{
                result[key] = getItem(key);
            });
            return result;
        },
        getItem,
        setItem (key, value) {
            return setMemoryStorage(`${namespace}/${key}`, value);
        },
        unsetItem (key) {
            delete storage[`${namespace}/${key}`];
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bKMue":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTemplate", ()=>isTemplate);
parcelHelpers.export(exports, "GET_ENV_PREFIX", ()=>GET_ENV_PREFIX);
parcelHelpers.export(exports, "TemplateDateMacros", ()=>TemplateDateMacros);
parcelHelpers.export(exports, "DefaultTemplateHelpers", ()=>DefaultTemplateHelpers);
parcelHelpers.export(exports, "compile", ()=>compile);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _formatCase = require("./format-case");
var process = require("7fab4d99158067b9");
const expressionsRegex = /\{\{([^}]+)\}\}/g;
const expressionRegex = /\{\{([^}]+)\}\}/;
const spaceSplitRegex = /(?:[^\s"]+|"[^"]*")+/g;
const pipeSplitRegex = /(?:[^>"]+|"[^"]*")+/g;
const isNumberRegex = /^(\d+(?:\.\d+)?)$/;
function isTemplate(source) {
    return typeof source === 'string' && expressionRegex.test(source);
}
function isValidDate(d) {
    return d instanceof Date && !isNaN(Number(d));
}
const GET_ENV_PREFIX = 'FORM_CONFIG_';
const TemplateDateMacros = {
    now: ()=>new Date(),
    yesterday: ()=>{
        const date = new Date();
        date.setDate(date.getDate() - 1);
        return date;
    },
    tomorrow: ()=>{
        const date = new Date();
        date.setDate(date.getDate() + 1);
        return date;
    }
};
function parseDateSource(source) {
    if (typeof source !== 'string' && typeof source !== 'number' && !(source instanceof Date)) return new Date(0);
    return typeof source === 'string' && source in TemplateDateMacros ? TemplateDateMacros[source]() : new Date(String(source).match(isNumberRegex) ? Number(source) : source);
}
const DefaultTemplateHelpers = {
    uppercase: (_locals, source)=>String(source).toUpperCase(),
    lowercase: (_locals, source)=>String(source).toLowerCase(),
    titlecase: (_locals, source)=>(0, _formatCase.formatTitleCase)(String(source)),
    camelcase: (_locals, source)=>(0, _formatCase.formatCamelCase)(String(source)),
    pascalcase: (_locals, source)=>(0, _formatCase.formatPascalCase)(String(source)),
    number: (_locals, source, locale = 'en', maximumFractionDigits = 2)=>{
        try {
            return new Intl.NumberFormat(String(locale), {
                maximumFractionDigits: Number(maximumFractionDigits)
            }).format(Number(source));
        } catch  {
            console?.warn(`invalid expression ${source}`);
            return String(source);
        }
    },
    round: (_locals, source, locale = 'en')=>{
        try {
            return new Intl.NumberFormat(String(locale)).format(Math.round(Number(source)));
        } catch  {
            console?.warn(`invalid expression ${source}`);
            return String(source);
        }
    },
    floor: (_locals, source, locale = 'en')=>{
        try {
            return new Intl.NumberFormat(String(locale)).format(Math.floor(Number(source)));
        } catch  {
            console?.warn(`invalid expression ${source}`);
            return String(source);
        }
    },
    ceil: (_locals, source, locale = 'en')=>{
        try {
            return new Intl.NumberFormat(String(locale)).format(Math.ceil(Number(source)));
        } catch  {
            console?.warn(`invalid expression ${source}`);
            return String(source);
        }
    },
    currency: (_locals, source, locale = 'en', currency = 'EUR')=>{
        try {
            return new Intl.NumberFormat(String(locale), {
                style: 'currency',
                currency: String(currency)
            }).format(Number(source));
        } catch  {
            console?.warn(`invalid expression ${source}`);
            return String(source);
        }
    },
    date: (_locals, source, locale = 'en', dateStyle = 'medium')=>{
        const date = parseDateSource(source);
        if (!isValidDate(date)) return source;
        try {
            return new Intl.DateTimeFormat(String(locale), {
                dateStyle: String(dateStyle)
            }).format(date);
        } catch  {
            console?.warn(`invalid expression ${source}`);
            return String(source);
        }
    },
    trimToLength (_locals, source, length, ellipsis = '...') {
        const sourceString = String(source);
        const lengthNumber = Number(length);
        return sourceString.length > lengthNumber ? `${sourceString.substring(0, lengthNumber)}${ellipsis}` : sourceString;
    },
    readJson (_locals, source, path) {
        try {
            //workaround because the object is already stringified -> follow up needed for investigation why this happens
            const sourceString = JSON.parse(`"${source}"`);
            return this.get(JSON.parse(sourceString), path);
        } catch  {
            console?.warn(`unable to parse string: ${source}`);
            return '';
        }
    },
    mergeJson (locals, ...sources) {
        if (sources.length < 2) return sources[0];
        // enforce sources to be interpreted as json data
        sources = sources.map((source)=>{
            if (typeof source !== 'string') return source;
            try {
                return JSON.parse(source);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch  {
                console.log('passed incompatible arguments to mergeJson');
                return undefined;
            }
        });
        // track if we are merging arrays or objects, first argument defines the type
        const sourceIsArray = Array.isArray(sources[0]);
        // keep it immutable
        let result = structuredClone(sources[0]);
        for (const mergeTarget of sources.slice(1)){
            // ignore mismatching arguments
            if (Array.isArray(mergeTarget) !== sourceIsArray) continue;
            // simply concat arrays, deep merge objects
            if (sourceIsArray) result = result.concat(mergeTarget);
            else result = (0, _mergeDefault.default)(result, mergeTarget);
        }
        return this.json(locals, result);
    },
    datetime: (_locals, source, locale = 'en', dateStyle = 'medium', timeStyle = 'short')=>{
        const date = parseDateSource(source);
        if (!isValidDate(date)) return source;
        try {
            return new Intl.DateTimeFormat(String(locale), {
                dateStyle: String(dateStyle),
                timeStyle: String(timeStyle)
            }).format(date);
        } catch  {
            console?.warn(`invalid expression ${source}`);
            return source;
        }
    },
    time: (_locals, source, locale = 'en', timeStyle = 'short')=>{
        const date = parseDateSource(source);
        if (!isValidDate(date)) return source;
        try {
            return new Intl.DateTimeFormat(String(locale), {
                timeStyle: String(timeStyle)
            }).format(date);
        } catch  {
            console?.warn(`invalid expression ${source}`);
            return source;
        }
    },
    join: (_locals, delimiter = '', ...parts)=>parts.join(String(delimiter)),
    concat: (_locals, ...parts)=>parts.join(''),
    get: (locals, varname = '', ...segments)=>(0, _getDefault.default)(locals, [
            varname,
            ...segments
        ].join(''), (0, _getDefault.default)(locals, String(varname), '')),
    json: (_locals, value = '', space)=>JSON.stringify(value ?? null, undefined, space),
    jsonString: (_locals, value = '', space)=>{
        const result = JSON.stringify(value ?? null, undefined, space);
        if (result.startsWith('"') && result.endsWith('"')) return result.slice(1, -1);
        return result;
    },
    reverse: (_locals, varname = '')=>String(varname ?? '').split('').reverse().join(''),
    echo: (_locals, string)=>String(string ?? ''),
    condition: (locals, input, thenArg, elseArg)=>{
        if (!input) return elseArg !== undefined ? (0, _getDefault.default)(locals, String(elseArg), elseArg) : '';
        let compare = false;
        try {
            compare = Boolean(JSON.parse(String((0, _getDefault.default)(locals, String(input), String(input)))));
        } catch  {
            compare = Boolean(String(input).trim());
        }
        if (compare) return thenArg !== undefined ? (0, _getDefault.default)(locals, String(thenArg), thenArg) : '';
        return elseArg !== undefined ? (0, _getDefault.default)(locals, String(elseArg), elseArg) : '';
    },
    flat: (_locals, input, depth = Infinity)=>{
        if (typeof input === 'string') try {
            input = JSON.parse(input);
        } catch  {
            console?.warn('flat: failed to parse input');
            return null;
        }
        if (!Array.isArray(input)) {
            console?.warn('flat: invalid input');
            return null;
        }
        return JSON.stringify(input.flat(Number(depth)));
    },
    getEnv: (_locals, varname = '', ...segments)=>{
        const path = [
            varname,
            ...segments
        ].join('');
        console.log('called with ', path);
        if (!path.startsWith(GET_ENV_PREFIX)) {
            console?.warn(`requested env variable "${path}" is not inside allowed prefix "${GET_ENV_PREFIX}"`);
            return '';
        }
        if (typeof process?.env !== 'object') return '';
        return (0, _getDefault.default)(process.env, path, '');
    }
};
function compileMatch(expression, locals = {}, defaultValue, helpers = DefaultTemplateHelpers, pipeResult) {
    let parts = Array.from(expression.match(spaceSplitRegex) ?? []);
    if (!parts.length) {
        if (pipeResult !== undefined) return (0, _getDefault.default)(locals, pipeResult, defaultValue);
        else return expression;
    }
    if (pipeResult !== undefined) {
        const [helper, ...args] = parts;
        parts = [
            helper,
            JSON.stringify(pipeResult),
            ...args
        ];
    }
    if (parts.length === 1) return (0, _getDefault.default)(locals, parts[0], defaultValue);
    if (parts[0] in helpers) {
        const [helperName, ...args] = parts;
        const helperArgs = args.map((part)=>{
            const arg = part.trim();
            if (arg.startsWith('"') && arg.endsWith('"')) return arg.slice(1, -1);
            else if (arg.match(isNumberRegex)) return Number(arg);
            return (0, _getDefault.default)(locals, arg, defaultValue);
        });
        return helpers[helperName](locals, ...helperArgs);
    }
    return (0, _getDefault.default)(locals, parts.join(' '), defaultValue);
}
function compilePipes(expression, locals = {}, defaultValue, helpers = DefaultTemplateHelpers) {
    const parts = Array.from(expression.match(pipeSplitRegex) ?? []).map((part)=>part.trim());
    if (!parts.length) return expression;
    if (parts.length === 1) return compileMatch(parts[0], locals, defaultValue, helpers);
    let intermediateResult;
    for (const expression of parts)intermediateResult = compileMatch(expression, locals, defaultValue, helpers, intermediateResult);
    return intermediateResult;
}
function compile(source, locals = {}, defaultValue, helpers = DefaultTemplateHelpers) {
    const enhancedLocals = {
        ...locals,
        $this: locals
    };
    return source.replace(expressionsRegex, (match)=>compilePipes(match.slice(2, -2).trim(), enhancedLocals, defaultValue, helpers));
}

},{"7fab4d99158067b9":"5jT8D","lodash/get":"dBTJh","lodash/merge":"iHC1F","./format-case":"2G0oK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5jT8D":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"dBTJh":[function(require,module,exports,__globalThis) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"5Vkba"}],"5Vkba":[function(require,module,exports,__globalThis) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"1tEcE","c3296f04fad32769":"b5swP"}],"1tEcE":[function(require,module,exports,__globalThis) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"1DVeR","e823e604d75f975b":"c7lh2","f5fff1c342107fbd":"6K5tB","b04e8cc634273c23":"iEDGT"}],"1DVeR":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"c7lh2":[function(require,module,exports,__globalThis) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"1DVeR","4cdff6c9e9ff5d38":"fMaHV"}],"fMaHV":[function(require,module,exports,__globalThis) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"5ltt8","74644060ad1a1d3c":"4gOki"}],"5ltt8":[function(require,module,exports,__globalThis) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"crlKT","9b2aaf31b7bdd837":"66zQh","46d5beb3375f8a28":"7zYCt"}],"crlKT":[function(require,module,exports,__globalThis) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"gVq56"}],"gVq56":[function(require,module,exports,__globalThis) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

},{"cd92e8811deaabf5":"egvmL"}],"egvmL":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"66zQh":[function(require,module,exports,__globalThis) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"crlKT"}],"7zYCt":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"4gOki":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;

},{}],"6K5tB":[function(require,module,exports,__globalThis) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"9EwFx"}],"9EwFx":[function(require,module,exports,__globalThis) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"kx0Xn"}],"kx0Xn":[function(require,module,exports,__globalThis) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"lV1BE"}],"lV1BE":[function(require,module,exports,__globalThis) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"6JGdu","d2967b0e32ccfa56":"jD16i","ca21409ea89624c0":"9OB5v","f88fd07f8dd1f67d":"hsHKK","dbf3eae765642a3b":"5bQCB"}],"6JGdu":[function(require,module,exports,__globalThis) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"1q5yZ","a07dcf3fd3097a0c":"iugcK","92c01c953ef00ded":"bEqpc"}],"1q5yZ":[function(require,module,exports,__globalThis) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"77BkF","bc25d439ccd1fb47":"jt1rM","f096b37295a92ab0":"finz6","d88173cbc6a133c8":"5E27p","afb9b3bae0461cbf":"giimS"}],"77BkF":[function(require,module,exports,__globalThis) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"lElJo"}],"lElJo":[function(require,module,exports,__globalThis) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"bz0ok"}],"bz0ok":[function(require,module,exports,__globalThis) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"i4SFU","16db51a0e009bd8c":"fQ3rQ"}],"i4SFU":[function(require,module,exports,__globalThis) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"3A7xI","cabbc2adfaeb27d9":"eUAv3","cbb5703fe1562e7f":"6hgJK","388b819f47a43aa5":"2HVCC"}],"3A7xI":[function(require,module,exports,__globalThis) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"5ltt8","3cba3c966459d528":"6hgJK"}],"6hgJK":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{}],"eUAv3":[function(require,module,exports,__globalThis) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"h0VAr"}],"h0VAr":[function(require,module,exports,__globalThis) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"gVq56"}],"2HVCC":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = toSource;

},{}],"fQ3rQ":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"jt1rM":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"finz6":[function(require,module,exports,__globalThis) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"lElJo"}],"5E27p":[function(require,module,exports,__globalThis) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"lElJo"}],"giimS":[function(require,module,exports,__globalThis) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"lElJo"}],"iugcK":[function(require,module,exports,__globalThis) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"5b3H7","b700cb849df2c166":"bZ5tW","d76dd90eead6cced":"11sMk","3d210628ba60ec8":"TkrmM","76026bf2d4cfff93":"cCYah"}],"5b3H7":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"bZ5tW":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"5AZA1"}],"5AZA1":[function(require,module,exports,__globalThis) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"evtiM"}],"evtiM":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"11sMk":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"5AZA1"}],"TkrmM":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"5AZA1"}],"cCYah":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"5AZA1"}],"bEqpc":[function(require,module,exports,__globalThis) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map');
module.exports = Map;

},{"ed0752fe9f482107":"bz0ok","29224713b8d411e6":"gVq56"}],"jD16i":[function(require,module,exports,__globalThis) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"hINJU"}],"hINJU":[function(require,module,exports,__globalThis) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"5JCrb"}],"5JCrb":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = isKeyable;

},{}],"9OB5v":[function(require,module,exports,__globalThis) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"hINJU"}],"hsHKK":[function(require,module,exports,__globalThis) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"hINJU"}],"5bQCB":[function(require,module,exports,__globalThis) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"hINJU"}],"iEDGT":[function(require,module,exports,__globalThis) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"E4Kq0"}],"E4Kq0":[function(require,module,exports,__globalThis) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"crlKT","8439a3a1551d0706":"chzeu","4b12c9f502d3288a":"1DVeR","a0ebd327d618908a":"fMaHV"}],"chzeu":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"b5swP":[function(require,module,exports,__globalThis) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"fMaHV"}],"iHC1F":[function(require,module,exports,__globalThis) {
var baseMerge = require("7b601c4be119b25d"), createAssigner = require("e87a09d93c0fc32d");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
module.exports = merge;

},{"7b601c4be119b25d":"1n4LL","e87a09d93c0fc32d":"e0xvq"}],"1n4LL":[function(require,module,exports,__globalThis) {
var Stack = require("49ff021be75c93ea"), assignMergeValue = require("76e9fd6386317324"), baseFor = require("e7dca58bcfe9c669"), baseMergeDeep = require("4ea46d88599071ec"), isObject = require("c52c932be04280cc"), keysIn = require("27adf66142f57b4b"), safeGet = require("564385b2292facea");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
module.exports = baseMerge;

},{"49ff021be75c93ea":"cltFt","76e9fd6386317324":"e0LII","e7dca58bcfe9c669":"9oLrx","4ea46d88599071ec":"8JjIw","c52c932be04280cc":"6hgJK","27adf66142f57b4b":"6emcB","564385b2292facea":"34puL"}],"cltFt":[function(require,module,exports,__globalThis) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"iugcK","ceda2a63c77c915":"5KcsT","91ee1b348d9d7172":"hJzOg","3fe28318f65b9332":"ck5Lg","724ca4def8b84e06":"Ez0QG","e9ceacb40d9582bd":"iepWB"}],"5KcsT":[function(require,module,exports,__globalThis) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"iugcK"}],"hJzOg":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"ck5Lg":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"Ez0QG":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"iepWB":[function(require,module,exports,__globalThis) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"iugcK","1494efbafafa9552":"bEqpc","6049e8027fe9407f":"lV1BE"}],"e0LII":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("30a6c72f04f5134"), eq = require("7d9c95e1ffdd4f16");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignMergeValue;

},{"30a6c72f04f5134":"ba13n","7d9c95e1ffdd4f16":"evtiM"}],"ba13n":[function(require,module,exports,__globalThis) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"fUDy8"}],"fUDy8":[function(require,module,exports,__globalThis) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"bz0ok"}],"9oLrx":[function(require,module,exports,__globalThis) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"d4N9s"}],"d4N9s":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"8JjIw":[function(require,module,exports,__globalThis) {
var assignMergeValue = require("4af3e5b0ee4c14f6"), cloneBuffer = require("ec8e1b90277c5e12"), cloneTypedArray = require("4b1a2b5090faf247"), copyArray = require("d7675bdf0a02bffc"), initCloneObject = require("1067a6f3f6bd5986"), isArguments = require("2238139506f6727b"), isArray = require("290c774b41e416bb"), isArrayLikeObject = require("f481819c40e5b527"), isBuffer = require("6532fda6a198015f"), isFunction = require("7f306c94b573f977"), isObject = require("32c89e763261c579"), isPlainObject = require("ff359d315efefc4f"), isTypedArray = require("61ce92c01fd411fe"), safeGet = require("abfa8f7e72201edb"), toPlainObject = require("c54d414b219fa287");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
module.exports = baseMergeDeep;

},{"4af3e5b0ee4c14f6":"e0LII","ec8e1b90277c5e12":"aNaSh","4b1a2b5090faf247":"WFexx","d7675bdf0a02bffc":"lWbYv","1067a6f3f6bd5986":"fGkGx","2238139506f6727b":"bpegN","290c774b41e416bb":"1DVeR","f481819c40e5b527":"gamaN","6532fda6a198015f":"26W2O","7f306c94b573f977":"3A7xI","32c89e763261c579":"6hgJK","ff359d315efefc4f":"lCxAG","61ce92c01fd411fe":"hq5rz","abfa8f7e72201edb":"34puL","c54d414b219fa287":"i8tDZ"}],"aNaSh":[function(require,module,exports,__globalThis) {
var root = require("5d68e87b918bbcc5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"5d68e87b918bbcc5":"gVq56"}],"WFexx":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("b3183de060e04548");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"b3183de060e04548":"ZLaCu"}],"ZLaCu":[function(require,module,exports,__globalThis) {
var Uint8Array = require("c50984a96481fd62");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"c50984a96481fd62":"eHExv"}],"eHExv":[function(require,module,exports,__globalThis) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"gVq56"}],"lWbYv":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"fGkGx":[function(require,module,exports,__globalThis) {
var baseCreate = require("4a25a11eb90445e8"), getPrototype = require("8c92276927b7c3e0"), isPrototype = require("e939f15d7a0f64a5");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"4a25a11eb90445e8":"5YCvM","8c92276927b7c3e0":"9DBU4","e939f15d7a0f64a5":"6l00J"}],"5YCvM":[function(require,module,exports,__globalThis) {
var isObject = require("2c87f13f7934e7bd");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"2c87f13f7934e7bd":"6hgJK"}],"9DBU4":[function(require,module,exports,__globalThis) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"3OxAn"}],"3OxAn":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"6l00J":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"bpegN":[function(require,module,exports,__globalThis) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;

},{"b56e5b7d86069686":"5IKlp","bead821d6af018b5":"4gOki"}],"5IKlp":[function(require,module,exports,__globalThis) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"5ltt8","b6cdbe52dcf709f8":"4gOki"}],"gamaN":[function(require,module,exports,__globalThis) {
var isArrayLike = require("9ce7efb3ed8cb283"), isObjectLike = require("639a4883b097af28");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;

},{"9ce7efb3ed8cb283":"kzICo","639a4883b097af28":"4gOki"}],"kzICo":[function(require,module,exports,__globalThis) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"3A7xI","f3db08d4d1110aaf":"aFNSq"}],"aFNSq":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"26W2O":[function(require,module,exports,__globalThis) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"gVq56","a1e87b138cf75d1d":"gotX4"}],"gotX4":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"lCxAG":[function(require,module,exports,__globalThis) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"5ltt8","2ca5b85a120835de":"9DBU4","963b65e043435612":"4gOki"}],"hq5rz":[function(require,module,exports,__globalThis) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"jRqan","903f50eb1c16d257":"jVyhK","fa49853a82034c30":"bPzLC"}],"jRqan":[function(require,module,exports,__globalThis) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"5ltt8","f661b3a120d7a4cb":"aFNSq","cdd86c83797c0618":"4gOki"}],"jVyhK":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"bPzLC":[function(require,module,exports,__globalThis) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"egvmL"}],"34puL":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = safeGet;

},{}],"i8tDZ":[function(require,module,exports,__globalThis) {
var copyObject = require("6377e94c7c46b197"), keysIn = require("437a3e3814017158");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
module.exports = toPlainObject;

},{"6377e94c7c46b197":"vDc33","437a3e3814017158":"6emcB"}],"vDc33":[function(require,module,exports,__globalThis) {
var assignValue = require("51e2769785cbfa78"), baseAssignValue = require("9cddf6ac1a092765");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"51e2769785cbfa78":"aKTSf","9cddf6ac1a092765":"ba13n"}],"aKTSf":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("be513dd57a36b3f4"), eq = require("b62ef95b3cf1cde1");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"be513dd57a36b3f4":"ba13n","b62ef95b3cf1cde1":"evtiM"}],"6emcB":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"aB7KR","194eb1a802636842":"5O0AO","ac15afdc3ddd76cd":"kzICo"}],"aB7KR":[function(require,module,exports,__globalThis) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"iMrJS","9cdb51ffa56f149b":"bpegN","38cd49f1e493b3d7":"1DVeR","b379831fe1873fed":"26W2O","f362a34cd8321bb7":"bxLaX","c019db5297494469":"hq5rz"}],"iMrJS":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"bxLaX":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"5O0AO":[function(require,module,exports,__globalThis) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"6hgJK","f7d53cd92b2b977b":"6l00J","c039208a16eb68bd":"8srRf"}],"8srRf":[function(require,module,exports,__globalThis) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"e0xvq":[function(require,module,exports,__globalThis) {
var baseRest = require("b91f3c8e236f389b"), isIterateeCall = require("4f5832110eba92d3");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = createAssigner;

},{"b91f3c8e236f389b":"5w1TW","4f5832110eba92d3":"gTLnH"}],"5w1TW":[function(require,module,exports,__globalThis) {
var identity = require("3b2979bd51a0f85f"), overRest = require("ff7d23ff2a2ea6f8"), setToString = require("a11d545e809d14f7");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}
module.exports = baseRest;

},{"3b2979bd51a0f85f":"2HXBf","ff7d23ff2a2ea6f8":"rlFXD","a11d545e809d14f7":"cmKNW"}],"2HXBf":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"rlFXD":[function(require,module,exports,__globalThis) {
var apply = require("6f683b05f63ed25a");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"6f683b05f63ed25a":"bZSxb"}],"bZSxb":[function(require,module,exports,__globalThis) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"cmKNW":[function(require,module,exports,__globalThis) {
var baseSetToString = require("eebd487fbab521b6"), shortOut = require("9114f59293388d49");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"eebd487fbab521b6":"i2oRN","9114f59293388d49":"9rYPt"}],"i2oRN":[function(require,module,exports,__globalThis) {
var constant = require("706929c7b4749485"), defineProperty = require("eff1240bc0447727"), identity = require("b00d1e57326793e1");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
    });
};
module.exports = baseSetToString;

},{"706929c7b4749485":"bvu2c","eff1240bc0447727":"fUDy8","b00d1e57326793e1":"2HXBf"}],"bvu2c":[function(require,module,exports,__globalThis) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"9rYPt":[function(require,module,exports,__globalThis) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"gTLnH":[function(require,module,exports,__globalThis) {
var eq = require("a8ec2a011d2eca69"), isArrayLike = require("616bc732534dffe0"), isIndex = require("e781332a36d1bd7"), isObject = require("c8548bf6929b8a5d");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"a8ec2a011d2eca69":"evtiM","616bc732534dffe0":"kzICo","e781332a36d1bd7":"bxLaX","c8548bf6929b8a5d":"6hgJK"}],"2G0oK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatPascalCase", ()=>formatPascalCase);
parcelHelpers.export(exports, "formatResourceNameCase", ()=>formatResourceNameCase);
parcelHelpers.export(exports, "formatCamelCase", ()=>formatCamelCase);
parcelHelpers.export(exports, "formatVariableCase", ()=>formatVariableCase);
parcelHelpers.export(exports, "formatTitleCase", ()=>formatTitleCase);
const replacePatterns = {
    "\xfc": 'ue',
    "\xe4": 'ae',
    "\xf6": 'oe',
    "\xdf": 'ss',
    "\xdc": 'Ue',
    "\xc4": 'Ae',
    "\xd6": 'Oe'
};
const formatRegexp = new RegExp(Object.keys(replacePatterns).join('|'), 'gi');
function formatPascalCase(source) {
    let result = String(source || '').trim();
    result = result.replace(formatRegexp, (matched)=>replacePatterns[matched]);
    result = result.split(/\s+/).map((word)=>{
        if (word.length < 2) return word.toUpperCase();
        return `${word.slice(0, 1).toUpperCase()}${word.slice(1)}`;
    }).join('');
    result = result.replace(/[^a-zA-Z0-9+-_$]/g, '');
    return result;
}
const formatResourceNameCase = formatPascalCase;
function formatCamelCase(source) {
    const result = formatResourceNameCase(source);
    return `${result.slice(0, 1).toLowerCase()}${result.slice(1)}`;
}
const formatVariableCase = formatCamelCase;
function formatTitleCase(source) {
    let result = String(source || '').trim();
    result = result.split(/[\s-]+/).map((word)=>{
        if (word.length < 2) return word.toUpperCase();
        return `${word.slice(0, 1).toUpperCase()}${word.slice(1).toLowerCase()}`;
    }).join(' ');
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ehckF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormEngineElementProvider", ()=>FormEngineElementProvider);
parcelHelpers.export(exports, "useFormEngineElementId", ()=>useFormEngineElementId);
/**
 * Gets localized element definition
 * when a directly matched locale is available, use it otherwise
 * split language tag into parts and check if at least the base language
 * is available. e.g. use 'en' for 'en-US' if 'en-US' is not present
 * @param element - source
 * @param locale - target locale
 * @returns localized element definition
 */ parcelHelpers.export(exports, "getLocalizedElementDefinition", ()=>getLocalizedElementDefinition);
parcelHelpers.export(exports, "default", ()=>useFormEngineElementState);
parcelHelpers.export(exports, "useFormEngineElement", ()=>useFormEngineElement);
parcelHelpers.export(exports, "useFormEngineElementController", ()=>useFormEngineElementController);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fetchBackend = require("../elements/fetch-backend");
var _fetchBackendDefault = parcelHelpers.interopDefault(_fetchBackend);
var _useForm = require("./use-form");
var _useFormsession = require("./use-formsession");
const FormEngineElementContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
function FormEngineElementProvider({ id, children }) {
    if (!id) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormEngineElementContext.Provider, {
        value: id,
        children: typeof children === 'function' ? children(id) : children
    });
}
function useFormEngineElementId() {
    const id = (0, _react.useContext)(FormEngineElementContext);
    if (!id) throw new Error('tried to use form element without provider');
    return id;
}
function getLocalizedElementDefinition(element, locale) {
    let elementLocale = {};
    if (element.locales?.[locale]) elementLocale = element.locales[locale];
    else if (locale.includes('-')) {
        const [fallbackLocale] = locale.split('-');
        if (element.locales?.[fallbackLocale]) elementLocale = element.locales[fallbackLocale];
    }
    return {
        ...element,
        ...elementLocale
    };
}
function useFormEngineElementState(id) {
    const element = (0, _useForm.useFormElement)(id);
    const session = (0, _react.useContext)((0, _useFormsession.FormSessionContext));
    const localizedElement = (0, _react.useMemo)(()=>{
        const { locale = 'default' } = session?.state?.locals ?? {};
        if (!locale || locale === 'default' || !element?.state || !element?.state?.locales) return element;
        return {
            ...element,
            state: {
                ...element.state,
                ...getLocalizedElementDefinition(element.state, locale)
            }
        };
    }, [
        element?.state,
        session?.state?.locals?.locale
    ]);
    return localizedElement;
}
function useFormEngineElement() {
    const id = useFormEngineElementId();
    return useFormEngineElementState(id);
}
function useFormEngineElementController() {
    const { state: element } = useFormEngineElement();
    const { state: form } = (0, _useForm.useFormContext)();
    const { state: session } = (0, _useFormsession.useFormSessionContext)();
    if (!element || !form || !form?.id) throw new Error(`tried to use element controller without provider`);
    return (0, _react.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data)=>{
        return (0, _fetchBackendDefault.default)(form.id, element.id, session, data);
    }, [
        element?.type,
        form?.id,
        session
    ]);
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../elements/fetch-backend":"3DXtY","./use-form":"5PZyy","./use-formsession":"2Th33","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3DXtY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>fetchElementControllerBackend);
var _fetchBackend = require("@form-engine/core-util/fetch-backend");
var _fetchBackendDefault = parcelHelpers.interopDefault(_fetchBackend);
var _index = require("@form-engine/core-application/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
async function fetchElementControllerBackend(formId, elementId, session, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, options = {}) {
    const path = (0, _indexDefault.default).elementControllerBackendRoute.replace(':formId', formId).replace(':elementId', elementId);
    return (0, _fetchBackendDefault.default)(path, session, data, options) || {};
}

},{"@form-engine/core-util/fetch-backend":"iZ0XX","@form-engine/core-application/index":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iZ0XX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchBackendError", ()=>FetchBackendError);
parcelHelpers.export(exports, "default", ()=>fetchBackend);
var _crossFetch = require("cross-fetch");
var _crossFetchDefault = parcelHelpers.interopDefault(_crossFetch);
class FetchBackendError extends Error {
    constructor(message, url, status = 500, errorCode = 'UNKNOWN_ERROR', payload = null, traceId){
        super(message), this.message = message, this.url = url, this.status = status, this.errorCode = errorCode, this.payload = payload, this.traceId = traceId;
    }
    toJSON() {
        return {
            message: this.message,
            url: this.url,
            status: this.status,
            errorCode: this.errorCode,
            payload: this.payload,
            traceId: this.traceId
        };
    }
}
async function fetchBackend(path, session, data, options = {}) {
    window.FormEngine ??= {};
    const response = await (0, _crossFetchDefault.default)(path, {
        method: 'POST',
        ...options,
        body: JSON.stringify({
            session,
            data
        }),
        headers: {
            'content-type': 'application/json',
            accept: 'application/json',
            ...options.headers || {}
        }
    });
    if (response.status < 200 || response.status >= 400) {
        const message = await response.text();
        let error;
        if (message.startsWith('{')) try {
            const errorInfo = JSON.parse(message);
            let errorData = null;
            if (String(errorInfo?.error?.message).startsWith('{')) errorData = JSON.parse(errorInfo.error.message);
            error = new FetchBackendError(errorData?.message ?? message, errorData?.url, errorData?.status, errorData?.errorCode, errorData?.payload, errorData?.traceId);
            window.FormEngine.__currentError = error;
        } catch  {
            error = new FetchBackendError(message);
            window.FormEngine.__currentError = error;
        }
        else window.FormEngine.__currentError = new FetchBackendError(message);
        throw error;
    }
    return await response.json();
}

},{"cross-fetch":"elqs3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"elqs3":[function(require,module,exports,__globalThis) {
// Save global object in a variable
var global = arguments[3];
var __global__ = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof global !== 'undefined' && global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        var global = typeof globalThis1 !== 'undefined' && globalThis1 || typeof self !== 'undefined' && self || typeof global !== 'undefined' && global;
        var support = {
            searchParams: 'URLSearchParams' in global,
            iterable: 'Symbol' in global && 'iterator' in Symbol,
            blob: 'FileReader' in global && 'Blob' in global && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in global,
            arrayBuffer: 'ArrayBuffer' in global
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) this._bodyText = '';
                else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) {
                        var isConsumed = consumed(this);
                        if (isConsumed) return isConsumed;
                        if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                        else return Promise.resolve(this._bodyArrayBuffer);
                    } else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'POST',
            'PUT'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ''
            });
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = global.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && global.location.href ? global.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer && request.headers.get('Content-Type') && request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1) xhr.responseType = 'arraybuffer';
                }
                if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                    xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                });
                else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!global.fetch) {
            global.fetch = fetch;
            global.Headers = Headers;
            global.Request = Request;
            global.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

},{}],"2Th33":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormSessionContext", ()=>FormSessionContext);
parcelHelpers.export(exports, "FormSessionI18nUpdater", ()=>FormSessionI18nUpdater);
parcelHelpers.export(exports, "SessionStore", ()=>SessionStore);
parcelHelpers.export(exports, "FormSessionProvider", ()=>FormSessionProvider);
parcelHelpers.export(exports, "useFormSessionContext", ()=>useFormSessionContext);
parcelHelpers.export(exports, "useCurrentPage", ()=>useCurrentPage);
parcelHelpers.export(exports, "FormElementSessionStateStruct", ()=>FormElementSessionStateStruct);
parcelHelpers.export(exports, "useFormElementSessionState", ()=>useFormElementSessionState);
parcelHelpers.export(exports, "useFormElementSession", ()=>useFormElementSession);
parcelHelpers.export(exports, "useParentFormPageSession", ()=>useParentFormPageSession);
parcelHelpers.export(exports, "useFormSessionValidation", ()=>useFormSessionValidation);
parcelHelpers.export(exports, "useFormSessionDatasources", ()=>useFormSessionDatasources);
parcelHelpers.export(exports, "useFormSessionLocals", ()=>useFormSessionLocals);
parcelHelpers.export(exports, "useFormSessionValues", ()=>useFormSessionValues);
parcelHelpers.export(exports, "useFormSessionErrors", ()=>useFormSessionErrors);
parcelHelpers.export(exports, "resetFormElementValue", ()=>resetFormElementValue);
parcelHelpers.export(exports, "setFormElementValue", ()=>setFormElementValue);
parcelHelpers.export(exports, "setFormElementValueByName", ()=>setFormElementValueByName);
parcelHelpers.export(exports, "setFormElementValueById", ()=>setFormElementValueById);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useElement = require("./use-element");
var _useForm = require("./use-form");
var _useStore = require("./use-store");
var _validation = require("../validation");
var _validationDefault = parcelHelpers.interopDefault(_validation);
var _formSession = require("../utilities/form-session");
var _index = require("../index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _elementList = require("@form-engine/core-util/element-list");
var _uuid = require("@form-engine/core-util/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
const FormSessionContext = /*#__PURE__*/ (0, _react.createContext)(null);
function FormSessionI18nUpdater() {
    const { state: session } = useFormSessionContext();
    (0, _react.useEffect)(()=>{
        if ((0, _indexDefault.default)?.i18n) (0, _indexDefault.default).i18n.locale = String(session?.locals?.locale ?? 'default');
    }, [
        session?.locals?.locale
    ]);
    return null;
}
class SessionStore extends (0, _useStore.Store) {
    constructor(initialState){
        super(initialState), this.clearAll = (eventData)=>{
            this.previousState = this.state;
            this.state = {
                ...this.initialState
            };
            if (this.state && !this.state.id) this.state.id = (0, _uuidDefault.default)();
            this.dispatch(eventData);
            return this.state;
        };
        if (this.state && !this.state.id) this.state.id = (0, _uuidDefault.default)();
    }
}
function FormSessionProvider({ value: initialState, children }) {
    const store = (0, _useStore.useStore)(initialState, SessionStore);
    useFormSessionValidation(store);
    if (!store) return null;
    // expose current store value for debugging
    (0, _indexDefault.default).__currentSession = store?.state;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FormSessionContext.Provider, {
        value: store,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormSessionI18nUpdater, {}),
            typeof children === 'function' ? children(store) : children
        ]
    });
}
function useFormSessionContext() {
    const context = (0, _react.useContext)(FormSessionContext);
    if (!context) throw new Error('tried to use form session without provider');
    return context;
}
function useCurrentPage() {
    const { state: { elements = [] } } = (0, _useForm.useFormContext)();
    const { state: { currentPage = '' }, setItem } = useFormSessionContext();
    const state = (0, _react.useMemo)(()=>{
        let value = currentPage;
        if (!currentPage) {
            const defaultPageElement = elements.find(({ type, isDefault })=>type === 'FormEnginePageElement' && isDefault);
            value = defaultPageElement?.name || '';
        }
        return value;
    }, [
        currentPage,
        elements,
        setItem
    ]);
    const setState = (0, _react.useCallback)((pageName)=>{
        setItem('currentPage', pageName);
    }, [
        setItem
    ]);
    return [
        state,
        setState
    ];
}
function FormElementSessionStateStruct(item = {}) {
    return {
        value: '',
        isTouched: false,
        isHidden: false,
        error: null,
        ...item
    };
}
function useFormElementSessionState(id) {
    const { state: session = {}, setItem } = useFormSessionContext();
    const state = (0, _react.useMemo)(()=>{
        return FormElementSessionStateStruct(id ? session?.elements?.[id] : {});
    }, [
        id,
        id && session?.elements?.[id]
    ]);
    const setter = (0, _react.useCallback)((value)=>{
        if (!id) return;
        setItem('elements', {
            ...session?.elements || {},
            [id]: FormElementSessionStateStruct({
                ...session?.elements?.[id] || {},
                ...value
            })
        });
    }, [
        setItem,
        id,
        session?.elements,
        id && session?.elements?.[id]
    ]);
    return [
        state,
        setter
    ];
}
function useFormElementSession() {
    return useFormElementSessionState((0, _useElement.useFormEngineElementId)());
}
function useParentFormPageSession() {
    const { id } = (0, _useForm.useFormEngineElementParentFormPage)() || {};
    const children = (0, _useForm.useFormEngineElementStateChildren)(id);
    const { state: session = {} } = useFormSessionContext();
    return (0, _react.useMemo)(()=>{
        const errors = {};
        let valid = true;
        const loading = [];
        const elements = Object.fromEntries(children.map(({ id })=>{
            const item = FormElementSessionStateStruct(session?.elements?.[id]);
            if (item.error) {
                errors[id] = item.error;
                valid = false;
            } else if (item.loading) loading.push(id);
            return [
                id,
                item
            ];
        }));
        return {
            elements,
            valid,
            errors,
            loading
        };
    }, [
        children,
        session
    ]);
}
function useFormSessionValidation(sessionStore) {
    const { state: elements = [] } = (0, _useForm.useFormElements)();
    const { state: session, setItem } = sessionStore || {};
    const { state: form } = (0, _useForm.useFormContext)();
    (0, _react.useEffect)(()=>{
        if (!elements.length || !setItem) return;
        const elementsUpdate = {};
        let needsUpdate = false;
        const validationSession = {
            ...session ?? {},
            locals: {
                ...session?.locals ?? {},
                values: {
                    ...session?.locals?.values ?? {},
                    ...(0, _formSession.getFormSessionValues)(form, session ?? {})
                }
            }
        };
        elements.forEach((element)=>{
            const { id } = element;
            const item = FormElementSessionStateStruct(validationSession?.elements?.[id]);
            const localizedElement = (0, _useElement.getLocalizedElementDefinition)(element, String(validationSession?.locals?.locale ?? 'default'));
            const error = (0, _validationDefault.default)(localizedElement, item.value || '', validationSession);
            if (item.error !== error) {
                elementsUpdate[id] = {
                    ...item,
                    error
                };
                needsUpdate = true;
            }
        });
        if (needsUpdate) setItem('elements', {
            ...session?.elements || {},
            ...elementsUpdate
        });
    }, [
        elements,
        session?.elements,
        session,
        setItem
    ]);
}
function useFormSessionDatasources() {
    const session = useFormSessionContext();
    if (!session) throw new Error(`no form session available`);
    const { state: { datasources = {} }, setItem: setSessionItem } = session;
    const set = (0, _react.useCallback)((value)=>setSessionItem('datasources', value), [
        setSessionItem
    ]);
    const setItem = (0, _react.useCallback)((key, value)=>{
        if (!setSessionItem) return;
        set({
            ...datasources || {},
            [key]: value
        });
    }, [
        set,
        datasources
    ]);
    return {
        state: datasources,
        setItem,
        set
    };
}
function useFormSessionLocals() {
    const { state: session, setItem: setSessionItem } = useFormSessionContext() || {
        state: {},
        setItem: null
    };
    const { state: form } = (0, _useForm.useFormContext)();
    const state = (0, _react.useMemo)(()=>{
        return (0, _formSession.getFormSessionLocals)(form, session);
    }, [
        session
    ]);
    const setItem = (0, _react.useCallback)((key, value)=>{
        if (!setSessionItem) return;
        setSessionItem('locals', {
            ...session?.locals || {},
            [key]: value
        });
    }, [
        setSessionItem,
        session?.locals
    ]);
    return {
        state,
        setItem
    };
}
function useFormSessionValues() {
    const { state: session } = useFormSessionContext();
    const { state: form } = (0, _useForm.useFormContext)();
    return (0, _react.useMemo)(()=>{
        return (0, _formSession.getFormSessionValues)(form, session);
    }, [
        session,
        form?.elements
    ]);
}
function useFormSessionErrors() {
    const { state, setItem } = useFormSessionContext();
    const set = (0, _react.useCallback)((errors)=>setItem('errors', errors), [
        setItem
    ]);
    return {
        state: state?.errors ?? {},
        clear: (0, _react.useCallback)(()=>{
            set(undefined);
        }, [
            setItem
        ]),
        addError: (0, _react.useCallback)((id, error)=>set({
                ...state?.errors ?? {},
                [id]: error
            }), [
            set,
            state
        ]),
        set
    };
}
function resetFormElementValue(session, element) {
    if (!session.elements) session.elements = {};
    session.elements[element.id] = FormElementSessionStateStruct();
}
function setFormElementValue(session, element, value) {
    session.elements ??= {};
    session.elements[element.id] ??= FormElementSessionStateStruct();
    session.elements[element.id] = {
        ...session.elements[element.id],
        value
    };
}
function setFormElementValueByName(form, session, elementName, value) {
    const element = (0, _elementList.getItemBy)(form.elements ?? [], 'name', elementName);
    if (!element) return;
    setFormElementValue(session, element, value);
}
function setFormElementValueById(form, session, id, value) {
    const element = (0, _elementList.getItemById)(form.elements ?? [], id);
    if (!element) return;
    setFormElementValue(session, element, value);
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./use-element":"ehckF","./use-form":"5PZyy","./use-store":"llHXk","../validation":"ciAXc","../utilities/form-session":"do3Fv","../index":"fjN6J","@form-engine/core-util/element-list":"e0ovy","@form-engine/core-util/uuid":"eZttN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"llHXk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Store", ()=>Store);
parcelHelpers.export(exports, "useStore", ()=>useStore);
parcelHelpers.export(exports, "useStoreEffect", ()=>useStoreEffect);
var _react = require("react");
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
class Store {
    constructor(initialState){
        this.set = (value, eventData)=>{
            this.previousState = this.state;
            if (!value) this.state = {
                ...this.initialState
            };
            else this.state = {
                ...this.initialState,
                ...value
            };
            this.dispatch(eventData);
            return this.state;
        };
        this.setItem = (key, value, eventData)=>{
            this.previousState = this.state;
            this.state = {
                ...this.state,
                [key]: value
            };
            this.dispatch(eventData);
            return this.state;
        };
        this.unsetItem = (key, eventData)=>{
            this.previousState = this.state;
            const copy = {
                ...this.state
            };
            delete copy[key];
            this.state = copy;
            this.dispatch(eventData);
            return this.state;
        };
        this.clearAll = (eventData)=>{
            this.previousState = this.state;
            this.state = {
                ...this.initialState
            };
            this.dispatch(eventData);
            return this.state;
        };
        this.initialState = initialState;
        this.state = {
            ...initialState
        };
        this.listeners = [];
    }
    getReference(eventData = {}) {
        const { state, previousState, set, setItem, unsetItem, clearAll } = this;
        return {
            state,
            previousState,
            set,
            setItem,
            unsetItem,
            clearAll,
            eventData
        };
    }
    subscribe(listener) {
        this.listeners.push(listener);
        return this;
    }
    unsubscribe(listener) {
        const index = this.listeners.indexOf(listener);
        if (index < 0) return this;
        this.listeners.splice(index, 1);
        return this;
    }
    dispatch(eventData = {}) {
        if ((0, _isEqualDefault.default)(this.state, this.previousState)) return this;
        for (const listener of this.listeners)listener(eventData);
        return this;
    }
}
function useStore(initialState, Implementation) {
    const [storeReference, setStoreReference] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        const Type = Implementation ?? Store;
        const store = new Type(initialState);
        const handleChange = (eventData)=>{
            setStoreReference(store.getReference(eventData));
        };
        store.subscribe(handleChange);
        handleChange();
        return ()=>{
            store.unsubscribe(handleChange);
        };
    }, [
        setStoreReference,
        initialState,
        Implementation
    ]);
    return storeReference;
}
function useStoreEffect(store, callback, additionalDependencies = []) {
    const [dirty, setDirty] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        setDirty(true);
    }, [
        store,
        setDirty
    ]);
    (0, _react.useEffect)(()=>{
        if (!dirty || !callback || !store) return;
        setDirty(false);
        callback(store);
    }, [
        store,
        dirty,
        callback,
        setDirty,
        ...additionalDependencies
    ]);
}

},{"react":"9njXz","lodash/isEqual":"3mRdp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3mRdp":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("7b71d3bc42bb6f3e");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"7b71d3bc42bb6f3e":"hrIE8"}],"hrIE8":[function(require,module,exports,__globalThis) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"9gcZQ","809bbb0c20650dbc":"4gOki"}],"9gcZQ":[function(require,module,exports,__globalThis) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"cltFt","96bc8a1825db53a5":"cXMUl","8bdece495e87fb69":"7eeNO","bb94920432a68eca":"kyaB8","45495edff98e5837":"1chae","18256411ae9e2858":"1DVeR","e5ba7abf54247fc5":"26W2O","50d786bb5c7366af":"hq5rz"}],"cXMUl":[function(require,module,exports,__globalThis) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"irm8l","1ee20de911db0cb0":"bjRBC","defff3d81be91b23":"c2cDw"}],"irm8l":[function(require,module,exports,__globalThis) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"lV1BE","9a831e81e9a1f98c":"blGac","1a2b6c8a7399c39f":"h2eS8"}],"blGac":[function(require,module,exports,__globalThis) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"h2eS8":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"bjRBC":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"c2cDw":[function(require,module,exports,__globalThis) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"7eeNO":[function(require,module,exports,__globalThis) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"crlKT","dbf6aa5033a0f48":"eHExv","539966708f906e61":"evtiM","8142d4017f0a425f":"cXMUl","48cddf732eff33ba":"7z4fi","9dc78b26c5daba20":"lxNlE"}],"7z4fi":[function(require,module,exports,__globalThis) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"lxNlE":[function(require,module,exports,__globalThis) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"kyaB8":[function(require,module,exports,__globalThis) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"lOHy9"}],"lOHy9":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"hu5MU","aa79b69a13f924db":"igqw1","e3ad83e53433bc8a":"9qKxr"}],"hu5MU":[function(require,module,exports,__globalThis) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"8JuEE","148b85918856c33a":"1DVeR"}],"8JuEE":[function(require,module,exports,__globalThis) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"igqw1":[function(require,module,exports,__globalThis) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"egrke","6b1c62cea92cdb9":"gRVIR"}],"egrke":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"gRVIR":[function(require,module,exports,__globalThis) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"9qKxr":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"aB7KR","e8453365fdacc8da":"f4fT3","7760b47b02971dfa":"kzICo"}],"f4fT3":[function(require,module,exports,__globalThis) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"6l00J","3ec652610d8dd5d3":"39iyK"}],"39iyK":[function(require,module,exports,__globalThis) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"3OxAn"}],"1chae":[function(require,module,exports,__globalThis) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"7C8Fy","28e3344aae951f13":"bEqpc","b286298be5b1d9a4":"97fST","3ae50c158f89813":"juoJE","9f458755f627d456":"9vICk","8e9160b373d7fe66":"5ltt8","b210627dd951641f":"2HVCC"}],"7C8Fy":[function(require,module,exports,__globalThis) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView');
module.exports = DataView;

},{"a6517d0448dad786":"bz0ok","f83c375075418382":"gVq56"}],"97fST":[function(require,module,exports,__globalThis) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, 'Promise');
module.exports = Promise;

},{"6940648d854355b5":"bz0ok","a5c6637bac681a0":"gVq56"}],"juoJE":[function(require,module,exports,__globalThis) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, 'Set');
module.exports = Set;

},{"56b792d64741a4ff":"bz0ok","ca486d41cdf819d4":"gVq56"}],"9vICk":[function(require,module,exports,__globalThis) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, 'WeakMap');
module.exports = WeakMap;

},{"4507415bd8810d3c":"bz0ok","7a9a6581834a8452":"gVq56"}],"ciAXc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _expressions = require("@form-engine/core-util/expressions");
var _ = require("..");
var _Default = parcelHelpers.interopDefault(_);
/**
 * converts string values containing `string[][]` json data, to a one dimensional
 * comma separated list, so validation functions can work with it.
 * @example
 *  concatNestedElementValue('[[],[]]'); // => ''
 *  concatNestedElementValue('[["List A - Value A", "List A - Value B"],["List B - Value A", "List B - Value B"]]');
 *  // => 'List A - Value A, List A - Value B, List B - Value A, List B - Value B'
 * @param rawValue - json encoded input value (of nested lists)
 * @returns comma separated list of flattened values
 */ function concatNestedElementValue(rawValue) {
    if (!rawValue) return '';
    let value;
    try {
        value = JSON.parse(rawValue);
    } catch  {
        console.warn('failed to parse nested element value during validation');
        return '';
    }
    if (!Array.isArray(value)) {
        console.warn('unexpected nested element value, expected array, got ', typeof value);
        return '';
    }
    if (!value.length) return '';
    const concatenatedValues = [];
    for (const group of value)if (Array.isArray(group)) concatenatedValues.push(...group);
    // regular lists values are expected to be simple comma separated lists,
    // so we treat nested lists the same way during validation
    return concatenatedValues.join(',');
}
exports.default = function validate(element, value, session) {
    const validationFunctions = Object.values((0, _Default.default).validations);
    // when the value of the element is expected to be nested list (e.g. multi checkbox)
    // we need to concat the json value before checking it
    if (element.nested) value = concatNestedElementValue(value);
    for (const validation of validationFunctions){
        const error = validation(element, value ?? '', session);
        if (error !== null) return error;
    }
    let required = element.required;
    if (!required && element.requiredExpressions?.length) required = (0, _expressions.evalExpressions)(element.requiredExpressions, session.locals ?? {});
    if (required && String(value || '') === '' && !session?.elements?.[element.id]?.loading) return (0, _Default.default).i18n.fallback(element.requiredMessage, 'validation.required', {
        label: element.label || element.name
    });
    return null;
};

},{"@form-engine/core-util/expressions":"ayzLO","..":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ayzLO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "comparisonOperations", ()=>comparisonOperations);
parcelHelpers.export(exports, "evalExpression", ()=>evalExpression);
parcelHelpers.export(exports, "evalExpressions", ()=>evalExpressions);
var _template = require("./template");
const parseNumber = (value)=>{
    let num;
    if (value instanceof Date) num = value.getTime();
    else if (typeof value === 'number') num = value;
    else num = parseFloat(String(value).trim());
    if (isNaN(num)) return 0;
    return num;
};
const compareUnknowns = (a, b)=>{
    const compA = typeof a === 'string' ? a.trim() : JSON.stringify(a) ?? '';
    const compB = typeof b === 'string' ? b.trim() : JSON.stringify(b) ?? '';
    return compA === compB;
};
const comparisonOperations = {
    equal: (a, b)=>compareUnknowns(a, b),
    'not-equal': (a, b)=>!compareUnknowns(a, b),
    greater: (a, b)=>parseNumber(a) > parseNumber(b),
    'greater-equal': (a, b)=>parseNumber(a) >= parseNumber(b),
    lesser: (a, b)=>parseNumber(a) < parseNumber(b),
    'lesser-equal': (a, b)=>parseNumber(a) <= parseNumber(b)
};
function evalExpression(expression, locals) {
    const { operator } = expression;
    if (!comparisonOperations[operator]) return false;
    const leftOperandValue = expression?.leftOperand ? (0, _template.compile)(expression.leftOperand, locals, '') : '';
    const rightOperandValue = expression?.rightOperand ? (0, _template.compile)(expression.rightOperand, locals, '') : '';
    const result = comparisonOperations[expression?.operator](leftOperandValue, rightOperandValue);
    return result;
}
function evalExpressions(expressions, locals) {
    let result;
    let prevDisjunctor;
    for (const expression of expressions){
        if (result === undefined) result = evalExpression(expression, locals);
        else if (!prevDisjunctor || prevDisjunctor === 'and') result = result && evalExpression(expression, locals);
        else if (prevDisjunctor === 'or') result = result || evalExpression(expression, locals);
        prevDisjunctor = expression.disjunctor;
    }
    return result;
}

},{"./template":"bKMue","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"do3Fv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormConstants", ()=>getFormConstants);
parcelHelpers.export(exports, "getFormSessionValues", ()=>getFormSessionValues);
parcelHelpers.export(exports, "getFormSessionLocals", ()=>getFormSessionLocals);
var _template = require("@form-engine/core-util/template");
function getFormConstants(form) {
    const result = {};
    (form.constants || []).forEach((def)=>{
        const key = String(def.id || '').trim();
        if (!key) return;
        result[key] = (0, _template.compile)(String(def.value || ''), result, '');
    });
    return result;
}
function getFormSessionValues(form, session) {
    const { elements = [] } = form;
    const values = {};
    Object.entries(session?.elements || {}).forEach(([id, { value = '' }])=>{
        const element = elements.find((el)=>el.id === id);
        if (!element || !element.name) return;
        values[String(element.name)] = value;
    });
    return values;
}
function getFormSessionLocals(form, session) {
    const constants = getFormConstants(form);
    const { locals, request, datasources } = session;
    const values = getFormSessionValues(form, session);
    const datasourceConstants = {};
    for (const datasourceResult of Object.values(datasources || {}))if (datasourceResult.constants) Object.assign(datasourceConstants, datasourceResult.constants);
    return {
        ...locals || {},
        ...constants || {},
        ...datasourceConstants,
        values,
        request: request || {}
    };
}

},{"@form-engine/core-util/template":"bKMue","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e0ovy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveItemId", ()=>resolveItemId);
parcelHelpers.export(exports, "toParentSorted", ()=>toParentSorted);
parcelHelpers.export(exports, "getItemIndexById", ()=>getItemIndexById);
parcelHelpers.export(exports, "getItemBy", ()=>getItemBy);
parcelHelpers.export(exports, "getItemById", ()=>getItemById);
parcelHelpers.export(exports, "insertItemBefore", ()=>insertItemBefore);
parcelHelpers.export(exports, "insertItemAfter", ()=>insertItemAfter);
parcelHelpers.export(exports, "removeItem", ()=>removeItem);
parcelHelpers.export(exports, "addItem", ()=>addItem);
parcelHelpers.export(exports, "getItemParents", ()=>getItemParents);
parcelHelpers.export(exports, "removeOrphans", ()=>removeOrphans);
parcelHelpers.export(exports, "hasParentItem", ()=>hasParentItem);
parcelHelpers.export(exports, "relocateItem", ()=>relocateItem);
parcelHelpers.export(exports, "relocateItemBefore", ()=>relocateItemBefore);
parcelHelpers.export(exports, "relocateItemAfter", ()=>relocateItemAfter);
parcelHelpers.export(exports, "getItemChildren", ()=>getItemChildren);
parcelHelpers.export(exports, "getItemBranch", ()=>getItemBranch);
parcelHelpers.export(exports, "cloneItemBranch", ()=>cloneItemBranch);
var _uuid = require("./uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
function isListWithItems(items) {
    return Array.isArray(items) && items.length > 0;
}
function resolveItemId(idOrItem) {
    return typeof idOrItem === 'string' ? idOrItem : idOrItem?.id;
}
function parentSort(items) {
    const result = [];
    function traverse(parent) {
        for (const item of items)if (parent && item?.parent === parent || !parent && !item?.parent) {
            result.push(item);
            item?.id && traverse(item.id);
        }
    }
    traverse();
    return result;
}
function toParentSorted(items) {
    if (!isListWithItems(items)) return [];
    return parentSort([
        ...items
    ]);
}
function getItemIndexById(items, id) {
    if (!id || !isListWithItems(items)) return -1;
    return items.findIndex((item)=>item.id === id);
}
function getItemBy(items, propertyName, propertyValue) {
    if (!isListWithItems(items)) return;
    return items.find((item)=>item[propertyName] === propertyValue);
}
function getItemById(items, id) {
    if (!id || !isListWithItems(items)) return;
    return items.find((item)=>item.id === id);
}
function insertItemBefore(items, target, before) {
    if (!isListWithItems(items)) return [
        {
            ...target
        }
    ];
    const beforeId = resolveItemId(before);
    const copy = [
        ...items
    ];
    if (beforeId === target.id) return parentSort(copy);
    let index = getItemIndexById(copy, beforeId);
    if (index < 0) index = 0;
    copy.splice(index, 0, {
        ...target
    });
    return parentSort(copy);
}
function insertItemAfter(items, target, after) {
    if (!isListWithItems(items)) return [
        {
            ...target
        }
    ];
    const afterId = resolveItemId(after);
    const copy = [
        ...items
    ];
    if (afterId === target.id) return parentSort(copy);
    let index = getItemIndexById(copy, afterId) + 1;
    if (index < 1 || index > copy.length) index = copy.length;
    copy.splice(index, 0, {
        ...target
    });
    return parentSort(copy);
}
function removeItem(items, target) {
    if (!isListWithItems(items)) return [];
    const copy = [
        ...items
    ];
    if (!target) return parentSort(copy);
    const index = getItemIndexById(copy, resolveItemId(target));
    if (index < 0) return parentSort(copy);
    copy.splice(index, 1);
    return parentSort(removeOrphans(copy));
}
function addItem(items, target) {
    if (!isListWithItems(items)) {
        if (target) return [
            target
        ];
        else return [];
    }
    if (!target) return parentSort(items);
    return parentSort([
        ...items,
        target
    ]);
}
function getItemParents(items, target) {
    const index = getItemIndexById(items, resolveItemId(target));
    if (index < 0 || !isListWithItems(items)) return [];
    const parents = [];
    let current = items[index];
    while(current?.parent){
        const parentIndex = getItemIndexById(items, current.parent);
        if (parentIndex > -1) {
            const parent = items[parentIndex];
            parents.push(parent);
            current = parent;
        } else current = null;
    }
    return parents;
}
function removeOrphans(items) {
    if (!isListWithItems(items)) return [];
    const copy = [
        ...items
    ];
    const idLookup = items.map(({ id })=>id);
    function removeBranch(target) {
        const index = copy.indexOf(target);
        if (index < 0) return;
        copy.splice(index, 1);
        for (const child of getItemChildren(copy, target))removeBranch(child);
    }
    for (const item of items)if (item.parent && !idLookup.includes(item.parent)) removeBranch(item);
    return copy;
}
function hasParentItem(items, parent, child) {
    const parentId = resolveItemId(parent);
    return getItemParents(items, child).findIndex(({ id })=>id === parentId) > -1;
}
function relocateItem(insert, items, source, destination) {
    // guard relocation from items inside of them selves
    if (!source || hasParentItem(items, source, destination /*|| source.parent*/ ) || source.id === source.parent) return [
        ...items || []
    ];
    const sourceId = resolveItemId(source);
    const destinationId = resolveItemId(destination);
    const copy = [
        ...items
    ];
    const index = getItemIndexById(items, sourceId);
    if (index > -1) copy.splice(index, 1);
    return insert(copy, source, destinationId);
}
function relocateItemBefore(items, source, destination) {
    return relocateItem(insertItemBefore, items, source, destination);
}
function relocateItemAfter(items, source, destination) {
    return relocateItem(insertItemAfter, items, source, destination);
}
function getItemChildren(items, source) {
    if (!isListWithItems(items)) return [];
    const sourceId = resolveItemId(source);
    return items.filter((item)=>item.parent === sourceId);
}
function getItemBranch(items, source) {
    if (!isListWithItems(items)) return [];
    const sourceId = resolveItemId(source);
    const item = typeof source === 'object' && items.includes(source) ? source : getItemById(items, sourceId);
    if (!item) return [];
    let branch = [
        item
    ];
    getItemChildren(items, sourceId).forEach((child)=>{
        const children = getItemBranch(items, child);
        branch = [
            ...branch,
            ...children
        ];
    });
    return branch;
}
function cloneItemBranch(items, source, generateId = (0, _uuidDefault.default), traverse) {
    const idMap = {};
    const sourceId = resolveItemId(source);
    // careful: assumes getItemBranch result to be sorted parent first
    return getItemBranch(items, source).map((item)=>{
        const id = generateId();
        idMap[item.id] = id;
        const clonedParentId = item?.parent && item?.parent in idMap ? idMap[item.parent] : undefined;
        const result = {
            ...item
        };
        result.id = id;
        // use original parent if item is root
        if (item.id === sourceId) result.parent = item.parent;
        else if (clonedParentId) result.parent = clonedParentId;
        if (traverse) traverse(item, result);
        return result;
    });
}

},{"./uuid":"eZttN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eZttN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _uuid = require("uuid");
exports.default = (0, _uuid.v4);

},{"uuid":"hIyym","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hIyym":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX", ()=>(0, _maxJsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v1ToV6", ()=>(0, _v1ToV6JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "v6", ()=>(0, _v6JsDefault.default));
parcelHelpers.export(exports, "v6ToV1", ()=>(0, _v6ToV1JsDefault.default));
parcelHelpers.export(exports, "v7", ()=>(0, _v7JsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v1ToV6Js = require("./v1ToV6.js");
var _v1ToV6JsDefault = parcelHelpers.interopDefault(_v1ToV6Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _v6Js = require("./v6.js");
var _v6JsDefault = parcelHelpers.interopDefault(_v6Js);
var _v6ToV1Js = require("./v6ToV1.js");
var _v6ToV1JsDefault = parcelHelpers.interopDefault(_v6ToV1Js);
var _v7Js = require("./v7.js");
var _v7JsDefault = parcelHelpers.interopDefault(_v7Js);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);

},{"./max.js":false,"./nil.js":false,"./parse.js":false,"./stringify.js":false,"./v1.js":false,"./v1ToV6.js":false,"./v3.js":false,"./v4.js":"h4z53","./v5.js":false,"./v6.js":false,"./v6ToV1.js":false,"./v7.js":false,"./validate.js":false,"./version.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"doA1n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unsafeStringify", ()=>unsafeStringify);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).slice(1));
function unsafeStringify(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
function stringify(arr, offset = 0) {
    var uuid = unsafeStringify(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"eG5s0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eG5s0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === 'string' && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"2jBiL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2jBiL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h4z53":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeJs = require("./native.js");
var _nativeJsDefault = parcelHelpers.interopDefault(_nativeJs);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
function v4(options, buf, offset) {
    if ((0, _nativeJsDefault.default).randomUUID && !buf && !options) return (0, _nativeJsDefault.default).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(rnds);
}
exports.default = v4;

},{"./native.js":"agPy7","./rng.js":"fo5Bv","./stringify.js":"doA1n","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"agPy7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
exports.default = {
    randomUUID
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fo5Bv":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dt2u8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONDITION_TYPES", ()=>CONDITION_TYPES);
parcelHelpers.export(exports, "default", ()=>FormEngineElement);
var _jsxRuntime = require("react/jsx-runtime");
var _useElement = require("../hooks/use-element");
var _useElementDefault = parcelHelpers.interopDefault(_useElement);
var _useElementDisabled = require("../hooks/use-element-disabled");
var _useElementHidden = require("../hooks/use-element-hidden");
var _index = require("../index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var CONDITION_TYPES = /*#__PURE__*/ function(CONDITION_TYPES) {
    CONDITION_TYPES["EQUAL"] = "equal";
    CONDITION_TYPES["NOT_EQUAL"] = "not-equal";
    CONDITION_TYPES["GREATER"] = "greater";
    CONDITION_TYPES["GREATER_EQUAL"] = "greater-equal";
    CONDITION_TYPES["LESSER"] = "lesser";
    CONDITION_TYPES["LESSER_EQUAL"] = "lesser-equal";
    return CONDITION_TYPES;
}({});
function FormEngineElement({ id, as: Component = 'div', elementComponent, containerComponent, prepend, append, ...props }) {
    const { state: elementDefinition } = (0, _useElementDefault.default)(id);
    const isHidden = (0, _useElementHidden.useFormEngineElementHiddenState)(id);
    if (!elementDefinition) return null;
    const { type = 'FormEngineTextElement', width = '12', marginLeft = '0', marginRight = '0', marginTop = '0', marginBottom = '0', name } = elementDefinition;
    const disabled = (0, _useElementDisabled.useFormEngineElementDisabledState)(id);
    const editMode = 'editMode' in props && props.editMode !== false;
    delete props.editMode;
    if (!editMode && isHidden) return null;
    const Type = (0, _indexDefault.default).elements[type];
    if (!Type) return null;
    const classNames = [
        'fe-element',
        `fe-width-${width}`
    ];
    if (marginLeft && marginLeft !== '0') classNames.push(`fe-ms-${marginLeft}`);
    if (marginRight && marginRight !== '0') classNames.push(`fe-me-${marginRight}`);
    if (marginBottom && marginBottom !== '0') classNames.push(`fe-mb-${marginBottom}`);
    if (marginTop && marginTop !== '0') classNames.push(`fe-mt-${marginTop}`);
    if (name) classNames.push(`fe-elname--${name}`);
    if (disabled) classNames.push(`disabled`);
    if (props.className) classNames.push(props.className);
    // clean props for htmlelement targets
    if (typeof Component === 'string') {
        delete props.editMode;
        delete props.parent;
        delete props.source;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useElement.FormEngineElementProvider), {
        id: id,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Component, {
            ...props,
            className: classNames.join(' '),
            children: [
                prepend,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Type, {
                    id: id,
                    containerComponent: containerComponent,
                    elementComponent: elementComponent,
                    editMode: editMode
                }),
                append
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","../hooks/use-element":"ehckF","../hooks/use-element-disabled":"klZMn","../hooks/use-element-hidden":"1rivZ","../index":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"klZMn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormEngineElementDisabledState", ()=>useFormEngineElementDisabledState);
parcelHelpers.export(exports, "useFormEngineElementDisabled", ()=>useFormEngineElementDisabled);
var _expressions = require("@form-engine/core-util/expressions");
var _react = require("react");
var _useElement = require("./use-element");
var _useElementDefault = parcelHelpers.interopDefault(_useElement);
var _useFormsession = require("./use-formsession");
function useFormEngineElementDisabledState(id) {
    const { state: element } = (0, _useElementDefault.default)(id);
    const { state: locals } = (0, _useFormsession.useFormSessionLocals)();
    return (0, _react.useMemo)(()=>{
        if (!element || element.disabled || !element.disabledExpressions?.length) return Boolean(element?.disabled);
        return Boolean((0, _expressions.evalExpressions)(element.disabledExpressions, locals));
    }, [
        locals,
        element?.id,
        element?.disabled,
        element?.disabledExpressions
    ]);
}
function useFormEngineElementDisabled() {
    return useFormEngineElementDisabledState((0, _useElement.useFormEngineElementId)());
}

},{"@form-engine/core-util/expressions":"ayzLO","react":"9njXz","./use-element":"ehckF","./use-formsession":"2Th33","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1rivZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormEngineElementHiddenState", ()=>useFormEngineElementHiddenState);
parcelHelpers.export(exports, "useFormEngineElementHidden", ()=>useFormEngineElementHidden);
var _expressions = require("@form-engine/core-util/expressions");
var _react = require("react");
var _useElement = require("./use-element");
var _useElementDefault = parcelHelpers.interopDefault(_useElement);
var _useFormsession = require("./use-formsession");
function useFormEngineElementHiddenState(id) {
    const { state: element } = (0, _useElementDefault.default)(id);
    const { state: locals } = (0, _useFormsession.useFormSessionLocals)();
    return (0, _react.useMemo)(()=>{
        if (!element || element.hidden || !element.hiddenExpressions?.length) return Boolean(element?.hidden);
        return Boolean((0, _expressions.evalExpressions)(element.hiddenExpressions, locals));
    }, [
        locals,
        element?.id,
        element?.hidden,
        element?.hiddenExpressions
    ]);
}
function useFormEngineElementHidden() {
    return useFormEngineElementHiddenState((0, _useElement.useFormEngineElementId)());
}

},{"@form-engine/core-util/expressions":"ayzLO","react":"9njXz","./use-element":"ehckF","./use-formsession":"2Th33","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hxA8J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FormEngineContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _element = require("./element");
var _elementDefault = parcelHelpers.interopDefault(_element);
function FormEngineContainer({ elementComponent: ElementComponent = (0, _elementDefault.default), containerComponent, childElementIds = [], prepend, append, as: Component = 'div', id, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Component, {
        ...props,
        className: `fe-container ${props.className || ''}`,
        children: [
            prepend,
            childElementIds.map((childId)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ElementComponent, {
                    id: childId,
                    parent: id,
                    containerComponent: containerComponent,
                    elementComponent: ElementComponent
                }, childId)),
            append
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./element":"dt2u8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"guNxk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWflEventName", ()=>getWflEventName);
parcelHelpers.export(exports, "WorkflowContext", ()=>WorkflowContext);
parcelHelpers.export(exports, "WorkflowError", ()=>WorkflowError);
parcelHelpers.export(exports, "WorkflowProvider", ()=>WorkflowProvider);
parcelHelpers.export(exports, "default", ()=>useWorkflow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormsession = require("./use-formsession");
var _useWfl = require("./use-wfl");
var _index = require("../index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _useForm = require("./use-form");
var _useLoadqueue = require("./use-loadqueue");
var _useLoadqueueDefault = parcelHelpers.interopDefault(_useLoadqueue);
var _useStore = require("./use-store");
function getWflEventName(layerOrId, eventName) {
    let id;
    if (typeof layerOrId === 'object') {
        if (!layerOrId?.id) throw new Error('layer definition missing required id');
        id = String(layerOrId.id);
    } else id = String(layerOrId);
    if (!eventName) return id;
    return `${id}@${eventName}`;
}
const WorkflowContext = /*#__PURE__*/ (0, _react.createContext)(null);
class WorkflowError extends Error {
    constructor(message, sessionUpdate = {}){
        super(message), this.sessionUpdate = sessionUpdate;
    }
}
function WorkflowProvider({ value, children }) {
    const [initialState] = (0, _react.useState)(value || {});
    const store = (0, _useStore.useStore)(initialState);
    const { state: form } = (0, _useForm.useFormContext)();
    const { state: session, set: setSession, previousState: previousSession } = (0, _useFormsession.useFormSessionContext)();
    const { addError } = (0, _useFormsession.useFormSessionErrors)();
    const [loading, setLoading] = (0, _react.useState)(false);
    const { enqueue, dequeue, queue } = (0, _useLoadqueueDefault.default)();
    (0, _react.useEffect)(()=>{
        if (!store?.state?.current) return;
        let mounted = true;
        setLoading(true);
        store?.state?.current.then((sessionUpdate)=>{
            if (!mounted) {
                console?.warn?.('workflow aborted');
                return;
            }
            const { state: { currentEvent }, setItem } = store;
            if (currentEvent === getWflEventName('form:init', 'success')) setItem('initialized', true);
            if (currentEvent === getWflEventName('form:ready', 'success')) setItem('ready', true);
            if (currentEvent === getWflEventName('form:submit', 'success')) setItem('submitted', true);
            setItem('current', null);
            setItem('currentEvent', null);
            setSession(sessionUpdate);
            setLoading(false);
        }).catch((e)=>{
            console?.error?.(e);
            if (!mounted) return;
            setLoading(false);
            addError(`workflow:${store?.state?.currentEvent ?? 'global'}`, e);
        });
        return ()=>{
            mounted = false;
        };
    }, [
        store,
        store?.state?.current,
        store?.state?.currentEvent,
        store?.setItem,
        setSession,
        setLoading
    ]);
    (0, _react.useEffect)(()=>{
        if (loading && !queue.includes('workflow')) enqueue('workflow');
        else if (!loading && queue.includes('workflow')) dequeue('workflow');
    }, [
        loading,
        enqueue,
        dequeue,
        queue
    ]);
    // Emit signals that a are configured to emit on field change
    (0, _react.useEffect)(()=>{
        // Don't emit signals if the store is not ready / the form is booting up
        // or if a workflow event is currently being processed
        // gotcha: loading is kept out of the dependency array to avoid infinite
        // loops, we dont care about the loading state changing outside of the
        // effects dependencies
        if (!store?.state?.ready || loading) return;
        // track if there is work do be done
        let dirty = false;
        // execute all signal nodes that qualify sequentially and continuously
        // build a new session object with the results of each signal
        async function emitChangeSignals() {
            const { elements = {} } = session ?? {};
            const { elements: prevElements = {} } = previousSession ?? {};
            // base session result on current session
            let sessionUpdate = {
                ...session
            };
            for (const [fieldId, fieldState] of Object.entries(elements)){
                // skip all elements that have unchanged values or no definiton
                if (prevElements?.[fieldId]?.value === fieldState?.value) continue;
                const elementDefinition = form?.elements?.find(({ id })=>id === fieldId);
                if (!elementDefinition) continue;
                // gather change signals that should fire for the current element
                const onChangeSignals = (form.workflowLayers ?? []).filter(({ enabled, type, signalType, signalOnChangeSource })=>enabled && type === 'FormEngineSignalWfl' && signalType === 'onFieldChange' && elementDefinition.name === signalOnChangeSource);
                if (!onChangeSignals.length) continue;
                // sequentially fire the signals and build the session with their
                // results
                for (const signal of onChangeSignals){
                    dirty = true;
                    sessionUpdate = await emitWorkflowEvent(form, form.workflowLayers, sessionUpdate, getWflEventName(signal, 'success'));
                }
            }
            return sessionUpdate;
        }
        // block workflow execution for the current event, if there is work do be
        // done
        const promise = emitChangeSignals();
        if (dirty) {
            store?.setItem('currentEvent', 'form:change');
            store?.setItem('current', promise);
        }
    }, [
        form,
        session,
        previousSession,
        store?.setItem,
        store?.state?.ready
    ]);
    if (!store || !session) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(WorkflowContext.Provider, {
        value: store,
        children: typeof children === 'function' ? children(store) : children
    });
}
function executeLayer(form, layerDefinition, intermediateSession, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data) {
    const { type } = layerDefinition;
    const LayerType = (0, _indexDefault.default)?.workflowLayers?.[type];
    if (!LayerType) return Promise.reject(new Error(`unknown WFL type ${type}`));
    let result;
    try {
        result = LayerType({
            session: intermediateSession,
            form,
            definition: layerDefinition,
            data
        });
    } catch (e) {
        return Promise.reject(e);
    }
    if (!(result instanceof Promise)) result = Promise.resolve(result);
    return result;
}
function emitWorkflowEvent(form, formWfls, intermediateSession, eventName, eventData) {
    const targets = (formWfls || []).filter(({ events, enabled })=>{
        return enabled && Array.isArray(events) && events.includes(eventName);
    });
    if (!targets.length) return Promise.resolve({
        ...intermediateSession
    });
    async function emitTargets() {
        let sessionUpdate = {
            ...intermediateSession
        };
        for (const target of targets){
            let result;
            let error;
            try {
                result = await executeLayer(form, target, sessionUpdate, eventData);
            } catch (e) {
                error = e;
            }
            if (error) {
                if (target.id) {
                    if (error instanceof WorkflowError) sessionUpdate = {
                        ...sessionUpdate,
                        ...error.sessionUpdate,
                        locals: {
                            ...sessionUpdate?.locals || {},
                            ...error.sessionUpdate.locals || {}
                        }
                    };
                    sessionUpdate = await emitWorkflowEvent(form, formWfls, sessionUpdate, getWflEventName(target, 'error'), error);
                }
            } else {
                if (result) sessionUpdate = {
                    ...sessionUpdate,
                    ...result,
                    locals: {
                        ...sessionUpdate?.locals || {},
                        ...result?.locals || {}
                    }
                };
                if (target.id) sessionUpdate = await emitWorkflowEvent(form, formWfls, sessionUpdate, getWflEventName(target, 'success'));
            }
        }
        return sessionUpdate;
    }
    return emitTargets();
}
function useWorkflow(disabled = false) {
    const context = (0, _react.useContext)(WorkflowContext);
    if (!context) throw new Error('tried to use workflow without provider');
    const { state: workflow, setItem: setWorkflowItem, set: setWorkflow, clearAll: clearWorkflow } = context;
    const { current, initialized, submitted, ready: isReady } = workflow;
    const { state: session } = (0, _useFormsession.useFormSessionContext)();
    const values = (0, _useFormsession.useFormSessionValues)();
    const wflIntermediateSession = (0, _react.useMemo)(()=>{
        return {
            ...session,
            locals: {
                ...session?.locals || {},
                values: {
                    ...values || {},
                    ...session?.locals?.values || {}
                }
            }
        };
    }, [
        session,
        values
    ]);
    const { state: form } = (0, _useForm.useFormContext)();
    const { state: formWfls } = (0, _useWfl.useWorkflowLayers)();
    const { queue: loadQueue = [] } = (0, _useLoadqueueDefault.default)();
    const emit = (0, _react.useCallback)((eventName, eventData, intermediateSession = wflIntermediateSession)=>{
        if (current) throw new Error(`could not emit ${eventName}, workflow already processing`);
        if (disabled) return Promise.resolve({
            ...intermediateSession
        });
        const promise = emitWorkflowEvent(form, formWfls, intermediateSession, eventName, eventData);
        setWorkflowItem('currentEvent', eventName);
        setWorkflowItem('current', promise);
        return promise;
    }, [
        disabled,
        formWfls,
        form,
        wflIntermediateSession,
        setWorkflowItem,
        current,
        values
    ]);
    const submit = (0, _react.useCallback)((intermediateSession)=>emit(getWflEventName('form:submit', 'success'), undefined, intermediateSession), [
        emit
    ]);
    const init = (0, _react.useCallback)((intermediateSession)=>emit(getWflEventName('form:init', 'success'), undefined, intermediateSession), [
        emit
    ]);
    const ready = (0, _react.useCallback)((intermediateSession)=>emit(getWflEventName('form:ready', 'success'), undefined, intermediateSession), [
        emit
    ]);
    const loading = loadQueue.includes('workflow') || Boolean(workflow?.current);
    const isSubmitting = workflow?.currentEvent === getWflEventName('form:submit', 'success') && loading;
    const isInitializing = workflow?.currentEvent === getWflEventName('form:init', 'success') && loading;
    return {
        state: workflow,
        set: setWorkflow,
        setItem: setWorkflowItem,
        clearAll: clearWorkflow,
        submitted,
        initialized,
        loading,
        emit,
        submit,
        init,
        isReady: Boolean(isReady),
        ready,
        isSubmitting,
        isInitializing
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./use-formsession":"2Th33","./use-wfl":"eobGp","../index":"fjN6J","./use-form":"5PZyy","./use-loadqueue":"3WYQI","./use-store":"llHXk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eobGp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useWorkflowLayers", ()=>useWorkflowLayers);
parcelHelpers.export(exports, "default", ()=>useWorkflowLayer);
var _useForm = require("./use-form");
function useWorkflowLayers() {
    return (0, _useForm.useFormWorkflowLayers)();
}
function useWorkflowLayer(id) {
    return (0, _useForm.useFormWorkflowLayer)(id);
}

},{"./use-form":"5PZyy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3WYQI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadQueueProvider", ()=>LoadQueueProvider);
parcelHelpers.export(exports, "default", ()=>useLoadQueue);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useStore = require("./use-store");
const LoadQueueContext = /*#__PURE__*/ (0, _react.createContext)(null);
function useLoadQueueWithContext(store) {
    const { state, setItem } = store || {};
    const { queue = [] } = state || {};
    const loading = (0, _react.useMemo)(()=>Boolean(queue.length > 0), [
        queue
    ]);
    const enqueue = (0, _react.useCallback)((identifier)=>{
        if (!setItem || queue.includes(identifier)) return;
        setItem('queue', [
            ...queue,
            identifier
        ]);
    }, [
        queue,
        setItem
    ]);
    const dequeue = (0, _react.useCallback)((identifier)=>{
        if (!setItem) return;
        const index = queue.indexOf(identifier);
        if (index < 0) return;
        const copy = [
            ...queue
        ];
        copy.splice(index, 1);
        setItem('queue', copy);
    }, [
        queue,
        setItem
    ]);
    return {
        queue,
        loading,
        enqueue,
        dequeue
    };
}
function LoadQueueProvider({ value, children }) {
    const [initialValue] = (0, _react.useState)(value ?? {
        queue: []
    });
    const store = (0, _useStore.useStore)(initialValue);
    const api = useLoadQueueWithContext(store);
    if (!store) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoadQueueContext.Provider, {
        value: store,
        children: typeof children === 'function' ? children(api) : children
    });
}
function useLoadQueue() {
    return useLoadQueueWithContext((0, _react.useContext)(LoadQueueContext));
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./use-store":"llHXk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dcQs3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ShadowPortal);
var _jsxRuntime = require("react/jsx-runtime");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactDom = require("react-dom");
class FeShadowElement extends HTMLDivElement {
}
customElements.define('fe-shadow', FeShadowElement, {
    extends: 'div'
});
function ShadowPortal({ as: Component = 'div', children, resetStyling = false, ...props }) {
    const root = (0, _react1.useRef)(undefined);
    const [shadowRoot, setShadowRoot] = (0, _react1.useState)(null);
    const [emotionCache, setEmotionCache] = (0, _react1.useState)(null);
    (0, _react1.useEffect)(()=>{
        const { current: domRoot } = root;
        if (!domRoot) return;
        const shadowElement = document.createElement('fe-shadow');
        shadowElement.attachShadow({
            mode: 'open'
        });
        domRoot.appendChild(shadowElement);
        const styleContainer = document.createElement('div');
        setEmotionCache((0, _cacheDefault.default)({
            key: 'css',
            prepend: false,
            container: styleContainer
        }));
        setShadowRoot(shadowElement.shadowRoot);
        if (resetStyling) {
            const reset = document.createElement('style');
            reset.textContent = `
                :host {
                all: initial;
                }
            `;
            styleContainer.appendChild(reset);
        }
        shadowElement?.shadowRoot?.appendChild(styleContainer);
        return ()=>{
            domRoot.removeChild(shadowElement);
        };
    }, [
        setShadowRoot,
        setEmotionCache,
        resetStyling
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: root,
        ...props,
        children: emotionCache && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.CacheProvider), {
            value: emotionCache,
            children: shadowRoot && children && /*#__PURE__*/ (0, _reactDom.createPortal)(children, shadowRoot)
        })
    });
}

},{"react/jsx-runtime":"1dlk8","@emotion/cache":"r7hGp","@emotion/react":"lIeII","react":"9njXz","react-dom":"2ApDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"r7hGp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createCache);
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var isBrowser = typeof document !== 'undefined';
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + 'box-$1$2' + (0, _stylis.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-item-' + (0, _stylis.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-line-pack' + (0, _stylis.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + 'box-' + (0, _stylis.replace)(value, '-grow', '') + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, '$1' + (0, _stylis.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + '$1'), /(image-set)/, (0, _stylis.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + 'box-pack:$3' + (0, _stylis.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, _stylis.WEBKIT) + '$2-$3' + '$1' + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, 'stretch') ? prefix((0, _stylis.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ':', ':' + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, _stylis.WEBKIT) + '$2$3' + '$1' + (0, _stylis.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, '@', '@' + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var getServerStylisCache = isBrowser ? undefined : (0, _weakMemoizeDefault.default)(function() {
    return (0, _memoizeDefault.default)(function() {
        return {};
    });
});
var defaultStylisPlugins = [
    prefixer
];
var createCache = function createCache(options) {
    var key = options.key;
    if (isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if (isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    if (!getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, _stylis.stringify),
            (0, _stylis.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, _stylis.stringify)
        ];
        var _serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis1 = function _stylis1(styles) {
            return (0, _stylis.serialize)((0, _stylis.compile)(styles), _serializer);
        };
        var serverStylisCache = getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis1(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"4RXfS","stylis":"8LsfH","@emotion/weak-memoize":"8azSs","@emotion/memoize":"fCpYs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4RXfS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
var isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8LsfH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", ()=>f);
parcelHelpers.export(exports, "COMMENT", ()=>n);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>w);
parcelHelpers.export(exports, "DECLARATION", ()=>s);
parcelHelpers.export(exports, "DOCUMENT", ()=>v);
parcelHelpers.export(exports, "FONT_FACE", ()=>b);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>d);
parcelHelpers.export(exports, "IMPORT", ()=>i);
parcelHelpers.export(exports, "KEYFRAMES", ()=>h);
parcelHelpers.export(exports, "LAYER", ()=>$);
parcelHelpers.export(exports, "MEDIA", ()=>u);
parcelHelpers.export(exports, "MOZ", ()=>r);
parcelHelpers.export(exports, "MS", ()=>e);
parcelHelpers.export(exports, "NAMESPACE", ()=>p);
parcelHelpers.export(exports, "PAGE", ()=>t);
parcelHelpers.export(exports, "RULESET", ()=>c);
parcelHelpers.export(exports, "SUPPORTS", ()=>l);
parcelHelpers.export(exports, "VIEWPORT", ()=>o);
parcelHelpers.export(exports, "WEBKIT", ()=>a);
parcelHelpers.export(exports, "abs", ()=>g);
parcelHelpers.export(exports, "alloc", ()=>V);
parcelHelpers.export(exports, "append", ()=>q);
parcelHelpers.export(exports, "assign", ()=>m);
parcelHelpers.export(exports, "caret", ()=>R);
parcelHelpers.export(exports, "char", ()=>L);
parcelHelpers.export(exports, "character", ()=>H);
parcelHelpers.export(exports, "characters", ()=>I);
parcelHelpers.export(exports, "charat", ()=>O);
parcelHelpers.export(exports, "column", ()=>E);
parcelHelpers.export(exports, "combine", ()=>B);
parcelHelpers.export(exports, "comment", ()=>ue);
parcelHelpers.export(exports, "commenter", ()=>ae);
parcelHelpers.export(exports, "compile", ()=>ce);
parcelHelpers.export(exports, "copy", ()=>K);
parcelHelpers.export(exports, "dealloc", ()=>W);
parcelHelpers.export(exports, "declaration", ()=>ie);
parcelHelpers.export(exports, "delimit", ()=>X);
parcelHelpers.export(exports, "delimiter", ()=>re);
parcelHelpers.export(exports, "escaping", ()=>ee);
parcelHelpers.export(exports, "from", ()=>k);
parcelHelpers.export(exports, "hash", ()=>x);
parcelHelpers.export(exports, "identifier", ()=>ne);
parcelHelpers.export(exports, "indexof", ()=>C);
parcelHelpers.export(exports, "length", ()=>F);
parcelHelpers.export(exports, "line", ()=>D);
parcelHelpers.export(exports, "match", ()=>j);
parcelHelpers.export(exports, "middleware", ()=>ve);
parcelHelpers.export(exports, "namespace", ()=>be);
parcelHelpers.export(exports, "next", ()=>P);
parcelHelpers.export(exports, "node", ()=>J);
parcelHelpers.export(exports, "parse", ()=>se);
parcelHelpers.export(exports, "peek", ()=>Q);
parcelHelpers.export(exports, "position", ()=>G);
parcelHelpers.export(exports, "prefix", ()=>fe);
parcelHelpers.export(exports, "prefixer", ()=>he);
parcelHelpers.export(exports, "prev", ()=>N);
parcelHelpers.export(exports, "replace", ()=>z);
parcelHelpers.export(exports, "ruleset", ()=>te);
parcelHelpers.export(exports, "rulesheet", ()=>pe);
parcelHelpers.export(exports, "serialize", ()=>oe);
parcelHelpers.export(exports, "sizeof", ()=>S);
parcelHelpers.export(exports, "slice", ()=>T);
parcelHelpers.export(exports, "stringify", ()=>le);
parcelHelpers.export(exports, "strlen", ()=>M);
parcelHelpers.export(exports, "substr", ()=>A);
parcelHelpers.export(exports, "token", ()=>U);
parcelHelpers.export(exports, "tokenize", ()=>Y);
parcelHelpers.export(exports, "tokenizer", ()=>_);
parcelHelpers.export(exports, "trim", ()=>y);
parcelHelpers.export(exports, "whitespace", ()=>Z);
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var $ = "@layer";
var g = Math.abs;
var k = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
    return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
    return e.trim();
}
function j(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
    return e.replace(r, a);
}
function C(e, r) {
    return e.indexOf(r);
}
function O(e, r) {
    return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
    return e.slice(r, a);
}
function M(e) {
    return e.length;
}
function S(e) {
    return e.length;
}
function q(e, r) {
    return r.push(e), e;
}
function B(e, r) {
    return e.map(r).join("");
}
var D = 1;
var E = 1;
var F = 0;
var G = 0;
var H = 0;
var I = "";
function J(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: D,
        column: E,
        length: t,
        return: ""
    };
}
function K(e, r) {
    return m(J("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function L() {
    return H;
}
function N() {
    H = G > 0 ? O(I, --G) : 0;
    if (E--, H === 10) E = 1, D--;
    return H;
}
function P() {
    H = G < F ? O(I, G++) : 0;
    if (E++, H === 10) E = 1, D++;
    return H;
}
function Q() {
    return O(I, G);
}
function R() {
    return G;
}
function T(e, r) {
    return A(I, e, r);
}
function U(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function V(e) {
    return D = E = 1, F = M(I = e), G = 0, [];
}
function W(e) {
    return I = "", e;
}
function X(e) {
    return y(T(G - 1, re(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y(e) {
    return W(_(V(e)));
}
function Z(e) {
    while(H = Q())if (H < 33) P();
    else break;
    return U(e) > 2 || U(H) > 3 ? "" : " ";
}
function _(e) {
    while(P())switch(U(H)){
        case 0:
            q(ne(G - 1), e);
            break;
        case 2:
            q(X(H), e);
            break;
        default:
            q(k(H), e);
    }
    return e;
}
function ee(e, r) {
    while(--r && P())if (H < 48 || H > 102 || H > 57 && H < 65 || H > 70 && H < 97) break;
    return T(e, R() + (r < 6 && Q() == 32 && P() == 32));
}
function re(e) {
    while(P())switch(H){
        case e:
            return G;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) re(H);
            break;
        case 40:
            if (e === 41) re(e);
            break;
        case 92:
            P();
            break;
    }
    return G;
}
function ae(e, r) {
    while(P())if (e + H === 57) break;
    else if (e + H === 84 && Q() === 47) break;
    return "/*" + T(r, G - 1) + "*" + k(e === 47 ? e : P());
}
function ne(e) {
    while(!U(Q()))P();
    return T(e, G);
}
function ce(e) {
    return W(se("", null, null, null, [
        ""
    ], e = V(e), 0, [
        0
    ], e));
}
function se(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = P()){
        case 40:
            if (h != 108 && O(j, l - 1) == 58) {
                if (C(j += z(X($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += X($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += Z(h);
            break;
        case 92:
            j += ee(R() - 1, 7);
            continue;
        case 47:
            switch(Q()){
                case 42:
                case 47:
                    q(ue(ae(P(), R()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = M(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = z(j, /\f/g, "");
                    if (p > 0 && M(j) - l) q(p > 32 ? ie(j + ";", n, a, l - 1) : ie(z(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    q(y = te(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) se(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && O(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                se(e, y, y, n && q(te(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                se(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + M(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && N() == 125) continue;
            }
            switch(j += k($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = (M(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if (Q() === 45) j += X(P());
                    v = Q(), o = l = M(g = j += ne(R())), $++;
                    break;
                case 45:
                    if (h === 45 && M(j) == 2) b = 0;
            }
    }
    return s;
}
function te(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = S(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = A(e, v + 1, v = g(w = u[b])), m = e; $ < h; ++$)if (m = y(w > 0 ? p[$] + " " + k : z(k, /&\f/g, p[$]))) f[d++] = m;
    return J(e, r, a, s === 0 ? c : i, f, o, l);
}
function ue(e, r, a) {
    return J(e, r, a, n, k(L()), A(e, 2, -2), 0);
}
function ie(e, r, a, n) {
    return J(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n);
}
function fe(n, c, s) {
    switch(x(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(O(n, c + 11)){
                case 114:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + z(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + z(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
        case 4554:
            return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + z(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, j(e.props, /grid-\w+-end/);
            })) return ~C(n + (s = s[c].value), "span") ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span") ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
            return e + z(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return j(e.props, /grid-\w+-start/);
            }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (M(n) - 1 - c > 6) switch(O(n, c + 1)){
                case 109:
                    if (O(n, c + 4) !== 45) break;
                case 102:
                    return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~C(n, "stretch") ? fe(z(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(O(n, O(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return z(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return z(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function oe(e, r) {
    var a = "";
    var n = S(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function le(e, r, a, t) {
    switch(e.type){
        case $:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + oe(e.children, t) + "}";
        case c:
            e.value = e.props.join(",");
    }
    return M(a = oe(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function ve(e) {
    var r = S(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function pe(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function he(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = fe(n.value, n.length, u);
                return;
            case h:
                return oe([
                    K(n, {
                        value: z(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return B(n.props, function(c) {
                    switch(j(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(read-\w+)/, ":" + r + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + a + "input-$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + r + "$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, e + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function be(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return B(Y(r), function(r, a, n) {
                    switch(O(r, 0)){
                        case 12:
                            return A(r, 1, M(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return S(n) > 1 ? "" : r;
                                case a = S(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8azSs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>weakMemoize);
var weakMemoize = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fCpYs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lIeII":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", ()=>(0, _emotionElementD59E098FEsmJs.C));
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _emotionElementD59E098FEsmJs.T));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _emotionElementD59E098FEsmJs.b));
parcelHelpers.export(exports, "__unsafe_useEmotionCache", ()=>(0, _emotionElementD59E098FEsmJs._));
parcelHelpers.export(exports, "useTheme", ()=>(0, _emotionElementD59E098FEsmJs.u));
parcelHelpers.export(exports, "withEmotionCache", ()=>(0, _emotionElementD59E098FEsmJs.w));
parcelHelpers.export(exports, "withTheme", ()=>(0, _emotionElementD59E098FEsmJs.d));
parcelHelpers.export(exports, "ClassNames", ()=>ClassNames);
parcelHelpers.export(exports, "Global", ()=>Global);
parcelHelpers.export(exports, "createElement", ()=>jsx);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "jsx", ()=>jsx);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _emotionElementD59E098FEsmJs = require("./emotion-element-d59e098f.esm.js");
var _react = require("react");
var _utils = require("@emotion/utils");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _serialize = require("@emotion/serialize");
var _cache = require("@emotion/cache");
var _extends = require("@babel/runtime/helpers/extends");
var _weakMemoize = require("@emotion/weak-memoize");
var _emotionReactIsolatedHnrsEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var jsx = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, _emotionElementD59E098FEsmJs.h).call(props, 'css')) return _react.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElementD59E098FEsmJs.E);
    createElementArgArray[1] = (0, _emotionElementD59E098FEsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return _react.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})(jsx || (jsx = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global = /* #__PURE__ */ (0, _emotionElementD59E098FEsmJs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ], undefined, _react.useContext((0, _emotionElementD59E098FEsmJs.T)));
    if (!(0, _emotionElementD59E098FEsmJs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ _react.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = _react.useRef();
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
function keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, _utils.insertStyles)(cache, serializedArr[i], false);
            if (!(0, _emotionElementD59E098FEsmJs.i) && res !== undefined) rules += res;
        }
        if (!(0, _emotionElementD59E098FEsmJs.i)) return rules;
    });
    if (!(0, _emotionElementD59E098FEsmJs.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ _react.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var ClassNames = /* #__PURE__ */ (0, _emotionElementD59E098FEsmJs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, _emotionElementD59E098FEsmJs.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, _utils.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, _emotionElementD59E098FEsmJs.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css, classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: _react.useContext((0, _emotionElementD59E098FEsmJs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

},{"./emotion-element-d59e098f.esm.js":"8wFC4","react":"9njXz","@emotion/utils":"du4W1","@emotion/use-insertion-effect-with-fallbacks":"kt8pI","@emotion/serialize":"6P7Gu","@emotion/cache":"r7hGp","@babel/runtime/helpers/extends":"ktcBy","@emotion/weak-memoize":"8azSs","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js":"4kFGQ","hoist-non-react-statics":"59Kh2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8wFC4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>CacheProvider);
parcelHelpers.export(exports, "E", ()=>Emotion$1);
parcelHelpers.export(exports, "T", ()=>ThemeContext);
parcelHelpers.export(exports, "_", ()=>__unsafe_useEmotionCache);
parcelHelpers.export(exports, "a", ()=>isDevelopment);
parcelHelpers.export(exports, "b", ()=>ThemeProvider);
parcelHelpers.export(exports, "c", ()=>createEmotionProps);
parcelHelpers.export(exports, "d", ()=>withTheme);
parcelHelpers.export(exports, "h", ()=>hasOwn);
parcelHelpers.export(exports, "i", ()=>isBrowser);
parcelHelpers.export(exports, "u", ()=>useTheme);
parcelHelpers.export(exports, "w", ()=>withEmotionCache);
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _emotionReactIsolatedHnrsEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js");
var _emotionReactIsolatedHnrsEsmJsDefault = parcelHelpers.interopDefault(_emotionReactIsolatedHnrsEsmJs);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var isDevelopment = false;
var isBrowser = typeof document !== 'undefined';
var EmotionCacheContext = /* #__PURE__ */ _react.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, _cacheDefault.default)({
    key: 'css'
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
    return (0, _react.useContext)(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!isBrowser) withEmotionCache = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, _react.useContext)(EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, _cacheDefault.default)({
                key: 'css'
            });
            return /*#__PURE__*/ _react.createElement(EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var ThemeContext = /* #__PURE__ */ _react.createContext({});
var useTheme = function useTheme() {
    return _react.useContext(ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */ (0, _weakMemoizeDefault.default)(function(outerTheme) {
    return (0, _weakMemoizeDefault.default)(function(theme) {
        return getTheme(outerTheme, theme);
    });
});
var ThemeProvider = function ThemeProvider(props) {
    var theme = _react.useContext(ThemeContext);
    if (props.theme !== theme) theme = createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ _react.forwardRef(function render(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, _emotionReactIsolatedHnrsEsmJsDefault.default)(WithTheme, Component);
}
var hasOwn = {}.hasOwnProperty;
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if (hasOwn.call(props, _key)) newProps[_key] = props[_key];
    newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    if (!isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ _react.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var Emotion = /* #__PURE__ */ withEmotionCache(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles, undefined, _react.useContext(ThemeContext));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if (hasOwn.call(props, _key2) && _key2 !== 'css' && _key2 !== typePropName && !isDevelopment) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ _react.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

},{"react":"9njXz","@emotion/cache":"r7hGp","@babel/runtime/helpers/esm/extends":"aAOJb","@emotion/weak-memoize":"8azSs","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js":"4kFGQ","@emotion/utils":"du4W1","@emotion/serialize":"6P7Gu","@emotion/use-insertion-effect-with-fallbacks":"kt8pI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kFGQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hoistNonReactStatics);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, _hoistNonReactStaticsDefault.default)(targetComponent, sourceComponent);
};

},{"hoist-non-react-statics":"59Kh2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59Kh2":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"3b6hO"}],"3b6hO":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"easHU"}],"easHU":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"du4W1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
parcelHelpers.export(exports, "registerStyles", ()=>registerStyles);
var isBrowser = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6P7Gu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var isDevelopment = false;
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if (isProcessableValue(asString)) string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment) throw new Error(noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
}

},{"@emotion/hash":"h2KJ7","@emotion/unitless":"bJPP1","@emotion/memoize":"fCpYs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h2KJ7":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>murmur2);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bJPP1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unitlessKeys);
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kt8pI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", ()=>useInsertionEffectAlwaysWithSyncFallback);
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", ()=>useInsertionEffectWithLayoutFallback);
var _react = require("react");
var isBrowser = typeof document !== 'undefined';
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = _react["useInsertionEffect"] ? _react["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser ? syncFallback : useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ktcBy":[function(require,module,exports,__globalThis) {
function _extends() {
    return module.exports = _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"5sq5X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_BOOTSTRAP_CDN_URL", ()=>DEFAULT_BOOTSTRAP_CDN_URL);
parcelHelpers.export(exports, "default", ()=>useFormResources);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useForm = require("./use-form");
function getResourceUrl(resource) {
    if (Array.isArray(resource)) return resource[0] || '';
    if (typeof resource === 'object') return resource?.url || '';
    return String(resource);
}
const DEFAULT_BOOTSTRAP_CDN_URL = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css';
function useFormResources() {
    const { state: { resources: formResources = [], includeCoreResources = true, includeBootstrapCdn = true, bootstrapCdnUrl = '' } } = (0, _useForm.useFormContext)();
    return (0, _react.useMemo)(()=>{
        let resources = formResources || [];
        if (!Array.isArray(resources) && typeof resources === 'object') resources = Object.entries(resources);
        if (includeBootstrapCdn) resources = [
            bootstrapCdnUrl?.trim() || DEFAULT_BOOTSTRAP_CDN_URL,
            ...resources
        ];
        const coreResources = Array.from(document.querySelectorAll('head link[rel="stylesheet"]')).map((node)=>{
            return [
                node.href
            ];
        });
        return [
            ...includeCoreResources ? coreResources : [],
            ...resources
        ].map((resource)=>getResourceUrl(resource)).filter((url, index, self)=>self.indexOf(url) === index).map((url, index)=>{
            if (url.endsWith('.js')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("script", {
                src: url
            }, index);
            if (url.endsWith('.css')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                type: "text/css",
                rel: "stylesheet",
                href: url
            }, index);
            return null;
        }).filter((node)=>node !== null);
    }, [
        formResources,
        includeCoreResources
    ]);
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./use-form":"5PZyy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lz7AL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDatasource);
parcelHelpers.export(exports, "useInvalidateDatasourceData", ()=>useInvalidateDatasourceData);
parcelHelpers.export(exports, "useDatasourceData", ()=>useDatasourceData);
parcelHelpers.export(exports, "useConfigDatasourceData", ()=>useConfigDatasourceData);
parcelHelpers.export(exports, "useFormElementDatasourceData", ()=>useFormElementDatasourceData);
var _react = require("react");
var _useElement = require("./use-element");
var _useForm = require("./use-form");
var _index = require("../index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _useLoadqueue = require("./use-loadqueue");
var _useLoadqueueDefault = parcelHelpers.interopDefault(_useLoadqueue);
var _useFormsession = require("./use-formsession");
var _expressions = require("@form-engine/core-util/expressions");
var _lodash = require("lodash");
function useDatasource(id) {
    return (0, _useForm.useFormDatasource)(id);
}
function useInvalidateDatasourceData() {
    const { state: sessionDatasources, set: setSessionDatasources } = (0, _useFormsession.useFormSessionDatasources)();
    return (0, _react.useCallback)((id)=>{
        if (id) {
            const copy = {
                ...sessionDatasources
            };
            delete copy[id];
            setSessionDatasources(copy);
        } else setSessionDatasources({});
    }, [
        sessionDatasources,
        setSessionDatasources
    ]);
}
function useDatasourceData(id) {
    const { state: datasource } = useDatasource(id);
    const { state: form } = (0, _useForm.useFormContext)();
    const { state: session } = (0, _useFormsession.useFormSessionContext)();
    const { state: errors, addError } = (0, _useFormsession.useFormSessionErrors)();
    const { state: sessionDatasources, setItem: setSessionDatasourcesItem } = (0, _useFormsession.useFormSessionDatasources)();
    const errorId = `datasources:${id}`;
    const currentError = errors[errorId];
    const [currentDatasourceResponse, setCurrentDatasourceResponse] = (0, _react.useState)(null);
    const result = id && sessionDatasources[id] ? sessionDatasources[id] : currentDatasourceResponse ?? {};
    const loading = Boolean(id && !result && !currentError);
    (0, _react.useEffect)(()=>{
        if (currentError || !datasource || !id || session?.isMock) return;
        const { type = '' } = datasource;
        const datasourceFunction = (0, _indexDefault.default).datasources[type];
        const isDirty = !sessionDatasources[id] || datasourceFunction.isDirty?.(datasource);
        // ignore this call, if the request ds type is not defined, or a cached
        // state is available and not stale/dirty
        if (!datasourceFunction || !isDirty) return;
        let mounted = true;
        datasourceFunction({
            definition: datasource,
            session,
            form
        }).then((result)=>{
            // only trigger state update when the hook is still mounted
            // and the result is in some form different than the last one
            if (!mounted || (0, _lodash.isEqual)(currentDatasourceResponse, result)) return;
            //propagate changes
            setSessionDatasourcesItem(id, result);
            setCurrentDatasourceResponse(result);
        }).catch((e)=>{
            if (!mounted) return;
            addError(errorId, e);
        });
        return ()=>{
            mounted = false;
        };
    }, [
        id,
        datasource,
        session,
        sessionDatasources,
        setSessionDatasourcesItem,
        addError,
        errorId,
        currentError,
        setCurrentDatasourceResponse,
        currentDatasourceResponse
    ]);
    return {
        error: null,
        options: [],
        data: [],
        ...result || {},
        loading
    };
}
function useConfigDatasourceData(datasourceConfig, expressions) {
    const isStatic = datasourceConfig?.mode === 'static';
    const datasourceResult = useDatasourceData(datasourceConfig?.datasourceId);
    const staticResult = (0, _react.useMemo)(()=>{
        let data = [];
        if (isStatic && Array.isArray(datasourceConfig?.staticOptions)) data = [
            ...datasourceConfig.staticOptions
        ];
        return {
            loading: false,
            error: null,
            data,
            options: [
                ...data
            ]
        };
    }, [
        isStatic,
        datasourceConfig?.staticOptions
    ]);
    const result = isStatic ? staticResult : datasourceResult;
    const { enqueue, dequeue } = (0, _useLoadqueueDefault.default)();
    (0, _react.useEffect)(()=>{
        if (!datasourceConfig?.datasourceId) return;
        if (result.loading) enqueue(datasourceConfig.datasourceId);
        else dequeue(datasourceConfig.datasourceId);
    }, [
        result.loading,
        enqueue,
        dequeue,
        datasourceConfig?.datasourceId
    ]);
    const { state: locals } = (0, _useFormsession.useFormSessionLocals)();
    const filteredResult = (0, _react.useMemo)(()=>{
        if (!expressions?.length) return result;
        const { data } = result;
        const isArrayResult = Array.isArray(data);
        return {
            ...result,
            options: result.options?.filter(($option, $index)=>{
                const iterator = {
                    ...isArrayResult ? data[$index] ?? {} : {},
                    $option,
                    $index
                };
                return (0, _expressions.evalExpressions)(expressions, {
                    ...locals,
                    $i: iterator
                });
            })
        };
    }, [
        result,
        expressions,
        locals
    ]);
    return filteredResult;
}
function useFormElementDatasourceData() {
    const { datasource, datasourceExpressions } = (0, _useElement.useFormEngineElement)().state ?? {};
    return useConfigDatasourceData(datasource, datasourceExpressions);
}

},{"react":"9njXz","./use-element":"ehckF","./use-form":"5PZyy","../index":"fjN6J","./use-loadqueue":"3WYQI","./use-formsession":"2Th33","@form-engine/core-util/expressions":"ayzLO","lodash":"1qc47","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1qc47":[function(require,module,exports,__globalThis) {
var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

},{}],"8dB1t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FormEngineErrorAlert);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _alert = require("./alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _reactBootstrapIcons = require("react-bootstrap-icons");
function FormEngineErrorAlert({ error }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
        variant: "danger-outline",
        title: error?.message,
        aside: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.CloudLightningRainFill), {}),
        children: false
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./alert":"4AHKQ","react-bootstrap-icons":"3TzoC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4AHKQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FormEngineAlert);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const VARIANTS = {
    primary: [
        'bg-primary bg-opacity-50',
        'text-primary',
        'text-white'
    ],
    secondary: [
        'bg-secondary bg-opacity-50',
        'text-secondary',
        'text-white'
    ],
    success: [
        'bg-success bg-opacity-50',
        'text-success',
        'text-white'
    ],
    danger: [
        'bg-danger bg-opacity-50',
        'text-danger',
        'text-white'
    ],
    warning: [
        'bg-warning bg-opacity-50',
        'text-warning',
        'text-white'
    ],
    info: [
        'bg-info bg-opacity-50',
        'text-info',
        'text-white'
    ],
    light: [
        'bg-light bg-opacity-50',
        'text-dark',
        'text-dark'
    ],
    dark: [
        'bg-dark bg-opacity-50',
        'text-white',
        'text-white'
    ],
    white: [
        'bg-white bg-opacity-50',
        'text-dark',
        'text-dark'
    ],
    transparent: [
        'bg-transparent',
        'text-body',
        'text-body'
    ],
    'primary-outline': [
        'bg-light bg-opacity-75 border border-primary',
        'text-primary',
        'text-body'
    ],
    'secondary-outline': [
        'bg-light bg-opacity-75 border border-secondary',
        'text-secondary',
        'text-body'
    ],
    'success-outline': [
        'bg-light bg-opacity-75 border border-success',
        'text-success',
        'text-body'
    ],
    'danger-outline': [
        'bg-light bg-opacity-75 border border-danger',
        'text-danger',
        'text-body'
    ],
    'warning-outline': [
        'bg-light bg-opacity-75 border border-warning',
        'text-warning',
        'text-body'
    ],
    'info-outline': [
        'bg-light bg-opacity-75 border border-info',
        'text-info',
        'text-body'
    ],
    'light-outline': [
        'bg-light bg-opacity-75 border border-light',
        'text-dark',
        'text-dark'
    ],
    'dark-outline': [
        'bg-light bg-opacity-75 border border-dark',
        'text-body',
        'text-body'
    ],
    'white-outline': [
        'bg-light bg-opacity-75 border border-white',
        'text-dark',
        'text-dark'
    ],
    'transparent-outline': [
        'bg-transparent border border-light',
        'text-body',
        'text-body'
    ]
};
function FormEngineAlert({ variant = 'primary', title, children, className, as: Component = 'div', titleAs: TitleComponent = 'h6', aside, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Component, {
        ...props,
        className: `fe-alert d-flex flex-row ${VARIANTS[variant][0]} ${className ?? ''}`,
        children: [
            aside && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `fe-alert__aside p-4 pe-2 ${VARIANTS[variant][1]}`,
                children: aside
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "fe-alert__content p-4 ps-2 flex-grow-1",
                children: [
                    title && /*#__PURE__*/ (0, _jsxRuntime.jsx)(TitleComponent, {
                        className: `mb-4 ${VARIANTS[variant][1]}`,
                        children: title
                    }),
                    children && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `${VARIANTS[variant][2]}`,
                        children: children
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3TzoC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Icon0CircleFill", ()=>(0, _0CircleFillDefault.default));
parcelHelpers.export(exports, "Icon0Circle", ()=>(0, _0CircleDefault.default));
parcelHelpers.export(exports, "Icon0SquareFill", ()=>(0, _0SquareFillDefault.default));
parcelHelpers.export(exports, "Icon0Square", ()=>(0, _0SquareDefault.default));
parcelHelpers.export(exports, "Icon1CircleFill", ()=>(0, _1CircleFillDefault.default));
parcelHelpers.export(exports, "Icon1Circle", ()=>(0, _1CircleDefault.default));
parcelHelpers.export(exports, "Icon1SquareFill", ()=>(0, _1SquareFillDefault.default));
parcelHelpers.export(exports, "Icon1Square", ()=>(0, _1SquareDefault.default));
parcelHelpers.export(exports, "Icon123", ()=>(0, _123Default.default));
parcelHelpers.export(exports, "Icon2CircleFill", ()=>(0, _2CircleFillDefault.default));
parcelHelpers.export(exports, "Icon2Circle", ()=>(0, _2CircleDefault.default));
parcelHelpers.export(exports, "Icon2SquareFill", ()=>(0, _2SquareFillDefault.default));
parcelHelpers.export(exports, "Icon2Square", ()=>(0, _2SquareDefault.default));
parcelHelpers.export(exports, "Icon3CircleFill", ()=>(0, _3CircleFillDefault.default));
parcelHelpers.export(exports, "Icon3Circle", ()=>(0, _3CircleDefault.default));
parcelHelpers.export(exports, "Icon3SquareFill", ()=>(0, _3SquareFillDefault.default));
parcelHelpers.export(exports, "Icon3Square", ()=>(0, _3SquareDefault.default));
parcelHelpers.export(exports, "Icon4CircleFill", ()=>(0, _4CircleFillDefault.default));
parcelHelpers.export(exports, "Icon4Circle", ()=>(0, _4CircleDefault.default));
parcelHelpers.export(exports, "Icon4SquareFill", ()=>(0, _4SquareFillDefault.default));
parcelHelpers.export(exports, "Icon4Square", ()=>(0, _4SquareDefault.default));
parcelHelpers.export(exports, "Icon5CircleFill", ()=>(0, _5CircleFillDefault.default));
parcelHelpers.export(exports, "Icon5Circle", ()=>(0, _5CircleDefault.default));
parcelHelpers.export(exports, "Icon5SquareFill", ()=>(0, _5SquareFillDefault.default));
parcelHelpers.export(exports, "Icon5Square", ()=>(0, _5SquareDefault.default));
parcelHelpers.export(exports, "Icon6CircleFill", ()=>(0, _6CircleFillDefault.default));
parcelHelpers.export(exports, "Icon6Circle", ()=>(0, _6CircleDefault.default));
parcelHelpers.export(exports, "Icon6SquareFill", ()=>(0, _6SquareFillDefault.default));
parcelHelpers.export(exports, "Icon6Square", ()=>(0, _6SquareDefault.default));
parcelHelpers.export(exports, "Icon7CircleFill", ()=>(0, _7CircleFillDefault.default));
parcelHelpers.export(exports, "Icon7Circle", ()=>(0, _7CircleDefault.default));
parcelHelpers.export(exports, "Icon7SquareFill", ()=>(0, _7SquareFillDefault.default));
parcelHelpers.export(exports, "Icon7Square", ()=>(0, _7SquareDefault.default));
parcelHelpers.export(exports, "Icon8CircleFill", ()=>(0, _8CircleFillDefault.default));
parcelHelpers.export(exports, "Icon8Circle", ()=>(0, _8CircleDefault.default));
parcelHelpers.export(exports, "Icon8SquareFill", ()=>(0, _8SquareFillDefault.default));
parcelHelpers.export(exports, "Icon8Square", ()=>(0, _8SquareDefault.default));
parcelHelpers.export(exports, "Icon9CircleFill", ()=>(0, _9CircleFillDefault.default));
parcelHelpers.export(exports, "Icon9Circle", ()=>(0, _9CircleDefault.default));
parcelHelpers.export(exports, "Icon9SquareFill", ()=>(0, _9SquareFillDefault.default));
parcelHelpers.export(exports, "Icon9Square", ()=>(0, _9SquareDefault.default));
parcelHelpers.export(exports, "Activity", ()=>(0, _activityDefault.default));
parcelHelpers.export(exports, "AirplaneEnginesFill", ()=>(0, _airplaneEnginesFillDefault.default));
parcelHelpers.export(exports, "AirplaneEngines", ()=>(0, _airplaneEnginesDefault.default));
parcelHelpers.export(exports, "AirplaneFill", ()=>(0, _airplaneFillDefault.default));
parcelHelpers.export(exports, "Airplane", ()=>(0, _airplaneDefault.default));
parcelHelpers.export(exports, "AlarmFill", ()=>(0, _alarmFillDefault.default));
parcelHelpers.export(exports, "Alarm", ()=>(0, _alarmDefault.default));
parcelHelpers.export(exports, "Alexa", ()=>(0, _alexaDefault.default));
parcelHelpers.export(exports, "AlignBottom", ()=>(0, _alignBottomDefault.default));
parcelHelpers.export(exports, "AlignCenter", ()=>(0, _alignCenterDefault.default));
parcelHelpers.export(exports, "AlignEnd", ()=>(0, _alignEndDefault.default));
parcelHelpers.export(exports, "AlignMiddle", ()=>(0, _alignMiddleDefault.default));
parcelHelpers.export(exports, "AlignStart", ()=>(0, _alignStartDefault.default));
parcelHelpers.export(exports, "AlignTop", ()=>(0, _alignTopDefault.default));
parcelHelpers.export(exports, "Alipay", ()=>(0, _alipayDefault.default));
parcelHelpers.export(exports, "AlphabetUppercase", ()=>(0, _alphabetUppercaseDefault.default));
parcelHelpers.export(exports, "Alphabet", ()=>(0, _alphabetDefault.default));
parcelHelpers.export(exports, "Alt", ()=>(0, _altDefault.default));
parcelHelpers.export(exports, "Amazon", ()=>(0, _amazonDefault.default));
parcelHelpers.export(exports, "Amd", ()=>(0, _amdDefault.default));
parcelHelpers.export(exports, "Android", ()=>(0, _androidDefault.default));
parcelHelpers.export(exports, "Android2", ()=>(0, _android2Default.default));
parcelHelpers.export(exports, "AppIndicator", ()=>(0, _appIndicatorDefault.default));
parcelHelpers.export(exports, "App", ()=>(0, _appDefault.default));
parcelHelpers.export(exports, "Apple", ()=>(0, _appleDefault.default));
parcelHelpers.export(exports, "ArchiveFill", ()=>(0, _archiveFillDefault.default));
parcelHelpers.export(exports, "Archive", ()=>(0, _archiveDefault.default));
parcelHelpers.export(exports, "Arrow90degDown", ()=>(0, _arrow90DegDownDefault.default));
parcelHelpers.export(exports, "Arrow90degLeft", ()=>(0, _arrow90DegLeftDefault.default));
parcelHelpers.export(exports, "Arrow90degRight", ()=>(0, _arrow90DegRightDefault.default));
parcelHelpers.export(exports, "Arrow90degUp", ()=>(0, _arrow90DegUpDefault.default));
parcelHelpers.export(exports, "ArrowBarDown", ()=>(0, _arrowBarDownDefault.default));
parcelHelpers.export(exports, "ArrowBarLeft", ()=>(0, _arrowBarLeftDefault.default));
parcelHelpers.export(exports, "ArrowBarRight", ()=>(0, _arrowBarRightDefault.default));
parcelHelpers.export(exports, "ArrowBarUp", ()=>(0, _arrowBarUpDefault.default));
parcelHelpers.export(exports, "ArrowClockwise", ()=>(0, _arrowClockwiseDefault.default));
parcelHelpers.export(exports, "ArrowCounterclockwise", ()=>(0, _arrowCounterclockwiseDefault.default));
parcelHelpers.export(exports, "ArrowDownCircleFill", ()=>(0, _arrowDownCircleFillDefault.default));
parcelHelpers.export(exports, "ArrowDownCircle", ()=>(0, _arrowDownCircleDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftCircleFill", ()=>(0, _arrowDownLeftCircleFillDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftCircle", ()=>(0, _arrowDownLeftCircleDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftSquareFill", ()=>(0, _arrowDownLeftSquareFillDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftSquare", ()=>(0, _arrowDownLeftSquareDefault.default));
parcelHelpers.export(exports, "ArrowDownLeft", ()=>(0, _arrowDownLeftDefault.default));
parcelHelpers.export(exports, "ArrowDownRightCircleFill", ()=>(0, _arrowDownRightCircleFillDefault.default));
parcelHelpers.export(exports, "ArrowDownRightCircle", ()=>(0, _arrowDownRightCircleDefault.default));
parcelHelpers.export(exports, "ArrowDownRightSquareFill", ()=>(0, _arrowDownRightSquareFillDefault.default));
parcelHelpers.export(exports, "ArrowDownRightSquare", ()=>(0, _arrowDownRightSquareDefault.default));
parcelHelpers.export(exports, "ArrowDownRight", ()=>(0, _arrowDownRightDefault.default));
parcelHelpers.export(exports, "ArrowDownShort", ()=>(0, _arrowDownShortDefault.default));
parcelHelpers.export(exports, "ArrowDownSquareFill", ()=>(0, _arrowDownSquareFillDefault.default));
parcelHelpers.export(exports, "ArrowDownSquare", ()=>(0, _arrowDownSquareDefault.default));
parcelHelpers.export(exports, "ArrowDownUp", ()=>(0, _arrowDownUpDefault.default));
parcelHelpers.export(exports, "ArrowDown", ()=>(0, _arrowDownDefault.default));
parcelHelpers.export(exports, "ArrowLeftCircleFill", ()=>(0, _arrowLeftCircleFillDefault.default));
parcelHelpers.export(exports, "ArrowLeftCircle", ()=>(0, _arrowLeftCircleDefault.default));
parcelHelpers.export(exports, "ArrowLeftRight", ()=>(0, _arrowLeftRightDefault.default));
parcelHelpers.export(exports, "ArrowLeftShort", ()=>(0, _arrowLeftShortDefault.default));
parcelHelpers.export(exports, "ArrowLeftSquareFill", ()=>(0, _arrowLeftSquareFillDefault.default));
parcelHelpers.export(exports, "ArrowLeftSquare", ()=>(0, _arrowLeftSquareDefault.default));
parcelHelpers.export(exports, "ArrowLeft", ()=>(0, _arrowLeftDefault.default));
parcelHelpers.export(exports, "ArrowRepeat", ()=>(0, _arrowRepeatDefault.default));
parcelHelpers.export(exports, "ArrowReturnLeft", ()=>(0, _arrowReturnLeftDefault.default));
parcelHelpers.export(exports, "ArrowReturnRight", ()=>(0, _arrowReturnRightDefault.default));
parcelHelpers.export(exports, "ArrowRightCircleFill", ()=>(0, _arrowRightCircleFillDefault.default));
parcelHelpers.export(exports, "ArrowRightCircle", ()=>(0, _arrowRightCircleDefault.default));
parcelHelpers.export(exports, "ArrowRightShort", ()=>(0, _arrowRightShortDefault.default));
parcelHelpers.export(exports, "ArrowRightSquareFill", ()=>(0, _arrowRightSquareFillDefault.default));
parcelHelpers.export(exports, "ArrowRightSquare", ()=>(0, _arrowRightSquareDefault.default));
parcelHelpers.export(exports, "ArrowRight", ()=>(0, _arrowRightDefault.default));
parcelHelpers.export(exports, "ArrowThroughHeartFill", ()=>(0, _arrowThroughHeartFillDefault.default));
parcelHelpers.export(exports, "ArrowThroughHeart", ()=>(0, _arrowThroughHeartDefault.default));
parcelHelpers.export(exports, "ArrowUpCircleFill", ()=>(0, _arrowUpCircleFillDefault.default));
parcelHelpers.export(exports, "ArrowUpCircle", ()=>(0, _arrowUpCircleDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftCircleFill", ()=>(0, _arrowUpLeftCircleFillDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftCircle", ()=>(0, _arrowUpLeftCircleDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftSquareFill", ()=>(0, _arrowUpLeftSquareFillDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftSquare", ()=>(0, _arrowUpLeftSquareDefault.default));
parcelHelpers.export(exports, "ArrowUpLeft", ()=>(0, _arrowUpLeftDefault.default));
parcelHelpers.export(exports, "ArrowUpRightCircleFill", ()=>(0, _arrowUpRightCircleFillDefault.default));
parcelHelpers.export(exports, "ArrowUpRightCircle", ()=>(0, _arrowUpRightCircleDefault.default));
parcelHelpers.export(exports, "ArrowUpRightSquareFill", ()=>(0, _arrowUpRightSquareFillDefault.default));
parcelHelpers.export(exports, "ArrowUpRightSquare", ()=>(0, _arrowUpRightSquareDefault.default));
parcelHelpers.export(exports, "ArrowUpRight", ()=>(0, _arrowUpRightDefault.default));
parcelHelpers.export(exports, "ArrowUpShort", ()=>(0, _arrowUpShortDefault.default));
parcelHelpers.export(exports, "ArrowUpSquareFill", ()=>(0, _arrowUpSquareFillDefault.default));
parcelHelpers.export(exports, "ArrowUpSquare", ()=>(0, _arrowUpSquareDefault.default));
parcelHelpers.export(exports, "ArrowUp", ()=>(0, _arrowUpDefault.default));
parcelHelpers.export(exports, "ArrowsAngleContract", ()=>(0, _arrowsAngleContractDefault.default));
parcelHelpers.export(exports, "ArrowsAngleExpand", ()=>(0, _arrowsAngleExpandDefault.default));
parcelHelpers.export(exports, "ArrowsCollapseVertical", ()=>(0, _arrowsCollapseVerticalDefault.default));
parcelHelpers.export(exports, "ArrowsCollapse", ()=>(0, _arrowsCollapseDefault.default));
parcelHelpers.export(exports, "ArrowsExpandVertical", ()=>(0, _arrowsExpandVerticalDefault.default));
parcelHelpers.export(exports, "ArrowsExpand", ()=>(0, _arrowsExpandDefault.default));
parcelHelpers.export(exports, "ArrowsFullscreen", ()=>(0, _arrowsFullscreenDefault.default));
parcelHelpers.export(exports, "ArrowsMove", ()=>(0, _arrowsMoveDefault.default));
parcelHelpers.export(exports, "ArrowsVertical", ()=>(0, _arrowsVerticalDefault.default));
parcelHelpers.export(exports, "Arrows", ()=>(0, _arrowsDefault.default));
parcelHelpers.export(exports, "AspectRatioFill", ()=>(0, _aspectRatioFillDefault.default));
parcelHelpers.export(exports, "AspectRatio", ()=>(0, _aspectRatioDefault.default));
parcelHelpers.export(exports, "Asterisk", ()=>(0, _asteriskDefault.default));
parcelHelpers.export(exports, "At", ()=>(0, _atDefault.default));
parcelHelpers.export(exports, "AwardFill", ()=>(0, _awardFillDefault.default));
parcelHelpers.export(exports, "Award", ()=>(0, _awardDefault.default));
parcelHelpers.export(exports, "Back", ()=>(0, _backDefault.default));
parcelHelpers.export(exports, "BackpackFill", ()=>(0, _backpackFillDefault.default));
parcelHelpers.export(exports, "Backpack", ()=>(0, _backpackDefault.default));
parcelHelpers.export(exports, "Backpack2Fill", ()=>(0, _backpack2FillDefault.default));
parcelHelpers.export(exports, "Backpack2", ()=>(0, _backpack2Default.default));
parcelHelpers.export(exports, "Backpack3Fill", ()=>(0, _backpack3FillDefault.default));
parcelHelpers.export(exports, "Backpack3", ()=>(0, _backpack3Default.default));
parcelHelpers.export(exports, "Backpack4Fill", ()=>(0, _backpack4FillDefault.default));
parcelHelpers.export(exports, "Backpack4", ()=>(0, _backpack4Default.default));
parcelHelpers.export(exports, "BackspaceFill", ()=>(0, _backspaceFillDefault.default));
parcelHelpers.export(exports, "BackspaceReverseFill", ()=>(0, _backspaceReverseFillDefault.default));
parcelHelpers.export(exports, "BackspaceReverse", ()=>(0, _backspaceReverseDefault.default));
parcelHelpers.export(exports, "Backspace", ()=>(0, _backspaceDefault.default));
parcelHelpers.export(exports, "Badge3dFill", ()=>(0, _badge3DFillDefault.default));
parcelHelpers.export(exports, "Badge3d", ()=>(0, _badge3DDefault.default));
parcelHelpers.export(exports, "Badge4kFill", ()=>(0, _badge4KFillDefault.default));
parcelHelpers.export(exports, "Badge4k", ()=>(0, _badge4KDefault.default));
parcelHelpers.export(exports, "Badge8kFill", ()=>(0, _badge8KFillDefault.default));
parcelHelpers.export(exports, "Badge8k", ()=>(0, _badge8KDefault.default));
parcelHelpers.export(exports, "BadgeAdFill", ()=>(0, _badgeAdFillDefault.default));
parcelHelpers.export(exports, "BadgeAd", ()=>(0, _badgeAdDefault.default));
parcelHelpers.export(exports, "BadgeArFill", ()=>(0, _badgeArFillDefault.default));
parcelHelpers.export(exports, "BadgeAr", ()=>(0, _badgeArDefault.default));
parcelHelpers.export(exports, "BadgeCcFill", ()=>(0, _badgeCcFillDefault.default));
parcelHelpers.export(exports, "BadgeCc", ()=>(0, _badgeCcDefault.default));
parcelHelpers.export(exports, "BadgeHdFill", ()=>(0, _badgeHdFillDefault.default));
parcelHelpers.export(exports, "BadgeHd", ()=>(0, _badgeHdDefault.default));
parcelHelpers.export(exports, "BadgeSdFill", ()=>(0, _badgeSdFillDefault.default));
parcelHelpers.export(exports, "BadgeSd", ()=>(0, _badgeSdDefault.default));
parcelHelpers.export(exports, "BadgeTmFill", ()=>(0, _badgeTmFillDefault.default));
parcelHelpers.export(exports, "BadgeTm", ()=>(0, _badgeTmDefault.default));
parcelHelpers.export(exports, "BadgeVoFill", ()=>(0, _badgeVoFillDefault.default));
parcelHelpers.export(exports, "BadgeVo", ()=>(0, _badgeVoDefault.default));
parcelHelpers.export(exports, "BadgeVrFill", ()=>(0, _badgeVrFillDefault.default));
parcelHelpers.export(exports, "BadgeVr", ()=>(0, _badgeVrDefault.default));
parcelHelpers.export(exports, "BadgeWcFill", ()=>(0, _badgeWcFillDefault.default));
parcelHelpers.export(exports, "BadgeWc", ()=>(0, _badgeWcDefault.default));
parcelHelpers.export(exports, "BagCheckFill", ()=>(0, _bagCheckFillDefault.default));
parcelHelpers.export(exports, "BagCheck", ()=>(0, _bagCheckDefault.default));
parcelHelpers.export(exports, "BagDashFill", ()=>(0, _bagDashFillDefault.default));
parcelHelpers.export(exports, "BagDash", ()=>(0, _bagDashDefault.default));
parcelHelpers.export(exports, "BagFill", ()=>(0, _bagFillDefault.default));
parcelHelpers.export(exports, "BagHeartFill", ()=>(0, _bagHeartFillDefault.default));
parcelHelpers.export(exports, "BagHeart", ()=>(0, _bagHeartDefault.default));
parcelHelpers.export(exports, "BagPlusFill", ()=>(0, _bagPlusFillDefault.default));
parcelHelpers.export(exports, "BagPlus", ()=>(0, _bagPlusDefault.default));
parcelHelpers.export(exports, "BagXFill", ()=>(0, _bagXFillDefault.default));
parcelHelpers.export(exports, "BagX", ()=>(0, _bagXDefault.default));
parcelHelpers.export(exports, "Bag", ()=>(0, _bagDefault.default));
parcelHelpers.export(exports, "BalloonFill", ()=>(0, _balloonFillDefault.default));
parcelHelpers.export(exports, "BalloonHeartFill", ()=>(0, _balloonHeartFillDefault.default));
parcelHelpers.export(exports, "BalloonHeart", ()=>(0, _balloonHeartDefault.default));
parcelHelpers.export(exports, "Balloon", ()=>(0, _balloonDefault.default));
parcelHelpers.export(exports, "BanFill", ()=>(0, _banFillDefault.default));
parcelHelpers.export(exports, "Ban", ()=>(0, _banDefault.default));
parcelHelpers.export(exports, "BandaidFill", ()=>(0, _bandaidFillDefault.default));
parcelHelpers.export(exports, "Bandaid", ()=>(0, _bandaidDefault.default));
parcelHelpers.export(exports, "Bank", ()=>(0, _bankDefault.default));
parcelHelpers.export(exports, "Bank2", ()=>(0, _bank2Default.default));
parcelHelpers.export(exports, "BarChartFill", ()=>(0, _barChartFillDefault.default));
parcelHelpers.export(exports, "BarChartLineFill", ()=>(0, _barChartLineFillDefault.default));
parcelHelpers.export(exports, "BarChartLine", ()=>(0, _barChartLineDefault.default));
parcelHelpers.export(exports, "BarChartSteps", ()=>(0, _barChartStepsDefault.default));
parcelHelpers.export(exports, "BarChart", ()=>(0, _barChartDefault.default));
parcelHelpers.export(exports, "BasketFill", ()=>(0, _basketFillDefault.default));
parcelHelpers.export(exports, "Basket", ()=>(0, _basketDefault.default));
parcelHelpers.export(exports, "Basket2Fill", ()=>(0, _basket2FillDefault.default));
parcelHelpers.export(exports, "Basket2", ()=>(0, _basket2Default.default));
parcelHelpers.export(exports, "Basket3Fill", ()=>(0, _basket3FillDefault.default));
parcelHelpers.export(exports, "Basket3", ()=>(0, _basket3Default.default));
parcelHelpers.export(exports, "BatteryCharging", ()=>(0, _batteryChargingDefault.default));
parcelHelpers.export(exports, "BatteryFull", ()=>(0, _batteryFullDefault.default));
parcelHelpers.export(exports, "BatteryHalf", ()=>(0, _batteryHalfDefault.default));
parcelHelpers.export(exports, "Battery", ()=>(0, _batteryDefault.default));
parcelHelpers.export(exports, "Behance", ()=>(0, _behanceDefault.default));
parcelHelpers.export(exports, "BellFill", ()=>(0, _bellFillDefault.default));
parcelHelpers.export(exports, "BellSlashFill", ()=>(0, _bellSlashFillDefault.default));
parcelHelpers.export(exports, "BellSlash", ()=>(0, _bellSlashDefault.default));
parcelHelpers.export(exports, "Bell", ()=>(0, _bellDefault.default));
parcelHelpers.export(exports, "Bezier", ()=>(0, _bezierDefault.default));
parcelHelpers.export(exports, "Bezier2", ()=>(0, _bezier2Default.default));
parcelHelpers.export(exports, "Bicycle", ()=>(0, _bicycleDefault.default));
parcelHelpers.export(exports, "Bing", ()=>(0, _bingDefault.default));
parcelHelpers.export(exports, "BinocularsFill", ()=>(0, _binocularsFillDefault.default));
parcelHelpers.export(exports, "Binoculars", ()=>(0, _binocularsDefault.default));
parcelHelpers.export(exports, "BlockquoteLeft", ()=>(0, _blockquoteLeftDefault.default));
parcelHelpers.export(exports, "BlockquoteRight", ()=>(0, _blockquoteRightDefault.default));
parcelHelpers.export(exports, "Bluetooth", ()=>(0, _bluetoothDefault.default));
parcelHelpers.export(exports, "BodyText", ()=>(0, _bodyTextDefault.default));
parcelHelpers.export(exports, "BookFill", ()=>(0, _bookFillDefault.default));
parcelHelpers.export(exports, "BookHalf", ()=>(0, _bookHalfDefault.default));
parcelHelpers.export(exports, "Book", ()=>(0, _bookDefault.default));
parcelHelpers.export(exports, "BookmarkCheckFill", ()=>(0, _bookmarkCheckFillDefault.default));
parcelHelpers.export(exports, "BookmarkCheck", ()=>(0, _bookmarkCheckDefault.default));
parcelHelpers.export(exports, "BookmarkDashFill", ()=>(0, _bookmarkDashFillDefault.default));
parcelHelpers.export(exports, "BookmarkDash", ()=>(0, _bookmarkDashDefault.default));
parcelHelpers.export(exports, "BookmarkFill", ()=>(0, _bookmarkFillDefault.default));
parcelHelpers.export(exports, "BookmarkHeartFill", ()=>(0, _bookmarkHeartFillDefault.default));
parcelHelpers.export(exports, "BookmarkHeart", ()=>(0, _bookmarkHeartDefault.default));
parcelHelpers.export(exports, "BookmarkPlusFill", ()=>(0, _bookmarkPlusFillDefault.default));
parcelHelpers.export(exports, "BookmarkPlus", ()=>(0, _bookmarkPlusDefault.default));
parcelHelpers.export(exports, "BookmarkStarFill", ()=>(0, _bookmarkStarFillDefault.default));
parcelHelpers.export(exports, "BookmarkStar", ()=>(0, _bookmarkStarDefault.default));
parcelHelpers.export(exports, "BookmarkXFill", ()=>(0, _bookmarkXFillDefault.default));
parcelHelpers.export(exports, "BookmarkX", ()=>(0, _bookmarkXDefault.default));
parcelHelpers.export(exports, "Bookmark", ()=>(0, _bookmarkDefault.default));
parcelHelpers.export(exports, "BookmarksFill", ()=>(0, _bookmarksFillDefault.default));
parcelHelpers.export(exports, "Bookmarks", ()=>(0, _bookmarksDefault.default));
parcelHelpers.export(exports, "Bookshelf", ()=>(0, _bookshelfDefault.default));
parcelHelpers.export(exports, "BoomboxFill", ()=>(0, _boomboxFillDefault.default));
parcelHelpers.export(exports, "Boombox", ()=>(0, _boomboxDefault.default));
parcelHelpers.export(exports, "BootstrapFill", ()=>(0, _bootstrapFillDefault.default));
parcelHelpers.export(exports, "BootstrapReboot", ()=>(0, _bootstrapRebootDefault.default));
parcelHelpers.export(exports, "Bootstrap", ()=>(0, _bootstrapDefault.default));
parcelHelpers.export(exports, "BorderAll", ()=>(0, _borderAllDefault.default));
parcelHelpers.export(exports, "BorderBottom", ()=>(0, _borderBottomDefault.default));
parcelHelpers.export(exports, "BorderCenter", ()=>(0, _borderCenterDefault.default));
parcelHelpers.export(exports, "BorderInner", ()=>(0, _borderInnerDefault.default));
parcelHelpers.export(exports, "BorderLeft", ()=>(0, _borderLeftDefault.default));
parcelHelpers.export(exports, "BorderMiddle", ()=>(0, _borderMiddleDefault.default));
parcelHelpers.export(exports, "BorderOuter", ()=>(0, _borderOuterDefault.default));
parcelHelpers.export(exports, "BorderRight", ()=>(0, _borderRightDefault.default));
parcelHelpers.export(exports, "BorderStyle", ()=>(0, _borderStyleDefault.default));
parcelHelpers.export(exports, "BorderTop", ()=>(0, _borderTopDefault.default));
parcelHelpers.export(exports, "BorderWidth", ()=>(0, _borderWidthDefault.default));
parcelHelpers.export(exports, "Border", ()=>(0, _borderDefault.default));
parcelHelpers.export(exports, "BoundingBoxCircles", ()=>(0, _boundingBoxCirclesDefault.default));
parcelHelpers.export(exports, "BoundingBox", ()=>(0, _boundingBoxDefault.default));
parcelHelpers.export(exports, "BoxArrowDownLeft", ()=>(0, _boxArrowDownLeftDefault.default));
parcelHelpers.export(exports, "BoxArrowDownRight", ()=>(0, _boxArrowDownRightDefault.default));
parcelHelpers.export(exports, "BoxArrowDown", ()=>(0, _boxArrowDownDefault.default));
parcelHelpers.export(exports, "BoxArrowInDownLeft", ()=>(0, _boxArrowInDownLeftDefault.default));
parcelHelpers.export(exports, "BoxArrowInDownRight", ()=>(0, _boxArrowInDownRightDefault.default));
parcelHelpers.export(exports, "BoxArrowInDown", ()=>(0, _boxArrowInDownDefault.default));
parcelHelpers.export(exports, "BoxArrowInLeft", ()=>(0, _boxArrowInLeftDefault.default));
parcelHelpers.export(exports, "BoxArrowInRight", ()=>(0, _boxArrowInRightDefault.default));
parcelHelpers.export(exports, "BoxArrowInUpLeft", ()=>(0, _boxArrowInUpLeftDefault.default));
parcelHelpers.export(exports, "BoxArrowInUpRight", ()=>(0, _boxArrowInUpRightDefault.default));
parcelHelpers.export(exports, "BoxArrowInUp", ()=>(0, _boxArrowInUpDefault.default));
parcelHelpers.export(exports, "BoxArrowLeft", ()=>(0, _boxArrowLeftDefault.default));
parcelHelpers.export(exports, "BoxArrowRight", ()=>(0, _boxArrowRightDefault.default));
parcelHelpers.export(exports, "BoxArrowUpLeft", ()=>(0, _boxArrowUpLeftDefault.default));
parcelHelpers.export(exports, "BoxArrowUpRight", ()=>(0, _boxArrowUpRightDefault.default));
parcelHelpers.export(exports, "BoxArrowUp", ()=>(0, _boxArrowUpDefault.default));
parcelHelpers.export(exports, "BoxFill", ()=>(0, _boxFillDefault.default));
parcelHelpers.export(exports, "BoxSeamFill", ()=>(0, _boxSeamFillDefault.default));
parcelHelpers.export(exports, "BoxSeam", ()=>(0, _boxSeamDefault.default));
parcelHelpers.export(exports, "Box", ()=>(0, _boxDefault.default));
parcelHelpers.export(exports, "Box2Fill", ()=>(0, _box2FillDefault.default));
parcelHelpers.export(exports, "Box2HeartFill", ()=>(0, _box2HeartFillDefault.default));
parcelHelpers.export(exports, "Box2Heart", ()=>(0, _box2HeartDefault.default));
parcelHelpers.export(exports, "Box2", ()=>(0, _box2Default.default));
parcelHelpers.export(exports, "Boxes", ()=>(0, _boxesDefault.default));
parcelHelpers.export(exports, "BracesAsterisk", ()=>(0, _bracesAsteriskDefault.default));
parcelHelpers.export(exports, "Braces", ()=>(0, _bracesDefault.default));
parcelHelpers.export(exports, "Bricks", ()=>(0, _bricksDefault.default));
parcelHelpers.export(exports, "BriefcaseFill", ()=>(0, _briefcaseFillDefault.default));
parcelHelpers.export(exports, "Briefcase", ()=>(0, _briefcaseDefault.default));
parcelHelpers.export(exports, "BrightnessAltHighFill", ()=>(0, _brightnessAltHighFillDefault.default));
parcelHelpers.export(exports, "BrightnessAltHigh", ()=>(0, _brightnessAltHighDefault.default));
parcelHelpers.export(exports, "BrightnessAltLowFill", ()=>(0, _brightnessAltLowFillDefault.default));
parcelHelpers.export(exports, "BrightnessAltLow", ()=>(0, _brightnessAltLowDefault.default));
parcelHelpers.export(exports, "BrightnessHighFill", ()=>(0, _brightnessHighFillDefault.default));
parcelHelpers.export(exports, "BrightnessHigh", ()=>(0, _brightnessHighDefault.default));
parcelHelpers.export(exports, "BrightnessLowFill", ()=>(0, _brightnessLowFillDefault.default));
parcelHelpers.export(exports, "BrightnessLow", ()=>(0, _brightnessLowDefault.default));
parcelHelpers.export(exports, "Brilliance", ()=>(0, _brillianceDefault.default));
parcelHelpers.export(exports, "BroadcastPin", ()=>(0, _broadcastPinDefault.default));
parcelHelpers.export(exports, "Broadcast", ()=>(0, _broadcastDefault.default));
parcelHelpers.export(exports, "BrowserChrome", ()=>(0, _browserChromeDefault.default));
parcelHelpers.export(exports, "BrowserEdge", ()=>(0, _browserEdgeDefault.default));
parcelHelpers.export(exports, "BrowserFirefox", ()=>(0, _browserFirefoxDefault.default));
parcelHelpers.export(exports, "BrowserSafari", ()=>(0, _browserSafariDefault.default));
parcelHelpers.export(exports, "BrushFill", ()=>(0, _brushFillDefault.default));
parcelHelpers.export(exports, "Brush", ()=>(0, _brushDefault.default));
parcelHelpers.export(exports, "BucketFill", ()=>(0, _bucketFillDefault.default));
parcelHelpers.export(exports, "Bucket", ()=>(0, _bucketDefault.default));
parcelHelpers.export(exports, "BugFill", ()=>(0, _bugFillDefault.default));
parcelHelpers.export(exports, "Bug", ()=>(0, _bugDefault.default));
parcelHelpers.export(exports, "BuildingAdd", ()=>(0, _buildingAddDefault.default));
parcelHelpers.export(exports, "BuildingCheck", ()=>(0, _buildingCheckDefault.default));
parcelHelpers.export(exports, "BuildingDash", ()=>(0, _buildingDashDefault.default));
parcelHelpers.export(exports, "BuildingDown", ()=>(0, _buildingDownDefault.default));
parcelHelpers.export(exports, "BuildingExclamation", ()=>(0, _buildingExclamationDefault.default));
parcelHelpers.export(exports, "BuildingFillAdd", ()=>(0, _buildingFillAddDefault.default));
parcelHelpers.export(exports, "BuildingFillCheck", ()=>(0, _buildingFillCheckDefault.default));
parcelHelpers.export(exports, "BuildingFillDash", ()=>(0, _buildingFillDashDefault.default));
parcelHelpers.export(exports, "BuildingFillDown", ()=>(0, _buildingFillDownDefault.default));
parcelHelpers.export(exports, "BuildingFillExclamation", ()=>(0, _buildingFillExclamationDefault.default));
parcelHelpers.export(exports, "BuildingFillGear", ()=>(0, _buildingFillGearDefault.default));
parcelHelpers.export(exports, "BuildingFillLock", ()=>(0, _buildingFillLockDefault.default));
parcelHelpers.export(exports, "BuildingFillSlash", ()=>(0, _buildingFillSlashDefault.default));
parcelHelpers.export(exports, "BuildingFillUp", ()=>(0, _buildingFillUpDefault.default));
parcelHelpers.export(exports, "BuildingFillX", ()=>(0, _buildingFillXDefault.default));
parcelHelpers.export(exports, "BuildingFill", ()=>(0, _buildingFillDefault.default));
parcelHelpers.export(exports, "BuildingGear", ()=>(0, _buildingGearDefault.default));
parcelHelpers.export(exports, "BuildingLock", ()=>(0, _buildingLockDefault.default));
parcelHelpers.export(exports, "BuildingSlash", ()=>(0, _buildingSlashDefault.default));
parcelHelpers.export(exports, "BuildingUp", ()=>(0, _buildingUpDefault.default));
parcelHelpers.export(exports, "BuildingX", ()=>(0, _buildingXDefault.default));
parcelHelpers.export(exports, "Building", ()=>(0, _buildingDefault.default));
parcelHelpers.export(exports, "BuildingsFill", ()=>(0, _buildingsFillDefault.default));
parcelHelpers.export(exports, "Buildings", ()=>(0, _buildingsDefault.default));
parcelHelpers.export(exports, "Bullseye", ()=>(0, _bullseyeDefault.default));
parcelHelpers.export(exports, "BusFrontFill", ()=>(0, _busFrontFillDefault.default));
parcelHelpers.export(exports, "BusFront", ()=>(0, _busFrontDefault.default));
parcelHelpers.export(exports, "CCircleFill", ()=>(0, _cCircleFillDefault.default));
parcelHelpers.export(exports, "CCircle", ()=>(0, _cCircleDefault.default));
parcelHelpers.export(exports, "CSquareFill", ()=>(0, _cSquareFillDefault.default));
parcelHelpers.export(exports, "CSquare", ()=>(0, _cSquareDefault.default));
parcelHelpers.export(exports, "CakeFill", ()=>(0, _cakeFillDefault.default));
parcelHelpers.export(exports, "Cake", ()=>(0, _cakeDefault.default));
parcelHelpers.export(exports, "Cake2Fill", ()=>(0, _cake2FillDefault.default));
parcelHelpers.export(exports, "Cake2", ()=>(0, _cake2Default.default));
parcelHelpers.export(exports, "CalculatorFill", ()=>(0, _calculatorFillDefault.default));
parcelHelpers.export(exports, "Calculator", ()=>(0, _calculatorDefault.default));
parcelHelpers.export(exports, "CalendarCheckFill", ()=>(0, _calendarCheckFillDefault.default));
parcelHelpers.export(exports, "CalendarCheck", ()=>(0, _calendarCheckDefault.default));
parcelHelpers.export(exports, "CalendarDateFill", ()=>(0, _calendarDateFillDefault.default));
parcelHelpers.export(exports, "CalendarDate", ()=>(0, _calendarDateDefault.default));
parcelHelpers.export(exports, "CalendarDayFill", ()=>(0, _calendarDayFillDefault.default));
parcelHelpers.export(exports, "CalendarDay", ()=>(0, _calendarDayDefault.default));
parcelHelpers.export(exports, "CalendarEventFill", ()=>(0, _calendarEventFillDefault.default));
parcelHelpers.export(exports, "CalendarEvent", ()=>(0, _calendarEventDefault.default));
parcelHelpers.export(exports, "CalendarFill", ()=>(0, _calendarFillDefault.default));
parcelHelpers.export(exports, "CalendarHeartFill", ()=>(0, _calendarHeartFillDefault.default));
parcelHelpers.export(exports, "CalendarHeart", ()=>(0, _calendarHeartDefault.default));
parcelHelpers.export(exports, "CalendarMinusFill", ()=>(0, _calendarMinusFillDefault.default));
parcelHelpers.export(exports, "CalendarMinus", ()=>(0, _calendarMinusDefault.default));
parcelHelpers.export(exports, "CalendarMonthFill", ()=>(0, _calendarMonthFillDefault.default));
parcelHelpers.export(exports, "CalendarMonth", ()=>(0, _calendarMonthDefault.default));
parcelHelpers.export(exports, "CalendarPlusFill", ()=>(0, _calendarPlusFillDefault.default));
parcelHelpers.export(exports, "CalendarPlus", ()=>(0, _calendarPlusDefault.default));
parcelHelpers.export(exports, "CalendarRangeFill", ()=>(0, _calendarRangeFillDefault.default));
parcelHelpers.export(exports, "CalendarRange", ()=>(0, _calendarRangeDefault.default));
parcelHelpers.export(exports, "CalendarWeekFill", ()=>(0, _calendarWeekFillDefault.default));
parcelHelpers.export(exports, "CalendarWeek", ()=>(0, _calendarWeekDefault.default));
parcelHelpers.export(exports, "CalendarXFill", ()=>(0, _calendarXFillDefault.default));
parcelHelpers.export(exports, "CalendarX", ()=>(0, _calendarXDefault.default));
parcelHelpers.export(exports, "Calendar", ()=>(0, _calendarDefault.default));
parcelHelpers.export(exports, "Calendar2CheckFill", ()=>(0, _calendar2CheckFillDefault.default));
parcelHelpers.export(exports, "Calendar2Check", ()=>(0, _calendar2CheckDefault.default));
parcelHelpers.export(exports, "Calendar2DateFill", ()=>(0, _calendar2DateFillDefault.default));
parcelHelpers.export(exports, "Calendar2Date", ()=>(0, _calendar2DateDefault.default));
parcelHelpers.export(exports, "Calendar2DayFill", ()=>(0, _calendar2DayFillDefault.default));
parcelHelpers.export(exports, "Calendar2Day", ()=>(0, _calendar2DayDefault.default));
parcelHelpers.export(exports, "Calendar2EventFill", ()=>(0, _calendar2EventFillDefault.default));
parcelHelpers.export(exports, "Calendar2Event", ()=>(0, _calendar2EventDefault.default));
parcelHelpers.export(exports, "Calendar2Fill", ()=>(0, _calendar2FillDefault.default));
parcelHelpers.export(exports, "Calendar2HeartFill", ()=>(0, _calendar2HeartFillDefault.default));
parcelHelpers.export(exports, "Calendar2Heart", ()=>(0, _calendar2HeartDefault.default));
parcelHelpers.export(exports, "Calendar2MinusFill", ()=>(0, _calendar2MinusFillDefault.default));
parcelHelpers.export(exports, "Calendar2Minus", ()=>(0, _calendar2MinusDefault.default));
parcelHelpers.export(exports, "Calendar2MonthFill", ()=>(0, _calendar2MonthFillDefault.default));
parcelHelpers.export(exports, "Calendar2Month", ()=>(0, _calendar2MonthDefault.default));
parcelHelpers.export(exports, "Calendar2PlusFill", ()=>(0, _calendar2PlusFillDefault.default));
parcelHelpers.export(exports, "Calendar2Plus", ()=>(0, _calendar2PlusDefault.default));
parcelHelpers.export(exports, "Calendar2RangeFill", ()=>(0, _calendar2RangeFillDefault.default));
parcelHelpers.export(exports, "Calendar2Range", ()=>(0, _calendar2RangeDefault.default));
parcelHelpers.export(exports, "Calendar2WeekFill", ()=>(0, _calendar2WeekFillDefault.default));
parcelHelpers.export(exports, "Calendar2Week", ()=>(0, _calendar2WeekDefault.default));
parcelHelpers.export(exports, "Calendar2XFill", ()=>(0, _calendar2XFillDefault.default));
parcelHelpers.export(exports, "Calendar2X", ()=>(0, _calendar2XDefault.default));
parcelHelpers.export(exports, "Calendar2", ()=>(0, _calendar2Default.default));
parcelHelpers.export(exports, "Calendar3EventFill", ()=>(0, _calendar3EventFillDefault.default));
parcelHelpers.export(exports, "Calendar3Event", ()=>(0, _calendar3EventDefault.default));
parcelHelpers.export(exports, "Calendar3Fill", ()=>(0, _calendar3FillDefault.default));
parcelHelpers.export(exports, "Calendar3RangeFill", ()=>(0, _calendar3RangeFillDefault.default));
parcelHelpers.export(exports, "Calendar3Range", ()=>(0, _calendar3RangeDefault.default));
parcelHelpers.export(exports, "Calendar3WeekFill", ()=>(0, _calendar3WeekFillDefault.default));
parcelHelpers.export(exports, "Calendar3Week", ()=>(0, _calendar3WeekDefault.default));
parcelHelpers.export(exports, "Calendar3", ()=>(0, _calendar3Default.default));
parcelHelpers.export(exports, "Calendar4Event", ()=>(0, _calendar4EventDefault.default));
parcelHelpers.export(exports, "Calendar4Range", ()=>(0, _calendar4RangeDefault.default));
parcelHelpers.export(exports, "Calendar4Week", ()=>(0, _calendar4WeekDefault.default));
parcelHelpers.export(exports, "Calendar4", ()=>(0, _calendar4Default.default));
parcelHelpers.export(exports, "CameraFill", ()=>(0, _cameraFillDefault.default));
parcelHelpers.export(exports, "CameraReelsFill", ()=>(0, _cameraReelsFillDefault.default));
parcelHelpers.export(exports, "CameraReels", ()=>(0, _cameraReelsDefault.default));
parcelHelpers.export(exports, "CameraVideoFill", ()=>(0, _cameraVideoFillDefault.default));
parcelHelpers.export(exports, "CameraVideoOffFill", ()=>(0, _cameraVideoOffFillDefault.default));
parcelHelpers.export(exports, "CameraVideoOff", ()=>(0, _cameraVideoOffDefault.default));
parcelHelpers.export(exports, "CameraVideo", ()=>(0, _cameraVideoDefault.default));
parcelHelpers.export(exports, "Camera", ()=>(0, _cameraDefault.default));
parcelHelpers.export(exports, "Camera2", ()=>(0, _camera2Default.default));
parcelHelpers.export(exports, "CapslockFill", ()=>(0, _capslockFillDefault.default));
parcelHelpers.export(exports, "Capslock", ()=>(0, _capslockDefault.default));
parcelHelpers.export(exports, "CapsulePill", ()=>(0, _capsulePillDefault.default));
parcelHelpers.export(exports, "Capsule", ()=>(0, _capsuleDefault.default));
parcelHelpers.export(exports, "CarFrontFill", ()=>(0, _carFrontFillDefault.default));
parcelHelpers.export(exports, "CarFront", ()=>(0, _carFrontDefault.default));
parcelHelpers.export(exports, "CardChecklist", ()=>(0, _cardChecklistDefault.default));
parcelHelpers.export(exports, "CardHeading", ()=>(0, _cardHeadingDefault.default));
parcelHelpers.export(exports, "CardImage", ()=>(0, _cardImageDefault.default));
parcelHelpers.export(exports, "CardList", ()=>(0, _cardListDefault.default));
parcelHelpers.export(exports, "CardText", ()=>(0, _cardTextDefault.default));
parcelHelpers.export(exports, "CaretDownFill", ()=>(0, _caretDownFillDefault.default));
parcelHelpers.export(exports, "CaretDownSquareFill", ()=>(0, _caretDownSquareFillDefault.default));
parcelHelpers.export(exports, "CaretDownSquare", ()=>(0, _caretDownSquareDefault.default));
parcelHelpers.export(exports, "CaretDown", ()=>(0, _caretDownDefault.default));
parcelHelpers.export(exports, "CaretLeftFill", ()=>(0, _caretLeftFillDefault.default));
parcelHelpers.export(exports, "CaretLeftSquareFill", ()=>(0, _caretLeftSquareFillDefault.default));
parcelHelpers.export(exports, "CaretLeftSquare", ()=>(0, _caretLeftSquareDefault.default));
parcelHelpers.export(exports, "CaretLeft", ()=>(0, _caretLeftDefault.default));
parcelHelpers.export(exports, "CaretRightFill", ()=>(0, _caretRightFillDefault.default));
parcelHelpers.export(exports, "CaretRightSquareFill", ()=>(0, _caretRightSquareFillDefault.default));
parcelHelpers.export(exports, "CaretRightSquare", ()=>(0, _caretRightSquareDefault.default));
parcelHelpers.export(exports, "CaretRight", ()=>(0, _caretRightDefault.default));
parcelHelpers.export(exports, "CaretUpFill", ()=>(0, _caretUpFillDefault.default));
parcelHelpers.export(exports, "CaretUpSquareFill", ()=>(0, _caretUpSquareFillDefault.default));
parcelHelpers.export(exports, "CaretUpSquare", ()=>(0, _caretUpSquareDefault.default));
parcelHelpers.export(exports, "CaretUp", ()=>(0, _caretUpDefault.default));
parcelHelpers.export(exports, "CartCheckFill", ()=>(0, _cartCheckFillDefault.default));
parcelHelpers.export(exports, "CartCheck", ()=>(0, _cartCheckDefault.default));
parcelHelpers.export(exports, "CartDashFill", ()=>(0, _cartDashFillDefault.default));
parcelHelpers.export(exports, "CartDash", ()=>(0, _cartDashDefault.default));
parcelHelpers.export(exports, "CartFill", ()=>(0, _cartFillDefault.default));
parcelHelpers.export(exports, "CartPlusFill", ()=>(0, _cartPlusFillDefault.default));
parcelHelpers.export(exports, "CartPlus", ()=>(0, _cartPlusDefault.default));
parcelHelpers.export(exports, "CartXFill", ()=>(0, _cartXFillDefault.default));
parcelHelpers.export(exports, "CartX", ()=>(0, _cartXDefault.default));
parcelHelpers.export(exports, "Cart", ()=>(0, _cartDefault.default));
parcelHelpers.export(exports, "Cart2", ()=>(0, _cart2Default.default));
parcelHelpers.export(exports, "Cart3", ()=>(0, _cart3Default.default));
parcelHelpers.export(exports, "Cart4", ()=>(0, _cart4Default.default));
parcelHelpers.export(exports, "CashCoin", ()=>(0, _cashCoinDefault.default));
parcelHelpers.export(exports, "CashStack", ()=>(0, _cashStackDefault.default));
parcelHelpers.export(exports, "Cash", ()=>(0, _cashDefault.default));
parcelHelpers.export(exports, "CassetteFill", ()=>(0, _cassetteFillDefault.default));
parcelHelpers.export(exports, "Cassette", ()=>(0, _cassetteDefault.default));
parcelHelpers.export(exports, "Cast", ()=>(0, _castDefault.default));
parcelHelpers.export(exports, "CcCircleFill", ()=>(0, _ccCircleFillDefault.default));
parcelHelpers.export(exports, "CcCircle", ()=>(0, _ccCircleDefault.default));
parcelHelpers.export(exports, "CcSquareFill", ()=>(0, _ccSquareFillDefault.default));
parcelHelpers.export(exports, "CcSquare", ()=>(0, _ccSquareDefault.default));
parcelHelpers.export(exports, "ChatDotsFill", ()=>(0, _chatDotsFillDefault.default));
parcelHelpers.export(exports, "ChatDots", ()=>(0, _chatDotsDefault.default));
parcelHelpers.export(exports, "ChatFill", ()=>(0, _chatFillDefault.default));
parcelHelpers.export(exports, "ChatHeartFill", ()=>(0, _chatHeartFillDefault.default));
parcelHelpers.export(exports, "ChatHeart", ()=>(0, _chatHeartDefault.default));
parcelHelpers.export(exports, "ChatLeftDotsFill", ()=>(0, _chatLeftDotsFillDefault.default));
parcelHelpers.export(exports, "ChatLeftDots", ()=>(0, _chatLeftDotsDefault.default));
parcelHelpers.export(exports, "ChatLeftFill", ()=>(0, _chatLeftFillDefault.default));
parcelHelpers.export(exports, "ChatLeftHeartFill", ()=>(0, _chatLeftHeartFillDefault.default));
parcelHelpers.export(exports, "ChatLeftHeart", ()=>(0, _chatLeftHeartDefault.default));
parcelHelpers.export(exports, "ChatLeftQuoteFill", ()=>(0, _chatLeftQuoteFillDefault.default));
parcelHelpers.export(exports, "ChatLeftQuote", ()=>(0, _chatLeftQuoteDefault.default));
parcelHelpers.export(exports, "ChatLeftTextFill", ()=>(0, _chatLeftTextFillDefault.default));
parcelHelpers.export(exports, "ChatLeftText", ()=>(0, _chatLeftTextDefault.default));
parcelHelpers.export(exports, "ChatLeft", ()=>(0, _chatLeftDefault.default));
parcelHelpers.export(exports, "ChatQuoteFill", ()=>(0, _chatQuoteFillDefault.default));
parcelHelpers.export(exports, "ChatQuote", ()=>(0, _chatQuoteDefault.default));
parcelHelpers.export(exports, "ChatRightDotsFill", ()=>(0, _chatRightDotsFillDefault.default));
parcelHelpers.export(exports, "ChatRightDots", ()=>(0, _chatRightDotsDefault.default));
parcelHelpers.export(exports, "ChatRightFill", ()=>(0, _chatRightFillDefault.default));
parcelHelpers.export(exports, "ChatRightHeartFill", ()=>(0, _chatRightHeartFillDefault.default));
parcelHelpers.export(exports, "ChatRightHeart", ()=>(0, _chatRightHeartDefault.default));
parcelHelpers.export(exports, "ChatRightQuoteFill", ()=>(0, _chatRightQuoteFillDefault.default));
parcelHelpers.export(exports, "ChatRightQuote", ()=>(0, _chatRightQuoteDefault.default));
parcelHelpers.export(exports, "ChatRightTextFill", ()=>(0, _chatRightTextFillDefault.default));
parcelHelpers.export(exports, "ChatRightText", ()=>(0, _chatRightTextDefault.default));
parcelHelpers.export(exports, "ChatRight", ()=>(0, _chatRightDefault.default));
parcelHelpers.export(exports, "ChatSquareDotsFill", ()=>(0, _chatSquareDotsFillDefault.default));
parcelHelpers.export(exports, "ChatSquareDots", ()=>(0, _chatSquareDotsDefault.default));
parcelHelpers.export(exports, "ChatSquareFill", ()=>(0, _chatSquareFillDefault.default));
parcelHelpers.export(exports, "ChatSquareHeartFill", ()=>(0, _chatSquareHeartFillDefault.default));
parcelHelpers.export(exports, "ChatSquareHeart", ()=>(0, _chatSquareHeartDefault.default));
parcelHelpers.export(exports, "ChatSquareQuoteFill", ()=>(0, _chatSquareQuoteFillDefault.default));
parcelHelpers.export(exports, "ChatSquareQuote", ()=>(0, _chatSquareQuoteDefault.default));
parcelHelpers.export(exports, "ChatSquareTextFill", ()=>(0, _chatSquareTextFillDefault.default));
parcelHelpers.export(exports, "ChatSquareText", ()=>(0, _chatSquareTextDefault.default));
parcelHelpers.export(exports, "ChatSquare", ()=>(0, _chatSquareDefault.default));
parcelHelpers.export(exports, "ChatTextFill", ()=>(0, _chatTextFillDefault.default));
parcelHelpers.export(exports, "ChatText", ()=>(0, _chatTextDefault.default));
parcelHelpers.export(exports, "Chat", ()=>(0, _chatDefault.default));
parcelHelpers.export(exports, "CheckAll", ()=>(0, _checkAllDefault.default));
parcelHelpers.export(exports, "CheckCircleFill", ()=>(0, _checkCircleFillDefault.default));
parcelHelpers.export(exports, "CheckCircle", ()=>(0, _checkCircleDefault.default));
parcelHelpers.export(exports, "CheckLg", ()=>(0, _checkLgDefault.default));
parcelHelpers.export(exports, "CheckSquareFill", ()=>(0, _checkSquareFillDefault.default));
parcelHelpers.export(exports, "CheckSquare", ()=>(0, _checkSquareDefault.default));
parcelHelpers.export(exports, "Check", ()=>(0, _checkDefault.default));
parcelHelpers.export(exports, "Check2All", ()=>(0, _check2AllDefault.default));
parcelHelpers.export(exports, "Check2Circle", ()=>(0, _check2CircleDefault.default));
parcelHelpers.export(exports, "Check2Square", ()=>(0, _check2SquareDefault.default));
parcelHelpers.export(exports, "Check2", ()=>(0, _check2Default.default));
parcelHelpers.export(exports, "ChevronBarContract", ()=>(0, _chevronBarContractDefault.default));
parcelHelpers.export(exports, "ChevronBarDown", ()=>(0, _chevronBarDownDefault.default));
parcelHelpers.export(exports, "ChevronBarExpand", ()=>(0, _chevronBarExpandDefault.default));
parcelHelpers.export(exports, "ChevronBarLeft", ()=>(0, _chevronBarLeftDefault.default));
parcelHelpers.export(exports, "ChevronBarRight", ()=>(0, _chevronBarRightDefault.default));
parcelHelpers.export(exports, "ChevronBarUp", ()=>(0, _chevronBarUpDefault.default));
parcelHelpers.export(exports, "ChevronCompactDown", ()=>(0, _chevronCompactDownDefault.default));
parcelHelpers.export(exports, "ChevronCompactLeft", ()=>(0, _chevronCompactLeftDefault.default));
parcelHelpers.export(exports, "ChevronCompactRight", ()=>(0, _chevronCompactRightDefault.default));
parcelHelpers.export(exports, "ChevronCompactUp", ()=>(0, _chevronCompactUpDefault.default));
parcelHelpers.export(exports, "ChevronContract", ()=>(0, _chevronContractDefault.default));
parcelHelpers.export(exports, "ChevronDoubleDown", ()=>(0, _chevronDoubleDownDefault.default));
parcelHelpers.export(exports, "ChevronDoubleLeft", ()=>(0, _chevronDoubleLeftDefault.default));
parcelHelpers.export(exports, "ChevronDoubleRight", ()=>(0, _chevronDoubleRightDefault.default));
parcelHelpers.export(exports, "ChevronDoubleUp", ()=>(0, _chevronDoubleUpDefault.default));
parcelHelpers.export(exports, "ChevronDown", ()=>(0, _chevronDownDefault.default));
parcelHelpers.export(exports, "ChevronExpand", ()=>(0, _chevronExpandDefault.default));
parcelHelpers.export(exports, "ChevronLeft", ()=>(0, _chevronLeftDefault.default));
parcelHelpers.export(exports, "ChevronRight", ()=>(0, _chevronRightDefault.default));
parcelHelpers.export(exports, "ChevronUp", ()=>(0, _chevronUpDefault.default));
parcelHelpers.export(exports, "CircleFill", ()=>(0, _circleFillDefault.default));
parcelHelpers.export(exports, "CircleHalf", ()=>(0, _circleHalfDefault.default));
parcelHelpers.export(exports, "CircleSquare", ()=>(0, _circleSquareDefault.default));
parcelHelpers.export(exports, "Circle", ()=>(0, _circleDefault.default));
parcelHelpers.export(exports, "ClipboardCheckFill", ()=>(0, _clipboardCheckFillDefault.default));
parcelHelpers.export(exports, "ClipboardCheck", ()=>(0, _clipboardCheckDefault.default));
parcelHelpers.export(exports, "ClipboardDataFill", ()=>(0, _clipboardDataFillDefault.default));
parcelHelpers.export(exports, "ClipboardData", ()=>(0, _clipboardDataDefault.default));
parcelHelpers.export(exports, "ClipboardFill", ()=>(0, _clipboardFillDefault.default));
parcelHelpers.export(exports, "ClipboardHeartFill", ()=>(0, _clipboardHeartFillDefault.default));
parcelHelpers.export(exports, "ClipboardHeart", ()=>(0, _clipboardHeartDefault.default));
parcelHelpers.export(exports, "ClipboardMinusFill", ()=>(0, _clipboardMinusFillDefault.default));
parcelHelpers.export(exports, "ClipboardMinus", ()=>(0, _clipboardMinusDefault.default));
parcelHelpers.export(exports, "ClipboardPlusFill", ()=>(0, _clipboardPlusFillDefault.default));
parcelHelpers.export(exports, "ClipboardPlus", ()=>(0, _clipboardPlusDefault.default));
parcelHelpers.export(exports, "ClipboardPulse", ()=>(0, _clipboardPulseDefault.default));
parcelHelpers.export(exports, "ClipboardXFill", ()=>(0, _clipboardXFillDefault.default));
parcelHelpers.export(exports, "ClipboardX", ()=>(0, _clipboardXDefault.default));
parcelHelpers.export(exports, "Clipboard", ()=>(0, _clipboardDefault.default));
parcelHelpers.export(exports, "Clipboard2CheckFill", ()=>(0, _clipboard2CheckFillDefault.default));
parcelHelpers.export(exports, "Clipboard2Check", ()=>(0, _clipboard2CheckDefault.default));
parcelHelpers.export(exports, "Clipboard2DataFill", ()=>(0, _clipboard2DataFillDefault.default));
parcelHelpers.export(exports, "Clipboard2Data", ()=>(0, _clipboard2DataDefault.default));
parcelHelpers.export(exports, "Clipboard2Fill", ()=>(0, _clipboard2FillDefault.default));
parcelHelpers.export(exports, "Clipboard2HeartFill", ()=>(0, _clipboard2HeartFillDefault.default));
parcelHelpers.export(exports, "Clipboard2Heart", ()=>(0, _clipboard2HeartDefault.default));
parcelHelpers.export(exports, "Clipboard2MinusFill", ()=>(0, _clipboard2MinusFillDefault.default));
parcelHelpers.export(exports, "Clipboard2Minus", ()=>(0, _clipboard2MinusDefault.default));
parcelHelpers.export(exports, "Clipboard2PlusFill", ()=>(0, _clipboard2PlusFillDefault.default));
parcelHelpers.export(exports, "Clipboard2Plus", ()=>(0, _clipboard2PlusDefault.default));
parcelHelpers.export(exports, "Clipboard2PulseFill", ()=>(0, _clipboard2PulseFillDefault.default));
parcelHelpers.export(exports, "Clipboard2Pulse", ()=>(0, _clipboard2PulseDefault.default));
parcelHelpers.export(exports, "Clipboard2XFill", ()=>(0, _clipboard2XFillDefault.default));
parcelHelpers.export(exports, "Clipboard2X", ()=>(0, _clipboard2XDefault.default));
parcelHelpers.export(exports, "Clipboard2", ()=>(0, _clipboard2Default.default));
parcelHelpers.export(exports, "ClockFill", ()=>(0, _clockFillDefault.default));
parcelHelpers.export(exports, "ClockHistory", ()=>(0, _clockHistoryDefault.default));
parcelHelpers.export(exports, "Clock", ()=>(0, _clockDefault.default));
parcelHelpers.export(exports, "CloudArrowDownFill", ()=>(0, _cloudArrowDownFillDefault.default));
parcelHelpers.export(exports, "CloudArrowDown", ()=>(0, _cloudArrowDownDefault.default));
parcelHelpers.export(exports, "CloudArrowUpFill", ()=>(0, _cloudArrowUpFillDefault.default));
parcelHelpers.export(exports, "CloudArrowUp", ()=>(0, _cloudArrowUpDefault.default));
parcelHelpers.export(exports, "CloudCheckFill", ()=>(0, _cloudCheckFillDefault.default));
parcelHelpers.export(exports, "CloudCheck", ()=>(0, _cloudCheckDefault.default));
parcelHelpers.export(exports, "CloudDownloadFill", ()=>(0, _cloudDownloadFillDefault.default));
parcelHelpers.export(exports, "CloudDownload", ()=>(0, _cloudDownloadDefault.default));
parcelHelpers.export(exports, "CloudDrizzleFill", ()=>(0, _cloudDrizzleFillDefault.default));
parcelHelpers.export(exports, "CloudDrizzle", ()=>(0, _cloudDrizzleDefault.default));
parcelHelpers.export(exports, "CloudFill", ()=>(0, _cloudFillDefault.default));
parcelHelpers.export(exports, "CloudFogFill", ()=>(0, _cloudFogFillDefault.default));
parcelHelpers.export(exports, "CloudFog", ()=>(0, _cloudFogDefault.default));
parcelHelpers.export(exports, "CloudFog2Fill", ()=>(0, _cloudFog2FillDefault.default));
parcelHelpers.export(exports, "CloudFog2", ()=>(0, _cloudFog2Default.default));
parcelHelpers.export(exports, "CloudHailFill", ()=>(0, _cloudHailFillDefault.default));
parcelHelpers.export(exports, "CloudHail", ()=>(0, _cloudHailDefault.default));
parcelHelpers.export(exports, "CloudHazeFill", ()=>(0, _cloudHazeFillDefault.default));
parcelHelpers.export(exports, "CloudHaze", ()=>(0, _cloudHazeDefault.default));
parcelHelpers.export(exports, "CloudHaze2Fill", ()=>(0, _cloudHaze2FillDefault.default));
parcelHelpers.export(exports, "CloudHaze2", ()=>(0, _cloudHaze2Default.default));
parcelHelpers.export(exports, "CloudLightningFill", ()=>(0, _cloudLightningFillDefault.default));
parcelHelpers.export(exports, "CloudLightningRainFill", ()=>(0, _cloudLightningRainFillDefault.default));
parcelHelpers.export(exports, "CloudLightningRain", ()=>(0, _cloudLightningRainDefault.default));
parcelHelpers.export(exports, "CloudLightning", ()=>(0, _cloudLightningDefault.default));
parcelHelpers.export(exports, "CloudMinusFill", ()=>(0, _cloudMinusFillDefault.default));
parcelHelpers.export(exports, "CloudMinus", ()=>(0, _cloudMinusDefault.default));
parcelHelpers.export(exports, "CloudMoonFill", ()=>(0, _cloudMoonFillDefault.default));
parcelHelpers.export(exports, "CloudMoon", ()=>(0, _cloudMoonDefault.default));
parcelHelpers.export(exports, "CloudPlusFill", ()=>(0, _cloudPlusFillDefault.default));
parcelHelpers.export(exports, "CloudPlus", ()=>(0, _cloudPlusDefault.default));
parcelHelpers.export(exports, "CloudRainFill", ()=>(0, _cloudRainFillDefault.default));
parcelHelpers.export(exports, "CloudRainHeavyFill", ()=>(0, _cloudRainHeavyFillDefault.default));
parcelHelpers.export(exports, "CloudRainHeavy", ()=>(0, _cloudRainHeavyDefault.default));
parcelHelpers.export(exports, "CloudRain", ()=>(0, _cloudRainDefault.default));
parcelHelpers.export(exports, "CloudSlashFill", ()=>(0, _cloudSlashFillDefault.default));
parcelHelpers.export(exports, "CloudSlash", ()=>(0, _cloudSlashDefault.default));
parcelHelpers.export(exports, "CloudSleetFill", ()=>(0, _cloudSleetFillDefault.default));
parcelHelpers.export(exports, "CloudSleet", ()=>(0, _cloudSleetDefault.default));
parcelHelpers.export(exports, "CloudSnowFill", ()=>(0, _cloudSnowFillDefault.default));
parcelHelpers.export(exports, "CloudSnow", ()=>(0, _cloudSnowDefault.default));
parcelHelpers.export(exports, "CloudSunFill", ()=>(0, _cloudSunFillDefault.default));
parcelHelpers.export(exports, "CloudSun", ()=>(0, _cloudSunDefault.default));
parcelHelpers.export(exports, "CloudUploadFill", ()=>(0, _cloudUploadFillDefault.default));
parcelHelpers.export(exports, "CloudUpload", ()=>(0, _cloudUploadDefault.default));
parcelHelpers.export(exports, "Cloud", ()=>(0, _cloudDefault.default));
parcelHelpers.export(exports, "CloudsFill", ()=>(0, _cloudsFillDefault.default));
parcelHelpers.export(exports, "Clouds", ()=>(0, _cloudsDefault.default));
parcelHelpers.export(exports, "CloudyFill", ()=>(0, _cloudyFillDefault.default));
parcelHelpers.export(exports, "Cloudy", ()=>(0, _cloudyDefault.default));
parcelHelpers.export(exports, "CodeSlash", ()=>(0, _codeSlashDefault.default));
parcelHelpers.export(exports, "CodeSquare", ()=>(0, _codeSquareDefault.default));
parcelHelpers.export(exports, "Code", ()=>(0, _codeDefault.default));
parcelHelpers.export(exports, "Coin", ()=>(0, _coinDefault.default));
parcelHelpers.export(exports, "CollectionFill", ()=>(0, _collectionFillDefault.default));
parcelHelpers.export(exports, "CollectionPlayFill", ()=>(0, _collectionPlayFillDefault.default));
parcelHelpers.export(exports, "CollectionPlay", ()=>(0, _collectionPlayDefault.default));
parcelHelpers.export(exports, "Collection", ()=>(0, _collectionDefault.default));
parcelHelpers.export(exports, "ColumnsGap", ()=>(0, _columnsGapDefault.default));
parcelHelpers.export(exports, "Columns", ()=>(0, _columnsDefault.default));
parcelHelpers.export(exports, "Command", ()=>(0, _commandDefault.default));
parcelHelpers.export(exports, "CompassFill", ()=>(0, _compassFillDefault.default));
parcelHelpers.export(exports, "Compass", ()=>(0, _compassDefault.default));
parcelHelpers.export(exports, "ConeStriped", ()=>(0, _coneStripedDefault.default));
parcelHelpers.export(exports, "Cone", ()=>(0, _coneDefault.default));
parcelHelpers.export(exports, "Controller", ()=>(0, _controllerDefault.default));
parcelHelpers.export(exports, "Cookie", ()=>(0, _cookieDefault.default));
parcelHelpers.export(exports, "Copy", ()=>(0, _copyDefault.default));
parcelHelpers.export(exports, "CpuFill", ()=>(0, _cpuFillDefault.default));
parcelHelpers.export(exports, "Cpu", ()=>(0, _cpuDefault.default));
parcelHelpers.export(exports, "CreditCard2BackFill", ()=>(0, _creditCard2BackFillDefault.default));
parcelHelpers.export(exports, "CreditCard2Back", ()=>(0, _creditCard2BackDefault.default));
parcelHelpers.export(exports, "CreditCard2FrontFill", ()=>(0, _creditCard2FrontFillDefault.default));
parcelHelpers.export(exports, "CreditCard2Front", ()=>(0, _creditCard2FrontDefault.default));
parcelHelpers.export(exports, "CreditCardFill", ()=>(0, _creditCardFillDefault.default));
parcelHelpers.export(exports, "CreditCard", ()=>(0, _creditCardDefault.default));
parcelHelpers.export(exports, "Crop", ()=>(0, _cropDefault.default));
parcelHelpers.export(exports, "Crosshair", ()=>(0, _crosshairDefault.default));
parcelHelpers.export(exports, "Crosshair2", ()=>(0, _crosshair2Default.default));
parcelHelpers.export(exports, "CupFill", ()=>(0, _cupFillDefault.default));
parcelHelpers.export(exports, "CupHotFill", ()=>(0, _cupHotFillDefault.default));
parcelHelpers.export(exports, "CupHot", ()=>(0, _cupHotDefault.default));
parcelHelpers.export(exports, "CupStraw", ()=>(0, _cupStrawDefault.default));
parcelHelpers.export(exports, "Cup", ()=>(0, _cupDefault.default));
parcelHelpers.export(exports, "CurrencyBitcoin", ()=>(0, _currencyBitcoinDefault.default));
parcelHelpers.export(exports, "CurrencyDollar", ()=>(0, _currencyDollarDefault.default));
parcelHelpers.export(exports, "CurrencyEuro", ()=>(0, _currencyEuroDefault.default));
parcelHelpers.export(exports, "CurrencyExchange", ()=>(0, _currencyExchangeDefault.default));
parcelHelpers.export(exports, "CurrencyPound", ()=>(0, _currencyPoundDefault.default));
parcelHelpers.export(exports, "CurrencyRupee", ()=>(0, _currencyRupeeDefault.default));
parcelHelpers.export(exports, "CurrencyYen", ()=>(0, _currencyYenDefault.default));
parcelHelpers.export(exports, "CursorFill", ()=>(0, _cursorFillDefault.default));
parcelHelpers.export(exports, "CursorText", ()=>(0, _cursorTextDefault.default));
parcelHelpers.export(exports, "Cursor", ()=>(0, _cursorDefault.default));
parcelHelpers.export(exports, "DashCircleDotted", ()=>(0, _dashCircleDottedDefault.default));
parcelHelpers.export(exports, "DashCircleFill", ()=>(0, _dashCircleFillDefault.default));
parcelHelpers.export(exports, "DashCircle", ()=>(0, _dashCircleDefault.default));
parcelHelpers.export(exports, "DashLg", ()=>(0, _dashLgDefault.default));
parcelHelpers.export(exports, "DashSquareDotted", ()=>(0, _dashSquareDottedDefault.default));
parcelHelpers.export(exports, "DashSquareFill", ()=>(0, _dashSquareFillDefault.default));
parcelHelpers.export(exports, "DashSquare", ()=>(0, _dashSquareDefault.default));
parcelHelpers.export(exports, "Dash", ()=>(0, _dashDefault.default));
parcelHelpers.export(exports, "DatabaseAdd", ()=>(0, _databaseAddDefault.default));
parcelHelpers.export(exports, "DatabaseCheck", ()=>(0, _databaseCheckDefault.default));
parcelHelpers.export(exports, "DatabaseDash", ()=>(0, _databaseDashDefault.default));
parcelHelpers.export(exports, "DatabaseDown", ()=>(0, _databaseDownDefault.default));
parcelHelpers.export(exports, "DatabaseExclamation", ()=>(0, _databaseExclamationDefault.default));
parcelHelpers.export(exports, "DatabaseFillAdd", ()=>(0, _databaseFillAddDefault.default));
parcelHelpers.export(exports, "DatabaseFillCheck", ()=>(0, _databaseFillCheckDefault.default));
parcelHelpers.export(exports, "DatabaseFillDash", ()=>(0, _databaseFillDashDefault.default));
parcelHelpers.export(exports, "DatabaseFillDown", ()=>(0, _databaseFillDownDefault.default));
parcelHelpers.export(exports, "DatabaseFillExclamation", ()=>(0, _databaseFillExclamationDefault.default));
parcelHelpers.export(exports, "DatabaseFillGear", ()=>(0, _databaseFillGearDefault.default));
parcelHelpers.export(exports, "DatabaseFillLock", ()=>(0, _databaseFillLockDefault.default));
parcelHelpers.export(exports, "DatabaseFillSlash", ()=>(0, _databaseFillSlashDefault.default));
parcelHelpers.export(exports, "DatabaseFillUp", ()=>(0, _databaseFillUpDefault.default));
parcelHelpers.export(exports, "DatabaseFillX", ()=>(0, _databaseFillXDefault.default));
parcelHelpers.export(exports, "DatabaseFill", ()=>(0, _databaseFillDefault.default));
parcelHelpers.export(exports, "DatabaseGear", ()=>(0, _databaseGearDefault.default));
parcelHelpers.export(exports, "DatabaseLock", ()=>(0, _databaseLockDefault.default));
parcelHelpers.export(exports, "DatabaseSlash", ()=>(0, _databaseSlashDefault.default));
parcelHelpers.export(exports, "DatabaseUp", ()=>(0, _databaseUpDefault.default));
parcelHelpers.export(exports, "DatabaseX", ()=>(0, _databaseXDefault.default));
parcelHelpers.export(exports, "Database", ()=>(0, _databaseDefault.default));
parcelHelpers.export(exports, "DeviceHddFill", ()=>(0, _deviceHddFillDefault.default));
parcelHelpers.export(exports, "DeviceHdd", ()=>(0, _deviceHddDefault.default));
parcelHelpers.export(exports, "DeviceSsdFill", ()=>(0, _deviceSsdFillDefault.default));
parcelHelpers.export(exports, "DeviceSsd", ()=>(0, _deviceSsdDefault.default));
parcelHelpers.export(exports, "Diagram2Fill", ()=>(0, _diagram2FillDefault.default));
parcelHelpers.export(exports, "Diagram2", ()=>(0, _diagram2Default.default));
parcelHelpers.export(exports, "Diagram3Fill", ()=>(0, _diagram3FillDefault.default));
parcelHelpers.export(exports, "Diagram3", ()=>(0, _diagram3Default.default));
parcelHelpers.export(exports, "DiamondFill", ()=>(0, _diamondFillDefault.default));
parcelHelpers.export(exports, "DiamondHalf", ()=>(0, _diamondHalfDefault.default));
parcelHelpers.export(exports, "Diamond", ()=>(0, _diamondDefault.default));
parcelHelpers.export(exports, "Dice1Fill", ()=>(0, _dice1FillDefault.default));
parcelHelpers.export(exports, "Dice1", ()=>(0, _dice1Default.default));
parcelHelpers.export(exports, "Dice2Fill", ()=>(0, _dice2FillDefault.default));
parcelHelpers.export(exports, "Dice2", ()=>(0, _dice2Default.default));
parcelHelpers.export(exports, "Dice3Fill", ()=>(0, _dice3FillDefault.default));
parcelHelpers.export(exports, "Dice3", ()=>(0, _dice3Default.default));
parcelHelpers.export(exports, "Dice4Fill", ()=>(0, _dice4FillDefault.default));
parcelHelpers.export(exports, "Dice4", ()=>(0, _dice4Default.default));
parcelHelpers.export(exports, "Dice5Fill", ()=>(0, _dice5FillDefault.default));
parcelHelpers.export(exports, "Dice5", ()=>(0, _dice5Default.default));
parcelHelpers.export(exports, "Dice6Fill", ()=>(0, _dice6FillDefault.default));
parcelHelpers.export(exports, "Dice6", ()=>(0, _dice6Default.default));
parcelHelpers.export(exports, "DiscFill", ()=>(0, _discFillDefault.default));
parcelHelpers.export(exports, "Disc", ()=>(0, _discDefault.default));
parcelHelpers.export(exports, "Discord", ()=>(0, _discordDefault.default));
parcelHelpers.export(exports, "DisplayFill", ()=>(0, _displayFillDefault.default));
parcelHelpers.export(exports, "Display", ()=>(0, _displayDefault.default));
parcelHelpers.export(exports, "DisplayportFill", ()=>(0, _displayportFillDefault.default));
parcelHelpers.export(exports, "Displayport", ()=>(0, _displayportDefault.default));
parcelHelpers.export(exports, "DistributeHorizontal", ()=>(0, _distributeHorizontalDefault.default));
parcelHelpers.export(exports, "DistributeVertical", ()=>(0, _distributeVerticalDefault.default));
parcelHelpers.export(exports, "DoorClosedFill", ()=>(0, _doorClosedFillDefault.default));
parcelHelpers.export(exports, "DoorClosed", ()=>(0, _doorClosedDefault.default));
parcelHelpers.export(exports, "DoorOpenFill", ()=>(0, _doorOpenFillDefault.default));
parcelHelpers.export(exports, "DoorOpen", ()=>(0, _doorOpenDefault.default));
parcelHelpers.export(exports, "Dot", ()=>(0, _dotDefault.default));
parcelHelpers.export(exports, "Download", ()=>(0, _downloadDefault.default));
parcelHelpers.export(exports, "DpadFill", ()=>(0, _dpadFillDefault.default));
parcelHelpers.export(exports, "Dpad", ()=>(0, _dpadDefault.default));
parcelHelpers.export(exports, "Dribbble", ()=>(0, _dribbbleDefault.default));
parcelHelpers.export(exports, "Dropbox", ()=>(0, _dropboxDefault.default));
parcelHelpers.export(exports, "DropletFill", ()=>(0, _dropletFillDefault.default));
parcelHelpers.export(exports, "DropletHalf", ()=>(0, _dropletHalfDefault.default));
parcelHelpers.export(exports, "Droplet", ()=>(0, _dropletDefault.default));
parcelHelpers.export(exports, "DuffleFill", ()=>(0, _duffleFillDefault.default));
parcelHelpers.export(exports, "Duffle", ()=>(0, _duffleDefault.default));
parcelHelpers.export(exports, "EarFill", ()=>(0, _earFillDefault.default));
parcelHelpers.export(exports, "Ear", ()=>(0, _earDefault.default));
parcelHelpers.export(exports, "Earbuds", ()=>(0, _earbudsDefault.default));
parcelHelpers.export(exports, "EaselFill", ()=>(0, _easelFillDefault.default));
parcelHelpers.export(exports, "Easel", ()=>(0, _easelDefault.default));
parcelHelpers.export(exports, "Easel2Fill", ()=>(0, _easel2FillDefault.default));
parcelHelpers.export(exports, "Easel2", ()=>(0, _easel2Default.default));
parcelHelpers.export(exports, "Easel3Fill", ()=>(0, _easel3FillDefault.default));
parcelHelpers.export(exports, "Easel3", ()=>(0, _easel3Default.default));
parcelHelpers.export(exports, "EggFill", ()=>(0, _eggFillDefault.default));
parcelHelpers.export(exports, "EggFried", ()=>(0, _eggFriedDefault.default));
parcelHelpers.export(exports, "Egg", ()=>(0, _eggDefault.default));
parcelHelpers.export(exports, "EjectFill", ()=>(0, _ejectFillDefault.default));
parcelHelpers.export(exports, "Eject", ()=>(0, _ejectDefault.default));
parcelHelpers.export(exports, "EmojiAngryFill", ()=>(0, _emojiAngryFillDefault.default));
parcelHelpers.export(exports, "EmojiAngry", ()=>(0, _emojiAngryDefault.default));
parcelHelpers.export(exports, "EmojiAstonishedFill", ()=>(0, _emojiAstonishedFillDefault.default));
parcelHelpers.export(exports, "EmojiAstonished", ()=>(0, _emojiAstonishedDefault.default));
parcelHelpers.export(exports, "EmojiDizzyFill", ()=>(0, _emojiDizzyFillDefault.default));
parcelHelpers.export(exports, "EmojiDizzy", ()=>(0, _emojiDizzyDefault.default));
parcelHelpers.export(exports, "EmojiExpressionlessFill", ()=>(0, _emojiExpressionlessFillDefault.default));
parcelHelpers.export(exports, "EmojiExpressionless", ()=>(0, _emojiExpressionlessDefault.default));
parcelHelpers.export(exports, "EmojiFrownFill", ()=>(0, _emojiFrownFillDefault.default));
parcelHelpers.export(exports, "EmojiFrown", ()=>(0, _emojiFrownDefault.default));
parcelHelpers.export(exports, "EmojiGrimaceFill", ()=>(0, _emojiGrimaceFillDefault.default));
parcelHelpers.export(exports, "EmojiGrimace", ()=>(0, _emojiGrimaceDefault.default));
parcelHelpers.export(exports, "EmojiGrinFill", ()=>(0, _emojiGrinFillDefault.default));
parcelHelpers.export(exports, "EmojiGrin", ()=>(0, _emojiGrinDefault.default));
parcelHelpers.export(exports, "EmojiHeartEyesFill", ()=>(0, _emojiHeartEyesFillDefault.default));
parcelHelpers.export(exports, "EmojiHeartEyes", ()=>(0, _emojiHeartEyesDefault.default));
parcelHelpers.export(exports, "EmojiKissFill", ()=>(0, _emojiKissFillDefault.default));
parcelHelpers.export(exports, "EmojiKiss", ()=>(0, _emojiKissDefault.default));
parcelHelpers.export(exports, "EmojiLaughingFill", ()=>(0, _emojiLaughingFillDefault.default));
parcelHelpers.export(exports, "EmojiLaughing", ()=>(0, _emojiLaughingDefault.default));
parcelHelpers.export(exports, "EmojiNeutralFill", ()=>(0, _emojiNeutralFillDefault.default));
parcelHelpers.export(exports, "EmojiNeutral", ()=>(0, _emojiNeutralDefault.default));
parcelHelpers.export(exports, "EmojiSmileFill", ()=>(0, _emojiSmileFillDefault.default));
parcelHelpers.export(exports, "EmojiSmileUpsideDownFill", ()=>(0, _emojiSmileUpsideDownFillDefault.default));
parcelHelpers.export(exports, "EmojiSmileUpsideDown", ()=>(0, _emojiSmileUpsideDownDefault.default));
parcelHelpers.export(exports, "EmojiSmile", ()=>(0, _emojiSmileDefault.default));
parcelHelpers.export(exports, "EmojiSunglassesFill", ()=>(0, _emojiSunglassesFillDefault.default));
parcelHelpers.export(exports, "EmojiSunglasses", ()=>(0, _emojiSunglassesDefault.default));
parcelHelpers.export(exports, "EmojiSurpriseFill", ()=>(0, _emojiSurpriseFillDefault.default));
parcelHelpers.export(exports, "EmojiSurprise", ()=>(0, _emojiSurpriseDefault.default));
parcelHelpers.export(exports, "EmojiTearFill", ()=>(0, _emojiTearFillDefault.default));
parcelHelpers.export(exports, "EmojiTear", ()=>(0, _emojiTearDefault.default));
parcelHelpers.export(exports, "EmojiWinkFill", ()=>(0, _emojiWinkFillDefault.default));
parcelHelpers.export(exports, "EmojiWink", ()=>(0, _emojiWinkDefault.default));
parcelHelpers.export(exports, "EnvelopeArrowDownFill", ()=>(0, _envelopeArrowDownFillDefault.default));
parcelHelpers.export(exports, "EnvelopeArrowDown", ()=>(0, _envelopeArrowDownDefault.default));
parcelHelpers.export(exports, "EnvelopeArrowUpFill", ()=>(0, _envelopeArrowUpFillDefault.default));
parcelHelpers.export(exports, "EnvelopeArrowUp", ()=>(0, _envelopeArrowUpDefault.default));
parcelHelpers.export(exports, "EnvelopeAtFill", ()=>(0, _envelopeAtFillDefault.default));
parcelHelpers.export(exports, "EnvelopeAt", ()=>(0, _envelopeAtDefault.default));
parcelHelpers.export(exports, "EnvelopeCheckFill", ()=>(0, _envelopeCheckFillDefault.default));
parcelHelpers.export(exports, "EnvelopeCheck", ()=>(0, _envelopeCheckDefault.default));
parcelHelpers.export(exports, "EnvelopeDashFill", ()=>(0, _envelopeDashFillDefault.default));
parcelHelpers.export(exports, "EnvelopeDash", ()=>(0, _envelopeDashDefault.default));
parcelHelpers.export(exports, "EnvelopeExclamationFill", ()=>(0, _envelopeExclamationFillDefault.default));
parcelHelpers.export(exports, "EnvelopeExclamation", ()=>(0, _envelopeExclamationDefault.default));
parcelHelpers.export(exports, "EnvelopeFill", ()=>(0, _envelopeFillDefault.default));
parcelHelpers.export(exports, "EnvelopeHeartFill", ()=>(0, _envelopeHeartFillDefault.default));
parcelHelpers.export(exports, "EnvelopeHeart", ()=>(0, _envelopeHeartDefault.default));
parcelHelpers.export(exports, "EnvelopeOpenFill", ()=>(0, _envelopeOpenFillDefault.default));
parcelHelpers.export(exports, "EnvelopeOpenHeartFill", ()=>(0, _envelopeOpenHeartFillDefault.default));
parcelHelpers.export(exports, "EnvelopeOpenHeart", ()=>(0, _envelopeOpenHeartDefault.default));
parcelHelpers.export(exports, "EnvelopeOpen", ()=>(0, _envelopeOpenDefault.default));
parcelHelpers.export(exports, "EnvelopePaperFill", ()=>(0, _envelopePaperFillDefault.default));
parcelHelpers.export(exports, "EnvelopePaperHeartFill", ()=>(0, _envelopePaperHeartFillDefault.default));
parcelHelpers.export(exports, "EnvelopePaperHeart", ()=>(0, _envelopePaperHeartDefault.default));
parcelHelpers.export(exports, "EnvelopePaper", ()=>(0, _envelopePaperDefault.default));
parcelHelpers.export(exports, "EnvelopePlusFill", ()=>(0, _envelopePlusFillDefault.default));
parcelHelpers.export(exports, "EnvelopePlus", ()=>(0, _envelopePlusDefault.default));
parcelHelpers.export(exports, "EnvelopeSlashFill", ()=>(0, _envelopeSlashFillDefault.default));
parcelHelpers.export(exports, "EnvelopeSlash", ()=>(0, _envelopeSlashDefault.default));
parcelHelpers.export(exports, "EnvelopeXFill", ()=>(0, _envelopeXFillDefault.default));
parcelHelpers.export(exports, "EnvelopeX", ()=>(0, _envelopeXDefault.default));
parcelHelpers.export(exports, "Envelope", ()=>(0, _envelopeDefault.default));
parcelHelpers.export(exports, "EraserFill", ()=>(0, _eraserFillDefault.default));
parcelHelpers.export(exports, "Eraser", ()=>(0, _eraserDefault.default));
parcelHelpers.export(exports, "Escape", ()=>(0, _escapeDefault.default));
parcelHelpers.export(exports, "Ethernet", ()=>(0, _ethernetDefault.default));
parcelHelpers.export(exports, "EvFrontFill", ()=>(0, _evFrontFillDefault.default));
parcelHelpers.export(exports, "EvFront", ()=>(0, _evFrontDefault.default));
parcelHelpers.export(exports, "EvStationFill", ()=>(0, _evStationFillDefault.default));
parcelHelpers.export(exports, "EvStation", ()=>(0, _evStationDefault.default));
parcelHelpers.export(exports, "ExclamationCircleFill", ()=>(0, _exclamationCircleFillDefault.default));
parcelHelpers.export(exports, "ExclamationCircle", ()=>(0, _exclamationCircleDefault.default));
parcelHelpers.export(exports, "ExclamationDiamondFill", ()=>(0, _exclamationDiamondFillDefault.default));
parcelHelpers.export(exports, "ExclamationDiamond", ()=>(0, _exclamationDiamondDefault.default));
parcelHelpers.export(exports, "ExclamationLg", ()=>(0, _exclamationLgDefault.default));
parcelHelpers.export(exports, "ExclamationOctagonFill", ()=>(0, _exclamationOctagonFillDefault.default));
parcelHelpers.export(exports, "ExclamationOctagon", ()=>(0, _exclamationOctagonDefault.default));
parcelHelpers.export(exports, "ExclamationSquareFill", ()=>(0, _exclamationSquareFillDefault.default));
parcelHelpers.export(exports, "ExclamationSquare", ()=>(0, _exclamationSquareDefault.default));
parcelHelpers.export(exports, "ExclamationTriangleFill", ()=>(0, _exclamationTriangleFillDefault.default));
parcelHelpers.export(exports, "ExclamationTriangle", ()=>(0, _exclamationTriangleDefault.default));
parcelHelpers.export(exports, "Exclamation", ()=>(0, _exclamationDefault.default));
parcelHelpers.export(exports, "Exclude", ()=>(0, _excludeDefault.default));
parcelHelpers.export(exports, "ExplicitFill", ()=>(0, _explicitFillDefault.default));
parcelHelpers.export(exports, "Explicit", ()=>(0, _explicitDefault.default));
parcelHelpers.export(exports, "Exposure", ()=>(0, _exposureDefault.default));
parcelHelpers.export(exports, "EyeFill", ()=>(0, _eyeFillDefault.default));
parcelHelpers.export(exports, "EyeSlashFill", ()=>(0, _eyeSlashFillDefault.default));
parcelHelpers.export(exports, "EyeSlash", ()=>(0, _eyeSlashDefault.default));
parcelHelpers.export(exports, "Eye", ()=>(0, _eyeDefault.default));
parcelHelpers.export(exports, "Eyedropper", ()=>(0, _eyedropperDefault.default));
parcelHelpers.export(exports, "Eyeglasses", ()=>(0, _eyeglassesDefault.default));
parcelHelpers.export(exports, "Facebook", ()=>(0, _facebookDefault.default));
parcelHelpers.export(exports, "Fan", ()=>(0, _fanDefault.default));
parcelHelpers.export(exports, "FastForwardBtnFill", ()=>(0, _fastForwardBtnFillDefault.default));
parcelHelpers.export(exports, "FastForwardBtn", ()=>(0, _fastForwardBtnDefault.default));
parcelHelpers.export(exports, "FastForwardCircleFill", ()=>(0, _fastForwardCircleFillDefault.default));
parcelHelpers.export(exports, "FastForwardCircle", ()=>(0, _fastForwardCircleDefault.default));
parcelHelpers.export(exports, "FastForwardFill", ()=>(0, _fastForwardFillDefault.default));
parcelHelpers.export(exports, "FastForward", ()=>(0, _fastForwardDefault.default));
parcelHelpers.export(exports, "Feather", ()=>(0, _featherDefault.default));
parcelHelpers.export(exports, "Feather2", ()=>(0, _feather2Default.default));
parcelHelpers.export(exports, "FileArrowDownFill", ()=>(0, _fileArrowDownFillDefault.default));
parcelHelpers.export(exports, "FileArrowDown", ()=>(0, _fileArrowDownDefault.default));
parcelHelpers.export(exports, "FileArrowUpFill", ()=>(0, _fileArrowUpFillDefault.default));
parcelHelpers.export(exports, "FileArrowUp", ()=>(0, _fileArrowUpDefault.default));
parcelHelpers.export(exports, "FileBarGraphFill", ()=>(0, _fileBarGraphFillDefault.default));
parcelHelpers.export(exports, "FileBarGraph", ()=>(0, _fileBarGraphDefault.default));
parcelHelpers.export(exports, "FileBinaryFill", ()=>(0, _fileBinaryFillDefault.default));
parcelHelpers.export(exports, "FileBinary", ()=>(0, _fileBinaryDefault.default));
parcelHelpers.export(exports, "FileBreakFill", ()=>(0, _fileBreakFillDefault.default));
parcelHelpers.export(exports, "FileBreak", ()=>(0, _fileBreakDefault.default));
parcelHelpers.export(exports, "FileCheckFill", ()=>(0, _fileCheckFillDefault.default));
parcelHelpers.export(exports, "FileCheck", ()=>(0, _fileCheckDefault.default));
parcelHelpers.export(exports, "FileCodeFill", ()=>(0, _fileCodeFillDefault.default));
parcelHelpers.export(exports, "FileCode", ()=>(0, _fileCodeDefault.default));
parcelHelpers.export(exports, "FileDiffFill", ()=>(0, _fileDiffFillDefault.default));
parcelHelpers.export(exports, "FileDiff", ()=>(0, _fileDiffDefault.default));
parcelHelpers.export(exports, "FileEarmarkArrowDownFill", ()=>(0, _fileEarmarkArrowDownFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkArrowDown", ()=>(0, _fileEarmarkArrowDownDefault.default));
parcelHelpers.export(exports, "FileEarmarkArrowUpFill", ()=>(0, _fileEarmarkArrowUpFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkArrowUp", ()=>(0, _fileEarmarkArrowUpDefault.default));
parcelHelpers.export(exports, "FileEarmarkBarGraphFill", ()=>(0, _fileEarmarkBarGraphFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkBarGraph", ()=>(0, _fileEarmarkBarGraphDefault.default));
parcelHelpers.export(exports, "FileEarmarkBinaryFill", ()=>(0, _fileEarmarkBinaryFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkBinary", ()=>(0, _fileEarmarkBinaryDefault.default));
parcelHelpers.export(exports, "FileEarmarkBreakFill", ()=>(0, _fileEarmarkBreakFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkBreak", ()=>(0, _fileEarmarkBreakDefault.default));
parcelHelpers.export(exports, "FileEarmarkCheckFill", ()=>(0, _fileEarmarkCheckFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkCheck", ()=>(0, _fileEarmarkCheckDefault.default));
parcelHelpers.export(exports, "FileEarmarkCodeFill", ()=>(0, _fileEarmarkCodeFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkCode", ()=>(0, _fileEarmarkCodeDefault.default));
parcelHelpers.export(exports, "FileEarmarkDiffFill", ()=>(0, _fileEarmarkDiffFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkDiff", ()=>(0, _fileEarmarkDiffDefault.default));
parcelHelpers.export(exports, "FileEarmarkEaselFill", ()=>(0, _fileEarmarkEaselFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkEasel", ()=>(0, _fileEarmarkEaselDefault.default));
parcelHelpers.export(exports, "FileEarmarkExcelFill", ()=>(0, _fileEarmarkExcelFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkExcel", ()=>(0, _fileEarmarkExcelDefault.default));
parcelHelpers.export(exports, "FileEarmarkFill", ()=>(0, _fileEarmarkFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkFontFill", ()=>(0, _fileEarmarkFontFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkFont", ()=>(0, _fileEarmarkFontDefault.default));
parcelHelpers.export(exports, "FileEarmarkImageFill", ()=>(0, _fileEarmarkImageFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkImage", ()=>(0, _fileEarmarkImageDefault.default));
parcelHelpers.export(exports, "FileEarmarkLockFill", ()=>(0, _fileEarmarkLockFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkLock", ()=>(0, _fileEarmarkLockDefault.default));
parcelHelpers.export(exports, "FileEarmarkLock2Fill", ()=>(0, _fileEarmarkLock2FillDefault.default));
parcelHelpers.export(exports, "FileEarmarkLock2", ()=>(0, _fileEarmarkLock2Default.default));
parcelHelpers.export(exports, "FileEarmarkMedicalFill", ()=>(0, _fileEarmarkMedicalFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkMedical", ()=>(0, _fileEarmarkMedicalDefault.default));
parcelHelpers.export(exports, "FileEarmarkMinusFill", ()=>(0, _fileEarmarkMinusFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkMinus", ()=>(0, _fileEarmarkMinusDefault.default));
parcelHelpers.export(exports, "FileEarmarkMusicFill", ()=>(0, _fileEarmarkMusicFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkMusic", ()=>(0, _fileEarmarkMusicDefault.default));
parcelHelpers.export(exports, "FileEarmarkPdfFill", ()=>(0, _fileEarmarkPdfFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkPdf", ()=>(0, _fileEarmarkPdfDefault.default));
parcelHelpers.export(exports, "FileEarmarkPersonFill", ()=>(0, _fileEarmarkPersonFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkPerson", ()=>(0, _fileEarmarkPersonDefault.default));
parcelHelpers.export(exports, "FileEarmarkPlayFill", ()=>(0, _fileEarmarkPlayFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkPlay", ()=>(0, _fileEarmarkPlayDefault.default));
parcelHelpers.export(exports, "FileEarmarkPlusFill", ()=>(0, _fileEarmarkPlusFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkPlus", ()=>(0, _fileEarmarkPlusDefault.default));
parcelHelpers.export(exports, "FileEarmarkPostFill", ()=>(0, _fileEarmarkPostFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkPost", ()=>(0, _fileEarmarkPostDefault.default));
parcelHelpers.export(exports, "FileEarmarkPptFill", ()=>(0, _fileEarmarkPptFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkPpt", ()=>(0, _fileEarmarkPptDefault.default));
parcelHelpers.export(exports, "FileEarmarkRichtextFill", ()=>(0, _fileEarmarkRichtextFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkRichtext", ()=>(0, _fileEarmarkRichtextDefault.default));
parcelHelpers.export(exports, "FileEarmarkRuledFill", ()=>(0, _fileEarmarkRuledFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkRuled", ()=>(0, _fileEarmarkRuledDefault.default));
parcelHelpers.export(exports, "FileEarmarkSlidesFill", ()=>(0, _fileEarmarkSlidesFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkSlides", ()=>(0, _fileEarmarkSlidesDefault.default));
parcelHelpers.export(exports, "FileEarmarkSpreadsheetFill", ()=>(0, _fileEarmarkSpreadsheetFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkSpreadsheet", ()=>(0, _fileEarmarkSpreadsheetDefault.default));
parcelHelpers.export(exports, "FileEarmarkTextFill", ()=>(0, _fileEarmarkTextFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkText", ()=>(0, _fileEarmarkTextDefault.default));
parcelHelpers.export(exports, "FileEarmarkWordFill", ()=>(0, _fileEarmarkWordFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkWord", ()=>(0, _fileEarmarkWordDefault.default));
parcelHelpers.export(exports, "FileEarmarkXFill", ()=>(0, _fileEarmarkXFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkX", ()=>(0, _fileEarmarkXDefault.default));
parcelHelpers.export(exports, "FileEarmarkZipFill", ()=>(0, _fileEarmarkZipFillDefault.default));
parcelHelpers.export(exports, "FileEarmarkZip", ()=>(0, _fileEarmarkZipDefault.default));
parcelHelpers.export(exports, "FileEarmark", ()=>(0, _fileEarmarkDefault.default));
parcelHelpers.export(exports, "FileEaselFill", ()=>(0, _fileEaselFillDefault.default));
parcelHelpers.export(exports, "FileEasel", ()=>(0, _fileEaselDefault.default));
parcelHelpers.export(exports, "FileExcelFill", ()=>(0, _fileExcelFillDefault.default));
parcelHelpers.export(exports, "FileExcel", ()=>(0, _fileExcelDefault.default));
parcelHelpers.export(exports, "FileFill", ()=>(0, _fileFillDefault.default));
parcelHelpers.export(exports, "FileFontFill", ()=>(0, _fileFontFillDefault.default));
parcelHelpers.export(exports, "FileFont", ()=>(0, _fileFontDefault.default));
parcelHelpers.export(exports, "FileImageFill", ()=>(0, _fileImageFillDefault.default));
parcelHelpers.export(exports, "FileImage", ()=>(0, _fileImageDefault.default));
parcelHelpers.export(exports, "FileLockFill", ()=>(0, _fileLockFillDefault.default));
parcelHelpers.export(exports, "FileLock", ()=>(0, _fileLockDefault.default));
parcelHelpers.export(exports, "FileLock2Fill", ()=>(0, _fileLock2FillDefault.default));
parcelHelpers.export(exports, "FileLock2", ()=>(0, _fileLock2Default.default));
parcelHelpers.export(exports, "FileMedicalFill", ()=>(0, _fileMedicalFillDefault.default));
parcelHelpers.export(exports, "FileMedical", ()=>(0, _fileMedicalDefault.default));
parcelHelpers.export(exports, "FileMinusFill", ()=>(0, _fileMinusFillDefault.default));
parcelHelpers.export(exports, "FileMinus", ()=>(0, _fileMinusDefault.default));
parcelHelpers.export(exports, "FileMusicFill", ()=>(0, _fileMusicFillDefault.default));
parcelHelpers.export(exports, "FileMusic", ()=>(0, _fileMusicDefault.default));
parcelHelpers.export(exports, "FilePdfFill", ()=>(0, _filePdfFillDefault.default));
parcelHelpers.export(exports, "FilePdf", ()=>(0, _filePdfDefault.default));
parcelHelpers.export(exports, "FilePersonFill", ()=>(0, _filePersonFillDefault.default));
parcelHelpers.export(exports, "FilePerson", ()=>(0, _filePersonDefault.default));
parcelHelpers.export(exports, "FilePlayFill", ()=>(0, _filePlayFillDefault.default));
parcelHelpers.export(exports, "FilePlay", ()=>(0, _filePlayDefault.default));
parcelHelpers.export(exports, "FilePlusFill", ()=>(0, _filePlusFillDefault.default));
parcelHelpers.export(exports, "FilePlus", ()=>(0, _filePlusDefault.default));
parcelHelpers.export(exports, "FilePostFill", ()=>(0, _filePostFillDefault.default));
parcelHelpers.export(exports, "FilePost", ()=>(0, _filePostDefault.default));
parcelHelpers.export(exports, "FilePptFill", ()=>(0, _filePptFillDefault.default));
parcelHelpers.export(exports, "FilePpt", ()=>(0, _filePptDefault.default));
parcelHelpers.export(exports, "FileRichtextFill", ()=>(0, _fileRichtextFillDefault.default));
parcelHelpers.export(exports, "FileRichtext", ()=>(0, _fileRichtextDefault.default));
parcelHelpers.export(exports, "FileRuledFill", ()=>(0, _fileRuledFillDefault.default));
parcelHelpers.export(exports, "FileRuled", ()=>(0, _fileRuledDefault.default));
parcelHelpers.export(exports, "FileSlidesFill", ()=>(0, _fileSlidesFillDefault.default));
parcelHelpers.export(exports, "FileSlides", ()=>(0, _fileSlidesDefault.default));
parcelHelpers.export(exports, "FileSpreadsheetFill", ()=>(0, _fileSpreadsheetFillDefault.default));
parcelHelpers.export(exports, "FileSpreadsheet", ()=>(0, _fileSpreadsheetDefault.default));
parcelHelpers.export(exports, "FileTextFill", ()=>(0, _fileTextFillDefault.default));
parcelHelpers.export(exports, "FileText", ()=>(0, _fileTextDefault.default));
parcelHelpers.export(exports, "FileWordFill", ()=>(0, _fileWordFillDefault.default));
parcelHelpers.export(exports, "FileWord", ()=>(0, _fileWordDefault.default));
parcelHelpers.export(exports, "FileXFill", ()=>(0, _fileXFillDefault.default));
parcelHelpers.export(exports, "FileX", ()=>(0, _fileXDefault.default));
parcelHelpers.export(exports, "FileZipFill", ()=>(0, _fileZipFillDefault.default));
parcelHelpers.export(exports, "FileZip", ()=>(0, _fileZipDefault.default));
parcelHelpers.export(exports, "File", ()=>(0, _fileDefault.default));
parcelHelpers.export(exports, "FilesAlt", ()=>(0, _filesAltDefault.default));
parcelHelpers.export(exports, "Files", ()=>(0, _filesDefault.default));
parcelHelpers.export(exports, "FiletypeAac", ()=>(0, _filetypeAacDefault.default));
parcelHelpers.export(exports, "FiletypeAi", ()=>(0, _filetypeAiDefault.default));
parcelHelpers.export(exports, "FiletypeBmp", ()=>(0, _filetypeBmpDefault.default));
parcelHelpers.export(exports, "FiletypeCs", ()=>(0, _filetypeCsDefault.default));
parcelHelpers.export(exports, "FiletypeCss", ()=>(0, _filetypeCssDefault.default));
parcelHelpers.export(exports, "FiletypeCsv", ()=>(0, _filetypeCsvDefault.default));
parcelHelpers.export(exports, "FiletypeDoc", ()=>(0, _filetypeDocDefault.default));
parcelHelpers.export(exports, "FiletypeDocx", ()=>(0, _filetypeDocxDefault.default));
parcelHelpers.export(exports, "FiletypeExe", ()=>(0, _filetypeExeDefault.default));
parcelHelpers.export(exports, "FiletypeGif", ()=>(0, _filetypeGifDefault.default));
parcelHelpers.export(exports, "FiletypeHeic", ()=>(0, _filetypeHeicDefault.default));
parcelHelpers.export(exports, "FiletypeHtml", ()=>(0, _filetypeHtmlDefault.default));
parcelHelpers.export(exports, "FiletypeJava", ()=>(0, _filetypeJavaDefault.default));
parcelHelpers.export(exports, "FiletypeJpg", ()=>(0, _filetypeJpgDefault.default));
parcelHelpers.export(exports, "FiletypeJs", ()=>(0, _filetypeJsDefault.default));
parcelHelpers.export(exports, "FiletypeJson", ()=>(0, _filetypeJsonDefault.default));
parcelHelpers.export(exports, "FiletypeJsx", ()=>(0, _filetypeJsxDefault.default));
parcelHelpers.export(exports, "FiletypeKey", ()=>(0, _filetypeKeyDefault.default));
parcelHelpers.export(exports, "FiletypeM4p", ()=>(0, _filetypeM4PDefault.default));
parcelHelpers.export(exports, "FiletypeMd", ()=>(0, _filetypeMdDefault.default));
parcelHelpers.export(exports, "FiletypeMdx", ()=>(0, _filetypeMdxDefault.default));
parcelHelpers.export(exports, "FiletypeMov", ()=>(0, _filetypeMovDefault.default));
parcelHelpers.export(exports, "FiletypeMp3", ()=>(0, _filetypeMp3Default.default));
parcelHelpers.export(exports, "FiletypeMp4", ()=>(0, _filetypeMp4Default.default));
parcelHelpers.export(exports, "FiletypeOtf", ()=>(0, _filetypeOtfDefault.default));
parcelHelpers.export(exports, "FiletypePdf", ()=>(0, _filetypePdfDefault.default));
parcelHelpers.export(exports, "FiletypePhp", ()=>(0, _filetypePhpDefault.default));
parcelHelpers.export(exports, "FiletypePng", ()=>(0, _filetypePngDefault.default));
parcelHelpers.export(exports, "FiletypePpt", ()=>(0, _filetypePptDefault.default));
parcelHelpers.export(exports, "FiletypePptx", ()=>(0, _filetypePptxDefault.default));
parcelHelpers.export(exports, "FiletypePsd", ()=>(0, _filetypePsdDefault.default));
parcelHelpers.export(exports, "FiletypePy", ()=>(0, _filetypePyDefault.default));
parcelHelpers.export(exports, "FiletypeRaw", ()=>(0, _filetypeRawDefault.default));
parcelHelpers.export(exports, "FiletypeRb", ()=>(0, _filetypeRbDefault.default));
parcelHelpers.export(exports, "FiletypeSass", ()=>(0, _filetypeSassDefault.default));
parcelHelpers.export(exports, "FiletypeScss", ()=>(0, _filetypeScssDefault.default));
parcelHelpers.export(exports, "FiletypeSh", ()=>(0, _filetypeShDefault.default));
parcelHelpers.export(exports, "FiletypeSql", ()=>(0, _filetypeSqlDefault.default));
parcelHelpers.export(exports, "FiletypeSvg", ()=>(0, _filetypeSvgDefault.default));
parcelHelpers.export(exports, "FiletypeTiff", ()=>(0, _filetypeTiffDefault.default));
parcelHelpers.export(exports, "FiletypeTsx", ()=>(0, _filetypeTsxDefault.default));
parcelHelpers.export(exports, "FiletypeTtf", ()=>(0, _filetypeTtfDefault.default));
parcelHelpers.export(exports, "FiletypeTxt", ()=>(0, _filetypeTxtDefault.default));
parcelHelpers.export(exports, "FiletypeWav", ()=>(0, _filetypeWavDefault.default));
parcelHelpers.export(exports, "FiletypeWoff", ()=>(0, _filetypeWoffDefault.default));
parcelHelpers.export(exports, "FiletypeXls", ()=>(0, _filetypeXlsDefault.default));
parcelHelpers.export(exports, "FiletypeXlsx", ()=>(0, _filetypeXlsxDefault.default));
parcelHelpers.export(exports, "FiletypeXml", ()=>(0, _filetypeXmlDefault.default));
parcelHelpers.export(exports, "FiletypeYml", ()=>(0, _filetypeYmlDefault.default));
parcelHelpers.export(exports, "Film", ()=>(0, _filmDefault.default));
parcelHelpers.export(exports, "FilterCircleFill", ()=>(0, _filterCircleFillDefault.default));
parcelHelpers.export(exports, "FilterCircle", ()=>(0, _filterCircleDefault.default));
parcelHelpers.export(exports, "FilterLeft", ()=>(0, _filterLeftDefault.default));
parcelHelpers.export(exports, "FilterRight", ()=>(0, _filterRightDefault.default));
parcelHelpers.export(exports, "FilterSquareFill", ()=>(0, _filterSquareFillDefault.default));
parcelHelpers.export(exports, "FilterSquare", ()=>(0, _filterSquareDefault.default));
parcelHelpers.export(exports, "Filter", ()=>(0, _filterDefault.default));
parcelHelpers.export(exports, "Fingerprint", ()=>(0, _fingerprintDefault.default));
parcelHelpers.export(exports, "Fire", ()=>(0, _fireDefault.default));
parcelHelpers.export(exports, "FlagFill", ()=>(0, _flagFillDefault.default));
parcelHelpers.export(exports, "Flag", ()=>(0, _flagDefault.default));
parcelHelpers.export(exports, "FloppyFill", ()=>(0, _floppyFillDefault.default));
parcelHelpers.export(exports, "Floppy", ()=>(0, _floppyDefault.default));
parcelHelpers.export(exports, "Floppy2Fill", ()=>(0, _floppy2FillDefault.default));
parcelHelpers.export(exports, "Floppy2", ()=>(0, _floppy2Default.default));
parcelHelpers.export(exports, "Flower1", ()=>(0, _flower1Default.default));
parcelHelpers.export(exports, "Flower2", ()=>(0, _flower2Default.default));
parcelHelpers.export(exports, "Flower3", ()=>(0, _flower3Default.default));
parcelHelpers.export(exports, "FolderCheck", ()=>(0, _folderCheckDefault.default));
parcelHelpers.export(exports, "FolderFill", ()=>(0, _folderFillDefault.default));
parcelHelpers.export(exports, "FolderMinus", ()=>(0, _folderMinusDefault.default));
parcelHelpers.export(exports, "FolderPlus", ()=>(0, _folderPlusDefault.default));
parcelHelpers.export(exports, "FolderSymlinkFill", ()=>(0, _folderSymlinkFillDefault.default));
parcelHelpers.export(exports, "FolderSymlink", ()=>(0, _folderSymlinkDefault.default));
parcelHelpers.export(exports, "FolderX", ()=>(0, _folderXDefault.default));
parcelHelpers.export(exports, "Folder", ()=>(0, _folderDefault.default));
parcelHelpers.export(exports, "Folder2Open", ()=>(0, _folder2OpenDefault.default));
parcelHelpers.export(exports, "Folder2", ()=>(0, _folder2Default.default));
parcelHelpers.export(exports, "Fonts", ()=>(0, _fontsDefault.default));
parcelHelpers.export(exports, "ForwardFill", ()=>(0, _forwardFillDefault.default));
parcelHelpers.export(exports, "Forward", ()=>(0, _forwardDefault.default));
parcelHelpers.export(exports, "Front", ()=>(0, _frontDefault.default));
parcelHelpers.export(exports, "FuelPumpDieselFill", ()=>(0, _fuelPumpDieselFillDefault.default));
parcelHelpers.export(exports, "FuelPumpDiesel", ()=>(0, _fuelPumpDieselDefault.default));
parcelHelpers.export(exports, "FuelPumpFill", ()=>(0, _fuelPumpFillDefault.default));
parcelHelpers.export(exports, "FuelPump", ()=>(0, _fuelPumpDefault.default));
parcelHelpers.export(exports, "FullscreenExit", ()=>(0, _fullscreenExitDefault.default));
parcelHelpers.export(exports, "Fullscreen", ()=>(0, _fullscreenDefault.default));
parcelHelpers.export(exports, "FunnelFill", ()=>(0, _funnelFillDefault.default));
parcelHelpers.export(exports, "Funnel", ()=>(0, _funnelDefault.default));
parcelHelpers.export(exports, "GearFill", ()=>(0, _gearFillDefault.default));
parcelHelpers.export(exports, "GearWideConnected", ()=>(0, _gearWideConnectedDefault.default));
parcelHelpers.export(exports, "GearWide", ()=>(0, _gearWideDefault.default));
parcelHelpers.export(exports, "Gear", ()=>(0, _gearDefault.default));
parcelHelpers.export(exports, "Gem", ()=>(0, _gemDefault.default));
parcelHelpers.export(exports, "GenderAmbiguous", ()=>(0, _genderAmbiguousDefault.default));
parcelHelpers.export(exports, "GenderFemale", ()=>(0, _genderFemaleDefault.default));
parcelHelpers.export(exports, "GenderMale", ()=>(0, _genderMaleDefault.default));
parcelHelpers.export(exports, "GenderNeuter", ()=>(0, _genderNeuterDefault.default));
parcelHelpers.export(exports, "GenderTrans", ()=>(0, _genderTransDefault.default));
parcelHelpers.export(exports, "GeoAltFill", ()=>(0, _geoAltFillDefault.default));
parcelHelpers.export(exports, "GeoAlt", ()=>(0, _geoAltDefault.default));
parcelHelpers.export(exports, "GeoFill", ()=>(0, _geoFillDefault.default));
parcelHelpers.export(exports, "Geo", ()=>(0, _geoDefault.default));
parcelHelpers.export(exports, "GiftFill", ()=>(0, _giftFillDefault.default));
parcelHelpers.export(exports, "Gift", ()=>(0, _giftDefault.default));
parcelHelpers.export(exports, "Git", ()=>(0, _gitDefault.default));
parcelHelpers.export(exports, "Github", ()=>(0, _githubDefault.default));
parcelHelpers.export(exports, "Gitlab", ()=>(0, _gitlabDefault.default));
parcelHelpers.export(exports, "GlobeAmericas", ()=>(0, _globeAmericasDefault.default));
parcelHelpers.export(exports, "GlobeAsiaAustralia", ()=>(0, _globeAsiaAustraliaDefault.default));
parcelHelpers.export(exports, "GlobeCentralSouthAsia", ()=>(0, _globeCentralSouthAsiaDefault.default));
parcelHelpers.export(exports, "GlobeEuropeAfrica", ()=>(0, _globeEuropeAfricaDefault.default));
parcelHelpers.export(exports, "Globe", ()=>(0, _globeDefault.default));
parcelHelpers.export(exports, "Globe2", ()=>(0, _globe2Default.default));
parcelHelpers.export(exports, "GooglePlay", ()=>(0, _googlePlayDefault.default));
parcelHelpers.export(exports, "Google", ()=>(0, _googleDefault.default));
parcelHelpers.export(exports, "GpuCard", ()=>(0, _gpuCardDefault.default));
parcelHelpers.export(exports, "GraphDownArrow", ()=>(0, _graphDownArrowDefault.default));
parcelHelpers.export(exports, "GraphDown", ()=>(0, _graphDownDefault.default));
parcelHelpers.export(exports, "GraphUpArrow", ()=>(0, _graphUpArrowDefault.default));
parcelHelpers.export(exports, "GraphUp", ()=>(0, _graphUpDefault.default));
parcelHelpers.export(exports, "Grid1x2Fill", ()=>(0, _grid1X2FillDefault.default));
parcelHelpers.export(exports, "Grid1x2", ()=>(0, _grid1X2Default.default));
parcelHelpers.export(exports, "Grid3x2GapFill", ()=>(0, _grid3X2GapFillDefault.default));
parcelHelpers.export(exports, "Grid3x2Gap", ()=>(0, _grid3X2GapDefault.default));
parcelHelpers.export(exports, "Grid3x2", ()=>(0, _grid3X2Default.default));
parcelHelpers.export(exports, "Grid3x3GapFill", ()=>(0, _grid3X3GapFillDefault.default));
parcelHelpers.export(exports, "Grid3x3Gap", ()=>(0, _grid3X3GapDefault.default));
parcelHelpers.export(exports, "Grid3x3", ()=>(0, _grid3X3Default.default));
parcelHelpers.export(exports, "GridFill", ()=>(0, _gridFillDefault.default));
parcelHelpers.export(exports, "Grid", ()=>(0, _gridDefault.default));
parcelHelpers.export(exports, "GripHorizontal", ()=>(0, _gripHorizontalDefault.default));
parcelHelpers.export(exports, "GripVertical", ()=>(0, _gripVerticalDefault.default));
parcelHelpers.export(exports, "HCircleFill", ()=>(0, _hCircleFillDefault.default));
parcelHelpers.export(exports, "HCircle", ()=>(0, _hCircleDefault.default));
parcelHelpers.export(exports, "HSquareFill", ()=>(0, _hSquareFillDefault.default));
parcelHelpers.export(exports, "HSquare", ()=>(0, _hSquareDefault.default));
parcelHelpers.export(exports, "Hammer", ()=>(0, _hammerDefault.default));
parcelHelpers.export(exports, "HandIndexFill", ()=>(0, _handIndexFillDefault.default));
parcelHelpers.export(exports, "HandIndexThumbFill", ()=>(0, _handIndexThumbFillDefault.default));
parcelHelpers.export(exports, "HandIndexThumb", ()=>(0, _handIndexThumbDefault.default));
parcelHelpers.export(exports, "HandIndex", ()=>(0, _handIndexDefault.default));
parcelHelpers.export(exports, "HandThumbsDownFill", ()=>(0, _handThumbsDownFillDefault.default));
parcelHelpers.export(exports, "HandThumbsDown", ()=>(0, _handThumbsDownDefault.default));
parcelHelpers.export(exports, "HandThumbsUpFill", ()=>(0, _handThumbsUpFillDefault.default));
parcelHelpers.export(exports, "HandThumbsUp", ()=>(0, _handThumbsUpDefault.default));
parcelHelpers.export(exports, "HandbagFill", ()=>(0, _handbagFillDefault.default));
parcelHelpers.export(exports, "Handbag", ()=>(0, _handbagDefault.default));
parcelHelpers.export(exports, "Hash", ()=>(0, _hashDefault.default));
parcelHelpers.export(exports, "HddFill", ()=>(0, _hddFillDefault.default));
parcelHelpers.export(exports, "HddNetworkFill", ()=>(0, _hddNetworkFillDefault.default));
parcelHelpers.export(exports, "HddNetwork", ()=>(0, _hddNetworkDefault.default));
parcelHelpers.export(exports, "HddRackFill", ()=>(0, _hddRackFillDefault.default));
parcelHelpers.export(exports, "HddRack", ()=>(0, _hddRackDefault.default));
parcelHelpers.export(exports, "HddStackFill", ()=>(0, _hddStackFillDefault.default));
parcelHelpers.export(exports, "HddStack", ()=>(0, _hddStackDefault.default));
parcelHelpers.export(exports, "Hdd", ()=>(0, _hddDefault.default));
parcelHelpers.export(exports, "HdmiFill", ()=>(0, _hdmiFillDefault.default));
parcelHelpers.export(exports, "Hdmi", ()=>(0, _hdmiDefault.default));
parcelHelpers.export(exports, "Headphones", ()=>(0, _headphonesDefault.default));
parcelHelpers.export(exports, "HeadsetVr", ()=>(0, _headsetVrDefault.default));
parcelHelpers.export(exports, "Headset", ()=>(0, _headsetDefault.default));
parcelHelpers.export(exports, "HeartArrow", ()=>(0, _heartArrowDefault.default));
parcelHelpers.export(exports, "HeartFill", ()=>(0, _heartFillDefault.default));
parcelHelpers.export(exports, "HeartHalf", ()=>(0, _heartHalfDefault.default));
parcelHelpers.export(exports, "HeartPulseFill", ()=>(0, _heartPulseFillDefault.default));
parcelHelpers.export(exports, "HeartPulse", ()=>(0, _heartPulseDefault.default));
parcelHelpers.export(exports, "Heart", ()=>(0, _heartDefault.default));
parcelHelpers.export(exports, "HeartbreakFill", ()=>(0, _heartbreakFillDefault.default));
parcelHelpers.export(exports, "Heartbreak", ()=>(0, _heartbreakDefault.default));
parcelHelpers.export(exports, "Hearts", ()=>(0, _heartsDefault.default));
parcelHelpers.export(exports, "HeptagonFill", ()=>(0, _heptagonFillDefault.default));
parcelHelpers.export(exports, "HeptagonHalf", ()=>(0, _heptagonHalfDefault.default));
parcelHelpers.export(exports, "Heptagon", ()=>(0, _heptagonDefault.default));
parcelHelpers.export(exports, "HexagonFill", ()=>(0, _hexagonFillDefault.default));
parcelHelpers.export(exports, "HexagonHalf", ()=>(0, _hexagonHalfDefault.default));
parcelHelpers.export(exports, "Hexagon", ()=>(0, _hexagonDefault.default));
parcelHelpers.export(exports, "Highlighter", ()=>(0, _highlighterDefault.default));
parcelHelpers.export(exports, "Highlights", ()=>(0, _highlightsDefault.default));
parcelHelpers.export(exports, "HospitalFill", ()=>(0, _hospitalFillDefault.default));
parcelHelpers.export(exports, "Hospital", ()=>(0, _hospitalDefault.default));
parcelHelpers.export(exports, "HourglassBottom", ()=>(0, _hourglassBottomDefault.default));
parcelHelpers.export(exports, "HourglassSplit", ()=>(0, _hourglassSplitDefault.default));
parcelHelpers.export(exports, "HourglassTop", ()=>(0, _hourglassTopDefault.default));
parcelHelpers.export(exports, "Hourglass", ()=>(0, _hourglassDefault.default));
parcelHelpers.export(exports, "HouseAddFill", ()=>(0, _houseAddFillDefault.default));
parcelHelpers.export(exports, "HouseAdd", ()=>(0, _houseAddDefault.default));
parcelHelpers.export(exports, "HouseCheckFill", ()=>(0, _houseCheckFillDefault.default));
parcelHelpers.export(exports, "HouseCheck", ()=>(0, _houseCheckDefault.default));
parcelHelpers.export(exports, "HouseDashFill", ()=>(0, _houseDashFillDefault.default));
parcelHelpers.export(exports, "HouseDash", ()=>(0, _houseDashDefault.default));
parcelHelpers.export(exports, "HouseDoorFill", ()=>(0, _houseDoorFillDefault.default));
parcelHelpers.export(exports, "HouseDoor", ()=>(0, _houseDoorDefault.default));
parcelHelpers.export(exports, "HouseDownFill", ()=>(0, _houseDownFillDefault.default));
parcelHelpers.export(exports, "HouseDown", ()=>(0, _houseDownDefault.default));
parcelHelpers.export(exports, "HouseExclamationFill", ()=>(0, _houseExclamationFillDefault.default));
parcelHelpers.export(exports, "HouseExclamation", ()=>(0, _houseExclamationDefault.default));
parcelHelpers.export(exports, "HouseFill", ()=>(0, _houseFillDefault.default));
parcelHelpers.export(exports, "HouseGearFill", ()=>(0, _houseGearFillDefault.default));
parcelHelpers.export(exports, "HouseGear", ()=>(0, _houseGearDefault.default));
parcelHelpers.export(exports, "HouseHeartFill", ()=>(0, _houseHeartFillDefault.default));
parcelHelpers.export(exports, "HouseHeart", ()=>(0, _houseHeartDefault.default));
parcelHelpers.export(exports, "HouseLockFill", ()=>(0, _houseLockFillDefault.default));
parcelHelpers.export(exports, "HouseLock", ()=>(0, _houseLockDefault.default));
parcelHelpers.export(exports, "HouseSlashFill", ()=>(0, _houseSlashFillDefault.default));
parcelHelpers.export(exports, "HouseSlash", ()=>(0, _houseSlashDefault.default));
parcelHelpers.export(exports, "HouseUpFill", ()=>(0, _houseUpFillDefault.default));
parcelHelpers.export(exports, "HouseUp", ()=>(0, _houseUpDefault.default));
parcelHelpers.export(exports, "HouseXFill", ()=>(0, _houseXFillDefault.default));
parcelHelpers.export(exports, "HouseX", ()=>(0, _houseXDefault.default));
parcelHelpers.export(exports, "House", ()=>(0, _houseDefault.default));
parcelHelpers.export(exports, "HousesFill", ()=>(0, _housesFillDefault.default));
parcelHelpers.export(exports, "Houses", ()=>(0, _housesDefault.default));
parcelHelpers.export(exports, "Hr", ()=>(0, _hrDefault.default));
parcelHelpers.export(exports, "Hurricane", ()=>(0, _hurricaneDefault.default));
parcelHelpers.export(exports, "Hypnotize", ()=>(0, _hypnotizeDefault.default));
parcelHelpers.export(exports, "ImageAlt", ()=>(0, _imageAltDefault.default));
parcelHelpers.export(exports, "ImageFill", ()=>(0, _imageFillDefault.default));
parcelHelpers.export(exports, "Image", ()=>(0, _imageDefault.default));
parcelHelpers.export(exports, "Images", ()=>(0, _imagesDefault.default));
parcelHelpers.export(exports, "InboxFill", ()=>(0, _inboxFillDefault.default));
parcelHelpers.export(exports, "Inbox", ()=>(0, _inboxDefault.default));
parcelHelpers.export(exports, "InboxesFill", ()=>(0, _inboxesFillDefault.default));
parcelHelpers.export(exports, "Inboxes", ()=>(0, _inboxesDefault.default));
parcelHelpers.export(exports, "Incognito", ()=>(0, _incognitoDefault.default));
parcelHelpers.export(exports, "Indent", ()=>(0, _indentDefault.default));
parcelHelpers.export(exports, "Infinity", ()=>(0, _infinityDefault.default));
parcelHelpers.export(exports, "InfoCircleFill", ()=>(0, _infoCircleFillDefault.default));
parcelHelpers.export(exports, "InfoCircle", ()=>(0, _infoCircleDefault.default));
parcelHelpers.export(exports, "InfoLg", ()=>(0, _infoLgDefault.default));
parcelHelpers.export(exports, "InfoSquareFill", ()=>(0, _infoSquareFillDefault.default));
parcelHelpers.export(exports, "InfoSquare", ()=>(0, _infoSquareDefault.default));
parcelHelpers.export(exports, "Info", ()=>(0, _infoDefault.default));
parcelHelpers.export(exports, "InputCursorText", ()=>(0, _inputCursorTextDefault.default));
parcelHelpers.export(exports, "InputCursor", ()=>(0, _inputCursorDefault.default));
parcelHelpers.export(exports, "Instagram", ()=>(0, _instagramDefault.default));
parcelHelpers.export(exports, "Intersect", ()=>(0, _intersectDefault.default));
parcelHelpers.export(exports, "JournalAlbum", ()=>(0, _journalAlbumDefault.default));
parcelHelpers.export(exports, "JournalArrowDown", ()=>(0, _journalArrowDownDefault.default));
parcelHelpers.export(exports, "JournalArrowUp", ()=>(0, _journalArrowUpDefault.default));
parcelHelpers.export(exports, "JournalBookmarkFill", ()=>(0, _journalBookmarkFillDefault.default));
parcelHelpers.export(exports, "JournalBookmark", ()=>(0, _journalBookmarkDefault.default));
parcelHelpers.export(exports, "JournalCheck", ()=>(0, _journalCheckDefault.default));
parcelHelpers.export(exports, "JournalCode", ()=>(0, _journalCodeDefault.default));
parcelHelpers.export(exports, "JournalMedical", ()=>(0, _journalMedicalDefault.default));
parcelHelpers.export(exports, "JournalMinus", ()=>(0, _journalMinusDefault.default));
parcelHelpers.export(exports, "JournalPlus", ()=>(0, _journalPlusDefault.default));
parcelHelpers.export(exports, "JournalRichtext", ()=>(0, _journalRichtextDefault.default));
parcelHelpers.export(exports, "JournalText", ()=>(0, _journalTextDefault.default));
parcelHelpers.export(exports, "JournalX", ()=>(0, _journalXDefault.default));
parcelHelpers.export(exports, "Journal", ()=>(0, _journalDefault.default));
parcelHelpers.export(exports, "Journals", ()=>(0, _journalsDefault.default));
parcelHelpers.export(exports, "Joystick", ()=>(0, _joystickDefault.default));
parcelHelpers.export(exports, "JustifyLeft", ()=>(0, _justifyLeftDefault.default));
parcelHelpers.export(exports, "JustifyRight", ()=>(0, _justifyRightDefault.default));
parcelHelpers.export(exports, "Justify", ()=>(0, _justifyDefault.default));
parcelHelpers.export(exports, "KanbanFill", ()=>(0, _kanbanFillDefault.default));
parcelHelpers.export(exports, "Kanban", ()=>(0, _kanbanDefault.default));
parcelHelpers.export(exports, "KeyFill", ()=>(0, _keyFillDefault.default));
parcelHelpers.export(exports, "Key", ()=>(0, _keyDefault.default));
parcelHelpers.export(exports, "KeyboardFill", ()=>(0, _keyboardFillDefault.default));
parcelHelpers.export(exports, "Keyboard", ()=>(0, _keyboardDefault.default));
parcelHelpers.export(exports, "Ladder", ()=>(0, _ladderDefault.default));
parcelHelpers.export(exports, "LampFill", ()=>(0, _lampFillDefault.default));
parcelHelpers.export(exports, "Lamp", ()=>(0, _lampDefault.default));
parcelHelpers.export(exports, "LaptopFill", ()=>(0, _laptopFillDefault.default));
parcelHelpers.export(exports, "Laptop", ()=>(0, _laptopDefault.default));
parcelHelpers.export(exports, "LayerBackward", ()=>(0, _layerBackwardDefault.default));
parcelHelpers.export(exports, "LayerForward", ()=>(0, _layerForwardDefault.default));
parcelHelpers.export(exports, "LayersFill", ()=>(0, _layersFillDefault.default));
parcelHelpers.export(exports, "LayersHalf", ()=>(0, _layersHalfDefault.default));
parcelHelpers.export(exports, "Layers", ()=>(0, _layersDefault.default));
parcelHelpers.export(exports, "LayoutSidebarInsetReverse", ()=>(0, _layoutSidebarInsetReverseDefault.default));
parcelHelpers.export(exports, "LayoutSidebarInset", ()=>(0, _layoutSidebarInsetDefault.default));
parcelHelpers.export(exports, "LayoutSidebarReverse", ()=>(0, _layoutSidebarReverseDefault.default));
parcelHelpers.export(exports, "LayoutSidebar", ()=>(0, _layoutSidebarDefault.default));
parcelHelpers.export(exports, "LayoutSplit", ()=>(0, _layoutSplitDefault.default));
parcelHelpers.export(exports, "LayoutTextSidebarReverse", ()=>(0, _layoutTextSidebarReverseDefault.default));
parcelHelpers.export(exports, "LayoutTextSidebar", ()=>(0, _layoutTextSidebarDefault.default));
parcelHelpers.export(exports, "LayoutTextWindowReverse", ()=>(0, _layoutTextWindowReverseDefault.default));
parcelHelpers.export(exports, "LayoutTextWindow", ()=>(0, _layoutTextWindowDefault.default));
parcelHelpers.export(exports, "LayoutThreeColumns", ()=>(0, _layoutThreeColumnsDefault.default));
parcelHelpers.export(exports, "LayoutWtf", ()=>(0, _layoutWtfDefault.default));
parcelHelpers.export(exports, "LifePreserver", ()=>(0, _lifePreserverDefault.default));
parcelHelpers.export(exports, "LightbulbFill", ()=>(0, _lightbulbFillDefault.default));
parcelHelpers.export(exports, "LightbulbOffFill", ()=>(0, _lightbulbOffFillDefault.default));
parcelHelpers.export(exports, "LightbulbOff", ()=>(0, _lightbulbOffDefault.default));
parcelHelpers.export(exports, "Lightbulb", ()=>(0, _lightbulbDefault.default));
parcelHelpers.export(exports, "LightningChargeFill", ()=>(0, _lightningChargeFillDefault.default));
parcelHelpers.export(exports, "LightningCharge", ()=>(0, _lightningChargeDefault.default));
parcelHelpers.export(exports, "LightningFill", ()=>(0, _lightningFillDefault.default));
parcelHelpers.export(exports, "Lightning", ()=>(0, _lightningDefault.default));
parcelHelpers.export(exports, "Line", ()=>(0, _lineDefault.default));
parcelHelpers.export(exports, "Link45deg", ()=>(0, _link45DegDefault.default));
parcelHelpers.export(exports, "Link", ()=>(0, _linkDefault.default));
parcelHelpers.export(exports, "Linkedin", ()=>(0, _linkedinDefault.default));
parcelHelpers.export(exports, "ListCheck", ()=>(0, _listCheckDefault.default));
parcelHelpers.export(exports, "ListColumnsReverse", ()=>(0, _listColumnsReverseDefault.default));
parcelHelpers.export(exports, "ListColumns", ()=>(0, _listColumnsDefault.default));
parcelHelpers.export(exports, "ListNested", ()=>(0, _listNestedDefault.default));
parcelHelpers.export(exports, "ListOl", ()=>(0, _listOlDefault.default));
parcelHelpers.export(exports, "ListStars", ()=>(0, _listStarsDefault.default));
parcelHelpers.export(exports, "ListTask", ()=>(0, _listTaskDefault.default));
parcelHelpers.export(exports, "ListUl", ()=>(0, _listUlDefault.default));
parcelHelpers.export(exports, "List", ()=>(0, _listDefault.default));
parcelHelpers.export(exports, "LockFill", ()=>(0, _lockFillDefault.default));
parcelHelpers.export(exports, "Lock", ()=>(0, _lockDefault.default));
parcelHelpers.export(exports, "LuggageFill", ()=>(0, _luggageFillDefault.default));
parcelHelpers.export(exports, "Luggage", ()=>(0, _luggageDefault.default));
parcelHelpers.export(exports, "LungsFill", ()=>(0, _lungsFillDefault.default));
parcelHelpers.export(exports, "Lungs", ()=>(0, _lungsDefault.default));
parcelHelpers.export(exports, "Magic", ()=>(0, _magicDefault.default));
parcelHelpers.export(exports, "MagnetFill", ()=>(0, _magnetFillDefault.default));
parcelHelpers.export(exports, "Magnet", ()=>(0, _magnetDefault.default));
parcelHelpers.export(exports, "MailboxFlag", ()=>(0, _mailboxFlagDefault.default));
parcelHelpers.export(exports, "Mailbox", ()=>(0, _mailboxDefault.default));
parcelHelpers.export(exports, "Mailbox2Flag", ()=>(0, _mailbox2FlagDefault.default));
parcelHelpers.export(exports, "Mailbox2", ()=>(0, _mailbox2Default.default));
parcelHelpers.export(exports, "MapFill", ()=>(0, _mapFillDefault.default));
parcelHelpers.export(exports, "Map", ()=>(0, _mapDefault.default));
parcelHelpers.export(exports, "MarkdownFill", ()=>(0, _markdownFillDefault.default));
parcelHelpers.export(exports, "Markdown", ()=>(0, _markdownDefault.default));
parcelHelpers.export(exports, "MarkerTip", ()=>(0, _markerTipDefault.default));
parcelHelpers.export(exports, "Mask", ()=>(0, _maskDefault.default));
parcelHelpers.export(exports, "Mastodon", ()=>(0, _mastodonDefault.default));
parcelHelpers.export(exports, "Medium", ()=>(0, _mediumDefault.default));
parcelHelpers.export(exports, "MegaphoneFill", ()=>(0, _megaphoneFillDefault.default));
parcelHelpers.export(exports, "Megaphone", ()=>(0, _megaphoneDefault.default));
parcelHelpers.export(exports, "Memory", ()=>(0, _memoryDefault.default));
parcelHelpers.export(exports, "MenuAppFill", ()=>(0, _menuAppFillDefault.default));
parcelHelpers.export(exports, "MenuApp", ()=>(0, _menuAppDefault.default));
parcelHelpers.export(exports, "MenuButtonFill", ()=>(0, _menuButtonFillDefault.default));
parcelHelpers.export(exports, "MenuButtonWideFill", ()=>(0, _menuButtonWideFillDefault.default));
parcelHelpers.export(exports, "MenuButtonWide", ()=>(0, _menuButtonWideDefault.default));
parcelHelpers.export(exports, "MenuButton", ()=>(0, _menuButtonDefault.default));
parcelHelpers.export(exports, "MenuDown", ()=>(0, _menuDownDefault.default));
parcelHelpers.export(exports, "MenuUp", ()=>(0, _menuUpDefault.default));
parcelHelpers.export(exports, "Messenger", ()=>(0, _messengerDefault.default));
parcelHelpers.export(exports, "Meta", ()=>(0, _metaDefault.default));
parcelHelpers.export(exports, "MicFill", ()=>(0, _micFillDefault.default));
parcelHelpers.export(exports, "MicMuteFill", ()=>(0, _micMuteFillDefault.default));
parcelHelpers.export(exports, "MicMute", ()=>(0, _micMuteDefault.default));
parcelHelpers.export(exports, "Mic", ()=>(0, _micDefault.default));
parcelHelpers.export(exports, "MicrosoftTeams", ()=>(0, _microsoftTeamsDefault.default));
parcelHelpers.export(exports, "Microsoft", ()=>(0, _microsoftDefault.default));
parcelHelpers.export(exports, "MinecartLoaded", ()=>(0, _minecartLoadedDefault.default));
parcelHelpers.export(exports, "Minecart", ()=>(0, _minecartDefault.default));
parcelHelpers.export(exports, "ModemFill", ()=>(0, _modemFillDefault.default));
parcelHelpers.export(exports, "Modem", ()=>(0, _modemDefault.default));
parcelHelpers.export(exports, "Moisture", ()=>(0, _moistureDefault.default));
parcelHelpers.export(exports, "MoonFill", ()=>(0, _moonFillDefault.default));
parcelHelpers.export(exports, "MoonStarsFill", ()=>(0, _moonStarsFillDefault.default));
parcelHelpers.export(exports, "MoonStars", ()=>(0, _moonStarsDefault.default));
parcelHelpers.export(exports, "Moon", ()=>(0, _moonDefault.default));
parcelHelpers.export(exports, "MortarboardFill", ()=>(0, _mortarboardFillDefault.default));
parcelHelpers.export(exports, "Mortarboard", ()=>(0, _mortarboardDefault.default));
parcelHelpers.export(exports, "MotherboardFill", ()=>(0, _motherboardFillDefault.default));
parcelHelpers.export(exports, "Motherboard", ()=>(0, _motherboardDefault.default));
parcelHelpers.export(exports, "MouseFill", ()=>(0, _mouseFillDefault.default));
parcelHelpers.export(exports, "Mouse", ()=>(0, _mouseDefault.default));
parcelHelpers.export(exports, "Mouse2Fill", ()=>(0, _mouse2FillDefault.default));
parcelHelpers.export(exports, "Mouse2", ()=>(0, _mouse2Default.default));
parcelHelpers.export(exports, "Mouse3Fill", ()=>(0, _mouse3FillDefault.default));
parcelHelpers.export(exports, "Mouse3", ()=>(0, _mouse3Default.default));
parcelHelpers.export(exports, "MusicNoteBeamed", ()=>(0, _musicNoteBeamedDefault.default));
parcelHelpers.export(exports, "MusicNoteList", ()=>(0, _musicNoteListDefault.default));
parcelHelpers.export(exports, "MusicNote", ()=>(0, _musicNoteDefault.default));
parcelHelpers.export(exports, "MusicPlayerFill", ()=>(0, _musicPlayerFillDefault.default));
parcelHelpers.export(exports, "MusicPlayer", ()=>(0, _musicPlayerDefault.default));
parcelHelpers.export(exports, "Newspaper", ()=>(0, _newspaperDefault.default));
parcelHelpers.export(exports, "NintendoSwitch", ()=>(0, _nintendoSwitchDefault.default));
parcelHelpers.export(exports, "NodeMinusFill", ()=>(0, _nodeMinusFillDefault.default));
parcelHelpers.export(exports, "NodeMinus", ()=>(0, _nodeMinusDefault.default));
parcelHelpers.export(exports, "NodePlusFill", ()=>(0, _nodePlusFillDefault.default));
parcelHelpers.export(exports, "NodePlus", ()=>(0, _nodePlusDefault.default));
parcelHelpers.export(exports, "NoiseReduction", ()=>(0, _noiseReductionDefault.default));
parcelHelpers.export(exports, "NutFill", ()=>(0, _nutFillDefault.default));
parcelHelpers.export(exports, "Nut", ()=>(0, _nutDefault.default));
parcelHelpers.export(exports, "Nvidia", ()=>(0, _nvidiaDefault.default));
parcelHelpers.export(exports, "NvmeFill", ()=>(0, _nvmeFillDefault.default));
parcelHelpers.export(exports, "Nvme", ()=>(0, _nvmeDefault.default));
parcelHelpers.export(exports, "OctagonFill", ()=>(0, _octagonFillDefault.default));
parcelHelpers.export(exports, "OctagonHalf", ()=>(0, _octagonHalfDefault.default));
parcelHelpers.export(exports, "Octagon", ()=>(0, _octagonDefault.default));
parcelHelpers.export(exports, "Opencollective", ()=>(0, _opencollectiveDefault.default));
parcelHelpers.export(exports, "OpticalAudioFill", ()=>(0, _opticalAudioFillDefault.default));
parcelHelpers.export(exports, "OpticalAudio", ()=>(0, _opticalAudioDefault.default));
parcelHelpers.export(exports, "Option", ()=>(0, _optionDefault.default));
parcelHelpers.export(exports, "Outlet", ()=>(0, _outletDefault.default));
parcelHelpers.export(exports, "PCircleFill", ()=>(0, _pCircleFillDefault.default));
parcelHelpers.export(exports, "PCircle", ()=>(0, _pCircleDefault.default));
parcelHelpers.export(exports, "PSquareFill", ()=>(0, _pSquareFillDefault.default));
parcelHelpers.export(exports, "PSquare", ()=>(0, _pSquareDefault.default));
parcelHelpers.export(exports, "PaintBucket", ()=>(0, _paintBucketDefault.default));
parcelHelpers.export(exports, "PaletteFill", ()=>(0, _paletteFillDefault.default));
parcelHelpers.export(exports, "Palette", ()=>(0, _paletteDefault.default));
parcelHelpers.export(exports, "Palette2", ()=>(0, _palette2Default.default));
parcelHelpers.export(exports, "Paperclip", ()=>(0, _paperclipDefault.default));
parcelHelpers.export(exports, "Paragraph", ()=>(0, _paragraphDefault.default));
parcelHelpers.export(exports, "PassFill", ()=>(0, _passFillDefault.default));
parcelHelpers.export(exports, "Pass", ()=>(0, _passDefault.default));
parcelHelpers.export(exports, "PassportFill", ()=>(0, _passportFillDefault.default));
parcelHelpers.export(exports, "Passport", ()=>(0, _passportDefault.default));
parcelHelpers.export(exports, "PatchCheckFill", ()=>(0, _patchCheckFillDefault.default));
parcelHelpers.export(exports, "PatchCheck", ()=>(0, _patchCheckDefault.default));
parcelHelpers.export(exports, "PatchExclamationFill", ()=>(0, _patchExclamationFillDefault.default));
parcelHelpers.export(exports, "PatchExclamation", ()=>(0, _patchExclamationDefault.default));
parcelHelpers.export(exports, "PatchMinusFill", ()=>(0, _patchMinusFillDefault.default));
parcelHelpers.export(exports, "PatchMinus", ()=>(0, _patchMinusDefault.default));
parcelHelpers.export(exports, "PatchPlusFill", ()=>(0, _patchPlusFillDefault.default));
parcelHelpers.export(exports, "PatchPlus", ()=>(0, _patchPlusDefault.default));
parcelHelpers.export(exports, "PatchQuestionFill", ()=>(0, _patchQuestionFillDefault.default));
parcelHelpers.export(exports, "PatchQuestion", ()=>(0, _patchQuestionDefault.default));
parcelHelpers.export(exports, "PauseBtnFill", ()=>(0, _pauseBtnFillDefault.default));
parcelHelpers.export(exports, "PauseBtn", ()=>(0, _pauseBtnDefault.default));
parcelHelpers.export(exports, "PauseCircleFill", ()=>(0, _pauseCircleFillDefault.default));
parcelHelpers.export(exports, "PauseCircle", ()=>(0, _pauseCircleDefault.default));
parcelHelpers.export(exports, "PauseFill", ()=>(0, _pauseFillDefault.default));
parcelHelpers.export(exports, "Pause", ()=>(0, _pauseDefault.default));
parcelHelpers.export(exports, "Paypal", ()=>(0, _paypalDefault.default));
parcelHelpers.export(exports, "PcDisplayHorizontal", ()=>(0, _pcDisplayHorizontalDefault.default));
parcelHelpers.export(exports, "PcDisplay", ()=>(0, _pcDisplayDefault.default));
parcelHelpers.export(exports, "PcHorizontal", ()=>(0, _pcHorizontalDefault.default));
parcelHelpers.export(exports, "Pc", ()=>(0, _pcDefault.default));
parcelHelpers.export(exports, "PciCardNetwork", ()=>(0, _pciCardNetworkDefault.default));
parcelHelpers.export(exports, "PciCardSound", ()=>(0, _pciCardSoundDefault.default));
parcelHelpers.export(exports, "PciCard", ()=>(0, _pciCardDefault.default));
parcelHelpers.export(exports, "PeaceFill", ()=>(0, _peaceFillDefault.default));
parcelHelpers.export(exports, "Peace", ()=>(0, _peaceDefault.default));
parcelHelpers.export(exports, "PenFill", ()=>(0, _penFillDefault.default));
parcelHelpers.export(exports, "Pen", ()=>(0, _penDefault.default));
parcelHelpers.export(exports, "PencilFill", ()=>(0, _pencilFillDefault.default));
parcelHelpers.export(exports, "PencilSquare", ()=>(0, _pencilSquareDefault.default));
parcelHelpers.export(exports, "Pencil", ()=>(0, _pencilDefault.default));
parcelHelpers.export(exports, "PentagonFill", ()=>(0, _pentagonFillDefault.default));
parcelHelpers.export(exports, "PentagonHalf", ()=>(0, _pentagonHalfDefault.default));
parcelHelpers.export(exports, "Pentagon", ()=>(0, _pentagonDefault.default));
parcelHelpers.export(exports, "PeopleFill", ()=>(0, _peopleFillDefault.default));
parcelHelpers.export(exports, "People", ()=>(0, _peopleDefault.default));
parcelHelpers.export(exports, "Percent", ()=>(0, _percentDefault.default));
parcelHelpers.export(exports, "PersonAdd", ()=>(0, _personAddDefault.default));
parcelHelpers.export(exports, "PersonArmsUp", ()=>(0, _personArmsUpDefault.default));
parcelHelpers.export(exports, "PersonBadgeFill", ()=>(0, _personBadgeFillDefault.default));
parcelHelpers.export(exports, "PersonBadge", ()=>(0, _personBadgeDefault.default));
parcelHelpers.export(exports, "PersonBoundingBox", ()=>(0, _personBoundingBoxDefault.default));
parcelHelpers.export(exports, "PersonCheckFill", ()=>(0, _personCheckFillDefault.default));
parcelHelpers.export(exports, "PersonCheck", ()=>(0, _personCheckDefault.default));
parcelHelpers.export(exports, "PersonCircle", ()=>(0, _personCircleDefault.default));
parcelHelpers.export(exports, "PersonDashFill", ()=>(0, _personDashFillDefault.default));
parcelHelpers.export(exports, "PersonDash", ()=>(0, _personDashDefault.default));
parcelHelpers.export(exports, "PersonDown", ()=>(0, _personDownDefault.default));
parcelHelpers.export(exports, "PersonExclamation", ()=>(0, _personExclamationDefault.default));
parcelHelpers.export(exports, "PersonFillAdd", ()=>(0, _personFillAddDefault.default));
parcelHelpers.export(exports, "PersonFillCheck", ()=>(0, _personFillCheckDefault.default));
parcelHelpers.export(exports, "PersonFillDash", ()=>(0, _personFillDashDefault.default));
parcelHelpers.export(exports, "PersonFillDown", ()=>(0, _personFillDownDefault.default));
parcelHelpers.export(exports, "PersonFillExclamation", ()=>(0, _personFillExclamationDefault.default));
parcelHelpers.export(exports, "PersonFillGear", ()=>(0, _personFillGearDefault.default));
parcelHelpers.export(exports, "PersonFillLock", ()=>(0, _personFillLockDefault.default));
parcelHelpers.export(exports, "PersonFillSlash", ()=>(0, _personFillSlashDefault.default));
parcelHelpers.export(exports, "PersonFillUp", ()=>(0, _personFillUpDefault.default));
parcelHelpers.export(exports, "PersonFillX", ()=>(0, _personFillXDefault.default));
parcelHelpers.export(exports, "PersonFill", ()=>(0, _personFillDefault.default));
parcelHelpers.export(exports, "PersonGear", ()=>(0, _personGearDefault.default));
parcelHelpers.export(exports, "PersonHeart", ()=>(0, _personHeartDefault.default));
parcelHelpers.export(exports, "PersonHearts", ()=>(0, _personHeartsDefault.default));
parcelHelpers.export(exports, "PersonLinesFill", ()=>(0, _personLinesFillDefault.default));
parcelHelpers.export(exports, "PersonLock", ()=>(0, _personLockDefault.default));
parcelHelpers.export(exports, "PersonPlusFill", ()=>(0, _personPlusFillDefault.default));
parcelHelpers.export(exports, "PersonPlus", ()=>(0, _personPlusDefault.default));
parcelHelpers.export(exports, "PersonRaisedHand", ()=>(0, _personRaisedHandDefault.default));
parcelHelpers.export(exports, "PersonRolodex", ()=>(0, _personRolodexDefault.default));
parcelHelpers.export(exports, "PersonSlash", ()=>(0, _personSlashDefault.default));
parcelHelpers.export(exports, "PersonSquare", ()=>(0, _personSquareDefault.default));
parcelHelpers.export(exports, "PersonStandingDress", ()=>(0, _personStandingDressDefault.default));
parcelHelpers.export(exports, "PersonStanding", ()=>(0, _personStandingDefault.default));
parcelHelpers.export(exports, "PersonUp", ()=>(0, _personUpDefault.default));
parcelHelpers.export(exports, "PersonVcardFill", ()=>(0, _personVcardFillDefault.default));
parcelHelpers.export(exports, "PersonVcard", ()=>(0, _personVcardDefault.default));
parcelHelpers.export(exports, "PersonVideo", ()=>(0, _personVideoDefault.default));
parcelHelpers.export(exports, "PersonVideo2", ()=>(0, _personVideo2Default.default));
parcelHelpers.export(exports, "PersonVideo3", ()=>(0, _personVideo3Default.default));
parcelHelpers.export(exports, "PersonWalking", ()=>(0, _personWalkingDefault.default));
parcelHelpers.export(exports, "PersonWheelchair", ()=>(0, _personWheelchairDefault.default));
parcelHelpers.export(exports, "PersonWorkspace", ()=>(0, _personWorkspaceDefault.default));
parcelHelpers.export(exports, "PersonXFill", ()=>(0, _personXFillDefault.default));
parcelHelpers.export(exports, "PersonX", ()=>(0, _personXDefault.default));
parcelHelpers.export(exports, "Person", ()=>(0, _personDefault.default));
parcelHelpers.export(exports, "PhoneFill", ()=>(0, _phoneFillDefault.default));
parcelHelpers.export(exports, "PhoneFlip", ()=>(0, _phoneFlipDefault.default));
parcelHelpers.export(exports, "PhoneLandscapeFill", ()=>(0, _phoneLandscapeFillDefault.default));
parcelHelpers.export(exports, "PhoneLandscape", ()=>(0, _phoneLandscapeDefault.default));
parcelHelpers.export(exports, "PhoneVibrateFill", ()=>(0, _phoneVibrateFillDefault.default));
parcelHelpers.export(exports, "PhoneVibrate", ()=>(0, _phoneVibrateDefault.default));
parcelHelpers.export(exports, "Phone", ()=>(0, _phoneDefault.default));
parcelHelpers.export(exports, "PieChartFill", ()=>(0, _pieChartFillDefault.default));
parcelHelpers.export(exports, "PieChart", ()=>(0, _pieChartDefault.default));
parcelHelpers.export(exports, "PiggyBankFill", ()=>(0, _piggyBankFillDefault.default));
parcelHelpers.export(exports, "PiggyBank", ()=>(0, _piggyBankDefault.default));
parcelHelpers.export(exports, "PinAngleFill", ()=>(0, _pinAngleFillDefault.default));
parcelHelpers.export(exports, "PinAngle", ()=>(0, _pinAngleDefault.default));
parcelHelpers.export(exports, "PinFill", ()=>(0, _pinFillDefault.default));
parcelHelpers.export(exports, "PinMapFill", ()=>(0, _pinMapFillDefault.default));
parcelHelpers.export(exports, "PinMap", ()=>(0, _pinMapDefault.default));
parcelHelpers.export(exports, "Pin", ()=>(0, _pinDefault.default));
parcelHelpers.export(exports, "Pinterest", ()=>(0, _pinterestDefault.default));
parcelHelpers.export(exports, "PipFill", ()=>(0, _pipFillDefault.default));
parcelHelpers.export(exports, "Pip", ()=>(0, _pipDefault.default));
parcelHelpers.export(exports, "PlayBtnFill", ()=>(0, _playBtnFillDefault.default));
parcelHelpers.export(exports, "PlayBtn", ()=>(0, _playBtnDefault.default));
parcelHelpers.export(exports, "PlayCircleFill", ()=>(0, _playCircleFillDefault.default));
parcelHelpers.export(exports, "PlayCircle", ()=>(0, _playCircleDefault.default));
parcelHelpers.export(exports, "PlayFill", ()=>(0, _playFillDefault.default));
parcelHelpers.export(exports, "Play", ()=>(0, _playDefault.default));
parcelHelpers.export(exports, "Playstation", ()=>(0, _playstationDefault.default));
parcelHelpers.export(exports, "PlugFill", ()=>(0, _plugFillDefault.default));
parcelHelpers.export(exports, "Plug", ()=>(0, _plugDefault.default));
parcelHelpers.export(exports, "Plugin", ()=>(0, _pluginDefault.default));
parcelHelpers.export(exports, "PlusCircleDotted", ()=>(0, _plusCircleDottedDefault.default));
parcelHelpers.export(exports, "PlusCircleFill", ()=>(0, _plusCircleFillDefault.default));
parcelHelpers.export(exports, "PlusCircle", ()=>(0, _plusCircleDefault.default));
parcelHelpers.export(exports, "PlusLg", ()=>(0, _plusLgDefault.default));
parcelHelpers.export(exports, "PlusSlashMinus", ()=>(0, _plusSlashMinusDefault.default));
parcelHelpers.export(exports, "PlusSquareDotted", ()=>(0, _plusSquareDottedDefault.default));
parcelHelpers.export(exports, "PlusSquareFill", ()=>(0, _plusSquareFillDefault.default));
parcelHelpers.export(exports, "PlusSquare", ()=>(0, _plusSquareDefault.default));
parcelHelpers.export(exports, "Plus", ()=>(0, _plusDefault.default));
parcelHelpers.export(exports, "PostageFill", ()=>(0, _postageFillDefault.default));
parcelHelpers.export(exports, "PostageHeartFill", ()=>(0, _postageHeartFillDefault.default));
parcelHelpers.export(exports, "PostageHeart", ()=>(0, _postageHeartDefault.default));
parcelHelpers.export(exports, "Postage", ()=>(0, _postageDefault.default));
parcelHelpers.export(exports, "PostcardFill", ()=>(0, _postcardFillDefault.default));
parcelHelpers.export(exports, "PostcardHeartFill", ()=>(0, _postcardHeartFillDefault.default));
parcelHelpers.export(exports, "PostcardHeart", ()=>(0, _postcardHeartDefault.default));
parcelHelpers.export(exports, "Postcard", ()=>(0, _postcardDefault.default));
parcelHelpers.export(exports, "Power", ()=>(0, _powerDefault.default));
parcelHelpers.export(exports, "Prescription", ()=>(0, _prescriptionDefault.default));
parcelHelpers.export(exports, "Prescription2", ()=>(0, _prescription2Default.default));
parcelHelpers.export(exports, "PrinterFill", ()=>(0, _printerFillDefault.default));
parcelHelpers.export(exports, "Printer", ()=>(0, _printerDefault.default));
parcelHelpers.export(exports, "ProjectorFill", ()=>(0, _projectorFillDefault.default));
parcelHelpers.export(exports, "Projector", ()=>(0, _projectorDefault.default));
parcelHelpers.export(exports, "PuzzleFill", ()=>(0, _puzzleFillDefault.default));
parcelHelpers.export(exports, "Puzzle", ()=>(0, _puzzleDefault.default));
parcelHelpers.export(exports, "QrCodeScan", ()=>(0, _qrCodeScanDefault.default));
parcelHelpers.export(exports, "QrCode", ()=>(0, _qrCodeDefault.default));
parcelHelpers.export(exports, "QuestionCircleFill", ()=>(0, _questionCircleFillDefault.default));
parcelHelpers.export(exports, "QuestionCircle", ()=>(0, _questionCircleDefault.default));
parcelHelpers.export(exports, "QuestionDiamondFill", ()=>(0, _questionDiamondFillDefault.default));
parcelHelpers.export(exports, "QuestionDiamond", ()=>(0, _questionDiamondDefault.default));
parcelHelpers.export(exports, "QuestionLg", ()=>(0, _questionLgDefault.default));
parcelHelpers.export(exports, "QuestionOctagonFill", ()=>(0, _questionOctagonFillDefault.default));
parcelHelpers.export(exports, "QuestionOctagon", ()=>(0, _questionOctagonDefault.default));
parcelHelpers.export(exports, "QuestionSquareFill", ()=>(0, _questionSquareFillDefault.default));
parcelHelpers.export(exports, "QuestionSquare", ()=>(0, _questionSquareDefault.default));
parcelHelpers.export(exports, "Question", ()=>(0, _questionDefault.default));
parcelHelpers.export(exports, "Quora", ()=>(0, _quoraDefault.default));
parcelHelpers.export(exports, "Quote", ()=>(0, _quoteDefault.default));
parcelHelpers.export(exports, "RCircleFill", ()=>(0, _rCircleFillDefault.default));
parcelHelpers.export(exports, "RCircle", ()=>(0, _rCircleDefault.default));
parcelHelpers.export(exports, "RSquareFill", ()=>(0, _rSquareFillDefault.default));
parcelHelpers.export(exports, "RSquare", ()=>(0, _rSquareDefault.default));
parcelHelpers.export(exports, "Radar", ()=>(0, _radarDefault.default));
parcelHelpers.export(exports, "Radioactive", ()=>(0, _radioactiveDefault.default));
parcelHelpers.export(exports, "Rainbow", ()=>(0, _rainbowDefault.default));
parcelHelpers.export(exports, "ReceiptCutoff", ()=>(0, _receiptCutoffDefault.default));
parcelHelpers.export(exports, "Receipt", ()=>(0, _receiptDefault.default));
parcelHelpers.export(exports, "Reception0", ()=>(0, _reception0Default.default));
parcelHelpers.export(exports, "Reception1", ()=>(0, _reception1Default.default));
parcelHelpers.export(exports, "Reception2", ()=>(0, _reception2Default.default));
parcelHelpers.export(exports, "Reception3", ()=>(0, _reception3Default.default));
parcelHelpers.export(exports, "Reception4", ()=>(0, _reception4Default.default));
parcelHelpers.export(exports, "RecordBtnFill", ()=>(0, _recordBtnFillDefault.default));
parcelHelpers.export(exports, "RecordBtn", ()=>(0, _recordBtnDefault.default));
parcelHelpers.export(exports, "RecordCircleFill", ()=>(0, _recordCircleFillDefault.default));
parcelHelpers.export(exports, "RecordCircle", ()=>(0, _recordCircleDefault.default));
parcelHelpers.export(exports, "RecordFill", ()=>(0, _recordFillDefault.default));
parcelHelpers.export(exports, "Record", ()=>(0, _recordDefault.default));
parcelHelpers.export(exports, "Record2Fill", ()=>(0, _record2FillDefault.default));
parcelHelpers.export(exports, "Record2", ()=>(0, _record2Default.default));
parcelHelpers.export(exports, "Recycle", ()=>(0, _recycleDefault.default));
parcelHelpers.export(exports, "Reddit", ()=>(0, _redditDefault.default));
parcelHelpers.export(exports, "Regex", ()=>(0, _regexDefault.default));
parcelHelpers.export(exports, "Repeat1", ()=>(0, _repeat1Default.default));
parcelHelpers.export(exports, "Repeat", ()=>(0, _repeatDefault.default));
parcelHelpers.export(exports, "ReplyAllFill", ()=>(0, _replyAllFillDefault.default));
parcelHelpers.export(exports, "ReplyAll", ()=>(0, _replyAllDefault.default));
parcelHelpers.export(exports, "ReplyFill", ()=>(0, _replyFillDefault.default));
parcelHelpers.export(exports, "Reply", ()=>(0, _replyDefault.default));
parcelHelpers.export(exports, "RewindBtnFill", ()=>(0, _rewindBtnFillDefault.default));
parcelHelpers.export(exports, "RewindBtn", ()=>(0, _rewindBtnDefault.default));
parcelHelpers.export(exports, "RewindCircleFill", ()=>(0, _rewindCircleFillDefault.default));
parcelHelpers.export(exports, "RewindCircle", ()=>(0, _rewindCircleDefault.default));
parcelHelpers.export(exports, "RewindFill", ()=>(0, _rewindFillDefault.default));
parcelHelpers.export(exports, "Rewind", ()=>(0, _rewindDefault.default));
parcelHelpers.export(exports, "Robot", ()=>(0, _robotDefault.default));
parcelHelpers.export(exports, "RocketFill", ()=>(0, _rocketFillDefault.default));
parcelHelpers.export(exports, "RocketTakeoffFill", ()=>(0, _rocketTakeoffFillDefault.default));
parcelHelpers.export(exports, "RocketTakeoff", ()=>(0, _rocketTakeoffDefault.default));
parcelHelpers.export(exports, "Rocket", ()=>(0, _rocketDefault.default));
parcelHelpers.export(exports, "RouterFill", ()=>(0, _routerFillDefault.default));
parcelHelpers.export(exports, "Router", ()=>(0, _routerDefault.default));
parcelHelpers.export(exports, "RssFill", ()=>(0, _rssFillDefault.default));
parcelHelpers.export(exports, "Rss", ()=>(0, _rssDefault.default));
parcelHelpers.export(exports, "Rulers", ()=>(0, _rulersDefault.default));
parcelHelpers.export(exports, "SafeFill", ()=>(0, _safeFillDefault.default));
parcelHelpers.export(exports, "Safe", ()=>(0, _safeDefault.default));
parcelHelpers.export(exports, "Safe2Fill", ()=>(0, _safe2FillDefault.default));
parcelHelpers.export(exports, "Safe2", ()=>(0, _safe2Default.default));
parcelHelpers.export(exports, "SaveFill", ()=>(0, _saveFillDefault.default));
parcelHelpers.export(exports, "Save", ()=>(0, _saveDefault.default));
parcelHelpers.export(exports, "Save2Fill", ()=>(0, _save2FillDefault.default));
parcelHelpers.export(exports, "Save2", ()=>(0, _save2Default.default));
parcelHelpers.export(exports, "Scissors", ()=>(0, _scissorsDefault.default));
parcelHelpers.export(exports, "Scooter", ()=>(0, _scooterDefault.default));
parcelHelpers.export(exports, "Screwdriver", ()=>(0, _screwdriverDefault.default));
parcelHelpers.export(exports, "SdCardFill", ()=>(0, _sdCardFillDefault.default));
parcelHelpers.export(exports, "SdCard", ()=>(0, _sdCardDefault.default));
parcelHelpers.export(exports, "SearchHeartFill", ()=>(0, _searchHeartFillDefault.default));
parcelHelpers.export(exports, "SearchHeart", ()=>(0, _searchHeartDefault.default));
parcelHelpers.export(exports, "Search", ()=>(0, _searchDefault.default));
parcelHelpers.export(exports, "SegmentedNav", ()=>(0, _segmentedNavDefault.default));
parcelHelpers.export(exports, "SendArrowDownFill", ()=>(0, _sendArrowDownFillDefault.default));
parcelHelpers.export(exports, "SendArrowDown", ()=>(0, _sendArrowDownDefault.default));
parcelHelpers.export(exports, "SendArrowUpFill", ()=>(0, _sendArrowUpFillDefault.default));
parcelHelpers.export(exports, "SendArrowUp", ()=>(0, _sendArrowUpDefault.default));
parcelHelpers.export(exports, "SendCheckFill", ()=>(0, _sendCheckFillDefault.default));
parcelHelpers.export(exports, "SendCheck", ()=>(0, _sendCheckDefault.default));
parcelHelpers.export(exports, "SendDashFill", ()=>(0, _sendDashFillDefault.default));
parcelHelpers.export(exports, "SendDash", ()=>(0, _sendDashDefault.default));
parcelHelpers.export(exports, "SendExclamationFill", ()=>(0, _sendExclamationFillDefault.default));
parcelHelpers.export(exports, "SendExclamation", ()=>(0, _sendExclamationDefault.default));
parcelHelpers.export(exports, "SendFill", ()=>(0, _sendFillDefault.default));
parcelHelpers.export(exports, "SendPlusFill", ()=>(0, _sendPlusFillDefault.default));
parcelHelpers.export(exports, "SendPlus", ()=>(0, _sendPlusDefault.default));
parcelHelpers.export(exports, "SendSlashFill", ()=>(0, _sendSlashFillDefault.default));
parcelHelpers.export(exports, "SendSlash", ()=>(0, _sendSlashDefault.default));
parcelHelpers.export(exports, "SendXFill", ()=>(0, _sendXFillDefault.default));
parcelHelpers.export(exports, "SendX", ()=>(0, _sendXDefault.default));
parcelHelpers.export(exports, "Send", ()=>(0, _sendDefault.default));
parcelHelpers.export(exports, "Server", ()=>(0, _serverDefault.default));
parcelHelpers.export(exports, "Shadows", ()=>(0, _shadowsDefault.default));
parcelHelpers.export(exports, "ShareFill", ()=>(0, _shareFillDefault.default));
parcelHelpers.export(exports, "Share", ()=>(0, _shareDefault.default));
parcelHelpers.export(exports, "ShieldCheck", ()=>(0, _shieldCheckDefault.default));
parcelHelpers.export(exports, "ShieldExclamation", ()=>(0, _shieldExclamationDefault.default));
parcelHelpers.export(exports, "ShieldFillCheck", ()=>(0, _shieldFillCheckDefault.default));
parcelHelpers.export(exports, "ShieldFillExclamation", ()=>(0, _shieldFillExclamationDefault.default));
parcelHelpers.export(exports, "ShieldFillMinus", ()=>(0, _shieldFillMinusDefault.default));
parcelHelpers.export(exports, "ShieldFillPlus", ()=>(0, _shieldFillPlusDefault.default));
parcelHelpers.export(exports, "ShieldFillX", ()=>(0, _shieldFillXDefault.default));
parcelHelpers.export(exports, "ShieldFill", ()=>(0, _shieldFillDefault.default));
parcelHelpers.export(exports, "ShieldLockFill", ()=>(0, _shieldLockFillDefault.default));
parcelHelpers.export(exports, "ShieldLock", ()=>(0, _shieldLockDefault.default));
parcelHelpers.export(exports, "ShieldMinus", ()=>(0, _shieldMinusDefault.default));
parcelHelpers.export(exports, "ShieldPlus", ()=>(0, _shieldPlusDefault.default));
parcelHelpers.export(exports, "ShieldShaded", ()=>(0, _shieldShadedDefault.default));
parcelHelpers.export(exports, "ShieldSlashFill", ()=>(0, _shieldSlashFillDefault.default));
parcelHelpers.export(exports, "ShieldSlash", ()=>(0, _shieldSlashDefault.default));
parcelHelpers.export(exports, "ShieldX", ()=>(0, _shieldXDefault.default));
parcelHelpers.export(exports, "Shield", ()=>(0, _shieldDefault.default));
parcelHelpers.export(exports, "ShiftFill", ()=>(0, _shiftFillDefault.default));
parcelHelpers.export(exports, "Shift", ()=>(0, _shiftDefault.default));
parcelHelpers.export(exports, "ShopWindow", ()=>(0, _shopWindowDefault.default));
parcelHelpers.export(exports, "Shop", ()=>(0, _shopDefault.default));
parcelHelpers.export(exports, "Shuffle", ()=>(0, _shuffleDefault.default));
parcelHelpers.export(exports, "SignDeadEndFill", ()=>(0, _signDeadEndFillDefault.default));
parcelHelpers.export(exports, "SignDeadEnd", ()=>(0, _signDeadEndDefault.default));
parcelHelpers.export(exports, "SignDoNotEnterFill", ()=>(0, _signDoNotEnterFillDefault.default));
parcelHelpers.export(exports, "SignDoNotEnter", ()=>(0, _signDoNotEnterDefault.default));
parcelHelpers.export(exports, "SignIntersectionFill", ()=>(0, _signIntersectionFillDefault.default));
parcelHelpers.export(exports, "SignIntersectionSideFill", ()=>(0, _signIntersectionSideFillDefault.default));
parcelHelpers.export(exports, "SignIntersectionSide", ()=>(0, _signIntersectionSideDefault.default));
parcelHelpers.export(exports, "SignIntersectionTFill", ()=>(0, _signIntersectionTFillDefault.default));
parcelHelpers.export(exports, "SignIntersectionT", ()=>(0, _signIntersectionTDefault.default));
parcelHelpers.export(exports, "SignIntersectionYFill", ()=>(0, _signIntersectionYFillDefault.default));
parcelHelpers.export(exports, "SignIntersectionY", ()=>(0, _signIntersectionYDefault.default));
parcelHelpers.export(exports, "SignIntersection", ()=>(0, _signIntersectionDefault.default));
parcelHelpers.export(exports, "SignMergeLeftFill", ()=>(0, _signMergeLeftFillDefault.default));
parcelHelpers.export(exports, "SignMergeLeft", ()=>(0, _signMergeLeftDefault.default));
parcelHelpers.export(exports, "SignMergeRightFill", ()=>(0, _signMergeRightFillDefault.default));
parcelHelpers.export(exports, "SignMergeRight", ()=>(0, _signMergeRightDefault.default));
parcelHelpers.export(exports, "SignNoLeftTurnFill", ()=>(0, _signNoLeftTurnFillDefault.default));
parcelHelpers.export(exports, "SignNoLeftTurn", ()=>(0, _signNoLeftTurnDefault.default));
parcelHelpers.export(exports, "SignNoParkingFill", ()=>(0, _signNoParkingFillDefault.default));
parcelHelpers.export(exports, "SignNoParking", ()=>(0, _signNoParkingDefault.default));
parcelHelpers.export(exports, "SignNoRightTurnFill", ()=>(0, _signNoRightTurnFillDefault.default));
parcelHelpers.export(exports, "SignNoRightTurn", ()=>(0, _signNoRightTurnDefault.default));
parcelHelpers.export(exports, "SignRailroadFill", ()=>(0, _signRailroadFillDefault.default));
parcelHelpers.export(exports, "SignRailroad", ()=>(0, _signRailroadDefault.default));
parcelHelpers.export(exports, "SignStopFill", ()=>(0, _signStopFillDefault.default));
parcelHelpers.export(exports, "SignStopLightsFill", ()=>(0, _signStopLightsFillDefault.default));
parcelHelpers.export(exports, "SignStopLights", ()=>(0, _signStopLightsDefault.default));
parcelHelpers.export(exports, "SignStop", ()=>(0, _signStopDefault.default));
parcelHelpers.export(exports, "SignTurnLeftFill", ()=>(0, _signTurnLeftFillDefault.default));
parcelHelpers.export(exports, "SignTurnLeft", ()=>(0, _signTurnLeftDefault.default));
parcelHelpers.export(exports, "SignTurnRightFill", ()=>(0, _signTurnRightFillDefault.default));
parcelHelpers.export(exports, "SignTurnRight", ()=>(0, _signTurnRightDefault.default));
parcelHelpers.export(exports, "SignTurnSlightLeftFill", ()=>(0, _signTurnSlightLeftFillDefault.default));
parcelHelpers.export(exports, "SignTurnSlightLeft", ()=>(0, _signTurnSlightLeftDefault.default));
parcelHelpers.export(exports, "SignTurnSlightRightFill", ()=>(0, _signTurnSlightRightFillDefault.default));
parcelHelpers.export(exports, "SignTurnSlightRight", ()=>(0, _signTurnSlightRightDefault.default));
parcelHelpers.export(exports, "SignYieldFill", ()=>(0, _signYieldFillDefault.default));
parcelHelpers.export(exports, "SignYield", ()=>(0, _signYieldDefault.default));
parcelHelpers.export(exports, "Signal", ()=>(0, _signalDefault.default));
parcelHelpers.export(exports, "Signpost2Fill", ()=>(0, _signpost2FillDefault.default));
parcelHelpers.export(exports, "Signpost2", ()=>(0, _signpost2Default.default));
parcelHelpers.export(exports, "SignpostFill", ()=>(0, _signpostFillDefault.default));
parcelHelpers.export(exports, "SignpostSplitFill", ()=>(0, _signpostSplitFillDefault.default));
parcelHelpers.export(exports, "SignpostSplit", ()=>(0, _signpostSplitDefault.default));
parcelHelpers.export(exports, "Signpost", ()=>(0, _signpostDefault.default));
parcelHelpers.export(exports, "SimFill", ()=>(0, _simFillDefault.default));
parcelHelpers.export(exports, "SimSlashFill", ()=>(0, _simSlashFillDefault.default));
parcelHelpers.export(exports, "SimSlash", ()=>(0, _simSlashDefault.default));
parcelHelpers.export(exports, "Sim", ()=>(0, _simDefault.default));
parcelHelpers.export(exports, "SinaWeibo", ()=>(0, _sinaWeiboDefault.default));
parcelHelpers.export(exports, "SkipBackwardBtnFill", ()=>(0, _skipBackwardBtnFillDefault.default));
parcelHelpers.export(exports, "SkipBackwardBtn", ()=>(0, _skipBackwardBtnDefault.default));
parcelHelpers.export(exports, "SkipBackwardCircleFill", ()=>(0, _skipBackwardCircleFillDefault.default));
parcelHelpers.export(exports, "SkipBackwardCircle", ()=>(0, _skipBackwardCircleDefault.default));
parcelHelpers.export(exports, "SkipBackwardFill", ()=>(0, _skipBackwardFillDefault.default));
parcelHelpers.export(exports, "SkipBackward", ()=>(0, _skipBackwardDefault.default));
parcelHelpers.export(exports, "SkipEndBtnFill", ()=>(0, _skipEndBtnFillDefault.default));
parcelHelpers.export(exports, "SkipEndBtn", ()=>(0, _skipEndBtnDefault.default));
parcelHelpers.export(exports, "SkipEndCircleFill", ()=>(0, _skipEndCircleFillDefault.default));
parcelHelpers.export(exports, "SkipEndCircle", ()=>(0, _skipEndCircleDefault.default));
parcelHelpers.export(exports, "SkipEndFill", ()=>(0, _skipEndFillDefault.default));
parcelHelpers.export(exports, "SkipEnd", ()=>(0, _skipEndDefault.default));
parcelHelpers.export(exports, "SkipForwardBtnFill", ()=>(0, _skipForwardBtnFillDefault.default));
parcelHelpers.export(exports, "SkipForwardBtn", ()=>(0, _skipForwardBtnDefault.default));
parcelHelpers.export(exports, "SkipForwardCircleFill", ()=>(0, _skipForwardCircleFillDefault.default));
parcelHelpers.export(exports, "SkipForwardCircle", ()=>(0, _skipForwardCircleDefault.default));
parcelHelpers.export(exports, "SkipForwardFill", ()=>(0, _skipForwardFillDefault.default));
parcelHelpers.export(exports, "SkipForward", ()=>(0, _skipForwardDefault.default));
parcelHelpers.export(exports, "SkipStartBtnFill", ()=>(0, _skipStartBtnFillDefault.default));
parcelHelpers.export(exports, "SkipStartBtn", ()=>(0, _skipStartBtnDefault.default));
parcelHelpers.export(exports, "SkipStartCircleFill", ()=>(0, _skipStartCircleFillDefault.default));
parcelHelpers.export(exports, "SkipStartCircle", ()=>(0, _skipStartCircleDefault.default));
parcelHelpers.export(exports, "SkipStartFill", ()=>(0, _skipStartFillDefault.default));
parcelHelpers.export(exports, "SkipStart", ()=>(0, _skipStartDefault.default));
parcelHelpers.export(exports, "Skype", ()=>(0, _skypeDefault.default));
parcelHelpers.export(exports, "Slack", ()=>(0, _slackDefault.default));
parcelHelpers.export(exports, "SlashCircleFill", ()=>(0, _slashCircleFillDefault.default));
parcelHelpers.export(exports, "SlashCircle", ()=>(0, _slashCircleDefault.default));
parcelHelpers.export(exports, "SlashLg", ()=>(0, _slashLgDefault.default));
parcelHelpers.export(exports, "SlashSquareFill", ()=>(0, _slashSquareFillDefault.default));
parcelHelpers.export(exports, "SlashSquare", ()=>(0, _slashSquareDefault.default));
parcelHelpers.export(exports, "Slash", ()=>(0, _slashDefault.default));
parcelHelpers.export(exports, "Sliders", ()=>(0, _slidersDefault.default));
parcelHelpers.export(exports, "Sliders2Vertical", ()=>(0, _sliders2VerticalDefault.default));
parcelHelpers.export(exports, "Sliders2", ()=>(0, _sliders2Default.default));
parcelHelpers.export(exports, "Smartwatch", ()=>(0, _smartwatchDefault.default));
parcelHelpers.export(exports, "Snapchat", ()=>(0, _snapchatDefault.default));
parcelHelpers.export(exports, "Snow", ()=>(0, _snowDefault.default));
parcelHelpers.export(exports, "Snow2", ()=>(0, _snow2Default.default));
parcelHelpers.export(exports, "Snow3", ()=>(0, _snow3Default.default));
parcelHelpers.export(exports, "SortAlphaDownAlt", ()=>(0, _sortAlphaDownAltDefault.default));
parcelHelpers.export(exports, "SortAlphaDown", ()=>(0, _sortAlphaDownDefault.default));
parcelHelpers.export(exports, "SortAlphaUpAlt", ()=>(0, _sortAlphaUpAltDefault.default));
parcelHelpers.export(exports, "SortAlphaUp", ()=>(0, _sortAlphaUpDefault.default));
parcelHelpers.export(exports, "SortDownAlt", ()=>(0, _sortDownAltDefault.default));
parcelHelpers.export(exports, "SortDown", ()=>(0, _sortDownDefault.default));
parcelHelpers.export(exports, "SortNumericDownAlt", ()=>(0, _sortNumericDownAltDefault.default));
parcelHelpers.export(exports, "SortNumericDown", ()=>(0, _sortNumericDownDefault.default));
parcelHelpers.export(exports, "SortNumericUpAlt", ()=>(0, _sortNumericUpAltDefault.default));
parcelHelpers.export(exports, "SortNumericUp", ()=>(0, _sortNumericUpDefault.default));
parcelHelpers.export(exports, "SortUpAlt", ()=>(0, _sortUpAltDefault.default));
parcelHelpers.export(exports, "SortUp", ()=>(0, _sortUpDefault.default));
parcelHelpers.export(exports, "Soundwave", ()=>(0, _soundwaveDefault.default));
parcelHelpers.export(exports, "Sourceforge", ()=>(0, _sourceforgeDefault.default));
parcelHelpers.export(exports, "SpeakerFill", ()=>(0, _speakerFillDefault.default));
parcelHelpers.export(exports, "Speaker", ()=>(0, _speakerDefault.default));
parcelHelpers.export(exports, "Speedometer", ()=>(0, _speedometerDefault.default));
parcelHelpers.export(exports, "Speedometer2", ()=>(0, _speedometer2Default.default));
parcelHelpers.export(exports, "Spellcheck", ()=>(0, _spellcheckDefault.default));
parcelHelpers.export(exports, "Spotify", ()=>(0, _spotifyDefault.default));
parcelHelpers.export(exports, "SquareFill", ()=>(0, _squareFillDefault.default));
parcelHelpers.export(exports, "SquareHalf", ()=>(0, _squareHalfDefault.default));
parcelHelpers.export(exports, "Square", ()=>(0, _squareDefault.default));
parcelHelpers.export(exports, "StackOverflow", ()=>(0, _stackOverflowDefault.default));
parcelHelpers.export(exports, "Stack", ()=>(0, _stackDefault.default));
parcelHelpers.export(exports, "StarFill", ()=>(0, _starFillDefault.default));
parcelHelpers.export(exports, "StarHalf", ()=>(0, _starHalfDefault.default));
parcelHelpers.export(exports, "Star", ()=>(0, _starDefault.default));
parcelHelpers.export(exports, "Stars", ()=>(0, _starsDefault.default));
parcelHelpers.export(exports, "Steam", ()=>(0, _steamDefault.default));
parcelHelpers.export(exports, "StickiesFill", ()=>(0, _stickiesFillDefault.default));
parcelHelpers.export(exports, "Stickies", ()=>(0, _stickiesDefault.default));
parcelHelpers.export(exports, "StickyFill", ()=>(0, _stickyFillDefault.default));
parcelHelpers.export(exports, "Sticky", ()=>(0, _stickyDefault.default));
parcelHelpers.export(exports, "StopBtnFill", ()=>(0, _stopBtnFillDefault.default));
parcelHelpers.export(exports, "StopBtn", ()=>(0, _stopBtnDefault.default));
parcelHelpers.export(exports, "StopCircleFill", ()=>(0, _stopCircleFillDefault.default));
parcelHelpers.export(exports, "StopCircle", ()=>(0, _stopCircleDefault.default));
parcelHelpers.export(exports, "StopFill", ()=>(0, _stopFillDefault.default));
parcelHelpers.export(exports, "Stop", ()=>(0, _stopDefault.default));
parcelHelpers.export(exports, "StoplightsFill", ()=>(0, _stoplightsFillDefault.default));
parcelHelpers.export(exports, "Stoplights", ()=>(0, _stoplightsDefault.default));
parcelHelpers.export(exports, "StopwatchFill", ()=>(0, _stopwatchFillDefault.default));
parcelHelpers.export(exports, "Stopwatch", ()=>(0, _stopwatchDefault.default));
parcelHelpers.export(exports, "Strava", ()=>(0, _stravaDefault.default));
parcelHelpers.export(exports, "Stripe", ()=>(0, _stripeDefault.default));
parcelHelpers.export(exports, "Subscript", ()=>(0, _subscriptDefault.default));
parcelHelpers.export(exports, "Substack", ()=>(0, _substackDefault.default));
parcelHelpers.export(exports, "Subtract", ()=>(0, _subtractDefault.default));
parcelHelpers.export(exports, "SuitClubFill", ()=>(0, _suitClubFillDefault.default));
parcelHelpers.export(exports, "SuitClub", ()=>(0, _suitClubDefault.default));
parcelHelpers.export(exports, "SuitDiamondFill", ()=>(0, _suitDiamondFillDefault.default));
parcelHelpers.export(exports, "SuitDiamond", ()=>(0, _suitDiamondDefault.default));
parcelHelpers.export(exports, "SuitHeartFill", ()=>(0, _suitHeartFillDefault.default));
parcelHelpers.export(exports, "SuitHeart", ()=>(0, _suitHeartDefault.default));
parcelHelpers.export(exports, "SuitSpadeFill", ()=>(0, _suitSpadeFillDefault.default));
parcelHelpers.export(exports, "SuitSpade", ()=>(0, _suitSpadeDefault.default));
parcelHelpers.export(exports, "SuitcaseFill", ()=>(0, _suitcaseFillDefault.default));
parcelHelpers.export(exports, "SuitcaseLgFill", ()=>(0, _suitcaseLgFillDefault.default));
parcelHelpers.export(exports, "SuitcaseLg", ()=>(0, _suitcaseLgDefault.default));
parcelHelpers.export(exports, "Suitcase", ()=>(0, _suitcaseDefault.default));
parcelHelpers.export(exports, "Suitcase2Fill", ()=>(0, _suitcase2FillDefault.default));
parcelHelpers.export(exports, "Suitcase2", ()=>(0, _suitcase2Default.default));
parcelHelpers.export(exports, "SunFill", ()=>(0, _sunFillDefault.default));
parcelHelpers.export(exports, "Sun", ()=>(0, _sunDefault.default));
parcelHelpers.export(exports, "Sunglasses", ()=>(0, _sunglassesDefault.default));
parcelHelpers.export(exports, "SunriseFill", ()=>(0, _sunriseFillDefault.default));
parcelHelpers.export(exports, "Sunrise", ()=>(0, _sunriseDefault.default));
parcelHelpers.export(exports, "SunsetFill", ()=>(0, _sunsetFillDefault.default));
parcelHelpers.export(exports, "Sunset", ()=>(0, _sunsetDefault.default));
parcelHelpers.export(exports, "Superscript", ()=>(0, _superscriptDefault.default));
parcelHelpers.export(exports, "SymmetryHorizontal", ()=>(0, _symmetryHorizontalDefault.default));
parcelHelpers.export(exports, "SymmetryVertical", ()=>(0, _symmetryVerticalDefault.default));
parcelHelpers.export(exports, "Table", ()=>(0, _tableDefault.default));
parcelHelpers.export(exports, "TabletFill", ()=>(0, _tabletFillDefault.default));
parcelHelpers.export(exports, "TabletLandscapeFill", ()=>(0, _tabletLandscapeFillDefault.default));
parcelHelpers.export(exports, "TabletLandscape", ()=>(0, _tabletLandscapeDefault.default));
parcelHelpers.export(exports, "Tablet", ()=>(0, _tabletDefault.default));
parcelHelpers.export(exports, "TagFill", ()=>(0, _tagFillDefault.default));
parcelHelpers.export(exports, "Tag", ()=>(0, _tagDefault.default));
parcelHelpers.export(exports, "TagsFill", ()=>(0, _tagsFillDefault.default));
parcelHelpers.export(exports, "Tags", ()=>(0, _tagsDefault.default));
parcelHelpers.export(exports, "TaxiFrontFill", ()=>(0, _taxiFrontFillDefault.default));
parcelHelpers.export(exports, "TaxiFront", ()=>(0, _taxiFrontDefault.default));
parcelHelpers.export(exports, "Telegram", ()=>(0, _telegramDefault.default));
parcelHelpers.export(exports, "TelephoneFill", ()=>(0, _telephoneFillDefault.default));
parcelHelpers.export(exports, "TelephoneForwardFill", ()=>(0, _telephoneForwardFillDefault.default));
parcelHelpers.export(exports, "TelephoneForward", ()=>(0, _telephoneForwardDefault.default));
parcelHelpers.export(exports, "TelephoneInboundFill", ()=>(0, _telephoneInboundFillDefault.default));
parcelHelpers.export(exports, "TelephoneInbound", ()=>(0, _telephoneInboundDefault.default));
parcelHelpers.export(exports, "TelephoneMinusFill", ()=>(0, _telephoneMinusFillDefault.default));
parcelHelpers.export(exports, "TelephoneMinus", ()=>(0, _telephoneMinusDefault.default));
parcelHelpers.export(exports, "TelephoneOutboundFill", ()=>(0, _telephoneOutboundFillDefault.default));
parcelHelpers.export(exports, "TelephoneOutbound", ()=>(0, _telephoneOutboundDefault.default));
parcelHelpers.export(exports, "TelephonePlusFill", ()=>(0, _telephonePlusFillDefault.default));
parcelHelpers.export(exports, "TelephonePlus", ()=>(0, _telephonePlusDefault.default));
parcelHelpers.export(exports, "TelephoneXFill", ()=>(0, _telephoneXFillDefault.default));
parcelHelpers.export(exports, "TelephoneX", ()=>(0, _telephoneXDefault.default));
parcelHelpers.export(exports, "Telephone", ()=>(0, _telephoneDefault.default));
parcelHelpers.export(exports, "TencentQq", ()=>(0, _tencentQqDefault.default));
parcelHelpers.export(exports, "TerminalDash", ()=>(0, _terminalDashDefault.default));
parcelHelpers.export(exports, "TerminalFill", ()=>(0, _terminalFillDefault.default));
parcelHelpers.export(exports, "TerminalPlus", ()=>(0, _terminalPlusDefault.default));
parcelHelpers.export(exports, "TerminalSplit", ()=>(0, _terminalSplitDefault.default));
parcelHelpers.export(exports, "TerminalX", ()=>(0, _terminalXDefault.default));
parcelHelpers.export(exports, "Terminal", ()=>(0, _terminalDefault.default));
parcelHelpers.export(exports, "TextCenter", ()=>(0, _textCenterDefault.default));
parcelHelpers.export(exports, "TextIndentLeft", ()=>(0, _textIndentLeftDefault.default));
parcelHelpers.export(exports, "TextIndentRight", ()=>(0, _textIndentRightDefault.default));
parcelHelpers.export(exports, "TextLeft", ()=>(0, _textLeftDefault.default));
parcelHelpers.export(exports, "TextParagraph", ()=>(0, _textParagraphDefault.default));
parcelHelpers.export(exports, "TextRight", ()=>(0, _textRightDefault.default));
parcelHelpers.export(exports, "TextWrap", ()=>(0, _textWrapDefault.default));
parcelHelpers.export(exports, "TextareaResize", ()=>(0, _textareaResizeDefault.default));
parcelHelpers.export(exports, "TextareaT", ()=>(0, _textareaTDefault.default));
parcelHelpers.export(exports, "Textarea", ()=>(0, _textareaDefault.default));
parcelHelpers.export(exports, "ThermometerHalf", ()=>(0, _thermometerHalfDefault.default));
parcelHelpers.export(exports, "ThermometerHigh", ()=>(0, _thermometerHighDefault.default));
parcelHelpers.export(exports, "ThermometerLow", ()=>(0, _thermometerLowDefault.default));
parcelHelpers.export(exports, "ThermometerSnow", ()=>(0, _thermometerSnowDefault.default));
parcelHelpers.export(exports, "ThermometerSun", ()=>(0, _thermometerSunDefault.default));
parcelHelpers.export(exports, "Thermometer", ()=>(0, _thermometerDefault.default));
parcelHelpers.export(exports, "ThreadsFill", ()=>(0, _threadsFillDefault.default));
parcelHelpers.export(exports, "Threads", ()=>(0, _threadsDefault.default));
parcelHelpers.export(exports, "ThreeDotsVertical", ()=>(0, _threeDotsVerticalDefault.default));
parcelHelpers.export(exports, "ThreeDots", ()=>(0, _threeDotsDefault.default));
parcelHelpers.export(exports, "ThunderboltFill", ()=>(0, _thunderboltFillDefault.default));
parcelHelpers.export(exports, "Thunderbolt", ()=>(0, _thunderboltDefault.default));
parcelHelpers.export(exports, "TicketDetailedFill", ()=>(0, _ticketDetailedFillDefault.default));
parcelHelpers.export(exports, "TicketDetailed", ()=>(0, _ticketDetailedDefault.default));
parcelHelpers.export(exports, "TicketFill", ()=>(0, _ticketFillDefault.default));
parcelHelpers.export(exports, "TicketPerforatedFill", ()=>(0, _ticketPerforatedFillDefault.default));
parcelHelpers.export(exports, "TicketPerforated", ()=>(0, _ticketPerforatedDefault.default));
parcelHelpers.export(exports, "Ticket", ()=>(0, _ticketDefault.default));
parcelHelpers.export(exports, "Tiktok", ()=>(0, _tiktokDefault.default));
parcelHelpers.export(exports, "ToggleOff", ()=>(0, _toggleOffDefault.default));
parcelHelpers.export(exports, "ToggleOn", ()=>(0, _toggleOnDefault.default));
parcelHelpers.export(exports, "Toggle2Off", ()=>(0, _toggle2OffDefault.default));
parcelHelpers.export(exports, "Toggle2On", ()=>(0, _toggle2OnDefault.default));
parcelHelpers.export(exports, "Toggles", ()=>(0, _togglesDefault.default));
parcelHelpers.export(exports, "Toggles2", ()=>(0, _toggles2Default.default));
parcelHelpers.export(exports, "Tools", ()=>(0, _toolsDefault.default));
parcelHelpers.export(exports, "Tornado", ()=>(0, _tornadoDefault.default));
parcelHelpers.export(exports, "TrainFreightFrontFill", ()=>(0, _trainFreightFrontFillDefault.default));
parcelHelpers.export(exports, "TrainFreightFront", ()=>(0, _trainFreightFrontDefault.default));
parcelHelpers.export(exports, "TrainFrontFill", ()=>(0, _trainFrontFillDefault.default));
parcelHelpers.export(exports, "TrainFront", ()=>(0, _trainFrontDefault.default));
parcelHelpers.export(exports, "TrainLightrailFrontFill", ()=>(0, _trainLightrailFrontFillDefault.default));
parcelHelpers.export(exports, "TrainLightrailFront", ()=>(0, _trainLightrailFrontDefault.default));
parcelHelpers.export(exports, "Translate", ()=>(0, _translateDefault.default));
parcelHelpers.export(exports, "Transparency", ()=>(0, _transparencyDefault.default));
parcelHelpers.export(exports, "TrashFill", ()=>(0, _trashFillDefault.default));
parcelHelpers.export(exports, "Trash", ()=>(0, _trashDefault.default));
parcelHelpers.export(exports, "Trash2Fill", ()=>(0, _trash2FillDefault.default));
parcelHelpers.export(exports, "Trash2", ()=>(0, _trash2Default.default));
parcelHelpers.export(exports, "Trash3Fill", ()=>(0, _trash3FillDefault.default));
parcelHelpers.export(exports, "Trash3", ()=>(0, _trash3Default.default));
parcelHelpers.export(exports, "TreeFill", ()=>(0, _treeFillDefault.default));
parcelHelpers.export(exports, "Tree", ()=>(0, _treeDefault.default));
parcelHelpers.export(exports, "Trello", ()=>(0, _trelloDefault.default));
parcelHelpers.export(exports, "TriangleFill", ()=>(0, _triangleFillDefault.default));
parcelHelpers.export(exports, "TriangleHalf", ()=>(0, _triangleHalfDefault.default));
parcelHelpers.export(exports, "Triangle", ()=>(0, _triangleDefault.default));
parcelHelpers.export(exports, "TrophyFill", ()=>(0, _trophyFillDefault.default));
parcelHelpers.export(exports, "Trophy", ()=>(0, _trophyDefault.default));
parcelHelpers.export(exports, "TropicalStorm", ()=>(0, _tropicalStormDefault.default));
parcelHelpers.export(exports, "TruckFlatbed", ()=>(0, _truckFlatbedDefault.default));
parcelHelpers.export(exports, "TruckFrontFill", ()=>(0, _truckFrontFillDefault.default));
parcelHelpers.export(exports, "TruckFront", ()=>(0, _truckFrontDefault.default));
parcelHelpers.export(exports, "Truck", ()=>(0, _truckDefault.default));
parcelHelpers.export(exports, "Tsunami", ()=>(0, _tsunamiDefault.default));
parcelHelpers.export(exports, "TvFill", ()=>(0, _tvFillDefault.default));
parcelHelpers.export(exports, "Tv", ()=>(0, _tvDefault.default));
parcelHelpers.export(exports, "Twitch", ()=>(0, _twitchDefault.default));
parcelHelpers.export(exports, "TwitterX", ()=>(0, _twitterXDefault.default));
parcelHelpers.export(exports, "Twitter", ()=>(0, _twitterDefault.default));
parcelHelpers.export(exports, "TypeBold", ()=>(0, _typeBoldDefault.default));
parcelHelpers.export(exports, "TypeH1", ()=>(0, _typeH1Default.default));
parcelHelpers.export(exports, "TypeH2", ()=>(0, _typeH2Default.default));
parcelHelpers.export(exports, "TypeH3", ()=>(0, _typeH3Default.default));
parcelHelpers.export(exports, "TypeH4", ()=>(0, _typeH4Default.default));
parcelHelpers.export(exports, "TypeH5", ()=>(0, _typeH5Default.default));
parcelHelpers.export(exports, "TypeH6", ()=>(0, _typeH6Default.default));
parcelHelpers.export(exports, "TypeItalic", ()=>(0, _typeItalicDefault.default));
parcelHelpers.export(exports, "TypeStrikethrough", ()=>(0, _typeStrikethroughDefault.default));
parcelHelpers.export(exports, "TypeUnderline", ()=>(0, _typeUnderlineDefault.default));
parcelHelpers.export(exports, "Type", ()=>(0, _typeDefault.default));
parcelHelpers.export(exports, "Ubuntu", ()=>(0, _ubuntuDefault.default));
parcelHelpers.export(exports, "UiChecksGrid", ()=>(0, _uiChecksGridDefault.default));
parcelHelpers.export(exports, "UiChecks", ()=>(0, _uiChecksDefault.default));
parcelHelpers.export(exports, "UiRadiosGrid", ()=>(0, _uiRadiosGridDefault.default));
parcelHelpers.export(exports, "UiRadios", ()=>(0, _uiRadiosDefault.default));
parcelHelpers.export(exports, "UmbrellaFill", ()=>(0, _umbrellaFillDefault.default));
parcelHelpers.export(exports, "Umbrella", ()=>(0, _umbrellaDefault.default));
parcelHelpers.export(exports, "Unindent", ()=>(0, _unindentDefault.default));
parcelHelpers.export(exports, "Union", ()=>(0, _unionDefault.default));
parcelHelpers.export(exports, "Unity", ()=>(0, _unityDefault.default));
parcelHelpers.export(exports, "UniversalAccessCircle", ()=>(0, _universalAccessCircleDefault.default));
parcelHelpers.export(exports, "UniversalAccess", ()=>(0, _universalAccessDefault.default));
parcelHelpers.export(exports, "UnlockFill", ()=>(0, _unlockFillDefault.default));
parcelHelpers.export(exports, "Unlock", ()=>(0, _unlockDefault.default));
parcelHelpers.export(exports, "UpcScan", ()=>(0, _upcScanDefault.default));
parcelHelpers.export(exports, "Upc", ()=>(0, _upcDefault.default));
parcelHelpers.export(exports, "Upload", ()=>(0, _uploadDefault.default));
parcelHelpers.export(exports, "UsbCFill", ()=>(0, _usbCFillDefault.default));
parcelHelpers.export(exports, "UsbC", ()=>(0, _usbCDefault.default));
parcelHelpers.export(exports, "UsbDriveFill", ()=>(0, _usbDriveFillDefault.default));
parcelHelpers.export(exports, "UsbDrive", ()=>(0, _usbDriveDefault.default));
parcelHelpers.export(exports, "UsbFill", ()=>(0, _usbFillDefault.default));
parcelHelpers.export(exports, "UsbMicroFill", ()=>(0, _usbMicroFillDefault.default));
parcelHelpers.export(exports, "UsbMicro", ()=>(0, _usbMicroDefault.default));
parcelHelpers.export(exports, "UsbMiniFill", ()=>(0, _usbMiniFillDefault.default));
parcelHelpers.export(exports, "UsbMini", ()=>(0, _usbMiniDefault.default));
parcelHelpers.export(exports, "UsbPlugFill", ()=>(0, _usbPlugFillDefault.default));
parcelHelpers.export(exports, "UsbPlug", ()=>(0, _usbPlugDefault.default));
parcelHelpers.export(exports, "UsbSymbol", ()=>(0, _usbSymbolDefault.default));
parcelHelpers.export(exports, "Usb", ()=>(0, _usbDefault.default));
parcelHelpers.export(exports, "Valentine", ()=>(0, _valentineDefault.default));
parcelHelpers.export(exports, "Valentine2", ()=>(0, _valentine2Default.default));
parcelHelpers.export(exports, "VectorPen", ()=>(0, _vectorPenDefault.default));
parcelHelpers.export(exports, "ViewList", ()=>(0, _viewListDefault.default));
parcelHelpers.export(exports, "ViewStacked", ()=>(0, _viewStackedDefault.default));
parcelHelpers.export(exports, "Vignette", ()=>(0, _vignetteDefault.default));
parcelHelpers.export(exports, "Vimeo", ()=>(0, _vimeoDefault.default));
parcelHelpers.export(exports, "VinylFill", ()=>(0, _vinylFillDefault.default));
parcelHelpers.export(exports, "Vinyl", ()=>(0, _vinylDefault.default));
parcelHelpers.export(exports, "Virus", ()=>(0, _virusDefault.default));
parcelHelpers.export(exports, "Virus2", ()=>(0, _virus2Default.default));
parcelHelpers.export(exports, "Voicemail", ()=>(0, _voicemailDefault.default));
parcelHelpers.export(exports, "VolumeDownFill", ()=>(0, _volumeDownFillDefault.default));
parcelHelpers.export(exports, "VolumeDown", ()=>(0, _volumeDownDefault.default));
parcelHelpers.export(exports, "VolumeMuteFill", ()=>(0, _volumeMuteFillDefault.default));
parcelHelpers.export(exports, "VolumeMute", ()=>(0, _volumeMuteDefault.default));
parcelHelpers.export(exports, "VolumeOffFill", ()=>(0, _volumeOffFillDefault.default));
parcelHelpers.export(exports, "VolumeOff", ()=>(0, _volumeOffDefault.default));
parcelHelpers.export(exports, "VolumeUpFill", ()=>(0, _volumeUpFillDefault.default));
parcelHelpers.export(exports, "VolumeUp", ()=>(0, _volumeUpDefault.default));
parcelHelpers.export(exports, "Vr", ()=>(0, _vrDefault.default));
parcelHelpers.export(exports, "WalletFill", ()=>(0, _walletFillDefault.default));
parcelHelpers.export(exports, "Wallet", ()=>(0, _walletDefault.default));
parcelHelpers.export(exports, "Wallet2", ()=>(0, _wallet2Default.default));
parcelHelpers.export(exports, "Watch", ()=>(0, _watchDefault.default));
parcelHelpers.export(exports, "Water", ()=>(0, _waterDefault.default));
parcelHelpers.export(exports, "WebcamFill", ()=>(0, _webcamFillDefault.default));
parcelHelpers.export(exports, "Webcam", ()=>(0, _webcamDefault.default));
parcelHelpers.export(exports, "Wechat", ()=>(0, _wechatDefault.default));
parcelHelpers.export(exports, "Whatsapp", ()=>(0, _whatsappDefault.default));
parcelHelpers.export(exports, "Wifi1", ()=>(0, _wifi1Default.default));
parcelHelpers.export(exports, "Wifi2", ()=>(0, _wifi2Default.default));
parcelHelpers.export(exports, "WifiOff", ()=>(0, _wifiOffDefault.default));
parcelHelpers.export(exports, "Wifi", ()=>(0, _wifiDefault.default));
parcelHelpers.export(exports, "Wikipedia", ()=>(0, _wikipediaDefault.default));
parcelHelpers.export(exports, "Wind", ()=>(0, _windDefault.default));
parcelHelpers.export(exports, "WindowDash", ()=>(0, _windowDashDefault.default));
parcelHelpers.export(exports, "WindowDesktop", ()=>(0, _windowDesktopDefault.default));
parcelHelpers.export(exports, "WindowDock", ()=>(0, _windowDockDefault.default));
parcelHelpers.export(exports, "WindowFullscreen", ()=>(0, _windowFullscreenDefault.default));
parcelHelpers.export(exports, "WindowPlus", ()=>(0, _windowPlusDefault.default));
parcelHelpers.export(exports, "WindowSidebar", ()=>(0, _windowSidebarDefault.default));
parcelHelpers.export(exports, "WindowSplit", ()=>(0, _windowSplitDefault.default));
parcelHelpers.export(exports, "WindowStack", ()=>(0, _windowStackDefault.default));
parcelHelpers.export(exports, "WindowX", ()=>(0, _windowXDefault.default));
parcelHelpers.export(exports, "Window", ()=>(0, _windowDefault.default));
parcelHelpers.export(exports, "Windows", ()=>(0, _windowsDefault.default));
parcelHelpers.export(exports, "Wordpress", ()=>(0, _wordpressDefault.default));
parcelHelpers.export(exports, "WrenchAdjustableCircleFill", ()=>(0, _wrenchAdjustableCircleFillDefault.default));
parcelHelpers.export(exports, "WrenchAdjustableCircle", ()=>(0, _wrenchAdjustableCircleDefault.default));
parcelHelpers.export(exports, "WrenchAdjustable", ()=>(0, _wrenchAdjustableDefault.default));
parcelHelpers.export(exports, "Wrench", ()=>(0, _wrenchDefault.default));
parcelHelpers.export(exports, "XCircleFill", ()=>(0, _xCircleFillDefault.default));
parcelHelpers.export(exports, "XCircle", ()=>(0, _xCircleDefault.default));
parcelHelpers.export(exports, "XDiamondFill", ()=>(0, _xDiamondFillDefault.default));
parcelHelpers.export(exports, "XDiamond", ()=>(0, _xDiamondDefault.default));
parcelHelpers.export(exports, "XLg", ()=>(0, _xLgDefault.default));
parcelHelpers.export(exports, "XOctagonFill", ()=>(0, _xOctagonFillDefault.default));
parcelHelpers.export(exports, "XOctagon", ()=>(0, _xOctagonDefault.default));
parcelHelpers.export(exports, "XSquareFill", ()=>(0, _xSquareFillDefault.default));
parcelHelpers.export(exports, "XSquare", ()=>(0, _xSquareDefault.default));
parcelHelpers.export(exports, "X", ()=>(0, _xDefault.default));
parcelHelpers.export(exports, "Xbox", ()=>(0, _xboxDefault.default));
parcelHelpers.export(exports, "Yelp", ()=>(0, _yelpDefault.default));
parcelHelpers.export(exports, "YinYang", ()=>(0, _yinYangDefault.default));
parcelHelpers.export(exports, "Youtube", ()=>(0, _youtubeDefault.default));
parcelHelpers.export(exports, "ZoomIn", ()=>(0, _zoomInDefault.default));
parcelHelpers.export(exports, "ZoomOut", ()=>(0, _zoomOutDefault.default));
var _0CircleFill = require("./icons/0-circle-fill");
var _0CircleFillDefault = parcelHelpers.interopDefault(_0CircleFill);
var _0Circle = require("./icons/0-circle");
var _0CircleDefault = parcelHelpers.interopDefault(_0Circle);
var _0SquareFill = require("./icons/0-square-fill");
var _0SquareFillDefault = parcelHelpers.interopDefault(_0SquareFill);
var _0Square = require("./icons/0-square");
var _0SquareDefault = parcelHelpers.interopDefault(_0Square);
var _1CircleFill = require("./icons/1-circle-fill");
var _1CircleFillDefault = parcelHelpers.interopDefault(_1CircleFill);
var _1Circle = require("./icons/1-circle");
var _1CircleDefault = parcelHelpers.interopDefault(_1Circle);
var _1SquareFill = require("./icons/1-square-fill");
var _1SquareFillDefault = parcelHelpers.interopDefault(_1SquareFill);
var _1Square = require("./icons/1-square");
var _1SquareDefault = parcelHelpers.interopDefault(_1Square);
var _123 = require("./icons/123");
var _123Default = parcelHelpers.interopDefault(_123);
var _2CircleFill = require("./icons/2-circle-fill");
var _2CircleFillDefault = parcelHelpers.interopDefault(_2CircleFill);
var _2Circle = require("./icons/2-circle");
var _2CircleDefault = parcelHelpers.interopDefault(_2Circle);
var _2SquareFill = require("./icons/2-square-fill");
var _2SquareFillDefault = parcelHelpers.interopDefault(_2SquareFill);
var _2Square = require("./icons/2-square");
var _2SquareDefault = parcelHelpers.interopDefault(_2Square);
var _3CircleFill = require("./icons/3-circle-fill");
var _3CircleFillDefault = parcelHelpers.interopDefault(_3CircleFill);
var _3Circle = require("./icons/3-circle");
var _3CircleDefault = parcelHelpers.interopDefault(_3Circle);
var _3SquareFill = require("./icons/3-square-fill");
var _3SquareFillDefault = parcelHelpers.interopDefault(_3SquareFill);
var _3Square = require("./icons/3-square");
var _3SquareDefault = parcelHelpers.interopDefault(_3Square);
var _4CircleFill = require("./icons/4-circle-fill");
var _4CircleFillDefault = parcelHelpers.interopDefault(_4CircleFill);
var _4Circle = require("./icons/4-circle");
var _4CircleDefault = parcelHelpers.interopDefault(_4Circle);
var _4SquareFill = require("./icons/4-square-fill");
var _4SquareFillDefault = parcelHelpers.interopDefault(_4SquareFill);
var _4Square = require("./icons/4-square");
var _4SquareDefault = parcelHelpers.interopDefault(_4Square);
var _5CircleFill = require("./icons/5-circle-fill");
var _5CircleFillDefault = parcelHelpers.interopDefault(_5CircleFill);
var _5Circle = require("./icons/5-circle");
var _5CircleDefault = parcelHelpers.interopDefault(_5Circle);
var _5SquareFill = require("./icons/5-square-fill");
var _5SquareFillDefault = parcelHelpers.interopDefault(_5SquareFill);
var _5Square = require("./icons/5-square");
var _5SquareDefault = parcelHelpers.interopDefault(_5Square);
var _6CircleFill = require("./icons/6-circle-fill");
var _6CircleFillDefault = parcelHelpers.interopDefault(_6CircleFill);
var _6Circle = require("./icons/6-circle");
var _6CircleDefault = parcelHelpers.interopDefault(_6Circle);
var _6SquareFill = require("./icons/6-square-fill");
var _6SquareFillDefault = parcelHelpers.interopDefault(_6SquareFill);
var _6Square = require("./icons/6-square");
var _6SquareDefault = parcelHelpers.interopDefault(_6Square);
var _7CircleFill = require("./icons/7-circle-fill");
var _7CircleFillDefault = parcelHelpers.interopDefault(_7CircleFill);
var _7Circle = require("./icons/7-circle");
var _7CircleDefault = parcelHelpers.interopDefault(_7Circle);
var _7SquareFill = require("./icons/7-square-fill");
var _7SquareFillDefault = parcelHelpers.interopDefault(_7SquareFill);
var _7Square = require("./icons/7-square");
var _7SquareDefault = parcelHelpers.interopDefault(_7Square);
var _8CircleFill = require("./icons/8-circle-fill");
var _8CircleFillDefault = parcelHelpers.interopDefault(_8CircleFill);
var _8Circle = require("./icons/8-circle");
var _8CircleDefault = parcelHelpers.interopDefault(_8Circle);
var _8SquareFill = require("./icons/8-square-fill");
var _8SquareFillDefault = parcelHelpers.interopDefault(_8SquareFill);
var _8Square = require("./icons/8-square");
var _8SquareDefault = parcelHelpers.interopDefault(_8Square);
var _9CircleFill = require("./icons/9-circle-fill");
var _9CircleFillDefault = parcelHelpers.interopDefault(_9CircleFill);
var _9Circle = require("./icons/9-circle");
var _9CircleDefault = parcelHelpers.interopDefault(_9Circle);
var _9SquareFill = require("./icons/9-square-fill");
var _9SquareFillDefault = parcelHelpers.interopDefault(_9SquareFill);
var _9Square = require("./icons/9-square");
var _9SquareDefault = parcelHelpers.interopDefault(_9Square);
var _activity = require("./icons/activity");
var _activityDefault = parcelHelpers.interopDefault(_activity);
var _airplaneEnginesFill = require("./icons/airplane-engines-fill");
var _airplaneEnginesFillDefault = parcelHelpers.interopDefault(_airplaneEnginesFill);
var _airplaneEngines = require("./icons/airplane-engines");
var _airplaneEnginesDefault = parcelHelpers.interopDefault(_airplaneEngines);
var _airplaneFill = require("./icons/airplane-fill");
var _airplaneFillDefault = parcelHelpers.interopDefault(_airplaneFill);
var _airplane = require("./icons/airplane");
var _airplaneDefault = parcelHelpers.interopDefault(_airplane);
var _alarmFill = require("./icons/alarm-fill");
var _alarmFillDefault = parcelHelpers.interopDefault(_alarmFill);
var _alarm = require("./icons/alarm");
var _alarmDefault = parcelHelpers.interopDefault(_alarm);
var _alexa = require("./icons/alexa");
var _alexaDefault = parcelHelpers.interopDefault(_alexa);
var _alignBottom = require("./icons/align-bottom");
var _alignBottomDefault = parcelHelpers.interopDefault(_alignBottom);
var _alignCenter = require("./icons/align-center");
var _alignCenterDefault = parcelHelpers.interopDefault(_alignCenter);
var _alignEnd = require("./icons/align-end");
var _alignEndDefault = parcelHelpers.interopDefault(_alignEnd);
var _alignMiddle = require("./icons/align-middle");
var _alignMiddleDefault = parcelHelpers.interopDefault(_alignMiddle);
var _alignStart = require("./icons/align-start");
var _alignStartDefault = parcelHelpers.interopDefault(_alignStart);
var _alignTop = require("./icons/align-top");
var _alignTopDefault = parcelHelpers.interopDefault(_alignTop);
var _alipay = require("./icons/alipay");
var _alipayDefault = parcelHelpers.interopDefault(_alipay);
var _alphabetUppercase = require("./icons/alphabet-uppercase");
var _alphabetUppercaseDefault = parcelHelpers.interopDefault(_alphabetUppercase);
var _alphabet = require("./icons/alphabet");
var _alphabetDefault = parcelHelpers.interopDefault(_alphabet);
var _alt = require("./icons/alt");
var _altDefault = parcelHelpers.interopDefault(_alt);
var _amazon = require("./icons/amazon");
var _amazonDefault = parcelHelpers.interopDefault(_amazon);
var _amd = require("./icons/amd");
var _amdDefault = parcelHelpers.interopDefault(_amd);
var _android = require("./icons/android");
var _androidDefault = parcelHelpers.interopDefault(_android);
var _android2 = require("./icons/android2");
var _android2Default = parcelHelpers.interopDefault(_android2);
var _appIndicator = require("./icons/app-indicator");
var _appIndicatorDefault = parcelHelpers.interopDefault(_appIndicator);
var _app = require("./icons/app");
var _appDefault = parcelHelpers.interopDefault(_app);
var _apple = require("./icons/apple");
var _appleDefault = parcelHelpers.interopDefault(_apple);
var _archiveFill = require("./icons/archive-fill");
var _archiveFillDefault = parcelHelpers.interopDefault(_archiveFill);
var _archive = require("./icons/archive");
var _archiveDefault = parcelHelpers.interopDefault(_archive);
var _arrow90DegDown = require("./icons/arrow-90deg-down");
var _arrow90DegDownDefault = parcelHelpers.interopDefault(_arrow90DegDown);
var _arrow90DegLeft = require("./icons/arrow-90deg-left");
var _arrow90DegLeftDefault = parcelHelpers.interopDefault(_arrow90DegLeft);
var _arrow90DegRight = require("./icons/arrow-90deg-right");
var _arrow90DegRightDefault = parcelHelpers.interopDefault(_arrow90DegRight);
var _arrow90DegUp = require("./icons/arrow-90deg-up");
var _arrow90DegUpDefault = parcelHelpers.interopDefault(_arrow90DegUp);
var _arrowBarDown = require("./icons/arrow-bar-down");
var _arrowBarDownDefault = parcelHelpers.interopDefault(_arrowBarDown);
var _arrowBarLeft = require("./icons/arrow-bar-left");
var _arrowBarLeftDefault = parcelHelpers.interopDefault(_arrowBarLeft);
var _arrowBarRight = require("./icons/arrow-bar-right");
var _arrowBarRightDefault = parcelHelpers.interopDefault(_arrowBarRight);
var _arrowBarUp = require("./icons/arrow-bar-up");
var _arrowBarUpDefault = parcelHelpers.interopDefault(_arrowBarUp);
var _arrowClockwise = require("./icons/arrow-clockwise");
var _arrowClockwiseDefault = parcelHelpers.interopDefault(_arrowClockwise);
var _arrowCounterclockwise = require("./icons/arrow-counterclockwise");
var _arrowCounterclockwiseDefault = parcelHelpers.interopDefault(_arrowCounterclockwise);
var _arrowDownCircleFill = require("./icons/arrow-down-circle-fill");
var _arrowDownCircleFillDefault = parcelHelpers.interopDefault(_arrowDownCircleFill);
var _arrowDownCircle = require("./icons/arrow-down-circle");
var _arrowDownCircleDefault = parcelHelpers.interopDefault(_arrowDownCircle);
var _arrowDownLeftCircleFill = require("./icons/arrow-down-left-circle-fill");
var _arrowDownLeftCircleFillDefault = parcelHelpers.interopDefault(_arrowDownLeftCircleFill);
var _arrowDownLeftCircle = require("./icons/arrow-down-left-circle");
var _arrowDownLeftCircleDefault = parcelHelpers.interopDefault(_arrowDownLeftCircle);
var _arrowDownLeftSquareFill = require("./icons/arrow-down-left-square-fill");
var _arrowDownLeftSquareFillDefault = parcelHelpers.interopDefault(_arrowDownLeftSquareFill);
var _arrowDownLeftSquare = require("./icons/arrow-down-left-square");
var _arrowDownLeftSquareDefault = parcelHelpers.interopDefault(_arrowDownLeftSquare);
var _arrowDownLeft = require("./icons/arrow-down-left");
var _arrowDownLeftDefault = parcelHelpers.interopDefault(_arrowDownLeft);
var _arrowDownRightCircleFill = require("./icons/arrow-down-right-circle-fill");
var _arrowDownRightCircleFillDefault = parcelHelpers.interopDefault(_arrowDownRightCircleFill);
var _arrowDownRightCircle = require("./icons/arrow-down-right-circle");
var _arrowDownRightCircleDefault = parcelHelpers.interopDefault(_arrowDownRightCircle);
var _arrowDownRightSquareFill = require("./icons/arrow-down-right-square-fill");
var _arrowDownRightSquareFillDefault = parcelHelpers.interopDefault(_arrowDownRightSquareFill);
var _arrowDownRightSquare = require("./icons/arrow-down-right-square");
var _arrowDownRightSquareDefault = parcelHelpers.interopDefault(_arrowDownRightSquare);
var _arrowDownRight = require("./icons/arrow-down-right");
var _arrowDownRightDefault = parcelHelpers.interopDefault(_arrowDownRight);
var _arrowDownShort = require("./icons/arrow-down-short");
var _arrowDownShortDefault = parcelHelpers.interopDefault(_arrowDownShort);
var _arrowDownSquareFill = require("./icons/arrow-down-square-fill");
var _arrowDownSquareFillDefault = parcelHelpers.interopDefault(_arrowDownSquareFill);
var _arrowDownSquare = require("./icons/arrow-down-square");
var _arrowDownSquareDefault = parcelHelpers.interopDefault(_arrowDownSquare);
var _arrowDownUp = require("./icons/arrow-down-up");
var _arrowDownUpDefault = parcelHelpers.interopDefault(_arrowDownUp);
var _arrowDown = require("./icons/arrow-down");
var _arrowDownDefault = parcelHelpers.interopDefault(_arrowDown);
var _arrowLeftCircleFill = require("./icons/arrow-left-circle-fill");
var _arrowLeftCircleFillDefault = parcelHelpers.interopDefault(_arrowLeftCircleFill);
var _arrowLeftCircle = require("./icons/arrow-left-circle");
var _arrowLeftCircleDefault = parcelHelpers.interopDefault(_arrowLeftCircle);
var _arrowLeftRight = require("./icons/arrow-left-right");
var _arrowLeftRightDefault = parcelHelpers.interopDefault(_arrowLeftRight);
var _arrowLeftShort = require("./icons/arrow-left-short");
var _arrowLeftShortDefault = parcelHelpers.interopDefault(_arrowLeftShort);
var _arrowLeftSquareFill = require("./icons/arrow-left-square-fill");
var _arrowLeftSquareFillDefault = parcelHelpers.interopDefault(_arrowLeftSquareFill);
var _arrowLeftSquare = require("./icons/arrow-left-square");
var _arrowLeftSquareDefault = parcelHelpers.interopDefault(_arrowLeftSquare);
var _arrowLeft = require("./icons/arrow-left");
var _arrowLeftDefault = parcelHelpers.interopDefault(_arrowLeft);
var _arrowRepeat = require("./icons/arrow-repeat");
var _arrowRepeatDefault = parcelHelpers.interopDefault(_arrowRepeat);
var _arrowReturnLeft = require("./icons/arrow-return-left");
var _arrowReturnLeftDefault = parcelHelpers.interopDefault(_arrowReturnLeft);
var _arrowReturnRight = require("./icons/arrow-return-right");
var _arrowReturnRightDefault = parcelHelpers.interopDefault(_arrowReturnRight);
var _arrowRightCircleFill = require("./icons/arrow-right-circle-fill");
var _arrowRightCircleFillDefault = parcelHelpers.interopDefault(_arrowRightCircleFill);
var _arrowRightCircle = require("./icons/arrow-right-circle");
var _arrowRightCircleDefault = parcelHelpers.interopDefault(_arrowRightCircle);
var _arrowRightShort = require("./icons/arrow-right-short");
var _arrowRightShortDefault = parcelHelpers.interopDefault(_arrowRightShort);
var _arrowRightSquareFill = require("./icons/arrow-right-square-fill");
var _arrowRightSquareFillDefault = parcelHelpers.interopDefault(_arrowRightSquareFill);
var _arrowRightSquare = require("./icons/arrow-right-square");
var _arrowRightSquareDefault = parcelHelpers.interopDefault(_arrowRightSquare);
var _arrowRight = require("./icons/arrow-right");
var _arrowRightDefault = parcelHelpers.interopDefault(_arrowRight);
var _arrowThroughHeartFill = require("./icons/arrow-through-heart-fill");
var _arrowThroughHeartFillDefault = parcelHelpers.interopDefault(_arrowThroughHeartFill);
var _arrowThroughHeart = require("./icons/arrow-through-heart");
var _arrowThroughHeartDefault = parcelHelpers.interopDefault(_arrowThroughHeart);
var _arrowUpCircleFill = require("./icons/arrow-up-circle-fill");
var _arrowUpCircleFillDefault = parcelHelpers.interopDefault(_arrowUpCircleFill);
var _arrowUpCircle = require("./icons/arrow-up-circle");
var _arrowUpCircleDefault = parcelHelpers.interopDefault(_arrowUpCircle);
var _arrowUpLeftCircleFill = require("./icons/arrow-up-left-circle-fill");
var _arrowUpLeftCircleFillDefault = parcelHelpers.interopDefault(_arrowUpLeftCircleFill);
var _arrowUpLeftCircle = require("./icons/arrow-up-left-circle");
var _arrowUpLeftCircleDefault = parcelHelpers.interopDefault(_arrowUpLeftCircle);
var _arrowUpLeftSquareFill = require("./icons/arrow-up-left-square-fill");
var _arrowUpLeftSquareFillDefault = parcelHelpers.interopDefault(_arrowUpLeftSquareFill);
var _arrowUpLeftSquare = require("./icons/arrow-up-left-square");
var _arrowUpLeftSquareDefault = parcelHelpers.interopDefault(_arrowUpLeftSquare);
var _arrowUpLeft = require("./icons/arrow-up-left");
var _arrowUpLeftDefault = parcelHelpers.interopDefault(_arrowUpLeft);
var _arrowUpRightCircleFill = require("./icons/arrow-up-right-circle-fill");
var _arrowUpRightCircleFillDefault = parcelHelpers.interopDefault(_arrowUpRightCircleFill);
var _arrowUpRightCircle = require("./icons/arrow-up-right-circle");
var _arrowUpRightCircleDefault = parcelHelpers.interopDefault(_arrowUpRightCircle);
var _arrowUpRightSquareFill = require("./icons/arrow-up-right-square-fill");
var _arrowUpRightSquareFillDefault = parcelHelpers.interopDefault(_arrowUpRightSquareFill);
var _arrowUpRightSquare = require("./icons/arrow-up-right-square");
var _arrowUpRightSquareDefault = parcelHelpers.interopDefault(_arrowUpRightSquare);
var _arrowUpRight = require("./icons/arrow-up-right");
var _arrowUpRightDefault = parcelHelpers.interopDefault(_arrowUpRight);
var _arrowUpShort = require("./icons/arrow-up-short");
var _arrowUpShortDefault = parcelHelpers.interopDefault(_arrowUpShort);
var _arrowUpSquareFill = require("./icons/arrow-up-square-fill");
var _arrowUpSquareFillDefault = parcelHelpers.interopDefault(_arrowUpSquareFill);
var _arrowUpSquare = require("./icons/arrow-up-square");
var _arrowUpSquareDefault = parcelHelpers.interopDefault(_arrowUpSquare);
var _arrowUp = require("./icons/arrow-up");
var _arrowUpDefault = parcelHelpers.interopDefault(_arrowUp);
var _arrowsAngleContract = require("./icons/arrows-angle-contract");
var _arrowsAngleContractDefault = parcelHelpers.interopDefault(_arrowsAngleContract);
var _arrowsAngleExpand = require("./icons/arrows-angle-expand");
var _arrowsAngleExpandDefault = parcelHelpers.interopDefault(_arrowsAngleExpand);
var _arrowsCollapseVertical = require("./icons/arrows-collapse-vertical");
var _arrowsCollapseVerticalDefault = parcelHelpers.interopDefault(_arrowsCollapseVertical);
var _arrowsCollapse = require("./icons/arrows-collapse");
var _arrowsCollapseDefault = parcelHelpers.interopDefault(_arrowsCollapse);
var _arrowsExpandVertical = require("./icons/arrows-expand-vertical");
var _arrowsExpandVerticalDefault = parcelHelpers.interopDefault(_arrowsExpandVertical);
var _arrowsExpand = require("./icons/arrows-expand");
var _arrowsExpandDefault = parcelHelpers.interopDefault(_arrowsExpand);
var _arrowsFullscreen = require("./icons/arrows-fullscreen");
var _arrowsFullscreenDefault = parcelHelpers.interopDefault(_arrowsFullscreen);
var _arrowsMove = require("./icons/arrows-move");
var _arrowsMoveDefault = parcelHelpers.interopDefault(_arrowsMove);
var _arrowsVertical = require("./icons/arrows-vertical");
var _arrowsVerticalDefault = parcelHelpers.interopDefault(_arrowsVertical);
var _arrows = require("./icons/arrows");
var _arrowsDefault = parcelHelpers.interopDefault(_arrows);
var _aspectRatioFill = require("./icons/aspect-ratio-fill");
var _aspectRatioFillDefault = parcelHelpers.interopDefault(_aspectRatioFill);
var _aspectRatio = require("./icons/aspect-ratio");
var _aspectRatioDefault = parcelHelpers.interopDefault(_aspectRatio);
var _asterisk = require("./icons/asterisk");
var _asteriskDefault = parcelHelpers.interopDefault(_asterisk);
var _at = require("./icons/at");
var _atDefault = parcelHelpers.interopDefault(_at);
var _awardFill = require("./icons/award-fill");
var _awardFillDefault = parcelHelpers.interopDefault(_awardFill);
var _award = require("./icons/award");
var _awardDefault = parcelHelpers.interopDefault(_award);
var _back = require("./icons/back");
var _backDefault = parcelHelpers.interopDefault(_back);
var _backpackFill = require("./icons/backpack-fill");
var _backpackFillDefault = parcelHelpers.interopDefault(_backpackFill);
var _backpack = require("./icons/backpack");
var _backpackDefault = parcelHelpers.interopDefault(_backpack);
var _backpack2Fill = require("./icons/backpack2-fill");
var _backpack2FillDefault = parcelHelpers.interopDefault(_backpack2Fill);
var _backpack2 = require("./icons/backpack2");
var _backpack2Default = parcelHelpers.interopDefault(_backpack2);
var _backpack3Fill = require("./icons/backpack3-fill");
var _backpack3FillDefault = parcelHelpers.interopDefault(_backpack3Fill);
var _backpack3 = require("./icons/backpack3");
var _backpack3Default = parcelHelpers.interopDefault(_backpack3);
var _backpack4Fill = require("./icons/backpack4-fill");
var _backpack4FillDefault = parcelHelpers.interopDefault(_backpack4Fill);
var _backpack4 = require("./icons/backpack4");
var _backpack4Default = parcelHelpers.interopDefault(_backpack4);
var _backspaceFill = require("./icons/backspace-fill");
var _backspaceFillDefault = parcelHelpers.interopDefault(_backspaceFill);
var _backspaceReverseFill = require("./icons/backspace-reverse-fill");
var _backspaceReverseFillDefault = parcelHelpers.interopDefault(_backspaceReverseFill);
var _backspaceReverse = require("./icons/backspace-reverse");
var _backspaceReverseDefault = parcelHelpers.interopDefault(_backspaceReverse);
var _backspace = require("./icons/backspace");
var _backspaceDefault = parcelHelpers.interopDefault(_backspace);
var _badge3DFill = require("./icons/badge-3d-fill");
var _badge3DFillDefault = parcelHelpers.interopDefault(_badge3DFill);
var _badge3D = require("./icons/badge-3d");
var _badge3DDefault = parcelHelpers.interopDefault(_badge3D);
var _badge4KFill = require("./icons/badge-4k-fill");
var _badge4KFillDefault = parcelHelpers.interopDefault(_badge4KFill);
var _badge4K = require("./icons/badge-4k");
var _badge4KDefault = parcelHelpers.interopDefault(_badge4K);
var _badge8KFill = require("./icons/badge-8k-fill");
var _badge8KFillDefault = parcelHelpers.interopDefault(_badge8KFill);
var _badge8K = require("./icons/badge-8k");
var _badge8KDefault = parcelHelpers.interopDefault(_badge8K);
var _badgeAdFill = require("./icons/badge-ad-fill");
var _badgeAdFillDefault = parcelHelpers.interopDefault(_badgeAdFill);
var _badgeAd = require("./icons/badge-ad");
var _badgeAdDefault = parcelHelpers.interopDefault(_badgeAd);
var _badgeArFill = require("./icons/badge-ar-fill");
var _badgeArFillDefault = parcelHelpers.interopDefault(_badgeArFill);
var _badgeAr = require("./icons/badge-ar");
var _badgeArDefault = parcelHelpers.interopDefault(_badgeAr);
var _badgeCcFill = require("./icons/badge-cc-fill");
var _badgeCcFillDefault = parcelHelpers.interopDefault(_badgeCcFill);
var _badgeCc = require("./icons/badge-cc");
var _badgeCcDefault = parcelHelpers.interopDefault(_badgeCc);
var _badgeHdFill = require("./icons/badge-hd-fill");
var _badgeHdFillDefault = parcelHelpers.interopDefault(_badgeHdFill);
var _badgeHd = require("./icons/badge-hd");
var _badgeHdDefault = parcelHelpers.interopDefault(_badgeHd);
var _badgeSdFill = require("./icons/badge-sd-fill");
var _badgeSdFillDefault = parcelHelpers.interopDefault(_badgeSdFill);
var _badgeSd = require("./icons/badge-sd");
var _badgeSdDefault = parcelHelpers.interopDefault(_badgeSd);
var _badgeTmFill = require("./icons/badge-tm-fill");
var _badgeTmFillDefault = parcelHelpers.interopDefault(_badgeTmFill);
var _badgeTm = require("./icons/badge-tm");
var _badgeTmDefault = parcelHelpers.interopDefault(_badgeTm);
var _badgeVoFill = require("./icons/badge-vo-fill");
var _badgeVoFillDefault = parcelHelpers.interopDefault(_badgeVoFill);
var _badgeVo = require("./icons/badge-vo");
var _badgeVoDefault = parcelHelpers.interopDefault(_badgeVo);
var _badgeVrFill = require("./icons/badge-vr-fill");
var _badgeVrFillDefault = parcelHelpers.interopDefault(_badgeVrFill);
var _badgeVr = require("./icons/badge-vr");
var _badgeVrDefault = parcelHelpers.interopDefault(_badgeVr);
var _badgeWcFill = require("./icons/badge-wc-fill");
var _badgeWcFillDefault = parcelHelpers.interopDefault(_badgeWcFill);
var _badgeWc = require("./icons/badge-wc");
var _badgeWcDefault = parcelHelpers.interopDefault(_badgeWc);
var _bagCheckFill = require("./icons/bag-check-fill");
var _bagCheckFillDefault = parcelHelpers.interopDefault(_bagCheckFill);
var _bagCheck = require("./icons/bag-check");
var _bagCheckDefault = parcelHelpers.interopDefault(_bagCheck);
var _bagDashFill = require("./icons/bag-dash-fill");
var _bagDashFillDefault = parcelHelpers.interopDefault(_bagDashFill);
var _bagDash = require("./icons/bag-dash");
var _bagDashDefault = parcelHelpers.interopDefault(_bagDash);
var _bagFill = require("./icons/bag-fill");
var _bagFillDefault = parcelHelpers.interopDefault(_bagFill);
var _bagHeartFill = require("./icons/bag-heart-fill");
var _bagHeartFillDefault = parcelHelpers.interopDefault(_bagHeartFill);
var _bagHeart = require("./icons/bag-heart");
var _bagHeartDefault = parcelHelpers.interopDefault(_bagHeart);
var _bagPlusFill = require("./icons/bag-plus-fill");
var _bagPlusFillDefault = parcelHelpers.interopDefault(_bagPlusFill);
var _bagPlus = require("./icons/bag-plus");
var _bagPlusDefault = parcelHelpers.interopDefault(_bagPlus);
var _bagXFill = require("./icons/bag-x-fill");
var _bagXFillDefault = parcelHelpers.interopDefault(_bagXFill);
var _bagX = require("./icons/bag-x");
var _bagXDefault = parcelHelpers.interopDefault(_bagX);
var _bag = require("./icons/bag");
var _bagDefault = parcelHelpers.interopDefault(_bag);
var _balloonFill = require("./icons/balloon-fill");
var _balloonFillDefault = parcelHelpers.interopDefault(_balloonFill);
var _balloonHeartFill = require("./icons/balloon-heart-fill");
var _balloonHeartFillDefault = parcelHelpers.interopDefault(_balloonHeartFill);
var _balloonHeart = require("./icons/balloon-heart");
var _balloonHeartDefault = parcelHelpers.interopDefault(_balloonHeart);
var _balloon = require("./icons/balloon");
var _balloonDefault = parcelHelpers.interopDefault(_balloon);
var _banFill = require("./icons/ban-fill");
var _banFillDefault = parcelHelpers.interopDefault(_banFill);
var _ban = require("./icons/ban");
var _banDefault = parcelHelpers.interopDefault(_ban);
var _bandaidFill = require("./icons/bandaid-fill");
var _bandaidFillDefault = parcelHelpers.interopDefault(_bandaidFill);
var _bandaid = require("./icons/bandaid");
var _bandaidDefault = parcelHelpers.interopDefault(_bandaid);
var _bank = require("./icons/bank");
var _bankDefault = parcelHelpers.interopDefault(_bank);
var _bank2 = require("./icons/bank2");
var _bank2Default = parcelHelpers.interopDefault(_bank2);
var _barChartFill = require("./icons/bar-chart-fill");
var _barChartFillDefault = parcelHelpers.interopDefault(_barChartFill);
var _barChartLineFill = require("./icons/bar-chart-line-fill");
var _barChartLineFillDefault = parcelHelpers.interopDefault(_barChartLineFill);
var _barChartLine = require("./icons/bar-chart-line");
var _barChartLineDefault = parcelHelpers.interopDefault(_barChartLine);
var _barChartSteps = require("./icons/bar-chart-steps");
var _barChartStepsDefault = parcelHelpers.interopDefault(_barChartSteps);
var _barChart = require("./icons/bar-chart");
var _barChartDefault = parcelHelpers.interopDefault(_barChart);
var _basketFill = require("./icons/basket-fill");
var _basketFillDefault = parcelHelpers.interopDefault(_basketFill);
var _basket = require("./icons/basket");
var _basketDefault = parcelHelpers.interopDefault(_basket);
var _basket2Fill = require("./icons/basket2-fill");
var _basket2FillDefault = parcelHelpers.interopDefault(_basket2Fill);
var _basket2 = require("./icons/basket2");
var _basket2Default = parcelHelpers.interopDefault(_basket2);
var _basket3Fill = require("./icons/basket3-fill");
var _basket3FillDefault = parcelHelpers.interopDefault(_basket3Fill);
var _basket3 = require("./icons/basket3");
var _basket3Default = parcelHelpers.interopDefault(_basket3);
var _batteryCharging = require("./icons/battery-charging");
var _batteryChargingDefault = parcelHelpers.interopDefault(_batteryCharging);
var _batteryFull = require("./icons/battery-full");
var _batteryFullDefault = parcelHelpers.interopDefault(_batteryFull);
var _batteryHalf = require("./icons/battery-half");
var _batteryHalfDefault = parcelHelpers.interopDefault(_batteryHalf);
var _battery = require("./icons/battery");
var _batteryDefault = parcelHelpers.interopDefault(_battery);
var _behance = require("./icons/behance");
var _behanceDefault = parcelHelpers.interopDefault(_behance);
var _bellFill = require("./icons/bell-fill");
var _bellFillDefault = parcelHelpers.interopDefault(_bellFill);
var _bellSlashFill = require("./icons/bell-slash-fill");
var _bellSlashFillDefault = parcelHelpers.interopDefault(_bellSlashFill);
var _bellSlash = require("./icons/bell-slash");
var _bellSlashDefault = parcelHelpers.interopDefault(_bellSlash);
var _bell = require("./icons/bell");
var _bellDefault = parcelHelpers.interopDefault(_bell);
var _bezier = require("./icons/bezier");
var _bezierDefault = parcelHelpers.interopDefault(_bezier);
var _bezier2 = require("./icons/bezier2");
var _bezier2Default = parcelHelpers.interopDefault(_bezier2);
var _bicycle = require("./icons/bicycle");
var _bicycleDefault = parcelHelpers.interopDefault(_bicycle);
var _bing = require("./icons/bing");
var _bingDefault = parcelHelpers.interopDefault(_bing);
var _binocularsFill = require("./icons/binoculars-fill");
var _binocularsFillDefault = parcelHelpers.interopDefault(_binocularsFill);
var _binoculars = require("./icons/binoculars");
var _binocularsDefault = parcelHelpers.interopDefault(_binoculars);
var _blockquoteLeft = require("./icons/blockquote-left");
var _blockquoteLeftDefault = parcelHelpers.interopDefault(_blockquoteLeft);
var _blockquoteRight = require("./icons/blockquote-right");
var _blockquoteRightDefault = parcelHelpers.interopDefault(_blockquoteRight);
var _bluetooth = require("./icons/bluetooth");
var _bluetoothDefault = parcelHelpers.interopDefault(_bluetooth);
var _bodyText = require("./icons/body-text");
var _bodyTextDefault = parcelHelpers.interopDefault(_bodyText);
var _bookFill = require("./icons/book-fill");
var _bookFillDefault = parcelHelpers.interopDefault(_bookFill);
var _bookHalf = require("./icons/book-half");
var _bookHalfDefault = parcelHelpers.interopDefault(_bookHalf);
var _book = require("./icons/book");
var _bookDefault = parcelHelpers.interopDefault(_book);
var _bookmarkCheckFill = require("./icons/bookmark-check-fill");
var _bookmarkCheckFillDefault = parcelHelpers.interopDefault(_bookmarkCheckFill);
var _bookmarkCheck = require("./icons/bookmark-check");
var _bookmarkCheckDefault = parcelHelpers.interopDefault(_bookmarkCheck);
var _bookmarkDashFill = require("./icons/bookmark-dash-fill");
var _bookmarkDashFillDefault = parcelHelpers.interopDefault(_bookmarkDashFill);
var _bookmarkDash = require("./icons/bookmark-dash");
var _bookmarkDashDefault = parcelHelpers.interopDefault(_bookmarkDash);
var _bookmarkFill = require("./icons/bookmark-fill");
var _bookmarkFillDefault = parcelHelpers.interopDefault(_bookmarkFill);
var _bookmarkHeartFill = require("./icons/bookmark-heart-fill");
var _bookmarkHeartFillDefault = parcelHelpers.interopDefault(_bookmarkHeartFill);
var _bookmarkHeart = require("./icons/bookmark-heart");
var _bookmarkHeartDefault = parcelHelpers.interopDefault(_bookmarkHeart);
var _bookmarkPlusFill = require("./icons/bookmark-plus-fill");
var _bookmarkPlusFillDefault = parcelHelpers.interopDefault(_bookmarkPlusFill);
var _bookmarkPlus = require("./icons/bookmark-plus");
var _bookmarkPlusDefault = parcelHelpers.interopDefault(_bookmarkPlus);
var _bookmarkStarFill = require("./icons/bookmark-star-fill");
var _bookmarkStarFillDefault = parcelHelpers.interopDefault(_bookmarkStarFill);
var _bookmarkStar = require("./icons/bookmark-star");
var _bookmarkStarDefault = parcelHelpers.interopDefault(_bookmarkStar);
var _bookmarkXFill = require("./icons/bookmark-x-fill");
var _bookmarkXFillDefault = parcelHelpers.interopDefault(_bookmarkXFill);
var _bookmarkX = require("./icons/bookmark-x");
var _bookmarkXDefault = parcelHelpers.interopDefault(_bookmarkX);
var _bookmark = require("./icons/bookmark");
var _bookmarkDefault = parcelHelpers.interopDefault(_bookmark);
var _bookmarksFill = require("./icons/bookmarks-fill");
var _bookmarksFillDefault = parcelHelpers.interopDefault(_bookmarksFill);
var _bookmarks = require("./icons/bookmarks");
var _bookmarksDefault = parcelHelpers.interopDefault(_bookmarks);
var _bookshelf = require("./icons/bookshelf");
var _bookshelfDefault = parcelHelpers.interopDefault(_bookshelf);
var _boomboxFill = require("./icons/boombox-fill");
var _boomboxFillDefault = parcelHelpers.interopDefault(_boomboxFill);
var _boombox = require("./icons/boombox");
var _boomboxDefault = parcelHelpers.interopDefault(_boombox);
var _bootstrapFill = require("./icons/bootstrap-fill");
var _bootstrapFillDefault = parcelHelpers.interopDefault(_bootstrapFill);
var _bootstrapReboot = require("./icons/bootstrap-reboot");
var _bootstrapRebootDefault = parcelHelpers.interopDefault(_bootstrapReboot);
var _bootstrap = require("./icons/bootstrap");
var _bootstrapDefault = parcelHelpers.interopDefault(_bootstrap);
var _borderAll = require("./icons/border-all");
var _borderAllDefault = parcelHelpers.interopDefault(_borderAll);
var _borderBottom = require("./icons/border-bottom");
var _borderBottomDefault = parcelHelpers.interopDefault(_borderBottom);
var _borderCenter = require("./icons/border-center");
var _borderCenterDefault = parcelHelpers.interopDefault(_borderCenter);
var _borderInner = require("./icons/border-inner");
var _borderInnerDefault = parcelHelpers.interopDefault(_borderInner);
var _borderLeft = require("./icons/border-left");
var _borderLeftDefault = parcelHelpers.interopDefault(_borderLeft);
var _borderMiddle = require("./icons/border-middle");
var _borderMiddleDefault = parcelHelpers.interopDefault(_borderMiddle);
var _borderOuter = require("./icons/border-outer");
var _borderOuterDefault = parcelHelpers.interopDefault(_borderOuter);
var _borderRight = require("./icons/border-right");
var _borderRightDefault = parcelHelpers.interopDefault(_borderRight);
var _borderStyle = require("./icons/border-style");
var _borderStyleDefault = parcelHelpers.interopDefault(_borderStyle);
var _borderTop = require("./icons/border-top");
var _borderTopDefault = parcelHelpers.interopDefault(_borderTop);
var _borderWidth = require("./icons/border-width");
var _borderWidthDefault = parcelHelpers.interopDefault(_borderWidth);
var _border = require("./icons/border");
var _borderDefault = parcelHelpers.interopDefault(_border);
var _boundingBoxCircles = require("./icons/bounding-box-circles");
var _boundingBoxCirclesDefault = parcelHelpers.interopDefault(_boundingBoxCircles);
var _boundingBox = require("./icons/bounding-box");
var _boundingBoxDefault = parcelHelpers.interopDefault(_boundingBox);
var _boxArrowDownLeft = require("./icons/box-arrow-down-left");
var _boxArrowDownLeftDefault = parcelHelpers.interopDefault(_boxArrowDownLeft);
var _boxArrowDownRight = require("./icons/box-arrow-down-right");
var _boxArrowDownRightDefault = parcelHelpers.interopDefault(_boxArrowDownRight);
var _boxArrowDown = require("./icons/box-arrow-down");
var _boxArrowDownDefault = parcelHelpers.interopDefault(_boxArrowDown);
var _boxArrowInDownLeft = require("./icons/box-arrow-in-down-left");
var _boxArrowInDownLeftDefault = parcelHelpers.interopDefault(_boxArrowInDownLeft);
var _boxArrowInDownRight = require("./icons/box-arrow-in-down-right");
var _boxArrowInDownRightDefault = parcelHelpers.interopDefault(_boxArrowInDownRight);
var _boxArrowInDown = require("./icons/box-arrow-in-down");
var _boxArrowInDownDefault = parcelHelpers.interopDefault(_boxArrowInDown);
var _boxArrowInLeft = require("./icons/box-arrow-in-left");
var _boxArrowInLeftDefault = parcelHelpers.interopDefault(_boxArrowInLeft);
var _boxArrowInRight = require("./icons/box-arrow-in-right");
var _boxArrowInRightDefault = parcelHelpers.interopDefault(_boxArrowInRight);
var _boxArrowInUpLeft = require("./icons/box-arrow-in-up-left");
var _boxArrowInUpLeftDefault = parcelHelpers.interopDefault(_boxArrowInUpLeft);
var _boxArrowInUpRight = require("./icons/box-arrow-in-up-right");
var _boxArrowInUpRightDefault = parcelHelpers.interopDefault(_boxArrowInUpRight);
var _boxArrowInUp = require("./icons/box-arrow-in-up");
var _boxArrowInUpDefault = parcelHelpers.interopDefault(_boxArrowInUp);
var _boxArrowLeft = require("./icons/box-arrow-left");
var _boxArrowLeftDefault = parcelHelpers.interopDefault(_boxArrowLeft);
var _boxArrowRight = require("./icons/box-arrow-right");
var _boxArrowRightDefault = parcelHelpers.interopDefault(_boxArrowRight);
var _boxArrowUpLeft = require("./icons/box-arrow-up-left");
var _boxArrowUpLeftDefault = parcelHelpers.interopDefault(_boxArrowUpLeft);
var _boxArrowUpRight = require("./icons/box-arrow-up-right");
var _boxArrowUpRightDefault = parcelHelpers.interopDefault(_boxArrowUpRight);
var _boxArrowUp = require("./icons/box-arrow-up");
var _boxArrowUpDefault = parcelHelpers.interopDefault(_boxArrowUp);
var _boxFill = require("./icons/box-fill");
var _boxFillDefault = parcelHelpers.interopDefault(_boxFill);
var _boxSeamFill = require("./icons/box-seam-fill");
var _boxSeamFillDefault = parcelHelpers.interopDefault(_boxSeamFill);
var _boxSeam = require("./icons/box-seam");
var _boxSeamDefault = parcelHelpers.interopDefault(_boxSeam);
var _box = require("./icons/box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _box2Fill = require("./icons/box2-fill");
var _box2FillDefault = parcelHelpers.interopDefault(_box2Fill);
var _box2HeartFill = require("./icons/box2-heart-fill");
var _box2HeartFillDefault = parcelHelpers.interopDefault(_box2HeartFill);
var _box2Heart = require("./icons/box2-heart");
var _box2HeartDefault = parcelHelpers.interopDefault(_box2Heart);
var _box2 = require("./icons/box2");
var _box2Default = parcelHelpers.interopDefault(_box2);
var _boxes = require("./icons/boxes");
var _boxesDefault = parcelHelpers.interopDefault(_boxes);
var _bracesAsterisk = require("./icons/braces-asterisk");
var _bracesAsteriskDefault = parcelHelpers.interopDefault(_bracesAsterisk);
var _braces = require("./icons/braces");
var _bracesDefault = parcelHelpers.interopDefault(_braces);
var _bricks = require("./icons/bricks");
var _bricksDefault = parcelHelpers.interopDefault(_bricks);
var _briefcaseFill = require("./icons/briefcase-fill");
var _briefcaseFillDefault = parcelHelpers.interopDefault(_briefcaseFill);
var _briefcase = require("./icons/briefcase");
var _briefcaseDefault = parcelHelpers.interopDefault(_briefcase);
var _brightnessAltHighFill = require("./icons/brightness-alt-high-fill");
var _brightnessAltHighFillDefault = parcelHelpers.interopDefault(_brightnessAltHighFill);
var _brightnessAltHigh = require("./icons/brightness-alt-high");
var _brightnessAltHighDefault = parcelHelpers.interopDefault(_brightnessAltHigh);
var _brightnessAltLowFill = require("./icons/brightness-alt-low-fill");
var _brightnessAltLowFillDefault = parcelHelpers.interopDefault(_brightnessAltLowFill);
var _brightnessAltLow = require("./icons/brightness-alt-low");
var _brightnessAltLowDefault = parcelHelpers.interopDefault(_brightnessAltLow);
var _brightnessHighFill = require("./icons/brightness-high-fill");
var _brightnessHighFillDefault = parcelHelpers.interopDefault(_brightnessHighFill);
var _brightnessHigh = require("./icons/brightness-high");
var _brightnessHighDefault = parcelHelpers.interopDefault(_brightnessHigh);
var _brightnessLowFill = require("./icons/brightness-low-fill");
var _brightnessLowFillDefault = parcelHelpers.interopDefault(_brightnessLowFill);
var _brightnessLow = require("./icons/brightness-low");
var _brightnessLowDefault = parcelHelpers.interopDefault(_brightnessLow);
var _brilliance = require("./icons/brilliance");
var _brillianceDefault = parcelHelpers.interopDefault(_brilliance);
var _broadcastPin = require("./icons/broadcast-pin");
var _broadcastPinDefault = parcelHelpers.interopDefault(_broadcastPin);
var _broadcast = require("./icons/broadcast");
var _broadcastDefault = parcelHelpers.interopDefault(_broadcast);
var _browserChrome = require("./icons/browser-chrome");
var _browserChromeDefault = parcelHelpers.interopDefault(_browserChrome);
var _browserEdge = require("./icons/browser-edge");
var _browserEdgeDefault = parcelHelpers.interopDefault(_browserEdge);
var _browserFirefox = require("./icons/browser-firefox");
var _browserFirefoxDefault = parcelHelpers.interopDefault(_browserFirefox);
var _browserSafari = require("./icons/browser-safari");
var _browserSafariDefault = parcelHelpers.interopDefault(_browserSafari);
var _brushFill = require("./icons/brush-fill");
var _brushFillDefault = parcelHelpers.interopDefault(_brushFill);
var _brush = require("./icons/brush");
var _brushDefault = parcelHelpers.interopDefault(_brush);
var _bucketFill = require("./icons/bucket-fill");
var _bucketFillDefault = parcelHelpers.interopDefault(_bucketFill);
var _bucket = require("./icons/bucket");
var _bucketDefault = parcelHelpers.interopDefault(_bucket);
var _bugFill = require("./icons/bug-fill");
var _bugFillDefault = parcelHelpers.interopDefault(_bugFill);
var _bug = require("./icons/bug");
var _bugDefault = parcelHelpers.interopDefault(_bug);
var _buildingAdd = require("./icons/building-add");
var _buildingAddDefault = parcelHelpers.interopDefault(_buildingAdd);
var _buildingCheck = require("./icons/building-check");
var _buildingCheckDefault = parcelHelpers.interopDefault(_buildingCheck);
var _buildingDash = require("./icons/building-dash");
var _buildingDashDefault = parcelHelpers.interopDefault(_buildingDash);
var _buildingDown = require("./icons/building-down");
var _buildingDownDefault = parcelHelpers.interopDefault(_buildingDown);
var _buildingExclamation = require("./icons/building-exclamation");
var _buildingExclamationDefault = parcelHelpers.interopDefault(_buildingExclamation);
var _buildingFillAdd = require("./icons/building-fill-add");
var _buildingFillAddDefault = parcelHelpers.interopDefault(_buildingFillAdd);
var _buildingFillCheck = require("./icons/building-fill-check");
var _buildingFillCheckDefault = parcelHelpers.interopDefault(_buildingFillCheck);
var _buildingFillDash = require("./icons/building-fill-dash");
var _buildingFillDashDefault = parcelHelpers.interopDefault(_buildingFillDash);
var _buildingFillDown = require("./icons/building-fill-down");
var _buildingFillDownDefault = parcelHelpers.interopDefault(_buildingFillDown);
var _buildingFillExclamation = require("./icons/building-fill-exclamation");
var _buildingFillExclamationDefault = parcelHelpers.interopDefault(_buildingFillExclamation);
var _buildingFillGear = require("./icons/building-fill-gear");
var _buildingFillGearDefault = parcelHelpers.interopDefault(_buildingFillGear);
var _buildingFillLock = require("./icons/building-fill-lock");
var _buildingFillLockDefault = parcelHelpers.interopDefault(_buildingFillLock);
var _buildingFillSlash = require("./icons/building-fill-slash");
var _buildingFillSlashDefault = parcelHelpers.interopDefault(_buildingFillSlash);
var _buildingFillUp = require("./icons/building-fill-up");
var _buildingFillUpDefault = parcelHelpers.interopDefault(_buildingFillUp);
var _buildingFillX = require("./icons/building-fill-x");
var _buildingFillXDefault = parcelHelpers.interopDefault(_buildingFillX);
var _buildingFill = require("./icons/building-fill");
var _buildingFillDefault = parcelHelpers.interopDefault(_buildingFill);
var _buildingGear = require("./icons/building-gear");
var _buildingGearDefault = parcelHelpers.interopDefault(_buildingGear);
var _buildingLock = require("./icons/building-lock");
var _buildingLockDefault = parcelHelpers.interopDefault(_buildingLock);
var _buildingSlash = require("./icons/building-slash");
var _buildingSlashDefault = parcelHelpers.interopDefault(_buildingSlash);
var _buildingUp = require("./icons/building-up");
var _buildingUpDefault = parcelHelpers.interopDefault(_buildingUp);
var _buildingX = require("./icons/building-x");
var _buildingXDefault = parcelHelpers.interopDefault(_buildingX);
var _building = require("./icons/building");
var _buildingDefault = parcelHelpers.interopDefault(_building);
var _buildingsFill = require("./icons/buildings-fill");
var _buildingsFillDefault = parcelHelpers.interopDefault(_buildingsFill);
var _buildings = require("./icons/buildings");
var _buildingsDefault = parcelHelpers.interopDefault(_buildings);
var _bullseye = require("./icons/bullseye");
var _bullseyeDefault = parcelHelpers.interopDefault(_bullseye);
var _busFrontFill = require("./icons/bus-front-fill");
var _busFrontFillDefault = parcelHelpers.interopDefault(_busFrontFill);
var _busFront = require("./icons/bus-front");
var _busFrontDefault = parcelHelpers.interopDefault(_busFront);
var _cCircleFill = require("./icons/c-circle-fill");
var _cCircleFillDefault = parcelHelpers.interopDefault(_cCircleFill);
var _cCircle = require("./icons/c-circle");
var _cCircleDefault = parcelHelpers.interopDefault(_cCircle);
var _cSquareFill = require("./icons/c-square-fill");
var _cSquareFillDefault = parcelHelpers.interopDefault(_cSquareFill);
var _cSquare = require("./icons/c-square");
var _cSquareDefault = parcelHelpers.interopDefault(_cSquare);
var _cakeFill = require("./icons/cake-fill");
var _cakeFillDefault = parcelHelpers.interopDefault(_cakeFill);
var _cake = require("./icons/cake");
var _cakeDefault = parcelHelpers.interopDefault(_cake);
var _cake2Fill = require("./icons/cake2-fill");
var _cake2FillDefault = parcelHelpers.interopDefault(_cake2Fill);
var _cake2 = require("./icons/cake2");
var _cake2Default = parcelHelpers.interopDefault(_cake2);
var _calculatorFill = require("./icons/calculator-fill");
var _calculatorFillDefault = parcelHelpers.interopDefault(_calculatorFill);
var _calculator = require("./icons/calculator");
var _calculatorDefault = parcelHelpers.interopDefault(_calculator);
var _calendarCheckFill = require("./icons/calendar-check-fill");
var _calendarCheckFillDefault = parcelHelpers.interopDefault(_calendarCheckFill);
var _calendarCheck = require("./icons/calendar-check");
var _calendarCheckDefault = parcelHelpers.interopDefault(_calendarCheck);
var _calendarDateFill = require("./icons/calendar-date-fill");
var _calendarDateFillDefault = parcelHelpers.interopDefault(_calendarDateFill);
var _calendarDate = require("./icons/calendar-date");
var _calendarDateDefault = parcelHelpers.interopDefault(_calendarDate);
var _calendarDayFill = require("./icons/calendar-day-fill");
var _calendarDayFillDefault = parcelHelpers.interopDefault(_calendarDayFill);
var _calendarDay = require("./icons/calendar-day");
var _calendarDayDefault = parcelHelpers.interopDefault(_calendarDay);
var _calendarEventFill = require("./icons/calendar-event-fill");
var _calendarEventFillDefault = parcelHelpers.interopDefault(_calendarEventFill);
var _calendarEvent = require("./icons/calendar-event");
var _calendarEventDefault = parcelHelpers.interopDefault(_calendarEvent);
var _calendarFill = require("./icons/calendar-fill");
var _calendarFillDefault = parcelHelpers.interopDefault(_calendarFill);
var _calendarHeartFill = require("./icons/calendar-heart-fill");
var _calendarHeartFillDefault = parcelHelpers.interopDefault(_calendarHeartFill);
var _calendarHeart = require("./icons/calendar-heart");
var _calendarHeartDefault = parcelHelpers.interopDefault(_calendarHeart);
var _calendarMinusFill = require("./icons/calendar-minus-fill");
var _calendarMinusFillDefault = parcelHelpers.interopDefault(_calendarMinusFill);
var _calendarMinus = require("./icons/calendar-minus");
var _calendarMinusDefault = parcelHelpers.interopDefault(_calendarMinus);
var _calendarMonthFill = require("./icons/calendar-month-fill");
var _calendarMonthFillDefault = parcelHelpers.interopDefault(_calendarMonthFill);
var _calendarMonth = require("./icons/calendar-month");
var _calendarMonthDefault = parcelHelpers.interopDefault(_calendarMonth);
var _calendarPlusFill = require("./icons/calendar-plus-fill");
var _calendarPlusFillDefault = parcelHelpers.interopDefault(_calendarPlusFill);
var _calendarPlus = require("./icons/calendar-plus");
var _calendarPlusDefault = parcelHelpers.interopDefault(_calendarPlus);
var _calendarRangeFill = require("./icons/calendar-range-fill");
var _calendarRangeFillDefault = parcelHelpers.interopDefault(_calendarRangeFill);
var _calendarRange = require("./icons/calendar-range");
var _calendarRangeDefault = parcelHelpers.interopDefault(_calendarRange);
var _calendarWeekFill = require("./icons/calendar-week-fill");
var _calendarWeekFillDefault = parcelHelpers.interopDefault(_calendarWeekFill);
var _calendarWeek = require("./icons/calendar-week");
var _calendarWeekDefault = parcelHelpers.interopDefault(_calendarWeek);
var _calendarXFill = require("./icons/calendar-x-fill");
var _calendarXFillDefault = parcelHelpers.interopDefault(_calendarXFill);
var _calendarX = require("./icons/calendar-x");
var _calendarXDefault = parcelHelpers.interopDefault(_calendarX);
var _calendar = require("./icons/calendar");
var _calendarDefault = parcelHelpers.interopDefault(_calendar);
var _calendar2CheckFill = require("./icons/calendar2-check-fill");
var _calendar2CheckFillDefault = parcelHelpers.interopDefault(_calendar2CheckFill);
var _calendar2Check = require("./icons/calendar2-check");
var _calendar2CheckDefault = parcelHelpers.interopDefault(_calendar2Check);
var _calendar2DateFill = require("./icons/calendar2-date-fill");
var _calendar2DateFillDefault = parcelHelpers.interopDefault(_calendar2DateFill);
var _calendar2Date = require("./icons/calendar2-date");
var _calendar2DateDefault = parcelHelpers.interopDefault(_calendar2Date);
var _calendar2DayFill = require("./icons/calendar2-day-fill");
var _calendar2DayFillDefault = parcelHelpers.interopDefault(_calendar2DayFill);
var _calendar2Day = require("./icons/calendar2-day");
var _calendar2DayDefault = parcelHelpers.interopDefault(_calendar2Day);
var _calendar2EventFill = require("./icons/calendar2-event-fill");
var _calendar2EventFillDefault = parcelHelpers.interopDefault(_calendar2EventFill);
var _calendar2Event = require("./icons/calendar2-event");
var _calendar2EventDefault = parcelHelpers.interopDefault(_calendar2Event);
var _calendar2Fill = require("./icons/calendar2-fill");
var _calendar2FillDefault = parcelHelpers.interopDefault(_calendar2Fill);
var _calendar2HeartFill = require("./icons/calendar2-heart-fill");
var _calendar2HeartFillDefault = parcelHelpers.interopDefault(_calendar2HeartFill);
var _calendar2Heart = require("./icons/calendar2-heart");
var _calendar2HeartDefault = parcelHelpers.interopDefault(_calendar2Heart);
var _calendar2MinusFill = require("./icons/calendar2-minus-fill");
var _calendar2MinusFillDefault = parcelHelpers.interopDefault(_calendar2MinusFill);
var _calendar2Minus = require("./icons/calendar2-minus");
var _calendar2MinusDefault = parcelHelpers.interopDefault(_calendar2Minus);
var _calendar2MonthFill = require("./icons/calendar2-month-fill");
var _calendar2MonthFillDefault = parcelHelpers.interopDefault(_calendar2MonthFill);
var _calendar2Month = require("./icons/calendar2-month");
var _calendar2MonthDefault = parcelHelpers.interopDefault(_calendar2Month);
var _calendar2PlusFill = require("./icons/calendar2-plus-fill");
var _calendar2PlusFillDefault = parcelHelpers.interopDefault(_calendar2PlusFill);
var _calendar2Plus = require("./icons/calendar2-plus");
var _calendar2PlusDefault = parcelHelpers.interopDefault(_calendar2Plus);
var _calendar2RangeFill = require("./icons/calendar2-range-fill");
var _calendar2RangeFillDefault = parcelHelpers.interopDefault(_calendar2RangeFill);
var _calendar2Range = require("./icons/calendar2-range");
var _calendar2RangeDefault = parcelHelpers.interopDefault(_calendar2Range);
var _calendar2WeekFill = require("./icons/calendar2-week-fill");
var _calendar2WeekFillDefault = parcelHelpers.interopDefault(_calendar2WeekFill);
var _calendar2Week = require("./icons/calendar2-week");
var _calendar2WeekDefault = parcelHelpers.interopDefault(_calendar2Week);
var _calendar2XFill = require("./icons/calendar2-x-fill");
var _calendar2XFillDefault = parcelHelpers.interopDefault(_calendar2XFill);
var _calendar2X = require("./icons/calendar2-x");
var _calendar2XDefault = parcelHelpers.interopDefault(_calendar2X);
var _calendar2 = require("./icons/calendar2");
var _calendar2Default = parcelHelpers.interopDefault(_calendar2);
var _calendar3EventFill = require("./icons/calendar3-event-fill");
var _calendar3EventFillDefault = parcelHelpers.interopDefault(_calendar3EventFill);
var _calendar3Event = require("./icons/calendar3-event");
var _calendar3EventDefault = parcelHelpers.interopDefault(_calendar3Event);
var _calendar3Fill = require("./icons/calendar3-fill");
var _calendar3FillDefault = parcelHelpers.interopDefault(_calendar3Fill);
var _calendar3RangeFill = require("./icons/calendar3-range-fill");
var _calendar3RangeFillDefault = parcelHelpers.interopDefault(_calendar3RangeFill);
var _calendar3Range = require("./icons/calendar3-range");
var _calendar3RangeDefault = parcelHelpers.interopDefault(_calendar3Range);
var _calendar3WeekFill = require("./icons/calendar3-week-fill");
var _calendar3WeekFillDefault = parcelHelpers.interopDefault(_calendar3WeekFill);
var _calendar3Week = require("./icons/calendar3-week");
var _calendar3WeekDefault = parcelHelpers.interopDefault(_calendar3Week);
var _calendar3 = require("./icons/calendar3");
var _calendar3Default = parcelHelpers.interopDefault(_calendar3);
var _calendar4Event = require("./icons/calendar4-event");
var _calendar4EventDefault = parcelHelpers.interopDefault(_calendar4Event);
var _calendar4Range = require("./icons/calendar4-range");
var _calendar4RangeDefault = parcelHelpers.interopDefault(_calendar4Range);
var _calendar4Week = require("./icons/calendar4-week");
var _calendar4WeekDefault = parcelHelpers.interopDefault(_calendar4Week);
var _calendar4 = require("./icons/calendar4");
var _calendar4Default = parcelHelpers.interopDefault(_calendar4);
var _cameraFill = require("./icons/camera-fill");
var _cameraFillDefault = parcelHelpers.interopDefault(_cameraFill);
var _cameraReelsFill = require("./icons/camera-reels-fill");
var _cameraReelsFillDefault = parcelHelpers.interopDefault(_cameraReelsFill);
var _cameraReels = require("./icons/camera-reels");
var _cameraReelsDefault = parcelHelpers.interopDefault(_cameraReels);
var _cameraVideoFill = require("./icons/camera-video-fill");
var _cameraVideoFillDefault = parcelHelpers.interopDefault(_cameraVideoFill);
var _cameraVideoOffFill = require("./icons/camera-video-off-fill");
var _cameraVideoOffFillDefault = parcelHelpers.interopDefault(_cameraVideoOffFill);
var _cameraVideoOff = require("./icons/camera-video-off");
var _cameraVideoOffDefault = parcelHelpers.interopDefault(_cameraVideoOff);
var _cameraVideo = require("./icons/camera-video");
var _cameraVideoDefault = parcelHelpers.interopDefault(_cameraVideo);
var _camera = require("./icons/camera");
var _cameraDefault = parcelHelpers.interopDefault(_camera);
var _camera2 = require("./icons/camera2");
var _camera2Default = parcelHelpers.interopDefault(_camera2);
var _capslockFill = require("./icons/capslock-fill");
var _capslockFillDefault = parcelHelpers.interopDefault(_capslockFill);
var _capslock = require("./icons/capslock");
var _capslockDefault = parcelHelpers.interopDefault(_capslock);
var _capsulePill = require("./icons/capsule-pill");
var _capsulePillDefault = parcelHelpers.interopDefault(_capsulePill);
var _capsule = require("./icons/capsule");
var _capsuleDefault = parcelHelpers.interopDefault(_capsule);
var _carFrontFill = require("./icons/car-front-fill");
var _carFrontFillDefault = parcelHelpers.interopDefault(_carFrontFill);
var _carFront = require("./icons/car-front");
var _carFrontDefault = parcelHelpers.interopDefault(_carFront);
var _cardChecklist = require("./icons/card-checklist");
var _cardChecklistDefault = parcelHelpers.interopDefault(_cardChecklist);
var _cardHeading = require("./icons/card-heading");
var _cardHeadingDefault = parcelHelpers.interopDefault(_cardHeading);
var _cardImage = require("./icons/card-image");
var _cardImageDefault = parcelHelpers.interopDefault(_cardImage);
var _cardList = require("./icons/card-list");
var _cardListDefault = parcelHelpers.interopDefault(_cardList);
var _cardText = require("./icons/card-text");
var _cardTextDefault = parcelHelpers.interopDefault(_cardText);
var _caretDownFill = require("./icons/caret-down-fill");
var _caretDownFillDefault = parcelHelpers.interopDefault(_caretDownFill);
var _caretDownSquareFill = require("./icons/caret-down-square-fill");
var _caretDownSquareFillDefault = parcelHelpers.interopDefault(_caretDownSquareFill);
var _caretDownSquare = require("./icons/caret-down-square");
var _caretDownSquareDefault = parcelHelpers.interopDefault(_caretDownSquare);
var _caretDown = require("./icons/caret-down");
var _caretDownDefault = parcelHelpers.interopDefault(_caretDown);
var _caretLeftFill = require("./icons/caret-left-fill");
var _caretLeftFillDefault = parcelHelpers.interopDefault(_caretLeftFill);
var _caretLeftSquareFill = require("./icons/caret-left-square-fill");
var _caretLeftSquareFillDefault = parcelHelpers.interopDefault(_caretLeftSquareFill);
var _caretLeftSquare = require("./icons/caret-left-square");
var _caretLeftSquareDefault = parcelHelpers.interopDefault(_caretLeftSquare);
var _caretLeft = require("./icons/caret-left");
var _caretLeftDefault = parcelHelpers.interopDefault(_caretLeft);
var _caretRightFill = require("./icons/caret-right-fill");
var _caretRightFillDefault = parcelHelpers.interopDefault(_caretRightFill);
var _caretRightSquareFill = require("./icons/caret-right-square-fill");
var _caretRightSquareFillDefault = parcelHelpers.interopDefault(_caretRightSquareFill);
var _caretRightSquare = require("./icons/caret-right-square");
var _caretRightSquareDefault = parcelHelpers.interopDefault(_caretRightSquare);
var _caretRight = require("./icons/caret-right");
var _caretRightDefault = parcelHelpers.interopDefault(_caretRight);
var _caretUpFill = require("./icons/caret-up-fill");
var _caretUpFillDefault = parcelHelpers.interopDefault(_caretUpFill);
var _caretUpSquareFill = require("./icons/caret-up-square-fill");
var _caretUpSquareFillDefault = parcelHelpers.interopDefault(_caretUpSquareFill);
var _caretUpSquare = require("./icons/caret-up-square");
var _caretUpSquareDefault = parcelHelpers.interopDefault(_caretUpSquare);
var _caretUp = require("./icons/caret-up");
var _caretUpDefault = parcelHelpers.interopDefault(_caretUp);
var _cartCheckFill = require("./icons/cart-check-fill");
var _cartCheckFillDefault = parcelHelpers.interopDefault(_cartCheckFill);
var _cartCheck = require("./icons/cart-check");
var _cartCheckDefault = parcelHelpers.interopDefault(_cartCheck);
var _cartDashFill = require("./icons/cart-dash-fill");
var _cartDashFillDefault = parcelHelpers.interopDefault(_cartDashFill);
var _cartDash = require("./icons/cart-dash");
var _cartDashDefault = parcelHelpers.interopDefault(_cartDash);
var _cartFill = require("./icons/cart-fill");
var _cartFillDefault = parcelHelpers.interopDefault(_cartFill);
var _cartPlusFill = require("./icons/cart-plus-fill");
var _cartPlusFillDefault = parcelHelpers.interopDefault(_cartPlusFill);
var _cartPlus = require("./icons/cart-plus");
var _cartPlusDefault = parcelHelpers.interopDefault(_cartPlus);
var _cartXFill = require("./icons/cart-x-fill");
var _cartXFillDefault = parcelHelpers.interopDefault(_cartXFill);
var _cartX = require("./icons/cart-x");
var _cartXDefault = parcelHelpers.interopDefault(_cartX);
var _cart = require("./icons/cart");
var _cartDefault = parcelHelpers.interopDefault(_cart);
var _cart2 = require("./icons/cart2");
var _cart2Default = parcelHelpers.interopDefault(_cart2);
var _cart3 = require("./icons/cart3");
var _cart3Default = parcelHelpers.interopDefault(_cart3);
var _cart4 = require("./icons/cart4");
var _cart4Default = parcelHelpers.interopDefault(_cart4);
var _cashCoin = require("./icons/cash-coin");
var _cashCoinDefault = parcelHelpers.interopDefault(_cashCoin);
var _cashStack = require("./icons/cash-stack");
var _cashStackDefault = parcelHelpers.interopDefault(_cashStack);
var _cash = require("./icons/cash");
var _cashDefault = parcelHelpers.interopDefault(_cash);
var _cassetteFill = require("./icons/cassette-fill");
var _cassetteFillDefault = parcelHelpers.interopDefault(_cassetteFill);
var _cassette = require("./icons/cassette");
var _cassetteDefault = parcelHelpers.interopDefault(_cassette);
var _cast = require("./icons/cast");
var _castDefault = parcelHelpers.interopDefault(_cast);
var _ccCircleFill = require("./icons/cc-circle-fill");
var _ccCircleFillDefault = parcelHelpers.interopDefault(_ccCircleFill);
var _ccCircle = require("./icons/cc-circle");
var _ccCircleDefault = parcelHelpers.interopDefault(_ccCircle);
var _ccSquareFill = require("./icons/cc-square-fill");
var _ccSquareFillDefault = parcelHelpers.interopDefault(_ccSquareFill);
var _ccSquare = require("./icons/cc-square");
var _ccSquareDefault = parcelHelpers.interopDefault(_ccSquare);
var _chatDotsFill = require("./icons/chat-dots-fill");
var _chatDotsFillDefault = parcelHelpers.interopDefault(_chatDotsFill);
var _chatDots = require("./icons/chat-dots");
var _chatDotsDefault = parcelHelpers.interopDefault(_chatDots);
var _chatFill = require("./icons/chat-fill");
var _chatFillDefault = parcelHelpers.interopDefault(_chatFill);
var _chatHeartFill = require("./icons/chat-heart-fill");
var _chatHeartFillDefault = parcelHelpers.interopDefault(_chatHeartFill);
var _chatHeart = require("./icons/chat-heart");
var _chatHeartDefault = parcelHelpers.interopDefault(_chatHeart);
var _chatLeftDotsFill = require("./icons/chat-left-dots-fill");
var _chatLeftDotsFillDefault = parcelHelpers.interopDefault(_chatLeftDotsFill);
var _chatLeftDots = require("./icons/chat-left-dots");
var _chatLeftDotsDefault = parcelHelpers.interopDefault(_chatLeftDots);
var _chatLeftFill = require("./icons/chat-left-fill");
var _chatLeftFillDefault = parcelHelpers.interopDefault(_chatLeftFill);
var _chatLeftHeartFill = require("./icons/chat-left-heart-fill");
var _chatLeftHeartFillDefault = parcelHelpers.interopDefault(_chatLeftHeartFill);
var _chatLeftHeart = require("./icons/chat-left-heart");
var _chatLeftHeartDefault = parcelHelpers.interopDefault(_chatLeftHeart);
var _chatLeftQuoteFill = require("./icons/chat-left-quote-fill");
var _chatLeftQuoteFillDefault = parcelHelpers.interopDefault(_chatLeftQuoteFill);
var _chatLeftQuote = require("./icons/chat-left-quote");
var _chatLeftQuoteDefault = parcelHelpers.interopDefault(_chatLeftQuote);
var _chatLeftTextFill = require("./icons/chat-left-text-fill");
var _chatLeftTextFillDefault = parcelHelpers.interopDefault(_chatLeftTextFill);
var _chatLeftText = require("./icons/chat-left-text");
var _chatLeftTextDefault = parcelHelpers.interopDefault(_chatLeftText);
var _chatLeft = require("./icons/chat-left");
var _chatLeftDefault = parcelHelpers.interopDefault(_chatLeft);
var _chatQuoteFill = require("./icons/chat-quote-fill");
var _chatQuoteFillDefault = parcelHelpers.interopDefault(_chatQuoteFill);
var _chatQuote = require("./icons/chat-quote");
var _chatQuoteDefault = parcelHelpers.interopDefault(_chatQuote);
var _chatRightDotsFill = require("./icons/chat-right-dots-fill");
var _chatRightDotsFillDefault = parcelHelpers.interopDefault(_chatRightDotsFill);
var _chatRightDots = require("./icons/chat-right-dots");
var _chatRightDotsDefault = parcelHelpers.interopDefault(_chatRightDots);
var _chatRightFill = require("./icons/chat-right-fill");
var _chatRightFillDefault = parcelHelpers.interopDefault(_chatRightFill);
var _chatRightHeartFill = require("./icons/chat-right-heart-fill");
var _chatRightHeartFillDefault = parcelHelpers.interopDefault(_chatRightHeartFill);
var _chatRightHeart = require("./icons/chat-right-heart");
var _chatRightHeartDefault = parcelHelpers.interopDefault(_chatRightHeart);
var _chatRightQuoteFill = require("./icons/chat-right-quote-fill");
var _chatRightQuoteFillDefault = parcelHelpers.interopDefault(_chatRightQuoteFill);
var _chatRightQuote = require("./icons/chat-right-quote");
var _chatRightQuoteDefault = parcelHelpers.interopDefault(_chatRightQuote);
var _chatRightTextFill = require("./icons/chat-right-text-fill");
var _chatRightTextFillDefault = parcelHelpers.interopDefault(_chatRightTextFill);
var _chatRightText = require("./icons/chat-right-text");
var _chatRightTextDefault = parcelHelpers.interopDefault(_chatRightText);
var _chatRight = require("./icons/chat-right");
var _chatRightDefault = parcelHelpers.interopDefault(_chatRight);
var _chatSquareDotsFill = require("./icons/chat-square-dots-fill");
var _chatSquareDotsFillDefault = parcelHelpers.interopDefault(_chatSquareDotsFill);
var _chatSquareDots = require("./icons/chat-square-dots");
var _chatSquareDotsDefault = parcelHelpers.interopDefault(_chatSquareDots);
var _chatSquareFill = require("./icons/chat-square-fill");
var _chatSquareFillDefault = parcelHelpers.interopDefault(_chatSquareFill);
var _chatSquareHeartFill = require("./icons/chat-square-heart-fill");
var _chatSquareHeartFillDefault = parcelHelpers.interopDefault(_chatSquareHeartFill);
var _chatSquareHeart = require("./icons/chat-square-heart");
var _chatSquareHeartDefault = parcelHelpers.interopDefault(_chatSquareHeart);
var _chatSquareQuoteFill = require("./icons/chat-square-quote-fill");
var _chatSquareQuoteFillDefault = parcelHelpers.interopDefault(_chatSquareQuoteFill);
var _chatSquareQuote = require("./icons/chat-square-quote");
var _chatSquareQuoteDefault = parcelHelpers.interopDefault(_chatSquareQuote);
var _chatSquareTextFill = require("./icons/chat-square-text-fill");
var _chatSquareTextFillDefault = parcelHelpers.interopDefault(_chatSquareTextFill);
var _chatSquareText = require("./icons/chat-square-text");
var _chatSquareTextDefault = parcelHelpers.interopDefault(_chatSquareText);
var _chatSquare = require("./icons/chat-square");
var _chatSquareDefault = parcelHelpers.interopDefault(_chatSquare);
var _chatTextFill = require("./icons/chat-text-fill");
var _chatTextFillDefault = parcelHelpers.interopDefault(_chatTextFill);
var _chatText = require("./icons/chat-text");
var _chatTextDefault = parcelHelpers.interopDefault(_chatText);
var _chat = require("./icons/chat");
var _chatDefault = parcelHelpers.interopDefault(_chat);
var _checkAll = require("./icons/check-all");
var _checkAllDefault = parcelHelpers.interopDefault(_checkAll);
var _checkCircleFill = require("./icons/check-circle-fill");
var _checkCircleFillDefault = parcelHelpers.interopDefault(_checkCircleFill);
var _checkCircle = require("./icons/check-circle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _checkLg = require("./icons/check-lg");
var _checkLgDefault = parcelHelpers.interopDefault(_checkLg);
var _checkSquareFill = require("./icons/check-square-fill");
var _checkSquareFillDefault = parcelHelpers.interopDefault(_checkSquareFill);
var _checkSquare = require("./icons/check-square");
var _checkSquareDefault = parcelHelpers.interopDefault(_checkSquare);
var _check = require("./icons/check");
var _checkDefault = parcelHelpers.interopDefault(_check);
var _check2All = require("./icons/check2-all");
var _check2AllDefault = parcelHelpers.interopDefault(_check2All);
var _check2Circle = require("./icons/check2-circle");
var _check2CircleDefault = parcelHelpers.interopDefault(_check2Circle);
var _check2Square = require("./icons/check2-square");
var _check2SquareDefault = parcelHelpers.interopDefault(_check2Square);
var _check2 = require("./icons/check2");
var _check2Default = parcelHelpers.interopDefault(_check2);
var _chevronBarContract = require("./icons/chevron-bar-contract");
var _chevronBarContractDefault = parcelHelpers.interopDefault(_chevronBarContract);
var _chevronBarDown = require("./icons/chevron-bar-down");
var _chevronBarDownDefault = parcelHelpers.interopDefault(_chevronBarDown);
var _chevronBarExpand = require("./icons/chevron-bar-expand");
var _chevronBarExpandDefault = parcelHelpers.interopDefault(_chevronBarExpand);
var _chevronBarLeft = require("./icons/chevron-bar-left");
var _chevronBarLeftDefault = parcelHelpers.interopDefault(_chevronBarLeft);
var _chevronBarRight = require("./icons/chevron-bar-right");
var _chevronBarRightDefault = parcelHelpers.interopDefault(_chevronBarRight);
var _chevronBarUp = require("./icons/chevron-bar-up");
var _chevronBarUpDefault = parcelHelpers.interopDefault(_chevronBarUp);
var _chevronCompactDown = require("./icons/chevron-compact-down");
var _chevronCompactDownDefault = parcelHelpers.interopDefault(_chevronCompactDown);
var _chevronCompactLeft = require("./icons/chevron-compact-left");
var _chevronCompactLeftDefault = parcelHelpers.interopDefault(_chevronCompactLeft);
var _chevronCompactRight = require("./icons/chevron-compact-right");
var _chevronCompactRightDefault = parcelHelpers.interopDefault(_chevronCompactRight);
var _chevronCompactUp = require("./icons/chevron-compact-up");
var _chevronCompactUpDefault = parcelHelpers.interopDefault(_chevronCompactUp);
var _chevronContract = require("./icons/chevron-contract");
var _chevronContractDefault = parcelHelpers.interopDefault(_chevronContract);
var _chevronDoubleDown = require("./icons/chevron-double-down");
var _chevronDoubleDownDefault = parcelHelpers.interopDefault(_chevronDoubleDown);
var _chevronDoubleLeft = require("./icons/chevron-double-left");
var _chevronDoubleLeftDefault = parcelHelpers.interopDefault(_chevronDoubleLeft);
var _chevronDoubleRight = require("./icons/chevron-double-right");
var _chevronDoubleRightDefault = parcelHelpers.interopDefault(_chevronDoubleRight);
var _chevronDoubleUp = require("./icons/chevron-double-up");
var _chevronDoubleUpDefault = parcelHelpers.interopDefault(_chevronDoubleUp);
var _chevronDown = require("./icons/chevron-down");
var _chevronDownDefault = parcelHelpers.interopDefault(_chevronDown);
var _chevronExpand = require("./icons/chevron-expand");
var _chevronExpandDefault = parcelHelpers.interopDefault(_chevronExpand);
var _chevronLeft = require("./icons/chevron-left");
var _chevronLeftDefault = parcelHelpers.interopDefault(_chevronLeft);
var _chevronRight = require("./icons/chevron-right");
var _chevronRightDefault = parcelHelpers.interopDefault(_chevronRight);
var _chevronUp = require("./icons/chevron-up");
var _chevronUpDefault = parcelHelpers.interopDefault(_chevronUp);
var _circleFill = require("./icons/circle-fill");
var _circleFillDefault = parcelHelpers.interopDefault(_circleFill);
var _circleHalf = require("./icons/circle-half");
var _circleHalfDefault = parcelHelpers.interopDefault(_circleHalf);
var _circleSquare = require("./icons/circle-square");
var _circleSquareDefault = parcelHelpers.interopDefault(_circleSquare);
var _circle = require("./icons/circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
var _clipboardCheckFill = require("./icons/clipboard-check-fill");
var _clipboardCheckFillDefault = parcelHelpers.interopDefault(_clipboardCheckFill);
var _clipboardCheck = require("./icons/clipboard-check");
var _clipboardCheckDefault = parcelHelpers.interopDefault(_clipboardCheck);
var _clipboardDataFill = require("./icons/clipboard-data-fill");
var _clipboardDataFillDefault = parcelHelpers.interopDefault(_clipboardDataFill);
var _clipboardData = require("./icons/clipboard-data");
var _clipboardDataDefault = parcelHelpers.interopDefault(_clipboardData);
var _clipboardFill = require("./icons/clipboard-fill");
var _clipboardFillDefault = parcelHelpers.interopDefault(_clipboardFill);
var _clipboardHeartFill = require("./icons/clipboard-heart-fill");
var _clipboardHeartFillDefault = parcelHelpers.interopDefault(_clipboardHeartFill);
var _clipboardHeart = require("./icons/clipboard-heart");
var _clipboardHeartDefault = parcelHelpers.interopDefault(_clipboardHeart);
var _clipboardMinusFill = require("./icons/clipboard-minus-fill");
var _clipboardMinusFillDefault = parcelHelpers.interopDefault(_clipboardMinusFill);
var _clipboardMinus = require("./icons/clipboard-minus");
var _clipboardMinusDefault = parcelHelpers.interopDefault(_clipboardMinus);
var _clipboardPlusFill = require("./icons/clipboard-plus-fill");
var _clipboardPlusFillDefault = parcelHelpers.interopDefault(_clipboardPlusFill);
var _clipboardPlus = require("./icons/clipboard-plus");
var _clipboardPlusDefault = parcelHelpers.interopDefault(_clipboardPlus);
var _clipboardPulse = require("./icons/clipboard-pulse");
var _clipboardPulseDefault = parcelHelpers.interopDefault(_clipboardPulse);
var _clipboardXFill = require("./icons/clipboard-x-fill");
var _clipboardXFillDefault = parcelHelpers.interopDefault(_clipboardXFill);
var _clipboardX = require("./icons/clipboard-x");
var _clipboardXDefault = parcelHelpers.interopDefault(_clipboardX);
var _clipboard = require("./icons/clipboard");
var _clipboardDefault = parcelHelpers.interopDefault(_clipboard);
var _clipboard2CheckFill = require("./icons/clipboard2-check-fill");
var _clipboard2CheckFillDefault = parcelHelpers.interopDefault(_clipboard2CheckFill);
var _clipboard2Check = require("./icons/clipboard2-check");
var _clipboard2CheckDefault = parcelHelpers.interopDefault(_clipboard2Check);
var _clipboard2DataFill = require("./icons/clipboard2-data-fill");
var _clipboard2DataFillDefault = parcelHelpers.interopDefault(_clipboard2DataFill);
var _clipboard2Data = require("./icons/clipboard2-data");
var _clipboard2DataDefault = parcelHelpers.interopDefault(_clipboard2Data);
var _clipboard2Fill = require("./icons/clipboard2-fill");
var _clipboard2FillDefault = parcelHelpers.interopDefault(_clipboard2Fill);
var _clipboard2HeartFill = require("./icons/clipboard2-heart-fill");
var _clipboard2HeartFillDefault = parcelHelpers.interopDefault(_clipboard2HeartFill);
var _clipboard2Heart = require("./icons/clipboard2-heart");
var _clipboard2HeartDefault = parcelHelpers.interopDefault(_clipboard2Heart);
var _clipboard2MinusFill = require("./icons/clipboard2-minus-fill");
var _clipboard2MinusFillDefault = parcelHelpers.interopDefault(_clipboard2MinusFill);
var _clipboard2Minus = require("./icons/clipboard2-minus");
var _clipboard2MinusDefault = parcelHelpers.interopDefault(_clipboard2Minus);
var _clipboard2PlusFill = require("./icons/clipboard2-plus-fill");
var _clipboard2PlusFillDefault = parcelHelpers.interopDefault(_clipboard2PlusFill);
var _clipboard2Plus = require("./icons/clipboard2-plus");
var _clipboard2PlusDefault = parcelHelpers.interopDefault(_clipboard2Plus);
var _clipboard2PulseFill = require("./icons/clipboard2-pulse-fill");
var _clipboard2PulseFillDefault = parcelHelpers.interopDefault(_clipboard2PulseFill);
var _clipboard2Pulse = require("./icons/clipboard2-pulse");
var _clipboard2PulseDefault = parcelHelpers.interopDefault(_clipboard2Pulse);
var _clipboard2XFill = require("./icons/clipboard2-x-fill");
var _clipboard2XFillDefault = parcelHelpers.interopDefault(_clipboard2XFill);
var _clipboard2X = require("./icons/clipboard2-x");
var _clipboard2XDefault = parcelHelpers.interopDefault(_clipboard2X);
var _clipboard2 = require("./icons/clipboard2");
var _clipboard2Default = parcelHelpers.interopDefault(_clipboard2);
var _clockFill = require("./icons/clock-fill");
var _clockFillDefault = parcelHelpers.interopDefault(_clockFill);
var _clockHistory = require("./icons/clock-history");
var _clockHistoryDefault = parcelHelpers.interopDefault(_clockHistory);
var _clock = require("./icons/clock");
var _clockDefault = parcelHelpers.interopDefault(_clock);
var _cloudArrowDownFill = require("./icons/cloud-arrow-down-fill");
var _cloudArrowDownFillDefault = parcelHelpers.interopDefault(_cloudArrowDownFill);
var _cloudArrowDown = require("./icons/cloud-arrow-down");
var _cloudArrowDownDefault = parcelHelpers.interopDefault(_cloudArrowDown);
var _cloudArrowUpFill = require("./icons/cloud-arrow-up-fill");
var _cloudArrowUpFillDefault = parcelHelpers.interopDefault(_cloudArrowUpFill);
var _cloudArrowUp = require("./icons/cloud-arrow-up");
var _cloudArrowUpDefault = parcelHelpers.interopDefault(_cloudArrowUp);
var _cloudCheckFill = require("./icons/cloud-check-fill");
var _cloudCheckFillDefault = parcelHelpers.interopDefault(_cloudCheckFill);
var _cloudCheck = require("./icons/cloud-check");
var _cloudCheckDefault = parcelHelpers.interopDefault(_cloudCheck);
var _cloudDownloadFill = require("./icons/cloud-download-fill");
var _cloudDownloadFillDefault = parcelHelpers.interopDefault(_cloudDownloadFill);
var _cloudDownload = require("./icons/cloud-download");
var _cloudDownloadDefault = parcelHelpers.interopDefault(_cloudDownload);
var _cloudDrizzleFill = require("./icons/cloud-drizzle-fill");
var _cloudDrizzleFillDefault = parcelHelpers.interopDefault(_cloudDrizzleFill);
var _cloudDrizzle = require("./icons/cloud-drizzle");
var _cloudDrizzleDefault = parcelHelpers.interopDefault(_cloudDrizzle);
var _cloudFill = require("./icons/cloud-fill");
var _cloudFillDefault = parcelHelpers.interopDefault(_cloudFill);
var _cloudFogFill = require("./icons/cloud-fog-fill");
var _cloudFogFillDefault = parcelHelpers.interopDefault(_cloudFogFill);
var _cloudFog = require("./icons/cloud-fog");
var _cloudFogDefault = parcelHelpers.interopDefault(_cloudFog);
var _cloudFog2Fill = require("./icons/cloud-fog2-fill");
var _cloudFog2FillDefault = parcelHelpers.interopDefault(_cloudFog2Fill);
var _cloudFog2 = require("./icons/cloud-fog2");
var _cloudFog2Default = parcelHelpers.interopDefault(_cloudFog2);
var _cloudHailFill = require("./icons/cloud-hail-fill");
var _cloudHailFillDefault = parcelHelpers.interopDefault(_cloudHailFill);
var _cloudHail = require("./icons/cloud-hail");
var _cloudHailDefault = parcelHelpers.interopDefault(_cloudHail);
var _cloudHazeFill = require("./icons/cloud-haze-fill");
var _cloudHazeFillDefault = parcelHelpers.interopDefault(_cloudHazeFill);
var _cloudHaze = require("./icons/cloud-haze");
var _cloudHazeDefault = parcelHelpers.interopDefault(_cloudHaze);
var _cloudHaze2Fill = require("./icons/cloud-haze2-fill");
var _cloudHaze2FillDefault = parcelHelpers.interopDefault(_cloudHaze2Fill);
var _cloudHaze2 = require("./icons/cloud-haze2");
var _cloudHaze2Default = parcelHelpers.interopDefault(_cloudHaze2);
var _cloudLightningFill = require("./icons/cloud-lightning-fill");
var _cloudLightningFillDefault = parcelHelpers.interopDefault(_cloudLightningFill);
var _cloudLightningRainFill = require("./icons/cloud-lightning-rain-fill");
var _cloudLightningRainFillDefault = parcelHelpers.interopDefault(_cloudLightningRainFill);
var _cloudLightningRain = require("./icons/cloud-lightning-rain");
var _cloudLightningRainDefault = parcelHelpers.interopDefault(_cloudLightningRain);
var _cloudLightning = require("./icons/cloud-lightning");
var _cloudLightningDefault = parcelHelpers.interopDefault(_cloudLightning);
var _cloudMinusFill = require("./icons/cloud-minus-fill");
var _cloudMinusFillDefault = parcelHelpers.interopDefault(_cloudMinusFill);
var _cloudMinus = require("./icons/cloud-minus");
var _cloudMinusDefault = parcelHelpers.interopDefault(_cloudMinus);
var _cloudMoonFill = require("./icons/cloud-moon-fill");
var _cloudMoonFillDefault = parcelHelpers.interopDefault(_cloudMoonFill);
var _cloudMoon = require("./icons/cloud-moon");
var _cloudMoonDefault = parcelHelpers.interopDefault(_cloudMoon);
var _cloudPlusFill = require("./icons/cloud-plus-fill");
var _cloudPlusFillDefault = parcelHelpers.interopDefault(_cloudPlusFill);
var _cloudPlus = require("./icons/cloud-plus");
var _cloudPlusDefault = parcelHelpers.interopDefault(_cloudPlus);
var _cloudRainFill = require("./icons/cloud-rain-fill");
var _cloudRainFillDefault = parcelHelpers.interopDefault(_cloudRainFill);
var _cloudRainHeavyFill = require("./icons/cloud-rain-heavy-fill");
var _cloudRainHeavyFillDefault = parcelHelpers.interopDefault(_cloudRainHeavyFill);
var _cloudRainHeavy = require("./icons/cloud-rain-heavy");
var _cloudRainHeavyDefault = parcelHelpers.interopDefault(_cloudRainHeavy);
var _cloudRain = require("./icons/cloud-rain");
var _cloudRainDefault = parcelHelpers.interopDefault(_cloudRain);
var _cloudSlashFill = require("./icons/cloud-slash-fill");
var _cloudSlashFillDefault = parcelHelpers.interopDefault(_cloudSlashFill);
var _cloudSlash = require("./icons/cloud-slash");
var _cloudSlashDefault = parcelHelpers.interopDefault(_cloudSlash);
var _cloudSleetFill = require("./icons/cloud-sleet-fill");
var _cloudSleetFillDefault = parcelHelpers.interopDefault(_cloudSleetFill);
var _cloudSleet = require("./icons/cloud-sleet");
var _cloudSleetDefault = parcelHelpers.interopDefault(_cloudSleet);
var _cloudSnowFill = require("./icons/cloud-snow-fill");
var _cloudSnowFillDefault = parcelHelpers.interopDefault(_cloudSnowFill);
var _cloudSnow = require("./icons/cloud-snow");
var _cloudSnowDefault = parcelHelpers.interopDefault(_cloudSnow);
var _cloudSunFill = require("./icons/cloud-sun-fill");
var _cloudSunFillDefault = parcelHelpers.interopDefault(_cloudSunFill);
var _cloudSun = require("./icons/cloud-sun");
var _cloudSunDefault = parcelHelpers.interopDefault(_cloudSun);
var _cloudUploadFill = require("./icons/cloud-upload-fill");
var _cloudUploadFillDefault = parcelHelpers.interopDefault(_cloudUploadFill);
var _cloudUpload = require("./icons/cloud-upload");
var _cloudUploadDefault = parcelHelpers.interopDefault(_cloudUpload);
var _cloud = require("./icons/cloud");
var _cloudDefault = parcelHelpers.interopDefault(_cloud);
var _cloudsFill = require("./icons/clouds-fill");
var _cloudsFillDefault = parcelHelpers.interopDefault(_cloudsFill);
var _clouds = require("./icons/clouds");
var _cloudsDefault = parcelHelpers.interopDefault(_clouds);
var _cloudyFill = require("./icons/cloudy-fill");
var _cloudyFillDefault = parcelHelpers.interopDefault(_cloudyFill);
var _cloudy = require("./icons/cloudy");
var _cloudyDefault = parcelHelpers.interopDefault(_cloudy);
var _codeSlash = require("./icons/code-slash");
var _codeSlashDefault = parcelHelpers.interopDefault(_codeSlash);
var _codeSquare = require("./icons/code-square");
var _codeSquareDefault = parcelHelpers.interopDefault(_codeSquare);
var _code = require("./icons/code");
var _codeDefault = parcelHelpers.interopDefault(_code);
var _coin = require("./icons/coin");
var _coinDefault = parcelHelpers.interopDefault(_coin);
var _collectionFill = require("./icons/collection-fill");
var _collectionFillDefault = parcelHelpers.interopDefault(_collectionFill);
var _collectionPlayFill = require("./icons/collection-play-fill");
var _collectionPlayFillDefault = parcelHelpers.interopDefault(_collectionPlayFill);
var _collectionPlay = require("./icons/collection-play");
var _collectionPlayDefault = parcelHelpers.interopDefault(_collectionPlay);
var _collection = require("./icons/collection");
var _collectionDefault = parcelHelpers.interopDefault(_collection);
var _columnsGap = require("./icons/columns-gap");
var _columnsGapDefault = parcelHelpers.interopDefault(_columnsGap);
var _columns = require("./icons/columns");
var _columnsDefault = parcelHelpers.interopDefault(_columns);
var _command = require("./icons/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _compassFill = require("./icons/compass-fill");
var _compassFillDefault = parcelHelpers.interopDefault(_compassFill);
var _compass = require("./icons/compass");
var _compassDefault = parcelHelpers.interopDefault(_compass);
var _coneStriped = require("./icons/cone-striped");
var _coneStripedDefault = parcelHelpers.interopDefault(_coneStriped);
var _cone = require("./icons/cone");
var _coneDefault = parcelHelpers.interopDefault(_cone);
var _controller = require("./icons/controller");
var _controllerDefault = parcelHelpers.interopDefault(_controller);
var _cookie = require("./icons/cookie");
var _cookieDefault = parcelHelpers.interopDefault(_cookie);
var _copy = require("./icons/copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _cpuFill = require("./icons/cpu-fill");
var _cpuFillDefault = parcelHelpers.interopDefault(_cpuFill);
var _cpu = require("./icons/cpu");
var _cpuDefault = parcelHelpers.interopDefault(_cpu);
var _creditCard2BackFill = require("./icons/credit-card-2-back-fill");
var _creditCard2BackFillDefault = parcelHelpers.interopDefault(_creditCard2BackFill);
var _creditCard2Back = require("./icons/credit-card-2-back");
var _creditCard2BackDefault = parcelHelpers.interopDefault(_creditCard2Back);
var _creditCard2FrontFill = require("./icons/credit-card-2-front-fill");
var _creditCard2FrontFillDefault = parcelHelpers.interopDefault(_creditCard2FrontFill);
var _creditCard2Front = require("./icons/credit-card-2-front");
var _creditCard2FrontDefault = parcelHelpers.interopDefault(_creditCard2Front);
var _creditCardFill = require("./icons/credit-card-fill");
var _creditCardFillDefault = parcelHelpers.interopDefault(_creditCardFill);
var _creditCard = require("./icons/credit-card");
var _creditCardDefault = parcelHelpers.interopDefault(_creditCard);
var _crop = require("./icons/crop");
var _cropDefault = parcelHelpers.interopDefault(_crop);
var _crosshair = require("./icons/crosshair");
var _crosshairDefault = parcelHelpers.interopDefault(_crosshair);
var _crosshair2 = require("./icons/crosshair2");
var _crosshair2Default = parcelHelpers.interopDefault(_crosshair2);
var _cupFill = require("./icons/cup-fill");
var _cupFillDefault = parcelHelpers.interopDefault(_cupFill);
var _cupHotFill = require("./icons/cup-hot-fill");
var _cupHotFillDefault = parcelHelpers.interopDefault(_cupHotFill);
var _cupHot = require("./icons/cup-hot");
var _cupHotDefault = parcelHelpers.interopDefault(_cupHot);
var _cupStraw = require("./icons/cup-straw");
var _cupStrawDefault = parcelHelpers.interopDefault(_cupStraw);
var _cup = require("./icons/cup");
var _cupDefault = parcelHelpers.interopDefault(_cup);
var _currencyBitcoin = require("./icons/currency-bitcoin");
var _currencyBitcoinDefault = parcelHelpers.interopDefault(_currencyBitcoin);
var _currencyDollar = require("./icons/currency-dollar");
var _currencyDollarDefault = parcelHelpers.interopDefault(_currencyDollar);
var _currencyEuro = require("./icons/currency-euro");
var _currencyEuroDefault = parcelHelpers.interopDefault(_currencyEuro);
var _currencyExchange = require("./icons/currency-exchange");
var _currencyExchangeDefault = parcelHelpers.interopDefault(_currencyExchange);
var _currencyPound = require("./icons/currency-pound");
var _currencyPoundDefault = parcelHelpers.interopDefault(_currencyPound);
var _currencyRupee = require("./icons/currency-rupee");
var _currencyRupeeDefault = parcelHelpers.interopDefault(_currencyRupee);
var _currencyYen = require("./icons/currency-yen");
var _currencyYenDefault = parcelHelpers.interopDefault(_currencyYen);
var _cursorFill = require("./icons/cursor-fill");
var _cursorFillDefault = parcelHelpers.interopDefault(_cursorFill);
var _cursorText = require("./icons/cursor-text");
var _cursorTextDefault = parcelHelpers.interopDefault(_cursorText);
var _cursor = require("./icons/cursor");
var _cursorDefault = parcelHelpers.interopDefault(_cursor);
var _dashCircleDotted = require("./icons/dash-circle-dotted");
var _dashCircleDottedDefault = parcelHelpers.interopDefault(_dashCircleDotted);
var _dashCircleFill = require("./icons/dash-circle-fill");
var _dashCircleFillDefault = parcelHelpers.interopDefault(_dashCircleFill);
var _dashCircle = require("./icons/dash-circle");
var _dashCircleDefault = parcelHelpers.interopDefault(_dashCircle);
var _dashLg = require("./icons/dash-lg");
var _dashLgDefault = parcelHelpers.interopDefault(_dashLg);
var _dashSquareDotted = require("./icons/dash-square-dotted");
var _dashSquareDottedDefault = parcelHelpers.interopDefault(_dashSquareDotted);
var _dashSquareFill = require("./icons/dash-square-fill");
var _dashSquareFillDefault = parcelHelpers.interopDefault(_dashSquareFill);
var _dashSquare = require("./icons/dash-square");
var _dashSquareDefault = parcelHelpers.interopDefault(_dashSquare);
var _dash = require("./icons/dash");
var _dashDefault = parcelHelpers.interopDefault(_dash);
var _databaseAdd = require("./icons/database-add");
var _databaseAddDefault = parcelHelpers.interopDefault(_databaseAdd);
var _databaseCheck = require("./icons/database-check");
var _databaseCheckDefault = parcelHelpers.interopDefault(_databaseCheck);
var _databaseDash = require("./icons/database-dash");
var _databaseDashDefault = parcelHelpers.interopDefault(_databaseDash);
var _databaseDown = require("./icons/database-down");
var _databaseDownDefault = parcelHelpers.interopDefault(_databaseDown);
var _databaseExclamation = require("./icons/database-exclamation");
var _databaseExclamationDefault = parcelHelpers.interopDefault(_databaseExclamation);
var _databaseFillAdd = require("./icons/database-fill-add");
var _databaseFillAddDefault = parcelHelpers.interopDefault(_databaseFillAdd);
var _databaseFillCheck = require("./icons/database-fill-check");
var _databaseFillCheckDefault = parcelHelpers.interopDefault(_databaseFillCheck);
var _databaseFillDash = require("./icons/database-fill-dash");
var _databaseFillDashDefault = parcelHelpers.interopDefault(_databaseFillDash);
var _databaseFillDown = require("./icons/database-fill-down");
var _databaseFillDownDefault = parcelHelpers.interopDefault(_databaseFillDown);
var _databaseFillExclamation = require("./icons/database-fill-exclamation");
var _databaseFillExclamationDefault = parcelHelpers.interopDefault(_databaseFillExclamation);
var _databaseFillGear = require("./icons/database-fill-gear");
var _databaseFillGearDefault = parcelHelpers.interopDefault(_databaseFillGear);
var _databaseFillLock = require("./icons/database-fill-lock");
var _databaseFillLockDefault = parcelHelpers.interopDefault(_databaseFillLock);
var _databaseFillSlash = require("./icons/database-fill-slash");
var _databaseFillSlashDefault = parcelHelpers.interopDefault(_databaseFillSlash);
var _databaseFillUp = require("./icons/database-fill-up");
var _databaseFillUpDefault = parcelHelpers.interopDefault(_databaseFillUp);
var _databaseFillX = require("./icons/database-fill-x");
var _databaseFillXDefault = parcelHelpers.interopDefault(_databaseFillX);
var _databaseFill = require("./icons/database-fill");
var _databaseFillDefault = parcelHelpers.interopDefault(_databaseFill);
var _databaseGear = require("./icons/database-gear");
var _databaseGearDefault = parcelHelpers.interopDefault(_databaseGear);
var _databaseLock = require("./icons/database-lock");
var _databaseLockDefault = parcelHelpers.interopDefault(_databaseLock);
var _databaseSlash = require("./icons/database-slash");
var _databaseSlashDefault = parcelHelpers.interopDefault(_databaseSlash);
var _databaseUp = require("./icons/database-up");
var _databaseUpDefault = parcelHelpers.interopDefault(_databaseUp);
var _databaseX = require("./icons/database-x");
var _databaseXDefault = parcelHelpers.interopDefault(_databaseX);
var _database = require("./icons/database");
var _databaseDefault = parcelHelpers.interopDefault(_database);
var _deviceHddFill = require("./icons/device-hdd-fill");
var _deviceHddFillDefault = parcelHelpers.interopDefault(_deviceHddFill);
var _deviceHdd = require("./icons/device-hdd");
var _deviceHddDefault = parcelHelpers.interopDefault(_deviceHdd);
var _deviceSsdFill = require("./icons/device-ssd-fill");
var _deviceSsdFillDefault = parcelHelpers.interopDefault(_deviceSsdFill);
var _deviceSsd = require("./icons/device-ssd");
var _deviceSsdDefault = parcelHelpers.interopDefault(_deviceSsd);
var _diagram2Fill = require("./icons/diagram-2-fill");
var _diagram2FillDefault = parcelHelpers.interopDefault(_diagram2Fill);
var _diagram2 = require("./icons/diagram-2");
var _diagram2Default = parcelHelpers.interopDefault(_diagram2);
var _diagram3Fill = require("./icons/diagram-3-fill");
var _diagram3FillDefault = parcelHelpers.interopDefault(_diagram3Fill);
var _diagram3 = require("./icons/diagram-3");
var _diagram3Default = parcelHelpers.interopDefault(_diagram3);
var _diamondFill = require("./icons/diamond-fill");
var _diamondFillDefault = parcelHelpers.interopDefault(_diamondFill);
var _diamondHalf = require("./icons/diamond-half");
var _diamondHalfDefault = parcelHelpers.interopDefault(_diamondHalf);
var _diamond = require("./icons/diamond");
var _diamondDefault = parcelHelpers.interopDefault(_diamond);
var _dice1Fill = require("./icons/dice-1-fill");
var _dice1FillDefault = parcelHelpers.interopDefault(_dice1Fill);
var _dice1 = require("./icons/dice-1");
var _dice1Default = parcelHelpers.interopDefault(_dice1);
var _dice2Fill = require("./icons/dice-2-fill");
var _dice2FillDefault = parcelHelpers.interopDefault(_dice2Fill);
var _dice2 = require("./icons/dice-2");
var _dice2Default = parcelHelpers.interopDefault(_dice2);
var _dice3Fill = require("./icons/dice-3-fill");
var _dice3FillDefault = parcelHelpers.interopDefault(_dice3Fill);
var _dice3 = require("./icons/dice-3");
var _dice3Default = parcelHelpers.interopDefault(_dice3);
var _dice4Fill = require("./icons/dice-4-fill");
var _dice4FillDefault = parcelHelpers.interopDefault(_dice4Fill);
var _dice4 = require("./icons/dice-4");
var _dice4Default = parcelHelpers.interopDefault(_dice4);
var _dice5Fill = require("./icons/dice-5-fill");
var _dice5FillDefault = parcelHelpers.interopDefault(_dice5Fill);
var _dice5 = require("./icons/dice-5");
var _dice5Default = parcelHelpers.interopDefault(_dice5);
var _dice6Fill = require("./icons/dice-6-fill");
var _dice6FillDefault = parcelHelpers.interopDefault(_dice6Fill);
var _dice6 = require("./icons/dice-6");
var _dice6Default = parcelHelpers.interopDefault(_dice6);
var _discFill = require("./icons/disc-fill");
var _discFillDefault = parcelHelpers.interopDefault(_discFill);
var _disc = require("./icons/disc");
var _discDefault = parcelHelpers.interopDefault(_disc);
var _discord = require("./icons/discord");
var _discordDefault = parcelHelpers.interopDefault(_discord);
var _displayFill = require("./icons/display-fill");
var _displayFillDefault = parcelHelpers.interopDefault(_displayFill);
var _display = require("./icons/display");
var _displayDefault = parcelHelpers.interopDefault(_display);
var _displayportFill = require("./icons/displayport-fill");
var _displayportFillDefault = parcelHelpers.interopDefault(_displayportFill);
var _displayport = require("./icons/displayport");
var _displayportDefault = parcelHelpers.interopDefault(_displayport);
var _distributeHorizontal = require("./icons/distribute-horizontal");
var _distributeHorizontalDefault = parcelHelpers.interopDefault(_distributeHorizontal);
var _distributeVertical = require("./icons/distribute-vertical");
var _distributeVerticalDefault = parcelHelpers.interopDefault(_distributeVertical);
var _doorClosedFill = require("./icons/door-closed-fill");
var _doorClosedFillDefault = parcelHelpers.interopDefault(_doorClosedFill);
var _doorClosed = require("./icons/door-closed");
var _doorClosedDefault = parcelHelpers.interopDefault(_doorClosed);
var _doorOpenFill = require("./icons/door-open-fill");
var _doorOpenFillDefault = parcelHelpers.interopDefault(_doorOpenFill);
var _doorOpen = require("./icons/door-open");
var _doorOpenDefault = parcelHelpers.interopDefault(_doorOpen);
var _dot = require("./icons/dot");
var _dotDefault = parcelHelpers.interopDefault(_dot);
var _download = require("./icons/download");
var _downloadDefault = parcelHelpers.interopDefault(_download);
var _dpadFill = require("./icons/dpad-fill");
var _dpadFillDefault = parcelHelpers.interopDefault(_dpadFill);
var _dpad = require("./icons/dpad");
var _dpadDefault = parcelHelpers.interopDefault(_dpad);
var _dribbble = require("./icons/dribbble");
var _dribbbleDefault = parcelHelpers.interopDefault(_dribbble);
var _dropbox = require("./icons/dropbox");
var _dropboxDefault = parcelHelpers.interopDefault(_dropbox);
var _dropletFill = require("./icons/droplet-fill");
var _dropletFillDefault = parcelHelpers.interopDefault(_dropletFill);
var _dropletHalf = require("./icons/droplet-half");
var _dropletHalfDefault = parcelHelpers.interopDefault(_dropletHalf);
var _droplet = require("./icons/droplet");
var _dropletDefault = parcelHelpers.interopDefault(_droplet);
var _duffleFill = require("./icons/duffle-fill");
var _duffleFillDefault = parcelHelpers.interopDefault(_duffleFill);
var _duffle = require("./icons/duffle");
var _duffleDefault = parcelHelpers.interopDefault(_duffle);
var _earFill = require("./icons/ear-fill");
var _earFillDefault = parcelHelpers.interopDefault(_earFill);
var _ear = require("./icons/ear");
var _earDefault = parcelHelpers.interopDefault(_ear);
var _earbuds = require("./icons/earbuds");
var _earbudsDefault = parcelHelpers.interopDefault(_earbuds);
var _easelFill = require("./icons/easel-fill");
var _easelFillDefault = parcelHelpers.interopDefault(_easelFill);
var _easel = require("./icons/easel");
var _easelDefault = parcelHelpers.interopDefault(_easel);
var _easel2Fill = require("./icons/easel2-fill");
var _easel2FillDefault = parcelHelpers.interopDefault(_easel2Fill);
var _easel2 = require("./icons/easel2");
var _easel2Default = parcelHelpers.interopDefault(_easel2);
var _easel3Fill = require("./icons/easel3-fill");
var _easel3FillDefault = parcelHelpers.interopDefault(_easel3Fill);
var _easel3 = require("./icons/easel3");
var _easel3Default = parcelHelpers.interopDefault(_easel3);
var _eggFill = require("./icons/egg-fill");
var _eggFillDefault = parcelHelpers.interopDefault(_eggFill);
var _eggFried = require("./icons/egg-fried");
var _eggFriedDefault = parcelHelpers.interopDefault(_eggFried);
var _egg = require("./icons/egg");
var _eggDefault = parcelHelpers.interopDefault(_egg);
var _ejectFill = require("./icons/eject-fill");
var _ejectFillDefault = parcelHelpers.interopDefault(_ejectFill);
var _eject = require("./icons/eject");
var _ejectDefault = parcelHelpers.interopDefault(_eject);
var _emojiAngryFill = require("./icons/emoji-angry-fill");
var _emojiAngryFillDefault = parcelHelpers.interopDefault(_emojiAngryFill);
var _emojiAngry = require("./icons/emoji-angry");
var _emojiAngryDefault = parcelHelpers.interopDefault(_emojiAngry);
var _emojiAstonishedFill = require("./icons/emoji-astonished-fill");
var _emojiAstonishedFillDefault = parcelHelpers.interopDefault(_emojiAstonishedFill);
var _emojiAstonished = require("./icons/emoji-astonished");
var _emojiAstonishedDefault = parcelHelpers.interopDefault(_emojiAstonished);
var _emojiDizzyFill = require("./icons/emoji-dizzy-fill");
var _emojiDizzyFillDefault = parcelHelpers.interopDefault(_emojiDizzyFill);
var _emojiDizzy = require("./icons/emoji-dizzy");
var _emojiDizzyDefault = parcelHelpers.interopDefault(_emojiDizzy);
var _emojiExpressionlessFill = require("./icons/emoji-expressionless-fill");
var _emojiExpressionlessFillDefault = parcelHelpers.interopDefault(_emojiExpressionlessFill);
var _emojiExpressionless = require("./icons/emoji-expressionless");
var _emojiExpressionlessDefault = parcelHelpers.interopDefault(_emojiExpressionless);
var _emojiFrownFill = require("./icons/emoji-frown-fill");
var _emojiFrownFillDefault = parcelHelpers.interopDefault(_emojiFrownFill);
var _emojiFrown = require("./icons/emoji-frown");
var _emojiFrownDefault = parcelHelpers.interopDefault(_emojiFrown);
var _emojiGrimaceFill = require("./icons/emoji-grimace-fill");
var _emojiGrimaceFillDefault = parcelHelpers.interopDefault(_emojiGrimaceFill);
var _emojiGrimace = require("./icons/emoji-grimace");
var _emojiGrimaceDefault = parcelHelpers.interopDefault(_emojiGrimace);
var _emojiGrinFill = require("./icons/emoji-grin-fill");
var _emojiGrinFillDefault = parcelHelpers.interopDefault(_emojiGrinFill);
var _emojiGrin = require("./icons/emoji-grin");
var _emojiGrinDefault = parcelHelpers.interopDefault(_emojiGrin);
var _emojiHeartEyesFill = require("./icons/emoji-heart-eyes-fill");
var _emojiHeartEyesFillDefault = parcelHelpers.interopDefault(_emojiHeartEyesFill);
var _emojiHeartEyes = require("./icons/emoji-heart-eyes");
var _emojiHeartEyesDefault = parcelHelpers.interopDefault(_emojiHeartEyes);
var _emojiKissFill = require("./icons/emoji-kiss-fill");
var _emojiKissFillDefault = parcelHelpers.interopDefault(_emojiKissFill);
var _emojiKiss = require("./icons/emoji-kiss");
var _emojiKissDefault = parcelHelpers.interopDefault(_emojiKiss);
var _emojiLaughingFill = require("./icons/emoji-laughing-fill");
var _emojiLaughingFillDefault = parcelHelpers.interopDefault(_emojiLaughingFill);
var _emojiLaughing = require("./icons/emoji-laughing");
var _emojiLaughingDefault = parcelHelpers.interopDefault(_emojiLaughing);
var _emojiNeutralFill = require("./icons/emoji-neutral-fill");
var _emojiNeutralFillDefault = parcelHelpers.interopDefault(_emojiNeutralFill);
var _emojiNeutral = require("./icons/emoji-neutral");
var _emojiNeutralDefault = parcelHelpers.interopDefault(_emojiNeutral);
var _emojiSmileFill = require("./icons/emoji-smile-fill");
var _emojiSmileFillDefault = parcelHelpers.interopDefault(_emojiSmileFill);
var _emojiSmileUpsideDownFill = require("./icons/emoji-smile-upside-down-fill");
var _emojiSmileUpsideDownFillDefault = parcelHelpers.interopDefault(_emojiSmileUpsideDownFill);
var _emojiSmileUpsideDown = require("./icons/emoji-smile-upside-down");
var _emojiSmileUpsideDownDefault = parcelHelpers.interopDefault(_emojiSmileUpsideDown);
var _emojiSmile = require("./icons/emoji-smile");
var _emojiSmileDefault = parcelHelpers.interopDefault(_emojiSmile);
var _emojiSunglassesFill = require("./icons/emoji-sunglasses-fill");
var _emojiSunglassesFillDefault = parcelHelpers.interopDefault(_emojiSunglassesFill);
var _emojiSunglasses = require("./icons/emoji-sunglasses");
var _emojiSunglassesDefault = parcelHelpers.interopDefault(_emojiSunglasses);
var _emojiSurpriseFill = require("./icons/emoji-surprise-fill");
var _emojiSurpriseFillDefault = parcelHelpers.interopDefault(_emojiSurpriseFill);
var _emojiSurprise = require("./icons/emoji-surprise");
var _emojiSurpriseDefault = parcelHelpers.interopDefault(_emojiSurprise);
var _emojiTearFill = require("./icons/emoji-tear-fill");
var _emojiTearFillDefault = parcelHelpers.interopDefault(_emojiTearFill);
var _emojiTear = require("./icons/emoji-tear");
var _emojiTearDefault = parcelHelpers.interopDefault(_emojiTear);
var _emojiWinkFill = require("./icons/emoji-wink-fill");
var _emojiWinkFillDefault = parcelHelpers.interopDefault(_emojiWinkFill);
var _emojiWink = require("./icons/emoji-wink");
var _emojiWinkDefault = parcelHelpers.interopDefault(_emojiWink);
var _envelopeArrowDownFill = require("./icons/envelope-arrow-down-fill");
var _envelopeArrowDownFillDefault = parcelHelpers.interopDefault(_envelopeArrowDownFill);
var _envelopeArrowDown = require("./icons/envelope-arrow-down");
var _envelopeArrowDownDefault = parcelHelpers.interopDefault(_envelopeArrowDown);
var _envelopeArrowUpFill = require("./icons/envelope-arrow-up-fill");
var _envelopeArrowUpFillDefault = parcelHelpers.interopDefault(_envelopeArrowUpFill);
var _envelopeArrowUp = require("./icons/envelope-arrow-up");
var _envelopeArrowUpDefault = parcelHelpers.interopDefault(_envelopeArrowUp);
var _envelopeAtFill = require("./icons/envelope-at-fill");
var _envelopeAtFillDefault = parcelHelpers.interopDefault(_envelopeAtFill);
var _envelopeAt = require("./icons/envelope-at");
var _envelopeAtDefault = parcelHelpers.interopDefault(_envelopeAt);
var _envelopeCheckFill = require("./icons/envelope-check-fill");
var _envelopeCheckFillDefault = parcelHelpers.interopDefault(_envelopeCheckFill);
var _envelopeCheck = require("./icons/envelope-check");
var _envelopeCheckDefault = parcelHelpers.interopDefault(_envelopeCheck);
var _envelopeDashFill = require("./icons/envelope-dash-fill");
var _envelopeDashFillDefault = parcelHelpers.interopDefault(_envelopeDashFill);
var _envelopeDash = require("./icons/envelope-dash");
var _envelopeDashDefault = parcelHelpers.interopDefault(_envelopeDash);
var _envelopeExclamationFill = require("./icons/envelope-exclamation-fill");
var _envelopeExclamationFillDefault = parcelHelpers.interopDefault(_envelopeExclamationFill);
var _envelopeExclamation = require("./icons/envelope-exclamation");
var _envelopeExclamationDefault = parcelHelpers.interopDefault(_envelopeExclamation);
var _envelopeFill = require("./icons/envelope-fill");
var _envelopeFillDefault = parcelHelpers.interopDefault(_envelopeFill);
var _envelopeHeartFill = require("./icons/envelope-heart-fill");
var _envelopeHeartFillDefault = parcelHelpers.interopDefault(_envelopeHeartFill);
var _envelopeHeart = require("./icons/envelope-heart");
var _envelopeHeartDefault = parcelHelpers.interopDefault(_envelopeHeart);
var _envelopeOpenFill = require("./icons/envelope-open-fill");
var _envelopeOpenFillDefault = parcelHelpers.interopDefault(_envelopeOpenFill);
var _envelopeOpenHeartFill = require("./icons/envelope-open-heart-fill");
var _envelopeOpenHeartFillDefault = parcelHelpers.interopDefault(_envelopeOpenHeartFill);
var _envelopeOpenHeart = require("./icons/envelope-open-heart");
var _envelopeOpenHeartDefault = parcelHelpers.interopDefault(_envelopeOpenHeart);
var _envelopeOpen = require("./icons/envelope-open");
var _envelopeOpenDefault = parcelHelpers.interopDefault(_envelopeOpen);
var _envelopePaperFill = require("./icons/envelope-paper-fill");
var _envelopePaperFillDefault = parcelHelpers.interopDefault(_envelopePaperFill);
var _envelopePaperHeartFill = require("./icons/envelope-paper-heart-fill");
var _envelopePaperHeartFillDefault = parcelHelpers.interopDefault(_envelopePaperHeartFill);
var _envelopePaperHeart = require("./icons/envelope-paper-heart");
var _envelopePaperHeartDefault = parcelHelpers.interopDefault(_envelopePaperHeart);
var _envelopePaper = require("./icons/envelope-paper");
var _envelopePaperDefault = parcelHelpers.interopDefault(_envelopePaper);
var _envelopePlusFill = require("./icons/envelope-plus-fill");
var _envelopePlusFillDefault = parcelHelpers.interopDefault(_envelopePlusFill);
var _envelopePlus = require("./icons/envelope-plus");
var _envelopePlusDefault = parcelHelpers.interopDefault(_envelopePlus);
var _envelopeSlashFill = require("./icons/envelope-slash-fill");
var _envelopeSlashFillDefault = parcelHelpers.interopDefault(_envelopeSlashFill);
var _envelopeSlash = require("./icons/envelope-slash");
var _envelopeSlashDefault = parcelHelpers.interopDefault(_envelopeSlash);
var _envelopeXFill = require("./icons/envelope-x-fill");
var _envelopeXFillDefault = parcelHelpers.interopDefault(_envelopeXFill);
var _envelopeX = require("./icons/envelope-x");
var _envelopeXDefault = parcelHelpers.interopDefault(_envelopeX);
var _envelope = require("./icons/envelope");
var _envelopeDefault = parcelHelpers.interopDefault(_envelope);
var _eraserFill = require("./icons/eraser-fill");
var _eraserFillDefault = parcelHelpers.interopDefault(_eraserFill);
var _eraser = require("./icons/eraser");
var _eraserDefault = parcelHelpers.interopDefault(_eraser);
var _escape = require("./icons/escape");
var _escapeDefault = parcelHelpers.interopDefault(_escape);
var _ethernet = require("./icons/ethernet");
var _ethernetDefault = parcelHelpers.interopDefault(_ethernet);
var _evFrontFill = require("./icons/ev-front-fill");
var _evFrontFillDefault = parcelHelpers.interopDefault(_evFrontFill);
var _evFront = require("./icons/ev-front");
var _evFrontDefault = parcelHelpers.interopDefault(_evFront);
var _evStationFill = require("./icons/ev-station-fill");
var _evStationFillDefault = parcelHelpers.interopDefault(_evStationFill);
var _evStation = require("./icons/ev-station");
var _evStationDefault = parcelHelpers.interopDefault(_evStation);
var _exclamationCircleFill = require("./icons/exclamation-circle-fill");
var _exclamationCircleFillDefault = parcelHelpers.interopDefault(_exclamationCircleFill);
var _exclamationCircle = require("./icons/exclamation-circle");
var _exclamationCircleDefault = parcelHelpers.interopDefault(_exclamationCircle);
var _exclamationDiamondFill = require("./icons/exclamation-diamond-fill");
var _exclamationDiamondFillDefault = parcelHelpers.interopDefault(_exclamationDiamondFill);
var _exclamationDiamond = require("./icons/exclamation-diamond");
var _exclamationDiamondDefault = parcelHelpers.interopDefault(_exclamationDiamond);
var _exclamationLg = require("./icons/exclamation-lg");
var _exclamationLgDefault = parcelHelpers.interopDefault(_exclamationLg);
var _exclamationOctagonFill = require("./icons/exclamation-octagon-fill");
var _exclamationOctagonFillDefault = parcelHelpers.interopDefault(_exclamationOctagonFill);
var _exclamationOctagon = require("./icons/exclamation-octagon");
var _exclamationOctagonDefault = parcelHelpers.interopDefault(_exclamationOctagon);
var _exclamationSquareFill = require("./icons/exclamation-square-fill");
var _exclamationSquareFillDefault = parcelHelpers.interopDefault(_exclamationSquareFill);
var _exclamationSquare = require("./icons/exclamation-square");
var _exclamationSquareDefault = parcelHelpers.interopDefault(_exclamationSquare);
var _exclamationTriangleFill = require("./icons/exclamation-triangle-fill");
var _exclamationTriangleFillDefault = parcelHelpers.interopDefault(_exclamationTriangleFill);
var _exclamationTriangle = require("./icons/exclamation-triangle");
var _exclamationTriangleDefault = parcelHelpers.interopDefault(_exclamationTriangle);
var _exclamation = require("./icons/exclamation");
var _exclamationDefault = parcelHelpers.interopDefault(_exclamation);
var _exclude = require("./icons/exclude");
var _excludeDefault = parcelHelpers.interopDefault(_exclude);
var _explicitFill = require("./icons/explicit-fill");
var _explicitFillDefault = parcelHelpers.interopDefault(_explicitFill);
var _explicit = require("./icons/explicit");
var _explicitDefault = parcelHelpers.interopDefault(_explicit);
var _exposure = require("./icons/exposure");
var _exposureDefault = parcelHelpers.interopDefault(_exposure);
var _eyeFill = require("./icons/eye-fill");
var _eyeFillDefault = parcelHelpers.interopDefault(_eyeFill);
var _eyeSlashFill = require("./icons/eye-slash-fill");
var _eyeSlashFillDefault = parcelHelpers.interopDefault(_eyeSlashFill);
var _eyeSlash = require("./icons/eye-slash");
var _eyeSlashDefault = parcelHelpers.interopDefault(_eyeSlash);
var _eye = require("./icons/eye");
var _eyeDefault = parcelHelpers.interopDefault(_eye);
var _eyedropper = require("./icons/eyedropper");
var _eyedropperDefault = parcelHelpers.interopDefault(_eyedropper);
var _eyeglasses = require("./icons/eyeglasses");
var _eyeglassesDefault = parcelHelpers.interopDefault(_eyeglasses);
var _facebook = require("./icons/facebook");
var _facebookDefault = parcelHelpers.interopDefault(_facebook);
var _fan = require("./icons/fan");
var _fanDefault = parcelHelpers.interopDefault(_fan);
var _fastForwardBtnFill = require("./icons/fast-forward-btn-fill");
var _fastForwardBtnFillDefault = parcelHelpers.interopDefault(_fastForwardBtnFill);
var _fastForwardBtn = require("./icons/fast-forward-btn");
var _fastForwardBtnDefault = parcelHelpers.interopDefault(_fastForwardBtn);
var _fastForwardCircleFill = require("./icons/fast-forward-circle-fill");
var _fastForwardCircleFillDefault = parcelHelpers.interopDefault(_fastForwardCircleFill);
var _fastForwardCircle = require("./icons/fast-forward-circle");
var _fastForwardCircleDefault = parcelHelpers.interopDefault(_fastForwardCircle);
var _fastForwardFill = require("./icons/fast-forward-fill");
var _fastForwardFillDefault = parcelHelpers.interopDefault(_fastForwardFill);
var _fastForward = require("./icons/fast-forward");
var _fastForwardDefault = parcelHelpers.interopDefault(_fastForward);
var _feather = require("./icons/feather");
var _featherDefault = parcelHelpers.interopDefault(_feather);
var _feather2 = require("./icons/feather2");
var _feather2Default = parcelHelpers.interopDefault(_feather2);
var _fileArrowDownFill = require("./icons/file-arrow-down-fill");
var _fileArrowDownFillDefault = parcelHelpers.interopDefault(_fileArrowDownFill);
var _fileArrowDown = require("./icons/file-arrow-down");
var _fileArrowDownDefault = parcelHelpers.interopDefault(_fileArrowDown);
var _fileArrowUpFill = require("./icons/file-arrow-up-fill");
var _fileArrowUpFillDefault = parcelHelpers.interopDefault(_fileArrowUpFill);
var _fileArrowUp = require("./icons/file-arrow-up");
var _fileArrowUpDefault = parcelHelpers.interopDefault(_fileArrowUp);
var _fileBarGraphFill = require("./icons/file-bar-graph-fill");
var _fileBarGraphFillDefault = parcelHelpers.interopDefault(_fileBarGraphFill);
var _fileBarGraph = require("./icons/file-bar-graph");
var _fileBarGraphDefault = parcelHelpers.interopDefault(_fileBarGraph);
var _fileBinaryFill = require("./icons/file-binary-fill");
var _fileBinaryFillDefault = parcelHelpers.interopDefault(_fileBinaryFill);
var _fileBinary = require("./icons/file-binary");
var _fileBinaryDefault = parcelHelpers.interopDefault(_fileBinary);
var _fileBreakFill = require("./icons/file-break-fill");
var _fileBreakFillDefault = parcelHelpers.interopDefault(_fileBreakFill);
var _fileBreak = require("./icons/file-break");
var _fileBreakDefault = parcelHelpers.interopDefault(_fileBreak);
var _fileCheckFill = require("./icons/file-check-fill");
var _fileCheckFillDefault = parcelHelpers.interopDefault(_fileCheckFill);
var _fileCheck = require("./icons/file-check");
var _fileCheckDefault = parcelHelpers.interopDefault(_fileCheck);
var _fileCodeFill = require("./icons/file-code-fill");
var _fileCodeFillDefault = parcelHelpers.interopDefault(_fileCodeFill);
var _fileCode = require("./icons/file-code");
var _fileCodeDefault = parcelHelpers.interopDefault(_fileCode);
var _fileDiffFill = require("./icons/file-diff-fill");
var _fileDiffFillDefault = parcelHelpers.interopDefault(_fileDiffFill);
var _fileDiff = require("./icons/file-diff");
var _fileDiffDefault = parcelHelpers.interopDefault(_fileDiff);
var _fileEarmarkArrowDownFill = require("./icons/file-earmark-arrow-down-fill");
var _fileEarmarkArrowDownFillDefault = parcelHelpers.interopDefault(_fileEarmarkArrowDownFill);
var _fileEarmarkArrowDown = require("./icons/file-earmark-arrow-down");
var _fileEarmarkArrowDownDefault = parcelHelpers.interopDefault(_fileEarmarkArrowDown);
var _fileEarmarkArrowUpFill = require("./icons/file-earmark-arrow-up-fill");
var _fileEarmarkArrowUpFillDefault = parcelHelpers.interopDefault(_fileEarmarkArrowUpFill);
var _fileEarmarkArrowUp = require("./icons/file-earmark-arrow-up");
var _fileEarmarkArrowUpDefault = parcelHelpers.interopDefault(_fileEarmarkArrowUp);
var _fileEarmarkBarGraphFill = require("./icons/file-earmark-bar-graph-fill");
var _fileEarmarkBarGraphFillDefault = parcelHelpers.interopDefault(_fileEarmarkBarGraphFill);
var _fileEarmarkBarGraph = require("./icons/file-earmark-bar-graph");
var _fileEarmarkBarGraphDefault = parcelHelpers.interopDefault(_fileEarmarkBarGraph);
var _fileEarmarkBinaryFill = require("./icons/file-earmark-binary-fill");
var _fileEarmarkBinaryFillDefault = parcelHelpers.interopDefault(_fileEarmarkBinaryFill);
var _fileEarmarkBinary = require("./icons/file-earmark-binary");
var _fileEarmarkBinaryDefault = parcelHelpers.interopDefault(_fileEarmarkBinary);
var _fileEarmarkBreakFill = require("./icons/file-earmark-break-fill");
var _fileEarmarkBreakFillDefault = parcelHelpers.interopDefault(_fileEarmarkBreakFill);
var _fileEarmarkBreak = require("./icons/file-earmark-break");
var _fileEarmarkBreakDefault = parcelHelpers.interopDefault(_fileEarmarkBreak);
var _fileEarmarkCheckFill = require("./icons/file-earmark-check-fill");
var _fileEarmarkCheckFillDefault = parcelHelpers.interopDefault(_fileEarmarkCheckFill);
var _fileEarmarkCheck = require("./icons/file-earmark-check");
var _fileEarmarkCheckDefault = parcelHelpers.interopDefault(_fileEarmarkCheck);
var _fileEarmarkCodeFill = require("./icons/file-earmark-code-fill");
var _fileEarmarkCodeFillDefault = parcelHelpers.interopDefault(_fileEarmarkCodeFill);
var _fileEarmarkCode = require("./icons/file-earmark-code");
var _fileEarmarkCodeDefault = parcelHelpers.interopDefault(_fileEarmarkCode);
var _fileEarmarkDiffFill = require("./icons/file-earmark-diff-fill");
var _fileEarmarkDiffFillDefault = parcelHelpers.interopDefault(_fileEarmarkDiffFill);
var _fileEarmarkDiff = require("./icons/file-earmark-diff");
var _fileEarmarkDiffDefault = parcelHelpers.interopDefault(_fileEarmarkDiff);
var _fileEarmarkEaselFill = require("./icons/file-earmark-easel-fill");
var _fileEarmarkEaselFillDefault = parcelHelpers.interopDefault(_fileEarmarkEaselFill);
var _fileEarmarkEasel = require("./icons/file-earmark-easel");
var _fileEarmarkEaselDefault = parcelHelpers.interopDefault(_fileEarmarkEasel);
var _fileEarmarkExcelFill = require("./icons/file-earmark-excel-fill");
var _fileEarmarkExcelFillDefault = parcelHelpers.interopDefault(_fileEarmarkExcelFill);
var _fileEarmarkExcel = require("./icons/file-earmark-excel");
var _fileEarmarkExcelDefault = parcelHelpers.interopDefault(_fileEarmarkExcel);
var _fileEarmarkFill = require("./icons/file-earmark-fill");
var _fileEarmarkFillDefault = parcelHelpers.interopDefault(_fileEarmarkFill);
var _fileEarmarkFontFill = require("./icons/file-earmark-font-fill");
var _fileEarmarkFontFillDefault = parcelHelpers.interopDefault(_fileEarmarkFontFill);
var _fileEarmarkFont = require("./icons/file-earmark-font");
var _fileEarmarkFontDefault = parcelHelpers.interopDefault(_fileEarmarkFont);
var _fileEarmarkImageFill = require("./icons/file-earmark-image-fill");
var _fileEarmarkImageFillDefault = parcelHelpers.interopDefault(_fileEarmarkImageFill);
var _fileEarmarkImage = require("./icons/file-earmark-image");
var _fileEarmarkImageDefault = parcelHelpers.interopDefault(_fileEarmarkImage);
var _fileEarmarkLockFill = require("./icons/file-earmark-lock-fill");
var _fileEarmarkLockFillDefault = parcelHelpers.interopDefault(_fileEarmarkLockFill);
var _fileEarmarkLock = require("./icons/file-earmark-lock");
var _fileEarmarkLockDefault = parcelHelpers.interopDefault(_fileEarmarkLock);
var _fileEarmarkLock2Fill = require("./icons/file-earmark-lock2-fill");
var _fileEarmarkLock2FillDefault = parcelHelpers.interopDefault(_fileEarmarkLock2Fill);
var _fileEarmarkLock2 = require("./icons/file-earmark-lock2");
var _fileEarmarkLock2Default = parcelHelpers.interopDefault(_fileEarmarkLock2);
var _fileEarmarkMedicalFill = require("./icons/file-earmark-medical-fill");
var _fileEarmarkMedicalFillDefault = parcelHelpers.interopDefault(_fileEarmarkMedicalFill);
var _fileEarmarkMedical = require("./icons/file-earmark-medical");
var _fileEarmarkMedicalDefault = parcelHelpers.interopDefault(_fileEarmarkMedical);
var _fileEarmarkMinusFill = require("./icons/file-earmark-minus-fill");
var _fileEarmarkMinusFillDefault = parcelHelpers.interopDefault(_fileEarmarkMinusFill);
var _fileEarmarkMinus = require("./icons/file-earmark-minus");
var _fileEarmarkMinusDefault = parcelHelpers.interopDefault(_fileEarmarkMinus);
var _fileEarmarkMusicFill = require("./icons/file-earmark-music-fill");
var _fileEarmarkMusicFillDefault = parcelHelpers.interopDefault(_fileEarmarkMusicFill);
var _fileEarmarkMusic = require("./icons/file-earmark-music");
var _fileEarmarkMusicDefault = parcelHelpers.interopDefault(_fileEarmarkMusic);
var _fileEarmarkPdfFill = require("./icons/file-earmark-pdf-fill");
var _fileEarmarkPdfFillDefault = parcelHelpers.interopDefault(_fileEarmarkPdfFill);
var _fileEarmarkPdf = require("./icons/file-earmark-pdf");
var _fileEarmarkPdfDefault = parcelHelpers.interopDefault(_fileEarmarkPdf);
var _fileEarmarkPersonFill = require("./icons/file-earmark-person-fill");
var _fileEarmarkPersonFillDefault = parcelHelpers.interopDefault(_fileEarmarkPersonFill);
var _fileEarmarkPerson = require("./icons/file-earmark-person");
var _fileEarmarkPersonDefault = parcelHelpers.interopDefault(_fileEarmarkPerson);
var _fileEarmarkPlayFill = require("./icons/file-earmark-play-fill");
var _fileEarmarkPlayFillDefault = parcelHelpers.interopDefault(_fileEarmarkPlayFill);
var _fileEarmarkPlay = require("./icons/file-earmark-play");
var _fileEarmarkPlayDefault = parcelHelpers.interopDefault(_fileEarmarkPlay);
var _fileEarmarkPlusFill = require("./icons/file-earmark-plus-fill");
var _fileEarmarkPlusFillDefault = parcelHelpers.interopDefault(_fileEarmarkPlusFill);
var _fileEarmarkPlus = require("./icons/file-earmark-plus");
var _fileEarmarkPlusDefault = parcelHelpers.interopDefault(_fileEarmarkPlus);
var _fileEarmarkPostFill = require("./icons/file-earmark-post-fill");
var _fileEarmarkPostFillDefault = parcelHelpers.interopDefault(_fileEarmarkPostFill);
var _fileEarmarkPost = require("./icons/file-earmark-post");
var _fileEarmarkPostDefault = parcelHelpers.interopDefault(_fileEarmarkPost);
var _fileEarmarkPptFill = require("./icons/file-earmark-ppt-fill");
var _fileEarmarkPptFillDefault = parcelHelpers.interopDefault(_fileEarmarkPptFill);
var _fileEarmarkPpt = require("./icons/file-earmark-ppt");
var _fileEarmarkPptDefault = parcelHelpers.interopDefault(_fileEarmarkPpt);
var _fileEarmarkRichtextFill = require("./icons/file-earmark-richtext-fill");
var _fileEarmarkRichtextFillDefault = parcelHelpers.interopDefault(_fileEarmarkRichtextFill);
var _fileEarmarkRichtext = require("./icons/file-earmark-richtext");
var _fileEarmarkRichtextDefault = parcelHelpers.interopDefault(_fileEarmarkRichtext);
var _fileEarmarkRuledFill = require("./icons/file-earmark-ruled-fill");
var _fileEarmarkRuledFillDefault = parcelHelpers.interopDefault(_fileEarmarkRuledFill);
var _fileEarmarkRuled = require("./icons/file-earmark-ruled");
var _fileEarmarkRuledDefault = parcelHelpers.interopDefault(_fileEarmarkRuled);
var _fileEarmarkSlidesFill = require("./icons/file-earmark-slides-fill");
var _fileEarmarkSlidesFillDefault = parcelHelpers.interopDefault(_fileEarmarkSlidesFill);
var _fileEarmarkSlides = require("./icons/file-earmark-slides");
var _fileEarmarkSlidesDefault = parcelHelpers.interopDefault(_fileEarmarkSlides);
var _fileEarmarkSpreadsheetFill = require("./icons/file-earmark-spreadsheet-fill");
var _fileEarmarkSpreadsheetFillDefault = parcelHelpers.interopDefault(_fileEarmarkSpreadsheetFill);
var _fileEarmarkSpreadsheet = require("./icons/file-earmark-spreadsheet");
var _fileEarmarkSpreadsheetDefault = parcelHelpers.interopDefault(_fileEarmarkSpreadsheet);
var _fileEarmarkTextFill = require("./icons/file-earmark-text-fill");
var _fileEarmarkTextFillDefault = parcelHelpers.interopDefault(_fileEarmarkTextFill);
var _fileEarmarkText = require("./icons/file-earmark-text");
var _fileEarmarkTextDefault = parcelHelpers.interopDefault(_fileEarmarkText);
var _fileEarmarkWordFill = require("./icons/file-earmark-word-fill");
var _fileEarmarkWordFillDefault = parcelHelpers.interopDefault(_fileEarmarkWordFill);
var _fileEarmarkWord = require("./icons/file-earmark-word");
var _fileEarmarkWordDefault = parcelHelpers.interopDefault(_fileEarmarkWord);
var _fileEarmarkXFill = require("./icons/file-earmark-x-fill");
var _fileEarmarkXFillDefault = parcelHelpers.interopDefault(_fileEarmarkXFill);
var _fileEarmarkX = require("./icons/file-earmark-x");
var _fileEarmarkXDefault = parcelHelpers.interopDefault(_fileEarmarkX);
var _fileEarmarkZipFill = require("./icons/file-earmark-zip-fill");
var _fileEarmarkZipFillDefault = parcelHelpers.interopDefault(_fileEarmarkZipFill);
var _fileEarmarkZip = require("./icons/file-earmark-zip");
var _fileEarmarkZipDefault = parcelHelpers.interopDefault(_fileEarmarkZip);
var _fileEarmark = require("./icons/file-earmark");
var _fileEarmarkDefault = parcelHelpers.interopDefault(_fileEarmark);
var _fileEaselFill = require("./icons/file-easel-fill");
var _fileEaselFillDefault = parcelHelpers.interopDefault(_fileEaselFill);
var _fileEasel = require("./icons/file-easel");
var _fileEaselDefault = parcelHelpers.interopDefault(_fileEasel);
var _fileExcelFill = require("./icons/file-excel-fill");
var _fileExcelFillDefault = parcelHelpers.interopDefault(_fileExcelFill);
var _fileExcel = require("./icons/file-excel");
var _fileExcelDefault = parcelHelpers.interopDefault(_fileExcel);
var _fileFill = require("./icons/file-fill");
var _fileFillDefault = parcelHelpers.interopDefault(_fileFill);
var _fileFontFill = require("./icons/file-font-fill");
var _fileFontFillDefault = parcelHelpers.interopDefault(_fileFontFill);
var _fileFont = require("./icons/file-font");
var _fileFontDefault = parcelHelpers.interopDefault(_fileFont);
var _fileImageFill = require("./icons/file-image-fill");
var _fileImageFillDefault = parcelHelpers.interopDefault(_fileImageFill);
var _fileImage = require("./icons/file-image");
var _fileImageDefault = parcelHelpers.interopDefault(_fileImage);
var _fileLockFill = require("./icons/file-lock-fill");
var _fileLockFillDefault = parcelHelpers.interopDefault(_fileLockFill);
var _fileLock = require("./icons/file-lock");
var _fileLockDefault = parcelHelpers.interopDefault(_fileLock);
var _fileLock2Fill = require("./icons/file-lock2-fill");
var _fileLock2FillDefault = parcelHelpers.interopDefault(_fileLock2Fill);
var _fileLock2 = require("./icons/file-lock2");
var _fileLock2Default = parcelHelpers.interopDefault(_fileLock2);
var _fileMedicalFill = require("./icons/file-medical-fill");
var _fileMedicalFillDefault = parcelHelpers.interopDefault(_fileMedicalFill);
var _fileMedical = require("./icons/file-medical");
var _fileMedicalDefault = parcelHelpers.interopDefault(_fileMedical);
var _fileMinusFill = require("./icons/file-minus-fill");
var _fileMinusFillDefault = parcelHelpers.interopDefault(_fileMinusFill);
var _fileMinus = require("./icons/file-minus");
var _fileMinusDefault = parcelHelpers.interopDefault(_fileMinus);
var _fileMusicFill = require("./icons/file-music-fill");
var _fileMusicFillDefault = parcelHelpers.interopDefault(_fileMusicFill);
var _fileMusic = require("./icons/file-music");
var _fileMusicDefault = parcelHelpers.interopDefault(_fileMusic);
var _filePdfFill = require("./icons/file-pdf-fill");
var _filePdfFillDefault = parcelHelpers.interopDefault(_filePdfFill);
var _filePdf = require("./icons/file-pdf");
var _filePdfDefault = parcelHelpers.interopDefault(_filePdf);
var _filePersonFill = require("./icons/file-person-fill");
var _filePersonFillDefault = parcelHelpers.interopDefault(_filePersonFill);
var _filePerson = require("./icons/file-person");
var _filePersonDefault = parcelHelpers.interopDefault(_filePerson);
var _filePlayFill = require("./icons/file-play-fill");
var _filePlayFillDefault = parcelHelpers.interopDefault(_filePlayFill);
var _filePlay = require("./icons/file-play");
var _filePlayDefault = parcelHelpers.interopDefault(_filePlay);
var _filePlusFill = require("./icons/file-plus-fill");
var _filePlusFillDefault = parcelHelpers.interopDefault(_filePlusFill);
var _filePlus = require("./icons/file-plus");
var _filePlusDefault = parcelHelpers.interopDefault(_filePlus);
var _filePostFill = require("./icons/file-post-fill");
var _filePostFillDefault = parcelHelpers.interopDefault(_filePostFill);
var _filePost = require("./icons/file-post");
var _filePostDefault = parcelHelpers.interopDefault(_filePost);
var _filePptFill = require("./icons/file-ppt-fill");
var _filePptFillDefault = parcelHelpers.interopDefault(_filePptFill);
var _filePpt = require("./icons/file-ppt");
var _filePptDefault = parcelHelpers.interopDefault(_filePpt);
var _fileRichtextFill = require("./icons/file-richtext-fill");
var _fileRichtextFillDefault = parcelHelpers.interopDefault(_fileRichtextFill);
var _fileRichtext = require("./icons/file-richtext");
var _fileRichtextDefault = parcelHelpers.interopDefault(_fileRichtext);
var _fileRuledFill = require("./icons/file-ruled-fill");
var _fileRuledFillDefault = parcelHelpers.interopDefault(_fileRuledFill);
var _fileRuled = require("./icons/file-ruled");
var _fileRuledDefault = parcelHelpers.interopDefault(_fileRuled);
var _fileSlidesFill = require("./icons/file-slides-fill");
var _fileSlidesFillDefault = parcelHelpers.interopDefault(_fileSlidesFill);
var _fileSlides = require("./icons/file-slides");
var _fileSlidesDefault = parcelHelpers.interopDefault(_fileSlides);
var _fileSpreadsheetFill = require("./icons/file-spreadsheet-fill");
var _fileSpreadsheetFillDefault = parcelHelpers.interopDefault(_fileSpreadsheetFill);
var _fileSpreadsheet = require("./icons/file-spreadsheet");
var _fileSpreadsheetDefault = parcelHelpers.interopDefault(_fileSpreadsheet);
var _fileTextFill = require("./icons/file-text-fill");
var _fileTextFillDefault = parcelHelpers.interopDefault(_fileTextFill);
var _fileText = require("./icons/file-text");
var _fileTextDefault = parcelHelpers.interopDefault(_fileText);
var _fileWordFill = require("./icons/file-word-fill");
var _fileWordFillDefault = parcelHelpers.interopDefault(_fileWordFill);
var _fileWord = require("./icons/file-word");
var _fileWordDefault = parcelHelpers.interopDefault(_fileWord);
var _fileXFill = require("./icons/file-x-fill");
var _fileXFillDefault = parcelHelpers.interopDefault(_fileXFill);
var _fileX = require("./icons/file-x");
var _fileXDefault = parcelHelpers.interopDefault(_fileX);
var _fileZipFill = require("./icons/file-zip-fill");
var _fileZipFillDefault = parcelHelpers.interopDefault(_fileZipFill);
var _fileZip = require("./icons/file-zip");
var _fileZipDefault = parcelHelpers.interopDefault(_fileZip);
var _file = require("./icons/file");
var _fileDefault = parcelHelpers.interopDefault(_file);
var _filesAlt = require("./icons/files-alt");
var _filesAltDefault = parcelHelpers.interopDefault(_filesAlt);
var _files = require("./icons/files");
var _filesDefault = parcelHelpers.interopDefault(_files);
var _filetypeAac = require("./icons/filetype-aac");
var _filetypeAacDefault = parcelHelpers.interopDefault(_filetypeAac);
var _filetypeAi = require("./icons/filetype-ai");
var _filetypeAiDefault = parcelHelpers.interopDefault(_filetypeAi);
var _filetypeBmp = require("./icons/filetype-bmp");
var _filetypeBmpDefault = parcelHelpers.interopDefault(_filetypeBmp);
var _filetypeCs = require("./icons/filetype-cs");
var _filetypeCsDefault = parcelHelpers.interopDefault(_filetypeCs);
var _filetypeCss = require("./icons/filetype-css");
var _filetypeCssDefault = parcelHelpers.interopDefault(_filetypeCss);
var _filetypeCsv = require("./icons/filetype-csv");
var _filetypeCsvDefault = parcelHelpers.interopDefault(_filetypeCsv);
var _filetypeDoc = require("./icons/filetype-doc");
var _filetypeDocDefault = parcelHelpers.interopDefault(_filetypeDoc);
var _filetypeDocx = require("./icons/filetype-docx");
var _filetypeDocxDefault = parcelHelpers.interopDefault(_filetypeDocx);
var _filetypeExe = require("./icons/filetype-exe");
var _filetypeExeDefault = parcelHelpers.interopDefault(_filetypeExe);
var _filetypeGif = require("./icons/filetype-gif");
var _filetypeGifDefault = parcelHelpers.interopDefault(_filetypeGif);
var _filetypeHeic = require("./icons/filetype-heic");
var _filetypeHeicDefault = parcelHelpers.interopDefault(_filetypeHeic);
var _filetypeHtml = require("./icons/filetype-html");
var _filetypeHtmlDefault = parcelHelpers.interopDefault(_filetypeHtml);
var _filetypeJava = require("./icons/filetype-java");
var _filetypeJavaDefault = parcelHelpers.interopDefault(_filetypeJava);
var _filetypeJpg = require("./icons/filetype-jpg");
var _filetypeJpgDefault = parcelHelpers.interopDefault(_filetypeJpg);
var _filetypeJs = require("./icons/filetype-js");
var _filetypeJsDefault = parcelHelpers.interopDefault(_filetypeJs);
var _filetypeJson = require("./icons/filetype-json");
var _filetypeJsonDefault = parcelHelpers.interopDefault(_filetypeJson);
var _filetypeJsx = require("./icons/filetype-jsx");
var _filetypeJsxDefault = parcelHelpers.interopDefault(_filetypeJsx);
var _filetypeKey = require("./icons/filetype-key");
var _filetypeKeyDefault = parcelHelpers.interopDefault(_filetypeKey);
var _filetypeM4P = require("./icons/filetype-m4p");
var _filetypeM4PDefault = parcelHelpers.interopDefault(_filetypeM4P);
var _filetypeMd = require("./icons/filetype-md");
var _filetypeMdDefault = parcelHelpers.interopDefault(_filetypeMd);
var _filetypeMdx = require("./icons/filetype-mdx");
var _filetypeMdxDefault = parcelHelpers.interopDefault(_filetypeMdx);
var _filetypeMov = require("./icons/filetype-mov");
var _filetypeMovDefault = parcelHelpers.interopDefault(_filetypeMov);
var _filetypeMp3 = require("./icons/filetype-mp3");
var _filetypeMp3Default = parcelHelpers.interopDefault(_filetypeMp3);
var _filetypeMp4 = require("./icons/filetype-mp4");
var _filetypeMp4Default = parcelHelpers.interopDefault(_filetypeMp4);
var _filetypeOtf = require("./icons/filetype-otf");
var _filetypeOtfDefault = parcelHelpers.interopDefault(_filetypeOtf);
var _filetypePdf = require("./icons/filetype-pdf");
var _filetypePdfDefault = parcelHelpers.interopDefault(_filetypePdf);
var _filetypePhp = require("./icons/filetype-php");
var _filetypePhpDefault = parcelHelpers.interopDefault(_filetypePhp);
var _filetypePng = require("./icons/filetype-png");
var _filetypePngDefault = parcelHelpers.interopDefault(_filetypePng);
var _filetypePpt = require("./icons/filetype-ppt");
var _filetypePptDefault = parcelHelpers.interopDefault(_filetypePpt);
var _filetypePptx = require("./icons/filetype-pptx");
var _filetypePptxDefault = parcelHelpers.interopDefault(_filetypePptx);
var _filetypePsd = require("./icons/filetype-psd");
var _filetypePsdDefault = parcelHelpers.interopDefault(_filetypePsd);
var _filetypePy = require("./icons/filetype-py");
var _filetypePyDefault = parcelHelpers.interopDefault(_filetypePy);
var _filetypeRaw = require("./icons/filetype-raw");
var _filetypeRawDefault = parcelHelpers.interopDefault(_filetypeRaw);
var _filetypeRb = require("./icons/filetype-rb");
var _filetypeRbDefault = parcelHelpers.interopDefault(_filetypeRb);
var _filetypeSass = require("./icons/filetype-sass");
var _filetypeSassDefault = parcelHelpers.interopDefault(_filetypeSass);
var _filetypeScss = require("./icons/filetype-scss");
var _filetypeScssDefault = parcelHelpers.interopDefault(_filetypeScss);
var _filetypeSh = require("./icons/filetype-sh");
var _filetypeShDefault = parcelHelpers.interopDefault(_filetypeSh);
var _filetypeSql = require("./icons/filetype-sql");
var _filetypeSqlDefault = parcelHelpers.interopDefault(_filetypeSql);
var _filetypeSvg = require("./icons/filetype-svg");
var _filetypeSvgDefault = parcelHelpers.interopDefault(_filetypeSvg);
var _filetypeTiff = require("./icons/filetype-tiff");
var _filetypeTiffDefault = parcelHelpers.interopDefault(_filetypeTiff);
var _filetypeTsx = require("./icons/filetype-tsx");
var _filetypeTsxDefault = parcelHelpers.interopDefault(_filetypeTsx);
var _filetypeTtf = require("./icons/filetype-ttf");
var _filetypeTtfDefault = parcelHelpers.interopDefault(_filetypeTtf);
var _filetypeTxt = require("./icons/filetype-txt");
var _filetypeTxtDefault = parcelHelpers.interopDefault(_filetypeTxt);
var _filetypeWav = require("./icons/filetype-wav");
var _filetypeWavDefault = parcelHelpers.interopDefault(_filetypeWav);
var _filetypeWoff = require("./icons/filetype-woff");
var _filetypeWoffDefault = parcelHelpers.interopDefault(_filetypeWoff);
var _filetypeXls = require("./icons/filetype-xls");
var _filetypeXlsDefault = parcelHelpers.interopDefault(_filetypeXls);
var _filetypeXlsx = require("./icons/filetype-xlsx");
var _filetypeXlsxDefault = parcelHelpers.interopDefault(_filetypeXlsx);
var _filetypeXml = require("./icons/filetype-xml");
var _filetypeXmlDefault = parcelHelpers.interopDefault(_filetypeXml);
var _filetypeYml = require("./icons/filetype-yml");
var _filetypeYmlDefault = parcelHelpers.interopDefault(_filetypeYml);
var _film = require("./icons/film");
var _filmDefault = parcelHelpers.interopDefault(_film);
var _filterCircleFill = require("./icons/filter-circle-fill");
var _filterCircleFillDefault = parcelHelpers.interopDefault(_filterCircleFill);
var _filterCircle = require("./icons/filter-circle");
var _filterCircleDefault = parcelHelpers.interopDefault(_filterCircle);
var _filterLeft = require("./icons/filter-left");
var _filterLeftDefault = parcelHelpers.interopDefault(_filterLeft);
var _filterRight = require("./icons/filter-right");
var _filterRightDefault = parcelHelpers.interopDefault(_filterRight);
var _filterSquareFill = require("./icons/filter-square-fill");
var _filterSquareFillDefault = parcelHelpers.interopDefault(_filterSquareFill);
var _filterSquare = require("./icons/filter-square");
var _filterSquareDefault = parcelHelpers.interopDefault(_filterSquare);
var _filter = require("./icons/filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _fingerprint = require("./icons/fingerprint");
var _fingerprintDefault = parcelHelpers.interopDefault(_fingerprint);
var _fire = require("./icons/fire");
var _fireDefault = parcelHelpers.interopDefault(_fire);
var _flagFill = require("./icons/flag-fill");
var _flagFillDefault = parcelHelpers.interopDefault(_flagFill);
var _flag = require("./icons/flag");
var _flagDefault = parcelHelpers.interopDefault(_flag);
var _floppyFill = require("./icons/floppy-fill");
var _floppyFillDefault = parcelHelpers.interopDefault(_floppyFill);
var _floppy = require("./icons/floppy");
var _floppyDefault = parcelHelpers.interopDefault(_floppy);
var _floppy2Fill = require("./icons/floppy2-fill");
var _floppy2FillDefault = parcelHelpers.interopDefault(_floppy2Fill);
var _floppy2 = require("./icons/floppy2");
var _floppy2Default = parcelHelpers.interopDefault(_floppy2);
var _flower1 = require("./icons/flower1");
var _flower1Default = parcelHelpers.interopDefault(_flower1);
var _flower2 = require("./icons/flower2");
var _flower2Default = parcelHelpers.interopDefault(_flower2);
var _flower3 = require("./icons/flower3");
var _flower3Default = parcelHelpers.interopDefault(_flower3);
var _folderCheck = require("./icons/folder-check");
var _folderCheckDefault = parcelHelpers.interopDefault(_folderCheck);
var _folderFill = require("./icons/folder-fill");
var _folderFillDefault = parcelHelpers.interopDefault(_folderFill);
var _folderMinus = require("./icons/folder-minus");
var _folderMinusDefault = parcelHelpers.interopDefault(_folderMinus);
var _folderPlus = require("./icons/folder-plus");
var _folderPlusDefault = parcelHelpers.interopDefault(_folderPlus);
var _folderSymlinkFill = require("./icons/folder-symlink-fill");
var _folderSymlinkFillDefault = parcelHelpers.interopDefault(_folderSymlinkFill);
var _folderSymlink = require("./icons/folder-symlink");
var _folderSymlinkDefault = parcelHelpers.interopDefault(_folderSymlink);
var _folderX = require("./icons/folder-x");
var _folderXDefault = parcelHelpers.interopDefault(_folderX);
var _folder = require("./icons/folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
var _folder2Open = require("./icons/folder2-open");
var _folder2OpenDefault = parcelHelpers.interopDefault(_folder2Open);
var _folder2 = require("./icons/folder2");
var _folder2Default = parcelHelpers.interopDefault(_folder2);
var _fonts = require("./icons/fonts");
var _fontsDefault = parcelHelpers.interopDefault(_fonts);
var _forwardFill = require("./icons/forward-fill");
var _forwardFillDefault = parcelHelpers.interopDefault(_forwardFill);
var _forward = require("./icons/forward");
var _forwardDefault = parcelHelpers.interopDefault(_forward);
var _front = require("./icons/front");
var _frontDefault = parcelHelpers.interopDefault(_front);
var _fuelPumpDieselFill = require("./icons/fuel-pump-diesel-fill");
var _fuelPumpDieselFillDefault = parcelHelpers.interopDefault(_fuelPumpDieselFill);
var _fuelPumpDiesel = require("./icons/fuel-pump-diesel");
var _fuelPumpDieselDefault = parcelHelpers.interopDefault(_fuelPumpDiesel);
var _fuelPumpFill = require("./icons/fuel-pump-fill");
var _fuelPumpFillDefault = parcelHelpers.interopDefault(_fuelPumpFill);
var _fuelPump = require("./icons/fuel-pump");
var _fuelPumpDefault = parcelHelpers.interopDefault(_fuelPump);
var _fullscreenExit = require("./icons/fullscreen-exit");
var _fullscreenExitDefault = parcelHelpers.interopDefault(_fullscreenExit);
var _fullscreen = require("./icons/fullscreen");
var _fullscreenDefault = parcelHelpers.interopDefault(_fullscreen);
var _funnelFill = require("./icons/funnel-fill");
var _funnelFillDefault = parcelHelpers.interopDefault(_funnelFill);
var _funnel = require("./icons/funnel");
var _funnelDefault = parcelHelpers.interopDefault(_funnel);
var _gearFill = require("./icons/gear-fill");
var _gearFillDefault = parcelHelpers.interopDefault(_gearFill);
var _gearWideConnected = require("./icons/gear-wide-connected");
var _gearWideConnectedDefault = parcelHelpers.interopDefault(_gearWideConnected);
var _gearWide = require("./icons/gear-wide");
var _gearWideDefault = parcelHelpers.interopDefault(_gearWide);
var _gear = require("./icons/gear");
var _gearDefault = parcelHelpers.interopDefault(_gear);
var _gem = require("./icons/gem");
var _gemDefault = parcelHelpers.interopDefault(_gem);
var _genderAmbiguous = require("./icons/gender-ambiguous");
var _genderAmbiguousDefault = parcelHelpers.interopDefault(_genderAmbiguous);
var _genderFemale = require("./icons/gender-female");
var _genderFemaleDefault = parcelHelpers.interopDefault(_genderFemale);
var _genderMale = require("./icons/gender-male");
var _genderMaleDefault = parcelHelpers.interopDefault(_genderMale);
var _genderNeuter = require("./icons/gender-neuter");
var _genderNeuterDefault = parcelHelpers.interopDefault(_genderNeuter);
var _genderTrans = require("./icons/gender-trans");
var _genderTransDefault = parcelHelpers.interopDefault(_genderTrans);
var _geoAltFill = require("./icons/geo-alt-fill");
var _geoAltFillDefault = parcelHelpers.interopDefault(_geoAltFill);
var _geoAlt = require("./icons/geo-alt");
var _geoAltDefault = parcelHelpers.interopDefault(_geoAlt);
var _geoFill = require("./icons/geo-fill");
var _geoFillDefault = parcelHelpers.interopDefault(_geoFill);
var _geo = require("./icons/geo");
var _geoDefault = parcelHelpers.interopDefault(_geo);
var _giftFill = require("./icons/gift-fill");
var _giftFillDefault = parcelHelpers.interopDefault(_giftFill);
var _gift = require("./icons/gift");
var _giftDefault = parcelHelpers.interopDefault(_gift);
var _git = require("./icons/git");
var _gitDefault = parcelHelpers.interopDefault(_git);
var _github = require("./icons/github");
var _githubDefault = parcelHelpers.interopDefault(_github);
var _gitlab = require("./icons/gitlab");
var _gitlabDefault = parcelHelpers.interopDefault(_gitlab);
var _globeAmericas = require("./icons/globe-americas");
var _globeAmericasDefault = parcelHelpers.interopDefault(_globeAmericas);
var _globeAsiaAustralia = require("./icons/globe-asia-australia");
var _globeAsiaAustraliaDefault = parcelHelpers.interopDefault(_globeAsiaAustralia);
var _globeCentralSouthAsia = require("./icons/globe-central-south-asia");
var _globeCentralSouthAsiaDefault = parcelHelpers.interopDefault(_globeCentralSouthAsia);
var _globeEuropeAfrica = require("./icons/globe-europe-africa");
var _globeEuropeAfricaDefault = parcelHelpers.interopDefault(_globeEuropeAfrica);
var _globe = require("./icons/globe");
var _globeDefault = parcelHelpers.interopDefault(_globe);
var _globe2 = require("./icons/globe2");
var _globe2Default = parcelHelpers.interopDefault(_globe2);
var _googlePlay = require("./icons/google-play");
var _googlePlayDefault = parcelHelpers.interopDefault(_googlePlay);
var _google = require("./icons/google");
var _googleDefault = parcelHelpers.interopDefault(_google);
var _gpuCard = require("./icons/gpu-card");
var _gpuCardDefault = parcelHelpers.interopDefault(_gpuCard);
var _graphDownArrow = require("./icons/graph-down-arrow");
var _graphDownArrowDefault = parcelHelpers.interopDefault(_graphDownArrow);
var _graphDown = require("./icons/graph-down");
var _graphDownDefault = parcelHelpers.interopDefault(_graphDown);
var _graphUpArrow = require("./icons/graph-up-arrow");
var _graphUpArrowDefault = parcelHelpers.interopDefault(_graphUpArrow);
var _graphUp = require("./icons/graph-up");
var _graphUpDefault = parcelHelpers.interopDefault(_graphUp);
var _grid1X2Fill = require("./icons/grid-1x2-fill");
var _grid1X2FillDefault = parcelHelpers.interopDefault(_grid1X2Fill);
var _grid1X2 = require("./icons/grid-1x2");
var _grid1X2Default = parcelHelpers.interopDefault(_grid1X2);
var _grid3X2GapFill = require("./icons/grid-3x2-gap-fill");
var _grid3X2GapFillDefault = parcelHelpers.interopDefault(_grid3X2GapFill);
var _grid3X2Gap = require("./icons/grid-3x2-gap");
var _grid3X2GapDefault = parcelHelpers.interopDefault(_grid3X2Gap);
var _grid3X2 = require("./icons/grid-3x2");
var _grid3X2Default = parcelHelpers.interopDefault(_grid3X2);
var _grid3X3GapFill = require("./icons/grid-3x3-gap-fill");
var _grid3X3GapFillDefault = parcelHelpers.interopDefault(_grid3X3GapFill);
var _grid3X3Gap = require("./icons/grid-3x3-gap");
var _grid3X3GapDefault = parcelHelpers.interopDefault(_grid3X3Gap);
var _grid3X3 = require("./icons/grid-3x3");
var _grid3X3Default = parcelHelpers.interopDefault(_grid3X3);
var _gridFill = require("./icons/grid-fill");
var _gridFillDefault = parcelHelpers.interopDefault(_gridFill);
var _grid = require("./icons/grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _gripHorizontal = require("./icons/grip-horizontal");
var _gripHorizontalDefault = parcelHelpers.interopDefault(_gripHorizontal);
var _gripVertical = require("./icons/grip-vertical");
var _gripVerticalDefault = parcelHelpers.interopDefault(_gripVertical);
var _hCircleFill = require("./icons/h-circle-fill");
var _hCircleFillDefault = parcelHelpers.interopDefault(_hCircleFill);
var _hCircle = require("./icons/h-circle");
var _hCircleDefault = parcelHelpers.interopDefault(_hCircle);
var _hSquareFill = require("./icons/h-square-fill");
var _hSquareFillDefault = parcelHelpers.interopDefault(_hSquareFill);
var _hSquare = require("./icons/h-square");
var _hSquareDefault = parcelHelpers.interopDefault(_hSquare);
var _hammer = require("./icons/hammer");
var _hammerDefault = parcelHelpers.interopDefault(_hammer);
var _handIndexFill = require("./icons/hand-index-fill");
var _handIndexFillDefault = parcelHelpers.interopDefault(_handIndexFill);
var _handIndexThumbFill = require("./icons/hand-index-thumb-fill");
var _handIndexThumbFillDefault = parcelHelpers.interopDefault(_handIndexThumbFill);
var _handIndexThumb = require("./icons/hand-index-thumb");
var _handIndexThumbDefault = parcelHelpers.interopDefault(_handIndexThumb);
var _handIndex = require("./icons/hand-index");
var _handIndexDefault = parcelHelpers.interopDefault(_handIndex);
var _handThumbsDownFill = require("./icons/hand-thumbs-down-fill");
var _handThumbsDownFillDefault = parcelHelpers.interopDefault(_handThumbsDownFill);
var _handThumbsDown = require("./icons/hand-thumbs-down");
var _handThumbsDownDefault = parcelHelpers.interopDefault(_handThumbsDown);
var _handThumbsUpFill = require("./icons/hand-thumbs-up-fill");
var _handThumbsUpFillDefault = parcelHelpers.interopDefault(_handThumbsUpFill);
var _handThumbsUp = require("./icons/hand-thumbs-up");
var _handThumbsUpDefault = parcelHelpers.interopDefault(_handThumbsUp);
var _handbagFill = require("./icons/handbag-fill");
var _handbagFillDefault = parcelHelpers.interopDefault(_handbagFill);
var _handbag = require("./icons/handbag");
var _handbagDefault = parcelHelpers.interopDefault(_handbag);
var _hash = require("./icons/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _hddFill = require("./icons/hdd-fill");
var _hddFillDefault = parcelHelpers.interopDefault(_hddFill);
var _hddNetworkFill = require("./icons/hdd-network-fill");
var _hddNetworkFillDefault = parcelHelpers.interopDefault(_hddNetworkFill);
var _hddNetwork = require("./icons/hdd-network");
var _hddNetworkDefault = parcelHelpers.interopDefault(_hddNetwork);
var _hddRackFill = require("./icons/hdd-rack-fill");
var _hddRackFillDefault = parcelHelpers.interopDefault(_hddRackFill);
var _hddRack = require("./icons/hdd-rack");
var _hddRackDefault = parcelHelpers.interopDefault(_hddRack);
var _hddStackFill = require("./icons/hdd-stack-fill");
var _hddStackFillDefault = parcelHelpers.interopDefault(_hddStackFill);
var _hddStack = require("./icons/hdd-stack");
var _hddStackDefault = parcelHelpers.interopDefault(_hddStack);
var _hdd = require("./icons/hdd");
var _hddDefault = parcelHelpers.interopDefault(_hdd);
var _hdmiFill = require("./icons/hdmi-fill");
var _hdmiFillDefault = parcelHelpers.interopDefault(_hdmiFill);
var _hdmi = require("./icons/hdmi");
var _hdmiDefault = parcelHelpers.interopDefault(_hdmi);
var _headphones = require("./icons/headphones");
var _headphonesDefault = parcelHelpers.interopDefault(_headphones);
var _headsetVr = require("./icons/headset-vr");
var _headsetVrDefault = parcelHelpers.interopDefault(_headsetVr);
var _headset = require("./icons/headset");
var _headsetDefault = parcelHelpers.interopDefault(_headset);
var _heartArrow = require("./icons/heart-arrow");
var _heartArrowDefault = parcelHelpers.interopDefault(_heartArrow);
var _heartFill = require("./icons/heart-fill");
var _heartFillDefault = parcelHelpers.interopDefault(_heartFill);
var _heartHalf = require("./icons/heart-half");
var _heartHalfDefault = parcelHelpers.interopDefault(_heartHalf);
var _heartPulseFill = require("./icons/heart-pulse-fill");
var _heartPulseFillDefault = parcelHelpers.interopDefault(_heartPulseFill);
var _heartPulse = require("./icons/heart-pulse");
var _heartPulseDefault = parcelHelpers.interopDefault(_heartPulse);
var _heart = require("./icons/heart");
var _heartDefault = parcelHelpers.interopDefault(_heart);
var _heartbreakFill = require("./icons/heartbreak-fill");
var _heartbreakFillDefault = parcelHelpers.interopDefault(_heartbreakFill);
var _heartbreak = require("./icons/heartbreak");
var _heartbreakDefault = parcelHelpers.interopDefault(_heartbreak);
var _hearts = require("./icons/hearts");
var _heartsDefault = parcelHelpers.interopDefault(_hearts);
var _heptagonFill = require("./icons/heptagon-fill");
var _heptagonFillDefault = parcelHelpers.interopDefault(_heptagonFill);
var _heptagonHalf = require("./icons/heptagon-half");
var _heptagonHalfDefault = parcelHelpers.interopDefault(_heptagonHalf);
var _heptagon = require("./icons/heptagon");
var _heptagonDefault = parcelHelpers.interopDefault(_heptagon);
var _hexagonFill = require("./icons/hexagon-fill");
var _hexagonFillDefault = parcelHelpers.interopDefault(_hexagonFill);
var _hexagonHalf = require("./icons/hexagon-half");
var _hexagonHalfDefault = parcelHelpers.interopDefault(_hexagonHalf);
var _hexagon = require("./icons/hexagon");
var _hexagonDefault = parcelHelpers.interopDefault(_hexagon);
var _highlighter = require("./icons/highlighter");
var _highlighterDefault = parcelHelpers.interopDefault(_highlighter);
var _highlights = require("./icons/highlights");
var _highlightsDefault = parcelHelpers.interopDefault(_highlights);
var _hospitalFill = require("./icons/hospital-fill");
var _hospitalFillDefault = parcelHelpers.interopDefault(_hospitalFill);
var _hospital = require("./icons/hospital");
var _hospitalDefault = parcelHelpers.interopDefault(_hospital);
var _hourglassBottom = require("./icons/hourglass-bottom");
var _hourglassBottomDefault = parcelHelpers.interopDefault(_hourglassBottom);
var _hourglassSplit = require("./icons/hourglass-split");
var _hourglassSplitDefault = parcelHelpers.interopDefault(_hourglassSplit);
var _hourglassTop = require("./icons/hourglass-top");
var _hourglassTopDefault = parcelHelpers.interopDefault(_hourglassTop);
var _hourglass = require("./icons/hourglass");
var _hourglassDefault = parcelHelpers.interopDefault(_hourglass);
var _houseAddFill = require("./icons/house-add-fill");
var _houseAddFillDefault = parcelHelpers.interopDefault(_houseAddFill);
var _houseAdd = require("./icons/house-add");
var _houseAddDefault = parcelHelpers.interopDefault(_houseAdd);
var _houseCheckFill = require("./icons/house-check-fill");
var _houseCheckFillDefault = parcelHelpers.interopDefault(_houseCheckFill);
var _houseCheck = require("./icons/house-check");
var _houseCheckDefault = parcelHelpers.interopDefault(_houseCheck);
var _houseDashFill = require("./icons/house-dash-fill");
var _houseDashFillDefault = parcelHelpers.interopDefault(_houseDashFill);
var _houseDash = require("./icons/house-dash");
var _houseDashDefault = parcelHelpers.interopDefault(_houseDash);
var _houseDoorFill = require("./icons/house-door-fill");
var _houseDoorFillDefault = parcelHelpers.interopDefault(_houseDoorFill);
var _houseDoor = require("./icons/house-door");
var _houseDoorDefault = parcelHelpers.interopDefault(_houseDoor);
var _houseDownFill = require("./icons/house-down-fill");
var _houseDownFillDefault = parcelHelpers.interopDefault(_houseDownFill);
var _houseDown = require("./icons/house-down");
var _houseDownDefault = parcelHelpers.interopDefault(_houseDown);
var _houseExclamationFill = require("./icons/house-exclamation-fill");
var _houseExclamationFillDefault = parcelHelpers.interopDefault(_houseExclamationFill);
var _houseExclamation = require("./icons/house-exclamation");
var _houseExclamationDefault = parcelHelpers.interopDefault(_houseExclamation);
var _houseFill = require("./icons/house-fill");
var _houseFillDefault = parcelHelpers.interopDefault(_houseFill);
var _houseGearFill = require("./icons/house-gear-fill");
var _houseGearFillDefault = parcelHelpers.interopDefault(_houseGearFill);
var _houseGear = require("./icons/house-gear");
var _houseGearDefault = parcelHelpers.interopDefault(_houseGear);
var _houseHeartFill = require("./icons/house-heart-fill");
var _houseHeartFillDefault = parcelHelpers.interopDefault(_houseHeartFill);
var _houseHeart = require("./icons/house-heart");
var _houseHeartDefault = parcelHelpers.interopDefault(_houseHeart);
var _houseLockFill = require("./icons/house-lock-fill");
var _houseLockFillDefault = parcelHelpers.interopDefault(_houseLockFill);
var _houseLock = require("./icons/house-lock");
var _houseLockDefault = parcelHelpers.interopDefault(_houseLock);
var _houseSlashFill = require("./icons/house-slash-fill");
var _houseSlashFillDefault = parcelHelpers.interopDefault(_houseSlashFill);
var _houseSlash = require("./icons/house-slash");
var _houseSlashDefault = parcelHelpers.interopDefault(_houseSlash);
var _houseUpFill = require("./icons/house-up-fill");
var _houseUpFillDefault = parcelHelpers.interopDefault(_houseUpFill);
var _houseUp = require("./icons/house-up");
var _houseUpDefault = parcelHelpers.interopDefault(_houseUp);
var _houseXFill = require("./icons/house-x-fill");
var _houseXFillDefault = parcelHelpers.interopDefault(_houseXFill);
var _houseX = require("./icons/house-x");
var _houseXDefault = parcelHelpers.interopDefault(_houseX);
var _house = require("./icons/house");
var _houseDefault = parcelHelpers.interopDefault(_house);
var _housesFill = require("./icons/houses-fill");
var _housesFillDefault = parcelHelpers.interopDefault(_housesFill);
var _houses = require("./icons/houses");
var _housesDefault = parcelHelpers.interopDefault(_houses);
var _hr = require("./icons/hr");
var _hrDefault = parcelHelpers.interopDefault(_hr);
var _hurricane = require("./icons/hurricane");
var _hurricaneDefault = parcelHelpers.interopDefault(_hurricane);
var _hypnotize = require("./icons/hypnotize");
var _hypnotizeDefault = parcelHelpers.interopDefault(_hypnotize);
var _imageAlt = require("./icons/image-alt");
var _imageAltDefault = parcelHelpers.interopDefault(_imageAlt);
var _imageFill = require("./icons/image-fill");
var _imageFillDefault = parcelHelpers.interopDefault(_imageFill);
var _image = require("./icons/image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _images = require("./icons/images");
var _imagesDefault = parcelHelpers.interopDefault(_images);
var _inboxFill = require("./icons/inbox-fill");
var _inboxFillDefault = parcelHelpers.interopDefault(_inboxFill);
var _inbox = require("./icons/inbox");
var _inboxDefault = parcelHelpers.interopDefault(_inbox);
var _inboxesFill = require("./icons/inboxes-fill");
var _inboxesFillDefault = parcelHelpers.interopDefault(_inboxesFill);
var _inboxes = require("./icons/inboxes");
var _inboxesDefault = parcelHelpers.interopDefault(_inboxes);
var _incognito = require("./icons/incognito");
var _incognitoDefault = parcelHelpers.interopDefault(_incognito);
var _indent = require("./icons/indent");
var _indentDefault = parcelHelpers.interopDefault(_indent);
var _infinity = require("./icons/infinity");
var _infinityDefault = parcelHelpers.interopDefault(_infinity);
var _infoCircleFill = require("./icons/info-circle-fill");
var _infoCircleFillDefault = parcelHelpers.interopDefault(_infoCircleFill);
var _infoCircle = require("./icons/info-circle");
var _infoCircleDefault = parcelHelpers.interopDefault(_infoCircle);
var _infoLg = require("./icons/info-lg");
var _infoLgDefault = parcelHelpers.interopDefault(_infoLg);
var _infoSquareFill = require("./icons/info-square-fill");
var _infoSquareFillDefault = parcelHelpers.interopDefault(_infoSquareFill);
var _infoSquare = require("./icons/info-square");
var _infoSquareDefault = parcelHelpers.interopDefault(_infoSquare);
var _info = require("./icons/info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _inputCursorText = require("./icons/input-cursor-text");
var _inputCursorTextDefault = parcelHelpers.interopDefault(_inputCursorText);
var _inputCursor = require("./icons/input-cursor");
var _inputCursorDefault = parcelHelpers.interopDefault(_inputCursor);
var _instagram = require("./icons/instagram");
var _instagramDefault = parcelHelpers.interopDefault(_instagram);
var _intersect = require("./icons/intersect");
var _intersectDefault = parcelHelpers.interopDefault(_intersect);
var _journalAlbum = require("./icons/journal-album");
var _journalAlbumDefault = parcelHelpers.interopDefault(_journalAlbum);
var _journalArrowDown = require("./icons/journal-arrow-down");
var _journalArrowDownDefault = parcelHelpers.interopDefault(_journalArrowDown);
var _journalArrowUp = require("./icons/journal-arrow-up");
var _journalArrowUpDefault = parcelHelpers.interopDefault(_journalArrowUp);
var _journalBookmarkFill = require("./icons/journal-bookmark-fill");
var _journalBookmarkFillDefault = parcelHelpers.interopDefault(_journalBookmarkFill);
var _journalBookmark = require("./icons/journal-bookmark");
var _journalBookmarkDefault = parcelHelpers.interopDefault(_journalBookmark);
var _journalCheck = require("./icons/journal-check");
var _journalCheckDefault = parcelHelpers.interopDefault(_journalCheck);
var _journalCode = require("./icons/journal-code");
var _journalCodeDefault = parcelHelpers.interopDefault(_journalCode);
var _journalMedical = require("./icons/journal-medical");
var _journalMedicalDefault = parcelHelpers.interopDefault(_journalMedical);
var _journalMinus = require("./icons/journal-minus");
var _journalMinusDefault = parcelHelpers.interopDefault(_journalMinus);
var _journalPlus = require("./icons/journal-plus");
var _journalPlusDefault = parcelHelpers.interopDefault(_journalPlus);
var _journalRichtext = require("./icons/journal-richtext");
var _journalRichtextDefault = parcelHelpers.interopDefault(_journalRichtext);
var _journalText = require("./icons/journal-text");
var _journalTextDefault = parcelHelpers.interopDefault(_journalText);
var _journalX = require("./icons/journal-x");
var _journalXDefault = parcelHelpers.interopDefault(_journalX);
var _journal = require("./icons/journal");
var _journalDefault = parcelHelpers.interopDefault(_journal);
var _journals = require("./icons/journals");
var _journalsDefault = parcelHelpers.interopDefault(_journals);
var _joystick = require("./icons/joystick");
var _joystickDefault = parcelHelpers.interopDefault(_joystick);
var _justifyLeft = require("./icons/justify-left");
var _justifyLeftDefault = parcelHelpers.interopDefault(_justifyLeft);
var _justifyRight = require("./icons/justify-right");
var _justifyRightDefault = parcelHelpers.interopDefault(_justifyRight);
var _justify = require("./icons/justify");
var _justifyDefault = parcelHelpers.interopDefault(_justify);
var _kanbanFill = require("./icons/kanban-fill");
var _kanbanFillDefault = parcelHelpers.interopDefault(_kanbanFill);
var _kanban = require("./icons/kanban");
var _kanbanDefault = parcelHelpers.interopDefault(_kanban);
var _keyFill = require("./icons/key-fill");
var _keyFillDefault = parcelHelpers.interopDefault(_keyFill);
var _key = require("./icons/key");
var _keyDefault = parcelHelpers.interopDefault(_key);
var _keyboardFill = require("./icons/keyboard-fill");
var _keyboardFillDefault = parcelHelpers.interopDefault(_keyboardFill);
var _keyboard = require("./icons/keyboard");
var _keyboardDefault = parcelHelpers.interopDefault(_keyboard);
var _ladder = require("./icons/ladder");
var _ladderDefault = parcelHelpers.interopDefault(_ladder);
var _lampFill = require("./icons/lamp-fill");
var _lampFillDefault = parcelHelpers.interopDefault(_lampFill);
var _lamp = require("./icons/lamp");
var _lampDefault = parcelHelpers.interopDefault(_lamp);
var _laptopFill = require("./icons/laptop-fill");
var _laptopFillDefault = parcelHelpers.interopDefault(_laptopFill);
var _laptop = require("./icons/laptop");
var _laptopDefault = parcelHelpers.interopDefault(_laptop);
var _layerBackward = require("./icons/layer-backward");
var _layerBackwardDefault = parcelHelpers.interopDefault(_layerBackward);
var _layerForward = require("./icons/layer-forward");
var _layerForwardDefault = parcelHelpers.interopDefault(_layerForward);
var _layersFill = require("./icons/layers-fill");
var _layersFillDefault = parcelHelpers.interopDefault(_layersFill);
var _layersHalf = require("./icons/layers-half");
var _layersHalfDefault = parcelHelpers.interopDefault(_layersHalf);
var _layers = require("./icons/layers");
var _layersDefault = parcelHelpers.interopDefault(_layers);
var _layoutSidebarInsetReverse = require("./icons/layout-sidebar-inset-reverse");
var _layoutSidebarInsetReverseDefault = parcelHelpers.interopDefault(_layoutSidebarInsetReverse);
var _layoutSidebarInset = require("./icons/layout-sidebar-inset");
var _layoutSidebarInsetDefault = parcelHelpers.interopDefault(_layoutSidebarInset);
var _layoutSidebarReverse = require("./icons/layout-sidebar-reverse");
var _layoutSidebarReverseDefault = parcelHelpers.interopDefault(_layoutSidebarReverse);
var _layoutSidebar = require("./icons/layout-sidebar");
var _layoutSidebarDefault = parcelHelpers.interopDefault(_layoutSidebar);
var _layoutSplit = require("./icons/layout-split");
var _layoutSplitDefault = parcelHelpers.interopDefault(_layoutSplit);
var _layoutTextSidebarReverse = require("./icons/layout-text-sidebar-reverse");
var _layoutTextSidebarReverseDefault = parcelHelpers.interopDefault(_layoutTextSidebarReverse);
var _layoutTextSidebar = require("./icons/layout-text-sidebar");
var _layoutTextSidebarDefault = parcelHelpers.interopDefault(_layoutTextSidebar);
var _layoutTextWindowReverse = require("./icons/layout-text-window-reverse");
var _layoutTextWindowReverseDefault = parcelHelpers.interopDefault(_layoutTextWindowReverse);
var _layoutTextWindow = require("./icons/layout-text-window");
var _layoutTextWindowDefault = parcelHelpers.interopDefault(_layoutTextWindow);
var _layoutThreeColumns = require("./icons/layout-three-columns");
var _layoutThreeColumnsDefault = parcelHelpers.interopDefault(_layoutThreeColumns);
var _layoutWtf = require("./icons/layout-wtf");
var _layoutWtfDefault = parcelHelpers.interopDefault(_layoutWtf);
var _lifePreserver = require("./icons/life-preserver");
var _lifePreserverDefault = parcelHelpers.interopDefault(_lifePreserver);
var _lightbulbFill = require("./icons/lightbulb-fill");
var _lightbulbFillDefault = parcelHelpers.interopDefault(_lightbulbFill);
var _lightbulbOffFill = require("./icons/lightbulb-off-fill");
var _lightbulbOffFillDefault = parcelHelpers.interopDefault(_lightbulbOffFill);
var _lightbulbOff = require("./icons/lightbulb-off");
var _lightbulbOffDefault = parcelHelpers.interopDefault(_lightbulbOff);
var _lightbulb = require("./icons/lightbulb");
var _lightbulbDefault = parcelHelpers.interopDefault(_lightbulb);
var _lightningChargeFill = require("./icons/lightning-charge-fill");
var _lightningChargeFillDefault = parcelHelpers.interopDefault(_lightningChargeFill);
var _lightningCharge = require("./icons/lightning-charge");
var _lightningChargeDefault = parcelHelpers.interopDefault(_lightningCharge);
var _lightningFill = require("./icons/lightning-fill");
var _lightningFillDefault = parcelHelpers.interopDefault(_lightningFill);
var _lightning = require("./icons/lightning");
var _lightningDefault = parcelHelpers.interopDefault(_lightning);
var _line = require("./icons/line");
var _lineDefault = parcelHelpers.interopDefault(_line);
var _link45Deg = require("./icons/link-45deg");
var _link45DegDefault = parcelHelpers.interopDefault(_link45Deg);
var _link = require("./icons/link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _linkedin = require("./icons/linkedin");
var _linkedinDefault = parcelHelpers.interopDefault(_linkedin);
var _listCheck = require("./icons/list-check");
var _listCheckDefault = parcelHelpers.interopDefault(_listCheck);
var _listColumnsReverse = require("./icons/list-columns-reverse");
var _listColumnsReverseDefault = parcelHelpers.interopDefault(_listColumnsReverse);
var _listColumns = require("./icons/list-columns");
var _listColumnsDefault = parcelHelpers.interopDefault(_listColumns);
var _listNested = require("./icons/list-nested");
var _listNestedDefault = parcelHelpers.interopDefault(_listNested);
var _listOl = require("./icons/list-ol");
var _listOlDefault = parcelHelpers.interopDefault(_listOl);
var _listStars = require("./icons/list-stars");
var _listStarsDefault = parcelHelpers.interopDefault(_listStars);
var _listTask = require("./icons/list-task");
var _listTaskDefault = parcelHelpers.interopDefault(_listTask);
var _listUl = require("./icons/list-ul");
var _listUlDefault = parcelHelpers.interopDefault(_listUl);
var _list = require("./icons/list");
var _listDefault = parcelHelpers.interopDefault(_list);
var _lockFill = require("./icons/lock-fill");
var _lockFillDefault = parcelHelpers.interopDefault(_lockFill);
var _lock = require("./icons/lock");
var _lockDefault = parcelHelpers.interopDefault(_lock);
var _luggageFill = require("./icons/luggage-fill");
var _luggageFillDefault = parcelHelpers.interopDefault(_luggageFill);
var _luggage = require("./icons/luggage");
var _luggageDefault = parcelHelpers.interopDefault(_luggage);
var _lungsFill = require("./icons/lungs-fill");
var _lungsFillDefault = parcelHelpers.interopDefault(_lungsFill);
var _lungs = require("./icons/lungs");
var _lungsDefault = parcelHelpers.interopDefault(_lungs);
var _magic = require("./icons/magic");
var _magicDefault = parcelHelpers.interopDefault(_magic);
var _magnetFill = require("./icons/magnet-fill");
var _magnetFillDefault = parcelHelpers.interopDefault(_magnetFill);
var _magnet = require("./icons/magnet");
var _magnetDefault = parcelHelpers.interopDefault(_magnet);
var _mailboxFlag = require("./icons/mailbox-flag");
var _mailboxFlagDefault = parcelHelpers.interopDefault(_mailboxFlag);
var _mailbox = require("./icons/mailbox");
var _mailboxDefault = parcelHelpers.interopDefault(_mailbox);
var _mailbox2Flag = require("./icons/mailbox2-flag");
var _mailbox2FlagDefault = parcelHelpers.interopDefault(_mailbox2Flag);
var _mailbox2 = require("./icons/mailbox2");
var _mailbox2Default = parcelHelpers.interopDefault(_mailbox2);
var _mapFill = require("./icons/map-fill");
var _mapFillDefault = parcelHelpers.interopDefault(_mapFill);
var _map = require("./icons/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _markdownFill = require("./icons/markdown-fill");
var _markdownFillDefault = parcelHelpers.interopDefault(_markdownFill);
var _markdown = require("./icons/markdown");
var _markdownDefault = parcelHelpers.interopDefault(_markdown);
var _markerTip = require("./icons/marker-tip");
var _markerTipDefault = parcelHelpers.interopDefault(_markerTip);
var _mask = require("./icons/mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _mastodon = require("./icons/mastodon");
var _mastodonDefault = parcelHelpers.interopDefault(_mastodon);
var _medium = require("./icons/medium");
var _mediumDefault = parcelHelpers.interopDefault(_medium);
var _megaphoneFill = require("./icons/megaphone-fill");
var _megaphoneFillDefault = parcelHelpers.interopDefault(_megaphoneFill);
var _megaphone = require("./icons/megaphone");
var _megaphoneDefault = parcelHelpers.interopDefault(_megaphone);
var _memory = require("./icons/memory");
var _memoryDefault = parcelHelpers.interopDefault(_memory);
var _menuAppFill = require("./icons/menu-app-fill");
var _menuAppFillDefault = parcelHelpers.interopDefault(_menuAppFill);
var _menuApp = require("./icons/menu-app");
var _menuAppDefault = parcelHelpers.interopDefault(_menuApp);
var _menuButtonFill = require("./icons/menu-button-fill");
var _menuButtonFillDefault = parcelHelpers.interopDefault(_menuButtonFill);
var _menuButtonWideFill = require("./icons/menu-button-wide-fill");
var _menuButtonWideFillDefault = parcelHelpers.interopDefault(_menuButtonWideFill);
var _menuButtonWide = require("./icons/menu-button-wide");
var _menuButtonWideDefault = parcelHelpers.interopDefault(_menuButtonWide);
var _menuButton = require("./icons/menu-button");
var _menuButtonDefault = parcelHelpers.interopDefault(_menuButton);
var _menuDown = require("./icons/menu-down");
var _menuDownDefault = parcelHelpers.interopDefault(_menuDown);
var _menuUp = require("./icons/menu-up");
var _menuUpDefault = parcelHelpers.interopDefault(_menuUp);
var _messenger = require("./icons/messenger");
var _messengerDefault = parcelHelpers.interopDefault(_messenger);
var _meta = require("./icons/meta");
var _metaDefault = parcelHelpers.interopDefault(_meta);
var _micFill = require("./icons/mic-fill");
var _micFillDefault = parcelHelpers.interopDefault(_micFill);
var _micMuteFill = require("./icons/mic-mute-fill");
var _micMuteFillDefault = parcelHelpers.interopDefault(_micMuteFill);
var _micMute = require("./icons/mic-mute");
var _micMuteDefault = parcelHelpers.interopDefault(_micMute);
var _mic = require("./icons/mic");
var _micDefault = parcelHelpers.interopDefault(_mic);
var _microsoftTeams = require("./icons/microsoft-teams");
var _microsoftTeamsDefault = parcelHelpers.interopDefault(_microsoftTeams);
var _microsoft = require("./icons/microsoft");
var _microsoftDefault = parcelHelpers.interopDefault(_microsoft);
var _minecartLoaded = require("./icons/minecart-loaded");
var _minecartLoadedDefault = parcelHelpers.interopDefault(_minecartLoaded);
var _minecart = require("./icons/minecart");
var _minecartDefault = parcelHelpers.interopDefault(_minecart);
var _modemFill = require("./icons/modem-fill");
var _modemFillDefault = parcelHelpers.interopDefault(_modemFill);
var _modem = require("./icons/modem");
var _modemDefault = parcelHelpers.interopDefault(_modem);
var _moisture = require("./icons/moisture");
var _moistureDefault = parcelHelpers.interopDefault(_moisture);
var _moonFill = require("./icons/moon-fill");
var _moonFillDefault = parcelHelpers.interopDefault(_moonFill);
var _moonStarsFill = require("./icons/moon-stars-fill");
var _moonStarsFillDefault = parcelHelpers.interopDefault(_moonStarsFill);
var _moonStars = require("./icons/moon-stars");
var _moonStarsDefault = parcelHelpers.interopDefault(_moonStars);
var _moon = require("./icons/moon");
var _moonDefault = parcelHelpers.interopDefault(_moon);
var _mortarboardFill = require("./icons/mortarboard-fill");
var _mortarboardFillDefault = parcelHelpers.interopDefault(_mortarboardFill);
var _mortarboard = require("./icons/mortarboard");
var _mortarboardDefault = parcelHelpers.interopDefault(_mortarboard);
var _motherboardFill = require("./icons/motherboard-fill");
var _motherboardFillDefault = parcelHelpers.interopDefault(_motherboardFill);
var _motherboard = require("./icons/motherboard");
var _motherboardDefault = parcelHelpers.interopDefault(_motherboard);
var _mouseFill = require("./icons/mouse-fill");
var _mouseFillDefault = parcelHelpers.interopDefault(_mouseFill);
var _mouse = require("./icons/mouse");
var _mouseDefault = parcelHelpers.interopDefault(_mouse);
var _mouse2Fill = require("./icons/mouse2-fill");
var _mouse2FillDefault = parcelHelpers.interopDefault(_mouse2Fill);
var _mouse2 = require("./icons/mouse2");
var _mouse2Default = parcelHelpers.interopDefault(_mouse2);
var _mouse3Fill = require("./icons/mouse3-fill");
var _mouse3FillDefault = parcelHelpers.interopDefault(_mouse3Fill);
var _mouse3 = require("./icons/mouse3");
var _mouse3Default = parcelHelpers.interopDefault(_mouse3);
var _musicNoteBeamed = require("./icons/music-note-beamed");
var _musicNoteBeamedDefault = parcelHelpers.interopDefault(_musicNoteBeamed);
var _musicNoteList = require("./icons/music-note-list");
var _musicNoteListDefault = parcelHelpers.interopDefault(_musicNoteList);
var _musicNote = require("./icons/music-note");
var _musicNoteDefault = parcelHelpers.interopDefault(_musicNote);
var _musicPlayerFill = require("./icons/music-player-fill");
var _musicPlayerFillDefault = parcelHelpers.interopDefault(_musicPlayerFill);
var _musicPlayer = require("./icons/music-player");
var _musicPlayerDefault = parcelHelpers.interopDefault(_musicPlayer);
var _newspaper = require("./icons/newspaper");
var _newspaperDefault = parcelHelpers.interopDefault(_newspaper);
var _nintendoSwitch = require("./icons/nintendo-switch");
var _nintendoSwitchDefault = parcelHelpers.interopDefault(_nintendoSwitch);
var _nodeMinusFill = require("./icons/node-minus-fill");
var _nodeMinusFillDefault = parcelHelpers.interopDefault(_nodeMinusFill);
var _nodeMinus = require("./icons/node-minus");
var _nodeMinusDefault = parcelHelpers.interopDefault(_nodeMinus);
var _nodePlusFill = require("./icons/node-plus-fill");
var _nodePlusFillDefault = parcelHelpers.interopDefault(_nodePlusFill);
var _nodePlus = require("./icons/node-plus");
var _nodePlusDefault = parcelHelpers.interopDefault(_nodePlus);
var _noiseReduction = require("./icons/noise-reduction");
var _noiseReductionDefault = parcelHelpers.interopDefault(_noiseReduction);
var _nutFill = require("./icons/nut-fill");
var _nutFillDefault = parcelHelpers.interopDefault(_nutFill);
var _nut = require("./icons/nut");
var _nutDefault = parcelHelpers.interopDefault(_nut);
var _nvidia = require("./icons/nvidia");
var _nvidiaDefault = parcelHelpers.interopDefault(_nvidia);
var _nvmeFill = require("./icons/nvme-fill");
var _nvmeFillDefault = parcelHelpers.interopDefault(_nvmeFill);
var _nvme = require("./icons/nvme");
var _nvmeDefault = parcelHelpers.interopDefault(_nvme);
var _octagonFill = require("./icons/octagon-fill");
var _octagonFillDefault = parcelHelpers.interopDefault(_octagonFill);
var _octagonHalf = require("./icons/octagon-half");
var _octagonHalfDefault = parcelHelpers.interopDefault(_octagonHalf);
var _octagon = require("./icons/octagon");
var _octagonDefault = parcelHelpers.interopDefault(_octagon);
var _opencollective = require("./icons/opencollective");
var _opencollectiveDefault = parcelHelpers.interopDefault(_opencollective);
var _opticalAudioFill = require("./icons/optical-audio-fill");
var _opticalAudioFillDefault = parcelHelpers.interopDefault(_opticalAudioFill);
var _opticalAudio = require("./icons/optical-audio");
var _opticalAudioDefault = parcelHelpers.interopDefault(_opticalAudio);
var _option = require("./icons/option");
var _optionDefault = parcelHelpers.interopDefault(_option);
var _outlet = require("./icons/outlet");
var _outletDefault = parcelHelpers.interopDefault(_outlet);
var _pCircleFill = require("./icons/p-circle-fill");
var _pCircleFillDefault = parcelHelpers.interopDefault(_pCircleFill);
var _pCircle = require("./icons/p-circle");
var _pCircleDefault = parcelHelpers.interopDefault(_pCircle);
var _pSquareFill = require("./icons/p-square-fill");
var _pSquareFillDefault = parcelHelpers.interopDefault(_pSquareFill);
var _pSquare = require("./icons/p-square");
var _pSquareDefault = parcelHelpers.interopDefault(_pSquare);
var _paintBucket = require("./icons/paint-bucket");
var _paintBucketDefault = parcelHelpers.interopDefault(_paintBucket);
var _paletteFill = require("./icons/palette-fill");
var _paletteFillDefault = parcelHelpers.interopDefault(_paletteFill);
var _palette = require("./icons/palette");
var _paletteDefault = parcelHelpers.interopDefault(_palette);
var _palette2 = require("./icons/palette2");
var _palette2Default = parcelHelpers.interopDefault(_palette2);
var _paperclip = require("./icons/paperclip");
var _paperclipDefault = parcelHelpers.interopDefault(_paperclip);
var _paragraph = require("./icons/paragraph");
var _paragraphDefault = parcelHelpers.interopDefault(_paragraph);
var _passFill = require("./icons/pass-fill");
var _passFillDefault = parcelHelpers.interopDefault(_passFill);
var _pass = require("./icons/pass");
var _passDefault = parcelHelpers.interopDefault(_pass);
var _passportFill = require("./icons/passport-fill");
var _passportFillDefault = parcelHelpers.interopDefault(_passportFill);
var _passport = require("./icons/passport");
var _passportDefault = parcelHelpers.interopDefault(_passport);
var _patchCheckFill = require("./icons/patch-check-fill");
var _patchCheckFillDefault = parcelHelpers.interopDefault(_patchCheckFill);
var _patchCheck = require("./icons/patch-check");
var _patchCheckDefault = parcelHelpers.interopDefault(_patchCheck);
var _patchExclamationFill = require("./icons/patch-exclamation-fill");
var _patchExclamationFillDefault = parcelHelpers.interopDefault(_patchExclamationFill);
var _patchExclamation = require("./icons/patch-exclamation");
var _patchExclamationDefault = parcelHelpers.interopDefault(_patchExclamation);
var _patchMinusFill = require("./icons/patch-minus-fill");
var _patchMinusFillDefault = parcelHelpers.interopDefault(_patchMinusFill);
var _patchMinus = require("./icons/patch-minus");
var _patchMinusDefault = parcelHelpers.interopDefault(_patchMinus);
var _patchPlusFill = require("./icons/patch-plus-fill");
var _patchPlusFillDefault = parcelHelpers.interopDefault(_patchPlusFill);
var _patchPlus = require("./icons/patch-plus");
var _patchPlusDefault = parcelHelpers.interopDefault(_patchPlus);
var _patchQuestionFill = require("./icons/patch-question-fill");
var _patchQuestionFillDefault = parcelHelpers.interopDefault(_patchQuestionFill);
var _patchQuestion = require("./icons/patch-question");
var _patchQuestionDefault = parcelHelpers.interopDefault(_patchQuestion);
var _pauseBtnFill = require("./icons/pause-btn-fill");
var _pauseBtnFillDefault = parcelHelpers.interopDefault(_pauseBtnFill);
var _pauseBtn = require("./icons/pause-btn");
var _pauseBtnDefault = parcelHelpers.interopDefault(_pauseBtn);
var _pauseCircleFill = require("./icons/pause-circle-fill");
var _pauseCircleFillDefault = parcelHelpers.interopDefault(_pauseCircleFill);
var _pauseCircle = require("./icons/pause-circle");
var _pauseCircleDefault = parcelHelpers.interopDefault(_pauseCircle);
var _pauseFill = require("./icons/pause-fill");
var _pauseFillDefault = parcelHelpers.interopDefault(_pauseFill);
var _pause = require("./icons/pause");
var _pauseDefault = parcelHelpers.interopDefault(_pause);
var _paypal = require("./icons/paypal");
var _paypalDefault = parcelHelpers.interopDefault(_paypal);
var _pcDisplayHorizontal = require("./icons/pc-display-horizontal");
var _pcDisplayHorizontalDefault = parcelHelpers.interopDefault(_pcDisplayHorizontal);
var _pcDisplay = require("./icons/pc-display");
var _pcDisplayDefault = parcelHelpers.interopDefault(_pcDisplay);
var _pcHorizontal = require("./icons/pc-horizontal");
var _pcHorizontalDefault = parcelHelpers.interopDefault(_pcHorizontal);
var _pc = require("./icons/pc");
var _pcDefault = parcelHelpers.interopDefault(_pc);
var _pciCardNetwork = require("./icons/pci-card-network");
var _pciCardNetworkDefault = parcelHelpers.interopDefault(_pciCardNetwork);
var _pciCardSound = require("./icons/pci-card-sound");
var _pciCardSoundDefault = parcelHelpers.interopDefault(_pciCardSound);
var _pciCard = require("./icons/pci-card");
var _pciCardDefault = parcelHelpers.interopDefault(_pciCard);
var _peaceFill = require("./icons/peace-fill");
var _peaceFillDefault = parcelHelpers.interopDefault(_peaceFill);
var _peace = require("./icons/peace");
var _peaceDefault = parcelHelpers.interopDefault(_peace);
var _penFill = require("./icons/pen-fill");
var _penFillDefault = parcelHelpers.interopDefault(_penFill);
var _pen = require("./icons/pen");
var _penDefault = parcelHelpers.interopDefault(_pen);
var _pencilFill = require("./icons/pencil-fill");
var _pencilFillDefault = parcelHelpers.interopDefault(_pencilFill);
var _pencilSquare = require("./icons/pencil-square");
var _pencilSquareDefault = parcelHelpers.interopDefault(_pencilSquare);
var _pencil = require("./icons/pencil");
var _pencilDefault = parcelHelpers.interopDefault(_pencil);
var _pentagonFill = require("./icons/pentagon-fill");
var _pentagonFillDefault = parcelHelpers.interopDefault(_pentagonFill);
var _pentagonHalf = require("./icons/pentagon-half");
var _pentagonHalfDefault = parcelHelpers.interopDefault(_pentagonHalf);
var _pentagon = require("./icons/pentagon");
var _pentagonDefault = parcelHelpers.interopDefault(_pentagon);
var _peopleFill = require("./icons/people-fill");
var _peopleFillDefault = parcelHelpers.interopDefault(_peopleFill);
var _people = require("./icons/people");
var _peopleDefault = parcelHelpers.interopDefault(_people);
var _percent = require("./icons/percent");
var _percentDefault = parcelHelpers.interopDefault(_percent);
var _personAdd = require("./icons/person-add");
var _personAddDefault = parcelHelpers.interopDefault(_personAdd);
var _personArmsUp = require("./icons/person-arms-up");
var _personArmsUpDefault = parcelHelpers.interopDefault(_personArmsUp);
var _personBadgeFill = require("./icons/person-badge-fill");
var _personBadgeFillDefault = parcelHelpers.interopDefault(_personBadgeFill);
var _personBadge = require("./icons/person-badge");
var _personBadgeDefault = parcelHelpers.interopDefault(_personBadge);
var _personBoundingBox = require("./icons/person-bounding-box");
var _personBoundingBoxDefault = parcelHelpers.interopDefault(_personBoundingBox);
var _personCheckFill = require("./icons/person-check-fill");
var _personCheckFillDefault = parcelHelpers.interopDefault(_personCheckFill);
var _personCheck = require("./icons/person-check");
var _personCheckDefault = parcelHelpers.interopDefault(_personCheck);
var _personCircle = require("./icons/person-circle");
var _personCircleDefault = parcelHelpers.interopDefault(_personCircle);
var _personDashFill = require("./icons/person-dash-fill");
var _personDashFillDefault = parcelHelpers.interopDefault(_personDashFill);
var _personDash = require("./icons/person-dash");
var _personDashDefault = parcelHelpers.interopDefault(_personDash);
var _personDown = require("./icons/person-down");
var _personDownDefault = parcelHelpers.interopDefault(_personDown);
var _personExclamation = require("./icons/person-exclamation");
var _personExclamationDefault = parcelHelpers.interopDefault(_personExclamation);
var _personFillAdd = require("./icons/person-fill-add");
var _personFillAddDefault = parcelHelpers.interopDefault(_personFillAdd);
var _personFillCheck = require("./icons/person-fill-check");
var _personFillCheckDefault = parcelHelpers.interopDefault(_personFillCheck);
var _personFillDash = require("./icons/person-fill-dash");
var _personFillDashDefault = parcelHelpers.interopDefault(_personFillDash);
var _personFillDown = require("./icons/person-fill-down");
var _personFillDownDefault = parcelHelpers.interopDefault(_personFillDown);
var _personFillExclamation = require("./icons/person-fill-exclamation");
var _personFillExclamationDefault = parcelHelpers.interopDefault(_personFillExclamation);
var _personFillGear = require("./icons/person-fill-gear");
var _personFillGearDefault = parcelHelpers.interopDefault(_personFillGear);
var _personFillLock = require("./icons/person-fill-lock");
var _personFillLockDefault = parcelHelpers.interopDefault(_personFillLock);
var _personFillSlash = require("./icons/person-fill-slash");
var _personFillSlashDefault = parcelHelpers.interopDefault(_personFillSlash);
var _personFillUp = require("./icons/person-fill-up");
var _personFillUpDefault = parcelHelpers.interopDefault(_personFillUp);
var _personFillX = require("./icons/person-fill-x");
var _personFillXDefault = parcelHelpers.interopDefault(_personFillX);
var _personFill = require("./icons/person-fill");
var _personFillDefault = parcelHelpers.interopDefault(_personFill);
var _personGear = require("./icons/person-gear");
var _personGearDefault = parcelHelpers.interopDefault(_personGear);
var _personHeart = require("./icons/person-heart");
var _personHeartDefault = parcelHelpers.interopDefault(_personHeart);
var _personHearts = require("./icons/person-hearts");
var _personHeartsDefault = parcelHelpers.interopDefault(_personHearts);
var _personLinesFill = require("./icons/person-lines-fill");
var _personLinesFillDefault = parcelHelpers.interopDefault(_personLinesFill);
var _personLock = require("./icons/person-lock");
var _personLockDefault = parcelHelpers.interopDefault(_personLock);
var _personPlusFill = require("./icons/person-plus-fill");
var _personPlusFillDefault = parcelHelpers.interopDefault(_personPlusFill);
var _personPlus = require("./icons/person-plus");
var _personPlusDefault = parcelHelpers.interopDefault(_personPlus);
var _personRaisedHand = require("./icons/person-raised-hand");
var _personRaisedHandDefault = parcelHelpers.interopDefault(_personRaisedHand);
var _personRolodex = require("./icons/person-rolodex");
var _personRolodexDefault = parcelHelpers.interopDefault(_personRolodex);
var _personSlash = require("./icons/person-slash");
var _personSlashDefault = parcelHelpers.interopDefault(_personSlash);
var _personSquare = require("./icons/person-square");
var _personSquareDefault = parcelHelpers.interopDefault(_personSquare);
var _personStandingDress = require("./icons/person-standing-dress");
var _personStandingDressDefault = parcelHelpers.interopDefault(_personStandingDress);
var _personStanding = require("./icons/person-standing");
var _personStandingDefault = parcelHelpers.interopDefault(_personStanding);
var _personUp = require("./icons/person-up");
var _personUpDefault = parcelHelpers.interopDefault(_personUp);
var _personVcardFill = require("./icons/person-vcard-fill");
var _personVcardFillDefault = parcelHelpers.interopDefault(_personVcardFill);
var _personVcard = require("./icons/person-vcard");
var _personVcardDefault = parcelHelpers.interopDefault(_personVcard);
var _personVideo = require("./icons/person-video");
var _personVideoDefault = parcelHelpers.interopDefault(_personVideo);
var _personVideo2 = require("./icons/person-video2");
var _personVideo2Default = parcelHelpers.interopDefault(_personVideo2);
var _personVideo3 = require("./icons/person-video3");
var _personVideo3Default = parcelHelpers.interopDefault(_personVideo3);
var _personWalking = require("./icons/person-walking");
var _personWalkingDefault = parcelHelpers.interopDefault(_personWalking);
var _personWheelchair = require("./icons/person-wheelchair");
var _personWheelchairDefault = parcelHelpers.interopDefault(_personWheelchair);
var _personWorkspace = require("./icons/person-workspace");
var _personWorkspaceDefault = parcelHelpers.interopDefault(_personWorkspace);
var _personXFill = require("./icons/person-x-fill");
var _personXFillDefault = parcelHelpers.interopDefault(_personXFill);
var _personX = require("./icons/person-x");
var _personXDefault = parcelHelpers.interopDefault(_personX);
var _person = require("./icons/person");
var _personDefault = parcelHelpers.interopDefault(_person);
var _phoneFill = require("./icons/phone-fill");
var _phoneFillDefault = parcelHelpers.interopDefault(_phoneFill);
var _phoneFlip = require("./icons/phone-flip");
var _phoneFlipDefault = parcelHelpers.interopDefault(_phoneFlip);
var _phoneLandscapeFill = require("./icons/phone-landscape-fill");
var _phoneLandscapeFillDefault = parcelHelpers.interopDefault(_phoneLandscapeFill);
var _phoneLandscape = require("./icons/phone-landscape");
var _phoneLandscapeDefault = parcelHelpers.interopDefault(_phoneLandscape);
var _phoneVibrateFill = require("./icons/phone-vibrate-fill");
var _phoneVibrateFillDefault = parcelHelpers.interopDefault(_phoneVibrateFill);
var _phoneVibrate = require("./icons/phone-vibrate");
var _phoneVibrateDefault = parcelHelpers.interopDefault(_phoneVibrate);
var _phone = require("./icons/phone");
var _phoneDefault = parcelHelpers.interopDefault(_phone);
var _pieChartFill = require("./icons/pie-chart-fill");
var _pieChartFillDefault = parcelHelpers.interopDefault(_pieChartFill);
var _pieChart = require("./icons/pie-chart");
var _pieChartDefault = parcelHelpers.interopDefault(_pieChart);
var _piggyBankFill = require("./icons/piggy-bank-fill");
var _piggyBankFillDefault = parcelHelpers.interopDefault(_piggyBankFill);
var _piggyBank = require("./icons/piggy-bank");
var _piggyBankDefault = parcelHelpers.interopDefault(_piggyBank);
var _pinAngleFill = require("./icons/pin-angle-fill");
var _pinAngleFillDefault = parcelHelpers.interopDefault(_pinAngleFill);
var _pinAngle = require("./icons/pin-angle");
var _pinAngleDefault = parcelHelpers.interopDefault(_pinAngle);
var _pinFill = require("./icons/pin-fill");
var _pinFillDefault = parcelHelpers.interopDefault(_pinFill);
var _pinMapFill = require("./icons/pin-map-fill");
var _pinMapFillDefault = parcelHelpers.interopDefault(_pinMapFill);
var _pinMap = require("./icons/pin-map");
var _pinMapDefault = parcelHelpers.interopDefault(_pinMap);
var _pin = require("./icons/pin");
var _pinDefault = parcelHelpers.interopDefault(_pin);
var _pinterest = require("./icons/pinterest");
var _pinterestDefault = parcelHelpers.interopDefault(_pinterest);
var _pipFill = require("./icons/pip-fill");
var _pipFillDefault = parcelHelpers.interopDefault(_pipFill);
var _pip = require("./icons/pip");
var _pipDefault = parcelHelpers.interopDefault(_pip);
var _playBtnFill = require("./icons/play-btn-fill");
var _playBtnFillDefault = parcelHelpers.interopDefault(_playBtnFill);
var _playBtn = require("./icons/play-btn");
var _playBtnDefault = parcelHelpers.interopDefault(_playBtn);
var _playCircleFill = require("./icons/play-circle-fill");
var _playCircleFillDefault = parcelHelpers.interopDefault(_playCircleFill);
var _playCircle = require("./icons/play-circle");
var _playCircleDefault = parcelHelpers.interopDefault(_playCircle);
var _playFill = require("./icons/play-fill");
var _playFillDefault = parcelHelpers.interopDefault(_playFill);
var _play = require("./icons/play");
var _playDefault = parcelHelpers.interopDefault(_play);
var _playstation = require("./icons/playstation");
var _playstationDefault = parcelHelpers.interopDefault(_playstation);
var _plugFill = require("./icons/plug-fill");
var _plugFillDefault = parcelHelpers.interopDefault(_plugFill);
var _plug = require("./icons/plug");
var _plugDefault = parcelHelpers.interopDefault(_plug);
var _plugin = require("./icons/plugin");
var _pluginDefault = parcelHelpers.interopDefault(_plugin);
var _plusCircleDotted = require("./icons/plus-circle-dotted");
var _plusCircleDottedDefault = parcelHelpers.interopDefault(_plusCircleDotted);
var _plusCircleFill = require("./icons/plus-circle-fill");
var _plusCircleFillDefault = parcelHelpers.interopDefault(_plusCircleFill);
var _plusCircle = require("./icons/plus-circle");
var _plusCircleDefault = parcelHelpers.interopDefault(_plusCircle);
var _plusLg = require("./icons/plus-lg");
var _plusLgDefault = parcelHelpers.interopDefault(_plusLg);
var _plusSlashMinus = require("./icons/plus-slash-minus");
var _plusSlashMinusDefault = parcelHelpers.interopDefault(_plusSlashMinus);
var _plusSquareDotted = require("./icons/plus-square-dotted");
var _plusSquareDottedDefault = parcelHelpers.interopDefault(_plusSquareDotted);
var _plusSquareFill = require("./icons/plus-square-fill");
var _plusSquareFillDefault = parcelHelpers.interopDefault(_plusSquareFill);
var _plusSquare = require("./icons/plus-square");
var _plusSquareDefault = parcelHelpers.interopDefault(_plusSquare);
var _plus = require("./icons/plus");
var _plusDefault = parcelHelpers.interopDefault(_plus);
var _postageFill = require("./icons/postage-fill");
var _postageFillDefault = parcelHelpers.interopDefault(_postageFill);
var _postageHeartFill = require("./icons/postage-heart-fill");
var _postageHeartFillDefault = parcelHelpers.interopDefault(_postageHeartFill);
var _postageHeart = require("./icons/postage-heart");
var _postageHeartDefault = parcelHelpers.interopDefault(_postageHeart);
var _postage = require("./icons/postage");
var _postageDefault = parcelHelpers.interopDefault(_postage);
var _postcardFill = require("./icons/postcard-fill");
var _postcardFillDefault = parcelHelpers.interopDefault(_postcardFill);
var _postcardHeartFill = require("./icons/postcard-heart-fill");
var _postcardHeartFillDefault = parcelHelpers.interopDefault(_postcardHeartFill);
var _postcardHeart = require("./icons/postcard-heart");
var _postcardHeartDefault = parcelHelpers.interopDefault(_postcardHeart);
var _postcard = require("./icons/postcard");
var _postcardDefault = parcelHelpers.interopDefault(_postcard);
var _power = require("./icons/power");
var _powerDefault = parcelHelpers.interopDefault(_power);
var _prescription = require("./icons/prescription");
var _prescriptionDefault = parcelHelpers.interopDefault(_prescription);
var _prescription2 = require("./icons/prescription2");
var _prescription2Default = parcelHelpers.interopDefault(_prescription2);
var _printerFill = require("./icons/printer-fill");
var _printerFillDefault = parcelHelpers.interopDefault(_printerFill);
var _printer = require("./icons/printer");
var _printerDefault = parcelHelpers.interopDefault(_printer);
var _projectorFill = require("./icons/projector-fill");
var _projectorFillDefault = parcelHelpers.interopDefault(_projectorFill);
var _projector = require("./icons/projector");
var _projectorDefault = parcelHelpers.interopDefault(_projector);
var _puzzleFill = require("./icons/puzzle-fill");
var _puzzleFillDefault = parcelHelpers.interopDefault(_puzzleFill);
var _puzzle = require("./icons/puzzle");
var _puzzleDefault = parcelHelpers.interopDefault(_puzzle);
var _qrCodeScan = require("./icons/qr-code-scan");
var _qrCodeScanDefault = parcelHelpers.interopDefault(_qrCodeScan);
var _qrCode = require("./icons/qr-code");
var _qrCodeDefault = parcelHelpers.interopDefault(_qrCode);
var _questionCircleFill = require("./icons/question-circle-fill");
var _questionCircleFillDefault = parcelHelpers.interopDefault(_questionCircleFill);
var _questionCircle = require("./icons/question-circle");
var _questionCircleDefault = parcelHelpers.interopDefault(_questionCircle);
var _questionDiamondFill = require("./icons/question-diamond-fill");
var _questionDiamondFillDefault = parcelHelpers.interopDefault(_questionDiamondFill);
var _questionDiamond = require("./icons/question-diamond");
var _questionDiamondDefault = parcelHelpers.interopDefault(_questionDiamond);
var _questionLg = require("./icons/question-lg");
var _questionLgDefault = parcelHelpers.interopDefault(_questionLg);
var _questionOctagonFill = require("./icons/question-octagon-fill");
var _questionOctagonFillDefault = parcelHelpers.interopDefault(_questionOctagonFill);
var _questionOctagon = require("./icons/question-octagon");
var _questionOctagonDefault = parcelHelpers.interopDefault(_questionOctagon);
var _questionSquareFill = require("./icons/question-square-fill");
var _questionSquareFillDefault = parcelHelpers.interopDefault(_questionSquareFill);
var _questionSquare = require("./icons/question-square");
var _questionSquareDefault = parcelHelpers.interopDefault(_questionSquare);
var _question = require("./icons/question");
var _questionDefault = parcelHelpers.interopDefault(_question);
var _quora = require("./icons/quora");
var _quoraDefault = parcelHelpers.interopDefault(_quora);
var _quote = require("./icons/quote");
var _quoteDefault = parcelHelpers.interopDefault(_quote);
var _rCircleFill = require("./icons/r-circle-fill");
var _rCircleFillDefault = parcelHelpers.interopDefault(_rCircleFill);
var _rCircle = require("./icons/r-circle");
var _rCircleDefault = parcelHelpers.interopDefault(_rCircle);
var _rSquareFill = require("./icons/r-square-fill");
var _rSquareFillDefault = parcelHelpers.interopDefault(_rSquareFill);
var _rSquare = require("./icons/r-square");
var _rSquareDefault = parcelHelpers.interopDefault(_rSquare);
var _radar = require("./icons/radar");
var _radarDefault = parcelHelpers.interopDefault(_radar);
var _radioactive = require("./icons/radioactive");
var _radioactiveDefault = parcelHelpers.interopDefault(_radioactive);
var _rainbow = require("./icons/rainbow");
var _rainbowDefault = parcelHelpers.interopDefault(_rainbow);
var _receiptCutoff = require("./icons/receipt-cutoff");
var _receiptCutoffDefault = parcelHelpers.interopDefault(_receiptCutoff);
var _receipt = require("./icons/receipt");
var _receiptDefault = parcelHelpers.interopDefault(_receipt);
var _reception0 = require("./icons/reception-0");
var _reception0Default = parcelHelpers.interopDefault(_reception0);
var _reception1 = require("./icons/reception-1");
var _reception1Default = parcelHelpers.interopDefault(_reception1);
var _reception2 = require("./icons/reception-2");
var _reception2Default = parcelHelpers.interopDefault(_reception2);
var _reception3 = require("./icons/reception-3");
var _reception3Default = parcelHelpers.interopDefault(_reception3);
var _reception4 = require("./icons/reception-4");
var _reception4Default = parcelHelpers.interopDefault(_reception4);
var _recordBtnFill = require("./icons/record-btn-fill");
var _recordBtnFillDefault = parcelHelpers.interopDefault(_recordBtnFill);
var _recordBtn = require("./icons/record-btn");
var _recordBtnDefault = parcelHelpers.interopDefault(_recordBtn);
var _recordCircleFill = require("./icons/record-circle-fill");
var _recordCircleFillDefault = parcelHelpers.interopDefault(_recordCircleFill);
var _recordCircle = require("./icons/record-circle");
var _recordCircleDefault = parcelHelpers.interopDefault(_recordCircle);
var _recordFill = require("./icons/record-fill");
var _recordFillDefault = parcelHelpers.interopDefault(_recordFill);
var _record = require("./icons/record");
var _recordDefault = parcelHelpers.interopDefault(_record);
var _record2Fill = require("./icons/record2-fill");
var _record2FillDefault = parcelHelpers.interopDefault(_record2Fill);
var _record2 = require("./icons/record2");
var _record2Default = parcelHelpers.interopDefault(_record2);
var _recycle = require("./icons/recycle");
var _recycleDefault = parcelHelpers.interopDefault(_recycle);
var _reddit = require("./icons/reddit");
var _redditDefault = parcelHelpers.interopDefault(_reddit);
var _regex = require("./icons/regex");
var _regexDefault = parcelHelpers.interopDefault(_regex);
var _repeat1 = require("./icons/repeat-1");
var _repeat1Default = parcelHelpers.interopDefault(_repeat1);
var _repeat = require("./icons/repeat");
var _repeatDefault = parcelHelpers.interopDefault(_repeat);
var _replyAllFill = require("./icons/reply-all-fill");
var _replyAllFillDefault = parcelHelpers.interopDefault(_replyAllFill);
var _replyAll = require("./icons/reply-all");
var _replyAllDefault = parcelHelpers.interopDefault(_replyAll);
var _replyFill = require("./icons/reply-fill");
var _replyFillDefault = parcelHelpers.interopDefault(_replyFill);
var _reply = require("./icons/reply");
var _replyDefault = parcelHelpers.interopDefault(_reply);
var _rewindBtnFill = require("./icons/rewind-btn-fill");
var _rewindBtnFillDefault = parcelHelpers.interopDefault(_rewindBtnFill);
var _rewindBtn = require("./icons/rewind-btn");
var _rewindBtnDefault = parcelHelpers.interopDefault(_rewindBtn);
var _rewindCircleFill = require("./icons/rewind-circle-fill");
var _rewindCircleFillDefault = parcelHelpers.interopDefault(_rewindCircleFill);
var _rewindCircle = require("./icons/rewind-circle");
var _rewindCircleDefault = parcelHelpers.interopDefault(_rewindCircle);
var _rewindFill = require("./icons/rewind-fill");
var _rewindFillDefault = parcelHelpers.interopDefault(_rewindFill);
var _rewind = require("./icons/rewind");
var _rewindDefault = parcelHelpers.interopDefault(_rewind);
var _robot = require("./icons/robot");
var _robotDefault = parcelHelpers.interopDefault(_robot);
var _rocketFill = require("./icons/rocket-fill");
var _rocketFillDefault = parcelHelpers.interopDefault(_rocketFill);
var _rocketTakeoffFill = require("./icons/rocket-takeoff-fill");
var _rocketTakeoffFillDefault = parcelHelpers.interopDefault(_rocketTakeoffFill);
var _rocketTakeoff = require("./icons/rocket-takeoff");
var _rocketTakeoffDefault = parcelHelpers.interopDefault(_rocketTakeoff);
var _rocket = require("./icons/rocket");
var _rocketDefault = parcelHelpers.interopDefault(_rocket);
var _routerFill = require("./icons/router-fill");
var _routerFillDefault = parcelHelpers.interopDefault(_routerFill);
var _router = require("./icons/router");
var _routerDefault = parcelHelpers.interopDefault(_router);
var _rssFill = require("./icons/rss-fill");
var _rssFillDefault = parcelHelpers.interopDefault(_rssFill);
var _rss = require("./icons/rss");
var _rssDefault = parcelHelpers.interopDefault(_rss);
var _rulers = require("./icons/rulers");
var _rulersDefault = parcelHelpers.interopDefault(_rulers);
var _safeFill = require("./icons/safe-fill");
var _safeFillDefault = parcelHelpers.interopDefault(_safeFill);
var _safe = require("./icons/safe");
var _safeDefault = parcelHelpers.interopDefault(_safe);
var _safe2Fill = require("./icons/safe2-fill");
var _safe2FillDefault = parcelHelpers.interopDefault(_safe2Fill);
var _safe2 = require("./icons/safe2");
var _safe2Default = parcelHelpers.interopDefault(_safe2);
var _saveFill = require("./icons/save-fill");
var _saveFillDefault = parcelHelpers.interopDefault(_saveFill);
var _save = require("./icons/save");
var _saveDefault = parcelHelpers.interopDefault(_save);
var _save2Fill = require("./icons/save2-fill");
var _save2FillDefault = parcelHelpers.interopDefault(_save2Fill);
var _save2 = require("./icons/save2");
var _save2Default = parcelHelpers.interopDefault(_save2);
var _scissors = require("./icons/scissors");
var _scissorsDefault = parcelHelpers.interopDefault(_scissors);
var _scooter = require("./icons/scooter");
var _scooterDefault = parcelHelpers.interopDefault(_scooter);
var _screwdriver = require("./icons/screwdriver");
var _screwdriverDefault = parcelHelpers.interopDefault(_screwdriver);
var _sdCardFill = require("./icons/sd-card-fill");
var _sdCardFillDefault = parcelHelpers.interopDefault(_sdCardFill);
var _sdCard = require("./icons/sd-card");
var _sdCardDefault = parcelHelpers.interopDefault(_sdCard);
var _searchHeartFill = require("./icons/search-heart-fill");
var _searchHeartFillDefault = parcelHelpers.interopDefault(_searchHeartFill);
var _searchHeart = require("./icons/search-heart");
var _searchHeartDefault = parcelHelpers.interopDefault(_searchHeart);
var _search = require("./icons/search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _segmentedNav = require("./icons/segmented-nav");
var _segmentedNavDefault = parcelHelpers.interopDefault(_segmentedNav);
var _sendArrowDownFill = require("./icons/send-arrow-down-fill");
var _sendArrowDownFillDefault = parcelHelpers.interopDefault(_sendArrowDownFill);
var _sendArrowDown = require("./icons/send-arrow-down");
var _sendArrowDownDefault = parcelHelpers.interopDefault(_sendArrowDown);
var _sendArrowUpFill = require("./icons/send-arrow-up-fill");
var _sendArrowUpFillDefault = parcelHelpers.interopDefault(_sendArrowUpFill);
var _sendArrowUp = require("./icons/send-arrow-up");
var _sendArrowUpDefault = parcelHelpers.interopDefault(_sendArrowUp);
var _sendCheckFill = require("./icons/send-check-fill");
var _sendCheckFillDefault = parcelHelpers.interopDefault(_sendCheckFill);
var _sendCheck = require("./icons/send-check");
var _sendCheckDefault = parcelHelpers.interopDefault(_sendCheck);
var _sendDashFill = require("./icons/send-dash-fill");
var _sendDashFillDefault = parcelHelpers.interopDefault(_sendDashFill);
var _sendDash = require("./icons/send-dash");
var _sendDashDefault = parcelHelpers.interopDefault(_sendDash);
var _sendExclamationFill = require("./icons/send-exclamation-fill");
var _sendExclamationFillDefault = parcelHelpers.interopDefault(_sendExclamationFill);
var _sendExclamation = require("./icons/send-exclamation");
var _sendExclamationDefault = parcelHelpers.interopDefault(_sendExclamation);
var _sendFill = require("./icons/send-fill");
var _sendFillDefault = parcelHelpers.interopDefault(_sendFill);
var _sendPlusFill = require("./icons/send-plus-fill");
var _sendPlusFillDefault = parcelHelpers.interopDefault(_sendPlusFill);
var _sendPlus = require("./icons/send-plus");
var _sendPlusDefault = parcelHelpers.interopDefault(_sendPlus);
var _sendSlashFill = require("./icons/send-slash-fill");
var _sendSlashFillDefault = parcelHelpers.interopDefault(_sendSlashFill);
var _sendSlash = require("./icons/send-slash");
var _sendSlashDefault = parcelHelpers.interopDefault(_sendSlash);
var _sendXFill = require("./icons/send-x-fill");
var _sendXFillDefault = parcelHelpers.interopDefault(_sendXFill);
var _sendX = require("./icons/send-x");
var _sendXDefault = parcelHelpers.interopDefault(_sendX);
var _send = require("./icons/send");
var _sendDefault = parcelHelpers.interopDefault(_send);
var _server = require("./icons/server");
var _serverDefault = parcelHelpers.interopDefault(_server);
var _shadows = require("./icons/shadows");
var _shadowsDefault = parcelHelpers.interopDefault(_shadows);
var _shareFill = require("./icons/share-fill");
var _shareFillDefault = parcelHelpers.interopDefault(_shareFill);
var _share = require("./icons/share");
var _shareDefault = parcelHelpers.interopDefault(_share);
var _shieldCheck = require("./icons/shield-check");
var _shieldCheckDefault = parcelHelpers.interopDefault(_shieldCheck);
var _shieldExclamation = require("./icons/shield-exclamation");
var _shieldExclamationDefault = parcelHelpers.interopDefault(_shieldExclamation);
var _shieldFillCheck = require("./icons/shield-fill-check");
var _shieldFillCheckDefault = parcelHelpers.interopDefault(_shieldFillCheck);
var _shieldFillExclamation = require("./icons/shield-fill-exclamation");
var _shieldFillExclamationDefault = parcelHelpers.interopDefault(_shieldFillExclamation);
var _shieldFillMinus = require("./icons/shield-fill-minus");
var _shieldFillMinusDefault = parcelHelpers.interopDefault(_shieldFillMinus);
var _shieldFillPlus = require("./icons/shield-fill-plus");
var _shieldFillPlusDefault = parcelHelpers.interopDefault(_shieldFillPlus);
var _shieldFillX = require("./icons/shield-fill-x");
var _shieldFillXDefault = parcelHelpers.interopDefault(_shieldFillX);
var _shieldFill = require("./icons/shield-fill");
var _shieldFillDefault = parcelHelpers.interopDefault(_shieldFill);
var _shieldLockFill = require("./icons/shield-lock-fill");
var _shieldLockFillDefault = parcelHelpers.interopDefault(_shieldLockFill);
var _shieldLock = require("./icons/shield-lock");
var _shieldLockDefault = parcelHelpers.interopDefault(_shieldLock);
var _shieldMinus = require("./icons/shield-minus");
var _shieldMinusDefault = parcelHelpers.interopDefault(_shieldMinus);
var _shieldPlus = require("./icons/shield-plus");
var _shieldPlusDefault = parcelHelpers.interopDefault(_shieldPlus);
var _shieldShaded = require("./icons/shield-shaded");
var _shieldShadedDefault = parcelHelpers.interopDefault(_shieldShaded);
var _shieldSlashFill = require("./icons/shield-slash-fill");
var _shieldSlashFillDefault = parcelHelpers.interopDefault(_shieldSlashFill);
var _shieldSlash = require("./icons/shield-slash");
var _shieldSlashDefault = parcelHelpers.interopDefault(_shieldSlash);
var _shieldX = require("./icons/shield-x");
var _shieldXDefault = parcelHelpers.interopDefault(_shieldX);
var _shield = require("./icons/shield");
var _shieldDefault = parcelHelpers.interopDefault(_shield);
var _shiftFill = require("./icons/shift-fill");
var _shiftFillDefault = parcelHelpers.interopDefault(_shiftFill);
var _shift = require("./icons/shift");
var _shiftDefault = parcelHelpers.interopDefault(_shift);
var _shopWindow = require("./icons/shop-window");
var _shopWindowDefault = parcelHelpers.interopDefault(_shopWindow);
var _shop = require("./icons/shop");
var _shopDefault = parcelHelpers.interopDefault(_shop);
var _shuffle = require("./icons/shuffle");
var _shuffleDefault = parcelHelpers.interopDefault(_shuffle);
var _signDeadEndFill = require("./icons/sign-dead-end-fill");
var _signDeadEndFillDefault = parcelHelpers.interopDefault(_signDeadEndFill);
var _signDeadEnd = require("./icons/sign-dead-end");
var _signDeadEndDefault = parcelHelpers.interopDefault(_signDeadEnd);
var _signDoNotEnterFill = require("./icons/sign-do-not-enter-fill");
var _signDoNotEnterFillDefault = parcelHelpers.interopDefault(_signDoNotEnterFill);
var _signDoNotEnter = require("./icons/sign-do-not-enter");
var _signDoNotEnterDefault = parcelHelpers.interopDefault(_signDoNotEnter);
var _signIntersectionFill = require("./icons/sign-intersection-fill");
var _signIntersectionFillDefault = parcelHelpers.interopDefault(_signIntersectionFill);
var _signIntersectionSideFill = require("./icons/sign-intersection-side-fill");
var _signIntersectionSideFillDefault = parcelHelpers.interopDefault(_signIntersectionSideFill);
var _signIntersectionSide = require("./icons/sign-intersection-side");
var _signIntersectionSideDefault = parcelHelpers.interopDefault(_signIntersectionSide);
var _signIntersectionTFill = require("./icons/sign-intersection-t-fill");
var _signIntersectionTFillDefault = parcelHelpers.interopDefault(_signIntersectionTFill);
var _signIntersectionT = require("./icons/sign-intersection-t");
var _signIntersectionTDefault = parcelHelpers.interopDefault(_signIntersectionT);
var _signIntersectionYFill = require("./icons/sign-intersection-y-fill");
var _signIntersectionYFillDefault = parcelHelpers.interopDefault(_signIntersectionYFill);
var _signIntersectionY = require("./icons/sign-intersection-y");
var _signIntersectionYDefault = parcelHelpers.interopDefault(_signIntersectionY);
var _signIntersection = require("./icons/sign-intersection");
var _signIntersectionDefault = parcelHelpers.interopDefault(_signIntersection);
var _signMergeLeftFill = require("./icons/sign-merge-left-fill");
var _signMergeLeftFillDefault = parcelHelpers.interopDefault(_signMergeLeftFill);
var _signMergeLeft = require("./icons/sign-merge-left");
var _signMergeLeftDefault = parcelHelpers.interopDefault(_signMergeLeft);
var _signMergeRightFill = require("./icons/sign-merge-right-fill");
var _signMergeRightFillDefault = parcelHelpers.interopDefault(_signMergeRightFill);
var _signMergeRight = require("./icons/sign-merge-right");
var _signMergeRightDefault = parcelHelpers.interopDefault(_signMergeRight);
var _signNoLeftTurnFill = require("./icons/sign-no-left-turn-fill");
var _signNoLeftTurnFillDefault = parcelHelpers.interopDefault(_signNoLeftTurnFill);
var _signNoLeftTurn = require("./icons/sign-no-left-turn");
var _signNoLeftTurnDefault = parcelHelpers.interopDefault(_signNoLeftTurn);
var _signNoParkingFill = require("./icons/sign-no-parking-fill");
var _signNoParkingFillDefault = parcelHelpers.interopDefault(_signNoParkingFill);
var _signNoParking = require("./icons/sign-no-parking");
var _signNoParkingDefault = parcelHelpers.interopDefault(_signNoParking);
var _signNoRightTurnFill = require("./icons/sign-no-right-turn-fill");
var _signNoRightTurnFillDefault = parcelHelpers.interopDefault(_signNoRightTurnFill);
var _signNoRightTurn = require("./icons/sign-no-right-turn");
var _signNoRightTurnDefault = parcelHelpers.interopDefault(_signNoRightTurn);
var _signRailroadFill = require("./icons/sign-railroad-fill");
var _signRailroadFillDefault = parcelHelpers.interopDefault(_signRailroadFill);
var _signRailroad = require("./icons/sign-railroad");
var _signRailroadDefault = parcelHelpers.interopDefault(_signRailroad);
var _signStopFill = require("./icons/sign-stop-fill");
var _signStopFillDefault = parcelHelpers.interopDefault(_signStopFill);
var _signStopLightsFill = require("./icons/sign-stop-lights-fill");
var _signStopLightsFillDefault = parcelHelpers.interopDefault(_signStopLightsFill);
var _signStopLights = require("./icons/sign-stop-lights");
var _signStopLightsDefault = parcelHelpers.interopDefault(_signStopLights);
var _signStop = require("./icons/sign-stop");
var _signStopDefault = parcelHelpers.interopDefault(_signStop);
var _signTurnLeftFill = require("./icons/sign-turn-left-fill");
var _signTurnLeftFillDefault = parcelHelpers.interopDefault(_signTurnLeftFill);
var _signTurnLeft = require("./icons/sign-turn-left");
var _signTurnLeftDefault = parcelHelpers.interopDefault(_signTurnLeft);
var _signTurnRightFill = require("./icons/sign-turn-right-fill");
var _signTurnRightFillDefault = parcelHelpers.interopDefault(_signTurnRightFill);
var _signTurnRight = require("./icons/sign-turn-right");
var _signTurnRightDefault = parcelHelpers.interopDefault(_signTurnRight);
var _signTurnSlightLeftFill = require("./icons/sign-turn-slight-left-fill");
var _signTurnSlightLeftFillDefault = parcelHelpers.interopDefault(_signTurnSlightLeftFill);
var _signTurnSlightLeft = require("./icons/sign-turn-slight-left");
var _signTurnSlightLeftDefault = parcelHelpers.interopDefault(_signTurnSlightLeft);
var _signTurnSlightRightFill = require("./icons/sign-turn-slight-right-fill");
var _signTurnSlightRightFillDefault = parcelHelpers.interopDefault(_signTurnSlightRightFill);
var _signTurnSlightRight = require("./icons/sign-turn-slight-right");
var _signTurnSlightRightDefault = parcelHelpers.interopDefault(_signTurnSlightRight);
var _signYieldFill = require("./icons/sign-yield-fill");
var _signYieldFillDefault = parcelHelpers.interopDefault(_signYieldFill);
var _signYield = require("./icons/sign-yield");
var _signYieldDefault = parcelHelpers.interopDefault(_signYield);
var _signal = require("./icons/signal");
var _signalDefault = parcelHelpers.interopDefault(_signal);
var _signpost2Fill = require("./icons/signpost-2-fill");
var _signpost2FillDefault = parcelHelpers.interopDefault(_signpost2Fill);
var _signpost2 = require("./icons/signpost-2");
var _signpost2Default = parcelHelpers.interopDefault(_signpost2);
var _signpostFill = require("./icons/signpost-fill");
var _signpostFillDefault = parcelHelpers.interopDefault(_signpostFill);
var _signpostSplitFill = require("./icons/signpost-split-fill");
var _signpostSplitFillDefault = parcelHelpers.interopDefault(_signpostSplitFill);
var _signpostSplit = require("./icons/signpost-split");
var _signpostSplitDefault = parcelHelpers.interopDefault(_signpostSplit);
var _signpost = require("./icons/signpost");
var _signpostDefault = parcelHelpers.interopDefault(_signpost);
var _simFill = require("./icons/sim-fill");
var _simFillDefault = parcelHelpers.interopDefault(_simFill);
var _simSlashFill = require("./icons/sim-slash-fill");
var _simSlashFillDefault = parcelHelpers.interopDefault(_simSlashFill);
var _simSlash = require("./icons/sim-slash");
var _simSlashDefault = parcelHelpers.interopDefault(_simSlash);
var _sim = require("./icons/sim");
var _simDefault = parcelHelpers.interopDefault(_sim);
var _sinaWeibo = require("./icons/sina-weibo");
var _sinaWeiboDefault = parcelHelpers.interopDefault(_sinaWeibo);
var _skipBackwardBtnFill = require("./icons/skip-backward-btn-fill");
var _skipBackwardBtnFillDefault = parcelHelpers.interopDefault(_skipBackwardBtnFill);
var _skipBackwardBtn = require("./icons/skip-backward-btn");
var _skipBackwardBtnDefault = parcelHelpers.interopDefault(_skipBackwardBtn);
var _skipBackwardCircleFill = require("./icons/skip-backward-circle-fill");
var _skipBackwardCircleFillDefault = parcelHelpers.interopDefault(_skipBackwardCircleFill);
var _skipBackwardCircle = require("./icons/skip-backward-circle");
var _skipBackwardCircleDefault = parcelHelpers.interopDefault(_skipBackwardCircle);
var _skipBackwardFill = require("./icons/skip-backward-fill");
var _skipBackwardFillDefault = parcelHelpers.interopDefault(_skipBackwardFill);
var _skipBackward = require("./icons/skip-backward");
var _skipBackwardDefault = parcelHelpers.interopDefault(_skipBackward);
var _skipEndBtnFill = require("./icons/skip-end-btn-fill");
var _skipEndBtnFillDefault = parcelHelpers.interopDefault(_skipEndBtnFill);
var _skipEndBtn = require("./icons/skip-end-btn");
var _skipEndBtnDefault = parcelHelpers.interopDefault(_skipEndBtn);
var _skipEndCircleFill = require("./icons/skip-end-circle-fill");
var _skipEndCircleFillDefault = parcelHelpers.interopDefault(_skipEndCircleFill);
var _skipEndCircle = require("./icons/skip-end-circle");
var _skipEndCircleDefault = parcelHelpers.interopDefault(_skipEndCircle);
var _skipEndFill = require("./icons/skip-end-fill");
var _skipEndFillDefault = parcelHelpers.interopDefault(_skipEndFill);
var _skipEnd = require("./icons/skip-end");
var _skipEndDefault = parcelHelpers.interopDefault(_skipEnd);
var _skipForwardBtnFill = require("./icons/skip-forward-btn-fill");
var _skipForwardBtnFillDefault = parcelHelpers.interopDefault(_skipForwardBtnFill);
var _skipForwardBtn = require("./icons/skip-forward-btn");
var _skipForwardBtnDefault = parcelHelpers.interopDefault(_skipForwardBtn);
var _skipForwardCircleFill = require("./icons/skip-forward-circle-fill");
var _skipForwardCircleFillDefault = parcelHelpers.interopDefault(_skipForwardCircleFill);
var _skipForwardCircle = require("./icons/skip-forward-circle");
var _skipForwardCircleDefault = parcelHelpers.interopDefault(_skipForwardCircle);
var _skipForwardFill = require("./icons/skip-forward-fill");
var _skipForwardFillDefault = parcelHelpers.interopDefault(_skipForwardFill);
var _skipForward = require("./icons/skip-forward");
var _skipForwardDefault = parcelHelpers.interopDefault(_skipForward);
var _skipStartBtnFill = require("./icons/skip-start-btn-fill");
var _skipStartBtnFillDefault = parcelHelpers.interopDefault(_skipStartBtnFill);
var _skipStartBtn = require("./icons/skip-start-btn");
var _skipStartBtnDefault = parcelHelpers.interopDefault(_skipStartBtn);
var _skipStartCircleFill = require("./icons/skip-start-circle-fill");
var _skipStartCircleFillDefault = parcelHelpers.interopDefault(_skipStartCircleFill);
var _skipStartCircle = require("./icons/skip-start-circle");
var _skipStartCircleDefault = parcelHelpers.interopDefault(_skipStartCircle);
var _skipStartFill = require("./icons/skip-start-fill");
var _skipStartFillDefault = parcelHelpers.interopDefault(_skipStartFill);
var _skipStart = require("./icons/skip-start");
var _skipStartDefault = parcelHelpers.interopDefault(_skipStart);
var _skype = require("./icons/skype");
var _skypeDefault = parcelHelpers.interopDefault(_skype);
var _slack = require("./icons/slack");
var _slackDefault = parcelHelpers.interopDefault(_slack);
var _slashCircleFill = require("./icons/slash-circle-fill");
var _slashCircleFillDefault = parcelHelpers.interopDefault(_slashCircleFill);
var _slashCircle = require("./icons/slash-circle");
var _slashCircleDefault = parcelHelpers.interopDefault(_slashCircle);
var _slashLg = require("./icons/slash-lg");
var _slashLgDefault = parcelHelpers.interopDefault(_slashLg);
var _slashSquareFill = require("./icons/slash-square-fill");
var _slashSquareFillDefault = parcelHelpers.interopDefault(_slashSquareFill);
var _slashSquare = require("./icons/slash-square");
var _slashSquareDefault = parcelHelpers.interopDefault(_slashSquare);
var _slash = require("./icons/slash");
var _slashDefault = parcelHelpers.interopDefault(_slash);
var _sliders = require("./icons/sliders");
var _slidersDefault = parcelHelpers.interopDefault(_sliders);
var _sliders2Vertical = require("./icons/sliders2-vertical");
var _sliders2VerticalDefault = parcelHelpers.interopDefault(_sliders2Vertical);
var _sliders2 = require("./icons/sliders2");
var _sliders2Default = parcelHelpers.interopDefault(_sliders2);
var _smartwatch = require("./icons/smartwatch");
var _smartwatchDefault = parcelHelpers.interopDefault(_smartwatch);
var _snapchat = require("./icons/snapchat");
var _snapchatDefault = parcelHelpers.interopDefault(_snapchat);
var _snow = require("./icons/snow");
var _snowDefault = parcelHelpers.interopDefault(_snow);
var _snow2 = require("./icons/snow2");
var _snow2Default = parcelHelpers.interopDefault(_snow2);
var _snow3 = require("./icons/snow3");
var _snow3Default = parcelHelpers.interopDefault(_snow3);
var _sortAlphaDownAlt = require("./icons/sort-alpha-down-alt");
var _sortAlphaDownAltDefault = parcelHelpers.interopDefault(_sortAlphaDownAlt);
var _sortAlphaDown = require("./icons/sort-alpha-down");
var _sortAlphaDownDefault = parcelHelpers.interopDefault(_sortAlphaDown);
var _sortAlphaUpAlt = require("./icons/sort-alpha-up-alt");
var _sortAlphaUpAltDefault = parcelHelpers.interopDefault(_sortAlphaUpAlt);
var _sortAlphaUp = require("./icons/sort-alpha-up");
var _sortAlphaUpDefault = parcelHelpers.interopDefault(_sortAlphaUp);
var _sortDownAlt = require("./icons/sort-down-alt");
var _sortDownAltDefault = parcelHelpers.interopDefault(_sortDownAlt);
var _sortDown = require("./icons/sort-down");
var _sortDownDefault = parcelHelpers.interopDefault(_sortDown);
var _sortNumericDownAlt = require("./icons/sort-numeric-down-alt");
var _sortNumericDownAltDefault = parcelHelpers.interopDefault(_sortNumericDownAlt);
var _sortNumericDown = require("./icons/sort-numeric-down");
var _sortNumericDownDefault = parcelHelpers.interopDefault(_sortNumericDown);
var _sortNumericUpAlt = require("./icons/sort-numeric-up-alt");
var _sortNumericUpAltDefault = parcelHelpers.interopDefault(_sortNumericUpAlt);
var _sortNumericUp = require("./icons/sort-numeric-up");
var _sortNumericUpDefault = parcelHelpers.interopDefault(_sortNumericUp);
var _sortUpAlt = require("./icons/sort-up-alt");
var _sortUpAltDefault = parcelHelpers.interopDefault(_sortUpAlt);
var _sortUp = require("./icons/sort-up");
var _sortUpDefault = parcelHelpers.interopDefault(_sortUp);
var _soundwave = require("./icons/soundwave");
var _soundwaveDefault = parcelHelpers.interopDefault(_soundwave);
var _sourceforge = require("./icons/sourceforge");
var _sourceforgeDefault = parcelHelpers.interopDefault(_sourceforge);
var _speakerFill = require("./icons/speaker-fill");
var _speakerFillDefault = parcelHelpers.interopDefault(_speakerFill);
var _speaker = require("./icons/speaker");
var _speakerDefault = parcelHelpers.interopDefault(_speaker);
var _speedometer = require("./icons/speedometer");
var _speedometerDefault = parcelHelpers.interopDefault(_speedometer);
var _speedometer2 = require("./icons/speedometer2");
var _speedometer2Default = parcelHelpers.interopDefault(_speedometer2);
var _spellcheck = require("./icons/spellcheck");
var _spellcheckDefault = parcelHelpers.interopDefault(_spellcheck);
var _spotify = require("./icons/spotify");
var _spotifyDefault = parcelHelpers.interopDefault(_spotify);
var _squareFill = require("./icons/square-fill");
var _squareFillDefault = parcelHelpers.interopDefault(_squareFill);
var _squareHalf = require("./icons/square-half");
var _squareHalfDefault = parcelHelpers.interopDefault(_squareHalf);
var _square = require("./icons/square");
var _squareDefault = parcelHelpers.interopDefault(_square);
var _stackOverflow = require("./icons/stack-overflow");
var _stackOverflowDefault = parcelHelpers.interopDefault(_stackOverflow);
var _stack = require("./icons/stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _starFill = require("./icons/star-fill");
var _starFillDefault = parcelHelpers.interopDefault(_starFill);
var _starHalf = require("./icons/star-half");
var _starHalfDefault = parcelHelpers.interopDefault(_starHalf);
var _star = require("./icons/star");
var _starDefault = parcelHelpers.interopDefault(_star);
var _stars = require("./icons/stars");
var _starsDefault = parcelHelpers.interopDefault(_stars);
var _steam = require("./icons/steam");
var _steamDefault = parcelHelpers.interopDefault(_steam);
var _stickiesFill = require("./icons/stickies-fill");
var _stickiesFillDefault = parcelHelpers.interopDefault(_stickiesFill);
var _stickies = require("./icons/stickies");
var _stickiesDefault = parcelHelpers.interopDefault(_stickies);
var _stickyFill = require("./icons/sticky-fill");
var _stickyFillDefault = parcelHelpers.interopDefault(_stickyFill);
var _sticky = require("./icons/sticky");
var _stickyDefault = parcelHelpers.interopDefault(_sticky);
var _stopBtnFill = require("./icons/stop-btn-fill");
var _stopBtnFillDefault = parcelHelpers.interopDefault(_stopBtnFill);
var _stopBtn = require("./icons/stop-btn");
var _stopBtnDefault = parcelHelpers.interopDefault(_stopBtn);
var _stopCircleFill = require("./icons/stop-circle-fill");
var _stopCircleFillDefault = parcelHelpers.interopDefault(_stopCircleFill);
var _stopCircle = require("./icons/stop-circle");
var _stopCircleDefault = parcelHelpers.interopDefault(_stopCircle);
var _stopFill = require("./icons/stop-fill");
var _stopFillDefault = parcelHelpers.interopDefault(_stopFill);
var _stop = require("./icons/stop");
var _stopDefault = parcelHelpers.interopDefault(_stop);
var _stoplightsFill = require("./icons/stoplights-fill");
var _stoplightsFillDefault = parcelHelpers.interopDefault(_stoplightsFill);
var _stoplights = require("./icons/stoplights");
var _stoplightsDefault = parcelHelpers.interopDefault(_stoplights);
var _stopwatchFill = require("./icons/stopwatch-fill");
var _stopwatchFillDefault = parcelHelpers.interopDefault(_stopwatchFill);
var _stopwatch = require("./icons/stopwatch");
var _stopwatchDefault = parcelHelpers.interopDefault(_stopwatch);
var _strava = require("./icons/strava");
var _stravaDefault = parcelHelpers.interopDefault(_strava);
var _stripe = require("./icons/stripe");
var _stripeDefault = parcelHelpers.interopDefault(_stripe);
var _subscript = require("./icons/subscript");
var _subscriptDefault = parcelHelpers.interopDefault(_subscript);
var _substack = require("./icons/substack");
var _substackDefault = parcelHelpers.interopDefault(_substack);
var _subtract = require("./icons/subtract");
var _subtractDefault = parcelHelpers.interopDefault(_subtract);
var _suitClubFill = require("./icons/suit-club-fill");
var _suitClubFillDefault = parcelHelpers.interopDefault(_suitClubFill);
var _suitClub = require("./icons/suit-club");
var _suitClubDefault = parcelHelpers.interopDefault(_suitClub);
var _suitDiamondFill = require("./icons/suit-diamond-fill");
var _suitDiamondFillDefault = parcelHelpers.interopDefault(_suitDiamondFill);
var _suitDiamond = require("./icons/suit-diamond");
var _suitDiamondDefault = parcelHelpers.interopDefault(_suitDiamond);
var _suitHeartFill = require("./icons/suit-heart-fill");
var _suitHeartFillDefault = parcelHelpers.interopDefault(_suitHeartFill);
var _suitHeart = require("./icons/suit-heart");
var _suitHeartDefault = parcelHelpers.interopDefault(_suitHeart);
var _suitSpadeFill = require("./icons/suit-spade-fill");
var _suitSpadeFillDefault = parcelHelpers.interopDefault(_suitSpadeFill);
var _suitSpade = require("./icons/suit-spade");
var _suitSpadeDefault = parcelHelpers.interopDefault(_suitSpade);
var _suitcaseFill = require("./icons/suitcase-fill");
var _suitcaseFillDefault = parcelHelpers.interopDefault(_suitcaseFill);
var _suitcaseLgFill = require("./icons/suitcase-lg-fill");
var _suitcaseLgFillDefault = parcelHelpers.interopDefault(_suitcaseLgFill);
var _suitcaseLg = require("./icons/suitcase-lg");
var _suitcaseLgDefault = parcelHelpers.interopDefault(_suitcaseLg);
var _suitcase = require("./icons/suitcase");
var _suitcaseDefault = parcelHelpers.interopDefault(_suitcase);
var _suitcase2Fill = require("./icons/suitcase2-fill");
var _suitcase2FillDefault = parcelHelpers.interopDefault(_suitcase2Fill);
var _suitcase2 = require("./icons/suitcase2");
var _suitcase2Default = parcelHelpers.interopDefault(_suitcase2);
var _sunFill = require("./icons/sun-fill");
var _sunFillDefault = parcelHelpers.interopDefault(_sunFill);
var _sun = require("./icons/sun");
var _sunDefault = parcelHelpers.interopDefault(_sun);
var _sunglasses = require("./icons/sunglasses");
var _sunglassesDefault = parcelHelpers.interopDefault(_sunglasses);
var _sunriseFill = require("./icons/sunrise-fill");
var _sunriseFillDefault = parcelHelpers.interopDefault(_sunriseFill);
var _sunrise = require("./icons/sunrise");
var _sunriseDefault = parcelHelpers.interopDefault(_sunrise);
var _sunsetFill = require("./icons/sunset-fill");
var _sunsetFillDefault = parcelHelpers.interopDefault(_sunsetFill);
var _sunset = require("./icons/sunset");
var _sunsetDefault = parcelHelpers.interopDefault(_sunset);
var _superscript = require("./icons/superscript");
var _superscriptDefault = parcelHelpers.interopDefault(_superscript);
var _symmetryHorizontal = require("./icons/symmetry-horizontal");
var _symmetryHorizontalDefault = parcelHelpers.interopDefault(_symmetryHorizontal);
var _symmetryVertical = require("./icons/symmetry-vertical");
var _symmetryVerticalDefault = parcelHelpers.interopDefault(_symmetryVertical);
var _table = require("./icons/table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tabletFill = require("./icons/tablet-fill");
var _tabletFillDefault = parcelHelpers.interopDefault(_tabletFill);
var _tabletLandscapeFill = require("./icons/tablet-landscape-fill");
var _tabletLandscapeFillDefault = parcelHelpers.interopDefault(_tabletLandscapeFill);
var _tabletLandscape = require("./icons/tablet-landscape");
var _tabletLandscapeDefault = parcelHelpers.interopDefault(_tabletLandscape);
var _tablet = require("./icons/tablet");
var _tabletDefault = parcelHelpers.interopDefault(_tablet);
var _tagFill = require("./icons/tag-fill");
var _tagFillDefault = parcelHelpers.interopDefault(_tagFill);
var _tag = require("./icons/tag");
var _tagDefault = parcelHelpers.interopDefault(_tag);
var _tagsFill = require("./icons/tags-fill");
var _tagsFillDefault = parcelHelpers.interopDefault(_tagsFill);
var _tags = require("./icons/tags");
var _tagsDefault = parcelHelpers.interopDefault(_tags);
var _taxiFrontFill = require("./icons/taxi-front-fill");
var _taxiFrontFillDefault = parcelHelpers.interopDefault(_taxiFrontFill);
var _taxiFront = require("./icons/taxi-front");
var _taxiFrontDefault = parcelHelpers.interopDefault(_taxiFront);
var _telegram = require("./icons/telegram");
var _telegramDefault = parcelHelpers.interopDefault(_telegram);
var _telephoneFill = require("./icons/telephone-fill");
var _telephoneFillDefault = parcelHelpers.interopDefault(_telephoneFill);
var _telephoneForwardFill = require("./icons/telephone-forward-fill");
var _telephoneForwardFillDefault = parcelHelpers.interopDefault(_telephoneForwardFill);
var _telephoneForward = require("./icons/telephone-forward");
var _telephoneForwardDefault = parcelHelpers.interopDefault(_telephoneForward);
var _telephoneInboundFill = require("./icons/telephone-inbound-fill");
var _telephoneInboundFillDefault = parcelHelpers.interopDefault(_telephoneInboundFill);
var _telephoneInbound = require("./icons/telephone-inbound");
var _telephoneInboundDefault = parcelHelpers.interopDefault(_telephoneInbound);
var _telephoneMinusFill = require("./icons/telephone-minus-fill");
var _telephoneMinusFillDefault = parcelHelpers.interopDefault(_telephoneMinusFill);
var _telephoneMinus = require("./icons/telephone-minus");
var _telephoneMinusDefault = parcelHelpers.interopDefault(_telephoneMinus);
var _telephoneOutboundFill = require("./icons/telephone-outbound-fill");
var _telephoneOutboundFillDefault = parcelHelpers.interopDefault(_telephoneOutboundFill);
var _telephoneOutbound = require("./icons/telephone-outbound");
var _telephoneOutboundDefault = parcelHelpers.interopDefault(_telephoneOutbound);
var _telephonePlusFill = require("./icons/telephone-plus-fill");
var _telephonePlusFillDefault = parcelHelpers.interopDefault(_telephonePlusFill);
var _telephonePlus = require("./icons/telephone-plus");
var _telephonePlusDefault = parcelHelpers.interopDefault(_telephonePlus);
var _telephoneXFill = require("./icons/telephone-x-fill");
var _telephoneXFillDefault = parcelHelpers.interopDefault(_telephoneXFill);
var _telephoneX = require("./icons/telephone-x");
var _telephoneXDefault = parcelHelpers.interopDefault(_telephoneX);
var _telephone = require("./icons/telephone");
var _telephoneDefault = parcelHelpers.interopDefault(_telephone);
var _tencentQq = require("./icons/tencent-qq");
var _tencentQqDefault = parcelHelpers.interopDefault(_tencentQq);
var _terminalDash = require("./icons/terminal-dash");
var _terminalDashDefault = parcelHelpers.interopDefault(_terminalDash);
var _terminalFill = require("./icons/terminal-fill");
var _terminalFillDefault = parcelHelpers.interopDefault(_terminalFill);
var _terminalPlus = require("./icons/terminal-plus");
var _terminalPlusDefault = parcelHelpers.interopDefault(_terminalPlus);
var _terminalSplit = require("./icons/terminal-split");
var _terminalSplitDefault = parcelHelpers.interopDefault(_terminalSplit);
var _terminalX = require("./icons/terminal-x");
var _terminalXDefault = parcelHelpers.interopDefault(_terminalX);
var _terminal = require("./icons/terminal");
var _terminalDefault = parcelHelpers.interopDefault(_terminal);
var _textCenter = require("./icons/text-center");
var _textCenterDefault = parcelHelpers.interopDefault(_textCenter);
var _textIndentLeft = require("./icons/text-indent-left");
var _textIndentLeftDefault = parcelHelpers.interopDefault(_textIndentLeft);
var _textIndentRight = require("./icons/text-indent-right");
var _textIndentRightDefault = parcelHelpers.interopDefault(_textIndentRight);
var _textLeft = require("./icons/text-left");
var _textLeftDefault = parcelHelpers.interopDefault(_textLeft);
var _textParagraph = require("./icons/text-paragraph");
var _textParagraphDefault = parcelHelpers.interopDefault(_textParagraph);
var _textRight = require("./icons/text-right");
var _textRightDefault = parcelHelpers.interopDefault(_textRight);
var _textWrap = require("./icons/text-wrap");
var _textWrapDefault = parcelHelpers.interopDefault(_textWrap);
var _textareaResize = require("./icons/textarea-resize");
var _textareaResizeDefault = parcelHelpers.interopDefault(_textareaResize);
var _textareaT = require("./icons/textarea-t");
var _textareaTDefault = parcelHelpers.interopDefault(_textareaT);
var _textarea = require("./icons/textarea");
var _textareaDefault = parcelHelpers.interopDefault(_textarea);
var _thermometerHalf = require("./icons/thermometer-half");
var _thermometerHalfDefault = parcelHelpers.interopDefault(_thermometerHalf);
var _thermometerHigh = require("./icons/thermometer-high");
var _thermometerHighDefault = parcelHelpers.interopDefault(_thermometerHigh);
var _thermometerLow = require("./icons/thermometer-low");
var _thermometerLowDefault = parcelHelpers.interopDefault(_thermometerLow);
var _thermometerSnow = require("./icons/thermometer-snow");
var _thermometerSnowDefault = parcelHelpers.interopDefault(_thermometerSnow);
var _thermometerSun = require("./icons/thermometer-sun");
var _thermometerSunDefault = parcelHelpers.interopDefault(_thermometerSun);
var _thermometer = require("./icons/thermometer");
var _thermometerDefault = parcelHelpers.interopDefault(_thermometer);
var _threadsFill = require("./icons/threads-fill");
var _threadsFillDefault = parcelHelpers.interopDefault(_threadsFill);
var _threads = require("./icons/threads");
var _threadsDefault = parcelHelpers.interopDefault(_threads);
var _threeDotsVertical = require("./icons/three-dots-vertical");
var _threeDotsVerticalDefault = parcelHelpers.interopDefault(_threeDotsVertical);
var _threeDots = require("./icons/three-dots");
var _threeDotsDefault = parcelHelpers.interopDefault(_threeDots);
var _thunderboltFill = require("./icons/thunderbolt-fill");
var _thunderboltFillDefault = parcelHelpers.interopDefault(_thunderboltFill);
var _thunderbolt = require("./icons/thunderbolt");
var _thunderboltDefault = parcelHelpers.interopDefault(_thunderbolt);
var _ticketDetailedFill = require("./icons/ticket-detailed-fill");
var _ticketDetailedFillDefault = parcelHelpers.interopDefault(_ticketDetailedFill);
var _ticketDetailed = require("./icons/ticket-detailed");
var _ticketDetailedDefault = parcelHelpers.interopDefault(_ticketDetailed);
var _ticketFill = require("./icons/ticket-fill");
var _ticketFillDefault = parcelHelpers.interopDefault(_ticketFill);
var _ticketPerforatedFill = require("./icons/ticket-perforated-fill");
var _ticketPerforatedFillDefault = parcelHelpers.interopDefault(_ticketPerforatedFill);
var _ticketPerforated = require("./icons/ticket-perforated");
var _ticketPerforatedDefault = parcelHelpers.interopDefault(_ticketPerforated);
var _ticket = require("./icons/ticket");
var _ticketDefault = parcelHelpers.interopDefault(_ticket);
var _tiktok = require("./icons/tiktok");
var _tiktokDefault = parcelHelpers.interopDefault(_tiktok);
var _toggleOff = require("./icons/toggle-off");
var _toggleOffDefault = parcelHelpers.interopDefault(_toggleOff);
var _toggleOn = require("./icons/toggle-on");
var _toggleOnDefault = parcelHelpers.interopDefault(_toggleOn);
var _toggle2Off = require("./icons/toggle2-off");
var _toggle2OffDefault = parcelHelpers.interopDefault(_toggle2Off);
var _toggle2On = require("./icons/toggle2-on");
var _toggle2OnDefault = parcelHelpers.interopDefault(_toggle2On);
var _toggles = require("./icons/toggles");
var _togglesDefault = parcelHelpers.interopDefault(_toggles);
var _toggles2 = require("./icons/toggles2");
var _toggles2Default = parcelHelpers.interopDefault(_toggles2);
var _tools = require("./icons/tools");
var _toolsDefault = parcelHelpers.interopDefault(_tools);
var _tornado = require("./icons/tornado");
var _tornadoDefault = parcelHelpers.interopDefault(_tornado);
var _trainFreightFrontFill = require("./icons/train-freight-front-fill");
var _trainFreightFrontFillDefault = parcelHelpers.interopDefault(_trainFreightFrontFill);
var _trainFreightFront = require("./icons/train-freight-front");
var _trainFreightFrontDefault = parcelHelpers.interopDefault(_trainFreightFront);
var _trainFrontFill = require("./icons/train-front-fill");
var _trainFrontFillDefault = parcelHelpers.interopDefault(_trainFrontFill);
var _trainFront = require("./icons/train-front");
var _trainFrontDefault = parcelHelpers.interopDefault(_trainFront);
var _trainLightrailFrontFill = require("./icons/train-lightrail-front-fill");
var _trainLightrailFrontFillDefault = parcelHelpers.interopDefault(_trainLightrailFrontFill);
var _trainLightrailFront = require("./icons/train-lightrail-front");
var _trainLightrailFrontDefault = parcelHelpers.interopDefault(_trainLightrailFront);
var _translate = require("./icons/translate");
var _translateDefault = parcelHelpers.interopDefault(_translate);
var _transparency = require("./icons/transparency");
var _transparencyDefault = parcelHelpers.interopDefault(_transparency);
var _trashFill = require("./icons/trash-fill");
var _trashFillDefault = parcelHelpers.interopDefault(_trashFill);
var _trash = require("./icons/trash");
var _trashDefault = parcelHelpers.interopDefault(_trash);
var _trash2Fill = require("./icons/trash2-fill");
var _trash2FillDefault = parcelHelpers.interopDefault(_trash2Fill);
var _trash2 = require("./icons/trash2");
var _trash2Default = parcelHelpers.interopDefault(_trash2);
var _trash3Fill = require("./icons/trash3-fill");
var _trash3FillDefault = parcelHelpers.interopDefault(_trash3Fill);
var _trash3 = require("./icons/trash3");
var _trash3Default = parcelHelpers.interopDefault(_trash3);
var _treeFill = require("./icons/tree-fill");
var _treeFillDefault = parcelHelpers.interopDefault(_treeFill);
var _tree = require("./icons/tree");
var _treeDefault = parcelHelpers.interopDefault(_tree);
var _trello = require("./icons/trello");
var _trelloDefault = parcelHelpers.interopDefault(_trello);
var _triangleFill = require("./icons/triangle-fill");
var _triangleFillDefault = parcelHelpers.interopDefault(_triangleFill);
var _triangleHalf = require("./icons/triangle-half");
var _triangleHalfDefault = parcelHelpers.interopDefault(_triangleHalf);
var _triangle = require("./icons/triangle");
var _triangleDefault = parcelHelpers.interopDefault(_triangle);
var _trophyFill = require("./icons/trophy-fill");
var _trophyFillDefault = parcelHelpers.interopDefault(_trophyFill);
var _trophy = require("./icons/trophy");
var _trophyDefault = parcelHelpers.interopDefault(_trophy);
var _tropicalStorm = require("./icons/tropical-storm");
var _tropicalStormDefault = parcelHelpers.interopDefault(_tropicalStorm);
var _truckFlatbed = require("./icons/truck-flatbed");
var _truckFlatbedDefault = parcelHelpers.interopDefault(_truckFlatbed);
var _truckFrontFill = require("./icons/truck-front-fill");
var _truckFrontFillDefault = parcelHelpers.interopDefault(_truckFrontFill);
var _truckFront = require("./icons/truck-front");
var _truckFrontDefault = parcelHelpers.interopDefault(_truckFront);
var _truck = require("./icons/truck");
var _truckDefault = parcelHelpers.interopDefault(_truck);
var _tsunami = require("./icons/tsunami");
var _tsunamiDefault = parcelHelpers.interopDefault(_tsunami);
var _tvFill = require("./icons/tv-fill");
var _tvFillDefault = parcelHelpers.interopDefault(_tvFill);
var _tv = require("./icons/tv");
var _tvDefault = parcelHelpers.interopDefault(_tv);
var _twitch = require("./icons/twitch");
var _twitchDefault = parcelHelpers.interopDefault(_twitch);
var _twitterX = require("./icons/twitter-x");
var _twitterXDefault = parcelHelpers.interopDefault(_twitterX);
var _twitter = require("./icons/twitter");
var _twitterDefault = parcelHelpers.interopDefault(_twitter);
var _typeBold = require("./icons/type-bold");
var _typeBoldDefault = parcelHelpers.interopDefault(_typeBold);
var _typeH1 = require("./icons/type-h1");
var _typeH1Default = parcelHelpers.interopDefault(_typeH1);
var _typeH2 = require("./icons/type-h2");
var _typeH2Default = parcelHelpers.interopDefault(_typeH2);
var _typeH3 = require("./icons/type-h3");
var _typeH3Default = parcelHelpers.interopDefault(_typeH3);
var _typeH4 = require("./icons/type-h4");
var _typeH4Default = parcelHelpers.interopDefault(_typeH4);
var _typeH5 = require("./icons/type-h5");
var _typeH5Default = parcelHelpers.interopDefault(_typeH5);
var _typeH6 = require("./icons/type-h6");
var _typeH6Default = parcelHelpers.interopDefault(_typeH6);
var _typeItalic = require("./icons/type-italic");
var _typeItalicDefault = parcelHelpers.interopDefault(_typeItalic);
var _typeStrikethrough = require("./icons/type-strikethrough");
var _typeStrikethroughDefault = parcelHelpers.interopDefault(_typeStrikethrough);
var _typeUnderline = require("./icons/type-underline");
var _typeUnderlineDefault = parcelHelpers.interopDefault(_typeUnderline);
var _type = require("./icons/type");
var _typeDefault = parcelHelpers.interopDefault(_type);
var _ubuntu = require("./icons/ubuntu");
var _ubuntuDefault = parcelHelpers.interopDefault(_ubuntu);
var _uiChecksGrid = require("./icons/ui-checks-grid");
var _uiChecksGridDefault = parcelHelpers.interopDefault(_uiChecksGrid);
var _uiChecks = require("./icons/ui-checks");
var _uiChecksDefault = parcelHelpers.interopDefault(_uiChecks);
var _uiRadiosGrid = require("./icons/ui-radios-grid");
var _uiRadiosGridDefault = parcelHelpers.interopDefault(_uiRadiosGrid);
var _uiRadios = require("./icons/ui-radios");
var _uiRadiosDefault = parcelHelpers.interopDefault(_uiRadios);
var _umbrellaFill = require("./icons/umbrella-fill");
var _umbrellaFillDefault = parcelHelpers.interopDefault(_umbrellaFill);
var _umbrella = require("./icons/umbrella");
var _umbrellaDefault = parcelHelpers.interopDefault(_umbrella);
var _unindent = require("./icons/unindent");
var _unindentDefault = parcelHelpers.interopDefault(_unindent);
var _union = require("./icons/union");
var _unionDefault = parcelHelpers.interopDefault(_union);
var _unity = require("./icons/unity");
var _unityDefault = parcelHelpers.interopDefault(_unity);
var _universalAccessCircle = require("./icons/universal-access-circle");
var _universalAccessCircleDefault = parcelHelpers.interopDefault(_universalAccessCircle);
var _universalAccess = require("./icons/universal-access");
var _universalAccessDefault = parcelHelpers.interopDefault(_universalAccess);
var _unlockFill = require("./icons/unlock-fill");
var _unlockFillDefault = parcelHelpers.interopDefault(_unlockFill);
var _unlock = require("./icons/unlock");
var _unlockDefault = parcelHelpers.interopDefault(_unlock);
var _upcScan = require("./icons/upc-scan");
var _upcScanDefault = parcelHelpers.interopDefault(_upcScan);
var _upc = require("./icons/upc");
var _upcDefault = parcelHelpers.interopDefault(_upc);
var _upload = require("./icons/upload");
var _uploadDefault = parcelHelpers.interopDefault(_upload);
var _usbCFill = require("./icons/usb-c-fill");
var _usbCFillDefault = parcelHelpers.interopDefault(_usbCFill);
var _usbC = require("./icons/usb-c");
var _usbCDefault = parcelHelpers.interopDefault(_usbC);
var _usbDriveFill = require("./icons/usb-drive-fill");
var _usbDriveFillDefault = parcelHelpers.interopDefault(_usbDriveFill);
var _usbDrive = require("./icons/usb-drive");
var _usbDriveDefault = parcelHelpers.interopDefault(_usbDrive);
var _usbFill = require("./icons/usb-fill");
var _usbFillDefault = parcelHelpers.interopDefault(_usbFill);
var _usbMicroFill = require("./icons/usb-micro-fill");
var _usbMicroFillDefault = parcelHelpers.interopDefault(_usbMicroFill);
var _usbMicro = require("./icons/usb-micro");
var _usbMicroDefault = parcelHelpers.interopDefault(_usbMicro);
var _usbMiniFill = require("./icons/usb-mini-fill");
var _usbMiniFillDefault = parcelHelpers.interopDefault(_usbMiniFill);
var _usbMini = require("./icons/usb-mini");
var _usbMiniDefault = parcelHelpers.interopDefault(_usbMini);
var _usbPlugFill = require("./icons/usb-plug-fill");
var _usbPlugFillDefault = parcelHelpers.interopDefault(_usbPlugFill);
var _usbPlug = require("./icons/usb-plug");
var _usbPlugDefault = parcelHelpers.interopDefault(_usbPlug);
var _usbSymbol = require("./icons/usb-symbol");
var _usbSymbolDefault = parcelHelpers.interopDefault(_usbSymbol);
var _usb = require("./icons/usb");
var _usbDefault = parcelHelpers.interopDefault(_usb);
var _valentine = require("./icons/valentine");
var _valentineDefault = parcelHelpers.interopDefault(_valentine);
var _valentine2 = require("./icons/valentine2");
var _valentine2Default = parcelHelpers.interopDefault(_valentine2);
var _vectorPen = require("./icons/vector-pen");
var _vectorPenDefault = parcelHelpers.interopDefault(_vectorPen);
var _viewList = require("./icons/view-list");
var _viewListDefault = parcelHelpers.interopDefault(_viewList);
var _viewStacked = require("./icons/view-stacked");
var _viewStackedDefault = parcelHelpers.interopDefault(_viewStacked);
var _vignette = require("./icons/vignette");
var _vignetteDefault = parcelHelpers.interopDefault(_vignette);
var _vimeo = require("./icons/vimeo");
var _vimeoDefault = parcelHelpers.interopDefault(_vimeo);
var _vinylFill = require("./icons/vinyl-fill");
var _vinylFillDefault = parcelHelpers.interopDefault(_vinylFill);
var _vinyl = require("./icons/vinyl");
var _vinylDefault = parcelHelpers.interopDefault(_vinyl);
var _virus = require("./icons/virus");
var _virusDefault = parcelHelpers.interopDefault(_virus);
var _virus2 = require("./icons/virus2");
var _virus2Default = parcelHelpers.interopDefault(_virus2);
var _voicemail = require("./icons/voicemail");
var _voicemailDefault = parcelHelpers.interopDefault(_voicemail);
var _volumeDownFill = require("./icons/volume-down-fill");
var _volumeDownFillDefault = parcelHelpers.interopDefault(_volumeDownFill);
var _volumeDown = require("./icons/volume-down");
var _volumeDownDefault = parcelHelpers.interopDefault(_volumeDown);
var _volumeMuteFill = require("./icons/volume-mute-fill");
var _volumeMuteFillDefault = parcelHelpers.interopDefault(_volumeMuteFill);
var _volumeMute = require("./icons/volume-mute");
var _volumeMuteDefault = parcelHelpers.interopDefault(_volumeMute);
var _volumeOffFill = require("./icons/volume-off-fill");
var _volumeOffFillDefault = parcelHelpers.interopDefault(_volumeOffFill);
var _volumeOff = require("./icons/volume-off");
var _volumeOffDefault = parcelHelpers.interopDefault(_volumeOff);
var _volumeUpFill = require("./icons/volume-up-fill");
var _volumeUpFillDefault = parcelHelpers.interopDefault(_volumeUpFill);
var _volumeUp = require("./icons/volume-up");
var _volumeUpDefault = parcelHelpers.interopDefault(_volumeUp);
var _vr = require("./icons/vr");
var _vrDefault = parcelHelpers.interopDefault(_vr);
var _walletFill = require("./icons/wallet-fill");
var _walletFillDefault = parcelHelpers.interopDefault(_walletFill);
var _wallet = require("./icons/wallet");
var _walletDefault = parcelHelpers.interopDefault(_wallet);
var _wallet2 = require("./icons/wallet2");
var _wallet2Default = parcelHelpers.interopDefault(_wallet2);
var _watch = require("./icons/watch");
var _watchDefault = parcelHelpers.interopDefault(_watch);
var _water = require("./icons/water");
var _waterDefault = parcelHelpers.interopDefault(_water);
var _webcamFill = require("./icons/webcam-fill");
var _webcamFillDefault = parcelHelpers.interopDefault(_webcamFill);
var _webcam = require("./icons/webcam");
var _webcamDefault = parcelHelpers.interopDefault(_webcam);
var _wechat = require("./icons/wechat");
var _wechatDefault = parcelHelpers.interopDefault(_wechat);
var _whatsapp = require("./icons/whatsapp");
var _whatsappDefault = parcelHelpers.interopDefault(_whatsapp);
var _wifi1 = require("./icons/wifi-1");
var _wifi1Default = parcelHelpers.interopDefault(_wifi1);
var _wifi2 = require("./icons/wifi-2");
var _wifi2Default = parcelHelpers.interopDefault(_wifi2);
var _wifiOff = require("./icons/wifi-off");
var _wifiOffDefault = parcelHelpers.interopDefault(_wifiOff);
var _wifi = require("./icons/wifi");
var _wifiDefault = parcelHelpers.interopDefault(_wifi);
var _wikipedia = require("./icons/wikipedia");
var _wikipediaDefault = parcelHelpers.interopDefault(_wikipedia);
var _wind = require("./icons/wind");
var _windDefault = parcelHelpers.interopDefault(_wind);
var _windowDash = require("./icons/window-dash");
var _windowDashDefault = parcelHelpers.interopDefault(_windowDash);
var _windowDesktop = require("./icons/window-desktop");
var _windowDesktopDefault = parcelHelpers.interopDefault(_windowDesktop);
var _windowDock = require("./icons/window-dock");
var _windowDockDefault = parcelHelpers.interopDefault(_windowDock);
var _windowFullscreen = require("./icons/window-fullscreen");
var _windowFullscreenDefault = parcelHelpers.interopDefault(_windowFullscreen);
var _windowPlus = require("./icons/window-plus");
var _windowPlusDefault = parcelHelpers.interopDefault(_windowPlus);
var _windowSidebar = require("./icons/window-sidebar");
var _windowSidebarDefault = parcelHelpers.interopDefault(_windowSidebar);
var _windowSplit = require("./icons/window-split");
var _windowSplitDefault = parcelHelpers.interopDefault(_windowSplit);
var _windowStack = require("./icons/window-stack");
var _windowStackDefault = parcelHelpers.interopDefault(_windowStack);
var _windowX = require("./icons/window-x");
var _windowXDefault = parcelHelpers.interopDefault(_windowX);
var _window = require("./icons/window");
var _windowDefault = parcelHelpers.interopDefault(_window);
var _windows = require("./icons/windows");
var _windowsDefault = parcelHelpers.interopDefault(_windows);
var _wordpress = require("./icons/wordpress");
var _wordpressDefault = parcelHelpers.interopDefault(_wordpress);
var _wrenchAdjustableCircleFill = require("./icons/wrench-adjustable-circle-fill");
var _wrenchAdjustableCircleFillDefault = parcelHelpers.interopDefault(_wrenchAdjustableCircleFill);
var _wrenchAdjustableCircle = require("./icons/wrench-adjustable-circle");
var _wrenchAdjustableCircleDefault = parcelHelpers.interopDefault(_wrenchAdjustableCircle);
var _wrenchAdjustable = require("./icons/wrench-adjustable");
var _wrenchAdjustableDefault = parcelHelpers.interopDefault(_wrenchAdjustable);
var _wrench = require("./icons/wrench");
var _wrenchDefault = parcelHelpers.interopDefault(_wrench);
var _xCircleFill = require("./icons/x-circle-fill");
var _xCircleFillDefault = parcelHelpers.interopDefault(_xCircleFill);
var _xCircle = require("./icons/x-circle");
var _xCircleDefault = parcelHelpers.interopDefault(_xCircle);
var _xDiamondFill = require("./icons/x-diamond-fill");
var _xDiamondFillDefault = parcelHelpers.interopDefault(_xDiamondFill);
var _xDiamond = require("./icons/x-diamond");
var _xDiamondDefault = parcelHelpers.interopDefault(_xDiamond);
var _xLg = require("./icons/x-lg");
var _xLgDefault = parcelHelpers.interopDefault(_xLg);
var _xOctagonFill = require("./icons/x-octagon-fill");
var _xOctagonFillDefault = parcelHelpers.interopDefault(_xOctagonFill);
var _xOctagon = require("./icons/x-octagon");
var _xOctagonDefault = parcelHelpers.interopDefault(_xOctagon);
var _xSquareFill = require("./icons/x-square-fill");
var _xSquareFillDefault = parcelHelpers.interopDefault(_xSquareFill);
var _xSquare = require("./icons/x-square");
var _xSquareDefault = parcelHelpers.interopDefault(_xSquare);
var _x = require("./icons/x");
var _xDefault = parcelHelpers.interopDefault(_x);
var _xbox = require("./icons/xbox");
var _xboxDefault = parcelHelpers.interopDefault(_xbox);
var _yelp = require("./icons/yelp");
var _yelpDefault = parcelHelpers.interopDefault(_yelp);
var _yinYang = require("./icons/yin-yang");
var _yinYangDefault = parcelHelpers.interopDefault(_yinYang);
var _youtube = require("./icons/youtube");
var _youtubeDefault = parcelHelpers.interopDefault(_youtube);
var _zoomIn = require("./icons/zoom-in");
var _zoomInDefault = parcelHelpers.interopDefault(_zoomIn);
var _zoomOut = require("./icons/zoom-out");
var _zoomOutDefault = parcelHelpers.interopDefault(_zoomOut);

},{"./icons/0-circle-fill":false,"./icons/0-circle":false,"./icons/0-square-fill":false,"./icons/0-square":false,"./icons/1-circle-fill":false,"./icons/1-circle":false,"./icons/1-square-fill":false,"./icons/1-square":false,"./icons/123":false,"./icons/2-circle-fill":false,"./icons/2-circle":false,"./icons/2-square-fill":false,"./icons/2-square":false,"./icons/3-circle-fill":false,"./icons/3-circle":false,"./icons/3-square-fill":false,"./icons/3-square":false,"./icons/4-circle-fill":false,"./icons/4-circle":false,"./icons/4-square-fill":false,"./icons/4-square":false,"./icons/5-circle-fill":false,"./icons/5-circle":false,"./icons/5-square-fill":false,"./icons/5-square":false,"./icons/6-circle-fill":false,"./icons/6-circle":false,"./icons/6-square-fill":false,"./icons/6-square":false,"./icons/7-circle-fill":false,"./icons/7-circle":false,"./icons/7-square-fill":false,"./icons/7-square":false,"./icons/8-circle-fill":false,"./icons/8-circle":false,"./icons/8-square-fill":false,"./icons/8-square":false,"./icons/9-circle-fill":false,"./icons/9-circle":false,"./icons/9-square-fill":false,"./icons/9-square":false,"./icons/activity":false,"./icons/airplane-engines-fill":false,"./icons/airplane-engines":false,"./icons/airplane-fill":false,"./icons/airplane":false,"./icons/alarm-fill":false,"./icons/alarm":false,"./icons/alexa":false,"./icons/align-bottom":false,"./icons/align-center":false,"./icons/align-end":false,"./icons/align-middle":false,"./icons/align-start":false,"./icons/align-top":false,"./icons/alipay":false,"./icons/alphabet-uppercase":false,"./icons/alphabet":false,"./icons/alt":false,"./icons/amazon":false,"./icons/amd":false,"./icons/android":false,"./icons/android2":false,"./icons/app-indicator":false,"./icons/app":false,"./icons/apple":false,"./icons/archive-fill":false,"./icons/archive":false,"./icons/arrow-90deg-down":false,"./icons/arrow-90deg-left":false,"./icons/arrow-90deg-right":false,"./icons/arrow-90deg-up":false,"./icons/arrow-bar-down":"bOszT","./icons/arrow-bar-left":"ju96a","./icons/arrow-bar-right":"hpIn2","./icons/arrow-bar-up":"cC1EG","./icons/arrow-clockwise":"4c6I4","./icons/arrow-counterclockwise":"gpQFK","./icons/arrow-down-circle-fill":false,"./icons/arrow-down-circle":"dTmMI","./icons/arrow-down-left-circle-fill":false,"./icons/arrow-down-left-circle":false,"./icons/arrow-down-left-square-fill":false,"./icons/arrow-down-left-square":false,"./icons/arrow-down-left":false,"./icons/arrow-down-right-circle-fill":false,"./icons/arrow-down-right-circle":false,"./icons/arrow-down-right-square-fill":false,"./icons/arrow-down-right-square":false,"./icons/arrow-down-right":false,"./icons/arrow-down-short":false,"./icons/arrow-down-square-fill":false,"./icons/arrow-down-square":false,"./icons/arrow-down-up":false,"./icons/arrow-down":false,"./icons/arrow-left-circle-fill":"ipFpD","./icons/arrow-left-circle":false,"./icons/arrow-left-right":"5cdV9","./icons/arrow-left-short":false,"./icons/arrow-left-square-fill":false,"./icons/arrow-left-square":false,"./icons/arrow-left":false,"./icons/arrow-repeat":false,"./icons/arrow-return-left":false,"./icons/arrow-return-right":false,"./icons/arrow-right-circle-fill":false,"./icons/arrow-right-circle":false,"./icons/arrow-right-short":false,"./icons/arrow-right-square-fill":false,"./icons/arrow-right-square":false,"./icons/arrow-right":"4TXZB","./icons/arrow-through-heart-fill":false,"./icons/arrow-through-heart":false,"./icons/arrow-up-circle-fill":false,"./icons/arrow-up-circle":false,"./icons/arrow-up-left-circle-fill":false,"./icons/arrow-up-left-circle":false,"./icons/arrow-up-left-square-fill":false,"./icons/arrow-up-left-square":false,"./icons/arrow-up-left":false,"./icons/arrow-up-right-circle-fill":false,"./icons/arrow-up-right-circle":false,"./icons/arrow-up-right-square-fill":false,"./icons/arrow-up-right-square":false,"./icons/arrow-up-right":false,"./icons/arrow-up-short":false,"./icons/arrow-up-square-fill":false,"./icons/arrow-up-square":false,"./icons/arrow-up":false,"./icons/arrows-angle-contract":false,"./icons/arrows-angle-expand":false,"./icons/arrows-collapse-vertical":false,"./icons/arrows-collapse":false,"./icons/arrows-expand-vertical":false,"./icons/arrows-expand":false,"./icons/arrows-fullscreen":false,"./icons/arrows-move":false,"./icons/arrows-vertical":false,"./icons/arrows":false,"./icons/aspect-ratio-fill":false,"./icons/aspect-ratio":false,"./icons/asterisk":false,"./icons/at":false,"./icons/award-fill":false,"./icons/award":false,"./icons/back":false,"./icons/backpack-fill":false,"./icons/backpack":false,"./icons/backpack2-fill":false,"./icons/backpack2":false,"./icons/backpack3-fill":false,"./icons/backpack3":false,"./icons/backpack4-fill":false,"./icons/backpack4":false,"./icons/backspace-fill":false,"./icons/backspace-reverse-fill":false,"./icons/backspace-reverse":false,"./icons/backspace":false,"./icons/badge-3d-fill":false,"./icons/badge-3d":false,"./icons/badge-4k-fill":false,"./icons/badge-4k":false,"./icons/badge-8k-fill":false,"./icons/badge-8k":false,"./icons/badge-ad-fill":false,"./icons/badge-ad":false,"./icons/badge-ar-fill":false,"./icons/badge-ar":false,"./icons/badge-cc-fill":false,"./icons/badge-cc":false,"./icons/badge-hd-fill":false,"./icons/badge-hd":false,"./icons/badge-sd-fill":false,"./icons/badge-sd":false,"./icons/badge-tm-fill":false,"./icons/badge-tm":false,"./icons/badge-vo-fill":false,"./icons/badge-vo":false,"./icons/badge-vr-fill":false,"./icons/badge-vr":false,"./icons/badge-wc-fill":false,"./icons/badge-wc":false,"./icons/bag-check-fill":false,"./icons/bag-check":false,"./icons/bag-dash-fill":false,"./icons/bag-dash":false,"./icons/bag-fill":false,"./icons/bag-heart-fill":false,"./icons/bag-heart":false,"./icons/bag-plus-fill":false,"./icons/bag-plus":false,"./icons/bag-x-fill":false,"./icons/bag-x":false,"./icons/bag":false,"./icons/balloon-fill":false,"./icons/balloon-heart-fill":false,"./icons/balloon-heart":false,"./icons/balloon":false,"./icons/ban-fill":false,"./icons/ban":false,"./icons/bandaid-fill":false,"./icons/bandaid":false,"./icons/bank":false,"./icons/bank2":false,"./icons/bar-chart-fill":false,"./icons/bar-chart-line-fill":false,"./icons/bar-chart-line":false,"./icons/bar-chart-steps":false,"./icons/bar-chart":false,"./icons/basket-fill":false,"./icons/basket":false,"./icons/basket2-fill":false,"./icons/basket2":false,"./icons/basket3-fill":false,"./icons/basket3":false,"./icons/battery-charging":false,"./icons/battery-full":false,"./icons/battery-half":false,"./icons/battery":false,"./icons/behance":false,"./icons/bell-fill":false,"./icons/bell-slash-fill":false,"./icons/bell-slash":false,"./icons/bell":false,"./icons/bezier":false,"./icons/bezier2":false,"./icons/bicycle":false,"./icons/bing":false,"./icons/binoculars-fill":false,"./icons/binoculars":false,"./icons/blockquote-left":false,"./icons/blockquote-right":false,"./icons/bluetooth":false,"./icons/body-text":false,"./icons/book-fill":false,"./icons/book-half":false,"./icons/book":false,"./icons/bookmark-check-fill":false,"./icons/bookmark-check":false,"./icons/bookmark-dash-fill":false,"./icons/bookmark-dash":false,"./icons/bookmark-fill":false,"./icons/bookmark-heart-fill":false,"./icons/bookmark-heart":false,"./icons/bookmark-plus-fill":false,"./icons/bookmark-plus":false,"./icons/bookmark-star-fill":false,"./icons/bookmark-star":false,"./icons/bookmark-x-fill":false,"./icons/bookmark-x":false,"./icons/bookmark":false,"./icons/bookmarks-fill":false,"./icons/bookmarks":false,"./icons/bookshelf":false,"./icons/boombox-fill":false,"./icons/boombox":false,"./icons/bootstrap-fill":false,"./icons/bootstrap-reboot":false,"./icons/bootstrap":false,"./icons/border-all":false,"./icons/border-bottom":false,"./icons/border-center":false,"./icons/border-inner":false,"./icons/border-left":false,"./icons/border-middle":false,"./icons/border-outer":false,"./icons/border-right":false,"./icons/border-style":false,"./icons/border-top":false,"./icons/border-width":false,"./icons/border":false,"./icons/bounding-box-circles":false,"./icons/bounding-box":false,"./icons/box-arrow-down-left":false,"./icons/box-arrow-down-right":false,"./icons/box-arrow-down":false,"./icons/box-arrow-in-down-left":false,"./icons/box-arrow-in-down-right":false,"./icons/box-arrow-in-down":false,"./icons/box-arrow-in-left":false,"./icons/box-arrow-in-right":"1M5zC","./icons/box-arrow-in-up-left":false,"./icons/box-arrow-in-up-right":false,"./icons/box-arrow-in-up":false,"./icons/box-arrow-left":false,"./icons/box-arrow-right":false,"./icons/box-arrow-up-left":false,"./icons/box-arrow-up-right":false,"./icons/box-arrow-up":false,"./icons/box-fill":false,"./icons/box-seam-fill":false,"./icons/box-seam":"a6Y2M","./icons/box":"4y3kH","./icons/box2-fill":false,"./icons/box2-heart-fill":false,"./icons/box2-heart":false,"./icons/box2":false,"./icons/boxes":false,"./icons/braces-asterisk":false,"./icons/braces":"cHLpS","./icons/bricks":false,"./icons/briefcase-fill":false,"./icons/briefcase":"7kzQA","./icons/brightness-alt-high-fill":false,"./icons/brightness-alt-high":false,"./icons/brightness-alt-low-fill":false,"./icons/brightness-alt-low":false,"./icons/brightness-high-fill":false,"./icons/brightness-high":false,"./icons/brightness-low-fill":false,"./icons/brightness-low":false,"./icons/brilliance":false,"./icons/broadcast-pin":false,"./icons/broadcast":false,"./icons/browser-chrome":false,"./icons/browser-edge":false,"./icons/browser-firefox":false,"./icons/browser-safari":false,"./icons/brush-fill":false,"./icons/brush":false,"./icons/bucket-fill":false,"./icons/bucket":false,"./icons/bug-fill":false,"./icons/bug":false,"./icons/building-add":false,"./icons/building-check":false,"./icons/building-dash":false,"./icons/building-down":false,"./icons/building-exclamation":false,"./icons/building-fill-add":false,"./icons/building-fill-check":false,"./icons/building-fill-dash":false,"./icons/building-fill-down":false,"./icons/building-fill-exclamation":false,"./icons/building-fill-gear":false,"./icons/building-fill-lock":false,"./icons/building-fill-slash":false,"./icons/building-fill-up":false,"./icons/building-fill-x":false,"./icons/building-fill":false,"./icons/building-gear":false,"./icons/building-lock":false,"./icons/building-slash":false,"./icons/building-up":false,"./icons/building-x":false,"./icons/building":false,"./icons/buildings-fill":false,"./icons/buildings":false,"./icons/bullseye":false,"./icons/bus-front-fill":false,"./icons/bus-front":false,"./icons/c-circle-fill":false,"./icons/c-circle":false,"./icons/c-square-fill":false,"./icons/c-square":false,"./icons/cake-fill":false,"./icons/cake":false,"./icons/cake2-fill":false,"./icons/cake2":false,"./icons/calculator-fill":false,"./icons/calculator":false,"./icons/calendar-check-fill":false,"./icons/calendar-check":false,"./icons/calendar-date-fill":false,"./icons/calendar-date":false,"./icons/calendar-day-fill":false,"./icons/calendar-day":false,"./icons/calendar-event-fill":false,"./icons/calendar-event":false,"./icons/calendar-fill":false,"./icons/calendar-heart-fill":false,"./icons/calendar-heart":false,"./icons/calendar-minus-fill":false,"./icons/calendar-minus":false,"./icons/calendar-month-fill":false,"./icons/calendar-month":false,"./icons/calendar-plus-fill":false,"./icons/calendar-plus":false,"./icons/calendar-range-fill":false,"./icons/calendar-range":false,"./icons/calendar-week-fill":false,"./icons/calendar-week":false,"./icons/calendar-x-fill":false,"./icons/calendar-x":false,"./icons/calendar":false,"./icons/calendar2-check-fill":false,"./icons/calendar2-check":false,"./icons/calendar2-date-fill":false,"./icons/calendar2-date":false,"./icons/calendar2-day-fill":false,"./icons/calendar2-day":false,"./icons/calendar2-event-fill":false,"./icons/calendar2-event":false,"./icons/calendar2-fill":false,"./icons/calendar2-heart-fill":false,"./icons/calendar2-heart":false,"./icons/calendar2-minus-fill":false,"./icons/calendar2-minus":false,"./icons/calendar2-month-fill":false,"./icons/calendar2-month":false,"./icons/calendar2-plus-fill":false,"./icons/calendar2-plus":false,"./icons/calendar2-range-fill":false,"./icons/calendar2-range":false,"./icons/calendar2-week-fill":false,"./icons/calendar2-week":false,"./icons/calendar2-x-fill":false,"./icons/calendar2-x":false,"./icons/calendar2":false,"./icons/calendar3-event-fill":false,"./icons/calendar3-event":false,"./icons/calendar3-fill":false,"./icons/calendar3-range-fill":false,"./icons/calendar3-range":false,"./icons/calendar3-week-fill":false,"./icons/calendar3-week":false,"./icons/calendar3":false,"./icons/calendar4-event":false,"./icons/calendar4-range":false,"./icons/calendar4-week":false,"./icons/calendar4":false,"./icons/camera-fill":false,"./icons/camera-reels-fill":false,"./icons/camera-reels":false,"./icons/camera-video-fill":false,"./icons/camera-video-off-fill":false,"./icons/camera-video-off":false,"./icons/camera-video":false,"./icons/camera":false,"./icons/camera2":"8Ol6k","./icons/capslock-fill":false,"./icons/capslock":false,"./icons/capsule-pill":false,"./icons/capsule":false,"./icons/car-front-fill":false,"./icons/car-front":false,"./icons/card-checklist":false,"./icons/card-heading":false,"./icons/card-image":false,"./icons/card-list":false,"./icons/card-text":"6i3rK","./icons/caret-down-fill":false,"./icons/caret-down-square-fill":false,"./icons/caret-down-square":false,"./icons/caret-down":"8waNh","./icons/caret-left-fill":false,"./icons/caret-left-square-fill":false,"./icons/caret-left-square":false,"./icons/caret-left":false,"./icons/caret-right-fill":false,"./icons/caret-right-square-fill":false,"./icons/caret-right-square":false,"./icons/caret-right":"fV8ZV","./icons/caret-up-fill":false,"./icons/caret-up-square-fill":false,"./icons/caret-up-square":false,"./icons/caret-up":false,"./icons/cart-check-fill":false,"./icons/cart-check":false,"./icons/cart-dash-fill":false,"./icons/cart-dash":false,"./icons/cart-fill":false,"./icons/cart-plus-fill":false,"./icons/cart-plus":false,"./icons/cart-x-fill":false,"./icons/cart-x":false,"./icons/cart":false,"./icons/cart2":false,"./icons/cart3":false,"./icons/cart4":false,"./icons/cash-coin":false,"./icons/cash-stack":false,"./icons/cash":false,"./icons/cassette-fill":false,"./icons/cassette":false,"./icons/cast":false,"./icons/cc-circle-fill":false,"./icons/cc-circle":false,"./icons/cc-square-fill":false,"./icons/cc-square":false,"./icons/chat-dots-fill":false,"./icons/chat-dots":false,"./icons/chat-fill":false,"./icons/chat-heart-fill":false,"./icons/chat-heart":false,"./icons/chat-left-dots-fill":false,"./icons/chat-left-dots":false,"./icons/chat-left-fill":false,"./icons/chat-left-heart-fill":false,"./icons/chat-left-heart":false,"./icons/chat-left-quote-fill":false,"./icons/chat-left-quote":false,"./icons/chat-left-text-fill":false,"./icons/chat-left-text":false,"./icons/chat-left":false,"./icons/chat-quote-fill":false,"./icons/chat-quote":false,"./icons/chat-right-dots-fill":false,"./icons/chat-right-dots":false,"./icons/chat-right-fill":false,"./icons/chat-right-heart-fill":false,"./icons/chat-right-heart":false,"./icons/chat-right-quote-fill":false,"./icons/chat-right-quote":false,"./icons/chat-right-text-fill":false,"./icons/chat-right-text":false,"./icons/chat-right":false,"./icons/chat-square-dots-fill":false,"./icons/chat-square-dots":false,"./icons/chat-square-fill":false,"./icons/chat-square-heart-fill":false,"./icons/chat-square-heart":false,"./icons/chat-square-quote-fill":false,"./icons/chat-square-quote":false,"./icons/chat-square-text-fill":false,"./icons/chat-square-text":false,"./icons/chat-square":false,"./icons/chat-text-fill":false,"./icons/chat-text":false,"./icons/chat":false,"./icons/check-all":false,"./icons/check-circle-fill":"27PO9","./icons/check-circle":false,"./icons/check-lg":false,"./icons/check-square-fill":false,"./icons/check-square":false,"./icons/check":false,"./icons/check2-all":false,"./icons/check2-circle":false,"./icons/check2-square":false,"./icons/check2":false,"./icons/chevron-bar-contract":false,"./icons/chevron-bar-down":false,"./icons/chevron-bar-expand":false,"./icons/chevron-bar-left":false,"./icons/chevron-bar-right":false,"./icons/chevron-bar-up":false,"./icons/chevron-compact-down":false,"./icons/chevron-compact-left":false,"./icons/chevron-compact-right":false,"./icons/chevron-compact-up":false,"./icons/chevron-contract":false,"./icons/chevron-double-down":false,"./icons/chevron-double-left":false,"./icons/chevron-double-right":false,"./icons/chevron-double-up":false,"./icons/chevron-down":false,"./icons/chevron-expand":false,"./icons/chevron-left":false,"./icons/chevron-right":false,"./icons/chevron-up":false,"./icons/circle-fill":false,"./icons/circle-half":false,"./icons/circle-square":false,"./icons/circle":false,"./icons/clipboard-check-fill":"kiC8I","./icons/clipboard-check":false,"./icons/clipboard-data-fill":false,"./icons/clipboard-data":false,"./icons/clipboard-fill":"fVpSE","./icons/clipboard-heart-fill":false,"./icons/clipboard-heart":false,"./icons/clipboard-minus-fill":false,"./icons/clipboard-minus":false,"./icons/clipboard-plus-fill":false,"./icons/clipboard-plus":false,"./icons/clipboard-pulse":false,"./icons/clipboard-x-fill":false,"./icons/clipboard-x":false,"./icons/clipboard":"kjYrs","./icons/clipboard2-check-fill":false,"./icons/clipboard2-check":false,"./icons/clipboard2-data-fill":false,"./icons/clipboard2-data":false,"./icons/clipboard2-fill":false,"./icons/clipboard2-heart-fill":false,"./icons/clipboard2-heart":false,"./icons/clipboard2-minus-fill":false,"./icons/clipboard2-minus":false,"./icons/clipboard2-plus-fill":false,"./icons/clipboard2-plus":false,"./icons/clipboard2-pulse-fill":false,"./icons/clipboard2-pulse":false,"./icons/clipboard2-x-fill":false,"./icons/clipboard2-x":false,"./icons/clipboard2":false,"./icons/clock-fill":false,"./icons/clock-history":false,"./icons/clock":false,"./icons/cloud-arrow-down-fill":false,"./icons/cloud-arrow-down":false,"./icons/cloud-arrow-up-fill":false,"./icons/cloud-arrow-up":false,"./icons/cloud-check-fill":false,"./icons/cloud-check":false,"./icons/cloud-download-fill":false,"./icons/cloud-download":false,"./icons/cloud-drizzle-fill":false,"./icons/cloud-drizzle":false,"./icons/cloud-fill":false,"./icons/cloud-fog-fill":false,"./icons/cloud-fog":false,"./icons/cloud-fog2-fill":false,"./icons/cloud-fog2":false,"./icons/cloud-hail-fill":false,"./icons/cloud-hail":false,"./icons/cloud-haze-fill":false,"./icons/cloud-haze":false,"./icons/cloud-haze2-fill":false,"./icons/cloud-haze2":false,"./icons/cloud-lightning-fill":false,"./icons/cloud-lightning-rain-fill":"9Upys","./icons/cloud-lightning-rain":false,"./icons/cloud-lightning":false,"./icons/cloud-minus-fill":false,"./icons/cloud-minus":false,"./icons/cloud-moon-fill":false,"./icons/cloud-moon":false,"./icons/cloud-plus-fill":false,"./icons/cloud-plus":false,"./icons/cloud-rain-fill":false,"./icons/cloud-rain-heavy-fill":false,"./icons/cloud-rain-heavy":false,"./icons/cloud-rain":false,"./icons/cloud-slash-fill":false,"./icons/cloud-slash":false,"./icons/cloud-sleet-fill":false,"./icons/cloud-sleet":false,"./icons/cloud-snow-fill":false,"./icons/cloud-snow":false,"./icons/cloud-sun-fill":false,"./icons/cloud-sun":false,"./icons/cloud-upload-fill":false,"./icons/cloud-upload":"cOawj","./icons/cloud":false,"./icons/clouds-fill":false,"./icons/clouds":false,"./icons/cloudy-fill":false,"./icons/cloudy":false,"./icons/code-slash":false,"./icons/code-square":false,"./icons/code":false,"./icons/coin":false,"./icons/collection-fill":"kggtA","./icons/collection-play-fill":false,"./icons/collection-play":false,"./icons/collection":false,"./icons/columns-gap":false,"./icons/columns":false,"./icons/command":false,"./icons/compass-fill":false,"./icons/compass":false,"./icons/cone-striped":false,"./icons/cone":false,"./icons/controller":false,"./icons/cookie":false,"./icons/copy":false,"./icons/cpu-fill":false,"./icons/cpu":false,"./icons/credit-card-2-back-fill":false,"./icons/credit-card-2-back":false,"./icons/credit-card-2-front-fill":false,"./icons/credit-card-2-front":false,"./icons/credit-card-fill":false,"./icons/credit-card":false,"./icons/crop":false,"./icons/crosshair":false,"./icons/crosshair2":false,"./icons/cup-fill":false,"./icons/cup-hot-fill":false,"./icons/cup-hot":false,"./icons/cup-straw":false,"./icons/cup":false,"./icons/currency-bitcoin":false,"./icons/currency-dollar":false,"./icons/currency-euro":false,"./icons/currency-exchange":false,"./icons/currency-pound":false,"./icons/currency-rupee":false,"./icons/currency-yen":false,"./icons/cursor-fill":false,"./icons/cursor-text":false,"./icons/cursor":"loru3","./icons/dash-circle-dotted":false,"./icons/dash-circle-fill":"aWvxp","./icons/dash-circle":false,"./icons/dash-lg":false,"./icons/dash-square-dotted":false,"./icons/dash-square-fill":false,"./icons/dash-square":false,"./icons/dash":false,"./icons/database-add":false,"./icons/database-check":false,"./icons/database-dash":false,"./icons/database-down":false,"./icons/database-exclamation":false,"./icons/database-fill-add":false,"./icons/database-fill-check":false,"./icons/database-fill-dash":false,"./icons/database-fill-down":false,"./icons/database-fill-exclamation":false,"./icons/database-fill-gear":false,"./icons/database-fill-lock":false,"./icons/database-fill-slash":false,"./icons/database-fill-up":false,"./icons/database-fill-x":false,"./icons/database-fill":false,"./icons/database-gear":false,"./icons/database-lock":false,"./icons/database-slash":false,"./icons/database-up":false,"./icons/database-x":false,"./icons/database":false,"./icons/device-hdd-fill":false,"./icons/device-hdd":false,"./icons/device-ssd-fill":false,"./icons/device-ssd":false,"./icons/diagram-2-fill":"jOxRn","./icons/diagram-2":false,"./icons/diagram-3-fill":false,"./icons/diagram-3":false,"./icons/diamond-fill":false,"./icons/diamond-half":"fHqj5","./icons/diamond":false,"./icons/dice-1-fill":false,"./icons/dice-1":false,"./icons/dice-2-fill":false,"./icons/dice-2":false,"./icons/dice-3-fill":false,"./icons/dice-3":false,"./icons/dice-4-fill":false,"./icons/dice-4":false,"./icons/dice-5-fill":false,"./icons/dice-5":false,"./icons/dice-6-fill":false,"./icons/dice-6":false,"./icons/disc-fill":false,"./icons/disc":false,"./icons/discord":false,"./icons/display-fill":false,"./icons/display":false,"./icons/displayport-fill":false,"./icons/displayport":false,"./icons/distribute-horizontal":false,"./icons/distribute-vertical":false,"./icons/door-closed-fill":false,"./icons/door-closed":false,"./icons/door-open-fill":false,"./icons/door-open":false,"./icons/dot":false,"./icons/download":false,"./icons/dpad-fill":false,"./icons/dpad":false,"./icons/dribbble":false,"./icons/dropbox":false,"./icons/droplet-fill":false,"./icons/droplet-half":false,"./icons/droplet":false,"./icons/duffle-fill":false,"./icons/duffle":false,"./icons/ear-fill":false,"./icons/ear":false,"./icons/earbuds":false,"./icons/easel-fill":false,"./icons/easel":false,"./icons/easel2-fill":false,"./icons/easel2":false,"./icons/easel3-fill":false,"./icons/easel3":false,"./icons/egg-fill":false,"./icons/egg-fried":false,"./icons/egg":false,"./icons/eject-fill":false,"./icons/eject":false,"./icons/emoji-angry-fill":false,"./icons/emoji-angry":false,"./icons/emoji-astonished-fill":false,"./icons/emoji-astonished":false,"./icons/emoji-dizzy-fill":false,"./icons/emoji-dizzy":false,"./icons/emoji-expressionless-fill":false,"./icons/emoji-expressionless":false,"./icons/emoji-frown-fill":false,"./icons/emoji-frown":false,"./icons/emoji-grimace-fill":false,"./icons/emoji-grimace":false,"./icons/emoji-grin-fill":false,"./icons/emoji-grin":false,"./icons/emoji-heart-eyes-fill":false,"./icons/emoji-heart-eyes":false,"./icons/emoji-kiss-fill":false,"./icons/emoji-kiss":false,"./icons/emoji-laughing-fill":false,"./icons/emoji-laughing":false,"./icons/emoji-neutral-fill":false,"./icons/emoji-neutral":false,"./icons/emoji-smile-fill":false,"./icons/emoji-smile-upside-down-fill":false,"./icons/emoji-smile-upside-down":false,"./icons/emoji-smile":false,"./icons/emoji-sunglasses-fill":false,"./icons/emoji-sunglasses":false,"./icons/emoji-surprise-fill":false,"./icons/emoji-surprise":false,"./icons/emoji-tear-fill":false,"./icons/emoji-tear":false,"./icons/emoji-wink-fill":false,"./icons/emoji-wink":false,"./icons/envelope-arrow-down-fill":false,"./icons/envelope-arrow-down":false,"./icons/envelope-arrow-up-fill":false,"./icons/envelope-arrow-up":false,"./icons/envelope-at-fill":false,"./icons/envelope-at":false,"./icons/envelope-check-fill":false,"./icons/envelope-check":false,"./icons/envelope-dash-fill":false,"./icons/envelope-dash":false,"./icons/envelope-exclamation-fill":false,"./icons/envelope-exclamation":false,"./icons/envelope-fill":false,"./icons/envelope-heart-fill":false,"./icons/envelope-heart":false,"./icons/envelope-open-fill":false,"./icons/envelope-open-heart-fill":false,"./icons/envelope-open-heart":false,"./icons/envelope-open":false,"./icons/envelope-paper-fill":false,"./icons/envelope-paper-heart-fill":false,"./icons/envelope-paper-heart":false,"./icons/envelope-paper":false,"./icons/envelope-plus-fill":false,"./icons/envelope-plus":false,"./icons/envelope-slash-fill":false,"./icons/envelope-slash":false,"./icons/envelope-x-fill":false,"./icons/envelope-x":false,"./icons/envelope":false,"./icons/eraser-fill":false,"./icons/eraser":false,"./icons/escape":false,"./icons/ethernet":false,"./icons/ev-front-fill":false,"./icons/ev-front":false,"./icons/ev-station-fill":false,"./icons/ev-station":false,"./icons/exclamation-circle-fill":false,"./icons/exclamation-circle":false,"./icons/exclamation-diamond-fill":"5Hnpi","./icons/exclamation-diamond":false,"./icons/exclamation-lg":false,"./icons/exclamation-octagon-fill":false,"./icons/exclamation-octagon":false,"./icons/exclamation-square-fill":"itQo2","./icons/exclamation-square":false,"./icons/exclamation-triangle-fill":false,"./icons/exclamation-triangle":false,"./icons/exclamation":false,"./icons/exclude":false,"./icons/explicit-fill":false,"./icons/explicit":false,"./icons/exposure":false,"./icons/eye-fill":false,"./icons/eye-slash-fill":false,"./icons/eye-slash":"4ZDc8","./icons/eye":"bz6ut","./icons/eyedropper":false,"./icons/eyeglasses":false,"./icons/facebook":false,"./icons/fan":false,"./icons/fast-forward-btn-fill":false,"./icons/fast-forward-btn":false,"./icons/fast-forward-circle-fill":false,"./icons/fast-forward-circle":false,"./icons/fast-forward-fill":false,"./icons/fast-forward":false,"./icons/feather":false,"./icons/feather2":false,"./icons/file-arrow-down-fill":false,"./icons/file-arrow-down":"jYKSY","./icons/file-arrow-up-fill":false,"./icons/file-arrow-up":false,"./icons/file-bar-graph-fill":false,"./icons/file-bar-graph":false,"./icons/file-binary-fill":false,"./icons/file-binary":false,"./icons/file-break-fill":false,"./icons/file-break":false,"./icons/file-check-fill":false,"./icons/file-check":false,"./icons/file-code-fill":false,"./icons/file-code":false,"./icons/file-diff-fill":false,"./icons/file-diff":false,"./icons/file-earmark-arrow-down-fill":false,"./icons/file-earmark-arrow-down":false,"./icons/file-earmark-arrow-up-fill":false,"./icons/file-earmark-arrow-up":false,"./icons/file-earmark-bar-graph-fill":false,"./icons/file-earmark-bar-graph":false,"./icons/file-earmark-binary-fill":false,"./icons/file-earmark-binary":false,"./icons/file-earmark-break-fill":false,"./icons/file-earmark-break":false,"./icons/file-earmark-check-fill":false,"./icons/file-earmark-check":false,"./icons/file-earmark-code-fill":false,"./icons/file-earmark-code":false,"./icons/file-earmark-diff-fill":false,"./icons/file-earmark-diff":false,"./icons/file-earmark-easel-fill":false,"./icons/file-earmark-easel":false,"./icons/file-earmark-excel-fill":false,"./icons/file-earmark-excel":false,"./icons/file-earmark-fill":false,"./icons/file-earmark-font-fill":false,"./icons/file-earmark-font":false,"./icons/file-earmark-image-fill":false,"./icons/file-earmark-image":false,"./icons/file-earmark-lock-fill":false,"./icons/file-earmark-lock":false,"./icons/file-earmark-lock2-fill":false,"./icons/file-earmark-lock2":false,"./icons/file-earmark-medical-fill":false,"./icons/file-earmark-medical":false,"./icons/file-earmark-minus-fill":false,"./icons/file-earmark-minus":false,"./icons/file-earmark-music-fill":false,"./icons/file-earmark-music":false,"./icons/file-earmark-pdf-fill":false,"./icons/file-earmark-pdf":false,"./icons/file-earmark-person-fill":false,"./icons/file-earmark-person":false,"./icons/file-earmark-play-fill":false,"./icons/file-earmark-play":false,"./icons/file-earmark-plus-fill":false,"./icons/file-earmark-plus":false,"./icons/file-earmark-post-fill":false,"./icons/file-earmark-post":false,"./icons/file-earmark-ppt-fill":false,"./icons/file-earmark-ppt":false,"./icons/file-earmark-richtext-fill":false,"./icons/file-earmark-richtext":false,"./icons/file-earmark-ruled-fill":false,"./icons/file-earmark-ruled":false,"./icons/file-earmark-slides-fill":false,"./icons/file-earmark-slides":false,"./icons/file-earmark-spreadsheet-fill":false,"./icons/file-earmark-spreadsheet":false,"./icons/file-earmark-text-fill":false,"./icons/file-earmark-text":false,"./icons/file-earmark-word-fill":false,"./icons/file-earmark-word":false,"./icons/file-earmark-x-fill":false,"./icons/file-earmark-x":false,"./icons/file-earmark-zip-fill":false,"./icons/file-earmark-zip":false,"./icons/file-earmark":false,"./icons/file-easel-fill":false,"./icons/file-easel":false,"./icons/file-excel-fill":false,"./icons/file-excel":false,"./icons/file-fill":false,"./icons/file-font-fill":false,"./icons/file-font":false,"./icons/file-image-fill":false,"./icons/file-image":false,"./icons/file-lock-fill":false,"./icons/file-lock":false,"./icons/file-lock2-fill":false,"./icons/file-lock2":false,"./icons/file-medical-fill":false,"./icons/file-medical":false,"./icons/file-minus-fill":false,"./icons/file-minus":false,"./icons/file-music-fill":false,"./icons/file-music":false,"./icons/file-pdf-fill":false,"./icons/file-pdf":false,"./icons/file-person-fill":false,"./icons/file-person":"anbkJ","./icons/file-play-fill":false,"./icons/file-play":false,"./icons/file-plus-fill":false,"./icons/file-plus":"2uvgb","./icons/file-post-fill":false,"./icons/file-post":false,"./icons/file-ppt-fill":false,"./icons/file-ppt":false,"./icons/file-richtext-fill":false,"./icons/file-richtext":"2WKOs","./icons/file-ruled-fill":false,"./icons/file-ruled":false,"./icons/file-slides-fill":false,"./icons/file-slides":false,"./icons/file-spreadsheet-fill":false,"./icons/file-spreadsheet":"b0TyQ","./icons/file-text-fill":false,"./icons/file-text":false,"./icons/file-word-fill":false,"./icons/file-word":false,"./icons/file-x-fill":false,"./icons/file-x":false,"./icons/file-zip-fill":false,"./icons/file-zip":false,"./icons/file":"7JFuM","./icons/files-alt":false,"./icons/files":false,"./icons/filetype-aac":false,"./icons/filetype-ai":false,"./icons/filetype-bmp":false,"./icons/filetype-cs":false,"./icons/filetype-css":false,"./icons/filetype-csv":false,"./icons/filetype-doc":false,"./icons/filetype-docx":false,"./icons/filetype-exe":false,"./icons/filetype-gif":false,"./icons/filetype-heic":false,"./icons/filetype-html":false,"./icons/filetype-java":false,"./icons/filetype-jpg":false,"./icons/filetype-js":false,"./icons/filetype-json":false,"./icons/filetype-jsx":false,"./icons/filetype-key":false,"./icons/filetype-m4p":false,"./icons/filetype-md":false,"./icons/filetype-mdx":false,"./icons/filetype-mov":false,"./icons/filetype-mp3":false,"./icons/filetype-mp4":false,"./icons/filetype-otf":false,"./icons/filetype-pdf":false,"./icons/filetype-php":false,"./icons/filetype-png":false,"./icons/filetype-ppt":false,"./icons/filetype-pptx":false,"./icons/filetype-psd":false,"./icons/filetype-py":false,"./icons/filetype-raw":false,"./icons/filetype-rb":false,"./icons/filetype-sass":false,"./icons/filetype-scss":false,"./icons/filetype-sh":false,"./icons/filetype-sql":false,"./icons/filetype-svg":false,"./icons/filetype-tiff":false,"./icons/filetype-tsx":false,"./icons/filetype-ttf":false,"./icons/filetype-txt":false,"./icons/filetype-wav":false,"./icons/filetype-woff":false,"./icons/filetype-xls":false,"./icons/filetype-xlsx":false,"./icons/filetype-xml":false,"./icons/filetype-yml":false,"./icons/film":false,"./icons/filter-circle-fill":false,"./icons/filter-circle":false,"./icons/filter-left":false,"./icons/filter-right":false,"./icons/filter-square-fill":false,"./icons/filter-square":false,"./icons/filter":false,"./icons/fingerprint":false,"./icons/fire":false,"./icons/flag-fill":false,"./icons/flag":false,"./icons/floppy-fill":false,"./icons/floppy":false,"./icons/floppy2-fill":false,"./icons/floppy2":false,"./icons/flower1":false,"./icons/flower2":false,"./icons/flower3":false,"./icons/folder-check":false,"./icons/folder-fill":false,"./icons/folder-minus":false,"./icons/folder-plus":false,"./icons/folder-symlink-fill":false,"./icons/folder-symlink":false,"./icons/folder-x":false,"./icons/folder":false,"./icons/folder2-open":false,"./icons/folder2":false,"./icons/fonts":false,"./icons/forward-fill":false,"./icons/forward":false,"./icons/front":false,"./icons/fuel-pump-diesel-fill":false,"./icons/fuel-pump-diesel":false,"./icons/fuel-pump-fill":false,"./icons/fuel-pump":false,"./icons/fullscreen-exit":false,"./icons/fullscreen":false,"./icons/funnel-fill":false,"./icons/funnel":false,"./icons/gear-fill":false,"./icons/gear-wide-connected":false,"./icons/gear-wide":false,"./icons/gear":false,"./icons/gem":false,"./icons/gender-ambiguous":false,"./icons/gender-female":false,"./icons/gender-male":false,"./icons/gender-neuter":false,"./icons/gender-trans":false,"./icons/geo-alt-fill":false,"./icons/geo-alt":false,"./icons/geo-fill":false,"./icons/geo":false,"./icons/gift-fill":false,"./icons/gift":false,"./icons/git":false,"./icons/github":false,"./icons/gitlab":false,"./icons/globe-americas":false,"./icons/globe-asia-australia":false,"./icons/globe-central-south-asia":false,"./icons/globe-europe-africa":false,"./icons/globe":false,"./icons/globe2":false,"./icons/google-play":false,"./icons/google":false,"./icons/gpu-card":false,"./icons/graph-down-arrow":false,"./icons/graph-down":false,"./icons/graph-up-arrow":false,"./icons/graph-up":false,"./icons/grid-1x2-fill":false,"./icons/grid-1x2":false,"./icons/grid-3x2-gap-fill":false,"./icons/grid-3x2-gap":false,"./icons/grid-3x2":false,"./icons/grid-3x3-gap-fill":false,"./icons/grid-3x3-gap":false,"./icons/grid-3x3":false,"./icons/grid-fill":false,"./icons/grid":false,"./icons/grip-horizontal":"2HHcO","./icons/grip-vertical":false,"./icons/h-circle-fill":false,"./icons/h-circle":false,"./icons/h-square-fill":false,"./icons/h-square":false,"./icons/hammer":false,"./icons/hand-index-fill":false,"./icons/hand-index-thumb-fill":false,"./icons/hand-index-thumb":"65wse","./icons/hand-index":false,"./icons/hand-thumbs-down-fill":false,"./icons/hand-thumbs-down":false,"./icons/hand-thumbs-up-fill":false,"./icons/hand-thumbs-up":false,"./icons/handbag-fill":false,"./icons/handbag":false,"./icons/hash":false,"./icons/hdd-fill":false,"./icons/hdd-network-fill":false,"./icons/hdd-network":false,"./icons/hdd-rack-fill":false,"./icons/hdd-rack":false,"./icons/hdd-stack-fill":false,"./icons/hdd-stack":false,"./icons/hdd":false,"./icons/hdmi-fill":false,"./icons/hdmi":false,"./icons/headphones":false,"./icons/headset-vr":false,"./icons/headset":false,"./icons/heart-arrow":false,"./icons/heart-fill":false,"./icons/heart-half":false,"./icons/heart-pulse-fill":false,"./icons/heart-pulse":false,"./icons/heart":false,"./icons/heartbreak-fill":false,"./icons/heartbreak":false,"./icons/hearts":false,"./icons/heptagon-fill":false,"./icons/heptagon-half":false,"./icons/heptagon":false,"./icons/hexagon-fill":false,"./icons/hexagon-half":false,"./icons/hexagon":false,"./icons/highlighter":false,"./icons/highlights":false,"./icons/hospital-fill":false,"./icons/hospital":false,"./icons/hourglass-bottom":false,"./icons/hourglass-split":false,"./icons/hourglass-top":false,"./icons/hourglass":false,"./icons/house-add-fill":false,"./icons/house-add":false,"./icons/house-check-fill":false,"./icons/house-check":false,"./icons/house-dash-fill":false,"./icons/house-dash":false,"./icons/house-door-fill":"4Kckt","./icons/house-door":false,"./icons/house-down-fill":false,"./icons/house-down":false,"./icons/house-exclamation-fill":false,"./icons/house-exclamation":false,"./icons/house-fill":false,"./icons/house-gear-fill":false,"./icons/house-gear":false,"./icons/house-heart-fill":false,"./icons/house-heart":false,"./icons/house-lock-fill":false,"./icons/house-lock":false,"./icons/house-slash-fill":false,"./icons/house-slash":false,"./icons/house-up-fill":false,"./icons/house-up":false,"./icons/house-x-fill":false,"./icons/house-x":false,"./icons/house":false,"./icons/houses-fill":false,"./icons/houses":false,"./icons/hr":false,"./icons/hurricane":false,"./icons/hypnotize":false,"./icons/image-alt":false,"./icons/image-fill":false,"./icons/image":false,"./icons/images":false,"./icons/inbox-fill":false,"./icons/inbox":false,"./icons/inboxes-fill":false,"./icons/inboxes":false,"./icons/incognito":false,"./icons/indent":false,"./icons/infinity":false,"./icons/info-circle-fill":false,"./icons/info-circle":false,"./icons/info-lg":false,"./icons/info-square-fill":false,"./icons/info-square":false,"./icons/info":false,"./icons/input-cursor-text":"aA9fB","./icons/input-cursor":false,"./icons/instagram":false,"./icons/intersect":false,"./icons/journal-album":false,"./icons/journal-arrow-down":false,"./icons/journal-arrow-up":false,"./icons/journal-bookmark-fill":false,"./icons/journal-bookmark":false,"./icons/journal-check":false,"./icons/journal-code":false,"./icons/journal-medical":false,"./icons/journal-minus":false,"./icons/journal-plus":false,"./icons/journal-richtext":false,"./icons/journal-text":false,"./icons/journal-x":false,"./icons/journal":false,"./icons/journals":false,"./icons/joystick":false,"./icons/justify-left":false,"./icons/justify-right":false,"./icons/justify":false,"./icons/kanban-fill":false,"./icons/kanban":false,"./icons/key-fill":false,"./icons/key":false,"./icons/keyboard-fill":false,"./icons/keyboard":false,"./icons/ladder":false,"./icons/lamp-fill":false,"./icons/lamp":false,"./icons/laptop-fill":false,"./icons/laptop":false,"./icons/layer-backward":false,"./icons/layer-forward":false,"./icons/layers-fill":false,"./icons/layers-half":false,"./icons/layers":false,"./icons/layout-sidebar-inset-reverse":false,"./icons/layout-sidebar-inset":false,"./icons/layout-sidebar-reverse":false,"./icons/layout-sidebar":false,"./icons/layout-split":false,"./icons/layout-text-sidebar-reverse":false,"./icons/layout-text-sidebar":false,"./icons/layout-text-window-reverse":false,"./icons/layout-text-window":false,"./icons/layout-three-columns":false,"./icons/layout-wtf":false,"./icons/life-preserver":false,"./icons/lightbulb-fill":false,"./icons/lightbulb-off-fill":false,"./icons/lightbulb-off":false,"./icons/lightbulb":false,"./icons/lightning-charge-fill":"aGb77","./icons/lightning-charge":false,"./icons/lightning-fill":false,"./icons/lightning":false,"./icons/line":false,"./icons/link-45deg":"fn9Gy","./icons/link":"hVkPL","./icons/linkedin":false,"./icons/list-check":false,"./icons/list-columns-reverse":false,"./icons/list-columns":false,"./icons/list-nested":false,"./icons/list-ol":false,"./icons/list-stars":false,"./icons/list-task":false,"./icons/list-ul":false,"./icons/list":"9Osc6","./icons/lock-fill":"gAsaK","./icons/lock":false,"./icons/luggage-fill":false,"./icons/luggage":false,"./icons/lungs-fill":false,"./icons/lungs":false,"./icons/magic":false,"./icons/magnet-fill":false,"./icons/magnet":false,"./icons/mailbox-flag":false,"./icons/mailbox":false,"./icons/mailbox2-flag":false,"./icons/mailbox2":false,"./icons/map-fill":false,"./icons/map":false,"./icons/markdown-fill":false,"./icons/markdown":false,"./icons/marker-tip":false,"./icons/mask":false,"./icons/mastodon":false,"./icons/medium":false,"./icons/megaphone-fill":false,"./icons/megaphone":false,"./icons/memory":false,"./icons/menu-app-fill":false,"./icons/menu-app":false,"./icons/menu-button-fill":false,"./icons/menu-button-wide-fill":"1OuD6","./icons/menu-button-wide":false,"./icons/menu-button":false,"./icons/menu-down":false,"./icons/menu-up":false,"./icons/messenger":false,"./icons/meta":false,"./icons/mic-fill":false,"./icons/mic-mute-fill":false,"./icons/mic-mute":false,"./icons/mic":false,"./icons/microsoft-teams":false,"./icons/microsoft":false,"./icons/minecart-loaded":false,"./icons/minecart":false,"./icons/modem-fill":false,"./icons/modem":false,"./icons/moisture":false,"./icons/moon-fill":false,"./icons/moon-stars-fill":false,"./icons/moon-stars":false,"./icons/moon":false,"./icons/mortarboard-fill":false,"./icons/mortarboard":false,"./icons/motherboard-fill":false,"./icons/motherboard":false,"./icons/mouse-fill":false,"./icons/mouse":false,"./icons/mouse2-fill":false,"./icons/mouse2":false,"./icons/mouse3-fill":false,"./icons/mouse3":false,"./icons/music-note-beamed":false,"./icons/music-note-list":false,"./icons/music-note":false,"./icons/music-player-fill":false,"./icons/music-player":false,"./icons/newspaper":false,"./icons/nintendo-switch":false,"./icons/node-minus-fill":false,"./icons/node-minus":false,"./icons/node-plus-fill":false,"./icons/node-plus":false,"./icons/noise-reduction":false,"./icons/nut-fill":false,"./icons/nut":false,"./icons/nvidia":false,"./icons/nvme-fill":false,"./icons/nvme":false,"./icons/octagon-fill":false,"./icons/octagon-half":false,"./icons/octagon":false,"./icons/opencollective":false,"./icons/optical-audio-fill":false,"./icons/optical-audio":false,"./icons/option":false,"./icons/outlet":false,"./icons/p-circle-fill":false,"./icons/p-circle":false,"./icons/p-square-fill":false,"./icons/p-square":false,"./icons/paint-bucket":false,"./icons/palette-fill":false,"./icons/palette":false,"./icons/palette2":false,"./icons/paperclip":false,"./icons/paragraph":false,"./icons/pass-fill":false,"./icons/pass":false,"./icons/passport-fill":false,"./icons/passport":false,"./icons/patch-check-fill":false,"./icons/patch-check":false,"./icons/patch-exclamation-fill":false,"./icons/patch-exclamation":false,"./icons/patch-minus-fill":false,"./icons/patch-minus":false,"./icons/patch-plus-fill":false,"./icons/patch-plus":false,"./icons/patch-question-fill":false,"./icons/patch-question":false,"./icons/pause-btn-fill":false,"./icons/pause-btn":false,"./icons/pause-circle-fill":false,"./icons/pause-circle":false,"./icons/pause-fill":false,"./icons/pause":false,"./icons/paypal":false,"./icons/pc-display-horizontal":false,"./icons/pc-display":false,"./icons/pc-horizontal":false,"./icons/pc":false,"./icons/pci-card-network":false,"./icons/pci-card-sound":false,"./icons/pci-card":false,"./icons/peace-fill":false,"./icons/peace":false,"./icons/pen-fill":false,"./icons/pen":false,"./icons/pencil-fill":"iG3vO","./icons/pencil-square":"8aCeN","./icons/pencil":false,"./icons/pentagon-fill":false,"./icons/pentagon-half":false,"./icons/pentagon":false,"./icons/people-fill":false,"./icons/people":false,"./icons/percent":false,"./icons/person-add":false,"./icons/person-arms-up":false,"./icons/person-badge-fill":false,"./icons/person-badge":false,"./icons/person-bounding-box":false,"./icons/person-check-fill":false,"./icons/person-check":false,"./icons/person-circle":false,"./icons/person-dash-fill":false,"./icons/person-dash":false,"./icons/person-down":false,"./icons/person-exclamation":false,"./icons/person-fill-add":false,"./icons/person-fill-check":false,"./icons/person-fill-dash":false,"./icons/person-fill-down":false,"./icons/person-fill-exclamation":false,"./icons/person-fill-gear":false,"./icons/person-fill-lock":false,"./icons/person-fill-slash":false,"./icons/person-fill-up":false,"./icons/person-fill-x":false,"./icons/person-fill":false,"./icons/person-gear":false,"./icons/person-heart":false,"./icons/person-hearts":false,"./icons/person-lines-fill":false,"./icons/person-lock":false,"./icons/person-plus-fill":false,"./icons/person-plus":false,"./icons/person-raised-hand":false,"./icons/person-rolodex":false,"./icons/person-slash":false,"./icons/person-square":false,"./icons/person-standing-dress":false,"./icons/person-standing":false,"./icons/person-up":false,"./icons/person-vcard-fill":false,"./icons/person-vcard":false,"./icons/person-video":false,"./icons/person-video2":false,"./icons/person-video3":false,"./icons/person-walking":false,"./icons/person-wheelchair":false,"./icons/person-workspace":false,"./icons/person-x-fill":false,"./icons/person-x":false,"./icons/person":false,"./icons/phone-fill":false,"./icons/phone-flip":false,"./icons/phone-landscape-fill":false,"./icons/phone-landscape":false,"./icons/phone-vibrate-fill":false,"./icons/phone-vibrate":false,"./icons/phone":false,"./icons/pie-chart-fill":false,"./icons/pie-chart":false,"./icons/piggy-bank-fill":false,"./icons/piggy-bank":false,"./icons/pin-angle-fill":false,"./icons/pin-angle":false,"./icons/pin-fill":false,"./icons/pin-map-fill":false,"./icons/pin-map":false,"./icons/pin":false,"./icons/pinterest":false,"./icons/pip-fill":false,"./icons/pip":false,"./icons/play-btn-fill":false,"./icons/play-btn":false,"./icons/play-circle-fill":false,"./icons/play-circle":false,"./icons/play-fill":false,"./icons/play":"fxPJ0","./icons/playstation":false,"./icons/plug-fill":false,"./icons/plug":"eMfL3","./icons/plugin":false,"./icons/plus-circle-dotted":false,"./icons/plus-circle-fill":"iyVs5","./icons/plus-circle":false,"./icons/plus-lg":"dn0fH","./icons/plus-slash-minus":false,"./icons/plus-square-dotted":false,"./icons/plus-square-fill":false,"./icons/plus-square":false,"./icons/plus":"1CYWG","./icons/postage-fill":false,"./icons/postage-heart-fill":false,"./icons/postage-heart":false,"./icons/postage":false,"./icons/postcard-fill":false,"./icons/postcard-heart-fill":false,"./icons/postcard-heart":false,"./icons/postcard":false,"./icons/power":false,"./icons/prescription":false,"./icons/prescription2":false,"./icons/printer-fill":false,"./icons/printer":false,"./icons/projector-fill":false,"./icons/projector":false,"./icons/puzzle-fill":false,"./icons/puzzle":false,"./icons/qr-code-scan":false,"./icons/qr-code":false,"./icons/question-circle-fill":false,"./icons/question-circle":false,"./icons/question-diamond-fill":false,"./icons/question-diamond":false,"./icons/question-lg":false,"./icons/question-octagon-fill":false,"./icons/question-octagon":false,"./icons/question-square-fill":false,"./icons/question-square":false,"./icons/question":false,"./icons/quora":false,"./icons/quote":false,"./icons/r-circle-fill":false,"./icons/r-circle":false,"./icons/r-square-fill":false,"./icons/r-square":false,"./icons/radar":false,"./icons/radioactive":false,"./icons/rainbow":false,"./icons/receipt-cutoff":false,"./icons/receipt":false,"./icons/reception-0":false,"./icons/reception-1":false,"./icons/reception-2":false,"./icons/reception-3":false,"./icons/reception-4":false,"./icons/record-btn-fill":false,"./icons/record-btn":false,"./icons/record-circle-fill":false,"./icons/record-circle":false,"./icons/record-fill":false,"./icons/record":false,"./icons/record2-fill":false,"./icons/record2":false,"./icons/recycle":false,"./icons/reddit":false,"./icons/regex":false,"./icons/repeat-1":false,"./icons/repeat":false,"./icons/reply-all-fill":false,"./icons/reply-all":false,"./icons/reply-fill":false,"./icons/reply":false,"./icons/rewind-btn-fill":false,"./icons/rewind-btn":false,"./icons/rewind-circle-fill":false,"./icons/rewind-circle":false,"./icons/rewind-fill":false,"./icons/rewind":false,"./icons/robot":false,"./icons/rocket-fill":false,"./icons/rocket-takeoff-fill":false,"./icons/rocket-takeoff":false,"./icons/rocket":false,"./icons/router-fill":false,"./icons/router":false,"./icons/rss-fill":false,"./icons/rss":false,"./icons/rulers":false,"./icons/safe-fill":false,"./icons/safe":false,"./icons/safe2-fill":false,"./icons/safe2":false,"./icons/save-fill":false,"./icons/save":false,"./icons/save2-fill":false,"./icons/save2":false,"./icons/scissors":"gTEPG","./icons/scooter":false,"./icons/screwdriver":false,"./icons/sd-card-fill":false,"./icons/sd-card":false,"./icons/search-heart-fill":false,"./icons/search-heart":false,"./icons/search":false,"./icons/segmented-nav":false,"./icons/send-arrow-down-fill":false,"./icons/send-arrow-down":false,"./icons/send-arrow-up-fill":false,"./icons/send-arrow-up":false,"./icons/send-check-fill":false,"./icons/send-check":false,"./icons/send-dash-fill":false,"./icons/send-dash":false,"./icons/send-exclamation-fill":false,"./icons/send-exclamation":false,"./icons/send-fill":false,"./icons/send-plus-fill":false,"./icons/send-plus":false,"./icons/send-slash-fill":false,"./icons/send-slash":false,"./icons/send-x-fill":false,"./icons/send-x":false,"./icons/send":false,"./icons/server":"8BnvQ","./icons/shadows":false,"./icons/share-fill":false,"./icons/share":false,"./icons/shield-check":false,"./icons/shield-exclamation":false,"./icons/shield-fill-check":false,"./icons/shield-fill-exclamation":false,"./icons/shield-fill-minus":false,"./icons/shield-fill-plus":false,"./icons/shield-fill-x":false,"./icons/shield-fill":false,"./icons/shield-lock-fill":false,"./icons/shield-lock":false,"./icons/shield-minus":false,"./icons/shield-plus":false,"./icons/shield-shaded":false,"./icons/shield-slash-fill":false,"./icons/shield-slash":false,"./icons/shield-x":false,"./icons/shield":false,"./icons/shift-fill":false,"./icons/shift":false,"./icons/shop-window":false,"./icons/shop":false,"./icons/shuffle":"7DNSM","./icons/sign-dead-end-fill":false,"./icons/sign-dead-end":false,"./icons/sign-do-not-enter-fill":false,"./icons/sign-do-not-enter":false,"./icons/sign-intersection-fill":false,"./icons/sign-intersection-side-fill":false,"./icons/sign-intersection-side":false,"./icons/sign-intersection-t-fill":false,"./icons/sign-intersection-t":false,"./icons/sign-intersection-y-fill":false,"./icons/sign-intersection-y":false,"./icons/sign-intersection":false,"./icons/sign-merge-left-fill":false,"./icons/sign-merge-left":false,"./icons/sign-merge-right-fill":false,"./icons/sign-merge-right":false,"./icons/sign-no-left-turn-fill":false,"./icons/sign-no-left-turn":false,"./icons/sign-no-parking-fill":false,"./icons/sign-no-parking":false,"./icons/sign-no-right-turn-fill":false,"./icons/sign-no-right-turn":false,"./icons/sign-railroad-fill":false,"./icons/sign-railroad":false,"./icons/sign-stop-fill":false,"./icons/sign-stop-lights-fill":false,"./icons/sign-stop-lights":false,"./icons/sign-stop":false,"./icons/sign-turn-left-fill":false,"./icons/sign-turn-left":false,"./icons/sign-turn-right-fill":false,"./icons/sign-turn-right":false,"./icons/sign-turn-slight-left-fill":false,"./icons/sign-turn-slight-left":false,"./icons/sign-turn-slight-right-fill":false,"./icons/sign-turn-slight-right":false,"./icons/sign-yield-fill":false,"./icons/sign-yield":false,"./icons/signal":false,"./icons/signpost-2-fill":false,"./icons/signpost-2":false,"./icons/signpost-fill":false,"./icons/signpost-split-fill":false,"./icons/signpost-split":false,"./icons/signpost":false,"./icons/sim-fill":false,"./icons/sim-slash-fill":false,"./icons/sim-slash":false,"./icons/sim":false,"./icons/sina-weibo":false,"./icons/skip-backward-btn-fill":false,"./icons/skip-backward-btn":false,"./icons/skip-backward-circle-fill":false,"./icons/skip-backward-circle":false,"./icons/skip-backward-fill":false,"./icons/skip-backward":false,"./icons/skip-end-btn-fill":false,"./icons/skip-end-btn":false,"./icons/skip-end-circle-fill":false,"./icons/skip-end-circle":false,"./icons/skip-end-fill":false,"./icons/skip-end":false,"./icons/skip-forward-btn-fill":false,"./icons/skip-forward-btn":false,"./icons/skip-forward-circle-fill":false,"./icons/skip-forward-circle":false,"./icons/skip-forward-fill":false,"./icons/skip-forward":false,"./icons/skip-start-btn-fill":false,"./icons/skip-start-btn":false,"./icons/skip-start-circle-fill":false,"./icons/skip-start-circle":false,"./icons/skip-start-fill":false,"./icons/skip-start":false,"./icons/skype":false,"./icons/slack":false,"./icons/slash-circle-fill":false,"./icons/slash-circle":false,"./icons/slash-lg":false,"./icons/slash-square-fill":false,"./icons/slash-square":false,"./icons/slash":false,"./icons/sliders":false,"./icons/sliders2-vertical":false,"./icons/sliders2":false,"./icons/smartwatch":false,"./icons/snapchat":false,"./icons/snow":false,"./icons/snow2":false,"./icons/snow3":false,"./icons/sort-alpha-down-alt":false,"./icons/sort-alpha-down":false,"./icons/sort-alpha-up-alt":false,"./icons/sort-alpha-up":false,"./icons/sort-down-alt":false,"./icons/sort-down":false,"./icons/sort-numeric-down-alt":false,"./icons/sort-numeric-down":false,"./icons/sort-numeric-up-alt":false,"./icons/sort-numeric-up":false,"./icons/sort-up-alt":false,"./icons/sort-up":false,"./icons/soundwave":false,"./icons/sourceforge":false,"./icons/speaker-fill":false,"./icons/speaker":false,"./icons/speedometer":false,"./icons/speedometer2":false,"./icons/spellcheck":false,"./icons/spotify":false,"./icons/square-fill":false,"./icons/square-half":false,"./icons/square":false,"./icons/stack-overflow":false,"./icons/stack":"jeGC2","./icons/star-fill":false,"./icons/star-half":false,"./icons/star":false,"./icons/stars":false,"./icons/steam":false,"./icons/stickies-fill":false,"./icons/stickies":false,"./icons/sticky-fill":false,"./icons/sticky":false,"./icons/stop-btn-fill":false,"./icons/stop-btn":false,"./icons/stop-circle-fill":false,"./icons/stop-circle":false,"./icons/stop-fill":false,"./icons/stop":false,"./icons/stoplights-fill":false,"./icons/stoplights":false,"./icons/stopwatch-fill":false,"./icons/stopwatch":false,"./icons/strava":false,"./icons/stripe":false,"./icons/subscript":false,"./icons/substack":false,"./icons/subtract":false,"./icons/suit-club-fill":false,"./icons/suit-club":false,"./icons/suit-diamond-fill":false,"./icons/suit-diamond":false,"./icons/suit-heart-fill":false,"./icons/suit-heart":false,"./icons/suit-spade-fill":false,"./icons/suit-spade":false,"./icons/suitcase-fill":false,"./icons/suitcase-lg-fill":false,"./icons/suitcase-lg":false,"./icons/suitcase":false,"./icons/suitcase2-fill":false,"./icons/suitcase2":false,"./icons/sun-fill":false,"./icons/sun":false,"./icons/sunglasses":false,"./icons/sunrise-fill":false,"./icons/sunrise":false,"./icons/sunset-fill":false,"./icons/sunset":false,"./icons/superscript":false,"./icons/symmetry-horizontal":false,"./icons/symmetry-vertical":false,"./icons/table":false,"./icons/tablet-fill":false,"./icons/tablet-landscape-fill":false,"./icons/tablet-landscape":false,"./icons/tablet":false,"./icons/tag-fill":false,"./icons/tag":false,"./icons/tags-fill":false,"./icons/tags":false,"./icons/taxi-front-fill":false,"./icons/taxi-front":false,"./icons/telegram":false,"./icons/telephone-fill":false,"./icons/telephone-forward-fill":false,"./icons/telephone-forward":false,"./icons/telephone-inbound-fill":false,"./icons/telephone-inbound":false,"./icons/telephone-minus-fill":false,"./icons/telephone-minus":false,"./icons/telephone-outbound-fill":false,"./icons/telephone-outbound":false,"./icons/telephone-plus-fill":false,"./icons/telephone-plus":false,"./icons/telephone-x-fill":false,"./icons/telephone-x":false,"./icons/telephone":false,"./icons/tencent-qq":false,"./icons/terminal-dash":false,"./icons/terminal-fill":false,"./icons/terminal-plus":false,"./icons/terminal-split":false,"./icons/terminal-x":false,"./icons/terminal":false,"./icons/text-center":false,"./icons/text-indent-left":false,"./icons/text-indent-right":false,"./icons/text-left":false,"./icons/text-paragraph":false,"./icons/text-right":false,"./icons/text-wrap":false,"./icons/textarea-resize":false,"./icons/textarea-t":false,"./icons/textarea":false,"./icons/thermometer-half":false,"./icons/thermometer-high":false,"./icons/thermometer-low":false,"./icons/thermometer-snow":false,"./icons/thermometer-sun":false,"./icons/thermometer":false,"./icons/threads-fill":false,"./icons/threads":false,"./icons/three-dots-vertical":false,"./icons/three-dots":"adrID","./icons/thunderbolt-fill":false,"./icons/thunderbolt":false,"./icons/ticket-detailed-fill":false,"./icons/ticket-detailed":false,"./icons/ticket-fill":false,"./icons/ticket-perforated-fill":false,"./icons/ticket-perforated":false,"./icons/ticket":false,"./icons/tiktok":false,"./icons/toggle-off":false,"./icons/toggle-on":"k2ZQa","./icons/toggle2-off":false,"./icons/toggle2-on":false,"./icons/toggles":false,"./icons/toggles2":false,"./icons/tools":false,"./icons/tornado":false,"./icons/train-freight-front-fill":false,"./icons/train-freight-front":false,"./icons/train-front-fill":false,"./icons/train-front":false,"./icons/train-lightrail-front-fill":false,"./icons/train-lightrail-front":false,"./icons/translate":"iXWxf","./icons/transparency":false,"./icons/trash-fill":"8mJdu","./icons/trash":false,"./icons/trash2-fill":"jtxl7","./icons/trash2":false,"./icons/trash3-fill":false,"./icons/trash3":false,"./icons/tree-fill":false,"./icons/tree":false,"./icons/trello":false,"./icons/triangle-fill":false,"./icons/triangle-half":false,"./icons/triangle":false,"./icons/trophy-fill":false,"./icons/trophy":false,"./icons/tropical-storm":false,"./icons/truck-flatbed":false,"./icons/truck-front-fill":false,"./icons/truck-front":false,"./icons/truck":false,"./icons/tsunami":false,"./icons/tv-fill":false,"./icons/tv":false,"./icons/twitch":false,"./icons/twitter-x":false,"./icons/twitter":false,"./icons/type-bold":false,"./icons/type-h1":false,"./icons/type-h2":false,"./icons/type-h3":false,"./icons/type-h4":false,"./icons/type-h5":false,"./icons/type-h6":false,"./icons/type-italic":false,"./icons/type-strikethrough":false,"./icons/type-underline":false,"./icons/type":false,"./icons/ubuntu":false,"./icons/ui-checks-grid":"gBkoB","./icons/ui-checks":false,"./icons/ui-radios-grid":false,"./icons/ui-radios":"85iuo","./icons/umbrella-fill":false,"./icons/umbrella":false,"./icons/unindent":false,"./icons/union":false,"./icons/unity":false,"./icons/universal-access-circle":false,"./icons/universal-access":false,"./icons/unlock-fill":false,"./icons/unlock":false,"./icons/upc-scan":false,"./icons/upc":false,"./icons/upload":false,"./icons/usb-c-fill":false,"./icons/usb-c":false,"./icons/usb-drive-fill":false,"./icons/usb-drive":false,"./icons/usb-fill":false,"./icons/usb-micro-fill":false,"./icons/usb-micro":false,"./icons/usb-mini-fill":false,"./icons/usb-mini":false,"./icons/usb-plug-fill":false,"./icons/usb-plug":false,"./icons/usb-symbol":false,"./icons/usb":false,"./icons/valentine":false,"./icons/valentine2":false,"./icons/vector-pen":false,"./icons/view-list":false,"./icons/view-stacked":false,"./icons/vignette":false,"./icons/vimeo":false,"./icons/vinyl-fill":false,"./icons/vinyl":false,"./icons/virus":false,"./icons/virus2":false,"./icons/voicemail":false,"./icons/volume-down-fill":false,"./icons/volume-down":false,"./icons/volume-mute-fill":false,"./icons/volume-mute":false,"./icons/volume-off-fill":false,"./icons/volume-off":false,"./icons/volume-up-fill":false,"./icons/volume-up":false,"./icons/vr":false,"./icons/wallet-fill":false,"./icons/wallet":false,"./icons/wallet2":false,"./icons/watch":false,"./icons/water":false,"./icons/webcam-fill":false,"./icons/webcam":false,"./icons/wechat":false,"./icons/whatsapp":false,"./icons/wifi-1":false,"./icons/wifi-2":false,"./icons/wifi-off":false,"./icons/wifi":false,"./icons/wikipedia":false,"./icons/wind":false,"./icons/window-dash":false,"./icons/window-desktop":false,"./icons/window-dock":false,"./icons/window-fullscreen":false,"./icons/window-plus":false,"./icons/window-sidebar":false,"./icons/window-split":false,"./icons/window-stack":false,"./icons/window-x":false,"./icons/window":false,"./icons/windows":false,"./icons/wordpress":false,"./icons/wrench-adjustable-circle-fill":false,"./icons/wrench-adjustable-circle":false,"./icons/wrench-adjustable":false,"./icons/wrench":false,"./icons/x-circle-fill":"kdwgI","./icons/x-circle":false,"./icons/x-diamond-fill":false,"./icons/x-diamond":false,"./icons/x-lg":"kYhWv","./icons/x-octagon-fill":false,"./icons/x-octagon":false,"./icons/x-square-fill":false,"./icons/x-square":false,"./icons/x":"cFbxT","./icons/xbox":false,"./icons/yelp":false,"./icons/yin-yang":false,"./icons/youtube":false,"./icons/zoom-in":false,"./icons/zoom-out":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bOszT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ArrowBarDown = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-bar-down',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5M8 6a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 .708-.708L7.5 12.293V6.5A.5.5 0 0 1 8 6"
    }));
});
ArrowBarDown.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ArrowBarDown.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ArrowBarDown;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ju96a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ArrowBarLeft = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-bar-left',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5"
    }));
});
ArrowBarLeft.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ArrowBarLeft.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ArrowBarLeft;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hpIn2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ArrowBarRight = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-bar-right',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8m-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5"
    }));
});
ArrowBarRight.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ArrowBarRight.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ArrowBarRight;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cC1EG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ArrowBarUp = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-bar-up',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M8 10a.5.5 0 0 0 .5-.5V3.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 3.707V9.5a.5.5 0 0 0 .5.5m-7 2.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5"
    }));
});
ArrowBarUp.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ArrowBarUp.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ArrowBarUp;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4c6I4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ArrowClockwise = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-clockwise',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"
    }));
});
ArrowClockwise.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ArrowClockwise.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ArrowClockwise;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gpQFK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ArrowCounterclockwise = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-counterclockwise',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466"
    }));
});
ArrowCounterclockwise.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ArrowCounterclockwise.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ArrowCounterclockwise;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dTmMI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ArrowDownCircle = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-down-circle',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"
    }));
});
ArrowDownCircle.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ArrowDownCircle.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ArrowDownCircle;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ipFpD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ArrowLeftCircleFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-left-circle-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
    }));
});
ArrowLeftCircleFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ArrowLeftCircleFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ArrowLeftCircleFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5cdV9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ArrowLeftRight = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-left-right',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"
    }));
});
ArrowLeftRight.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ArrowLeftRight.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ArrowLeftRight;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4TXZB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ArrowRight = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-right',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
    }));
});
ArrowRight.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ArrowRight.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ArrowRight;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1M5zC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var BoxArrowInRight = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-box-arrow-in-right',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
    }));
});
BoxArrowInRight.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
BoxArrowInRight.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = BoxArrowInRight;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a6Y2M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var BoxSeam = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-box-seam',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2zm3.564 1.426L5.596 5 8 5.961 14.154 3.5zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z"
    }));
});
BoxSeam.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
BoxSeam.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = BoxSeam;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4y3kH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Box = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-box',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z"
    }));
});
Box.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Box.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Box;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cHLpS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Braces = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-braces',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M2.114 8.063V7.9c1.005-.102 1.497-.615 1.497-1.6V4.503c0-1.094.39-1.538 1.354-1.538h.273V2h-.376C3.25 2 2.49 2.759 2.49 4.352v1.524c0 1.094-.376 1.456-1.49 1.456v1.299c1.114 0 1.49.362 1.49 1.456v1.524c0 1.593.759 2.352 2.372 2.352h.376v-.964h-.273c-.964 0-1.354-.444-1.354-1.538V9.663c0-.984-.492-1.497-1.497-1.6M13.886 7.9v.163c-1.005.103-1.497.616-1.497 1.6v1.798c0 1.094-.39 1.538-1.354 1.538h-.273v.964h.376c1.613 0 2.372-.759 2.372-2.352v-1.524c0-1.094.376-1.456 1.49-1.456V7.332c-1.114 0-1.49-.362-1.49-1.456V4.352C13.51 2.759 12.75 2 11.138 2h-.376v.964h.273c.964 0 1.354.444 1.354 1.538V6.3c0 .984.492 1.497 1.497 1.6"
    }));
});
Braces.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Braces.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Braces;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7kzQA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Briefcase = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-briefcase',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5m1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0M1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5"
    }));
});
Briefcase.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Briefcase.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Briefcase;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Ol6k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Camera2 = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-camera2',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M5 8c0-1.657 2.343-3 4-3V4a4 4 0 0 0-4 4"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M12.318 3h2.015C15.253 3 16 3.746 16 4.667v6.666c0 .92-.746 1.667-1.667 1.667h-2.015A5.97 5.97 0 0 1 9 14a5.97 5.97 0 0 1-3.318-1H1.667C.747 13 0 12.254 0 11.333V4.667C0 3.747.746 3 1.667 3H2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1h.682A5.97 5.97 0 0 1 9 2c1.227 0 2.367.368 3.318 1M2 4.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M14 8A5 5 0 1 0 4 8a5 5 0 0 0 10 0"
    }));
});
Camera2.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Camera2.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Camera2;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6i3rK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var CardText = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-card-text',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M3 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8m0 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"
    }));
});
CardText.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
CardText.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = CardText;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8waNh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var CaretDown = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-caret-down',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M3.204 5h9.592L8 10.481zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659"
    }));
});
CaretDown.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
CaretDown.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = CaretDown;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fV8ZV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var CaretRight = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-caret-right',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6 12.796V3.204L11.481 8zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753"
    }));
});
CaretRight.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
CaretRight.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = CaretRight;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"27PO9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var CheckCircleFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-check-circle-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
    }));
});
CheckCircleFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
CheckCircleFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = CheckCircleFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kiC8I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ClipboardCheckFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-clipboard-check-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5zm6.854 7.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708"
    }));
});
ClipboardCheckFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ClipboardCheckFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ClipboardCheckFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fVpSE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ClipboardFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-clipboard-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M10 1.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-5 0A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5v1A1.5 1.5 0 0 1 9.5 4h-3A1.5 1.5 0 0 1 5 2.5zm-2 0h1v1A2.5 2.5 0 0 0 6.5 5h3A2.5 2.5 0 0 0 12 2.5v-1h1a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2"
    }));
});
ClipboardFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ClipboardFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ClipboardFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kjYrs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Clipboard = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-clipboard',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z"
    }));
});
Clipboard.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Clipboard.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Clipboard;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Upys":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var CloudLightningRainFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-cloud-lightning-rain-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M2.658 11.026a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316m9.5 0a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316m-7.5 1.5a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316m9.5 0a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316m-7.105-1.25A.5.5 0 0 1 7.5 11h1a.5.5 0 0 1 .474.658l-.28.842H9.5a.5.5 0 0 1 .39.812l-2 2.5a.5.5 0 0 1-.875-.433L7.36 14H6.5a.5.5 0 0 1-.447-.724zm6.352-7.249a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973"
    }));
});
CloudLightningRainFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
CloudLightningRainFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = CloudLightningRainFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cOawj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var CloudUpload = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-cloud-upload',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708z"
    }));
});
CloudUpload.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
CloudUpload.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = CloudUpload;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kggtA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var CollectionFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-collection-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6zM2 3a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 0-1h-11A.5.5 0 0 0 2 3m2-2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7A.5.5 0 0 0 4 1"
    }));
});
CollectionFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
CollectionFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = CollectionFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"loru3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Cursor = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-cursor',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103zM2.25 8.184l3.897 1.67a.5.5 0 0 1 .262.263l1.67 3.897L12.743 3.52z"
    }));
});
Cursor.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Cursor.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Cursor;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aWvxp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var DashCircleFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-dash-circle-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
    }));
});
DashCircleFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
DashCircleFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = DashCircleFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jOxRn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Diagram2Fill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-diagram-2-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 5 7h2.5V6A1.5 1.5 0 0 1 6 4.5zm-3 8A1.5 1.5 0 0 1 4.5 10h1A1.5 1.5 0 0 1 7 11.5v1A1.5 1.5 0 0 1 5.5 14h-1A1.5 1.5 0 0 1 3 12.5zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 9 12.5z"
    }));
});
Diagram2Fill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Diagram2Fill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Diagram2Fill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fHqj5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var DiamondHalf = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-diamond-half',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098zM8 .989c.127 0 .253.049.35.145l6.516 6.516a.495.495 0 0 1 0 .7L8.35 14.866a.5.5 0 0 1-.35.145z"
    }));
});
DiamondHalf.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
DiamondHalf.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = DiamondHalf;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Hnpi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ExclamationDiamondFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-exclamation-diamond-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
    }));
});
ExclamationDiamondFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ExclamationDiamondFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ExclamationDiamondFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"itQo2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ExclamationSquareFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-exclamation-square-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm6 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
    }));
});
ExclamationSquareFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ExclamationSquareFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ExclamationSquareFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ZDc8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var EyeSlash = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-eye-slash',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"
    }));
});
EyeSlash.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
EyeSlash.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = EyeSlash;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bz6ut":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Eye = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-eye',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"
    }));
});
Eye.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Eye.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Eye;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jYKSY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var FileArrowDown = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-file-arrow-down',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M8 5a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5A.5.5 0 0 1 8 5"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1"
    }));
});
FileArrowDown.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
FileArrowDown.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = FileArrowDown;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"anbkJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var FilePerson = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-file-person',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M12 1a1 1 0 0 1 1 1v10.755S12 11 8 11s-5 1.755-5 1.755V2a1 1 0 0 1 1-1zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M8 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
    }));
});
FilePerson.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
FilePerson.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = FilePerson;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2uvgb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var FilePlus = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-file-plus',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M8.5 6a.5.5 0 0 0-1 0v1.5H6a.5.5 0 0 0 0 1h1.5V10a.5.5 0 0 0 1 0V8.5H10a.5.5 0 0 0 0-1H8.5z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1"
    }));
});
FilePlus.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
FilePlus.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = FilePlus;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2WKOs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var FileRichtext = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-file-richtext',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M7 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V7.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V7s1.54-1.274 1.639-1.208M5 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1"
    }));
});
FileRichtext.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
FileRichtext.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = FileRichtext;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b0TyQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var FileSpreadsheet = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-file-spreadsheet',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v4h10V2a1 1 0 0 0-1-1zm9 6h-3v2h3zm0 3h-3v2h3zm0 3h-3v2h2a1 1 0 0 0 1-1zm-4 2v-2H6v2zm-4 0v-2H3v1a1 1 0 0 0 1 1zm-2-3h2v-2H3zm0-3h2V7H3zm3-2v2h3V7zm3 3H6v2h3z"
    }));
});
FileSpreadsheet.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
FileSpreadsheet.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = FileSpreadsheet;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7JFuM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var File = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-file',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1"
    }));
});
File.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
File.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = File;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2HHcO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var GripHorizontal = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-grip-horizontal',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M2 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
    }));
});
GripHorizontal.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
GripHorizontal.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = GripHorizontal;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"65wse":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var HandIndexThumb = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-hand-index-thumb',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6.75 1a.75.75 0 0 1 .75.75V8a.5.5 0 0 0 1 0V5.467l.086-.004c.317-.012.637-.008.816.027.134.027.294.096.448.182.077.042.15.147.15.314V8a.5.5 0 0 0 1 0V6.435l.106-.01c.316-.024.584-.01.708.04.118.046.3.207.486.43.081.096.15.19.2.259V8.5a.5.5 0 1 0 1 0v-1h.342a1 1 0 0 1 .995 1.1l-.271 2.715a2.5 2.5 0 0 1-.317.991l-1.395 2.442a.5.5 0 0 1-.434.252H6.118a.5.5 0 0 1-.447-.276l-1.232-2.465-2.512-4.185a.517.517 0 0 1 .809-.631l2.41 2.41A.5.5 0 0 0 6 9.5V1.75A.75.75 0 0 1 6.75 1M8.5 4.466V1.75a1.75 1.75 0 1 0-3.5 0v6.543L3.443 6.736A1.517 1.517 0 0 0 1.07 8.588l2.491 4.153 1.215 2.43A1.5 1.5 0 0 0 6.118 16h6.302a1.5 1.5 0 0 0 1.302-.756l1.395-2.441a3.5 3.5 0 0 0 .444-1.389l.271-2.715a2 2 0 0 0-1.99-2.199h-.581a5 5 0 0 0-.195-.248c-.191-.229-.51-.568-.88-.716-.364-.146-.846-.132-1.158-.108l-.132.012a1.26 1.26 0 0 0-.56-.642 2.6 2.6 0 0 0-.738-.288c-.31-.062-.739-.058-1.05-.046zm2.094 2.025"
    }));
});
HandIndexThumb.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
HandIndexThumb.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = HandIndexThumb;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Kckt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var HouseDoorFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-house-door-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5"
    }));
});
HouseDoorFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
HouseDoorFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = HouseDoorFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aA9fB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var InputCursorText = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-input-cursor-text',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M5 2a.5.5 0 0 1 .5-.5c.862 0 1.573.287 2.06.566.174.099.321.198.44.286.119-.088.266-.187.44-.286A4.17 4.17 0 0 1 10.5 1.5a.5.5 0 0 1 0 1c-.638 0-1.177.213-1.564.434a3.5 3.5 0 0 0-.436.294V7.5H9a.5.5 0 0 1 0 1h-.5v4.272c.1.08.248.187.436.294.387.221.926.434 1.564.434a.5.5 0 0 1 0 1 4.17 4.17 0 0 1-2.06-.566A5 5 0 0 1 8 13.65a5 5 0 0 1-.44.285 4.17 4.17 0 0 1-2.06.566.5.5 0 0 1 0-1c.638 0 1.177-.213 1.564-.434.188-.107.335-.214.436-.294V8.5H7a.5.5 0 0 1 0-1h.5V3.228a3.5 3.5 0 0 0-.436-.294A3.17 3.17 0 0 0 5.5 2.5.5.5 0 0 1 5 2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"
    }));
});
InputCursorText.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
InputCursorText.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = InputCursorText;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aGb77":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var LightningChargeFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-lightning-charge-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09z"
    }));
});
LightningChargeFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
LightningChargeFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = LightningChargeFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fn9Gy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Link45deg = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-link-45deg',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"
    }));
});
Link45deg.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Link45deg.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Link45deg;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hVkPL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Link = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-link',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9q-.13 0-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4 4 0 0 1-.82 1H12a3 3 0 1 0 0-6z"
    }));
});
Link.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Link.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Link;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Osc6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var List = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-list',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
    }));
});
List.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
List.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = List;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gAsaK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var LockFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-lock-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2"
    }));
});
LockFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
LockFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = LockFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1OuD6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var MenuButtonWideFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-menu-button-wide-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h13A1.5 1.5 0 0 0 16 3.5v-2A1.5 1.5 0 0 0 14.5 0zm1 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1m9.927.427A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"
    }));
});
MenuButtonWideFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
MenuButtonWideFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = MenuButtonWideFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iG3vO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var PencilFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-pencil-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"
    }));
});
PencilFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
PencilFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = PencilFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8aCeN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var PencilSquare = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-pencil-square',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
    }));
});
PencilSquare.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
PencilSquare.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = PencilSquare;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fxPJ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Play = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-play',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M10.804 8 5 4.633v6.734zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696z"
    }));
});
Play.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Play.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Play;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eMfL3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Plug = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-plug',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6 0a.5.5 0 0 1 .5.5V3h3V.5a.5.5 0 0 1 1 0V3h1a.5.5 0 0 1 .5.5v3A3.5 3.5 0 0 1 8.5 10c-.002.434-.01.845-.04 1.22-.041.514-.126 1.003-.317 1.424a2.08 2.08 0 0 1-.97 1.028C6.725 13.9 6.169 14 5.5 14c-.998 0-1.61.33-1.974.718A1.92 1.92 0 0 0 3 16H2c0-.616.232-1.367.797-1.968C3.374 13.42 4.261 13 5.5 13c.581 0 .962-.088 1.218-.219.241-.123.4-.3.514-.55.121-.266.193-.621.23-1.09.027-.34.035-.718.037-1.141A3.5 3.5 0 0 1 4 6.5v-3a.5.5 0 0 1 .5-.5h1V.5A.5.5 0 0 1 6 0M5 4v2.5A2.5 2.5 0 0 0 7.5 9h1A2.5 2.5 0 0 0 11 6.5V4z"
    }));
});
Plug.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Plug.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Plug;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iyVs5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var PlusCircleFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-plus-circle-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z"
    }));
});
PlusCircleFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
PlusCircleFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = PlusCircleFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dn0fH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var PlusLg = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-plus-lg',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
    }));
});
PlusLg.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
PlusLg.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = PlusLg;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1CYWG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Plus = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-plus',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"
    }));
});
Plus.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Plus.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Plus;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gTEPG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Scissors = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-scissors',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M3.5 3.5c-.614-.884-.074-1.962.858-2.5L8 7.226 11.642 1c.932.538 1.472 1.616.858 2.5L8.81 8.61l1.556 2.661a2.5 2.5 0 1 1-.794.637L8 9.73l-1.572 2.177a2.5 2.5 0 1 1-.794-.637L7.19 8.61zm2.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m7 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"
    }));
});
Scissors.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Scissors.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Scissors;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8BnvQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Server = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-server',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M1.333 2.667C1.333 1.194 4.318 0 8 0s6.667 1.194 6.667 2.667V4c0 1.473-2.985 2.667-6.667 2.667S1.333 5.473 1.333 4z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M1.333 6.334v3C1.333 10.805 4.318 12 8 12s6.667-1.194 6.667-2.667V6.334a6.5 6.5 0 0 1-1.458.79C11.81 7.684 9.967 8 8 8s-3.809-.317-5.208-.876a6.5 6.5 0 0 1-1.458-.79z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M14.667 11.668a6.5 6.5 0 0 1-1.458.789c-1.4.56-3.242.876-5.21.876-1.966 0-3.809-.316-5.208-.876a6.5 6.5 0 0 1-1.458-.79v1.666C1.333 14.806 4.318 16 8 16s6.667-1.194 6.667-2.667z"
    }));
});
Server.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Server.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Server;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7DNSM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Shuffle = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-shuffle',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M0 3.5A.5.5 0 0 1 .5 3H1c2.202 0 3.827 1.24 4.874 2.418.49.552.865 1.102 1.126 1.532.26-.43.636-.98 1.126-1.532C9.173 4.24 10.798 3 13 3v1c-1.798 0-3.173 1.01-4.126 2.082A9.6 9.6 0 0 0 7.556 8a9.6 9.6 0 0 0 1.317 1.918C9.828 10.99 11.204 12 13 12v1c-2.202 0-3.827-1.24-4.874-2.418A10.6 10.6 0 0 1 7 9.05c-.26.43-.636.98-1.126 1.532C4.827 11.76 3.202 13 1 13H.5a.5.5 0 0 1 0-1H1c1.798 0 3.173-1.01 4.126-2.082A9.6 9.6 0 0 0 6.444 8a9.6 9.6 0 0 0-1.317-1.918C4.172 5.01 2.796 4 1 4H.5a.5.5 0 0 1-.5-.5"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M13 5.466V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192m0 9v-3.932a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192"
    }));
});
Shuffle.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Shuffle.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Shuffle;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jeGC2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Stack = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-stack',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m14.12 10.163 1.715.858c.22.11.22.424 0 .534L8.267 15.34a.6.6 0 0 1-.534 0L.165 11.555a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.66zM7.733.063a.6.6 0 0 1 .534 0l7.568 3.784a.3.3 0 0 1 0 .535L8.267 8.165a.6.6 0 0 1-.534 0L.165 4.382a.299.299 0 0 1 0-.535z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m14.12 6.576 1.715.858c.22.11.22.424 0 .534l-7.568 3.784a.6.6 0 0 1-.534 0L.165 7.968a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0z"
    }));
});
Stack.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Stack.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Stack;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"adrID":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ThreeDots = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-three-dots',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
    }));
});
ThreeDots.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ThreeDots.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ThreeDots;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k2ZQa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ToggleOn = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-toggle-on',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
    }));
});
ToggleOn.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
ToggleOn.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = ToggleOn;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iXWxf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Translate = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-translate',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286zm1.634-.736L5.5 3.956h-.049l-.679 2.022z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm7.138 9.995q.289.451.63.846c-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6 6 0 0 1-.415-.492 2 2 0 0 1-.94.31"
    }));
});
Translate.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Translate.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Translate;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8mJdu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var TrashFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-trash-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0"
    }));
});
TrashFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
TrashFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = TrashFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jtxl7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Trash2Fill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-trash2-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M2.037 3.225A.7.7 0 0 1 2 3c0-1.105 2.686-2 6-2s6 .895 6 2a.7.7 0 0 1-.037.225l-1.684 10.104A2 2 0 0 1 10.305 15H5.694a2 2 0 0 1-1.973-1.671zm9.89-.69C10.966 2.214 9.578 2 8 2c-1.58 0-2.968.215-3.926.534-.477.16-.795.327-.975.466.18.14.498.307.975.466C5.032 3.786 6.42 4 8 4s2.967-.215 3.926-.534c.477-.16.795-.327.975-.466-.18-.14-.498-.307-.975-.466z"
    }));
});
Trash2Fill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
Trash2Fill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = Trash2Fill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gBkoB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var UiChecksGrid = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-ui-checks-grid',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M2 10h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1m9-9h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1m0 9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zm0-10a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM2 9a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2zm7 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zM0 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm5.354.854a.5.5 0 1 0-.708-.708L3 3.793l-.646-.647a.5.5 0 1 0-.708.708l1 1a.5.5 0 0 0 .708 0z"
    }));
});
UiChecksGrid.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
UiChecksGrid.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = UiChecksGrid;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"85iuo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var UiRadios = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-ui-radios',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M7 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zM0 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0m7-1.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zm0-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M3 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
    }));
});
UiRadios.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
UiRadios.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = UiRadios;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kdwgI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var XCircleFill = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-x-circle-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"
    }));
});
XCircleFill.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
XCircleFill.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = XCircleFill;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kYhWv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var XLg = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-x-lg',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
    }));
});
XLg.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
XLg.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = XLg;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cFbxT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "color",
    "size",
    "title",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var X = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-x',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
    }));
});
X.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    title: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
X.defaultProps = {
    color: 'currentColor',
    size: '1em',
    title: null,
    className: ''
};
exports.default = X;

},{"react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Dluo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormEngineSpinner", ()=>FormEngineSpinner);
parcelHelpers.export(exports, "FormEngineSpinnerBar", ()=>FormEngineSpinnerBar);
parcelHelpers.export(exports, "default", ()=>FormEngineSpinnerBoundary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
function FormEngineSpinner({ children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Spinner), {
        role: "status",
        variant: "primary",
        ...props,
        className: `fe-spinner ${props.className ?? ''}`,
        animation: props.animation || 'border',
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "visually-hidden",
                children: "Loading..."
            })
        ]
    });
}
function FormEngineSpinnerBar({ className, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `fe-spinner-bar ${className}`,
        ...props
    });
}
function FormEngineSpinnerBoundary({ children, show = false, spinner: SpinnerComponent = FormEngineSpinner, bar: BarComponent = FormEngineSpinnerBar, className = '', prepend, append, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            prepend,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `fe-spinner-boundary ${show ? `fe-spinner-boundary--show` : `fe-spinner-boundary--hide`} ${className}`,
                ...props,
                children: [
                    BarComponent && /*#__PURE__*/ (0, _jsxRuntime.jsx)(BarComponent, {}),
                    SpinnerComponent && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SpinnerComponent, {}),
                    children
                ]
            }),
            append
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hPYJl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInert", ()=>useInert);
var _react = require("react");
var _wicgInert = require("wicg-inert");
function useInert(ref, initialValue = false) {
    const [isInert, setIsInert] = (0, _react.useState)(initialValue);
    (0, _react.useEffect)(()=>{
        if (ref.current) {
            if (isInert) ref.current.setAttribute('inert', '');
            else ref.current.removeAttribute('inert');
        }
        return ()=>{
            ref.current?.removeAttribute('inert');
        };
    }, [
        isInert
    ]);
    return [
        isInert,
        setIsInert
    ];
}

},{"react":"9njXz","wicg-inert":"9MlOA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9MlOA":[function(require,module,exports,__globalThis) {
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/**
 * This work is licensed under the W3C Software and Document License
 * (http://www.w3.org/Consortium/Legal/2015/copyright-software-and-document).
 */ (function() {
    // Return early if we're not running inside of the browser.
    if (typeof window === 'undefined' || typeof Element === 'undefined') return;
    // Convenience function for converting NodeLists.
    /** @type {typeof Array.prototype.slice} */ var slice = Array.prototype.slice;
    /**
   * IE has a non-standard name for "matches".
   * @type {typeof Element.prototype.matches}
   */ var matches = Element.prototype.matches || Element.prototype.msMatchesSelector;
    /** @type {string} */ var _focusableElementsString = [
        'a[href]',
        'area[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'button:not([disabled])',
        'details',
        'summary',
        'iframe',
        'object',
        'embed',
        'video',
        '[contenteditable]'
    ].join(',');
    /**
   * `InertRoot` manages a single inert subtree, i.e. a DOM subtree whose root element has an `inert`
   * attribute.
   *
   * Its main functions are:
   *
   * - to create and maintain a set of managed `InertNode`s, including when mutations occur in the
   *   subtree. The `makeSubtreeUnfocusable()` method handles collecting `InertNode`s via registering
   *   each focusable node in the subtree with the singleton `InertManager` which manages all known
   *   focusable nodes within inert subtrees. `InertManager` ensures that a single `InertNode`
   *   instance exists for each focusable node which has at least one inert root as an ancestor.
   *
   * - to notify all managed `InertNode`s when this subtree stops being inert (i.e. when the `inert`
   *   attribute is removed from the root node). This is handled in the destructor, which calls the
   *   `deregister` method on `InertManager` for each managed inert node.
   */ var InertRoot = function() {
        /**
     * @param {!HTMLElement} rootElement The HTMLElement at the root of the inert subtree.
     * @param {!InertManager} inertManager The global singleton InertManager object.
     */ function InertRoot(rootElement, inertManager) {
            _classCallCheck(this, InertRoot);
            /** @type {!InertManager} */ this._inertManager = inertManager;
            /** @type {!HTMLElement} */ this._rootElement = rootElement;
            /**
       * @type {!Set<!InertNode>}
       * All managed focusable nodes in this InertRoot's subtree.
       */ this._managedNodes = new Set();
            // Make the subtree hidden from assistive technology
            if (this._rootElement.hasAttribute('aria-hidden')) /** @type {?string} */ this._savedAriaHidden = this._rootElement.getAttribute('aria-hidden');
            else this._savedAriaHidden = null;
            this._rootElement.setAttribute('aria-hidden', 'true');
            // Make all focusable elements in the subtree unfocusable and add them to _managedNodes
            this._makeSubtreeUnfocusable(this._rootElement);
            // Watch for:
            // - any additions in the subtree: make them unfocusable too
            // - any removals from the subtree: remove them from this inert root's managed nodes
            // - attribute changes: if `tabindex` is added, or removed from an intrinsically focusable
            //   element, make that node a managed node.
            this._observer = new MutationObserver(this._onMutation.bind(this));
            this._observer.observe(this._rootElement, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        /**
     * Call this whenever this object is about to become obsolete.  This unwinds all of the state
     * stored in this object and updates the state of all of the managed nodes.
     */ _createClass(InertRoot, [
            {
                key: 'destructor',
                value: function destructor() {
                    this._observer.disconnect();
                    if (this._rootElement) {
                        if (this._savedAriaHidden !== null) this._rootElement.setAttribute('aria-hidden', this._savedAriaHidden);
                        else this._rootElement.removeAttribute('aria-hidden');
                    }
                    this._managedNodes.forEach(function(inertNode) {
                        this._unmanageNode(inertNode.node);
                    }, this);
                    // Note we cast the nulls to the ANY type here because:
                    // 1) We want the class properties to be declared as non-null, or else we
                    //    need even more casts throughout this code. All bets are off if an
                    //    instance has been destroyed and a method is called.
                    // 2) We don't want to cast "this", because we want type-aware optimizations
                    //    to know which properties we're setting.
                    this._observer = /** @type {?} */ null;
                    this._rootElement = /** @type {?} */ null;
                    this._managedNodes = /** @type {?} */ null;
                    this._inertManager = /** @type {?} */ null;
                }
            },
            {
                key: '_makeSubtreeUnfocusable',
                /**
       * @param {!Node} startNode
       */ value: function _makeSubtreeUnfocusable(startNode) {
                    var _this2 = this;
                    composedTreeWalk(startNode, function(node) {
                        return _this2._visitNode(node);
                    });
                    var activeElement = document.activeElement;
                    if (!document.body.contains(startNode)) {
                        // startNode may be in shadow DOM, so find its nearest shadowRoot to get the activeElement.
                        var node = startNode;
                        /** @type {!ShadowRoot|undefined} */ var root = undefined;
                        while(node){
                            if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                root = /** @type {!ShadowRoot} */ node;
                                break;
                            }
                            node = node.parentNode;
                        }
                        if (root) activeElement = root.activeElement;
                    }
                    if (startNode.contains(activeElement)) {
                        activeElement.blur();
                        // In IE11, if an element is already focused, and then set to tabindex=-1
                        // calling blur() will not actually move the focus.
                        // To work around this we call focus() on the body instead.
                        if (activeElement === document.activeElement) document.body.focus();
                    }
                }
            },
            {
                key: '_visitNode',
                value: function _visitNode(node) {
                    if (node.nodeType !== Node.ELEMENT_NODE) return;
                    var element = /** @type {!HTMLElement} */ node;
                    // If a descendant inert root becomes un-inert, its descendants will still be inert because of
                    // this inert root, so all of its managed nodes need to be adopted by this InertRoot.
                    if (element !== this._rootElement && element.hasAttribute('inert')) this._adoptInertRoot(element);
                    if (matches.call(element, _focusableElementsString) || element.hasAttribute('tabindex')) this._manageNode(element);
                }
            },
            {
                key: '_manageNode',
                value: function _manageNode(node) {
                    var inertNode = this._inertManager.register(node, this);
                    this._managedNodes.add(inertNode);
                }
            },
            {
                key: '_unmanageNode',
                value: function _unmanageNode(node) {
                    var inertNode = this._inertManager.deregister(node, this);
                    if (inertNode) this._managedNodes['delete'](inertNode);
                }
            },
            {
                key: '_unmanageSubtree',
                value: function _unmanageSubtree(startNode) {
                    var _this3 = this;
                    composedTreeWalk(startNode, function(node) {
                        return _this3._unmanageNode(node);
                    });
                }
            },
            {
                key: '_adoptInertRoot',
                value: function _adoptInertRoot(node) {
                    var inertSubroot = this._inertManager.getInertRoot(node);
                    // During initialisation this inert root may not have been registered yet,
                    // so register it now if need be.
                    if (!inertSubroot) {
                        this._inertManager.setInert(node, true);
                        inertSubroot = this._inertManager.getInertRoot(node);
                    }
                    inertSubroot.managedNodes.forEach(function(savedInertNode) {
                        this._manageNode(savedInertNode.node);
                    }, this);
                }
            },
            {
                key: '_onMutation',
                value: function _onMutation(records, self) {
                    records.forEach(function(record) {
                        var target = /** @type {!HTMLElement} */ record.target;
                        if (record.type === 'childList') {
                            // Manage added nodes
                            slice.call(record.addedNodes).forEach(function(node) {
                                this._makeSubtreeUnfocusable(node);
                            }, this);
                            // Un-manage removed nodes
                            slice.call(record.removedNodes).forEach(function(node) {
                                this._unmanageSubtree(node);
                            }, this);
                        } else if (record.type === 'attributes') {
                            if (record.attributeName === 'tabindex') // Re-initialise inert node if tabindex changes
                            this._manageNode(target);
                            else if (target !== this._rootElement && record.attributeName === 'inert' && target.hasAttribute('inert')) {
                                // If a new inert root is added, adopt its managed nodes and make sure it knows about the
                                // already managed nodes from this inert subroot.
                                this._adoptInertRoot(target);
                                var inertSubroot = this._inertManager.getInertRoot(target);
                                this._managedNodes.forEach(function(managedNode) {
                                    if (target.contains(managedNode.node)) inertSubroot._manageNode(managedNode.node);
                                });
                            }
                        }
                    }, this);
                }
            },
            {
                key: 'managedNodes',
                get: function get() {
                    return new Set(this._managedNodes);
                }
            },
            {
                key: 'hasSavedAriaHidden',
                get: function get() {
                    return this._savedAriaHidden !== null;
                }
            },
            {
                key: 'savedAriaHidden',
                set: function set(ariaHidden) {
                    this._savedAriaHidden = ariaHidden;
                },
                get: function get() {
                    return this._savedAriaHidden;
                }
            }
        ]);
        return InertRoot;
    }();
    /**
   * `InertNode` initialises and manages a single inert node.
   * A node is inert if it is a descendant of one or more inert root elements.
   *
   * On construction, `InertNode` saves the existing `tabindex` value for the node, if any, and
   * either removes the `tabindex` attribute or sets it to `-1`, depending on whether the element
   * is intrinsically focusable or not.
   *
   * `InertNode` maintains a set of `InertRoot`s which are descendants of this `InertNode`. When an
   * `InertRoot` is destroyed, and calls `InertManager.deregister()`, the `InertManager` notifies the
   * `InertNode` via `removeInertRoot()`, which in turn destroys the `InertNode` if no `InertRoot`s
   * remain in the set. On destruction, `InertNode` reinstates the stored `tabindex` if one exists,
   * or removes the `tabindex` attribute if the element is intrinsically focusable.
   */ var InertNode = function() {
        /**
     * @param {!Node} node A focusable element to be made inert.
     * @param {!InertRoot} inertRoot The inert root element associated with this inert node.
     */ function InertNode(node, inertRoot) {
            _classCallCheck(this, InertNode);
            /** @type {!Node} */ this._node = node;
            /** @type {boolean} */ this._overrodeFocusMethod = false;
            /**
       * @type {!Set<!InertRoot>} The set of descendant inert roots.
       *    If and only if this set becomes empty, this node is no longer inert.
       */ this._inertRoots = new Set([
                inertRoot
            ]);
            /** @type {?number} */ this._savedTabIndex = null;
            /** @type {boolean} */ this._destroyed = false;
            // Save any prior tabindex info and make this node untabbable
            this.ensureUntabbable();
        }
        /**
     * Call this whenever this object is about to become obsolete.
     * This makes the managed node focusable again and deletes all of the previously stored state.
     */ _createClass(InertNode, [
            {
                key: 'destructor',
                value: function destructor() {
                    this._throwIfDestroyed();
                    if (this._node && this._node.nodeType === Node.ELEMENT_NODE) {
                        var element = /** @type {!HTMLElement} */ this._node;
                        if (this._savedTabIndex !== null) element.setAttribute('tabindex', this._savedTabIndex);
                        else element.removeAttribute('tabindex');
                        // Use `delete` to restore native focus method.
                        if (this._overrodeFocusMethod) delete element.focus;
                    }
                    // See note in InertRoot.destructor for why we cast these nulls to ANY.
                    this._node = /** @type {?} */ null;
                    this._inertRoots = /** @type {?} */ null;
                    this._destroyed = true;
                }
            },
            {
                key: '_throwIfDestroyed',
                /**
       * Throw if user tries to access destroyed InertNode.
       */ value: function _throwIfDestroyed() {
                    if (this.destroyed) throw new Error('Trying to access destroyed InertNode');
                }
            },
            {
                key: 'ensureUntabbable',
                /** Save the existing tabindex value and make the node untabbable and unfocusable */ value: function ensureUntabbable() {
                    if (this.node.nodeType !== Node.ELEMENT_NODE) return;
                    var element = /** @type {!HTMLElement} */ this.node;
                    if (matches.call(element, _focusableElementsString)) {
                        if (/** @type {!HTMLElement} */ element.tabIndex === -1 && this.hasSavedTabIndex) return;
                        if (element.hasAttribute('tabindex')) this._savedTabIndex = /** @type {!HTMLElement} */ element.tabIndex;
                        element.setAttribute('tabindex', '-1');
                        if (element.nodeType === Node.ELEMENT_NODE) {
                            element.focus = function() {};
                            this._overrodeFocusMethod = true;
                        }
                    } else if (element.hasAttribute('tabindex')) {
                        this._savedTabIndex = /** @type {!HTMLElement} */ element.tabIndex;
                        element.removeAttribute('tabindex');
                    }
                }
            },
            {
                key: 'addInertRoot',
                value: function addInertRoot(inertRoot) {
                    this._throwIfDestroyed();
                    this._inertRoots.add(inertRoot);
                }
            },
            {
                key: 'removeInertRoot',
                value: function removeInertRoot(inertRoot) {
                    this._throwIfDestroyed();
                    this._inertRoots['delete'](inertRoot);
                    if (this._inertRoots.size === 0) this.destructor();
                }
            },
            {
                key: 'destroyed',
                get: function get() {
                    return /** @type {!InertNode} */ this._destroyed;
                }
            },
            {
                key: 'hasSavedTabIndex',
                get: function get() {
                    return this._savedTabIndex !== null;
                }
            },
            {
                key: 'node',
                get: function get() {
                    this._throwIfDestroyed();
                    return this._node;
                }
            },
            {
                key: 'savedTabIndex',
                set: function set(tabIndex) {
                    this._throwIfDestroyed();
                    this._savedTabIndex = tabIndex;
                },
                get: function get() {
                    this._throwIfDestroyed();
                    return this._savedTabIndex;
                }
            }
        ]);
        return InertNode;
    }();
    /**
   * InertManager is a per-document singleton object which manages all inert roots and nodes.
   *
   * When an element becomes an inert root by having an `inert` attribute set and/or its `inert`
   * property set to `true`, the `setInert` method creates an `InertRoot` object for the element.
   * The `InertRoot` in turn registers itself as managing all of the element's focusable descendant
   * nodes via the `register()` method. The `InertManager` ensures that a single `InertNode` instance
   * is created for each such node, via the `_managedNodes` map.
   */ var InertManager = function() {
        /**
     * @param {!Document} document
     */ function InertManager(document1) {
            _classCallCheck(this, InertManager);
            if (!document1) throw new Error('Missing required argument; InertManager needs to wrap a document.');
            /** @type {!Document} */ this._document = document1;
            /**
       * All managed nodes known to this InertManager. In a map to allow looking up by Node.
       * @type {!Map<!Node, !InertNode>}
       */ this._managedNodes = new Map();
            /**
       * All inert roots known to this InertManager. In a map to allow looking up by Node.
       * @type {!Map<!Node, !InertRoot>}
       */ this._inertRoots = new Map();
            /**
       * Observer for mutations on `document.body`.
       * @type {!MutationObserver}
       */ this._observer = new MutationObserver(this._watchForInert.bind(this));
            // Add inert style.
            addInertStyle(document1.head || document1.body || document1.documentElement);
            // Wait for document to be loaded.
            if (document1.readyState === 'loading') document1.addEventListener('DOMContentLoaded', this._onDocumentLoaded.bind(this));
            else this._onDocumentLoaded();
        }
        /**
     * Set whether the given element should be an inert root or not.
     * @param {!HTMLElement} root
     * @param {boolean} inert
     */ _createClass(InertManager, [
            {
                key: 'setInert',
                value: function setInert(root, inert) {
                    if (inert) {
                        if (this._inertRoots.has(root)) // element is already inert
                        return;
                        var inertRoot = new InertRoot(root, this);
                        root.setAttribute('inert', '');
                        this._inertRoots.set(root, inertRoot);
                        // If not contained in the document, it must be in a shadowRoot.
                        // Ensure inert styles are added there.
                        if (!this._document.body.contains(root)) {
                            var parent = root.parentNode;
                            while(parent){
                                if (parent.nodeType === 11) addInertStyle(parent);
                                parent = parent.parentNode;
                            }
                        }
                    } else {
                        if (!this._inertRoots.has(root)) // element is already non-inert
                        return;
                        var _inertRoot = this._inertRoots.get(root);
                        _inertRoot.destructor();
                        this._inertRoots['delete'](root);
                        root.removeAttribute('inert');
                    }
                }
            },
            {
                key: 'getInertRoot',
                value: function getInertRoot(element) {
                    return this._inertRoots.get(element);
                }
            },
            {
                key: 'register',
                value: function register(node, inertRoot) {
                    var inertNode = this._managedNodes.get(node);
                    if (inertNode !== undefined) // node was already in an inert subtree
                    inertNode.addInertRoot(inertRoot);
                    else inertNode = new InertNode(node, inertRoot);
                    this._managedNodes.set(node, inertNode);
                    return inertNode;
                }
            },
            {
                key: 'deregister',
                value: function deregister(node, inertRoot) {
                    var inertNode = this._managedNodes.get(node);
                    if (!inertNode) return null;
                    inertNode.removeInertRoot(inertRoot);
                    if (inertNode.destroyed) this._managedNodes['delete'](node);
                    return inertNode;
                }
            },
            {
                key: '_onDocumentLoaded',
                value: function _onDocumentLoaded() {
                    // Find all inert roots in document and make them actually inert.
                    var inertElements = slice.call(this._document.querySelectorAll('[inert]'));
                    inertElements.forEach(function(inertElement) {
                        this.setInert(inertElement, true);
                    }, this);
                    // Comment this out to use programmatic API only.
                    this._observer.observe(this._document.body || this._document.documentElement, {
                        attributes: true,
                        subtree: true,
                        childList: true
                    });
                }
            },
            {
                key: '_watchForInert',
                value: function _watchForInert(records, self) {
                    var _this = this;
                    records.forEach(function(record) {
                        switch(record.type){
                            case 'childList':
                                slice.call(record.addedNodes).forEach(function(node) {
                                    if (node.nodeType !== Node.ELEMENT_NODE) return;
                                    var inertElements = slice.call(node.querySelectorAll('[inert]'));
                                    if (matches.call(node, '[inert]')) inertElements.unshift(node);
                                    inertElements.forEach(function(inertElement) {
                                        this.setInert(inertElement, true);
                                    }, _this);
                                }, _this);
                                break;
                            case 'attributes':
                                if (record.attributeName !== 'inert') return;
                                var target = /** @type {!HTMLElement} */ record.target;
                                var inert = target.hasAttribute('inert');
                                _this.setInert(target, inert);
                                break;
                        }
                    }, this);
                }
            }
        ]);
        return InertManager;
    }();
    /**
   * Recursively walk the composed tree from |node|.
   * @param {!Node} node
   * @param {(function (!HTMLElement))=} callback Callback to be called for each element traversed,
   *     before descending into child nodes.
   * @param {?ShadowRoot=} shadowRootAncestor The nearest ShadowRoot ancestor, if any.
   */ function composedTreeWalk(node, callback, shadowRootAncestor) {
        if (node.nodeType == Node.ELEMENT_NODE) {
            var element = /** @type {!HTMLElement} */ node;
            if (callback) callback(element);
            // Descend into node:
            // If it has a ShadowRoot, ignore all child elements - these will be picked
            // up by the <content> or <shadow> elements. Descend straight into the
            // ShadowRoot.
            var shadowRoot = /** @type {!HTMLElement} */ element.shadowRoot;
            if (shadowRoot) {
                composedTreeWalk(shadowRoot, callback, shadowRoot);
                return;
            }
            // If it is a <content> element, descend into distributed elements - these
            // are elements from outside the shadow root which are rendered inside the
            // shadow DOM.
            if (element.localName == 'content') {
                var content = /** @type {!HTMLContentElement} */ element;
                // Verifies if ShadowDom v0 is supported.
                var distributedNodes = content.getDistributedNodes ? content.getDistributedNodes() : [];
                for(var i = 0; i < distributedNodes.length; i++)composedTreeWalk(distributedNodes[i], callback, shadowRootAncestor);
                return;
            }
            // If it is a <slot> element, descend into assigned nodes - these
            // are elements from outside the shadow root which are rendered inside the
            // shadow DOM.
            if (element.localName == 'slot') {
                var slot = /** @type {!HTMLSlotElement} */ element;
                // Verify if ShadowDom v1 is supported.
                var _distributedNodes = slot.assignedNodes ? slot.assignedNodes({
                    flatten: true
                }) : [];
                for(var _i = 0; _i < _distributedNodes.length; _i++)composedTreeWalk(_distributedNodes[_i], callback, shadowRootAncestor);
                return;
            }
        }
        // If it is neither the parent of a ShadowRoot, a <content> element, a <slot>
        // element, nor a <shadow> element recurse normally.
        var child = node.firstChild;
        while(child != null){
            composedTreeWalk(child, callback, shadowRootAncestor);
            child = child.nextSibling;
        }
    }
    /**
   * Adds a style element to the node containing the inert specific styles
   * @param {!Node} node
   */ function addInertStyle(node) {
        if (node.querySelector('style#inert-style, link#inert-style')) return;
        var style = document.createElement('style');
        style.setAttribute('id', 'inert-style');
        style.textContent = "\n[inert] {\n  pointer-events: none;\n  cursor: default;\n}\n\n[inert], [inert] * {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n";
        node.appendChild(style);
    }
    if (!HTMLElement.prototype.hasOwnProperty('inert')) {
        /** @type {!InertManager} */ var inertManager = new InertManager(document);
        Object.defineProperty(HTMLElement.prototype, 'inert', {
            enumerable: true,
            /** @this {!HTMLElement} */ get: function get() {
                return this.hasAttribute('inert');
            },
            /** @this {!HTMLElement} */ set: function set(inert) {
                inertManager.setInert(this, inert);
            }
        });
    }
})();

},{}],"hkAR3":[function() {},{}],"lLUIH":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
parcelHelpers.export(exports, "es", ()=>(0, _esJsonDefault.default));
parcelHelpers.export(exports, "it", ()=>(0, _itJsonDefault.default));
parcelHelpers.export(exports, "fr", ()=>(0, _frJsonDefault.default));
parcelHelpers.export(exports, "no", ()=>(0, _noJsonDefault.default));
parcelHelpers.export(exports, "sv", ()=>(0, _svJsonDefault.default));
parcelHelpers.export(exports, "da", ()=>(0, _daJsonDefault.default));
parcelHelpers.export(exports, "fi", ()=>(0, _fiJsonDefault.default));
parcelHelpers.export(exports, "nl", ()=>(0, _nlJsonDefault.default));
parcelHelpers.export(exports, "pl", ()=>(0, _plJsonDefault.default));
parcelHelpers.export(exports, "cs", ()=>(0, _csJsonDefault.default));
parcelHelpers.export(exports, "ja", ()=>(0, _jaJsonDefault.default));
parcelHelpers.export(exports, "ko", ()=>(0, _koJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);
var _esJson = require("./es.json");
var _esJsonDefault = parcelHelpers.interopDefault(_esJson);
var _itJson = require("./it.json");
var _itJsonDefault = parcelHelpers.interopDefault(_itJson);
var _frJson = require("./fr.json");
var _frJsonDefault = parcelHelpers.interopDefault(_frJson);
var _noJson = require("./no.json");
var _noJsonDefault = parcelHelpers.interopDefault(_noJson);
var _svJson = require("./sv.json");
var _svJsonDefault = parcelHelpers.interopDefault(_svJson);
var _daJson = require("./da.json");
var _daJsonDefault = parcelHelpers.interopDefault(_daJson);
var _fiJson = require("./fi.json");
var _fiJsonDefault = parcelHelpers.interopDefault(_fiJson);
var _nlJson = require("./nl.json");
var _nlJsonDefault = parcelHelpers.interopDefault(_nlJson);
var _plJson = require("./pl.json");
var _plJsonDefault = parcelHelpers.interopDefault(_plJson);
var _csJson = require("./cs.json");
var _csJsonDefault = parcelHelpers.interopDefault(_csJson);
var _jaJson = require("./ja.json");
var _jaJsonDefault = parcelHelpers.interopDefault(_jaJson);
var _koJson = require("./ko.json");
var _koJsonDefault = parcelHelpers.interopDefault(_koJson);

},{"./default.json":"bdPD4","./de.json":"afevP","./es.json":"bf5JM","./it.json":"gZKod","./fr.json":"jikSd","./no.json":"3WZZc","./sv.json":"cQwU5","./da.json":"l5CEn","./fi.json":"cLH4x","./nl.json":"jM6yG","./pl.json":"EP8qA","./cs.json":"7FkOY","./ja.json":"7M2jl","./ko.json":"29vVz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bdPD4":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.required":"{{label}} is a required field","validation.minLength":"{{label}} needs to be at least {{min}} characters long","validation.maxLength":"{{label}} cant be longer than {{max}} characters","validation.contentTypeAlphanumeric":"{{label}} needs to be alphanumeric","validation.contentTypeDate":"{{label}} needs to be a date","validation.contentTypeDateBefore":"{{label}} needs to be a date before {{date beforeDate}}","validation.contentTypeDateAfter":"{{label}} needs to be a date after {{date afterDate}}","validation.contentTypeDatetime":"{{label}} needs to be a date and time","validation.contentTypeDatetimeBefore":"{{label}} needs to be a date before {{datetime beforeDate}}","validation.contentTypeDatetimeAfter":"{{label}} needs to be a date after {{datetime afterDate}}","validation.contentTypeEmail":"{{label}} needs to be a email","validation.contentTypeInteger":"{{label}} needs to be a number","validation.contentTypeNumber":"{{label}} needs to be a number","validation.contentTypeRegex":"{{label}} has the wrong format","validation.contentTypeText":"{{label}} needs to be a text","validation.contentTypeTime":"{{label}} needs to be a time","validation.contentTypeUrl":"{{label}} needs to be a web address","select-element.default-option":"Select\u2026","button-element.network-required":"You are currently offline. Please establish a network connection to continue."}');

},{}],"afevP":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.required":"{{label}} ist ein Pflichtfeld","validation.minLength":"{{label}} muss mindestens {{min}} Zeichen lang sein","validation.maxLength":"{{label}} darf nicht l\xe4nger als {{max}} Zeichen sein","validation.contentTypeAlphanumeric":"{{label}} muss alphanumerisch sein","validation.contentTypeDate":"{{label}} muss ein Datum sein","validation.contentTypeDateBefore":"{{label}} muss ein Datum vor {{date beforeDate}} sein","validation.contentTypeDateAfter":"{{label}} muss ein Datum nach {{date afterDate}} sein","validation.contentTypeDatetime":"{{label}} muss ein Datum und eine Uhrzeit sein","validation.contentTypeDatetimeBefore":"{{label}} muss ein Datum vor {{datetime beforeDate}} sein","validation.contentTypeDatetimeAfter":"{{label}} muss ein Datum nach {{datetime afterDate}} sein","validation.contentTypeEmail":"{{label}} muss eine E-Mail sein","validation.contentTypeInteger":"{{label}} muss eine Zahl sein","validation.contentTypeNumber":"{{label}} muss eine Zahl sein","validation.contentTypeRegex":"{{label}} hat das falsche Format","validation.contentTypeText":"{{label}} muss ein Text sein","validation.contentTypeTime":"{{label}} muss eine Zeit sein","validation.contentTypeUrl":"{{label}} muss eine Webadresse sein","select-element.default-option":"W\xe4hlen\u2026","button-element.network-required":"Sie sind derzeit offline. Bitte stellen Sie eine Netzwerkverbindung her, um fortzufahren."}');

},{}],"bf5JM":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.required":"{{label}} es un campo obligatorio","validation.minLength":"{{label}} debe tener al menos {{min}} caracteres","validation.maxLength":"{{label}} no puede tener m\xe1s de {{max}} caracteres","validation.contentTypeAlphanumeric":"{{label}} debe ser alfanum\xe9rico","validation.contentTypeDate":"{{label}} debe ser una fecha","validation.contentTypeDateBefore":"{{label}} debe ser una fecha anterior a {{date beforeDate}}","validation.contentTypeDateAfter":"{{label}} debe ser una fecha posterior a {{date afterDate}}","validation.contentTypeDatetime":"{{label}} debe ser una fecha y una hora","validation.contentTypeDatetimeBefore":"{{label}} debe ser una fecha anterior a {{datetime beforeDate}}","validation.contentTypeDatetimeAfter":"{{label}} debe ser una fecha posterior a {{datetime afterDate}}","validation.contentTypeEmail":"{{label}} debe ser un correo electr\xf3nico","validation.contentTypeInteger":"{{label}} debe ser un n\xfamero","validation.contentTypeNumber":"{{label}} debe ser un n\xfamero","validation.contentTypeRegex":"{{label}} tiene un formato incorrecto","validation.contentTypeText":"{{label}} debe ser un texto","validation.contentTypeTime":"{{label}} debe ser una hora","validation.contentTypeUrl":"{{label}} debe ser una direcci\xf3n web","select-element.default-option":"Seleccione\u2026","button-element.network-required":"Actualmente est\xe1s desconectado. Establece una conexi\xf3n de red para continuar."}');

},{}],"gZKod":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.required":"{{label}} \xe8 un campo obbligatorio","validation.minLength":"{{label}} deve essere lungo almeno {{min}} caratteri","validation.maxLength":"{{label}} non pu\xf2 essere pi\xf9 lungo di {{max}} caratteri","validation.contentTypeAlphanumeric":"{{label}} deve essere alfanumerico","validation.contentTypeDate":"{{label}} deve essere una data","validation.contentTypeDateBefore":"{{label}} deve essere una data precedente a {{date beforeDate}}","validation.contentTypeDateAfter":"{{label}} deve essere una data successiva a {{date afterDate}}","validation.contentTypeDatetime":"{{label}} deve essere una data e un\'ora","validation.contentTypeDatetimeBefore":"{{label}} deve essere una data precedente a {{datetime beforeDate}}","validation.contentTypeDatetimeAfter":"{{label}} deve essere una data successiva a {{datetime afterDate}}","validation.contentTypeEmail":"{{label}} deve essere un\'email","validation.contentTypeInteger":"{{label}} deve essere un numero","validation.contentTypeNumber":"{{label}} deve essere un numero","validation.contentTypeRegex":"{{label}} ha il formato sbagliato","validation.contentTypeText":"{{label}} deve essere un testo","validation.contentTypeTime":"{{label}} deve essere un orario","validation.contentTypeUrl":"{{label}} deve essere un indirizzo web","select-element.default-option":"Selezionare\u2026","button-element.network-required":"Al momento sei offline. Stabilisci una connessione di rete per continuare."}');

},{}],"jikSd":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.required":"{{label}} est un champ obligatoire","validation.minLength":"{{label}} doit comporter au moins {{min}} caract\xe8res","validation.maxLength":"{{label}} ne peut pas d\xe9passer {{max}} caract\xe8res","validation.contentTypeAlphanumeric":"{{label}} doit \xeatre alphanum\xe9rique","validation.contentTypeDate":"{{label}} doit \xeatre une date","validation.contentTypeDateBefore":"{{label}} doit \xeatre une date ant\xe9rieure \xe0 {{date beforeDate}}","validation.contentTypeDateAfter":"{{label}} doit \xeatre une date apr\xe8s {{date afterDate}}","validation.contentTypeDatetime":"{{label}} doit \xeatre une date et une heure","validation.contentTypeDatetimeBefore":"{{label}} doit \xeatre une date ant\xe9rieure \xe0 {{datetime beforeDate}}","validation.contentTypeDatetimeAfter":"{{label}} doit \xeatre une date apr\xe8s {{datetime afterDate}}","validation.contentTypeEmail":"{{label}} doit \xeatre un email","validation.contentTypeInteger":"{{label}} doit \xeatre un nombre","validation.contentTypeNumber":"{{label}} doit \xeatre un nombre","validation.contentTypeRegex":"{{label}} a le mauvais format","validation.contentTypeText":"{{label}} doit \xeatre un texte","validation.contentTypeTime":"{{label}} doit \xeatre une heure","validation.contentTypeUrl":"{{label}} doit \xeatre une adresse Web","select-element.default-option":"S\xe9lectionner\u2026","button-element.network-required":"Vous \xeates actuellement hors ligne. Veuillez \xe9tablir une connexion r\xe9seau pour continuer."}');

},{}],"3WZZc":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.required":"{{label}} er et obligatorisk felt","validation.minLength":"{{label}} m\xe5 best\xe5 av minst {{min}} tegn","validation.maxLength":"{{label}} kan ikke v\xe6re lengre enn {{max}} tegn","validation.contentTypeAlphanumeric":"{{label}} m\xe5 v\xe6re alfanumerisk","validation.contentTypeDate":"{{label}} m\xe5 v\xe6re en dato","validation.contentTypeDateBefore":"{{label}} m\xe5 v\xe6re en dato f\xf8r {{date beforeDate}}","validation.contentTypeDateAfter":"{{label}} m\xe5 v\xe6re en dato etter {{date afterDate}}","validation.contentTypeDatetime":"{{label}} m\xe5 v\xe6re en dato og et klokkeslett","validation.contentTypeDatetimeBefore":"{{label}} m\xe5 v\xe6re en dato f\xf8r {{datetime beforeDate}}","validation.contentTypeDatetimeAfter":"{{label}} m\xe5 v\xe6re en dato etter {{datetime afterDate}}","validation.contentTypeEmail":"{{label}} m\xe5 v\xe6re en e-post","validation.contentTypeInteger":"{{label}} m\xe5 v\xe6re et tall","validation.contentTypeNumber":"{{label}} m\xe5 v\xe6re et tall","validation.contentTypeRegex":"{{label}} har feil format","validation.contentTypeText":"{{label}} m\xe5 v\xe6re en tekst","validation.contentTypeTime":"{{label}} m\xe5 v\xe6re en tid","validation.contentTypeUrl":"{{label}} m\xe5 v\xe6re en nettadresse","select-element.default-option":"\xc5 velge\u2026","button-element.network-required":"Du er for \xf8yeblikket frakoblet. Opprett en nettverkstilkobling for \xe5 fortsette."}');

},{}],"cQwU5":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.required":"{{label}} \xe4r ett obligatoriskt f\xe4lt","validation.minLength":"{{label}} m\xe5ste vara minst {{min}} tecken l\xe5ng","validation.maxLength":"{{label}} kan inte vara l\xe4ngre \xe4n {{max}} tecken","validation.contentTypeAlphanumeric":"{{label}} m\xe5ste vara alfanumerisk","validation.contentTypeDate":"{{label}} m\xe5ste vara ett datum","validation.contentTypeDateBefore":"{{label}} m\xe5ste vara ett datum f\xf6re {{date beforeDate}}","validation.contentTypeDateAfter":"{{label}} m\xe5ste vara ett datum efter {{date afterDate}}","validation.contentTypeDatetime":"{{label}} m\xe5ste vara ett datum och en tid","validation.contentTypeDatetimeBefore":"{{label}} m\xe5ste vara ett datum f\xf6re {{datetime beforeDate}}","validation.contentTypeDatetimeAfter":"{{label}} m\xe5ste vara ett datum efter {{datetime afterDate}}","validation.contentTypeEmail":"{{label}} m\xe5ste vara ett e-postmeddelande","validation.contentTypeInteger":"{{label}} m\xe5ste vara ett tal","validation.contentTypeNumber":"{{label}} m\xe5ste vara ett nummer","validation.contentTypeRegex":"{{label}} har fel format","validation.contentTypeText":"{{label}} m\xe5ste vara en text","validation.contentTypeTime":"{{label}} m\xe5ste vara en tid","validation.contentTypeUrl":"{{label}} m\xe5ste vara en webbadress","select-element.default-option":"V\xe4lj\u2026","button-element.network-required":"Du \xe4r f\xf6r n\xe4rvarande offline. V\xe4nligen uppr\xe4tta en n\xe4tverksanslutning f\xf6r att forts\xe4tta."}');

},{}],"l5CEn":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.required":"{{label}} er et obligatorisk felt","validation.minLength":"{{label}} skal v\xe6re mindst {{min}} tegn lang","validation.maxLength":"{{label}} m\xe5 ikke v\xe6re l\xe6ngere end {{max}} tegn","validation.contentTypeAlphanumeric":"{{label}} skal v\xe6re alfanumerisk","validation.contentTypeDate":"{{label}} skal v\xe6re en dato","validation.contentTypeDateBefore":"{{label}} skal v\xe6re en dato f\xf8r {{date beforeDate}}","validation.contentTypeDateAfter":"{{label}} skal v\xe6re en dato efter {{date afterDate}}","validation.contentTypeDatetime":"{{label}} skal v\xe6re en dato og et klokkesl\xe6t","validation.contentTypeDatetimeBefore":"{{label}} skal v\xe6re en dato f\xf8r {{datetime beforeDate}}","validation.contentTypeDatetimeAfter":"{{label}} skal v\xe6re en dato efter {{datetime afterDate}}","validation.contentTypeEmail":"{{label}} skal v\xe6re en e-mail","validation.contentTypeInteger":"{{label}} skal v\xe6re et tal","validation.contentTypeNumber":"{{label}} skal v\xe6re et tal","validation.contentTypeRegex":"{{label}} har det forkerte format","validation.contentTypeText":"{{label}} skal v\xe6re en tekst","validation.contentTypeTime":"{{label}} skal v\xe6re et tidspunkt","validation.contentTypeUrl":"{{label}} skal v\xe6re en webadresse","select-element.default-option":"V\xe6lg\u2026","button-element.network-required":"Du er i \xf8jeblikket offline. Opret en netv\xe6rksforbindelse for at forts\xe6tte."}');

},{}],"cLH4x":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.required":"{{label}} on pakollinen kentt\xe4","validation.minLength":"{{label}} on oltava v\xe4hint\xe4\xe4n {{min}} merkki\xe4 pitk\xe4","validation.maxLength":"{{label}} ei voi olla pidempi kuin {{max}} merkki\xe4","validation.contentTypeAlphanumeric":"{{label}} on oltava aakkosnumeerinen","validation.contentTypeDate":"{{label}} on oltava p\xe4iv\xe4m\xe4\xe4r\xe4","validation.contentTypeDateBefore":"{{label}} on oltava p\xe4iv\xe4m\xe4\xe4r\xe4 ennen {{date beforeDate}}","validation.contentTypeDateAfter":"{{label}} on oltava {{date afterDate}} j\xe4lkeinen p\xe4iv\xe4m\xe4\xe4r\xe4","validation.contentTypeDatetime":"{{label}} on oltava p\xe4iv\xe4m\xe4\xe4r\xe4 ja aika","validation.contentTypeDatetimeBefore":"{{label}} on oltava p\xe4iv\xe4m\xe4\xe4r\xe4 ennen {{datetime beforeDate}}","validation.contentTypeDatetimeAfter":"{{label}} on oltava {{datetime afterDate}} j\xe4lkeinen p\xe4iv\xe4m\xe4\xe4r\xe4","validation.contentTypeEmail":"{{label}} on oltava s\xe4hk\xf6posti","validation.contentTypeInteger":"{{label}} on oltava numero","validation.contentTypeNumber":"{{label}} on oltava numero","validation.contentTypeRegex":"{{label}} on v\xe4\xe4r\xe4ss\xe4 muodossa","validation.contentTypeText":"{{label}} on oltava teksti","validation.contentTypeTime":"{{label}} on oltava aika","validation.contentTypeUrl":"{{label}} on oltava verkko-osoite","select-element.default-option":"Valitse\u2026","button-element.network-required":"Olet t\xe4ll\xe4 hetkell\xe4 offline-tilassa. Muodosta verkkoyhteys jatkaaksesi."}');

},{}],"jM6yG":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.required":"{{label}} is een verplicht veld","validation.minLength":"{{label}} moet minstens {{min}} tekens lang zijn","validation.maxLength":"{{label}} kan niet langer zijn dan {{max}} tekens","validation.contentTypeAlphanumeric":"{{label}} moet alfanumeriek zijn","validation.contentTypeDate":"{{label}} moet een datum zijn","validation.contentTypeDateBefore":"{{label}} moet een datum zijn v\xf3\xf3r {{date beforeDate}}","validation.contentTypeDateAfter":"{{label}} moet een datum zijn na {{date afterDate}}","validation.contentTypeDatetime":"{{label}} moet een datum en tijd zijn","validation.contentTypeDatetimeBefore":"{{label}} moet een datum zijn v\xf3\xf3r {{datetime beforeDate}}","validation.contentTypeDatetimeAfter":"{{label}} moet een datum zijn na {{datetime afterDate}}","validation.contentTypeEmail":"{{label}} moet een e-mail zijn","validation.contentTypeInteger":"{{label}} moet een getal zijn","validation.contentTypeNumber":"{{label}} moet een getal zijn","validation.contentTypeRegex":"{{label}} heeft het verkeerde formaat","validation.contentTypeText":"{{label}} moet een tekst zijn","validation.contentTypeTime":"{{label}} moet een tijd zijn","validation.contentTypeUrl":"{{label}} moet een webadres zijn","select-element.default-option":"Selecteer...","button-element.network-required":"U bent momenteel offline. Maak een netwerkverbinding om door te gaan."}');

},{}],"EP8qA":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.required":"{{label}} jest polem wymaganym","validation.minLength":"{{label}} musi mie\u0107 co najmniej {{min}} znak\xf3w","validation.maxLength":"{{label}} nie mo\u017Ce by\u0107 d\u0142u\u017Csze ni\u017C {{max}} znak\xf3w","validation.contentTypeAlphanumeric":"{{label}} musi by\u0107 alfanumeryczne","validation.contentTypeDate":"{{label}} musi by\u0107 dat\u0105","validation.contentTypeDateBefore":"{{label}} musi by\u0107 dat\u0105 wcze\u015Bniejsz\u0105 ni\u017C {{date beforeDate}}","validation.contentTypeDateAfter":"{{label}} musi by\u0107 dat\u0105 p\xf3\u017Aniejsz\u0105 ni\u017C {{date afterDate}}","validation.contentTypeDatetime":"{{label}} musi by\u0107 dat\u0105 i godzin\u0105","validation.contentTypeDatetimeBefore":"{{label}} musi by\u0107 dat\u0105 przed {{datetime beforeDate}}","validation.contentTypeDatetimeAfter":"{{label}} musi by\u0107 dat\u0105 po {{datetime afterDate}}","validation.contentTypeEmail":"{{label}} musi by\u0107 e-mailem","validation.contentTypeInteger":"{{label}} musi by\u0107 liczb\u0105","validation.contentTypeNumber":"{{label}} musi by\u0107 liczb\u0105","validation.contentTypeRegex":"{{label}} ma z\u0142y format","validation.contentTypeText":"{{label}} musi by\u0107 tekstem","validation.contentTypeTime":"{{label}} musi by\u0107 godzin\u0105","validation.contentTypeUrl":"{{label}} musi by\u0107 adresem internetowym","select-element.default-option":"Wybiera\u0107\u2026","button-element.network-required":"Obecnie jeste\u015B offline. Nawi\u0105\u017C po\u0142\u0105czenie sieciowe, aby kontynuowa\u0107."}');

},{}],"7FkOY":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.required":"{{label}} je povinn\xe9 pole","validation.minLength":"{{label}} mus\xed obsahovat alespo\u0148 {{min}} znak\u016F","validation.maxLength":"{{label}} nem\u016F\u017Ee b\xfdt del\u0161\xed ne\u017E {{max}} znak\u016F","validation.contentTypeAlphanumeric":"{{label}} mus\xed b\xfdt alfanumerick\xfd","validation.contentTypeDate":"{{label}} mus\xed b\xfdt datum","validation.contentTypeDateBefore":"{{label}} mus\xed b\xfdt datum p\u0159ed {{date beforeDate}}","validation.contentTypeDateAfter":"{{label}} mus\xed b\xfdt datum po {{date afterDate}}","validation.contentTypeDatetime":"{{label}} mus\xed b\xfdt datum a \u010Das","validation.contentTypeDatetimeBefore":"{{label}} mus\xed b\xfdt datum p\u0159ed {{datetime beforeDate}}","validation.contentTypeDatetimeAfter":"{{label}} mus\xed b\xfdt datum po {{datetime afterDate}}","validation.contentTypeEmail":"{{label}} mus\xed b\xfdt e-mail","validation.contentTypeInteger":"{{label}} mus\xed b\xfdt \u010D\xedslo","validation.contentTypeNumber":"{{label}} mus\xed b\xfdt \u010D\xedslo","validation.contentTypeRegex":"{{label}} m\xe1 nespr\xe1vn\xfd form\xe1t","validation.contentTypeText":"{{label}} mus\xed b\xfdt text","validation.contentTypeTime":"{{label}} mus\xed b\xfdt \u010Das","validation.contentTypeUrl":"{{label}} mus\xed b\xfdt webov\xe1 adresa","select-element.default-option":"Vybrat\u2026","button-element.network-required":"Moment\xe1ln\u011B jste offline. Chcete-li pokra\u010Dovat, vytvo\u0159te s\xed\u0165ov\xe9 p\u0159ipojen\xed."}');

},{}],"7M2jl":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.required":"{{label}} \u306F\u5FC5\u9808\u30D5\u30A3\u30FC\u30EB\u30C9\u3067\u3059","validation.minLength":"{{label}} \u306F\u5C11\u306A\u304F\u3068\u3082 {{min}} \u6587\u5B57\u306E\u9577\u3055\u304C\u5FC5\u8981\u3067\u3059","validation.maxLength":"{{label}} \u306F {{max}} \u6587\u5B57\u3088\u308A\u9577\u304F\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093","validation.contentTypeAlphanumeric":"{{label}} \u306F\u82F1\u6570\u5B57\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059","validation.contentTypeDate":"{{label}} \u306F\u65E5\u4ED8\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059","validation.contentTypeDateBefore":"{{label}} \u306F {{date beforeDate}} \u3088\u308A\u524D\u306E\u65E5\u4ED8\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059","validation.contentTypeDateAfter":"{{label}} \u306F {{date afterDate}} \u3088\u308A\u5F8C\u306E\u65E5\u4ED8\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059","validation.contentTypeDatetime":"{{label}} \u306F\u65E5\u4ED8\u3068\u6642\u523B\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059","validation.contentTypeDatetimeBefore":"{{label}} \u306F {{datetime beforeDate}} \u3088\u308A\u524D\u306E\u65E5\u4ED8\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059","validation.contentTypeDatetimeAfter":"{{label}} \u306F {{datetime afterDate}} \u3088\u308A\u5F8C\u306E\u65E5\u4ED8\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059","validation.contentTypeEmail":"{{label}} \u306F\u96FB\u5B50\u30E1\u30FC\u30EB\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059","validation.contentTypeInteger":"{{label}} \u306F\u6570\u5024\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059","validation.contentTypeNumber":"{{label}} \u306F\u6570\u5B57\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059","validation.contentTypeRegex":"{{label}} \u306E\u5F62\u5F0F\u304C\u9593\u9055\u3063\u3066\u3044\u307E\u3059","validation.contentTypeText":"{{label}} \u306F\u30C6\u30AD\u30B9\u30C8\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059","validation.contentTypeTime":"{{label}} \u306F\u6642\u9593\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059","validation.contentTypeUrl":"{{label}} \u306F Web \u30A2\u30C9\u30EC\u30B9\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059","select-element.default-option":"\u9078\u629E\u3059\u308B\u2026","button-element.network-required":"\u73FE\u5728\u30AA\u30D5\u30E9\u30A4\u30F3\u3067\u3059\u3002\u7D9A\u884C\u3059\u308B\u306B\u306F\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u63A5\u7D9A\u3092\u78BA\u7ACB\u3057\u3066\u304F\u3060\u3055\u3044\u3002"}');

},{}],"29vVz":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.required":"{{label}}\uC740(\uB294) \uD544\uC218 \uD544\uB4DC\uC785\uB2C8\uB2E4.","validation.minLength":"{{label}}\uC740 {{min}}\uC790 \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4.","validation.maxLength":"{{label}}\uC740 {{max}}\uC790\uB97C \uCD08\uACFC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.","validation.contentTypeAlphanumeric":"{{label}}\uC740 \uC601\uC22B\uC790\uC5EC\uC57C \uD569\uB2C8\uB2E4.","validation.contentTypeDate":"{{label}}\uC740 \uB0A0\uC9DC\uC5EC\uC57C \uD569\uB2C8\uB2E4.","validation.contentTypeDateBefore":"{{label}}\uC740 {{date beforeDate}} \uC774\uC804 \uB0A0\uC9DC\uC5EC\uC57C \uD569\uB2C8\uB2E4.","validation.contentTypeDateAfter":"{{label}}\uC740(\uB294) {{date afterDate}} \uC774\uD6C4\uC758 \uB0A0\uC9DC\uC5EC\uC57C \uD569\uB2C8\uB2E4.","validation.contentTypeDatetime":"{{label}}\uC740 \uB0A0\uC9DC\uC640 \uC2DC\uAC04\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4.","validation.contentTypeDatetimeBefore":"{{label}}\uC740 {{datetime beforeDate}} \uC774\uC804 \uB0A0\uC9DC\uC5EC\uC57C \uD569\uB2C8\uB2E4.","validation.contentTypeDatetimeAfter":"{{label}}\uC740 {{datetime afterDate}} \uC774\uD6C4\uC758 \uB0A0\uC9DC\uC5EC\uC57C \uD569\uB2C8\uB2E4.","validation.contentTypeEmail":"{{label}}\uC740(\uB294) \uC774\uBA54\uC77C\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4.","validation.contentTypeInteger":"{{label}}\uC740 \uC22B\uC790\uC5EC\uC57C \uD569\uB2C8\uB2E4.","validation.contentTypeNumber":"{{label}}\uC740(\uB294) \uC22B\uC790\uC5EC\uC57C \uD569\uB2C8\uB2E4.","validation.contentTypeRegex":"{{label}} \uD615\uC2DD\uC774 \uC798\uBABB\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","validation.contentTypeText":"{{label}}\uC740 \uD14D\uC2A4\uD2B8\uC5EC\uC57C \uD569\uB2C8\uB2E4.","validation.contentTypeTime":"{{label}}\uC740 \uC2DC\uAC04\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4.","validation.contentTypeUrl":"{{label}}\uC740 \uC6F9 \uC8FC\uC18C\uC5EC\uC57C \uD569\uB2C8\uB2E4.","select-element.default-option":"\uACE0\uB974\uB2E4\u2026","button-element.network-required":"\uD604\uC7AC \uC624\uD504\uB77C\uC778 \uC0C1\uD0DC\uC785\uB2C8\uB2E4. \uACC4\uC18D\uD558\uB824\uBA74 \uB124\uD2B8\uC6CC\uD06C \uC5F0\uACB0\uC744 \uC124\uC815\uD558\uC138\uC694."}');

},{}],"efQsn":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PackagesDatasourcesJwt", ()=>(0, _corePluginDefault.default));
parcelHelpers.export(exports, "PackagesDatasourcesStatic", ()=>(0, _corePluginDefault1.default));
parcelHelpers.export(exports, "PackagesDatasourcesHttpRequest", ()=>(0, _corePluginDefault2.default));
parcelHelpers.export(exports, "PackagesElementsPage", ()=>(0, _corePluginDefault3.default));
parcelHelpers.export(exports, "PackagesElementsInput", ()=>(0, _corePluginDefault4.default));
parcelHelpers.export(exports, "PackagesElementsMarkdown", ()=>(0, _corePluginDefault5.default));
parcelHelpers.export(exports, "PackagesElementsRadios", ()=>(0, _corePluginDefault6.default));
parcelHelpers.export(exports, "PackagesElementsCheckbox", ()=>(0, _corePluginDefault7.default));
parcelHelpers.export(exports, "PackagesElementsNavigation", ()=>(0, _corePluginDefault8.default));
parcelHelpers.export(exports, "PackagesElementsContainer", ()=>(0, _corePluginDefault9.default));
parcelHelpers.export(exports, "PackagesElementsTextarea", ()=>(0, _corePluginDefault10.default));
parcelHelpers.export(exports, "PackagesElementsButton", ()=>(0, _corePluginDefault11.default));
parcelHelpers.export(exports, "PackagesElementsSelect", ()=>(0, _corePluginDefault12.default));
parcelHelpers.export(exports, "PackagesWorkflowLayersRedirectWfl", ()=>(0, _corePluginDefault13.default));
parcelHelpers.export(exports, "PackagesWorkflowLayersConditionWfl", ()=>(0, _corePluginDefault14.default));
parcelHelpers.export(exports, "PackagesWorkflowLayersSignalWfl", ()=>(0, _corePluginDefault15.default));
parcelHelpers.export(exports, "PackagesWorkflowLayersSetterWfl", ()=>(0, _corePluginDefault16.default));
parcelHelpers.export(exports, "PackagesWorkflowLayersHttpRequest", ()=>(0, _corePluginDefault17.default));
parcelHelpers.export(exports, "PackagesWorkflowLayersSessionLogWfl", ()=>(0, _corePluginDefault18.default));
parcelHelpers.export(exports, "PackagesWorkflowLayersShowPageWfl", ()=>(0, _corePluginDefault19.default));
parcelHelpers.export(exports, "PackagesBsoCore", ()=>(0, _corePluginDefault20.default));
parcelHelpers.export(exports, "PackagesBsoAttachmentInput", ()=>(0, _corePluginDefault21.default));
var _corePlugin = require("../../datasources/jwt/core.plugin");
var _corePluginDefault = parcelHelpers.interopDefault(_corePlugin);
var _corePlugin1 = require("../../datasources/static/core.plugin");
var _corePluginDefault1 = parcelHelpers.interopDefault(_corePlugin1);
var _corePlugin2 = require("../../datasources/http-request/core.plugin");
var _corePluginDefault2 = parcelHelpers.interopDefault(_corePlugin2);
var _corePlugin3 = require("../../elements/page/core.plugin");
var _corePluginDefault3 = parcelHelpers.interopDefault(_corePlugin3);
var _corePlugin4 = require("../../elements/input/core.plugin");
var _corePluginDefault4 = parcelHelpers.interopDefault(_corePlugin4);
var _corePlugin5 = require("../../elements/markdown/core.plugin");
var _corePluginDefault5 = parcelHelpers.interopDefault(_corePlugin5);
var _corePlugin6 = require("../../elements/radios/core.plugin");
var _corePluginDefault6 = parcelHelpers.interopDefault(_corePlugin6);
var _corePlugin7 = require("../../elements/checkbox/core.plugin");
var _corePluginDefault7 = parcelHelpers.interopDefault(_corePlugin7);
var _corePlugin8 = require("../../elements/navigation/core.plugin");
var _corePluginDefault8 = parcelHelpers.interopDefault(_corePlugin8);
var _corePlugin9 = require("../../elements/container/core.plugin");
var _corePluginDefault9 = parcelHelpers.interopDefault(_corePlugin9);
var _corePlugin10 = require("../../elements/textarea/core.plugin");
var _corePluginDefault10 = parcelHelpers.interopDefault(_corePlugin10);
var _corePlugin11 = require("../../elements/button/core.plugin");
var _corePluginDefault11 = parcelHelpers.interopDefault(_corePlugin11);
var _corePlugin12 = require("../../elements/select/core.plugin");
var _corePluginDefault12 = parcelHelpers.interopDefault(_corePlugin12);
var _corePlugin13 = require("../../workflow-layers/redirect-wfl/core.plugin");
var _corePluginDefault13 = parcelHelpers.interopDefault(_corePlugin13);
var _corePlugin14 = require("../../workflow-layers/condition-wfl/core.plugin");
var _corePluginDefault14 = parcelHelpers.interopDefault(_corePlugin14);
var _corePlugin15 = require("../../workflow-layers/signal-wfl/core.plugin");
var _corePluginDefault15 = parcelHelpers.interopDefault(_corePlugin15);
var _corePlugin16 = require("../../workflow-layers/setter-wfl/core.plugin");
var _corePluginDefault16 = parcelHelpers.interopDefault(_corePlugin16);
var _corePlugin17 = require("../../workflow-layers/http-request/core.plugin");
var _corePluginDefault17 = parcelHelpers.interopDefault(_corePlugin17);
var _corePlugin18 = require("../../workflow-layers/session-log-wfl/core.plugin");
var _corePluginDefault18 = parcelHelpers.interopDefault(_corePlugin18);
var _corePlugin19 = require("../../workflow-layers/show-page-wfl/core.plugin");
var _corePluginDefault19 = parcelHelpers.interopDefault(_corePlugin19);
var _corePlugin20 = require("../../bso/core/core.plugin");
var _corePluginDefault20 = parcelHelpers.interopDefault(_corePlugin20);
var _corePlugin21 = require("../../bso/attachment-input/core.plugin");
var _corePluginDefault21 = parcelHelpers.interopDefault(_corePlugin21);

},{"../../datasources/jwt/core.plugin":"WfY51","../../datasources/static/core.plugin":"fw3w5","../../datasources/http-request/core.plugin":"5RLUj","../../elements/page/core.plugin":"2but4","../../elements/input/core.plugin":"fD11m","../../elements/markdown/core.plugin":"5xr8v","../../elements/radios/core.plugin":"fjWbT","../../elements/checkbox/core.plugin":"gra5k","../../elements/navigation/core.plugin":"6d2Jo","../../elements/container/core.plugin":"kGFgp","../../elements/textarea/core.plugin":"3xnp6","../../elements/button/core.plugin":"6hOUU","../../elements/select/core.plugin":"l84Uz","../../workflow-layers/redirect-wfl/core.plugin":"dqVBT","../../workflow-layers/condition-wfl/core.plugin":"eqeBK","../../workflow-layers/signal-wfl/core.plugin":"3yTRY","../../workflow-layers/setter-wfl/core.plugin":"67smr","../../workflow-layers/http-request/core.plugin":"fD5Uk","../../workflow-layers/session-log-wfl/core.plugin":"7KCVE","../../workflow-layers/show-page-wfl/core.plugin":"giqKC","../../bso/core/core.plugin":"e0qQS","../../bso/attachment-input/core.plugin":"iLdSq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"WfY51":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jwtDatasource = require("./datasources/jwt-datasource");
var _jwtDatasourceDefault = parcelHelpers.interopDefault(_jwtDatasource);
exports.default = {
    datasources: {
        [(0, _jwtDatasourceDefault.default).apiName]: (0, _jwtDatasourceDefault.default)
    }
};

},{"./datasources/jwt-datasource":"bzMgD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bzMgD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_JWT_PATH", ()=>DEFAULT_JWT_PATH);
parcelHelpers.export(exports, "DEFAULT_OUTPUT_PATH", ()=>DEFAULT_OUTPUT_PATH);
parcelHelpers.export(exports, "apiName", ()=>apiName);
var _formSession = require("@form-engine/core-application/utilities/form-session");
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _set = require("lodash/set");
var _setDefault = parcelHelpers.interopDefault(_set);
const DEFAULT_JWT_PATH = 'request.headers.authorization';
const DEFAULT_OUTPUT_PATH = 'jwt';
const apiName = 'FormEngineJwtDatasource';
async function FormEngineJwtDatasource(options) {
    if (options?.definition?.type !== apiName) throw new Error(`invalid jwt datasource definition`);
    let data = {};
    let error;
    const locals = (0, _formSession.getFormSessionLocals)(options.form, options?.session ?? {});
    const token = String((0, _getDefault.default)(locals, String(options.definition.jwtSource || DEFAULT_JWT_PATH)) ?? '');
    if (token) {
        const [, payload] = token.split('.');
        if (payload) try {
            data = JSON.parse(atob(payload));
        } catch (e) {
            error = e;
        }
    }
    const constants = (0, _setDefault.default)({}, String(options?.definition?.jwtOutput || DEFAULT_OUTPUT_PATH), data);
    return Promise.resolve({
        data,
        error,
        options: [],
        constants
    });
}
exports.default = Object.assign(FormEngineJwtDatasource, {
    apiName,
    isGlobal: true
});

},{"@form-engine/core-application/utilities/form-session":"do3Fv","lodash/get":"dBTJh","lodash/set":"7LBfm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7LBfm":[function(require,module,exports,__globalThis) {
var baseSet = require("a003324b62105673");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function set(object, path, value) {
    return object == null ? object : baseSet(object, path, value);
}
module.exports = set;

},{"a003324b62105673":"7efHu"}],"7efHu":[function(require,module,exports,__globalThis) {
var assignValue = require("a01f3b7ce097c710"), castPath = require("56e0b8a492d56399"), isIndex = require("d1eb8acc5a65dc38"), isObject = require("dfb182b16ef275c0"), toKey = require("6a51dc787ca5b6e3");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function baseSet(object, path, value, customizer) {
    if (!isObject(object)) return object;
    path = castPath(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = toKey(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = baseSet;

},{"a01f3b7ce097c710":"aKTSf","56e0b8a492d56399":"1tEcE","d1eb8acc5a65dc38":"bxLaX","dfb182b16ef275c0":"6hgJK","6a51dc787ca5b6e3":"b5swP"}],"fw3w5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _staticDatasource = require("./datasources/static-datasource");
var _staticDatasourceDefault = parcelHelpers.interopDefault(_staticDatasource);
exports.default = {
    datasources: {
        [(0, _staticDatasource.apiName)]: (0, _staticDatasourceDefault.default)
    }
};

},{"./datasources/static-datasource":"h0bDq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h0bDq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SourceType", ()=>SourceType);
parcelHelpers.export(exports, "DEFAULT_SOURCE_TYPE", ()=>DEFAULT_SOURCE_TYPE);
parcelHelpers.export(exports, "apiName", ()=>apiName);
var _papaparse = require("papaparse");
var _papaparseDefault = parcelHelpers.interopDefault(_papaparse);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _set = require("lodash/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _template = require("@form-engine/core-util/template");
var _formSession = require("@form-engine/core-application/utilities/form-session");
var SourceType = /*#__PURE__*/ function(SourceType) {
    SourceType["Csv"] = "csv";
    SourceType["Json"] = "json";
    SourceType["Variable"] = "variable";
    return SourceType;
}({});
const DEFAULT_SOURCE_TYPE = "csv";
const apiName = 'FormEngineStaticDatasource';
function FormEngineStaticDatasource(options) {
    const { source = '', sourceType = DEFAULT_SOURCE_TYPE, labelColumn = '', valueColumn = '', csvOptions = {
        header: true
    }, resultPath, previousError = null, constantsPath } = options?.definition ?? {};
    const locals = (0, _formSession.getFormSessionLocals)(options.form, options?.session ?? {});
    let data = [];
    let error = previousError;
    let result;
    if (!error) switch(sourceType){
        case "variable":
            try {
                result = (0, _getDefault.default)(locals, source);
                data = (resultPath ? (0, _getDefault.default)(result, resultPath) : result) || [];
            } catch (e) {
                data = [];
                error = e;
            }
            break;
        case "json":
            try {
                result = JSON.parse(source);
                data = (resultPath ? (0, _getDefault.default)(result, resultPath) : result) || [];
            } catch (e) {
                data = [];
                error = e;
            }
            break;
        case "csv":
            try {
                result = data = (0, _papaparseDefault.default).parse(source, csvOptions).data || [];
            } catch (e) {
                result = data = [];
                error = e;
            }
            break;
        default:
            data = [];
            error = new Error(`unknown source type ${sourceType}`);
    }
    return Promise.resolve({
        constants: constantsPath ? (0, _setDefault.default)({}, constantsPath, result) : undefined,
        data,
        error,
        options: Array.isArray(data) ? data.map((item)=>{
            const itemLocals = {
                ...locals,
                $i: item
            };
            return [
                (0, _template.compile)(valueColumn, itemLocals, ''),
                (0, _template.compile)(labelColumn, itemLocals, '')
            ];
        }) : []
    });
}
FormEngineStaticDatasource.apiName = apiName;
FormEngineStaticDatasource.isDirty = (def)=>def.sourceType === "variable";
exports.default = FormEngineStaticDatasource;

},{"papaparse":"8J3nL","lodash/get":"dBTJh","lodash/set":"7LBfm","@form-engine/core-util/template":"bKMue","@form-engine/core-application/utilities/form-session":"do3Fv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8J3nL":[function(require,module,exports,__globalThis) {
/* @license
Papa Parse
v5.4.1
https://github.com/mholt/PapaParse
License: MIT
*/ !function(e, t) {
    "function" == typeof define && define.amd ? define([], t) : module.exports = t();
}(this, function s() {
    "use strict";
    var f = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== f ? f : {};
    var n = !f.document && !!f.postMessage, o = f.IS_PAPA_WORKER || !1, a = {}, u = 0, b = {
        parse: function(e, t) {
            var r = (t = t || {}).dynamicTyping || !1;
            J(r) && (t.dynamicTypingFunction = r, r = {});
            if (t.dynamicTyping = r, t.transform = !!J(t.transform) && t.transform, t.worker && b.WORKERS_SUPPORTED) {
                var i = function() {
                    if (!b.WORKERS_SUPPORTED) return !1;
                    var e = (r = f.URL || f.webkitURL || null, i = s.toString(), b.BLOB_URL || (b.BLOB_URL = r.createObjectURL(new Blob([
                        "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                        "(",
                        i,
                        ")();"
                    ], {
                        type: "text/javascript"
                    })))), t = new f.Worker(e);
                    var r, i;
                    return t.onmessage = _, t.id = u++, a[t.id] = t;
                }();
                return i.userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = J(t.step), t.chunk = J(t.chunk), t.complete = J(t.complete), t.error = J(t.error), delete t.worker, void i.postMessage({
                    input: e,
                    config: t,
                    workerId: i.id
                });
            }
            var n = null;
            b.NODE_STREAM_INPUT, "string" == typeof e ? (e = function(e) {
                if (65279 === e.charCodeAt(0)) return e.slice(1);
                return e;
            }(e), n = t.download ? new l(t) : new p(t)) : !0 === e.readable && J(e.read) && J(e.on) ? n = new g(t) : (f.File && e instanceof File || e instanceof Object) && (n = new c(t));
            return n.stream(e);
        },
        unparse: function(e, t) {
            var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, r = !1, i = null, o = !1;
            !function() {
                if ("object" != typeof t) return;
                "string" != typeof t.delimiter || b.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter);
                ("boolean" == typeof t.quotes || "function" == typeof t.quotes || Array.isArray(t.quotes)) && (n = t.quotes);
                "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (r = t.skipEmptyLines);
                "string" == typeof t.newline && (y = t.newline);
                "string" == typeof t.quoteChar && (s = t.quoteChar);
                "boolean" == typeof t.header && (_ = t.header);
                if (Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    i = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s);
                ("boolean" == typeof t.escapeFormulae || t.escapeFormulae instanceof RegExp) && (o = t.escapeFormulae instanceof RegExp ? t.escapeFormulae : /^[=+\-@\t\r].*$/);
            }();
            var u = new RegExp(Q(s), "g");
            "string" == typeof e && (e = JSON.parse(e));
            if (Array.isArray(e)) {
                if (!e.length || Array.isArray(e[0])) return h(null, e, r);
                if ("object" == typeof e[0]) return h(i || Object.keys(e[0]), e, r);
            } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || i), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
                e.data
            ])), h(e.fields || [], e.data || [], r);
            throw new Error("Unable to serialize unrecognized input");
            function h(e, t, r) {
                var i = "";
                "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
                var n = Array.isArray(e) && 0 < e.length, s = !Array.isArray(t[0]);
                if (n && _) {
                    for(var a = 0; a < e.length; a++)0 < a && (i += m), i += v(e[a], a);
                    0 < t.length && (i += y);
                }
                for(var o = 0; o < t.length; o++){
                    var u = n ? e.length : t[o].length, h = !1, f = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                    if (r && !n && (h = "greedy" === r ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === r && n) {
                        for(var d = [], l = 0; l < u; l++){
                            var c = s ? e[l] : l;
                            d.push(t[o][c]);
                        }
                        h = "" === d.join("").trim();
                    }
                    if (!h) {
                        for(var p = 0; p < u; p++){
                            0 < p && !f && (i += m);
                            var g = n && s ? e[p] : p;
                            i += v(t[o][g], p);
                        }
                        o < t.length - 1 && (!r || 0 < u && !f) && (i += y);
                    }
                }
                return i;
            }
            function v(e, t) {
                if (null == e) return "";
                if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
                var r = !1;
                o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0);
                var i = e.toString().replace(u, a);
                return (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || function(e, t) {
                    for(var r = 0; r < t.length; r++)if (-1 < e.indexOf(t[r])) return !0;
                    return !1;
                }(i, b.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i;
            }
        }
    };
    if (b.RECORD_SEP = String.fromCharCode(30), b.UNIT_SEP = String.fromCharCode(31), b.BYTE_ORDER_MARK = "\ufeff", b.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        b.BYTE_ORDER_MARK
    ], b.WORKERS_SUPPORTED = !n && !!f.Worker, b.NODE_STREAM_INPUT = 1, b.LocalChunkSize = 10485760, b.RemoteChunkSize = 5242880, b.DefaultDelimiter = ",", b.Parser = E, b.ParserHandle = r, b.NetworkStreamer = l, b.FileStreamer = c, b.StringStreamer = p, b.ReadableStreamStreamer = g, f.jQuery) {
        var d = f.jQuery;
        d.fn.parse = function(o) {
            var r = o.config || {}, u = [];
            return this.each(function(e) {
                if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && f.FileReader) || !this.files || 0 === this.files.length) return !0;
                for(var t = 0; t < this.files.length; t++)u.push({
                    file: this.files[t],
                    inputElem: this,
                    instanceConfig: d.extend({}, r)
                });
            }), e(), this;
            function e() {
                if (0 !== u.length) {
                    var e, t, r, i, n = u[0];
                    if (J(o.before)) {
                        var s = o.before(n.file, n.inputElem);
                        if ("object" == typeof s) {
                            if ("abort" === s.action) return e = "AbortError", t = n.file, r = n.inputElem, i = s.reason, void (J(o.error) && o.error({
                                name: e
                            }, t, r, i));
                            if ("skip" === s.action) return void h();
                            "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                        } else if ("skip" === s) return void h();
                    }
                    var a = n.instanceConfig.complete;
                    n.instanceConfig.complete = function(e) {
                        J(a) && a(e, n.file, n.inputElem), h();
                    }, b.parse(n.file, n.instanceConfig);
                } else J(o.complete) && o.complete();
            }
            function h() {
                u.splice(0, 1), e();
            }
        };
    }
    function h(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = w(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new r(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(e, t) {
            if (this.isFirstChunk && J(this._config.beforeFirstChunk)) {
                var r = this._config.beforeFirstChunk(e);
                void 0 !== r && (e = r);
            }
            this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + e;
            this._partialLine = "";
            var n = this._handle.parse(i, this._baseIndex, !this._finished);
            if (!this._handle.paused() && !this._handle.aborted()) {
                var s = n.meta.cursor;
                this._finished || (this._partialLine = i.substring(s - this._baseIndex), this._baseIndex = s), n && n.data && (this._rowCount += n.data.length);
                var a = this._finished || this._config.preview && this._rowCount >= this._config.preview;
                if (o) f.postMessage({
                    results: n,
                    workerId: b.WORKER_ID,
                    finished: a
                });
                else if (J(this._config.chunk) && !t) {
                    if (this._config.chunk(n, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    n = void 0, this._completeResults = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(n.data), this._completeResults.errors = this._completeResults.errors.concat(n.errors), this._completeResults.meta = n.meta), this._completed || !a || !J(this._config.complete) || n && n.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), a || n && n.meta.paused || this._nextChunk(), n;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            J(this._config.error) ? this._config.error(e) : o && this._config.error && f.postMessage({
                workerId: b.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function l(e) {
        var i;
        (e = e || {}).chunkSize || (e.chunkSize = b.RemoteChunkSize), h.call(this, e), this._nextChunk = n ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (i = new XMLHttpRequest, this._config.withCredentials && (i.withCredentials = this._config.withCredentials), n || (i.onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)), i.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !n), this._config.downloadRequestHeaders) {
                    var e = this._config.downloadRequestHeaders;
                    for(var t in e)i.setRequestHeader(t, e[t]);
                }
                if (this._config.chunkSize) {
                    var r = this._start + this._config.chunkSize - 1;
                    i.setRequestHeader("Range", "bytes=" + this._start + "-" + r);
                }
                try {
                    i.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                n && 0 === i.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === i.readyState && (i.status < 200 || 400 <= i.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : i.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(e) {
                var t = e.getResponseHeader("Content-Range");
                if (null === t) return -1;
                return parseInt(t.substring(t.lastIndexOf("/") + 1));
            }(i), this.parseChunk(i.responseText)));
        }, this._chunkError = function(e) {
            var t = i.statusText || e;
            this._sendError(new Error(t));
        };
    }
    function c(e) {
        var i, n;
        (e = e || {}).chunkSize || (e.chunkSize = b.LocalChunkSize), h.call(this, e);
        var s = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, n = e.slice || e.webkitSlice || e.mozSlice, s ? ((i = new FileReader).onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input;
            if (this._config.chunkSize) {
                var t = Math.min(this._start + this._config.chunkSize, this._input.size);
                e = n.call(e, this._start, t);
            }
            var r = i.readAsText(e, this._config.encoding);
            s || this._chunkLoaded({
                target: {
                    result: r
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function p(e) {
        var r;
        h.call(this, e = e || {}), this.stream = function(e) {
            return r = e, this._nextChunk();
        }, this._nextChunk = function() {
            if (!this._finished) {
                var e, t = this._config.chunkSize;
                return t ? (e = r.substring(0, t), r = r.substring(t)) : (e = r, r = ""), this._finished = !r, this.parseChunk(e);
            }
        };
    }
    function g(e) {
        h.call(this, e = e || {});
        var t = [], r = !0, i = !1;
        this.pause = function() {
            h.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            h.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            i && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : r = !0;
        }, this._streamData = v(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), r && (r = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = v(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = v(function() {
            this._streamCleanUp(), i = !0, this._streamData("");
        }, this), this._streamCleanUp = v(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function r(m) {
        var a, o, u, i = Math.pow(2, 53), n = -i, s = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, h = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, t = this, r = 0, f = 0, d = !1, e = !1, l = [], c = {
            data: [],
            errors: [],
            meta: {}
        };
        if (J(m.step)) {
            var p = m.step;
            m.step = function(e) {
                if (c = e, _()) g();
                else {
                    if (g(), 0 === c.data.length) return;
                    r += e.data.length, m.preview && r > m.preview ? o.abort() : (c.data = c.data[0], p(c, t));
                }
            };
        }
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            return c && u && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + b.DefaultDelimiter + "'"), u = !1), m.skipEmptyLines && (c.data = c.data.filter(function(e) {
                return !y(e);
            })), _() && function() {
                if (!c) return;
                function e(e, t) {
                    J(m.transformHeader) && (e = m.transformHeader(e, t)), l.push(e);
                }
                if (Array.isArray(c.data[0])) {
                    for(var t = 0; _() && t < c.data.length; t++)c.data[t].forEach(e);
                    c.data.splice(0, 1);
                } else c.data.forEach(e);
            }(), function() {
                if (!c || !m.header && !m.dynamicTyping && !m.transform) return c;
                function e(e, t) {
                    var r, i = m.header ? {} : [];
                    for(r = 0; r < e.length; r++){
                        var n = r, s = e[r];
                        m.header && (n = r >= l.length ? "__parsed_extra" : l[r]), m.transform && (s = m.transform(s, n)), s = v(n, s), "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                    }
                    return m.header && (r > l.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + l.length + " fields but parsed " + r, f + t) : r < l.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + l.length + " fields but parsed " + r, f + t)), i;
                }
                var t = 1;
                !c.data.length || Array.isArray(c.data[0]) ? (c.data = c.data.map(e), t = c.data.length) : c.data = e(c.data, 0);
                m.header && c.meta && (c.meta.fields = l);
                return f += t, c;
            }();
        }
        function _() {
            return m.header && 0 === l.length;
        }
        function v(e, t) {
            var r;
            return r = e, m.dynamicTypingFunction && void 0 === m.dynamicTyping[r] && (m.dynamicTyping[r] = m.dynamicTypingFunction(r)), !0 === (m.dynamicTyping[r] || m.dynamicTyping) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (function(e) {
                if (s.test(e)) {
                    var t = parseFloat(e);
                    if (n < t && t < i) return !0;
                }
                return !1;
            }(t) ? parseFloat(t) : h.test(t) ? new Date(t) : "" === t ? null : t) : t;
        }
        function k(e, t, r, i) {
            var n = {
                type: e,
                code: t,
                message: r
            };
            void 0 !== i && (n.row = i), c.errors.push(n);
        }
        this.parse = function(e, t, r) {
            var i = m.quoteChar || '"';
            if (m.newline || (m.newline = function(e, t) {
                e = e.substring(0, 1048576);
                var r = new RegExp(Q(t) + "([^]*?)" + Q(t), "gm"), i = (e = e.replace(r, "")).split("\r"), n = e.split("\n"), s = 1 < n.length && n[0].length < i[0].length;
                if (1 === i.length || s) return "\n";
                for(var a = 0, o = 0; o < i.length; o++)"\n" === i[o][0] && a++;
                return a >= i.length / 2 ? "\r\n" : "\r";
            }(e, i)), u = !1, m.delimiter) J(m.delimiter) && (m.delimiter = m.delimiter(e), c.meta.delimiter = m.delimiter);
            else {
                var n = function(e, t, r, i, n) {
                    var s, a, o, u;
                    n = n || [
                        ",",
                        "\t",
                        "|",
                        ";",
                        b.RECORD_SEP,
                        b.UNIT_SEP
                    ];
                    for(var h = 0; h < n.length; h++){
                        var f = n[h], d = 0, l = 0, c = 0;
                        o = void 0;
                        for(var p = new E({
                            comments: i,
                            delimiter: f,
                            newline: t,
                            preview: 10
                        }).parse(e), g = 0; g < p.data.length; g++)if (r && y(p.data[g])) c++;
                        else {
                            var _ = p.data[g].length;
                            l += _, void 0 !== o ? 0 < _ && (d += Math.abs(_ - o), o = _) : o = _;
                        }
                        0 < p.data.length && (l /= p.data.length - c), (void 0 === a || d <= a) && (void 0 === u || u < l) && 1.99 < l && (a = d, s = f, u = l);
                    }
                    return {
                        successful: !!(m.delimiter = s),
                        bestDelimiter: s
                    };
                }(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess);
                n.successful ? m.delimiter = n.bestDelimiter : (u = !0, m.delimiter = b.DefaultDelimiter), c.meta.delimiter = m.delimiter;
            }
            var s = w(m);
            return m.preview && m.header && s.preview++, a = e, o = new E(s), c = o.parse(a, t, r), g(), d ? {
                meta: {
                    paused: !0
                }
            } : c || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return d;
        }, this.pause = function() {
            d = !0, o.abort(), a = J(m.chunk) ? "" : a.substring(o.getCharIndex());
        }, this.resume = function() {
            t.streamer._halted ? (d = !1, t.streamer.parseChunk(a, !0)) : setTimeout(t.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, o.abort(), c.meta.aborted = !0, J(m.complete) && m.complete(c), a = "";
        };
    }
    function Q(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(j) {
        var z, M = (j = j || {}).delimiter, P = j.newline, U = j.comments, q = j.step, N = j.preview, B = j.fastMode, K = z = void 0 === j.quoteChar || null === j.quoteChar ? '"' : j.quoteChar;
        if (void 0 !== j.escapeChar && (K = j.escapeChar), ("string" != typeof M || -1 < b.BAD_DELIMITERS.indexOf(M)) && (M = ","), U === M) throw new Error("Comment character same as delimiter");
        !0 === U ? U = "#" : ("string" != typeof U || -1 < b.BAD_DELIMITERS.indexOf(U)) && (U = !1), "\n" !== P && "\r" !== P && "\r\n" !== P && (P = "\n");
        var W = 0, H = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = M.length, s = P.length, a = U.length, o = J(q), u = [], h = [], f = [], d = W = 0;
            if (!i) return L();
            if (j.header && !t) {
                var l = i.split(P)[0].split(M), c = [], p = {}, g = !1;
                for(var _ in l){
                    var m = l[_];
                    J(j.transformHeader) && (m = j.transformHeader(m, _));
                    var y = m, v = p[m] || 0;
                    for(0 < v && (g = !0, y = m + "_" + v), p[m] = v + 1; c.includes(y);)y = y + "_" + v;
                    c.push(y);
                }
                if (g) {
                    var k = i.split(P);
                    k[0] = c.join(M), i = k.join(P);
                }
            }
            if (B || !1 !== B && -1 === i.indexOf(z)) {
                for(var b = i.split(P), E = 0; E < b.length; E++){
                    if (f = b[E], W += f.length, E !== b.length - 1) W += P.length;
                    else if (r) return L();
                    if (!U || f.substring(0, a) !== U) {
                        if (o) {
                            if (u = [], I(f.split(M)), F(), H) return L();
                        } else I(f.split(M));
                        if (N && N <= E) return u = u.slice(0, N), L(!0);
                    }
                }
                return L();
            }
            for(var w = i.indexOf(M, W), R = i.indexOf(P, W), C = new RegExp(Q(K) + Q(z), "g"), S = i.indexOf(z, W);;)if (i[W] !== z) {
                if (U && 0 === f.length && i.substring(W, W + a) === U) {
                    if (-1 === R) return L();
                    W = R + s, R = i.indexOf(P, W), w = i.indexOf(M, W);
                } else if (-1 !== w && (w < R || -1 === R)) f.push(i.substring(W, w)), W = w + e, w = i.indexOf(M, W);
                else {
                    if (-1 === R) break;
                    if (f.push(i.substring(W, R)), D(R + s), o && (F(), H)) return L();
                    if (N && u.length >= N) return L(!0);
                }
            } else for(S = W, W++;;){
                if (-1 === (S = i.indexOf(z, S + 1))) return r || h.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: u.length,
                    index: W
                }), T();
                if (S === n - 1) return T(i.substring(W, S).replace(C, z));
                if (z !== K || i[S + 1] !== K) {
                    if (z === K || 0 === S || i[S - 1] !== K) {
                        -1 !== w && w < S + 1 && (w = i.indexOf(M, S + 1)), -1 !== R && R < S + 1 && (R = i.indexOf(P, S + 1));
                        var O = A(-1 === R ? w : Math.min(w, R));
                        if (i.substr(S + 1 + O, e) === M) {
                            f.push(i.substring(W, S).replace(C, z)), i[W = S + 1 + O + e] !== z && (S = i.indexOf(z, W)), w = i.indexOf(M, W), R = i.indexOf(P, W);
                            break;
                        }
                        var x = A(R);
                        if (i.substring(S + 1 + x, S + 1 + x + s) === P) {
                            if (f.push(i.substring(W, S).replace(C, z)), D(S + 1 + x + s), w = i.indexOf(M, W), S = i.indexOf(z, W), o && (F(), H)) return L();
                            if (N && u.length >= N) return L(!0);
                            break;
                        }
                        h.push({
                            type: "Quotes",
                            code: "InvalidQuotes",
                            message: "Trailing quote on quoted field is malformed",
                            row: u.length,
                            index: W
                        }), S++;
                    }
                } else S++;
            }
            return T();
            function I(e) {
                u.push(e), d = W;
            }
            function A(e) {
                var t = 0;
                if (-1 !== e) {
                    var r = i.substring(S + 1, e);
                    r && "" === r.trim() && (t = r.length);
                }
                return t;
            }
            function T(e) {
                return r || (void 0 === e && (e = i.substring(W)), f.push(e), W = n, I(f), o && F()), L();
            }
            function D(e) {
                W = e, I(f), f = [], R = i.indexOf(P, W);
            }
            function L(e) {
                return {
                    data: u,
                    errors: h,
                    meta: {
                        delimiter: M,
                        linebreak: P,
                        aborted: H,
                        truncated: !!e,
                        cursor: d + (t || 0)
                    }
                };
            }
            function F() {
                q(L()), u = [], h = [];
            }
        }, this.abort = function() {
            H = !0;
        }, this.getCharIndex = function() {
            return W;
        };
    }
    function _(e) {
        var t = e.data, r = a[t.workerId], i = !1;
        if (t.error) r.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    i = !0, m(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: y,
                resume: y
            };
            if (J(r.userStep)) {
                for(var s = 0; s < t.results.data.length && (r.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !i); s++);
                delete t.results;
            } else J(r.userChunk) && (r.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !i && m(t.workerId, t.results);
    }
    function m(e, t) {
        var r = a[e];
        J(r.userComplete) && r.userComplete(t), r.terminate(), delete a[e];
    }
    function y() {
        throw new Error("Not implemented.");
    }
    function w(e) {
        if ("object" != typeof e || null === e) return e;
        var t = Array.isArray(e) ? [] : {};
        for(var r in e)t[r] = w(e[r]);
        return t;
    }
    function v(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function J(e) {
        return "function" == typeof e;
    }
    return o && (f.onmessage = function(e) {
        var t = e.data;
        void 0 === b.WORKER_ID && t && (b.WORKER_ID = t.workerId);
        if ("string" == typeof t.input) f.postMessage({
            workerId: b.WORKER_ID,
            results: b.parse(t.input, t.config),
            finished: !0
        });
        else if (f.File && t.input instanceof File || t.input instanceof Object) {
            var r = b.parse(t.input, t.config);
            r && f.postMessage({
                workerId: b.WORKER_ID,
                results: r,
                finished: !0
            });
        }
    }), (l.prototype = Object.create(h.prototype)).constructor = l, (c.prototype = Object.create(h.prototype)).constructor = c, (p.prototype = Object.create(p.prototype)).constructor = p, (g.prototype = Object.create(h.prototype)).constructor = g, b;
});

},{}],"5RLUj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpRequest = require("./datasources/http-request");
var _client = require("./datasources/http-request/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
exports.default = {
    datasources: {
        [(0, _httpRequest.apiName)]: (0, _clientDefault.default)
    }
};

},{"./datasources/http-request":"5qSAM","./datasources/http-request/client":"3lpgi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5qSAM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
const apiName = 'FormEngineHttpRequestDatasource';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3lpgi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchBackend = require("@form-engine/core-application/datasources/fetch-backend");
var _fetchBackendDefault = parcelHelpers.interopDefault(_fetchBackend);
var _staticDatasource = require("@form-engine/datasource-static/datasources/static-datasource");
var _staticDatasourceDefault = parcelHelpers.interopDefault(_staticDatasource);
var _ = require(".");
async function FormEngineHttpRequestDatasource({ definition, form, session }) {
    const { prefetchResult, ...staticOptions } = definition;
    if (prefetchResult !== undefined) return (0, _staticDatasourceDefault.default)({
        definition: {
            ...staticOptions,
            source: prefetchResult
        },
        form,
        session
    });
    if (!form?.id) throw new Error('tried to invoke datasource with incomplete form definition');
    let source = '';
    // skip loading when editing
    if (![
        'translate',
        'edit'
    ].includes(session?.editMode ?? '')) {
        const { data } = await (0, _fetchBackendDefault.default)(form.id, definition.id, session ?? {});
        source = data;
    }
    return (0, _staticDatasourceDefault.default)({
        definition: {
            ...staticOptions,
            source
        },
        form,
        session
    });
}
FormEngineHttpRequestDatasource.apiName = (0, _.apiName);
exports.default = FormEngineHttpRequestDatasource;

},{"@form-engine/core-application/datasources/fetch-backend":"e1qSx","@form-engine/datasource-static/datasources/static-datasource":"h0bDq",".":"5qSAM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e1qSx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>fetchDatasourceBackend);
var _fetchBackend = require("@form-engine/core-util/fetch-backend");
var _fetchBackendDefault = parcelHelpers.interopDefault(_fetchBackend);
var _index = require("@form-engine/core-application/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
async function fetchDatasourceBackend(formId, datasourceId, session, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, options = {}) {
    const path = (0, _indexDefault.default).datasourceBackendRoute.replace(':formId', formId).replace(':datasourceId', datasourceId);
    return (0, _fetchBackendDefault.default)(path, session, data, options) || {};
}

},{"@form-engine/core-util/fetch-backend":"iZ0XX","@form-engine/core-application/index":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2but4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pageElement = require("./components/page-element");
var _pageElementDefault = parcelHelpers.interopDefault(_pageElement);
exports.default = {
    elements: {
        [(0, _pageElementDefault.default).apiName]: (0, _pageElementDefault.default)
    }
};

},{"./components/page-element":"1yaLX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1yaLX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _element = require("@form-engine/core-application/components/element");
var _elementDefault = parcelHelpers.interopDefault(_element);
var _container = require("@form-engine/core-application/components/container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _useElementDefault = parcelHelpers.interopDefault(_useElement);
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
const apiName = 'FormEnginePageElement';
exports.default = Object.assign(function FormEnginePageElement({ elementComponent = (0, _elementDefault.default), containerComponent: Container = (0, _containerDefault.default), id, editMode }) {
    const { state: { elements = [] } } = (0, _useForm.useFormContext)();
    const { state: element } = (0, _useElementDefault.default)(id);
    if (!element || element.type !== apiName) throw new Error('tried to render page with invalid definition');
    const { state: { currentPage = '' } } = (0, _useFormsession.useFormSessionContext)();
    const childElementIds = (0, _react.useMemo)(()=>elements.filter((element)=>element.parent === id).map((element)=>element.id), [
        elements,
        id
    ]);
    let isActive = true;
    if (!editMode) {
        if (!currentPage) isActive = Boolean(element.isDefault);
        else isActive = currentPage === element.name;
    }
    if (!isActive) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Container, {
        id: id,
        className: "fe-page",
        childElementIds: childElementIds,
        elementComponent: elementComponent,
        containerComponent: Container
    });
}, {
    apiName,
    isField: false,
    isContainer: true,
    enabled: true
});

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-application/components/element":"dt2u8","@form-engine/core-application/components/container":"hxA8J","@form-engine/core-application/hooks/use-element":"ehckF","@form-engine/core-application/hooks/use-formsession":"2Th33","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fD11m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inputElement = require("./components/input-element");
var _inputElementDefault = parcelHelpers.interopDefault(_inputElement);
exports.default = {
    elements: {
        [(0, _inputElementDefault.default).apiName]: (0, _inputElementDefault.default)
    }
};

},{"./components/input-element":"adGv3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"adGv3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
var _jsxRuntime = require("react/jsx-runtime");
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _useElementDisabled = require("@form-engine/core-application/hooks/use-element-disabled");
var _useElementRequired = require("@form-engine/core-application/hooks/use-element-required");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _classNames = require("@form-engine/core-util/class-names");
var _classNamesDefault = parcelHelpers.interopDefault(_classNames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _useDateElementAttributes = require("../hooks/use-date-element-attributes");
var _useDateElementAttributesDefault = parcelHelpers.interopDefault(_useDateElementAttributes);
const apiName = 'FormEngineInputElement';
exports.default = Object.assign(function FormEngineInputElement({ editMode = false, formGroupProps, ...additionalPropsProp }) {
    const { state: { showValidFeedback = true } } = (0, _useForm.useFormContext)();
    // make this smarter in the future
    const { state: element } = (0, _useElement.useFormEngineElement)();
    if (!element) throw new Error(`tried to render input with invalid definition`);
    const [session, setSession] = (0, _useFormsession.useFormElementSession)();
    const disabled = (0, _useElementDisabled.useFormEngineElementDisabled)();
    const required = (0, _useElementRequired.useFormEngineElementRequired)();
    const handleChange = (0, _react.useCallback)((e)=>{
        const value = e.target.value;
        setSession({
            ...session,
            value
        });
    }, [
        setSession,
        session
    ]);
    const handleTouched = (0, _react.useCallback)(()=>{
        setSession({
            ...session,
            isTouched: true
        });
    }, [
        setSession,
        session
    ]);
    let additionalProps = {
        ...(0, _useDateElementAttributesDefault.default)(element),
        ...additionalPropsProp
    };
    delete additionalProps.containerComponent;
    delete additionalProps.elementComponent;
    delete additionalProps.source;
    delete additionalProps.parent;
    delete additionalProps.id;
    delete additionalProps.prepend;
    delete additionalProps.append;
    if (editMode) additionalProps = {
        ...additionalProps,
        autoComplete: 'off',
        autoCorrect: 'off',
        autoCapitalize: 'none',
        spellCheck: 'false'
    };
    const type = additionalProps.type || String(element.inputType || 'text');
    const control = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
        id: element.id,
        name: element.name,
        placeholder: element.placeholder || '',
        disabled: disabled,
        required: required,
        isValid: showValidFeedback && session.isTouched && !session.error && !session.loading,
        isInvalid: Boolean(session.isTouched && session.error),
        onChange: handleChange,
        onBlur: handleTouched,
        value: type === 'file' ? undefined : String(session.value),
        autoComplete: element.autoComplete || 'on',
        ...additionalProps,
        type: type
    });
    const error = session.isTouched && element.showError && session.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl).Feedback, {
        type: "invalid",
        tooltip: false,
        children: session.error
    });
    const loader = session.loading !== undefined && session.loading !== false && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.ProgressBar), {
        className: "mt-1",
        style: {
            height: '5px'
        },
        animated: true,
        striped: true,
        now: typeof session.loading === 'number' ? session.loading : 100
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormGroup), {
        ...formGroupProps ?? {},
        className: (0, _classNamesDefault.default)('fe-input', formGroupProps?.className),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                element.label && element.floatingLabel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FloatingLabel), {
                    label: element.label,
                    controlId: element.id,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(control.type, {
                                ...control.props,
                                id: undefined
                            }),
                            error
                        ]
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        element.label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormLabel), {
                            htmlFor: element.id,
                            children: element.label
                        }),
                        control,
                        error
                    ]
                }),
                loader
            ]
        })
    });
}, {
    apiName,
    isField: true,
    enabled: true
});

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/hooks/use-element":"ehckF","@form-engine/core-application/hooks/use-element-disabled":"klZMn","@form-engine/core-application/hooks/use-element-required":"cruGZ","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-application/hooks/use-formsession":"2Th33","@form-engine/core-util/class-names":"fk8HN","react":"9njXz","react-bootstrap":"f5rnA","../hooks/use-date-element-attributes":"cym0G","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cruGZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormEngineElementRequiredState", ()=>useFormEngineElementRequiredState);
parcelHelpers.export(exports, "useFormEngineElementRequired", ()=>useFormEngineElementRequired);
var _expressions = require("@form-engine/core-util/expressions");
var _react = require("react");
var _useElement = require("./use-element");
var _useElementDefault = parcelHelpers.interopDefault(_useElement);
var _useFormsession = require("./use-formsession");
function useFormEngineElementRequiredState(id) {
    const element = (0, _useElementDefault.default)(id)?.state;
    const { state: locals } = (0, _useFormsession.useFormSessionLocals)();
    return (0, _react.useMemo)(()=>{
        if (!element || element.required || !element.requiredExpressions?.length) return Boolean(element?.required);
        return Boolean((0, _expressions.evalExpressions)(element.requiredExpressions, locals));
    }, [
        locals,
        element?.id,
        element?.required,
        element?.requiredExpressions
    ]);
}
function useFormEngineElementRequired() {
    return useFormEngineElementRequiredState((0, _useElement.useFormEngineElementId)());
}

},{"@form-engine/core-util/expressions":"ayzLO","react":"9njXz","./use-element":"ehckF","./use-formsession":"2Th33","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fk8HN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classNames);
function classNames(...args) {
    const result = [];
    for (const arg of args){
        if (typeof arg === 'string' && arg.trim()) result.push(arg.trim());
        else if (Object.prototype.toString.call(arg) === '[object Object]') {
            for (const [className, condition] of Object.entries(arg))if (condition && className.trim()) result.push(className.trim());
        }
    }
    if (!result.length) return;
    return result.reduce((p, c)=>{
        if (!p.includes(c)) p.push(c);
        return p;
    }, []).join(' ');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cym0G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDateElementAttributes);
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _react = require("react");
var _day = require("@form-engine/core-util/day");
var _template = require("@form-engine/core-util/template");
/**
 * parses a date provided via template into a Date object and than adds one day
 * to it, providing the _minimum_ date, that can be selected in the date picker.
 * finally returns in the ISO Date (w/o time) format required by datepicker inputs.
 * @param template - The template containing some form of date representation e.g. `{{date "now"}}`
 * @param locals - variable stack to use during template compilation
 * @returns ISO Date string
 */ function getMin(template, locals) {
    const date = new Date((0, _template.compile)(String(template), locals));
    if (isNaN(date.getTime())) return '';
    return (0, _day.day)(date).add(1, 'day').format('YYYY-MM-DD');
}
/**
 * parses a date provided via template into a Date object and than substracts one day
 * from it, providing the _maximum_ date, that can be selected in the date picker.
 * finally returns in the ISO Date (w/o time) format required by datepicker inputs.
 * @param template - The template containing some form of date representation e.g. `{{date "now"}}`
 * @param locals - variable stack to use during template compilation
 * @returns ISO Date string
 */ function getMax(template, locals) {
    const date = new Date((0, _template.compile)(String(template), locals));
    if (isNaN(date.getTime())) return '';
    return (0, _day.day)(date).subtract(1, 'day').format('YYYY-MM-DD');
}
function useDateElementAttributes(element) {
    const locals = (0, _useFormsession.useFormSessionLocals)();
    return (0, _react.useMemo)(()=>{
        const attrs = {};
        if (![
            'date',
            'datetime'
        ].includes(String(element?.inputType))) return attrs;
        if (element?.validateContentTypeDateAfter) attrs.min = getMin(element?.validateContentTypeDateAfter, locals);
        if (element?.validateContentTypeDateBefore) attrs.max = getMax(element?.validateContentTypeDateBefore, locals);
        return attrs;
    }, [
        element,
        locals.state
    ]);
}

},{"@form-engine/core-application/hooks/use-formsession":"2Th33","react":"9njXz","@form-engine/core-util/day":"fgtKF","@form-engine/core-util/template":"bKMue","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fgtKF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dayLib", ()=>_dayjs);
parcelHelpers.export(exports, "day", ()=>(0, _dayjsDefault.default));
parcelHelpers.export(exports, "formatDistanceToNow", ()=>formatDistanceToNow);
parcelHelpers.export(exports, "formatDateTime", ()=>formatDateTime);
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _duration = require("dayjs/plugin/duration");
var _durationDefault = parcelHelpers.interopDefault(_duration);
var _relativeTime = require("dayjs/plugin/relativeTime");
var _relativeTimeDefault = parcelHelpers.interopDefault(_relativeTime);
var _calendar = require("dayjs/plugin/calendar");
var _calendarDefault = parcelHelpers.interopDefault(_calendar);
_dayjs.extend((0, _durationDefault.default));
_dayjs.extend((0, _relativeTimeDefault.default));
_dayjs.extend((0, _calendarDefault.default));
function formatDistanceToNow(date, withoutSuffix = true) {
    return (0, _dayjsDefault.default)(date).fromNow(withoutSuffix);
}
function formatDateTime(date, format = new Intl.DateTimeFormat(navigator?.language ?? 'en', {
    dateStyle: 'short',
    timeStyle: 'short'
})) {
    return format.format(date);
}

},{"dayjs":"9FMDe","dayjs/plugin/duration":"ltDXl","dayjs/plugin/relativeTime":"22eVN","dayjs/plugin/calendar":"gTMog","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9FMDe":[function(require,module,exports,__globalThis) {
!function(t, e) {
    module.exports = e();
}(this, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

},{}],"ltDXl":[function(require,module,exports,__globalThis) {
!function(t, s) {
    module.exports = s();
}(this, function() {
    "use strict";
    var t, s, n = 1e3, i = 6e4, e = 36e5, r = 864e5, o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = 31536e6, d = 2628e6, a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, h = {
        years: u,
        months: d,
        days: r,
        hours: e,
        minutes: i,
        seconds: n,
        milliseconds: 1,
        weeks: 6048e5
    }, c = function(t) {
        return t instanceof g;
    }, f = function(t, s, n) {
        return new g(t, n, s.$l);
    }, m = function(t) {
        return s.p(t) + "s";
    }, l = function(t) {
        return t < 0;
    }, $ = function(t) {
        return l(t) ? Math.ceil(t) : Math.floor(t);
    }, y = function(t) {
        return Math.abs(t);
    }, v = function(t, s) {
        return t ? l(t) ? {
            negative: !0,
            format: "" + y(t) + s
        } : {
            negative: !1,
            format: "" + t + s
        } : {
            negative: !1,
            format: ""
        };
    }, g = function() {
        function l(t, s, n) {
            var i = this;
            if (this.$d = {}, this.$l = n, void 0 === t && (this.$ms = 0, this.parseFromMilliseconds()), s) return f(t * h[m(s)], this);
            if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
            if ("object" == typeof t) return Object.keys(t).forEach(function(s) {
                i.$d[m(s)] = t[s];
            }), this.calMilliseconds(), this;
            if ("string" == typeof t) {
                var e = t.match(a);
                if (e) {
                    var r = e.slice(2).map(function(t) {
                        return null != t ? Number(t) : 0;
                    });
                    return this.$d.years = r[0], this.$d.months = r[1], this.$d.weeks = r[2], this.$d.days = r[3], this.$d.hours = r[4], this.$d.minutes = r[5], this.$d.seconds = r[6], this.calMilliseconds(), this;
                }
            }
            return this;
        }
        var y = l.prototype;
        return y.calMilliseconds = function() {
            var t = this;
            this.$ms = Object.keys(this.$d).reduce(function(s, n) {
                return s + (t.$d[n] || 0) * h[n];
            }, 0);
        }, y.parseFromMilliseconds = function() {
            var t = this.$ms;
            this.$d.years = $(t / u), t %= u, this.$d.months = $(t / d), t %= d, this.$d.days = $(t / r), t %= r, this.$d.hours = $(t / e), t %= e, this.$d.minutes = $(t / i), t %= i, this.$d.seconds = $(t / n), t %= n, this.$d.milliseconds = t;
        }, y.toISOString = function() {
            var t = v(this.$d.years, "Y"), s = v(this.$d.months, "M"), n = +this.$d.days || 0;
            this.$d.weeks && (n += 7 * this.$d.weeks);
            var i = v(n, "D"), e = v(this.$d.hours, "H"), r = v(this.$d.minutes, "M"), o = this.$d.seconds || 0;
            this.$d.milliseconds && (o += this.$d.milliseconds / 1e3, o = Math.round(1e3 * o) / 1e3);
            var u = v(o, "S"), d = t.negative || s.negative || i.negative || e.negative || r.negative || u.negative, a = e.format || r.format || u.format ? "T" : "", h = (d ? "-" : "") + "P" + t.format + s.format + i.format + a + e.format + r.format + u.format;
            return "P" === h || "-P" === h ? "P0D" : h;
        }, y.toJSON = function() {
            return this.toISOString();
        }, y.format = function(t) {
            var n = t || "YYYY-MM-DDTHH:mm:ss", i = {
                Y: this.$d.years,
                YY: s.s(this.$d.years, 2, "0"),
                YYYY: s.s(this.$d.years, 4, "0"),
                M: this.$d.months,
                MM: s.s(this.$d.months, 2, "0"),
                D: this.$d.days,
                DD: s.s(this.$d.days, 2, "0"),
                H: this.$d.hours,
                HH: s.s(this.$d.hours, 2, "0"),
                m: this.$d.minutes,
                mm: s.s(this.$d.minutes, 2, "0"),
                s: this.$d.seconds,
                ss: s.s(this.$d.seconds, 2, "0"),
                SSS: s.s(this.$d.milliseconds, 3, "0")
            };
            return n.replace(o, function(t, s) {
                return s || String(i[t]);
            });
        }, y.as = function(t) {
            return this.$ms / h[m(t)];
        }, y.get = function(t) {
            var s = this.$ms, n = m(t);
            return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? $(s / h[n]) : this.$d[n], s || 0;
        }, y.add = function(t, s, n) {
            var i;
            return i = s ? t * h[m(s)] : c(t) ? t.$ms : f(t, this).$ms, f(this.$ms + i * (n ? -1 : 1), this);
        }, y.subtract = function(t, s) {
            return this.add(t, s, !0);
        }, y.locale = function(t) {
            var s = this.clone();
            return s.$l = t, s;
        }, y.clone = function() {
            return f(this.$ms, this);
        }, y.humanize = function(s) {
            return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
        }, y.valueOf = function() {
            return this.asMilliseconds();
        }, y.milliseconds = function() {
            return this.get("milliseconds");
        }, y.asMilliseconds = function() {
            return this.as("milliseconds");
        }, y.seconds = function() {
            return this.get("seconds");
        }, y.asSeconds = function() {
            return this.as("seconds");
        }, y.minutes = function() {
            return this.get("minutes");
        }, y.asMinutes = function() {
            return this.as("minutes");
        }, y.hours = function() {
            return this.get("hours");
        }, y.asHours = function() {
            return this.as("hours");
        }, y.days = function() {
            return this.get("days");
        }, y.asDays = function() {
            return this.as("days");
        }, y.weeks = function() {
            return this.get("weeks");
        }, y.asWeeks = function() {
            return this.as("weeks");
        }, y.months = function() {
            return this.get("months");
        }, y.asMonths = function() {
            return this.as("months");
        }, y.years = function() {
            return this.get("years");
        }, y.asYears = function() {
            return this.as("years");
        }, l;
    }(), p = function(t, s, n) {
        return t.add(s.years() * n, "y").add(s.months() * n, "M").add(s.days() * n, "d").add(s.hours() * n, "h").add(s.minutes() * n, "m").add(s.seconds() * n, "s").add(s.milliseconds() * n, "ms");
    };
    return function(n, i, e) {
        t = e, s = e().$utils(), e.duration = function(t, s) {
            var n = e.locale();
            return f(t, {
                $l: n
            }, s);
        }, e.isDuration = c;
        var r = i.prototype.add, o = i.prototype.subtract;
        i.prototype.add = function(t, s) {
            return c(t) ? p(this, t, 1) : r.bind(this)(t, s);
        }, i.prototype.subtract = function(t, s) {
            return c(t) ? p(this, t, -1) : o.bind(this)(t, s);
        };
    };
});

},{}],"22eVN":[function(require,module,exports,__globalThis) {
!function(r, e) {
    module.exports = e();
}(this, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});

},{}],"gTMog":[function(require,module,exports,__globalThis) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    "use strict";
    return function(e, t, a) {
        var n = "h:mm A", d = {
            lastDay: "[Yesterday at] " + n,
            sameDay: "[Today at] " + n,
            nextDay: "[Tomorrow at] " + n,
            nextWeek: "dddd [at] " + n,
            lastWeek: "[Last] dddd [at] " + n,
            sameElse: "MM/DD/YYYY"
        };
        t.prototype.calendar = function(e, t) {
            var n = t || this.$locale().calendar || d, o = a(e || void 0).startOf("d"), s = this.diff(o, "d", !0), i = "sameElse", f = s < -6 ? i : s < -1 ? "lastWeek" : s < 0 ? "lastDay" : s < 1 ? "sameDay" : s < 2 ? "nextDay" : s < 7 ? "nextWeek" : i, l = n[f] || d[f];
            return "function" == typeof l ? l.call(this, a()) : this.format(l);
        };
    };
});

},{}],"5xr8v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _markdownElement = require("./components/markdown-element");
var _markdownElementDefault = parcelHelpers.interopDefault(_markdownElement);
exports.default = {
    elements: {
        [(0, _markdownElementDefault.default).apiName]: (0, _markdownElementDefault.default)
    }
};

},{"./components/markdown-element":"cYufM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cYufM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _useMarkdown = require("@form-engine/core-application/hooks/use-markdown");
var _useMarkdownDefault = parcelHelpers.interopDefault(_useMarkdown);
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _template = require("@form-engine/core-util/template");
const apiName = 'FormEngineMarkdownElement';
exports.default = Object.assign(function FormEngineMarkdownElement() {
    const { state: element } = (0, _useElement.useFormEngineElement)();
    const { state: locals } = (0, _useFormsession.useFormSessionLocals)();
    if (!element || element.type !== apiName) throw new Error('tried to render markdown element with invalid definition');
    const compileMarkdown = (0, _useMarkdownDefault.default)();
    const html = (0, _react.useMemo)(()=>{
        if (String(element.markdownBody).trim()) return compileMarkdown((0, _template.compile)(element.markdownBody ?? '', locals));
        else return '';
    }, [
        element.markdownBody,
        compileMarkdown,
        locals
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "fe-body-text",
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
}, {
    apiName,
    isField: false,
    enabled: true
});

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/core-application/hooks/use-element":"ehckF","@form-engine/core-application/hooks/use-markdown":"lwtKh","@form-engine/core-application/hooks/use-formsession":"2Th33","@form-engine/core-util/template":"bKMue","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lwtKh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMarkdown);
var _react = require("react");
var _showdown = require("showdown");
const converter = new (0, _showdown.Converter)({
    tables: true,
    simplifiedAutoLink: true,
    strikethrough: true,
    tasklists: true
});
function useMarkdown() {
    return (0, _react.useCallback)((source)=>{
        return converter.makeHtml(String(source ?? ''));
    }, []);
}

},{"react":"9njXz","showdown":"jcdSG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jcdSG":[function(require,module,exports,__globalThis) {
(function() {
    /**
 * Created by Tivie on 13-07-2015.
 */ function getDefaultOpts(simple) {
        'use strict';
        var defaultOptions = {
            omitExtraWLInCodeBlocks: {
                defaultValue: false,
                describe: 'Omit the default extra whiteline added to code blocks',
                type: 'boolean'
            },
            noHeaderId: {
                defaultValue: false,
                describe: 'Turn on/off generated header id',
                type: 'boolean'
            },
            prefixHeaderId: {
                defaultValue: false,
                describe: 'Add a prefix to the generated header ids. Passing a string will prefix that string to the header id. Setting to true will add a generic \'section-\' prefix',
                type: 'string'
            },
            rawPrefixHeaderId: {
                defaultValue: false,
                describe: 'Setting this option to true will prevent showdown from modifying the prefix. This might result in malformed IDs (if, for instance, the " char is used in the prefix)',
                type: 'boolean'
            },
            ghCompatibleHeaderId: {
                defaultValue: false,
                describe: 'Generate header ids compatible with github style (spaces are replaced with dashes, a bunch of non alphanumeric chars are removed)',
                type: 'boolean'
            },
            rawHeaderId: {
                defaultValue: false,
                describe: 'Remove only spaces, \' and " from generated header ids (including prefixes), replacing them with dashes (-). WARNING: This might result in malformed ids',
                type: 'boolean'
            },
            headerLevelStart: {
                defaultValue: false,
                describe: 'The header blocks level start',
                type: 'integer'
            },
            parseImgDimensions: {
                defaultValue: false,
                describe: 'Turn on/off image dimension parsing',
                type: 'boolean'
            },
            simplifiedAutoLink: {
                defaultValue: false,
                describe: 'Turn on/off GFM autolink style',
                type: 'boolean'
            },
            excludeTrailingPunctuationFromURLs: {
                defaultValue: false,
                describe: 'Excludes trailing punctuation from links generated with autoLinking',
                type: 'boolean'
            },
            literalMidWordUnderscores: {
                defaultValue: false,
                describe: 'Parse midword underscores as literal underscores',
                type: 'boolean'
            },
            literalMidWordAsterisks: {
                defaultValue: false,
                describe: 'Parse midword asterisks as literal asterisks',
                type: 'boolean'
            },
            strikethrough: {
                defaultValue: false,
                describe: 'Turn on/off strikethrough support',
                type: 'boolean'
            },
            tables: {
                defaultValue: false,
                describe: 'Turn on/off tables support',
                type: 'boolean'
            },
            tablesHeaderId: {
                defaultValue: false,
                describe: 'Add an id to table headers',
                type: 'boolean'
            },
            ghCodeBlocks: {
                defaultValue: true,
                describe: 'Turn on/off GFM fenced code blocks support',
                type: 'boolean'
            },
            tasklists: {
                defaultValue: false,
                describe: 'Turn on/off GFM tasklist support',
                type: 'boolean'
            },
            smoothLivePreview: {
                defaultValue: false,
                describe: 'Prevents weird effects in live previews due to incomplete input',
                type: 'boolean'
            },
            smartIndentationFix: {
                defaultValue: false,
                describe: 'Tries to smartly fix indentation in es6 strings',
                type: 'boolean'
            },
            disableForced4SpacesIndentedSublists: {
                defaultValue: false,
                describe: 'Disables the requirement of indenting nested sublists by 4 spaces',
                type: 'boolean'
            },
            simpleLineBreaks: {
                defaultValue: false,
                describe: 'Parses simple line breaks as <br> (GFM Style)',
                type: 'boolean'
            },
            requireSpaceBeforeHeadingText: {
                defaultValue: false,
                describe: 'Makes adding a space between `#` and the header text mandatory (GFM Style)',
                type: 'boolean'
            },
            ghMentions: {
                defaultValue: false,
                describe: 'Enables github @mentions',
                type: 'boolean'
            },
            ghMentionsLink: {
                defaultValue: 'https://github.com/{u}',
                describe: 'Changes the link generated by @mentions. Only applies if ghMentions option is enabled.',
                type: 'string'
            },
            encodeEmails: {
                defaultValue: true,
                describe: 'Encode e-mail addresses through the use of Character Entities, transforming ASCII e-mail addresses into its equivalent decimal entities',
                type: 'boolean'
            },
            openLinksInNewWindow: {
                defaultValue: false,
                describe: 'Open all links in new windows',
                type: 'boolean'
            },
            backslashEscapesHTMLTags: {
                defaultValue: false,
                describe: 'Support for HTML Tag escaping. ex: \<div>foo\</div>',
                type: 'boolean'
            },
            emoji: {
                defaultValue: false,
                describe: 'Enable emoji support. Ex: `this is a :smile: emoji`',
                type: 'boolean'
            },
            underline: {
                defaultValue: false,
                describe: 'Enable support for underline. Syntax is double or triple underscores: `__underline word__`. With this option enabled, underscores no longer parses into `<em>` and `<strong>`',
                type: 'boolean'
            },
            ellipsis: {
                defaultValue: true,
                describe: 'Replaces three dots with the ellipsis unicode character',
                type: 'boolean'
            },
            completeHTMLDocument: {
                defaultValue: false,
                describe: 'Outputs a complete html document, including `<html>`, `<head>` and `<body>` tags',
                type: 'boolean'
            },
            metadata: {
                defaultValue: false,
                describe: "Enable support for document metadata (defined at the top of the document between `\xab\xab\xab` and `\xbb\xbb\xbb` or between `---` and `---`).",
                type: 'boolean'
            },
            splitAdjacentBlockquotes: {
                defaultValue: false,
                describe: 'Split adjacent blockquote blocks',
                type: 'boolean'
            }
        };
        if (simple === false) return JSON.parse(JSON.stringify(defaultOptions));
        var ret = {};
        for(var opt in defaultOptions)if (defaultOptions.hasOwnProperty(opt)) ret[opt] = defaultOptions[opt].defaultValue;
        return ret;
    }
    function allOptionsOn() {
        'use strict';
        var options = getDefaultOpts(true), ret = {};
        for(var opt in options)if (options.hasOwnProperty(opt)) ret[opt] = true;
        return ret;
    }
    /**
 * Created by Tivie on 06-01-2015.
 */ // Private properties
    var showdown = {}, parsers = {}, extensions = {}, globalOptions = getDefaultOpts(true), setFlavor = 'vanilla', flavor = {
        github: {
            omitExtraWLInCodeBlocks: true,
            simplifiedAutoLink: true,
            excludeTrailingPunctuationFromURLs: true,
            literalMidWordUnderscores: true,
            strikethrough: true,
            tables: true,
            tablesHeaderId: true,
            ghCodeBlocks: true,
            tasklists: true,
            disableForced4SpacesIndentedSublists: true,
            simpleLineBreaks: true,
            requireSpaceBeforeHeadingText: true,
            ghCompatibleHeaderId: true,
            ghMentions: true,
            backslashEscapesHTMLTags: true,
            emoji: true,
            splitAdjacentBlockquotes: true
        },
        original: {
            noHeaderId: true,
            ghCodeBlocks: false
        },
        ghost: {
            omitExtraWLInCodeBlocks: true,
            parseImgDimensions: true,
            simplifiedAutoLink: true,
            excludeTrailingPunctuationFromURLs: true,
            literalMidWordUnderscores: true,
            strikethrough: true,
            tables: true,
            tablesHeaderId: true,
            ghCodeBlocks: true,
            tasklists: true,
            smoothLivePreview: true,
            simpleLineBreaks: true,
            requireSpaceBeforeHeadingText: true,
            ghMentions: false,
            encodeEmails: true
        },
        vanilla: getDefaultOpts(true),
        allOn: allOptionsOn()
    };
    /**
 * helper namespace
 * @type {{}}
 */ showdown.helper = {};
    /**
 * TODO LEGACY SUPPORT CODE
 * @type {{}}
 */ showdown.extensions = {};
    /**
 * Set a global option
 * @static
 * @param {string} key
 * @param {*} value
 * @returns {showdown}
 */ showdown.setOption = function(key, value) {
        'use strict';
        globalOptions[key] = value;
        return this;
    };
    /**
 * Get a global option
 * @static
 * @param {string} key
 * @returns {*}
 */ showdown.getOption = function(key) {
        'use strict';
        return globalOptions[key];
    };
    /**
 * Get the global options
 * @static
 * @returns {{}}
 */ showdown.getOptions = function() {
        'use strict';
        return globalOptions;
    };
    /**
 * Reset global options to the default values
 * @static
 */ showdown.resetOptions = function() {
        'use strict';
        globalOptions = getDefaultOpts(true);
    };
    /**
 * Set the flavor showdown should use as default
 * @param {string} name
 */ showdown.setFlavor = function(name) {
        'use strict';
        if (!flavor.hasOwnProperty(name)) throw Error(name + ' flavor was not found');
        showdown.resetOptions();
        var preset = flavor[name];
        setFlavor = name;
        for(var option in preset)if (preset.hasOwnProperty(option)) globalOptions[option] = preset[option];
    };
    /**
 * Get the currently set flavor
 * @returns {string}
 */ showdown.getFlavor = function() {
        'use strict';
        return setFlavor;
    };
    /**
 * Get the options of a specified flavor. Returns undefined if the flavor was not found
 * @param {string} name Name of the flavor
 * @returns {{}|undefined}
 */ showdown.getFlavorOptions = function(name) {
        'use strict';
        if (flavor.hasOwnProperty(name)) return flavor[name];
    };
    /**
 * Get the default options
 * @static
 * @param {boolean} [simple=true]
 * @returns {{}}
 */ showdown.getDefaultOptions = function(simple) {
        'use strict';
        return getDefaultOpts(simple);
    };
    /**
 * Get or set a subParser
 *
 * subParser(name)       - Get a registered subParser
 * subParser(name, func) - Register a subParser
 * @static
 * @param {string} name
 * @param {function} [func]
 * @returns {*}
 */ showdown.subParser = function(name, func) {
        'use strict';
        if (showdown.helper.isString(name)) {
            if (typeof func !== 'undefined') parsers[name] = func;
            else {
                if (parsers.hasOwnProperty(name)) return parsers[name];
                else throw Error('SubParser named ' + name + ' not registered!');
            }
        }
    };
    /**
 * Gets or registers an extension
 * @static
 * @param {string} name
 * @param {object|object[]|function=} ext
 * @returns {*}
 */ showdown.extension = function(name, ext) {
        'use strict';
        if (!showdown.helper.isString(name)) throw Error('Extension \'name\' must be a string');
        name = showdown.helper.stdExtName(name);
        // Getter
        if (showdown.helper.isUndefined(ext)) {
            if (!extensions.hasOwnProperty(name)) throw Error('Extension named ' + name + ' is not registered!');
            return extensions[name];
        // Setter
        } else {
            // Expand extension if it's wrapped in a function
            if (typeof ext === 'function') ext = ext();
            // Ensure extension is an array
            if (!showdown.helper.isArray(ext)) ext = [
                ext
            ];
            var validExtension = validate(ext, name);
            if (validExtension.valid) extensions[name] = ext;
            else throw Error(validExtension.error);
        }
    };
    /**
 * Gets all extensions registered
 * @returns {{}}
 */ showdown.getAllExtensions = function() {
        'use strict';
        return extensions;
    };
    /**
 * Remove an extension
 * @param {string} name
 */ showdown.removeExtension = function(name) {
        'use strict';
        delete extensions[name];
    };
    /**
 * Removes all extensions
 */ showdown.resetExtensions = function() {
        'use strict';
        extensions = {};
    };
    /**
 * Validate extension
 * @param {array} extension
 * @param {string} name
 * @returns {{valid: boolean, error: string}}
 */ function validate(extension, name) {
        'use strict';
        var errMsg = name ? 'Error in ' + name + ' extension->' : 'Error in unnamed extension', ret = {
            valid: true,
            error: ''
        };
        if (!showdown.helper.isArray(extension)) extension = [
            extension
        ];
        for(var i = 0; i < extension.length; ++i){
            var baseMsg = errMsg + ' sub-extension ' + i + ': ', ext = extension[i];
            if (typeof ext !== 'object') {
                ret.valid = false;
                ret.error = baseMsg + 'must be an object, but ' + typeof ext + ' given';
                return ret;
            }
            if (!showdown.helper.isString(ext.type)) {
                ret.valid = false;
                ret.error = baseMsg + 'property "type" must be a string, but ' + typeof ext.type + ' given';
                return ret;
            }
            var type = ext.type = ext.type.toLowerCase();
            // normalize extension type
            if (type === 'language') type = ext.type = 'lang';
            if (type === 'html') type = ext.type = 'output';
            if (type !== 'lang' && type !== 'output' && type !== 'listener') {
                ret.valid = false;
                ret.error = baseMsg + 'type ' + type + ' is not recognized. Valid values: "lang/language", "output/html" or "listener"';
                return ret;
            }
            if (type === 'listener') {
                if (showdown.helper.isUndefined(ext.listeners)) {
                    ret.valid = false;
                    ret.error = baseMsg + '. Extensions of type "listener" must have a property called "listeners"';
                    return ret;
                }
            } else if (showdown.helper.isUndefined(ext.filter) && showdown.helper.isUndefined(ext.regex)) {
                ret.valid = false;
                ret.error = baseMsg + type + ' extensions must define either a "regex" property or a "filter" method';
                return ret;
            }
            if (ext.listeners) {
                if (typeof ext.listeners !== 'object') {
                    ret.valid = false;
                    ret.error = baseMsg + '"listeners" property must be an object but ' + typeof ext.listeners + ' given';
                    return ret;
                }
                for(var ln in ext.listeners){
                    if (ext.listeners.hasOwnProperty(ln)) {
                        if (typeof ext.listeners[ln] !== 'function') {
                            ret.valid = false;
                            ret.error = baseMsg + '"listeners" property must be an hash of [event name]: [callback]. listeners.' + ln + ' must be a function but ' + typeof ext.listeners[ln] + ' given';
                            return ret;
                        }
                    }
                }
            }
            if (ext.filter) {
                if (typeof ext.filter !== 'function') {
                    ret.valid = false;
                    ret.error = baseMsg + '"filter" must be a function, but ' + typeof ext.filter + ' given';
                    return ret;
                }
            } else if (ext.regex) {
                if (showdown.helper.isString(ext.regex)) ext.regex = new RegExp(ext.regex, 'g');
                if (!(ext.regex instanceof RegExp)) {
                    ret.valid = false;
                    ret.error = baseMsg + '"regex" property must either be a string or a RegExp object, but ' + typeof ext.regex + ' given';
                    return ret;
                }
                if (showdown.helper.isUndefined(ext.replace)) {
                    ret.valid = false;
                    ret.error = baseMsg + '"regex" extensions must implement a replace string or function';
                    return ret;
                }
            }
        }
        return ret;
    }
    /**
 * Validate extension
 * @param {object} ext
 * @returns {boolean}
 */ showdown.validateExtension = function(ext) {
        'use strict';
        var validateExtension = validate(ext, null);
        if (!validateExtension.valid) {
            console.warn(validateExtension.error);
            return false;
        }
        return true;
    };
    /**
 * showdownjs helper functions
 */ if (!showdown.hasOwnProperty('helper')) showdown.helper = {};
    /**
 * Check if var is string
 * @static
 * @param {string} a
 * @returns {boolean}
 */ showdown.helper.isString = function(a) {
        'use strict';
        return typeof a === 'string' || a instanceof String;
    };
    /**
 * Check if var is a function
 * @static
 * @param {*} a
 * @returns {boolean}
 */ showdown.helper.isFunction = function(a) {
        'use strict';
        var getType = {};
        return a && getType.toString.call(a) === '[object Function]';
    };
    /**
 * isArray helper function
 * @static
 * @param {*} a
 * @returns {boolean}
 */ showdown.helper.isArray = function(a) {
        'use strict';
        return Array.isArray(a);
    };
    /**
 * Check if value is undefined
 * @static
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 */ showdown.helper.isUndefined = function(value) {
        'use strict';
        return typeof value === 'undefined';
    };
    /**
 * ForEach helper function
 * Iterates over Arrays and Objects (own properties only)
 * @static
 * @param {*} obj
 * @param {function} callback Accepts 3 params: 1. value, 2. key, 3. the original array/object
 */ showdown.helper.forEach = function(obj, callback) {
        'use strict';
        // check if obj is defined
        if (showdown.helper.isUndefined(obj)) throw new Error('obj param is required');
        if (showdown.helper.isUndefined(callback)) throw new Error('callback param is required');
        if (!showdown.helper.isFunction(callback)) throw new Error('callback param must be a function/closure');
        if (typeof obj.forEach === 'function') obj.forEach(callback);
        else if (showdown.helper.isArray(obj)) for(var i = 0; i < obj.length; i++)callback(obj[i], i, obj);
        else if (typeof obj === 'object') {
            for(var prop in obj)if (obj.hasOwnProperty(prop)) callback(obj[prop], prop, obj);
        } else throw new Error('obj does not seem to be an array or an iterable object');
    };
    /**
 * Standardidize extension name
 * @static
 * @param {string} s extension name
 * @returns {string}
 */ showdown.helper.stdExtName = function(s) {
        'use strict';
        return s.replace(/[_?*+\/\\.^-]/g, '').replace(/\s/g, '').toLowerCase();
    };
    function escapeCharactersCallback(wholeMatch, m1) {
        'use strict';
        var charCodeToEscape = m1.charCodeAt(0);
        return "\xa8E" + charCodeToEscape + 'E';
    }
    /**
 * Callback used to escape characters when passing through String.replace
 * @static
 * @param {string} wholeMatch
 * @param {string} m1
 * @returns {string}
 */ showdown.helper.escapeCharactersCallback = escapeCharactersCallback;
    /**
 * Escape characters in a string
 * @static
 * @param {string} text
 * @param {string} charsToEscape
 * @param {boolean} afterBackslash
 * @returns {XML|string|void|*}
 */ showdown.helper.escapeCharacters = function(text, charsToEscape, afterBackslash) {
        'use strict';
        // First we have to escape the escape characters so that
        // we can build a character class out of them
        var regexString = '([' + charsToEscape.replace(/([\[\]\\])/g, '\\$1') + '])';
        if (afterBackslash) regexString = '\\\\' + regexString;
        var regex = new RegExp(regexString, 'g');
        text = text.replace(regex, escapeCharactersCallback);
        return text;
    };
    /**
 * Unescape HTML entities
 * @param txt
 * @returns {string}
 */ showdown.helper.unescapeHTMLEntities = function(txt) {
        'use strict';
        return txt.replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
    };
    var rgxFindMatchPos = function(str, left, right, flags) {
        'use strict';
        var f = flags || '', g = f.indexOf('g') > -1, x = new RegExp(left + '|' + right, 'g' + f.replace(/g/g, '')), l = new RegExp(left, f.replace(/g/g, '')), pos = [], t, s, m, start, end;
        do {
            t = 0;
            while(m = x.exec(str)){
                if (l.test(m[0])) {
                    if (!t++) {
                        s = x.lastIndex;
                        start = s - m[0].length;
                    }
                } else if (t) {
                    if (!--t) {
                        end = m.index + m[0].length;
                        var obj = {
                            left: {
                                start: start,
                                end: s
                            },
                            match: {
                                start: s,
                                end: m.index
                            },
                            right: {
                                start: m.index,
                                end: end
                            },
                            wholeMatch: {
                                start: start,
                                end: end
                            }
                        };
                        pos.push(obj);
                        if (!g) return pos;
                    }
                }
            }
        }while (t && (x.lastIndex = s));
        return pos;
    };
    /**
 * matchRecursiveRegExp
 *
 * (c) 2007 Steven Levithan <stevenlevithan.com>
 * MIT License
 *
 * Accepts a string to search, a left and right format delimiter
 * as regex patterns, and optional regex flags. Returns an array
 * of matches, allowing nested instances of left/right delimiters.
 * Use the "g" flag to return all matches, otherwise only the
 * first is returned. Be careful to ensure that the left and
 * right format delimiters produce mutually exclusive matches.
 * Backreferences are not supported within the right delimiter
 * due to how it is internally combined with the left delimiter.
 * When matching strings whose format delimiters are unbalanced
 * to the left or right, the output is intentionally as a
 * conventional regex library with recursion support would
 * produce, e.g. "<<x>" and "<x>>" both produce ["x"] when using
 * "<" and ">" as the delimiters (both strings contain a single,
 * balanced instance of "<x>").
 *
 * examples:
 * matchRecursiveRegExp("test", "\\(", "\\)")
 * returns: []
 * matchRecursiveRegExp("<t<<e>><s>>t<>", "<", ">", "g")
 * returns: ["t<<e>><s>", ""]
 * matchRecursiveRegExp("<div id=\"x\">test</div>", "<div\\b[^>]*>", "</div>", "gi")
 * returns: ["test"]
 */ showdown.helper.matchRecursiveRegExp = function(str, left, right, flags) {
        'use strict';
        var matchPos = rgxFindMatchPos(str, left, right, flags), results = [];
        for(var i = 0; i < matchPos.length; ++i)results.push([
            str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end),
            str.slice(matchPos[i].match.start, matchPos[i].match.end),
            str.slice(matchPos[i].left.start, matchPos[i].left.end),
            str.slice(matchPos[i].right.start, matchPos[i].right.end)
        ]);
        return results;
    };
    /**
 *
 * @param {string} str
 * @param {string|function} replacement
 * @param {string} left
 * @param {string} right
 * @param {string} flags
 * @returns {string}
 */ showdown.helper.replaceRecursiveRegExp = function(str, replacement, left, right, flags) {
        'use strict';
        if (!showdown.helper.isFunction(replacement)) {
            var repStr = replacement;
            replacement = function() {
                return repStr;
            };
        }
        var matchPos = rgxFindMatchPos(str, left, right, flags), finalStr = str, lng = matchPos.length;
        if (lng > 0) {
            var bits = [];
            if (matchPos[0].wholeMatch.start !== 0) bits.push(str.slice(0, matchPos[0].wholeMatch.start));
            for(var i = 0; i < lng; ++i){
                bits.push(replacement(str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end), str.slice(matchPos[i].match.start, matchPos[i].match.end), str.slice(matchPos[i].left.start, matchPos[i].left.end), str.slice(matchPos[i].right.start, matchPos[i].right.end)));
                if (i < lng - 1) bits.push(str.slice(matchPos[i].wholeMatch.end, matchPos[i + 1].wholeMatch.start));
            }
            if (matchPos[lng - 1].wholeMatch.end < str.length) bits.push(str.slice(matchPos[lng - 1].wholeMatch.end));
            finalStr = bits.join('');
        }
        return finalStr;
    };
    /**
 * Returns the index within the passed String object of the first occurrence of the specified regex,
 * starting the search at fromIndex. Returns -1 if the value is not found.
 *
 * @param {string} str string to search
 * @param {RegExp} regex Regular expression to search
 * @param {int} [fromIndex = 0] Index to start the search
 * @returns {Number}
 * @throws InvalidArgumentError
 */ showdown.helper.regexIndexOf = function(str, regex, fromIndex) {
        'use strict';
        if (!showdown.helper.isString(str)) throw 'InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string';
        if (regex instanceof RegExp === false) throw 'InvalidArgumentError: second parameter of showdown.helper.regexIndexOf function must be an instance of RegExp';
        var indexOf = str.substring(fromIndex || 0).search(regex);
        return indexOf >= 0 ? indexOf + (fromIndex || 0) : indexOf;
    };
    /**
 * Splits the passed string object at the defined index, and returns an array composed of the two substrings
 * @param {string} str string to split
 * @param {int} index index to split string at
 * @returns {[string,string]}
 * @throws InvalidArgumentError
 */ showdown.helper.splitAtIndex = function(str, index) {
        'use strict';
        if (!showdown.helper.isString(str)) throw 'InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string';
        return [
            str.substring(0, index),
            str.substring(index)
        ];
    };
    /**
 * Obfuscate an e-mail address through the use of Character Entities,
 * transforming ASCII characters into their equivalent decimal or hex entities.
 *
 * Since it has a random component, subsequent calls to this function produce different results
 *
 * @param {string} mail
 * @returns {string}
 */ showdown.helper.encodeEmailAddress = function(mail) {
        'use strict';
        var encode = [
            function(ch) {
                return '&#' + ch.charCodeAt(0) + ';';
            },
            function(ch) {
                return '&#x' + ch.charCodeAt(0).toString(16) + ';';
            },
            function(ch) {
                return ch;
            }
        ];
        mail = mail.replace(/./g, function(ch) {
            if (ch === '@') // this *must* be encoded. I insist.
            ch = encode[Math.floor(Math.random() * 2)](ch);
            else {
                var r = Math.random();
                // roughly 10% raw, 45% hex, 45% dec
                ch = r > 0.9 ? encode[2](ch) : r > 0.45 ? encode[1](ch) : encode[0](ch);
            }
            return ch;
        });
        return mail;
    };
    /**
 *
 * @param str
 * @param targetLength
 * @param padString
 * @returns {string}
 */ showdown.helper.padEnd = function padEnd(str, targetLength, padString) {
        'use strict';
        /*jshint bitwise: false*/ // eslint-disable-next-line space-infix-ops
        targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
        /*jshint bitwise: true*/ padString = String(padString || ' ');
        if (str.length > targetLength) return String(str);
        else {
            targetLength = targetLength - str.length;
            if (targetLength > padString.length) padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
            return String(str) + padString.slice(0, targetLength);
        }
    };
    /**
 * POLYFILLS
 */ // use this instead of builtin is undefined for IE8 compatibility
    if (typeof console === 'undefined') console = {
        warn: function(msg) {
            'use strict';
            alert(msg);
        },
        log: function(msg) {
            'use strict';
            alert(msg);
        },
        error: function(msg) {
            'use strict';
            throw msg;
        }
    };
    /**
 * Common regexes.
 * We declare some common regexes to improve performance
 */ showdown.helper.regexes = {
        asteriskDashAndColon: /([*_:~])/g
    };
    /**
 * EMOJIS LIST
 */ showdown.helper.emojis = {
        '+1': '\ud83d\udc4d',
        '-1': '\ud83d\udc4e',
        '100': '\ud83d\udcaf',
        '1234': '\ud83d\udd22',
        '1st_place_medal': '\ud83e\udd47',
        '2nd_place_medal': '\ud83e\udd48',
        '3rd_place_medal': '\ud83e\udd49',
        '8ball': '\ud83c\udfb1',
        'a': '\ud83c\udd70\ufe0f',
        'ab': '\ud83c\udd8e',
        'abc': '\ud83d\udd24',
        'abcd': '\ud83d\udd21',
        'accept': '\ud83c\ude51',
        'aerial_tramway': '\ud83d\udea1',
        'airplane': '\u2708\ufe0f',
        'alarm_clock': '\u23f0',
        'alembic': '\u2697\ufe0f',
        'alien': '\ud83d\udc7d',
        'ambulance': '\ud83d\ude91',
        'amphora': '\ud83c\udffa',
        'anchor': '\u2693\ufe0f',
        'angel': '\ud83d\udc7c',
        'anger': '\ud83d\udca2',
        'angry': '\ud83d\ude20',
        'anguished': '\ud83d\ude27',
        'ant': '\ud83d\udc1c',
        'apple': '\ud83c\udf4e',
        'aquarius': '\u2652\ufe0f',
        'aries': '\u2648\ufe0f',
        'arrow_backward': '\u25c0\ufe0f',
        'arrow_double_down': '\u23ec',
        'arrow_double_up': '\u23eb',
        'arrow_down': '\u2b07\ufe0f',
        'arrow_down_small': '\ud83d\udd3d',
        'arrow_forward': '\u25b6\ufe0f',
        'arrow_heading_down': '\u2935\ufe0f',
        'arrow_heading_up': '\u2934\ufe0f',
        'arrow_left': '\u2b05\ufe0f',
        'arrow_lower_left': '\u2199\ufe0f',
        'arrow_lower_right': '\u2198\ufe0f',
        'arrow_right': '\u27a1\ufe0f',
        'arrow_right_hook': '\u21aa\ufe0f',
        'arrow_up': '\u2b06\ufe0f',
        'arrow_up_down': '\u2195\ufe0f',
        'arrow_up_small': '\ud83d\udd3c',
        'arrow_upper_left': '\u2196\ufe0f',
        'arrow_upper_right': '\u2197\ufe0f',
        'arrows_clockwise': '\ud83d\udd03',
        'arrows_counterclockwise': '\ud83d\udd04',
        'art': '\ud83c\udfa8',
        'articulated_lorry': '\ud83d\ude9b',
        'artificial_satellite': '\ud83d\udef0',
        'astonished': '\ud83d\ude32',
        'athletic_shoe': '\ud83d\udc5f',
        'atm': '\ud83c\udfe7',
        'atom_symbol': '\u269b\ufe0f',
        'avocado': '\ud83e\udd51',
        'b': '\ud83c\udd71\ufe0f',
        'baby': '\ud83d\udc76',
        'baby_bottle': '\ud83c\udf7c',
        'baby_chick': '\ud83d\udc24',
        'baby_symbol': '\ud83d\udebc',
        'back': '\ud83d\udd19',
        'bacon': '\ud83e\udd53',
        'badminton': '\ud83c\udff8',
        'baggage_claim': '\ud83d\udec4',
        'baguette_bread': '\ud83e\udd56',
        'balance_scale': '\u2696\ufe0f',
        'balloon': '\ud83c\udf88',
        'ballot_box': '\ud83d\uddf3',
        'ballot_box_with_check': '\u2611\ufe0f',
        'bamboo': '\ud83c\udf8d',
        'banana': '\ud83c\udf4c',
        'bangbang': '\u203c\ufe0f',
        'bank': '\ud83c\udfe6',
        'bar_chart': '\ud83d\udcca',
        'barber': '\ud83d\udc88',
        'baseball': '\u26be\ufe0f',
        'basketball': '\ud83c\udfc0',
        'basketball_man': '\u26f9\ufe0f',
        'basketball_woman': '\u26f9\ufe0f&zwj;\u2640\ufe0f',
        'bat': '\ud83e\udd87',
        'bath': '\ud83d\udec0',
        'bathtub': '\ud83d\udec1',
        'battery': '\ud83d\udd0b',
        'beach_umbrella': '\ud83c\udfd6',
        'bear': '\ud83d\udc3b',
        'bed': '\ud83d\udecf',
        'bee': '\ud83d\udc1d',
        'beer': '\ud83c\udf7a',
        'beers': '\ud83c\udf7b',
        'beetle': '\ud83d\udc1e',
        'beginner': '\ud83d\udd30',
        'bell': '\ud83d\udd14',
        'bellhop_bell': '\ud83d\udece',
        'bento': '\ud83c\udf71',
        'biking_man': '\ud83d\udeb4',
        'bike': '\ud83d\udeb2',
        'biking_woman': '\ud83d\udeb4&zwj;\u2640\ufe0f',
        'bikini': '\ud83d\udc59',
        'biohazard': '\u2623\ufe0f',
        'bird': '\ud83d\udc26',
        'birthday': '\ud83c\udf82',
        'black_circle': '\u26ab\ufe0f',
        'black_flag': '\ud83c\udff4',
        'black_heart': '\ud83d\udda4',
        'black_joker': '\ud83c\udccf',
        'black_large_square': '\u2b1b\ufe0f',
        'black_medium_small_square': '\u25fe\ufe0f',
        'black_medium_square': '\u25fc\ufe0f',
        'black_nib': '\u2712\ufe0f',
        'black_small_square': '\u25aa\ufe0f',
        'black_square_button': '\ud83d\udd32',
        'blonde_man': '\ud83d\udc71',
        'blonde_woman': '\ud83d\udc71&zwj;\u2640\ufe0f',
        'blossom': '\ud83c\udf3c',
        'blowfish': '\ud83d\udc21',
        'blue_book': '\ud83d\udcd8',
        'blue_car': '\ud83d\ude99',
        'blue_heart': '\ud83d\udc99',
        'blush': '\ud83d\ude0a',
        'boar': '\ud83d\udc17',
        'boat': '\u26f5\ufe0f',
        'bomb': '\ud83d\udca3',
        'book': '\ud83d\udcd6',
        'bookmark': '\ud83d\udd16',
        'bookmark_tabs': '\ud83d\udcd1',
        'books': '\ud83d\udcda',
        'boom': '\ud83d\udca5',
        'boot': '\ud83d\udc62',
        'bouquet': '\ud83d\udc90',
        'bowing_man': '\ud83d\ude47',
        'bow_and_arrow': '\ud83c\udff9',
        'bowing_woman': '\ud83d\ude47&zwj;\u2640\ufe0f',
        'bowling': '\ud83c\udfb3',
        'boxing_glove': '\ud83e\udd4a',
        'boy': '\ud83d\udc66',
        'bread': '\ud83c\udf5e',
        'bride_with_veil': '\ud83d\udc70',
        'bridge_at_night': '\ud83c\udf09',
        'briefcase': '\ud83d\udcbc',
        'broken_heart': '\ud83d\udc94',
        'bug': '\ud83d\udc1b',
        'building_construction': '\ud83c\udfd7',
        'bulb': '\ud83d\udca1',
        'bullettrain_front': '\ud83d\ude85',
        'bullettrain_side': '\ud83d\ude84',
        'burrito': '\ud83c\udf2f',
        'bus': '\ud83d\ude8c',
        'business_suit_levitating': '\ud83d\udd74',
        'busstop': '\ud83d\ude8f',
        'bust_in_silhouette': '\ud83d\udc64',
        'busts_in_silhouette': '\ud83d\udc65',
        'butterfly': '\ud83e\udd8b',
        'cactus': '\ud83c\udf35',
        'cake': '\ud83c\udf70',
        'calendar': '\ud83d\udcc6',
        'call_me_hand': '\ud83e\udd19',
        'calling': '\ud83d\udcf2',
        'camel': '\ud83d\udc2b',
        'camera': '\ud83d\udcf7',
        'camera_flash': '\ud83d\udcf8',
        'camping': '\ud83c\udfd5',
        'cancer': '\u264b\ufe0f',
        'candle': '\ud83d\udd6f',
        'candy': '\ud83c\udf6c',
        'canoe': '\ud83d\udef6',
        'capital_abcd': '\ud83d\udd20',
        'capricorn': '\u2651\ufe0f',
        'car': '\ud83d\ude97',
        'card_file_box': '\ud83d\uddc3',
        'card_index': '\ud83d\udcc7',
        'card_index_dividers': '\ud83d\uddc2',
        'carousel_horse': '\ud83c\udfa0',
        'carrot': '\ud83e\udd55',
        'cat': '\ud83d\udc31',
        'cat2': '\ud83d\udc08',
        'cd': '\ud83d\udcbf',
        'chains': '\u26d3',
        'champagne': '\ud83c\udf7e',
        'chart': '\ud83d\udcb9',
        'chart_with_downwards_trend': '\ud83d\udcc9',
        'chart_with_upwards_trend': '\ud83d\udcc8',
        'checkered_flag': '\ud83c\udfc1',
        'cheese': '\ud83e\uddc0',
        'cherries': '\ud83c\udf52',
        'cherry_blossom': '\ud83c\udf38',
        'chestnut': '\ud83c\udf30',
        'chicken': '\ud83d\udc14',
        'children_crossing': '\ud83d\udeb8',
        'chipmunk': '\ud83d\udc3f',
        'chocolate_bar': '\ud83c\udf6b',
        'christmas_tree': '\ud83c\udf84',
        'church': '\u26ea\ufe0f',
        'cinema': '\ud83c\udfa6',
        'circus_tent': '\ud83c\udfaa',
        'city_sunrise': '\ud83c\udf07',
        'city_sunset': '\ud83c\udf06',
        'cityscape': '\ud83c\udfd9',
        'cl': '\ud83c\udd91',
        'clamp': '\ud83d\udddc',
        'clap': '\ud83d\udc4f',
        'clapper': '\ud83c\udfac',
        'classical_building': '\ud83c\udfdb',
        'clinking_glasses': '\ud83e\udd42',
        'clipboard': '\ud83d\udccb',
        'clock1': '\ud83d\udd50',
        'clock10': '\ud83d\udd59',
        'clock1030': '\ud83d\udd65',
        'clock11': '\ud83d\udd5a',
        'clock1130': '\ud83d\udd66',
        'clock12': '\ud83d\udd5b',
        'clock1230': '\ud83d\udd67',
        'clock130': '\ud83d\udd5c',
        'clock2': '\ud83d\udd51',
        'clock230': '\ud83d\udd5d',
        'clock3': '\ud83d\udd52',
        'clock330': '\ud83d\udd5e',
        'clock4': '\ud83d\udd53',
        'clock430': '\ud83d\udd5f',
        'clock5': '\ud83d\udd54',
        'clock530': '\ud83d\udd60',
        'clock6': '\ud83d\udd55',
        'clock630': '\ud83d\udd61',
        'clock7': '\ud83d\udd56',
        'clock730': '\ud83d\udd62',
        'clock8': '\ud83d\udd57',
        'clock830': '\ud83d\udd63',
        'clock9': '\ud83d\udd58',
        'clock930': '\ud83d\udd64',
        'closed_book': '\ud83d\udcd5',
        'closed_lock_with_key': '\ud83d\udd10',
        'closed_umbrella': '\ud83c\udf02',
        'cloud': '\u2601\ufe0f',
        'cloud_with_lightning': '\ud83c\udf29',
        'cloud_with_lightning_and_rain': '\u26c8',
        'cloud_with_rain': '\ud83c\udf27',
        'cloud_with_snow': '\ud83c\udf28',
        'clown_face': '\ud83e\udd21',
        'clubs': '\u2663\ufe0f',
        'cocktail': '\ud83c\udf78',
        'coffee': '\u2615\ufe0f',
        'coffin': '\u26b0\ufe0f',
        'cold_sweat': '\ud83d\ude30',
        'comet': '\u2604\ufe0f',
        'computer': '\ud83d\udcbb',
        'computer_mouse': '\ud83d\uddb1',
        'confetti_ball': '\ud83c\udf8a',
        'confounded': '\ud83d\ude16',
        'confused': '\ud83d\ude15',
        'congratulations': '\u3297\ufe0f',
        'construction': '\ud83d\udea7',
        'construction_worker_man': '\ud83d\udc77',
        'construction_worker_woman': '\ud83d\udc77&zwj;\u2640\ufe0f',
        'control_knobs': '\ud83c\udf9b',
        'convenience_store': '\ud83c\udfea',
        'cookie': '\ud83c\udf6a',
        'cool': '\ud83c\udd92',
        'policeman': '\ud83d\udc6e',
        'copyright': '\u00a9\ufe0f',
        'corn': '\ud83c\udf3d',
        'couch_and_lamp': '\ud83d\udecb',
        'couple': '\ud83d\udc6b',
        'couple_with_heart_woman_man': '\ud83d\udc91',
        'couple_with_heart_man_man': '\ud83d\udc68&zwj;\u2764\ufe0f&zwj;\ud83d\udc68',
        'couple_with_heart_woman_woman': '\ud83d\udc69&zwj;\u2764\ufe0f&zwj;\ud83d\udc69',
        'couplekiss_man_man': '\ud83d\udc68&zwj;\u2764\ufe0f&zwj;\ud83d\udc8b&zwj;\ud83d\udc68',
        'couplekiss_man_woman': '\ud83d\udc8f',
        'couplekiss_woman_woman': '\ud83d\udc69&zwj;\u2764\ufe0f&zwj;\ud83d\udc8b&zwj;\ud83d\udc69',
        'cow': '\ud83d\udc2e',
        'cow2': '\ud83d\udc04',
        'cowboy_hat_face': '\ud83e\udd20',
        'crab': '\ud83e\udd80',
        'crayon': '\ud83d\udd8d',
        'credit_card': '\ud83d\udcb3',
        'crescent_moon': '\ud83c\udf19',
        'cricket': '\ud83c\udfcf',
        'crocodile': '\ud83d\udc0a',
        'croissant': '\ud83e\udd50',
        'crossed_fingers': '\ud83e\udd1e',
        'crossed_flags': '\ud83c\udf8c',
        'crossed_swords': '\u2694\ufe0f',
        'crown': '\ud83d\udc51',
        'cry': '\ud83d\ude22',
        'crying_cat_face': '\ud83d\ude3f',
        'crystal_ball': '\ud83d\udd2e',
        'cucumber': '\ud83e\udd52',
        'cupid': '\ud83d\udc98',
        'curly_loop': '\u27b0',
        'currency_exchange': '\ud83d\udcb1',
        'curry': '\ud83c\udf5b',
        'custard': '\ud83c\udf6e',
        'customs': '\ud83d\udec3',
        'cyclone': '\ud83c\udf00',
        'dagger': '\ud83d\udde1',
        'dancer': '\ud83d\udc83',
        'dancing_women': '\ud83d\udc6f',
        'dancing_men': '\ud83d\udc6f&zwj;\u2642\ufe0f',
        'dango': '\ud83c\udf61',
        'dark_sunglasses': '\ud83d\udd76',
        'dart': '\ud83c\udfaf',
        'dash': '\ud83d\udca8',
        'date': '\ud83d\udcc5',
        'deciduous_tree': '\ud83c\udf33',
        'deer': '\ud83e\udd8c',
        'department_store': '\ud83c\udfec',
        'derelict_house': '\ud83c\udfda',
        'desert': '\ud83c\udfdc',
        'desert_island': '\ud83c\udfdd',
        'desktop_computer': '\ud83d\udda5',
        'male_detective': '\ud83d\udd75\ufe0f',
        'diamond_shape_with_a_dot_inside': '\ud83d\udca0',
        'diamonds': '\u2666\ufe0f',
        'disappointed': '\ud83d\ude1e',
        'disappointed_relieved': '\ud83d\ude25',
        'dizzy': '\ud83d\udcab',
        'dizzy_face': '\ud83d\ude35',
        'do_not_litter': '\ud83d\udeaf',
        'dog': '\ud83d\udc36',
        'dog2': '\ud83d\udc15',
        'dollar': '\ud83d\udcb5',
        'dolls': '\ud83c\udf8e',
        'dolphin': '\ud83d\udc2c',
        'door': '\ud83d\udeaa',
        'doughnut': '\ud83c\udf69',
        'dove': '\ud83d\udd4a',
        'dragon': '\ud83d\udc09',
        'dragon_face': '\ud83d\udc32',
        'dress': '\ud83d\udc57',
        'dromedary_camel': '\ud83d\udc2a',
        'drooling_face': '\ud83e\udd24',
        'droplet': '\ud83d\udca7',
        'drum': '\ud83e\udd41',
        'duck': '\ud83e\udd86',
        'dvd': '\ud83d\udcc0',
        'e-mail': '\ud83d\udce7',
        'eagle': '\ud83e\udd85',
        'ear': '\ud83d\udc42',
        'ear_of_rice': '\ud83c\udf3e',
        'earth_africa': '\ud83c\udf0d',
        'earth_americas': '\ud83c\udf0e',
        'earth_asia': '\ud83c\udf0f',
        'egg': '\ud83e\udd5a',
        'eggplant': '\ud83c\udf46',
        'eight_pointed_black_star': '\u2734\ufe0f',
        'eight_spoked_asterisk': '\u2733\ufe0f',
        'electric_plug': '\ud83d\udd0c',
        'elephant': '\ud83d\udc18',
        'email': '\u2709\ufe0f',
        'end': '\ud83d\udd1a',
        'envelope_with_arrow': '\ud83d\udce9',
        'euro': '\ud83d\udcb6',
        'european_castle': '\ud83c\udff0',
        'european_post_office': '\ud83c\udfe4',
        'evergreen_tree': '\ud83c\udf32',
        'exclamation': '\u2757\ufe0f',
        'expressionless': '\ud83d\ude11',
        'eye': '\ud83d\udc41',
        'eye_speech_bubble': '\ud83d\udc41&zwj;\ud83d\udde8',
        'eyeglasses': '\ud83d\udc53',
        'eyes': '\ud83d\udc40',
        'face_with_head_bandage': '\ud83e\udd15',
        'face_with_thermometer': '\ud83e\udd12',
        'fist_oncoming': '\ud83d\udc4a',
        'factory': '\ud83c\udfed',
        'fallen_leaf': '\ud83c\udf42',
        'family_man_woman_boy': '\ud83d\udc6a',
        'family_man_boy': '\ud83d\udc68&zwj;\ud83d\udc66',
        'family_man_boy_boy': '\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66',
        'family_man_girl': '\ud83d\udc68&zwj;\ud83d\udc67',
        'family_man_girl_boy': '\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66',
        'family_man_girl_girl': '\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67',
        'family_man_man_boy': '\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66',
        'family_man_man_boy_boy': '\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66',
        'family_man_man_girl': '\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67',
        'family_man_man_girl_boy': '\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66',
        'family_man_man_girl_girl': '\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67',
        'family_man_woman_boy_boy': '\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66',
        'family_man_woman_girl': '\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67',
        'family_man_woman_girl_boy': '\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66',
        'family_man_woman_girl_girl': '\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67',
        'family_woman_boy': '\ud83d\udc69&zwj;\ud83d\udc66',
        'family_woman_boy_boy': '\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66',
        'family_woman_girl': '\ud83d\udc69&zwj;\ud83d\udc67',
        'family_woman_girl_boy': '\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66',
        'family_woman_girl_girl': '\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67',
        'family_woman_woman_boy': '\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66',
        'family_woman_woman_boy_boy': '\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66',
        'family_woman_woman_girl': '\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67',
        'family_woman_woman_girl_boy': '\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66',
        'family_woman_woman_girl_girl': '\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67',
        'fast_forward': '\u23e9',
        'fax': '\ud83d\udce0',
        'fearful': '\ud83d\ude28',
        'feet': '\ud83d\udc3e',
        'female_detective': '\ud83d\udd75\ufe0f&zwj;\u2640\ufe0f',
        'ferris_wheel': '\ud83c\udfa1',
        'ferry': '\u26f4',
        'field_hockey': '\ud83c\udfd1',
        'file_cabinet': '\ud83d\uddc4',
        'file_folder': '\ud83d\udcc1',
        'film_projector': '\ud83d\udcfd',
        'film_strip': '\ud83c\udf9e',
        'fire': '\ud83d\udd25',
        'fire_engine': '\ud83d\ude92',
        'fireworks': '\ud83c\udf86',
        'first_quarter_moon': '\ud83c\udf13',
        'first_quarter_moon_with_face': '\ud83c\udf1b',
        'fish': '\ud83d\udc1f',
        'fish_cake': '\ud83c\udf65',
        'fishing_pole_and_fish': '\ud83c\udfa3',
        'fist_raised': '\u270a',
        'fist_left': '\ud83e\udd1b',
        'fist_right': '\ud83e\udd1c',
        'flags': '\ud83c\udf8f',
        'flashlight': '\ud83d\udd26',
        'fleur_de_lis': '\u269c\ufe0f',
        'flight_arrival': '\ud83d\udeec',
        'flight_departure': '\ud83d\udeeb',
        'floppy_disk': '\ud83d\udcbe',
        'flower_playing_cards': '\ud83c\udfb4',
        'flushed': '\ud83d\ude33',
        'fog': '\ud83c\udf2b',
        'foggy': '\ud83c\udf01',
        'football': '\ud83c\udfc8',
        'footprints': '\ud83d\udc63',
        'fork_and_knife': '\ud83c\udf74',
        'fountain': '\u26f2\ufe0f',
        'fountain_pen': '\ud83d\udd8b',
        'four_leaf_clover': '\ud83c\udf40',
        'fox_face': '\ud83e\udd8a',
        'framed_picture': '\ud83d\uddbc',
        'free': '\ud83c\udd93',
        'fried_egg': '\ud83c\udf73',
        'fried_shrimp': '\ud83c\udf64',
        'fries': '\ud83c\udf5f',
        'frog': '\ud83d\udc38',
        'frowning': '\ud83d\ude26',
        'frowning_face': '\u2639\ufe0f',
        'frowning_man': '\ud83d\ude4d&zwj;\u2642\ufe0f',
        'frowning_woman': '\ud83d\ude4d',
        'middle_finger': '\ud83d\udd95',
        'fuelpump': '\u26fd\ufe0f',
        'full_moon': '\ud83c\udf15',
        'full_moon_with_face': '\ud83c\udf1d',
        'funeral_urn': '\u26b1\ufe0f',
        'game_die': '\ud83c\udfb2',
        'gear': '\u2699\ufe0f',
        'gem': '\ud83d\udc8e',
        'gemini': '\u264a\ufe0f',
        'ghost': '\ud83d\udc7b',
        'gift': '\ud83c\udf81',
        'gift_heart': '\ud83d\udc9d',
        'girl': '\ud83d\udc67',
        'globe_with_meridians': '\ud83c\udf10',
        'goal_net': '\ud83e\udd45',
        'goat': '\ud83d\udc10',
        'golf': '\u26f3\ufe0f',
        'golfing_man': '\ud83c\udfcc\ufe0f',
        'golfing_woman': '\ud83c\udfcc\ufe0f&zwj;\u2640\ufe0f',
        'gorilla': '\ud83e\udd8d',
        'grapes': '\ud83c\udf47',
        'green_apple': '\ud83c\udf4f',
        'green_book': '\ud83d\udcd7',
        'green_heart': '\ud83d\udc9a',
        'green_salad': '\ud83e\udd57',
        'grey_exclamation': '\u2755',
        'grey_question': '\u2754',
        'grimacing': '\ud83d\ude2c',
        'grin': '\ud83d\ude01',
        'grinning': '\ud83d\ude00',
        'guardsman': '\ud83d\udc82',
        'guardswoman': '\ud83d\udc82&zwj;\u2640\ufe0f',
        'guitar': '\ud83c\udfb8',
        'gun': '\ud83d\udd2b',
        'haircut_woman': '\ud83d\udc87',
        'haircut_man': '\ud83d\udc87&zwj;\u2642\ufe0f',
        'hamburger': '\ud83c\udf54',
        'hammer': '\ud83d\udd28',
        'hammer_and_pick': '\u2692',
        'hammer_and_wrench': '\ud83d\udee0',
        'hamster': '\ud83d\udc39',
        'hand': '\u270b',
        'handbag': '\ud83d\udc5c',
        'handshake': '\ud83e\udd1d',
        'hankey': '\ud83d\udca9',
        'hatched_chick': '\ud83d\udc25',
        'hatching_chick': '\ud83d\udc23',
        'headphones': '\ud83c\udfa7',
        'hear_no_evil': '\ud83d\ude49',
        'heart': '\u2764\ufe0f',
        'heart_decoration': '\ud83d\udc9f',
        'heart_eyes': '\ud83d\ude0d',
        'heart_eyes_cat': '\ud83d\ude3b',
        'heartbeat': '\ud83d\udc93',
        'heartpulse': '\ud83d\udc97',
        'hearts': '\u2665\ufe0f',
        'heavy_check_mark': '\u2714\ufe0f',
        'heavy_division_sign': '\u2797',
        'heavy_dollar_sign': '\ud83d\udcb2',
        'heavy_heart_exclamation': '\u2763\ufe0f',
        'heavy_minus_sign': '\u2796',
        'heavy_multiplication_x': '\u2716\ufe0f',
        'heavy_plus_sign': '\u2795',
        'helicopter': '\ud83d\ude81',
        'herb': '\ud83c\udf3f',
        'hibiscus': '\ud83c\udf3a',
        'high_brightness': '\ud83d\udd06',
        'high_heel': '\ud83d\udc60',
        'hocho': '\ud83d\udd2a',
        'hole': '\ud83d\udd73',
        'honey_pot': '\ud83c\udf6f',
        'horse': '\ud83d\udc34',
        'horse_racing': '\ud83c\udfc7',
        'hospital': '\ud83c\udfe5',
        'hot_pepper': '\ud83c\udf36',
        'hotdog': '\ud83c\udf2d',
        'hotel': '\ud83c\udfe8',
        'hotsprings': '\u2668\ufe0f',
        'hourglass': '\u231b\ufe0f',
        'hourglass_flowing_sand': '\u23f3',
        'house': '\ud83c\udfe0',
        'house_with_garden': '\ud83c\udfe1',
        'houses': '\ud83c\udfd8',
        'hugs': '\ud83e\udd17',
        'hushed': '\ud83d\ude2f',
        'ice_cream': '\ud83c\udf68',
        'ice_hockey': '\ud83c\udfd2',
        'ice_skate': '\u26f8',
        'icecream': '\ud83c\udf66',
        'id': '\ud83c\udd94',
        'ideograph_advantage': '\ud83c\ude50',
        'imp': '\ud83d\udc7f',
        'inbox_tray': '\ud83d\udce5',
        'incoming_envelope': '\ud83d\udce8',
        'tipping_hand_woman': '\ud83d\udc81',
        'information_source': '\u2139\ufe0f',
        'innocent': '\ud83d\ude07',
        'interrobang': '\u2049\ufe0f',
        'iphone': '\ud83d\udcf1',
        'izakaya_lantern': '\ud83c\udfee',
        'jack_o_lantern': '\ud83c\udf83',
        'japan': '\ud83d\uddfe',
        'japanese_castle': '\ud83c\udfef',
        'japanese_goblin': '\ud83d\udc7a',
        'japanese_ogre': '\ud83d\udc79',
        'jeans': '\ud83d\udc56',
        'joy': '\ud83d\ude02',
        'joy_cat': '\ud83d\ude39',
        'joystick': '\ud83d\udd79',
        'kaaba': '\ud83d\udd4b',
        'key': '\ud83d\udd11',
        'keyboard': '\u2328\ufe0f',
        'keycap_ten': '\ud83d\udd1f',
        'kick_scooter': '\ud83d\udef4',
        'kimono': '\ud83d\udc58',
        'kiss': '\ud83d\udc8b',
        'kissing': '\ud83d\ude17',
        'kissing_cat': '\ud83d\ude3d',
        'kissing_closed_eyes': '\ud83d\ude1a',
        'kissing_heart': '\ud83d\ude18',
        'kissing_smiling_eyes': '\ud83d\ude19',
        'kiwi_fruit': '\ud83e\udd5d',
        'koala': '\ud83d\udc28',
        'koko': '\ud83c\ude01',
        'label': '\ud83c\udff7',
        'large_blue_circle': '\ud83d\udd35',
        'large_blue_diamond': '\ud83d\udd37',
        'large_orange_diamond': '\ud83d\udd36',
        'last_quarter_moon': '\ud83c\udf17',
        'last_quarter_moon_with_face': '\ud83c\udf1c',
        'latin_cross': '\u271d\ufe0f',
        'laughing': '\ud83d\ude06',
        'leaves': '\ud83c\udf43',
        'ledger': '\ud83d\udcd2',
        'left_luggage': '\ud83d\udec5',
        'left_right_arrow': '\u2194\ufe0f',
        'leftwards_arrow_with_hook': '\u21a9\ufe0f',
        'lemon': '\ud83c\udf4b',
        'leo': '\u264c\ufe0f',
        'leopard': '\ud83d\udc06',
        'level_slider': '\ud83c\udf9a',
        'libra': '\u264e\ufe0f',
        'light_rail': '\ud83d\ude88',
        'link': '\ud83d\udd17',
        'lion': '\ud83e\udd81',
        'lips': '\ud83d\udc44',
        'lipstick': '\ud83d\udc84',
        'lizard': '\ud83e\udd8e',
        'lock': '\ud83d\udd12',
        'lock_with_ink_pen': '\ud83d\udd0f',
        'lollipop': '\ud83c\udf6d',
        'loop': '\u27bf',
        'loud_sound': '\ud83d\udd0a',
        'loudspeaker': '\ud83d\udce2',
        'love_hotel': '\ud83c\udfe9',
        'love_letter': '\ud83d\udc8c',
        'low_brightness': '\ud83d\udd05',
        'lying_face': '\ud83e\udd25',
        'm': '\u24c2\ufe0f',
        'mag': '\ud83d\udd0d',
        'mag_right': '\ud83d\udd0e',
        'mahjong': '\ud83c\udc04\ufe0f',
        'mailbox': '\ud83d\udceb',
        'mailbox_closed': '\ud83d\udcea',
        'mailbox_with_mail': '\ud83d\udcec',
        'mailbox_with_no_mail': '\ud83d\udced',
        'man': '\ud83d\udc68',
        'man_artist': '\ud83d\udc68&zwj;\ud83c\udfa8',
        'man_astronaut': '\ud83d\udc68&zwj;\ud83d\ude80',
        'man_cartwheeling': '\ud83e\udd38&zwj;\u2642\ufe0f',
        'man_cook': '\ud83d\udc68&zwj;\ud83c\udf73',
        'man_dancing': '\ud83d\udd7a',
        'man_facepalming': '\ud83e\udd26&zwj;\u2642\ufe0f',
        'man_factory_worker': '\ud83d\udc68&zwj;\ud83c\udfed',
        'man_farmer': '\ud83d\udc68&zwj;\ud83c\udf3e',
        'man_firefighter': '\ud83d\udc68&zwj;\ud83d\ude92',
        'man_health_worker': '\ud83d\udc68&zwj;\u2695\ufe0f',
        'man_in_tuxedo': '\ud83e\udd35',
        'man_judge': '\ud83d\udc68&zwj;\u2696\ufe0f',
        'man_juggling': '\ud83e\udd39&zwj;\u2642\ufe0f',
        'man_mechanic': '\ud83d\udc68&zwj;\ud83d\udd27',
        'man_office_worker': '\ud83d\udc68&zwj;\ud83d\udcbc',
        'man_pilot': '\ud83d\udc68&zwj;\u2708\ufe0f',
        'man_playing_handball': '\ud83e\udd3e&zwj;\u2642\ufe0f',
        'man_playing_water_polo': '\ud83e\udd3d&zwj;\u2642\ufe0f',
        'man_scientist': '\ud83d\udc68&zwj;\ud83d\udd2c',
        'man_shrugging': '\ud83e\udd37&zwj;\u2642\ufe0f',
        'man_singer': '\ud83d\udc68&zwj;\ud83c\udfa4',
        'man_student': '\ud83d\udc68&zwj;\ud83c\udf93',
        'man_teacher': '\ud83d\udc68&zwj;\ud83c\udfeb',
        'man_technologist': '\ud83d\udc68&zwj;\ud83d\udcbb',
        'man_with_gua_pi_mao': '\ud83d\udc72',
        'man_with_turban': '\ud83d\udc73',
        'tangerine': '\ud83c\udf4a',
        'mans_shoe': '\ud83d\udc5e',
        'mantelpiece_clock': '\ud83d\udd70',
        'maple_leaf': '\ud83c\udf41',
        'martial_arts_uniform': '\ud83e\udd4b',
        'mask': '\ud83d\ude37',
        'massage_woman': '\ud83d\udc86',
        'massage_man': '\ud83d\udc86&zwj;\u2642\ufe0f',
        'meat_on_bone': '\ud83c\udf56',
        'medal_military': '\ud83c\udf96',
        'medal_sports': '\ud83c\udfc5',
        'mega': '\ud83d\udce3',
        'melon': '\ud83c\udf48',
        'memo': '\ud83d\udcdd',
        'men_wrestling': '\ud83e\udd3c&zwj;\u2642\ufe0f',
        'menorah': '\ud83d\udd4e',
        'mens': '\ud83d\udeb9',
        'metal': '\ud83e\udd18',
        'metro': '\ud83d\ude87',
        'microphone': '\ud83c\udfa4',
        'microscope': '\ud83d\udd2c',
        'milk_glass': '\ud83e\udd5b',
        'milky_way': '\ud83c\udf0c',
        'minibus': '\ud83d\ude90',
        'minidisc': '\ud83d\udcbd',
        'mobile_phone_off': '\ud83d\udcf4',
        'money_mouth_face': '\ud83e\udd11',
        'money_with_wings': '\ud83d\udcb8',
        'moneybag': '\ud83d\udcb0',
        'monkey': '\ud83d\udc12',
        'monkey_face': '\ud83d\udc35',
        'monorail': '\ud83d\ude9d',
        'moon': '\ud83c\udf14',
        'mortar_board': '\ud83c\udf93',
        'mosque': '\ud83d\udd4c',
        'motor_boat': '\ud83d\udee5',
        'motor_scooter': '\ud83d\udef5',
        'motorcycle': '\ud83c\udfcd',
        'motorway': '\ud83d\udee3',
        'mount_fuji': '\ud83d\uddfb',
        'mountain': '\u26f0',
        'mountain_biking_man': '\ud83d\udeb5',
        'mountain_biking_woman': '\ud83d\udeb5&zwj;\u2640\ufe0f',
        'mountain_cableway': '\ud83d\udea0',
        'mountain_railway': '\ud83d\ude9e',
        'mountain_snow': '\ud83c\udfd4',
        'mouse': '\ud83d\udc2d',
        'mouse2': '\ud83d\udc01',
        'movie_camera': '\ud83c\udfa5',
        'moyai': '\ud83d\uddff',
        'mrs_claus': '\ud83e\udd36',
        'muscle': '\ud83d\udcaa',
        'mushroom': '\ud83c\udf44',
        'musical_keyboard': '\ud83c\udfb9',
        'musical_note': '\ud83c\udfb5',
        'musical_score': '\ud83c\udfbc',
        'mute': '\ud83d\udd07',
        'nail_care': '\ud83d\udc85',
        'name_badge': '\ud83d\udcdb',
        'national_park': '\ud83c\udfde',
        'nauseated_face': '\ud83e\udd22',
        'necktie': '\ud83d\udc54',
        'negative_squared_cross_mark': '\u274e',
        'nerd_face': '\ud83e\udd13',
        'neutral_face': '\ud83d\ude10',
        'new': '\ud83c\udd95',
        'new_moon': '\ud83c\udf11',
        'new_moon_with_face': '\ud83c\udf1a',
        'newspaper': '\ud83d\udcf0',
        'newspaper_roll': '\ud83d\uddde',
        'next_track_button': '\u23ed',
        'ng': '\ud83c\udd96',
        'no_good_man': '\ud83d\ude45&zwj;\u2642\ufe0f',
        'no_good_woman': '\ud83d\ude45',
        'night_with_stars': '\ud83c\udf03',
        'no_bell': '\ud83d\udd15',
        'no_bicycles': '\ud83d\udeb3',
        'no_entry': '\u26d4\ufe0f',
        'no_entry_sign': '\ud83d\udeab',
        'no_mobile_phones': '\ud83d\udcf5',
        'no_mouth': '\ud83d\ude36',
        'no_pedestrians': '\ud83d\udeb7',
        'no_smoking': '\ud83d\udead',
        'non-potable_water': '\ud83d\udeb1',
        'nose': '\ud83d\udc43',
        'notebook': '\ud83d\udcd3',
        'notebook_with_decorative_cover': '\ud83d\udcd4',
        'notes': '\ud83c\udfb6',
        'nut_and_bolt': '\ud83d\udd29',
        'o': '\u2b55\ufe0f',
        'o2': '\ud83c\udd7e\ufe0f',
        'ocean': '\ud83c\udf0a',
        'octopus': '\ud83d\udc19',
        'oden': '\ud83c\udf62',
        'office': '\ud83c\udfe2',
        'oil_drum': '\ud83d\udee2',
        'ok': '\ud83c\udd97',
        'ok_hand': '\ud83d\udc4c',
        'ok_man': '\ud83d\ude46&zwj;\u2642\ufe0f',
        'ok_woman': '\ud83d\ude46',
        'old_key': '\ud83d\udddd',
        'older_man': '\ud83d\udc74',
        'older_woman': '\ud83d\udc75',
        'om': '\ud83d\udd49',
        'on': '\ud83d\udd1b',
        'oncoming_automobile': '\ud83d\ude98',
        'oncoming_bus': '\ud83d\ude8d',
        'oncoming_police_car': '\ud83d\ude94',
        'oncoming_taxi': '\ud83d\ude96',
        'open_file_folder': '\ud83d\udcc2',
        'open_hands': '\ud83d\udc50',
        'open_mouth': '\ud83d\ude2e',
        'open_umbrella': '\u2602\ufe0f',
        'ophiuchus': '\u26ce',
        'orange_book': '\ud83d\udcd9',
        'orthodox_cross': '\u2626\ufe0f',
        'outbox_tray': '\ud83d\udce4',
        'owl': '\ud83e\udd89',
        'ox': '\ud83d\udc02',
        'package': '\ud83d\udce6',
        'page_facing_up': '\ud83d\udcc4',
        'page_with_curl': '\ud83d\udcc3',
        'pager': '\ud83d\udcdf',
        'paintbrush': '\ud83d\udd8c',
        'palm_tree': '\ud83c\udf34',
        'pancakes': '\ud83e\udd5e',
        'panda_face': '\ud83d\udc3c',
        'paperclip': '\ud83d\udcce',
        'paperclips': '\ud83d\udd87',
        'parasol_on_ground': '\u26f1',
        'parking': '\ud83c\udd7f\ufe0f',
        'part_alternation_mark': '\u303d\ufe0f',
        'partly_sunny': '\u26c5\ufe0f',
        'passenger_ship': '\ud83d\udef3',
        'passport_control': '\ud83d\udec2',
        'pause_button': '\u23f8',
        'peace_symbol': '\u262e\ufe0f',
        'peach': '\ud83c\udf51',
        'peanuts': '\ud83e\udd5c',
        'pear': '\ud83c\udf50',
        'pen': '\ud83d\udd8a',
        'pencil2': '\u270f\ufe0f',
        'penguin': '\ud83d\udc27',
        'pensive': '\ud83d\ude14',
        'performing_arts': '\ud83c\udfad',
        'persevere': '\ud83d\ude23',
        'person_fencing': '\ud83e\udd3a',
        'pouting_woman': '\ud83d\ude4e',
        'phone': '\u260e\ufe0f',
        'pick': '\u26cf',
        'pig': '\ud83d\udc37',
        'pig2': '\ud83d\udc16',
        'pig_nose': '\ud83d\udc3d',
        'pill': '\ud83d\udc8a',
        'pineapple': '\ud83c\udf4d',
        'ping_pong': '\ud83c\udfd3',
        'pisces': '\u2653\ufe0f',
        'pizza': '\ud83c\udf55',
        'place_of_worship': '\ud83d\uded0',
        'plate_with_cutlery': '\ud83c\udf7d',
        'play_or_pause_button': '\u23ef',
        'point_down': '\ud83d\udc47',
        'point_left': '\ud83d\udc48',
        'point_right': '\ud83d\udc49',
        'point_up': '\u261d\ufe0f',
        'point_up_2': '\ud83d\udc46',
        'police_car': '\ud83d\ude93',
        'policewoman': '\ud83d\udc6e&zwj;\u2640\ufe0f',
        'poodle': '\ud83d\udc29',
        'popcorn': '\ud83c\udf7f',
        'post_office': '\ud83c\udfe3',
        'postal_horn': '\ud83d\udcef',
        'postbox': '\ud83d\udcee',
        'potable_water': '\ud83d\udeb0',
        'potato': '\ud83e\udd54',
        'pouch': '\ud83d\udc5d',
        'poultry_leg': '\ud83c\udf57',
        'pound': '\ud83d\udcb7',
        'rage': '\ud83d\ude21',
        'pouting_cat': '\ud83d\ude3e',
        'pouting_man': '\ud83d\ude4e&zwj;\u2642\ufe0f',
        'pray': '\ud83d\ude4f',
        'prayer_beads': '\ud83d\udcff',
        'pregnant_woman': '\ud83e\udd30',
        'previous_track_button': '\u23ee',
        'prince': '\ud83e\udd34',
        'princess': '\ud83d\udc78',
        'printer': '\ud83d\udda8',
        'purple_heart': '\ud83d\udc9c',
        'purse': '\ud83d\udc5b',
        'pushpin': '\ud83d\udccc',
        'put_litter_in_its_place': '\ud83d\udeae',
        'question': '\u2753',
        'rabbit': '\ud83d\udc30',
        'rabbit2': '\ud83d\udc07',
        'racehorse': '\ud83d\udc0e',
        'racing_car': '\ud83c\udfce',
        'radio': '\ud83d\udcfb',
        'radio_button': '\ud83d\udd18',
        'radioactive': '\u2622\ufe0f',
        'railway_car': '\ud83d\ude83',
        'railway_track': '\ud83d\udee4',
        'rainbow': '\ud83c\udf08',
        'rainbow_flag': '\ud83c\udff3\ufe0f&zwj;\ud83c\udf08',
        'raised_back_of_hand': '\ud83e\udd1a',
        'raised_hand_with_fingers_splayed': '\ud83d\udd90',
        'raised_hands': '\ud83d\ude4c',
        'raising_hand_woman': '\ud83d\ude4b',
        'raising_hand_man': '\ud83d\ude4b&zwj;\u2642\ufe0f',
        'ram': '\ud83d\udc0f',
        'ramen': '\ud83c\udf5c',
        'rat': '\ud83d\udc00',
        'record_button': '\u23fa',
        'recycle': '\u267b\ufe0f',
        'red_circle': '\ud83d\udd34',
        'registered': '\u00ae\ufe0f',
        'relaxed': '\u263a\ufe0f',
        'relieved': '\ud83d\ude0c',
        'reminder_ribbon': '\ud83c\udf97',
        'repeat': '\ud83d\udd01',
        'repeat_one': '\ud83d\udd02',
        'rescue_worker_helmet': '\u26d1',
        'restroom': '\ud83d\udebb',
        'revolving_hearts': '\ud83d\udc9e',
        'rewind': '\u23ea',
        'rhinoceros': '\ud83e\udd8f',
        'ribbon': '\ud83c\udf80',
        'rice': '\ud83c\udf5a',
        'rice_ball': '\ud83c\udf59',
        'rice_cracker': '\ud83c\udf58',
        'rice_scene': '\ud83c\udf91',
        'right_anger_bubble': '\ud83d\uddef',
        'ring': '\ud83d\udc8d',
        'robot': '\ud83e\udd16',
        'rocket': '\ud83d\ude80',
        'rofl': '\ud83e\udd23',
        'roll_eyes': '\ud83d\ude44',
        'roller_coaster': '\ud83c\udfa2',
        'rooster': '\ud83d\udc13',
        'rose': '\ud83c\udf39',
        'rosette': '\ud83c\udff5',
        'rotating_light': '\ud83d\udea8',
        'round_pushpin': '\ud83d\udccd',
        'rowing_man': '\ud83d\udea3',
        'rowing_woman': '\ud83d\udea3&zwj;\u2640\ufe0f',
        'rugby_football': '\ud83c\udfc9',
        'running_man': '\ud83c\udfc3',
        'running_shirt_with_sash': '\ud83c\udfbd',
        'running_woman': '\ud83c\udfc3&zwj;\u2640\ufe0f',
        'sa': '\ud83c\ude02\ufe0f',
        'sagittarius': '\u2650\ufe0f',
        'sake': '\ud83c\udf76',
        'sandal': '\ud83d\udc61',
        'santa': '\ud83c\udf85',
        'satellite': '\ud83d\udce1',
        'saxophone': '\ud83c\udfb7',
        'school': '\ud83c\udfeb',
        'school_satchel': '\ud83c\udf92',
        'scissors': '\u2702\ufe0f',
        'scorpion': '\ud83e\udd82',
        'scorpius': '\u264f\ufe0f',
        'scream': '\ud83d\ude31',
        'scream_cat': '\ud83d\ude40',
        'scroll': '\ud83d\udcdc',
        'seat': '\ud83d\udcba',
        'secret': '\u3299\ufe0f',
        'see_no_evil': '\ud83d\ude48',
        'seedling': '\ud83c\udf31',
        'selfie': '\ud83e\udd33',
        'shallow_pan_of_food': '\ud83e\udd58',
        'shamrock': '\u2618\ufe0f',
        'shark': '\ud83e\udd88',
        'shaved_ice': '\ud83c\udf67',
        'sheep': '\ud83d\udc11',
        'shell': '\ud83d\udc1a',
        'shield': '\ud83d\udee1',
        'shinto_shrine': '\u26e9',
        'ship': '\ud83d\udea2',
        'shirt': '\ud83d\udc55',
        'shopping': '\ud83d\udecd',
        'shopping_cart': '\ud83d\uded2',
        'shower': '\ud83d\udebf',
        'shrimp': '\ud83e\udd90',
        'signal_strength': '\ud83d\udcf6',
        'six_pointed_star': '\ud83d\udd2f',
        'ski': '\ud83c\udfbf',
        'skier': '\u26f7',
        'skull': '\ud83d\udc80',
        'skull_and_crossbones': '\u2620\ufe0f',
        'sleeping': '\ud83d\ude34',
        'sleeping_bed': '\ud83d\udecc',
        'sleepy': '\ud83d\ude2a',
        'slightly_frowning_face': '\ud83d\ude41',
        'slightly_smiling_face': '\ud83d\ude42',
        'slot_machine': '\ud83c\udfb0',
        'small_airplane': '\ud83d\udee9',
        'small_blue_diamond': '\ud83d\udd39',
        'small_orange_diamond': '\ud83d\udd38',
        'small_red_triangle': '\ud83d\udd3a',
        'small_red_triangle_down': '\ud83d\udd3b',
        'smile': '\ud83d\ude04',
        'smile_cat': '\ud83d\ude38',
        'smiley': '\ud83d\ude03',
        'smiley_cat': '\ud83d\ude3a',
        'smiling_imp': '\ud83d\ude08',
        'smirk': '\ud83d\ude0f',
        'smirk_cat': '\ud83d\ude3c',
        'smoking': '\ud83d\udeac',
        'snail': '\ud83d\udc0c',
        'snake': '\ud83d\udc0d',
        'sneezing_face': '\ud83e\udd27',
        'snowboarder': '\ud83c\udfc2',
        'snowflake': '\u2744\ufe0f',
        'snowman': '\u26c4\ufe0f',
        'snowman_with_snow': '\u2603\ufe0f',
        'sob': '\ud83d\ude2d',
        'soccer': '\u26bd\ufe0f',
        'soon': '\ud83d\udd1c',
        'sos': '\ud83c\udd98',
        'sound': '\ud83d\udd09',
        'space_invader': '\ud83d\udc7e',
        'spades': '\u2660\ufe0f',
        'spaghetti': '\ud83c\udf5d',
        'sparkle': '\u2747\ufe0f',
        'sparkler': '\ud83c\udf87',
        'sparkles': '\u2728',
        'sparkling_heart': '\ud83d\udc96',
        'speak_no_evil': '\ud83d\ude4a',
        'speaker': '\ud83d\udd08',
        'speaking_head': '\ud83d\udde3',
        'speech_balloon': '\ud83d\udcac',
        'speedboat': '\ud83d\udea4',
        'spider': '\ud83d\udd77',
        'spider_web': '\ud83d\udd78',
        'spiral_calendar': '\ud83d\uddd3',
        'spiral_notepad': '\ud83d\uddd2',
        'spoon': '\ud83e\udd44',
        'squid': '\ud83e\udd91',
        'stadium': '\ud83c\udfdf',
        'star': '\u2b50\ufe0f',
        'star2': '\ud83c\udf1f',
        'star_and_crescent': '\u262a\ufe0f',
        'star_of_david': '\u2721\ufe0f',
        'stars': '\ud83c\udf20',
        'station': '\ud83d\ude89',
        'statue_of_liberty': '\ud83d\uddfd',
        'steam_locomotive': '\ud83d\ude82',
        'stew': '\ud83c\udf72',
        'stop_button': '\u23f9',
        'stop_sign': '\ud83d\uded1',
        'stopwatch': '\u23f1',
        'straight_ruler': '\ud83d\udccf',
        'strawberry': '\ud83c\udf53',
        'stuck_out_tongue': '\ud83d\ude1b',
        'stuck_out_tongue_closed_eyes': '\ud83d\ude1d',
        'stuck_out_tongue_winking_eye': '\ud83d\ude1c',
        'studio_microphone': '\ud83c\udf99',
        'stuffed_flatbread': '\ud83e\udd59',
        'sun_behind_large_cloud': '\ud83c\udf25',
        'sun_behind_rain_cloud': '\ud83c\udf26',
        'sun_behind_small_cloud': '\ud83c\udf24',
        'sun_with_face': '\ud83c\udf1e',
        'sunflower': '\ud83c\udf3b',
        'sunglasses': '\ud83d\ude0e',
        'sunny': '\u2600\ufe0f',
        'sunrise': '\ud83c\udf05',
        'sunrise_over_mountains': '\ud83c\udf04',
        'surfing_man': '\ud83c\udfc4',
        'surfing_woman': '\ud83c\udfc4&zwj;\u2640\ufe0f',
        'sushi': '\ud83c\udf63',
        'suspension_railway': '\ud83d\ude9f',
        'sweat': '\ud83d\ude13',
        'sweat_drops': '\ud83d\udca6',
        'sweat_smile': '\ud83d\ude05',
        'sweet_potato': '\ud83c\udf60',
        'swimming_man': '\ud83c\udfca',
        'swimming_woman': '\ud83c\udfca&zwj;\u2640\ufe0f',
        'symbols': '\ud83d\udd23',
        'synagogue': '\ud83d\udd4d',
        'syringe': '\ud83d\udc89',
        'taco': '\ud83c\udf2e',
        'tada': '\ud83c\udf89',
        'tanabata_tree': '\ud83c\udf8b',
        'taurus': '\u2649\ufe0f',
        'taxi': '\ud83d\ude95',
        'tea': '\ud83c\udf75',
        'telephone_receiver': '\ud83d\udcde',
        'telescope': '\ud83d\udd2d',
        'tennis': '\ud83c\udfbe',
        'tent': '\u26fa\ufe0f',
        'thermometer': '\ud83c\udf21',
        'thinking': '\ud83e\udd14',
        'thought_balloon': '\ud83d\udcad',
        'ticket': '\ud83c\udfab',
        'tickets': '\ud83c\udf9f',
        'tiger': '\ud83d\udc2f',
        'tiger2': '\ud83d\udc05',
        'timer_clock': '\u23f2',
        'tipping_hand_man': '\ud83d\udc81&zwj;\u2642\ufe0f',
        'tired_face': '\ud83d\ude2b',
        'tm': '\u2122\ufe0f',
        'toilet': '\ud83d\udebd',
        'tokyo_tower': '\ud83d\uddfc',
        'tomato': '\ud83c\udf45',
        'tongue': '\ud83d\udc45',
        'top': '\ud83d\udd1d',
        'tophat': '\ud83c\udfa9',
        'tornado': '\ud83c\udf2a',
        'trackball': '\ud83d\uddb2',
        'tractor': '\ud83d\ude9c',
        'traffic_light': '\ud83d\udea5',
        'train': '\ud83d\ude8b',
        'train2': '\ud83d\ude86',
        'tram': '\ud83d\ude8a',
        'triangular_flag_on_post': '\ud83d\udea9',
        'triangular_ruler': '\ud83d\udcd0',
        'trident': '\ud83d\udd31',
        'triumph': '\ud83d\ude24',
        'trolleybus': '\ud83d\ude8e',
        'trophy': '\ud83c\udfc6',
        'tropical_drink': '\ud83c\udf79',
        'tropical_fish': '\ud83d\udc20',
        'truck': '\ud83d\ude9a',
        'trumpet': '\ud83c\udfba',
        'tulip': '\ud83c\udf37',
        'tumbler_glass': '\ud83e\udd43',
        'turkey': '\ud83e\udd83',
        'turtle': '\ud83d\udc22',
        'tv': '\ud83d\udcfa',
        'twisted_rightwards_arrows': '\ud83d\udd00',
        'two_hearts': '\ud83d\udc95',
        'two_men_holding_hands': '\ud83d\udc6c',
        'two_women_holding_hands': '\ud83d\udc6d',
        'u5272': '\ud83c\ude39',
        'u5408': '\ud83c\ude34',
        'u55b6': '\ud83c\ude3a',
        'u6307': '\ud83c\ude2f\ufe0f',
        'u6708': '\ud83c\ude37\ufe0f',
        'u6709': '\ud83c\ude36',
        'u6e80': '\ud83c\ude35',
        'u7121': '\ud83c\ude1a\ufe0f',
        'u7533': '\ud83c\ude38',
        'u7981': '\ud83c\ude32',
        'u7a7a': '\ud83c\ude33',
        'umbrella': '\u2614\ufe0f',
        'unamused': '\ud83d\ude12',
        'underage': '\ud83d\udd1e',
        'unicorn': '\ud83e\udd84',
        'unlock': '\ud83d\udd13',
        'up': '\ud83c\udd99',
        'upside_down_face': '\ud83d\ude43',
        'v': '\u270c\ufe0f',
        'vertical_traffic_light': '\ud83d\udea6',
        'vhs': '\ud83d\udcfc',
        'vibration_mode': '\ud83d\udcf3',
        'video_camera': '\ud83d\udcf9',
        'video_game': '\ud83c\udfae',
        'violin': '\ud83c\udfbb',
        'virgo': '\u264d\ufe0f',
        'volcano': '\ud83c\udf0b',
        'volleyball': '\ud83c\udfd0',
        'vs': '\ud83c\udd9a',
        'vulcan_salute': '\ud83d\udd96',
        'walking_man': '\ud83d\udeb6',
        'walking_woman': '\ud83d\udeb6&zwj;\u2640\ufe0f',
        'waning_crescent_moon': '\ud83c\udf18',
        'waning_gibbous_moon': '\ud83c\udf16',
        'warning': '\u26a0\ufe0f',
        'wastebasket': '\ud83d\uddd1',
        'watch': '\u231a\ufe0f',
        'water_buffalo': '\ud83d\udc03',
        'watermelon': '\ud83c\udf49',
        'wave': '\ud83d\udc4b',
        'wavy_dash': '\u3030\ufe0f',
        'waxing_crescent_moon': '\ud83c\udf12',
        'wc': '\ud83d\udebe',
        'weary': '\ud83d\ude29',
        'wedding': '\ud83d\udc92',
        'weight_lifting_man': '\ud83c\udfcb\ufe0f',
        'weight_lifting_woman': '\ud83c\udfcb\ufe0f&zwj;\u2640\ufe0f',
        'whale': '\ud83d\udc33',
        'whale2': '\ud83d\udc0b',
        'wheel_of_dharma': '\u2638\ufe0f',
        'wheelchair': '\u267f\ufe0f',
        'white_check_mark': '\u2705',
        'white_circle': '\u26aa\ufe0f',
        'white_flag': '\ud83c\udff3\ufe0f',
        'white_flower': '\ud83d\udcae',
        'white_large_square': '\u2b1c\ufe0f',
        'white_medium_small_square': '\u25fd\ufe0f',
        'white_medium_square': '\u25fb\ufe0f',
        'white_small_square': '\u25ab\ufe0f',
        'white_square_button': '\ud83d\udd33',
        'wilted_flower': '\ud83e\udd40',
        'wind_chime': '\ud83c\udf90',
        'wind_face': '\ud83c\udf2c',
        'wine_glass': '\ud83c\udf77',
        'wink': '\ud83d\ude09',
        'wolf': '\ud83d\udc3a',
        'woman': '\ud83d\udc69',
        'woman_artist': '\ud83d\udc69&zwj;\ud83c\udfa8',
        'woman_astronaut': '\ud83d\udc69&zwj;\ud83d\ude80',
        'woman_cartwheeling': '\ud83e\udd38&zwj;\u2640\ufe0f',
        'woman_cook': '\ud83d\udc69&zwj;\ud83c\udf73',
        'woman_facepalming': '\ud83e\udd26&zwj;\u2640\ufe0f',
        'woman_factory_worker': '\ud83d\udc69&zwj;\ud83c\udfed',
        'woman_farmer': '\ud83d\udc69&zwj;\ud83c\udf3e',
        'woman_firefighter': '\ud83d\udc69&zwj;\ud83d\ude92',
        'woman_health_worker': '\ud83d\udc69&zwj;\u2695\ufe0f',
        'woman_judge': '\ud83d\udc69&zwj;\u2696\ufe0f',
        'woman_juggling': '\ud83e\udd39&zwj;\u2640\ufe0f',
        'woman_mechanic': '\ud83d\udc69&zwj;\ud83d\udd27',
        'woman_office_worker': '\ud83d\udc69&zwj;\ud83d\udcbc',
        'woman_pilot': '\ud83d\udc69&zwj;\u2708\ufe0f',
        'woman_playing_handball': '\ud83e\udd3e&zwj;\u2640\ufe0f',
        'woman_playing_water_polo': '\ud83e\udd3d&zwj;\u2640\ufe0f',
        'woman_scientist': '\ud83d\udc69&zwj;\ud83d\udd2c',
        'woman_shrugging': '\ud83e\udd37&zwj;\u2640\ufe0f',
        'woman_singer': '\ud83d\udc69&zwj;\ud83c\udfa4',
        'woman_student': '\ud83d\udc69&zwj;\ud83c\udf93',
        'woman_teacher': '\ud83d\udc69&zwj;\ud83c\udfeb',
        'woman_technologist': '\ud83d\udc69&zwj;\ud83d\udcbb',
        'woman_with_turban': '\ud83d\udc73&zwj;\u2640\ufe0f',
        'womans_clothes': '\ud83d\udc5a',
        'womans_hat': '\ud83d\udc52',
        'women_wrestling': '\ud83e\udd3c&zwj;\u2640\ufe0f',
        'womens': '\ud83d\udeba',
        'world_map': '\ud83d\uddfa',
        'worried': '\ud83d\ude1f',
        'wrench': '\ud83d\udd27',
        'writing_hand': '\u270d\ufe0f',
        'x': '\u274c',
        'yellow_heart': '\ud83d\udc9b',
        'yen': '\ud83d\udcb4',
        'yin_yang': '\u262f\ufe0f',
        'yum': '\ud83d\ude0b',
        'zap': '\u26a1\ufe0f',
        'zipper_mouth_face': '\ud83e\udd10',
        'zzz': '\ud83d\udca4',
        /* special emojis :P */ 'octocat': '<img alt=":octocat:" height="20" width="20" align="absmiddle" src="https://assets-cdn.github.com/images/icons/emoji/octocat.png">',
        'showdown': '<span style="font-family: \'Anonymous Pro\', monospace; text-decoration: underline; text-decoration-style: dashed; text-decoration-color: #3e8b8a;text-underline-position: under;">S</span>'
    };
    /**
 * Created by Estevao on 31-05-2015.
 */ /**
 * Showdown Converter class
 * @class
 * @param {object} [converterOptions]
 * @returns {Converter}
 */ showdown.Converter = function(converterOptions) {
        'use strict';
        var /**
       * Options used by this converter
       * @private
       * @type {{}}
       */ options = {}, /**
       * Language extensions used by this converter
       * @private
       * @type {Array}
       */ langExtensions = [], /**
       * Output modifiers extensions used by this converter
       * @private
       * @type {Array}
       */ outputModifiers = [], /**
       * Event listeners
       * @private
       * @type {{}}
       */ listeners = {}, /**
       * The flavor set in this converter
       */ setConvFlavor = setFlavor, /**
       * Metadata of the document
       * @type {{parsed: {}, raw: string, format: string}}
       */ metadata = {
            parsed: {},
            raw: '',
            format: ''
        };
        _constructor();
        /**
   * Converter constructor
   * @private
   */ function _constructor() {
            converterOptions = converterOptions || {};
            for(var gOpt in globalOptions)if (globalOptions.hasOwnProperty(gOpt)) options[gOpt] = globalOptions[gOpt];
            // Merge options
            if (typeof converterOptions === 'object') {
                for(var opt in converterOptions)if (converterOptions.hasOwnProperty(opt)) options[opt] = converterOptions[opt];
            } else throw Error('Converter expects the passed parameter to be an object, but ' + typeof converterOptions + ' was passed instead.');
            if (options.extensions) showdown.helper.forEach(options.extensions, _parseExtension);
        }
        /**
   * Parse extension
   * @param {*} ext
   * @param {string} [name='']
   * @private
   */ function _parseExtension(ext, name) {
            name = name || null;
            // If it's a string, the extension was previously loaded
            if (showdown.helper.isString(ext)) {
                ext = showdown.helper.stdExtName(ext);
                name = ext;
                // LEGACY_SUPPORT CODE
                if (showdown.extensions[ext]) {
                    console.warn('DEPRECATION WARNING: ' + ext + ' is an old extension that uses a deprecated loading method.' + 'Please inform the developer that the extension should be updated!');
                    legacyExtensionLoading(showdown.extensions[ext], ext);
                    return;
                // END LEGACY SUPPORT CODE
                } else if (!showdown.helper.isUndefined(extensions[ext])) ext = extensions[ext];
                else throw Error('Extension "' + ext + '" could not be loaded. It was either not found or is not a valid extension.');
            }
            if (typeof ext === 'function') ext = ext();
            if (!showdown.helper.isArray(ext)) ext = [
                ext
            ];
            var validExt = validate(ext, name);
            if (!validExt.valid) throw Error(validExt.error);
            for(var i = 0; i < ext.length; ++i){
                switch(ext[i].type){
                    case 'lang':
                        langExtensions.push(ext[i]);
                        break;
                    case 'output':
                        outputModifiers.push(ext[i]);
                        break;
                }
                if (ext[i].hasOwnProperty('listeners')) {
                    for(var ln in ext[i].listeners)if (ext[i].listeners.hasOwnProperty(ln)) listen(ln, ext[i].listeners[ln]);
                }
            }
        }
        /**
   * LEGACY_SUPPORT
   * @param {*} ext
   * @param {string} name
   */ function legacyExtensionLoading(ext, name) {
            if (typeof ext === 'function') ext = ext(new showdown.Converter());
            if (!showdown.helper.isArray(ext)) ext = [
                ext
            ];
            var valid = validate(ext, name);
            if (!valid.valid) throw Error(valid.error);
            for(var i = 0; i < ext.length; ++i)switch(ext[i].type){
                case 'lang':
                    langExtensions.push(ext[i]);
                    break;
                case 'output':
                    outputModifiers.push(ext[i]);
                    break;
                default:
                    throw Error('Extension loader error: Type unrecognized!!!');
            }
        }
        /**
   * Listen to an event
   * @param {string} name
   * @param {function} callback
   */ function listen(name, callback) {
            if (!showdown.helper.isString(name)) throw Error('Invalid argument in converter.listen() method: name must be a string, but ' + typeof name + ' given');
            if (typeof callback !== 'function') throw Error('Invalid argument in converter.listen() method: callback must be a function, but ' + typeof callback + ' given');
            if (!listeners.hasOwnProperty(name)) listeners[name] = [];
            listeners[name].push(callback);
        }
        function rTrimInputText(text) {
            var rsp = text.match(/^\s*/)[0].length, rgx = new RegExp('^\\s{0,' + rsp + '}', 'gm');
            return text.replace(rgx, '');
        }
        /**
   * Dispatch an event
   * @private
   * @param {string} evtName Event name
   * @param {string} text Text
   * @param {{}} options Converter Options
   * @param {{}} globals
   * @returns {string}
   */ this._dispatch = function dispatch(evtName, text, options, globals) {
            if (listeners.hasOwnProperty(evtName)) for(var ei = 0; ei < listeners[evtName].length; ++ei){
                var nText = listeners[evtName][ei](evtName, text, this, options, globals);
                if (nText && typeof nText !== 'undefined') text = nText;
            }
            return text;
        };
        /**
   * Listen to an event
   * @param {string} name
   * @param {function} callback
   * @returns {showdown.Converter}
   */ this.listen = function(name, callback) {
            listen(name, callback);
            return this;
        };
        /**
   * Converts a markdown string into HTML
   * @param {string} text
   * @returns {*}
   */ this.makeHtml = function(text) {
            //check if text is not falsy
            if (!text) return text;
            var globals = {
                gHtmlBlocks: [],
                gHtmlMdBlocks: [],
                gHtmlSpans: [],
                gUrls: {},
                gTitles: {},
                gDimensions: {},
                gListLevel: 0,
                hashLinkCounts: {},
                langExtensions: langExtensions,
                outputModifiers: outputModifiers,
                converter: this,
                ghCodeBlocks: [],
                metadata: {
                    parsed: {},
                    raw: '',
                    format: ''
                }
            };
            // This lets us use ¨ trema as an escape char to avoid md5 hashes
            // The choice of character is arbitrary; anything that isn't
            // magic in Markdown will work.
            text = text.replace(/¨/g, "\xa8T");
            // Replace $ with ¨D
            // RegExp interprets $ as a special character
            // when it's in a replacement string
            text = text.replace(/\$/g, "\xa8D");
            // Standardize line endings
            text = text.replace(/\r\n/g, '\n'); // DOS to Unix
            text = text.replace(/\r/g, '\n'); // Mac to Unix
            // Stardardize line spaces
            text = text.replace(/\u00A0/g, '&nbsp;');
            if (options.smartIndentationFix) text = rTrimInputText(text);
            // Make sure text begins and ends with a couple of newlines:
            text = '\n\n' + text + '\n\n';
            // detab
            text = showdown.subParser('detab')(text, options, globals);
            /**
     * Strip any lines consisting only of spaces and tabs.
     * This makes subsequent regexs easier to write, because we can
     * match consecutive blank lines with /\n+/ instead of something
     * contorted like /[ \t]*\n+/
     */ text = text.replace(/^[ \t]+$/mg, '');
            //run languageExtensions
            showdown.helper.forEach(langExtensions, function(ext) {
                text = showdown.subParser('runExtension')(ext, text, options, globals);
            });
            // run the sub parsers
            text = showdown.subParser('metadata')(text, options, globals);
            text = showdown.subParser('hashPreCodeTags')(text, options, globals);
            text = showdown.subParser('githubCodeBlocks')(text, options, globals);
            text = showdown.subParser('hashHTMLBlocks')(text, options, globals);
            text = showdown.subParser('hashCodeTags')(text, options, globals);
            text = showdown.subParser('stripLinkDefinitions')(text, options, globals);
            text = showdown.subParser('blockGamut')(text, options, globals);
            text = showdown.subParser('unhashHTMLSpans')(text, options, globals);
            text = showdown.subParser('unescapeSpecialChars')(text, options, globals);
            // attacklab: Restore dollar signs
            text = text.replace(/¨D/g, '$$');
            // attacklab: Restore tremas
            text = text.replace(/¨T/g, "\xa8");
            // render a complete html document instead of a partial if the option is enabled
            text = showdown.subParser('completeHTMLDocument')(text, options, globals);
            // Run output modifiers
            showdown.helper.forEach(outputModifiers, function(ext) {
                text = showdown.subParser('runExtension')(ext, text, options, globals);
            });
            // update metadata
            metadata = globals.metadata;
            return text;
        };
        /**
   * Converts an HTML string into a markdown string
   * @param src
   * @param [HTMLParser] A WHATWG DOM and HTML parser, such as JSDOM. If none is supplied, window.document will be used.
   * @returns {string}
   */ this.makeMarkdown = this.makeMd = function(src, HTMLParser) {
            // replace \r\n with \n
            src = src.replace(/\r\n/g, '\n');
            src = src.replace(/\r/g, '\n'); // old macs
            // due to an edge case, we need to find this: > <
            // to prevent removing of non silent white spaces
            // ex: <em>this is</em> <strong>sparta</strong>
            src = src.replace(/>[ \t]+</, ">\xa8NBSP;<");
            if (!HTMLParser) {
                if (window && window.document) HTMLParser = window.document;
                else throw new Error('HTMLParser is undefined. If in a webworker or nodejs environment, you need to provide a WHATWG DOM and HTML such as JSDOM');
            }
            var doc = HTMLParser.createElement('div');
            doc.innerHTML = src;
            var globals = {
                preList: substitutePreCodeTags(doc)
            };
            // remove all newlines and collapse spaces
            clean(doc);
            // some stuff, like accidental reference links must now be escaped
            // TODO
            // doc.innerHTML = doc.innerHTML.replace(/\[[\S\t ]]/);
            var nodes = doc.childNodes, mdDoc = '';
            for(var i = 0; i < nodes.length; i++)mdDoc += showdown.subParser('makeMarkdown.node')(nodes[i], globals);
            function clean(node) {
                for(var n = 0; n < node.childNodes.length; ++n){
                    var child = node.childNodes[n];
                    if (child.nodeType === 3) {
                        if (!/\S/.test(child.nodeValue) && !/^[ ]+$/.test(child.nodeValue)) {
                            node.removeChild(child);
                            --n;
                        } else {
                            child.nodeValue = child.nodeValue.split('\n').join(' ');
                            child.nodeValue = child.nodeValue.replace(/(\s)+/g, '$1');
                        }
                    } else if (child.nodeType === 1) clean(child);
                }
            }
            // find all pre tags and replace contents with placeholder
            // we need this so that we can remove all indentation from html
            // to ease up parsing
            function substitutePreCodeTags(doc) {
                var pres = doc.querySelectorAll('pre'), presPH = [];
                for(var i = 0; i < pres.length; ++i)if (pres[i].childElementCount === 1 && pres[i].firstChild.tagName.toLowerCase() === 'code') {
                    var content = pres[i].firstChild.innerHTML.trim(), language = pres[i].firstChild.getAttribute('data-language') || '';
                    // if data-language attribute is not defined, then we look for class language-*
                    if (language === '') {
                        var classes = pres[i].firstChild.className.split(' ');
                        for(var c = 0; c < classes.length; ++c){
                            var matches = classes[c].match(/^language-(.+)$/);
                            if (matches !== null) {
                                language = matches[1];
                                break;
                            }
                        }
                    }
                    // unescape html entities in content
                    content = showdown.helper.unescapeHTMLEntities(content);
                    presPH.push(content);
                    pres[i].outerHTML = '<precode language="' + language + '" precodenum="' + i.toString() + '"></precode>';
                } else {
                    presPH.push(pres[i].innerHTML);
                    pres[i].innerHTML = '';
                    pres[i].setAttribute('prenum', i.toString());
                }
                return presPH;
            }
            return mdDoc;
        };
        /**
   * Set an option of this Converter instance
   * @param {string} key
   * @param {*} value
   */ this.setOption = function(key, value) {
            options[key] = value;
        };
        /**
   * Get the option of this Converter instance
   * @param {string} key
   * @returns {*}
   */ this.getOption = function(key) {
            return options[key];
        };
        /**
   * Get the options of this Converter instance
   * @returns {{}}
   */ this.getOptions = function() {
            return options;
        };
        /**
   * Add extension to THIS converter
   * @param {{}} extension
   * @param {string} [name=null]
   */ this.addExtension = function(extension, name) {
            name = name || null;
            _parseExtension(extension, name);
        };
        /**
   * Use a global registered extension with THIS converter
   * @param {string} extensionName Name of the previously registered extension
   */ this.useExtension = function(extensionName) {
            _parseExtension(extensionName);
        };
        /**
   * Set the flavor THIS converter should use
   * @param {string} name
   */ this.setFlavor = function(name) {
            if (!flavor.hasOwnProperty(name)) throw Error(name + ' flavor was not found');
            var preset = flavor[name];
            setConvFlavor = name;
            for(var option in preset)if (preset.hasOwnProperty(option)) options[option] = preset[option];
        };
        /**
   * Get the currently set flavor of this converter
   * @returns {string}
   */ this.getFlavor = function() {
            return setConvFlavor;
        };
        /**
   * Remove an extension from THIS converter.
   * Note: This is a costly operation. It's better to initialize a new converter
   * and specify the extensions you wish to use
   * @param {Array} extension
   */ this.removeExtension = function(extension) {
            if (!showdown.helper.isArray(extension)) extension = [
                extension
            ];
            for(var a = 0; a < extension.length; ++a){
                var ext = extension[a];
                for(var i = 0; i < langExtensions.length; ++i)if (langExtensions[i] === ext) langExtensions.splice(i, 1);
                for(var ii = 0; ii < outputModifiers.length; ++ii)if (outputModifiers[ii] === ext) outputModifiers.splice(ii, 1);
            }
        };
        /**
   * Get all extension of THIS converter
   * @returns {{language: Array, output: Array}}
   */ this.getAllExtensions = function() {
            return {
                language: langExtensions,
                output: outputModifiers
            };
        };
        /**
   * Get the metadata of the previously parsed document
   * @param raw
   * @returns {string|{}}
   */ this.getMetadata = function(raw) {
            if (raw) return metadata.raw;
            else return metadata.parsed;
        };
        /**
   * Get the metadata format of the previously parsed document
   * @returns {string}
   */ this.getMetadataFormat = function() {
            return metadata.format;
        };
        /**
   * Private: set a single key, value metadata pair
   * @param {string} key
   * @param {string} value
   */ this._setMetadataPair = function(key, value) {
            metadata.parsed[key] = value;
        };
        /**
   * Private: set metadata format
   * @param {string} format
   */ this._setMetadataFormat = function(format) {
            metadata.format = format;
        };
        /**
   * Private: set metadata raw text
   * @param {string} raw
   */ this._setMetadataRaw = function(raw) {
            metadata.raw = raw;
        };
    };
    /**
 * Turn Markdown link shortcuts into XHTML <a> tags.
 */ showdown.subParser('anchors', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('anchors.before', text, options, globals);
        var writeAnchorTag = function(wholeMatch, linkText, linkId, url, m5, m6, title) {
            if (showdown.helper.isUndefined(title)) title = '';
            linkId = linkId.toLowerCase();
            // Special case for explicit empty url
            if (wholeMatch.search(/\(<?\s*>? ?(['"].*['"])?\)$/m) > -1) url = '';
            else if (!url) {
                if (!linkId) // lower-case and turn embedded newlines into spaces
                linkId = linkText.toLowerCase().replace(/ ?\n/g, ' ');
                url = '#' + linkId;
                if (!showdown.helper.isUndefined(globals.gUrls[linkId])) {
                    url = globals.gUrls[linkId];
                    if (!showdown.helper.isUndefined(globals.gTitles[linkId])) title = globals.gTitles[linkId];
                } else return wholeMatch;
            }
            //url = showdown.helper.escapeCharacters(url, '*_', false); // replaced line to improve performance
            url = url.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
            var result = '<a href="' + url + '"';
            if (title !== '' && title !== null) {
                title = title.replace(/"/g, '&quot;');
                //title = showdown.helper.escapeCharacters(title, '*_', false); // replaced line to improve performance
                title = title.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
                result += ' title="' + title + '"';
            }
            // optionLinksInNewWindow only applies
            // to external links. Hash links (#) open in same page
            if (options.openLinksInNewWindow && !/^#/.test(url)) // escaped _
            result += ' rel="noopener noreferrer" target="\xa8E95Eblank"';
            result += '>' + linkText + '</a>';
            return result;
        };
        // First, handle reference-style links: [link text] [id]
        text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)] ?(?:\n *)?\[(.*?)]()()()()/g, writeAnchorTag);
        // Next, inline-style links: [link text](url "optional title")
        // cases with crazy urls like ./image/cat1).png
        text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<([^>]*)>(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g, writeAnchorTag);
        // normal cases
        text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g, writeAnchorTag);
        // handle reference-style shortcuts: [link text]
        // These must come last in case you've also got [link test][1]
        // or [link test](/foo)
        text = text.replace(/\[([^\[\]]+)]()()()()()/g, writeAnchorTag);
        // Lastly handle GithubMentions if option is enabled
        if (options.ghMentions) text = text.replace(/(^|\s)(\\)?(@([a-z\d]+(?:[a-z\d.-]+?[a-z\d]+)*))/gmi, function(wm, st, escape, mentions, username) {
            if (escape === '\\') return st + mentions;
            //check if options.ghMentionsLink is a string
            if (!showdown.helper.isString(options.ghMentionsLink)) throw new Error('ghMentionsLink option must be a string');
            var lnk = options.ghMentionsLink.replace(/\{u}/g, username), target = '';
            if (options.openLinksInNewWindow) target = ' rel="noopener noreferrer" target="\xa8E95Eblank"';
            return st + '<a href="' + lnk + '"' + target + '>' + mentions + '</a>';
        });
        text = globals.converter._dispatch('anchors.after', text, options, globals);
        return text;
    });
    // url allowed chars [a-z\d_.~:/?#[]@!$&'()*+,;=-]
    var simpleURLRegex = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+?\.[^'">\s]+?)()(\1)?(?=\s|$)(?!["<>])/gi, simpleURLRegex2 = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+\.[^'">\s]+?)([.!?,()\[\]])?(\1)?(?=\s|$)(?!["<>])/gi, delimUrlRegex = /()<(((https?|ftp|dict):\/\/|www\.)[^'">\s]+)()>()/gi, simpleMailRegex = /(^|\s)(?:mailto:)?([A-Za-z0-9!#$%&'*+-/=?^_`{|}~.]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)(?=$|\s)/gmi, delimMailRegex = /<()(?:mailto:)?([-.\w]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)>/gi, replaceLink = function(options) {
        'use strict';
        return function(wm, leadingMagicChars, link, m2, m3, trailingPunctuation, trailingMagicChars) {
            link = link.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
            var lnkTxt = link, append = '', target = '', lmc = leadingMagicChars || '', tmc = trailingMagicChars || '';
            if (/^www\./i.test(link)) link = link.replace(/^www\./i, 'http://www.');
            if (options.excludeTrailingPunctuationFromURLs && trailingPunctuation) append = trailingPunctuation;
            if (options.openLinksInNewWindow) target = ' rel="noopener noreferrer" target="\xa8E95Eblank"';
            return lmc + '<a href="' + link + '"' + target + '>' + lnkTxt + '</a>' + append + tmc;
        };
    }, replaceMail = function(options, globals) {
        'use strict';
        return function(wholeMatch, b, mail) {
            var href = 'mailto:';
            b = b || '';
            mail = showdown.subParser('unescapeSpecialChars')(mail, options, globals);
            if (options.encodeEmails) {
                href = showdown.helper.encodeEmailAddress(href + mail);
                mail = showdown.helper.encodeEmailAddress(mail);
            } else href = href + mail;
            return b + '<a href="' + href + '">' + mail + '</a>';
        };
    };
    showdown.subParser('autoLinks', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('autoLinks.before', text, options, globals);
        text = text.replace(delimUrlRegex, replaceLink(options));
        text = text.replace(delimMailRegex, replaceMail(options, globals));
        text = globals.converter._dispatch('autoLinks.after', text, options, globals);
        return text;
    });
    showdown.subParser('simplifiedAutoLinks', function(text, options, globals) {
        'use strict';
        if (!options.simplifiedAutoLink) return text;
        text = globals.converter._dispatch('simplifiedAutoLinks.before', text, options, globals);
        if (options.excludeTrailingPunctuationFromURLs) text = text.replace(simpleURLRegex2, replaceLink(options));
        else text = text.replace(simpleURLRegex, replaceLink(options));
        text = text.replace(simpleMailRegex, replaceMail(options, globals));
        text = globals.converter._dispatch('simplifiedAutoLinks.after', text, options, globals);
        return text;
    });
    /**
 * These are all the transformations that form block-level
 * tags like paragraphs, headers, and list items.
 */ showdown.subParser('blockGamut', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('blockGamut.before', text, options, globals);
        // we parse blockquotes first so that we can have headings and hrs
        // inside blockquotes
        text = showdown.subParser('blockQuotes')(text, options, globals);
        text = showdown.subParser('headers')(text, options, globals);
        // Do Horizontal Rules:
        text = showdown.subParser('horizontalRule')(text, options, globals);
        text = showdown.subParser('lists')(text, options, globals);
        text = showdown.subParser('codeBlocks')(text, options, globals);
        text = showdown.subParser('tables')(text, options, globals);
        // We already ran _HashHTMLBlocks() before, in Markdown(), but that
        // was to escape raw HTML in the original Markdown source. This time,
        // we're escaping the markup we've just created, so that we don't wrap
        // <p> tags around block-level tags.
        text = showdown.subParser('hashHTMLBlocks')(text, options, globals);
        text = showdown.subParser('paragraphs')(text, options, globals);
        text = globals.converter._dispatch('blockGamut.after', text, options, globals);
        return text;
    });
    showdown.subParser('blockQuotes', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('blockQuotes.before', text, options, globals);
        // add a couple extra lines after the text and endtext mark
        text = text + '\n\n';
        var rgx = /(^ {0,3}>[ \t]?.+\n(.+\n)*\n*)+/gm;
        if (options.splitAdjacentBlockquotes) rgx = /^ {0,3}>[\s\S]*?(?:\n\n)/gm;
        text = text.replace(rgx, function(bq) {
            // attacklab: hack around Konqueror 3.5.4 bug:
            // "----------bug".replace(/^-/g,"") == "bug"
            bq = bq.replace(/^[ \t]*>[ \t]?/gm, ''); // trim one level of quoting
            // attacklab: clean up hack
            bq = bq.replace(/¨0/g, '');
            bq = bq.replace(/^[ \t]+$/gm, ''); // trim whitespace-only lines
            bq = showdown.subParser('githubCodeBlocks')(bq, options, globals);
            bq = showdown.subParser('blockGamut')(bq, options, globals); // recurse
            bq = bq.replace(/(^|\n)/g, '$1  ');
            // These leading spaces screw with <pre> content, so we need to fix that:
            bq = bq.replace(/(\s*<pre>[^\r]+?<\/pre>)/gm, function(wholeMatch, m1) {
                var pre = m1;
                // attacklab: hack around Konqueror 3.5.4 bug:
                pre = pre.replace(/^  /mg, "\xa80");
                pre = pre.replace(/¨0/g, '');
                return pre;
            });
            return showdown.subParser('hashBlock')('<blockquote>\n' + bq + '\n</blockquote>', options, globals);
        });
        text = globals.converter._dispatch('blockQuotes.after', text, options, globals);
        return text;
    });
    /**
 * Process Markdown `<pre><code>` blocks.
 */ showdown.subParser('codeBlocks', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('codeBlocks.before', text, options, globals);
        // sentinel workarounds for lack of \A and \Z, safari\khtml bug
        text += "\xa80";
        var pattern = /(?:\n\n|^)((?:(?:[ ]{4}|\t).*\n+)+)(\n*[ ]{0,3}[^ \t\n]|(?=¨0))/g;
        text = text.replace(pattern, function(wholeMatch, m1, m2) {
            var codeblock = m1, nextChar = m2, end = '\n';
            codeblock = showdown.subParser('outdent')(codeblock, options, globals);
            codeblock = showdown.subParser('encodeCode')(codeblock, options, globals);
            codeblock = showdown.subParser('detab')(codeblock, options, globals);
            codeblock = codeblock.replace(/^\n+/g, ''); // trim leading newlines
            codeblock = codeblock.replace(/\n+$/g, ''); // trim trailing newlines
            if (options.omitExtraWLInCodeBlocks) end = '';
            codeblock = '<pre><code>' + codeblock + end + '</code></pre>';
            return showdown.subParser('hashBlock')(codeblock, options, globals) + nextChar;
        });
        // strip sentinel
        text = text.replace(/¨0/, '');
        text = globals.converter._dispatch('codeBlocks.after', text, options, globals);
        return text;
    });
    /**
 *
 *   *  Backtick quotes are used for <code></code> spans.
 *
 *   *  You can use multiple backticks as the delimiters if you want to
 *     include literal backticks in the code span. So, this input:
 *
 *         Just type ``foo `bar` baz`` at the prompt.
 *
 *       Will translate to:
 *
 *         <p>Just type <code>foo `bar` baz</code> at the prompt.</p>
 *
 *    There's no arbitrary limit to the number of backticks you
 *    can use as delimters. If you need three consecutive backticks
 *    in your code, use four for delimiters, etc.
 *
 *  *  You can use spaces to get literal backticks at the edges:
 *
 *         ... type `` `bar` `` ...
 *
 *       Turns to:
 *
 *         ... type <code>`bar`</code> ...
 */ showdown.subParser('codeSpans', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('codeSpans.before', text, options, globals);
        if (typeof text === 'undefined') text = '';
        text = text.replace(/(^|[^\\])(`+)([^\r]*?[^`])\2(?!`)/gm, function(wholeMatch, m1, m2, m3) {
            var c = m3;
            c = c.replace(/^([ \t]*)/g, ''); // leading whitespace
            c = c.replace(/[ \t]*$/g, ''); // trailing whitespace
            c = showdown.subParser('encodeCode')(c, options, globals);
            c = m1 + '<code>' + c + '</code>';
            c = showdown.subParser('hashHTMLSpans')(c, options, globals);
            return c;
        });
        text = globals.converter._dispatch('codeSpans.after', text, options, globals);
        return text;
    });
    /**
 * Create a full HTML document from the processed markdown
 */ showdown.subParser('completeHTMLDocument', function(text, options, globals) {
        'use strict';
        if (!options.completeHTMLDocument) return text;
        text = globals.converter._dispatch('completeHTMLDocument.before', text, options, globals);
        var doctype = 'html', doctypeParsed = '<!DOCTYPE HTML>\n', title = '', charset = '<meta charset="utf-8">\n', lang = '', metadata = '';
        if (typeof globals.metadata.parsed.doctype !== 'undefined') {
            doctypeParsed = '<!DOCTYPE ' + globals.metadata.parsed.doctype + '>\n';
            doctype = globals.metadata.parsed.doctype.toString().toLowerCase();
            if (doctype === 'html' || doctype === 'html5') charset = '<meta charset="utf-8">';
        }
        for(var meta in globals.metadata.parsed)if (globals.metadata.parsed.hasOwnProperty(meta)) switch(meta.toLowerCase()){
            case 'doctype':
                break;
            case 'title':
                title = '<title>' + globals.metadata.parsed.title + '</title>\n';
                break;
            case 'charset':
                if (doctype === 'html' || doctype === 'html5') charset = '<meta charset="' + globals.metadata.parsed.charset + '">\n';
                else charset = '<meta name="charset" content="' + globals.metadata.parsed.charset + '">\n';
                break;
            case 'language':
            case 'lang':
                lang = ' lang="' + globals.metadata.parsed[meta] + '"';
                metadata += '<meta name="' + meta + '" content="' + globals.metadata.parsed[meta] + '">\n';
                break;
            default:
                metadata += '<meta name="' + meta + '" content="' + globals.metadata.parsed[meta] + '">\n';
        }
        text = doctypeParsed + '<html' + lang + '>\n<head>\n' + title + charset + metadata + '</head>\n<body>\n' + text.trim() + '\n</body>\n</html>';
        text = globals.converter._dispatch('completeHTMLDocument.after', text, options, globals);
        return text;
    });
    /**
 * Convert all tabs to spaces
 */ showdown.subParser('detab', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('detab.before', text, options, globals);
        // expand first n-1 tabs
        text = text.replace(/\t(?=\t)/g, '    '); // g_tab_width
        // replace the nth with two sentinels
        text = text.replace(/\t/g, "\xa8A\xa8B");
        // use the sentinel to anchor our regex so it doesn't explode
        text = text.replace(/¨B(.+?)¨A/g, function(wholeMatch, m1) {
            var leadingText = m1, numSpaces = 4 - leadingText.length % 4; // g_tab_width
            // there *must* be a better way to do this:
            for(var i = 0; i < numSpaces; i++)leadingText += ' ';
            return leadingText;
        });
        // clean up sentinels
        text = text.replace(/¨A/g, '    '); // g_tab_width
        text = text.replace(/¨B/g, '');
        text = globals.converter._dispatch('detab.after', text, options, globals);
        return text;
    });
    showdown.subParser('ellipsis', function(text, options, globals) {
        'use strict';
        if (!options.ellipsis) return text;
        text = globals.converter._dispatch('ellipsis.before', text, options, globals);
        text = text.replace(/\.\.\./g, "\u2026");
        text = globals.converter._dispatch('ellipsis.after', text, options, globals);
        return text;
    });
    /**
 * Turn emoji codes into emojis
 *
 * List of supported emojis: https://github.com/showdownjs/showdown/wiki/Emojis
 */ showdown.subParser('emoji', function(text, options, globals) {
        'use strict';
        if (!options.emoji) return text;
        text = globals.converter._dispatch('emoji.before', text, options, globals);
        var emojiRgx = /:([\S]+?):/g;
        text = text.replace(emojiRgx, function(wm, emojiCode) {
            if (showdown.helper.emojis.hasOwnProperty(emojiCode)) return showdown.helper.emojis[emojiCode];
            return wm;
        });
        text = globals.converter._dispatch('emoji.after', text, options, globals);
        return text;
    });
    /**
 * Smart processing for ampersands and angle brackets that need to be encoded.
 */ showdown.subParser('encodeAmpsAndAngles', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('encodeAmpsAndAngles.before', text, options, globals);
        // Ampersand-encoding based entirely on Nat Irons's Amputator MT plugin:
        // http://bumppo.net/projects/amputator/
        text = text.replace(/&(?!#?[xX]?(?:[0-9a-fA-F]+|\w+);)/g, '&amp;');
        // Encode naked <'s
        text = text.replace(/<(?![a-z\/?$!])/gi, '&lt;');
        // Encode <
        text = text.replace(/</g, '&lt;');
        // Encode >
        text = text.replace(/>/g, '&gt;');
        text = globals.converter._dispatch('encodeAmpsAndAngles.after', text, options, globals);
        return text;
    });
    /**
 * Returns the string, with after processing the following backslash escape sequences.
 *
 * attacklab: The polite way to do this is with the new escapeCharacters() function:
 *
 *    text = escapeCharacters(text,"\\",true);
 *    text = escapeCharacters(text,"`*_{}[]()>#+-.!",true);
 *
 * ...but we're sidestepping its use of the (slow) RegExp constructor
 * as an optimization for Firefox.  This function gets called a LOT.
 */ showdown.subParser('encodeBackslashEscapes', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('encodeBackslashEscapes.before', text, options, globals);
        text = text.replace(/\\(\\)/g, showdown.helper.escapeCharactersCallback);
        text = text.replace(/\\([`*_{}\[\]()>#+.!~=|:-])/g, showdown.helper.escapeCharactersCallback);
        text = globals.converter._dispatch('encodeBackslashEscapes.after', text, options, globals);
        return text;
    });
    /**
 * Encode/escape certain characters inside Markdown code runs.
 * The point is that in code, these characters are literals,
 * and lose their special Markdown meanings.
 */ showdown.subParser('encodeCode', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('encodeCode.before', text, options, globals);
        // Encode all ampersands; HTML entities are not
        // entities within a Markdown code span.
        text = text.replace(/&/g, '&amp;')// Do the angle bracket song and dance:
        .replace(/</g, '&lt;').replace(/>/g, '&gt;')// Now, escape characters that are magic in Markdown:
        .replace(/([*_{}\[\]\\=~-])/g, showdown.helper.escapeCharactersCallback);
        text = globals.converter._dispatch('encodeCode.after', text, options, globals);
        return text;
    });
    /**
 * Within tags -- meaning between < and > -- encode [\ ` * _ ~ =] so they
 * don't conflict with their use in Markdown for code, italics and strong.
 */ showdown.subParser('escapeSpecialCharsWithinTagAttributes', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('escapeSpecialCharsWithinTagAttributes.before', text, options, globals);
        // Build a regex to find HTML tags.
        var tags = /<\/?[a-z\d_:-]+(?:[\s]+[\s\S]+?)?>/gi, comments = /<!(--(?:(?:[^>-]|-[^>])(?:[^-]|-[^-])*)--)>/gi;
        text = text.replace(tags, function(wholeMatch) {
            return wholeMatch.replace(/(.)<\/?code>(?=.)/g, '$1`').replace(/([\\`*_~=|])/g, showdown.helper.escapeCharactersCallback);
        });
        text = text.replace(comments, function(wholeMatch) {
            return wholeMatch.replace(/([\\`*_~=|])/g, showdown.helper.escapeCharactersCallback);
        });
        text = globals.converter._dispatch('escapeSpecialCharsWithinTagAttributes.after', text, options, globals);
        return text;
    });
    /**
 * Handle github codeblocks prior to running HashHTML so that
 * HTML contained within the codeblock gets escaped properly
 * Example:
 * ```ruby
 *     def hello_world(x)
 *       puts "Hello, #{x}"
 *     end
 * ```
 */ showdown.subParser('githubCodeBlocks', function(text, options, globals) {
        'use strict';
        // early exit if option is not enabled
        if (!options.ghCodeBlocks) return text;
        text = globals.converter._dispatch('githubCodeBlocks.before', text, options, globals);
        text += "\xa80";
        text = text.replace(/(?:^|\n)(?: {0,3})(```+|~~~+)(?: *)([^\s`~]*)\n([\s\S]*?)\n(?: {0,3})\1/g, function(wholeMatch, delim, language, codeblock) {
            var end = options.omitExtraWLInCodeBlocks ? '' : '\n';
            // First parse the github code block
            codeblock = showdown.subParser('encodeCode')(codeblock, options, globals);
            codeblock = showdown.subParser('detab')(codeblock, options, globals);
            codeblock = codeblock.replace(/^\n+/g, ''); // trim leading newlines
            codeblock = codeblock.replace(/\n+$/g, ''); // trim trailing whitespace
            codeblock = '<pre><code' + (language ? ' class="' + language + ' language-' + language + '"' : '') + '>' + codeblock + end + '</code></pre>';
            codeblock = showdown.subParser('hashBlock')(codeblock, options, globals);
            // Since GHCodeblocks can be false positives, we need to
            // store the primitive text and the parsed text in a global var,
            // and then return a token
            return "\n\n\xa8G" + (globals.ghCodeBlocks.push({
                text: wholeMatch,
                codeblock: codeblock
            }) - 1) + 'G\n\n';
        });
        // attacklab: strip sentinel
        text = text.replace(/¨0/, '');
        return globals.converter._dispatch('githubCodeBlocks.after', text, options, globals);
    });
    showdown.subParser('hashBlock', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('hashBlock.before', text, options, globals);
        text = text.replace(/(^\n+|\n+$)/g, '');
        text = "\n\n\xa8K" + (globals.gHtmlBlocks.push(text) - 1) + 'K\n\n';
        text = globals.converter._dispatch('hashBlock.after', text, options, globals);
        return text;
    });
    /**
 * Hash and escape <code> elements that should not be parsed as markdown
 */ showdown.subParser('hashCodeTags', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('hashCodeTags.before', text, options, globals);
        var repFunc = function(wholeMatch, match, left, right) {
            var codeblock = left + showdown.subParser('encodeCode')(match, options, globals) + right;
            return "\xa8C" + (globals.gHtmlSpans.push(codeblock) - 1) + 'C';
        };
        // Hash naked <code>
        text = showdown.helper.replaceRecursiveRegExp(text, repFunc, '<code\\b[^>]*>', '</code>', 'gim');
        text = globals.converter._dispatch('hashCodeTags.after', text, options, globals);
        return text;
    });
    showdown.subParser('hashElement', function(text, options, globals) {
        'use strict';
        return function(wholeMatch, m1) {
            var blockText = m1;
            // Undo double lines
            blockText = blockText.replace(/\n\n/g, '\n');
            blockText = blockText.replace(/^\n/, '');
            // strip trailing blank lines
            blockText = blockText.replace(/\n+$/g, '');
            // Replace the element text with a marker ("¨KxK" where x is its key)
            blockText = "\n\n\xa8K" + (globals.gHtmlBlocks.push(blockText) - 1) + 'K\n\n';
            return blockText;
        };
    });
    showdown.subParser('hashHTMLBlocks', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('hashHTMLBlocks.before', text, options, globals);
        var blockTags = [
            'pre',
            'div',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'blockquote',
            'table',
            'dl',
            'ol',
            'ul',
            'script',
            'noscript',
            'form',
            'fieldset',
            'iframe',
            'math',
            'style',
            'section',
            'header',
            'footer',
            'nav',
            'article',
            'aside',
            'address',
            'audio',
            'canvas',
            'figure',
            'hgroup',
            'output',
            'video',
            'p'
        ], repFunc = function(wholeMatch, match, left, right) {
            var txt = wholeMatch;
            // check if this html element is marked as markdown
            // if so, it's contents should be parsed as markdown
            if (left.search(/\bmarkdown\b/) !== -1) txt = left + globals.converter.makeHtml(match) + right;
            return "\n\n\xa8K" + (globals.gHtmlBlocks.push(txt) - 1) + 'K\n\n';
        };
        if (options.backslashEscapesHTMLTags) // encode backslash escaped HTML tags
        text = text.replace(/\\<(\/?[^>]+?)>/g, function(wm, inside) {
            return '&lt;' + inside + '&gt;';
        });
        // hash HTML Blocks
        for(var i = 0; i < blockTags.length; ++i){
            var opTagPos, rgx1 = new RegExp('^ {0,3}(<' + blockTags[i] + '\\b[^>]*>)', 'im'), patLeft = '<' + blockTags[i] + '\\b[^>]*>', patRight = '</' + blockTags[i] + '>';
            // 1. Look for the first position of the first opening HTML tag in the text
            while((opTagPos = showdown.helper.regexIndexOf(text, rgx1)) !== -1){
                // if the HTML tag is \ escaped, we need to escape it and break
                //2. Split the text in that position
                var subTexts = showdown.helper.splitAtIndex(text, opTagPos), //3. Match recursively
                newSubText1 = showdown.helper.replaceRecursiveRegExp(subTexts[1], repFunc, patLeft, patRight, 'im');
                // prevent an infinite loop
                if (newSubText1 === subTexts[1]) break;
                text = subTexts[0].concat(newSubText1);
            }
        }
        // HR SPECIAL CASE
        text = text.replace(/(\n {0,3}(<(hr)\b([^<>])*?\/?>)[ \t]*(?=\n{2,}))/g, showdown.subParser('hashElement')(text, options, globals));
        // Special case for standalone HTML comments
        text = showdown.helper.replaceRecursiveRegExp(text, function(txt) {
            return "\n\n\xa8K" + (globals.gHtmlBlocks.push(txt) - 1) + 'K\n\n';
        }, '^ {0,3}<!--', '-->', 'gm');
        // PHP and ASP-style processor instructions (<?...?> and <%...%>)
        text = text.replace(/(?:\n\n)( {0,3}(?:<([?%])[^\r]*?\2>)[ \t]*(?=\n{2,}))/g, showdown.subParser('hashElement')(text, options, globals));
        text = globals.converter._dispatch('hashHTMLBlocks.after', text, options, globals);
        return text;
    });
    /**
 * Hash span elements that should not be parsed as markdown
 */ showdown.subParser('hashHTMLSpans', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('hashHTMLSpans.before', text, options, globals);
        function hashHTMLSpan(html) {
            return "\xa8C" + (globals.gHtmlSpans.push(html) - 1) + 'C';
        }
        // Hash Self Closing tags
        text = text.replace(/<[^>]+?\/>/gi, function(wm) {
            return hashHTMLSpan(wm);
        });
        // Hash tags without properties
        text = text.replace(/<([^>]+?)>[\s\S]*?<\/\1>/g, function(wm) {
            return hashHTMLSpan(wm);
        });
        // Hash tags with properties
        text = text.replace(/<([^>]+?)\s[^>]+?>[\s\S]*?<\/\1>/g, function(wm) {
            return hashHTMLSpan(wm);
        });
        // Hash self closing tags without />
        text = text.replace(/<[^>]+?>/gi, function(wm) {
            return hashHTMLSpan(wm);
        });
        /*showdown.helper.matchRecursiveRegExp(text, '<code\\b[^>]*>', '</code>', 'gi');*/ text = globals.converter._dispatch('hashHTMLSpans.after', text, options, globals);
        return text;
    });
    /**
 * Unhash HTML spans
 */ showdown.subParser('unhashHTMLSpans', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('unhashHTMLSpans.before', text, options, globals);
        for(var i = 0; i < globals.gHtmlSpans.length; ++i){
            var repText = globals.gHtmlSpans[i], // limiter to prevent infinite loop (assume 10 as limit for recurse)
            limit = 0;
            while(/¨C(\d+)C/.test(repText)){
                var num = RegExp.$1;
                repText = repText.replace("\xa8C" + num + 'C', globals.gHtmlSpans[num]);
                if (limit === 10) {
                    console.error('maximum nesting of 10 spans reached!!!');
                    break;
                }
                ++limit;
            }
            text = text.replace("\xa8C" + i + 'C', repText);
        }
        text = globals.converter._dispatch('unhashHTMLSpans.after', text, options, globals);
        return text;
    });
    /**
 * Hash and escape <pre><code> elements that should not be parsed as markdown
 */ showdown.subParser('hashPreCodeTags', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('hashPreCodeTags.before', text, options, globals);
        var repFunc = function(wholeMatch, match, left, right) {
            // encode html entities
            var codeblock = left + showdown.subParser('encodeCode')(match, options, globals) + right;
            return "\n\n\xa8G" + (globals.ghCodeBlocks.push({
                text: wholeMatch,
                codeblock: codeblock
            }) - 1) + 'G\n\n';
        };
        // Hash <pre><code>
        text = showdown.helper.replaceRecursiveRegExp(text, repFunc, '^ {0,3}<pre\\b[^>]*>\\s*<code\\b[^>]*>', '^ {0,3}</code>\\s*</pre>', 'gim');
        text = globals.converter._dispatch('hashPreCodeTags.after', text, options, globals);
        return text;
    });
    showdown.subParser('headers', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('headers.before', text, options, globals);
        var headerLevelStart = isNaN(parseInt(options.headerLevelStart)) ? 1 : parseInt(options.headerLevelStart), // Set text-style headers:
        //	Header 1
        //	========
        //
        //	Header 2
        //	--------
        //
        setextRegexH1 = options.smoothLivePreview ? /^(.+)[ \t]*\n={2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n=+[ \t]*\n+/gm, setextRegexH2 = options.smoothLivePreview ? /^(.+)[ \t]*\n-{2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n-+[ \t]*\n+/gm;
        text = text.replace(setextRegexH1, function(wholeMatch, m1) {
            var spanGamut = showdown.subParser('spanGamut')(m1, options, globals), hID = options.noHeaderId ? '' : ' id="' + headerId(m1) + '"', hLevel = headerLevelStart, hashBlock = '<h' + hLevel + hID + '>' + spanGamut + '</h' + hLevel + '>';
            return showdown.subParser('hashBlock')(hashBlock, options, globals);
        });
        text = text.replace(setextRegexH2, function(matchFound, m1) {
            var spanGamut = showdown.subParser('spanGamut')(m1, options, globals), hID = options.noHeaderId ? '' : ' id="' + headerId(m1) + '"', hLevel = headerLevelStart + 1, hashBlock = '<h' + hLevel + hID + '>' + spanGamut + '</h' + hLevel + '>';
            return showdown.subParser('hashBlock')(hashBlock, options, globals);
        });
        // atx-style headers:
        //  # Header 1
        //  ## Header 2
        //  ## Header 2 with closing hashes ##
        //  ...
        //  ###### Header 6
        //
        var atxStyle = options.requireSpaceBeforeHeadingText ? /^(#{1,6})[ \t]+(.+?)[ \t]*#*\n+/gm : /^(#{1,6})[ \t]*(.+?)[ \t]*#*\n+/gm;
        text = text.replace(atxStyle, function(wholeMatch, m1, m2) {
            var hText = m2;
            if (options.customizedHeaderId) hText = m2.replace(/\s?\{([^{]+?)}\s*$/, '');
            var span = showdown.subParser('spanGamut')(hText, options, globals), hID = options.noHeaderId ? '' : ' id="' + headerId(m2) + '"', hLevel = headerLevelStart - 1 + m1.length, header = '<h' + hLevel + hID + '>' + span + '</h' + hLevel + '>';
            return showdown.subParser('hashBlock')(header, options, globals);
        });
        function headerId(m) {
            var title, prefix;
            // It is separate from other options to allow combining prefix and customized
            if (options.customizedHeaderId) {
                var match = m.match(/\{([^{]+?)}\s*$/);
                if (match && match[1]) m = match[1];
            }
            title = m;
            // Prefix id to prevent causing inadvertent pre-existing style matches.
            if (showdown.helper.isString(options.prefixHeaderId)) prefix = options.prefixHeaderId;
            else if (options.prefixHeaderId === true) prefix = 'section-';
            else prefix = '';
            if (!options.rawPrefixHeaderId) title = prefix + title;
            if (options.ghCompatibleHeaderId) title = title.replace(/ /g, '-')// replace previously escaped chars (&, ¨ and $)
            .replace(/&amp;/g, '').replace(/¨T/g, '').replace(/¨D/g, '')// replace rest of the chars (&~$ are repeated as they might have been escaped)
            // borrowed from github's redcarpet (some they should produce similar results)
            .replace(/[&+$,\/:;=?@"#{}|^¨~\[\]`\\*)(%.!'<>]/g, '').toLowerCase();
            else if (options.rawHeaderId) title = title.replace(/ /g, '-')// replace previously escaped chars (&, ¨ and $)
            .replace(/&amp;/g, '&').replace(/¨T/g, "\xa8").replace(/¨D/g, '$')// replace " and '
            .replace(/["']/g, '-').toLowerCase();
            else title = title.replace(/[^\w]/g, '').toLowerCase();
            if (options.rawPrefixHeaderId) title = prefix + title;
            if (globals.hashLinkCounts[title]) title = title + '-' + globals.hashLinkCounts[title]++;
            else globals.hashLinkCounts[title] = 1;
            return title;
        }
        text = globals.converter._dispatch('headers.after', text, options, globals);
        return text;
    });
    /**
 * Turn Markdown link shortcuts into XHTML <a> tags.
 */ showdown.subParser('horizontalRule', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('horizontalRule.before', text, options, globals);
        var key = showdown.subParser('hashBlock')('<hr />', options, globals);
        text = text.replace(/^ {0,2}( ?-){3,}[ \t]*$/gm, key);
        text = text.replace(/^ {0,2}( ?\*){3,}[ \t]*$/gm, key);
        text = text.replace(/^ {0,2}( ?_){3,}[ \t]*$/gm, key);
        text = globals.converter._dispatch('horizontalRule.after', text, options, globals);
        return text;
    });
    /**
 * Turn Markdown image shortcuts into <img> tags.
 */ showdown.subParser('images', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('images.before', text, options, globals);
        var inlineRegExp = /!\[([^\]]*?)][ \t]*()\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g, crazyRegExp = /!\[([^\]]*?)][ \t]*()\([ \t]?<([^>]*)>(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(?:(["'])([^"]*?)\6))?[ \t]?\)/g, base64RegExp = /!\[([^\]]*?)][ \t]*()\([ \t]?<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g, referenceRegExp = /!\[([^\]]*?)] ?(?:\n *)?\[([\s\S]*?)]()()()()()/g, refShortcutRegExp = /!\[([^\[\]]+)]()()()()()/g;
        function writeImageTagBase64(wholeMatch, altText, linkId, url, width, height, m5, title) {
            url = url.replace(/\s/g, '');
            return writeImageTag(wholeMatch, altText, linkId, url, width, height, m5, title);
        }
        function writeImageTag(wholeMatch, altText, linkId, url, width, height, m5, title) {
            var gUrls = globals.gUrls, gTitles = globals.gTitles, gDims = globals.gDimensions;
            linkId = linkId.toLowerCase();
            if (!title) title = '';
            // Special case for explicit empty url
            if (wholeMatch.search(/\(<?\s*>? ?(['"].*['"])?\)$/m) > -1) url = '';
            else if (url === '' || url === null) {
                if (linkId === '' || linkId === null) // lower-case and turn embedded newlines into spaces
                linkId = altText.toLowerCase().replace(/ ?\n/g, ' ');
                url = '#' + linkId;
                if (!showdown.helper.isUndefined(gUrls[linkId])) {
                    url = gUrls[linkId];
                    if (!showdown.helper.isUndefined(gTitles[linkId])) title = gTitles[linkId];
                    if (!showdown.helper.isUndefined(gDims[linkId])) {
                        width = gDims[linkId].width;
                        height = gDims[linkId].height;
                    }
                } else return wholeMatch;
            }
            altText = altText.replace(/"/g, '&quot;')//altText = showdown.helper.escapeCharacters(altText, '*_', false);
            .replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
            //url = showdown.helper.escapeCharacters(url, '*_', false);
            url = url.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
            var result = '<img src="' + url + '" alt="' + altText + '"';
            if (title && showdown.helper.isString(title)) {
                title = title.replace(/"/g, '&quot;')//title = showdown.helper.escapeCharacters(title, '*_', false);
                .replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
                result += ' title="' + title + '"';
            }
            if (width && height) {
                width = width === '*' ? 'auto' : width;
                height = height === '*' ? 'auto' : height;
                result += ' width="' + width + '"';
                result += ' height="' + height + '"';
            }
            result += ' />';
            return result;
        }
        // First, handle reference-style labeled images: ![alt text][id]
        text = text.replace(referenceRegExp, writeImageTag);
        // Next, handle inline images:  ![alt text](url =<width>x<height> "optional title")
        // base64 encoded images
        text = text.replace(base64RegExp, writeImageTagBase64);
        // cases with crazy urls like ./image/cat1).png
        text = text.replace(crazyRegExp, writeImageTag);
        // normal cases
        text = text.replace(inlineRegExp, writeImageTag);
        // handle reference-style shortcuts: ![img text]
        text = text.replace(refShortcutRegExp, writeImageTag);
        text = globals.converter._dispatch('images.after', text, options, globals);
        return text;
    });
    showdown.subParser('italicsAndBold', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('italicsAndBold.before', text, options, globals);
        // it's faster to have 3 separate regexes for each case than have just one
        // because of backtracing, in some cases, it could lead to an exponential effect
        // called "catastrophic backtrace". Ominous!
        function parseInside(txt, left, right) {
            /*
    if (options.simplifiedAutoLink) {
      txt = showdown.subParser('simplifiedAutoLinks')(txt, options, globals);
    }
    */ return left + txt + right;
        }
        // Parse underscores
        if (options.literalMidWordUnderscores) {
            text = text.replace(/\b___(\S[\s\S]*?)___\b/g, function(wm, txt) {
                return parseInside(txt, '<strong><em>', '</em></strong>');
            });
            text = text.replace(/\b__(\S[\s\S]*?)__\b/g, function(wm, txt) {
                return parseInside(txt, '<strong>', '</strong>');
            });
            text = text.replace(/\b_(\S[\s\S]*?)_\b/g, function(wm, txt) {
                return parseInside(txt, '<em>', '</em>');
            });
        } else {
            text = text.replace(/___(\S[\s\S]*?)___/g, function(wm, m) {
                return /\S$/.test(m) ? parseInside(m, '<strong><em>', '</em></strong>') : wm;
            });
            text = text.replace(/__(\S[\s\S]*?)__/g, function(wm, m) {
                return /\S$/.test(m) ? parseInside(m, '<strong>', '</strong>') : wm;
            });
            text = text.replace(/_([^\s_][\s\S]*?)_/g, function(wm, m) {
                // !/^_[^_]/.test(m) - test if it doesn't start with __ (since it seems redundant, we removed it)
                return /\S$/.test(m) ? parseInside(m, '<em>', '</em>') : wm;
            });
        }
        // Now parse asterisks
        if (options.literalMidWordAsterisks) {
            text = text.replace(/([^*]|^)\B\*\*\*(\S[\s\S]*?)\*\*\*\B(?!\*)/g, function(wm, lead, txt) {
                return parseInside(txt, lead + '<strong><em>', '</em></strong>');
            });
            text = text.replace(/([^*]|^)\B\*\*(\S[\s\S]*?)\*\*\B(?!\*)/g, function(wm, lead, txt) {
                return parseInside(txt, lead + '<strong>', '</strong>');
            });
            text = text.replace(/([^*]|^)\B\*(\S[\s\S]*?)\*\B(?!\*)/g, function(wm, lead, txt) {
                return parseInside(txt, lead + '<em>', '</em>');
            });
        } else {
            text = text.replace(/\*\*\*(\S[\s\S]*?)\*\*\*/g, function(wm, m) {
                return /\S$/.test(m) ? parseInside(m, '<strong><em>', '</em></strong>') : wm;
            });
            text = text.replace(/\*\*(\S[\s\S]*?)\*\*/g, function(wm, m) {
                return /\S$/.test(m) ? parseInside(m, '<strong>', '</strong>') : wm;
            });
            text = text.replace(/\*([^\s*][\s\S]*?)\*/g, function(wm, m) {
                // !/^\*[^*]/.test(m) - test if it doesn't start with ** (since it seems redundant, we removed it)
                return /\S$/.test(m) ? parseInside(m, '<em>', '</em>') : wm;
            });
        }
        text = globals.converter._dispatch('italicsAndBold.after', text, options, globals);
        return text;
    });
    /**
 * Form HTML ordered (numbered) and unordered (bulleted) lists.
 */ showdown.subParser('lists', function(text, options, globals) {
        'use strict';
        /**
   * Process the contents of a single ordered or unordered list, splitting it
   * into individual list items.
   * @param {string} listStr
   * @param {boolean} trimTrailing
   * @returns {string}
   */ function processListItems(listStr, trimTrailing) {
            // The $g_list_level global keeps track of when we're inside a list.
            // Each time we enter a list, we increment it; when we leave a list,
            // we decrement. If it's zero, we're not in a list anymore.
            //
            // We do this because when we're not inside a list, we want to treat
            // something like this:
            //
            //    I recommend upgrading to version
            //    8. Oops, now this line is treated
            //    as a sub-list.
            //
            // As a single paragraph, despite the fact that the second line starts
            // with a digit-period-space sequence.
            //
            // Whereas when we're inside a list (or sub-list), that line will be
            // treated as the start of a sub-list. What a kludge, huh? This is
            // an aspect of Markdown's syntax that's hard to parse perfectly
            // without resorting to mind-reading. Perhaps the solution is to
            // change the syntax rules such that sub-lists must start with a
            // starting cardinal number; e.g. "1." or "a.".
            globals.gListLevel++;
            // trim trailing blank lines:
            listStr = listStr.replace(/\n{2,}$/, '\n');
            // attacklab: add sentinel to emulate \z
            listStr += "\xa80";
            var rgx = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(¨0| {0,3}([*+-]|\d+[.])[ \t]+))/gm, isParagraphed = /\n[ \t]*\n(?!¨0)/.test(listStr);
            // Since version 1.5, nesting sublists requires 4 spaces (or 1 tab) indentation,
            // which is a syntax breaking change
            // activating this option reverts to old behavior
            if (options.disableForced4SpacesIndentedSublists) rgx = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(¨0|\2([*+-]|\d+[.])[ \t]+))/gm;
            listStr = listStr.replace(rgx, function(wholeMatch, m1, m2, m3, m4, taskbtn, checked) {
                checked = checked && checked.trim() !== '';
                var item = showdown.subParser('outdent')(m4, options, globals), bulletStyle = '';
                // Support for github tasklists
                if (taskbtn && options.tasklists) {
                    bulletStyle = ' class="task-list-item" style="list-style-type: none;"';
                    item = item.replace(/^[ \t]*\[(x|X| )?]/m, function() {
                        var otp = '<input type="checkbox" disabled style="margin: 0px 0.35em 0.25em -1.6em; vertical-align: middle;"';
                        if (checked) otp += ' checked';
                        otp += '>';
                        return otp;
                    });
                }
                // ISSUE #312
                // This input: - - - a
                // causes trouble to the parser, since it interprets it as:
                // <ul><li><li><li>a</li></li></li></ul>
                // instead of:
                // <ul><li>- - a</li></ul>
                // So, to prevent it, we will put a marker (¨A)in the beginning of the line
                // Kind of hackish/monkey patching, but seems more effective than overcomplicating the list parser
                item = item.replace(/^([-*+]|\d\.)[ \t]+[\S\n ]*/g, function(wm2) {
                    return "\xa8A" + wm2;
                });
                // m1 - Leading line or
                // Has a double return (multi paragraph) or
                // Has sublist
                if (m1 || item.search(/\n{2,}/) > -1) {
                    item = showdown.subParser('githubCodeBlocks')(item, options, globals);
                    item = showdown.subParser('blockGamut')(item, options, globals);
                } else {
                    // Recursion for sub-lists:
                    item = showdown.subParser('lists')(item, options, globals);
                    item = item.replace(/\n$/, ''); // chomp(item)
                    item = showdown.subParser('hashHTMLBlocks')(item, options, globals);
                    // Colapse double linebreaks
                    item = item.replace(/\n\n+/g, '\n\n');
                    if (isParagraphed) item = showdown.subParser('paragraphs')(item, options, globals);
                    else item = showdown.subParser('spanGamut')(item, options, globals);
                }
                // now we need to remove the marker (¨A)
                item = item.replace("\xa8A", '');
                // we can finally wrap the line in list item tags
                item = '<li' + bulletStyle + '>' + item + '</li>\n';
                return item;
            });
            // attacklab: strip sentinel
            listStr = listStr.replace(/¨0/g, '');
            globals.gListLevel--;
            if (trimTrailing) listStr = listStr.replace(/\s+$/, '');
            return listStr;
        }
        function styleStartNumber(list, listType) {
            // check if ol and starts by a number different than 1
            if (listType === 'ol') {
                var res = list.match(/^ *(\d+)\./);
                if (res && res[1] !== '1') return ' start="' + res[1] + '"';
            }
            return '';
        }
        /**
   * Check and parse consecutive lists (better fix for issue #142)
   * @param {string} list
   * @param {string} listType
   * @param {boolean} trimTrailing
   * @returns {string}
   */ function parseConsecutiveLists(list, listType, trimTrailing) {
            // check if we caught 2 or more consecutive lists by mistake
            // we use the counterRgx, meaning if listType is UL we look for OL and vice versa
            var olRgx = options.disableForced4SpacesIndentedSublists ? /^ ?\d+\.[ \t]/gm : /^ {0,3}\d+\.[ \t]/gm, ulRgx = options.disableForced4SpacesIndentedSublists ? /^ ?[*+-][ \t]/gm : /^ {0,3}[*+-][ \t]/gm, counterRxg = listType === 'ul' ? olRgx : ulRgx, result = '';
            if (list.search(counterRxg) !== -1) (function parseCL(txt) {
                var pos = txt.search(counterRxg), style = styleStartNumber(list, listType);
                if (pos !== -1) {
                    // slice
                    result += '\n\n<' + listType + style + '>\n' + processListItems(txt.slice(0, pos), !!trimTrailing) + '</' + listType + '>\n';
                    // invert counterType and listType
                    listType = listType === 'ul' ? 'ol' : 'ul';
                    counterRxg = listType === 'ul' ? olRgx : ulRgx;
                    //recurse
                    parseCL(txt.slice(pos));
                } else result += '\n\n<' + listType + style + '>\n' + processListItems(txt, !!trimTrailing) + '</' + listType + '>\n';
            })(list);
            else {
                var style = styleStartNumber(list, listType);
                result = '\n\n<' + listType + style + '>\n' + processListItems(list, !!trimTrailing) + '</' + listType + '>\n';
            }
            return result;
        }
        /** Start of list parsing **/ text = globals.converter._dispatch('lists.before', text, options, globals);
        // add sentinel to hack around khtml/safari bug:
        // http://bugs.webkit.org/show_bug.cgi?id=11231
        text += "\xa80";
        if (globals.gListLevel) text = text.replace(/^(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(¨0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm, function(wholeMatch, list, m2) {
            var listType = m2.search(/[*+-]/g) > -1 ? 'ul' : 'ol';
            return parseConsecutiveLists(list, listType, true);
        });
        else text = text.replace(/(\n\n|^\n?)(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(¨0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm, function(wholeMatch, m1, list, m3) {
            var listType = m3.search(/[*+-]/g) > -1 ? 'ul' : 'ol';
            return parseConsecutiveLists(list, listType, false);
        });
        // strip sentinel
        text = text.replace(/¨0/, '');
        text = globals.converter._dispatch('lists.after', text, options, globals);
        return text;
    });
    /**
 * Parse metadata at the top of the document
 */ showdown.subParser('metadata', function(text, options, globals) {
        'use strict';
        if (!options.metadata) return text;
        text = globals.converter._dispatch('metadata.before', text, options, globals);
        function parseMetadataContents(content) {
            // raw is raw so it's not changed in any way
            globals.metadata.raw = content;
            // escape chars forbidden in html attributes
            // double quotes
            content = content// ampersand first
            .replace(/&/g, '&amp;')// double quotes
            .replace(/"/g, '&quot;');
            content = content.replace(/\n {4}/g, ' ');
            content.replace(/^([\S ]+): +([\s\S]+?)$/gm, function(wm, key, value) {
                globals.metadata.parsed[key] = value;
                return '';
            });
        }
        text = text.replace(/^\s*«««+(\S*?)\n([\s\S]+?)\n»»»+\n/, function(wholematch, format, content) {
            parseMetadataContents(content);
            return "\xa8M";
        });
        text = text.replace(/^\s*---+(\S*?)\n([\s\S]+?)\n---+\n/, function(wholematch, format, content) {
            if (format) globals.metadata.format = format;
            parseMetadataContents(content);
            return "\xa8M";
        });
        text = text.replace(/¨M/g, '');
        text = globals.converter._dispatch('metadata.after', text, options, globals);
        return text;
    });
    /**
 * Remove one level of line-leading tabs or spaces
 */ showdown.subParser('outdent', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('outdent.before', text, options, globals);
        // attacklab: hack around Konqueror 3.5.4 bug:
        // "----------bug".replace(/^-/g,"") == "bug"
        text = text.replace(/^(\t|[ ]{1,4})/gm, "\xa80"); // attacklab: g_tab_width
        // attacklab: clean up hack
        text = text.replace(/¨0/g, '');
        text = globals.converter._dispatch('outdent.after', text, options, globals);
        return text;
    });
    /**
 *
 */ showdown.subParser('paragraphs', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('paragraphs.before', text, options, globals);
        // Strip leading and trailing lines:
        text = text.replace(/^\n+/g, '');
        text = text.replace(/\n+$/g, '');
        var grafs = text.split(/\n{2,}/g), grafsOut = [], end = grafs.length; // Wrap <p> tags
        for(var i = 0; i < end; i++){
            var str = grafs[i];
            // if this is an HTML marker, copy it
            if (str.search(/¨(K|G)(\d+)\1/g) >= 0) grafsOut.push(str);
            else if (str.search(/\S/) >= 0) {
                str = showdown.subParser('spanGamut')(str, options, globals);
                str = str.replace(/^([ \t]*)/g, '<p>');
                str += '</p>';
                grafsOut.push(str);
            }
        }
        /** Unhashify HTML blocks */ end = grafsOut.length;
        for(i = 0; i < end; i++){
            var blockText = '', grafsOutIt = grafsOut[i], codeFlag = false;
            // if this is a marker for an html block...
            // use RegExp.test instead of string.search because of QML bug
            while(/¨(K|G)(\d+)\1/.test(grafsOutIt)){
                var delim = RegExp.$1, num = RegExp.$2;
                if (delim === 'K') blockText = globals.gHtmlBlocks[num];
                else // we need to check if ghBlock is a false positive
                if (codeFlag) // use encoded version of all text
                blockText = showdown.subParser('encodeCode')(globals.ghCodeBlocks[num].text, options, globals);
                else blockText = globals.ghCodeBlocks[num].codeblock;
                blockText = blockText.replace(/\$/g, '$$$$'); // Escape any dollar signs
                grafsOutIt = grafsOutIt.replace(/(\n\n)?¨(K|G)\d+\2(\n\n)?/, blockText);
                // Check if grafsOutIt is a pre->code
                if (/^<pre\b[^>]*>\s*<code\b[^>]*>/.test(grafsOutIt)) codeFlag = true;
            }
            grafsOut[i] = grafsOutIt;
        }
        text = grafsOut.join('\n');
        // Strip leading and trailing lines:
        text = text.replace(/^\n+/g, '');
        text = text.replace(/\n+$/g, '');
        return globals.converter._dispatch('paragraphs.after', text, options, globals);
    });
    /**
 * Run extension
 */ showdown.subParser('runExtension', function(ext, text, options, globals) {
        'use strict';
        if (ext.filter) text = ext.filter(text, globals.converter, options);
        else if (ext.regex) {
            // TODO remove this when old extension loading mechanism is deprecated
            var re = ext.regex;
            if (!(re instanceof RegExp)) re = new RegExp(re, 'g');
            text = text.replace(re, ext.replace);
        }
        return text;
    });
    /**
 * These are all the transformations that occur *within* block-level
 * tags like paragraphs, headers, and list items.
 */ showdown.subParser('spanGamut', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('spanGamut.before', text, options, globals);
        text = showdown.subParser('codeSpans')(text, options, globals);
        text = showdown.subParser('escapeSpecialCharsWithinTagAttributes')(text, options, globals);
        text = showdown.subParser('encodeBackslashEscapes')(text, options, globals);
        // Process anchor and image tags. Images must come first,
        // because ![foo][f] looks like an anchor.
        text = showdown.subParser('images')(text, options, globals);
        text = showdown.subParser('anchors')(text, options, globals);
        // Make links out of things like `<http://example.com/>`
        // Must come after anchors, because you can use < and >
        // delimiters in inline links like [this](<url>).
        text = showdown.subParser('autoLinks')(text, options, globals);
        text = showdown.subParser('simplifiedAutoLinks')(text, options, globals);
        text = showdown.subParser('emoji')(text, options, globals);
        text = showdown.subParser('underline')(text, options, globals);
        text = showdown.subParser('italicsAndBold')(text, options, globals);
        text = showdown.subParser('strikethrough')(text, options, globals);
        text = showdown.subParser('ellipsis')(text, options, globals);
        // we need to hash HTML tags inside spans
        text = showdown.subParser('hashHTMLSpans')(text, options, globals);
        // now we encode amps and angles
        text = showdown.subParser('encodeAmpsAndAngles')(text, options, globals);
        // Do hard breaks
        if (options.simpleLineBreaks) // GFM style hard breaks
        // only add line breaks if the text does not contain a block (special case for lists)
        {
            if (!/\n\n¨K/.test(text)) text = text.replace(/\n+/g, '<br />\n');
        } else // Vanilla hard breaks
        text = text.replace(/  +\n/g, '<br />\n');
        text = globals.converter._dispatch('spanGamut.after', text, options, globals);
        return text;
    });
    showdown.subParser('strikethrough', function(text, options, globals) {
        'use strict';
        function parseInside(txt) {
            if (options.simplifiedAutoLink) txt = showdown.subParser('simplifiedAutoLinks')(txt, options, globals);
            return '<del>' + txt + '</del>';
        }
        if (options.strikethrough) {
            text = globals.converter._dispatch('strikethrough.before', text, options, globals);
            text = text.replace(/(?:~){2}([\s\S]+?)(?:~){2}/g, function(wm, txt) {
                return parseInside(txt);
            });
            text = globals.converter._dispatch('strikethrough.after', text, options, globals);
        }
        return text;
    });
    /**
 * Strips link definitions from text, stores the URLs and titles in
 * hash references.
 * Link defs are in the form: ^[id]: url "optional title"
 */ showdown.subParser('stripLinkDefinitions', function(text, options, globals) {
        'use strict';
        var regex = /^ {0,3}\[([^\]]+)]:[ \t]*\n?[ \t]*<?([^>\s]+)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n+|(?=¨0))/gm, base64Regex = /^ {0,3}\[([^\]]+)]:[ \t]*\n?[ \t]*<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n\n|(?=¨0)|(?=\n\[))/gm;
        // attacklab: sentinel workarounds for lack of \A and \Z, safari\khtml bug
        text += "\xa80";
        var replaceFunc = function(wholeMatch, linkId, url, width, height, blankLines, title) {
            // if there aren't two instances of linkId it must not be a reference link so back out
            linkId = linkId.toLowerCase();
            if (text.toLowerCase().split(linkId).length - 1 < 2) return wholeMatch;
            if (url.match(/^data:.+?\/.+?;base64,/)) // remove newlines
            globals.gUrls[linkId] = url.replace(/\s/g, '');
            else globals.gUrls[linkId] = showdown.subParser('encodeAmpsAndAngles')(url, options, globals); // Link IDs are case-insensitive
            if (blankLines) // Oops, found blank lines, so it's not a title.
            // Put back the parenthetical statement we stole.
            return blankLines + title;
            else {
                if (title) globals.gTitles[linkId] = title.replace(/"|'/g, '&quot;');
                if (options.parseImgDimensions && width && height) globals.gDimensions[linkId] = {
                    width: width,
                    height: height
                };
            }
            // Completely remove the definition from the text
            return '';
        };
        // first we try to find base64 link references
        text = text.replace(base64Regex, replaceFunc);
        text = text.replace(regex, replaceFunc);
        // attacklab: strip sentinel
        text = text.replace(/¨0/, '');
        return text;
    });
    showdown.subParser('tables', function(text, options, globals) {
        'use strict';
        if (!options.tables) return text;
        var tableRgx = /^ {0,3}\|?.+\|.+\n {0,3}\|?[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*:?[ \t]*(?:[-=]){2,}[\s\S]+?(?:\n\n|¨0)/gm, //singeColTblRgx = /^ {0,3}\|.+\|\n {0,3}\|[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*\n(?: {0,3}\|.+\|\n)+(?:\n\n|¨0)/gm;
        singeColTblRgx = /^ {0,3}\|.+\|[ \t]*\n {0,3}\|[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*\n( {0,3}\|.+\|[ \t]*\n)*(?:\n|¨0)/gm;
        function parseStyles(sLine) {
            if (/^:[ \t]*--*$/.test(sLine)) return ' style="text-align:left;"';
            else if (/^--*[ \t]*:[ \t]*$/.test(sLine)) return ' style="text-align:right;"';
            else if (/^:[ \t]*--*[ \t]*:$/.test(sLine)) return ' style="text-align:center;"';
            else return '';
        }
        function parseHeaders(header, style) {
            var id = '';
            header = header.trim();
            // support both tablesHeaderId and tableHeaderId due to error in documentation so we don't break backwards compatibility
            if (options.tablesHeaderId || options.tableHeaderId) id = ' id="' + header.replace(/ /g, '_').toLowerCase() + '"';
            header = showdown.subParser('spanGamut')(header, options, globals);
            return '<th' + id + style + '>' + header + '</th>\n';
        }
        function parseCells(cell, style) {
            var subText = showdown.subParser('spanGamut')(cell, options, globals);
            return '<td' + style + '>' + subText + '</td>\n';
        }
        function buildTable(headers, cells) {
            var tb = '<table>\n<thead>\n<tr>\n', tblLgn = headers.length;
            for(var i = 0; i < tblLgn; ++i)tb += headers[i];
            tb += '</tr>\n</thead>\n<tbody>\n';
            for(i = 0; i < cells.length; ++i){
                tb += '<tr>\n';
                for(var ii = 0; ii < tblLgn; ++ii)tb += cells[i][ii];
                tb += '</tr>\n';
            }
            tb += '</tbody>\n</table>\n';
            return tb;
        }
        function parseTable(rawTable) {
            var i, tableLines = rawTable.split('\n');
            for(i = 0; i < tableLines.length; ++i){
                // strip wrong first and last column if wrapped tables are used
                if (/^ {0,3}\|/.test(tableLines[i])) tableLines[i] = tableLines[i].replace(/^ {0,3}\|/, '');
                if (/\|[ \t]*$/.test(tableLines[i])) tableLines[i] = tableLines[i].replace(/\|[ \t]*$/, '');
                // parse code spans first, but we only support one line code spans
                tableLines[i] = showdown.subParser('codeSpans')(tableLines[i], options, globals);
            }
            var rawHeaders = tableLines[0].split('|').map(function(s) {
                return s.trim();
            }), rawStyles = tableLines[1].split('|').map(function(s) {
                return s.trim();
            }), rawCells = [], headers = [], styles = [], cells = [];
            tableLines.shift();
            tableLines.shift();
            for(i = 0; i < tableLines.length; ++i){
                if (tableLines[i].trim() === '') continue;
                rawCells.push(tableLines[i].split('|').map(function(s) {
                    return s.trim();
                }));
            }
            if (rawHeaders.length < rawStyles.length) return rawTable;
            for(i = 0; i < rawStyles.length; ++i)styles.push(parseStyles(rawStyles[i]));
            for(i = 0; i < rawHeaders.length; ++i){
                if (showdown.helper.isUndefined(styles[i])) styles[i] = '';
                headers.push(parseHeaders(rawHeaders[i], styles[i]));
            }
            for(i = 0; i < rawCells.length; ++i){
                var row = [];
                for(var ii = 0; ii < headers.length; ++ii){
                    showdown.helper.isUndefined(rawCells[i][ii]);
                    row.push(parseCells(rawCells[i][ii], styles[ii]));
                }
                cells.push(row);
            }
            return buildTable(headers, cells);
        }
        text = globals.converter._dispatch('tables.before', text, options, globals);
        // find escaped pipe characters
        text = text.replace(/\\(\|)/g, showdown.helper.escapeCharactersCallback);
        // parse multi column tables
        text = text.replace(tableRgx, parseTable);
        // parse one column tables
        text = text.replace(singeColTblRgx, parseTable);
        text = globals.converter._dispatch('tables.after', text, options, globals);
        return text;
    });
    showdown.subParser('underline', function(text, options, globals) {
        'use strict';
        if (!options.underline) return text;
        text = globals.converter._dispatch('underline.before', text, options, globals);
        if (options.literalMidWordUnderscores) {
            text = text.replace(/\b___(\S[\s\S]*?)___\b/g, function(wm, txt) {
                return '<u>' + txt + '</u>';
            });
            text = text.replace(/\b__(\S[\s\S]*?)__\b/g, function(wm, txt) {
                return '<u>' + txt + '</u>';
            });
        } else {
            text = text.replace(/___(\S[\s\S]*?)___/g, function(wm, m) {
                return /\S$/.test(m) ? '<u>' + m + '</u>' : wm;
            });
            text = text.replace(/__(\S[\s\S]*?)__/g, function(wm, m) {
                return /\S$/.test(m) ? '<u>' + m + '</u>' : wm;
            });
        }
        // escape remaining underscores to prevent them being parsed by italic and bold
        text = text.replace(/(_)/g, showdown.helper.escapeCharactersCallback);
        text = globals.converter._dispatch('underline.after', text, options, globals);
        return text;
    });
    /**
 * Swap back in all the special characters we've hidden.
 */ showdown.subParser('unescapeSpecialChars', function(text, options, globals) {
        'use strict';
        text = globals.converter._dispatch('unescapeSpecialChars.before', text, options, globals);
        text = text.replace(/¨E(\d+)E/g, function(wholeMatch, m1) {
            var charCodeToReplace = parseInt(m1);
            return String.fromCharCode(charCodeToReplace);
        });
        text = globals.converter._dispatch('unescapeSpecialChars.after', text, options, globals);
        return text;
    });
    showdown.subParser('makeMarkdown.blockquote', function(node, globals) {
        'use strict';
        var txt = '';
        if (node.hasChildNodes()) {
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i){
                var innerTxt = showdown.subParser('makeMarkdown.node')(children[i], globals);
                if (innerTxt === '') continue;
                txt += innerTxt;
            }
        }
        // cleanup
        txt = txt.trim();
        txt = '> ' + txt.split('\n').join('\n> ');
        return txt;
    });
    showdown.subParser('makeMarkdown.codeBlock', function(node, globals) {
        'use strict';
        var lang = node.getAttribute('language'), num = node.getAttribute('precodenum');
        return '```' + lang + '\n' + globals.preList[num] + '\n```';
    });
    showdown.subParser('makeMarkdown.codeSpan', function(node) {
        'use strict';
        return '`' + node.innerHTML + '`';
    });
    showdown.subParser('makeMarkdown.emphasis', function(node, globals) {
        'use strict';
        var txt = '';
        if (node.hasChildNodes()) {
            txt += '*';
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
            txt += '*';
        }
        return txt;
    });
    showdown.subParser('makeMarkdown.header', function(node, globals, headerLevel) {
        'use strict';
        var headerMark = new Array(headerLevel + 1).join('#'), txt = '';
        if (node.hasChildNodes()) {
            txt = headerMark + ' ';
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
        }
        return txt;
    });
    showdown.subParser('makeMarkdown.hr', function() {
        'use strict';
        return '---';
    });
    showdown.subParser('makeMarkdown.image', function(node) {
        'use strict';
        var txt = '';
        if (node.hasAttribute('src')) {
            txt += '![' + node.getAttribute('alt') + '](';
            txt += '<' + node.getAttribute('src') + '>';
            if (node.hasAttribute('width') && node.hasAttribute('height')) txt += ' =' + node.getAttribute('width') + 'x' + node.getAttribute('height');
            if (node.hasAttribute('title')) txt += ' "' + node.getAttribute('title') + '"';
            txt += ')';
        }
        return txt;
    });
    showdown.subParser('makeMarkdown.links', function(node, globals) {
        'use strict';
        var txt = '';
        if (node.hasChildNodes() && node.hasAttribute('href')) {
            var children = node.childNodes, childrenLength = children.length;
            txt = '[';
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
            txt += '](';
            txt += '<' + node.getAttribute('href') + '>';
            if (node.hasAttribute('title')) txt += ' "' + node.getAttribute('title') + '"';
            txt += ')';
        }
        return txt;
    });
    showdown.subParser('makeMarkdown.list', function(node, globals, type) {
        'use strict';
        var txt = '';
        if (!node.hasChildNodes()) return '';
        var listItems = node.childNodes, listItemsLenght = listItems.length, listNum = node.getAttribute('start') || 1;
        for(var i = 0; i < listItemsLenght; ++i){
            if (typeof listItems[i].tagName === 'undefined' || listItems[i].tagName.toLowerCase() !== 'li') continue;
            // define the bullet to use in list
            var bullet = '';
            if (type === 'ol') bullet = listNum.toString() + '. ';
            else bullet = '- ';
            // parse list item
            txt += bullet + showdown.subParser('makeMarkdown.listItem')(listItems[i], globals);
            ++listNum;
        }
        // add comment at the end to prevent consecutive lists to be parsed as one
        txt += '\n<!-- -->\n';
        return txt.trim();
    });
    showdown.subParser('makeMarkdown.listItem', function(node, globals) {
        'use strict';
        var listItemTxt = '';
        var children = node.childNodes, childrenLenght = children.length;
        for(var i = 0; i < childrenLenght; ++i)listItemTxt += showdown.subParser('makeMarkdown.node')(children[i], globals);
        // if it's only one liner, we need to add a newline at the end
        if (!/\n$/.test(listItemTxt)) listItemTxt += '\n';
        else // it's multiparagraph, so we need to indent
        listItemTxt = listItemTxt.split('\n').join('\n    ').replace(/^ {4}$/gm, '').replace(/\n\n+/g, '\n\n');
        return listItemTxt;
    });
    showdown.subParser('makeMarkdown.node', function(node, globals, spansOnly) {
        'use strict';
        spansOnly = spansOnly || false;
        var txt = '';
        // edge case of text without wrapper paragraph
        if (node.nodeType === 3) return showdown.subParser('makeMarkdown.txt')(node, globals);
        // HTML comment
        if (node.nodeType === 8) return '<!--' + node.data + '-->\n\n';
        // process only node elements
        if (node.nodeType !== 1) return '';
        var tagName = node.tagName.toLowerCase();
        switch(tagName){
            //
            // BLOCKS
            //
            case 'h1':
                if (!spansOnly) txt = showdown.subParser('makeMarkdown.header')(node, globals, 1) + '\n\n';
                break;
            case 'h2':
                if (!spansOnly) txt = showdown.subParser('makeMarkdown.header')(node, globals, 2) + '\n\n';
                break;
            case 'h3':
                if (!spansOnly) txt = showdown.subParser('makeMarkdown.header')(node, globals, 3) + '\n\n';
                break;
            case 'h4':
                if (!spansOnly) txt = showdown.subParser('makeMarkdown.header')(node, globals, 4) + '\n\n';
                break;
            case 'h5':
                if (!spansOnly) txt = showdown.subParser('makeMarkdown.header')(node, globals, 5) + '\n\n';
                break;
            case 'h6':
                if (!spansOnly) txt = showdown.subParser('makeMarkdown.header')(node, globals, 6) + '\n\n';
                break;
            case 'p':
                if (!spansOnly) txt = showdown.subParser('makeMarkdown.paragraph')(node, globals) + '\n\n';
                break;
            case 'blockquote':
                if (!spansOnly) txt = showdown.subParser('makeMarkdown.blockquote')(node, globals) + '\n\n';
                break;
            case 'hr':
                if (!spansOnly) txt = showdown.subParser('makeMarkdown.hr')(node, globals) + '\n\n';
                break;
            case 'ol':
                if (!spansOnly) txt = showdown.subParser('makeMarkdown.list')(node, globals, 'ol') + '\n\n';
                break;
            case 'ul':
                if (!spansOnly) txt = showdown.subParser('makeMarkdown.list')(node, globals, 'ul') + '\n\n';
                break;
            case 'precode':
                if (!spansOnly) txt = showdown.subParser('makeMarkdown.codeBlock')(node, globals) + '\n\n';
                break;
            case 'pre':
                if (!spansOnly) txt = showdown.subParser('makeMarkdown.pre')(node, globals) + '\n\n';
                break;
            case 'table':
                if (!spansOnly) txt = showdown.subParser('makeMarkdown.table')(node, globals) + '\n\n';
                break;
            //
            // SPANS
            //
            case 'code':
                txt = showdown.subParser('makeMarkdown.codeSpan')(node, globals);
                break;
            case 'em':
            case 'i':
                txt = showdown.subParser('makeMarkdown.emphasis')(node, globals);
                break;
            case 'strong':
            case 'b':
                txt = showdown.subParser('makeMarkdown.strong')(node, globals);
                break;
            case 'del':
                txt = showdown.subParser('makeMarkdown.strikethrough')(node, globals);
                break;
            case 'a':
                txt = showdown.subParser('makeMarkdown.links')(node, globals);
                break;
            case 'img':
                txt = showdown.subParser('makeMarkdown.image')(node, globals);
                break;
            default:
                txt = node.outerHTML + '\n\n';
        }
        // common normalization
        // TODO eventually
        return txt;
    });
    showdown.subParser('makeMarkdown.paragraph', function(node, globals) {
        'use strict';
        var txt = '';
        if (node.hasChildNodes()) {
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
        }
        // some text normalization
        txt = txt.trim();
        return txt;
    });
    showdown.subParser('makeMarkdown.pre', function(node, globals) {
        'use strict';
        var num = node.getAttribute('prenum');
        return '<pre>' + globals.preList[num] + '</pre>';
    });
    showdown.subParser('makeMarkdown.strikethrough', function(node, globals) {
        'use strict';
        var txt = '';
        if (node.hasChildNodes()) {
            txt += '~~';
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
            txt += '~~';
        }
        return txt;
    });
    showdown.subParser('makeMarkdown.strong', function(node, globals) {
        'use strict';
        var txt = '';
        if (node.hasChildNodes()) {
            txt += '**';
            var children = node.childNodes, childrenLength = children.length;
            for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
            txt += '**';
        }
        return txt;
    });
    showdown.subParser('makeMarkdown.table', function(node, globals) {
        'use strict';
        var txt = '', tableArray = [
            [],
            []
        ], headings = node.querySelectorAll('thead>tr>th'), rows = node.querySelectorAll('tbody>tr'), i, ii;
        for(i = 0; i < headings.length; ++i){
            var headContent = showdown.subParser('makeMarkdown.tableCell')(headings[i], globals), allign = '---';
            if (headings[i].hasAttribute('style')) {
                var style = headings[i].getAttribute('style').toLowerCase().replace(/\s/g, '');
                switch(style){
                    case 'text-align:left;':
                        allign = ':---';
                        break;
                    case 'text-align:right;':
                        allign = '---:';
                        break;
                    case 'text-align:center;':
                        allign = ':---:';
                        break;
                }
            }
            tableArray[0][i] = headContent.trim();
            tableArray[1][i] = allign;
        }
        for(i = 0; i < rows.length; ++i){
            var r = tableArray.push([]) - 1, cols = rows[i].getElementsByTagName('td');
            for(ii = 0; ii < headings.length; ++ii){
                var cellContent = ' ';
                if (typeof cols[ii] !== 'undefined') cellContent = showdown.subParser('makeMarkdown.tableCell')(cols[ii], globals);
                tableArray[r].push(cellContent);
            }
        }
        var cellSpacesCount = 3;
        for(i = 0; i < tableArray.length; ++i)for(ii = 0; ii < tableArray[i].length; ++ii){
            var strLen = tableArray[i][ii].length;
            if (strLen > cellSpacesCount) cellSpacesCount = strLen;
        }
        for(i = 0; i < tableArray.length; ++i){
            for(ii = 0; ii < tableArray[i].length; ++ii)if (i === 1) {
                if (tableArray[i][ii].slice(-1) === ':') tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii].slice(-1), cellSpacesCount - 1, '-') + ':';
                else tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii], cellSpacesCount, '-');
            } else tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii], cellSpacesCount);
            txt += '| ' + tableArray[i].join(' | ') + ' |\n';
        }
        return txt.trim();
    });
    showdown.subParser('makeMarkdown.tableCell', function(node, globals) {
        'use strict';
        var txt = '';
        if (!node.hasChildNodes()) return '';
        var children = node.childNodes, childrenLength = children.length;
        for(var i = 0; i < childrenLength; ++i)txt += showdown.subParser('makeMarkdown.node')(children[i], globals, true);
        return txt.trim();
    });
    showdown.subParser('makeMarkdown.txt', function(node) {
        'use strict';
        var txt = node.nodeValue;
        // multiple spaces are collapsed
        txt = txt.replace(/ +/g, ' ');
        // replace the custom ¨NBSP; with a space
        txt = txt.replace(/¨NBSP;/g, ' ');
        // ", <, > and & should replace escaped html entities
        txt = showdown.helper.unescapeHTMLEntities(txt);
        // escape markdown magic characters
        // emphasis, strong and strikethrough - can appear everywhere
        // we also escape pipe (|) because of tables
        // and escape ` because of code blocks and spans
        txt = txt.replace(/([*_~|`])/g, '\\$1');
        // escape > because of blockquotes
        txt = txt.replace(/^(\s*)>/g, '\\$1>');
        // hash character, only troublesome at the beginning of a line because of headers
        txt = txt.replace(/^#/gm, '\\#');
        // horizontal rules
        txt = txt.replace(/^(\s*)([-=]{3,})(\s*)$/, '$1\\$2$3');
        // dot, because of ordered lists, only troublesome at the beginning of a line when preceded by an integer
        txt = txt.replace(/^( {0,3}\d+)\./gm, '$1\\.');
        // +, * and -, at the beginning of a line becomes a list, so we need to escape them also (asterisk was already escaped)
        txt = txt.replace(/^( {0,3})([+-])/gm, '$1\\$2');
        // images and links, ] followed by ( is problematic, so we escape it
        txt = txt.replace(/]([\s]*)\(/g, '\\]$1\\(');
        // reference URIs must also be escaped
        txt = txt.replace(/^ {0,3}\[([\S \t]*?)]:/gm, '\\[$1]:');
        return txt;
    });
    var root = this;
    // AMD Loader
    if (typeof define === 'function' && define.amd) define(function() {
        'use strict';
        return showdown;
    });
    else if (0, module.exports) module.exports = showdown;
    else root.showdown = showdown;
}).call(this);

},{}],"fjWbT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _radiosElement = require("./components/radios-element");
var _radiosElementDefault = parcelHelpers.interopDefault(_radiosElement);
exports.default = {
    elements: {
        [(0, _radiosElementDefault.default).apiName]: (0, _radiosElementDefault.default)
    }
};

},{"./components/radios-element":"kv3Qt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kv3Qt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
var _jsxRuntime = require("react/jsx-runtime");
var _useDatasource = require("@form-engine/core-application/hooks/use-datasource");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _useMarkdown = require("@form-engine/core-application/hooks/use-markdown");
var _useMarkdownDefault = parcelHelpers.interopDefault(_useMarkdown);
var _template = require("@form-engine/core-util/template");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _useElementDisabled = require("@form-engine/core-application/hooks/use-element-disabled");
var _useElementRequired = require("@form-engine/core-application/hooks/use-element-required");
var _uuid = require("@form-engine/core-util/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
const apiName = 'FormEngineRadiosElement';
exports.default = Object.assign(function FormEngineRadiosElement() {
    const { state: { showValidFeedback = true } } = (0, _useForm.useFormContext)();
    const { state: element } = (0, _useElement.useFormEngineElement)();
    if (!element || element.type !== apiName) throw new Error('tried to render radios with invalid definition');
    const [session, setSession] = (0, _useFormsession.useFormElementSession)();
    const disabled = (0, _useElementDisabled.useFormEngineElementDisabled)();
    const { options } = (0, _useDatasource.useFormElementDatasourceData)();
    const compileMarkdown = (0, _useMarkdownDefault.default)();
    const { state: locals } = (0, _useFormsession.useFormSessionLocals)();
    const required = (0, _useElementRequired.useFormEngineElementRequired)();
    const currentValue = (0, _react.useMemo)(()=>{
        return String(session.value || '');
    }, [
        session.value
    ]);
    const handleChange = (0, _react.useCallback)((e)=>{
        const target = e.target;
        const value = target.checked ? target.value : '';
        setSession({
            ...session,
            isTouched: true,
            value
        });
    }, [
        setSession,
        session,
        currentValue
    ]);
    const id = (0, _react.useMemo)(()=>(0, _uuidDefault.default)(), []);
    const controls = (options || []).map((option, key)=>{
        let label, value;
        if (Array.isArray(option)) [value, label] = option;
        else label = value = option;
        label = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: compileMarkdown(label)
            }
        });
        value = (0, _template.compile)(value || '', locals, '');
        const selected = currentValue === value;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormCheck), {
            id: `cb-${id}-${key}`,
            inline: Boolean(element.inline),
            name: element.name,
            type: "radio",
            label: label,
            checked: selected,
            disabled: disabled,
            required: required,
            isValid: showValidFeedback && session.isTouched && !session.error,
            isInvalid: Boolean(session.isTouched && session.error),
            onChange: handleChange,
            value: value
        }, key);
    });
    const error = session.isTouched && element.showError && session.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl).Feedback, {
        type: "invalid",
        children: session.error
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormGroup), {
        className: "fe-radios",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                element.label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "form-label",
                    children: element.label
                }),
                controls,
                error
            ]
        })
    });
}, {
    apiName,
    isField: true,
    enabled: true
});

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/hooks/use-datasource":"lz7AL","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-application/hooks/use-formsession":"2Th33","@form-engine/core-application/hooks/use-markdown":"lwtKh","@form-engine/core-util/template":"bKMue","react":"9njXz","react-bootstrap":"f5rnA","@form-engine/core-application/hooks/use-element":"ehckF","@form-engine/core-application/hooks/use-element-disabled":"klZMn","@form-engine/core-application/hooks/use-element-required":"cruGZ","@form-engine/core-util/uuid":"eZttN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gra5k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkboxElement = require("./components/checkbox-element");
var _checkboxElementDefault = parcelHelpers.interopDefault(_checkboxElement);
exports.default = {
    elements: {
        [(0, _checkboxElementDefault.default).apiName]: (0, _checkboxElementDefault.default)
    }
};

},{"./components/checkbox-element":"bIVAR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bIVAR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
var _jsxRuntime = require("react/jsx-runtime");
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _formCheckList = require("./form-check-list");
var _formCheckListDefault = parcelHelpers.interopDefault(_formCheckList);
var _index = require("./nested-form-check-list/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
const apiName = 'FormEngineCheckboxElement';
exports.default = Object.assign(function FormEngineCheckboxElement() {
    const { state: element } = (0, _useElement.useFormEngineElement)();
    if (!element || element.type !== apiName) throw new Error('tried to render checkbox with invalid definition');
    const { state } = (0, _useElement.useFormEngineElement)();
    if (state?.nested) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexDefault.default), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formCheckListDefault.default), {});
}, {
    apiName,
    isField: true,
    enabled: true
});

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/hooks/use-element":"ehckF","./form-check-list":"4rYtI","./nested-form-check-list/index":"akjTc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4rYtI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormCheckListRenderer", ()=>FormCheckListRenderer);
parcelHelpers.export(exports, "default", ()=>FormCheckList);
var _jsxRuntime = require("react/jsx-runtime");
var _useMarkdown = require("@form-engine/core-application/hooks/use-markdown");
var _useMarkdownDefault = parcelHelpers.interopDefault(_useMarkdown);
var _template = require("@form-engine/core-util/template");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _useDatasource = require("@form-engine/core-application/hooks/use-datasource");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _useElementDisabled = require("@form-engine/core-application/hooks/use-element-disabled");
var _useElementRequired = require("@form-engine/core-application/hooks/use-element-required");
var _checkboxElement = require("./checkbox-element");
var _uuid = require("@form-engine/core-util/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
function FormCheckListRenderer({ inline, disabled, isTouched, showError, showValidFeedback, label: listLabel, error, locals, options, currentValue, name, onChange }) {
    const compileMarkdown = (0, _useMarkdownDefault.default)();
    const id = (0, _react.useMemo)(()=>(0, _uuidDefault.default)(), []);
    const controls = options.map((option, key)=>{
        let label, value;
        if (Array.isArray(option)) [value, label] = option;
        else label = value = option;
        label = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: compileMarkdown(label)
            }
        });
        value = (0, _template.compile)(String(value ?? ''), locals, '');
        const selected = currentValue.includes(value);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormCheck), {
            id: `cb-${id}-${key}`,
            inline: Boolean(inline),
            name: name,
            type: "checkbox",
            label: label,
            checked: selected,
            disabled: disabled,
            isValid: showValidFeedback && isTouched && !error,
            isInvalid: Boolean(isTouched && error),
            onChange: onChange,
            value: value
        }, key);
    });
    const errorElement = isTouched && showError && error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl).Feedback, {
        type: "invalid",
        children: error
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormGroup), {
        className: "fe-checkbox",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                listLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "form-label",
                    children: listLabel
                }),
                controls,
                errorElement
            ]
        })
    });
}
function FormCheckList() {
    const { state: { showValidFeedback = true } } = (0, _useForm.useFormContext)();
    const { state: element } = (0, _useElement.useFormEngineElement)();
    if (!element || element.type !== (0, _checkboxElement.apiName)) throw new Error('tried to render checkbox with invalid definition');
    const [session, setSession] = (0, _useFormsession.useFormElementSession)();
    const currentValue = (0, _react.useMemo)(()=>{
        return Array.isArray(session?.value) ? session.value : String(session.value || '').trim().split(',');
    }, [
        session.value
    ]);
    const handleChange = (0, _react.useCallback)((e)=>{
        const target = e.target;
        const getStringValue = (source)=>source.filter((v)=>Boolean(v)).join(',');
        if (target.checked && !currentValue.includes(target.value)) setSession({
            ...session,
            isTouched: true,
            value: getStringValue([
                ...currentValue,
                target.value
            ])
        });
        else if (!target.checked && currentValue.includes(target.value)) {
            const copy = [
                ...currentValue
            ];
            copy.splice(copy.indexOf(target.value), 1);
            setSession({
                ...session,
                isTouched: true,
                value: getStringValue(copy)
            });
        }
    }, [
        setSession,
        session,
        currentValue
    ]);
    const props = {
        inline: element.inline,
        required: (0, _useElementRequired.useFormEngineElementRequired)(),
        disabled: (0, _useElementDisabled.useFormEngineElementDisabled)(),
        isTouched: session.isTouched,
        showError: element.showError,
        showValidFeedback,
        label: element.label,
        error: session.error || undefined,
        locals: (0, _useFormsession.useFormSessionLocals)()?.state,
        options: (0, _useDatasource.useFormElementDatasourceData)()?.options,
        currentValue,
        name: String(element.name),
        onChange: handleChange
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormCheckListRenderer, {
        ...props
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/hooks/use-markdown":"lwtKh","@form-engine/core-util/template":"bKMue","react":"9njXz","react-bootstrap":"f5rnA","@form-engine/core-application/hooks/use-datasource":"lz7AL","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-application/hooks/use-formsession":"2Th33","@form-engine/core-application/hooks/use-element":"ehckF","@form-engine/core-application/hooks/use-element-disabled":"klZMn","@form-engine/core-application/hooks/use-element-required":"cruGZ","./checkbox-element":"bIVAR","@form-engine/core-util/uuid":"eZttN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"akjTc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NestedFormCheckList);
var _jsxRuntime = require("react/jsx-runtime");
var _useDatasource = require("@form-engine/core-application/hooks/use-datasource");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _template = require("@form-engine/core-util/template");
var _react = require("react");
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _useElementDisabled = require("@form-engine/core-application/hooks/use-element-disabled");
var _formCheckList = require("../form-check-list");
var _checkboxElement = require("../checkbox-element");
function NestedFormCheckList() {
    const { state: { showValidFeedback = true } } = (0, _useForm.useFormContext)();
    const { state: element } = (0, _useElement.useFormEngineElement)();
    if (!element || element.type !== (0, _checkboxElement.apiName)) throw new Error('tried to render checkbox with invalid definition');
    const { nestedGroupLabel = '{{$i.Label}}', nestedGroupOptions = 'Options' } = element;
    const { data } = (0, _useDatasource.useFormElementDatasourceData)();
    const locals = (0, _useFormsession.useFormSessionLocals)()?.state ?? {};
    const [session, setSession] = (0, _useFormsession.useFormElementSession)();
    const disabled = (0, _useElementDisabled.useFormEngineElementDisabled)();
    const groups = (0, _react.useMemo)(()=>{
        const result = [];
        if (!Array.isArray(data)) return result;
        for (const group of data){
            if (group === null || typeof group !== 'object') return;
            result.push({
                label: (0, _template.compile)(String(nestedGroupLabel), {
                    ...locals,
                    $i: group
                }),
                options: String(nestedGroupOptions) in group ? group[String(nestedGroupOptions)] : []
            });
        }
        return result;
    }, [
        data,
        nestedGroupLabel,
        nestedGroupOptions,
        locals
    ]);
    const currentValue = (0, _react.useMemo)(()=>{
        try {
            const value = JSON.parse(String(session?.value || '[]'));
            if (!Array.isArray(value)) return [];
            return value;
        } catch  {
            return [];
        }
    }, [
        session.value
    ]);
    const getChangeHandler = (0, _react.useCallback)((index)=>{
        return (e)=>{
            const target = e.target;
            const newValue = Array.from({
                length: groups.length
            }, (_, i)=>{
                return Array.isArray(currentValue[i]) ? [
                    ...currentValue[i]
                ] : [];
            });
            const currentGroupValue = newValue.at(index);
            let dirty = false;
            if (target.checked && !currentGroupValue.includes(target.value)) {
                dirty = true;
                currentGroupValue.push(target.value);
            } else if (!target.checked && currentGroupValue.includes(target.value)) {
                dirty = true;
                currentGroupValue.splice(currentGroupValue.indexOf(target.value), 1);
            }
            dirty && setSession({
                ...session,
                isTouched: true,
                value: JSON.stringify(newValue)
            });
        };
    }, [
        groups,
        currentValue,
        session,
        setSession
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "fe-nested-checkbox-list",
        children: [
            element.label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "form-label",
                children: element.label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                className: "fe-nested-checkbox-list--items",
                children: groups.map((groupData, index)=>{
                    const props = {
                        inline: Boolean(element.inline),
                        disabled,
                        isTouched: session.isTouched,
                        showError: Boolean(element.showError),
                        showValidFeedback,
                        label: groupData.label,
                        error: session.error || undefined,
                        locals: {
                            ...locals,
                            $i: data[index]
                        },
                        options: groupData.options,
                        currentValue: currentValue.at(index) ?? [],
                        name: String(element.name),
                        onChange: getChangeHandler(index)
                    };
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formCheckList.FormCheckListRenderer), {
                            ...props
                        })
                    }, index);
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/hooks/use-datasource":"lz7AL","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-application/hooks/use-formsession":"2Th33","@form-engine/core-util/template":"bKMue","react":"9njXz","@form-engine/core-application/hooks/use-element":"ehckF","@form-engine/core-application/hooks/use-element-disabled":"klZMn","../form-check-list":"4rYtI","../checkbox-element":"bIVAR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6d2Jo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _navigationElement = require("./components/navigation-element");
var _navigationElementDefault = parcelHelpers.interopDefault(_navigationElement);
exports.default = {
    elements: {
        [(0, _navigationElementDefault.default).apiName]: (0, _navigationElementDefault.default)
    }
};

},{"./components/navigation-element":"bKaAi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bKaAi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
var _jsxRuntime = require("react/jsx-runtime");
var _useDatasource = require("@form-engine/core-application/hooks/use-datasource");
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _template = require("@form-engine/core-util/template");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
const apiName = 'FormEngineNavigationElement';
exports.default = Object.assign(function FormEngineNavigationElement() {
    const { state: element } = (0, _useElement.useFormEngineElement)();
    if (!element || element.type !== apiName) throw new Error('tried to render input with invalid definition');
    const { options } = (0, _useDatasource.useFormElementDatasourceData)();
    const { state: locals } = (0, _useFormsession.useFormSessionLocals)();
    const [currentPage = '', setCurrentPage] = (0, _useFormsession.useCurrentPage)();
    const controls = options.map((option, key)=>{
        let label, value;
        if (Array.isArray(option)) [value, label] = option;
        else label = value = option;
        value = (0, _template.compile)(value || '', locals, '');
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Item, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Link, {
                eventKey: value,
                onClick: (e)=>{
                    e.preventDefault();
                    setCurrentPage(value);
                },
                children: label
            })
        }, key);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormGroup), {
        className: "fe-navigation",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav), {
            variant: "tabs",
            activeKey: currentPage,
            children: controls
        })
    });
}, {
    apiName,
    isField: false,
    enabled: true
});

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/hooks/use-datasource":"lz7AL","@form-engine/core-application/hooks/use-element":"ehckF","@form-engine/core-application/hooks/use-formsession":"2Th33","@form-engine/core-util/template":"bKMue","react":"9njXz","react-bootstrap":"f5rnA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kGFgp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _containerElement = require("./components/container-element");
var _containerElementDefault = parcelHelpers.interopDefault(_containerElement);
exports.default = {
    elements: {
        [(0, _containerElementDefault.default).apiName]: (0, _containerElementDefault.default)
    }
};

},{"./components/container-element":"bBYj4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bBYj4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _element = require("@form-engine/core-application/components/element");
var _elementDefault = parcelHelpers.interopDefault(_element);
var _container = require("@form-engine/core-application/components/container");
var _containerDefault = parcelHelpers.interopDefault(_container);
const apiName = 'FormEngineContainerElement';
exports.default = Object.assign(function FormEngineContainerElement({ elementComponent = (0, _elementDefault.default), containerComponent: Container = (0, _containerDefault.default), id }) {
    const { state: { elements = [] } } = (0, _useForm.useFormContext)();
    const childElementIds = (0, _react.useMemo)(()=>elements.filter((element)=>element.parent === id).map((element)=>element.id), [
        elements,
        id
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Container, {
        id: id,
        childElementIds: childElementIds,
        elementComponent: elementComponent,
        containerComponent: Container
    });
}, {
    apiName,
    isField: false,
    isContainer: true,
    enabled: true
});

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-application/components/element":"dt2u8","@form-engine/core-application/components/container":"hxA8J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3xnp6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _textareaElement = require("./components/textarea-element");
var _textareaElementDefault = parcelHelpers.interopDefault(_textareaElement);
exports.default = {
    elements: {
        [(0, _textareaElementDefault.default).apiName]: (0, _textareaElementDefault.default)
    }
};

},{"./components/textarea-element":"jX5X1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jX5X1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _inputElement = require("@form-engine/element-input/components/input-element");
var _inputElementDefault = parcelHelpers.interopDefault(_inputElement);
var _useElement = require("@form-engine/core-application/hooks/use-element");
const apiName = 'FormEngineTextareaElement';
exports.default = Object.assign(function FormEngineTextareaElement(props) {
    const { state: element } = (0, _useElement.useFormEngineElement)();
    if (!element || element.type !== apiName) throw new Error('tried to render textarea with invalid definition');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputElementDefault.default), {
        ...props,
        as: "textarea",
        rows: element.rows || '2'
    });
}, {
    apiName,
    isField: true,
    enabled: true
});

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/element-input/components/input-element":"adGv3","@form-engine/core-application/hooks/use-element":"ehckF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6hOUU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _buttonElement = require("./components/button-element");
var _buttonElementDefault = parcelHelpers.interopDefault(_buttonElement);
exports.default = {
    elements: {
        [(0, _buttonElement.apiName)]: (0, _buttonElementDefault.default)
    }
};

},{"./components/button-element":"dSd6b","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dSd6b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BUTTON_ACTIONS", ()=>BUTTON_ACTIONS);
parcelHelpers.export(exports, "BUTTON_ACTIONS_LABELS", ()=>BUTTON_ACTIONS_LABELS);
parcelHelpers.export(exports, "apiName", ()=>apiName);
var _jsxRuntime = require("react/jsx-runtime");
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _useWorkflow = require("@form-engine/core-application/hooks/use-workflow");
var _useWorkflowDefault = parcelHelpers.interopDefault(_useWorkflow);
var _react = require("react");
var _reactBootstrap = require("react-bootstrap");
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _useElementDisabled = require("@form-engine/core-application/hooks/use-element-disabled");
var _useOnlineStatus = require("@form-engine/core-application/hooks/use-online-status");
var _useOnlineStatusDefault = parcelHelpers.interopDefault(_useOnlineStatus);
var _networkRequiredPopover = require("./button-element-popovers/network-required-popover");
var _networkRequiredPopoverDefault = parcelHelpers.interopDefault(_networkRequiredPopover);
const BUTTON_ACTIONS = {
    SUBMIT: 'submit',
    SHOW_PAGE: 'show-page',
    OPEN_URL: 'open-url',
    EMIT_EVENT: 'emit-event'
};
const BUTTON_ACTIONS_LABELS = {
    SUBMIT: 'Submit',
    SHOW_PAGE: 'Show Page',
    OPEN_URL: 'Open Url',
    EMIT_EVENT: 'Emit Signal'
};
const apiName = 'FormEngineButtonElement';
exports.default = Object.assign(function FormEngineButtonElement() {
    const { state: elementDefinition } = (0, _useElement.useFormEngineElement)();
    if (!elementDefinition || elementDefinition.type !== apiName) throw new Error('tried to render button with invalid definition');
    const { action, label, isBlock, variant, size, url, urlTarget, pageName, eventName, requireValid = false, requireOnline = true } = elementDefinition;
    const { state: session = {}, setItem: setSessionItem } = (0, _useFormsession.useFormSessionContext)();
    const { valid: pageValid, loading: pageElementsLoading } = (0, _useFormsession.useParentFormPageSession)();
    const { emit } = (0, _useWorkflowDefault.default)();
    const showNetworkRequiredFeedback = !(0, _useOnlineStatusDefault.default)() && requireOnline;
    const disabledByExpression = (0, _useElementDisabled.useFormEngineElementDisabled)();
    const disabled = (0, _react.useMemo)(()=>{
        if (disabledByExpression) return true;
        if (showNetworkRequiredFeedback) return true;
        if (pageElementsLoading.length) return true;
        if (!requireValid) return false;
        return !pageValid;
    }, [
        requireValid,
        showNetworkRequiredFeedback,
        pageValid,
        disabledByExpression,
        pageElementsLoading
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const actionProps = (0, _react.useMemo)(()=>{
        if (!action) return {
            type: 'submit'
        };
        switch(action){
            case BUTTON_ACTIONS.SUBMIT:
                return {
                    type: 'submit'
                };
            case BUTTON_ACTIONS.OPEN_URL:
                return {
                    as: 'a',
                    href: url ? url : undefined,
                    target: urlTarget ? urlTarget : undefined
                };
            case BUTTON_ACTIONS.SHOW_PAGE:
                return {
                    onClick: ()=>pageName && setSessionItem('currentPage', pageName)
                };
            case BUTTON_ACTIONS.EMIT_EVENT:
                return {
                    onClick: ()=>emit && eventName && emit(eventName)
                };
            default:
                console.warn(`${action} not implemented`);
        }
    }, [
        action,
        url,
        pageName,
        session,
        setSessionItem,
        emit
    ]);
    const { isSubmitting } = (0, _useWorkflowDefault.default)();
    const buttonRef = (0, _react.useRef)(undefined);
    const button = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
                ...actionProps,
                variant,
                size,
                disabled: disabled || isSubmitting,
                className: "fe-button",
                ref: buttonRef,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networkRequiredPopoverDefault.default), {
                show: showNetworkRequiredFeedback,
                target: buttonRef.current
            })
        ]
    });
    if (!isBlock) return button;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "d-grid gap-2 fe-button",
        children: button
    });
}, {
    apiName,
    isField: false,
    enabled: true
});

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/hooks/use-formsession":"2Th33","@form-engine/core-application/hooks/use-workflow":"guNxk","react":"9njXz","react-bootstrap":"f5rnA","@form-engine/core-application/hooks/use-element":"ehckF","@form-engine/core-application/hooks/use-element-disabled":"klZMn","@form-engine/core-application/hooks/use-online-status":"fbMjw","./button-element-popovers/network-required-popover":"9P5pE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fbMjw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useOnlineStatus);
var _react = require("react");
function getOnlineStatus() {
    return typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean' ? navigator.onLine : true;
}
function useOnlineStatus() {
    const [onlineStatus, setOnlineStatus] = (0, _react.useState)(getOnlineStatus());
    (0, _react.useEffect)(()=>{
        let mounted = true;
        const setOffline = ()=>mounted && setOnlineStatus(false);
        const setOnline = ()=>mounted && setOnlineStatus(true);
        window.addEventListener('online', setOnline);
        window.addEventListener('offline', setOffline);
        return ()=>{
            mounted = false;
            window.removeEventListener('online', setOnline);
            window.removeEventListener('offline', setOffline);
        };
    }, []);
    return onlineStatus;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9P5pE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FormEngineButtonElementNetworkRequiredPopover);
var _jsxRuntime = require("react/jsx-runtime");
var _basePopover = require("./base-popover");
var _index = require("@form-engine/core-application/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
function FormEngineButtonElementNetworkRequiredPopover({ children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _basePopover.FormEngineButtonElementBasePopover), {
        ...props,
        children: [
            (0, _indexDefault.default).i18n.c('button-element.network-required'),
            children
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","./base-popover":"an7Sb","@form-engine/core-application/index":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"an7Sb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormEngineButtonElementBasePopover", ()=>FormEngineButtonElementBasePopover);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _overlay = require("react-bootstrap/Overlay");
var _overlayDefault = parcelHelpers.interopDefault(_overlay);
var _popover = require("react-bootstrap/Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
function FormEngineButtonElementBasePopover({ target, show = false, placement = 'bottom', title, children }) {
    const containerRef = (0, _react.useRef)(null);
    if (!target) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: containerRef,
        className: "fe-button-popover-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overlayDefault.default), {
            show: show,
            target: target,
            placement: placement,
            container: containerRef,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _popoverDefault.default), {
                id: `popover-positioned-${placement}`,
                children: [
                    title && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverDefault.default).Header, {
                        as: "h3",
                        children: title
                    }),
                    children && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverDefault.default).Body, {
                        children: children
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap/Overlay":"cdIGB","react-bootstrap/Popover":"jhMQy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l84Uz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _selectElement = require("./components/select-element");
var _selectElementDefault = parcelHelpers.interopDefault(_selectElement);
exports.default = {
    elements: {
        [(0, _selectElementDefault.default).apiName]: (0, _selectElementDefault.default)
    }
};

},{"./components/select-element":"5KuU4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5KuU4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTROL_TYPES", ()=>CONTROL_TYPES);
parcelHelpers.export(exports, "apiName", ()=>apiName);
var _jsxRuntime = require("react/jsx-runtime");
var _coreApplication = require("@form-engine/core-application");
var _coreApplicationDefault = parcelHelpers.interopDefault(_coreApplication);
var _select = require("@form-engine/core-application/components/select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _useDatasource = require("@form-engine/core-application/hooks/use-datasource");
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _useElementDisabled = require("@form-engine/core-application/hooks/use-element-disabled");
var _useElementRequired = require("@form-engine/core-application/hooks/use-element-required");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _template = require("@form-engine/core-util/template");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
const CONTROL_TYPES = {
    NATIVE: 'native',
    ADVANCED: 'advanced'
};
const apiName = 'FormEngineSelectElement';
exports.default = Object.assign(function FormEngineSelectElement() {
    const { state: { showValidFeedback = true } } = (0, _useForm.useFormContext)();
    const { state: element } = (0, _useElement.useFormEngineElement)();
    if (!element || element.type !== apiName) throw new Error('tried to render select with invalid definition');
    const { name = '', label = '', floatingLabel = false, searchable = true, controlType = CONTROL_TYPES.NATIVE, showDefaultOption = false, defaultOptionLabel = (0, _coreApplicationDefault.default).i18n.c('select-element.default-option'), placeholder = (0, _coreApplicationDefault.default).i18n.c('select-element.default-option') } = element;
    const renderFloatingLabel = label && floatingLabel;
    const disabled = (0, _useElementDisabled.useFormEngineElementDisabled)();
    const { state: locals } = (0, _useFormsession.useFormSessionLocals)();
    const required = (0, _useElementRequired.useFormEngineElementRequired)();
    const [session, setSession] = (0, _useFormsession.useFormElementSession)();
    const handleChange = (0, _react.useCallback)((e)=>{
        const value = e.target.value;
        setSession({
            ...session,
            isTouched: true,
            value
        });
    }, [
        setSession,
        session
    ]);
    const datasourceResult = (0, _useDatasource.useFormElementDatasourceData)();
    let options = datasourceResult.options.map((option)=>{
        let label, value;
        if (Array.isArray(option)) [value, label] = option;
        else label = value = option;
        value = (0, _template.compile)(value || '', locals, '');
        label = (0, _template.compile)(label || value, locals, '');
        return {
            value,
            label
        };
    });
    // introduces an empty option on native selects, as a means to clear
    // optional values. on advanced selects, this is not needed
    if (controlType === CONTROL_TYPES.NATIVE && showDefaultOption) options = [
        {
            label: defaultOptionLabel,
            value: ''
        },
        ...options
    ];
    let control = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
        id: element.id,
        name: name,
        disabled: datasourceResult.loading || disabled,
        value: String(session.value ?? ''),
        onChange: handleChange,
        required: required,
        isValid: showValidFeedback && session.isTouched && !session.error,
        isInvalid: Boolean(session.isTouched && session.error),
        children: options.map(({ value, label }, key)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: value,
                children: label || value
            }, key);
        })
    });
    if (controlType === CONTROL_TYPES.ADVANCED) {
        // we only need feedback classes for react-select (CONTROL_TYPES.ADVANCED),
        // since react-bootstrap-component's select comes with that out of the box
        let feedbackClassNames;
        if (showValidFeedback && session.isTouched) feedbackClassNames = session.error ? 'is-invalid' : 'is-valid';
        control = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
            id: element.id,
            name: name,
            placeholder: placeholder,
            isDisabled: datasourceResult.loading || disabled,
            value: String(session.value ?? ''),
            onChange: handleChange,
            required: required,
            isInvalid: Boolean(session.isTouched && session.error),
            className: feedbackClassNames,
            options: options,
            isSearchable: searchable
        });
    }
    const error = session.isTouched && element.showError && session.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl).Feedback, {
        type: "invalid",
        tooltip: false,
        children: session.error
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormGroup), {
        className: "select-formgroup",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: renderFloatingLabel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FloatingLabel), {
                label: label,
                controlId: element.id,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(control.type, {
                            ...control.props,
                            id: undefined
                        }),
                        error
                    ]
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormLabel), {
                        htmlFor: element.id,
                        children: label
                    }),
                    control,
                    error
                ]
            })
        })
    });
}, {
    apiName,
    isField: true,
    enabled: true
});

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application":"fjN6J","@form-engine/core-application/components/select":"50UeV","@form-engine/core-application/hooks/use-datasource":"lz7AL","@form-engine/core-application/hooks/use-element":"ehckF","@form-engine/core-application/hooks/use-element-disabled":"klZMn","@form-engine/core-application/hooks/use-element-required":"cruGZ","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-application/hooks/use-formsession":"2Th33","@form-engine/core-util/template":"bKMue","react":"9njXz","react-bootstrap":"f5rnA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"50UeV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FormEngineFormSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _advanced = require("./advanced");
var _classNames = require("@form-engine/core-util/class-names");
var _classNamesDefault = parcelHelpers.interopDefault(_classNames);
function FormEngineFormSelect({ advanced, ...props }) {
    if (props.options || advanced) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _advanced.FormEngineAdvancedFormSelect), {
        ...props,
        className: (0, _classNamesDefault.default)('fe-core-select', props.className)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormSelect), {
        ...props
    });
}
FormEngineFormSelect.Advanced = (0, _advanced.FormEngineAdvancedFormSelect);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","./advanced":"ivs8x","@form-engine/core-util/class-names":"fk8HN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ivs8x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormEngineAdvancedFormSelectDropdownIndicator", ()=>FormEngineAdvancedFormSelectDropdownIndicator);
parcelHelpers.export(exports, "FormEngineAdvancedFormSelectClearIndicator", ()=>FormEngineAdvancedFormSelectClearIndicator);
parcelHelpers.export(exports, "FormEngineAdvancedFormSelect", ()=>FormEngineAdvancedFormSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _creatable = require("react-select/creatable");
var _creatableDefault = parcelHelpers.interopDefault(_creatable);
function FormEngineAdvancedFormSelectDropdownIndicator({ innerProps }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        ...innerProps,
        className: "fe-select__dropdown-indicator",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.CaretDown), {})
    });
}
function FormEngineAdvancedFormSelectClearIndicator({ innerProps }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        ...innerProps,
        className: "fe-select__clear-indicator",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.XLg), {})
    });
}
const FormEngineAdvancedFormSelect = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(({ children, options: optionsProp = [], value, className = 'fe-core-select', onChange, ...props }, ref)=>{
    const required = 'required' in props && props.required !== false;
    delete props.required;
    const creatable = 'creatable' in props && props.creatable !== false;
    delete props.creatable;
    const options = (0, _react.useMemo)(()=>{
        function traverse(items) {
            const result = [];
            for (const item of items){
                if (item.type === 'option') {
                    const option = {
                        ...item.props,
                        isOption: true,
                        label: String(item.props.label || item.props.children)
                    };
                    delete option.children;
                    result.push(option);
                } else if (item.type === 'optgroup') {
                    const group = {
                        ...item.props,
                        isGroup: true,
                        options: traverse(item.props.children)
                    };
                    delete group.children;
                    result.push(group);
                } else if (typeof item === 'object') result.push({
                    ...item,
                    isOption: true
                });
            }
            return result;
        }
        return traverse((0, _reactDefault.default).Children.count(children) ? (0, _reactDefault.default).Children.toArray(children) : optionsProp);
    }, [
        children,
        optionsProp
    ]);
    const currentOption = (0, _react.useMemo)(()=>{
        if (props.isMulti) return value;
        function traverse(items) {
            for (const item of items){
                if (item.isOption && item.value === value) return item;
                else if (item.isGroup) {
                    const subItem = traverse(item.options || []);
                    if (subItem) return subItem;
                }
            }
        }
        const result = traverse(options);
        // no value given or a viable option found for the value
        if (value === undefined || value === '' || result) return result;
        // given value does not exist in the options
        return {
            label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ExclamationSquareFill), {
                        className: "me-2"
                    }),
                    " ",
                    value
                ]
            })
        };
    }, [
        options,
        value,
        props.isMulti
    ]);
    const handleChange = (0, _react.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (optionOrOptions, actionMeta)=>{
        if (!onChange) return;
        if (props.isMulti) {
            onChange({
                target: {
                    value: optionOrOptions ?? []
                },
                actionMeta
            });
            return;
        }
        if (optionOrOptions) onChange({
            target: optionOrOptions,
            actionMeta
        });
        else onChange({
            target: {
                value: ''
            },
            actionMeta
        });
    }, [
        onChange,
        props
    ]);
    const Component = creatable ? (0, _creatableDefault.default) : (0, _reactSelectDefault.default);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        options: options,
        ...props,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ref: ref,
        value: currentOption,
        className: `fe-select ${className}`,
        classNamePrefix: `fe-select`,
        onChange: handleChange,
        isClearable: !required,
        components: {
            ClearIndicator: FormEngineAdvancedFormSelectClearIndicator
        }
    });
});
FormEngineAdvancedFormSelect.displayName = 'FormEngineAdvancedFormSelect';

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap-icons":"3TzoC","react-select":"j36cq","react-select/creatable":"hUPxg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j36cq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStateManager", ()=>(0, _useStateManager7E1E8489EsmJs.u));
parcelHelpers.export(exports, "createFilter", ()=>(0, _selectC7902D94EsmJs.c));
parcelHelpers.export(exports, "defaultTheme", ()=>(0, _selectC7902D94EsmJs.d));
parcelHelpers.export(exports, "mergeStyles", ()=>(0, _selectC7902D94EsmJs.m));
parcelHelpers.export(exports, "components", ()=>(0, _indexA301F526EsmJs.c));
parcelHelpers.export(exports, "NonceProvider", ()=>NonceProvider);
parcelHelpers.export(exports, "default", ()=>StateManagedSelect$1);
var _useStateManager7E1E8489EsmJs = require("./useStateManager-7e1e8489.esm.js");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _selectC7902D94EsmJs = require("./Select-c7902d94.esm.js");
var _react1 = require("@emotion/react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _indexA301F526EsmJs = require("./index-a301f526.esm.js");
var _objectSpread2 = require("@babel/runtime/helpers/objectSpread2");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _createClass = require("@babel/runtime/helpers/createClass");
var _inherits = require("@babel/runtime/helpers/inherits");
var _createSuper = require("@babel/runtime/helpers/createSuper");
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _memoizeOne = require("memoize-one");
var _typeof = require("@babel/runtime/helpers/typeof");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var StateManagedSelect = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, _useStateManager7E1E8489EsmJs.u)(props);
    return /*#__PURE__*/ _react.createElement((0, _selectC7902D94EsmJs.S), (0, _extendsDefault.default)({
        ref: ref
    }, baseSelectProps));
});
var StateManagedSelect$1 = StateManagedSelect;
var NonceProvider = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, _react.useMemo)(function() {
        return (0, _cacheDefault.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ _react.createElement((0, _react1.CacheProvider), {
        value: emotionCache
    }, children);
};

},{"./useStateManager-7e1e8489.esm.js":"DxpkG","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","./Select-c7902d94.esm.js":"5GiZu","@emotion/react":"lIeII","@emotion/cache":"r7hGp","./index-a301f526.esm.js":false,"@babel/runtime/helpers/objectSpread2":"TY7Mr","@babel/runtime/helpers/slicedToArray":"cSV7V","@babel/runtime/helpers/objectWithoutProperties":"5xa1i","@babel/runtime/helpers/classCallCheck":"6C9u8","@babel/runtime/helpers/createClass":"g9J5L","@babel/runtime/helpers/inherits":"43peb","@babel/runtime/helpers/createSuper":"ayUOk","@babel/runtime/helpers/toConsumableArray":"c2UGM","memoize-one":"jucOx","@babel/runtime/helpers/typeof":"979to","@babel/runtime/helpers/taggedTemplateLiteral":"cpSDa","@babel/runtime/helpers/defineProperty":"hjdoh","react-dom":"2ApDx","@floating-ui/dom":"4vfaI","use-isomorphic-layout-effect":"1Jrzu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"DxpkG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "u", ()=>useStateManager);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _react = require("react");
var _excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function useStateManager(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    var _useState = (0, _react.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, _react.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, _react.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, _slicedToArrayDefault.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, _react.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, _react.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, _react.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, _react.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

},{"@babel/runtime/helpers/esm/objectSpread2":"59BsR","@babel/runtime/helpers/esm/slicedToArray":"idCNq","@babel/runtime/helpers/esm/objectWithoutProperties":"aFSss","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59BsR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectSpread2);
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyJsDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

},{"./defineProperty.js":"5zOJa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5zOJa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(e, r, t) {
    return (r = (0, _toPropertyKeyJsDefault.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

},{"./toPropertyKey.js":"61Sn9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"61Sn9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"la19k","./toPrimitive.js":"cVPci","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"la19k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cVPci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"la19k","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"idCNq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_slicedToArray);
var _arrayWithHolesJs = require("./arrayWithHoles.js");
var _arrayWithHolesJsDefault = parcelHelpers.interopDefault(_arrayWithHolesJs);
var _iterableToArrayLimitJs = require("./iterableToArrayLimit.js");
var _iterableToArrayLimitJsDefault = parcelHelpers.interopDefault(_iterableToArrayLimitJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableRestJs = require("./nonIterableRest.js");
var _nonIterableRestJsDefault = parcelHelpers.interopDefault(_nonIterableRestJs);
function _slicedToArray(r, e) {
    return (0, _arrayWithHolesJsDefault.default)(r) || (0, _iterableToArrayLimitJsDefault.default)(r, e) || (0, _unsupportedIterableToArrayJsDefault.default)(r, e) || (0, _nonIterableRestJsDefault.default)();
}

},{"./arrayWithHoles.js":"81tIH","./iterableToArrayLimit.js":"8js8z","./unsupportedIterableToArray.js":"K5PcV","./nonIterableRest.js":"7uBRd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"81tIH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayWithHoles);
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8js8z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_iterableToArrayLimit);
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"K5PcV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_unsupportedIterableToArray);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, _arrayLikeToArrayJsDefault.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, _arrayLikeToArrayJsDefault.default)(r, a) : void 0;
    }
}

},{"./arrayLikeToArray.js":"enjjy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"enjjy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayLikeToArray);
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7uBRd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_nonIterableRest);
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aFSss":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutProperties);
var _objectWithoutPropertiesLooseJs = require("./objectWithoutPropertiesLoose.js");
var _objectWithoutPropertiesLooseJsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLooseJs);
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = (0, _objectWithoutPropertiesLooseJsDefault.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

},{"./objectWithoutPropertiesLoose.js":"jGdYV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5GiZu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>Select);
parcelHelpers.export(exports, "a", ()=>defaultProps);
parcelHelpers.export(exports, "b", ()=>getOptionLabel$1);
parcelHelpers.export(exports, "c", ()=>createFilter);
parcelHelpers.export(exports, "d", ()=>defaultTheme);
parcelHelpers.export(exports, "g", ()=>getOptionValue$1);
parcelHelpers.export(exports, "m", ()=>mergeStyles);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
var _indexA301F526EsmJs = require("./index-a301f526.esm.js");
var _react1 = require("@emotion/react");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var _ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var A11yText = function A11yText(props) {
    return (0, _react1.jsx)("span", (0, _extendsDefault.default)({
        css: _ref
    }, props));
};
var A11yText$1 = A11yText;
var defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, _react.useMemo)(function() {
        return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, _react.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, _objectSpread2Default.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, _react.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, _react.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, _react.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, _react1.jsx)((0, _react.Fragment), null, (0, _react1.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, _react1.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, _react1.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, _react1.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, _react1.jsx)((0, _react.Fragment), null, (0, _react1.jsx)(A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, _react1.jsx)(A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var LiveRegion$1 = LiveRegion;
var diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var anyDiacritic = new RegExp('[' + diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};
for(var i = 0; i < diacritics.length; i++){
    var diacritic = diacritics[i];
    for(var j = 0; j < diacritic.letters.length; j++)diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
var stripDiacritics = function stripDiacritics(str) {
    return str.replace(anyDiacritic, function(match) {
        return diacriticToBase[match];
    });
};
var memoizedStripDiacriticsForInput = (0, _memoizeOneDefault.default)(stripDiacritics);
var trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, _objectSpread2Default.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? trimString(rawInput) : rawInput;
        var candidate = trim ? trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = memoizedStripDiacriticsForInput(input);
            candidate = stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var _excluded = [
    "innerRef"
];
function DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, _indexA301F526EsmJs.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, _react1.jsx)("input", (0, _extendsDefault.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, _react1.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, _react.useRef)(false);
    var isTop = (0, _react.useRef)(false);
    var touchStart = (0, _react.useRef)(0);
    var scrollTarget = (0, _react.useRef)(null);
    var handleEventDelta = (0, _react.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, _react.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, _react.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, _react.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, _indexA301F526EsmJs.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function preventTouchMove(e) {
    e.preventDefault();
}
function allowTouchMove(e) {
    e.stopPropagation();
}
function preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
    capture: false,
    passive: false
};
function useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, _react.useRef)({});
    var scrollTarget = (0, _react.useRef)(null);
    var addScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys(LOCK_STYLES).forEach(function(key) {
                var val = LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', preventTouchMove, listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
                touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
            }
        }
        // increment active scroll locks
        activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && activeScrollLocks < 1) STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && isTouchDevice()) {
            target.removeEventListener('touchmove', preventTouchMove, listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var _ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, _react1.jsx)((0, _react.Fragment), null, lockEnabled && (0, _react1.jsx)("div", {
        onClick: blurSelectInput,
        css: _ref2$1
    }), children(targetRef));
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, _react1.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: _ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var RequiredInput$1 = RequiredInput;
/// <reference types="user-agent-data-types" />
function testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function isIPhone() {
    return testPlatform(/^iPhone/i);
}
function isMac() {
    return testPlatform(/^Mac/i);
}
function isIPad() {
    return testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
    return isIPhone() || isIPad();
}
function isAppleDevice() {
    return isMac() || isIOS();
}
var formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
    return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
    return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var defaultStyles = {
    clearIndicator: (0, _indexA301F526EsmJs.a),
    container: (0, _indexA301F526EsmJs.b),
    control: (0, _indexA301F526EsmJs.d),
    dropdownIndicator: (0, _indexA301F526EsmJs.e),
    group: (0, _indexA301F526EsmJs.g),
    groupHeading: (0, _indexA301F526EsmJs.f),
    indicatorsContainer: (0, _indexA301F526EsmJs.i),
    indicatorSeparator: (0, _indexA301F526EsmJs.h),
    input: (0, _indexA301F526EsmJs.j),
    loadingIndicator: (0, _indexA301F526EsmJs.l),
    loadingMessage: (0, _indexA301F526EsmJs.k),
    menu: (0, _indexA301F526EsmJs.m),
    menuList: (0, _indexA301F526EsmJs.n),
    menuPortal: (0, _indexA301F526EsmJs.o),
    multiValue: (0, _indexA301F526EsmJs.p),
    multiValueLabel: (0, _indexA301F526EsmJs.q),
    multiValueRemove: (0, _indexA301F526EsmJs.t),
    noOptionsMessage: (0, _indexA301F526EsmJs.u),
    option: (0, _indexA301F526EsmJs.v),
    placeholder: (0, _indexA301F526EsmJs.w),
    singleValue: (0, _indexA301F526EsmJs.x),
    valueContainer: (0, _indexA301F526EsmJs.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function mergeStyles(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, _objectSpread2Default.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var baseUnit = 4;
// The minimum height of the control
var controlHeight = 38;
// The amount of space between the control and menu */
var menuGutter = baseUnit * 2;
var spacing = {
    baseUnit: baseUnit,
    controlHeight: controlHeight,
    menuGutter: menuGutter
};
var defaultTheme = {
    borderRadius: borderRadius,
    colors: colors,
    spacing: spacing
};
var defaultProps = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, _indexA301F526EsmJs.z)(),
    captureMenuScroll: !(0, _indexA301F526EsmJs.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: createFilter(),
    formatGroupLabel: formatGroupLabel,
    getOptionLabel: getOptionLabel$1,
    getOptionValue: getOptionValue$1,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, _indexA301F526EsmJs.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = _isOptionDisabled(props, option, selectValue);
    var isSelected = _isOptionSelected(props, option, selectValue);
    var label = getOptionLabel(props, option);
    var value = getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, _indexA301F526EsmJs.K));
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, _toConsumableArrayDefault.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, _toConsumableArrayDefault.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptions(props, selectValue) {
    return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = getOptionValue(props, option);
    return selectValue.some(function(i) {
        return getOptionValue(props, i) === candidate;
    });
}
function _filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var instanceId = 1;
var Select = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(Select, _Component);
    var _super = (0, _createSuperDefault.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, _classCallCheckDefault.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, _indexA301F526EsmJs.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, _indexA301F526EsmJs.B)([].concat((0, _toConsumableArrayDefault.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, _indexA301F526EsmJs.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, _indexA301F526EsmJs.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, _indexA301F526EsmJs.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, _indexA301F526EsmJs.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, _indexA301F526EsmJs.D)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return buildFocusableOptionsWithIds(buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, _indexA301F526EsmJs.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, _indexA301F526EsmJs.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, _objectSpread2Default.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, _indexA301F526EsmJs.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
        _this.state.selectValue = (0, _indexA301F526EsmJs.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, _createClassDefault.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, _indexA301F526EsmJs.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, _indexA301F526EsmJs.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return defaultTheme;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme(defaultTheme);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, defaultTheme), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return _isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return _isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return _filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ _react.createElement(DummyInput, (0, _extendsDefault.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, _indexA301F526EsmJs.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ _react.createElement(Input, (0, _extendsDefault.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ _react.createElement(Placeholder, (0, _extendsDefault.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ _react.createElement(MultiValue, (0, _extendsDefault.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ _react.createElement(SingleValue, (0, _extendsDefault.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ _react.createElement(ClearIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ _react.createElement(LoadingIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ _react.createElement(IndicatorSeparator, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ _react.createElement(DropdownIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ _react.createElement(Option, (0, _extendsDefault.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ _react.createElement(Group, (0, _extendsDefault.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ _react.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ _react.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ _react.createElement((0, _indexA301F526EsmJs.M), (0, _extendsDefault.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ _react.createElement(Menu, (0, _extendsDefault.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ _react.createElement(ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ _react.createElement(MenuList, (0, _extendsDefault.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ _react.createElement(MenuPortal, (0, _extendsDefault.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ _react.createElement(RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ _react.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ _react.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ _react.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ _react.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ _react.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ _react.createElement(LiveRegion$1, (0, _extendsDefault.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ _react.createElement(SelectContainer, (0, _extendsDefault.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ _react.createElement(Control, (0, _extendsDefault.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ _react.createElement(ValueContainer, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ _react.createElement(IndicatorsContainer, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, _indexA301F526EsmJs.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? buildFocusableOptionsWithIds(buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, _indexA301F526EsmJs.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, _react.Component));
Select.defaultProps = defaultProps;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectSpread2":"59BsR","@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/toConsumableArray":"iT0h5","react":"9njXz","./index-a301f526.esm.js":"gYAEP","@emotion/react":"lIeII","memoize-one":"jucOx","@babel/runtime/helpers/esm/objectWithoutProperties":"aFSss","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chhAr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_classCallCheck);
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3gRhs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createClass);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, _toPropertyKeyJsDefault.default)(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

},{"./toPropertyKey.js":"61Sn9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6oM96":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inherits);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, _setPrototypeOfJsDefault.default)(t, e);
}

},{"./setPrototypeOf.js":"9UMxe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Qcqa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createSuper);
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
var _possibleConstructorReturnJs = require("./possibleConstructorReturn.js");
var _possibleConstructorReturnJsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnJs);
function _createSuper(t) {
    var r = (0, _isNativeReflectConstructJsDefault.default)();
    return function() {
        var e, o = (0, _getPrototypeOfJsDefault.default)(t);
        if (r) {
            var s = (0, _getPrototypeOfJsDefault.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, _possibleConstructorReturnJsDefault.default)(this, e);
    };
}

},{"./getPrototypeOf.js":"kxTHC","./isNativeReflectConstruct.js":"3xdRH","./possibleConstructorReturn.js":"gHSsV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kxTHC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_getPrototypeOf);
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3xdRH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeReflectConstruct);
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gHSsV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_possibleConstructorReturn);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _assertThisInitializedJs = require("./assertThisInitialized.js");
var _assertThisInitializedJsDefault = parcelHelpers.interopDefault(_assertThisInitializedJs);
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == (0, _typeofJsDefault.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, _assertThisInitializedJsDefault.default)(t);
}

},{"./typeof.js":"la19k","./assertThisInitialized.js":"jJtsr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jJtsr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iT0h5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_toConsumableArray);
var _arrayWithoutHolesJs = require("./arrayWithoutHoles.js");
var _arrayWithoutHolesJsDefault = parcelHelpers.interopDefault(_arrayWithoutHolesJs);
var _iterableToArrayJs = require("./iterableToArray.js");
var _iterableToArrayJsDefault = parcelHelpers.interopDefault(_iterableToArrayJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableSpreadJs = require("./nonIterableSpread.js");
var _nonIterableSpreadJsDefault = parcelHelpers.interopDefault(_nonIterableSpreadJs);
function _toConsumableArray(r) {
    return (0, _arrayWithoutHolesJsDefault.default)(r) || (0, _iterableToArrayJsDefault.default)(r) || (0, _unsupportedIterableToArrayJsDefault.default)(r) || (0, _nonIterableSpreadJsDefault.default)();
}

},{"./arrayWithoutHoles.js":"1M61l","./iterableToArray.js":"isHxT","./unsupportedIterableToArray.js":"K5PcV","./nonIterableSpread.js":"8TA3X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1M61l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayWithoutHoles);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return (0, _arrayLikeToArrayJsDefault.default)(r);
}

},{"./arrayLikeToArray.js":"enjjy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"isHxT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_iterableToArray);
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8TA3X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_nonIterableSpread);
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gYAEP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "A", ()=>isMobileDevice);
parcelHelpers.export(exports, "B", ()=>multiValueAsValue);
parcelHelpers.export(exports, "C", ()=>singleValueAsValue);
parcelHelpers.export(exports, "D", ()=>valueTernary);
parcelHelpers.export(exports, "E", ()=>classNames);
parcelHelpers.export(exports, "F", ()=>defaultComponents);
parcelHelpers.export(exports, "G", ()=>isDocumentElement);
parcelHelpers.export(exports, "H", ()=>cleanValue);
parcelHelpers.export(exports, "I", ()=>scrollIntoView);
parcelHelpers.export(exports, "J", ()=>noop);
parcelHelpers.export(exports, "K", ()=>notNullish);
parcelHelpers.export(exports, "L", ()=>handleInputChange);
parcelHelpers.export(exports, "M", ()=>MenuPlacer);
parcelHelpers.export(exports, "a", ()=>clearIndicatorCSS);
parcelHelpers.export(exports, "b", ()=>containerCSS);
parcelHelpers.export(exports, "c", ()=>components);
parcelHelpers.export(exports, "d", ()=>css$1);
parcelHelpers.export(exports, "e", ()=>dropdownIndicatorCSS);
parcelHelpers.export(exports, "f", ()=>groupHeadingCSS);
parcelHelpers.export(exports, "g", ()=>groupCSS);
parcelHelpers.export(exports, "h", ()=>indicatorSeparatorCSS);
parcelHelpers.export(exports, "i", ()=>indicatorsContainerCSS);
parcelHelpers.export(exports, "j", ()=>inputCSS);
parcelHelpers.export(exports, "k", ()=>loadingMessageCSS);
parcelHelpers.export(exports, "l", ()=>loadingIndicatorCSS);
parcelHelpers.export(exports, "m", ()=>menuCSS);
parcelHelpers.export(exports, "n", ()=>menuListCSS);
parcelHelpers.export(exports, "o", ()=>menuPortalCSS);
parcelHelpers.export(exports, "p", ()=>multiValueCSS);
parcelHelpers.export(exports, "q", ()=>multiValueLabelCSS);
parcelHelpers.export(exports, "r", ()=>removeProps);
parcelHelpers.export(exports, "s", ()=>supportsPassiveEvents);
parcelHelpers.export(exports, "t", ()=>multiValueRemoveCSS);
parcelHelpers.export(exports, "u", ()=>noOptionsMessageCSS);
parcelHelpers.export(exports, "v", ()=>optionCSS);
parcelHelpers.export(exports, "w", ()=>placeholderCSS);
parcelHelpers.export(exports, "x", ()=>css);
parcelHelpers.export(exports, "y", ()=>valueContainerCSS);
parcelHelpers.export(exports, "z", ()=>isTouchCapable);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _taggedTemplateLiteral = require("@babel/runtime/helpers/esm/taggedTemplateLiteral");
var _taggedTemplateLiteralDefault = parcelHelpers.interopDefault(_taggedTemplateLiteral);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react1 = require("react");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _useIsomorphicLayoutEffectDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffect);
var _excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function classNames(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat(applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var cleanValue = function cleanValue(value) {
    if (isArray(value)) return value.filter(Boolean);
    if ((0, _typeofDefault.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, _objectWithoutPropertiesDefault.default)(props, _excluded$4);
    return (0, _objectSpread2Default.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function normalizedHeight(el) {
    if (isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function getScrollTop(el) {
    if (isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if (isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
    var start = getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = easeOutCubic(currentTime, start, change, duration);
        scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
    get passive () {
        return passiveOptionAccessed = true;
    }
};
// check for SSR
var w = typeof window !== 'undefined' ? window : {};
if (w.addEventListener && w.removeEventListener) {
    w.addEventListener('p', noop, options);
    w.removeEventListener('p', noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
    return item != null;
}
function isArray(arg) {
    return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
    return singleValue;
}
function multiValueAsValue(multiValue) {
    return multiValue;
}
var removeProps = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, _slicedToArrayDefault.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, _slicedToArrayDefault.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var _excluded$3 = [
    "children",
    "innerProps"
], _excluded2$1 = [
    "children",
    "innerProps"
];
function getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
    var scrollTop = getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var menuCSS = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, _objectSpread2Default.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, _definePropertyDefault.default)(_objectSpread2, alignToControl(placement), '100%'), (0, _definePropertyDefault.default)(_objectSpread2, "position", 'absolute'), (0, _definePropertyDefault.default)(_objectSpread2, "width", '100%'), (0, _definePropertyDefault.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var PortalPlacementContext = /*#__PURE__*/ (0, _react1.createContext)(null);
// NOTE: internal only
var MenuPlacer = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, _react1.useContext)(PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, _react1.useRef)(null);
    var _useState = (0, _react1.useState)(maxMenuHeight), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, _react1.useState)(null), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, props), {}, {
            placement: placement || coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var Menu$1 = Menu;
// ==============================
// Menu List
// ==============================
var menuListCSS = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, _objectSpread2Default.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, _objectSpread2Default.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref6, _excluded$3);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref7, _excluded2$1);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var menuPortalCSS = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, _react1.useRef)(null);
    var cleanupRef = (0, _react1.useRef)(null);
    var _useState5 = (0, _react1.useState)(coercePlacement(menuPlacement)), _useState6 = (0, _slicedToArrayDefault.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, _react1.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, _react1.useState)(null), _useState8 = (0, _slicedToArrayDefault.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, _react1.useCallback)(function() {
        if (!controlElement) return;
        var rect = getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, _react1.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, _dom.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, _react1.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, _react.jsx)("div", (0, _extendsDefault.default)({
        ref: setMenuPortalElement
    }, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, _react.jsx)(PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, _reactDom.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var containerCSS = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var valueContainerCSS = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, _objectSpread2Default.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var indicatorsContainerCSS = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var _templateObject;
var _excluded$2 = [
    "size"
], _excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var _ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded$2);
    return (0, _react.jsx)("svg", (0, _extendsDefault.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: _ref2
    }, props));
};
var CrossIcon = function CrossIcon(props) {
    return (0, _react.jsx)(Svg, (0, _extendsDefault.default)({
        size: 20
    }, props), (0, _react.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var DownChevron = function DownChevron(props) {
    return (0, _react.jsx)(Svg, (0, _extendsDefault.default)({
        size: 20
    }, props), (0, _react.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, _react.jsx)(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, _react.jsx)(CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, _react.jsx)("span", (0, _extendsDefault.default)({}, innerProps, getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var loadingDotAnimations = (0, _react.keyframes)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralDefault.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, _objectSpread2Default.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, _react.jsx)("span", {
        css: /*#__PURE__*/ (0, _react.css)({
            animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref7, _excluded2);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, _react.jsx)(LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, _react.jsx)(LoadingDot, {
        delay: 160,
        offset: true
    }), (0, _react.jsx)(LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var css$1 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, _objectSpread2Default.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        ref: innerRef
    }, getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var Control$1 = Control;
var _excluded$1 = [
    "data"
];
var groupCSS = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, _react.jsx)(Heading, (0, _extendsDefault.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, _react.jsx)("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, _objectSpread2Default.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, _objectWithoutPropertiesDefault.default)(_cleanCommonProps, _excluded$1);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var Group$1 = Group;
var _excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var inputCSS = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, _objectSpread2Default.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, spacingStyle)
};
var inputStyle = function inputStyle(isHidden) {
    return (0, _objectSpread2Default.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, spacingStyle);
};
var Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, _objectWithoutPropertiesDefault.default)(_cleanCommonProps, _excluded);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, _react.jsx)("input", (0, _extendsDefault.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var Input$1 = Input;
var multiValueCSS = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, _objectSpread2Default.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, _objectSpread2Default.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, _react.jsx)("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        role: "button"
    }, innerProps), children || (0, _react.jsx)(CrossIcon, {
        size: 14
    }));
}
var MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, _react.jsx)(Container, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, _react.jsx)(Label, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)({}, getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, _react.jsx)(Remove, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var MultiValue$1 = MultiValue;
var optionCSS = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var Option$1 = Option;
var placeholderCSS = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var Placeholder$1 = Placeholder;
var css = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var SingleValue$1 = SingleValue;
var components = {
    ClearIndicator: ClearIndicator,
    Control: Control$1,
    DropdownIndicator: DropdownIndicator,
    DownChevron: DownChevron,
    CrossIcon: CrossIcon,
    Group: Group$1,
    GroupHeading: GroupHeading,
    IndicatorsContainer: IndicatorsContainer,
    IndicatorSeparator: IndicatorSeparator,
    Input: Input$1,
    LoadingIndicator: LoadingIndicator,
    Menu: Menu$1,
    MenuList: MenuList,
    MenuPortal: MenuPortal,
    LoadingMessage: LoadingMessage,
    NoOptionsMessage: NoOptionsMessage,
    MultiValue: MultiValue$1,
    MultiValueContainer: MultiValueContainer,
    MultiValueLabel: MultiValueLabel,
    MultiValueRemove: MultiValueRemove,
    Option: Option$1,
    Placeholder: Placeholder$1,
    SelectContainer: SelectContainer,
    SingleValue: SingleValue$1,
    ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, components), props.components);
};

},{"@babel/runtime/helpers/esm/objectSpread2":"59BsR","@babel/runtime/helpers/esm/extends":"aAOJb","@emotion/react":"lIeII","@babel/runtime/helpers/esm/slicedToArray":"idCNq","@babel/runtime/helpers/esm/objectWithoutProperties":"aFSss","@babel/runtime/helpers/esm/typeof":"la19k","@babel/runtime/helpers/esm/taggedTemplateLiteral":"fonV0","@babel/runtime/helpers/esm/defineProperty":"5zOJa","react":"9njXz","react-dom":"2ApDx","@floating-ui/dom":"4vfaI","use-isomorphic-layout-effect":"1Jrzu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fonV0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_taggedTemplateLiteral);
function _taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4vfaI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "autoUpdate", ()=>autoUpdate);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "platform", ()=>platform);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    const css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, _dom.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width,
        height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    const domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width, height, $ } = getCssDimensions(domElement);
    let x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x,
        y
    };
}
const noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    const win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, _dom.getWindow)(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = unwrapElement(element);
    let scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, _dom.getWindow)(domElement);
        const offsetWin = offsetParent && (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, _dom.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, _dom.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, _dom.getWindow)(currentIFrame);
            currentIFrame = (0, _dom.getFrameElement)(currentWin);
        }
    }
    return (0, _core.rectToClientRect)({
        width,
        height,
        x,
        y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
    const leftScroll = (0, _dom.getNodeScroll)(element).scrollLeft;
    if (!rect) return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x,
        y
    };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements, rect, offsetParent, strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, _dom.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, _utils.createCoords)(1);
    const offsets = (0, _utils.createCoords)(0);
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if ((0, _dom.isHTMLElement)(offsetParent)) {
            const offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : (0, _utils.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    const html = (0, _dom.getDocumentElement)(element);
    const scroll = (0, _dom.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === 'rtl') x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width,
        height,
        x,
        y
    };
}
function getViewportRect(element, strategy) {
    const win = (0, _dom.getWindow)(element);
    const html = (0, _dom.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, _dom.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width,
        height,
        x,
        y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, _dom.isHTMLElement)(element) ? getScale(element) : (0, _utils.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width,
        height,
        x,
        y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, _core.rectToClientRect)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, _dom.getParentNode)(element);
    if (parentNode === stopNode || !(0, _dom.isElement)(parentNode) || (0, _dom.isLastTraversableNode)(parentNode)) return false;
    return (0, _dom.getComputedStyle)(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, _dom.getOverflowAncestors)(element, [], false).filter((el)=>(0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, _dom.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, _dom.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, _dom.isOverflowElement)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    let { element, boundary, rootBoundary, strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, _dom.isTopLayer)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, _utils.max)(rect.top, accRect.top);
        accRect.right = (0, _utils.min)(rect.right, accRect.right);
        accRect.bottom = (0, _utils.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _utils.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function getDimensions(element) {
    const { width, height } = getCssDimensions(element);
    return {
        width,
        height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, _utils.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x,
        y,
        width: rect.width,
        height: rect.height
    };
}
function isStaticPositioned(element) {
    return (0, _dom.getComputedStyle)(element).position === 'static';
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, _dom.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    const win = (0, _dom.getWindow)(element);
    if ((0, _dom.isTopLayer)(element)) return win;
    if (!(0, _dom.isHTMLElement)(element)) {
        let svgOffsetParent = (0, _dom.getParentNode)(element);
        while(svgOffsetParent && !(0, _dom.isLastTraversableNode)(svgOffsetParent)){
            if ((0, _dom.isElement)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, _dom.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, _dom.isLastTraversableNode)(offsetParent) && isStaticPositioned(offsetParent) && !(0, _dom.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, _dom.getContainingBlock)(element) || win;
}
const getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === 'rtl';
}
const platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect,
    getOffsetParent,
    getElementRects,
    getClientRects,
    getDimensions,
    getScale,
    isElement: (0, _dom.isElement),
    isRTL
};
function rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left, top, width, height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, _utils.floor)(top);
        const insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, _utils.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === 'function', layoutShift = typeof IntersectionObserver === 'function', animationFrame = false } = options;
    const referenceEl = unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : [],
        ...(0, _dom.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const detectOverflow = (0, _core.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = (0, _core.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = (0, _core.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = (0, _core.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = (0, _core.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = (0, _core.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = (0, _core.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (0, _core.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = (0, _core.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = (0, _core.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const computePosition = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, _core.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

},{"@floating-ui/core":"jiGLa","@floating-ui/utils":"4C4fb","@floating-ui/utils/dom":"ctIgS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jiGLa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", ()=>(0, _utils.rectToClientRect));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference, floating } = _ref;
    const sideAxis = (0, _utils.getSideAxis)(placement);
    const alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    const alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    const side = (0, _utils.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, _utils.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const computePosition = async (reference, floating, config)=>{
    const { placement = 'bottom', strategy = 'absolute', middleware = [], platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference,
        floating,
        strategy
    });
    let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name, fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data, reset } = await fn({
            x,
            y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy,
            middlewareData,
            rects,
            platform,
            elements: {
                reference,
                floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference,
                    floating,
                    strategy
                }) : reset.rects;
                ({ x, y } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x,
        y,
        placement: statefulPlacement,
        strategy,
        middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x, y, platform, rects, elements, strategy } = state;
    const { boundary = 'clippingAncestors', rootBoundary = 'viewport', elementContext = 'floating', altBoundary = false, padding = 0 } = (0, _utils.evaluate)(options, state);
    const paddingObject = (0, _utils.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, _utils.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary,
        rootBoundary,
        strategy
    }));
    const rect = elementContext === 'floating' ? {
        x,
        y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, _utils.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements,
        rect,
        offsetParent,
        strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options)=>({
        name: 'arrow',
        options,
        async fn (state) {
            const { x, y, placement, rects, platform, elements, middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element, padding = 0 } = (0, _utils.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            const coords = {
                x,
                y
            };
            const axis = (0, _utils.getAlignmentAxis)(placement);
            const length = (0, _utils.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, _utils.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, _utils.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects, middlewareData, placement, platform, elements } = state;
            const { crossAxis = false, alignment, allowedPlacements = (0, _utils.placements), autoAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, _utils.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, _utils.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, _utils.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement, middlewareData, rects, initialPlacement, platform, elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy = 'bestFit', fallbackAxisSideDirection = 'none', flipAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, _utils.getSide)(placement);
            const initialSideAxis = (0, _utils.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, _utils.getOppositePlacement)(initialPlacement)
            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement,
                    overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, _utils.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options,
        async fn (state) {
            const { rects } = state;
            const { strategy = 'referenceHidden', ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function getBoundingRect(rects) {
    const minX = (0, _utils.min)(...rects.map((rect)=>rect.left));
    const minY = (0, _utils.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, _utils.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, _utils.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, _utils.rectToClientRect)(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options,
        async fn (state) {
            const { placement, elements, rects, platform, strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding = 2, x, y } = (0, _utils.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = getRectsByLine(nativeClientRects);
            const fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, _utils.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, _utils.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top,
                            bottom,
                            left,
                            right,
                            width,
                            height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, _utils.getSide)(placement) === 'left';
                    const maxRight = (0, _utils.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, _utils.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top,
                        bottom,
                        left,
                        right,
                        width,
                        height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect
                },
                floating: elements.floating,
                strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
    const { placement, platform, elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, _utils.getSide)(placement);
    const alignment = (0, _utils.getAlignment)(placement);
    const isVertical = (0, _utils.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, _utils.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x, y, placement, middlewareData } = state;
            const diffCoords = await convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options,
        async fn (state) {
            const { x, y, placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter = {
                fn: (_ref)=>{
                    let { x, y } = _ref;
                    return {
                        x,
                        y
                    };
                }
            }, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, _utils.getSideAxis)((0, _utils.getSide)(placement));
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, _utils.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, _utils.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = function(options) {
    if (options === void 0) options = {};
    return {
        options,
        fn (state) {
            const { x, y, placement, rects, middlewareData } = state;
            const { offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const crossAxis = (0, _utils.getSideAxis)(placement);
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, _utils.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, _utils.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement, rects, platform, elements } = state;
            const { apply = ()=>{}, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const side = (0, _utils.getSide)(placement);
            const alignment = (0, _utils.getAlignment)(placement);
            const isYAxis = (0, _utils.getSideAxis)(placement) === 'y';
            const { width, height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, _utils.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, _utils.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, _utils.max)(overflow.left, 0);
                const xMax = (0, _utils.max)(overflow.right, 0);
                const yMin = (0, _utils.max)(overflow.top, 0);
                const yMax = (0, _utils.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, _utils.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, _utils.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth,
                availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

},{"@floating-ui/utils":"4C4fb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4C4fb":[function(require,module,exports,__globalThis) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", ()=>alignments);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "createCoords", ()=>createCoords);
parcelHelpers.export(exports, "evaluate", ()=>evaluate);
parcelHelpers.export(exports, "expandPaddingObject", ()=>expandPaddingObject);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "getAlignment", ()=>getAlignment);
parcelHelpers.export(exports, "getAlignmentAxis", ()=>getAlignmentAxis);
parcelHelpers.export(exports, "getAlignmentSides", ()=>getAlignmentSides);
parcelHelpers.export(exports, "getAxisLength", ()=>getAxisLength);
parcelHelpers.export(exports, "getExpandedPlacements", ()=>getExpandedPlacements);
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", ()=>getOppositeAlignmentPlacement);
parcelHelpers.export(exports, "getOppositeAxis", ()=>getOppositeAxis);
parcelHelpers.export(exports, "getOppositeAxisPlacements", ()=>getOppositeAxisPlacements);
parcelHelpers.export(exports, "getOppositePlacement", ()=>getOppositePlacement);
parcelHelpers.export(exports, "getPaddingObject", ()=>getPaddingObject);
parcelHelpers.export(exports, "getSide", ()=>getSide);
parcelHelpers.export(exports, "getSideAxis", ()=>getSideAxis);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "rectToClientRect", ()=>rectToClientRect);
parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "sides", ()=>sides);
const sides = [
    'top',
    'right',
    'bottom',
    'left'
];
const alignments = [
    'start',
    'end'
];
const placements = /*#__PURE__*/ sides.reduce((acc, side)=>acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v)=>({
        x: v,
        y: v
    });
const oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
    return placement.split('-')[0];
}
function getAlignment(placement) {
    return placement.split('-')[1];
}
function getOppositeAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
    return [
        'top',
        'bottom'
    ].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = getAlignment(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const length = getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    const oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = getAlignment(placement);
    let list = getSideList(getSide(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function getPaddingObject(padding) {
    return typeof padding !== 'number' ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    const { x, y, width, height } = rect;
    return {
        width,
        height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x,
        y
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ctIgS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
parcelHelpers.export(exports, "getContainingBlock", ()=>getContainingBlock);
parcelHelpers.export(exports, "getDocumentElement", ()=>getDocumentElement);
parcelHelpers.export(exports, "getFrameElement", ()=>getFrameElement);
parcelHelpers.export(exports, "getNearestOverflowAncestor", ()=>getNearestOverflowAncestor);
parcelHelpers.export(exports, "getNodeName", ()=>getNodeName);
parcelHelpers.export(exports, "getNodeScroll", ()=>getNodeScroll);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>getOverflowAncestors);
parcelHelpers.export(exports, "getParentNode", ()=>getParentNode);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "isContainingBlock", ()=>isContainingBlock);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isLastTraversableNode", ()=>isLastTraversableNode);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isOverflowElement", ()=>isOverflowElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
parcelHelpers.export(exports, "isTableElement", ()=>isTableElement);
parcelHelpers.export(exports, "isTopLayer", ()=>isTopLayer);
parcelHelpers.export(exports, "isWebKit", ()=>isWebKit);
function hasWindow() {
    return typeof window !== 'undefined';
}
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    if (!hasWindow()) return false;
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    if (!hasWindow()) return false;
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    if (!hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    if (!hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
    const { overflow, overflowX, overflowY, display } = getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].includes(getNodeName(element));
}
function isTopLayer(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function isContainingBlock(elementOrCss) {
    const webkit = isWebKit();
    const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function getContainingBlock(element) {
    let currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else if (isTopLayer(currentNode)) return null;
        currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function getParentNode(node) {
    if (getNodeName(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    const parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = getWindow(scrollableAncestor);
    if (isBody) {
        const frameElement = getFrameElement(win);
        return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
    }
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Jrzu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index);
var _react = require("react");
var index = (0, _react.useLayoutEffect);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jucOx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoizeOne);
var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function isEqual(first, second) {
    if (first === second) return true;
    if (safeIsNaN(first) && safeIsNaN(second)) return true;
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"TY7Mr":[function(require,module,exports,__globalThis) {
var defineProperty = require("818faec3224b1d63");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"818faec3224b1d63":"hjdoh"}],"hjdoh":[function(require,module,exports,__globalThis) {
var toPropertyKey = require("29ac19868e7f119");
function _defineProperty(e, r, t) {
    return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"29ac19868e7f119":"6uI3m"}],"6uI3m":[function(require,module,exports,__globalThis) {
var _typeof = require("a14bd529aa4ac1cd")["default"];
var toPrimitive = require("2713647ce51d8c75");
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a14bd529aa4ac1cd":"979to","2713647ce51d8c75":"3Msou"}],"979to":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"3Msou":[function(require,module,exports,__globalThis) {
var _typeof = require("e0211298897b2d31")["default"];
function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"e0211298897b2d31":"979to"}],"cSV7V":[function(require,module,exports,__globalThis) {
var arrayWithHoles = require("a3af206dbd14b1b5");
var iterableToArrayLimit = require("c109e0e3b1a7ef05");
var unsupportedIterableToArray = require("6782568c4383bd49");
var nonIterableRest = require("1e06d43f4bd6e532");
function _slicedToArray(r, e) {
    return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a3af206dbd14b1b5":"1GvOn","c109e0e3b1a7ef05":"5o08D","6782568c4383bd49":"4zHVJ","1e06d43f4bd6e532":"aSebZ"}],"1GvOn":[function(require,module,exports,__globalThis) {
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"5o08D":[function(require,module,exports,__globalThis) {
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"4zHVJ":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("f8ccc0353f5f3746");
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
    }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f8ccc0353f5f3746":"1AicQ"}],"1AicQ":[function(require,module,exports,__globalThis) {
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"aSebZ":[function(require,module,exports,__globalThis) {
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"5xa1i":[function(require,module,exports,__globalThis) {
var objectWithoutPropertiesLoose = require("424c8dc91f0a14f9");
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"424c8dc91f0a14f9":"imPRm"}],"imPRm":[function(require,module,exports,__globalThis) {
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"6C9u8":[function(require,module,exports,__globalThis) {
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"g9J5L":[function(require,module,exports,__globalThis) {
var toPropertyKey = require("b03a9e1e96a7e901");
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b03a9e1e96a7e901":"6uI3m"}],"43peb":[function(require,module,exports,__globalThis) {
var setPrototypeOf = require("f41396146170672b");
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && setPrototypeOf(t, e);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f41396146170672b":"iyNOR"}],"iyNOR":[function(require,module,exports,__globalThis) {
function _setPrototypeOf(t, e) {
    return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"ayUOk":[function(require,module,exports,__globalThis) {
var getPrototypeOf = require("b241ea01e2bf5861");
var isNativeReflectConstruct = require("35b08a444265bcf9");
var possibleConstructorReturn = require("d50bbe07b7bb3622");
function _createSuper(t) {
    var r = isNativeReflectConstruct();
    return function() {
        var e, o = getPrototypeOf(t);
        if (r) {
            var s = getPrototypeOf(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return possibleConstructorReturn(this, e);
    };
}
module.exports = _createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b241ea01e2bf5861":"CaUfL","35b08a444265bcf9":"4whD7","d50bbe07b7bb3622":"2pp8P"}],"CaUfL":[function(require,module,exports,__globalThis) {
function _getPrototypeOf(t) {
    return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"4whD7":[function(require,module,exports,__globalThis) {
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = _isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"2pp8P":[function(require,module,exports,__globalThis) {
var _typeof = require("52fa942c15a57b36")["default"];
var assertThisInitialized = require("ca3744a9acc8b6f9");
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return assertThisInitialized(t);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"52fa942c15a57b36":"979to","ca3744a9acc8b6f9":"f0luE"}],"f0luE":[function(require,module,exports,__globalThis) {
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"c2UGM":[function(require,module,exports,__globalThis) {
var arrayWithoutHoles = require("80b438c8f11ca70e");
var iterableToArray = require("4f1268a27b81f1fd");
var unsupportedIterableToArray = require("bfa7725fe5f724b");
var nonIterableSpread = require("24ae2b6222a85da6");
function _toConsumableArray(r) {
    return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"80b438c8f11ca70e":"aOlvk","4f1268a27b81f1fd":"1KRMO","bfa7725fe5f724b":"4zHVJ","24ae2b6222a85da6":"jdiaX"}],"aOlvk":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("d3a23041cb0f1512");
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"d3a23041cb0f1512":"1AicQ"}],"1KRMO":[function(require,module,exports,__globalThis) {
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"jdiaX":[function(require,module,exports,__globalThis) {
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"cpSDa":[function(require,module,exports,__globalThis) {
function _taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = _taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"hUPxg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCreatable", ()=>(0, _useCreatableBf6Ebe1FEsmJs.u));
parcelHelpers.export(exports, "default", ()=>CreatableSelect$1);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _selectC7902D94EsmJs = require("../../dist/Select-c7902d94.esm.js");
var _useStateManager7E1E8489EsmJs = require("../../dist/useStateManager-7e1e8489.esm.js");
var _useCreatableBf6Ebe1FEsmJs = require("../../dist/useCreatable-bf6ebe1f.esm.js");
var _objectSpread2 = require("@babel/runtime/helpers/objectSpread2");
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _createClass = require("@babel/runtime/helpers/createClass");
var _inherits = require("@babel/runtime/helpers/inherits");
var _createSuper = require("@babel/runtime/helpers/createSuper");
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _indexA301F526EsmJs = require("../../dist/index-a301f526.esm.js");
var _react1 = require("@emotion/react");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _typeof = require("@babel/runtime/helpers/typeof");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _memoizeOne = require("memoize-one");
var CreatableSelect = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var creatableProps = (0, _useStateManager7E1E8489EsmJs.u)(props);
    var selectProps = (0, _useCreatableBf6Ebe1FEsmJs.u)(creatableProps);
    return /*#__PURE__*/ _react.createElement((0, _selectC7902D94EsmJs.S), (0, _extendsDefault.default)({
        ref: ref
    }, selectProps));
});
var CreatableSelect$1 = CreatableSelect;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","../../dist/Select-c7902d94.esm.js":"5GiZu","../../dist/useStateManager-7e1e8489.esm.js":"DxpkG","../../dist/useCreatable-bf6ebe1f.esm.js":"ikKaV","@babel/runtime/helpers/objectSpread2":"TY7Mr","@babel/runtime/helpers/classCallCheck":"6C9u8","@babel/runtime/helpers/createClass":"g9J5L","@babel/runtime/helpers/inherits":"43peb","@babel/runtime/helpers/createSuper":"ayUOk","@babel/runtime/helpers/toConsumableArray":"c2UGM","../../dist/index-a301f526.esm.js":"gYAEP","@emotion/react":"lIeII","@babel/runtime/helpers/slicedToArray":"cSV7V","@babel/runtime/helpers/objectWithoutProperties":"5xa1i","@babel/runtime/helpers/typeof":"979to","@babel/runtime/helpers/taggedTemplateLiteral":"cpSDa","@babel/runtime/helpers/defineProperty":"hjdoh","react-dom":"2ApDx","@floating-ui/dom":"4vfaI","use-isomorphic-layout-effect":"1Jrzu","memoize-one":"jucOx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ikKaV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "u", ()=>useCreatable);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _react = require("react");
var _indexA301F526EsmJs = require("./index-a301f526.esm.js");
var _selectC7902D94EsmJs = require("./Select-c7902d94.esm.js");
var _excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function useCreatable(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, _selectC7902D94EsmJs.g) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, _selectC7902D94EsmJs.b) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, _react.useMemo)(function() {
        return isValidNewOption(inputValue, (0, _indexA301F526EsmJs.H)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, _react.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption
        ].concat((0, _toConsumableArrayDefault.default)(propsOptions)) : [].concat((0, _toConsumableArrayDefault.default)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, _react.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, _indexA301F526EsmJs.D)(isMulti, [].concat((0, _toConsumableArrayDefault.default)((0, _indexA301F526EsmJs.H)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}

},{"@babel/runtime/helpers/esm/objectSpread2":"59BsR","@babel/runtime/helpers/esm/toConsumableArray":"iT0h5","@babel/runtime/helpers/esm/objectWithoutProperties":"aFSss","react":"9njXz","./index-a301f526.esm.js":"gYAEP","./Select-c7902d94.esm.js":"5GiZu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dqVBT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _redirect = require("./workflow-layers/redirect");
var _redirectDefault = parcelHelpers.interopDefault(_redirect);
exports.default = {
    workflowLayers: {
        [(0, _redirectDefault.default).apiName]: (0, _redirectDefault.default)
    }
};

},{"./workflow-layers/redirect":"lL6q3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lL6q3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
var _coreApplication = require("@form-engine/core-application");
var _coreApplicationDefault = parcelHelpers.interopDefault(_coreApplication);
var _template = require("@form-engine/core-util/template");
var _formSession = require("@form-engine/core-application/utilities/form-session");
/**
 * this is needed because the ts typechecker incorrectly errors TS2352 otherwise
 * @see https://caniuse.com/?search=canparse
 */ const { canParse } = URL;
function FormEngineRedirectWfl({ form, session, definition }) {
    if (definition.type !== apiName) throw new Error('invalid workflow definition');
    const response = Promise.resolve({
        ...session
    });
    if (!definition.url) return response;
    let url = (0, _template.compile)(definition.url, (0, _formSession.getFormSessionLocals)(form, session));
    const { origin } = new URL(document.baseURI);
    if (!/^https?:\/\//i.test(url)) url = `${origin}${url}`;
    let valid = false;
    if (!definition.allowForeignOrigins) {
        if (canParse(url)) valid = new URL(url).origin === origin;
    } else valid = true;
    if (valid) window.open(url, (0, _coreApplicationDefault.default).isBuilder ? '_blank' : definition.urlTarget ?? '_self');
    else console?.error(`redirect url ${url} is forbidden`);
    return response;
}
const apiName = FormEngineRedirectWfl.apiName = 'FormEngineRedirectWfl';
exports.default = FormEngineRedirectWfl;

},{"@form-engine/core-application":"fjN6J","@form-engine/core-util/template":"bKMue","@form-engine/core-application/utilities/form-session":"do3Fv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eqeBK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _condition = require("./workflow-layers/condition");
var _conditionDefault = parcelHelpers.interopDefault(_condition);
exports.default = {
    workflowLayers: {
        [(0, _condition.apiName)]: (0, _conditionDefault.default)
    }
};

},{"./workflow-layers/condition":"5TQMg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5TQMg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
var _formSession = require("@form-engine/core-application/utilities/form-session");
var _expressions = require("@form-engine/core-util/expressions");
async function FormEngineConditionWfl({ session, definition, form }) {
    if (definition.expressions) {
        const locals = (0, _formSession.getFormSessionLocals)(form, session);
        const result = Boolean((0, _expressions.evalExpressions)(definition.expressions, locals));
        if (!result) return Promise.reject(new Error('expression not met'));
    }
    return Promise.resolve({
        ...session
    });
}
const apiName = 'FormEngineConditionWfl';
FormEngineConditionWfl.apiName = apiName;
exports.default = FormEngineConditionWfl;

},{"@form-engine/core-application/utilities/form-session":"do3Fv","@form-engine/core-util/expressions":"ayzLO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3yTRY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _signal = require("./workflow-layers/signal");
var _signalDefault = parcelHelpers.interopDefault(_signal);
exports.default = {
    workflowLayers: {
        [(0, _signal.apiName)]: (0, _signalDefault.default)
    }
};

},{"./workflow-layers/signal":"abcXP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"abcXP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
function FormEngineSignalWfl({ session }) {
    return Promise.resolve({
        ...session
    });
}
const apiName = FormEngineSignalWfl.apiName = 'FormEngineSignalWfl';
exports.default = FormEngineSignalWfl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67smr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setter = require("./workflow-layers/setter");
var _setterDefault = parcelHelpers.interopDefault(_setter);
exports.default = {
    workflowLayers: {
        [(0, _setter.apiName)]: (0, _setterDefault.default)
    }
};

},{"./workflow-layers/setter":"iC4Ck","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iC4Ck":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _formSession = require("@form-engine/core-application/utilities/form-session");
var _createObject = require("@form-engine/core-util/create-object");
var _template = require("@form-engine/core-util/template");
async function FormEngineSetterWfl({ session, definition, form }) {
    if (definition.type !== apiName) throw new Error('invalid workflow definition');
    const sessionUpdate = {
        ...session
    };
    if (definition.assignments) {
        const locals = (0, _formSession.getFormSessionLocals)(form, sessionUpdate);
        const map = (0, _createObject.compileObject)(definition.assignments, locals);
        Object.entries(map).forEach(([key, value])=>{
            key = (0, _template.compile)(key, locals);
            if (key.startsWith('values.')) (0, _useFormsession.setFormElementValueByName)(form, sessionUpdate, key.slice(7), value);
            else {
                sessionUpdate.locals ??= {};
                sessionUpdate.locals[key] = value;
            }
        });
    }
    return Promise.resolve(sessionUpdate);
}
const apiName = FormEngineSetterWfl.apiName = 'FormEngineSetterWfl';
exports.default = FormEngineSetterWfl;

},{"@form-engine/core-application/hooks/use-formsession":"2Th33","@form-engine/core-application/utilities/form-session":"do3Fv","@form-engine/core-util/create-object":"dBL9S","@form-engine/core-util/template":"bKMue","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dBL9S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createObject", ()=>createObject);
parcelHelpers.export(exports, "useObjectDefaults", ()=>useObjectDefaults);
parcelHelpers.export(exports, "compileObject", ()=>compileObject);
var _react = require("react");
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _template = require("./template");
function createObject(defaults, ...overrides) {
    return (0, _mergeDefault.default)({}, defaults, ...overrides);
}
function useObjectDefaults(defaults, ...overrides) {
    return (0, _react.useMemo)(()=>createObject(defaults, ...overrides), [
        defaults,
        ...overrides
    ]);
}
function compileObject(objectDefinition, locals) {
    const result = {};
    for (const { key, value, type } of objectDefinition){
        const compiled = typeof value === 'string' ? (0, _template.compile)(value, locals, '') : '';
        const sanitized = String(compiled ?? '').trim();
        switch(type){
            case 'json':
                try {
                    result[key] = JSON.parse(sanitized);
                } catch  {
                    console?.warn(`could not parse ${key}`);
                }
                break;
            case 'string':
                if (sanitized !== '') result[key] = sanitized;
                break;
            case 'raw-string':
                result[key] = compiled;
                break;
            case 'boolean':
                try {
                    result[key] = Boolean(JSON.parse(sanitized));
                } catch  {
                    result[key] = false;
                }
                break;
            case 'number':
                result[key] = Number(sanitized);
                if (isNaN(result[key])) result[key] = 0;
                break;
            default:
                throw new Error(`unknown type ${type}`);
        }
    }
    return result;
}

},{"react":"9njXz","lodash/merge":"iHC1F","./template":"bKMue","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fD5Uk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _client = require("./workflow-layers/http-request/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
exports.default = {
    workflowLayers: {
        [(0, _clientDefault.default).apiName]: (0, _clientDefault.default)
    }
};

},{"./workflow-layers/http-request/client":"EYNdn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"EYNdn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchBackend = require("@form-engine/core-application/workflow-layers/fetch-backend");
var _fetchBackendDefault = parcelHelpers.interopDefault(_fetchBackend);
var _ = require(".");
var _fetchBackend1 = require("@form-engine/core-util/fetch-backend");
var _useWorkflow = require("@form-engine/core-application/hooks/use-workflow");
async function FormEngineHttpRequestWfl({ form, session, definition }) {
    if (!form?.id) throw new Error('tried to invoke workflow layer with incomplete form definition');
    if (definition.type !== (0, _.apiName)) throw new Error(`invalid workflow definition`);
    let sessionUpdate;
    try {
        sessionUpdate = await (0, _fetchBackendDefault.default)(form.id, definition.id, session);
        return sessionUpdate;
    } catch (e) {
        const { storeErrorAs } = definition;
        if (e instanceof (0, _fetchBackend1.FetchBackendError)) throw new (0, _useWorkflow.WorkflowError)(e.message, storeErrorAs ? {
            locals: {
                [storeErrorAs]: e.toJSON()
            }
        } : {});
        throw e;
    }
}
FormEngineHttpRequestWfl.apiName = (0, _.apiName);
exports.default = FormEngineHttpRequestWfl;

},{"@form-engine/core-application/workflow-layers/fetch-backend":"cKMex",".":"8mMZ5","@form-engine/core-util/fetch-backend":"iZ0XX","@form-engine/core-application/hooks/use-workflow":"guNxk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cKMex":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>fetchWflBackend);
var _fetchBackend = require("@form-engine/core-util/fetch-backend");
var _fetchBackendDefault = parcelHelpers.interopDefault(_fetchBackend);
var _index = require("@form-engine/core-application/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
async function fetchWflBackend(formId, wflId, session, data, options = {}) {
    const path = (0, _indexDefault.default).wflBackendRoute.replace(':formId', formId).replace(':wflId', wflId);
    return (0, _fetchBackendDefault.default)(path, session, data, options) || {};
}

},{"@form-engine/core-util/fetch-backend":"iZ0XX","@form-engine/core-application/index":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8mMZ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
const apiName = 'FormEngineHttpRequestWfl';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7KCVE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _sessionLog = require("./workflow-layers/session-log");
var _client = require("./workflow-layers/session-log/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
exports.default = {
    workflowLayers: {
        [(0, _sessionLog.apiName)]: (0, _clientDefault.default)
    }
};

},{"./workflow-layers/session-log":"icEoh","./workflow-layers/session-log/client":"3JoJN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"icEoh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
const apiName = 'FormEngineSessionLogWfl';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3JoJN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchBackend = require("@form-engine/core-application/workflow-layers/fetch-backend");
var _fetchBackendDefault = parcelHelpers.interopDefault(_fetchBackend);
var _ = require(".");
async function FormEngineSessionLogWfl({ form, session, definition }) {
    if (definition.type !== (0, _.apiName)) throw new Error('invalid workflow definition');
    if (!form?.id) throw new Error('tried to invoke workflow layer with incomplete form definition');
    const sessionUpdate = await (0, _fetchBackendDefault.default)(form.id, definition.id, session);
    return sessionUpdate;
}
FormEngineSessionLogWfl.apiName = (0, _.apiName);
exports.default = FormEngineSessionLogWfl;

},{"@form-engine/core-application/workflow-layers/fetch-backend":"cKMex",".":"icEoh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"giqKC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _showPage = require("./workflow-layers/show-page");
var _showPageDefault = parcelHelpers.interopDefault(_showPage);
exports.default = {
    workflowLayers: {
        [(0, _showPage.apiName)]: (0, _showPageDefault.default)
    }
};

},{"./workflow-layers/show-page":"5TkcZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5TkcZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
function FormEngineShowPageWfl({ session, definition }) {
    return Promise.resolve({
        ...session,
        currentPage: String(definition?.pageName ?? '')
    });
}
const apiName = FormEngineShowPageWfl.apiName = 'FormEngineShowPageWfl';
exports.default = FormEngineShowPageWfl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e0qQS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _renderer = require("./components/form/renderer");
var _rendererDefault = parcelHelpers.interopDefault(_renderer);
var _declareCspApi = require("./utilities/declare-csp-api");
exports.default = {
    rendererComponent: (0, _rendererDefault.default)
};

},{"./components/form/renderer":"7WNj4","./utilities/declare-csp-api":"54dFI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7WNj4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BsoFormEngineRenderer);
var _jsxRuntime = require("react/jsx-runtime");
var _engine = require("@form-engine/core-application/components/engine");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _classNames = require("@form-engine/core-util/class-names");
var _classNamesDefault = parcelHelpers.interopDefault(_classNames);
var _sessionRemote = require("./session-remote");
var _sessionRemoteDefault = parcelHelpers.interopDefault(_sessionRemote);
function BsoFormEngineRenderer({ className, ...props }) {
    const { state: form } = (0, _useForm.useFormContext)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _engine.FormEngineRenderer), {
        ...props,
        className: (0, _classNamesDefault.default)(className, form.bsoTheme),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sessionRemoteDefault.default), {})
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/components/engine":"8IyYu","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-util/class-names":"fk8HN","./session-remote":"adTqo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"adTqo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sessionRemotes", ()=>sessionRemotes);
parcelHelpers.export(exports, "default", ()=>BsoFormEngineSessionRemote);
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _react = require("react");
const sessionRemotes = new Map();
function BsoFormEngineSessionRemote() {
    const session = (0, _useFormsession.useFormSessionContext)();
    const { state: form } = (0, _useForm.useFormContext)();
    (0, _react.useEffect)(()=>{
        if (!form.id) return;
        sessionRemotes.set(form.id, session);
        return ()=>{
            sessionRemotes.delete(form.id);
        };
    }, [
        form.id,
        session
    ]);
    return null;
}

},{"@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-application/hooks/use-formsession":"2Th33","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"54dFI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Csp", ()=>Csp);
var _cspApi = require("../csp-api");
if (window) window.Csp ??= _cspApi;
const Csp = window.Csp;

},{"../csp-api":"3W5iG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3W5iG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>_v1);
parcelHelpers.export(exports, "default", ()=>_v1);
var _v1 = require("./v1");

},{"./v1":"NWfQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"NWfQg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
var _updateToken = require("./update-token");
parcelHelpers.exportAll(_updateToken, exports);
const version = 1;

},{"./update-token":"i7QU3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i7QU3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateToken", ()=>updateToken);
var _lodash = require("lodash");
var _sessionRemote = require("../../components/form/session-remote");
function updateToken(token) {
    if (!token || typeof token !== 'string') throw new Error(`invalid input provided to updateToken, got '${token}', expected non-empty string`);
    const authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
    for (const remote of (0, _sessionRemote.sessionRemotes).values())remote.set((0, _lodash.set)(structuredClone(remote.state), 'request.headers.authorization', authorization));
}

},{"lodash":"1qc47","../../components/form/session-remote":"adTqo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iLdSq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _attachmentsElement = require("./components/attachments-element");
var _attachmentsElementDefault = parcelHelpers.interopDefault(_attachmentsElement);
var _attachmentValidation = require("./validations/attachment-validation");
var _attachmentValidationDefault = parcelHelpers.interopDefault(_attachmentValidation);
var _coreTranslations = require("./core-translations");
var _attachmentListValidation = require("./validations/attachment-list-validation");
var _attachmentListValidationDefault = parcelHelpers.interopDefault(_attachmentListValidation);
exports.default = {
    elements: {
        [(0, _attachmentsElement.apiName)]: (0, _attachmentsElementDefault.default)
    },
    validations: {
        BsoAttachmentValidation: (0, _attachmentValidationDefault.default),
        BsoAttachmentListValidation: (0, _attachmentListValidationDefault.default)
    },
    translations: _coreTranslations
};

},{"./components/attachments-element":"3NvWx","./validations/attachment-validation":"hRBdq","./core-translations":"1TV2L","./validations/attachment-list-validation":"dAjJp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3NvWx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiName", ()=>apiName);
parcelHelpers.export(exports, "defaultCategory", ()=>defaultCategory);
var _jsxRuntime = require("react/jsx-runtime");
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _attachmentsUploadInput = require("./attachments-upload-input");
var _attachmentsUploadInputDefault = parcelHelpers.interopDefault(_attachmentsUploadInput);
var _attachmentsUploadInputList = require("./attachments-upload-input-list");
var _attachmentsUploadInputListDefault = parcelHelpers.interopDefault(_attachmentsUploadInputList);
const apiName = 'BsoAttachmentsElement';
const defaultCategory = 'Other';
exports.default = Object.assign(function BsoAttachmentsElement(props) {
    const { state: element } = (0, _useElement.useFormEngineElement)();
    if (!element || element.type !== apiName) throw new Error('tried to render input with invalid definition');
    const { multiple = false, renderAsList = false } = element;
    const ComponentType = multiple && renderAsList ? (0, _attachmentsUploadInputListDefault.default) : (0, _attachmentsUploadInputDefault.default);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ComponentType, {
        ...props
    });
}, {
    apiName,
    isField: true,
    enabled: true
});

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/hooks/use-element":"ehckF","./attachments-upload-input":"1nktd","./attachments-upload-input-list":"a7sr7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1nktd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BsoAttachmentsUploadInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _inputElement = require("@form-engine/element-input/components/input-element");
var _inputElementDefault = parcelHelpers.interopDefault(_inputElement);
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _attachmentsElement = require("./attachments-element");
var _uploadHandling = require("../utils/upload-handling");
function BsoAttachmentsUploadInput({ formGroupProps = {
    className: 'fe-attachment-input'
}, type = 'file', ...props }) {
    const { state: element } = (0, _useElement.useFormEngineElement)();
    if (!element || element.type !== (0, _attachmentsElement.apiName)) throw new Error('tried to render input with invalid definition');
    const { multiple = false, accept } = element;
    const controller = (0, _useElement.useFormEngineElementController)();
    const [session, setSession] = (0, _useFormsession.useFormElementSession)();
    const handleChange = (0, _react.useCallback)((e)=>{
        const { files } = e.target;
        if (files && files?.length) setSession({
            ...session,
            loading: true,
            isTouched: true,
            value: undefined,
            error: undefined,
            currentFileList: files
        });
        else setSession({
            ...session,
            loading: false,
            isTouched: true,
            value: undefined,
            error: undefined,
            currentFileList: undefined
        });
    }, [
        setSession,
        session
    ]);
    (0, _react.useEffect)(()=>{
        // wait for validation to settle
        if (session?.error === undefined) return;
        const currentFiles = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        session?.currentFileList;
        // wait for valid file list
        if (!currentFiles?.length || session?.error !== null) {
            if (session?.loading) // mark element as idle if no upload takes place
            setSession({
                ...session,
                loading: false
            });
            return;
        }
        let mounted = true;
        (async ()=>{
            const indices = await (0, _uploadHandling.createAttachmentIndices)(controller, currentFiles);
            const uploads = [];
            for (const [key, attachmentIndex] of indices.entries()){
                const file = currentFiles[key];
                uploads.push((0, _uploadHandling.uploadFileTo)(attachmentIndex.uploadUrl, file));
            }
            await Promise.all(uploads);
            const value = JSON.stringify(indices.map(({ attachmentId })=>attachmentId));
            if (!mounted) return;
            setSession({
                ...session,
                loading: false,
                currentFileList: undefined,
                value
            });
        })();
        return ()=>{
            mounted = false;
        };
    }, [
        session?.currentFileList,
        session?.error,
        setSession,
        controller
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputElementDefault.default), {
        ...props,
        disabled: Boolean(session?.loading),
        multiple: multiple,
        accept: accept,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange: handleChange,
        formGroupProps: formGroupProps,
        type: type
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/element-input/components/input-element":"adGv3","@form-engine/core-application/hooks/use-element":"ehckF","@form-engine/core-application/hooks/use-formsession":"2Th33","./attachments-element":"3NvWx","../utils/upload-handling":"8Qeey","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Qeey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FileSelectionSizeError", ()=>FileSelectionSizeError);
parcelHelpers.export(exports, "FileSelectionCancelError", ()=>FileSelectionCancelError);
parcelHelpers.export(exports, "FileSelectionEmptyError", ()=>FileSelectionEmptyError);
parcelHelpers.export(exports, "UnexpectedUploadLoadStateError", ()=>UnexpectedUploadLoadStateError);
parcelHelpers.export(exports, "selectFile", ()=>selectFile);
parcelHelpers.export(exports, "createAttachmentIndices", ()=>createAttachmentIndices);
parcelHelpers.export(exports, "uploadFileTo", ()=>uploadFileTo);
parcelHelpers.export(exports, "requestUserFile", ()=>requestUserFile);
parcelHelpers.export(exports, "requestAttachmentIndexForUploadState", ()=>requestAttachmentIndexForUploadState);
parcelHelpers.export(exports, "uploadAttachmentForUploadState", ()=>uploadAttachmentForUploadState);
var _uuid = require("@form-engine/core-util/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
class FileSelectionSizeError extends Error {
    constructor(){
        super('The files selected are too big');
    }
}
class FileSelectionCancelError extends Error {
    constructor(){
        super('File selection canceled');
    }
}
class FileSelectionEmptyError extends Error {
    constructor(){
        super('No valid files to upload');
    }
}
class UnexpectedUploadLoadStateError extends Error {
    constructor(need, got){
        super(`load state '${need}' required, got ${got}`);
    }
}
function selectFile(accept = '*/*', maxSize = 0, multiple = false) {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = accept;
    fileInput.multiple = multiple;
    return new Promise((resolve, reject)=>{
        fileInput.onchange = ()=>{
            if (fileInput.files && maxSize) {
                const size = Array.from(fileInput.files).reduce((p, c)=>p + c.size, 0);
                if (size > maxSize * 1048576) {
                    reject(new FileSelectionSizeError());
                    return;
                }
            }
            resolve(fileInput.files);
        };
        fileInput.oncancel = ()=>reject(new FileSelectionCancelError());
        fileInput.click();
    });
}
function createAttachmentIndices(controller, files) {
    const indices = [];
    for (const file of files)indices.push(controller({
        action: 'createAttachmentIndex',
        fileName: file.name,
        fileSize: file.size
    }));
    return Promise.all(indices);
}
async function uploadFileTo(presignedUploadUrl, file) {
    if (document.location.host === 'localhost') {
        console.info('localdev environment detected, simulating upload...');
        await new Promise((resolve)=>setTimeout(resolve, 1500 + Math.random() * 500));
    } else await fetch(presignedUploadUrl, {
        method: 'PUT',
        headers: {
            'Content-Type': file.type
        },
        body: file
    });
}
async function requestUserFile(bsoCategory, accept, maxSize) {
    const files = await selectFile(accept, maxSize);
    if (!files?.length) throw new FileSelectionEmptyError();
    return {
        id: (0, _uuidDefault.default)(),
        file: files.item(0),
        bsoCategory,
        loadState: 'initial'
    };
}
async function requestAttachmentIndexForUploadState(controller, state) {
    const { file, bsoCategory, loadState } = state;
    if (loadState !== 'initial') throw new UnexpectedUploadLoadStateError('initial', loadState);
    return {
        ...state,
        attachmentIndex: await controller({
            action: 'createAttachmentIndex',
            fileName: file.name,
            category: bsoCategory,
            fileSize: file.size
        }),
        loadState: 'indexed'
    };
}
async function uploadAttachmentForUploadState(state) {
    const { file, attachmentIndex, loadState } = state;
    if (!attachmentIndex || loadState !== 'indexed') throw new UnexpectedUploadLoadStateError('indexed', loadState);
    await uploadFileTo(attachmentIndex.uploadUrl, file);
    return {
        ...state,
        loadState: 'uploaded'
    };
}

},{"@form-engine/core-util/uuid":"eZttN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a7sr7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BsoAttachmentsUploadInputList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _button = require("react-bootstrap/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _attachmentsElement = require("./attachments-element");
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _reactBootstrap = require("react-bootstrap");
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _classNames = require("@form-engine/core-util/class-names");
var _classNamesDefault = parcelHelpers.interopDefault(_classNames);
var _useElementSessionUploads = require("../hooks/use-element-session-uploads");
var _coreApplication = require("@form-engine/core-application");
var _coreApplicationDefault = parcelHelpers.interopDefault(_coreApplication);
var _useElementDisabled = require("@form-engine/core-application/hooks/use-element-disabled");
var _useElementHidden = require("@form-engine/core-application/hooks/use-element-hidden");
var _formatFileSize = require("@form-engine/core-util/format-file-size");
var _formatFileSizeDefault = parcelHelpers.interopDefault(_formatFileSize);
function UploadInputAddButton({ onAdd, categories, disabled }) {
    const [show, setShow] = (0, _react.useState)(false);
    const toggleRef = (0, _react.useRef)(null);
    const i18n = (0, _coreApplicationDefault.default).i18n.prefix('attachment.');
    (0, _react.useEffect)(()=>{
        let mounted = true;
        const toggleOff = (e)=>{
            if (!mounted || !toggleRef.current || e.composedPath().includes(toggleRef.current)) return;
            setShow(false);
        };
        window.addEventListener('click', toggleOff);
        return ()=>{
            mounted = false;
            window.removeEventListener('click', toggleOff);
        };
    }, [
        setShow
    ]);
    if (!categories?.length) return null;
    if (categories.length === 1) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        size: "sm",
        variant: "secondary",
        onClick: ()=>{
            !disabled && onAdd?.(categories[0].bsoCategory, categories[0].accept, Number(categories[0].validationMaxAttachmentSize ?? 0));
        },
        disabled: disabled,
        children: [
            'Other',
            'Unclassified',
            ''
        ].includes(String(categories[0].bsoCategory)) ? i18n.c(`uploadDropdown`) : i18n.c(`uploadButton`, {
            category: i18n.c(`bsoCategory.${categories[0].bsoCategory || (0, _attachmentsElement.defaultCategory)}`)
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Dropdown), {
        show: show,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Dropdown).Toggle, {
                size: "sm",
                variant: "secondary",
                disabled: disabled,
                onClick: ()=>!disabled && setShow(true),
                ref: toggleRef,
                children: i18n.c(`uploadDropdown`)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Dropdown).Menu, {
                children: categories.map((category, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Dropdown).Item, {
                        onClick: ()=>{
                            !disabled && onAdd?.(category.bsoCategory, category.accept, Number(category.validationMaxAttachmentSize ?? 0));
                        },
                        children: i18n.c(`bsoCategory.${category.bsoCategory || (0, _attachmentsElement.defaultCategory)}`)
                    }, key))
            })
        ]
    });
}
function UploadInputListElement({ id, file, bsoCategory, loadState, onRemove, disabled = false, bordered = false }) {
    const nonInteractive = disabled || loadState !== 'uploaded';
    const i18n = (0, _coreApplicationDefault.default).i18n.prefix('attachment.');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Stack), {
        direction: "horizontal",
        gap: 3,
        className: (0, _classNamesDefault.default)(bordered && 'border-top', nonInteractive && 'opacity-25 pe-none', 'me-2'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "p-2 text-sm",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                        children: file.name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Badge), {
                                bg: "secondary",
                                children: (0, _formatFileSizeDefault.default)(file.size)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Badge), {
                                bg: "secondary",
                                children: i18n.c(`bsoCategory.${bsoCategory || (0, _attachmentsElement.defaultCategory)}`)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "p-2 ms-auto",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    size: "sm",
                    variant: "light",
                    className: 'p-0',
                    style: {
                        width: '2rem',
                        height: '2rem'
                    },
                    disabled: nonInteractive,
                    onClick: ()=>!nonInteractive && onRemove?.(id),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: "\xd7"
                    })
                })
            })
        ]
    });
}
function BsoAttachmentsUploadInputList({ formGroupProps = {
    className: 'fe-attachment-input'
} }) {
    const { state: element } = (0, _useElement.useFormEngineElement)();
    if (!element || element.type !== (0, _attachmentsElement.apiName)) throw new Error('tried to render input with invalid definition');
    const [session] = (0, _useFormsession.useFormElementSession)();
    const { addUpload, removeUpload, uploads, categories } = (0, _useElementSessionUploads.useElementSessionUploads)();
    const disabled = (0, _useElementDisabled.useFormEngineElementDisabled)();
    const nonInteractive = Boolean(session.loading || disabled);
    const hidden = (0, _useElementHidden.useFormEngineElementHidden)();
    if (hidden) return null;
    const loader = session.loading !== undefined && session.loading !== false && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.ProgressBar), {
        className: "mt-1",
        style: {
            height: '5px'
        },
        animated: true,
        striped: true,
        now: typeof session.loading === 'number' ? session.loading : 100
    });
    const errorText = session.error || session.transientError;
    const error = !loader && session.isTouched && element.showError && errorText && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl).Feedback, {
        type: "invalid",
        tooltip: false,
        children: String(errorText)
    });
    const control = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classNamesDefault.default)('form-control p-2', !loader && error && 'is-invalid', !loader && session.isTouched && !session.error && 'is-valid'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(UploadInputAddButton, {
                categories: categories,
                onAdd: addUpload,
                disabled: nonInteractive
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Stack), {
                className: (0, _classNamesDefault.default)(uploads?.length && categories.length && 'mt-2', 'me-4'),
                children: uploads?.map((upload, index)=>{
                    return /*#__PURE__*/ (0, _react.createElement)(UploadInputListElement, {
                        ...upload,
                        key: upload.id,
                        bordered: index !== 0 || Boolean(categories.length),
                        disabled: nonInteractive,
                        onRemove: removeUpload
                    });
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormGroup), {
        ...formGroupProps ?? {},
        className: (0, _classNamesDefault.default)('fe-attachment-list', 'user-select-none', formGroupProps?.className),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                element.label && element.floatingLabel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FloatingLabel), {
                    label: element.label,
                    controlId: element.id,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(control.type, {
                                ...control.props,
                                id: undefined
                            }),
                            error
                        ]
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        element.label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormLabel), {
                            htmlFor: element.id,
                            children: element.label
                        }),
                        control,
                        error
                    ]
                }),
                loader
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap/Button":"2TJC6","./attachments-element":"3NvWx","@form-engine/core-application/hooks/use-element":"ehckF","react-bootstrap":"f5rnA","@form-engine/core-application/hooks/use-formsession":"2Th33","@form-engine/core-util/class-names":"fk8HN","../hooks/use-element-session-uploads":"dVZhI","@form-engine/core-application":"fjN6J","@form-engine/core-application/hooks/use-element-disabled":"klZMn","@form-engine/core-application/hooks/use-element-hidden":"1rivZ","@form-engine/core-util/format-file-size":"irWEe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dVZhI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useElementSessionUploads", ()=>useElementSessionUploads);
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _uploadHandling = require("../utils/upload-handling");
var _react = require("react");
var _attachmentsElement = require("../components/attachments-element");
var _coreApplication = require("@form-engine/core-application");
function useElementSessionUploads() {
    const { state: element } = (0, _useElement.useFormEngineElement)();
    if (!element || element.type !== (0, _attachmentsElement.apiName)) throw new Error('tried to render input with invalid definition');
    const controller = (0, _useElement.useFormEngineElementController)();
    const [session, setSession] = (0, _useFormsession.useFormElementSession)();
    const addUpload = (0, _react.useCallback)(async (bsoCategory = '', accept, maxSize)=>{
        const { uploads } = session;
        setSession({
            loading: true
        });
        try {
            let upload = await (0, _uploadHandling.requestUserFile)(bsoCategory, accept, maxSize);
            setSession({
                loading: true,
                uploads: [
                    ...uploads ?? [],
                    upload
                ],
                transientError: null
            });
            upload = await (0, _uploadHandling.requestAttachmentIndexForUploadState)(controller, upload);
            setSession({
                loading: true,
                uploads: [
                    ...uploads ?? [],
                    upload
                ],
                transientError: null
            });
            upload = await (0, _uploadHandling.uploadAttachmentForUploadState)(upload);
            setSession({
                loading: false,
                uploads: [
                    ...uploads ?? [],
                    upload
                ],
                transientError: null
            });
        } catch (e) {
            if (e instanceof (0, _uploadHandling.FileSelectionSizeError)) {
                setSession({
                    loading: false,
                    uploads,
                    transientError: (0, _coreApplication.i18n).c('validation.maxAttachmentSize', {
                        max: maxSize
                    }),
                    isTouched: true
                });
                return;
            }
            console.warn(e);
            setSession({
                loading: false,
                uploads
            });
            return;
        }
    }, [
        session?.uploads,
        setSession,
        controller
    ]);
    const removeUpload = (0, _react.useCallback)((id)=>{
        setSession({
            uploads: [
                ...session?.uploads ?? []
            ].filter((upload)=>upload.id !== id),
            transientError: null
        });
    }, [
        session?.uploads,
        setSession
    ]);
    // compute form element value when uploads change
    (0, _react.useEffect)(()=>{
        // ignore effect when uploads aren't initialized yet
        if (!session?.uploads) return;
        setSession({
            isTouched: true,
            value: JSON.stringify([
                ...session?.uploads ?? []
            ].filter(({ loadState })=>loadState === 'uploaded').map(({ attachmentIndex })=>attachmentIndex.attachmentId))
        });
    }, [
        session?.uploads,
        setSession
    ]);
    const categories = (0, _react.useMemo)(()=>{
        return (element.listSettings ?? []).filter(({ validationMaxAttachments, bsoCategory = '' })=>{
            const max = Number(validationMaxAttachments ?? 1);
            return max < 1 || (session?.uploads || []).filter((u)=>u.bsoCategory === bsoCategory).length < max;
        });
    }, [
        session?.uploads,
        element.listSettings
    ]);
    return {
        addUpload,
        removeUpload,
        uploads: session?.uploads ?? [],
        categories
    };
}

},{"@form-engine/core-application/hooks/use-element":"ehckF","@form-engine/core-application/hooks/use-formsession":"2Th33","../utils/upload-handling":"8Qeey","react":"9njXz","../components/attachments-element":"3NvWx","@form-engine/core-application":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"irWEe":[function(require,module,exports,__globalThis) {
/**
 * Format bytes as human-readable text.
 * @see https://stackoverflow.com/questions/10420352/converting-file-size-in-bytes-to-human-readable-string
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatFileSize);
function formatFileSize(bytes, si = true, dp = 1) {
    const thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) return bytes + ' B';
    const units = si ? [
        'kB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
    ] : [
        'KiB',
        'MiB',
        'GiB',
        'TiB',
        'PiB',
        'EiB',
        'ZiB',
        'YiB'
    ];
    let u = -1;
    const r = 10 ** dp;
    do {
        bytes /= thresh;
        ++u;
    }while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
    return bytes.toFixed(dp) + ' ' + units[u];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hRBdq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coreApplication = require("@form-engine/core-application");
var _coreApplicationDefault = parcelHelpers.interopDefault(_coreApplication);
var _attachmentsElement = require("../components/attachments-element");
const BsoAttachmentValidation = (element, _value, session)=>{
    // only validate supported attachment element configurations
    if (element.type !== (0, _attachmentsElement.apiName) || element.multiple && element.renderAsList) return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const uploadSession = session.elements?.[element.id] ?? {};
    const files = uploadSession?.currentFileList;
    const { c } = (0, _coreApplicationDefault.default).i18n;
    const label = element?.label ?? element?.name;
    if (!files) return null;
    if (element.validationMaxAttachments) {
        const max = Number(element.validationMaxAttachments);
        if (files.length > max) return c('validation.maxAttachments', {
            label,
            max
        });
    }
    if (element.validationMaxAttachments) {
        const min = Number(element.validationMinAttachments);
        if (files.length < min) return c('validation.minAttachments', {
            label,
            min: element.validationMinAttachments
        });
    }
    if (element.validationMaxAttachmentSize) {
        const max = Number(element.validationMaxAttachmentSize) * 1048576;
        for (const file of files){
            if (file.size > max) return c('validation.maxAttachmentSize', {
                label,
                max: element.validationMaxAttachmentSize
            });
        }
    }
    return null;
};
exports.default = BsoAttachmentValidation;

},{"@form-engine/core-application":"fjN6J","../components/attachments-element":"3NvWx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1TV2L":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
parcelHelpers.export(exports, "es", ()=>(0, _esJsonDefault.default));
parcelHelpers.export(exports, "it", ()=>(0, _itJsonDefault.default));
parcelHelpers.export(exports, "fr", ()=>(0, _frJsonDefault.default));
parcelHelpers.export(exports, "no", ()=>(0, _noJsonDefault.default));
parcelHelpers.export(exports, "sv", ()=>(0, _svJsonDefault.default));
parcelHelpers.export(exports, "da", ()=>(0, _daJsonDefault.default));
parcelHelpers.export(exports, "fi", ()=>(0, _fiJsonDefault.default));
parcelHelpers.export(exports, "nl", ()=>(0, _nlJsonDefault.default));
parcelHelpers.export(exports, "pl", ()=>(0, _plJsonDefault.default));
parcelHelpers.export(exports, "pt", ()=>(0, _ptJsonDefault.default));
parcelHelpers.export(exports, "cs", ()=>(0, _csJsonDefault.default));
parcelHelpers.export(exports, "ja", ()=>(0, _jaJsonDefault.default));
parcelHelpers.export(exports, "ko", ()=>(0, _koJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);
var _esJson = require("./es.json");
var _esJsonDefault = parcelHelpers.interopDefault(_esJson);
var _itJson = require("./it.json");
var _itJsonDefault = parcelHelpers.interopDefault(_itJson);
var _frJson = require("./fr.json");
var _frJsonDefault = parcelHelpers.interopDefault(_frJson);
var _noJson = require("./no.json");
var _noJsonDefault = parcelHelpers.interopDefault(_noJson);
var _svJson = require("./sv.json");
var _svJsonDefault = parcelHelpers.interopDefault(_svJson);
var _daJson = require("./da.json");
var _daJsonDefault = parcelHelpers.interopDefault(_daJson);
var _fiJson = require("./fi.json");
var _fiJsonDefault = parcelHelpers.interopDefault(_fiJson);
var _nlJson = require("./nl.json");
var _nlJsonDefault = parcelHelpers.interopDefault(_nlJson);
var _plJson = require("./pl.json");
var _plJsonDefault = parcelHelpers.interopDefault(_plJson);
var _ptJson = require("./pt.json");
var _ptJsonDefault = parcelHelpers.interopDefault(_ptJson);
var _csJson = require("./cs.json");
var _csJsonDefault = parcelHelpers.interopDefault(_csJson);
var _jaJson = require("./ja.json");
var _jaJsonDefault = parcelHelpers.interopDefault(_jaJson);
var _koJson = require("./ko.json");
var _koJsonDefault = parcelHelpers.interopDefault(_koJson);

},{"./default.json":"6GUuO","./de.json":"3VyKE","./es.json":"lazpZ","./it.json":"iuMk3","./fr.json":"larfF","./no.json":"apsuE","./sv.json":"hsUQY","./da.json":"okGuT","./fi.json":"4DjJS","./nl.json":"jK5sg","./pl.json":"erpNa","./pt.json":"gbTIH","./cs.json":"0kD86","./ja.json":"4uptY","./ko.json":"kAEWc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6GUuO":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"validation.maxAttachments\":\"only {{max}} attachments are allowed\",\"validation.minAttachments\":\"at least {{min}} attachments are required\",\"validation.maxAttachmentSize\":\"Attachments can't be bigger than {{max}} Megabytes\",\"validation.attachmentListItemRequired\":\"please provide an attachment for \\\"{{category}}\\\"\",\"validation.attachmentListItemMaxAttachments\":\"only {{max}} attachments for \\\"{{category}}\\\" are allowed\",\"validation.attachmentListItemMaxAttachmentSize\":\"{{category}} attachments can't be bigger than {{max}} Megabytes\",\"attachment.bsoCategory.DiagnosticReport\":\"Diagnostic Report\",\"attachment.bsoCategory.InvoiceDocument\":\"Invoice Document\",\"attachment.bsoCategory.ShippingDocument\":\"Shipping Document\",\"attachment.bsoCategory.Letter\":\"Letter\",\"attachment.bsoCategory.PictureReference\":\"Picture Reference\",\"attachment.bsoCategory.BugReport\":\"Bug Report\",\"attachment.bsoCategory.Other\":\"Other\",\"attachment.bsoCategory.Unclassified\":\"Unclassified\",\"attachment.bsoCategory.ServiceForms\":\"Service Form\",\"attachment.bsoCategory.RegistrationDocument\":\"Registration Document\",\"attachment.bsoCategory.ShopInside\":\"Image of Shop Interior\",\"attachment.bsoCategory.ShopImageMigration\":\"Shop image Migration\",\"attachment.bsoCategory.ShopImage\":\"Image of Shopfront\",\"attachment.uploadButton\":\"Upload {{category}}\",\"attachment.uploadDropdown\":\"Upload a File\"}");

},{}],"3VyKE":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.maxAttachments":"Es k\xf6nnen maximal {{max}} Anh\xe4nge hochgeladen werden.","validation.minAttachments":"Es werden mindestens {{min}} Anh\xe4nge ben\xf6tigt.","validation.maxAttachmentSize":"Anh\xe4nge k\xf6nnen maximal {{max}} Megabyte gro\xdf sein.","validation.attachmentListItemRequired":"Bitte h\xe4ng eine Datei f\xfcr \\"{{category}}\\" an.","validation.attachmentListItemMaxAttachments":"Es d\xfcrfen nur {{max}} Anh\xe4nge in  \\"{{category}}\\" hochgeladen werden.","validation.attachmentListItemMaxAttachmentSize":"{{category}}-Anh\xe4nge d\xfcrfen nicht gr\xf6\xdfer als {{max}} Megabyte sein.","attachment.bsoCategory.DiagnosticReport":"Diagnosebericht","attachment.bsoCategory.InvoiceDocument":"Rechnungsdokument","attachment.bsoCategory.ShippingDocument":"Versanddokument","attachment.bsoCategory.Letter":"Brief","attachment.bsoCategory.PictureReference":"Bildreferenz","attachment.bsoCategory.BugReport":"Fehlerbericht","attachment.bsoCategory.Other":"Sonstige","attachment.bsoCategory.Unclassified":"Nicht klassifiziert","attachment.bsoCategory.ServiceForms":"Serviceformular","attachment.bsoCategory.RegistrationDocument":"Registrierungsdokument","attachment.bsoCategory.ShopInside":"Foto vom Ladeninneren","attachment.bsoCategory.ShopImageMigration":"ShopImage Migration","attachment.bsoCategory.ShopImage":"Foto von der Ladenfront","attachment.uploadButton":"{{category}} Hochladen","attachment.uploadDropdown":"Datei hochladen"}');

},{}],"lazpZ":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.maxAttachments":"Solo puedes adjuntar hasta {{max}} archivos.","validation.minAttachments":"Se necesitan al menos {{min}} archivos adjuntos.","validation.maxAttachmentSize":"Los archivos adjuntos no pueden superar los {{max}} megabytes.","validation.attachmentListItemRequired":"Por favor, env\xedanos un archivo adjunto para \\"{{categor\xeda}}\\".","validation.attachmentListItemMaxAttachments":"Solo puedes subir hasta {{max}} archivos adjuntos para \\"{{category}}\\".","validation.attachmentListItemMaxAttachmentSize":"Los archivos adjuntos de {{category}} no pueden superar los {{max}} megabytes.","attachment.bsoCategory.DiagnosticReport":"Informe de diagn\xf3stico","attachment.bsoCategory.InvoiceDocument":"Documento de factura","attachment.bsoCategory.ShippingDocument":"Documento de env\xedo","attachment.bsoCategory.Letter":"Carta","attachment.bsoCategory.PictureReference":"Referencia de imagen","attachment.bsoCategory.BugReport":"Informe de errores","attachment.bsoCategory.Other":"Otro","attachment.bsoCategory.Unclassified":"Sin clasificar","attachment.bsoCategory.ServiceForms":"Formulario de servicio","attachment.bsoCategory.RegistrationDocument":"Documento de registro","attachment.bsoCategory.ShopInside":"Imagen del interior de la tienda","attachment.bsoCategory.ShopImageMigration":"Migraci\xf3n de im\xe1genes de la tienda","attachment.bsoCategory.ShopImage":"Imagen de la fachada de la tienda","attachment.uploadButton":"Sube {{category}}","attachment.uploadDropdown":"Sube un archivo"}');

},{}],"iuMk3":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.maxAttachments":"Puoi aggiungere solo {{max}} allegati.","validation.minAttachments":"Sono richiesti almeno {{min}} allegati.","validation.maxAttachmentSize":"Gli allegati non possono superare i {{max}} Megabyte.","validation.attachmentListItemRequired":"Per favore, aggiungi un allegato per \\"{{category}}\\".","validation.attachmentListItemMaxAttachments":"Puoi caricare solo {{max}} allegati per la categoria \\"{{category}}\\".","validation.attachmentListItemMaxAttachmentSize":"Gli allegati di {{category}} non possono superare i {{max}} Megabyte.","attachment.bsoCategory.DiagnosticReport":"Rapporto diagnostico","attachment.bsoCategory.InvoiceDocument":"Documento della fattura","attachment.bsoCategory.ShippingDocument":"Documento di spedizione","attachment.bsoCategory.Letter":"Lettera","attachment.bsoCategory.PictureReference":"Immagine di riferimento","attachment.bsoCategory.BugReport":"Segnalazione bug","attachment.bsoCategory.Other":"Altro","attachment.bsoCategory.Unclassified":"Non classificato","attachment.bsoCategory.ServiceForms":"Modulo di servizio","attachment.bsoCategory.RegistrationDocument":"Documento di registrazione","attachment.bsoCategory.ShopInside":"Foto dell\u2019interno del negozio","attachment.bsoCategory.ShopImageMigration":"Trasferimento immagini negozio","attachment.bsoCategory.ShopImage":"Foto della vetrina","attachment.uploadButton":"Carica {{category}}","attachment.uploadDropdown":"Carica un file"}');

},{}],"larfF":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.maxAttachments":"Seules {{max}} pi\xe8ces jointes sont autoris\xe9es.","validation.minAttachments":"","validation.maxAttachmentSize":"Les pi\xe8ces jointes ne peuvent pas faire plus de {{max}} m\xe9gaoctets.","validation.attachmentListItemRequired":"Merci d\u2019ajouter une pi\xe8ce jointe pour \xab {{category}} \xbb.","validation.attachmentListItemMaxAttachments":"Seules {{max}} pi\xe8ces jointes sont autoris\xe9es pour la cat\xe9gorie \xab {{category}} \xbb.","validation.attachmentListItemMaxAttachmentSize":"Les pi\xe8ces jointes pour {{category}} ne peuvent pas d\xe9passer {{max}} m\xe9gaoctets.","attachment.bsoCategory.DiagnosticReport":"Rapport de diagnostic","attachment.bsoCategory.InvoiceDocument":"Facture","attachment.bsoCategory.ShippingDocument":"Document d\u2019exp\xe9dition","attachment.bsoCategory.Letter":"Lettre","attachment.bsoCategory.PictureReference":"Photo de r\xe9f\xe9rence","attachment.bsoCategory.BugReport":"Rapport d\'erreur","attachment.bsoCategory.Other":"Autre","attachment.bsoCategory.Unclassified":"Non class\xe9","attachment.bsoCategory.ServiceForms":"Formulaire de service","attachment.bsoCategory.RegistrationDocument":"Document d\u2019inscription","attachment.bsoCategory.ShopInside":"Photo de l\u2019int\xe9rieur du magasin","attachment.bsoCategory.ShopImageMigration":"Migration d\u2019image du magasin","attachment.bsoCategory.ShopImage":"Photo de la devanture du magasin","attachment.uploadButton":"T\xe9l\xe9charge {{category}}","attachment.uploadDropdown":"T\xe9l\xe9charge un fichier"}');

},{}],"apsuE":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.maxAttachments":"Kun {{max}} vedlegg er tillatt.","validation.minAttachments":"minst {{min}} vedlegg m\xe5 legges ved","validation.maxAttachmentSize":"Vedleggene dine kan ikke v\xe6re st\xf8rre enn {{max}} megabyte.","validation.attachmentListItemRequired":"Vennligst legg ved en fil for \\"{{category}}\\".","validation.attachmentListItemMaxAttachments":"kun {{max}} vedlegg er tillatt for \\"{{category}}","validation.attachmentListItemMaxAttachmentSize":"{{category}}-vedlegg kan ikke v\xe6re st\xf8rre enn {{max}} megabyte.","attachment.bsoCategory.DiagnosticReport":"Diagnoserapport","attachment.bsoCategory.InvoiceDocument":"Fakturadokument","attachment.bsoCategory.ShippingDocument":"Fraktdokument","attachment.bsoCategory.Letter":"Brev","attachment.bsoCategory.PictureReference":"Bildereferanse","attachment.bsoCategory.BugReport":"Feilrapport","attachment.bsoCategory.Other":"Annet","attachment.bsoCategory.Unclassified":"Uklassifisert","attachment.bsoCategory.ServiceForms":"Serviceskjema","attachment.bsoCategory.RegistrationDocument":"Registreringsdokument","attachment.bsoCategory.ShopInside":"Bilde av butikkinteri\xf8r","attachment.bsoCategory.ShopImageMigration":"Flytting av butikkbilder","attachment.bsoCategory.ShopImage":"Bilde av butikkfasade","attachment.uploadButton":"Last opp {{category}}","attachment.uploadDropdown":"Last opp en fil"}');

},{}],"hsUQY":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.maxAttachments":"Du kan bara ladda upp {{max}} bilagor.","validation.minAttachments":"Minst {{min}} bilagor beh\xf6vs.","validation.maxAttachmentSize":"Bilagor kan inte vara st\xf6rre \xe4n {{max}} megabyte.","validation.attachmentListItemRequired":"L\xe4gg till en bilaga f\xf6r \\"{{category}}","validation.attachmentListItemMaxAttachments":"Endast {{max}} bilagor \xe4r till\xe5tna f\xf6r kategorin \\"{{category}}\\".","validation.attachmentListItemMaxAttachmentSize":"{{category}} bilagor kan inte vara st\xf6rre \xe4n {{max}} megabyte","attachment.bsoCategory.DiagnosticReport":"Diagnosrapport","attachment.bsoCategory.InvoiceDocument":"Fakturadokument","attachment.bsoCategory.ShippingDocument":"Fraktdokument","attachment.bsoCategory.Letter":"Brev","attachment.bsoCategory.PictureReference":"Bildreferens","attachment.bsoCategory.BugReport":"Felrapport","attachment.bsoCategory.Other":"\xd6vrigt","attachment.bsoCategory.Unclassified":"Oklassificerat","attachment.bsoCategory.ServiceForms":"Serviceformul\xe4r","attachment.bsoCategory.RegistrationDocument":"Registreringsdokument","attachment.bsoCategory.ShopInside":"Bild p\xe5 butikens interi\xf6r","attachment.bsoCategory.ShopImageMigration":"Migrering av butiksbild","attachment.bsoCategory.ShopImage":"Bild p\xe5 butikens fasad","attachment.uploadButton":"Ladda upp {{category}}","attachment.uploadDropdown":"Ladda upp en fil"}');

},{}],"okGuT":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.maxAttachments":"kun {{max}} vedh\xe6ftede filer er tilladt","validation.minAttachments":"mindst {{min}} vedh\xe6ftede filer er p\xe5kr\xe6vet","validation.maxAttachmentSize":"Vedh\xe6ftede filer kan ikke v\xe6re st\xf8rre end {{max}} Megabytes","validation.attachmentListItemRequired":"Venligst vedh\xe6ft en fil til \\"{{category}}\\".","validation.attachmentListItemMaxAttachments":"Du kan kun tilf\xf8je op til {{max}} vedh\xe6ftede filer til \\"{{category}}\\".","validation.attachmentListItemMaxAttachmentSize":"{{category}}-vedh\xe6ftninger m\xe5 ikke v\xe6re st\xf8rre end {{max}} megabyte","attachment.bsoCategory.DiagnosticReport":"Diagnose rapport","attachment.bsoCategory.InvoiceDocument":"Fakturadokument","attachment.bsoCategory.ShippingDocument":"Forsendelsesdokument","attachment.bsoCategory.Letter":"Brev","attachment.bsoCategory.PictureReference":"Billedreference","attachment.bsoCategory.BugReport":"Fejlrapport","attachment.bsoCategory.Other":"Andet","attachment.bsoCategory.Unclassified":"Uklassificeret","attachment.bsoCategory.ServiceForms":"Serviceformular","attachment.bsoCategory.RegistrationDocument":"Registreringsdokument","attachment.bsoCategory.ShopInside":"Billede af butiksinteri\xf8r","attachment.bsoCategory.ShopImageMigration":"Butiksbillede Migration","attachment.bsoCategory.ShopImage":"Billede af butiksfacade","attachment.uploadButton":"Upload {{category}}","attachment.uploadDropdown":"Upload en fil"}');

},{}],"4DjJS":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.maxAttachments":"Vain {{max}} liitett\xe4 sallitaan.","validation.minAttachments":"v\xe4hint\xe4\xe4n {{min}} liitett\xe4 tarvitaan","validation.maxAttachmentSize":"Liitetiedostojen koko ei saa ylitt\xe4\xe4 {{max}} megatavua.","validation.attachmentListItemRequired":"Liit\xe4 liite \\"{{Category}}","validation.attachmentListItemMaxAttachments":"Vain {{max}} liitett\xe4 kategoriaan \\"{{category}}\\" on sallittu.","validation.attachmentListItemMaxAttachmentSize":"{{category}}-liitteiden koko ei voi ylitt\xe4\xe4 {{max}} megatavua.","attachment.bsoCategory.DiagnosticReport":"Vianm\xe4\xe4ritysraportti","attachment.bsoCategory.InvoiceDocument":"Lasku","attachment.bsoCategory.ShippingDocument":"Toimitusasiakirja","attachment.bsoCategory.Letter":"Kirje","attachment.bsoCategory.PictureReference":"Kuvaviite","attachment.bsoCategory.BugReport":"Vikailmoitus","attachment.bsoCategory.Other":"Muu","attachment.bsoCategory.Unclassified":"Ei luokiteltu","attachment.bsoCategory.ServiceForms":"Palvelulomake","attachment.bsoCategory.RegistrationDocument":"Rekister\xf6intiasiakirja","attachment.bsoCategory.ShopInside":"Kuva myym\xe4l\xe4n sis\xe4lt\xe4","attachment.bsoCategory.ShopImageMigration":"Kaupan kuvan siirto","attachment.bsoCategory.ShopImage":"Kuva liikkeen julkisivusta","attachment.uploadButton":"Lataa {{category}}","attachment.uploadDropdown":"Lataa tiedosto"}');

},{}],"jK5sg":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"validation.maxAttachments\":\"Je kunt maximaal {{max}} bijlagen toevoegen.\",\"validation.minAttachments\":\"Er zijn minstens {{min}} bijlagen nodig.\",\"validation.maxAttachmentSize\":\"Bijlagen kunnen niet groter zijn dan {{max}} megabytes.\",\"validation.attachmentListItemRequired\":\"Voeg een bijlage toe voor \\\"{{category}}\\\".\",\"validation.attachmentListItemMaxAttachments\":\"Je kunt maximaal {{max}} bijlagen toevoegen voor \\\"{{category}}\\\".\",\"validation.attachmentListItemMaxAttachmentSize\":\"{{category}} bijlagen kunnen niet groter zijn dan {{max}} megabytes.\",\"attachment.bsoCategory.DiagnosticReport\":\"Diagnoserapport\",\"attachment.bsoCategory.InvoiceDocument\":\"Factuur\",\"attachment.bsoCategory.ShippingDocument\":\"Verzenddocument\",\"attachment.bsoCategory.Letter\":\"Brief\",\"attachment.bsoCategory.PictureReference\":\"Referentie afbeelding\",\"attachment.bsoCategory.BugReport\":\"Bugrapport\",\"attachment.bsoCategory.Other\":\"Ander bestand\",\"attachment.bsoCategory.Unclassified\":\"Niet geclassificeerd\",\"attachment.bsoCategory.ServiceForms\":\"Serviceformulier\",\"attachment.bsoCategory.RegistrationDocument\":\"Registratiedocument\",\"attachment.bsoCategory.ShopInside\":\"Foto van winkelinterieur\",\"attachment.bsoCategory.ShopImageMigration\":\"ShopImage migratie\",\"attachment.bsoCategory.ShopImage\":\"Foto van voorgevel\",\"attachment.uploadButton\":\"{{category}} uploaden\",\"attachment.uploadDropdown\":\"Bestand uploaden\"}");

},{}],"erpNa":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.maxAttachments":"Dozwolone s\u0105 maksymalnie {{max}} za\u0142\u0105czniki.","validation.minAttachments":"Potrzebujesz co najmniej {{min}} za\u0142\u0105cznik\xf3w.","validation.maxAttachmentSize":"Za\u0142\u0105czniki nie mog\u0105 przekracza\u0107 {{max}} megabajt\xf3w.","validation.attachmentListItemRequired":"Prosz\u0119 do\u0142\u0105czy\u0107 za\u0142\u0105cznik do \\"{{category}}\\".","validation.attachmentListItemMaxAttachments":"Mo\u017Cesz doda\u0107 maksymalnie {{max}} za\u0142\u0105cznik\xf3w dla kategorii \\"{{category}}\\".","validation.attachmentListItemMaxAttachmentSize":"Za\u0142\u0105czniki w kategorii {{category}} nie mog\u0105 przekracza\u0107 {{max}} megabajt\xf3w.","attachment.bsoCategory.DiagnosticReport":"Raport diagnostyczny","attachment.bsoCategory.InvoiceDocument":"Faktura","attachment.bsoCategory.ShippingDocument":"Dokument wysy\u0142kowy","attachment.bsoCategory.Letter":"List","attachment.bsoCategory.PictureReference":"Zdj\u0119cie pogl\u0105dowe","attachment.bsoCategory.BugReport":"Zg\u0142oszenie b\u0142\u0119du","attachment.bsoCategory.Other":"Inne","attachment.bsoCategory.Unclassified":"Niesklasyfikowane","attachment.bsoCategory.ServiceForms":"Formularz serwisowy","attachment.bsoCategory.RegistrationDocument":"Dokument rejestracyjny","attachment.bsoCategory.ShopInside":"Zdj\u0119cie wn\u0119trza sklepu","attachment.bsoCategory.ShopImageMigration":"Przeniesienie zdj\u0119cia sklepu","attachment.bsoCategory.ShopImage":"Zdj\u0119cie witryny sklepowej","attachment.uploadButton":"Prze\u015Blij {{category}}","attachment.uploadDropdown":"Dodaj plik"}');

},{}],"gbTIH":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.maxAttachments":"S\xe3o permitidos apenas {{max}} anexos.","validation.minAttachments":"pelo menos {{min}} anexos s\xe3o obrigat\xf3rios","validation.maxAttachmentSize":"Os anexos n\xe3o podem passar de {{max}} megabytes.","validation.attachmentListItemRequired":"Por favor, forne\xe7a um anexo para \\"{{category}}","validation.attachmentListItemMaxAttachments":"S\xf3 \xe9 permitido enviar at\xe9 {{max}} anexos para \\"{{category}}\\".","validation.attachmentListItemMaxAttachmentSize":"Os anexos da categoria {{category}} n\xe3o podem ter mais de {{max}} megabytes.","attachment.bsoCategory.DiagnosticReport":"Relat\xf3rio de diagn\xf3stico","attachment.bsoCategory.InvoiceDocument":"Documento de fatura","attachment.bsoCategory.ShippingDocument":"Documento de envio","attachment.bsoCategory.Letter":"Carta","attachment.bsoCategory.PictureReference":"Refer\xeancia de imagem","attachment.bsoCategory.BugReport":"Relat\xf3rio de erro","attachment.bsoCategory.Other":"Outro","attachment.bsoCategory.Unclassified":"N\xe3o classificado","attachment.bsoCategory.ServiceForms":"Formul\xe1rio de servi\xe7o","attachment.bsoCategory.RegistrationDocument":"Documento de registo","attachment.bsoCategory.ShopInside":"Foto do interior da loja","attachment.bsoCategory.ShopImageMigration":"Migra\xe7\xe3o de imagens da loja","attachment.bsoCategory.ShopImage":"Foto da montra da loja","attachment.uploadButton":"Carregar {{category}}","attachment.uploadDropdown":"Carregar um ficheiro"}');

},{}],"0kD86":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.maxAttachments":"M\u016F\u017Ee\u0161 p\u0159ipojit maxim\xe1ln\u011B {{max}} p\u0159\xedloh.","validation.minAttachments":"je pot\u0159eba p\u0159ilo\u017Eit alespo\u0148 {{min}} p\u0159\xedlohy","validation.maxAttachmentSize":"P\u0159\xedlohy nem\u016F\u017Eou b\xfdt v\u011Bt\u0161\xed ne\u017E {{max}} megabajt\u016F.","validation.attachmentListItemRequired":"Pros\xedm, p\u0159ilo\u017E soubor k \\"{{category}}\\".","validation.attachmentListItemMaxAttachments":"Povolit m\u016F\u017Ee\u0161 jen {{max}} p\u0159\xedloh pro \\"{{category}}\\".","validation.attachmentListItemMaxAttachmentSize":"P\u0159\xedlohy typu {{category}} nesm\xed b\xfdt v\u011Bt\u0161\xed ne\u017E {{max}} megabajt\u016F.","attachment.bsoCategory.DiagnosticReport":"Diagnostick\xe1 zpr\xe1va","attachment.bsoCategory.InvoiceDocument":"Faktura","attachment.bsoCategory.ShippingDocument":"P\u0159epravn\xed dokument","attachment.bsoCategory.Letter":"Dopis","attachment.bsoCategory.PictureReference":"Obr\xe1zek jako reference","attachment.bsoCategory.BugReport":"Hl\xe1\u0161en\xed chyby","attachment.bsoCategory.Other":"Jin\xe9","attachment.bsoCategory.Unclassified":"Neza\u0159azeno","attachment.bsoCategory.ServiceForms":"Servisn\xed formul\xe1\u0159","attachment.bsoCategory.RegistrationDocument":"Registra\u010Dn\xed dokument","attachment.bsoCategory.ShopInside":"Fotka interi\xe9ru prodejny","attachment.bsoCategory.ShopImageMigration":"P\u0159enos obr\xe1zk\u016F z obchodu","attachment.bsoCategory.ShopImage":"Fotka v\xfdlohy","attachment.uploadButton":"Nahraj {{category}}","attachment.uploadDropdown":"Nahraj soubor"}');

},{}],"4uptY":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.maxAttachments":"\u6DFB\u4ED8\u30D5\u30A1\u30A4\u30EB\u306F\u6700\u5927{{max}}\u500B\u307E\u3067\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3067\u304D\u307E\u3059\u3002","validation.minAttachments":"\u5C11\u306A\u304F\u3068\u3082{{min}}\u500B\u306E\u6DFB\u4ED8\u30D5\u30A1\u30A4\u30EB\u304C\u5FC5\u8981\u3060\u3088","validation.maxAttachmentSize":"\u6DFB\u4ED8\u30D5\u30A1\u30A4\u30EB\u306F{{max}}\u30E1\u30AC\u30D0\u30A4\u30C8\u3092\u8D85\u3048\u306A\u3044\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u306D\u3002","validation.attachmentListItemRequired":"{{category}}\\"\u306E\u6DFB\u4ED8\u30D5\u30A1\u30A4\u30EB\u3092\u63D0\u4F9B\u3057\u3066\u304F\u3060\u3055\u3044","validation.attachmentListItemMaxAttachments":"{{category}}\\" \u306E {{max}} \u6DFB\u4ED8\u30D5\u30A1\u30A4\u30EB\u306E\u307F\u304C\u8A31\u53EF\u3055\u308C\u307E\u3059","validation.attachmentListItemMaxAttachmentSize":"{{category}}\u6DFB\u4ED8\u30D5\u30A1\u30A4\u30EB\u306F{{max}}\u30E1\u30AC\u30D0\u30A4\u30C8\u3088\u308A\u5927\u304D\u304F\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093","attachment.bsoCategory.DiagnosticReport":"\u8A3A\u65AD\u30EC\u30DD\u30FC\u30C8","attachment.bsoCategory.InvoiceDocument":"\u8ACB\u6C42\u66F8","attachment.bsoCategory.ShippingDocument":"\u51FA\u8377\u66F8\u985E","attachment.bsoCategory.Letter":"\u624B\u7D19","attachment.bsoCategory.PictureReference":"\u753B\u50CF\u53C2\u7167","attachment.bsoCategory.BugReport":"\u30D0\u30B0\u30EC\u30DD\u30FC\u30C8","attachment.bsoCategory.Other":"\u305D\u306E\u4ED6","attachment.bsoCategory.Unclassified":"\u672A\u5206\u985E","attachment.bsoCategory.ServiceForms":"\u30B5\u30FC\u30D3\u30B9\u30D5\u30A9\u30FC\u30E0","attachment.bsoCategory.RegistrationDocument":"\u767B\u9332\u66F8\u985E","attachment.bsoCategory.ShopInside":"\u5E97\u5185\u306E\u5199\u771F","attachment.bsoCategory.ShopImageMigration":"\u30B7\u30E7\u30C3\u30D7\u753B\u50CF\u306E\u79FB\u884C","attachment.bsoCategory.ShopImage":"\u5E97\u982D\u5199\u771F","attachment.uploadButton":"{{category}}\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9","attachment.uploadDropdown":"\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9"}');

},{}],"kAEWc":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"validation.maxAttachments":"{{max}}\uAC1C\uC758 \uD30C\uC77C\uB9CC \uCCA8\uBD80\uD560 \uC218 \uC788\uC5B4\uC694.","validation.minAttachments":"{{min}}\uAC1C \uC774\uC0C1\uC758 \uCCA8\uBD80 \uD30C\uC77C\uC774 \uD544\uC694\uD574\uC694.","validation.maxAttachmentSize":"\uCCA8\uBD80 \uD30C\uC77C\uC740 {{max}}MB\uB97C \uCD08\uACFC\uD560 \uC218 \uC5C6\uC5B4\uC694.","validation.attachmentListItemRequired":"{{category}}\\"\uC5D0 \uB300\uD55C \uCCA8\uBD80 \uD30C\uC77C\uC744 \uC81C\uACF5\uD558\uC138\uC694.","validation.attachmentListItemMaxAttachments":"{{category}}\\"\uC5D0 \uB300\uD55C {{max}}\uAC1C\uC758 \uCCA8\uBD80 \uD30C\uC77C\uB9CC \uD5C8\uC6A9\uB429\uB2C8\uB2E4.","validation.attachmentListItemMaxAttachmentSize":"{{category}} \uCCA8\uBD80 \uD30C\uC77C\uC740 {{max}} \uBA54\uAC00\uBC14\uC774\uD2B8\uBCF4\uB2E4 \uD074 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.","attachment.bsoCategory.DiagnosticReport":"\uC9C4\uB2E8 \uB9AC\uD3EC\uD2B8","attachment.bsoCategory.InvoiceDocument":"\uCCAD\uAD6C\uC11C","attachment.bsoCategory.ShippingDocument":"\uBC30\uC1A1 \uC11C\uB958","attachment.bsoCategory.Letter":"\uD3B8\uC9C0","attachment.bsoCategory.PictureReference":"\uC0AC\uC9C4 \uCC38\uACE0","attachment.bsoCategory.BugReport":"\uBC84\uADF8 \uB9AC\uD3EC\uD2B8","attachment.bsoCategory.Other":"\uAE30\uD0C0","attachment.bsoCategory.Unclassified":"\uBD84\uB958\uB418\uC9C0 \uC54A\uC74C","attachment.bsoCategory.ServiceForms":"\uC11C\uBE44\uC2A4 \uC2E0\uCCAD\uC11C","attachment.bsoCategory.RegistrationDocument":"\uB4F1\uB85D \uC11C\uB958","attachment.bsoCategory.ShopInside":"\uB9E4\uC7A5 \uB0B4\uBD80 \uC0AC\uC9C4","attachment.bsoCategory.ShopImageMigration":"\uB9E4\uC7A5 \uC774\uBBF8\uC9C0 \uC774\uC804","attachment.bsoCategory.ShopImage":"\uB9E4\uC7A5 \uC678\uAD00 \uC0AC\uC9C4","attachment.uploadButton":"{{category}} \uC5C5\uB85C\uB4DC","attachment.uploadDropdown":"\uD30C\uC77C \uC5C5\uB85C\uB4DC"}');

},{}],"dAjJp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coreApplication = require("@form-engine/core-application");
var _coreApplicationDefault = parcelHelpers.interopDefault(_coreApplication);
var _attachmentsElement = require("../components/attachments-element");
const BsoAttachmentListValidation = (element, _value, session)=>{
    // only validate supported attachment element configurations
    if (element.type !== (0, _attachmentsElement.apiName) || !element.renderAsList || !element.multiple || !element.listSettings?.length) return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { uploads = [] } = session.elements?.[element.id] ?? {};
    const { c } = (0, _coreApplicationDefault.default).i18n;
    const label = element?.label ?? element?.name;
    for (const uploadSetting of element.listSettings){
        const currentUploads = uploads?.filter((u)=>u.bsoCategory === uploadSetting.bsoCategory) ?? [];
        const category = c(`attachment.bsoCategory.${uploadSetting.bsoCategory || (0, _attachmentsElement.defaultCategory)}`);
        if (uploadSetting.required && !currentUploads.length) return c('validation.attachmentListItemRequired', {
            label,
            category
        });
        if (uploadSetting.validationMaxAttachments) {
            const max = Number(uploadSetting.validationMaxAttachments);
            if (currentUploads.length > max) return c('validation.attachmentListItemMaxAttachments', {
                label,
                category,
                max
            });
        }
        if (uploadSetting.validationMaxAttachmentSize) {
            const max = Number(uploadSetting.validationMaxAttachmentSize) * 1048576;
            for (const { file } of currentUploads){
                if (file.size > max) return c('validation.attachmentListItemMaxAttachmentSize', {
                    label,
                    category,
                    max: uploadSetting.validationMaxAttachmentSize
                });
            }
        }
    }
    return null;
};
exports.default = BsoAttachmentListValidation;

},{"@form-engine/core-application":"fjN6J","../components/attachments-element":"3NvWx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bJfzW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormEngineValidateContentType", ()=>(0, _contentTypeDefault.default));
parcelHelpers.export(exports, "FormEngineValidateMaxLength", ()=>(0, _maxLengthDefault.default));
parcelHelpers.export(exports, "FormEngineValidateMinLength", ()=>(0, _minLengthDefault.default));
var _contentType = require("./content-type");
var _contentTypeDefault = parcelHelpers.interopDefault(_contentType);
var _maxLength = require("./max-length");
var _maxLengthDefault = parcelHelpers.interopDefault(_maxLength);
var _minLength = require("./min-length");
var _minLengthDefault = parcelHelpers.interopDefault(_minLength);

},{"./content-type":"7jaeP","./max-length":"AQ438","./min-length":"98I3E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7jaeP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _contentTypes = require("./content-types");
const contentTypeMap = _contentTypes;
exports.default = function FormEngineValidateContentType(element, value, session) {
    const { validationContentType: type = 'FormEngineValidateContentTypeText' } = element;
    if (!type || !contentTypeMap[String(type)]) return null;
    return contentTypeMap[String(type)](element, value, session);
};

},{"./content-types":"lTsic","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lTsic":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormEngineValidateContentTypeAlphanumeric", ()=>(0, _alphanumericDefault.default));
parcelHelpers.export(exports, "FormEngineValidateContentTypeDate", ()=>(0, _dateDefault.default));
parcelHelpers.export(exports, "FormEngineValidateContentTypeDatetime", ()=>(0, _datetimeDefault.default));
parcelHelpers.export(exports, "FormEngineValidateContentTypeEmail", ()=>(0, _emailDefault.default));
parcelHelpers.export(exports, "FormEngineValidateContentTypeInteger", ()=>(0, _integerDefault.default));
parcelHelpers.export(exports, "FormEngineValidateContentTypeNumber", ()=>(0, _numberDefault.default));
parcelHelpers.export(exports, "FormEngineValidateContentTypeRegex", ()=>(0, _regexDefault.default));
parcelHelpers.export(exports, "FormEngineValidateContentTypeText", ()=>(0, _textDefault.default));
parcelHelpers.export(exports, "FormEngineValidateContentTypeTime", ()=>(0, _timeDefault.default));
parcelHelpers.export(exports, "FormEngineValidateContentTypeUrl", ()=>(0, _urlDefault.default));
var _alphanumeric = require("./alphanumeric");
var _alphanumericDefault = parcelHelpers.interopDefault(_alphanumeric);
var _date = require("./date");
var _dateDefault = parcelHelpers.interopDefault(_date);
var _datetime = require("./datetime");
var _datetimeDefault = parcelHelpers.interopDefault(_datetime);
var _email = require("./email");
var _emailDefault = parcelHelpers.interopDefault(_email);
var _integer = require("./integer");
var _integerDefault = parcelHelpers.interopDefault(_integer);
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);
var _regex = require("./regex");
var _regexDefault = parcelHelpers.interopDefault(_regex);
var _text = require("./text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _time = require("./time");
var _timeDefault = parcelHelpers.interopDefault(_time);
var _url = require("./url");
var _urlDefault = parcelHelpers.interopDefault(_url);

},{"./alphanumeric":"avNa0","./date":"7IMru","./datetime":"5kZWC","./email":"4l05G","./integer":"gQflo","./number":"2LD0h","./regex":"7b4SI","./text":"dAAYd","./time":"2p5h0","./url":"fwrle","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avNa0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGEX", ()=>REGEX);
var _ = require("../../..");
var _Default = parcelHelpers.interopDefault(_);
const REGEX = /^[\p{L}\p{N}]*$/u;
exports.default = function FormEngineValidateContentTypeAlphanumeric(element, value) {
    if (value !== '' && !REGEX.test(value)) return (0, _Default.default).i18n.fallback(element.validateContentTypeMessage, 'validation.contentTypeAlphanumeric', {
        label: element.label || element.name
    });
    return null;
};

},{"../../..":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7IMru":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_MESSAGE", ()=>DEFAULT_MESSAGE);
var _template = require("@form-engine/core-util/template");
var _ = require("../../..");
var _Default = parcelHelpers.interopDefault(_);
const DEFAULT_MESSAGE = '{{label}} needs to be a date';
exports.default = function FormEngineValidateContentTypeDate(element, value, session) {
    const date = Date.parse(value);
    if (value === '') return null;
    if (isNaN(date)) return (0, _Default.default).i18n.fallback(element.validateContentTypeMessage, 'validation.contentTypeDate', {
        label: element.label || element.name
    });
    if (element.validateContentTypeDateBefore) {
        const beforeDate = Date.parse((0, _template.compile)(element.validateContentTypeDateBefore, session?.locals));
        if (!isNaN(beforeDate) && beforeDate < date) return (0, _Default.default).i18n.fallback(element.validateContentTypeMessage, 'validation.contentTypeDateBefore', {
            label: element.label || element.name,
            date,
            beforeDate
        });
    }
    if (element.validateContentTypeDateAfter) {
        const afterDate = Date.parse((0, _template.compile)(element.validateContentTypeDateAfter, session?.locals));
        if (!isNaN(afterDate) && afterDate > date) return (0, _Default.default).i18n.fallback(element.validateContentTypeMessage, 'validation.contentTypeDateAfter', {
            label: element.label || element.name,
            date,
            afterDate
        });
    }
    return null;
};

},{"@form-engine/core-util/template":"bKMue","../../..":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5kZWC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _template = require("@form-engine/core-util/template");
var _ = require("../../..");
var _Default = parcelHelpers.interopDefault(_);
/** @todo needs a more robust implementation */ exports.default = function FormEngineValidateContentTypeDatetime(element, value, session) {
    const date = Date.parse(value);
    if (value === '') return null;
    if (value !== '' && (isNaN(date) || !value.includes(':'))) return (0, _Default.default).i18n.fallback(element.validateContentTypeMessage, 'validation.contentTypeDatetime', {
        label: element.label || element.name
    });
    if (element.validateContentTypeDateBefore) {
        const beforeDate = Date.parse((0, _template.compile)(element.validateContentTypeDateBefore, session?.locals));
        if (!isNaN(beforeDate) && beforeDate > date) return (0, _Default.default).i18n.fallback(element.validateContentTypeMessage, 'validation.contentTypeDatetimeBefore', {
            label: element.label || element.name,
            date,
            beforeDate
        });
    }
    if (element.validateContentTypeDateAfter) {
        const afterDate = Date.parse((0, _template.compile)(element.validateContentTypeDateAfter, session?.locals));
        if (!isNaN(afterDate) && afterDate < date) return (0, _Default.default).i18n.fallback(element.validateContentTypeMessage, 'validation.contentTypeDatetimeAfter', {
            label: element.label || element.name,
            date,
            afterDate
        });
    }
    return null;
};

},{"@form-engine/core-util/template":"bKMue","../../..":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4l05G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGEX", ()=>REGEX);
var _ = require("../../..");
var _Default = parcelHelpers.interopDefault(_);
const REGEX = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
exports.default = function FormEngineValidateContentTypeEmail(element, value) {
    if (value !== '' && !REGEX.test(String(value || ''))) return (0, _Default.default).i18n.fallback(element.validateContentTypeMessage, 'validation.contentTypeEmail', {
        label: element.label || element.name
    });
    return null;
};

},{"../../..":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gQflo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGEX", ()=>REGEX);
var _ = require("../../..");
var _Default = parcelHelpers.interopDefault(_);
const REGEX = /^\d+$/;
exports.default = function FormEngineValidateContentTypeInteger(element, value) {
    if (value !== '' && !REGEX.test(value)) return (0, _Default.default).i18n.fallback(element.validateContentTypeMessage, 'validation.contentTypeInteger', {
        label: element.label || element.name
    });
    return null;
};

},{"../../..":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2LD0h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGEX", ()=>REGEX);
var _ = require("../../..");
var _Default = parcelHelpers.interopDefault(_);
const REGEX = /^[+-]?([0-9]*[.])?[0-9]+$/;
exports.default = function FormEngineValidateContentTypeNumber(element, value) {
    if (value !== '' && !REGEX.test(value)) return (0, _Default.default).i18n.fallback(element.validateContentTypeMessage, 'validation.contentTypeNumber', {
        label: element.label || element.name
    });
    return null;
};

},{"../../..":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7b4SI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ = require("../../..");
var _Default = parcelHelpers.interopDefault(_);
exports.default = function FormEngineValidateContentTypeRegex(element, value) {
    const { validateContentTypeRegex: pattern = false } = element;
    if (!pattern) return null;
    let regexp;
    try {
        regexp = new RegExp(pattern);
    } catch  {
        return null;
    }
    if (value !== '' && !regexp.test(value)) return (0, _Default.default).i18n.fallback(element.validateContentTypeMessage, 'validation.contentTypeRegex', {
        label: element.label || element.name
    });
    return null;
};

},{"../../..":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dAAYd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ = require("../../..");
var _Default = parcelHelpers.interopDefault(_);
exports.default = function FormEngineValidateContentTypeText(element, value) {
    if (typeof value !== 'string') return (0, _Default.default).i18n.fallback(element.validateContentTypeMessage, 'validation.contentTypeText', {
        label: element.label || element.name
    });
    return null;
};

},{"../../..":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2p5h0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGEX", ()=>REGEX);
var _ = require("../../..");
var _Default = parcelHelpers.interopDefault(_);
const REGEX = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
exports.default = function FormEngineValidateContentTypeTime(element, value) {
    if (value !== '' && !REGEX.test(value)) return (0, _Default.default).i18n.fallback(element.validateContentTypeMessage, 'validation.contentTypeTime', {
        label: element.label || element.name
    });
    return null;
};

},{"../../..":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fwrle":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGEX", ()=>REGEX);
var _ = require("../../..");
var _Default = parcelHelpers.interopDefault(_);
const REGEX = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;
exports.default = function FormEngineValidateContentTypeUrl(element, value) {
    if (value !== '' && !REGEX.test(value)) return (0, _Default.default).i18n.fallback(element.validateContentTypeMessage, 'validation.contentTypeUrl', {
        label: element.label || element.name
    });
    return null;
};

},{"../../..":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"AQ438":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ = require("../..");
var _Default = parcelHelpers.interopDefault(_);
exports.default = function FormEngineValidateMaxLength(element, value) {
    const max = parseInt(String(element.validationMaxLength || '0'), 10);
    if (!max || isNaN(max)) return null;
    if (value !== '' && value.length > max) return (0, _Default.default).i18n.fallback(element.validationMaxLengthMessage, 'validation.maxLength', {
        label: element.label || element.name,
        max
    });
    return null;
};

},{"../..":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"98I3E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ = require("../..");
var _Default = parcelHelpers.interopDefault(_);
exports.default = function FormEngineValidateMinLength(element, value) {
    const min = parseInt(String(element.validationMinLength || '0'), 10);
    if (!min || isNaN(min)) return null;
    if (value !== '' && value.length < min) return (0, _Default.default).i18n.fallback(element.validationMinLengthMessage, 'validation.minLength', {
        label: element.label || element.name,
        min
    });
    return null;
};

},{"../..":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"45jyA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerPlugin", ()=>registerPlugin);
parcelHelpers.export(exports, "registerImportedPluginModules", ()=>registerImportedPluginModules);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
function registerPlugin(target, definition) {
    // window.FormEngine = merge(window.FormEngine || {}, definition);
    return (0, _mergeDefault.default)(target || {}, definition);
}
function registerImportedPluginModules(target, moduleDictionary, modifier) {
    let result = target;
    Object.values(moduleDictionary).forEach((child)=>{
        result = registerPlugin(target, modifier ? modifier(child) : child);
    });
    return result;
}

},{"lodash/merge":"iHC1F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9DQ3u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18n", ()=>I18n);
var _useStore = require("../hooks/use-store");
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _template = require("@form-engine/core-util/template");
class I18n extends (0, _useStore.Store) {
    constructor(initialState){
        super({
            defaultLocale: 'default',
            locale: 'default',
            ...initialState ?? {},
            data: {
                ...initialState?.data ?? {}
            }
        }), this.t = (path)=>{
            const { locale, defaultLocale, data } = this.state;
            let result = (0, _getDefault.default)(data?.[locale] ?? {}, path);
            if (result !== undefined) return result;
            if (locale.includes('-')) {
                const [fallbackLocale] = locale.split('-');
                result = (0, _getDefault.default)(data?.[fallbackLocale] ?? {}, path);
                if (result !== undefined) return result;
            }
            result = (0, _getDefault.default)(data?.[defaultLocale] ?? {}, path);
            if (result !== undefined) return result;
            return '';
        }, this.c = (path, locals)=>{
            const result = this.t(path);
            if (!locals) return result;
            return (0, _template.compile)(result, locals);
        }, this.fallback = (source, fallbackPath, locals)=>{
            const sourceString = String(source ?? '').trim();
            const result = sourceString ? sourceString : this.t(fallbackPath);
            if (!locals) return result;
            return (0, _template.compile)(result, locals);
        }, this.Node = ({ id: path, ...locals })=>{
            return this.c(path, locals);
        }, this.prefix = (prefix)=>{
            function withPrefix(path) {
                if (Array.isArray(path)) return [
                    prefix,
                    ...path
                ];
                return `${prefix}${String(path)}`;
            }
            return {
                t: (...params)=>this.t(withPrefix(params[0])),
                c: (...params)=>{
                    const [path, ...rest] = params;
                    return this.c(withPrefix(path), ...rest);
                },
                fallback: (...params)=>{
                    const [source, path, ...rest] = params;
                    return this.fallback(source, withPrefix(path), ...rest);
                },
                Node: (props)=>this.Node({
                        ...props ?? {},
                        id: withPrefix(props.id)
                    }),
                prefix: (prefix)=>this.prefix(withPrefix(prefix))
            };
        };
    }
    get locale() {
        return this.state?.locale;
    }
    set locale(locale) {
        this.setItem('locale', locale);
    }
    get defaultLocale() {
        return this.state?.defaultLocale;
    }
    set defaultLocale(locale) {
        this.setItem('defaultLocale', locale);
    }
    getReference(eventData = {}) {
        const { state, previousState, set, setItem, unsetItem, clearAll, t, c, fallback, prefix, Node } = this;
        return {
            state,
            previousState,
            set,
            setItem,
            unsetItem,
            clearAll,
            eventData,
            t,
            c,
            fallback,
            prefix,
            Node
        };
    }
}

},{"../hooks/use-store":"llHXk","lodash/get":"dBTJh","@form-engine/core-util/template":"bKMue","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ajEzA":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PackagesDatasourcesJwt", ()=>(0, _builderPluginDefault.default));
parcelHelpers.export(exports, "PackagesDatasourcesStatic", ()=>(0, _builderPluginDefault1.default));
parcelHelpers.export(exports, "PackagesDatasourcesHttpRequest", ()=>(0, _builderPluginDefault2.default));
parcelHelpers.export(exports, "PackagesElementsPage", ()=>(0, _builderPluginDefault3.default));
parcelHelpers.export(exports, "PackagesElementsInput", ()=>(0, _builderPluginDefault4.default));
parcelHelpers.export(exports, "PackagesElementsMarkdown", ()=>(0, _builderPluginDefault5.default));
parcelHelpers.export(exports, "PackagesElementsRadios", ()=>(0, _builderPluginDefault6.default));
parcelHelpers.export(exports, "PackagesElementsCheckbox", ()=>(0, _builderPluginDefault7.default));
parcelHelpers.export(exports, "PackagesElementsNavigation", ()=>(0, _builderPluginDefault8.default));
parcelHelpers.export(exports, "PackagesElementsContainer", ()=>(0, _builderPluginDefault9.default));
parcelHelpers.export(exports, "PackagesElementsTextarea", ()=>(0, _builderPluginDefault10.default));
parcelHelpers.export(exports, "PackagesElementsButton", ()=>(0, _builderPluginDefault11.default));
parcelHelpers.export(exports, "PackagesElementsSelect", ()=>(0, _builderPluginDefault12.default));
parcelHelpers.export(exports, "PackagesWorkflowLayersRedirectWfl", ()=>(0, _builderPluginDefault13.default));
parcelHelpers.export(exports, "PackagesWorkflowLayersConditionWfl", ()=>(0, _builderPluginDefault14.default));
parcelHelpers.export(exports, "PackagesWorkflowLayersSignalWfl", ()=>(0, _builderPluginDefault15.default));
parcelHelpers.export(exports, "PackagesWorkflowLayersSetterWfl", ()=>(0, _builderPluginDefault16.default));
parcelHelpers.export(exports, "PackagesWorkflowLayersHttpRequest", ()=>(0, _builderPluginDefault17.default));
parcelHelpers.export(exports, "PackagesWorkflowLayersSessionLogWfl", ()=>(0, _builderPluginDefault18.default));
parcelHelpers.export(exports, "PackagesWorkflowLayersShowPageWfl", ()=>(0, _builderPluginDefault19.default));
parcelHelpers.export(exports, "PackagesBuilderMask", ()=>(0, _builderPluginDefault20.default));
parcelHelpers.export(exports, "PackagesBuilderFormEditor", ()=>(0, _builderPluginDefault21.default));
parcelHelpers.export(exports, "PackagesBuilderHub", ()=>(0, _builderPluginDefault22.default));
parcelHelpers.export(exports, "PackagesBsoCore", ()=>(0, _builderPluginDefault23.default));
parcelHelpers.export(exports, "PackagesBsoAttachmentInput", ()=>(0, _builderPluginDefault24.default));
var _builderPlugin = require("../../datasources/jwt/builder.plugin");
var _builderPluginDefault = parcelHelpers.interopDefault(_builderPlugin);
var _builderPlugin1 = require("../../datasources/static/builder.plugin");
var _builderPluginDefault1 = parcelHelpers.interopDefault(_builderPlugin1);
var _builderPlugin2 = require("../../datasources/http-request/builder.plugin");
var _builderPluginDefault2 = parcelHelpers.interopDefault(_builderPlugin2);
var _builderPlugin3 = require("../../elements/page/builder.plugin");
var _builderPluginDefault3 = parcelHelpers.interopDefault(_builderPlugin3);
var _builderPlugin4 = require("../../elements/input/builder.plugin");
var _builderPluginDefault4 = parcelHelpers.interopDefault(_builderPlugin4);
var _builderPlugin5 = require("../../elements/markdown/builder.plugin");
var _builderPluginDefault5 = parcelHelpers.interopDefault(_builderPlugin5);
var _builderPlugin6 = require("../../elements/radios/builder.plugin");
var _builderPluginDefault6 = parcelHelpers.interopDefault(_builderPlugin6);
var _builderPlugin7 = require("../../elements/checkbox/builder.plugin");
var _builderPluginDefault7 = parcelHelpers.interopDefault(_builderPlugin7);
var _builderPlugin8 = require("../../elements/navigation/builder.plugin");
var _builderPluginDefault8 = parcelHelpers.interopDefault(_builderPlugin8);
var _builderPlugin9 = require("../../elements/container/builder.plugin");
var _builderPluginDefault9 = parcelHelpers.interopDefault(_builderPlugin9);
var _builderPlugin10 = require("../../elements/textarea/builder.plugin");
var _builderPluginDefault10 = parcelHelpers.interopDefault(_builderPlugin10);
var _builderPlugin11 = require("../../elements/button/builder.plugin");
var _builderPluginDefault11 = parcelHelpers.interopDefault(_builderPlugin11);
var _builderPlugin12 = require("../../elements/select/builder.plugin");
var _builderPluginDefault12 = parcelHelpers.interopDefault(_builderPlugin12);
var _builderPlugin13 = require("../../workflow-layers/redirect-wfl/builder.plugin");
var _builderPluginDefault13 = parcelHelpers.interopDefault(_builderPlugin13);
var _builderPlugin14 = require("../../workflow-layers/condition-wfl/builder.plugin");
var _builderPluginDefault14 = parcelHelpers.interopDefault(_builderPlugin14);
var _builderPlugin15 = require("../../workflow-layers/signal-wfl/builder.plugin");
var _builderPluginDefault15 = parcelHelpers.interopDefault(_builderPlugin15);
var _builderPlugin16 = require("../../workflow-layers/setter-wfl/builder.plugin");
var _builderPluginDefault16 = parcelHelpers.interopDefault(_builderPlugin16);
var _builderPlugin17 = require("../../workflow-layers/http-request/builder.plugin");
var _builderPluginDefault17 = parcelHelpers.interopDefault(_builderPlugin17);
var _builderPlugin18 = require("../../workflow-layers/session-log-wfl/builder.plugin");
var _builderPluginDefault18 = parcelHelpers.interopDefault(_builderPlugin18);
var _builderPlugin19 = require("../../workflow-layers/show-page-wfl/builder.plugin");
var _builderPluginDefault19 = parcelHelpers.interopDefault(_builderPlugin19);
var _builderPlugin20 = require("../../builder/mask/builder.plugin");
var _builderPluginDefault20 = parcelHelpers.interopDefault(_builderPlugin20);
var _builderPlugin21 = require("../../builder/form-editor/builder.plugin");
var _builderPluginDefault21 = parcelHelpers.interopDefault(_builderPlugin21);
var _builderPlugin22 = require("../../builder/hub/builder.plugin");
var _builderPluginDefault22 = parcelHelpers.interopDefault(_builderPlugin22);
var _builderPlugin23 = require("../../bso/core/builder.plugin");
var _builderPluginDefault23 = parcelHelpers.interopDefault(_builderPlugin23);
var _builderPlugin24 = require("../../bso/attachment-input/builder.plugin");
var _builderPluginDefault24 = parcelHelpers.interopDefault(_builderPlugin24);

},{"../../datasources/jwt/builder.plugin":"4kZqm","../../datasources/static/builder.plugin":"9Hwhc","../../datasources/http-request/builder.plugin":"7m4JD","../../elements/page/builder.plugin":"fVzsL","../../elements/input/builder.plugin":"ajZzi","../../elements/markdown/builder.plugin":"8OI9M","../../elements/radios/builder.plugin":"iQSXY","../../elements/checkbox/builder.plugin":"gMILk","../../elements/navigation/builder.plugin":"llYCK","../../elements/container/builder.plugin":"01bJA","../../elements/textarea/builder.plugin":"gI8ie","../../elements/button/builder.plugin":"lR9P2","../../elements/select/builder.plugin":"5c4JG","../../workflow-layers/redirect-wfl/builder.plugin":"l16BS","../../workflow-layers/condition-wfl/builder.plugin":"kMdza","../../workflow-layers/signal-wfl/builder.plugin":"kbWTZ","../../workflow-layers/setter-wfl/builder.plugin":"2ES9c","../../workflow-layers/http-request/builder.plugin":"a1z33","../../workflow-layers/session-log-wfl/builder.plugin":"21CZk","../../workflow-layers/show-page-wfl/builder.plugin":"9OyPY","../../builder/mask/builder.plugin":"6Xxeo","../../builder/form-editor/builder.plugin":"c4ZFi","../../builder/hub/builder.plugin":"g464e","../../bso/core/builder.plugin":"gqrmd","../../bso/attachment-input/builder.plugin":"ewf5P","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kZqm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jwtDatasourceMask = require("./components/jwt-datasource-mask");
var _jwtDatasourceMaskDefault = parcelHelpers.interopDefault(_jwtDatasourceMask);
var _jwtDatasource = require("./datasources/jwt-datasource");
var _jwtDatasourceDefault = parcelHelpers.interopDefault(_jwtDatasource);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _defaultJwtReader = require("./presets/default-jwt-reader");
var _defaultJwtReaderDefault = parcelHelpers.interopDefault(_defaultJwtReader);
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    datasources: {
        [(0, _jwtDatasourceDefault.default).apiName]: {
            label: `${(0, _jwtDatasourceDefault.default).apiName}.title`,
            description: `${(0, _jwtDatasourceDefault.default).apiName}.description`,
            exposesOptions: false,
            Icon: (0, _reactBootstrapIcons.FilePerson),
            Datasource: (0, _jwtDatasourceDefault.default),
            Mask: (0, _jwtDatasourceMaskDefault.default)
        }
    },
    formPresets: {
        DefaultJwtReaderDatasourcePreset: (0, _defaultJwtReaderDefault.default)
    }
};

},{"./components/jwt-datasource-mask":"jU9T7","./datasources/jwt-datasource":"bzMgD","react-bootstrap-icons":"3TzoC","./presets/default-jwt-reader":"b0URj","./builder-translations":"b9xPF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jU9T7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderJwtDatasourceSetup", ()=>BuilderJwtDatasourceSetup);
parcelHelpers.export(exports, "default", ()=>BuilderJwtDatasourceMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _string = require("@form-engine/builder-mask/components/properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _jwtDatasource = require("../datasources/jwt-datasource");
var _name = require("@form-engine/builder-mask/components/properties/name");
var _nameDefault = parcelHelpers.interopDefault(_name);
var _jwtDatasourceDefault = parcelHelpers.interopDefault(_jwtDatasource);
var _builderApplication = require("@form-engine/builder-application");
function BuilderJwtDatasourceSetup() {
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _jwtDatasourceDefault.default).apiName}.`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nameDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "description",
                        label: c('description')
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                label: "JWT",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "jwtSource",
                        label: c('jwtSource'),
                        defaultValue: (0, _jwtDatasource.DEFAULT_JWT_PATH)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "jwtOutput",
                        label: c('jwtOutput'),
                        defaultValue: (0, _jwtDatasource.DEFAULT_OUTPUT_PATH)
                    })
                ]
            })
        ]
    });
}
function BuilderJwtDatasourceMask() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "feb-view",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "feb-view-inner",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                        xl: {
                            span: 8,
                            offset: 2
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderJwtDatasourceSetup, {})
                    })
                })
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/properties/string":"e6M7S","../datasources/jwt-datasource":"bzMgD","@form-engine/builder-mask/components/properties/name":"cCuUh","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1nZOW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderMaskGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function BuilderMaskGroup({ label, children, className = '', id }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `feb-mask-group ${className}`,
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "feb-mask-group-head",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                    children: label
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "feb-mask-group-body",
                children: [
                    id && (0, _builderApplicationDefault.default).renderComponentExtensions(id, ({ placement })=>placement === 'before'),
                    children,
                    id && (0, _builderApplicationDefault.default).renderComponentExtensions(id, ({ placement })=>placement === 'after')
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-application":"7iKr0","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e6M7S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderStringProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _property = require("../mask/property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _useMask = require("../../hooks/use-mask");
var _insertVariable = require("../wizards/insert-variable");
var _insertVariableDefault = parcelHelpers.interopDefault(_insertVariable);
var _useMaskConfig = require("../../hooks/use-mask-config");
var _useMaskValidation = require("../../hooks/use-mask-validation");
function BuilderStringProperty({ label, propertyName, defaultValue = '', prefix, suffix, variableOptions, // avg word length = 5, avg type speed = 40 words per minute, = 60000 / 40 / 5
formatter, ...props }) {
    const stacked = 'stacked' in props && props.stacked !== false;
    delete props.stacked;
    const compilable = 'compilable' in props && props.compilable !== false;
    delete props.compilable;
    const { state, setItemProperty } = (0, _useMask.useMaskContext)();
    const value = String(typeof state?.[propertyName] === 'string' ? state[propertyName] : defaultValue);
    const [currentValue, setCurrentValue] = (0, _react.useState)(value);
    (0, _react.useEffect)(()=>{
        setCurrentValue(value);
    }, [
        value,
        setCurrentValue
    ]);
    const handleChange = (0, _react.useCallback)((newValue)=>{
        if (typeof formatter === 'function') newValue = formatter(newValue, propertyName, state);
        if (newValue !== state?.[propertyName]) setItemProperty(propertyName, newValue);
    }, [
        setItemProperty,
        state,
        propertyName,
        formatter
    ]);
    const permission = (0, _useMaskConfig.useMaskPropertyPermission)(propertyName);
    const error = (0, _useMaskValidation.useMaskPropertyError)(propertyName);
    const control = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
        size: "sm",
        ...props,
        value: currentValue,
        disabled: permission === 'read',
        onChange: (e)=>{
            const { value } = e.target;
            setCurrentValue(value);
            handleChange(value);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertyDefault.default), {
        className: "feb-string-property",
        label: label,
        error: error?.message,
        stacked: stacked,
        children: prefix || suffix || compilable ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.InputGroup), {
            children: [
                prefix,
                control,
                suffix,
                compilable && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _insertVariableDefault.default), {
                    disabled: permission === 'read',
                    propertyName: propertyName,
                    options: variableOptions
                })
            ]
        }) : control
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","../mask/property":"dLorN","../../hooks/use-mask":"72MTY","../wizards/insert-variable":"iFouO","../../hooks/use-mask-config":"daHU1","../../hooks/use-mask-validation":"cYKiY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dLorN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
function BuilderProperty({ label, error, children, className = '', ...props }) {
    const stacked = 'stacked' in props && props.stacked !== false;
    delete props.stacked;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
        ...props,
        className: `fe-property ${className}`,
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormLabel), {
                column: true,
                sm: stacked ? 12 : 4,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                className: "d-flex align-items-center justify-content-end",
                children: children
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                className: "text-danger text-sm",
                sm: {
                    span: stacked ? 12 : 8,
                    offset: stacked ? undefined : 4
                },
                children: error
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"72MTY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MaskContext", ()=>MaskContext);
parcelHelpers.export(exports, "getMaskProviderValueFromStore", ()=>getMaskProviderValueFromStore);
parcelHelpers.export(exports, "MaskProvider", ()=>MaskProvider);
parcelHelpers.export(exports, "StoreMaskProvider", ()=>StoreMaskProvider);
parcelHelpers.export(exports, "useMaskContext", ()=>useMaskContext);
parcelHelpers.export(exports, "useMaskProperty", ()=>useMaskProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const MaskContext = /*#__PURE__*/ (0, _react.createContext)(null);
function getMaskProviderValueFromStore(ref) {
    const setItemProperty = (0, _react.useMemo)(()=>{
        return (key, value)=>{
            ref?.setItem?.(key, value);
        };
    }, [
        ref?.setItem
    ]);
    if (!ref) return;
    return {
        setItemProperty,
        setItem: ref.setItem,
        state: ref.state
    };
}
function MaskProvider({ value, children }) {
    if (!value) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MaskContext.Provider, {
        value: value,
        children: typeof children === 'function' ? children(value) : children
    });
}
function StoreMaskProvider({ store, children }) {
    const value = (0, _react.useMemo)(()=>{
        if (!store) return null;
        return {
            state: store.state,
            setItem: store.set,
            setItemProperty: (propertyName, value)=>{
                store.setItem(propertyName, value);
            }
        };
    }, [
        store
    ]);
    if (!store) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MaskProvider, {
        value: value ?? undefined,
        children: children
    });
}
function useMaskContext() {
    const context = (0, _react.useContext)(MaskContext);
    if (!context) throw new Error('tried to use mask context without provider');
    return context;
}
function useMaskProperty(propertyName, fallback) {
    const { state, setItemProperty } = useMaskContext();
    const value = state && propertyName in state ? state[propertyName] : fallback;
    const setProperty = (0, _react.useCallback)((setterOrValue)=>{
        let update;
        if (typeof setterOrValue === 'function') update = setterOrValue(value);
        else update = setterOrValue;
        if (update !== value) setItemProperty(propertyName, update);
    }, [
        state,
        value,
        propertyName,
        setItemProperty
    ]);
    return [
        value,
        setProperty
    ];
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iFouO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderInsertVariableWizard);
var _jsxRuntime = require("react/jsx-runtime");
var _variableSelect = require("@form-engine/builder-application/components/variable-select");
var _variableSelectDefault = parcelHelpers.interopDefault(_variableSelect);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useMask = require("../../../hooks/use-mask");
function BuilderInsertVariableWizard({ propertyName, ...props }) {
    const [value, setValue] = (0, _useMask.useMaskProperty)(propertyName);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _variableSelectDefault.default), {
        ...props,
        value: value,
        onChange: setValue
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-application/components/variable-select":"fDZcE","react":"9njXz","../../../hooks/use-mask":"72MTY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fDZcE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STATIC_VARIABLE_OPTIONS", ()=>STATIC_VARIABLE_OPTIONS);
parcelHelpers.export(exports, "BuilderInsertVariableSelector", ()=>BuilderInsertVariableSelector);
parcelHelpers.export(exports, "default", ()=>BuilderVariableSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _coreApplication = require("@form-engine/core-application");
var _coreApplicationDefault = parcelHelpers.interopDefault(_coreApplication);
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _select = require("../select");
var _selectDefault = parcelHelpers.interopDefault(_select);
const STATIC_VARIABLE_OPTIONS = [
    'request.',
    'request.headers',
    'request.headers.authorization',
    'locale',
    'jwt.',
    'bso.'
];
function resolveVariableOptions(form) {
    const options = [
        ...STATIC_VARIABLE_OPTIONS
    ];
    if (!form) return options;
    form?.elements?.forEach((element)=>{
        const isField = element?.type && element?.type in (0, _coreApplicationDefault.default).getFieldElements();
        if (element.name && isField) options.push(`values.${element.name}`);
    });
    form?.constants?.forEach((constant)=>{
        if (constant.id) options.push(constant.id);
    });
    return options;
}
function BuilderInsertVariableSelector({ options: additionalOptions, onChange, value }) {
    const { state: form } = (0, _useForm.useFormContext)();
    const options = (0, _react.useMemo)(()=>[
            ...resolveVariableOptions(form),
            ...additionalOptions ?? []
        ].sort().map((v)=>({
                value: `{{${v}}}`,
                label: v
            })), [
        form,
        additionalOptions
    ]);
    const handleChange = (0, _react.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e)=>{
        onChange?.(`${value ?? ''}${e?.target?.value ?? ''}`);
    }, [
        value,
        onChange
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            height: 250,
            width: 250,
            overflow: 'hidden'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default).Advanced, {
            className: "feb-variable-select",
            options: options,
            placeholder: "Search\u2026",
            menuIsOpen: true,
            minMenuHeight: 222,
            maxMenuHeight: 222,
            style: {
                width: '100%'
            },
            onChange: handleChange
        })
    });
}
const BuilderVariableSelectPopover = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(({ options, value, onChange, ...props }, ref)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Popover), {
        ref: ref,
        body: true,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                overflowY: 'auto',
                margin: '-16px',
                fontSize: '12px'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderInsertVariableSelector, {
                value: value,
                onChange: onChange,
                options: options
            })
        })
    });
});
BuilderVariableSelectPopover.displayName = 'BuilderVariableSelectPopover';
function BuilderVariableSelect({ value, onChange, children, options, disabled }) {
    const button = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
        variant: "outline-dark",
        size: "sm",
        disabled: disabled,
        style: {
            pointerEvents: disabled ? 'none' : 'initial'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.Braces), {})
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.OverlayTrigger), {
        trigger: "click",
        rootClose: true,
        transition: false,
        overlay: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderVariableSelectPopover, {
            value: value,
            onChange: onChange,
            options: options
        }),
        children: children ?? button
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application":"fjN6J","@form-engine/core-application/hooks/use-form":"5PZyy","react":"9njXz","react-bootstrap":"f5rnA","react-bootstrap-icons":"3TzoC","../select":"38vFU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"38vFU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderFormSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _advanced = require("./advanced");
function BuilderFormSelect({ advanced, ...props }) {
    // eslint-disable-next-line react/prop-types
    if (props.options || advanced) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _advanced.BuilderAdvancedFormSelect), {
        ...props
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormSelect), {
        ...props
    });
}
BuilderFormSelect.Advanced = (0, _advanced.BuilderAdvancedFormSelect);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","./advanced":"h5QTD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h5QTD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderAdvancedFormSelect", ()=>BuilderAdvancedFormSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _advanced = require("@form-engine/core-application/components/select/advanced");
var _classNames = require("@form-engine/core-util/class-names");
var _classNamesDefault = parcelHelpers.interopDefault(_classNames);
var _react = require("react");
const BuilderAdvancedFormSelect = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _advanced.FormEngineAdvancedFormSelect), {
        ...props,
        className: (0, _classNamesDefault.default)(props.className, 'fe-builder-select'),
        ref: ref
    }));
BuilderAdvancedFormSelect.displayName = 'BuilderAdvancedFormSelect';

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/components/select/advanced":"ivs8x","@form-engine/core-util/class-names":"fk8HN","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"daHU1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MaskConfigContextValueDefaults", ()=>MaskConfigContextValueDefaults);
parcelHelpers.export(exports, "MaskContext", ()=>MaskContext);
parcelHelpers.export(exports, "MaskConfigProvider", ()=>MaskConfigProvider);
parcelHelpers.export(exports, "useMaskConfigContext", ()=>useMaskConfigContext);
parcelHelpers.export(exports, "useMaskPropertyPermission", ()=>useMaskPropertyPermission);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useMaskValidation = require("./use-mask-validation");
const MaskConfigContextValueDefaults = {};
const MaskContext = /*#__PURE__*/ (0, _react.createContext)(null);
function MaskConfigProvider({ value, children }) {
    if (!value) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MaskContext.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useMaskValidation.MaskValidationProvider), {
            children: typeof children === 'function' ? children(value) : children
        })
    });
}
function useMaskConfigContext() {
    const context = (0, _react.useContext)(MaskContext);
    if (!context) throw new Error('tried to use mask context config without provider');
    return context;
}
function useMaskPropertyPermission(propertyName, fallback) {
    const context = (0, _react.useContext)(MaskContext);
    return context?.permissions?.[propertyName] ?? fallback;
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./use-mask-validation":"cYKiY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cYKiY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MaskValidationContext", ()=>MaskValidationContext);
parcelHelpers.export(exports, "MaskValidationProvider", ()=>MaskValidationProvider);
parcelHelpers.export(exports, "useMaskValidationContext", ()=>useMaskValidationContext);
parcelHelpers.export(exports, "useMaskPropertyError", ()=>useMaskPropertyError);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useMask = require("./use-mask");
var _useMaskConfig = require("./use-mask-config");
const MaskValidationContext = /*#__PURE__*/ (0, _react.createContext)(null);
function MaskValidationProvider({ children }) {
    const { state } = (0, _useMask.useMaskContext)();
    const { schema } = (0, _useMaskConfig.useMaskConfigContext)();
    const value = (0, _react.useMemo)(()=>schema?.safeParse(state) ?? null, [
        state,
        schema
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MaskValidationContext.Provider, {
        value: value,
        children: children
    });
}
function useMaskValidationContext() {
    return (0, _react.useContext)(MaskValidationContext) ?? null;
}
function useMaskPropertyError(propertyName) {
    const context = (0, _react.useContext)(MaskValidationContext);
    return (0, _react.useMemo)(()=>{
        if (!context || context.success === true) return null;
        for (const issue of context.error.issues ?? []){
            if (issue.path[0] === propertyName) return issue;
        }
        return null;
    }, [
        context,
        propertyName
    ]);
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./use-mask":"72MTY","./use-mask-config":"daHU1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cCuUh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderNameProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _formatCase = require("@form-engine/core-util/format-case");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _string = require("./string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _builderApplication = require("@form-engine/builder-application");
function BuilderNameProperty(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
        label: (0, _builderApplication.i18n).c('mask.nameProperty.title'),
        ...props,
        formatter: (0, _formatCase.formatResourceNameCase),
        propertyName: props.propertyName ?? 'name'
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-util/format-case":"2G0oK","react":"9njXz","./string":"e6M7S","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b0URj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _uuid = require("@form-engine/core-util/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _jwtDatasource = require("../datasources/jwt-datasource");
exports.default = {
    name: 'Default Jwt Reader',
    required: true,
    init (form) {
        form?.datasources?.push({
            id: (0, _uuidDefault.default)(),
            type: (0, _jwtDatasource.apiName),
            name: 'Jwt Reader',
            description: 'Provides given json webtoken contents inside of the forms local variables'
        });
    }
};

},{"@form-engine/core-util/uuid":"eZttN","../datasources/jwt-datasource":"bzMgD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b9xPF":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"3qPa6","./de.json":"cRyl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3qPa6":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineJwtDatasource\":{\"title\":\"JWT Data\",\"description\":\"Read data from a given JSON Web Token\"},\"mask\":{\"FormEngineJwtDatasource\":{\"description\":\"Description\",\"jwtSource\":\"Token Source\",\"jwtOutput\":\"Output Name\"}}}");

},{}],"cRyl5":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineJwtDatasource\":{\"title\":\"JWT-Daten\",\"description\":\"Lesen Sie Daten aus einem bestimmten JSON-Web-Token\"},\"mask\":{\"FormEngineJwtDatasource\":{\"description\":\"Beschreibung\",\"jwtSource\":\"Token-Quelle\",\"jwtOutput\":\"Ausgabename\"}}}");

},{}],"9Hwhc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _staticDatasourceMask = require("./components/static-datasource-mask");
var _staticDatasourceMaskDefault = parcelHelpers.interopDefault(_staticDatasourceMask);
var _staticDatasource = require("./datasources/static-datasource");
var _staticDatasourceDefault = parcelHelpers.interopDefault(_staticDatasource);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    datasources: {
        [(0, _staticDatasourceDefault.default).apiName]: {
            label: `${(0, _staticDatasourceDefault.default).apiName}.title`,
            description: `${(0, _staticDatasourceDefault.default).apiName}.description`,
            exposesOptions: true,
            Icon: (0, _reactBootstrapIcons.FileSpreadsheet),
            Datasource: (0, _staticDatasourceDefault.default),
            Mask: (0, _staticDatasourceMaskDefault.default)
        }
    }
};

},{"./components/static-datasource-mask":"iQSAY","./datasources/static-datasource":"h0bDq","react-bootstrap-icons":"3TzoC","./builder-translations":"vl6mJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iQSAY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderStaticDatasourceSetup", ()=>BuilderStaticDatasourceSetup);
parcelHelpers.export(exports, "default", ()=>BuilderStaticDatasourceMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _useFormEditor = require("@form-engine/builder-form-editor/hooks/use-form-editor");
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _datasourceDataTable = require("@form-engine/builder-application/components/datasource-data-table");
var _datasourceDataTableDefault = parcelHelpers.interopDefault(_datasourceDataTable);
var _drawerTabs = require("@form-engine/builder-application/components/drawer-tabs");
var _drawerTabsDefault = parcelHelpers.interopDefault(_drawerTabs);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _code = require("@form-engine/builder-mask/components/properties/code");
var _codeDefault = parcelHelpers.interopDefault(_code);
var _enum = require("@form-engine/builder-mask/components/properties/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _string = require("@form-engine/builder-mask/components/properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _name = require("@form-engine/builder-mask/components/properties/name");
var _nameDefault = parcelHelpers.interopDefault(_name);
var _staticDatasource = require("../datasources/static-datasource");
var _staticDatasourceDefault = parcelHelpers.interopDefault(_staticDatasource);
var _builderApplication = require("@form-engine/builder-application");
function BuilderStaticDatasourceSetup() {
    const { state } = (0, _useMask.useMaskContext)();
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _staticDatasourceDefault.default).apiName}.`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nameDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "description",
                        label: c('description')
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                label: c('contentGroupTitle'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                        propertyName: "sourceType",
                        label: c('sourceType'),
                        options: [
                            [
                                'csv',
                                'CSV'
                            ],
                            [
                                'json',
                                'JSON'
                            ],
                            [
                                'variable',
                                'Variable'
                            ]
                        ]
                    }),
                    state?.sourceType === 'json' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "resultPath",
                        label: c('resultPath'),
                        placeholder: c('resultPathPlaceholder')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "labelColumn",
                        label: c('labelColumn'),
                        placeholder: c('labelColumnPlaceholder'),
                        compilable: true,
                        variableOptions: [
                            '$i.'
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "valueColumn",
                        label: c('valueColumn'),
                        placeholder: c('valueColumnPlaceholder'),
                        compilable: true,
                        variableOptions: [
                            '$i.'
                        ]
                    }),
                    state?.sourceType === 'variable' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "source",
                        label: c('source')
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _codeDefault.default), {
                        propertyName: "source",
                        label: c('source'),
                        language: String(state?.sourceType || 'csv')
                    })
                ]
            })
        ]
    });
}
function BuilderStaticDatasourceMask({ id }) {
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _staticDatasourceDefault.default).apiName}.`);
    const { state: editor, setItem: setEditorItem } = (0, _useFormEditor.useFormEditorContext)();
    const { tab = 'setup' } = (editor.datasources ?? {})[id] ?? {};
    const setTab = (0, _react.useCallback)((tab)=>{
        const { datasources = {} } = editor;
        const { [id]: datasource = {} } = datasources;
        setEditorItem('datasources', {
            ...datasources,
            [id]: {
                ...datasource,
                tab
            }
        });
    }, [
        editor,
        setEditorItem,
        id
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerTabsDefault.default), {
                activeKey: tab,
                items: {
                    setup: c('setup'),
                    data: c('data')
                },
                onChange: setTab
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "feb-view",
                children: [
                    tab === 'setup' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "feb-view-inner",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                                xl: {
                                    span: 8,
                                    offset: 2
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderStaticDatasourceSetup, {})
                            })
                        })
                    }),
                    tab === 'data' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "feb-view-inner p-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datasourceDataTableDefault.default), {
                            id: id
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","@form-engine/builder-form-editor/hooks/use-form-editor":"4pkiD","@form-engine/builder-mask/hooks/use-mask":"72MTY","@form-engine/builder-application/components/datasource-data-table":"2ROOD","@form-engine/builder-application/components/drawer-tabs":"5gJGr","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/properties/code":"3j0at","@form-engine/builder-mask/components/properties/enum":"2kNfK","@form-engine/builder-mask/components/properties/string":"e6M7S","@form-engine/builder-mask/components/properties/name":"cCuUh","../datasources/static-datasource":"h0bDq","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4pkiD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormEditorContextValueSchema", ()=>FormEditorContextValueSchema);
parcelHelpers.export(exports, "FormEditorContext", ()=>FormEditorContext);
parcelHelpers.export(exports, "formEditorStorage", ()=>formEditorStorage);
parcelHelpers.export(exports, "FormEditorProvider", ()=>FormEditorProvider);
parcelHelpers.export(exports, "useFormEditorContext", ()=>useFormEditorContext);
var _jsxRuntime = require("react/jsx-runtime");
var _useStore = require("@form-engine/core-application/hooks/use-store");
var _localStorage = require("@form-engine/core-util/local-storage");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _zod = require("zod");
const FormEditorContextValueSchema = (0, _zod.z).object({
    view: (0, _zod.z).string().default('form'),
    leftDrawerTab: (0, _zod.z).string().default('outline'),
    canvasTab: (0, _zod.z).enum([
        'edit',
        'preview',
        'translate'
    ]).default('edit'),
    rightDrawerTab: (0, _zod.z).string().default('settings'),
    previewSettings: (0, _zod.z).object({
        locale: (0, _zod.z).string().optional().default('default'),
        auth: (0, _zod.z).enum([
            'basic',
            'bearer'
        ]).default('basic'),
        basicAuthUsername: (0, _zod.z).string().optional(),
        basicAuthPassword: (0, _zod.z).string().optional(),
        bearerToken: (0, _zod.z).string().optional(),
        customVariables: (0, _zod.z).array((0, _zod.z).object({
            key: (0, _zod.z).string(),
            value: (0, _zod.z).string()
        })).default([])
    }).default({}),
    selectedWorkflowLayerId: (0, _zod.z).string().optional(),
    selectedDatasourceId: (0, _zod.z).string().optional(),
    isDragging: (0, _zod.z).boolean().default(false),
    sourceType: (0, _zod.z).enum([
        'element',
        'preset'
    ]).optional(),
    source: (0, _zod.z).record((0, _zod.z).unknown()).optional(),
    selectedId: (0, _zod.z).string().optional(),
    outlineCollapseList: (0, _zod.z).array((0, _zod.z).string()).default([]),
    translationLocale: (0, _zod.z).string().optional(),
    datasources: (0, _zod.z).record((0, _zod.z).unknown()).optional(),
    workflowLayers: (0, _zod.z).record((0, _zod.z).unknown()).optional(),
    constants: (0, _zod.z).record((0, _zod.z).unknown()).optional()
}).and((0, _zod.z).record((0, _zod.z).unknown()));
const FormEditorContext = /*#__PURE__*/ (0, _react.createContext)(null);
const formEditorStorageNamespace = (0, _localStorage.getStorageNamespace)('febEditor');
const formEditorStorage = {
    ...formEditorStorageNamespace,
    /**
     * drops expensive fields that should be omitted from local storage
     * @see https://ebike.atlassian.net/browse/CSPI-549
     */ setItem (key, value) {
        if (value) value = {
            ...value,
            formHistory: [],
            formRedoHistory: []
        };
        return formEditorStorageNamespace.setItem(key, value);
    }
};
const FormEditorContextValueSchemaDefault = FormEditorContextValueSchema.parse({});
function useSchemaResult(schema, data, fallback) {
    return (0, _react.useMemo)(()=>{
        let result = schema.safeParse(data);
        if (!result.success) {
            result = schema.safeParse(fallback ?? {});
            if (!result.success) throw new Error('could not parse schema');
            console.warn('got broken schema data using fallback');
        }
        return result.data;
    }, [
        schema,
        data,
        fallback
    ]);
}
function FormEditorProvider({ value: initialState, children }) {
    const store = (0, _useStore.useStore)(useSchemaResult(FormEditorContextValueSchema, initialState, FormEditorContextValueSchemaDefault));
    if (!store) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormEditorContext.Provider, {
        value: store,
        children: typeof children === 'function' ? children(store) : children
    });
}
function useFormEditorContext() {
    const context = (0, _react.useContext)(FormEditorContext);
    if (!context) throw new Error('tried to use form editor context without provider');
    return context;
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/hooks/use-store":"llHXk","@form-engine/core-util/local-storage":"2m0Di","react":"9njXz","zod":"lk66X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2m0Di":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStorage", ()=>getStorage);
parcelHelpers.export(exports, "setStorage", ()=>setStorage);
parcelHelpers.export(exports, "getStorageNamespace", ()=>getStorageNamespace);
function getStorage(key, fallback = null) {
    const raw = localStorage.getItem(key);
    if (raw) return JSON.parse(raw);
    return fallback;
}
function setStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}
function getStorageNamespace(namespace) {
    const getKeys = ()=>{
        const prefix = `${namespace}/`;
        return Object.keys(localStorage).filter((key)=>key.startsWith(prefix)).map((key)=>key.slice(prefix.length));
    };
    const getItem = (key, fallback = null)=>{
        return getStorage(`${namespace}/${key}`, fallback);
    };
    return {
        getKeys,
        getAll () {
            const result = {};
            getKeys().forEach((key)=>{
                result[key] = getItem(key);
            });
            return result;
        },
        getItem,
        setItem (key, value) {
            return setStorage(`${namespace}/${key}`, value);
        },
        unsetItem (key) {
            localStorage.removeItem(`${namespace}/${key}`);
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lk66X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BRAND", ()=>BRAND);
parcelHelpers.export(exports, "DIRTY", ()=>DIRTY);
parcelHelpers.export(exports, "EMPTY_PATH", ()=>EMPTY_PATH);
parcelHelpers.export(exports, "INVALID", ()=>INVALID);
parcelHelpers.export(exports, "NEVER", ()=>NEVER);
parcelHelpers.export(exports, "OK", ()=>OK);
parcelHelpers.export(exports, "ParseStatus", ()=>ParseStatus);
parcelHelpers.export(exports, "Schema", ()=>ZodType);
parcelHelpers.export(exports, "ZodAny", ()=>ZodAny);
parcelHelpers.export(exports, "ZodArray", ()=>ZodArray);
parcelHelpers.export(exports, "ZodBigInt", ()=>ZodBigInt);
parcelHelpers.export(exports, "ZodBoolean", ()=>ZodBoolean);
parcelHelpers.export(exports, "ZodBranded", ()=>ZodBranded);
parcelHelpers.export(exports, "ZodCatch", ()=>ZodCatch);
parcelHelpers.export(exports, "ZodDate", ()=>ZodDate);
parcelHelpers.export(exports, "ZodDefault", ()=>ZodDefault);
parcelHelpers.export(exports, "ZodDiscriminatedUnion", ()=>ZodDiscriminatedUnion);
parcelHelpers.export(exports, "ZodEffects", ()=>ZodEffects);
parcelHelpers.export(exports, "ZodEnum", ()=>ZodEnum);
parcelHelpers.export(exports, "ZodError", ()=>ZodError);
parcelHelpers.export(exports, "ZodFirstPartyTypeKind", ()=>ZodFirstPartyTypeKind);
parcelHelpers.export(exports, "ZodFunction", ()=>ZodFunction);
parcelHelpers.export(exports, "ZodIntersection", ()=>ZodIntersection);
parcelHelpers.export(exports, "ZodIssueCode", ()=>ZodIssueCode);
parcelHelpers.export(exports, "ZodLazy", ()=>ZodLazy);
parcelHelpers.export(exports, "ZodLiteral", ()=>ZodLiteral);
parcelHelpers.export(exports, "ZodMap", ()=>ZodMap);
parcelHelpers.export(exports, "ZodNaN", ()=>ZodNaN);
parcelHelpers.export(exports, "ZodNativeEnum", ()=>ZodNativeEnum);
parcelHelpers.export(exports, "ZodNever", ()=>ZodNever);
parcelHelpers.export(exports, "ZodNull", ()=>ZodNull);
parcelHelpers.export(exports, "ZodNullable", ()=>ZodNullable);
parcelHelpers.export(exports, "ZodNumber", ()=>ZodNumber);
parcelHelpers.export(exports, "ZodObject", ()=>ZodObject);
parcelHelpers.export(exports, "ZodOptional", ()=>ZodOptional);
parcelHelpers.export(exports, "ZodParsedType", ()=>ZodParsedType);
parcelHelpers.export(exports, "ZodPipeline", ()=>ZodPipeline);
parcelHelpers.export(exports, "ZodPromise", ()=>ZodPromise);
parcelHelpers.export(exports, "ZodReadonly", ()=>ZodReadonly);
parcelHelpers.export(exports, "ZodRecord", ()=>ZodRecord);
parcelHelpers.export(exports, "ZodSchema", ()=>ZodType);
parcelHelpers.export(exports, "ZodSet", ()=>ZodSet);
parcelHelpers.export(exports, "ZodString", ()=>ZodString);
parcelHelpers.export(exports, "ZodSymbol", ()=>ZodSymbol);
parcelHelpers.export(exports, "ZodTransformer", ()=>ZodEffects);
parcelHelpers.export(exports, "ZodTuple", ()=>ZodTuple);
parcelHelpers.export(exports, "ZodType", ()=>ZodType);
parcelHelpers.export(exports, "ZodUndefined", ()=>ZodUndefined);
parcelHelpers.export(exports, "ZodUnion", ()=>ZodUnion);
parcelHelpers.export(exports, "ZodUnknown", ()=>ZodUnknown);
parcelHelpers.export(exports, "ZodVoid", ()=>ZodVoid);
parcelHelpers.export(exports, "addIssueToContext", ()=>addIssueToContext);
parcelHelpers.export(exports, "any", ()=>anyType);
parcelHelpers.export(exports, "array", ()=>arrayType);
parcelHelpers.export(exports, "bigint", ()=>bigIntType);
parcelHelpers.export(exports, "boolean", ()=>booleanType);
parcelHelpers.export(exports, "coerce", ()=>coerce);
parcelHelpers.export(exports, "custom", ()=>custom);
parcelHelpers.export(exports, "date", ()=>dateType);
parcelHelpers.export(exports, "datetimeRegex", ()=>datetimeRegex);
parcelHelpers.export(exports, "default", ()=>z);
parcelHelpers.export(exports, "defaultErrorMap", ()=>errorMap);
parcelHelpers.export(exports, "discriminatedUnion", ()=>discriminatedUnionType);
parcelHelpers.export(exports, "effect", ()=>effectsType);
parcelHelpers.export(exports, "enum", ()=>enumType);
parcelHelpers.export(exports, "function", ()=>functionType);
parcelHelpers.export(exports, "getErrorMap", ()=>getErrorMap);
parcelHelpers.export(exports, "getParsedType", ()=>getParsedType);
parcelHelpers.export(exports, "instanceof", ()=>instanceOfType);
parcelHelpers.export(exports, "intersection", ()=>intersectionType);
parcelHelpers.export(exports, "isAborted", ()=>isAborted);
parcelHelpers.export(exports, "isAsync", ()=>isAsync);
parcelHelpers.export(exports, "isDirty", ()=>isDirty);
parcelHelpers.export(exports, "isValid", ()=>isValid);
parcelHelpers.export(exports, "late", ()=>late);
parcelHelpers.export(exports, "lazy", ()=>lazyType);
parcelHelpers.export(exports, "literal", ()=>literalType);
parcelHelpers.export(exports, "makeIssue", ()=>makeIssue);
parcelHelpers.export(exports, "map", ()=>mapType);
parcelHelpers.export(exports, "nan", ()=>nanType);
parcelHelpers.export(exports, "nativeEnum", ()=>nativeEnumType);
parcelHelpers.export(exports, "never", ()=>neverType);
parcelHelpers.export(exports, "null", ()=>nullType);
parcelHelpers.export(exports, "nullable", ()=>nullableType);
parcelHelpers.export(exports, "number", ()=>numberType);
parcelHelpers.export(exports, "object", ()=>objectType);
parcelHelpers.export(exports, "objectUtil", ()=>objectUtil);
parcelHelpers.export(exports, "oboolean", ()=>oboolean);
parcelHelpers.export(exports, "onumber", ()=>onumber);
parcelHelpers.export(exports, "optional", ()=>optionalType);
parcelHelpers.export(exports, "ostring", ()=>ostring);
parcelHelpers.export(exports, "pipeline", ()=>pipelineType);
parcelHelpers.export(exports, "preprocess", ()=>preprocessType);
parcelHelpers.export(exports, "promise", ()=>promiseType);
parcelHelpers.export(exports, "quotelessJson", ()=>quotelessJson);
parcelHelpers.export(exports, "record", ()=>recordType);
parcelHelpers.export(exports, "set", ()=>setType);
parcelHelpers.export(exports, "setErrorMap", ()=>setErrorMap);
parcelHelpers.export(exports, "strictObject", ()=>strictObjectType);
parcelHelpers.export(exports, "string", ()=>stringType);
parcelHelpers.export(exports, "symbol", ()=>symbolType);
parcelHelpers.export(exports, "transformer", ()=>effectsType);
parcelHelpers.export(exports, "tuple", ()=>tupleType);
parcelHelpers.export(exports, "undefined", ()=>undefinedType);
parcelHelpers.export(exports, "union", ()=>unionType);
parcelHelpers.export(exports, "unknown", ()=>unknownType);
parcelHelpers.export(exports, "util", ()=>util);
parcelHelpers.export(exports, "void", ()=>voidType);
parcelHelpers.export(exports, "z", ()=>z);
var util;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const getParsedType = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) return ZodParsedType.array;
            if (data === null) return ZodParsedType.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return ZodParsedType.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return ZodParsedType.map;
            if (typeof Set !== "undefined" && data instanceof Set) return ZodParsedType.set;
            if (typeof Date !== "undefined" && data instanceof Date) return ZodParsedType.date;
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};
const ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const quotelessJson = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof ZodError)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors,
            fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues)=>{
    const error = new ZodError(issues);
    return error;
};
const errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
            break;
        case ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
            break;
        case ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else util.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util.assertNever(issue);
    }
    return {
        message
    };
};
let overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}
const makeIssue = (params)=>{
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const overrideMap = getErrorMap();
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === errorMap ? undefined : errorMap
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return INVALID;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key,
                value
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key, value } = pair;
            if (key.status === "aborted") return INVALID;
            if (value.status === "aborted") return INVALID;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const INVALID = Object.freeze({
    status: "aborted"
});
const DIRTY = (value)=>({
        status: "dirty",
        value
    });
const OK = (value)=>({
        status: "valid",
        value
    });
const isAborted = (x)=>x.status === "aborted";
const isDirty = (x)=>x.status === "dirty";
const isValid = (x)=>x.status === "valid";
const isAsync = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));
var _ZodEnum_cache, _ZodNativeEnum_cache;
class ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result)=>{
    if (isValid(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function processCreateParams(params) {
    if (!params) return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description
    };
}
class ZodType {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return getParsedType(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: getParsedType(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: getParsedType(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if (isAsync(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data)
        };
        const result = this._parseSync({
            data,
            path: ctx.path,
            parent: ctx
        });
        return handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data)
        };
        const maybeAsyncResult = this._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
        const result = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: ZodIssueCode.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "refinement",
                refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this, this._def);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "transform",
                transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[0-9a-z]+$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const nanoidRegex = /^[a-z0-9_-]{21}$/i;
const durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
// faster, simpler, safer
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function timeRegex(args) {
    return new RegExp(`^${timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function datetimeRegex(args) {
    let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) return true;
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.string,
                received: ctx.parsedType
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "email",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!emojiRegex) emojiRegex = new RegExp(_emojiRegex, "u");
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "emoji",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "uuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "nanoid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid2",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ulid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                addIssueToContext(ctx, {
                    validation: "url",
                    code: ZodIssueCode.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "regex",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "duration",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ip",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "base64",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation,
            code: ZodIssueCode.invalid_string,
            ...errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params)=>{
    var _a;
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.number,
                received: ctx.parsedType
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
ZodNumber.create = (params)=>{
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params)
    });
};
class ZodBigInt extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.bigint) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.bigint,
                received: ctx.parsedType
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
ZodBigInt.create = (params)=>{
    var _a;
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params)
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.boolean,
                received: ctx.parsedType
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodBoolean.create = (params)=>{
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params)
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.date,
                received: ctx.parsedType
            });
            return INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_date
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else util.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params)=>{
    return new ZodDate({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params)
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.symbol,
                received: ctx.parsedType
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodSymbol.create = (params)=>{
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params)
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.undefined,
                received: ctx.parsedType
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodUndefined.create = (params)=>{
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params)
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.null,
                received: ctx.parsedType
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodNull.create = (params)=>{
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params)
    });
};
class ZodAny extends ZodType {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodAny.create = (params)=>{
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params)
    });
};
class ZodUnknown extends ZodType {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodUnknown.create = (params)=>{
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params)
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.never,
            received: ctx.parsedType
        });
        return INVALID;
    }
}
ZodNever.create = (params)=>{
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params)
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.void,
                received: ctx.parsedType
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodVoid.create = (params)=>{
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params)
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType
            });
            return INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                addIssueToContext(ctx, {
                    code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return ParseStatus.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: {
                value: minLength,
                message: errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: {
                value: len,
                message: errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params)=>{
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params)
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof ZodArray) return new ZodArray({
        ...schema._def,
        type: deepPartialify(schema.element)
    });
    else if (schema instanceof ZodOptional) return ZodOptional.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodNullable) return ZodNullable.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodTuple) return ZodTuple.create(schema.items.map((item)=>deepPartialify(item)));
    else return schema;
}
class ZodObject extends ZodType {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = util.objectKeys(shape);
        return this._cached = {
            shape,
            keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType
            });
            return INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key,
                    value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return ParseStatus.mergeObjectSync(status, syncPairs);
        });
        else return ParseStatus.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: ZodFirstPartyTypeKind.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        util.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        util.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof ZodOptional)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return createZodEnum(util.objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.strictCreate = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.lazycreate = (shape, params)=>{
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new ZodError(result.ctx.common.issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors
            });
            return INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new ZodError(issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors
            });
            return INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params)=>{
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type)=>{
    if (type instanceof ZodLazy) return getDiscriminator(type.schema);
    else if (type instanceof ZodEffects) return getDiscriminator(type.innerType());
    else if (type instanceof ZodLiteral) return [
        type.value
    ];
    else if (type instanceof ZodEnum) return type.options;
    else if (type instanceof ZodNativeEnum) // eslint-disable-next-line ban/ban
    return util.objectValues(type.enum);
    else if (type instanceof ZodDefault) return getDiscriminator(type._def.innerType);
    else if (type instanceof ZodUndefined) return [
        undefined
    ];
    else if (type instanceof ZodNull) return [
        null
    ];
    else if (type instanceof ZodOptional) return [
        undefined,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodNullable) return [
        null,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodBranded) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodReadonly) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodCatch) return getDiscriminator(type._def.innerType);
    else return [];
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType
            });
            return INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params)
        });
    }
}
function mergeValues(a, b) {
    const aType = getParsedType(a);
    const bType = getParsedType(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        const bKeys = util.objectKeys(b);
        const sharedKeys = util.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if (isAborted(parsedLeft) || isAborted(parsedRight)) return INVALID;
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_intersection_types
                });
                return INVALID;
            }
            if (isDirty(parsedLeft) || isDirty(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
ZodIntersection.create = (left, right, params)=>{
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params)
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType
            });
            return INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return ParseStatus.mergeArray(status, results);
        });
        else return ParseStatus.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest
        });
    }
}
ZodTuple.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params)
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType
            });
            return INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return ParseStatus.mergeObjectAsync(status, pairs);
        else return ParseStatus.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) return new ZodRecord({
            keyType: first,
            valueType: second,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(third)
        });
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second)
        });
    }
}
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.map) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.map,
                received: ctx.parsedType
            });
            return INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
ZodMap.create = (keyType, valueType, params)=>{
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params)
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.set) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.set,
                received: ctx.parsedType
            });
            return INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: {
                value: minSize,
                message: errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params)=>{
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params)
    });
};
class ZodFunction extends ZodType {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.function) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.function,
                received: ctx.parsedType
            });
            return INVALID;
        }
        function makeArgsIssue(args, error) {
            return makeIssue({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: ZodIssueCode.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return makeIssue({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: ZodIssueCode.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(async function(...args) {
                const error = new ZodError([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new ZodError([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new ZodError([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create())
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params)
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
ZodLazy.create = (getter, params)=>{
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params)
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_literal,
                expected: this._def.value
            });
            return INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params)=>{
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params)
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params)
    });
}
class ZodEnum extends ZodType {
    constructor(){
        super(...arguments);
        _ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type
            });
            return INVALID;
        }
        if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f")) __classPrivateFieldSet(this, _ZodEnum_cache, new Set(this._def.values), "f");
        if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return ZodEnum.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return ZodEnum.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
_ZodEnum_cache = new WeakMap();
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    constructor(){
        super(...arguments);
        _ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type
            });
            return INVALID;
        }
        if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f")) __classPrivateFieldSet(this, _ZodNativeEnum_cache, new Set(util.getValidEnumValues(this._def.values)), "f");
        if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
_ZodNativeEnum_cache = new WeakMap();
ZodNativeEnum.create = (values, params)=>{
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params)
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.promise,
                received: ctx.parsedType
            });
            return INVALID;
        }
        const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
        return OK(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
ZodPromise.create = (schema, params)=>{
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params)
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                addIssueToContext(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return INVALID;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return INVALID;
                if (result.status === "dirty") return DIRTY(result.value);
                if (status.value === "dirty") return DIRTY(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return INVALID;
                if (result.status === "dirty") return DIRTY(result.value);
                if (status.value === "dirty") return DIRTY(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!isValid(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!isValid(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        util.assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params)=>{
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params)
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params)=>{
    return new ZodEffects({
        schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params)
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.undefined) return OK(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params)=>{
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params)
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.null) return OK(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params)=>{
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params)
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === ZodParsedType.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params)=>{
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...processCreateParams(params)
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if (isAsync(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new ZodError(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new ZodError(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
ZodCatch.create = (type, params)=>{
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...processCreateParams(params)
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.nan,
                received: ctx.parsedType
            });
            return INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
ZodNaN.create = (params)=>{
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params)
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return DIRTY(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline
        });
    }
}
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if (isValid(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return isAsync(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodReadonly.create = (type, params)=>{
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params)
    });
};
function custom(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return ZodAny.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return ZodAny.create();
}
const late = {
    object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>custom((data)=>data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = ()=>stringType().optional();
const onumber = ()=>numberType().optional();
const oboolean = ()=>booleanType().optional();
const coerce = {
    string: (arg)=>ZodString.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>ZodNumber.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>ZodBoolean.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>ZodBigInt.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>ZodDate.create({
            ...arg,
            coerce: true
        })
};
const NEVER = INVALID;
var z = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid,
    isAsync: isAsync,
    get util () {
        return util;
    },
    get objectUtil () {
        return objectUtil;
    },
    ZodParsedType: ZodParsedType,
    getParsedType: getParsedType,
    ZodType: ZodType,
    datetimeRegex: datetimeRegex,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodSymbol: ZodSymbol,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodCatch: ZodCatch,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    ZodPipeline: ZodPipeline,
    ZodReadonly: ZodReadonly,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () {
        return ZodFirstPartyTypeKind;
    },
    coerce: coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    'enum': enumType,
    'function': functionType,
    'instanceof': instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    'null': nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    'undefined': undefinedType,
    union: unionType,
    unknown: unknownType,
    'void': voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ROOD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderDatasourceDataTable);
var _jsxRuntime = require("react/jsx-runtime");
var _useDatasource = require("@form-engine/core-application/hooks/use-datasource");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _spinnerBoundary = require("../spinner-boundary");
var _spinnerBoundaryDefault = parcelHelpers.interopDefault(_spinnerBoundary);
var _table = require("../table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
function BuilderBoundDatasourceDataTable({ id }) {
    const { data: datasourceData, loading } = (0, _useDatasource.useDatasourceData)(id);
    const hasData = datasourceData && Array.isArray(datasourceData) && datasourceData.length > 0;
    const tableData = (0, _react.useMemo)(()=>{
        if (!hasData) return null;
        return {
            columns: Object.keys(datasourceData[0]),
            rows: datasourceData
        };
    }, [
        datasourceData,
        hasData
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerBoundaryDefault.default), {
        show: loading,
        children: hasData ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
            sticky: true,
            data: tableData?.rows,
            children: tableData?.columns.map((key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                    dataKey: key,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    cell: ({ content: value })=>typeof value === 'string' ? value : JSON.stringify(value)
                }, key))
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            className: "text-center p-5 text-muted",
            children: "Data not displayable"
        })
    });
}
function BuilderDatasourceDataTable({ session: initialSession, ...props }) {
    const [session] = (0, _react.useState)(initialSession || {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useFormsession.FormSessionProvider), {
        value: session,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderBoundDatasourceDataTable, {
            ...props
        })
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/hooks/use-datasource":"lz7AL","react":"9njXz","../spinner-boundary":"eYtmG","../table":"lv8ZN","@form-engine/core-application/hooks/use-formsession":"2Th33","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eYtmG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderSpinner", ()=>BuilderSpinner);
parcelHelpers.export(exports, "BuilderSpinnerBar", ()=>BuilderSpinnerBar);
parcelHelpers.export(exports, "default", ()=>BuilderSpinnerBoundary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
function BuilderSpinner({ children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Spinner), {
        role: "status",
        variant: "primary",
        ...props,
        animation: props.animation || 'border',
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "visually-hidden",
                children: "Loading..."
            })
        ]
    });
}
function BuilderSpinnerBar({ className, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `feb-spinner-bar ${className}`,
        ...props
    });
}
function BuilderSpinnerBoundary({ children, show = false, spinner: SpinnerComponent = BuilderSpinner, bar: BarComponent = BuilderSpinnerBar, className = '', prepend, append, ...props }) {
    const overlay = 'overlay' in props && props.overlay !== false;
    delete props.overlay;
    if (!show) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children
    }) || null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            prepend,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `feb-spinner-boundary ${className} ${overlay ? 'is-overlay' : ''}`,
                ...props,
                children: [
                    BarComponent && /*#__PURE__*/ (0, _jsxRuntime.jsx)(BarComponent, {}),
                    SpinnerComponent && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SpinnerComponent, {})
                ]
            }),
            append
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lv8ZN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */ parcelHelpers.export(exports, "Column", ()=>Column);
parcelHelpers.export(exports, "Cell", ()=>Cell);
parcelHelpers.export(exports, "HeaderCell", ()=>HeaderCell);
parcelHelpers.export(exports, "default", ()=>BuilderTable);
var _jsxRuntime = require("react/jsx-runtime");
var _useBounds = require("../../hooks/use-bounds");
var _useBoundsDefault = parcelHelpers.interopDefault(_useBounds);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactWindow = require("react-window");
function Column(_props) {
    // purely virtual should not do anything
    return null;
}
function isColumn(data) {
    return typeof data === 'object' && data !== null && 'dataKey' in data;
}
function Cell({ dataKey, index, data, children, as: Component = (0, _reactDefault.default).Fragment }) {
    const row = data[index];
    const content = row[dataKey];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        children: typeof children === 'function' ? children({
            content,
            data,
            dataKey,
            index,
            row
        }) : content
    });
}
function HeaderCell({ dataKey, children, as: Component = (0, _reactDefault.default).Fragment }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        children: typeof children === 'function' ? children({
            dataKey
        }) : dataKey
    });
}
function BuilderTable({ className = '', data, children, cellContainer: CellContainerComp = 'div', cell: CellComp = Cell, headerCell: HeaderCellComp = HeaderCell, columnMinWidth = 96, ...props }) {
    const isSticky = 'sticky' in props && props.sticky !== false;
    delete props.sticky;
    const { bounds: { width, height }, ref: refWrap } = (0, _useBoundsDefault.default)();
    const columns = (0, _react.useMemo)(()=>{
        return (0, _reactDefault.default).Children.map(children, (child)=>{
            if (!child || typeof child !== 'object' || !('type' in child) || child.type !== Column) throw new Error(`BuilderTable only accepts Columns as children`);
            return child.props;
        });
    }, [
        children
    ]) || [];
    const renderer = (0, _react.useMemo)(()=>{
        return function CellRenderer({ columnIndex, rowIndex, style }) {
            const column = columns[columnIndex];
            if (!isColumn(column)) return null;
            const { dataKey, header: headerContent, cell: cellContent } = column;
            if (!dataKey) return null;
            let cell;
            let className;
            if (!isSticky && rowIndex === 0) {
                cell = /*#__PURE__*/ (0, _jsxRuntime.jsx)(HeaderCellComp, {
                    dataKey: dataKey,
                    children: headerContent
                });
                className = 'feb-th';
            } else {
                cell = /*#__PURE__*/ (0, _jsxRuntime.jsx)(CellComp, {
                    dataKey: dataKey,
                    data: data,
                    index: isSticky ? rowIndex : rowIndex - 1,
                    children: cellContent
                });
                className = 'feb-td';
            }
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CellContainerComp, {
                className: `feb-tc ${className}`,
                style: style,
                children: cell
            });
        };
    }, [
        columns,
        data,
        CellContainerComp,
        isSticky
    ]);
    const [widthProvider, widthEstimate] = (0, _react.useMemo)(()=>{
        let rest = width;
        const auto = [];
        const sizes = [];
        columns.forEach((column, index)=>{
            if (isColumn(column) && 'width' in column) {
                const width = Number(column.width);
                sizes.push(width);
                rest -= width;
            } else {
                sizes.push(-1);
                auto.push(index);
            }
        });
        let autoWidth = rest / auto.length;
        if (columnMinWidth > autoWidth) autoWidth = columnMinWidth;
        auto.forEach((index)=>{
            sizes[index] = autoWidth;
        });
        return [
            (index)=>sizes[index],
            sizes.reduce((p, s)=>s + p, 0) / sizes.length
        ];
    }, [
        columns,
        width,
        columnMinWidth
    ]);
    const rowHeight = props.rowHeight || (()=>30);
    const heightEstimate = rowHeight(0);
    const refHead = (0, _react.useRef)(undefined);
    const scrollHead = (0, _react.useCallback)((e)=>{
        if (!refHead.current || !isSticky) return;
        refHead.current.scrollTo({
            left: e.scrollLeft,
            top: 0
        });
    }, [
        isSticky
    ]);
    const hasSize = Boolean(width && height);
    const grid = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isSticky && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactWindow.VariableSizeGrid), {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                ref: refHead,
                className: `feb-thead`,
                width: width,
                rowHeight: rowHeight,
                height: rowHeight(0),
                columnCount: columns.length,
                columnWidth: widthProvider,
                estimatedColumnWidth: widthEstimate,
                estimatedRowHeight: heightEstimate,
                rowCount: 1,
                children: ({ columnIndex, style })=>{
                    const { dataKey = null, header: headerContent = null } = isColumn(columns[columnIndex]) ? columns[columnIndex] : {};
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CellContainerComp, {
                        className: `feb-tc feb-th`,
                        style: style,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(HeaderCellComp, {
                            dataKey: dataKey,
                            children: headerContent
                        })
                    });
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactWindow.VariableSizeGrid), {
                ...props,
                onScroll: scrollHead,
                width: width,
                height: isSticky ? height - rowHeight(0) : height,
                columnWidth: widthProvider,
                rowHeight: rowHeight,
                rowCount: isSticky ? data.length : data.length + 1,
                columnCount: columns.length,
                className: `feb-tbody ${className}`,
                children: renderer
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "feb-table",
        ref: refWrap,
        children: hasSize && grid
    });
}
Object.assign(BuilderTable, {
    Column,
    Cell,
    HeaderCell
});

},{"react/jsx-runtime":"1dlk8","../../hooks/use-bounds":"jQMWQ","react":"9njXz","react-window":"4BX6K","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jQMWQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useBounds);
var _react = require("react");
function useBounds() {
    const [bounds, setBounds] = (0, _react.useState)(new DOMRect());
    const ref = (0, _react.useRef)(undefined);
    (0, _react.useEffect)(()=>{
        if (!ref.current) return;
        const el = ref.current;
        let mounted = true;
        const update = ()=>{
            if (!ref || !mounted || !ref.current) return;
            setBounds(el.getBoundingClientRect());
        };
        const observer = new ResizeObserver(update);
        observer.observe(el);
        update();
        return ()=>{
            mounted = false;
            observer.unobserve(el);
        };
    }, [
        setBounds
    ]);
    return {
        bounds,
        ref
    };
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4BX6K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FixedSizeGrid", ()=>FixedSizeGrid);
parcelHelpers.export(exports, "FixedSizeList", ()=>FixedSizeList);
parcelHelpers.export(exports, "VariableSizeGrid", ()=>VariableSizeGrid);
parcelHelpers.export(exports, "VariableSizeList", ()=>VariableSizeList);
parcelHelpers.export(exports, "areEqual", ()=>areEqual);
parcelHelpers.export(exports, "shouldComponentUpdate", ()=>shouldComponentUpdate);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _react = require("react");
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var now = hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
    var start = now();
    function tick() {
        if (now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var size = -1; // This utility copied from "dom-helpers" package.
function getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if (size === -1 || recalculate) {
        var div = document.createElement('div');
        var style = div.style;
        style.width = '50px';
        style.height = '50px';
        style.overflow = 'scroll';
        document.body.appendChild(div);
        size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return size;
}
var cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if (cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement('div');
        var outerStyle = outerDiv.style;
        outerStyle.width = '50px';
        outerStyle.height = '50px';
        outerStyle.overflow = 'scroll';
        outerStyle.direction = 'rtl';
        var innerDiv = document.createElement('div');
        var innerStyle = innerDiv.style;
        innerStyle.width = '100px';
        innerStyle.height = '100px';
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) cachedRTLResult = 'positive-descending';
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) cachedRTLResult = 'negative';
            else cachedRTLResult = 'positive-ascending';
        }
        document.body.removeChild(outerDiv);
        return cachedRTLResult;
    }
    return cachedRTLResult;
}
var IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var devWarningsOverscanCount = null;
var devWarningsOverscanRowsColumnsCount = null;
var devWarningsTagName = null;
function createGridComponent(_ref2) {
    var _class;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, _inheritsLooseDefault.default)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, _assertThisInitializedDefault.default)(_this));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, _assertThisInitializedDefault.default)(_this),
                isScrolling: false,
                horizontalScrollDirection: 'forward',
                scrollLeft: typeof _this.props.initialScrollLeft === 'number' ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === 'number' ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: 'forward'
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, _memoizeOneDefault.default)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, _memoizeOneDefault.default)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === 'rtl';
                    itemStyleCache[key] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, _memoizeOneDefault.default)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === 'rtl') switch(getRTLOffsetType()){
                        case 'negative':
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case 'positive-descending':
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward',
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward'
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? 'auto' : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === 'number') outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === 'number') outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === 'rtl') switch(getRTLOffsetType()){
                    case 'negative':
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case 'positive-ascending':
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, _react.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, _react.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, _extendsDefault.default)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, _react.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === 'function') {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === 'function') {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, _react.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        useIsScrolling: false
    }, _class;
}
var validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === 'column') instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === 'column' ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === 'column' ? props.width : props.height;
    var itemMetadata = getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === 'column' ? getEstimatedTotalWidth(props, instanceProps) : getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === 'smart') {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
        else align = 'center';
    }
    switch(align){
        case 'start':
            return maxOffset;
        case 'end':
            return minOffset;
        case 'center':
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case 'auto':
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var VariableSizeGrid = /*#__PURE__*/ createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return getItemMetadata('column', props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return findNearestItem('column', props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = getItemMetadata('column', props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += getItemMetadata('column', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: getEstimatedTotalHeight,
    getEstimatedTotalWidth: getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return getOffsetForIndexAndAlignment('column', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return getOffsetForIndexAndAlignment('row', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return getItemMetadata('row', props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return findNearestItem('row', props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = getItemMetadata('row', props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += getItemMetadata('row', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === 'number') instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === 'number') instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var devWarningsDirection = null;
var devWarningsTagName$1 = null;
function createListComponent(_ref) {
    var _class;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, _inheritsLooseDefault.default)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, _assertThisInitializedDefault.default)(_this));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, _assertThisInitializedDefault.default)(_this),
                isScrolling: false,
                scrollDirection: 'forward',
                scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, _memoizeOneDefault.default)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, _memoizeOneDefault.default)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
                    var isRtl = direction === 'rtl';
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : '100%',
                        width: isHorizontal ? size : '100%'
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, _memoizeOneDefault.default)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch(getRTLOffsetType()){
                        case 'negative':
                            scrollOffset = -scrollLeft;
                            break;
                        case 'positive-descending':
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = 'auto';
            var _this$props2 = this.props, itemCount = _this$props2.itemCount, layout = _this$props2.layout;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            // This is an edge case for lists; normally they only scroll in the dominant direction.
            var scrollbarSize = 0;
            if (this._outerRef) {
                var outerRef = this._outerRef;
                if (layout === 'vertical') scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? getScrollbarSize() : 0;
                else scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? getScrollbarSize() : 0;
            }
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, direction = _this$props3.direction, initialScrollOffset = _this$props3.initialScrollOffset, layout = _this$props3.layout;
            if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props4 = this.props, direction = _this$props4.direction, layout = _this$props4.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') {
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch(getRTLOffsetType()){
                        case 'negative':
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case 'positive-ascending':
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, direction = _this$props5.direction, height = _this$props5.height, innerRef = _this$props5.innerRef, innerElementType = _this$props5.innerElementType, innerTagName = _this$props5.innerTagName, itemCount = _this$props5.itemCount, itemData = _this$props5.itemData, _this$props5$itemKey = _this$props5.itemKey, itemKey = _this$props5$itemKey === void 0 ? defaultItemKey$1 : _this$props5$itemKey, layout = _this$props5.layout, outerElementType = _this$props5.outerElementType, outerTagName = _this$props5.outerTagName, style = _this$props5.style, useIsScrolling = _this$props5.useIsScrolling, width = _this$props5.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, _react.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, _react.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, _extendsDefault.default)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, _react.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? '100%' : estimatedTotalSize,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: isHorizontal ? estimatedTotalSize : '100%'
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === 'function') {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === 'function') {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props6 = this.props, itemCount = _this$props6.itemCount, overscanCount = _this$props6.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, _react.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        layout: 'vertical',
        overscanCount: 2,
        useIsScrolling: false
    }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var VariableSizeList = /*#__PURE__*/ createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var FixedSizeGrid = /*#__PURE__*/ createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === 'smart') {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === 'smart') {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var FixedSizeList = /*#__PURE__*/ createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
var _excluded = [
    "style"
], _excluded2 = [
    "style"
];
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function areEqual(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, _objectWithoutPropertiesLooseDefault.default)(prevProps, _excluded);
    var nextStyle = nextProps.style, nextRest = (0, _objectWithoutPropertiesLooseDefault.default)(nextProps, _excluded2);
    return !shallowDiffers(prevStyle, nextStyle) && !shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function shouldComponentUpdate(nextProps, nextState) {
    return !areEqual(this.props, nextProps) || shallowDiffers(this.state, nextState);
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","memoize-one":"eFj2c","react":"9njXz","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eFj2c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function isEqual(first, second) {
    if (first === second) return true;
    if (safeIsNaN(first) && safeIsNaN(second)) return true;
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
exports.default = memoizeOne;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5gJGr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderDrawerTabs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
function BuilderDrawerTabs({ items = {}, onChange, prepend = null, append = null, children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Nav), {
        className: "feb-drawer-tabs",
        variant: "tabs",
        ...props,
        children: [
            prepend,
            Object.entries(items).map(([key, label])=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Item, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Link, {
                        eventKey: key,
                        onClick: ()=>{
                            onChange && onChange(key);
                        },
                        children: label || key
                    })
                }, key);
            }),
            children,
            append
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3j0at":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultInlineEditorOptions", ()=>defaultInlineEditorOptions);
parcelHelpers.export(exports, "defaultOffCanvasEditorOptions", ()=>defaultOffCanvasEditorOptions);
parcelHelpers.export(exports, "BuilderInlineCodeProperty", ()=>BuilderInlineCodeProperty);
parcelHelpers.export(exports, "BuilderOffCanvasCodeProperty", ()=>BuilderOffCanvasCodeProperty);
parcelHelpers.export(exports, "default", ()=>BuilderCodeProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("@monaco-editor/react");
var _reactDefault1 = parcelHelpers.interopDefault(_react1);
var _property = require("../mask/property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _useMask = require("../../hooks/use-mask");
var _useMaskConfig = require("../../hooks/use-mask-config");
var _button = require("react-bootstrap/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _offcanvas = require("react-bootstrap/Offcanvas");
var _offcanvasDefault = parcelHelpers.interopDefault(_offcanvas);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _useMaskValidation = require("../../hooks/use-mask-validation");
const defaultInlineEditorOptions = {
    lineNumbers: false,
    fontSize: 12,
    minimap: {
        enabled: false
    },
    glyphMargin: false,
    folding: false,
    lineDecorationsWidth: 0,
    lineNumbersMinChars: 0,
    scrollBeyondLastLine: false
};
const defaultOffCanvasEditorOptions = {};
function BuilderInlineCodeProperty({ label, propertyName, defaultValue = '', language = 'plain', ...props }) {
    const { state, setItemProperty } = (0, _useMask.useMaskContext)();
    const value = typeof state?.[propertyName] === 'string' ? state[propertyName] : defaultValue;
    const permission = (0, _useMaskConfig.useMaskPropertyPermission)(propertyName);
    const error = (0, _useMaskValidation.useMaskPropertyError)(propertyName);
    const editorOptions = (0, _react.useMemo)(()=>{
        return {
            ...defaultInlineEditorOptions,
            readOnly: permission === 'read'
        };
    }, [
        permission
    ]);
    const handleChange = (0, _react.useCallback)((value)=>{
        setItemProperty(propertyName, value);
    }, [
        propertyName,
        setItemProperty
    ]);
    const lines = Math.max(String(value ?? '').split(/\r\n|\r|\n/).length + 2, 4);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertyDefault.default), {
        className: "feb-code-property",
        stacked: true,
        label: label,
        error: error?.message,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "w-100 form-control",
            ...props,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault1.default), {
                height: `${lines * 18}px`,
                language: language,
                value: value,
                onChange: handleChange,
                options: editorOptions
            })
        })
    });
}
function BuilderOffCanvasCodeProperty({ label, propertyName, defaultValue = '', language = 'plain', placement = 'end' }) {
    const { state, setItemProperty } = (0, _useMask.useMaskContext)();
    const mounted = (0, _react.useRef)(true);
    const value = typeof state?.[propertyName] === 'string' ? state[propertyName] : defaultValue;
    const permission = (0, _useMaskConfig.useMaskPropertyPermission)(propertyName);
    const error = (0, _useMaskValidation.useMaskPropertyError)(propertyName);
    const editorOptions = (0, _react.useMemo)(()=>{
        return {
            ...defaultOffCanvasEditorOptions,
            readOnly: permission === 'read'
        };
    }, [
        permission
    ]);
    // fixes state leak with the change listener beeing called when the selected element
    (0, _react.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, [
        state
    ]);
    const handleChange = (0, _react.useCallback)((newValue)=>{
        if (mounted.current) setItemProperty(propertyName, newValue);
    }, [
        propertyName,
        setItemProperty
    ]);
    const [show, setShow] = (0, _react.useState)(false);
    const handleClose = ()=>setShow(false);
    const toggleShow = ()=>setShow(!show);
    (0, _react.useEffect)(()=>{
        document.documentElement.classList.toggle('feb-offcanvas-editor--show', show);
        document.documentElement.classList.toggle(`feb-offcanvas-editor--show-${placement}`, show);
    }, [
        show,
        placement
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            document.documentElement.classList.toggle('feb-offcanvas-editor--show', false);
            document.documentElement.classList.toggle(`feb-offcanvas-editor--show-${placement}`, false);
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertyDefault.default), {
                className: "feb-code-property",
                label: label,
                error: error?.message,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "outline-secondary",
                    active: show,
                    className: "w-100",
                    style: {
                        maxWidth: '150px'
                    },
                    onClick: toggleShow,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.PencilFill), {})
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _offcanvasDefault.default), {
                className: "feb-offcanvas-editor",
                show: show,
                onHide: handleClose,
                placement: placement,
                backdrop: false,
                enforceFocus: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offcanvasDefault.default).Header, {
                        closeButton: true,
                        closeVariant: "white",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offcanvasDefault.default).Title, {
                            children: label
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offcanvasDefault.default).Body, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault1.default), {
                            height: `100%`,
                            language: language,
                            value: value,
                            onChange: handleChange,
                            options: editorOptions,
                            theme: "vs-dark"
                        })
                    })
                ]
            })
        ]
    });
}
function BuilderCodeProperty({ ...props }) {
    let offCanvas;
    if (typeof props.offCanvas === 'string') offCanvas = props.offCanvas;
    else offCanvas = props.offCanvas !== false ? 'end' : '';
    delete props.offCanvas;
    return offCanvas ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderOffCanvasCodeProperty, {
        ...props,
        placement: offCanvas
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderInlineCodeProperty, {
        ...props
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@monaco-editor/react":"4J0rl","../mask/property":"dLorN","../../hooks/use-mask":"72MTY","../../hooks/use-mask-config":"daHU1","react-bootstrap/Button":"2TJC6","react-bootstrap/Offcanvas":"3kK4v","react-bootstrap-icons":"3TzoC","../../hooks/use-mask-validation":"cYKiY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4J0rl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiffEditor", ()=>we);
parcelHelpers.export(exports, "Editor", ()=>de);
parcelHelpers.export(exports, "default", ()=>Ft);
parcelHelpers.export(exports, "loader", ()=>(0, _loaderDefault.default));
parcelHelpers.export(exports, "useMonaco", ()=>Le);
var _loader = require("@monaco-editor/loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var le = {
    wrapper: {
        display: "flex",
        position: "relative",
        textAlign: "initial"
    },
    fullWidth: {
        width: "100%"
    },
    hide: {
        display: "none"
    }
}, v = le;
var ae = {
    container: {
        display: "flex",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "center"
    }
}, Y = ae;
function Me({ children: e }) {
    return (0, _reactDefault.default).createElement("div", {
        style: Y.container
    }, e);
}
var Z = Me;
var $ = Z;
function Ee({ width: e, height: r, isEditorReady: n, loading: t, _ref: a, className: m, wrapperProps: E }) {
    return (0, _reactDefault.default).createElement("section", {
        style: {
            ...v.wrapper,
            width: e,
            height: r
        },
        ...E
    }, !n && (0, _reactDefault.default).createElement($, null, t), (0, _reactDefault.default).createElement("div", {
        ref: a,
        style: {
            ...v.fullWidth,
            ...!n && v.hide
        },
        className: m
    }));
}
var ee = Ee;
var H = (0, _react.memo)(ee);
function Ce(e) {
    (0, _react.useEffect)(e, []);
}
var k = Ce;
function he(e, r, n = !0) {
    let t = (0, _react.useRef)(!0);
    (0, _react.useEffect)(t.current || !n ? ()=>{
        t.current = !1;
    } : e, r);
}
var l = he;
function D() {}
function h(e, r, n, t) {
    return De(e, t) || be(e, r, n, t);
}
function De(e, r) {
    return e.editor.getModel(te(e, r));
}
function be(e, r, n, t) {
    return e.editor.createModel(r, n, t ? te(e, t) : void 0);
}
function te(e, r) {
    return e.Uri.parse(r);
}
function Oe({ original: e, modified: r, language: n, originalLanguage: t, modifiedLanguage: a, originalModelPath: m, modifiedModelPath: E, keepCurrentOriginalModel: g = !1, keepCurrentModifiedModel: N = !1, theme: x = "light", loading: P = "Loading...", options: y = {}, height: V = "100%", width: z = "100%", className: F, wrapperProps: j = {}, beforeMount: A = D, onMount: q = D }) {
    let [M, O] = (0, _react.useState)(!1), [T, s] = (0, _react.useState)(!0), u = (0, _react.useRef)(null), c = (0, _react.useRef)(null), w = (0, _react.useRef)(null), d = (0, _react.useRef)(q), o = (0, _react.useRef)(A), b = (0, _react.useRef)(!1);
    k(()=>{
        let i = (0, _loaderDefault.default).init();
        return i.then((f)=>(c.current = f) && s(!1)).catch((f)=>f?.type !== "cancelation" && console.error("Monaco initialization: error:", f)), ()=>u.current ? I() : i.cancel();
    }), l(()=>{
        if (u.current && c.current) {
            let i = u.current.getOriginalEditor(), f = h(c.current, e || "", t || n || "text", m || "");
            f !== i.getModel() && i.setModel(f);
        }
    }, [
        m
    ], M), l(()=>{
        if (u.current && c.current) {
            let i = u.current.getModifiedEditor(), f = h(c.current, r || "", a || n || "text", E || "");
            f !== i.getModel() && i.setModel(f);
        }
    }, [
        E
    ], M), l(()=>{
        let i = u.current.getModifiedEditor();
        i.getOption(c.current.editor.EditorOption.readOnly) ? i.setValue(r || "") : r !== i.getValue() && (i.executeEdits("", [
            {
                range: i.getModel().getFullModelRange(),
                text: r || "",
                forceMoveMarkers: !0
            }
        ]), i.pushUndoStop());
    }, [
        r
    ], M), l(()=>{
        u.current?.getModel()?.original.setValue(e || "");
    }, [
        e
    ], M), l(()=>{
        let { original: i, modified: f } = u.current.getModel();
        c.current.editor.setModelLanguage(i, t || n || "text"), c.current.editor.setModelLanguage(f, a || n || "text");
    }, [
        n,
        t,
        a
    ], M), l(()=>{
        c.current?.editor.setTheme(x);
    }, [
        x
    ], M), l(()=>{
        u.current?.updateOptions(y);
    }, [
        y
    ], M);
    let L = (0, _react.useCallback)(()=>{
        if (!c.current) return;
        o.current(c.current);
        let i = h(c.current, e || "", t || n || "text", m || ""), f = h(c.current, r || "", a || n || "text", E || "");
        u.current?.setModel({
            original: i,
            modified: f
        });
    }, [
        n,
        r,
        a,
        e,
        t,
        m,
        E
    ]), U = (0, _react.useCallback)(()=>{
        !b.current && w.current && (u.current = c.current.editor.createDiffEditor(w.current, {
            automaticLayout: !0,
            ...y
        }), L(), c.current?.editor.setTheme(x), O(!0), b.current = !0);
    }, [
        y,
        x,
        L
    ]);
    (0, _react.useEffect)(()=>{
        M && d.current(u.current, c.current);
    }, [
        M
    ]), (0, _react.useEffect)(()=>{
        !T && !M && U();
    }, [
        T,
        M,
        U
    ]);
    function I() {
        let i = u.current?.getModel();
        g || i?.original?.dispose(), N || i?.modified?.dispose(), u.current?.dispose();
    }
    return (0, _reactDefault.default).createElement(H, {
        width: z,
        height: V,
        isEditorReady: M,
        loading: P,
        _ref: w,
        className: F,
        wrapperProps: j
    });
}
var ie = Oe;
var we = (0, _react.memo)(ie);
function Pe() {
    let [e, r] = (0, _react.useState)((0, _loaderDefault.default).__getMonacoInstance());
    return k(()=>{
        let n;
        return e || (n = (0, _loaderDefault.default).init(), n.then((t)=>{
            r(t);
        })), ()=>n?.cancel();
    }), e;
}
var Le = Pe;
function He(e) {
    let r = (0, _react.useRef)();
    return (0, _react.useEffect)(()=>{
        r.current = e;
    }, [
        e
    ]), r.current;
}
var se = He;
var _ = new Map;
function Ve({ defaultValue: e, defaultLanguage: r, defaultPath: n, value: t, language: a, path: m, theme: E = "light", line: g, loading: N = "Loading...", options: x = {}, overrideServices: P = {}, saveViewState: y = !0, keepCurrentModel: V = !1, width: z = "100%", height: F = "100%", className: j, wrapperProps: A = {}, beforeMount: q = D, onMount: M = D, onChange: O, onValidate: T = D }) {
    let [s, u] = (0, _react.useState)(!1), [c, w] = (0, _react.useState)(!0), d = (0, _react.useRef)(null), o = (0, _react.useRef)(null), b = (0, _react.useRef)(null), L = (0, _react.useRef)(M), U = (0, _react.useRef)(q), I = (0, _react.useRef)(), i = (0, _react.useRef)(t), f = se(m), Q = (0, _react.useRef)(!1), B = (0, _react.useRef)(!1);
    k(()=>{
        let p = (0, _loaderDefault.default).init();
        return p.then((R)=>(d.current = R) && w(!1)).catch((R)=>R?.type !== "cancelation" && console.error("Monaco initialization: error:", R)), ()=>o.current ? pe() : p.cancel();
    }), l(()=>{
        let p = h(d.current, e || t || "", r || a || "", m || n || "");
        p !== o.current?.getModel() && (y && _.set(f, o.current?.saveViewState()), o.current?.setModel(p), y && o.current?.restoreViewState(_.get(m)));
    }, [
        m
    ], s), l(()=>{
        o.current?.updateOptions(x);
    }, [
        x
    ], s), l(()=>{
        !o.current || t === void 0 || (o.current.getOption(d.current.editor.EditorOption.readOnly) ? o.current.setValue(t) : t !== o.current.getValue() && (B.current = !0, o.current.executeEdits("", [
            {
                range: o.current.getModel().getFullModelRange(),
                text: t,
                forceMoveMarkers: !0
            }
        ]), o.current.pushUndoStop(), B.current = !1));
    }, [
        t
    ], s), l(()=>{
        let p = o.current?.getModel();
        p && a && d.current?.editor.setModelLanguage(p, a);
    }, [
        a
    ], s), l(()=>{
        g !== void 0 && o.current?.revealLine(g);
    }, [
        g
    ], s), l(()=>{
        d.current?.editor.setTheme(E);
    }, [
        E
    ], s);
    let X = (0, _react.useCallback)(()=>{
        if (!(!b.current || !d.current) && !Q.current) {
            U.current(d.current);
            let p = m || n, R = h(d.current, t || e || "", r || a || "", p || "");
            o.current = d.current?.editor.create(b.current, {
                model: R,
                automaticLayout: !0,
                ...x
            }, P), y && o.current.restoreViewState(_.get(p)), d.current.editor.setTheme(E), g !== void 0 && o.current.revealLine(g), u(!0), Q.current = !0;
        }
    }, [
        e,
        r,
        n,
        t,
        a,
        m,
        x,
        P,
        y,
        E,
        g
    ]);
    (0, _react.useEffect)(()=>{
        s && L.current(o.current, d.current);
    }, [
        s
    ]), (0, _react.useEffect)(()=>{
        !c && !s && X();
    }, [
        c,
        s,
        X
    ]), i.current = t, (0, _react.useEffect)(()=>{
        s && O && (I.current?.dispose(), I.current = o.current?.onDidChangeModelContent((p)=>{
            B.current || O(o.current.getValue(), p);
        }));
    }, [
        s,
        O
    ]), (0, _react.useEffect)(()=>{
        if (s) {
            let p = d.current.editor.onDidChangeMarkers((R)=>{
                let G = o.current.getModel()?.uri;
                if (G && R.find((J)=>J.path === G.path)) {
                    let J = d.current.editor.getModelMarkers({
                        resource: G
                    });
                    T?.(J);
                }
            });
            return ()=>{
                p?.dispose();
            };
        }
        return ()=>{};
    }, [
        s,
        T
    ]);
    function pe() {
        I.current?.dispose(), V ? y && _.set(m, o.current.saveViewState()) : o.current.getModel()?.dispose(), o.current.dispose();
    }
    return (0, _reactDefault.default).createElement(H, {
        width: z,
        height: F,
        isEditorReady: s,
        loading: N,
        _ref: b,
        className: j,
        wrapperProps: A
    });
}
var fe = Ve;
var de = (0, _react.memo)(fe);
var Ft = de;

},{"@monaco-editor/loader":"fLTi2","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fLTi2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _indexJsDefault.default));
var _indexJs = require("./loader/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);

},{"./loader/index.js":"7c6Nc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7c6Nc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rollupPluginBabelHelpersJs = require("../_virtual/_rollupPluginBabelHelpers.js");
var _stateLocal = require("state-local");
var _stateLocalDefault = parcelHelpers.interopDefault(_stateLocal);
var _indexJs = require("../config/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../validators/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _composeJs = require("../utils/compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _deepMergeJs = require("../utils/deepMerge.js");
var _deepMergeJsDefault = parcelHelpers.interopDefault(_deepMergeJs);
var _makeCancelableJs = require("../utils/makeCancelable.js");
var _makeCancelableJsDefault = parcelHelpers.interopDefault(_makeCancelableJs);
/** the local state of the module */ var _state$create = (0, _stateLocalDefault.default).create({
    config: (0, _indexJsDefault.default),
    isInitialized: false,
    resolve: null,
    reject: null,
    monaco: null
}), _state$create2 = (0, _rollupPluginBabelHelpersJs.slicedToArray)(_state$create, 2), getState = _state$create2[0], setState = _state$create2[1];
/**
 * set the loader configuration
 * @param {Object} config - the configuration object
 */ function config(globalConfig) {
    var _validators$config = (0, _indexJsDefault1.default).config(globalConfig), monaco = _validators$config.monaco, config = (0, _rollupPluginBabelHelpersJs.objectWithoutProperties)(_validators$config, [
        "monaco"
    ]);
    setState(function(state) {
        return {
            config: (0, _deepMergeJsDefault.default)(state.config, config),
            monaco: monaco
        };
    });
}
/**
 * handles the initialization of the monaco-editor
 * @return {Promise} - returns an instance of monaco (with a cancelable promise)
 */ function init() {
    var state = getState(function(_ref) {
        var monaco = _ref.monaco, isInitialized = _ref.isInitialized, resolve = _ref.resolve;
        return {
            monaco: monaco,
            isInitialized: isInitialized,
            resolve: resolve
        };
    });
    if (!state.isInitialized) {
        setState({
            isInitialized: true
        });
        if (state.monaco) {
            state.resolve(state.monaco);
            return (0, _makeCancelableJsDefault.default)(wrapperPromise);
        }
        if (window.monaco && window.monaco.editor) {
            storeMonacoInstance(window.monaco);
            state.resolve(window.monaco);
            return (0, _makeCancelableJsDefault.default)(wrapperPromise);
        }
        (0, _composeJsDefault.default)(injectScripts, getMonacoLoaderScript)(configureLoader);
    }
    return (0, _makeCancelableJsDefault.default)(wrapperPromise);
}
/**
 * injects provided scripts into the document.body
 * @param {Object} script - an HTML script element
 * @return {Object} - the injected HTML script element
 */ function injectScripts(script) {
    return document.body.appendChild(script);
}
/**
 * creates an HTML script element with/without provided src
 * @param {string} [src] - the source path of the script
 * @return {Object} - the created HTML script element
 */ function createScript(src) {
    var script = document.createElement('script');
    return src && (script.src = src), script;
}
/**
 * creates an HTML script element with the monaco loader src
 * @return {Object} - the created HTML script element
 */ function getMonacoLoaderScript(configureLoader) {
    var state = getState(function(_ref2) {
        var config = _ref2.config, reject = _ref2.reject;
        return {
            config: config,
            reject: reject
        };
    });
    var loaderScript = createScript("".concat(state.config.paths.vs, "/loader.js"));
    loaderScript.onload = function() {
        return configureLoader();
    };
    loaderScript.onerror = state.reject;
    return loaderScript;
}
/**
 * configures the monaco loader
 */ function configureLoader() {
    var state = getState(function(_ref3) {
        var config = _ref3.config, resolve = _ref3.resolve, reject = _ref3.reject;
        return {
            config: config,
            resolve: resolve,
            reject: reject
        };
    });
    var require1 = window.require;
    require1.config(state.config);
    require1([
        'vs/editor/editor.main'
    ], function(monaco) {
        storeMonacoInstance(monaco);
        state.resolve(monaco);
    }, function(error) {
        state.reject(error);
    });
}
/**
 * store monaco instance in local state
 */ function storeMonacoInstance(monaco) {
    if (!getState().monaco) setState({
        monaco: monaco
    });
}
/**
 * internal helper function
 * extracts stored monaco instance
 * @return {Object|null} - the monaco instance
 */ function __getMonacoInstance() {
    return getState(function(_ref4) {
        var monaco = _ref4.monaco;
        return monaco;
    });
}
var wrapperPromise = new Promise(function(resolve, reject) {
    return setState({
        resolve: resolve,
        reject: reject
    });
});
var loader = {
    config: config,
    init: init,
    __getMonacoInstance: __getMonacoInstance
};
exports.default = loader;

},{"../_virtual/_rollupPluginBabelHelpers.js":"apqP6","state-local":"2hfrf","../config/index.js":"auMSe","../validators/index.js":"1jk9u","../utils/compose.js":"lfwBP","../utils/deepMerge.js":"fiQ4I","../utils/makeCancelable.js":"g0IQu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"apqP6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrayLikeToArray", ()=>_arrayLikeToArray);
parcelHelpers.export(exports, "arrayWithHoles", ()=>_arrayWithHoles);
parcelHelpers.export(exports, "defineProperty", ()=>_defineProperty);
parcelHelpers.export(exports, "iterableToArrayLimit", ()=>_iterableToArrayLimit);
parcelHelpers.export(exports, "nonIterableRest", ()=>_nonIterableRest);
parcelHelpers.export(exports, "objectSpread2", ()=>_objectSpread2);
parcelHelpers.export(exports, "objectWithoutProperties", ()=>_objectWithoutProperties);
parcelHelpers.export(exports, "objectWithoutPropertiesLoose", ()=>_objectWithoutPropertiesLoose);
parcelHelpers.export(exports, "slicedToArray", ()=>_slicedToArray);
parcelHelpers.export(exports, "unsupportedIterableToArray", ()=>_unsupportedIterableToArray);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2hfrf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(x) {
        return fns.reduceRight(function(y, f) {
            return f(y);
        }, x);
    };
}
function curry(fn) {
    return function curried() {
        var _this = this;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return args.length >= fn.length ? fn.apply(this, args) : function() {
            for(var _len3 = arguments.length, nextArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)nextArgs[_key3] = arguments[_key3];
            return curried.apply(_this, [].concat(args, nextArgs));
        };
    };
}
function isObject(value) {
    return ({}).toString.call(value).includes('Object');
}
function isEmpty(obj) {
    return !Object.keys(obj).length;
}
function isFunction(value) {
    return typeof value === 'function';
}
function hasOwnProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
function validateChanges(initial, changes) {
    if (!isObject(changes)) errorHandler('changeType');
    if (Object.keys(changes).some(function(field) {
        return !hasOwnProperty(initial, field);
    })) errorHandler('changeField');
    return changes;
}
function validateSelector(selector) {
    if (!isFunction(selector)) errorHandler('selectorType');
}
function validateHandler(handler) {
    if (!(isFunction(handler) || isObject(handler))) errorHandler('handlerType');
    if (isObject(handler) && Object.values(handler).some(function(_handler) {
        return !isFunction(_handler);
    })) errorHandler('handlersType');
}
function validateInitial(initial) {
    if (!initial) errorHandler('initialIsRequired');
    if (!isObject(initial)) errorHandler('initialType');
    if (isEmpty(initial)) errorHandler('initialContent');
}
function throwError(errorMessages, type) {
    throw new Error(errorMessages[type] || errorMessages["default"]);
}
var errorMessages = {
    initialIsRequired: 'initial state is required',
    initialType: 'initial state should be an object',
    initialContent: 'initial state shouldn\'t be an empty object',
    handlerType: 'handler should be an object or a function',
    handlersType: 'all handlers should be a functions',
    selectorType: 'selector should be a function',
    changeType: 'provided value of changes should be an object',
    changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
    "default": 'an unknown error accured in `state-local` package'
};
var errorHandler = curry(throwError)(errorMessages);
var validators = {
    changes: validateChanges,
    selector: validateSelector,
    handler: validateHandler,
    initial: validateInitial
};
function create(initial) {
    var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    validators.initial(initial);
    validators.handler(handler);
    var state = {
        current: initial
    };
    var didUpdate = curry(didStateUpdate)(state, handler);
    var update = curry(updateState)(state);
    var validate = curry(validators.changes)(initial);
    var getChanges = curry(extractChanges)(state);
    function getState() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function(state) {
            return state;
        };
        validators.selector(selector);
        return selector(state.current);
    }
    function setState(causedChanges) {
        compose(didUpdate, update, validate, getChanges)(causedChanges);
    }
    return [
        getState,
        setState
    ];
}
function extractChanges(state, causedChanges) {
    return isFunction(causedChanges) ? causedChanges(state.current) : causedChanges;
}
function updateState(state, changes) {
    state.current = _objectSpread2(_objectSpread2({}, state.current), changes);
    return changes;
}
function didStateUpdate(state, handler, changes) {
    isFunction(handler) ? handler(state.current) : Object.keys(changes).forEach(function(field) {
        var _handler$field;
        return (_handler$field = handler[field]) === null || _handler$field === void 0 ? void 0 : _handler$field.call(handler, state.current[field]);
    });
    return changes;
}
var index = {
    create: create
};
exports.default = index;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"auMSe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var config = {
    paths: {
        vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.52.2/min/vs'
    }
};
exports.default = config;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1jk9u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorHandler", ()=>errorHandler);
parcelHelpers.export(exports, "errorMessages", ()=>errorMessages);
var _curryJs = require("../utils/curry.js");
var _curryJsDefault = parcelHelpers.interopDefault(_curryJs);
var _isObjectJs = require("../utils/isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/**
 * validates the configuration object and informs about deprecation
 * @param {Object} config - the configuration object 
 * @return {Object} config - the validated configuration object
 */ function validateConfig(config) {
    if (!config) errorHandler('configIsRequired');
    if (!(0, _isObjectJsDefault.default)(config)) errorHandler('configType');
    if (config.urls) {
        informAboutDeprecation();
        return {
            paths: {
                vs: config.urls.monacoBase
            }
        };
    }
    return config;
}
/**
 * logs deprecation message
 */ function informAboutDeprecation() {
    console.warn(errorMessages.deprecation);
}
function throwError(errorMessages, type) {
    throw new Error(errorMessages[type] || errorMessages["default"]);
}
var errorMessages = {
    configIsRequired: 'the configuration object is required',
    configType: 'the configuration object should be an object',
    "default": 'an unknown error accured in `@monaco-editor/loader` package',
    deprecation: "Deprecation warning!\n    You are using deprecated way of configuration.\n\n    Instead of using\n      monaco.config({ urls: { monacoBase: '...' } })\n    use\n      monaco.config({ paths: { vs: '...' } })\n\n    For more please check the link https://github.com/suren-atoyan/monaco-loader#config\n  "
};
var errorHandler = (0, _curryJsDefault.default)(throwError)(errorMessages);
var validators = {
    config: validateConfig
};
exports.default = validators;

},{"../utils/curry.js":"kCBTg","../utils/isObject.js":"lSiZO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kCBTg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function curry(fn) {
    return function curried() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return args.length >= fn.length ? fn.apply(this, args) : function() {
            for(var _len2 = arguments.length, nextArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)nextArgs[_key2] = arguments[_key2];
            return curried.apply(_this, [].concat(args, nextArgs));
        };
    };
}
exports.default = curry;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lSiZO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObject(value) {
    return ({}).toString.call(value).includes('Object');
}
exports.default = isObject;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lfwBP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var compose = function compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(x) {
        return fns.reduceRight(function(y, f) {
            return f(y);
        }, x);
    };
};
exports.default = compose;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fiQ4I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rollupPluginBabelHelpersJs = require("../_virtual/_rollupPluginBabelHelpers.js");
function merge(target, source) {
    Object.keys(source).forEach(function(key) {
        if (source[key] instanceof Object) {
            if (target[key]) Object.assign(source[key], merge(target[key], source[key]));
        }
    });
    return (0, _rollupPluginBabelHelpersJs.objectSpread2)((0, _rollupPluginBabelHelpersJs.objectSpread2)({}, target), source);
}
exports.default = merge;

},{"../_virtual/_rollupPluginBabelHelpers.js":"apqP6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g0IQu":[function(require,module,exports,__globalThis) {
// The source (has been changed) is https://github.com/facebook/react/issues/5465#issuecomment-157888325
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CANCELATION_MESSAGE", ()=>CANCELATION_MESSAGE);
var CANCELATION_MESSAGE = {
    type: 'cancelation',
    msg: 'operation is manually canceled'
};
function makeCancelable(promise) {
    var hasCanceled_ = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(val) {
            return hasCanceled_ ? reject(CANCELATION_MESSAGE) : resolve(val);
        });
        promise["catch"](reject);
    });
    return wrappedPromise.cancel = function() {
        return hasCanceled_ = true;
    }, wrappedPromise;
}
exports.default = makeCancelable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2kNfK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderEnumProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _property = require("../mask/property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _useMask = require("../../hooks/use-mask");
var _select = require("@form-engine/builder-application/components/select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _useMaskConfig = require("../../hooks/use-mask-config");
var _useMaskValidation = require("../../hooks/use-mask-validation");
function BuilderEnumProperty({ label, propertyName, options = [], defaultValue = '', ...props }) {
    const stacked = 'stacked' in props && props.stacked !== false;
    delete props.stacked;
    const { state, setItemProperty } = (0, _useMask.useMaskContext)();
    const required = 'required' in props && props.required !== false;
    delete props.required;
    const value = typeof state?.[propertyName] === 'string' ? state[propertyName] : defaultValue;
    const permission = (0, _useMaskConfig.useMaskPropertyPermission)(propertyName);
    const error = (0, _useMaskValidation.useMaskPropertyError)(propertyName);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertyDefault.default), {
        className: "feb-enum-property",
        label: label,
        error: error?.message,
        stacked: stacked,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "flex-grow-1",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default).Advanced, {
                ...props,
                value: value,
                required: required,
                isDisabled: permission === 'read',
                onChange: (e)=>setItemProperty(propertyName, e.target.value),
                children: options.map((option, key)=>{
                    let label, value;
                    if (Array.isArray(option)) [value, label] = option;
                    else label = value = option;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                        value: value,
                        children: label || value
                    }, key);
                })
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../mask/property":"dLorN","../../hooks/use-mask":"72MTY","@form-engine/builder-application/components/select":"38vFU","../../hooks/use-mask-config":"daHU1","../../hooks/use-mask-validation":"cYKiY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"vl6mJ":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"8OGXM","./de.json":"7c8hb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8OGXM":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineStaticDatasource\":{\"title\":\"Static Data\",\"description\":\"Manually insert static data to be used inside your form\"},\"mask\":{\"FormEngineStaticDatasource\":{\"description\":\"Description\",\"sourceType\":\"Source Type\",\"resultPath\":\"Result Path\",\"resultPathPlaceholder\":\"e.g. entries\",\"labelColumn\":\"Label Column\",\"labelColumnPlaceholder\":\"e.g. {{$i.Label}}\",\"valueColumn\":\"Value Column\",\"valueColumnPlaceholder\":\"e.g. {{$i.Value}}\",\"source\":\"Source\",\"setup\":\"Setup\",\"data\":\"Browse\"}}}");

},{}],"7c8hb":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"FormEngineStaticDatasource":{"title":"Statische Daten","description":"F\xfcgen Sie manuell statische Daten ein, die in Ihrem Formular verwendet werden sollen"},"mask":{"FormEngineStaticDatasource":{"description":"Beschreibung","sourceType":"Quelle Typ","resultPath":"Ergebnispfad","resultPathPlaceholder":"z.B. Eintr\xe4ge","labelColumn":"Spalte beschriften","labelColumnPlaceholder":"z.B. {{.Etikett}}","valueColumn":"Wertspalte","valueColumnPlaceholder":"z.B. {{.Wert}}","source":"Quelle","setup":"Aufstellen","data":"Durchsuche"}}}');

},{}],"7m4JD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpRequestDatasourceMask = require("./components/http-request-datasource-mask");
var _httpRequestDatasourceMaskDefault = parcelHelpers.interopDefault(_httpRequestDatasourceMask);
var _client = require("./datasources/http-request/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    datasources: {
        [(0, _clientDefault.default).apiName]: {
            label: `${(0, _clientDefault.default).apiName}.title`,
            description: `${(0, _clientDefault.default).apiName}.description`,
            exposesOptions: true,
            Icon: (0, _reactBootstrapIcons.Server),
            Datasource: (0, _clientDefault.default),
            Mask: (0, _httpRequestDatasourceMaskDefault.default)
        }
    }
};

},{"./components/http-request-datasource-mask":"aikDv","./datasources/http-request/client":"3lpgi","react-bootstrap-icons":"3TzoC","./builder-translations":"8t1id","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aikDv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderHttpRequestDatasourceSetup", ()=>BuilderHttpRequestDatasourceSetup);
parcelHelpers.export(exports, "default", ()=>BuilderHttpRequestDatasourceMask);
var _jsxRuntime = require("react/jsx-runtime");
var _useFormEditor = require("@form-engine/builder-form-editor/hooks/use-form-editor");
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _datasourceDataTable = require("@form-engine/builder-application/components/datasource-data-table");
var _datasourceDataTableDefault = parcelHelpers.interopDefault(_datasourceDataTable);
var _drawerTabs = require("@form-engine/builder-application/components/drawer-tabs");
var _drawerTabsDefault = parcelHelpers.interopDefault(_drawerTabs);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _enum = require("@form-engine/builder-mask/components/properties/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _string = require("@form-engine/builder-mask/components/properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _name = require("@form-engine/builder-mask/components/properties/name");
var _nameDefault = parcelHelpers.interopDefault(_name);
var _requestPayload = require("@form-engine/builder-mask/components/groups/request-payload");
var _requestPayloadDefault = parcelHelpers.interopDefault(_requestPayload);
var _client = require("../datasources/http-request/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _builderApplication = require("@form-engine/builder-application");
var _auth = require("@form-engine/builder-mask/components/properties/auth");
var _authDefault = parcelHelpers.interopDefault(_auth);
function BuilderHttpRequestDatasourceSetup() {
    const { state } = (0, _useMask.useMaskContext)();
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _clientDefault.default).apiName}.`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nameDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "description",
                        label: c('description')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        compilable: true,
                        propertyName: "url",
                        label: c('url'),
                        type: "url"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                        propertyName: "method",
                        label: c('method'),
                        options: [
                            'GET',
                            'POST',
                            'PUT',
                            'PATCH',
                            'DELETE'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupDefault.default), {
                label: c('authGroupTitle'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authDefault.default), {})
            }),
            [
                'POST',
                'PUT',
                'PATCH'
            ].includes(String(state?.method)) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requestPayloadDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                label: c('responseGroupTitle'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                        propertyName: "sourceType",
                        label: c('sourceType'),
                        options: [
                            [
                                'csv',
                                'CSV'
                            ],
                            [
                                'json',
                                'JSON'
                            ]
                        ]
                    }),
                    String(state?.sourceType) === 'json' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        compilable: true,
                        propertyName: "resultPath",
                        label: c('resultPath'),
                        placeholder: 'eg. "entries"'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "labelColumn",
                        label: c('labelColumn'),
                        placeholder: c('labelColumnPlaceholder'),
                        compilable: true,
                        variableOptions: [
                            '$i.'
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "valueColumn",
                        label: c('valueColumn'),
                        placeholder: c('valueColumnPlaceholder'),
                        compilable: true,
                        variableOptions: [
                            '$i.'
                        ]
                    })
                ]
            })
        ]
    });
}
function BuilderHttpRequestDatasourceMask({ id }) {
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _clientDefault.default).apiName}.`);
    const { state: editor, setItem: setEditorItem } = (0, _useFormEditor.useFormEditorContext)();
    const { tab = 'setup' } = (editor?.datasources ?? {})[id] ?? {};
    const setTab = (0, _react.useCallback)((tab)=>{
        const { datasources } = editor;
        const { [id]: datasource = {} } = datasources ?? {};
        setEditorItem('datasources', {
            ...datasources ?? {},
            [id]: {
                ...datasource,
                tab
            }
        });
    }, [
        editor,
        setEditorItem,
        id
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerTabsDefault.default), {
                activeKey: tab,
                items: {
                    setup: c('setup'),
                    data: c('data')
                },
                onChange: setTab
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "feb-view",
                children: [
                    tab === 'setup' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "feb-view-inner",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                                xl: {
                                    span: 8,
                                    offset: 2
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderHttpRequestDatasourceSetup, {})
                            })
                        })
                    }),
                    tab === 'data' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "feb-view-inner p-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datasourceDataTableDefault.default), {
                            id: id
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-form-editor/hooks/use-form-editor":"4pkiD","@form-engine/builder-mask/hooks/use-mask":"72MTY","react":"9njXz","react-bootstrap":"f5rnA","@form-engine/builder-application/components/datasource-data-table":"2ROOD","@form-engine/builder-application/components/drawer-tabs":"5gJGr","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/properties/enum":"2kNfK","@form-engine/builder-mask/components/properties/string":"e6M7S","@form-engine/builder-mask/components/properties/name":"cCuUh","@form-engine/builder-mask/components/groups/request-payload":"cUiDR","../datasources/http-request/client":"3lpgi","@form-engine/builder-application":"7iKr0","@form-engine/builder-mask/components/properties/auth":"g7ynP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cUiDR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderMaskGroupRequestPayloadTypes", ()=>BuilderMaskGroupRequestPayloadTypes);
parcelHelpers.export(exports, "default", ()=>BuilderMaskGroupRequestPayload);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useMask = require("../../hooks/use-mask");
var _group = require("../mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _code = require("../properties/code");
var _codeDefault = parcelHelpers.interopDefault(_code);
var _enum = require("../properties/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _object = require("../properties/object");
var _objectDefault = parcelHelpers.interopDefault(_object);
var _builderApplication = require("@form-engine/builder-application");
const BuilderMaskGroupRequestPayloadTypes = {
    'text/plain': {
        label: 'mask.requestPayloadGroup.textPlain',
        component: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _codeDefault.default), {
                ...props,
                language: "text"
            })
    },
    'text/csv': {
        label: 'mask.requestPayloadGroup.textCsv',
        component: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _codeDefault.default), {
                ...props,
                language: "csv"
            })
    },
    'application/json': {
        label: 'mask.requestPayloadGroup.applicationJson',
        component: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _objectDefault.default), {
                ...props
            })
    },
    'application/x-www-form-urlencoded': {
        label: 'mask.requestPayloadGroup.applicationXWwwFormUrlencoded',
        component: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _codeDefault.default), {
                ...props,
                language: "json"
            })
    }
};
function BuilderMaskGroupRequestPayload({ bodyPropertyName = 'body', contentTypePropertyName = 'contentType', types = BuilderMaskGroupRequestPayloadTypes, forceContentType, children, ...props }) {
    const { state } = (0, _useMask.useMaskContext)();
    const targetContentType = forceContentType ? forceContentType : state?.[contentTypePropertyName];
    const Component = targetContentType && String(targetContentType) in types ? types[targetContentType]?.component : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
        id: "BuilderMaskGroupRequestPayload",
        label: (0, _builderApplication.i18n).c('mask.requestPayloadGroup.title'),
        ...props,
        children: [
            !forceContentType && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                propertyName: contentTypePropertyName,
                label: (0, _builderApplication.i18n).c('mask.requestPayloadGroup.contentType'),
                options: Object.entries(types).map(([key, def])=>[
                        key,
                        (0, _builderApplication.i18n).c(def.label)
                    ])
            }),
            Component && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                label: (0, _builderApplication.i18n).c('mask.requestPayloadGroup.body'),
                propertyName: bodyPropertyName
            }),
            children
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../hooks/use-mask":"72MTY","../mask/group":"1nZOW","../properties/code":"3j0at","../properties/enum":"2kNfK","../properties/object":"2qru1","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2qru1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderObjectProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _select = require("@form-engine/builder-application/components/select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _builderArrayFormControl = require("@form-engine/builder-array-form-control");
var _builderArrayFormControlDefault = parcelHelpers.interopDefault(_builderArrayFormControl);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useMask = require("../../hooks/use-mask");
var _useMaskConfig = require("../../hooks/use-mask-config");
var _property = require("../mask/property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _builderApplication = require("@form-engine/builder-application");
var _useMaskValidation = require("../../hooks/use-mask-validation");
const DEFAULT_PROPERTY_TYPE = 'string';
const builderObjectPropertyCols = {
    key: {
        label: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                id: "mask.objectProperty.key"
            }),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        formatter: (source)=>String(source ?? '').trim(),
        compilable: true
    },
    type: {
        label: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                id: "mask.objectProperty.type"
            }),
        size: '80px',
        props: {
            innerProps: {
                as: ({ value, onChange })=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default).Advanced, {
                        value: value,
                        onChange: onChange,
                        options: [
                            {
                                value: 'string',
                                label: (0, _builderApplication.i18n).c('mask.objectProperty.typeOptions.string')
                            },
                            {
                                value: 'number',
                                label: (0, _builderApplication.i18n).c('mask.objectProperty.typeOptions.number')
                            },
                            {
                                value: 'boolean',
                                label: (0, _builderApplication.i18n).c('mask.objectProperty.typeOptions.boolean')
                            },
                            {
                                value: 'json',
                                label: (0, _builderApplication.i18n).c('mask.objectProperty.typeOptions.json')
                            },
                            {
                                value: 'raw-string',
                                label: (0, _builderApplication.i18n).c('mask.objectProperty.typeOptions.raw-string')
                            }
                        ]
                    });
                }
            }
        }
    },
    value: {
        label: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                id: "mask.objectProperty.value"
            }),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        formatter: (source)=>String(source ?? '').trim(),
        compilable: true
    }
};
function BuilderObjectProperty({ cols: colsProp, propertyName, defaultValue, label, ...props }) {
    const cols = (0, _react.useMemo)(()=>{
        if (!colsProp) return builderObjectPropertyCols;
        return (0, _mergeDefault.default)({}, builderObjectPropertyCols, colsProp);
    }, [
        colsProp
    ]);
    const { state, setItemProperty } = (0, _useMask.useMaskContext)();
    const value = (0, _react.useMemo)(()=>{
        let entries = state?.[propertyName] ? state[propertyName] : defaultValue;
        // convert deprecated object values to array
        if (entries && !Array.isArray(entries)) entries = Object.entries(entries).map(([key, def])=>({
                ...def ?? {},
                key
            }));
        return (entries ?? []).map(({ key, value, type })=>({
                key,
                value: value ?? '',
                type: type || DEFAULT_PROPERTY_TYPE
            }));
    }, [
        state?.[propertyName],
        defaultValue
    ]);
    const handleChange = (0, _react.useCallback)((update)=>{
        setItemProperty(propertyName, (update ?? []).map(({ key, value, type })=>({
                key,
                value: value ?? '',
                type: type || DEFAULT_PROPERTY_TYPE
            })));
    }, [
        setItemProperty,
        propertyName
    ]);
    const permission = (0, _useMaskConfig.useMaskPropertyPermission)(propertyName);
    const error = (0, _useMaskValidation.useMaskPropertyError)(propertyName);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertyDefault.default), {
        className: "feb-array-property",
        stacked: true,
        label: label,
        error: error?.message,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderArrayFormControlDefault.default), {
            schema: 'object',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            cols: cols,
            value: value,
            disabled: permission === 'read',
            onChange: handleChange
        })
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-application/components/select":"38vFU","@form-engine/builder-array-form-control":"2zkEC","lodash/merge":"iHC1F","react":"9njXz","../../hooks/use-mask":"72MTY","../../hooks/use-mask-config":"daHU1","../mask/property":"dLorN","@form-engine/builder-application":"7iKr0","../../hooks/use-mask-validation":"cYKiY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2zkEC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ARRAY_SCHEMA", ()=>ARRAY_SCHEMA);
parcelHelpers.export(exports, "OBJECT_SCHEMA", ()=>OBJECT_SCHEMA);
parcelHelpers.export(exports, "CSSNS", ()=>CSSNS);
parcelHelpers.export(exports, "default", ()=>BuilderArrayFormControl);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _builderIconButton = require("@form-engine/builder-icon-button");
var _builderIconButtonDefault = parcelHelpers.interopDefault(_builderIconButton);
var _headCell = require("./head-cell");
var _headCellDefault = parcelHelpers.interopDefault(_headCell);
var _item = require("./item");
const ARRAY_SCHEMA = 'array';
const OBJECT_SCHEMA = 'object';
const CSSNS = 'feb-array-form-control';
function BuilderArrayFormControl({ schema = OBJECT_SCHEMA, cols: colsProp, value: valueProp, onChange, className, as: Component = 'div', head = true, headCell: HeadCellComponent = (0, _headCellDefault.default), item: ItemComponent = (0, _item.BuilderArrayFormControlItem), disabled = false, ...props }) {
    const dnd = props.dnd !== false;
    delete props.dnd;
    const value = (0, _react.useMemo)(()=>valueProp || [], [
        valueProp
    ]);
    const cols = (0, _react.useMemo)(()=>{
        if (!colsProp) return [];
        let cols;
        if (!Array.isArray(colsProp)) cols = Object.entries(colsProp);
        else cols = colsProp;
        return cols.map(([key, config])=>{
            if (!config) return {
                key,
                label: key
            };
            if (typeof config === 'string') return {
                key,
                label: config
            };
            return {
                ...config,
                key
            };
        });
    }, [
        colsProp
    ]);
    const handleItemChange = (0, _react.useCallback)((index)=>{
        return (data)=>{
            const copy = [
                ...value
            ];
            if (!data) {
                copy.splice(index, 1);
                onChange && onChange(copy);
                return;
            }
            copy[index] = data;
            onChange && onChange(copy);
        };
    }, [
        value,
        onChange
    ]);
    const handleAddItem = (0, _react.useCallback)(()=>{
        if (!onChange) return;
        let item = null;
        if (schema === ARRAY_SCHEMA) item = cols.map(({ defaultValue = '' })=>defaultValue);
        else if (schema === OBJECT_SCHEMA) item = Object.fromEntries(cols.map(({ defaultValue = '', key })=>[
                key,
                defaultValue
            ]));
        else if (typeof schema === 'function') item = schema();
        item && onChange([
            ...value,
            item
        ]);
    }, [
        value,
        onChange,
        schema,
        cols
    ]);
    const handleMoveItem = (0, _react.useCallback)((sourceIndex, targetIndex)=>{
        const copy = [
            ...value
        ];
        copy.splice(sourceIndex, 1);
        let insertIndex = copy.indexOf(value[targetIndex]);
        if (sourceIndex < targetIndex) insertIndex += 1;
        copy.splice(insertIndex, 0, value[sourceIndex]);
        onChange && onChange(copy);
    }, [
        value,
        onChange
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Component, {
        className: `${CSSNS} ${disabled ? `${CSSNS}--disabled` : ''} ${className}`,
        ...props,
        children: [
            head && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `${CSSNS}__head`,
                children: [
                    dnd && /*#__PURE__*/ (0, _jsxRuntime.jsx)(HeadCellComponent, {
                        col: {
                            label: ''
                        },
                        className: `${CSSNS}__prefix-headcell`
                    }),
                    cols && cols.map((col, index)=>{
                        const { headCellComponent: Component = HeadCellComponent } = col;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                            col: col
                        }, index);
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(HeadCellComponent, {
                        col: {
                            label: ''
                        },
                        className: `${CSSNS}__suffix-headcell`
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `${CSSNS}__body`,
                children: value.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ItemComponent, {
                        cols: cols,
                        value: item,
                        schema: schema,
                        onChange: handleItemChange(index),
                        dnd: dnd,
                        index: index,
                        onMove: handleMoveItem
                    }, index))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-end",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderIconButtonDefault.default), {
                    onClick: handleAddItem,
                    title: "Add item",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.PlusCircleFill), {})
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap-icons":"3TzoC","@form-engine/builder-icon-button":"1BXFC","./head-cell":"l4Gxc","./item":"5qobc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1BXFC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconButton = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(({ as: Component = 'button', color, className = '', ...props }, ref)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        className: `feb-icon-btn ${color ? `feb-icon-btn--${color}` : ''} ${className}`,
        ref: ref
    });
});
IconButton.displayName = 'IconButton';
exports.default = IconButton;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l4Gxc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderArrayFormControlHeadCell);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require(".");
var _cell = require("./cell");
var _cellDefault = parcelHelpers.interopDefault(_cell);
function BuilderArrayFormControlHeadCell({ as: Component = (0, _cellDefault.default), className = '', ...props }) {
    const label = typeof props.col?.label === 'function' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(props.col.label, {}) : props.col?.label;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        className: `${(0, _.CSSNS)}__headcell ${className}`,
        ...props,
        children: label
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz",".":"2zkEC","./cell":"Lhb09","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Lhb09":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderArrayFormControlCell);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require(".");
function BuilderArrayFormControlCell({ as: Component = 'div', className = '', col = {}, ...props }) {
    const { size } = col;
    const style = (0, _react.useMemo)(()=>{
        const sizeStyle = {};
        if (size === 'auto') sizeStyle.flex = `1 0 auto`;
        else if (typeof size === 'number') sizeStyle.flex = `0 0 ${size}px`;
        else sizeStyle.flex = `0 0 ${size}`;
        return {
            ...props.style || {},
            ...sizeStyle
        };
    }, [
        size,
        props.style
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        style: style,
        className: `${(0, _.CSSNS)}__cell ${className}`
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz",".":"2zkEC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5qobc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderArrayFormControlItem", ()=>BuilderArrayFormControlItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _builderIconButton = require("@form-engine/builder-icon-button");
var _builderIconButtonDefault = parcelHelpers.interopDefault(_builderIconButton);
var _ = require(".");
var _editableCell = require("./editable-cell");
var _editableCellDefault = parcelHelpers.interopDefault(_editableCell);
function BuilderArrayFormControlItem({ as: Component = 'div', cell: CellComponent = (0, _editableCellDefault.default), className = '', cols, value, onChange, schema, dnd = false, index: itemIndex, onMove, ...props }) {
    const [draggable, setDraggable] = (0, _react.useState)(false);
    const cells = (0, _react.useMemo)(()=>{
        return cols.map((col, index)=>{
            if (schema === (0, _.ARRAY_SCHEMA)) return value[index];
            else if (col.key) return value?.[col.key];
        });
    }, [
        value,
        cols,
        schema
    ]);
    const handleCellChange = (0, _react.useCallback)((index)=>{
        return (event)=>{
            if (!onChange) return;
            const cellValue = event.target?.value || '';
            let copy;
            if (schema === (0, _.ARRAY_SCHEMA)) copy = cols.map((_col, colIndex)=>{
                if (index === colIndex) return cellValue;
                return value[colIndex];
            });
            else if (schema === (0, _.OBJECT_SCHEMA)) copy = Object.fromEntries(cols.map((col, colIndex)=>{
                if (!col.key) throw new Error('invalid key configuration');
                return [
                    col.key,
                    colIndex === index ? col.formatter ? col.formatter(cellValue) : cellValue : value?.[col.key]
                ];
            }));
            else if (typeof schema === 'function') {
                const { key } = cols[index];
                if (!key) throw new Error('invalid key configuration');
                copy = schema({
                    ...value,
                    [key]: cellValue
                });
            }
            onChange(copy);
        };
    }, [
        value,
        onChange
    ]);
    const handleDeleteItem = (0, _react.useCallback)(()=>{
        onChange && onChange(null);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Component, {
        ...props,
        className: `${(0, _.CSSNS)}__row ${className}`,
        draggable: draggable,
        onDragStart: (e)=>{
            e.dataTransfer.dropEffect = 'move';
            e.dataTransfer.setData('sourceIndex', String(itemIndex));
        },
        onDragOver: (e)=>{
            e.preventDefault();
        },
        onDrop: (e)=>{
            const sourceIndex = Number(e.dataTransfer.getData('sourceIndex'));
            if (!onMove || sourceIndex === itemIndex) return;
            onMove(sourceIndex, itemIndex);
        },
        children: [
            dnd && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `${(0, _.CSSNS)}__cell ${(0, _.CSSNS)}__prefix-cell`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderIconButtonDefault.default), {
                    className: `${(0, _.CSSNS)}__dnd-btn`,
                    onMouseOver: ()=>setDraggable(true),
                    onMouseOut: ()=>setDraggable(false),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.GripHorizontal), {})
                })
            }),
            cols.map((col, index)=>{
                const { cellComponent: Component = CellComponent, key, asModel, props = {}, compilable } = col;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                    ...props,
                    compilable: compilable,
                    col: col,
                    value: asModel ? value : cells[index],
                    onChange: asModel ? onChange : handleCellChange(index)
                }, key);
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `${(0, _.CSSNS)}__cell ${(0, _.CSSNS)}__suffix-cell`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderIconButtonDefault.default), {
                    className: `${(0, _.CSSNS)}__remove-btn`,
                    onClick: handleDeleteItem,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.X), {})
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap-icons":"3TzoC","@form-engine/builder-icon-button":"1BXFC",".":"2zkEC","./editable-cell":"lEFU0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lEFU0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderArrayFormControlEditableCell);
var _jsxRuntime = require("react/jsx-runtime");
var _variableSelect = require("@form-engine/builder-application/components/variable-select");
var _variableSelectDefault = parcelHelpers.interopDefault(_variableSelect);
var _builderIconButton = require("@form-engine/builder-icon-button");
var _builderIconButtonDefault = parcelHelpers.interopDefault(_builderIconButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _ = require(".");
var _cell = require("./cell");
var _cellDefault = parcelHelpers.interopDefault(_cell);
function BuilderArrayFormControlEditableCell({ as: Component = (0, _cellDefault.default), className = '', innerProps: innerPropsProp = {}, value, onChange, compilable = false, ...props }) {
    const { as: ControlComponent = 'input', ...innerProps } = innerPropsProp;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Component, {
        ...props,
        className: `${(0, _.CSSNS)}__editable-cell ${className} ${compilable ? 'd-flex flex-row' : ''}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ControlComponent, {
                ...innerProps,
                value: value || '',
                onChange: onChange,
                className: "flex-grow"
            }),
            compilable && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _variableSelectDefault.default), {
                value: value,
                onChange: (value)=>onChange?.({
                        target: {
                            value
                        }
                    }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderIconButtonDefault.default), {
                    color: "secondary",
                    className: "ms-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.Braces), {})
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-application/components/variable-select":"fDZcE","@form-engine/builder-icon-button":"1BXFC","react":"9njXz","react-bootstrap-icons":"3TzoC",".":"2zkEC","./cell":"Lhb09","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g7ynP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderAuthProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useMask = require("../../hooks/use-mask");
var _enum = require("./enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _string = require("./string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _builderApplication = require("@form-engine/builder-application");
function BuilderAuthProperty({ authPropertyName = 'auth', usernameProperyName = 'basicAuthUsername', passwordProperyName = 'basicAuthPassword', accessTokenProperyName = 'bearerToken' }) {
    const { state } = (0, _useMask.useMaskContext)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                propertyName: authPropertyName,
                label: (0, _builderApplication.i18n).c('mask.authProperty.method'),
                options: [
                    [
                        '',
                        (0, _builderApplication.i18n).c('mask.authProperty.methods.none')
                    ],
                    [
                        'basic',
                        (0, _builderApplication.i18n).c('mask.authProperty.methods.basic')
                    ],
                    [
                        'bearer',
                        (0, _builderApplication.i18n).c('mask.authProperty.methods.bearer')
                    ]
                ]
            }),
            state?.auth === 'basic' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        compilable: true,
                        propertyName: usernameProperyName,
                        label: (0, _builderApplication.i18n).c('mask.authProperty.basicAuthUsername'),
                        defaultValue: "{{defaultBasicAuthUsername}}"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        compilable: true,
                        propertyName: passwordProperyName,
                        label: (0, _builderApplication.i18n).c('mask.authProperty.basicAuthPassword'),
                        defaultValue: "{{defaultBasicAuthPassword}}",
                        type: "password"
                    })
                ]
            }),
            state?.auth === 'bearer' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                    compilable: true,
                    propertyName: accessTokenProperyName,
                    defaultValue: "{{request.headers.authorization}}",
                    label: (0, _builderApplication.i18n).c('mask.authProperty.authorization')
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../hooks/use-mask":"72MTY","./enum":"2kNfK","./string":"e6M7S","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8t1id":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"divrD","./de.json":"eIxT0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"divrD":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineHttpRequestDatasource\":{\"title\":\"Http Request\",\"description\":\"HTTP Request, from which the result is used (expects CSV, YAML or JSON)\"},\"mask\":{\"FormEngineHttpRequestDatasource\":{\"description\":\"Description\",\"url\":\"Url\",\"method\":\"Method\",\"authGroupTitle\":\"Authorization\",\"responseGroupTitle\":\"Response\",\"sourceType\":\"Source Type\",\"resultPath\":\"Result Path\",\"resultPathPlaceholder\":\"e.g. entries\",\"labelColumn\":\"Label Column\",\"labelColumnPlaceholder\":\"e.g. {{$i.Label}}\",\"valueColumn\":\"Value Column\",\"valueColumnPlaceholder\":\"e.g. {{$i.Value}}\",\"setup\":\"Setup\",\"data\":\"Browse\"}}}");

},{}],"eIxT0":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"FormEngineHttpRequestDatasource":{"title":"HTTP-Anfrage","description":"HTTP Request, dessen Ergebnis verwendet wird (erwartet CSV, YAML oder JSON)"},"mask":{"FormEngineHttpRequestDatasource":{"description":"Beschreibung","url":"URL","method":"Methode","authGroupTitle":"Genehmigung","responseGroupTitle":"Antwort","sourceType":"Quelle Typ","resultPath":"Ergebnispfad","resultPathPlaceholder":"z.B. Eintr\xe4ge","labelColumn":"Spalte beschriften","labelColumnPlaceholder":"z.B. {{.Etikett}}","valueColumn":"Wertspalte","valueColumnPlaceholder":"z.B. {{.Wert}}","setup":"Aufstellen","data":"Durchsuche"}}}');

},{}],"fVzsL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pageBuilderElement = require("./components/page-builder-element");
var _pageBuilderElementDefault = parcelHelpers.interopDefault(_pageBuilderElement);
var _defaultPage = require("./presets/default-page");
var _defaultPageDefault = parcelHelpers.interopDefault(_defaultPage);
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    elements: {
        [(0, _pageBuilderElementDefault.default).Element.apiName]: (0, _pageBuilderElementDefault.default)
    },
    formPresets: {
        DefaultPageElementPreset: (0, _defaultPageDefault.default)
    },
    maskConfigurations: {
        [(0, _pageBuilderElementDefault.default).Element.apiName]: {
            edit: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    isDefault: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            preview: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    isDefault: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            translate: {
                permissions: {
                    name: 'read',
                    hidden: 'read',
                    width: 'read',
                    marginTop: 'read',
                    marginRight: 'read',
                    marginBottom: 'read',
                    marginLeft: 'read',
                    isDefault: 'read',
                    requiredExpressions: 'read',
                    hiddenExpressions: 'read'
                }
            }
        }
    }
};

},{"./components/page-builder-element":"66bzH","./presets/default-page":"50LqL","./builder-translations":"g3CQy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"66bzH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "label", ()=>label);
parcelHelpers.export(exports, "Element", ()=>(0, _pageElementDefault.default));
parcelHelpers.export(exports, "DrawerButton", ()=>(0, _drawerButtonDefault.default));
parcelHelpers.export(exports, "Mask", ()=>(0, _maskDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _reactBootstrapIcons.File));
var _drawerButton = require("./drawer-button");
var _drawerButtonDefault = parcelHelpers.interopDefault(_drawerButton);
var _mask = require("./mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _pageElement = require("../page-element");
var _pageElementDefault = parcelHelpers.interopDefault(_pageElement);
var _reactBootstrapIcons = require("react-bootstrap-icons");
const label = `${(0, _pageElementDefault.default).apiName}.title`;
exports.default = {
    label,
    DrawerButton: (0, _drawerButtonDefault.default),
    Mask: (0, _maskDefault.default),
    Element: (0, _pageElementDefault.default),
    Icon: (0, _reactBootstrapIcons.File)
};

},{"./drawer-button":"ist5u","./mask":"3qJpS","../page-element":"1yaLX","react-bootstrap-icons":"3TzoC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ist5u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderPageElementDrawerButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@form-engine/builder-form-editor/components/elements-drawer/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _index = require("./index");
var _builderApplication = require("@form-engine/builder-application");
const ctor = (overrides = {})=>({
        id: '',
        type: (0, _index.Element).apiName,
        ...overrides
    });
function BuilderPageElementDrawerButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
        ...props,
        constructor: ctor,
        dragLabel: (0, _builderApplication.i18n).c((0, _index.label)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {}),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                id: (0, _index.label)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-form-editor/components/elements-drawer/button":"lldAk","./index":"66bzH","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lldAk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderElementsDrawerButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("@form-engine/core-util/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _dnd = require("../dnd");
var _dragImage = require("../dnd/drag-image");
function BuilderElementsDrawerButton({ constructor, as: Component = (0, _dnd.BuilderDragSource), dragLabel, preset, ...props }) {
    const createSource = (0, _react.useCallback)(()=>{
        const sourceData = {};
        if (typeof constructor === 'function') Object.assign(sourceData, constructor());
        else if (typeof constructor === 'object') Object.assign(sourceData, constructor);
        if (!sourceData.id) sourceData.id = (0, _uuidDefault.default)();
        return sourceData;
    }, [
        constructor
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        as: "button",
        source: preset ? undefined : createSource,
        dragImage: dragLabel && (0, _dragImage.getDragImageCanvas)(dragLabel),
        preset: preset,
        ...props
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/core-util/uuid":"eZttN","../dnd":"1wcEC","../dnd/drag-image":"1iPvr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1wcEC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PLACEMENT_BEFORE", ()=>PLACEMENT_BEFORE);
parcelHelpers.export(exports, "PLACEMENT_AFTER", ()=>PLACEMENT_AFTER);
parcelHelpers.export(exports, "BuilderDropTarget", ()=>BuilderDropTarget);
parcelHelpers.export(exports, "BuilderDragSource", ()=>BuilderDragSource);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _useFormEditor = require("../../hooks/use-form-editor");
var _elementList = require("@form-engine/core-util/element-list");
var _formPreset = require("../../utilities/form-preset");
const PLACEMENT_BEFORE = 'before';
const PLACEMENT_AFTER = 'after';
function useStopDrag() {
    const { setItem } = (0, _useFormEditor.useFormEditorContext)();
    return (0, _react.useCallback)(()=>{
        setItem('isDragging', false);
        setItem('source', undefined);
        setItem('sourceType', undefined);
        document.documentElement.classList.toggle('is-dragging', false);
    }, [
        setItem
    ]);
}
function useStartDrag() {
    const { setItem } = (0, _useFormEditor.useFormEditorContext)();
    return (0, _react.useCallback)((sourceType, source)=>{
        setItem('isDragging', true);
        setItem('source', source);
        setItem('sourceType', sourceType);
        document.documentElement.classList.toggle('is-dragging', true);
    }, [
        setItem
    ]);
}
function BuilderDropTarget({ as: Component = 'div', id, parent = '', placement = PLACEMENT_BEFORE, onClick, ...props }) {
    const { state: editor } = (0, _useFormEditor.useFormEditorContext)();
    const { state: form, setItem, set: setForm } = (0, _useForm.useFormContext)();
    const ref = (0, _react.useRef)(null);
    const stopDrag = useStopDrag();
    const applyPreset = (0, _react.useCallback)(()=>{
        if (editor.sourceType !== 'preset' || !editor?.source?.data) return;
        const elementInsertionMethod = placement === PLACEMENT_AFTER ? (0, _elementList.relocateItemAfter) : (0, _elementList.relocateItemBefore);
        setForm((0, _formPreset.applyPresetData)(editor.source.data, form, id, parent, elementInsertionMethod));
    }, [
        setForm,
        form,
        id,
        placement,
        parent,
        editor
    ]);
    const relocate = (0, _react.useCallback)(()=>{
        if (!form?.elements || !editor?.source || id === editor.source.id || editor.sourceType !== 'element') return;
        const update = (placement === PLACEMENT_AFTER ? (0, _elementList.relocateItemAfter) : (0, _elementList.relocateItemBefore))(form.elements, {
            name: `Element${form.elements?.length ?? 0}`,
            ...editor.source,
            parent
        }, id);
        setItem('elements', update);
    }, [
        id,
        parent,
        placement,
        editor,
        form,
        setItem
    ]);
    const handleDrop = (0, _react.useCallback)(()=>{
        if (editor.sourceType === 'element') relocate();
        else if (editor.sourceType === 'preset') applyPreset();
        stopDrag();
    }, [
        relocate,
        applyPreset,
        stopDrag
    ]);
    const handleDragLeave = (0, _react.useCallback)(()=>{
        ref.current?.classList.toggle('is-dragging-over', false);
    }, []);
    const handleDragOver = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        ref.current?.classList.toggle('is-dragging-over', true);
    }, []);
    (0, _react.useEffect)(()=>{
        function hide() {
            ref.current?.classList.toggle('is-dragging-over', false);
        }
        document.addEventListener('dragend', hide);
        document.addEventListener('drop', hide);
        return ()=>{
            document.removeEventListener('dragend', hide);
            document.removeEventListener('drop', hide);
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        className: "feb-drop-target",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ref: ref,
            className: "feb-drop-target-inner",
            onDragOver: handleDragOver,
            onDragLeave: handleDragLeave,
            onDrop: handleDrop,
            onClick: onClick
        })
    });
}
function BuilderDragSource({ source, preset, as: Component = 'div', dragImage, className = '', ...props }) {
    const [isDragging, setIsDragging] = (0, _react.useState)(false);
    const startDrag = useStartDrag();
    const stopDrag = useStopDrag();
    const ref = (0, _react.useRef)(null);
    const handleDragStart = (0, _react.useCallback)((e)=>{
        if (e.target !== ref.current) return;
        if (preset) {
            setIsDragging(true);
            startDrag('preset', preset);
            e.dataTransfer.dropEffect = 'copy';
        } else if (source) {
            const isConstructor = typeof source === 'function';
            setIsDragging(true);
            startDrag('element', isConstructor ? source() : source);
            e.dataTransfer.dropEffect = isConstructor ? 'copy' : 'move';
        }
        if (dragImage) e.dataTransfer.setDragImage(dragImage, 0, -16);
    }, [
        setIsDragging,
        startDrag,
        source,
        preset,
        dragImage
    ]);
    (0, _react.useEffect)(()=>{
        let mounted = true;
        function handleStop() {
            // only stop dragging, if this is the current drag source
            if (!mounted || !isDragging) return;
            stopDrag();
            setIsDragging(false);
        }
        document.addEventListener('dragend', handleStop);
        document.addEventListener('drop', handleStop);
        return ()=>{
            mounted = false;
            document.removeEventListener('dragend', handleStop);
            document.removeEventListener('drop', handleStop);
        };
    }, [
        isDragging,
        setIsDragging,
        stopDrag
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        className: `feb-drag-source ${className} ${isDragging ? 'is-dragging' : ''}`,
        onDragStart: handleDragStart,
        draggable: true
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/core-application/hooks/use-form":"5PZyy","../../hooks/use-form-editor":"4pkiD","@form-engine/core-util/element-list":"e0ovy","../../utilities/form-preset":"UuTIr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"UuTIr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPresetDataFromElement", ()=>createPresetDataFromElement);
parcelHelpers.export(exports, "renewPresetDataIds", ()=>renewPresetDataIds);
parcelHelpers.export(exports, "applyPresetData", ()=>applyPresetData);
var _elementList = require("@form-engine/core-util/element-list");
var _typeGuards = require("@form-engine/core-util/type-guards");
var _uuid = require("@form-engine/core-util/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
function createPresetDataFromElement(form, elementId, includeDatasources = true) {
    const presetData = {};
    if (includeDatasources) {
        presetData.datasources = [];
        presetData.elements = (0, _elementList.cloneItemBranch)(form?.elements ?? [], elementId, undefined, (item, clone)=>{
            if (item.id === elementId) delete clone.parent;
            if (!(0, _typeGuards.isPlainObject)(item.datasource) || !(0, _typeGuards.isPlainObject)(clone.datasource)) return;
            const config = item.datasource;
            if (config.mode !== 'static' && config.datasourceId && clone.datasource) {
                const [datasource] = (0, _elementList.cloneItemBranch)(form.datasources ?? [], config.datasourceId);
                if (datasource && presetData.datasources) {
                    clone.datasource = {
                        ...item.datasource,
                        datasourceId: datasource.id
                    };
                    presetData.datasources.push(datasource);
                }
            }
        });
    } else presetData.elements = (0, _elementList.cloneItemBranch)(form?.elements ?? [], elementId, undefined, (item, clone)=>{
        if (item.id === elementId) delete clone.parent;
    });
    return structuredClone(presetData);
}
const DEFAULT_RENEW_COLLECTION_IDS = [
    'elements',
    'workflowLayers',
    'datasources',
    'constants'
];
function renewPresetDataIds(data, renewCollections = DEFAULT_RENEW_COLLECTION_IDS) {
    const staleIds = renewCollections.reduce((ids, collectionKey)=>{
        const collection = data[collectionKey] ?? [];
        for (const item of collection)if (item?.id && !ids.includes(item.id)) ids.push(item.id);
        return ids;
    }, []);
    let jsonData = JSON.stringify(data);
    for (const id of staleIds)jsonData = jsonData.replaceAll(id, (0, _uuidDefault.default)());
    return JSON.parse(jsonData);
}
function applyPresetData(data, sourceForm, elementDestination, elementInsertionParent, elementInsertionMethod = (0, _elementList.insertItemBefore)) {
    const form = structuredClone(sourceForm);
    const { elements, datasources, workflowLayers, constants, ...mergeableData } = renewPresetDataIds(data);
    Object.assign(form, mergeableData);
    const [rootElement, ...childElements] = elements ?? [];
    if (rootElement) {
        if (elementInsertionParent) rootElement.parent = (0, _elementList.resolveItemId)(elementInsertionParent);
        form.elements = (0, _elementList.relocateItem)(elementInsertionMethod, form.elements ?? [], rootElement, elementDestination);
        if (childElements.length) for (const child of childElements.reverse())form.elements = (0, _elementList.insertItemAfter)(form.elements, child, rootElement.id);
    }
    /** @todo reassign wfl / datasource assignments on preset id's with name collisions  */ if (datasources?.length) {
        form.datasources ??= [];
        for (const datasource of datasources)if (!(0, _elementList.getItemBy)(form.datasources, 'name', datasource)) form.datasources.push(structuredClone(datasource));
    }
    if (workflowLayers?.length) {
        form.workflowLayers ??= [];
        for (const workflowLayer of workflowLayers)if (!(0, _elementList.getItemBy)(form.workflowLayers, 'name', workflowLayer)) form.workflowLayers.push(structuredClone(workflowLayer));
    }
    if (constants?.length) {
        form.constants ??= [];
        for (const constant of constants)if (!(0, _elementList.getItemBy)(form.constants, 'name', constant)) form.constants.push(structuredClone(constant));
    }
    return form;
}

},{"@form-engine/core-util/element-list":"e0ovy","@form-engine/core-util/type-guards":"gnnvq","@form-engine/core-util/uuid":"eZttN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gnnvq":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
function isPlainObject(value) {
    return typeof value === 'object' && value !== null && value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1iPvr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDragImageCanvas", ()=>getDragImageCanvas);
const cache = new Map();
function getDragImageCanvas(text) {
    if (cache.has(text)) return cache.get(text);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('could not create 2d canvas context');
    const computedStyle = getComputedStyle(document.body);
    const fontSize = 12;
    const fontFamily = computedStyle.getPropertyValue('--bs-body-font-family');
    const fontColor = computedStyle.getPropertyValue('--bs-light');
    const bg = computedStyle.getPropertyValue('--bs-primary');
    const paddingX = 15;
    const paddingY = 8;
    const marginLeft = 10;
    const marginTop = 10;
    const radius = 3;
    const scale = window.devicePixelRatio;
    const applyFontStyle = ()=>{
        ctx.font = `${fontSize}px ${fontFamily}`;
        ctx.textBaseline = 'middle';
    };
    applyFontStyle();
    const metrics = ctx.measureText(text);
    const width = metrics.width + paddingX * 2 + marginLeft;
    const height = fontSize + paddingY * 2 + marginTop;
    canvas.width = width * scale;
    canvas.height = height * scale;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    ctx.scale(scale, scale);
    ctx.fillStyle = bg;
    ctx.beginPath();
    ctx.roundRect(marginLeft, marginTop, width - marginLeft, height - marginTop, [
        radius,
        radius,
        radius,
        radius
    ]);
    ctx.fill();
    ctx.fillStyle = fontColor;
    ctx.beginPath();
    applyFontStyle();
    ctx.fillText(text, marginLeft + paddingX, marginTop + (height - marginTop) / 2);
    ctx.fill();
    canvas.style.top = '-100vh';
    canvas.style.pointerEvents = 'none';
    canvas.style.position = 'fixed';
    document.body.appendChild(canvas);
    cache.set(text, canvas);
    return canvas;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3qJpS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderPageElementMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mask = require("@form-engine/builder-mask/components/mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _conditions = require("@form-engine/builder-mask/components/groups/conditions");
var _conditionsDefault = parcelHelpers.interopDefault(_conditions);
var _boolean = require("@form-engine/builder-mask/components/properties/boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
var _appearance = require("@form-engine/builder-mask/components/groups/appearance");
var _appearanceDefault = parcelHelpers.interopDefault(_appearance);
var _ = require(".");
var _builderApplication = require("@form-engine/builder-application");
function BuilderPageElementMask(props) {
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _.Element).apiName}.`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _maskDefault.default), {
        id: (0, _.Element).apiName,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appearanceDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupDefault.default), {
                label: c('groupTitle'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                    propertyName: "isDefault",
                    label: c('isDefault')
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditionsDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/mask":"kcLv4","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/groups/conditions":"cw0Md","@form-engine/builder-mask/components/properties/boolean":"k2UVH","@form-engine/builder-mask/components/groups/appearance":"krT6N",".":"66bzH","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kcLv4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderElementMask);
var _jsxRuntime = require("react/jsx-runtime");
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
var _createObject = require("@form-engine/core-util/create-object");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useMaskConfig = require("../../hooks/use-mask-config");
var _general = require("../groups/general");
var _generalDefault = parcelHelpers.interopDefault(_general);
function BuilderElementMask({ as: Component = 'div', children, id, editMode = 'edit', ...props }) {
    const general = props.general !== false;
    delete props.general;
    const config = (0, _react.useMemo)(()=>{
        const currentConfigMap = id && (0, _builderApplicationDefault.default)?.maskConfigurations[id];
        let currentConfig;
        if (currentConfigMap) currentConfig = currentConfigMap[editMode];
        return (0, _createObject.createObject)((0, _useMaskConfig.MaskConfigContextValueDefaults), currentConfig ?? {});
    }, [
        id,
        editMode
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useMaskConfig.MaskConfigProvider), {
        value: config,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Component, {
            ...props,
            className: `feb-element-mask feb-element-mask--${editMode} ${props.className || ''}`,
            children: [
                id && (0, _builderApplicationDefault.default).renderComponentExtensions(id, ({ placement })=>placement === 'before'),
                general && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalDefault.default), {}),
                children,
                id && (0, _builderApplicationDefault.default).renderComponentExtensions(id, ({ placement })=>placement === 'after')
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-application":"7iKr0","@form-engine/core-util/create-object":"dBL9S","react":"9njXz","../../hooks/use-mask-config":"daHU1","../groups/general":"asnpT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"asnpT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderMaskGroupGeneral);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _group = require("../mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _boolean = require("../properties/boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
var _name = require("../properties/name");
var _nameDefault = parcelHelpers.interopDefault(_name);
var _builderApplication = require("@form-engine/builder-application");
var _index = require("@form-engine/core-application/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _useMask = require("../../hooks/use-mask");
function BuilderMaskGroupGeneral({ name, hidden, disabled }) {
    const { state } = (0, _useMask.useMaskContext)();
    const isField = state?.type && state?.type in (0, _indexDefault.default).getFieldElements();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
        id: "BuilderMaskGroupGeneral",
        children: [
            name !== false && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nameDefault.default), {}),
            hidden !== false && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                propertyName: "hidden",
                label: (0, _builderApplication.i18n).c('mask.generalGroup.hidden')
            }),
            (isField || disabled === true) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                propertyName: "disabled",
                label: (0, _builderApplication.i18n).c('mask.generalGroup.disabled')
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../mask/group":"1nZOW","../properties/boolean":"k2UVH","../properties/name":"cCuUh","@form-engine/builder-application":"7iKr0","@form-engine/core-application/index":"fjN6J","../../hooks/use-mask":"72MTY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k2UVH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderBooleanProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _useMask = require("../../hooks/use-mask");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _property = require("../mask/property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _useMaskConfig = require("../../hooks/use-mask-config");
var _useMaskValidation = require("../../hooks/use-mask-validation");
function BuilderBooleanProperty({ label, propertyName, defaultValue = false, ...props }) {
    const stacked = 'stacked' in props && props.stacked !== false;
    delete props.stacked;
    const { state, setItemProperty } = (0, _useMask.useMaskContext)();
    const value = state && propertyName in state ? Boolean(state[propertyName]) : defaultValue;
    const permission = (0, _useMaskConfig.useMaskPropertyPermission)(propertyName);
    const error = (0, _useMaskValidation.useMaskPropertyError)(propertyName);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertyDefault.default), {
        className: "feb-boolean-property",
        label: label,
        error: error?.message,
        stacked: stacked,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormCheck), {
            type: "switch",
            ...props,
            disabled: permission === 'read',
            checked: value,
            onChange: (e)=>setItemProperty(propertyName, Boolean(e.target.checked))
        })
    });
}

},{"react/jsx-runtime":"1dlk8","../../hooks/use-mask":"72MTY","react":"9njXz","react-bootstrap":"f5rnA","../mask/property":"dLorN","../../hooks/use-mask-config":"daHU1","../../hooks/use-mask-validation":"cYKiY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cw0Md":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONDITION_TYPE_OPTIONS", ()=>CONDITION_TYPE_OPTIONS);
parcelHelpers.export(exports, "default", ()=>BuilderMaskGroupConditions);
var _jsxRuntime = require("react/jsx-runtime");
var _useMask = require("../../hooks/use-mask");
var _element = require("@form-engine/core-application/components/element");
var _coreApplication = require("@form-engine/core-application");
var _coreApplicationDefault = parcelHelpers.interopDefault(_coreApplication);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _group = require("../mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _expressions = require("../properties/expressions");
var _expressionsDefault = parcelHelpers.interopDefault(_expressions);
var _builderApplication = require("@form-engine/builder-application");
const CONDITION_TYPE_OPTIONS = Object.values((0, _element.CONDITION_TYPES)).map((value)=>[
        value,
        value
    ]);
function BuilderMaskGroupConditions({ requiredExpressions = true, disabledExpressions = true, hiddenExpressions = true }) {
    const { state } = (0, _useMask.useMaskContext)();
    const isField = state?.type && state?.type in (0, _coreApplicationDefault.default).getFieldElements();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
        id: "BuilderMaskGroupConditions",
        label: (0, _builderApplication.i18n).c('mask.conditionsGroup.title'),
        children: [
            requiredExpressions && isField && !state?.required && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expressionsDefault.default), {
                label: (0, _builderApplication.i18n).c('mask.conditionsGroup.requiredExpressions'),
                propertyName: "requiredExpressions"
            }),
            disabledExpressions && isField && !state?.disabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expressionsDefault.default), {
                label: (0, _builderApplication.i18n).c('mask.conditionsGroup.disabledExpressions'),
                propertyName: "disabledExpressions"
            }),
            hiddenExpressions && !state?.hidden && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expressionsDefault.default), {
                label: (0, _builderApplication.i18n).c('mask.conditionsGroup.hiddenExpressions'),
                propertyName: "hiddenExpressions"
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","../../hooks/use-mask":"72MTY","@form-engine/core-application/components/element":"dt2u8","@form-engine/core-application":"fjN6J","react":"9njXz","../mask/group":"1nZOW","../properties/expressions":"cByR7","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cByR7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EXPRESSION_OPERATORS", ()=>EXPRESSION_OPERATORS);
parcelHelpers.export(exports, "EXPRESSION_DISJUNCTIONS", ()=>EXPRESSION_DISJUNCTIONS);
parcelHelpers.export(exports, "default", ()=>BuilderExpressionsProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _arrayFormControl = require("@form-engine/builder-array-form-control/components/array-form-control");
var _arrayFormControlDefault = parcelHelpers.interopDefault(_arrayFormControl);
var _cell = require("@form-engine/builder-array-form-control/components/array-form-control/cell");
var _cellDefault = parcelHelpers.interopDefault(_cell);
var _formatCase = require("@form-engine/core-util/format-case");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useMask = require("../../hooks/use-mask");
var _useMaskConfig = require("../../hooks/use-mask-config");
var _property = require("../mask/property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _enum = require("./enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _string = require("./string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _builderApplication = require("@form-engine/builder-application");
var _useMaskValidation = require("../../hooks/use-mask-validation");
var EXPRESSION_OPERATORS = /*#__PURE__*/ function(EXPRESSION_OPERATORS) {
    EXPRESSION_OPERATORS["EQUAL"] = "equal";
    EXPRESSION_OPERATORS["NOT_EQUAL"] = "not-equal";
    EXPRESSION_OPERATORS["GREATER"] = "greater";
    EXPRESSION_OPERATORS["GREATER_EQUAL"] = "greater-equal";
    EXPRESSION_OPERATORS["LESSER"] = "lesser";
    EXPRESSION_OPERATORS["LESSER_EQUAL"] = "lesser-equal";
    return EXPRESSION_OPERATORS;
}({});
var EXPRESSION_DISJUNCTIONS = /*#__PURE__*/ function(EXPRESSION_DISJUNCTIONS) {
    EXPRESSION_DISJUNCTIONS["AND"] = "and";
    EXPRESSION_DISJUNCTIONS["OR"] = "or";
    return EXPRESSION_DISJUNCTIONS;
}({});
function ExpressionInput({ value, onChange, forceLeftOperand, forceRightOperand, forceOperator, forceDisjunctor, variableOptions }) {
    const [state, setState] = (0, _react.useState)(value);
    (0, _react.useEffect)(()=>{
        setState(value);
    }, [
        value,
        setState
    ]);
    const setItem = (0, _react.useCallback)((newValue)=>{
        if (newValue) {
            if (forceLeftOperand !== undefined) newValue.leftOperand = forceLeftOperand;
            if (forceRightOperand !== undefined) newValue.rightOperand = forceRightOperand;
            if (forceOperator !== undefined) newValue.operator = forceOperator;
            if (forceDisjunctor !== undefined) newValue.disjunctor = forceDisjunctor;
        }
        setState(newValue);
        onChange?.(newValue);
    }, [
        setState,
        onChange,
        forceLeftOperand,
        forceRightOperand,
        forceOperator,
        forceDisjunctor
    ]);
    const setItemProperty = (0, _react.useCallback)((propertyName, newValue)=>{
        setItem({
            ...value ?? {},
            [propertyName]: newValue
        });
    }, [
        setItem,
        value
    ]);
    const api = (0, _react.useMemo)(()=>({
            state,
            setItem,
            setItemProperty
        }), [
        state,
        setItem
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _useMask.MaskProvider), {
        value: api,
        children: [
            forceLeftOperand === undefined && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                compilable: true,
                label: (0, _builderApplication.i18n).c('mask.expressionsProperty.leftOperand'),
                propertyName: "leftOperand",
                placeholder: '""',
                variableOptions: variableOptions
            }),
            forceOperator === undefined && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                label: (0, _builderApplication.i18n).c('mask.expressionsProperty.operator'),
                propertyName: "operator",
                options: Object.values(EXPRESSION_OPERATORS).map((value)=>[
                        value,
                        (0, _formatCase.formatTitleCase)(value)
                    ])
            }),
            forceRightOperand === undefined && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                compilable: true,
                label: (0, _builderApplication.i18n).c('mask.expressionsProperty.rightOperand'),
                propertyName: "rightOperand",
                placeholder: '""',
                variableOptions: variableOptions
            }),
            forceDisjunctor === undefined && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                label: (0, _builderApplication.i18n).c('mask.expressionsProperty.disjunctor'),
                propertyName: "disjunctor",
                options: Object.values(EXPRESSION_DISJUNCTIONS).map((value)=>[
                        value,
                        (0, _formatCase.formatTitleCase)(value)
                    ])
            })
        ]
    });
}
function ExpressionInputCell({ value, onChange, forceLeftOperand, forceOperator, forceRightOperand, forceDisjunctor, variableOptions, ...cellProps }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cellDefault.default), {
        ...cellProps,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExpressionInput, {
            value,
            onChange,
            forceLeftOperand,
            forceOperator,
            forceRightOperand,
            forceDisjunctor,
            variableOptions
        })
    });
}
function BuilderExpressionsProperty({ label = (0, _builderApplication.i18n).c('mask.expressionsProperty.title'), propertyName = 'expressions', forceLeftOperand, forceRightOperand, forceOperator, forceDisjunctor, variableOptions, // eslint-disable-next-line @typescript-eslint/no-unused-vars
prefix: _prefix, ...props }) {
    const [expressions, setExpressions] = (0, _useMask.useMaskProperty)(propertyName, []);
    const cols = (0, _react.useMemo)(()=>{
        return {
            expressions: {
                asModel: true,
                cellComponent: ExpressionInputCell,
                props: {
                    forceLeftOperand,
                    forceRightOperand,
                    forceOperator,
                    forceDisjunctor,
                    variableOptions
                }
            }
        };
    }, [
        forceLeftOperand,
        forceRightOperand,
        forceOperator,
        forceDisjunctor,
        variableOptions
    ]);
    const permission = (0, _useMaskConfig.useMaskPropertyPermission)(propertyName);
    const error = (0, _useMaskValidation.useMaskPropertyError)(propertyName);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertyDefault.default), {
        className: "feb-expressions-property",
        stacked: true,
        label: label,
        error: error?.message,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrayFormControlDefault.default), {
            head: false,
            schema: 'object',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            cols: cols,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            value: expressions,
            onChange: setExpressions,
            disabled: permission === 'read'
        })
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-array-form-control/components/array-form-control":"2zkEC","@form-engine/builder-array-form-control/components/array-form-control/cell":"Lhb09","@form-engine/core-util/format-case":"2G0oK","react":"9njXz","../../hooks/use-mask":"72MTY","../../hooks/use-mask-config":"daHU1","../mask/property":"dLorN","./enum":"2kNfK","./string":"e6M7S","@form-engine/builder-application":"7iKr0","../../hooks/use-mask-validation":"cYKiY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"krT6N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderMaskGroupBounds);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _group = require("../mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _bounds = require("../properties/bounds");
var _boundsDefault = parcelHelpers.interopDefault(_bounds);
var _builderApplication = require("@form-engine/builder-application");
function BuilderMaskGroupBounds() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupDefault.default), {
        id: "BuilderMaskGroupBounds",
        label: (0, _builderApplication.i18n).c('mask.boundsGroup.title'),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boundsDefault.default), {})
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../mask/group":"1nZOW","../properties/bounds":"fud6R","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fud6R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderBoundsProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _useMask = require("../../hooks/use-mask");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _useMaskConfig = require("../../hooks/use-mask-config");
var _builderApplication = require("@form-engine/builder-application");
function BuilderBoundsProperty() {
    const { state, setItemProperty } = (0, _useMask.useMaskContext)();
    const xlColSize = {
        span: 12
    };
    const smColSize = {
        span: 12
    };
    const widthPermission = (0, _useMaskConfig.useMaskPropertyPermission)('width');
    const marginTopPermission = (0, _useMaskConfig.useMaskPropertyPermission)('marginTop');
    const marginRightPermission = (0, _useMaskConfig.useMaskPropertyPermission)('marginRight');
    const marginBottomPermission = (0, _useMaskConfig.useMaskPropertyPermission)('marginBottom');
    const marginLeftPermission = (0, _useMaskConfig.useMaskPropertyPermission)('marginLeft');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                xl: xlColSize,
                sm: smColSize,
                className: "mb-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.InputGroup), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
                            size: "sm",
                            type: "number",
                            step: "1",
                            min: "1",
                            max: "12",
                            value: state?.width || '12',
                            disabled: widthPermission === 'read',
                            onChange: (e)=>setItemProperty('width', e.target.value)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.InputGroup).Text, {
                            title: (0, _builderApplication.i18n).c('mask.boundsProperty.width'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ArrowLeftRight), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                xl: xlColSize,
                sm: smColSize,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
                    style: {
                        ['--bs-gutter-x']: '.5rem',
                        ['--bs-gutter-y']: '.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                            md: 6,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.InputGroup), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
                                        size: "sm",
                                        type: "number",
                                        step: "1",
                                        min: "0",
                                        max: "11",
                                        value: state?.marginTop || '0',
                                        disabled: marginTopPermission === 'read',
                                        onChange: (e)=>setItemProperty('marginTop', e.target.value)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.InputGroup).Text, {
                                        title: (0, _builderApplication.i18n).c('mask.boundsProperty.marginTop'),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ArrowBarUp), {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                            md: 6,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.InputGroup), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
                                        size: "sm",
                                        type: "number",
                                        step: "1",
                                        min: "0",
                                        max: "11",
                                        value: state?.marginRight || '0',
                                        disabled: marginRightPermission === 'read',
                                        onChange: (e)=>setItemProperty('marginRight', e.target.value)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.InputGroup).Text, {
                                        title: (0, _builderApplication.i18n).c('mask.boundsProperty.marginRight'),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ArrowBarRight), {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                            md: 6,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.InputGroup), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
                                        size: "sm",
                                        type: "number",
                                        step: "1",
                                        min: "0",
                                        max: "11",
                                        value: state?.marginBottom || '0',
                                        disabled: marginBottomPermission === 'read',
                                        onChange: (e)=>setItemProperty('marginBottom', e.target.value)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.InputGroup).Text, {
                                        title: (0, _builderApplication.i18n).c('mask.boundsProperty.marginBottom'),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ArrowBarDown), {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                            md: 6,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.InputGroup), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
                                        size: "sm",
                                        type: "number",
                                        step: "1",
                                        min: "0",
                                        max: "11",
                                        value: state?.marginLeft || '0',
                                        disabled: marginLeftPermission === 'read',
                                        onChange: (e)=>setItemProperty('marginLeft', e.target.value)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.InputGroup).Text, {
                                        title: (0, _builderApplication.i18n).c('mask.boundsProperty.marginLeft'),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ArrowBarLeft), {})
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","../../hooks/use-mask":"72MTY","react":"9njXz","react-bootstrap":"f5rnA","react-bootstrap-icons":"3TzoC","../../hooks/use-mask-config":"daHU1","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"50LqL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _uuid = require("@form-engine/core-util/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _pageElement = require("../components/page-element");
var _pageElementDefault = parcelHelpers.interopDefault(_pageElement);
exports.default = {
    name: 'Default Page Element',
    required: true,
    init (form) {
        form?.elements?.push({
            id: (0, _uuidDefault.default)(),
            type: (0, _pageElementDefault.default).apiName,
            name: 'DefaultPage',
            label: 'Default Page',
            isDefault: true
        });
    }
};

},{"@form-engine/core-util/uuid":"eZttN","../components/page-element":"1yaLX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g3CQy":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"1e5k2","./de.json":"1vCdj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1e5k2":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEnginePageElement\":{\"title\":\"Page\"},\"mask\":{\"FormEnginePageElement\":{\"groupTitle\":\"Page\",\"isDefault\":\"Use as entry Page\"}}}");

},{}],"1vCdj":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEnginePageElement\":{\"title\":\"Buchseite\"},\"mask\":{\"FormEnginePageElement\":{\"groupTitle\":\"Buchseite\",\"isDefault\":\"Als Einstiegsseite verwenden\"}}}");

},{}],"ajZzi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inputBuilderElement = require("./components/input-builder-element");
var _inputBuilderElementDefault = parcelHelpers.interopDefault(_inputBuilderElement);
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    elements: {
        [(0, _inputBuilderElementDefault.default).Element.apiName]: (0, _inputBuilderElementDefault.default)
    },
    maskConfigurations: {
        [(0, _inputBuilderElementDefault.default).Element.apiName]: {
            edit: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    disabled: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    label: 'write',
                    floatingLabel: 'write',
                    showError: 'write',
                    placeholder: 'write',
                    inputType: 'write',
                    autoComplete: 'write',
                    required: 'write',
                    validationContentType: 'write',
                    validateContentTypeRegex: 'write',
                    validateContentTypeMessage: 'write',
                    validationMinLength: 'write',
                    validationMaxLength: 'write',
                    validationValueOf: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            preview: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    disabled: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    label: 'write',
                    floatingLabel: 'write',
                    showError: 'write',
                    placeholder: 'write',
                    inputType: 'write',
                    autoComplete: 'write',
                    required: 'write',
                    validationContentType: 'write',
                    validateContentTypeRegex: 'write',
                    validateContentTypeMessage: 'write',
                    validationMinLength: 'write',
                    validationMaxLength: 'write',
                    validationValueOf: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            translate: {
                permissions: {
                    name: 'read',
                    hidden: 'read',
                    disabled: 'read',
                    width: 'read',
                    marginTop: 'read',
                    marginRight: 'read',
                    marginBottom: 'read',
                    marginLeft: 'read',
                    label: 'write',
                    floatingLabel: 'read',
                    showError: 'read',
                    placeholder: 'write',
                    inputType: 'read',
                    autoComplete: 'read',
                    required: 'read',
                    validationContentType: 'read',
                    validateContentTypeRegex: 'read',
                    validateContentTypeMessage: 'write',
                    validationMinLength: 'read',
                    validationMaxLength: 'read',
                    validationValueOf: 'read',
                    requiredExpressions: 'read',
                    hiddenExpressions: 'read'
                }
            }
        }
    }
};

},{"./components/input-builder-element":"eKHaY","./builder-translations":"b6P9Y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eKHaY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "label", ()=>label);
parcelHelpers.export(exports, "Element", ()=>(0, _inputElementDefault.default));
parcelHelpers.export(exports, "DrawerButton", ()=>(0, _drawerButtonDefault.default));
parcelHelpers.export(exports, "Mask", ()=>(0, _maskDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _reactBootstrapIcons.InputCursorText));
var _drawerButton = require("./drawer-button");
var _drawerButtonDefault = parcelHelpers.interopDefault(_drawerButton);
var _mask = require("./mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _inputElement = require("../input-element");
var _inputElementDefault = parcelHelpers.interopDefault(_inputElement);
var _reactBootstrapIcons = require("react-bootstrap-icons");
const label = `${(0, _inputElementDefault.default).apiName}.title`;
exports.default = {
    label,
    DrawerButton: (0, _drawerButtonDefault.default),
    Mask: (0, _maskDefault.default),
    Element: (0, _inputElementDefault.default),
    Icon: (0, _reactBootstrapIcons.InputCursorText)
};

},{"./drawer-button":"8xqCR","./mask":"80ucN","../input-element":"adGv3","react-bootstrap-icons":"3TzoC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8xqCR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderInputElementDrawerButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@form-engine/builder-form-editor/components/elements-drawer/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _index = require("./index");
var _builderApplication = require("@form-engine/builder-application");
const ctor = (overrides = {})=>({
        id: '',
        type: (0, _index.Element).apiName,
        ...overrides
    });
function BuilderInputElementDrawerButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
        ...props,
        constructor: ctor,
        dragLabel: (0, _builderApplication.i18n).c((0, _index.label)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {}),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                id: (0, _index.label)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-form-editor/components/elements-drawer/button":"lldAk","./index":"eKHaY","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"80ucN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderInputElementMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mask = require("@form-engine/builder-mask/components/mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _appearance = require("@form-engine/builder-mask/components/groups/appearance");
var _appearanceDefault = parcelHelpers.interopDefault(_appearance);
var _conditions = require("@form-engine/builder-mask/components/groups/conditions");
var _conditionsDefault = parcelHelpers.interopDefault(_conditions);
var _validation = require("@form-engine/builder-mask/components/groups/validation");
var _validationDefault = parcelHelpers.interopDefault(_validation);
var _boolean = require("@form-engine/builder-mask/components/properties/boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
var _enum = require("@form-engine/builder-mask/components/properties/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _floatingLabel = require("@form-engine/builder-mask/components/properties/floating-label");
var _floatingLabelDefault = parcelHelpers.interopDefault(_floatingLabel);
var _inputType = require("@form-engine/builder-mask/components/properties/input-type");
var _inputTypeDefault = parcelHelpers.interopDefault(_inputType);
var _label = require("@form-engine/builder-mask/components/properties/label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _placeholder = require("@form-engine/builder-mask/components/properties/placeholder");
var _placeholderDefault = parcelHelpers.interopDefault(_placeholder);
var _formatCase = require("@form-engine/core-util/format-case");
var _ = require(".");
var _builderApplication = require("@form-engine/builder-application");
/** @see https://raw.githubusercontent.com/mdn/content/main/files/en-us/web/html/attributes/autocomplete/index.md */ const AUTOCOMPLETE_OPTIONS = [
    [
        'on'
    ],
    [
        'off'
    ],
    [
        'name'
    ],
    [
        'honorific-prefix'
    ],
    [
        'given-name'
    ],
    [
        'additional-name'
    ],
    [
        'family-name'
    ],
    [
        'honorific-suffix'
    ],
    [
        'nickname'
    ],
    [
        'email'
    ],
    [
        'username'
    ],
    [
        'new-password'
    ],
    [
        'current-password'
    ],
    [
        'one-time-code'
    ],
    [
        'organization-title'
    ],
    [
        'organization'
    ],
    [
        'address-line1'
    ],
    [
        'address-line2'
    ],
    [
        'address-line3'
    ],
    [
        'address-level4'
    ],
    [
        'address-level3'
    ],
    [
        'address-level2'
    ],
    [
        'address-level1'
    ],
    [
        'country'
    ],
    [
        'country-name'
    ],
    [
        'postal-code'
    ],
    [
        'cc-name'
    ],
    [
        'cc-given-name'
    ],
    [
        'cc-additional-name'
    ],
    [
        'cc-family-name'
    ],
    [
        'cc-number'
    ],
    [
        'cc-exp'
    ],
    [
        'cc-exp-month'
    ],
    [
        'cc-exp-year'
    ],
    [
        'cc-csc'
    ],
    [
        'cc-type'
    ],
    [
        'transaction-currency'
    ],
    [
        'transaction-amount'
    ],
    [
        'language'
    ],
    [
        'bday'
    ],
    [
        'bday-day'
    ],
    [
        'bday-month'
    ],
    [
        'bday-year'
    ],
    [
        'sex'
    ],
    [
        'tel'
    ],
    [
        'tel-country-code'
    ],
    [
        'tel-national'
    ],
    [
        'tel-area-code'
    ],
    [
        'tel-local'
    ],
    [
        'tel-extension'
    ],
    [
        'impp'
    ],
    [
        'url'
    ],
    [
        'photo'
    ]
].map((item)=>[
        item[0],
        (0, _formatCase.formatTitleCase)(item[0])
    ]);
function BuilderInputElementMask(props) {
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _.Element).apiName}.`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _maskDefault.default), {
        id: (0, _.Element).apiName,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appearanceDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                label: c('groupTitle'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _floatingLabelDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "showError",
                        label: c('showError')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _placeholderDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputTypeDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                        propertyName: "autoComplete",
                        label: c('autoComplete'),
                        options: AUTOCOMPLETE_OPTIONS
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validationDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditionsDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/mask":"kcLv4","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/groups/appearance":"krT6N","@form-engine/builder-mask/components/groups/conditions":"cw0Md","@form-engine/builder-mask/components/groups/validation":"jzCix","@form-engine/builder-mask/components/properties/boolean":"k2UVH","@form-engine/builder-mask/components/properties/enum":"2kNfK","@form-engine/builder-mask/components/properties/floating-label":"3xmdn","@form-engine/builder-mask/components/properties/input-type":"jl59s","@form-engine/builder-mask/components/properties/label":"hDKxg","@form-engine/builder-mask/components/properties/placeholder":"fvXxk","@form-engine/core-util/format-case":"2G0oK",".":"eKHaY","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jzCix":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderMaskGroupValidation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _group = require("../mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _boolean = require("../properties/boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
var _string = require("../properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _validationContentType = require("../properties/validation-content-type");
var _validationContentTypeDefault = parcelHelpers.interopDefault(_validationContentType);
var _builderApplication = require("@form-engine/builder-application");
function BuilderMaskGroupValidation({ required, contentType, length, children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
        id: "BuilderMaskGroupValidation",
        label: (0, _builderApplication.i18n).c('mask.validationGroup.title'),
        ...props,
        children: [
            required !== false && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                propertyName: "required",
                label: (0, _builderApplication.i18n).c('mask.validationGroup.required')
            }),
            contentType !== false && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validationContentTypeDefault.default), {}),
            length !== false && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "validationMinLength",
                        step: "1",
                        type: "number",
                        label: (0, _builderApplication.i18n).c('mask.validationGroup.validationMinLength')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "validationMaxLength",
                        step: "1",
                        type: "number",
                        label: (0, _builderApplication.i18n).c('mask.validationGroup.validationMaxLength')
                    })
                ]
            }),
            children
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../mask/group":"1nZOW","../properties/boolean":"k2UVH","../properties/string":"e6M7S","../properties/validation-content-type":"bik10","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bik10":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderValidationContentTypeProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _string = require("./string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _contentTypes = require("@form-engine/core-application/validation/validations/content-types");
var _useMask = require("../../hooks/use-mask");
var _enum = require("./enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _builderApplication = require("@form-engine/builder-application");
const validationOptions = Object.keys(_contentTypes).map((key)=>[
        key,
        key.replace('FormEngineValidateContentType', '')
    ]);
function BuilderValidationContentTypeProperty() {
    const { state } = (0, _useMask.useMaskContext)();
    const { validationContentType: type = '' } = state ?? {};
    const { c } = (0, _builderApplication.i18n).prefix('mask.validationContentTypeProperty.');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                propertyName: "validationContentType",
                label: c('validationContentType'),
                options: [
                    ...validationOptions
                ]
            }),
            type === 'FormEngineValidateContentTypeRegex' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                propertyName: "validateContentTypeRegex",
                label: c('validateContentTypeRegex'),
                placeholder: c('validateContentTypeRegexPlaceholder'),
                compilable: true
            }),
            [
                'FormEngineValidateContentTypeDate',
                'FormEngineValidateContentTypeDatetime'
            ].includes(String(type)) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "validateContentTypeDateBefore",
                        label: c('validateContentTypeDateBefore'),
                        placeholder: c('validateContentTypeDateBeforePlaceholder'),
                        compilable: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "validateContentTypeDateAfter",
                        label: c('validateContentTypeDateAfter'),
                        placeholder: c('validateContentTypeDateAfterPlaceholder'),
                        compilable: true
                    })
                ]
            }),
            type && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                propertyName: "validateContentTypeMessage",
                label: c('validateContentTypeMessage'),
                compilable: true
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./string":"e6M7S","@form-engine/core-application/validation/validations/content-types":"lTsic","../../hooks/use-mask":"72MTY","./enum":"2kNfK","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3xmdn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderFloatingLabelProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _boolean = require("./boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
var _builderApplication = require("@form-engine/builder-application");
function BuilderFloatingLabelProperty(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
        label: (0, _builderApplication.i18n).c('mask.floatingLabelProperty.title'),
        ...props,
        propertyName: props.propertyName ?? 'floatingLabel'
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./boolean":"k2UVH","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jl59s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderInputTypeProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _enum = require("./enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _builderApplication = require("@form-engine/builder-application");
const inputTypes = {
    text: 'Text',
    // button: 'button',
    // checkbox: 'checkbox',
    color: 'Color',
    date: 'Date',
    'datetime-local': 'Datetime Local',
    email: 'Email',
    // file: 'file',
    hidden: 'Hidden',
    // image: 'image',
    month: 'Month',
    number: 'Number',
    password: 'Password',
    // radio: 'radio',
    // range: 'range',
    // reset: 'reset',
    // search: 'search',
    // submit: 'submit',
    tel: 'Tel',
    time: 'Time',
    url: 'Url',
    week: 'Week'
};
function BuilderInputTypeProperty(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
        options: Object.entries(inputTypes),
        label: (0, _builderApplication.i18n).c('mask.inputTypeProperty.title'),
        defaultValue: "text",
        ...props,
        propertyName: props.propertyName ?? 'inputType'
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./enum":"2kNfK","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hDKxg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderLabelProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _string = require("./string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _builderApplication = require("@form-engine/builder-application");
function BuilderLabelProperty(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
        label: (0, _builderApplication.i18n).c('mask.labelProperty.title'),
        ...props,
        propertyName: props.propertyName ?? 'label'
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./string":"e6M7S","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fvXxk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderPlaceholderProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _string = require("./string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _builderApplication = require("@form-engine/builder-application");
function BuilderPlaceholderProperty(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
        label: (0, _builderApplication.i18n).c('mask.placeholderProperty.title'),
        ...props,
        propertyName: props.propertyName ?? 'placeholder'
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./string":"e6M7S","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b6P9Y":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"2ue7P","./de.json":"lL3aA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ue7P":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineInputElement\":{\"title\":\"Input\"},\"mask\":{\"FormEngineInputElement\":{\"groupTitle\":\"Input\",\"showError\":\"Show Error\",\"autoComplete\":\"Auto Complete\"}}}");

},{}],"lL3aA":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"FormEngineInputElement":{"title":"Eingang"},"mask":{"FormEngineInputElement":{"groupTitle":"Eingang","showError":"Fehler anzeigen","autoComplete":"Automatisch vervollst\xe4ndigen"}}}');

},{}],"8OI9M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _markdownBuilderElement = require("./components/markdown-builder-element");
var _markdownBuilderElementDefault = parcelHelpers.interopDefault(_markdownBuilderElement);
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    elements: {
        [(0, _markdownBuilderElementDefault.default).Element.apiName]: (0, _markdownBuilderElementDefault.default)
    },
    maskConfigurations: {
        [(0, _markdownBuilderElementDefault.default).Element.apiName]: {
            edit: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    markdownBody: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            preview: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    markdownBody: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            translate: {
                permissions: {
                    name: 'read',
                    hidden: 'read',
                    width: 'read',
                    marginTop: 'read',
                    marginRight: 'read',
                    marginBottom: 'read',
                    marginLeft: 'read',
                    markdownBody: 'write',
                    requiredExpressions: 'read',
                    hiddenExpressions: 'read'
                }
            }
        }
    }
};

},{"./components/markdown-builder-element":"b5kXr","./builder-translations":"lOV4F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b5kXr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "label", ()=>label);
parcelHelpers.export(exports, "Element", ()=>(0, _markdownElementDefault.default));
parcelHelpers.export(exports, "DrawerButton", ()=>(0, _drawerButtonDefault.default));
parcelHelpers.export(exports, "Mask", ()=>(0, _maskDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _reactBootstrapIcons.FileRichtext));
var _drawerButton = require("./drawer-button");
var _drawerButtonDefault = parcelHelpers.interopDefault(_drawerButton);
var _mask = require("./mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _markdownElement = require("../markdown-element");
var _markdownElementDefault = parcelHelpers.interopDefault(_markdownElement);
var _reactBootstrapIcons = require("react-bootstrap-icons");
const label = `${(0, _markdownElementDefault.default).apiName}.title`;
exports.default = {
    label,
    DrawerButton: (0, _drawerButtonDefault.default),
    Mask: (0, _maskDefault.default),
    Element: (0, _markdownElementDefault.default),
    Icon: (0, _reactBootstrapIcons.FileRichtext)
};

},{"./drawer-button":"cos2a","./mask":"eWDYF","../markdown-element":"cYufM","react-bootstrap-icons":"3TzoC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cos2a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderMarkdownElementDrawerButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@form-engine/builder-form-editor/components/elements-drawer/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _index = require("./index");
var _builderApplication = require("@form-engine/builder-application");
const ctor = (overrides = {})=>({
        id: '',
        type: (0, _index.Element).apiName,
        ...overrides
    });
function BuilderMarkdownElementDrawerButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
        ...props,
        constructor: ctor,
        dragLabel: (0, _builderApplication.i18n).c((0, _index.label)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {}),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                id: (0, _index.label)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-form-editor/components/elements-drawer/button":"lldAk","./index":"b5kXr","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eWDYF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderMarkdownElementMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mask = require("@form-engine/builder-mask/components/mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _appearance = require("@form-engine/builder-mask/components/groups/appearance");
var _appearanceDefault = parcelHelpers.interopDefault(_appearance);
var _conditions = require("@form-engine/builder-mask/components/groups/conditions");
var _conditionsDefault = parcelHelpers.interopDefault(_conditions);
var _markdownBody = require("@form-engine/builder-mask/components/properties/markdown-body");
var _markdownBodyDefault = parcelHelpers.interopDefault(_markdownBody);
var _ = require(".");
var _builderApplication = require("@form-engine/builder-application");
function BuilderMarkdownElementMask(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _maskDefault.default), {
        id: (0, _.Element).apiName,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appearanceDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupDefault.default), {
                label: "Content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markdownBodyDefault.default), {
                    label: (0, _builderApplication.i18n).c(`mask.${(0, _.Element).apiName}.markdownBody`)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditionsDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/mask":"kcLv4","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/groups/appearance":"krT6N","@form-engine/builder-mask/components/groups/conditions":"cw0Md","@form-engine/builder-mask/components/properties/markdown-body":"aO1oH",".":"b5kXr","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aO1oH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderMarkdownBodyProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _code = require("./code");
var _codeDefault = parcelHelpers.interopDefault(_code);
function BuilderMarkdownBodyProperty({ propertyName = 'markdownBody', label = false, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _codeDefault.default), {
        language: "markdown",
        ...props,
        propertyName,
        label
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./code":"3j0at","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lOV4F":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"rUc1f","./de.json":"gNnlF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"rUc1f":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineMarkdownElement\":{\"title\":\"Richtext\"},\"mask\":{\"FormEngineMarkdownElement\":{\"markdownBody\":\"Markdown\"}}}");

},{}],"gNnlF":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineMarkdownElement\":{\"title\":\"Richtext\"},\"mask\":{\"FormEngineMarkdownElement\":{\"markdownBody\":\"Abschlag\"}}}");

},{}],"iQSXY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _radiosBuilderElement = require("./components/radios-builder-element");
var _radiosBuilderElementDefault = parcelHelpers.interopDefault(_radiosBuilderElement);
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    elements: {
        [(0, _radiosBuilderElementDefault.default).Element.apiName]: (0, _radiosBuilderElementDefault.default)
    },
    maskConfigurations: {
        [(0, _radiosBuilderElementDefault.default).Element.apiName]: {
            edit: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    disabled: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    label: 'write',
                    inline: 'write',
                    datasource: 'write',
                    datasourceExpressions: 'write',
                    required: 'write',
                    validationContentType: 'write',
                    validateContentTypeRegex: 'write',
                    validateContentTypeMessage: 'write',
                    validationMinLength: 'write',
                    validationMaxLength: 'write',
                    validationValueOf: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            preview: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    disabled: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    label: 'write',
                    inline: 'write',
                    datasource: 'write',
                    datasourceExpressions: 'write',
                    required: 'write',
                    validationContentType: 'write',
                    validateContentTypeRegex: 'write',
                    validateContentTypeMessage: 'write',
                    validationMinLength: 'write',
                    validationMaxLength: 'write',
                    validationValueOf: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            translate: {
                permissions: {
                    name: 'read',
                    hidden: 'read',
                    disabled: 'read',
                    width: 'read',
                    marginTop: 'read',
                    marginRight: 'read',
                    marginBottom: 'read',
                    marginLeft: 'read',
                    label: 'write',
                    inline: 'read',
                    datasource: 'write',
                    datasourceExpressions: 'write',
                    required: 'read',
                    validationContentType: 'read',
                    validateContentTypeRegex: 'read',
                    validateContentTypeMessage: 'write',
                    validationMinLength: 'read',
                    validationMaxLength: 'read',
                    validationValueOf: 'read',
                    requiredExpressions: 'read',
                    hiddenExpressions: 'read'
                }
            }
        }
    }
};

},{"./components/radios-builder-element":"fsKnM","./builder-translations":"dpRYo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fsKnM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "label", ()=>label);
parcelHelpers.export(exports, "Element", ()=>(0, _radiosElementDefault.default));
parcelHelpers.export(exports, "DrawerButton", ()=>(0, _drawerButtonDefault.default));
parcelHelpers.export(exports, "Mask", ()=>(0, _maskDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _reactBootstrapIcons.UiRadios));
var _drawerButton = require("./drawer-button");
var _drawerButtonDefault = parcelHelpers.interopDefault(_drawerButton);
var _mask = require("./mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _radiosElement = require("../radios-element");
var _radiosElementDefault = parcelHelpers.interopDefault(_radiosElement);
var _reactBootstrapIcons = require("react-bootstrap-icons");
const label = `${(0, _radiosElementDefault.default).apiName}.title`;
exports.default = {
    label,
    DrawerButton: (0, _drawerButtonDefault.default),
    Mask: (0, _maskDefault.default),
    Element: (0, _radiosElementDefault.default),
    Icon: (0, _reactBootstrapIcons.UiRadios)
};

},{"./drawer-button":"c9Qhq","./mask":"eMRNF","../radios-element":"kv3Qt","react-bootstrap-icons":"3TzoC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c9Qhq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderRadiosElementDrawerButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@form-engine/builder-form-editor/components/elements-drawer/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _index = require("./index");
var _builderApplication = require("@form-engine/builder-application");
const ctor = (overrides = {})=>({
        id: '',
        type: (0, _index.Element).apiName,
        ...overrides
    });
function BuilderRadiosElementDrawerButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
        ...props,
        constructor: ctor,
        dragLabel: (0, _builderApplication.i18n).c((0, _index.label)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {}),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                id: (0, _index.label)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-form-editor/components/elements-drawer/button":"lldAk","./index":"fsKnM","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eMRNF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderRadiosElementMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mask = require("@form-engine/builder-mask/components/mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _appearance = require("@form-engine/builder-mask/components/groups/appearance");
var _appearanceDefault = parcelHelpers.interopDefault(_appearance);
var _label = require("@form-engine/builder-mask/components/properties/label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _dataSource = require("@form-engine/builder-mask/components/properties/data-source");
var _dataSourceDefault = parcelHelpers.interopDefault(_dataSource);
var _validation = require("@form-engine/builder-mask/components/groups/validation");
var _validationDefault = parcelHelpers.interopDefault(_validation);
var _boolean = require("@form-engine/builder-mask/components/properties/boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
var _conditions = require("@form-engine/builder-mask/components/groups/conditions");
var _conditionsDefault = parcelHelpers.interopDefault(_conditions);
var _expressions = require("@form-engine/builder-mask/components/properties/expressions");
var _expressionsDefault = parcelHelpers.interopDefault(_expressions);
var _ = require(".");
var _builderApplication = require("@form-engine/builder-application");
function BuilderRadiosElementMask(props) {
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _.Element).apiName}.`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _maskDefault.default), {
        id: (0, _.Element).apiName,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appearanceDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                label: c('groupTitle'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "inline",
                        label: c('inline')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSourceDefault.default), {
                        label: c('datasource')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expressionsDefault.default), {
                        label: c('datasourceExpressions'),
                        propertyName: "datasourceExpressions",
                        variableOptions: [
                            '$i.'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validationDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditionsDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/mask":"kcLv4","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/groups/appearance":"krT6N","@form-engine/builder-mask/components/properties/label":"hDKxg","@form-engine/builder-mask/components/properties/data-source":"jEPUo","@form-engine/builder-mask/components/groups/validation":"jzCix","@form-engine/builder-mask/components/properties/boolean":"k2UVH","@form-engine/builder-mask/components/groups/conditions":"cw0Md","@form-engine/builder-mask/components/properties/expressions":"cByR7",".":"fsKnM","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jEPUo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataSourceSelect", ()=>DataSourceSelect);
parcelHelpers.export(exports, "StaticOptionsEditor", ()=>StaticOptionsEditor);
parcelHelpers.export(exports, "DATASOURCE_PROPERTY_MODE_STATIC", ()=>DATASOURCE_PROPERTY_MODE_STATIC);
parcelHelpers.export(exports, "DATASOURCE_PROPERTY_MODE_SOURCE", ()=>DATASOURCE_PROPERTY_MODE_SOURCE);
parcelHelpers.export(exports, "default", ()=>BuilderDataSourceProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _useMask = require("../../hooks/use-mask");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _builderArrayFormControl = require("@form-engine/builder-array-form-control");
var _builderArrayFormControlDefault = parcelHelpers.interopDefault(_builderArrayFormControl);
var _select = require("@form-engine/builder-application/components/select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _property = require("../mask/property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
var _useMaskConfig = require("../../hooks/use-mask-config");
var _useMaskValidation = require("../../hooks/use-mask-validation");
function isSelectableDatasource(config) {
    return Boolean((0, _builderApplicationDefault.default)?.datasources?.[config.type]?.exposesOptions);
}
function DataSourceSelect({ value, onChange, disabled }) {
    const { state: { datasources = [] } } = (0, _useForm.useFormContext)();
    const handleChange = (0, _react.useCallback)((e)=>{
        onChange && onChange(e.target.value);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default).Advanced, {
        isDisabled: disabled,
        value: value,
        onChange: handleChange,
        children: datasources.filter(isSelectableDatasource).map(({ id, name })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: id,
                children: name
            }, id);
        })
    });
}
function StaticOptionsEditorOption({ value = [], onChange }) {
    const handleValueChange = (0, _react.useCallback)((e)=>onChange && onChange([
            e.target.value,
            value[1]
        ]), [
        onChange,
        value
    ]);
    const handleLabelChange = (0, _react.useCallback)((e)=>onChange && onChange([
            value[0],
            e.target.value
        ]), [
        onChange,
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
        className: "mb-2",
        style: {
            ['--bs-gutter-x']: '5px'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                xs: 4,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
                    size: "sm",
                    type: "text",
                    value: value[0] || '',
                    onChange: handleValueChange
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                xs: 8,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
                    size: "sm",
                    type: "text",
                    value: value[1] || '',
                    onChange: handleLabelChange
                })
            })
        ]
    });
}
function StaticOptionsEditor({ value = [
    [
        '',
        ''
    ]
], onChange }) {
    const add = (0, _react.useCallback)(()=>{
        onChange && onChange([
            ...value,
            [
                '',
                ''
            ]
        ]);
    }, [
        onChange,
        value
    ]);
    const remove = (0, _react.useCallback)(()=>{
        if (!onChange) return;
        const copy = [
            ...value
        ];
        copy.pop();
        onChange && onChange(copy);
    }, [
        onChange,
        value
    ]);
    const handleChange = (0, _react.useCallback)((index, option)=>{
        if (!onChange) return;
        const copy = [
            ...value
        ];
        copy[index] = option;
        onChange && onChange(copy);
    }, [
        onChange,
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            value.map((option, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StaticOptionsEditorOption, {
                    value: option,
                    onChange: (ov)=>handleChange(index, ov)
                }, index)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                    className: "d-flex justify-content-end",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.ButtonGroup), {
                        size: "sm",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
                                variant: "light",
                                onClick: add,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.PlusCircleFill), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
                                variant: "light",
                                onClick: remove,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.DashCircleFill), {})
                            })
                        ]
                    })
                })
            })
        ]
    });
}
const DATASOURCE_PROPERTY_MODE_STATIC = 'static';
const DATASOURCE_PROPERTY_MODE_SOURCE = 'source';
function BuilderDataSourceProperty({ label = (0, _builderApplication.i18n).c('mask.datasourceProperty.title'), propertyName = 'datasource', defaultValue = {}, modes = [
    DATASOURCE_PROPERTY_MODE_STATIC,
    DATASOURCE_PROPERTY_MODE_SOURCE
], stacked = true }) {
    const { state: element, setItemProperty } = (0, _useMask.useMaskContext)();
    if (!element) throw new Error('invalid DataSource Property Invokation');
    const set = (0, _react.useCallback)((value)=>{
        setItemProperty(propertyName, {
            ...element[propertyName] || {},
            ...value
        });
    }, [
        element,
        propertyName,
        setItemProperty
    ]);
    const { mode = modes[0], staticOptions = [], datasourceId = '' } = element[propertyName] || defaultValue;
    const permission = (0, _useMaskConfig.useMaskPropertyPermission)(propertyName);
    const error = (0, _useMaskValidation.useMaskPropertyError)(propertyName);
    const disabled = permission === 'read';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertyDefault.default), {
        stacked: stacked,
        className: "fe-data-source-property",
        label: label,
        error: error?.message,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "w-100",
            children: [
                modes.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Nav), {
                    variant: "tabs",
                    activeKey: mode,
                    className: "mb-2",
                    children: [
                        modes.includes(DATASOURCE_PROPERTY_MODE_STATIC) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Item, {
                            className: "ms-auto",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Link, {
                                eventKey: "static",
                                as: "button",
                                onClick: ()=>{
                                    if (disabled) return;
                                    set({
                                        mode: DATASOURCE_PROPERTY_MODE_STATIC
                                    });
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                                    id: "mask.datasourceProperty.static"
                                })
                            })
                        }),
                        modes.includes(DATASOURCE_PROPERTY_MODE_SOURCE) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Item, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Link, {
                                eventKey: "source",
                                as: "button",
                                onClick: ()=>{
                                    if (disabled) return;
                                    set({
                                        mode: DATASOURCE_PROPERTY_MODE_SOURCE
                                    });
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                                    id: "mask.datasourceProperty.source"
                                })
                            })
                        })
                    ]
                }),
                mode === DATASOURCE_PROPERTY_MODE_SOURCE && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DataSourceSelect, {
                    value: datasourceId,
                    onChange: (value)=>{
                        set({
                            datasourceId: value,
                            mode: DATASOURCE_PROPERTY_MODE_SOURCE
                        });
                    },
                    disabled: disabled
                }),
                mode === DATASOURCE_PROPERTY_MODE_STATIC && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderArrayFormControlDefault.default), {
                    cols: [
                        [
                            'value',
                            (0, _builderApplication.i18n).c('mask.datasourceProperty.optionValue')
                        ],
                        [
                            'label',
                            (0, _builderApplication.i18n).c('mask.datasourceProperty.optionLabel')
                        ]
                    ],
                    value: staticOptions,
                    schema: (0, _builderArrayFormControl.ARRAY_SCHEMA),
                    disabled: disabled,
                    onChange: (value)=>{
                        set({
                            staticOptions: value,
                            mode: DATASOURCE_PROPERTY_MODE_STATIC
                        });
                    }
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","../../hooks/use-mask":"72MTY","@form-engine/core-application/hooks/use-form":"5PZyy","react":"9njXz","react-bootstrap":"f5rnA","react-bootstrap-icons":"3TzoC","@form-engine/builder-array-form-control":"2zkEC","@form-engine/builder-application/components/select":"38vFU","../mask/property":"dLorN","@form-engine/builder-application":"7iKr0","../../hooks/use-mask-config":"daHU1","../../hooks/use-mask-validation":"cYKiY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dpRYo":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"3EnlM","./de.json":"18SqD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3EnlM":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineRadiosElement\":{\"title\":\"Radios\"},\"mask\":{\"FormEngineRadiosElement\":{\"groupTitle\":\"Radios\",\"inline\":\"Inline\",\"datasource\":\"Options\",\"datasourceExpressions\":\"Options Filter\"}}}");

},{}],"18SqD":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineRadiosElement\":{\"title\":\"Radios\"},\"mask\":{\"FormEngineRadiosElement\":{\"groupTitle\":\"Radios\",\"inline\":\"In der Reihe\",\"datasource\":\"Optionen\",\"datasourceExpressions\":\"Optionsfilter\"}}}");

},{}],"gMILk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkboxBuilderElement = require("./components/checkbox-builder-element");
var _checkboxBuilderElementDefault = parcelHelpers.interopDefault(_checkboxBuilderElement);
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    elements: {
        [(0, _checkboxBuilderElementDefault.default).Element.apiName]: (0, _checkboxBuilderElementDefault.default)
    },
    maskConfigurations: {
        [(0, _checkboxBuilderElementDefault.default).Element.apiName]: {
            edit: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    disabled: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    label: 'write',
                    inline: 'write',
                    datasource: 'write',
                    datasourceExpressions: 'write',
                    required: 'write',
                    validationContentType: 'write',
                    validateContentTypeRegex: 'write',
                    validateContentTypeMessage: 'write',
                    validationMinLength: 'write',
                    validationMaxLength: 'write',
                    validationValueOf: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write',
                    nested: 'write',
                    nestedGroupOptions: 'write',
                    nestedGroupLabel: 'write'
                }
            },
            preview: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    disabled: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    label: 'write',
                    inline: 'write',
                    datasource: 'write',
                    datasourceExpressions: 'write',
                    required: 'write',
                    validationContentType: 'write',
                    validateContentTypeRegex: 'write',
                    validateContentTypeMessage: 'write',
                    validationMinLength: 'write',
                    validationMaxLength: 'write',
                    validationValueOf: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write',
                    nested: 'write',
                    nestedGroupOptions: 'write',
                    nestedGroupLabel: 'write'
                }
            },
            translate: {
                permissions: {
                    name: 'read',
                    hidden: 'read',
                    disabled: 'read',
                    width: 'read',
                    marginTop: 'read',
                    marginRight: 'read',
                    marginBottom: 'read',
                    marginLeft: 'read',
                    label: 'write',
                    inline: 'read',
                    datasource: 'write',
                    datasourceExpressions: 'write',
                    required: 'read',
                    validationContentType: 'read',
                    validateContentTypeRegex: 'read',
                    validateContentTypeMessage: 'write',
                    validationMinLength: 'read',
                    validationMaxLength: 'read',
                    validationValueOf: 'read',
                    requiredExpressions: 'read',
                    hiddenExpressions: 'read',
                    nested: 'read',
                    nestedGroupOptions: 'read',
                    nestedGroupLabel: 'write'
                }
            }
        }
    }
};

},{"./components/checkbox-builder-element":"9el6P","./builder-translations":"brSkY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9el6P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "label", ()=>label);
parcelHelpers.export(exports, "Element", ()=>(0, _checkboxElementDefault.default));
parcelHelpers.export(exports, "DrawerButton", ()=>(0, _drawerButtonDefault.default));
parcelHelpers.export(exports, "Mask", ()=>(0, _maskDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _reactBootstrapIcons.ToggleOn));
var _drawerButton = require("./drawer-button");
var _drawerButtonDefault = parcelHelpers.interopDefault(_drawerButton);
var _mask = require("./mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _checkboxElement = require("../checkbox-element");
var _checkboxElementDefault = parcelHelpers.interopDefault(_checkboxElement);
var _reactBootstrapIcons = require("react-bootstrap-icons");
const label = `${(0, _checkboxElementDefault.default).apiName}.title`;
exports.default = {
    label,
    DrawerButton: (0, _drawerButtonDefault.default),
    Mask: (0, _maskDefault.default),
    Element: (0, _checkboxElementDefault.default),
    Icon: (0, _reactBootstrapIcons.ToggleOn)
};

},{"./drawer-button":"kKmkH","./mask":"kUby7","../checkbox-element":"bIVAR","react-bootstrap-icons":"3TzoC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kKmkH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderCheckboxElementDrawerButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@form-engine/builder-form-editor/components/elements-drawer/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _index = require("./index");
var _builderApplication = require("@form-engine/builder-application");
const ctor = (overrides = {})=>({
        id: '',
        type: (0, _index.Element).apiName,
        ...overrides
    });
function BuilderCheckboxElementDrawerButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
        ...props,
        constructor: ctor,
        dragLabel: (0, _builderApplication.i18n).c((0, _index.label)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {}),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                id: (0, _index.label)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-form-editor/components/elements-drawer/button":"lldAk","./index":"9el6P","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kUby7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderCheckboxElementMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mask = require("@form-engine/builder-mask/components/mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _appearance = require("@form-engine/builder-mask/components/groups/appearance");
var _appearanceDefault = parcelHelpers.interopDefault(_appearance);
var _label = require("@form-engine/builder-mask/components/properties/label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _dataSource = require("@form-engine/builder-mask/components/properties/data-source");
var _dataSourceDefault = parcelHelpers.interopDefault(_dataSource);
var _validation = require("@form-engine/builder-mask/components/groups/validation");
var _validationDefault = parcelHelpers.interopDefault(_validation);
var _boolean = require("@form-engine/builder-mask/components/properties/boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
var _conditions = require("@form-engine/builder-mask/components/groups/conditions");
var _conditionsDefault = parcelHelpers.interopDefault(_conditions);
var _expressions = require("@form-engine/builder-mask/components/properties/expressions");
var _expressionsDefault = parcelHelpers.interopDefault(_expressions);
var _ = require(".");
var _builderApplication = require("@form-engine/builder-application");
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _string = require("@form-engine/builder-mask/components/properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
function BuilderCheckboxElementMask(props) {
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _.Element).apiName}.`);
    const [nested] = (0, _useMask.useMaskProperty)('nested', false);
    const [datasource, setDatasource] = (0, _useMask.useMaskProperty)('datasource');
    const [datasourceExpressions, setDatasourceExpressions] = (0, _useMask.useMaskProperty)('datasourceExpressions');
    (0, _react.useEffect)(()=>{
        if (!nested) return;
        if (datasource?.mode !== 'source') setDatasource({
            ...datasource ?? {},
            mode: 'source'
        });
        if (datasourceExpressions) setDatasourceExpressions(undefined);
    }, [
        nested,
        datasource,
        setDatasource,
        datasourceExpressions,
        setDatasourceExpressions
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _maskDefault.default), {
        id: (0, _.Element).apiName,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appearanceDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                label: c('groupTitle'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "inline",
                        label: c('inline')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "nested",
                        label: c('nested')
                    }),
                    nested ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                                propertyName: "nestedGroupLabel",
                                compilable: true,
                                variableOptions: [
                                    '$i'
                                ],
                                defaultValue: "{{$i.Label}}",
                                label: c('nestedGroupLabel')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                                propertyName: "nestedGroupOptions",
                                defaultValue: "Options",
                                label: c('nestedGroupOptions')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSourceDefault.default), {
                                label: c('datasource'),
                                modes: [
                                    'source'
                                ],
                                stacked: false
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSourceDefault.default), {
                                label: c('datasource')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expressionsDefault.default), {
                                label: c('datasourceExpressions'),
                                propertyName: "datasourceExpressions",
                                variableOptions: [
                                    '$i.'
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validationDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditionsDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/mask":"kcLv4","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/groups/appearance":"krT6N","@form-engine/builder-mask/components/properties/label":"hDKxg","@form-engine/builder-mask/components/properties/data-source":"jEPUo","@form-engine/builder-mask/components/groups/validation":"jzCix","@form-engine/builder-mask/components/properties/boolean":"k2UVH","@form-engine/builder-mask/components/groups/conditions":"cw0Md","@form-engine/builder-mask/components/properties/expressions":"cByR7",".":"9el6P","@form-engine/builder-application":"7iKr0","@form-engine/builder-mask/hooks/use-mask":"72MTY","@form-engine/builder-mask/components/properties/string":"e6M7S","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"brSkY":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"cv45K","./de.json":"cmrx9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cv45K":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineCheckboxElement\":{\"title\":\"Checkbox\"},\"mask\":{\"FormEngineCheckboxElement\":{\"groupTitle\":\"Checkbox\",\"inline\":\"Inline\",\"datasource\":\"Options\",\"datasourceExpressions\":\"Options Filter\",\"nested\":\"Nested\",\"nestedGroupOptions\":\"Options Key\",\"nestedGroupLabel\":\"Group Label\"}}}");

},{}],"cmrx9":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"FormEngineCheckboxElement":{"title":"Kontrollk\xe4stchen"},"mask":{"FormEngineCheckboxElement":{"groupTitle":"Kontrollk\xe4stchen","inline":"In der Reihe","datasource":"Optionen","datasourceExpressions":"Optionsfilter","nested":"Verschachtelt","nestedGroupOptions":"Zugriffsschl\xfcssel","nestedGroupLabel":"\xdcberschrift"}}}');

},{}],"llYCK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _navigationBuilderElement = require("./components/navigation-builder-element");
var _navigationBuilderElementDefault = parcelHelpers.interopDefault(_navigationBuilderElement);
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    elements: {
        [(0, _navigationBuilderElementDefault.default).Element.apiName]: (0, _navigationBuilderElementDefault.default)
    },
    [(0, _navigationBuilderElementDefault.default).Element.apiName]: {
        edit: {
            permissions: {
                name: 'write',
                hidden: 'write',
                width: 'write',
                marginTop: 'write',
                marginRight: 'write',
                marginBottom: 'write',
                marginLeft: 'write',
                datasource: 'write',
                datasourceExpressions: 'write',
                hiddenExpressions: 'write'
            }
        },
        preview: {
            permissions: {
                name: 'write',
                hidden: 'write',
                width: 'write',
                marginTop: 'write',
                marginRight: 'write',
                marginBottom: 'write',
                marginLeft: 'write',
                datasource: 'write',
                datasourceExpressions: 'write',
                hiddenExpressions: 'write'
            }
        },
        translate: {
            permissions: {
                name: 'read',
                hidden: 'read',
                width: 'read',
                marginTop: 'read',
                marginRight: 'read',
                marginBottom: 'read',
                marginLeft: 'read',
                datasource: 'write',
                datasourceExpressions: 'write',
                hiddenExpressions: 'read'
            }
        }
    }
};

},{"./components/navigation-builder-element":"l7Z53","./builder-translations":"23woF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l7Z53":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "label", ()=>label);
parcelHelpers.export(exports, "Element", ()=>(0, _navigationElementDefault.default));
parcelHelpers.export(exports, "DrawerButton", ()=>(0, _drawerButtonDefault.default));
parcelHelpers.export(exports, "Mask", ()=>(0, _maskDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _reactBootstrapIcons.HandIndexThumb));
var _drawerButton = require("./drawer-button");
var _drawerButtonDefault = parcelHelpers.interopDefault(_drawerButton);
var _mask = require("./mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _navigationElement = require("../navigation-element");
var _navigationElementDefault = parcelHelpers.interopDefault(_navigationElement);
var _reactBootstrapIcons = require("react-bootstrap-icons");
const label = `${(0, _navigationElementDefault.default).apiName}.title`;
exports.default = {
    label,
    DrawerButton: (0, _drawerButtonDefault.default),
    Mask: (0, _maskDefault.default),
    Element: (0, _navigationElementDefault.default),
    Icon: (0, _reactBootstrapIcons.HandIndexThumb)
};

},{"./drawer-button":"7VPLq","./mask":"9SlAe","../navigation-element":"bKaAi","react-bootstrap-icons":"3TzoC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7VPLq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderNavigationElementDrawerButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@form-engine/builder-form-editor/components/elements-drawer/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _index = require("./index");
var _builderApplication = require("@form-engine/builder-application");
const ctor = (overrides = {})=>({
        id: '',
        type: (0, _index.Element).apiName,
        ...overrides
    });
function BuilderNavigationElementDrawerButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
        ...props,
        constructor: ctor,
        dragLabel: (0, _builderApplication.i18n).c((0, _index.label)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {}),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                id: (0, _index.label)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-form-editor/components/elements-drawer/button":"lldAk","./index":"l7Z53","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9SlAe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderButtonElementMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mask = require("@form-engine/builder-mask/components/mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _appearance = require("@form-engine/builder-mask/components/groups/appearance");
var _appearanceDefault = parcelHelpers.interopDefault(_appearance);
var _conditions = require("@form-engine/builder-mask/components/groups/conditions");
var _conditionsDefault = parcelHelpers.interopDefault(_conditions);
var _dataSource = require("@form-engine/builder-mask/components/properties/data-source");
var _dataSourceDefault = parcelHelpers.interopDefault(_dataSource);
var _expressions = require("@form-engine/builder-mask/components/properties/expressions");
var _expressionsDefault = parcelHelpers.interopDefault(_expressions);
var _ = require(".");
var _builderApplication = require("@form-engine/builder-application");
function BuilderButtonElementMask(props) {
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _.Element).apiName}.`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _maskDefault.default), {
        id: (0, _.Element).apiName,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appearanceDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                label: c('groupTitle'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSourceDefault.default), {
                        label: c('datasource')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expressionsDefault.default), {
                        label: c('datasourceExpressions'),
                        propertyName: "datasourceExpressions",
                        variableOptions: [
                            '$i.'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditionsDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/mask":"kcLv4","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/groups/appearance":"krT6N","@form-engine/builder-mask/components/groups/conditions":"cw0Md","@form-engine/builder-mask/components/properties/data-source":"jEPUo","@form-engine/builder-mask/components/properties/expressions":"cByR7",".":"l7Z53","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"23woF":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"kvqDR","./de.json":"kMKkG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kvqDR":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineNavigationElement\":{\"title\":\"Navigation\"},\"mask\":{\"FormEngineNavigationElement\":{\"groupTitle\":\"Navigation\",\"datasource\":\"Items\",\"datasourceExpressions\":\"Items Filter\"}}}");

},{}],"kMKkG":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineNavigationElement\":{\"title\":\"Navigation\"},\"mask\":{\"FormEngineNavigationElement\":{\"groupTitle\":\"Navigation\",\"datasource\":\"Artikel\",\"datasourceExpressions\":\"Artikelfilter\"}}}");

},{}],"01bJA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _containerBuilderElement = require("./components/container-builder-element");
var _containerBuilderElementDefault = parcelHelpers.interopDefault(_containerBuilderElement);
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    elements: {
        [(0, _containerBuilderElementDefault.default).Element.apiName]: (0, _containerBuilderElementDefault.default)
    },
    maskConfigurations: {
        [(0, _containerBuilderElementDefault.default).Element.apiName]: {
            edit: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            preview: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            translate: {
                permissions: {
                    name: 'read',
                    hidden: 'read',
                    width: 'read',
                    marginTop: 'read',
                    marginRight: 'read',
                    marginBottom: 'read',
                    marginLeft: 'read',
                    requiredExpressions: 'read',
                    hiddenExpressions: 'read'
                }
            }
        }
    }
};

},{"./components/container-builder-element":"6GHtx","./builder-translations":"2PWw1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6GHtx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "label", ()=>label);
parcelHelpers.export(exports, "Element", ()=>(0, _containerElementDefault.default));
parcelHelpers.export(exports, "DrawerButton", ()=>(0, _drawerButtonDefault.default));
parcelHelpers.export(exports, "Mask", ()=>(0, _maskDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _reactBootstrapIcons.Box));
var _containerElement = require("../container-element");
var _containerElementDefault = parcelHelpers.interopDefault(_containerElement);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _drawerButton = require("./drawer-button");
var _drawerButtonDefault = parcelHelpers.interopDefault(_drawerButton);
var _mask = require("./mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
const label = `${(0, _containerElementDefault.default).apiName}.title`;
exports.default = {
    label,
    DrawerButton: (0, _drawerButtonDefault.default),
    Mask: (0, _maskDefault.default),
    Element: (0, _containerElementDefault.default),
    Icon: (0, _reactBootstrapIcons.Box)
};

},{"../container-element":"bBYj4","react-bootstrap-icons":"3TzoC","./drawer-button":"9Z2QI","./mask":"2VWXr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Z2QI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderContainerElementDrawerButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@form-engine/builder-form-editor/components/elements-drawer/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _index = require("./index");
var _builderApplication = require("@form-engine/builder-application");
const ctor = (overrides = {})=>({
        id: '',
        type: (0, _index.Element).apiName,
        ...overrides
    });
function BuilderContainerElementDrawerButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
        ...props,
        constructor: ctor,
        dragLabel: (0, _builderApplication.i18n).c((0, _index.label)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {}),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                id: (0, _index.label)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-form-editor/components/elements-drawer/button":"lldAk","./index":"6GHtx","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2VWXr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderContainerElementMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mask = require("@form-engine/builder-mask/components/mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _appearance = require("@form-engine/builder-mask/components/groups/appearance");
var _appearanceDefault = parcelHelpers.interopDefault(_appearance);
var _conditions = require("@form-engine/builder-mask/components/groups/conditions");
var _conditionsDefault = parcelHelpers.interopDefault(_conditions);
var _ = require(".");
function BuilderContainerElementMask(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _maskDefault.default), {
        id: (0, _.Element).apiName,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appearanceDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditionsDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/mask":"kcLv4","@form-engine/builder-mask/components/groups/appearance":"krT6N","@form-engine/builder-mask/components/groups/conditions":"cw0Md",".":"6GHtx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2PWw1":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"hBlYR","./de.json":"lBAkr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hBlYR":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineContainerElement\":{\"title\":\"Container\"}}");

},{}],"lBAkr":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineContainerElement\":{\"title\":\"Container\"}}");

},{}],"gI8ie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _textareaBuilderElement = require("./components/textarea-builder-element");
var _textareaBuilderElementDefault = parcelHelpers.interopDefault(_textareaBuilderElement);
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    elements: {
        [(0, _textareaBuilderElementDefault.default).Element.apiName]: (0, _textareaBuilderElementDefault.default)
    },
    maskConfigurations: {
        [(0, _textareaBuilderElementDefault.default).Element.apiName]: {
            edit: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    disabled: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    label: 'write',
                    floatingLabel: 'write',
                    showError: 'write',
                    placeholder: 'write',
                    rows: 'write',
                    required: 'write',
                    validationContentType: 'write',
                    validateContentTypeRegex: 'write',
                    validateContentTypeMessage: 'write',
                    validationMinLength: 'write',
                    validationMaxLength: 'write',
                    validationValueOf: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            preview: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    disabled: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    label: 'write',
                    floatingLabel: 'write',
                    showError: 'write',
                    placeholder: 'write',
                    rows: 'write',
                    required: 'write',
                    validationContentType: 'write',
                    validateContentTypeRegex: 'write',
                    validateContentTypeMessage: 'write',
                    validationMinLength: 'write',
                    validationMaxLength: 'write',
                    validationValueOf: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            translate: {
                permissions: {
                    name: 'read',
                    hidden: 'read',
                    disabled: 'read',
                    width: 'read',
                    marginTop: 'read',
                    marginRight: 'read',
                    marginBottom: 'read',
                    marginLeft: 'read',
                    label: 'write',
                    floatingLabel: 'read',
                    showError: 'read',
                    placeholder: 'write',
                    rows: 'write',
                    required: 'read',
                    validationContentType: 'read',
                    validateContentTypeRegex: 'read',
                    validateContentTypeMessage: 'write',
                    validationMinLength: 'read',
                    validationMaxLength: 'read',
                    validationValueOf: 'read',
                    requiredExpressions: 'read',
                    hiddenExpressions: 'read'
                }
            }
        }
    }
};

},{"./components/textarea-builder-element":"9fKH6","./builder-translations":"jwyIf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9fKH6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "label", ()=>label);
parcelHelpers.export(exports, "Element", ()=>(0, _textareaElementDefault.default));
parcelHelpers.export(exports, "DrawerButton", ()=>(0, _drawerButtonDefault.default));
parcelHelpers.export(exports, "Mask", ()=>(0, _maskDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _reactBootstrapIcons.CardText));
var _drawerButton = require("./drawer-button");
var _drawerButtonDefault = parcelHelpers.interopDefault(_drawerButton);
var _mask = require("./mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _textareaElement = require("../textarea-element");
var _textareaElementDefault = parcelHelpers.interopDefault(_textareaElement);
var _reactBootstrapIcons = require("react-bootstrap-icons");
const label = `${(0, _textareaElementDefault.default).apiName}.title`;
exports.default = {
    label,
    DrawerButton: (0, _drawerButtonDefault.default),
    Mask: (0, _maskDefault.default),
    Element: (0, _textareaElementDefault.default),
    Icon: (0, _reactBootstrapIcons.CardText)
};

},{"./drawer-button":"bee3H","./mask":"6u5nv","../textarea-element":"jX5X1","react-bootstrap-icons":"3TzoC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bee3H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderTextareaElementDrawerButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@form-engine/builder-form-editor/components/elements-drawer/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _index = require("./index");
var _builderApplication = require("@form-engine/builder-application");
const ctor = (overrides = {})=>({
        id: '',
        type: (0, _index.Element).apiName,
        ...overrides
    });
function BuilderTextareaElementDrawerButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
        ...props,
        constructor: ctor,
        dragLabel: (0, _builderApplication.i18n).c((0, _index.label)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {}),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                id: (0, _index.label)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-form-editor/components/elements-drawer/button":"lldAk","./index":"9fKH6","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6u5nv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderTextareaElementMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mask = require("@form-engine/builder-mask/components/mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _appearance = require("@form-engine/builder-mask/components/groups/appearance");
var _appearanceDefault = parcelHelpers.interopDefault(_appearance);
var _conditions = require("@form-engine/builder-mask/components/groups/conditions");
var _conditionsDefault = parcelHelpers.interopDefault(_conditions);
var _validation = require("@form-engine/builder-mask/components/groups/validation");
var _validationDefault = parcelHelpers.interopDefault(_validation);
var _boolean = require("@form-engine/builder-mask/components/properties/boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
var _floatingLabel = require("@form-engine/builder-mask/components/properties/floating-label");
var _floatingLabelDefault = parcelHelpers.interopDefault(_floatingLabel);
var _label = require("@form-engine/builder-mask/components/properties/label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _placeholder = require("@form-engine/builder-mask/components/properties/placeholder");
var _placeholderDefault = parcelHelpers.interopDefault(_placeholder);
var _string = require("@form-engine/builder-mask/components/properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _ = require(".");
var _builderApplication = require("@form-engine/builder-application");
function BuilderTextareaElementMask(props) {
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _.Element).apiName}.`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _maskDefault.default), {
        id: (0, _.Element).apiName,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appearanceDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                label: c('groupTitle'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _floatingLabelDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "showError",
                        label: c('showError')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _placeholderDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        type: "number",
                        step: "1",
                        min: "2",
                        max: "20",
                        propertyName: "rows",
                        label: c('rows'),
                        defaultValue: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validationDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditionsDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/mask":"kcLv4","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/groups/appearance":"krT6N","@form-engine/builder-mask/components/groups/conditions":"cw0Md","@form-engine/builder-mask/components/groups/validation":"jzCix","@form-engine/builder-mask/components/properties/boolean":"k2UVH","@form-engine/builder-mask/components/properties/floating-label":"3xmdn","@form-engine/builder-mask/components/properties/label":"hDKxg","@form-engine/builder-mask/components/properties/placeholder":"fvXxk","@form-engine/builder-mask/components/properties/string":"e6M7S",".":"9fKH6","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jwyIf":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"cIW3d","./de.json":"bsVvg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cIW3d":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineTextareaElement\":{\"title\":\"Textarea\"},\"mask\":{\"FormEngineTextareaElement\":{\"groupTitle\":\"Textarea\",\"showError\":\"Show Error\",\"rows\":\"Rows\"}}}");

},{}],"bsVvg":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineTextareaElement\":{\"title\":\"Textbereich\"},\"mask\":{\"FormEngineTextareaElement\":{\"groupTitle\":\"Textbereich\",\"showError\":\"Fehler anzeigen\",\"rows\":\"Reihen\"}}}");

},{}],"lR9P2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _buttonBuilderElement = require("./components/button-builder-element");
var _buttonBuilderElementDefault = parcelHelpers.interopDefault(_buttonBuilderElement);
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    elements: {
        [(0, _buttonBuilderElementDefault.default).Element.apiName]: (0, _buttonBuilderElementDefault.default)
    },
    maskConfigurations: {
        [(0, _buttonBuilderElementDefault.default).Element.apiName]: {
            edit: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    disabled: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    label: 'write',
                    isBlock: 'write',
                    variant: 'write',
                    requireValid: 'write',
                    requireOnline: 'write',
                    action: 'write',
                    eventName: 'write',
                    pageName: 'write',
                    url: 'write',
                    urlTarget: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            preview: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    disabled: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    label: 'write',
                    isBlock: 'write',
                    variant: 'write',
                    requireValid: 'write',
                    requireOnline: 'write',
                    action: 'write',
                    eventName: 'write',
                    pageName: 'write',
                    url: 'write',
                    urlTarget: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            translate: {
                permissions: {
                    name: 'read',
                    hidden: 'read',
                    disabled: 'read',
                    width: 'read',
                    marginTop: 'read',
                    marginRight: 'read',
                    marginBottom: 'read',
                    marginLeft: 'read',
                    label: 'write',
                    isBlock: 'read',
                    variant: 'read',
                    requireValid: 'read',
                    requireOnline: 'read',
                    action: 'read',
                    eventName: 'read',
                    pageName: 'read',
                    url: 'write',
                    urlTarget: 'read',
                    requiredExpressions: 'read',
                    hiddenExpressions: 'read'
                }
            }
        }
    }
};

},{"./components/button-builder-element":"jUZ0C","./builder-translations":"1UWaP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jUZ0C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "label", ()=>label);
parcelHelpers.export(exports, "Element", ()=>(0, _buttonElementDefault.default));
parcelHelpers.export(exports, "DrawerButton", ()=>(0, _drawerButtonDefault.default));
parcelHelpers.export(exports, "Mask", ()=>(0, _maskDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _reactBootstrapIcons.HandIndexThumb));
var _drawerButton = require("./drawer-button");
var _drawerButtonDefault = parcelHelpers.interopDefault(_drawerButton);
var _mask = require("./mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _buttonElement = require("../button-element");
var _buttonElementDefault = parcelHelpers.interopDefault(_buttonElement);
var _reactBootstrapIcons = require("react-bootstrap-icons");
const label = `${(0, _buttonElementDefault.default).apiName}.title`;
exports.default = {
    label,
    DrawerButton: (0, _drawerButtonDefault.default),
    Mask: (0, _maskDefault.default),
    Element: (0, _buttonElementDefault.default),
    Icon: (0, _reactBootstrapIcons.HandIndexThumb)
};

},{"./drawer-button":"7L2ku","./mask":"lm2iu","../button-element":"dSd6b","react-bootstrap-icons":"3TzoC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7L2ku":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderButtonElementDrawerButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@form-engine/builder-form-editor/components/elements-drawer/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _index = require("./index");
var _builderApplication = require("@form-engine/builder-application");
const ctor = (overrides = {})=>({
        id: '',
        type: (0, _index.Element).apiName,
        label: 'Click me!',
        ...overrides
    });
function BuilderButtonElementDrawerButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
        ...props,
        constructor: ctor,
        dragLabel: (0, _builderApplication.i18n).c((0, _index.label)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {}),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                id: (0, _index.label)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-form-editor/components/elements-drawer/button":"lldAk","./index":"jUZ0C","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lm2iu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderButtonElementMask);
var _jsxRuntime = require("react/jsx-runtime");
var _buttonElement = require("../button-element");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mask = require("@form-engine/builder-mask/components/mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _boolean = require("@form-engine/builder-mask/components/properties/boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
var _enum = require("@form-engine/builder-mask/components/properties/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _appearance = require("@form-engine/builder-mask/components/groups/appearance");
var _appearanceDefault = parcelHelpers.interopDefault(_appearance);
var _label = require("@form-engine/builder-mask/components/properties/label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _string = require("@form-engine/builder-mask/components/properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _pageName = require("@form-engine/builder-mask/components/properties/page-name");
var _pageNameDefault = parcelHelpers.interopDefault(_pageName);
var _conditions = require("@form-engine/builder-mask/components/groups/conditions");
var _conditionsDefault = parcelHelpers.interopDefault(_conditions);
var _useWfl = require("@form-engine/core-application/hooks/use-wfl");
var _ = require(".");
var _builderApplication = require("@form-engine/builder-application");
var _general = require("@form-engine/builder-mask/components/groups/general");
var _generalDefault = parcelHelpers.interopDefault(_general);
const variants = [
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
    'dark',
    'light',
    'link',
    'outline-primary',
    'outline-secondary',
    'outline-success',
    'outline-danger',
    'outline-warning',
    'outline-info',
    'outline-dark',
    'outline-light'
].map((key)=>[
        key,
        key
    ]);
const ACTION_OPTIONS = Object.keys((0, _buttonElement.BUTTON_ACTIONS)).map((key)=>[
        (0, _buttonElement.BUTTON_ACTIONS)[key],
        (0, _buttonElement.BUTTON_ACTIONS_LABELS)[key]
    ]);
const SIGNAL_TYPE_NAME = 'FormEngineSignalWfl';
function BuilderButtonElementMask(props) {
    const { state } = (0, _useMask.useMaskContext)();
    const { state: layers } = (0, _useWfl.useWorkflowLayers)();
    const signalOptions = (0, _react.useMemo)(()=>{
        return layers.filter(({ type })=>type === SIGNAL_TYPE_NAME).map((signal)=>[
                `${signal.id}@success`,
                signal.name
            ]);
    }, [
        layers
    ]);
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _.Element).apiName}.`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _maskDefault.default), {
        id: (0, _.Element).apiName,
        ...props,
        general: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalDefault.default), {
                disabled: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appearanceDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                label: "Button",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "isBlock",
                        label: c('isBlock')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                        propertyName: "variant",
                        label: c('variant'),
                        defaultValue: "primary",
                        options: variants
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "requireValid",
                        label: c('requireValid')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "requireOnline",
                        label: c('requireOnline'),
                        defaultValue: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                        propertyName: "action",
                        label: c('action'),
                        defaultValue: (0, _buttonElement.BUTTON_ACTIONS).SUBMIT,
                        options: ACTION_OPTIONS
                    }),
                    state?.action === (0, _buttonElement.BUTTON_ACTIONS).EMIT_EVENT && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                        propertyName: "eventName",
                        label: c('eventName'),
                        options: signalOptions
                    }),
                    state?.action === (0, _buttonElement.BUTTON_ACTIONS).SHOW_PAGE && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageNameDefault.default), {
                        label: "Target Page"
                    }),
                    state?.action === (0, _buttonElement.BUTTON_ACTIONS).OPEN_URL && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                                propertyName: "url",
                                type: "url",
                                label: c('url')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                                propertyName: "urlTarget",
                                label: c('urlTarget'),
                                options: [
                                    [
                                        '',
                                        'Self'
                                    ],
                                    [
                                        '_blank',
                                        'Blank'
                                    ],
                                    [
                                        '_parent',
                                        'Parent'
                                    ],
                                    [
                                        '_top',
                                        'Top'
                                    ]
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditionsDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","../button-element":"dSd6b","react":"9njXz","@form-engine/builder-mask/components/mask":"kcLv4","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/properties/boolean":"k2UVH","@form-engine/builder-mask/components/properties/enum":"2kNfK","@form-engine/builder-mask/components/groups/appearance":"krT6N","@form-engine/builder-mask/components/properties/label":"hDKxg","@form-engine/builder-mask/hooks/use-mask":"72MTY","@form-engine/builder-mask/components/properties/string":"e6M7S","@form-engine/builder-mask/components/properties/page-name":"lLs1S","@form-engine/builder-mask/components/groups/conditions":"cw0Md","@form-engine/core-application/hooks/use-wfl":"eobGp",".":"jUZ0C","@form-engine/builder-application":"7iKr0","@form-engine/builder-mask/components/groups/general":"asnpT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lLs1S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderPageNameProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _enum = require("./enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _builderApplication = require("@form-engine/builder-application");
function BuilderPageNameProperty(props) {
    const { state: elements } = (0, _useForm.useFormElements)();
    const options = (0, _react.useMemo)(()=>{
        return (elements || []).filter(({ type, name })=>name && type === 'FormEnginePageElement').map(({ name })=>[
                name
            ]);
    }, [
        elements
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
        label: (0, _builderApplication.i18n).c('mask.pageNameProperty.title'),
        ...props,
        propertyName: props.propertyName ?? 'pageName',
        options: options
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/hooks/use-form":"5PZyy","react":"9njXz","./enum":"2kNfK","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1UWaP":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"iZOpw","./de.json":"538iV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iZOpw":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineButtonElement\":{\"title\":\"Button\"},\"mask\":{\"FormEngineButtonElement\":{\"isBlock\":\"Block\",\"variant\":\"Variant\",\"requireValid\":\"Disable on page error\",\"requireOnline\":\"Disable when offline\",\"action\":\"Action\",\"eventName\":\"Signal\",\"pageName\":\"Target Page\",\"url\":\"Url\",\"urlTarget\":\"Target\"}}}");

},{}],"538iV":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineButtonElement\":{\"title\":\"Knopf\"},\"mask\":{\"FormEngineButtonElement\":{\"isBlock\":\"Block\",\"variant\":\"Variante\",\"requireValid\":\"Abschicken bei Seitenfehler deaktivieren\",\"requireOnline\":\"Abschicken deaktivieren wenn offline\",\"action\":\"Handlung\",\"eventName\":\"Signal\",\"pageName\":\"Zielseite\",\"url\":\"URL\",\"urlTarget\":\"Ziel\"}}}");

},{}],"5c4JG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _selectBuilderElement = require("./components/select-builder-element");
var _selectBuilderElementDefault = parcelHelpers.interopDefault(_selectBuilderElement);
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    elements: {
        [(0, _selectBuilderElementDefault.default).Element.apiName]: (0, _selectBuilderElementDefault.default)
    },
    maskConfigurations: {
        [(0, _selectBuilderElementDefault.default).Element.apiName]: {
            edit: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    disabled: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    label: 'write',
                    floatingLabel: 'write',
                    searchable: 'write',
                    showUnselect: 'write',
                    datasource: 'write',
                    datasourceExpressions: 'write',
                    required: 'write',
                    validationContentType: 'write',
                    validateContentTypeRegex: 'write',
                    validateContentTypeMessage: 'write',
                    validationMinLength: 'write',
                    validationMaxLength: 'write',
                    validationValueOf: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write',
                    placeholder: 'write',
                    controlType: 'write'
                }
            },
            preview: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    disabled: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    label: 'write',
                    floatingLabel: 'write',
                    searchable: 'write',
                    showUnselect: 'write',
                    datasource: 'write',
                    datasourceExpressions: 'write',
                    required: 'write',
                    validationContentType: 'write',
                    validateContentTypeRegex: 'write',
                    validateContentTypeMessage: 'write',
                    validationMinLength: 'write',
                    validationMaxLength: 'write',
                    validationValueOf: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write',
                    placeholder: 'write',
                    controlType: 'write'
                }
            },
            translate: {
                permissions: {
                    name: 'read',
                    hidden: 'read',
                    disabled: 'read',
                    width: 'read',
                    marginTop: 'read',
                    marginRight: 'read',
                    marginBottom: 'read',
                    marginLeft: 'read',
                    label: 'write',
                    floatingLabel: 'read',
                    searchable: 'read',
                    showUnselect: 'read',
                    datasource: 'write',
                    datasourceExpressions: 'write',
                    required: 'read',
                    validationContentType: 'read',
                    validateContentTypeRegex: 'read',
                    validateContentTypeMessage: 'write',
                    validationMinLength: 'read',
                    validationMaxLength: 'read',
                    validationValueOf: 'read',
                    requiredExpressions: 'read',
                    hiddenExpressions: 'read',
                    placeholder: 'write',
                    controlType: 'read'
                }
            }
        }
    }
};

},{"./components/select-builder-element":"hOCw8","./builder-translations":"iDs8E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hOCw8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "label", ()=>label);
parcelHelpers.export(exports, "Element", ()=>(0, _selectElementDefault.default));
parcelHelpers.export(exports, "DrawerButton", ()=>(0, _drawerButtonDefault.default));
parcelHelpers.export(exports, "Mask", ()=>(0, _maskDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _reactBootstrapIcons.MenuButtonWideFill));
var _drawerButton = require("./drawer-button");
var _drawerButtonDefault = parcelHelpers.interopDefault(_drawerButton);
var _mask = require("./mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _selectElement = require("../select-element");
var _selectElementDefault = parcelHelpers.interopDefault(_selectElement);
var _reactBootstrapIcons = require("react-bootstrap-icons");
const label = `${(0, _selectElementDefault.default).apiName}.title`;
exports.default = {
    label,
    DrawerButton: (0, _drawerButtonDefault.default),
    Mask: (0, _maskDefault.default),
    Element: (0, _selectElementDefault.default),
    Icon: (0, _reactBootstrapIcons.MenuButtonWideFill)
};

},{"./drawer-button":"9PfIZ","./mask":"drbab","../select-element":"5KuU4","react-bootstrap-icons":"3TzoC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9PfIZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderSelectElementDrawerButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@form-engine/builder-form-editor/components/elements-drawer/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _index = require("./index");
var _builderApplication = require("@form-engine/builder-application");
const ctor = (overrides = {})=>({
        id: '',
        type: (0, _index.Element).apiName,
        ...overrides
    });
function BuilderSelectElementDrawerButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
        ...props,
        constructor: ctor,
        dragLabel: (0, _builderApplication.i18n).c((0, _index.label)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {}),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                id: (0, _index.label)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-form-editor/components/elements-drawer/button":"lldAk","./index":"hOCw8","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"drbab":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderSelectElementMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mask = require("@form-engine/builder-mask/components/mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _boolean = require("@form-engine/builder-mask/components/properties/boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
var _appearance = require("@form-engine/builder-mask/components/groups/appearance");
var _appearanceDefault = parcelHelpers.interopDefault(_appearance);
var _floatingLabel = require("@form-engine/builder-mask/components/properties/floating-label");
var _floatingLabelDefault = parcelHelpers.interopDefault(_floatingLabel);
var _label = require("@form-engine/builder-mask/components/properties/label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _dataSource = require("@form-engine/builder-mask/components/properties/data-source");
var _dataSourceDefault = parcelHelpers.interopDefault(_dataSource);
var _validation = require("@form-engine/builder-mask/components/groups/validation");
var _validationDefault = parcelHelpers.interopDefault(_validation);
var _conditions = require("@form-engine/builder-mask/components/groups/conditions");
var _conditionsDefault = parcelHelpers.interopDefault(_conditions);
var _expressions = require("@form-engine/builder-mask/components/properties/expressions");
var _expressionsDefault = parcelHelpers.interopDefault(_expressions);
var _selectElement = require("../select-element");
var _ = require(".");
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _string = require("@form-engine/builder-mask/components/properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _builderApplication = require("@form-engine/builder-application");
var _enum = require("@form-engine/builder-mask/components/properties/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
function BuilderSelectElementMask(props) {
    const { state } = (0, _useMask.useMaskContext)();
    const { controlType = (0, _selectElement.CONTROL_TYPES).NATIVE } = state ?? {};
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _.Element).apiName}.`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _maskDefault.default), {
        id: (0, _.Element).apiName,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appearanceDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                label: c('groupTitle'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                        propertyName: "controlType",
                        label: c('controlType'),
                        defaultValue: (0, _selectElement.CONTROL_TYPES).NATIVE,
                        options: [
                            [
                                (0, _selectElement.CONTROL_TYPES).NATIVE,
                                c('controlTypes.native')
                            ],
                            [
                                (0, _selectElement.CONTROL_TYPES).ADVANCED,
                                c('controlTypes.advanced')
                            ]
                        ]
                    }),
                    controlType === (0, _selectElement.CONTROL_TYPES).ADVANCED && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                                propertyName: "searchable",
                                label: c('searchable'),
                                defaultValue: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                                propertyName: "placeholder",
                                label: c('placeholder'),
                                placeholder: "Select..."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _floatingLabelDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "showError",
                        label: c('showError')
                    }),
                    controlType === (0, _selectElement.CONTROL_TYPES).NATIVE && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                                propertyName: "showDefaultOption",
                                label: c('showDefaultOption')
                            }),
                            Boolean(state?.showDefaultOption) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                                propertyName: "defaultOptionLabel",
                                label: c('defaultOptionLabel'),
                                placeholder: c('defaultOptionLabelPlaceholder')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSourceDefault.default), {
                        label: c('datasource')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expressionsDefault.default), {
                        label: c('datasourceExpressions'),
                        propertyName: "datasourceExpressions",
                        variableOptions: [
                            '$i.'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validationDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditionsDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/mask":"kcLv4","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/properties/boolean":"k2UVH","@form-engine/builder-mask/components/groups/appearance":"krT6N","@form-engine/builder-mask/components/properties/floating-label":"3xmdn","@form-engine/builder-mask/components/properties/label":"hDKxg","@form-engine/builder-mask/components/properties/data-source":"jEPUo","@form-engine/builder-mask/components/groups/validation":"jzCix","@form-engine/builder-mask/components/groups/conditions":"cw0Md","@form-engine/builder-mask/components/properties/expressions":"cByR7","../select-element":"5KuU4",".":"hOCw8","@form-engine/builder-mask/hooks/use-mask":"72MTY","@form-engine/builder-mask/components/properties/string":"e6M7S","@form-engine/builder-application":"7iKr0","@form-engine/builder-mask/components/properties/enum":"2kNfK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iDs8E":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"exP8b","./de.json":"4WfC1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"exP8b":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"FormEngineSelectElement":{"title":"Select"},"mask":{"FormEngineSelectElement":{"groupTitle":"Select","datasource":"Options","datasourceExpressions":"Options Filter","showError":"Show Error","showDefaultOption":"Show Default Option","defaultOptionLabel":"Default Option Label","defaultOptionLabelPlaceholder":"Select\u2026","searchable":"Searchable","placeholder":"Placeholder","controlType":"Appearance","controlTypes":{"native":"Native","advanced":"Advanced"}}}}');

},{}],"4WfC1":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"FormEngineSelectElement":{"title":"W\xe4hlen"},"mask":{"FormEngineSelectElement":{"groupTitle":"W\xe4hlen","datasource":"Optionen","datasourceExpressions":"Optionsfilter","showError":"Fehler anzeigen","showDefaultOption":"Standardoption anzeigen","defaultOptionLabel":"Bezeichnung der Standardoption","defaultOptionLabelPlaceholder":"W\xe4hlen\u2026","searchable":"Durchsuchbar","placeholder":"Platzhalter","controlType":"Darstellung","controlTypes":{"native":"Nativ","advanced":"Erweitert"}}}}');

},{}],"l16BS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _redirectWflMask = require("./components/redirect-wfl-mask");
var _redirectWflMaskDefault = parcelHelpers.interopDefault(_redirectWflMask);
var _redirect = require("./workflow-layers/redirect");
var _redirectDefault = parcelHelpers.interopDefault(_redirect);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    workflowLayers: {
        [(0, _redirectDefault.default).apiName]: {
            label: `${(0, _redirectDefault.default).apiName}.title`,
            description: `${(0, _redirectDefault.default).apiName}.description`,
            Icon: (0, _reactBootstrapIcons.Link),
            WorkflowLayer: (0, _redirectDefault.default),
            Mask: (0, _redirectWflMaskDefault.default)
        }
    }
};

},{"./components/redirect-wfl-mask":"fOGr2","./workflow-layers/redirect":"lL6q3","react-bootstrap-icons":"3TzoC","./builder-translations":"gYJq7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fOGr2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderRedirectWflSetup", ()=>BuilderRedirectWflSetup);
parcelHelpers.export(exports, "default", ()=>BuilderRedirectWflMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _wflBehaviour = require("@form-engine/builder-mask/components/groups/wfl-behaviour");
var _wflBehaviourDefault = parcelHelpers.interopDefault(_wflBehaviour);
var _string = require("@form-engine/builder-mask/components/properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _enum = require("@form-engine/builder-mask/components/properties/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _redirect = require("../workflow-layers/redirect");
var _redirectDefault = parcelHelpers.interopDefault(_redirect);
var _builderApplication = require("@form-engine/builder-application");
var _boolean = require("@form-engine/builder-mask/components/properties/boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
function BuilderRedirectWflSetup() {
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _redirectDefault.default).apiName}.`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wflBehaviourDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                label: c('groupTitle'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "url",
                        type: "url",
                        label: c('url'),
                        compilable: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "allowForeignOrigins",
                        label: c('allowForeignOrigins')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                        propertyName: "urlTarget",
                        label: c('urlTarget'),
                        defaultValue: "_self",
                        options: [
                            [
                                '_self',
                                'Self'
                            ],
                            [
                                '_blank',
                                'Blank'
                            ],
                            [
                                '_parent',
                                'Parent'
                            ],
                            [
                                '_top',
                                'Top'
                            ]
                        ]
                    })
                ]
            })
        ]
    });
}
function BuilderRedirectWflMask() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderRedirectWflSetup, {});
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/groups/wfl-behaviour":"3PqZm","@form-engine/builder-mask/components/properties/string":"e6M7S","@form-engine/builder-mask/components/properties/enum":"2kNfK","../workflow-layers/redirect":"lL6q3","@form-engine/builder-application":"7iKr0","@form-engine/builder-mask/components/properties/boolean":"k2UVH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3PqZm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderMaskGroupWflBehaviour);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _group = require("../mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _boolean = require("../properties/boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
var _string = require("../properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _name = require("../properties/name");
var _nameDefault = parcelHelpers.interopDefault(_name);
var _builderApplication = require("@form-engine/builder-application");
function BuilderMaskGroupWflBehaviour(// eslint-disable-next-line @typescript-eslint/no-unused-vars
_props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
            label: (0, _builderApplication.i18n).c('mask.wflBehaviourGroup.title'),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nameDefault.default), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                    propertyName: "description",
                    label: (0, _builderApplication.i18n).c('mask.wflBehaviourGroup.description')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                    propertyName: "enabled",
                    label: (0, _builderApplication.i18n).c('mask.wflBehaviourGroup.enabled')
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../mask/group":"1nZOW","../properties/boolean":"k2UVH","../properties/string":"e6M7S","../properties/name":"cCuUh","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gYJq7":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"1TWVP","./de.json":"luvOX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1TWVP":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineRedirectWfl\":{\"title\":\"Redirect\",\"description\":\"React to events by redirecting to a web page\"},\"mask\":{\"FormEngineRedirectWfl\":{\"description\":\"Description\",\"url\":\"Url\",\"urlTarget\":\"Url Target\",\"allowForeignOrigins\":\"Allow foreign Origins\"}}}");

},{}],"luvOX":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"FormEngineRedirectWfl":{"title":"Umleiten","description":"Reagieren Sie auf Ereignisse, indem Sie auf eine Webseite umleiten"},"mask":{"FormEngineRedirectWfl":{"description":"Beschreibung","url":"URL","urlTarget":"URL-Ziel","allowForeignOrigins":"Erlaube Fremd-Dom\xe4nen"}}}');

},{}],"kMdza":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _conditionWflMask = require("./components/condition-wfl-mask");
var _conditionWflMaskDefault = parcelHelpers.interopDefault(_conditionWflMask);
var _condition = require("./workflow-layers/condition");
var _conditionDefault = parcelHelpers.interopDefault(_condition);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _conditionWflNode = require("./components/condition-wfl-node");
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    workflowLayers: {
        [(0, _condition.apiName)]: {
            label: `${0, _condition.apiName}.title`,
            description: `${0, _condition.apiName}.description`,
            Icon: (0, _reactBootstrapIcons.DiamondHalf),
            WorkflowLayer: (0, _conditionDefault.default),
            Mask: (0, _conditionWflMaskDefault.default),
            Node: (0, _conditionWflNode.BuilderConditionWflNode)
        }
    }
};

},{"./components/condition-wfl-mask":"j6Qs0","./workflow-layers/condition":"5TQMg","react-bootstrap-icons":"3TzoC","./components/condition-wfl-node":"1bZ91","./builder-translations":"bV2OD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j6Qs0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderShowPageWflSetup", ()=>BuilderShowPageWflSetup);
parcelHelpers.export(exports, "default", ()=>BuilderShowPageWflMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _wflBehaviour = require("@form-engine/builder-mask/components/groups/wfl-behaviour");
var _wflBehaviourDefault = parcelHelpers.interopDefault(_wflBehaviour);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _expressions = require("@form-engine/builder-mask/components/properties/expressions");
var _expressionsDefault = parcelHelpers.interopDefault(_expressions);
var _builderApplication = require("@form-engine/builder-application");
var _condition = require("../workflow-layers/condition");
var _conditionDefault = parcelHelpers.interopDefault(_condition);
function BuilderShowPageWflSetup() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wflBehaviourDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupDefault.default), {
                label: (0, _builderApplication.i18n).c(`mask.${(0, _conditionDefault.default).apiName}.groupTitle`),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expressionsDefault.default), {})
            })
        ]
    });
}
function BuilderShowPageWflMask() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderShowPageWflSetup, {});
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/groups/wfl-behaviour":"3PqZm","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/properties/expressions":"cByR7","@form-engine/builder-application":"7iKr0","../workflow-layers/condition":"5TQMg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1bZ91":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderConditionWflNode", ()=>BuilderConditionWflNode);
var _jsxRuntime = require("react/jsx-runtime");
var _layerNode = require("@form-engine/builder-form-editor/components/workflow-editor/layer-node");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrapIcons = require("react-bootstrap-icons");
const BuilderConditionWflNode = /*#__PURE__*/ (0, _react.memo)(function BuilderConditionWflNode(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layerNode.BuilderWorkflowEditorLayerNode), {
        ...props,
        sources: {
            error: {
                icon: (0, _reactBootstrapIcons.XCircleFill)
            },
            success: {
                icon: (0, _reactBootstrapIcons.CheckCircleFill)
            }
        }
    });
});

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-form-editor/components/workflow-editor/layer-node":"kygrj","react":"9njXz","react-bootstrap-icons":"3TzoC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kygrj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderWorkflowEditorLayerNode", ()=>BuilderWorkflowEditorLayerNode);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactflow = require("reactflow");
const DEFAULT_TARGETS = {
    target: {
        handle: {
            position: (0, _reactflow.Position).Top
        }
    }
};
const DEFAULT_SOURCES = {
    success: {
        handle: {
            position: (0, _reactflow.Position).Bottom
        }
    }
};
function LayerNode({ id, data, selected, targets = DEFAULT_TARGETS, sources = DEFAULT_SOURCES }) {
    const targetEntries = Object.entries(targets ?? {});
    const sourceEntries = Object.entries(sources ?? {});
    const label = typeof data.label === 'function' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(data.label, {}) : data.label;
    const body = typeof data.body === 'function' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(data.body, {}) : data.body;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: `react-flow__node-default react-flow__node-default nopan ${selected ? 'selected' : ''} selectable`,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "layer-node__header",
                    children: label
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "layer-node__body",
                    children: [
                        body && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mb-2",
                            children: body
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "d-flex flex-row",
                            style: {
                                margin: '0 -11px 0 -11px'
                            },
                            children: targetEntries.map(([key, def], index)=>{
                                const { icon: Icon, title } = def;
                                const colWidth = 100 / targetEntries.length;
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "text-center",
                                    style: {
                                        width: `${colWidth}%`
                                    },
                                    ...def.wrapProps ?? {},
                                    children: [
                                        Icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                                            title: title
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactflow.Handle), {
                                            position: (0, _reactflow.Position).Top,
                                            ...def.handle ?? {},
                                            type: "target",
                                            id: `${id}@${key}`,
                                            style: {
                                                left: `${colWidth * index + colWidth * 0.5}%`
                                            }
                                        })
                                    ]
                                }, key);
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "d-flex flex-row",
                            style: {
                                margin: '0 -11px 0 -11px'
                            },
                            children: sourceEntries.map(([key, def], index)=>{
                                const { icon: Icon, title } = def;
                                const colWidth = 100 / sourceEntries.length;
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "text-center",
                                    style: {
                                        width: `${colWidth}%`
                                    },
                                    ...def.wrapProps ?? {},
                                    children: [
                                        Icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                                            title: title
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactflow.Handle), {
                                            position: (0, _reactflow.Position).Bottom,
                                            ...def.handle ?? {},
                                            type: "source",
                                            id: `${id}@${key}`,
                                            style: {
                                                left: `${colWidth * index + colWidth * 0.5}%`
                                            }
                                        })
                                    ]
                                }, key);
                            })
                        })
                    ]
                })
            ]
        })
    });
}
const BuilderWorkflowEditorLayerNode = /*#__PURE__*/ (0, _react.memo)(LayerNode);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","reactflow":"9KIiR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9KIiR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _core.ReactFlow));
var _core = require("@reactflow/core");
parcelHelpers.exportAll(_core, exports);
var _minimap = require("@reactflow/minimap");
parcelHelpers.exportAll(_minimap, exports);
var _controls = require("@reactflow/controls");
parcelHelpers.exportAll(_controls, exports);
var _background = require("@reactflow/background");
parcelHelpers.exportAll(_background, exports);
var _nodeToolbar = require("@reactflow/node-toolbar");
parcelHelpers.exportAll(_nodeToolbar, exports);
var _nodeResizer = require("@reactflow/node-resizer");
parcelHelpers.exportAll(_nodeResizer, exports);

},{"@reactflow/core":"3rgpy","@reactflow/minimap":"d9cb4","@reactflow/controls":"eTDWu","@reactflow/background":"6FeeA","@reactflow/node-toolbar":"jffgV","@reactflow/node-resizer":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3rgpy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseEdge", ()=>BaseEdge);
parcelHelpers.export(exports, "BezierEdge", ()=>BezierEdge);
parcelHelpers.export(exports, "ConnectionLineType", ()=>ConnectionLineType);
parcelHelpers.export(exports, "ConnectionMode", ()=>ConnectionMode);
parcelHelpers.export(exports, "EdgeLabelRenderer", ()=>EdgeLabelRenderer);
parcelHelpers.export(exports, "EdgeText", ()=>EdgeText$1);
parcelHelpers.export(exports, "Handle", ()=>Handle$1);
parcelHelpers.export(exports, "MarkerType", ()=>MarkerType);
parcelHelpers.export(exports, "PanOnScrollMode", ()=>PanOnScrollMode);
parcelHelpers.export(exports, "Panel", ()=>Panel);
parcelHelpers.export(exports, "Position", ()=>Position);
parcelHelpers.export(exports, "ReactFlow", ()=>ReactFlow);
parcelHelpers.export(exports, "ReactFlowProvider", ()=>ReactFlowProvider);
parcelHelpers.export(exports, "SelectionMode", ()=>SelectionMode);
parcelHelpers.export(exports, "SimpleBezierEdge", ()=>SimpleBezierEdge);
parcelHelpers.export(exports, "SmoothStepEdge", ()=>SmoothStepEdge);
parcelHelpers.export(exports, "StepEdge", ()=>StepEdge);
parcelHelpers.export(exports, "StraightEdge", ()=>StraightEdge);
parcelHelpers.export(exports, "addEdge", ()=>addEdge);
parcelHelpers.export(exports, "applyEdgeChanges", ()=>applyEdgeChanges);
parcelHelpers.export(exports, "applyNodeChanges", ()=>applyNodeChanges);
parcelHelpers.export(exports, "boxToRect", ()=>boxToRect);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "getBezierPath", ()=>getBezierPath);
parcelHelpers.export(exports, "getBoundsOfRects", ()=>getBoundsOfRects);
parcelHelpers.export(exports, "getConnectedEdges", ()=>getConnectedEdges);
parcelHelpers.export(exports, "getIncomers", ()=>getIncomers);
parcelHelpers.export(exports, "getMarkerEnd", ()=>getMarkerEnd);
parcelHelpers.export(exports, "getNodePositionWithOrigin", ()=>getNodePositionWithOrigin);
parcelHelpers.export(exports, "getNodesBounds", ()=>getNodesBounds);
parcelHelpers.export(exports, "getOutgoers", ()=>getOutgoers);
parcelHelpers.export(exports, "getRectOfNodes", ()=>getRectOfNodes);
parcelHelpers.export(exports, "getSimpleBezierPath", ()=>getSimpleBezierPath);
parcelHelpers.export(exports, "getSmoothStepPath", ()=>getSmoothStepPath);
parcelHelpers.export(exports, "getStraightPath", ()=>getStraightPath);
parcelHelpers.export(exports, "getTransformForBounds", ()=>getTransformForBounds);
parcelHelpers.export(exports, "getViewportForBounds", ()=>getViewportForBounds);
parcelHelpers.export(exports, "handleParentExpand", ()=>handleParentExpand);
parcelHelpers.export(exports, "internalsSymbol", ()=>internalsSymbol);
parcelHelpers.export(exports, "isEdge", ()=>isEdge);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "reconnectEdge", ()=>reconnectEdge);
parcelHelpers.export(exports, "rectToBox", ()=>rectToBox);
parcelHelpers.export(exports, "updateEdge", ()=>updateEdge);
parcelHelpers.export(exports, "useEdges", ()=>useEdges);
parcelHelpers.export(exports, "useEdgesState", ()=>useEdgesState);
parcelHelpers.export(exports, "useGetPointerPosition", ()=>useGetPointerPosition);
parcelHelpers.export(exports, "useKeyPress", ()=>useKeyPress);
parcelHelpers.export(exports, "useNodeId", ()=>useNodeId);
parcelHelpers.export(exports, "useNodes", ()=>useNodes);
parcelHelpers.export(exports, "useNodesInitialized", ()=>useNodesInitialized);
parcelHelpers.export(exports, "useNodesState", ()=>useNodesState);
parcelHelpers.export(exports, "useOnSelectionChange", ()=>useOnSelectionChange);
parcelHelpers.export(exports, "useOnViewportChange", ()=>useOnViewportChange);
parcelHelpers.export(exports, "useReactFlow", ()=>useReactFlow);
parcelHelpers.export(exports, "useStore", ()=>useStore);
parcelHelpers.export(exports, "useStoreApi", ()=>useStoreApi);
parcelHelpers.export(exports, "useUpdateNodeInternals", ()=>useUpdateNodeInternals);
parcelHelpers.export(exports, "useViewport", ()=>useViewport);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classcat = require("classcat");
var _classcatDefault = parcelHelpers.interopDefault(_classcat);
var _traditional = require("zustand/traditional");
var _shallow = require("zustand/shallow");
var _d3Zoom = require("d3-zoom");
var _d3Selection = require("d3-selection");
var _d3Drag = require("d3-drag");
var _reactDom = require("react-dom");
const StoreContext = (0, _react.createContext)(null);
const Provider$1 = StoreContext.Provider;
const errorMessages = {
    error001: ()=>'[React Flow]: Seems like you have not used zustand provider as an ancestor. Help: https://reactflow.dev/error#001',
    error002: ()=>"It looks like you've created a new nodeTypes or edgeTypes object. If this wasn't on purpose please define the nodeTypes/edgeTypes outside of the component or memoize them.",
    error003: (nodeType)=>`Node type "${nodeType}" not found. Using fallback type "default".`,
    error004: ()=>'The React Flow parent container needs a width and a height to render the graph.',
    error005: ()=>'Only child nodes can use a parent extent.',
    error006: ()=>"Can't create edge. An edge needs a source and a target.",
    error007: (id)=>`The old edge with id=${id} does not exist.`,
    error009: (type)=>`Marker type "${type}" doesn't exist.`,
    error008: (sourceHandle, edge)=>`Couldn't create edge for ${!sourceHandle ? 'source' : 'target'} handle id: "${!sourceHandle ? edge.sourceHandle : edge.targetHandle}", edge id: ${edge.id}.`,
    error010: ()=>'Handle: No node id found. Make sure to only use a Handle inside a custom Node.',
    error011: (edgeType)=>`Edge type "${edgeType}" not found. Using fallback type "default".`,
    error012: (id)=>`Node with id "${id}" does not exist, it may have been removed. This can happen when a node is deleted before the "onNodeClick" handler is called.`
};
const zustandErrorMessage = errorMessages['error001']();
function useStore(selector, equalityFn) {
    const store = (0, _react.useContext)(StoreContext);
    if (store === null) throw new Error(zustandErrorMessage);
    return (0, _traditional.useStoreWithEqualityFn)(store, selector, equalityFn);
}
const useStoreApi = ()=>{
    const store = (0, _react.useContext)(StoreContext);
    if (store === null) throw new Error(zustandErrorMessage);
    return (0, _react.useMemo)(()=>({
            getState: store.getState,
            setState: store.setState,
            subscribe: store.subscribe,
            destroy: store.destroy
        }), [
        store
    ]);
};
const selector$g = (s)=>s.userSelectionActive ? 'none' : 'all';
function Panel({ position, children, className, style, ...rest }) {
    const pointerEvents = useStore(selector$g);
    const positionClasses = `${position}`.split('-');
    return (0, _reactDefault.default).createElement("div", {
        className: (0, _classcatDefault.default)([
            'react-flow__panel',
            className,
            ...positionClasses
        ]),
        style: {
            ...style,
            pointerEvents
        },
        ...rest
    }, children);
}
function Attribution({ proOptions, position = 'bottom-right' }) {
    if (proOptions?.hideAttribution) return null;
    return (0, _reactDefault.default).createElement(Panel, {
        position: position,
        className: "react-flow__attribution",
        "data-message": "Please only hide this attribution when you are subscribed to React Flow Pro: https://reactflow.dev/pro"
    }, (0, _reactDefault.default).createElement("a", {
        href: "https://reactflow.dev",
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": "React Flow attribution"
    }, "React Flow"));
}
const EdgeText = ({ x, y, label, labelStyle = {}, labelShowBg = true, labelBgStyle = {}, labelBgPadding = [
    2,
    4
], labelBgBorderRadius = 2, children, className, ...rest })=>{
    const edgeRef = (0, _react.useRef)(null);
    const [edgeTextBbox, setEdgeTextBbox] = (0, _react.useState)({
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    const edgeTextClasses = (0, _classcatDefault.default)([
        'react-flow__edge-textwrapper',
        className
    ]);
    (0, _react.useEffect)(()=>{
        if (edgeRef.current) {
            const textBbox = edgeRef.current.getBBox();
            setEdgeTextBbox({
                x: textBbox.x,
                y: textBbox.y,
                width: textBbox.width,
                height: textBbox.height
            });
        }
    }, [
        label
    ]);
    if (typeof label === 'undefined' || !label) return null;
    return (0, _reactDefault.default).createElement("g", {
        transform: `translate(${x - edgeTextBbox.width / 2} ${y - edgeTextBbox.height / 2})`,
        className: edgeTextClasses,
        visibility: edgeTextBbox.width ? 'visible' : 'hidden',
        ...rest
    }, labelShowBg && (0, _reactDefault.default).createElement("rect", {
        width: edgeTextBbox.width + 2 * labelBgPadding[0],
        x: -labelBgPadding[0],
        y: -labelBgPadding[1],
        height: edgeTextBbox.height + 2 * labelBgPadding[1],
        className: "react-flow__edge-textbg",
        style: labelBgStyle,
        rx: labelBgBorderRadius,
        ry: labelBgBorderRadius
    }), (0, _reactDefault.default).createElement("text", {
        className: "react-flow__edge-text",
        y: edgeTextBbox.height / 2,
        dy: "0.3em",
        ref: edgeRef,
        style: labelStyle
    }, label), children);
};
var EdgeText$1 = (0, _react.memo)(EdgeText);
const getDimensions = (node)=>({
        width: node.offsetWidth,
        height: node.offsetHeight
    });
const clamp = (val, min = 0, max = 1)=>Math.min(Math.max(val, min), max);
const clampPosition = (position = {
    x: 0,
    y: 0
}, extent)=>({
        x: clamp(position.x, extent[0][0], extent[1][0]),
        y: clamp(position.y, extent[0][1], extent[1][1])
    });
// returns a number between 0 and 1 that represents the velocity of the movement
// when the mouse is close to the edge of the canvas
const calcAutoPanVelocity = (value, min, max)=>{
    if (value < min) return clamp(Math.abs(value - min), 1, 50) / 50;
    else if (value > max) return -clamp(Math.abs(value - max), 1, 50) / 50;
    return 0;
};
const calcAutoPan = (pos, bounds)=>{
    const xMovement = calcAutoPanVelocity(pos.x, 35, bounds.width - 35) * 20;
    const yMovement = calcAutoPanVelocity(pos.y, 35, bounds.height - 35) * 20;
    return [
        xMovement,
        yMovement
    ];
};
const getHostForElement = (element)=>element.getRootNode?.() || window?.document;
const getBoundsOfBoxes = (box1, box2)=>({
        x: Math.min(box1.x, box2.x),
        y: Math.min(box1.y, box2.y),
        x2: Math.max(box1.x2, box2.x2),
        y2: Math.max(box1.y2, box2.y2)
    });
const rectToBox = ({ x, y, width, height })=>({
        x,
        y,
        x2: x + width,
        y2: y + height
    });
const boxToRect = ({ x, y, x2, y2 })=>({
        x,
        y,
        width: x2 - x,
        height: y2 - y
    });
const nodeToRect = (node)=>({
        ...node.positionAbsolute || {
            x: 0,
            y: 0
        },
        width: node.width || 0,
        height: node.height || 0
    });
const getBoundsOfRects = (rect1, rect2)=>boxToRect(getBoundsOfBoxes(rectToBox(rect1), rectToBox(rect2)));
const getOverlappingArea = (rectA, rectB)=>{
    const xOverlap = Math.max(0, Math.min(rectA.x + rectA.width, rectB.x + rectB.width) - Math.max(rectA.x, rectB.x));
    const yOverlap = Math.max(0, Math.min(rectA.y + rectA.height, rectB.y + rectB.height) - Math.max(rectA.y, rectB.y));
    return Math.ceil(xOverlap * yOverlap);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isRectObject = (obj)=>isNumeric(obj.width) && isNumeric(obj.height) && isNumeric(obj.x) && isNumeric(obj.y);
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */ const isNumeric = (n)=>!isNaN(n) && isFinite(n);
const internalsSymbol = Symbol.for('internals');
// used for a11y key board controls for nodes and edges
const elementSelectionKeys = [
    'Enter',
    ' ',
    'Escape'
];
const devWarn = (id, message)=>{};
const isReactKeyboardEvent = (event)=>'nativeEvent' in event;
function isInputDOMNode(event) {
    const kbEvent = isReactKeyboardEvent(event) ? event.nativeEvent : event;
    // using composed path for handling shadow dom
    const target = kbEvent.composedPath?.()?.[0] || event.target;
    const isInput = [
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ].includes(target?.nodeName) || target?.hasAttribute('contenteditable');
    // when an input field is focused we don't want to trigger deletion or movement of nodes
    return isInput || !!target?.closest('.nokey');
}
const isMouseEvent = (event)=>'clientX' in event;
const getEventPosition = (event, bounds)=>{
    const isMouseTriggered = isMouseEvent(event);
    const evtX = isMouseTriggered ? event.clientX : event.touches?.[0].clientX;
    const evtY = isMouseTriggered ? event.clientY : event.touches?.[0].clientY;
    return {
        x: evtX - (bounds?.left ?? 0),
        y: evtY - (bounds?.top ?? 0)
    };
};
const isMacOs = ()=>typeof navigator !== 'undefined' && navigator?.userAgent?.indexOf('Mac') >= 0;
const BaseEdge = ({ id, path, labelX, labelY, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, markerEnd, markerStart, interactionWidth = 20 })=>{
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        id: id,
        style: style,
        d: path,
        fill: "none",
        className: "react-flow__edge-path",
        markerEnd: markerEnd,
        markerStart: markerStart
    }), interactionWidth && (0, _reactDefault.default).createElement("path", {
        d: path,
        fill: "none",
        strokeOpacity: 0,
        strokeWidth: interactionWidth,
        className: "react-flow__edge-interaction"
    }), label && isNumeric(labelX) && isNumeric(labelY) ? (0, _reactDefault.default).createElement(EdgeText$1, {
        x: labelX,
        y: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius
    }) : null);
};
BaseEdge.displayName = 'BaseEdge';
const getMarkerEnd = (markerType, markerEndId)=>{
    if (typeof markerEndId !== 'undefined' && markerEndId) return `url(#${markerEndId})`;
    return typeof markerType !== 'undefined' ? `url(#react-flow__${markerType})` : 'none';
};
function getMouseHandler$1(id, getState, handler) {
    return handler === undefined ? handler : (event)=>{
        const edge = getState().edges.find((e)=>e.id === id);
        if (edge) handler(event, {
            ...edge
        });
    };
}
// this is used for straight edges and simple smoothstep edges (LTR, RTL, BTT, TTB)
function getEdgeCenter({ sourceX, sourceY, targetX, targetY }) {
    const xOffset = Math.abs(targetX - sourceX) / 2;
    const centerX = targetX < sourceX ? targetX + xOffset : targetX - xOffset;
    const yOffset = Math.abs(targetY - sourceY) / 2;
    const centerY = targetY < sourceY ? targetY + yOffset : targetY - yOffset;
    return [
        centerX,
        centerY,
        xOffset,
        yOffset
    ];
}
function getBezierEdgeCenter({ sourceX, sourceY, targetX, targetY, sourceControlX, sourceControlY, targetControlX, targetControlY }) {
    // cubic bezier t=0.5 mid point, not the actual mid point, but easy to calculate
    // https://stackoverflow.com/questions/67516101/how-to-find-distance-mid-point-of-bezier-curve
    const centerX = sourceX * 0.125 + sourceControlX * 0.375 + targetControlX * 0.375 + targetX * 0.125;
    const centerY = sourceY * 0.125 + sourceControlY * 0.375 + targetControlY * 0.375 + targetY * 0.125;
    const offsetX = Math.abs(centerX - sourceX);
    const offsetY = Math.abs(centerY - sourceY);
    return [
        centerX,
        centerY,
        offsetX,
        offsetY
    ];
}
var ConnectionMode;
(function(ConnectionMode) {
    ConnectionMode["Strict"] = "strict";
    ConnectionMode["Loose"] = "loose";
})(ConnectionMode || (ConnectionMode = {}));
var PanOnScrollMode;
(function(PanOnScrollMode) {
    PanOnScrollMode["Free"] = "free";
    PanOnScrollMode["Vertical"] = "vertical";
    PanOnScrollMode["Horizontal"] = "horizontal";
})(PanOnScrollMode || (PanOnScrollMode = {}));
var SelectionMode;
(function(SelectionMode) {
    SelectionMode["Partial"] = "partial";
    SelectionMode["Full"] = "full";
})(SelectionMode || (SelectionMode = {}));
var ConnectionLineType;
(function(ConnectionLineType) {
    ConnectionLineType["Bezier"] = "default";
    ConnectionLineType["Straight"] = "straight";
    ConnectionLineType["Step"] = "step";
    ConnectionLineType["SmoothStep"] = "smoothstep";
    ConnectionLineType["SimpleBezier"] = "simplebezier";
})(ConnectionLineType || (ConnectionLineType = {}));
var MarkerType;
(function(MarkerType) {
    MarkerType["Arrow"] = "arrow";
    MarkerType["ArrowClosed"] = "arrowclosed";
})(MarkerType || (MarkerType = {}));
var Position;
(function(Position) {
    Position["Left"] = "left";
    Position["Top"] = "top";
    Position["Right"] = "right";
    Position["Bottom"] = "bottom";
})(Position || (Position = {}));
function getControl({ pos, x1, y1, x2, y2 }) {
    if (pos === Position.Left || pos === Position.Right) return [
        0.5 * (x1 + x2),
        y1
    ];
    return [
        x1,
        0.5 * (y1 + y2)
    ];
}
function getSimpleBezierPath({ sourceX, sourceY, sourcePosition = Position.Bottom, targetX, targetY, targetPosition = Position.Top }) {
    const [sourceControlX, sourceControlY] = getControl({
        pos: sourcePosition,
        x1: sourceX,
        y1: sourceY,
        x2: targetX,
        y2: targetY
    });
    const [targetControlX, targetControlY] = getControl({
        pos: targetPosition,
        x1: targetX,
        y1: targetY,
        x2: sourceX,
        y2: sourceY
    });
    const [labelX, labelY, offsetX, offsetY] = getBezierEdgeCenter({
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourceControlX,
        sourceControlY,
        targetControlX,
        targetControlY
    });
    return [
        `M${sourceX},${sourceY} C${sourceControlX},${sourceControlY} ${targetControlX},${targetControlY} ${targetX},${targetY}`,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const SimpleBezierEdge = (0, _react.memo)(({ sourceX, sourceY, targetX, targetY, sourcePosition = Position.Bottom, targetPosition = Position.Top, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, markerEnd, markerStart, interactionWidth })=>{
    const [path, labelX, labelY] = getSimpleBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition
    });
    return (0, _reactDefault.default).createElement(BaseEdge, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
SimpleBezierEdge.displayName = 'SimpleBezierEdge';
const handleDirections = {
    [Position.Left]: {
        x: -1,
        y: 0
    },
    [Position.Right]: {
        x: 1,
        y: 0
    },
    [Position.Top]: {
        x: 0,
        y: -1
    },
    [Position.Bottom]: {
        x: 0,
        y: 1
    }
};
const getDirection = ({ source, sourcePosition = Position.Bottom, target })=>{
    if (sourcePosition === Position.Left || sourcePosition === Position.Right) return source.x < target.x ? {
        x: 1,
        y: 0
    } : {
        x: -1,
        y: 0
    };
    return source.y < target.y ? {
        x: 0,
        y: 1
    } : {
        x: 0,
        y: -1
    };
};
const distance = (a, b)=>Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
// ith this function we try to mimic a orthogonal edge routing behaviour
// It's not as good as a real orthogonal edge routing but it's faster and good enough as a default for step and smooth step edges
function getPoints({ source, sourcePosition = Position.Bottom, target, targetPosition = Position.Top, center, offset }) {
    const sourceDir = handleDirections[sourcePosition];
    const targetDir = handleDirections[targetPosition];
    const sourceGapped = {
        x: source.x + sourceDir.x * offset,
        y: source.y + sourceDir.y * offset
    };
    const targetGapped = {
        x: target.x + targetDir.x * offset,
        y: target.y + targetDir.y * offset
    };
    const dir = getDirection({
        source: sourceGapped,
        sourcePosition,
        target: targetGapped
    });
    const dirAccessor = dir.x !== 0 ? 'x' : 'y';
    const currDir = dir[dirAccessor];
    let points = [];
    let centerX, centerY;
    const sourceGapOffset = {
        x: 0,
        y: 0
    };
    const targetGapOffset = {
        x: 0,
        y: 0
    };
    const [defaultCenterX, defaultCenterY, defaultOffsetX, defaultOffsetY] = getEdgeCenter({
        sourceX: source.x,
        sourceY: source.y,
        targetX: target.x,
        targetY: target.y
    });
    // opposite handle positions, default case
    if (sourceDir[dirAccessor] * targetDir[dirAccessor] === -1) {
        centerX = center.x ?? defaultCenterX;
        centerY = center.y ?? defaultCenterY;
        //    --->
        //    |
        // >---
        const verticalSplit = [
            {
                x: centerX,
                y: sourceGapped.y
            },
            {
                x: centerX,
                y: targetGapped.y
            }
        ];
        //    |
        //  ---
        //  |
        const horizontalSplit = [
            {
                x: sourceGapped.x,
                y: centerY
            },
            {
                x: targetGapped.x,
                y: centerY
            }
        ];
        if (sourceDir[dirAccessor] === currDir) points = dirAccessor === 'x' ? verticalSplit : horizontalSplit;
        else points = dirAccessor === 'x' ? horizontalSplit : verticalSplit;
    } else {
        // sourceTarget means we take x from source and y from target, targetSource is the opposite
        const sourceTarget = [
            {
                x: sourceGapped.x,
                y: targetGapped.y
            }
        ];
        const targetSource = [
            {
                x: targetGapped.x,
                y: sourceGapped.y
            }
        ];
        // this handles edges with same handle positions
        if (dirAccessor === 'x') points = sourceDir.x === currDir ? targetSource : sourceTarget;
        else points = sourceDir.y === currDir ? sourceTarget : targetSource;
        if (sourcePosition === targetPosition) {
            const diff = Math.abs(source[dirAccessor] - target[dirAccessor]);
            // if an edge goes from right to right for example (sourcePosition === targetPosition) and the distance between source.x and target.x is less than the offset, the added point and the gapped source/target will overlap. This leads to a weird edge path. To avoid this we add a gapOffset to the source/target
            if (diff <= offset) {
                const gapOffset = Math.min(offset - 1, offset - diff);
                if (sourceDir[dirAccessor] === currDir) sourceGapOffset[dirAccessor] = (sourceGapped[dirAccessor] > source[dirAccessor] ? -1 : 1) * gapOffset;
                else targetGapOffset[dirAccessor] = (targetGapped[dirAccessor] > target[dirAccessor] ? -1 : 1) * gapOffset;
            }
        }
        // these are conditions for handling mixed handle positions like Right -> Bottom for example
        if (sourcePosition !== targetPosition) {
            const dirAccessorOpposite = dirAccessor === 'x' ? 'y' : 'x';
            const isSameDir = sourceDir[dirAccessor] === targetDir[dirAccessorOpposite];
            const sourceGtTargetOppo = sourceGapped[dirAccessorOpposite] > targetGapped[dirAccessorOpposite];
            const sourceLtTargetOppo = sourceGapped[dirAccessorOpposite] < targetGapped[dirAccessorOpposite];
            const flipSourceTarget = sourceDir[dirAccessor] === 1 && (!isSameDir && sourceGtTargetOppo || isSameDir && sourceLtTargetOppo) || sourceDir[dirAccessor] !== 1 && (!isSameDir && sourceLtTargetOppo || isSameDir && sourceGtTargetOppo);
            if (flipSourceTarget) points = dirAccessor === 'x' ? sourceTarget : targetSource;
        }
        const sourceGapPoint = {
            x: sourceGapped.x + sourceGapOffset.x,
            y: sourceGapped.y + sourceGapOffset.y
        };
        const targetGapPoint = {
            x: targetGapped.x + targetGapOffset.x,
            y: targetGapped.y + targetGapOffset.y
        };
        const maxXDistance = Math.max(Math.abs(sourceGapPoint.x - points[0].x), Math.abs(targetGapPoint.x - points[0].x));
        const maxYDistance = Math.max(Math.abs(sourceGapPoint.y - points[0].y), Math.abs(targetGapPoint.y - points[0].y));
        // we want to place the label on the longest segment of the edge
        if (maxXDistance >= maxYDistance) {
            centerX = (sourceGapPoint.x + targetGapPoint.x) / 2;
            centerY = points[0].y;
        } else {
            centerX = points[0].x;
            centerY = (sourceGapPoint.y + targetGapPoint.y) / 2;
        }
    }
    const pathPoints = [
        source,
        {
            x: sourceGapped.x + sourceGapOffset.x,
            y: sourceGapped.y + sourceGapOffset.y
        },
        ...points,
        {
            x: targetGapped.x + targetGapOffset.x,
            y: targetGapped.y + targetGapOffset.y
        },
        target
    ];
    return [
        pathPoints,
        centerX,
        centerY,
        defaultOffsetX,
        defaultOffsetY
    ];
}
function getBend(a, b, c, size) {
    const bendSize = Math.min(distance(a, b) / 2, distance(b, c) / 2, size);
    const { x, y } = b;
    // no bend
    if (a.x === x && x === c.x || a.y === y && y === c.y) return `L${x} ${y}`;
    // first segment is horizontal
    if (a.y === y) {
        const xDir = a.x < c.x ? -1 : 1;
        const yDir = a.y < c.y ? 1 : -1;
        return `L ${x + bendSize * xDir},${y}Q ${x},${y} ${x},${y + bendSize * yDir}`;
    }
    const xDir = a.x < c.x ? 1 : -1;
    const yDir = a.y < c.y ? -1 : 1;
    return `L ${x},${y + bendSize * yDir}Q ${x},${y} ${x + bendSize * xDir},${y}`;
}
function getSmoothStepPath({ sourceX, sourceY, sourcePosition = Position.Bottom, targetX, targetY, targetPosition = Position.Top, borderRadius = 5, centerX, centerY, offset = 20 }) {
    const [points, labelX, labelY, offsetX, offsetY] = getPoints({
        source: {
            x: sourceX,
            y: sourceY
        },
        sourcePosition,
        target: {
            x: targetX,
            y: targetY
        },
        targetPosition,
        center: {
            x: centerX,
            y: centerY
        },
        offset
    });
    const path = points.reduce((res, p, i)=>{
        let segment = '';
        if (i > 0 && i < points.length - 1) segment = getBend(points[i - 1], p, points[i + 1], borderRadius);
        else segment = `${i === 0 ? 'M' : 'L'}${p.x} ${p.y}`;
        res += segment;
        return res;
    }, '');
    return [
        path,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const SmoothStepEdge = (0, _react.memo)(({ sourceX, sourceY, targetX, targetY, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, sourcePosition = Position.Bottom, targetPosition = Position.Top, markerEnd, markerStart, pathOptions, interactionWidth })=>{
    const [path, labelX, labelY] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
        borderRadius: pathOptions?.borderRadius,
        offset: pathOptions?.offset
    });
    return (0, _reactDefault.default).createElement(BaseEdge, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
SmoothStepEdge.displayName = 'SmoothStepEdge';
const StepEdge = (0, _react.memo)((props)=>(0, _reactDefault.default).createElement(SmoothStepEdge, {
        ...props,
        pathOptions: (0, _react.useMemo)(()=>({
                borderRadius: 0,
                offset: props.pathOptions?.offset
            }), [
            props.pathOptions?.offset
        ])
    }));
StepEdge.displayName = 'StepEdge';
function getStraightPath({ sourceX, sourceY, targetX, targetY }) {
    const [labelX, labelY, offsetX, offsetY] = getEdgeCenter({
        sourceX,
        sourceY,
        targetX,
        targetY
    });
    return [
        `M ${sourceX},${sourceY}L ${targetX},${targetY}`,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const StraightEdge = (0, _react.memo)(({ sourceX, sourceY, targetX, targetY, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, markerEnd, markerStart, interactionWidth })=>{
    const [path, labelX, labelY] = getStraightPath({
        sourceX,
        sourceY,
        targetX,
        targetY
    });
    return (0, _reactDefault.default).createElement(BaseEdge, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
StraightEdge.displayName = 'StraightEdge';
function calculateControlOffset(distance, curvature) {
    if (distance >= 0) return 0.5 * distance;
    return curvature * 25 * Math.sqrt(-distance);
}
function getControlWithCurvature({ pos, x1, y1, x2, y2, c }) {
    switch(pos){
        case Position.Left:
            return [
                x1 - calculateControlOffset(x1 - x2, c),
                y1
            ];
        case Position.Right:
            return [
                x1 + calculateControlOffset(x2 - x1, c),
                y1
            ];
        case Position.Top:
            return [
                x1,
                y1 - calculateControlOffset(y1 - y2, c)
            ];
        case Position.Bottom:
            return [
                x1,
                y1 + calculateControlOffset(y2 - y1, c)
            ];
    }
}
function getBezierPath({ sourceX, sourceY, sourcePosition = Position.Bottom, targetX, targetY, targetPosition = Position.Top, curvature = 0.25 }) {
    const [sourceControlX, sourceControlY] = getControlWithCurvature({
        pos: sourcePosition,
        x1: sourceX,
        y1: sourceY,
        x2: targetX,
        y2: targetY,
        c: curvature
    });
    const [targetControlX, targetControlY] = getControlWithCurvature({
        pos: targetPosition,
        x1: targetX,
        y1: targetY,
        x2: sourceX,
        y2: sourceY,
        c: curvature
    });
    const [labelX, labelY, offsetX, offsetY] = getBezierEdgeCenter({
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourceControlX,
        sourceControlY,
        targetControlX,
        targetControlY
    });
    return [
        `M${sourceX},${sourceY} C${sourceControlX},${sourceControlY} ${targetControlX},${targetControlY} ${targetX},${targetY}`,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const BezierEdge = (0, _react.memo)(({ sourceX, sourceY, targetX, targetY, sourcePosition = Position.Bottom, targetPosition = Position.Top, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, markerEnd, markerStart, pathOptions, interactionWidth })=>{
    const [path, labelX, labelY] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
        curvature: pathOptions?.curvature
    });
    return (0, _reactDefault.default).createElement(BaseEdge, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
BezierEdge.displayName = 'BezierEdge';
const NodeIdContext = (0, _react.createContext)(null);
const Provider = NodeIdContext.Provider;
NodeIdContext.Consumer;
const useNodeId = ()=>{
    const nodeId = (0, _react.useContext)(NodeIdContext);
    return nodeId;
};
const isEdge = (element)=>'id' in element && 'source' in element && 'target' in element;
const isNode = (element)=>'id' in element && !('source' in element) && !('target' in element);
const getOutgoers = (node, nodes, edges)=>{
    if (!isNode(node)) return [];
    const outgoerIds = edges.filter((e)=>e.source === node.id).map((e)=>e.target);
    return nodes.filter((n)=>outgoerIds.includes(n.id));
};
const getIncomers = (node, nodes, edges)=>{
    if (!isNode(node)) return [];
    const incomersIds = edges.filter((e)=>e.target === node.id).map((e)=>e.source);
    return nodes.filter((n)=>incomersIds.includes(n.id));
};
const getEdgeId = ({ source, sourceHandle, target, targetHandle })=>`reactflow__edge-${source}${sourceHandle || ''}-${target}${targetHandle || ''}`;
const getMarkerId = (marker, rfId)=>{
    if (typeof marker === 'undefined') return '';
    if (typeof marker === 'string') return marker;
    const idPrefix = rfId ? `${rfId}__` : '';
    return `${idPrefix}${Object.keys(marker).sort().map((key)=>`${key}=${marker[key]}`).join('&')}`;
};
const connectionExists = (edge, edges)=>{
    return edges.some((el)=>el.source === edge.source && el.target === edge.target && (el.sourceHandle === edge.sourceHandle || !el.sourceHandle && !edge.sourceHandle) && (el.targetHandle === edge.targetHandle || !el.targetHandle && !edge.targetHandle));
};
const addEdge = (edgeParams, edges)=>{
    if (!edgeParams.source || !edgeParams.target) {
        devWarn('006', errorMessages['error006']());
        return edges;
    }
    let edge;
    if (isEdge(edgeParams)) edge = {
        ...edgeParams
    };
    else edge = {
        ...edgeParams,
        id: getEdgeId(edgeParams)
    };
    if (connectionExists(edge, edges)) return edges;
    return edges.concat(edge);
};
const reconnectEdge = (oldEdge, newConnection, edges, options = {
    shouldReplaceId: true
})=>{
    const { id: oldEdgeId, ...rest } = oldEdge;
    if (!newConnection.source || !newConnection.target) {
        devWarn('006', errorMessages['error006']());
        return edges;
    }
    const foundEdge = edges.find((e)=>e.id === oldEdgeId);
    if (!foundEdge) {
        devWarn('007', errorMessages['error007'](oldEdgeId));
        return edges;
    }
    // Remove old edge and create the new edge with parameters of old edge.
    const edge = {
        ...rest,
        id: options.shouldReplaceId ? getEdgeId(newConnection) : oldEdgeId,
        source: newConnection.source,
        target: newConnection.target,
        sourceHandle: newConnection.sourceHandle,
        targetHandle: newConnection.targetHandle
    };
    return edges.filter((e)=>e.id !== oldEdgeId).concat(edge);
};
/**
 *
 * @deprecated Use `reconnectEdge` instead.
 */ const updateEdge = (oldEdge, newConnection, edges, options = {
    shouldReplaceId: true
})=>{
    console.warn('[DEPRECATED] `updateEdge` is deprecated. Instead use `reconnectEdge` https://reactflow.dev/api-reference/utils/reconnect-edge');
    return reconnectEdge(oldEdge, newConnection, edges, options);
};
const pointToRendererPoint = ({ x, y }, [tx, ty, tScale], snapToGrid, [snapX, snapY])=>{
    const position = {
        x: (x - tx) / tScale,
        y: (y - ty) / tScale
    };
    if (snapToGrid) return {
        x: snapX * Math.round(position.x / snapX),
        y: snapY * Math.round(position.y / snapY)
    };
    return position;
};
const rendererPointToPoint = ({ x, y }, [tx, ty, tScale])=>{
    return {
        x: x * tScale + tx,
        y: y * tScale + ty
    };
};
const getNodePositionWithOrigin = (node, nodeOrigin = [
    0,
    0
])=>{
    if (!node) return {
        x: 0,
        y: 0,
        positionAbsolute: {
            x: 0,
            y: 0
        }
    };
    const offsetX = (node.width ?? 0) * nodeOrigin[0];
    const offsetY = (node.height ?? 0) * nodeOrigin[1];
    const position = {
        x: node.position.x - offsetX,
        y: node.position.y - offsetY
    };
    return {
        ...position,
        positionAbsolute: node.positionAbsolute ? {
            x: node.positionAbsolute.x - offsetX,
            y: node.positionAbsolute.y - offsetY
        } : position
    };
};
const getNodesBounds = (nodes, nodeOrigin = [
    0,
    0
])=>{
    if (nodes.length === 0) return {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    };
    const box = nodes.reduce((currBox, node)=>{
        const { x, y } = getNodePositionWithOrigin(node, nodeOrigin).positionAbsolute;
        return getBoundsOfBoxes(currBox, rectToBox({
            x,
            y,
            width: node.width || 0,
            height: node.height || 0
        }));
    }, {
        x: Infinity,
        y: Infinity,
        x2: -Infinity,
        y2: -Infinity
    });
    return boxToRect(box);
};
// @deprecated Use `getNodesBounds`.
const getRectOfNodes = (nodes, nodeOrigin = [
    0,
    0
])=>{
    console.warn('[DEPRECATED] `getRectOfNodes` is deprecated. Instead use `getNodesBounds` https://reactflow.dev/api-reference/utils/get-nodes-bounds.');
    return getNodesBounds(nodes, nodeOrigin);
};
const getNodesInside = (nodeInternals, rect, [tx, ty, tScale] = [
    0,
    0,
    1
], partially = false, // set excludeNonSelectableNodes if you want to pay attention to the nodes "selectable" attribute
excludeNonSelectableNodes = false, nodeOrigin = [
    0,
    0
])=>{
    const paneRect = {
        x: (rect.x - tx) / tScale,
        y: (rect.y - ty) / tScale,
        width: rect.width / tScale,
        height: rect.height / tScale
    };
    const visibleNodes = [];
    nodeInternals.forEach((node)=>{
        const { width, height, selectable = true, hidden = false } = node;
        if (excludeNonSelectableNodes && !selectable || hidden) return false;
        const { positionAbsolute } = getNodePositionWithOrigin(node, nodeOrigin);
        const nodeRect = {
            x: positionAbsolute.x,
            y: positionAbsolute.y,
            width: width || 0,
            height: height || 0
        };
        const overlappingArea = getOverlappingArea(paneRect, nodeRect);
        const notInitialized = typeof width === 'undefined' || typeof height === 'undefined' || width === null || height === null;
        const partiallyVisible = partially && overlappingArea > 0;
        const area = (width || 0) * (height || 0);
        const isVisible = notInitialized || partiallyVisible || overlappingArea >= area;
        if (isVisible || node.dragging) visibleNodes.push(node);
    });
    return visibleNodes;
};
const getConnectedEdges = (nodes, edges)=>{
    const nodeIds = nodes.map((node)=>node.id);
    return edges.filter((edge)=>nodeIds.includes(edge.source) || nodeIds.includes(edge.target));
};
// @deprecated Use `getViewportForBounds`.
const getTransformForBounds = (bounds, width, height, minZoom, maxZoom, padding = 0.1)=>{
    const { x, y, zoom } = getViewportForBounds(bounds, width, height, minZoom, maxZoom, padding);
    console.warn('[DEPRECATED] `getTransformForBounds` is deprecated. Instead use `getViewportForBounds`. Beware that the return value is type Viewport (`{ x: number, y: number, zoom: number }`) instead of Transform (`[number, number, number]`). https://reactflow.dev/api-reference/utils/get-viewport-for-bounds');
    return [
        x,
        y,
        zoom
    ];
};
const getViewportForBounds = (bounds, width, height, minZoom, maxZoom, padding = 0.1)=>{
    const xZoom = width / (bounds.width * (1 + padding));
    const yZoom = height / (bounds.height * (1 + padding));
    const zoom = Math.min(xZoom, yZoom);
    const clampedZoom = clamp(zoom, minZoom, maxZoom);
    const boundsCenterX = bounds.x + bounds.width / 2;
    const boundsCenterY = bounds.y + bounds.height / 2;
    const x = width / 2 - boundsCenterX * clampedZoom;
    const y = height / 2 - boundsCenterY * clampedZoom;
    return {
        x,
        y,
        zoom: clampedZoom
    };
};
const getD3Transition = (selection, duration = 0)=>{
    return selection.transition().duration(duration);
};
// this functions collects all handles and adds an absolute position
// so that we can later find the closest handle to the mouse position
function getHandles(node, handleBounds, type, currentHandle) {
    return (handleBounds[type] || []).reduce((res, h)=>{
        if (`${node.id}-${h.id}-${type}` !== currentHandle) res.push({
            id: h.id || null,
            type,
            nodeId: node.id,
            x: (node.positionAbsolute?.x ?? 0) + h.x + h.width / 2,
            y: (node.positionAbsolute?.y ?? 0) + h.y + h.height / 2
        });
        return res;
    }, []);
}
function getClosestHandle(event, doc, pos, connectionRadius, handles, validator) {
    // we always want to prioritize the handle below the mouse cursor over the closest distance handle,
    // because it could be that the center of another handle is closer to the mouse pointer than the handle below the cursor
    const { x, y } = getEventPosition(event);
    const domNodes = doc.elementsFromPoint(x, y);
    const handleBelow = domNodes.find((el)=>el.classList.contains('react-flow__handle'));
    if (handleBelow) {
        const handleNodeId = handleBelow.getAttribute('data-nodeid');
        if (handleNodeId) {
            const handleType = getHandleType(undefined, handleBelow);
            const handleId = handleBelow.getAttribute('data-handleid');
            const validHandleResult = validator({
                nodeId: handleNodeId,
                id: handleId,
                type: handleType
            });
            if (validHandleResult) {
                const handle = handles.find((h)=>h.nodeId === handleNodeId && h.type === handleType && h.id === handleId);
                return {
                    handle: {
                        id: handleId,
                        type: handleType,
                        nodeId: handleNodeId,
                        x: handle?.x || pos.x,
                        y: handle?.y || pos.y
                    },
                    validHandleResult
                };
            }
        }
    }
    // if we couldn't find a handle below the mouse cursor we look for the closest distance based on the connectionRadius
    let closestHandles = [];
    let minDistance = Infinity;
    handles.forEach((handle)=>{
        const distance = Math.sqrt((handle.x - pos.x) ** 2 + (handle.y - pos.y) ** 2);
        if (distance <= connectionRadius) {
            const validHandleResult = validator(handle);
            if (distance <= minDistance) {
                if (distance < minDistance) closestHandles = [
                    {
                        handle,
                        validHandleResult
                    }
                ];
                else if (distance === minDistance) // when multiple handles are on the same distance we collect all of them
                closestHandles.push({
                    handle,
                    validHandleResult
                });
                minDistance = distance;
            }
        }
    });
    if (!closestHandles.length) return {
        handle: null,
        validHandleResult: defaultResult()
    };
    if (closestHandles.length === 1) return closestHandles[0];
    const hasValidHandle = closestHandles.some(({ validHandleResult })=>validHandleResult.isValid);
    const hasTargetHandle = closestHandles.some(({ handle })=>handle.type === 'target');
    // if multiple handles are layouted on top of each other we prefer the one with type = target and the one that is valid
    return closestHandles.find(({ handle, validHandleResult })=>hasTargetHandle ? handle.type === 'target' : hasValidHandle ? validHandleResult.isValid : true) || closestHandles[0];
}
const nullConnection = {
    source: null,
    target: null,
    sourceHandle: null,
    targetHandle: null
};
const defaultResult = ()=>({
        handleDomNode: null,
        isValid: false,
        connection: nullConnection,
        endHandle: null
    });
// checks if  and returns connection in fom of an object { source: 123, target: 312 }
function isValidHandle(handle, connectionMode, fromNodeId, fromHandleId, fromType, isValidConnection, doc) {
    const isTarget = fromType === 'target';
    const handleToCheck = doc.querySelector(`.react-flow__handle[data-id="${handle?.nodeId}-${handle?.id}-${handle?.type}"]`);
    const result = {
        ...defaultResult(),
        handleDomNode: handleToCheck
    };
    if (handleToCheck) {
        const handleType = getHandleType(undefined, handleToCheck);
        const handleNodeId = handleToCheck.getAttribute('data-nodeid');
        const handleId = handleToCheck.getAttribute('data-handleid');
        const connectable = handleToCheck.classList.contains('connectable');
        const connectableEnd = handleToCheck.classList.contains('connectableend');
        const connection = {
            source: isTarget ? handleNodeId : fromNodeId,
            sourceHandle: isTarget ? handleId : fromHandleId,
            target: isTarget ? fromNodeId : handleNodeId,
            targetHandle: isTarget ? fromHandleId : handleId
        };
        result.connection = connection;
        const isConnectable = connectable && connectableEnd;
        // in strict mode we don't allow target to target or source to source connections
        const isValid = isConnectable && (connectionMode === ConnectionMode.Strict ? isTarget && handleType === 'source' || !isTarget && handleType === 'target' : handleNodeId !== fromNodeId || handleId !== fromHandleId);
        if (isValid) {
            result.endHandle = {
                nodeId: handleNodeId,
                handleId,
                type: handleType
            };
            result.isValid = isValidConnection(connection);
        }
    }
    return result;
}
function getHandleLookup({ nodes, nodeId, handleId, handleType }) {
    return nodes.reduce((res, node)=>{
        if (node[internalsSymbol]) {
            const { handleBounds } = node[internalsSymbol];
            let sourceHandles = [];
            let targetHandles = [];
            if (handleBounds) {
                sourceHandles = getHandles(node, handleBounds, 'source', `${nodeId}-${handleId}-${handleType}`);
                targetHandles = getHandles(node, handleBounds, 'target', `${nodeId}-${handleId}-${handleType}`);
            }
            res.push(...sourceHandles, ...targetHandles);
        }
        return res;
    }, []);
}
function getHandleType(edgeUpdaterType, handleDomNode) {
    if (edgeUpdaterType) return edgeUpdaterType;
    else if (handleDomNode?.classList.contains('target')) return 'target';
    else if (handleDomNode?.classList.contains('source')) return 'source';
    return null;
}
function resetRecentHandle(handleDomNode) {
    handleDomNode?.classList.remove('valid', 'connecting', 'react-flow__handle-valid', 'react-flow__handle-connecting');
}
function getConnectionStatus(isInsideConnectionRadius, isHandleValid) {
    let connectionStatus = null;
    if (isHandleValid) connectionStatus = 'valid';
    else if (isInsideConnectionRadius && !isHandleValid) connectionStatus = 'invalid';
    return connectionStatus;
}
function handlePointerDown({ event, handleId, nodeId, onConnect, isTarget, getState, setState, isValidConnection, edgeUpdaterType, onReconnectEnd }) {
    // when react-flow is used inside a shadow root we can't use document
    const doc = getHostForElement(event.target);
    const { connectionMode, domNode, autoPanOnConnect, connectionRadius, onConnectStart, panBy, getNodes, cancelConnection } = getState();
    let autoPanId = 0;
    let closestHandle;
    const { x, y } = getEventPosition(event);
    const clickedHandle = doc?.elementFromPoint(x, y);
    const handleType = getHandleType(edgeUpdaterType, clickedHandle);
    const containerBounds = domNode?.getBoundingClientRect();
    if (!containerBounds || !handleType) return;
    let prevActiveHandle;
    let connectionPosition = getEventPosition(event, containerBounds);
    let autoPanStarted = false;
    let connection = null;
    let isValid = false;
    let handleDomNode = null;
    const handleLookup = getHandleLookup({
        nodes: getNodes(),
        nodeId,
        handleId,
        handleType
    });
    // when the user is moving the mouse close to the edge of the canvas while connecting we move the canvas
    const autoPan = ()=>{
        if (!autoPanOnConnect) return;
        const [xMovement, yMovement] = calcAutoPan(connectionPosition, containerBounds);
        panBy({
            x: xMovement,
            y: yMovement
        });
        autoPanId = requestAnimationFrame(autoPan);
    };
    setState({
        connectionPosition,
        connectionStatus: null,
        // connectionNodeId etc will be removed in the next major in favor of connectionStartHandle
        connectionNodeId: nodeId,
        connectionHandleId: handleId,
        connectionHandleType: handleType,
        connectionStartHandle: {
            nodeId,
            handleId,
            type: handleType
        },
        connectionEndHandle: null
    });
    onConnectStart?.(event, {
        nodeId,
        handleId,
        handleType
    });
    function onPointerMove(event) {
        const { transform } = getState();
        connectionPosition = getEventPosition(event, containerBounds);
        const { handle, validHandleResult } = getClosestHandle(event, doc, pointToRendererPoint(connectionPosition, transform, false, [
            1,
            1
        ]), connectionRadius, handleLookup, (handle)=>isValidHandle(handle, connectionMode, nodeId, handleId, isTarget ? 'target' : 'source', isValidConnection, doc));
        closestHandle = handle;
        if (!autoPanStarted) {
            autoPan();
            autoPanStarted = true;
        }
        handleDomNode = validHandleResult.handleDomNode;
        connection = validHandleResult.connection;
        isValid = validHandleResult.isValid;
        setState({
            connectionPosition: closestHandle && isValid ? rendererPointToPoint({
                x: closestHandle.x,
                y: closestHandle.y
            }, transform) : connectionPosition,
            connectionStatus: getConnectionStatus(!!closestHandle, isValid),
            connectionEndHandle: validHandleResult.endHandle
        });
        if (!closestHandle && !isValid && !handleDomNode) return resetRecentHandle(prevActiveHandle);
        if (connection.source !== connection.target && handleDomNode) {
            resetRecentHandle(prevActiveHandle);
            prevActiveHandle = handleDomNode;
            // @todo: remove the old class names "react-flow__handle-" in the next major version
            handleDomNode.classList.add('connecting', 'react-flow__handle-connecting');
            handleDomNode.classList.toggle('valid', isValid);
            handleDomNode.classList.toggle('react-flow__handle-valid', isValid);
        }
    }
    function onPointerUp(event) {
        if ((closestHandle || handleDomNode) && connection && isValid) onConnect?.(connection);
        // it's important to get a fresh reference from the store here
        // in order to get the latest state of onConnectEnd
        getState().onConnectEnd?.(event);
        if (edgeUpdaterType) onReconnectEnd?.(event);
        resetRecentHandle(prevActiveHandle);
        cancelConnection();
        cancelAnimationFrame(autoPanId);
        autoPanStarted = false;
        isValid = false;
        connection = null;
        handleDomNode = null;
        doc.removeEventListener('mousemove', onPointerMove);
        doc.removeEventListener('mouseup', onPointerUp);
        doc.removeEventListener('touchmove', onPointerMove);
        doc.removeEventListener('touchend', onPointerUp);
    }
    doc.addEventListener('mousemove', onPointerMove);
    doc.addEventListener('mouseup', onPointerUp);
    doc.addEventListener('touchmove', onPointerMove);
    doc.addEventListener('touchend', onPointerUp);
}
const alwaysValid = ()=>true;
const selector$f = (s)=>({
        connectionStartHandle: s.connectionStartHandle,
        connectOnClick: s.connectOnClick,
        noPanClassName: s.noPanClassName
    });
const connectingSelector = (nodeId, handleId, type)=>(state)=>{
        const { connectionStartHandle: startHandle, connectionEndHandle: endHandle, connectionClickStartHandle: clickHandle } = state;
        return {
            connecting: startHandle?.nodeId === nodeId && startHandle?.handleId === handleId && startHandle?.type === type || endHandle?.nodeId === nodeId && endHandle?.handleId === handleId && endHandle?.type === type,
            clickConnecting: clickHandle?.nodeId === nodeId && clickHandle?.handleId === handleId && clickHandle?.type === type
        };
    };
const Handle = (0, _react.forwardRef)(({ type = 'source', position = Position.Top, isValidConnection, isConnectable = true, isConnectableStart = true, isConnectableEnd = true, id, onConnect, children, className, onMouseDown, onTouchStart, ...rest }, ref)=>{
    const handleId = id || null;
    const isTarget = type === 'target';
    const store = useStoreApi();
    const nodeId = useNodeId();
    const { connectOnClick, noPanClassName } = useStore(selector$f, (0, _shallow.shallow));
    const { connecting, clickConnecting } = useStore(connectingSelector(nodeId, handleId, type), (0, _shallow.shallow));
    if (!nodeId) store.getState().onError?.('010', errorMessages['error010']());
    const onConnectExtended = (params)=>{
        const { defaultEdgeOptions, onConnect: onConnectAction, hasDefaultEdges } = store.getState();
        const edgeParams = {
            ...defaultEdgeOptions,
            ...params
        };
        if (hasDefaultEdges) {
            const { edges, setEdges } = store.getState();
            setEdges(addEdge(edgeParams, edges));
        }
        onConnectAction?.(edgeParams);
        onConnect?.(edgeParams);
    };
    const onPointerDown = (event)=>{
        if (!nodeId) return;
        const isMouseTriggered = isMouseEvent(event);
        if (isConnectableStart && (isMouseTriggered && event.button === 0 || !isMouseTriggered)) handlePointerDown({
            event,
            handleId,
            nodeId,
            onConnect: onConnectExtended,
            isTarget,
            getState: store.getState,
            setState: store.setState,
            isValidConnection: isValidConnection || store.getState().isValidConnection || alwaysValid
        });
        if (isMouseTriggered) onMouseDown?.(event);
        else onTouchStart?.(event);
    };
    const onClick = (event)=>{
        const { onClickConnectStart, onClickConnectEnd, connectionClickStartHandle, connectionMode, isValidConnection: isValidConnectionStore } = store.getState();
        if (!nodeId || !connectionClickStartHandle && !isConnectableStart) return;
        if (!connectionClickStartHandle) {
            onClickConnectStart?.(event, {
                nodeId,
                handleId,
                handleType: type
            });
            store.setState({
                connectionClickStartHandle: {
                    nodeId,
                    type,
                    handleId
                }
            });
            return;
        }
        const doc = getHostForElement(event.target);
        const isValidConnectionHandler = isValidConnection || isValidConnectionStore || alwaysValid;
        const { connection, isValid } = isValidHandle({
            nodeId,
            id: handleId,
            type
        }, connectionMode, connectionClickStartHandle.nodeId, connectionClickStartHandle.handleId || null, connectionClickStartHandle.type, isValidConnectionHandler, doc);
        if (isValid) onConnectExtended(connection);
        onClickConnectEnd?.(event);
        store.setState({
            connectionClickStartHandle: null
        });
    };
    return (0, _reactDefault.default).createElement("div", {
        "data-handleid": handleId,
        "data-nodeid": nodeId,
        "data-handlepos": position,
        "data-id": `${nodeId}-${handleId}-${type}`,
        className: (0, _classcatDefault.default)([
            'react-flow__handle',
            `react-flow__handle-${position}`,
            'nodrag',
            noPanClassName,
            className,
            {
                source: !isTarget,
                target: isTarget,
                connectable: isConnectable,
                connectablestart: isConnectableStart,
                connectableend: isConnectableEnd,
                connecting: clickConnecting,
                // this class is used to style the handle when the user is connecting
                connectionindicator: isConnectable && (isConnectableStart && !connecting || isConnectableEnd && connecting)
            }
        ]),
        onMouseDown: onPointerDown,
        onTouchStart: onPointerDown,
        onClick: connectOnClick ? onClick : undefined,
        ref: ref,
        ...rest
    }, children);
});
Handle.displayName = 'Handle';
var Handle$1 = (0, _react.memo)(Handle);
const DefaultNode = ({ data, isConnectable, targetPosition = Position.Top, sourcePosition = Position.Bottom })=>{
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(Handle$1, {
        type: "target",
        position: targetPosition,
        isConnectable: isConnectable
    }), data?.label, (0, _reactDefault.default).createElement(Handle$1, {
        type: "source",
        position: sourcePosition,
        isConnectable: isConnectable
    }));
};
DefaultNode.displayName = 'DefaultNode';
var DefaultNode$1 = (0, _react.memo)(DefaultNode);
const InputNode = ({ data, isConnectable, sourcePosition = Position.Bottom })=>(0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, data?.label, (0, _reactDefault.default).createElement(Handle$1, {
        type: "source",
        position: sourcePosition,
        isConnectable: isConnectable
    }));
InputNode.displayName = 'InputNode';
var InputNode$1 = (0, _react.memo)(InputNode);
const OutputNode = ({ data, isConnectable, targetPosition = Position.Top })=>(0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(Handle$1, {
        type: "target",
        position: targetPosition,
        isConnectable: isConnectable
    }), data?.label);
OutputNode.displayName = 'OutputNode';
var OutputNode$1 = (0, _react.memo)(OutputNode);
const GroupNode = ()=>null;
GroupNode.displayName = 'GroupNode';
const selector$e = (s)=>({
        selectedNodes: s.getNodes().filter((n)=>n.selected),
        selectedEdges: s.edges.filter((e)=>e.selected).map((e)=>({
                ...e
            }))
    });
const selectId = (obj)=>obj.id;
function areEqual(a, b) {
    return (0, _shallow.shallow)(a.selectedNodes.map(selectId), b.selectedNodes.map(selectId)) && (0, _shallow.shallow)(a.selectedEdges.map(selectId), b.selectedEdges.map(selectId));
}
// This is just a helper component for calling the onSelectionChange listener.
// @TODO: Now that we have the onNodesChange and on EdgesChange listeners, do we still need this component?
const SelectionListener = (0, _react.memo)(({ onSelectionChange })=>{
    const store = useStoreApi();
    const { selectedNodes, selectedEdges } = useStore(selector$e, areEqual);
    (0, _react.useEffect)(()=>{
        const params = {
            nodes: selectedNodes,
            edges: selectedEdges
        };
        onSelectionChange?.(params);
        store.getState().onSelectionChange.forEach((fn)=>fn(params));
    }, [
        selectedNodes,
        selectedEdges,
        onSelectionChange
    ]);
    return null;
});
SelectionListener.displayName = 'SelectionListener';
const changeSelector = (s)=>!!s.onSelectionChange;
function Wrapper$1({ onSelectionChange }) {
    const storeHasSelectionChange = useStore(changeSelector);
    if (onSelectionChange || storeHasSelectionChange) return (0, _reactDefault.default).createElement(SelectionListener, {
        onSelectionChange: onSelectionChange
    });
    return null;
}
const selector$d = (s)=>({
        setNodes: s.setNodes,
        setEdges: s.setEdges,
        setDefaultNodesAndEdges: s.setDefaultNodesAndEdges,
        setMinZoom: s.setMinZoom,
        setMaxZoom: s.setMaxZoom,
        setTranslateExtent: s.setTranslateExtent,
        setNodeExtent: s.setNodeExtent,
        reset: s.reset
    });
function useStoreUpdater(value, setStoreState) {
    (0, _react.useEffect)(()=>{
        if (typeof value !== 'undefined') setStoreState(value);
    }, [
        value
    ]);
}
// updates with values in store that don't have a dedicated setter function
function useDirectStoreUpdater(key, value, setState) {
    (0, _react.useEffect)(()=>{
        if (typeof value !== 'undefined') setState({
            [key]: value
        });
    }, [
        value
    ]);
}
const StoreUpdater = ({ nodes, edges, defaultNodes, defaultEdges, onConnect, onConnectStart, onConnectEnd, onClickConnectStart, onClickConnectEnd, nodesDraggable, nodesConnectable, nodesFocusable, edgesFocusable, edgesUpdatable, elevateNodesOnSelect, minZoom, maxZoom, nodeExtent, onNodesChange, onEdgesChange, elementsSelectable, connectionMode, snapGrid, snapToGrid, translateExtent, connectOnClick, defaultEdgeOptions, fitView, fitViewOptions, onNodesDelete, onEdgesDelete, onNodeDrag, onNodeDragStart, onNodeDragStop, onSelectionDrag, onSelectionDragStart, onSelectionDragStop, noPanClassName, nodeOrigin, rfId, autoPanOnConnect, autoPanOnNodeDrag, onError, connectionRadius, isValidConnection, nodeDragThreshold })=>{
    const { setNodes, setEdges, setDefaultNodesAndEdges, setMinZoom, setMaxZoom, setTranslateExtent, setNodeExtent, reset } = useStore(selector$d, (0, _shallow.shallow));
    const store = useStoreApi();
    (0, _react.useEffect)(()=>{
        const edgesWithDefaults = defaultEdges?.map((e)=>({
                ...e,
                ...defaultEdgeOptions
            }));
        setDefaultNodesAndEdges(defaultNodes, edgesWithDefaults);
        return ()=>{
            reset();
        };
    }, []);
    useDirectStoreUpdater('defaultEdgeOptions', defaultEdgeOptions, store.setState);
    useDirectStoreUpdater('connectionMode', connectionMode, store.setState);
    useDirectStoreUpdater('onConnect', onConnect, store.setState);
    useDirectStoreUpdater('onConnectStart', onConnectStart, store.setState);
    useDirectStoreUpdater('onConnectEnd', onConnectEnd, store.setState);
    useDirectStoreUpdater('onClickConnectStart', onClickConnectStart, store.setState);
    useDirectStoreUpdater('onClickConnectEnd', onClickConnectEnd, store.setState);
    useDirectStoreUpdater('nodesDraggable', nodesDraggable, store.setState);
    useDirectStoreUpdater('nodesConnectable', nodesConnectable, store.setState);
    useDirectStoreUpdater('nodesFocusable', nodesFocusable, store.setState);
    useDirectStoreUpdater('edgesFocusable', edgesFocusable, store.setState);
    useDirectStoreUpdater('edgesUpdatable', edgesUpdatable, store.setState);
    useDirectStoreUpdater('elementsSelectable', elementsSelectable, store.setState);
    useDirectStoreUpdater('elevateNodesOnSelect', elevateNodesOnSelect, store.setState);
    useDirectStoreUpdater('snapToGrid', snapToGrid, store.setState);
    useDirectStoreUpdater('snapGrid', snapGrid, store.setState);
    useDirectStoreUpdater('onNodesChange', onNodesChange, store.setState);
    useDirectStoreUpdater('onEdgesChange', onEdgesChange, store.setState);
    useDirectStoreUpdater('connectOnClick', connectOnClick, store.setState);
    useDirectStoreUpdater('fitViewOnInit', fitView, store.setState);
    useDirectStoreUpdater('fitViewOnInitOptions', fitViewOptions, store.setState);
    useDirectStoreUpdater('onNodesDelete', onNodesDelete, store.setState);
    useDirectStoreUpdater('onEdgesDelete', onEdgesDelete, store.setState);
    useDirectStoreUpdater('onNodeDrag', onNodeDrag, store.setState);
    useDirectStoreUpdater('onNodeDragStart', onNodeDragStart, store.setState);
    useDirectStoreUpdater('onNodeDragStop', onNodeDragStop, store.setState);
    useDirectStoreUpdater('onSelectionDrag', onSelectionDrag, store.setState);
    useDirectStoreUpdater('onSelectionDragStart', onSelectionDragStart, store.setState);
    useDirectStoreUpdater('onSelectionDragStop', onSelectionDragStop, store.setState);
    useDirectStoreUpdater('noPanClassName', noPanClassName, store.setState);
    useDirectStoreUpdater('nodeOrigin', nodeOrigin, store.setState);
    useDirectStoreUpdater('rfId', rfId, store.setState);
    useDirectStoreUpdater('autoPanOnConnect', autoPanOnConnect, store.setState);
    useDirectStoreUpdater('autoPanOnNodeDrag', autoPanOnNodeDrag, store.setState);
    useDirectStoreUpdater('onError', onError, store.setState);
    useDirectStoreUpdater('connectionRadius', connectionRadius, store.setState);
    useDirectStoreUpdater('isValidConnection', isValidConnection, store.setState);
    useDirectStoreUpdater('nodeDragThreshold', nodeDragThreshold, store.setState);
    useStoreUpdater(nodes, setNodes);
    useStoreUpdater(edges, setEdges);
    useStoreUpdater(minZoom, setMinZoom);
    useStoreUpdater(maxZoom, setMaxZoom);
    useStoreUpdater(translateExtent, setTranslateExtent);
    useStoreUpdater(nodeExtent, setNodeExtent);
    return null;
};
const style = {
    display: 'none'
};
const ariaLiveStyle = {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0px, 0px, 0px, 0px)',
    clipPath: 'inset(100%)'
};
const ARIA_NODE_DESC_KEY = 'react-flow__node-desc';
const ARIA_EDGE_DESC_KEY = 'react-flow__edge-desc';
const ARIA_LIVE_MESSAGE = 'react-flow__aria-live';
const selector$c = (s)=>s.ariaLiveMessage;
function AriaLiveMessage({ rfId }) {
    const ariaLiveMessage = useStore(selector$c);
    return (0, _reactDefault.default).createElement("div", {
        id: `${ARIA_LIVE_MESSAGE}-${rfId}`,
        "aria-live": "assertive",
        "aria-atomic": "true",
        style: ariaLiveStyle
    }, ariaLiveMessage);
}
function A11yDescriptions({ rfId, disableKeyboardA11y }) {
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("div", {
        id: `${ARIA_NODE_DESC_KEY}-${rfId}`,
        style: style
    }, "Press enter or space to select a node.", !disableKeyboardA11y && 'You can then use the arrow keys to move the node around.', " Press delete to remove it and escape to cancel.", ' '), (0, _reactDefault.default).createElement("div", {
        id: `${ARIA_EDGE_DESC_KEY}-${rfId}`,
        style: style
    }, "Press enter or space to select an edge. You can then press delete to remove it or escape to cancel."), !disableKeyboardA11y && (0, _reactDefault.default).createElement(AriaLiveMessage, {
        rfId: rfId
    }));
}
// the keycode can be a string 'a' or an array of strings ['a', 'a+d']
// a string means a single key 'a' or a combination when '+' is used 'a+d'
// an array means different possibilities. Explainer: ['a', 'd+s'] here the
// user can use the single key 'a' or the combination 'd' + 's'
var useKeyPress = (keyCode = null, options = {
    actInsideInputWithModifier: true
})=>{
    const [keyPressed, setKeyPressed] = (0, _react.useState)(false);
    // we need to remember if a modifier key is pressed in order to track it
    const modifierPressed = (0, _react.useRef)(false);
    // we need to remember the pressed keys in order to support combinations
    const pressedKeys = (0, _react.useRef)(new Set([]));
    // keyCodes = array with single keys [['a']] or key combinations [['a', 's']]
    // keysToWatch = array with all keys flattened ['a', 'd', 'ShiftLeft']
    // used to check if we store event.code or event.key. When the code is in the list of keysToWatch
    // we use the code otherwise the key. Explainer: When you press the left "command" key, the code is "MetaLeft"
    // and the key is "Meta". We want users to be able to pass keys and codes so we assume that the key is meant when
    // we can't find it in the list of keysToWatch.
    const [keyCodes, keysToWatch] = (0, _react.useMemo)(()=>{
        if (keyCode !== null) {
            const keyCodeArr = Array.isArray(keyCode) ? keyCode : [
                keyCode
            ];
            const keys = keyCodeArr.filter((kc)=>typeof kc === 'string').map((kc)=>kc.split('+'));
            const keysFlat = keys.reduce((res, item)=>res.concat(...item), []);
            return [
                keys,
                keysFlat
            ];
        }
        return [
            [],
            []
        ];
    }, [
        keyCode
    ]);
    (0, _react.useEffect)(()=>{
        const doc = typeof document !== 'undefined' ? document : null;
        const target = options?.target || doc;
        if (keyCode !== null) {
            const downHandler = (event)=>{
                modifierPressed.current = event.ctrlKey || event.metaKey || event.shiftKey;
                const preventAction = (!modifierPressed.current || modifierPressed.current && !options.actInsideInputWithModifier) && isInputDOMNode(event);
                if (preventAction) return false;
                const keyOrCode = useKeyOrCode(event.code, keysToWatch);
                pressedKeys.current.add(event[keyOrCode]);
                if (isMatchingKey(keyCodes, pressedKeys.current, false)) {
                    event.preventDefault();
                    setKeyPressed(true);
                }
            };
            const upHandler = (event)=>{
                const preventAction = (!modifierPressed.current || modifierPressed.current && !options.actInsideInputWithModifier) && isInputDOMNode(event);
                if (preventAction) return false;
                const keyOrCode = useKeyOrCode(event.code, keysToWatch);
                if (isMatchingKey(keyCodes, pressedKeys.current, true)) {
                    setKeyPressed(false);
                    pressedKeys.current.clear();
                } else pressedKeys.current.delete(event[keyOrCode]);
                // fix for Mac: when cmd key is pressed, keyup is not triggered for any other key, see: https://stackoverflow.com/questions/27380018/when-cmd-key-is-kept-pressed-keyup-is-not-triggered-for-any-other-key
                if (event.key === 'Meta') pressedKeys.current.clear();
                modifierPressed.current = false;
            };
            const resetHandler = ()=>{
                pressedKeys.current.clear();
                setKeyPressed(false);
            };
            target?.addEventListener('keydown', downHandler);
            target?.addEventListener('keyup', upHandler);
            window.addEventListener('blur', resetHandler);
            return ()=>{
                target?.removeEventListener('keydown', downHandler);
                target?.removeEventListener('keyup', upHandler);
                window.removeEventListener('blur', resetHandler);
            };
        }
    }, [
        keyCode,
        setKeyPressed
    ]);
    return keyPressed;
};
// utils
function isMatchingKey(keyCodes, pressedKeys, isUp) {
    return keyCodes// we only want to compare same sizes of keyCode definitions
    // and pressed keys. When the user specified 'Meta' as a key somewhere
    // this would also be truthy without this filter when user presses 'Meta' + 'r'
    .filter((keys)=>isUp || keys.length === pressedKeys.size)// since we want to support multiple possibilities only one of the
    // combinations need to be part of the pressed keys
    .some((keys)=>keys.every((k)=>pressedKeys.has(k)));
}
function useKeyOrCode(eventCode, keysToWatch) {
    return keysToWatch.includes(eventCode) ? 'code' : 'key';
}
function calculateXYZPosition(node, nodeInternals, result, nodeOrigin) {
    const parentId = node.parentNode || node.parentId;
    if (!parentId) return result;
    const parentNode = nodeInternals.get(parentId);
    const parentNodePosition = getNodePositionWithOrigin(parentNode, nodeOrigin);
    return calculateXYZPosition(parentNode, nodeInternals, {
        x: (result.x ?? 0) + parentNodePosition.x,
        y: (result.y ?? 0) + parentNodePosition.y,
        z: (parentNode[internalsSymbol]?.z ?? 0) > (result.z ?? 0) ? parentNode[internalsSymbol]?.z ?? 0 : result.z ?? 0
    }, nodeOrigin);
}
function updateAbsoluteNodePositions(nodeInternals, nodeOrigin, parentNodes) {
    nodeInternals.forEach((node)=>{
        const parentId = node.parentNode || node.parentId;
        if (parentId && !nodeInternals.has(parentId)) throw new Error(`Parent node ${parentId} not found`);
        if (parentId || parentNodes?.[node.id]) {
            const { x, y, z } = calculateXYZPosition(node, nodeInternals, {
                ...node.position,
                z: node[internalsSymbol]?.z ?? 0
            }, nodeOrigin);
            node.positionAbsolute = {
                x,
                y
            };
            node[internalsSymbol].z = z;
            if (parentNodes?.[node.id]) node[internalsSymbol].isParent = true;
        }
    });
}
function createNodeInternals(nodes, nodeInternals, nodeOrigin, elevateNodesOnSelect) {
    const nextNodeInternals = new Map();
    const parentNodes = {};
    const selectedNodeZ = elevateNodesOnSelect ? 1000 : 0;
    nodes.forEach((node)=>{
        const z = (isNumeric(node.zIndex) ? node.zIndex : 0) + (node.selected ? selectedNodeZ : 0);
        const currInternals = nodeInternals.get(node.id);
        const internals = {
            ...node,
            positionAbsolute: {
                x: node.position.x,
                y: node.position.y
            }
        };
        const parentId = node.parentNode || node.parentId;
        if (parentId) parentNodes[parentId] = true;
        const resetHandleBounds = currInternals?.type && currInternals?.type !== node.type;
        Object.defineProperty(internals, internalsSymbol, {
            enumerable: false,
            value: {
                handleBounds: resetHandleBounds ? undefined : currInternals?.[internalsSymbol]?.handleBounds,
                z
            }
        });
        nextNodeInternals.set(node.id, internals);
    });
    updateAbsoluteNodePositions(nextNodeInternals, nodeOrigin, parentNodes);
    return nextNodeInternals;
}
function fitView(get, options = {}) {
    const { getNodes, width, height, minZoom, maxZoom, d3Zoom, d3Selection, fitViewOnInitDone, fitViewOnInit, nodeOrigin } = get();
    const isInitialFitView = options.initial && !fitViewOnInitDone && fitViewOnInit;
    const d3initialized = d3Zoom && d3Selection;
    if (d3initialized && (isInitialFitView || !options.initial)) {
        const nodes = getNodes().filter((n)=>{
            const isVisible = options.includeHiddenNodes ? n.width && n.height : !n.hidden;
            if (options.nodes?.length) return isVisible && options.nodes.some((optionNode)=>optionNode.id === n.id);
            return isVisible;
        });
        const nodesInitialized = nodes.every((n)=>n.width && n.height);
        if (nodes.length > 0 && nodesInitialized) {
            const bounds = getNodesBounds(nodes, nodeOrigin);
            const { x, y, zoom } = getViewportForBounds(bounds, width, height, options.minZoom ?? minZoom, options.maxZoom ?? maxZoom, options.padding ?? 0.1);
            const nextTransform = (0, _d3Zoom.zoomIdentity).translate(x, y).scale(zoom);
            if (typeof options.duration === 'number' && options.duration > 0) d3Zoom.transform(getD3Transition(d3Selection, options.duration), nextTransform);
            else d3Zoom.transform(d3Selection, nextTransform);
            return true;
        }
    }
    return false;
}
function handleControlledNodeSelectionChange(nodeChanges, nodeInternals) {
    nodeChanges.forEach((change)=>{
        const node = nodeInternals.get(change.id);
        if (node) nodeInternals.set(node.id, {
            ...node,
            [internalsSymbol]: node[internalsSymbol],
            selected: change.selected
        });
    });
    return new Map(nodeInternals);
}
function handleControlledEdgeSelectionChange(edgeChanges, edges) {
    return edges.map((e)=>{
        const change = edgeChanges.find((change)=>change.id === e.id);
        if (change) e.selected = change.selected;
        return e;
    });
}
function updateNodesAndEdgesSelections({ changedNodes, changedEdges, get, set }) {
    const { nodeInternals, edges, onNodesChange, onEdgesChange, hasDefaultNodes, hasDefaultEdges } = get();
    if (changedNodes?.length) {
        if (hasDefaultNodes) set({
            nodeInternals: handleControlledNodeSelectionChange(changedNodes, nodeInternals)
        });
        onNodesChange?.(changedNodes);
    }
    if (changedEdges?.length) {
        if (hasDefaultEdges) set({
            edges: handleControlledEdgeSelectionChange(changedEdges, edges)
        });
        onEdgesChange?.(changedEdges);
    }
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = ()=>{};
const initialViewportHelper = {
    zoomIn: noop,
    zoomOut: noop,
    zoomTo: noop,
    getZoom: ()=>1,
    setViewport: noop,
    getViewport: ()=>({
            x: 0,
            y: 0,
            zoom: 1
        }),
    fitView: ()=>false,
    setCenter: noop,
    fitBounds: noop,
    project: (position)=>position,
    screenToFlowPosition: (position)=>position,
    flowToScreenPosition: (position)=>position,
    viewportInitialized: false
};
const selector$b = (s)=>({
        d3Zoom: s.d3Zoom,
        d3Selection: s.d3Selection
    });
const useViewportHelper = ()=>{
    const store = useStoreApi();
    const { d3Zoom, d3Selection } = useStore(selector$b, (0, _shallow.shallow));
    const viewportHelperFunctions = (0, _react.useMemo)(()=>{
        if (d3Selection && d3Zoom) return {
            zoomIn: (options)=>d3Zoom.scaleBy(getD3Transition(d3Selection, options?.duration), 1.2),
            zoomOut: (options)=>d3Zoom.scaleBy(getD3Transition(d3Selection, options?.duration), 1 / 1.2),
            zoomTo: (zoomLevel, options)=>d3Zoom.scaleTo(getD3Transition(d3Selection, options?.duration), zoomLevel),
            getZoom: ()=>store.getState().transform[2],
            setViewport: (transform, options)=>{
                const [x, y, zoom] = store.getState().transform;
                const nextTransform = (0, _d3Zoom.zoomIdentity).translate(transform.x ?? x, transform.y ?? y).scale(transform.zoom ?? zoom);
                d3Zoom.transform(getD3Transition(d3Selection, options?.duration), nextTransform);
            },
            getViewport: ()=>{
                const [x, y, zoom] = store.getState().transform;
                return {
                    x,
                    y,
                    zoom
                };
            },
            fitView: (options)=>fitView(store.getState, options),
            setCenter: (x, y, options)=>{
                const { width, height, maxZoom } = store.getState();
                const nextZoom = typeof options?.zoom !== 'undefined' ? options.zoom : maxZoom;
                const centerX = width / 2 - x * nextZoom;
                const centerY = height / 2 - y * nextZoom;
                const transform = (0, _d3Zoom.zoomIdentity).translate(centerX, centerY).scale(nextZoom);
                d3Zoom.transform(getD3Transition(d3Selection, options?.duration), transform);
            },
            fitBounds: (bounds, options)=>{
                const { width, height, minZoom, maxZoom } = store.getState();
                const { x, y, zoom } = getViewportForBounds(bounds, width, height, minZoom, maxZoom, options?.padding ?? 0.1);
                const transform = (0, _d3Zoom.zoomIdentity).translate(x, y).scale(zoom);
                d3Zoom.transform(getD3Transition(d3Selection, options?.duration), transform);
            },
            // @deprecated Use `screenToFlowPosition`.
            project: (position)=>{
                const { transform, snapToGrid, snapGrid } = store.getState();
                console.warn('[DEPRECATED] `project` is deprecated. Instead use `screenToFlowPosition`. There is no need to subtract the react flow bounds anymore! https://reactflow.dev/api-reference/types/react-flow-instance#screen-to-flow-position');
                return pointToRendererPoint(position, transform, snapToGrid, snapGrid);
            },
            screenToFlowPosition: (position)=>{
                const { transform, snapToGrid, snapGrid, domNode } = store.getState();
                if (!domNode) return position;
                const { x: domX, y: domY } = domNode.getBoundingClientRect();
                const relativePosition = {
                    x: position.x - domX,
                    y: position.y - domY
                };
                return pointToRendererPoint(relativePosition, transform, snapToGrid, snapGrid);
            },
            flowToScreenPosition: (position)=>{
                const { transform, domNode } = store.getState();
                if (!domNode) return position;
                const { x: domX, y: domY } = domNode.getBoundingClientRect();
                const rendererPosition = rendererPointToPoint(position, transform);
                return {
                    x: rendererPosition.x + domX,
                    y: rendererPosition.y + domY
                };
            },
            viewportInitialized: true
        };
        return initialViewportHelper;
    }, [
        d3Zoom,
        d3Selection
    ]);
    return viewportHelperFunctions;
};
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */ function useReactFlow() {
    const viewportHelper = useViewportHelper();
    const store = useStoreApi();
    const getNodes = (0, _react.useCallback)(()=>{
        return store.getState().getNodes().map((n)=>({
                ...n
            }));
    }, []);
    const getNode = (0, _react.useCallback)((id)=>{
        return store.getState().nodeInternals.get(id);
    }, []);
    const getEdges = (0, _react.useCallback)(()=>{
        const { edges = [] } = store.getState();
        return edges.map((e)=>({
                ...e
            }));
    }, []);
    const getEdge = (0, _react.useCallback)((id)=>{
        const { edges = [] } = store.getState();
        return edges.find((e)=>e.id === id);
    }, []);
    const setNodes = (0, _react.useCallback)((payload)=>{
        const { getNodes, setNodes, hasDefaultNodes, onNodesChange } = store.getState();
        const nodes = getNodes();
        const nextNodes = typeof payload === 'function' ? payload(nodes) : payload;
        if (hasDefaultNodes) setNodes(nextNodes);
        else if (onNodesChange) {
            const changes = nextNodes.length === 0 ? nodes.map((node)=>({
                    type: 'remove',
                    id: node.id
                })) : nextNodes.map((node)=>({
                    item: node,
                    type: 'reset'
                }));
            onNodesChange(changes);
        }
    }, []);
    const setEdges = (0, _react.useCallback)((payload)=>{
        const { edges = [], setEdges, hasDefaultEdges, onEdgesChange } = store.getState();
        const nextEdges = typeof payload === 'function' ? payload(edges) : payload;
        if (hasDefaultEdges) setEdges(nextEdges);
        else if (onEdgesChange) {
            const changes = nextEdges.length === 0 ? edges.map((edge)=>({
                    type: 'remove',
                    id: edge.id
                })) : nextEdges.map((edge)=>({
                    item: edge,
                    type: 'reset'
                }));
            onEdgesChange(changes);
        }
    }, []);
    const addNodes = (0, _react.useCallback)((payload)=>{
        const nodes = Array.isArray(payload) ? payload : [
            payload
        ];
        const { getNodes, setNodes, hasDefaultNodes, onNodesChange } = store.getState();
        if (hasDefaultNodes) {
            const currentNodes = getNodes();
            const nextNodes = [
                ...currentNodes,
                ...nodes
            ];
            setNodes(nextNodes);
        } else if (onNodesChange) {
            const changes = nodes.map((node)=>({
                    item: node,
                    type: 'add'
                }));
            onNodesChange(changes);
        }
    }, []);
    const addEdges = (0, _react.useCallback)((payload)=>{
        const nextEdges = Array.isArray(payload) ? payload : [
            payload
        ];
        const { edges = [], setEdges, hasDefaultEdges, onEdgesChange } = store.getState();
        if (hasDefaultEdges) setEdges([
            ...edges,
            ...nextEdges
        ]);
        else if (onEdgesChange) {
            const changes = nextEdges.map((edge)=>({
                    item: edge,
                    type: 'add'
                }));
            onEdgesChange(changes);
        }
    }, []);
    const toObject = (0, _react.useCallback)(()=>{
        const { getNodes, edges = [], transform } = store.getState();
        const [x, y, zoom] = transform;
        return {
            nodes: getNodes().map((n)=>({
                    ...n
                })),
            edges: edges.map((e)=>({
                    ...e
                })),
            viewport: {
                x,
                y,
                zoom
            }
        };
    }, []);
    const deleteElements = (0, _react.useCallback)(({ nodes: nodesDeleted, edges: edgesDeleted })=>{
        const { nodeInternals, getNodes, edges, hasDefaultNodes, hasDefaultEdges, onNodesDelete, onEdgesDelete, onNodesChange, onEdgesChange } = store.getState();
        const nodeIds = (nodesDeleted || []).map((node)=>node.id);
        const edgeIds = (edgesDeleted || []).map((edge)=>edge.id);
        const nodesToRemove = getNodes().reduce((res, node)=>{
            const parentId = node.parentNode || node.parentId;
            const parentHit = !nodeIds.includes(node.id) && parentId && res.find((n)=>n.id === parentId);
            const deletable = typeof node.deletable === 'boolean' ? node.deletable : true;
            if (deletable && (nodeIds.includes(node.id) || parentHit)) res.push(node);
            return res;
        }, []);
        const deletableEdges = edges.filter((e)=>typeof e.deletable === 'boolean' ? e.deletable : true);
        const initialHitEdges = deletableEdges.filter((e)=>edgeIds.includes(e.id));
        if (nodesToRemove || initialHitEdges) {
            const connectedEdges = getConnectedEdges(nodesToRemove, deletableEdges);
            const edgesToRemove = [
                ...initialHitEdges,
                ...connectedEdges
            ];
            const edgeIdsToRemove = edgesToRemove.reduce((res, edge)=>{
                if (!res.includes(edge.id)) res.push(edge.id);
                return res;
            }, []);
            if (hasDefaultEdges || hasDefaultNodes) {
                if (hasDefaultEdges) store.setState({
                    edges: edges.filter((e)=>!edgeIdsToRemove.includes(e.id))
                });
                if (hasDefaultNodes) {
                    nodesToRemove.forEach((node)=>{
                        nodeInternals.delete(node.id);
                    });
                    store.setState({
                        nodeInternals: new Map(nodeInternals)
                    });
                }
            }
            if (edgeIdsToRemove.length > 0) {
                onEdgesDelete?.(edgesToRemove);
                if (onEdgesChange) onEdgesChange(edgeIdsToRemove.map((id)=>({
                        id,
                        type: 'remove'
                    })));
            }
            if (nodesToRemove.length > 0) {
                onNodesDelete?.(nodesToRemove);
                if (onNodesChange) {
                    const nodeChanges = nodesToRemove.map((n)=>({
                            id: n.id,
                            type: 'remove'
                        }));
                    onNodesChange(nodeChanges);
                }
            }
        }
    }, []);
    const getNodeRect = (0, _react.useCallback)((nodeOrRect)=>{
        const isRect = isRectObject(nodeOrRect);
        const node = isRect ? null : store.getState().nodeInternals.get(nodeOrRect.id);
        if (!isRect && !node) return [
            null,
            null,
            isRect
        ];
        const nodeRect = isRect ? nodeOrRect : nodeToRect(node);
        return [
            nodeRect,
            node,
            isRect
        ];
    }, []);
    const getIntersectingNodes = (0, _react.useCallback)((nodeOrRect, partially = true, nodes)=>{
        const [nodeRect, node, isRect] = getNodeRect(nodeOrRect);
        if (!nodeRect) return [];
        return (nodes || store.getState().getNodes()).filter((n)=>{
            if (!isRect && (n.id === node.id || !n.positionAbsolute)) return false;
            const currNodeRect = nodeToRect(n);
            const overlappingArea = getOverlappingArea(currNodeRect, nodeRect);
            const partiallyVisible = partially && overlappingArea > 0;
            return partiallyVisible || overlappingArea >= nodeRect.width * nodeRect.height;
        });
    }, []);
    const isNodeIntersecting = (0, _react.useCallback)((nodeOrRect, area, partially = true)=>{
        const [nodeRect] = getNodeRect(nodeOrRect);
        if (!nodeRect) return false;
        const overlappingArea = getOverlappingArea(nodeRect, area);
        const partiallyVisible = partially && overlappingArea > 0;
        return partiallyVisible || overlappingArea >= nodeRect.width * nodeRect.height;
    }, []);
    return (0, _react.useMemo)(()=>{
        return {
            ...viewportHelper,
            getNodes,
            getNode,
            getEdges,
            getEdge,
            setNodes,
            setEdges,
            addNodes,
            addEdges,
            toObject,
            deleteElements,
            getIntersectingNodes,
            isNodeIntersecting
        };
    }, [
        viewportHelper,
        getNodes,
        getNode,
        getEdges,
        getEdge,
        setNodes,
        setEdges,
        addNodes,
        addEdges,
        toObject,
        deleteElements,
        getIntersectingNodes,
        isNodeIntersecting
    ]);
}
const deleteKeyOptions = {
    actInsideInputWithModifier: false
};
var useGlobalKeyHandler = ({ deleteKeyCode, multiSelectionKeyCode })=>{
    const store = useStoreApi();
    const { deleteElements } = useReactFlow();
    const deleteKeyPressed = useKeyPress(deleteKeyCode, deleteKeyOptions);
    const multiSelectionKeyPressed = useKeyPress(multiSelectionKeyCode);
    (0, _react.useEffect)(()=>{
        if (deleteKeyPressed) {
            const { edges, getNodes } = store.getState();
            const selectedNodes = getNodes().filter((node)=>node.selected);
            const selectedEdges = edges.filter((edge)=>edge.selected);
            deleteElements({
                nodes: selectedNodes,
                edges: selectedEdges
            });
            store.setState({
                nodesSelectionActive: false
            });
        }
    }, [
        deleteKeyPressed
    ]);
    (0, _react.useEffect)(()=>{
        store.setState({
            multiSelectionActive: multiSelectionKeyPressed
        });
    }, [
        multiSelectionKeyPressed
    ]);
};
function useResizeHandler(rendererNode) {
    const store = useStoreApi();
    (0, _react.useEffect)(()=>{
        let resizeObserver;
        const updateDimensions = ()=>{
            if (!rendererNode.current) return;
            const size = getDimensions(rendererNode.current);
            if (size.height === 0 || size.width === 0) store.getState().onError?.('004', errorMessages['error004']());
            store.setState({
                width: size.width || 500,
                height: size.height || 500
            });
        };
        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        if (rendererNode.current) {
            resizeObserver = new ResizeObserver(()=>updateDimensions());
            resizeObserver.observe(rendererNode.current);
        }
        return ()=>{
            window.removeEventListener('resize', updateDimensions);
            if (resizeObserver && rendererNode.current) resizeObserver.unobserve(rendererNode.current);
        };
    }, []);
}
const containerStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0
};
/* eslint-disable @typescript-eslint/ban-ts-comment */ const viewChanged = (prevViewport, eventTransform)=>prevViewport.x !== eventTransform.x || prevViewport.y !== eventTransform.y || prevViewport.zoom !== eventTransform.k;
const eventToFlowTransform = (eventTransform)=>({
        x: eventTransform.x,
        y: eventTransform.y,
        zoom: eventTransform.k
    });
const isWrappedWithClass = (event, className)=>event.target.closest(`.${className}`);
const isRightClickPan = (panOnDrag, usedButton)=>usedButton === 2 && Array.isArray(panOnDrag) && panOnDrag.includes(2);
const wheelDelta = (event)=>{
    const factor = event.ctrlKey && isMacOs() ? 10 : 1;
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * factor;
};
const selector$a = (s)=>({
        d3Zoom: s.d3Zoom,
        d3Selection: s.d3Selection,
        d3ZoomHandler: s.d3ZoomHandler,
        userSelectionActive: s.userSelectionActive
    });
const ZoomPane = ({ onMove, onMoveStart, onMoveEnd, onPaneContextMenu, zoomOnScroll = true, zoomOnPinch = true, panOnScroll = false, panOnScrollSpeed = 0.5, panOnScrollMode = PanOnScrollMode.Free, zoomOnDoubleClick = true, elementsSelectable, panOnDrag = true, defaultViewport, translateExtent, minZoom, maxZoom, zoomActivationKeyCode, preventScrolling = true, children, noWheelClassName, noPanClassName })=>{
    const timerId = (0, _react.useRef)();
    const store = useStoreApi();
    const isZoomingOrPanning = (0, _react.useRef)(false);
    const zoomedWithRightMouseButton = (0, _react.useRef)(false);
    const zoomPane = (0, _react.useRef)(null);
    const prevTransform = (0, _react.useRef)({
        x: 0,
        y: 0,
        zoom: 0
    });
    const { d3Zoom, d3Selection, d3ZoomHandler, userSelectionActive } = useStore(selector$a, (0, _shallow.shallow));
    const zoomActivationKeyPressed = useKeyPress(zoomActivationKeyCode);
    const mouseButton = (0, _react.useRef)(0);
    const isPanScrolling = (0, _react.useRef)(false);
    const panScrollTimeout = (0, _react.useRef)();
    useResizeHandler(zoomPane);
    (0, _react.useEffect)(()=>{
        if (zoomPane.current) {
            const bbox = zoomPane.current.getBoundingClientRect();
            const d3ZoomInstance = (0, _d3Zoom.zoom)().scaleExtent([
                minZoom,
                maxZoom
            ]).translateExtent(translateExtent);
            const selection = (0, _d3Selection.select)(zoomPane.current).call(d3ZoomInstance);
            const updatedTransform = (0, _d3Zoom.zoomIdentity).translate(defaultViewport.x, defaultViewport.y).scale(clamp(defaultViewport.zoom, minZoom, maxZoom));
            const extent = [
                [
                    0,
                    0
                ],
                [
                    bbox.width,
                    bbox.height
                ]
            ];
            const constrainedTransform = d3ZoomInstance.constrain()(updatedTransform, extent, translateExtent);
            d3ZoomInstance.transform(selection, constrainedTransform);
            d3ZoomInstance.wheelDelta(wheelDelta);
            store.setState({
                d3Zoom: d3ZoomInstance,
                d3Selection: selection,
                d3ZoomHandler: selection.on('wheel.zoom'),
                // we need to pass transform because zoom handler is not registered when we set the initial transform
                transform: [
                    constrainedTransform.x,
                    constrainedTransform.y,
                    constrainedTransform.k
                ],
                domNode: zoomPane.current.closest('.react-flow')
            });
        }
    }, []);
    (0, _react.useEffect)(()=>{
        if (d3Selection && d3Zoom) {
            if (panOnScroll && !zoomActivationKeyPressed && !userSelectionActive) d3Selection.on('wheel.zoom', (event)=>{
                if (isWrappedWithClass(event, noWheelClassName)) return false;
                event.preventDefault();
                event.stopImmediatePropagation();
                const currentZoom = d3Selection.property('__zoom').k || 1;
                // macos and win set ctrlKey=true for pinch gesture on a trackpad
                if (event.ctrlKey && zoomOnPinch) {
                    const point = (0, _d3Selection.pointer)(event);
                    const pinchDelta = wheelDelta(event);
                    const zoom = currentZoom * Math.pow(2, pinchDelta);
                    // @ts-ignore
                    d3Zoom.scaleTo(d3Selection, zoom, point, event);
                    return;
                }
                // increase scroll speed in firefox
                // firefox: deltaMode === 1; chrome: deltaMode === 0
                const deltaNormalize = event.deltaMode === 1 ? 20 : 1;
                let deltaX = panOnScrollMode === PanOnScrollMode.Vertical ? 0 : event.deltaX * deltaNormalize;
                let deltaY = panOnScrollMode === PanOnScrollMode.Horizontal ? 0 : event.deltaY * deltaNormalize;
                // this enables vertical scrolling with shift + scroll on windows
                if (!isMacOs() && event.shiftKey && panOnScrollMode !== PanOnScrollMode.Vertical) {
                    deltaX = event.deltaY * deltaNormalize;
                    deltaY = 0;
                }
                d3Zoom.translateBy(d3Selection, -(deltaX / currentZoom) * panOnScrollSpeed, -(deltaY / currentZoom) * panOnScrollSpeed, // @ts-ignore
                {
                    internal: true
                });
                const nextViewport = eventToFlowTransform(d3Selection.property('__zoom'));
                const { onViewportChangeStart, onViewportChange, onViewportChangeEnd } = store.getState();
                clearTimeout(panScrollTimeout.current);
                // for pan on scroll we need to handle the event calls on our own
                // we can't use the start, zoom and end events from d3-zoom
                // because start and move gets called on every scroll event and not once at the beginning
                if (!isPanScrolling.current) {
                    isPanScrolling.current = true;
                    onMoveStart?.(event, nextViewport);
                    onViewportChangeStart?.(nextViewport);
                }
                if (isPanScrolling.current) {
                    onMove?.(event, nextViewport);
                    onViewportChange?.(nextViewport);
                    panScrollTimeout.current = setTimeout(()=>{
                        onMoveEnd?.(event, nextViewport);
                        onViewportChangeEnd?.(nextViewport);
                        isPanScrolling.current = false;
                    }, 150);
                }
            }, {
                passive: false
            });
            else if (typeof d3ZoomHandler !== 'undefined') d3Selection.on('wheel.zoom', function(event, d) {
                // we still want to enable pinch zooming even if preventScrolling is set to false
                const invalidEvent = !preventScrolling && event.type === 'wheel' && !event.ctrlKey;
                if (invalidEvent || isWrappedWithClass(event, noWheelClassName)) return null;
                event.preventDefault();
                d3ZoomHandler.call(this, event, d);
            }, {
                passive: false
            });
        }
    }, [
        userSelectionActive,
        panOnScroll,
        panOnScrollMode,
        d3Selection,
        d3Zoom,
        d3ZoomHandler,
        zoomActivationKeyPressed,
        zoomOnPinch,
        preventScrolling,
        noWheelClassName,
        onMoveStart,
        onMove,
        onMoveEnd
    ]);
    (0, _react.useEffect)(()=>{
        if (d3Zoom) d3Zoom.on('start', (event)=>{
            if (!event.sourceEvent || event.sourceEvent.internal) return null;
            // we need to remember it here, because it's always 0 in the "zoom" event
            mouseButton.current = event.sourceEvent?.button;
            const { onViewportChangeStart } = store.getState();
            const flowTransform = eventToFlowTransform(event.transform);
            isZoomingOrPanning.current = true;
            prevTransform.current = flowTransform;
            if (event.sourceEvent?.type === 'mousedown') store.setState({
                paneDragging: true
            });
            onViewportChangeStart?.(flowTransform);
            onMoveStart?.(event.sourceEvent, flowTransform);
        });
    }, [
        d3Zoom,
        onMoveStart
    ]);
    (0, _react.useEffect)(()=>{
        if (d3Zoom) {
            if (userSelectionActive && !isZoomingOrPanning.current) d3Zoom.on('zoom', null);
            else if (!userSelectionActive) d3Zoom.on('zoom', (event)=>{
                const { onViewportChange } = store.getState();
                store.setState({
                    transform: [
                        event.transform.x,
                        event.transform.y,
                        event.transform.k
                    ]
                });
                zoomedWithRightMouseButton.current = !!(onPaneContextMenu && isRightClickPan(panOnDrag, mouseButton.current ?? 0));
                if ((onMove || onViewportChange) && !event.sourceEvent?.internal) {
                    const flowTransform = eventToFlowTransform(event.transform);
                    onViewportChange?.(flowTransform);
                    onMove?.(event.sourceEvent, flowTransform);
                }
            });
        }
    }, [
        userSelectionActive,
        d3Zoom,
        onMove,
        panOnDrag,
        onPaneContextMenu
    ]);
    (0, _react.useEffect)(()=>{
        if (d3Zoom) d3Zoom.on('end', (event)=>{
            if (!event.sourceEvent || event.sourceEvent.internal) return null;
            const { onViewportChangeEnd } = store.getState();
            isZoomingOrPanning.current = false;
            store.setState({
                paneDragging: false
            });
            if (onPaneContextMenu && isRightClickPan(panOnDrag, mouseButton.current ?? 0) && !zoomedWithRightMouseButton.current) onPaneContextMenu(event.sourceEvent);
            zoomedWithRightMouseButton.current = false;
            if ((onMoveEnd || onViewportChangeEnd) && viewChanged(prevTransform.current, event.transform)) {
                const flowTransform = eventToFlowTransform(event.transform);
                prevTransform.current = flowTransform;
                clearTimeout(timerId.current);
                timerId.current = setTimeout(()=>{
                    onViewportChangeEnd?.(flowTransform);
                    onMoveEnd?.(event.sourceEvent, flowTransform);
                }, panOnScroll ? 150 : 0);
            }
        });
    }, [
        d3Zoom,
        panOnScroll,
        panOnDrag,
        onMoveEnd,
        onPaneContextMenu
    ]);
    (0, _react.useEffect)(()=>{
        if (d3Zoom) d3Zoom.filter((event)=>{
            const zoomScroll = zoomActivationKeyPressed || zoomOnScroll;
            const pinchZoom = zoomOnPinch && event.ctrlKey;
            if ((panOnDrag === true || Array.isArray(panOnDrag) && panOnDrag.includes(1)) && event.button === 1 && event.type === 'mousedown' && (isWrappedWithClass(event, 'react-flow__node') || isWrappedWithClass(event, 'react-flow__edge'))) return true;
            // if all interactions are disabled, we prevent all zoom events
            if (!panOnDrag && !zoomScroll && !panOnScroll && !zoomOnDoubleClick && !zoomOnPinch) return false;
            // during a selection we prevent all other interactions
            if (userSelectionActive) return false;
            // if zoom on double click is disabled, we prevent the double click event
            if (!zoomOnDoubleClick && event.type === 'dblclick') return false;
            // if the target element is inside an element with the nowheel class, we prevent zooming
            if (isWrappedWithClass(event, noWheelClassName) && event.type === 'wheel') return false;
            // if the target element is inside an element with the nopan class, we prevent panning
            if (isWrappedWithClass(event, noPanClassName) && (event.type !== 'wheel' || panOnScroll && event.type === 'wheel' && !zoomActivationKeyPressed)) return false;
            if (!zoomOnPinch && event.ctrlKey && event.type === 'wheel') return false;
            // when there is no scroll handling enabled, we prevent all wheel events
            if (!zoomScroll && !panOnScroll && !pinchZoom && event.type === 'wheel') return false;
            // if the pane is not movable, we prevent dragging it with mousestart or touchstart
            if (!panOnDrag && (event.type === 'mousedown' || event.type === 'touchstart')) return false;
            // if the pane is only movable using allowed clicks
            if (Array.isArray(panOnDrag) && !panOnDrag.includes(event.button) && event.type === 'mousedown') return false;
            // We only allow right clicks if pan on drag is set to right click
            const buttonAllowed = Array.isArray(panOnDrag) && panOnDrag.includes(event.button) || !event.button || event.button <= 1;
            // default filter for d3-zoom
            return (!event.ctrlKey || event.type === 'wheel') && buttonAllowed;
        });
    }, [
        userSelectionActive,
        d3Zoom,
        zoomOnScroll,
        zoomOnPinch,
        panOnScroll,
        zoomOnDoubleClick,
        panOnDrag,
        elementsSelectable,
        zoomActivationKeyPressed
    ]);
    return (0, _reactDefault.default).createElement("div", {
        className: "react-flow__renderer",
        ref: zoomPane,
        style: containerStyle
    }, children);
};
const selector$9 = (s)=>({
        userSelectionActive: s.userSelectionActive,
        userSelectionRect: s.userSelectionRect
    });
function UserSelection() {
    const { userSelectionActive, userSelectionRect } = useStore(selector$9, (0, _shallow.shallow));
    const isActive = userSelectionActive && userSelectionRect;
    if (!isActive) return null;
    return (0, _reactDefault.default).createElement("div", {
        className: "react-flow__selection react-flow__container",
        style: {
            width: userSelectionRect.width,
            height: userSelectionRect.height,
            transform: `translate(${userSelectionRect.x}px, ${userSelectionRect.y}px)`
        }
    });
}
function handleParentExpand(res, updateItem) {
    const parentId = updateItem.parentNode || updateItem.parentId;
    const parent = res.find((e)=>e.id === parentId);
    if (parent) {
        const extendWidth = updateItem.position.x + updateItem.width - parent.width;
        const extendHeight = updateItem.position.y + updateItem.height - parent.height;
        if (extendWidth > 0 || extendHeight > 0 || updateItem.position.x < 0 || updateItem.position.y < 0) {
            parent.style = {
                ...parent.style
            };
            parent.style.width = parent.style.width ?? parent.width;
            parent.style.height = parent.style.height ?? parent.height;
            if (extendWidth > 0) parent.style.width += extendWidth;
            if (extendHeight > 0) parent.style.height += extendHeight;
            if (updateItem.position.x < 0) {
                const xDiff = Math.abs(updateItem.position.x);
                parent.position.x = parent.position.x - xDiff;
                parent.style.width += xDiff;
                updateItem.position.x = 0;
            }
            if (updateItem.position.y < 0) {
                const yDiff = Math.abs(updateItem.position.y);
                parent.position.y = parent.position.y - yDiff;
                parent.style.height += yDiff;
                updateItem.position.y = 0;
            }
            parent.width = parent.style.width;
            parent.height = parent.style.height;
        }
    }
}
function applyChanges(changes, elements) {
    // we need this hack to handle the setNodes and setEdges function of the useReactFlow hook for controlled flows
    if (changes.some((c)=>c.type === 'reset')) return changes.filter((c)=>c.type === 'reset').map((c)=>c.item);
    const initElements = changes.filter((c)=>c.type === 'add').map((c)=>c.item);
    return elements.reduce((res, item)=>{
        const currentChanges = changes.filter((c)=>c.id === item.id);
        if (currentChanges.length === 0) {
            res.push(item);
            return res;
        }
        const updateItem = {
            ...item
        };
        for (const currentChange of currentChanges)if (currentChange) switch(currentChange.type){
            case 'select':
                updateItem.selected = currentChange.selected;
                break;
            case 'position':
                if (typeof currentChange.position !== 'undefined') updateItem.position = currentChange.position;
                if (typeof currentChange.positionAbsolute !== 'undefined') updateItem.positionAbsolute = currentChange.positionAbsolute;
                if (typeof currentChange.dragging !== 'undefined') updateItem.dragging = currentChange.dragging;
                if (updateItem.expandParent) handleParentExpand(res, updateItem);
                break;
            case 'dimensions':
                if (typeof currentChange.dimensions !== 'undefined') {
                    updateItem.width = currentChange.dimensions.width;
                    updateItem.height = currentChange.dimensions.height;
                }
                if (typeof currentChange.updateStyle !== 'undefined') updateItem.style = {
                    ...updateItem.style || {},
                    ...currentChange.dimensions
                };
                if (typeof currentChange.resizing === 'boolean') updateItem.resizing = currentChange.resizing;
                if (updateItem.expandParent) handleParentExpand(res, updateItem);
                break;
            case 'remove':
                return res;
        }
        res.push(updateItem);
        return res;
    }, initElements);
}
function applyNodeChanges(changes, nodes) {
    return applyChanges(changes, nodes);
}
function applyEdgeChanges(changes, edges) {
    return applyChanges(changes, edges);
}
const createSelectionChange = (id, selected)=>({
        id,
        type: 'select',
        selected
    });
function getSelectionChanges(items, selectedIds) {
    return items.reduce((res, item)=>{
        const willBeSelected = selectedIds.includes(item.id);
        if (!item.selected && willBeSelected) {
            item.selected = true;
            res.push(createSelectionChange(item.id, true));
        } else if (item.selected && !willBeSelected) {
            item.selected = false;
            res.push(createSelectionChange(item.id, false));
        }
        return res;
    }, []);
}
/**
 * The user selection rectangle gets displayed when a user drags the mouse while pressing shift
 */ const wrapHandler = (handler, containerRef)=>{
    return (event)=>{
        if (event.target !== containerRef.current) return;
        handler?.(event);
    };
};
const selector$8 = (s)=>({
        userSelectionActive: s.userSelectionActive,
        elementsSelectable: s.elementsSelectable,
        dragging: s.paneDragging
    });
const Pane = (0, _react.memo)(({ isSelecting, selectionMode = SelectionMode.Full, panOnDrag, onSelectionStart, onSelectionEnd, onPaneClick, onPaneContextMenu, onPaneScroll, onPaneMouseEnter, onPaneMouseMove, onPaneMouseLeave, children })=>{
    const container = (0, _react.useRef)(null);
    const store = useStoreApi();
    const prevSelectedNodesCount = (0, _react.useRef)(0);
    const prevSelectedEdgesCount = (0, _react.useRef)(0);
    const containerBounds = (0, _react.useRef)();
    const { userSelectionActive, elementsSelectable, dragging } = useStore(selector$8, (0, _shallow.shallow));
    const resetUserSelection = ()=>{
        store.setState({
            userSelectionActive: false,
            userSelectionRect: null
        });
        prevSelectedNodesCount.current = 0;
        prevSelectedEdgesCount.current = 0;
    };
    const onClick = (event)=>{
        onPaneClick?.(event);
        store.getState().resetSelectedElements();
        store.setState({
            nodesSelectionActive: false
        });
    };
    const onContextMenu = (event)=>{
        if (Array.isArray(panOnDrag) && panOnDrag?.includes(2)) {
            event.preventDefault();
            return;
        }
        onPaneContextMenu?.(event);
    };
    const onWheel = onPaneScroll ? (event)=>onPaneScroll(event) : undefined;
    const onMouseDown = (event)=>{
        const { resetSelectedElements, domNode } = store.getState();
        containerBounds.current = domNode?.getBoundingClientRect();
        if (!elementsSelectable || !isSelecting || event.button !== 0 || event.target !== container.current || !containerBounds.current) return;
        const { x, y } = getEventPosition(event, containerBounds.current);
        resetSelectedElements();
        store.setState({
            userSelectionRect: {
                width: 0,
                height: 0,
                startX: x,
                startY: y,
                x,
                y
            }
        });
        onSelectionStart?.(event);
    };
    const onMouseMove = (event)=>{
        const { userSelectionRect, nodeInternals, edges, transform, onNodesChange, onEdgesChange, nodeOrigin, getNodes } = store.getState();
        if (!isSelecting || !containerBounds.current || !userSelectionRect) return;
        store.setState({
            userSelectionActive: true,
            nodesSelectionActive: false
        });
        const mousePos = getEventPosition(event, containerBounds.current);
        const startX = userSelectionRect.startX ?? 0;
        const startY = userSelectionRect.startY ?? 0;
        const nextUserSelectRect = {
            ...userSelectionRect,
            x: mousePos.x < startX ? mousePos.x : startX,
            y: mousePos.y < startY ? mousePos.y : startY,
            width: Math.abs(mousePos.x - startX),
            height: Math.abs(mousePos.y - startY)
        };
        const nodes = getNodes();
        const selectedNodes = getNodesInside(nodeInternals, nextUserSelectRect, transform, selectionMode === SelectionMode.Partial, true, nodeOrigin);
        const selectedEdgeIds = getConnectedEdges(selectedNodes, edges).map((e)=>e.id);
        const selectedNodeIds = selectedNodes.map((n)=>n.id);
        if (prevSelectedNodesCount.current !== selectedNodeIds.length) {
            prevSelectedNodesCount.current = selectedNodeIds.length;
            const changes = getSelectionChanges(nodes, selectedNodeIds);
            if (changes.length) onNodesChange?.(changes);
        }
        if (prevSelectedEdgesCount.current !== selectedEdgeIds.length) {
            prevSelectedEdgesCount.current = selectedEdgeIds.length;
            const changes = getSelectionChanges(edges, selectedEdgeIds);
            if (changes.length) onEdgesChange?.(changes);
        }
        store.setState({
            userSelectionRect: nextUserSelectRect
        });
    };
    const onMouseUp = (event)=>{
        if (event.button !== 0) return;
        const { userSelectionRect } = store.getState();
        // We only want to trigger click functions when in selection mode if
        // the user did not move the mouse.
        if (!userSelectionActive && userSelectionRect && event.target === container.current) onClick?.(event);
        store.setState({
            nodesSelectionActive: prevSelectedNodesCount.current > 0
        });
        resetUserSelection();
        onSelectionEnd?.(event);
    };
    const onMouseLeave = (event)=>{
        if (userSelectionActive) {
            store.setState({
                nodesSelectionActive: prevSelectedNodesCount.current > 0
            });
            onSelectionEnd?.(event);
        }
        resetUserSelection();
    };
    const hasActiveSelection = elementsSelectable && (isSelecting || userSelectionActive);
    return (0, _reactDefault.default).createElement("div", {
        className: (0, _classcatDefault.default)([
            'react-flow__pane',
            {
                dragging,
                selection: isSelecting
            }
        ]),
        onClick: hasActiveSelection ? undefined : wrapHandler(onClick, container),
        onContextMenu: wrapHandler(onContextMenu, container),
        onWheel: wrapHandler(onWheel, container),
        onMouseEnter: hasActiveSelection ? undefined : onPaneMouseEnter,
        onMouseDown: hasActiveSelection ? onMouseDown : undefined,
        onMouseMove: hasActiveSelection ? onMouseMove : onPaneMouseMove,
        onMouseUp: hasActiveSelection ? onMouseUp : undefined,
        onMouseLeave: hasActiveSelection ? onMouseLeave : onPaneMouseLeave,
        ref: container,
        style: containerStyle
    }, children, (0, _reactDefault.default).createElement(UserSelection, null));
});
Pane.displayName = 'Pane';
function isParentSelected(node, nodeInternals) {
    const parentId = node.parentNode || node.parentId;
    if (!parentId) return false;
    const parentNode = nodeInternals.get(parentId);
    if (!parentNode) return false;
    if (parentNode.selected) return true;
    return isParentSelected(parentNode, nodeInternals);
}
function hasSelector(target, selector, nodeRef) {
    let current = target;
    do {
        if (current?.matches(selector)) return true;
        if (current === nodeRef.current) return false;
        current = current.parentElement;
    }while (current);
    return false;
}
// looks for all selected nodes and created a NodeDragItem for each of them
function getDragItems(nodeInternals, nodesDraggable, mousePos, nodeId) {
    return Array.from(nodeInternals.values()).filter((n)=>(n.selected || n.id === nodeId) && (!n.parentNode || n.parentId || !isParentSelected(n, nodeInternals)) && (n.draggable || nodesDraggable && typeof n.draggable === 'undefined')).map((n)=>({
            id: n.id,
            position: n.position || {
                x: 0,
                y: 0
            },
            positionAbsolute: n.positionAbsolute || {
                x: 0,
                y: 0
            },
            distance: {
                x: mousePos.x - (n.positionAbsolute?.x ?? 0),
                y: mousePos.y - (n.positionAbsolute?.y ?? 0)
            },
            delta: {
                x: 0,
                y: 0
            },
            extent: n.extent,
            parentNode: n.parentNode || n.parentId,
            parentId: n.parentNode || n.parentId,
            width: n.width,
            height: n.height,
            expandParent: n.expandParent
        }));
}
function clampNodeExtent(node, extent) {
    if (!extent || extent === 'parent') return extent;
    return [
        extent[0],
        [
            extent[1][0] - (node.width || 0),
            extent[1][1] - (node.height || 0)
        ]
    ];
}
function calcNextPosition(node, nextPosition, nodeInternals, nodeExtent, nodeOrigin = [
    0,
    0
], onError) {
    const clampedNodeExtent = clampNodeExtent(node, node.extent || nodeExtent);
    let currentExtent = clampedNodeExtent;
    const parentId = node.parentNode || node.parentId;
    if (node.extent === 'parent' && !node.expandParent) {
        if (parentId && node.width && node.height) {
            const parent = nodeInternals.get(parentId);
            const { x: parentX, y: parentY } = getNodePositionWithOrigin(parent, nodeOrigin).positionAbsolute;
            currentExtent = parent && isNumeric(parentX) && isNumeric(parentY) && isNumeric(parent.width) && isNumeric(parent.height) ? [
                [
                    parentX + node.width * nodeOrigin[0],
                    parentY + node.height * nodeOrigin[1]
                ],
                [
                    parentX + parent.width - node.width + node.width * nodeOrigin[0],
                    parentY + parent.height - node.height + node.height * nodeOrigin[1]
                ]
            ] : currentExtent;
        } else {
            onError?.('005', errorMessages['error005']());
            currentExtent = clampedNodeExtent;
        }
    } else if (node.extent && parentId && node.extent !== 'parent') {
        const parent = nodeInternals.get(parentId);
        const { x: parentX, y: parentY } = getNodePositionWithOrigin(parent, nodeOrigin).positionAbsolute;
        currentExtent = [
            [
                node.extent[0][0] + parentX,
                node.extent[0][1] + parentY
            ],
            [
                node.extent[1][0] + parentX,
                node.extent[1][1] + parentY
            ]
        ];
    }
    let parentPosition = {
        x: 0,
        y: 0
    };
    if (parentId) {
        const parentNode = nodeInternals.get(parentId);
        parentPosition = getNodePositionWithOrigin(parentNode, nodeOrigin).positionAbsolute;
    }
    const positionAbsolute = currentExtent && currentExtent !== 'parent' ? clampPosition(nextPosition, currentExtent) : nextPosition;
    return {
        position: {
            x: positionAbsolute.x - parentPosition.x,
            y: positionAbsolute.y - parentPosition.y
        },
        positionAbsolute
    };
}
// returns two params:
// 1. the dragged node (or the first of the list, if we are dragging a node selection)
// 2. array of selected nodes (for multi selections)
function getEventHandlerParams({ nodeId, dragItems, nodeInternals }) {
    const extentedDragItems = dragItems.map((n)=>{
        const node = nodeInternals.get(n.id);
        return {
            ...node,
            position: n.position,
            positionAbsolute: n.positionAbsolute
        };
    });
    return [
        nodeId ? extentedDragItems.find((n)=>n.id === nodeId) : extentedDragItems[0],
        extentedDragItems
    ];
}
const getHandleBounds = (selector, nodeElement, zoom, nodeOrigin)=>{
    const handles = nodeElement.querySelectorAll(selector);
    if (!handles || !handles.length) return null;
    const handlesArray = Array.from(handles);
    const nodeBounds = nodeElement.getBoundingClientRect();
    const nodeOffset = {
        x: nodeBounds.width * nodeOrigin[0],
        y: nodeBounds.height * nodeOrigin[1]
    };
    return handlesArray.map((handle)=>{
        const handleBounds = handle.getBoundingClientRect();
        return {
            id: handle.getAttribute('data-handleid'),
            position: handle.getAttribute('data-handlepos'),
            x: (handleBounds.left - nodeBounds.left - nodeOffset.x) / zoom,
            y: (handleBounds.top - nodeBounds.top - nodeOffset.y) / zoom,
            ...getDimensions(handle)
        };
    });
};
function getMouseHandler(id, getState, handler) {
    return handler === undefined ? handler : (event)=>{
        const node = getState().nodeInternals.get(id);
        if (node) handler(event, {
            ...node
        });
    };
}
// this handler is called by
// 1. the click handler when node is not draggable or selectNodesOnDrag = false
// or
// 2. the on drag start handler when node is draggable and selectNodesOnDrag = true
function handleNodeClick({ id, store, unselect = false, nodeRef }) {
    const { addSelectedNodes, unselectNodesAndEdges, multiSelectionActive, nodeInternals, onError } = store.getState();
    const node = nodeInternals.get(id);
    if (!node) {
        onError?.('012', errorMessages['error012'](id));
        return;
    }
    store.setState({
        nodesSelectionActive: false
    });
    if (!node.selected) addSelectedNodes([
        id
    ]);
    else if (unselect || node.selected && multiSelectionActive) {
        unselectNodesAndEdges({
            nodes: [
                node
            ],
            edges: []
        });
        requestAnimationFrame(()=>nodeRef?.current?.blur());
    }
}
function useGetPointerPosition() {
    const store = useStoreApi();
    // returns the pointer position projected to the RF coordinate system
    const getPointerPosition = (0, _react.useCallback)(({ sourceEvent })=>{
        const { transform, snapGrid, snapToGrid } = store.getState();
        const x = sourceEvent.touches ? sourceEvent.touches[0].clientX : sourceEvent.clientX;
        const y = sourceEvent.touches ? sourceEvent.touches[0].clientY : sourceEvent.clientY;
        const pointerPos = {
            x: (x - transform[0]) / transform[2],
            y: (y - transform[1]) / transform[2]
        };
        // we need the snapped position in order to be able to skip unnecessary drag events
        return {
            xSnapped: snapToGrid ? snapGrid[0] * Math.round(pointerPos.x / snapGrid[0]) : pointerPos.x,
            ySnapped: snapToGrid ? snapGrid[1] * Math.round(pointerPos.y / snapGrid[1]) : pointerPos.y,
            ...pointerPos
        };
    }, []);
    return getPointerPosition;
}
function wrapSelectionDragFunc(selectionFunc) {
    return (event, _, nodes)=>selectionFunc?.(event, nodes);
}
function useDrag({ nodeRef, disabled = false, noDragClassName, handleSelector, nodeId, isSelectable, selectNodesOnDrag }) {
    const store = useStoreApi();
    const [dragging, setDragging] = (0, _react.useState)(false);
    const dragItems = (0, _react.useRef)([]);
    const lastPos = (0, _react.useRef)({
        x: null,
        y: null
    });
    const autoPanId = (0, _react.useRef)(0);
    const containerBounds = (0, _react.useRef)(null);
    const mousePosition = (0, _react.useRef)({
        x: 0,
        y: 0
    });
    const dragEvent = (0, _react.useRef)(null);
    const autoPanStarted = (0, _react.useRef)(false);
    const dragStarted = (0, _react.useRef)(false);
    const abortDrag = (0, _react.useRef)(false);
    const getPointerPosition = useGetPointerPosition();
    (0, _react.useEffect)(()=>{
        if (nodeRef?.current) {
            const selection = (0, _d3Selection.select)(nodeRef.current);
            const updateNodes = ({ x, y })=>{
                const { nodeInternals, onNodeDrag, onSelectionDrag, updateNodePositions, nodeExtent, snapGrid, snapToGrid, nodeOrigin, onError } = store.getState();
                lastPos.current = {
                    x,
                    y
                };
                let hasChange = false;
                let nodesBox = {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 0
                };
                if (dragItems.current.length > 1 && nodeExtent) {
                    const rect = getNodesBounds(dragItems.current, nodeOrigin);
                    nodesBox = rectToBox(rect);
                }
                dragItems.current = dragItems.current.map((n)=>{
                    const nextPosition = {
                        x: x - n.distance.x,
                        y: y - n.distance.y
                    };
                    if (snapToGrid) {
                        nextPosition.x = snapGrid[0] * Math.round(nextPosition.x / snapGrid[0]);
                        nextPosition.y = snapGrid[1] * Math.round(nextPosition.y / snapGrid[1]);
                    }
                    // if there is selection with multiple nodes and a node extent is set, we need to adjust the node extent for each node
                    // based on its position so that the node stays at it's position relative to the selection.
                    const adjustedNodeExtent = [
                        [
                            nodeExtent[0][0],
                            nodeExtent[0][1]
                        ],
                        [
                            nodeExtent[1][0],
                            nodeExtent[1][1]
                        ]
                    ];
                    if (dragItems.current.length > 1 && nodeExtent && !n.extent) {
                        adjustedNodeExtent[0][0] = n.positionAbsolute.x - nodesBox.x + nodeExtent[0][0];
                        adjustedNodeExtent[1][0] = n.positionAbsolute.x + (n.width ?? 0) - nodesBox.x2 + nodeExtent[1][0];
                        adjustedNodeExtent[0][1] = n.positionAbsolute.y - nodesBox.y + nodeExtent[0][1];
                        adjustedNodeExtent[1][1] = n.positionAbsolute.y + (n.height ?? 0) - nodesBox.y2 + nodeExtent[1][1];
                    }
                    const updatedPos = calcNextPosition(n, nextPosition, nodeInternals, adjustedNodeExtent, nodeOrigin, onError);
                    // we want to make sure that we only fire a change event when there is a change
                    hasChange = hasChange || n.position.x !== updatedPos.position.x || n.position.y !== updatedPos.position.y;
                    n.position = updatedPos.position;
                    n.positionAbsolute = updatedPos.positionAbsolute;
                    return n;
                });
                if (!hasChange) return;
                updateNodePositions(dragItems.current, true, true);
                setDragging(true);
                const onDrag = nodeId ? onNodeDrag : wrapSelectionDragFunc(onSelectionDrag);
                if (onDrag && dragEvent.current) {
                    const [currentNode, nodes] = getEventHandlerParams({
                        nodeId,
                        dragItems: dragItems.current,
                        nodeInternals
                    });
                    onDrag(dragEvent.current, currentNode, nodes);
                }
            };
            const autoPan = ()=>{
                if (!containerBounds.current) return;
                const [xMovement, yMovement] = calcAutoPan(mousePosition.current, containerBounds.current);
                if (xMovement !== 0 || yMovement !== 0) {
                    const { transform, panBy } = store.getState();
                    lastPos.current.x = (lastPos.current.x ?? 0) - xMovement / transform[2];
                    lastPos.current.y = (lastPos.current.y ?? 0) - yMovement / transform[2];
                    if (panBy({
                        x: xMovement,
                        y: yMovement
                    })) updateNodes(lastPos.current);
                }
                autoPanId.current = requestAnimationFrame(autoPan);
            };
            const startDrag = (event)=>{
                const { nodeInternals, multiSelectionActive, nodesDraggable, unselectNodesAndEdges, onNodeDragStart, onSelectionDragStart } = store.getState();
                dragStarted.current = true;
                const onStart = nodeId ? onNodeDragStart : wrapSelectionDragFunc(onSelectionDragStart);
                if ((!selectNodesOnDrag || !isSelectable) && !multiSelectionActive && nodeId) {
                    if (!nodeInternals.get(nodeId)?.selected) // we need to reset selected nodes when selectNodesOnDrag=false
                    unselectNodesAndEdges();
                }
                if (nodeId && isSelectable && selectNodesOnDrag) handleNodeClick({
                    id: nodeId,
                    store,
                    nodeRef: nodeRef
                });
                const pointerPos = getPointerPosition(event);
                lastPos.current = pointerPos;
                dragItems.current = getDragItems(nodeInternals, nodesDraggable, pointerPos, nodeId);
                if (onStart && dragItems.current) {
                    const [currentNode, nodes] = getEventHandlerParams({
                        nodeId,
                        dragItems: dragItems.current,
                        nodeInternals
                    });
                    onStart(event.sourceEvent, currentNode, nodes);
                }
            };
            if (disabled) selection.on('.drag', null);
            else {
                const dragHandler = (0, _d3Drag.drag)().on('start', (event)=>{
                    const { domNode, nodeDragThreshold } = store.getState();
                    if (nodeDragThreshold === 0) startDrag(event);
                    abortDrag.current = false;
                    const pointerPos = getPointerPosition(event);
                    lastPos.current = pointerPos;
                    containerBounds.current = domNode?.getBoundingClientRect() || null;
                    mousePosition.current = getEventPosition(event.sourceEvent, containerBounds.current);
                }).on('drag', (event)=>{
                    const pointerPos = getPointerPosition(event);
                    const { autoPanOnNodeDrag, nodeDragThreshold } = store.getState();
                    if (event.sourceEvent.type === 'touchmove' && event.sourceEvent.touches.length > 1) abortDrag.current = true;
                    if (abortDrag.current) return;
                    if (!autoPanStarted.current && dragStarted.current && autoPanOnNodeDrag) {
                        autoPanStarted.current = true;
                        autoPan();
                    }
                    if (!dragStarted.current) {
                        const x = pointerPos.xSnapped - (lastPos?.current?.x ?? 0);
                        const y = pointerPos.ySnapped - (lastPos?.current?.y ?? 0);
                        const distance = Math.sqrt(x * x + y * y);
                        if (distance > nodeDragThreshold) startDrag(event);
                    }
                    // skip events without movement
                    if ((lastPos.current.x !== pointerPos.xSnapped || lastPos.current.y !== pointerPos.ySnapped) && dragItems.current && dragStarted.current) {
                        dragEvent.current = event.sourceEvent;
                        mousePosition.current = getEventPosition(event.sourceEvent, containerBounds.current);
                        updateNodes(pointerPos);
                    }
                }).on('end', (event)=>{
                    if (!dragStarted.current || abortDrag.current) return;
                    setDragging(false);
                    autoPanStarted.current = false;
                    dragStarted.current = false;
                    cancelAnimationFrame(autoPanId.current);
                    if (dragItems.current) {
                        const { updateNodePositions, nodeInternals, onNodeDragStop, onSelectionDragStop } = store.getState();
                        const onStop = nodeId ? onNodeDragStop : wrapSelectionDragFunc(onSelectionDragStop);
                        updateNodePositions(dragItems.current, false, false);
                        if (onStop) {
                            const [currentNode, nodes] = getEventHandlerParams({
                                nodeId,
                                dragItems: dragItems.current,
                                nodeInternals
                            });
                            onStop(event.sourceEvent, currentNode, nodes);
                        }
                    }
                }).filter((event)=>{
                    const target = event.target;
                    const isDraggable = !event.button && (!noDragClassName || !hasSelector(target, `.${noDragClassName}`, nodeRef)) && (!handleSelector || hasSelector(target, handleSelector, nodeRef));
                    return isDraggable;
                });
                selection.call(dragHandler);
                return ()=>{
                    selection.on('.drag', null);
                };
            }
        }
    }, [
        nodeRef,
        disabled,
        noDragClassName,
        handleSelector,
        isSelectable,
        store,
        nodeId,
        selectNodesOnDrag,
        getPointerPosition
    ]);
    return dragging;
}
function useUpdateNodePositions() {
    const store = useStoreApi();
    const updatePositions = (0, _react.useCallback)((params)=>{
        const { nodeInternals, nodeExtent, updateNodePositions, getNodes, snapToGrid, snapGrid, onError, nodesDraggable } = store.getState();
        const selectedNodes = getNodes().filter((n)=>n.selected && (n.draggable || nodesDraggable && typeof n.draggable === 'undefined'));
        // by default a node moves 5px on each key press, or 20px if shift is pressed
        // if snap grid is enabled, we use that for the velocity.
        const xVelo = snapToGrid ? snapGrid[0] : 5;
        const yVelo = snapToGrid ? snapGrid[1] : 5;
        const factor = params.isShiftPressed ? 4 : 1;
        const positionDiffX = params.x * xVelo * factor;
        const positionDiffY = params.y * yVelo * factor;
        const nodeUpdates = selectedNodes.map((n)=>{
            if (n.positionAbsolute) {
                const nextPosition = {
                    x: n.positionAbsolute.x + positionDiffX,
                    y: n.positionAbsolute.y + positionDiffY
                };
                if (snapToGrid) {
                    nextPosition.x = snapGrid[0] * Math.round(nextPosition.x / snapGrid[0]);
                    nextPosition.y = snapGrid[1] * Math.round(nextPosition.y / snapGrid[1]);
                }
                const { positionAbsolute, position } = calcNextPosition(n, nextPosition, nodeInternals, nodeExtent, undefined, onError);
                n.position = position;
                n.positionAbsolute = positionAbsolute;
            }
            return n;
        });
        updateNodePositions(nodeUpdates, true, false);
    }, []);
    return updatePositions;
}
const arrowKeyDiffs = {
    ArrowUp: {
        x: 0,
        y: -1
    },
    ArrowDown: {
        x: 0,
        y: 1
    },
    ArrowLeft: {
        x: -1,
        y: 0
    },
    ArrowRight: {
        x: 1,
        y: 0
    }
};
var wrapNode = (NodeComponent)=>{
    const NodeWrapper = ({ id, type, data, xPos, yPos, xPosOrigin, yPosOrigin, selected, onClick, onMouseEnter, onMouseMove, onMouseLeave, onContextMenu, onDoubleClick, style, className, isDraggable, isSelectable, isConnectable, isFocusable, selectNodesOnDrag, sourcePosition, targetPosition, hidden, resizeObserver, dragHandle, zIndex, isParent, noDragClassName, noPanClassName, initialized, disableKeyboardA11y, ariaLabel, rfId, hasHandleBounds })=>{
        const store = useStoreApi();
        const nodeRef = (0, _react.useRef)(null);
        const prevNodeRef = (0, _react.useRef)(null);
        const prevSourcePosition = (0, _react.useRef)(sourcePosition);
        const prevTargetPosition = (0, _react.useRef)(targetPosition);
        const prevType = (0, _react.useRef)(type);
        const hasPointerEvents = isSelectable || isDraggable || onClick || onMouseEnter || onMouseMove || onMouseLeave;
        const updatePositions = useUpdateNodePositions();
        const onMouseEnterHandler = getMouseHandler(id, store.getState, onMouseEnter);
        const onMouseMoveHandler = getMouseHandler(id, store.getState, onMouseMove);
        const onMouseLeaveHandler = getMouseHandler(id, store.getState, onMouseLeave);
        const onContextMenuHandler = getMouseHandler(id, store.getState, onContextMenu);
        const onDoubleClickHandler = getMouseHandler(id, store.getState, onDoubleClick);
        const onSelectNodeHandler = (event)=>{
            const { nodeDragThreshold } = store.getState();
            if (isSelectable && (!selectNodesOnDrag || !isDraggable || nodeDragThreshold > 0)) // this handler gets called within the drag start event when selectNodesOnDrag=true
            handleNodeClick({
                id,
                store,
                nodeRef
            });
            if (onClick) {
                const node = store.getState().nodeInternals.get(id);
                if (node) onClick(event, {
                    ...node
                });
            }
        };
        const onKeyDown = (event)=>{
            if (isInputDOMNode(event)) return;
            if (disableKeyboardA11y) return;
            if (elementSelectionKeys.includes(event.key) && isSelectable) {
                const unselect = event.key === 'Escape';
                handleNodeClick({
                    id,
                    store,
                    unselect,
                    nodeRef
                });
            } else if (isDraggable && selected && Object.prototype.hasOwnProperty.call(arrowKeyDiffs, event.key)) {
                store.setState({
                    ariaLiveMessage: `Moved selected node ${event.key.replace('Arrow', '').toLowerCase()}. New position, x: ${~~xPos}, y: ${~~yPos}`
                });
                updatePositions({
                    x: arrowKeyDiffs[event.key].x,
                    y: arrowKeyDiffs[event.key].y,
                    isShiftPressed: event.shiftKey
                });
            }
        };
        (0, _react.useEffect)(()=>{
            return ()=>{
                if (prevNodeRef.current) {
                    resizeObserver?.unobserve(prevNodeRef.current);
                    prevNodeRef.current = null;
                }
            };
        }, []);
        (0, _react.useEffect)(()=>{
            if (nodeRef.current && !hidden) {
                const currNode = nodeRef.current;
                if (!initialized || !hasHandleBounds || prevNodeRef.current !== currNode) {
                    // At this point we always want to make sure that the node gets re-measured / re-initialized.
                    // We need to unobserve it first in case it is still observed
                    if (prevNodeRef.current) resizeObserver?.unobserve(prevNodeRef.current);
                    resizeObserver?.observe(currNode);
                    prevNodeRef.current = currNode;
                }
            }
        }, [
            hidden,
            initialized,
            hasHandleBounds
        ]);
        (0, _react.useEffect)(()=>{
            // when the user programmatically changes the source or handle position, we re-initialize the node
            const typeChanged = prevType.current !== type;
            const sourcePosChanged = prevSourcePosition.current !== sourcePosition;
            const targetPosChanged = prevTargetPosition.current !== targetPosition;
            if (nodeRef.current && (typeChanged || sourcePosChanged || targetPosChanged)) {
                if (typeChanged) prevType.current = type;
                if (sourcePosChanged) prevSourcePosition.current = sourcePosition;
                if (targetPosChanged) prevTargetPosition.current = targetPosition;
                store.getState().updateNodeDimensions([
                    {
                        id,
                        nodeElement: nodeRef.current,
                        forceUpdate: true
                    }
                ]);
            }
        }, [
            id,
            type,
            sourcePosition,
            targetPosition
        ]);
        const dragging = useDrag({
            nodeRef,
            disabled: hidden || !isDraggable,
            noDragClassName,
            handleSelector: dragHandle,
            nodeId: id,
            isSelectable,
            selectNodesOnDrag
        });
        if (hidden) return null;
        return (0, _reactDefault.default).createElement("div", {
            className: (0, _classcatDefault.default)([
                'react-flow__node',
                `react-flow__node-${type}`,
                {
                    // this is overwritable by passing `nopan` as a class name
                    [noPanClassName]: isDraggable
                },
                className,
                {
                    selected,
                    selectable: isSelectable,
                    parent: isParent,
                    dragging
                }
            ]),
            ref: nodeRef,
            style: {
                zIndex,
                transform: `translate(${xPosOrigin}px,${yPosOrigin}px)`,
                pointerEvents: hasPointerEvents ? 'all' : 'none',
                visibility: initialized ? 'visible' : 'hidden',
                ...style
            },
            "data-id": id,
            "data-testid": `rf__node-${id}`,
            onMouseEnter: onMouseEnterHandler,
            onMouseMove: onMouseMoveHandler,
            onMouseLeave: onMouseLeaveHandler,
            onContextMenu: onContextMenuHandler,
            onClick: onSelectNodeHandler,
            onDoubleClick: onDoubleClickHandler,
            onKeyDown: isFocusable ? onKeyDown : undefined,
            tabIndex: isFocusable ? 0 : undefined,
            role: isFocusable ? 'button' : undefined,
            "aria-describedby": disableKeyboardA11y ? undefined : `${ARIA_NODE_DESC_KEY}-${rfId}`,
            "aria-label": ariaLabel
        }, (0, _reactDefault.default).createElement(Provider, {
            value: id
        }, (0, _reactDefault.default).createElement(NodeComponent, {
            id: id,
            data: data,
            type: type,
            xPos: xPos,
            yPos: yPos,
            selected: selected,
            isConnectable: isConnectable,
            sourcePosition: sourcePosition,
            targetPosition: targetPosition,
            dragging: dragging,
            dragHandle: dragHandle,
            zIndex: zIndex
        })));
    };
    NodeWrapper.displayName = 'NodeWrapper';
    return (0, _react.memo)(NodeWrapper);
};
/**
 * The nodes selection rectangle gets displayed when a user
 * made a selection with on or several nodes
 */ const selector$7 = (s)=>{
    const selectedNodes = s.getNodes().filter((n)=>n.selected);
    return {
        ...getNodesBounds(selectedNodes, s.nodeOrigin),
        transformString: `translate(${s.transform[0]}px,${s.transform[1]}px) scale(${s.transform[2]})`,
        userSelectionActive: s.userSelectionActive
    };
};
function NodesSelection({ onSelectionContextMenu, noPanClassName, disableKeyboardA11y }) {
    const store = useStoreApi();
    const { width, height, x: left, y: top, transformString, userSelectionActive } = useStore(selector$7, (0, _shallow.shallow));
    const updatePositions = useUpdateNodePositions();
    const nodeRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (!disableKeyboardA11y) nodeRef.current?.focus({
            preventScroll: true
        });
    }, [
        disableKeyboardA11y
    ]);
    useDrag({
        nodeRef
    });
    if (userSelectionActive || !width || !height) return null;
    const onContextMenu = onSelectionContextMenu ? (event)=>{
        const selectedNodes = store.getState().getNodes().filter((n)=>n.selected);
        onSelectionContextMenu(event, selectedNodes);
    } : undefined;
    const onKeyDown = (event)=>{
        if (Object.prototype.hasOwnProperty.call(arrowKeyDiffs, event.key)) updatePositions({
            x: arrowKeyDiffs[event.key].x,
            y: arrowKeyDiffs[event.key].y,
            isShiftPressed: event.shiftKey
        });
    };
    return (0, _reactDefault.default).createElement("div", {
        className: (0, _classcatDefault.default)([
            'react-flow__nodesselection',
            'react-flow__container',
            noPanClassName
        ]),
        style: {
            transform: transformString
        }
    }, (0, _reactDefault.default).createElement("div", {
        ref: nodeRef,
        className: "react-flow__nodesselection-rect",
        onContextMenu: onContextMenu,
        tabIndex: disableKeyboardA11y ? undefined : -1,
        onKeyDown: disableKeyboardA11y ? undefined : onKeyDown,
        style: {
            width,
            height,
            top,
            left
        }
    }));
}
var NodesSelection$1 = (0, _react.memo)(NodesSelection);
const selector$6 = (s)=>s.nodesSelectionActive;
const FlowRenderer = ({ children, onPaneClick, onPaneMouseEnter, onPaneMouseMove, onPaneMouseLeave, onPaneContextMenu, onPaneScroll, deleteKeyCode, onMove, onMoveStart, onMoveEnd, selectionKeyCode, selectionOnDrag, selectionMode, onSelectionStart, onSelectionEnd, multiSelectionKeyCode, panActivationKeyCode, zoomActivationKeyCode, elementsSelectable, zoomOnScroll, zoomOnPinch, panOnScroll: _panOnScroll, panOnScrollSpeed, panOnScrollMode, zoomOnDoubleClick, panOnDrag: _panOnDrag, defaultViewport, translateExtent, minZoom, maxZoom, preventScrolling, onSelectionContextMenu, noWheelClassName, noPanClassName, disableKeyboardA11y })=>{
    const nodesSelectionActive = useStore(selector$6);
    const selectionKeyPressed = useKeyPress(selectionKeyCode);
    const panActivationKeyPressed = useKeyPress(panActivationKeyCode);
    const panOnDrag = panActivationKeyPressed || _panOnDrag;
    const panOnScroll = panActivationKeyPressed || _panOnScroll;
    const isSelecting = selectionKeyPressed || selectionOnDrag && panOnDrag !== true;
    useGlobalKeyHandler({
        deleteKeyCode,
        multiSelectionKeyCode
    });
    return (0, _reactDefault.default).createElement(ZoomPane, {
        onMove: onMove,
        onMoveStart: onMoveStart,
        onMoveEnd: onMoveEnd,
        onPaneContextMenu: onPaneContextMenu,
        elementsSelectable: elementsSelectable,
        zoomOnScroll: zoomOnScroll,
        zoomOnPinch: zoomOnPinch,
        panOnScroll: panOnScroll,
        panOnScrollSpeed: panOnScrollSpeed,
        panOnScrollMode: panOnScrollMode,
        zoomOnDoubleClick: zoomOnDoubleClick,
        panOnDrag: !selectionKeyPressed && panOnDrag,
        defaultViewport: defaultViewport,
        translateExtent: translateExtent,
        minZoom: minZoom,
        maxZoom: maxZoom,
        zoomActivationKeyCode: zoomActivationKeyCode,
        preventScrolling: preventScrolling,
        noWheelClassName: noWheelClassName,
        noPanClassName: noPanClassName
    }, (0, _reactDefault.default).createElement(Pane, {
        onSelectionStart: onSelectionStart,
        onSelectionEnd: onSelectionEnd,
        onPaneClick: onPaneClick,
        onPaneMouseEnter: onPaneMouseEnter,
        onPaneMouseMove: onPaneMouseMove,
        onPaneMouseLeave: onPaneMouseLeave,
        onPaneContextMenu: onPaneContextMenu,
        onPaneScroll: onPaneScroll,
        panOnDrag: panOnDrag,
        isSelecting: !!isSelecting,
        selectionMode: selectionMode
    }, children, nodesSelectionActive && (0, _reactDefault.default).createElement(NodesSelection$1, {
        onSelectionContextMenu: onSelectionContextMenu,
        noPanClassName: noPanClassName,
        disableKeyboardA11y: disableKeyboardA11y
    })));
};
FlowRenderer.displayName = 'FlowRenderer';
var FlowRenderer$1 = (0, _react.memo)(FlowRenderer);
function useVisibleNodes(onlyRenderVisible) {
    const nodes = useStore((0, _react.useCallback)((s)=>onlyRenderVisible ? getNodesInside(s.nodeInternals, {
            x: 0,
            y: 0,
            width: s.width,
            height: s.height
        }, s.transform, true) : s.getNodes(), [
        onlyRenderVisible
    ]));
    return nodes;
}
function createNodeTypes(nodeTypes) {
    const standardTypes = {
        input: wrapNode(nodeTypes.input || InputNode$1),
        default: wrapNode(nodeTypes.default || DefaultNode$1),
        output: wrapNode(nodeTypes.output || OutputNode$1),
        group: wrapNode(nodeTypes.group || GroupNode)
    };
    const wrappedTypes = {};
    const specialTypes = Object.keys(nodeTypes).filter((k)=>![
            'input',
            'default',
            'output',
            'group'
        ].includes(k)).reduce((res, key)=>{
        res[key] = wrapNode(nodeTypes[key] || DefaultNode$1);
        return res;
    }, wrappedTypes);
    return {
        ...standardTypes,
        ...specialTypes
    };
}
const getPositionWithOrigin = ({ x, y, width, height, origin })=>{
    if (!width || !height) return {
        x,
        y
    };
    if (origin[0] < 0 || origin[1] < 0 || origin[0] > 1 || origin[1] > 1) return {
        x,
        y
    };
    return {
        x: x - width * origin[0],
        y: y - height * origin[1]
    };
};
const selector$5 = (s)=>({
        nodesDraggable: s.nodesDraggable,
        nodesConnectable: s.nodesConnectable,
        nodesFocusable: s.nodesFocusable,
        elementsSelectable: s.elementsSelectable,
        updateNodeDimensions: s.updateNodeDimensions,
        onError: s.onError
    });
const NodeRenderer = (props)=>{
    const { nodesDraggable, nodesConnectable, nodesFocusable, elementsSelectable, updateNodeDimensions, onError } = useStore(selector$5, (0, _shallow.shallow));
    const nodes = useVisibleNodes(props.onlyRenderVisibleElements);
    const resizeObserverRef = (0, _react.useRef)();
    const resizeObserver = (0, _react.useMemo)(()=>{
        if (typeof ResizeObserver === 'undefined') return null;
        const observer = new ResizeObserver((entries)=>{
            const updates = entries.map((entry)=>({
                    id: entry.target.getAttribute('data-id'),
                    nodeElement: entry.target,
                    forceUpdate: true
                }));
            updateNodeDimensions(updates);
        });
        resizeObserverRef.current = observer;
        return observer;
    }, []);
    (0, _react.useEffect)(()=>{
        return ()=>{
            resizeObserverRef?.current?.disconnect();
        };
    }, []);
    return (0, _reactDefault.default).createElement("div", {
        className: "react-flow__nodes",
        style: containerStyle
    }, nodes.map((node)=>{
        let nodeType = node.type || 'default';
        if (!props.nodeTypes[nodeType]) {
            onError?.('003', errorMessages['error003'](nodeType));
            nodeType = 'default';
        }
        const NodeComponent = props.nodeTypes[nodeType] || props.nodeTypes.default;
        const isDraggable = !!(node.draggable || nodesDraggable && typeof node.draggable === 'undefined');
        const isSelectable = !!(node.selectable || elementsSelectable && typeof node.selectable === 'undefined');
        const isConnectable = !!(node.connectable || nodesConnectable && typeof node.connectable === 'undefined');
        const isFocusable = !!(node.focusable || nodesFocusable && typeof node.focusable === 'undefined');
        const clampedPosition = props.nodeExtent ? clampPosition(node.positionAbsolute, props.nodeExtent) : node.positionAbsolute;
        const posX = clampedPosition?.x ?? 0;
        const posY = clampedPosition?.y ?? 0;
        const posOrigin = getPositionWithOrigin({
            x: posX,
            y: posY,
            width: node.width ?? 0,
            height: node.height ?? 0,
            origin: props.nodeOrigin
        });
        return (0, _reactDefault.default).createElement(NodeComponent, {
            key: node.id,
            id: node.id,
            className: node.className,
            style: node.style,
            type: nodeType,
            data: node.data,
            sourcePosition: node.sourcePosition || Position.Bottom,
            targetPosition: node.targetPosition || Position.Top,
            hidden: node.hidden,
            xPos: posX,
            yPos: posY,
            xPosOrigin: posOrigin.x,
            yPosOrigin: posOrigin.y,
            selectNodesOnDrag: props.selectNodesOnDrag,
            onClick: props.onNodeClick,
            onMouseEnter: props.onNodeMouseEnter,
            onMouseMove: props.onNodeMouseMove,
            onMouseLeave: props.onNodeMouseLeave,
            onContextMenu: props.onNodeContextMenu,
            onDoubleClick: props.onNodeDoubleClick,
            selected: !!node.selected,
            isDraggable: isDraggable,
            isSelectable: isSelectable,
            isConnectable: isConnectable,
            isFocusable: isFocusable,
            resizeObserver: resizeObserver,
            dragHandle: node.dragHandle,
            zIndex: node[internalsSymbol]?.z ?? 0,
            isParent: !!node[internalsSymbol]?.isParent,
            noDragClassName: props.noDragClassName,
            noPanClassName: props.noPanClassName,
            initialized: !!node.width && !!node.height,
            rfId: props.rfId,
            disableKeyboardA11y: props.disableKeyboardA11y,
            ariaLabel: node.ariaLabel,
            hasHandleBounds: !!node[internalsSymbol]?.handleBounds
        });
    }));
};
NodeRenderer.displayName = 'NodeRenderer';
var NodeRenderer$1 = (0, _react.memo)(NodeRenderer);
const shiftX = (x, shift, position)=>{
    if (position === Position.Left) return x - shift;
    if (position === Position.Right) return x + shift;
    return x;
};
const shiftY = (y, shift, position)=>{
    if (position === Position.Top) return y - shift;
    if (position === Position.Bottom) return y + shift;
    return y;
};
const EdgeUpdaterClassName = 'react-flow__edgeupdater';
const EdgeAnchor = ({ position, centerX, centerY, radius = 10, onMouseDown, onMouseEnter, onMouseOut, type })=>(0, _reactDefault.default).createElement("circle", {
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseOut: onMouseOut,
        className: (0, _classcatDefault.default)([
            EdgeUpdaterClassName,
            `${EdgeUpdaterClassName}-${type}`
        ]),
        cx: shiftX(centerX, radius, position),
        cy: shiftY(centerY, radius, position),
        r: radius,
        stroke: "transparent",
        fill: "transparent"
    });
const alwaysValidConnection = ()=>true;
var wrapEdge = (EdgeComponent)=>{
    const EdgeWrapper = ({ id, className, type, data, onClick, onEdgeDoubleClick, selected, animated, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, source, target, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, elementsSelectable, hidden, sourceHandleId, targetHandleId, onContextMenu, onMouseEnter, onMouseMove, onMouseLeave, reconnectRadius, onReconnect, onReconnectStart, onReconnectEnd, markerEnd, markerStart, rfId, ariaLabel, isFocusable, isReconnectable, pathOptions, interactionWidth, disableKeyboardA11y })=>{
        const edgeRef = (0, _react.useRef)(null);
        const [updateHover, setUpdateHover] = (0, _react.useState)(false);
        const [updating, setUpdating] = (0, _react.useState)(false);
        const store = useStoreApi();
        const markerStartUrl = (0, _react.useMemo)(()=>`url('#${getMarkerId(markerStart, rfId)}')`, [
            markerStart,
            rfId
        ]);
        const markerEndUrl = (0, _react.useMemo)(()=>`url('#${getMarkerId(markerEnd, rfId)}')`, [
            markerEnd,
            rfId
        ]);
        if (hidden) return null;
        const onEdgeClick = (event)=>{
            const { edges, addSelectedEdges, unselectNodesAndEdges, multiSelectionActive } = store.getState();
            const edge = edges.find((e)=>e.id === id);
            if (!edge) return;
            if (elementsSelectable) {
                store.setState({
                    nodesSelectionActive: false
                });
                if (edge.selected && multiSelectionActive) {
                    unselectNodesAndEdges({
                        nodes: [],
                        edges: [
                            edge
                        ]
                    });
                    edgeRef.current?.blur();
                } else addSelectedEdges([
                    id
                ]);
            }
            if (onClick) onClick(event, edge);
        };
        const onEdgeDoubleClickHandler = getMouseHandler$1(id, store.getState, onEdgeDoubleClick);
        const onEdgeContextMenu = getMouseHandler$1(id, store.getState, onContextMenu);
        const onEdgeMouseEnter = getMouseHandler$1(id, store.getState, onMouseEnter);
        const onEdgeMouseMove = getMouseHandler$1(id, store.getState, onMouseMove);
        const onEdgeMouseLeave = getMouseHandler$1(id, store.getState, onMouseLeave);
        const handleEdgeUpdater = (event, isSourceHandle)=>{
            // avoid triggering edge updater if mouse btn is not left
            if (event.button !== 0) return;
            const { edges, isValidConnection: isValidConnectionStore } = store.getState();
            const nodeId = isSourceHandle ? target : source;
            const handleId = (isSourceHandle ? targetHandleId : sourceHandleId) || null;
            const handleType = isSourceHandle ? 'target' : 'source';
            const isValidConnection = isValidConnectionStore || alwaysValidConnection;
            const isTarget = isSourceHandle;
            const edge = edges.find((e)=>e.id === id);
            setUpdating(true);
            onReconnectStart?.(event, edge, handleType);
            const _onReconnectEnd = (evt)=>{
                setUpdating(false);
                onReconnectEnd?.(evt, edge, handleType);
            };
            const onConnectEdge = (connection)=>onReconnect?.(edge, connection);
            handlePointerDown({
                event,
                handleId,
                nodeId,
                onConnect: onConnectEdge,
                isTarget,
                getState: store.getState,
                setState: store.setState,
                isValidConnection,
                edgeUpdaterType: handleType,
                onReconnectEnd: _onReconnectEnd
            });
        };
        const onEdgeUpdaterSourceMouseDown = (event)=>handleEdgeUpdater(event, true);
        const onEdgeUpdaterTargetMouseDown = (event)=>handleEdgeUpdater(event, false);
        const onEdgeUpdaterMouseEnter = ()=>setUpdateHover(true);
        const onEdgeUpdaterMouseOut = ()=>setUpdateHover(false);
        const inactive = !elementsSelectable && !onClick;
        const onKeyDown = (event)=>{
            if (!disableKeyboardA11y && elementSelectionKeys.includes(event.key) && elementsSelectable) {
                const { unselectNodesAndEdges, addSelectedEdges, edges } = store.getState();
                const unselect = event.key === 'Escape';
                if (unselect) {
                    edgeRef.current?.blur();
                    unselectNodesAndEdges({
                        edges: [
                            edges.find((e)=>e.id === id)
                        ]
                    });
                } else addSelectedEdges([
                    id
                ]);
            }
        };
        return (0, _reactDefault.default).createElement("g", {
            className: (0, _classcatDefault.default)([
                'react-flow__edge',
                `react-flow__edge-${type}`,
                className,
                {
                    selected,
                    animated,
                    inactive,
                    updating: updateHover
                }
            ]),
            onClick: onEdgeClick,
            onDoubleClick: onEdgeDoubleClickHandler,
            onContextMenu: onEdgeContextMenu,
            onMouseEnter: onEdgeMouseEnter,
            onMouseMove: onEdgeMouseMove,
            onMouseLeave: onEdgeMouseLeave,
            onKeyDown: isFocusable ? onKeyDown : undefined,
            tabIndex: isFocusable ? 0 : undefined,
            role: isFocusable ? 'button' : 'img',
            "data-testid": `rf__edge-${id}`,
            "aria-label": ariaLabel === null ? undefined : ariaLabel ? ariaLabel : `Edge from ${source} to ${target}`,
            "aria-describedby": isFocusable ? `${ARIA_EDGE_DESC_KEY}-${rfId}` : undefined,
            ref: edgeRef
        }, !updating && (0, _reactDefault.default).createElement(EdgeComponent, {
            id: id,
            source: source,
            target: target,
            selected: selected,
            animated: animated,
            label: label,
            labelStyle: labelStyle,
            labelShowBg: labelShowBg,
            labelBgStyle: labelBgStyle,
            labelBgPadding: labelBgPadding,
            labelBgBorderRadius: labelBgBorderRadius,
            data: data,
            style: style,
            sourceX: sourceX,
            sourceY: sourceY,
            targetX: targetX,
            targetY: targetY,
            sourcePosition: sourcePosition,
            targetPosition: targetPosition,
            sourceHandleId: sourceHandleId,
            targetHandleId: targetHandleId,
            markerStart: markerStartUrl,
            markerEnd: markerEndUrl,
            pathOptions: pathOptions,
            interactionWidth: interactionWidth
        }), isReconnectable && (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (isReconnectable === 'source' || isReconnectable === true) && (0, _reactDefault.default).createElement(EdgeAnchor, {
            position: sourcePosition,
            centerX: sourceX,
            centerY: sourceY,
            radius: reconnectRadius,
            onMouseDown: onEdgeUpdaterSourceMouseDown,
            onMouseEnter: onEdgeUpdaterMouseEnter,
            onMouseOut: onEdgeUpdaterMouseOut,
            type: "source"
        }), (isReconnectable === 'target' || isReconnectable === true) && (0, _reactDefault.default).createElement(EdgeAnchor, {
            position: targetPosition,
            centerX: targetX,
            centerY: targetY,
            radius: reconnectRadius,
            onMouseDown: onEdgeUpdaterTargetMouseDown,
            onMouseEnter: onEdgeUpdaterMouseEnter,
            onMouseOut: onEdgeUpdaterMouseOut,
            type: "target"
        })));
    };
    EdgeWrapper.displayName = 'EdgeWrapper';
    return (0, _react.memo)(EdgeWrapper);
};
function createEdgeTypes(edgeTypes) {
    const standardTypes = {
        default: wrapEdge(edgeTypes.default || BezierEdge),
        straight: wrapEdge(edgeTypes.bezier || StraightEdge),
        step: wrapEdge(edgeTypes.step || StepEdge),
        smoothstep: wrapEdge(edgeTypes.step || SmoothStepEdge),
        simplebezier: wrapEdge(edgeTypes.simplebezier || SimpleBezierEdge)
    };
    const wrappedTypes = {};
    const specialTypes = Object.keys(edgeTypes).filter((k)=>![
            'default',
            'bezier'
        ].includes(k)).reduce((res, key)=>{
        res[key] = wrapEdge(edgeTypes[key] || BezierEdge);
        return res;
    }, wrappedTypes);
    return {
        ...standardTypes,
        ...specialTypes
    };
}
function getHandlePosition(position, nodeRect, handle = null) {
    const x = (handle?.x || 0) + nodeRect.x;
    const y = (handle?.y || 0) + nodeRect.y;
    const width = handle?.width || nodeRect.width;
    const height = handle?.height || nodeRect.height;
    switch(position){
        case Position.Top:
            return {
                x: x + width / 2,
                y
            };
        case Position.Right:
            return {
                x: x + width,
                y: y + height / 2
            };
        case Position.Bottom:
            return {
                x: x + width / 2,
                y: y + height
            };
        case Position.Left:
            return {
                x,
                y: y + height / 2
            };
    }
}
function getHandle(bounds, handleId) {
    if (!bounds) return null;
    if (bounds.length === 1 || !handleId) return bounds[0];
    else if (handleId) return bounds.find((d)=>d.id === handleId) || null;
    return null;
}
const getEdgePositions = (sourceNodeRect, sourceHandle, sourcePosition, targetNodeRect, targetHandle, targetPosition)=>{
    const sourceHandlePos = getHandlePosition(sourcePosition, sourceNodeRect, sourceHandle);
    const targetHandlePos = getHandlePosition(targetPosition, targetNodeRect, targetHandle);
    return {
        sourceX: sourceHandlePos.x,
        sourceY: sourceHandlePos.y,
        targetX: targetHandlePos.x,
        targetY: targetHandlePos.y
    };
};
function isEdgeVisible({ sourcePos, targetPos, sourceWidth, sourceHeight, targetWidth, targetHeight, width, height, transform }) {
    const edgeBox = {
        x: Math.min(sourcePos.x, targetPos.x),
        y: Math.min(sourcePos.y, targetPos.y),
        x2: Math.max(sourcePos.x + sourceWidth, targetPos.x + targetWidth),
        y2: Math.max(sourcePos.y + sourceHeight, targetPos.y + targetHeight)
    };
    if (edgeBox.x === edgeBox.x2) edgeBox.x2 += 1;
    if (edgeBox.y === edgeBox.y2) edgeBox.y2 += 1;
    const viewBox = rectToBox({
        x: (0 - transform[0]) / transform[2],
        y: (0 - transform[1]) / transform[2],
        width: width / transform[2],
        height: height / transform[2]
    });
    const xOverlap = Math.max(0, Math.min(viewBox.x2, edgeBox.x2) - Math.max(viewBox.x, edgeBox.x));
    const yOverlap = Math.max(0, Math.min(viewBox.y2, edgeBox.y2) - Math.max(viewBox.y, edgeBox.y));
    const overlappingArea = Math.ceil(xOverlap * yOverlap);
    return overlappingArea > 0;
}
function getNodeData(node) {
    const handleBounds = node?.[internalsSymbol]?.handleBounds || null;
    const isValid = handleBounds && node?.width && node?.height && typeof node?.positionAbsolute?.x !== 'undefined' && typeof node?.positionAbsolute?.y !== 'undefined';
    return [
        {
            x: node?.positionAbsolute?.x || 0,
            y: node?.positionAbsolute?.y || 0,
            width: node?.width || 0,
            height: node?.height || 0
        },
        handleBounds,
        !!isValid
    ];
}
const defaultEdgeTree = [
    {
        level: 0,
        isMaxLevel: true,
        edges: []
    }
];
function groupEdgesByZLevel(edges, nodeInternals, elevateEdgesOnSelect = false) {
    let maxLevel = -1;
    const levelLookup = edges.reduce((tree, edge)=>{
        const hasZIndex = isNumeric(edge.zIndex);
        let z = hasZIndex ? edge.zIndex : 0;
        if (elevateEdgesOnSelect) {
            const targetNode = nodeInternals.get(edge.target);
            const sourceNode = nodeInternals.get(edge.source);
            const edgeOrConnectedNodeSelected = edge.selected || targetNode?.selected || sourceNode?.selected;
            const selectedZIndex = Math.max(sourceNode?.[internalsSymbol]?.z || 0, targetNode?.[internalsSymbol]?.z || 0, 1000);
            z = (hasZIndex ? edge.zIndex : 0) + (edgeOrConnectedNodeSelected ? selectedZIndex : 0);
        }
        if (tree[z]) tree[z].push(edge);
        else tree[z] = [
            edge
        ];
        maxLevel = z > maxLevel ? z : maxLevel;
        return tree;
    }, {});
    const edgeTree = Object.entries(levelLookup).map(([key, edges])=>{
        const level = +key;
        return {
            edges,
            level,
            isMaxLevel: level === maxLevel
        };
    });
    if (edgeTree.length === 0) return defaultEdgeTree;
    return edgeTree;
}
function useVisibleEdges(onlyRenderVisible, nodeInternals, elevateEdgesOnSelect) {
    const edges = useStore((0, _react.useCallback)((s)=>{
        if (!onlyRenderVisible) return s.edges;
        return s.edges.filter((e)=>{
            const sourceNode = nodeInternals.get(e.source);
            const targetNode = nodeInternals.get(e.target);
            return sourceNode?.width && sourceNode?.height && targetNode?.width && targetNode?.height && isEdgeVisible({
                sourcePos: sourceNode.positionAbsolute || {
                    x: 0,
                    y: 0
                },
                targetPos: targetNode.positionAbsolute || {
                    x: 0,
                    y: 0
                },
                sourceWidth: sourceNode.width,
                sourceHeight: sourceNode.height,
                targetWidth: targetNode.width,
                targetHeight: targetNode.height,
                width: s.width,
                height: s.height,
                transform: s.transform
            });
        });
    }, [
        onlyRenderVisible,
        nodeInternals
    ]));
    return groupEdgesByZLevel(edges, nodeInternals, elevateEdgesOnSelect);
}
const ArrowSymbol = ({ color = 'none', strokeWidth = 1 })=>{
    return (0, _reactDefault.default).createElement("polyline", {
        style: {
            stroke: color,
            strokeWidth
        },
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none",
        points: "-5,-4 0,0 -5,4"
    });
};
const ArrowClosedSymbol = ({ color = 'none', strokeWidth = 1 })=>{
    return (0, _reactDefault.default).createElement("polyline", {
        style: {
            stroke: color,
            fill: color,
            strokeWidth
        },
        strokeLinecap: "round",
        strokeLinejoin: "round",
        points: "-5,-4 0,0 -5,4 -5,-4"
    });
};
const MarkerSymbols = {
    [MarkerType.Arrow]: ArrowSymbol,
    [MarkerType.ArrowClosed]: ArrowClosedSymbol
};
function useMarkerSymbol(type) {
    const store = useStoreApi();
    const symbol = (0, _react.useMemo)(()=>{
        const symbolExists = Object.prototype.hasOwnProperty.call(MarkerSymbols, type);
        if (!symbolExists) {
            store.getState().onError?.('009', errorMessages['error009'](type));
            return null;
        }
        return MarkerSymbols[type];
    }, [
        type
    ]);
    return symbol;
}
const Marker = ({ id, type, color, width = 12.5, height = 12.5, markerUnits = 'strokeWidth', strokeWidth, orient = 'auto-start-reverse' })=>{
    const Symbol1 = useMarkerSymbol(type);
    if (!Symbol1) return null;
    return (0, _reactDefault.default).createElement("marker", {
        className: "react-flow__arrowhead",
        id: id,
        markerWidth: `${width}`,
        markerHeight: `${height}`,
        viewBox: "-10 -10 20 20",
        markerUnits: markerUnits,
        orient: orient,
        refX: "0",
        refY: "0"
    }, (0, _reactDefault.default).createElement(Symbol1, {
        color: color,
        strokeWidth: strokeWidth
    }));
};
const markerSelector = ({ defaultColor, rfId })=>(s)=>{
        const ids = [];
        return s.edges.reduce((markers, edge)=>{
            [
                edge.markerStart,
                edge.markerEnd
            ].forEach((marker)=>{
                if (marker && typeof marker === 'object') {
                    const markerId = getMarkerId(marker, rfId);
                    if (!ids.includes(markerId)) {
                        markers.push({
                            id: markerId,
                            color: marker.color || defaultColor,
                            ...marker
                        });
                        ids.push(markerId);
                    }
                }
            });
            return markers;
        }, []).sort((a, b)=>a.id.localeCompare(b.id));
    };
// when you have multiple flows on a page and you hide the first one, the other ones have no markers anymore
// when they do have markers with the same ids. To prevent this the user can pass a unique id to the react flow wrapper
// that we can then use for creating our unique marker ids
const MarkerDefinitions = ({ defaultColor, rfId })=>{
    const markers = useStore((0, _react.useCallback)(markerSelector({
        defaultColor,
        rfId
    }), [
        defaultColor,
        rfId
    ]), // the id includes all marker options, so we just need to look at that part of the marker
    (a, b)=>!(a.length !== b.length || a.some((m, i)=>m.id !== b[i].id)));
    return (0, _reactDefault.default).createElement("defs", null, markers.map((marker)=>(0, _reactDefault.default).createElement(Marker, {
            id: marker.id,
            key: marker.id,
            type: marker.type,
            color: marker.color,
            width: marker.width,
            height: marker.height,
            markerUnits: marker.markerUnits,
            strokeWidth: marker.strokeWidth,
            orient: marker.orient
        })));
};
MarkerDefinitions.displayName = 'MarkerDefinitions';
var MarkerDefinitions$1 = (0, _react.memo)(MarkerDefinitions);
const selector$4 = (s)=>({
        nodesConnectable: s.nodesConnectable,
        edgesFocusable: s.edgesFocusable,
        edgesUpdatable: s.edgesUpdatable,
        elementsSelectable: s.elementsSelectable,
        width: s.width,
        height: s.height,
        connectionMode: s.connectionMode,
        nodeInternals: s.nodeInternals,
        onError: s.onError
    });
const EdgeRenderer = ({ defaultMarkerColor, onlyRenderVisibleElements, elevateEdgesOnSelect, rfId, edgeTypes, noPanClassName, onEdgeContextMenu, onEdgeMouseEnter, onEdgeMouseMove, onEdgeMouseLeave, onEdgeClick, onEdgeDoubleClick, onReconnect, onReconnectStart, onReconnectEnd, reconnectRadius, children, disableKeyboardA11y })=>{
    const { edgesFocusable, edgesUpdatable, elementsSelectable, width, height, connectionMode, nodeInternals, onError } = useStore(selector$4, (0, _shallow.shallow));
    const edgeTree = useVisibleEdges(onlyRenderVisibleElements, nodeInternals, elevateEdgesOnSelect);
    if (!width) return null;
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, edgeTree.map(({ level, edges, isMaxLevel })=>(0, _reactDefault.default).createElement("svg", {
            key: level,
            style: {
                zIndex: level
            },
            width: width,
            height: height,
            className: "react-flow__edges react-flow__container"
        }, isMaxLevel && (0, _reactDefault.default).createElement(MarkerDefinitions$1, {
            defaultColor: defaultMarkerColor,
            rfId: rfId
        }), (0, _reactDefault.default).createElement("g", null, edges.map((edge)=>{
            const [sourceNodeRect, sourceHandleBounds, sourceIsValid] = getNodeData(nodeInternals.get(edge.source));
            const [targetNodeRect, targetHandleBounds, targetIsValid] = getNodeData(nodeInternals.get(edge.target));
            if (!sourceIsValid || !targetIsValid) return null;
            let edgeType = edge.type || 'default';
            if (!edgeTypes[edgeType]) {
                onError?.('011', errorMessages['error011'](edgeType));
                edgeType = 'default';
            }
            const EdgeComponent = edgeTypes[edgeType] || edgeTypes.default;
            // when connection type is loose we can define all handles as sources and connect source -> source
            const targetNodeHandles = connectionMode === ConnectionMode.Strict ? targetHandleBounds.target : (targetHandleBounds.target ?? []).concat(targetHandleBounds.source ?? []);
            const sourceHandle = getHandle(sourceHandleBounds.source, edge.sourceHandle);
            const targetHandle = getHandle(targetNodeHandles, edge.targetHandle);
            const sourcePosition = sourceHandle?.position || Position.Bottom;
            const targetPosition = targetHandle?.position || Position.Top;
            const isFocusable = !!(edge.focusable || edgesFocusable && typeof edge.focusable === 'undefined');
            const edgeReconnectable = edge.reconnectable || edge.updatable;
            const isReconnectable = typeof onReconnect !== 'undefined' && (edgeReconnectable || edgesUpdatable && typeof edgeReconnectable === 'undefined');
            if (!sourceHandle || !targetHandle) {
                onError?.('008', errorMessages['error008'](sourceHandle, edge));
                return null;
            }
            const { sourceX, sourceY, targetX, targetY } = getEdgePositions(sourceNodeRect, sourceHandle, sourcePosition, targetNodeRect, targetHandle, targetPosition);
            return (0, _reactDefault.default).createElement(EdgeComponent, {
                key: edge.id,
                id: edge.id,
                className: (0, _classcatDefault.default)([
                    edge.className,
                    noPanClassName
                ]),
                type: edgeType,
                data: edge.data,
                selected: !!edge.selected,
                animated: !!edge.animated,
                hidden: !!edge.hidden,
                label: edge.label,
                labelStyle: edge.labelStyle,
                labelShowBg: edge.labelShowBg,
                labelBgStyle: edge.labelBgStyle,
                labelBgPadding: edge.labelBgPadding,
                labelBgBorderRadius: edge.labelBgBorderRadius,
                style: edge.style,
                source: edge.source,
                target: edge.target,
                sourceHandleId: edge.sourceHandle,
                targetHandleId: edge.targetHandle,
                markerEnd: edge.markerEnd,
                markerStart: edge.markerStart,
                sourceX: sourceX,
                sourceY: sourceY,
                targetX: targetX,
                targetY: targetY,
                sourcePosition: sourcePosition,
                targetPosition: targetPosition,
                elementsSelectable: elementsSelectable,
                onContextMenu: onEdgeContextMenu,
                onMouseEnter: onEdgeMouseEnter,
                onMouseMove: onEdgeMouseMove,
                onMouseLeave: onEdgeMouseLeave,
                onClick: onEdgeClick,
                onEdgeDoubleClick: onEdgeDoubleClick,
                onReconnect: onReconnect,
                onReconnectStart: onReconnectStart,
                onReconnectEnd: onReconnectEnd,
                reconnectRadius: reconnectRadius,
                rfId: rfId,
                ariaLabel: edge.ariaLabel,
                isFocusable: isFocusable,
                isReconnectable: isReconnectable,
                pathOptions: 'pathOptions' in edge ? edge.pathOptions : undefined,
                interactionWidth: edge.interactionWidth,
                disableKeyboardA11y: disableKeyboardA11y
            });
        })))), children);
};
EdgeRenderer.displayName = 'EdgeRenderer';
var EdgeRenderer$1 = (0, _react.memo)(EdgeRenderer);
const selector$3 = (s)=>`translate(${s.transform[0]}px,${s.transform[1]}px) scale(${s.transform[2]})`;
function Viewport({ children }) {
    const transform = useStore(selector$3);
    return (0, _reactDefault.default).createElement("div", {
        className: "react-flow__viewport react-flow__container",
        style: {
            transform
        }
    }, children);
}
function useOnInitHandler(onInit) {
    const rfInstance = useReactFlow();
    const isInitialized = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (!isInitialized.current && rfInstance.viewportInitialized && onInit) {
            setTimeout(()=>onInit(rfInstance), 1);
            isInitialized.current = true;
        }
    }, [
        onInit,
        rfInstance.viewportInitialized
    ]);
}
const oppositePosition = {
    [Position.Left]: Position.Right,
    [Position.Right]: Position.Left,
    [Position.Top]: Position.Bottom,
    [Position.Bottom]: Position.Top
};
const ConnectionLine = ({ nodeId, handleType, style, type = ConnectionLineType.Bezier, CustomComponent, connectionStatus })=>{
    const { fromNode, handleId, toX, toY, connectionMode } = useStore((0, _react.useCallback)((s)=>({
            fromNode: s.nodeInternals.get(nodeId),
            handleId: s.connectionHandleId,
            toX: (s.connectionPosition.x - s.transform[0]) / s.transform[2],
            toY: (s.connectionPosition.y - s.transform[1]) / s.transform[2],
            connectionMode: s.connectionMode
        }), [
        nodeId
    ]), (0, _shallow.shallow));
    const fromHandleBounds = fromNode?.[internalsSymbol]?.handleBounds;
    let handleBounds = fromHandleBounds?.[handleType];
    if (connectionMode === ConnectionMode.Loose) handleBounds = handleBounds ? handleBounds : fromHandleBounds?.[handleType === 'source' ? 'target' : 'source'];
    if (!fromNode || !handleBounds) return null;
    const fromHandle = handleId ? handleBounds.find((d)=>d.id === handleId) : handleBounds[0];
    const fromHandleX = fromHandle ? fromHandle.x + fromHandle.width / 2 : (fromNode.width ?? 0) / 2;
    const fromHandleY = fromHandle ? fromHandle.y + fromHandle.height / 2 : fromNode.height ?? 0;
    const fromX = (fromNode.positionAbsolute?.x ?? 0) + fromHandleX;
    const fromY = (fromNode.positionAbsolute?.y ?? 0) + fromHandleY;
    const fromPosition = fromHandle?.position;
    const toPosition = fromPosition ? oppositePosition[fromPosition] : null;
    if (!fromPosition || !toPosition) return null;
    if (CustomComponent) return (0, _reactDefault.default).createElement(CustomComponent, {
        connectionLineType: type,
        connectionLineStyle: style,
        fromNode: fromNode,
        fromHandle: fromHandle,
        fromX: fromX,
        fromY: fromY,
        toX: toX,
        toY: toY,
        fromPosition: fromPosition,
        toPosition: toPosition,
        connectionStatus: connectionStatus
    });
    let dAttr = '';
    const pathParams = {
        sourceX: fromX,
        sourceY: fromY,
        sourcePosition: fromPosition,
        targetX: toX,
        targetY: toY,
        targetPosition: toPosition
    };
    if (type === ConnectionLineType.Bezier) // we assume the destination position is opposite to the source position
    [dAttr] = getBezierPath(pathParams);
    else if (type === ConnectionLineType.Step) [dAttr] = getSmoothStepPath({
        ...pathParams,
        borderRadius: 0
    });
    else if (type === ConnectionLineType.SmoothStep) [dAttr] = getSmoothStepPath(pathParams);
    else if (type === ConnectionLineType.SimpleBezier) [dAttr] = getSimpleBezierPath(pathParams);
    else dAttr = `M${fromX},${fromY} ${toX},${toY}`;
    return (0, _reactDefault.default).createElement("path", {
        d: dAttr,
        fill: "none",
        className: "react-flow__connection-path",
        style: style
    });
};
ConnectionLine.displayName = 'ConnectionLine';
const selector$2 = (s)=>({
        nodeId: s.connectionNodeId,
        handleType: s.connectionHandleType,
        nodesConnectable: s.nodesConnectable,
        connectionStatus: s.connectionStatus,
        width: s.width,
        height: s.height
    });
function ConnectionLineWrapper({ containerStyle, style, type, component }) {
    const { nodeId, handleType, nodesConnectable, width, height, connectionStatus } = useStore(selector$2, (0, _shallow.shallow));
    const isValid = !!(nodeId && handleType && width && nodesConnectable);
    if (!isValid) return null;
    return (0, _reactDefault.default).createElement("svg", {
        style: containerStyle,
        width: width,
        height: height,
        className: "react-flow__edges react-flow__connectionline react-flow__container"
    }, (0, _reactDefault.default).createElement("g", {
        className: (0, _classcatDefault.default)([
            'react-flow__connection',
            connectionStatus
        ])
    }, (0, _reactDefault.default).createElement(ConnectionLine, {
        nodeId: nodeId,
        handleType: handleType,
        style: style,
        type: type,
        CustomComponent: component,
        connectionStatus: connectionStatus
    })));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useNodeOrEdgeTypes(nodeOrEdgeTypes, createTypes) {
    const typesKeysRef = (0, _react.useRef)(null);
    const store = useStoreApi();
    const typesParsed = (0, _react.useMemo)(()=>{
        return createTypes(nodeOrEdgeTypes);
    }, [
        nodeOrEdgeTypes
    ]);
    return typesParsed;
}
const GraphView = ({ nodeTypes, edgeTypes, onMove, onMoveStart, onMoveEnd, onInit, onNodeClick, onEdgeClick, onNodeDoubleClick, onEdgeDoubleClick, onNodeMouseEnter, onNodeMouseMove, onNodeMouseLeave, onNodeContextMenu, onSelectionContextMenu, onSelectionStart, onSelectionEnd, connectionLineType, connectionLineStyle, connectionLineComponent, connectionLineContainerStyle, selectionKeyCode, selectionOnDrag, selectionMode, multiSelectionKeyCode, panActivationKeyCode, zoomActivationKeyCode, deleteKeyCode, onlyRenderVisibleElements, elementsSelectable, selectNodesOnDrag, defaultViewport, translateExtent, minZoom, maxZoom, preventScrolling, defaultMarkerColor, zoomOnScroll, zoomOnPinch, panOnScroll, panOnScrollSpeed, panOnScrollMode, zoomOnDoubleClick, panOnDrag, onPaneClick, onPaneMouseEnter, onPaneMouseMove, onPaneMouseLeave, onPaneScroll, onPaneContextMenu, onEdgeContextMenu, onEdgeMouseEnter, onEdgeMouseMove, onEdgeMouseLeave, onReconnect, onReconnectStart, onReconnectEnd, reconnectRadius, noDragClassName, noWheelClassName, noPanClassName, elevateEdgesOnSelect, disableKeyboardA11y, nodeOrigin, nodeExtent, rfId })=>{
    const nodeTypesWrapped = useNodeOrEdgeTypes(nodeTypes, createNodeTypes);
    const edgeTypesWrapped = useNodeOrEdgeTypes(edgeTypes, createEdgeTypes);
    useOnInitHandler(onInit);
    return (0, _reactDefault.default).createElement(FlowRenderer$1, {
        onPaneClick: onPaneClick,
        onPaneMouseEnter: onPaneMouseEnter,
        onPaneMouseMove: onPaneMouseMove,
        onPaneMouseLeave: onPaneMouseLeave,
        onPaneContextMenu: onPaneContextMenu,
        onPaneScroll: onPaneScroll,
        deleteKeyCode: deleteKeyCode,
        selectionKeyCode: selectionKeyCode,
        selectionOnDrag: selectionOnDrag,
        selectionMode: selectionMode,
        onSelectionStart: onSelectionStart,
        onSelectionEnd: onSelectionEnd,
        multiSelectionKeyCode: multiSelectionKeyCode,
        panActivationKeyCode: panActivationKeyCode,
        zoomActivationKeyCode: zoomActivationKeyCode,
        elementsSelectable: elementsSelectable,
        onMove: onMove,
        onMoveStart: onMoveStart,
        onMoveEnd: onMoveEnd,
        zoomOnScroll: zoomOnScroll,
        zoomOnPinch: zoomOnPinch,
        zoomOnDoubleClick: zoomOnDoubleClick,
        panOnScroll: panOnScroll,
        panOnScrollSpeed: panOnScrollSpeed,
        panOnScrollMode: panOnScrollMode,
        panOnDrag: panOnDrag,
        defaultViewport: defaultViewport,
        translateExtent: translateExtent,
        minZoom: minZoom,
        maxZoom: maxZoom,
        onSelectionContextMenu: onSelectionContextMenu,
        preventScrolling: preventScrolling,
        noDragClassName: noDragClassName,
        noWheelClassName: noWheelClassName,
        noPanClassName: noPanClassName,
        disableKeyboardA11y: disableKeyboardA11y
    }, (0, _reactDefault.default).createElement(Viewport, null, (0, _reactDefault.default).createElement(EdgeRenderer$1, {
        edgeTypes: edgeTypesWrapped,
        onEdgeClick: onEdgeClick,
        onEdgeDoubleClick: onEdgeDoubleClick,
        onlyRenderVisibleElements: onlyRenderVisibleElements,
        onEdgeContextMenu: onEdgeContextMenu,
        onEdgeMouseEnter: onEdgeMouseEnter,
        onEdgeMouseMove: onEdgeMouseMove,
        onEdgeMouseLeave: onEdgeMouseLeave,
        onReconnect: onReconnect,
        onReconnectStart: onReconnectStart,
        onReconnectEnd: onReconnectEnd,
        reconnectRadius: reconnectRadius,
        defaultMarkerColor: defaultMarkerColor,
        noPanClassName: noPanClassName,
        elevateEdgesOnSelect: !!elevateEdgesOnSelect,
        disableKeyboardA11y: disableKeyboardA11y,
        rfId: rfId
    }, (0, _reactDefault.default).createElement(ConnectionLineWrapper, {
        style: connectionLineStyle,
        type: connectionLineType,
        component: connectionLineComponent,
        containerStyle: connectionLineContainerStyle
    })), (0, _reactDefault.default).createElement("div", {
        className: "react-flow__edgelabel-renderer"
    }), (0, _reactDefault.default).createElement(NodeRenderer$1, {
        nodeTypes: nodeTypesWrapped,
        onNodeClick: onNodeClick,
        onNodeDoubleClick: onNodeDoubleClick,
        onNodeMouseEnter: onNodeMouseEnter,
        onNodeMouseMove: onNodeMouseMove,
        onNodeMouseLeave: onNodeMouseLeave,
        onNodeContextMenu: onNodeContextMenu,
        selectNodesOnDrag: selectNodesOnDrag,
        onlyRenderVisibleElements: onlyRenderVisibleElements,
        noPanClassName: noPanClassName,
        noDragClassName: noDragClassName,
        disableKeyboardA11y: disableKeyboardA11y,
        nodeOrigin: nodeOrigin,
        nodeExtent: nodeExtent,
        rfId: rfId
    })));
};
GraphView.displayName = 'GraphView';
var GraphView$1 = (0, _react.memo)(GraphView);
const infiniteExtent = [
    [
        Number.NEGATIVE_INFINITY,
        Number.NEGATIVE_INFINITY
    ],
    [
        Number.POSITIVE_INFINITY,
        Number.POSITIVE_INFINITY
    ]
];
const initialState = {
    rfId: '1',
    width: 0,
    height: 0,
    transform: [
        0,
        0,
        1
    ],
    nodeInternals: new Map(),
    edges: [],
    onNodesChange: null,
    onEdgesChange: null,
    hasDefaultNodes: false,
    hasDefaultEdges: false,
    d3Zoom: null,
    d3Selection: null,
    d3ZoomHandler: undefined,
    minZoom: 0.5,
    maxZoom: 2,
    translateExtent: infiniteExtent,
    nodeExtent: infiniteExtent,
    nodesSelectionActive: false,
    userSelectionActive: false,
    userSelectionRect: null,
    connectionNodeId: null,
    connectionHandleId: null,
    connectionHandleType: 'source',
    connectionPosition: {
        x: 0,
        y: 0
    },
    connectionStatus: null,
    connectionMode: ConnectionMode.Strict,
    domNode: null,
    paneDragging: false,
    noPanClassName: 'nopan',
    nodeOrigin: [
        0,
        0
    ],
    nodeDragThreshold: 0,
    snapGrid: [
        15,
        15
    ],
    snapToGrid: false,
    nodesDraggable: true,
    nodesConnectable: true,
    nodesFocusable: true,
    edgesFocusable: true,
    edgesUpdatable: true,
    elementsSelectable: true,
    elevateNodesOnSelect: true,
    fitViewOnInit: false,
    fitViewOnInitDone: false,
    fitViewOnInitOptions: undefined,
    onSelectionChange: [],
    multiSelectionActive: false,
    connectionStartHandle: null,
    connectionEndHandle: null,
    connectionClickStartHandle: null,
    connectOnClick: true,
    ariaLiveMessage: '',
    autoPanOnConnect: true,
    autoPanOnNodeDrag: true,
    connectionRadius: 20,
    onError: devWarn,
    isValidConnection: undefined
};
const createRFStore = ()=>(0, _traditional.createWithEqualityFn)((set, get)=>({
            ...initialState,
            setNodes: (nodes)=>{
                const { nodeInternals, nodeOrigin, elevateNodesOnSelect } = get();
                set({
                    nodeInternals: createNodeInternals(nodes, nodeInternals, nodeOrigin, elevateNodesOnSelect)
                });
            },
            getNodes: ()=>{
                return Array.from(get().nodeInternals.values());
            },
            setEdges: (edges)=>{
                const { defaultEdgeOptions = {} } = get();
                set({
                    edges: edges.map((e)=>({
                            ...defaultEdgeOptions,
                            ...e
                        }))
                });
            },
            setDefaultNodesAndEdges: (nodes, edges)=>{
                const hasDefaultNodes = typeof nodes !== 'undefined';
                const hasDefaultEdges = typeof edges !== 'undefined';
                const nodeInternals = hasDefaultNodes ? createNodeInternals(nodes, new Map(), get().nodeOrigin, get().elevateNodesOnSelect) : new Map();
                const nextEdges = hasDefaultEdges ? edges : [];
                set({
                    nodeInternals,
                    edges: nextEdges,
                    hasDefaultNodes,
                    hasDefaultEdges
                });
            },
            updateNodeDimensions: (updates)=>{
                const { onNodesChange, nodeInternals, fitViewOnInit, fitViewOnInitDone, fitViewOnInitOptions, domNode, nodeOrigin } = get();
                const viewportNode = domNode?.querySelector('.react-flow__viewport');
                if (!viewportNode) return;
                const style = window.getComputedStyle(viewportNode);
                const { m22: zoom } = new window.DOMMatrixReadOnly(style.transform);
                const changes = updates.reduce((res, update)=>{
                    const node = nodeInternals.get(update.id);
                    if (node?.hidden) nodeInternals.set(node.id, {
                        ...node,
                        [internalsSymbol]: {
                            ...node[internalsSymbol],
                            // we need to reset the handle bounds when the node is hidden
                            // in order to force a new observation when the node is shown again
                            handleBounds: undefined
                        }
                    });
                    else if (node) {
                        const dimensions = getDimensions(update.nodeElement);
                        const doUpdate = !!(dimensions.width && dimensions.height && (node.width !== dimensions.width || node.height !== dimensions.height || update.forceUpdate));
                        if (doUpdate) {
                            nodeInternals.set(node.id, {
                                ...node,
                                [internalsSymbol]: {
                                    ...node[internalsSymbol],
                                    handleBounds: {
                                        source: getHandleBounds('.source', update.nodeElement, zoom, nodeOrigin),
                                        target: getHandleBounds('.target', update.nodeElement, zoom, nodeOrigin)
                                    }
                                },
                                ...dimensions
                            });
                            res.push({
                                id: node.id,
                                type: 'dimensions',
                                dimensions
                            });
                        }
                    }
                    return res;
                }, []);
                updateAbsoluteNodePositions(nodeInternals, nodeOrigin);
                const nextFitViewOnInitDone = fitViewOnInitDone || fitViewOnInit && !fitViewOnInitDone && fitView(get, {
                    initial: true,
                    ...fitViewOnInitOptions
                });
                set({
                    nodeInternals: new Map(nodeInternals),
                    fitViewOnInitDone: nextFitViewOnInitDone
                });
                if (changes?.length > 0) onNodesChange?.(changes);
            },
            updateNodePositions: (nodeDragItems, positionChanged = true, dragging = false)=>{
                const { triggerNodeChanges } = get();
                const changes = nodeDragItems.map((node)=>{
                    const change = {
                        id: node.id,
                        type: 'position',
                        dragging
                    };
                    if (positionChanged) {
                        change.positionAbsolute = node.positionAbsolute;
                        change.position = node.position;
                    }
                    return change;
                });
                triggerNodeChanges(changes);
            },
            triggerNodeChanges: (changes)=>{
                const { onNodesChange, nodeInternals, hasDefaultNodes, nodeOrigin, getNodes, elevateNodesOnSelect } = get();
                if (changes?.length) {
                    if (hasDefaultNodes) {
                        const nodes = applyNodeChanges(changes, getNodes());
                        const nextNodeInternals = createNodeInternals(nodes, nodeInternals, nodeOrigin, elevateNodesOnSelect);
                        set({
                            nodeInternals: nextNodeInternals
                        });
                    }
                    onNodesChange?.(changes);
                }
            },
            addSelectedNodes: (selectedNodeIds)=>{
                const { multiSelectionActive, edges, getNodes } = get();
                let changedNodes;
                let changedEdges = null;
                if (multiSelectionActive) changedNodes = selectedNodeIds.map((nodeId)=>createSelectionChange(nodeId, true));
                else {
                    changedNodes = getSelectionChanges(getNodes(), selectedNodeIds);
                    changedEdges = getSelectionChanges(edges, []);
                }
                updateNodesAndEdgesSelections({
                    changedNodes,
                    changedEdges,
                    get,
                    set
                });
            },
            addSelectedEdges: (selectedEdgeIds)=>{
                const { multiSelectionActive, edges, getNodes } = get();
                let changedEdges;
                let changedNodes = null;
                if (multiSelectionActive) changedEdges = selectedEdgeIds.map((edgeId)=>createSelectionChange(edgeId, true));
                else {
                    changedEdges = getSelectionChanges(edges, selectedEdgeIds);
                    changedNodes = getSelectionChanges(getNodes(), []);
                }
                updateNodesAndEdgesSelections({
                    changedNodes,
                    changedEdges,
                    get,
                    set
                });
            },
            unselectNodesAndEdges: ({ nodes, edges } = {})=>{
                const { edges: storeEdges, getNodes } = get();
                const nodesToUnselect = nodes ? nodes : getNodes();
                const edgesToUnselect = edges ? edges : storeEdges;
                const changedNodes = nodesToUnselect.map((n)=>{
                    n.selected = false;
                    return createSelectionChange(n.id, false);
                });
                const changedEdges = edgesToUnselect.map((edge)=>createSelectionChange(edge.id, false));
                updateNodesAndEdgesSelections({
                    changedNodes,
                    changedEdges,
                    get,
                    set
                });
            },
            setMinZoom: (minZoom)=>{
                const { d3Zoom, maxZoom } = get();
                d3Zoom?.scaleExtent([
                    minZoom,
                    maxZoom
                ]);
                set({
                    minZoom
                });
            },
            setMaxZoom: (maxZoom)=>{
                const { d3Zoom, minZoom } = get();
                d3Zoom?.scaleExtent([
                    minZoom,
                    maxZoom
                ]);
                set({
                    maxZoom
                });
            },
            setTranslateExtent: (translateExtent)=>{
                get().d3Zoom?.translateExtent(translateExtent);
                set({
                    translateExtent
                });
            },
            resetSelectedElements: ()=>{
                const { edges, getNodes } = get();
                const nodes = getNodes();
                const nodesToUnselect = nodes.filter((e)=>e.selected).map((n)=>createSelectionChange(n.id, false));
                const edgesToUnselect = edges.filter((e)=>e.selected).map((e)=>createSelectionChange(e.id, false));
                updateNodesAndEdgesSelections({
                    changedNodes: nodesToUnselect,
                    changedEdges: edgesToUnselect,
                    get,
                    set
                });
            },
            setNodeExtent: (nodeExtent)=>{
                const { nodeInternals } = get();
                nodeInternals.forEach((node)=>{
                    node.positionAbsolute = clampPosition(node.position, nodeExtent);
                });
                set({
                    nodeExtent,
                    nodeInternals: new Map(nodeInternals)
                });
            },
            panBy: (delta)=>{
                const { transform, width, height, d3Zoom, d3Selection, translateExtent } = get();
                if (!d3Zoom || !d3Selection || !delta.x && !delta.y) return false;
                const nextTransform = (0, _d3Zoom.zoomIdentity).translate(transform[0] + delta.x, transform[1] + delta.y).scale(transform[2]);
                const extent = [
                    [
                        0,
                        0
                    ],
                    [
                        width,
                        height
                    ]
                ];
                const constrainedTransform = d3Zoom?.constrain()(nextTransform, extent, translateExtent);
                d3Zoom.transform(d3Selection, constrainedTransform);
                const transformChanged = transform[0] !== constrainedTransform.x || transform[1] !== constrainedTransform.y || transform[2] !== constrainedTransform.k;
                return transformChanged;
            },
            cancelConnection: ()=>set({
                    connectionNodeId: initialState.connectionNodeId,
                    connectionHandleId: initialState.connectionHandleId,
                    connectionHandleType: initialState.connectionHandleType,
                    connectionStatus: initialState.connectionStatus,
                    connectionStartHandle: initialState.connectionStartHandle,
                    connectionEndHandle: initialState.connectionEndHandle
                }),
            reset: ()=>set({
                    ...initialState
                })
        }), Object.is);
const ReactFlowProvider = ({ children })=>{
    const storeRef = (0, _react.useRef)(null);
    if (!storeRef.current) storeRef.current = createRFStore();
    return (0, _reactDefault.default).createElement(Provider$1, {
        value: storeRef.current
    }, children);
};
ReactFlowProvider.displayName = 'ReactFlowProvider';
const Wrapper = ({ children })=>{
    const isWrapped = (0, _react.useContext)(StoreContext);
    if (isWrapped) // we need to wrap it with a fragment because it's not allowed for children to be a ReactNode
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children);
    return (0, _reactDefault.default).createElement(ReactFlowProvider, null, children);
};
Wrapper.displayName = 'ReactFlowWrapper';
const defaultNodeTypes = {
    input: InputNode$1,
    default: DefaultNode$1,
    output: OutputNode$1,
    group: GroupNode
};
const defaultEdgeTypes = {
    default: BezierEdge,
    straight: StraightEdge,
    step: StepEdge,
    smoothstep: SmoothStepEdge,
    simplebezier: SimpleBezierEdge
};
const initNodeOrigin = [
    0,
    0
];
const initSnapGrid = [
    15,
    15
];
const initDefaultViewport = {
    x: 0,
    y: 0,
    zoom: 1
};
const wrapperStyle = {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
    zIndex: 0
};
const ReactFlow = (0, _react.forwardRef)(({ nodes, edges, defaultNodes, defaultEdges, className, nodeTypes = defaultNodeTypes, edgeTypes = defaultEdgeTypes, onNodeClick, onEdgeClick, onInit, onMove, onMoveStart, onMoveEnd, onConnect, onConnectStart, onConnectEnd, onClickConnectStart, onClickConnectEnd, onNodeMouseEnter, onNodeMouseMove, onNodeMouseLeave, onNodeContextMenu, onNodeDoubleClick, onNodeDragStart, onNodeDrag, onNodeDragStop, onNodesDelete, onEdgesDelete, onSelectionChange, onSelectionDragStart, onSelectionDrag, onSelectionDragStop, onSelectionContextMenu, onSelectionStart, onSelectionEnd, connectionMode = ConnectionMode.Strict, connectionLineType = ConnectionLineType.Bezier, connectionLineStyle, connectionLineComponent, connectionLineContainerStyle, deleteKeyCode = 'Backspace', selectionKeyCode = 'Shift', selectionOnDrag = false, selectionMode = SelectionMode.Full, panActivationKeyCode = 'Space', multiSelectionKeyCode = isMacOs() ? 'Meta' : 'Control', zoomActivationKeyCode = isMacOs() ? 'Meta' : 'Control', snapToGrid = false, snapGrid = initSnapGrid, onlyRenderVisibleElements = false, selectNodesOnDrag = true, nodesDraggable, nodesConnectable, nodesFocusable, nodeOrigin = initNodeOrigin, edgesFocusable, edgesUpdatable, elementsSelectable, defaultViewport = initDefaultViewport, minZoom = 0.5, maxZoom = 2, translateExtent = infiniteExtent, preventScrolling = true, nodeExtent, defaultMarkerColor = '#b1b1b7', zoomOnScroll = true, zoomOnPinch = true, panOnScroll = false, panOnScrollSpeed = 0.5, panOnScrollMode = PanOnScrollMode.Free, zoomOnDoubleClick = true, panOnDrag = true, onPaneClick, onPaneMouseEnter, onPaneMouseMove, onPaneMouseLeave, onPaneScroll, onPaneContextMenu, children, onEdgeContextMenu, onEdgeDoubleClick, onEdgeMouseEnter, onEdgeMouseMove, onEdgeMouseLeave, onEdgeUpdate, onEdgeUpdateStart, onEdgeUpdateEnd, onReconnect, onReconnectStart, onReconnectEnd, reconnectRadius = 10, edgeUpdaterRadius = 10, onNodesChange, onEdgesChange, noDragClassName = 'nodrag', noWheelClassName = 'nowheel', noPanClassName = 'nopan', fitView = false, fitViewOptions, connectOnClick = true, attributionPosition, proOptions, defaultEdgeOptions, elevateNodesOnSelect = true, elevateEdgesOnSelect = false, disableKeyboardA11y = false, autoPanOnConnect = true, autoPanOnNodeDrag = true, connectionRadius = 20, isValidConnection, onError, style, id, nodeDragThreshold, ...rest }, ref)=>{
    const rfId = id || '1';
    return (0, _reactDefault.default).createElement("div", {
        ...rest,
        style: {
            ...style,
            ...wrapperStyle
        },
        ref: ref,
        className: (0, _classcatDefault.default)([
            'react-flow',
            className
        ]),
        "data-testid": "rf__wrapper",
        id: id
    }, (0, _reactDefault.default).createElement(Wrapper, null, (0, _reactDefault.default).createElement(GraphView$1, {
        onInit: onInit,
        onMove: onMove,
        onMoveStart: onMoveStart,
        onMoveEnd: onMoveEnd,
        onNodeClick: onNodeClick,
        onEdgeClick: onEdgeClick,
        onNodeMouseEnter: onNodeMouseEnter,
        onNodeMouseMove: onNodeMouseMove,
        onNodeMouseLeave: onNodeMouseLeave,
        onNodeContextMenu: onNodeContextMenu,
        onNodeDoubleClick: onNodeDoubleClick,
        nodeTypes: nodeTypes,
        edgeTypes: edgeTypes,
        connectionLineType: connectionLineType,
        connectionLineStyle: connectionLineStyle,
        connectionLineComponent: connectionLineComponent,
        connectionLineContainerStyle: connectionLineContainerStyle,
        selectionKeyCode: selectionKeyCode,
        selectionOnDrag: selectionOnDrag,
        selectionMode: selectionMode,
        deleteKeyCode: deleteKeyCode,
        multiSelectionKeyCode: multiSelectionKeyCode,
        panActivationKeyCode: panActivationKeyCode,
        zoomActivationKeyCode: zoomActivationKeyCode,
        onlyRenderVisibleElements: onlyRenderVisibleElements,
        selectNodesOnDrag: selectNodesOnDrag,
        defaultViewport: defaultViewport,
        translateExtent: translateExtent,
        minZoom: minZoom,
        maxZoom: maxZoom,
        preventScrolling: preventScrolling,
        zoomOnScroll: zoomOnScroll,
        zoomOnPinch: zoomOnPinch,
        zoomOnDoubleClick: zoomOnDoubleClick,
        panOnScroll: panOnScroll,
        panOnScrollSpeed: panOnScrollSpeed,
        panOnScrollMode: panOnScrollMode,
        panOnDrag: panOnDrag,
        onPaneClick: onPaneClick,
        onPaneMouseEnter: onPaneMouseEnter,
        onPaneMouseMove: onPaneMouseMove,
        onPaneMouseLeave: onPaneMouseLeave,
        onPaneScroll: onPaneScroll,
        onPaneContextMenu: onPaneContextMenu,
        onSelectionContextMenu: onSelectionContextMenu,
        onSelectionStart: onSelectionStart,
        onSelectionEnd: onSelectionEnd,
        onEdgeContextMenu: onEdgeContextMenu,
        onEdgeDoubleClick: onEdgeDoubleClick,
        onEdgeMouseEnter: onEdgeMouseEnter,
        onEdgeMouseMove: onEdgeMouseMove,
        onEdgeMouseLeave: onEdgeMouseLeave,
        onReconnect: onReconnect ?? onEdgeUpdate,
        onReconnectStart: onReconnectStart ?? onEdgeUpdateStart,
        onReconnectEnd: onReconnectEnd ?? onEdgeUpdateEnd,
        reconnectRadius: reconnectRadius ?? edgeUpdaterRadius,
        defaultMarkerColor: defaultMarkerColor,
        noDragClassName: noDragClassName,
        noWheelClassName: noWheelClassName,
        noPanClassName: noPanClassName,
        elevateEdgesOnSelect: elevateEdgesOnSelect,
        rfId: rfId,
        disableKeyboardA11y: disableKeyboardA11y,
        nodeOrigin: nodeOrigin,
        nodeExtent: nodeExtent
    }), (0, _reactDefault.default).createElement(StoreUpdater, {
        nodes: nodes,
        edges: edges,
        defaultNodes: defaultNodes,
        defaultEdges: defaultEdges,
        onConnect: onConnect,
        onConnectStart: onConnectStart,
        onConnectEnd: onConnectEnd,
        onClickConnectStart: onClickConnectStart,
        onClickConnectEnd: onClickConnectEnd,
        nodesDraggable: nodesDraggable,
        nodesConnectable: nodesConnectable,
        nodesFocusable: nodesFocusable,
        edgesFocusable: edgesFocusable,
        edgesUpdatable: edgesUpdatable,
        elementsSelectable: elementsSelectable,
        elevateNodesOnSelect: elevateNodesOnSelect,
        minZoom: minZoom,
        maxZoom: maxZoom,
        nodeExtent: nodeExtent,
        onNodesChange: onNodesChange,
        onEdgesChange: onEdgesChange,
        snapToGrid: snapToGrid,
        snapGrid: snapGrid,
        connectionMode: connectionMode,
        translateExtent: translateExtent,
        connectOnClick: connectOnClick,
        defaultEdgeOptions: defaultEdgeOptions,
        fitView: fitView,
        fitViewOptions: fitViewOptions,
        onNodesDelete: onNodesDelete,
        onEdgesDelete: onEdgesDelete,
        onNodeDragStart: onNodeDragStart,
        onNodeDrag: onNodeDrag,
        onNodeDragStop: onNodeDragStop,
        onSelectionDrag: onSelectionDrag,
        onSelectionDragStart: onSelectionDragStart,
        onSelectionDragStop: onSelectionDragStop,
        noPanClassName: noPanClassName,
        nodeOrigin: nodeOrigin,
        rfId: rfId,
        autoPanOnConnect: autoPanOnConnect,
        autoPanOnNodeDrag: autoPanOnNodeDrag,
        onError: onError,
        connectionRadius: connectionRadius,
        isValidConnection: isValidConnection,
        nodeDragThreshold: nodeDragThreshold
    }), (0, _reactDefault.default).createElement(Wrapper$1, {
        onSelectionChange: onSelectionChange
    }), children, (0, _reactDefault.default).createElement(Attribution, {
        proOptions: proOptions,
        position: attributionPosition
    }), (0, _reactDefault.default).createElement(A11yDescriptions, {
        rfId: rfId,
        disableKeyboardA11y: disableKeyboardA11y
    })));
});
ReactFlow.displayName = 'ReactFlow';
const selector$1 = (s)=>s.domNode?.querySelector('.react-flow__edgelabel-renderer');
function EdgeLabelRenderer({ children }) {
    const edgeLabelRenderer = useStore(selector$1);
    if (!edgeLabelRenderer) return null;
    return (0, _reactDom.createPortal)(children, edgeLabelRenderer);
}
function useUpdateNodeInternals() {
    const store = useStoreApi();
    return (0, _react.useCallback)((id)=>{
        const { domNode, updateNodeDimensions } = store.getState();
        const updateIds = Array.isArray(id) ? id : [
            id
        ];
        const updates = updateIds.reduce((res, updateId)=>{
            const nodeElement = domNode?.querySelector(`.react-flow__node[data-id="${updateId}"]`);
            if (nodeElement) res.push({
                id: updateId,
                nodeElement,
                forceUpdate: true
            });
            return res;
        }, []);
        requestAnimationFrame(()=>updateNodeDimensions(updates));
    }, []);
}
const nodesSelector = (state)=>state.getNodes();
function useNodes() {
    const nodes = useStore(nodesSelector, (0, _shallow.shallow));
    return nodes;
}
const edgesSelector = (state)=>state.edges;
function useEdges() {
    const edges = useStore(edgesSelector, (0, _shallow.shallow));
    return edges;
}
const viewportSelector = (state)=>({
        x: state.transform[0],
        y: state.transform[1],
        zoom: state.transform[2]
    });
function useViewport() {
    const viewport = useStore(viewportSelector, (0, _shallow.shallow));
    return viewport;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ function createUseItemsState(applyChanges) {
    return (initialItems)=>{
        const [items, setItems] = (0, _react.useState)(initialItems);
        const onItemsChange = (0, _react.useCallback)((changes)=>setItems((items)=>applyChanges(changes, items)), []);
        return [
            items,
            setItems,
            onItemsChange
        ];
    };
}
const useNodesState = createUseItemsState(applyNodeChanges);
const useEdgesState = createUseItemsState(applyEdgeChanges);
function useOnViewportChange({ onStart, onChange, onEnd }) {
    const store = useStoreApi();
    (0, _react.useEffect)(()=>{
        store.setState({
            onViewportChangeStart: onStart
        });
    }, [
        onStart
    ]);
    (0, _react.useEffect)(()=>{
        store.setState({
            onViewportChange: onChange
        });
    }, [
        onChange
    ]);
    (0, _react.useEffect)(()=>{
        store.setState({
            onViewportChangeEnd: onEnd
        });
    }, [
        onEnd
    ]);
}
function useOnSelectionChange({ onChange }) {
    const store = useStoreApi();
    (0, _react.useEffect)(()=>{
        const nextSelectionChangeHandlers = [
            ...store.getState().onSelectionChange,
            onChange
        ];
        store.setState({
            onSelectionChange: nextSelectionChangeHandlers
        });
        return ()=>{
            const nextHandlers = store.getState().onSelectionChange.filter((fn)=>fn !== onChange);
            store.setState({
                onSelectionChange: nextHandlers
            });
        };
    }, [
        onChange
    ]);
}
const selector = (options)=>(s)=>{
        if (s.nodeInternals.size === 0) return false;
        return s.getNodes().filter((n)=>options.includeHiddenNodes ? true : !n.hidden).every((n)=>n[internalsSymbol]?.handleBounds !== undefined);
    };
const defaultOptions = {
    includeHiddenNodes: false
};
function useNodesInitialized(options = defaultOptions) {
    const initialized = useStore(selector(options));
    return initialized;
}

},{"react":"9njXz","classcat":"1IIbb","zustand/traditional":"4L6sR","zustand/shallow":"qIjDw","d3-zoom":"9wSnq","d3-selection":"9PvvP","d3-drag":"HHNYu","react-dom":"2ApDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1IIbb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cc);
function cc(names) {
    if (typeof names === "string" || typeof names === "number") return "" + names;
    let out = "";
    if (Array.isArray(names)) {
        for(let i = 0, tmp; i < names.length; i++)if ((tmp = cc(names[i])) !== "") out += (out && " ") + tmp;
    } else {
        for(let k in names)if (names[k]) out += (out && " ") + k;
    }
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4L6sR":[function(require,module,exports,__globalThis) {
'use strict';
var ReactExports = require("55fe33b72be7f997");
var useSyncExternalStoreExports = require("bfacb3376c7259e5");
var vanilla = require("93e7584e5ac2a823");
var useDebugValue = ReactExports.useDebugValue;
var useSyncExternalStoreWithSelector = useSyncExternalStoreExports.useSyncExternalStoreWithSelector;
var identity = function identity(arg) {
    return arg;
};
function useStoreWithEqualityFn(api, selector, equalityFn) {
    if (selector === void 0) selector = identity;
    var slice = useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    useDebugValue(slice);
    return slice;
}
var createWithEqualityFnImpl = function createWithEqualityFnImpl(createState, defaultEqualityFn) {
    var api = vanilla.createStore(createState);
    var useBoundStoreWithEqualityFn = function useBoundStoreWithEqualityFn(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = defaultEqualityFn;
        return useStoreWithEqualityFn(api, selector, equalityFn);
    };
    Object.assign(useBoundStoreWithEqualityFn, api);
    return useBoundStoreWithEqualityFn;
};
var createWithEqualityFn = function createWithEqualityFn(createState, defaultEqualityFn) {
    return createState ? createWithEqualityFnImpl(createState, defaultEqualityFn) : createWithEqualityFnImpl;
};
exports.createWithEqualityFn = createWithEqualityFn;
exports.useStoreWithEqualityFn = useStoreWithEqualityFn;

},{"55fe33b72be7f997":"9njXz","bfacb3376c7259e5":"iQR6c","93e7584e5ac2a823":"6Uk7m"}],"iQR6c":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("d1848724d1e53763");

},{"d1848724d1e53763":"d7S7r"}],"d7S7r":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("d57a74df6bca20fd"), shim = require("5be634d856d1f9fa");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = shim.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    useDebugValue(value);
    return value;
};

},{"d57a74df6bca20fd":"9njXz","5be634d856d1f9fa":"jHyRW"}],"jHyRW":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("3e3e060a1c619377");

},{"3e3e060a1c619377":"7utQz"}],"7utQz":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("a18024ece7b3cd12");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    useEffect(function() {
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    useDebugValue(value);
    return value;
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
exports.useSyncExternalStore = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;

},{"a18024ece7b3cd12":"9njXz"}],"6Uk7m":[function(require,module,exports,__globalThis) {
'use strict';
var createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var createStore = function createStore(createState) {
    return createState ? createStoreImpl(createState) : createStoreImpl;
};
var vanilla = function(createState) {
    return createStore(createState);
};
exports.createStore = createStore;
exports.default = vanilla;
module.exports = vanilla;
module.exports.createStore = createStore;
exports.default = module.exports;

},{}],"qIjDw":[function(require,module,exports,__globalThis) {
'use strict';
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function shallow$1(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for(var _iterator = _createForOfIteratorHelperLoose(objA), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            if (!Object.is(value, objB.get(key))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for(var _iterator2 = _createForOfIteratorHelperLoose(objA), _step2; !(_step2 = _iterator2()).done;){
            var _value = _step2.value;
            if (!objB.has(_value)) return false;
        }
        return true;
    }
    var keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(var _i = 0, _keysA = keysA; _i < _keysA.length; _i++){
        var keyA = _keysA[_i];
        if (!Object.prototype.hasOwnProperty.call(objB, keyA) || !Object.is(objA[keyA], objB[keyA])) return false;
    }
    return true;
}
var shallow = function(objA, objB) {
    return shallow$1(objA, objB);
};
exports.default = shallow;
exports.shallow = shallow$1;
module.exports = shallow;
module.exports.shallow = shallow$1;
exports.default = module.exports;

},{}],"9wSnq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "zoomTransform", ()=>(0, _transformJsDefault.default));
parcelHelpers.export(exports, "zoomIdentity", ()=>(0, _transformJs.identity));
parcelHelpers.export(exports, "ZoomTransform", ()=>(0, _transformJs.Transform));
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);

},{"./zoom.js":"lvjYn","./transform.js":"boRyC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lvjYn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var filter = defaultFilter, extent = defaultExtent, constrain = defaultConstrain, wheelDelta = defaultWheelDelta, touchable = defaultTouchable, scaleExtent = [
            0,
            Infinity
        ], translateExtent = [
            [
                -Infinity,
                -Infinity
            ],
            [
                Infinity,
                Infinity
            ]
        ], duration = 250, interpolate = (0, _d3Interpolate.interpolateZoom), listeners = (0, _d3Dispatch.dispatch)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
        function zoom(selection) {
            selection.property("__zoom", defaultTransform).on("wheel.zoom", wheeled, {
                passive: false
            }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        zoom.transform = function(collection, transform, point, event) {
            var selection = collection.selection ? collection.selection() : collection;
            selection.property("__zoom", defaultTransform);
            if (collection !== selection) schedule(collection, transform, point, event);
            else selection.interrupt().each(function() {
                gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
            });
        };
        zoom.scaleBy = function(selection, k, p, event) {
            zoom.scaleTo(selection, function() {
                var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return k0 * k1;
            }, p, event);
        };
        zoom.scaleTo = function(selection, k, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
            }, p, event);
        };
        zoom.translateBy = function(selection, x, y, event) {
            zoom.transform(selection, function() {
                return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
            }, null, event);
        };
        zoom.translateTo = function(selection, x, y, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
                return constrain((0, _transformJs.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
            }, p, event);
        };
        function scale(transform, k) {
            k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
            return k === transform.k ? transform : new (0, _transformJs.Transform)(k, transform.x, transform.y);
        }
        function translate(transform, p0, p1) {
            var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
            return x === transform.x && y === transform.y ? transform : new (0, _transformJs.Transform)(transform.k, x, y);
        }
        function centroid(extent) {
            return [
                (+extent[0][0] + +extent[1][0]) / 2,
                (+extent[0][1] + +extent[1][1]) / 2
            ];
        }
        function schedule(transition, transform, point, event) {
            transition.on("start.zoom", function() {
                gesture(this, arguments).event(event).start();
            }).on("interrupt.zoom end.zoom", function() {
                gesture(this, arguments).event(event).end();
            }).tween("zoom", function() {
                var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
                return function(t) {
                    if (t === 1) t = b; // Avoid rounding error on end.
                    else {
                        var l = i(t), k = w / l[2];
                        t = new (0, _transformJs.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                    }
                    g.zoom(null, t);
                };
            });
        }
        function gesture(that, args, clean) {
            return !clean && that.__zooming || new Gesture(that, args);
        }
        function Gesture(that, args) {
            this.that = that;
            this.args = args;
            this.active = 0;
            this.sourceEvent = null;
            this.extent = extent.apply(that, args);
            this.taps = 0;
        }
        Gesture.prototype = {
            event: function(event) {
                if (event) this.sourceEvent = event;
                return this;
            },
            start: function() {
                if (++this.active === 1) {
                    this.that.__zooming = this;
                    this.emit("start");
                }
                return this;
            },
            zoom: function(key, transform) {
                if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
                if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
                if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
                this.that.__zoom = transform;
                this.emit("zoom");
                return this;
            },
            end: function() {
                if (--this.active === 0) {
                    delete this.that.__zooming;
                    this.emit("end");
                }
                return this;
            },
            emit: function(type) {
                var d = (0, _d3Selection.select)(this.that).datum();
                listeners.call(type, this.that, new (0, _eventJsDefault.default)(type, {
                    sourceEvent: this.sourceEvent,
                    target: zoom,
                    type,
                    transform: this.that.__zoom,
                    dispatch: listeners
                }), d);
            }
        };
        function wheeled(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, _d3Selection.pointer)(event);
            // If the mouse is in the same location as before, reuse it.
            // If there were recent wheel events, reset the wheel idle timeout.
            if (g.wheel) {
                if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
                clearTimeout(g.wheel);
            } else if (t.k === k) return;
            else {
                g.mouse = [
                    p,
                    t.invert(p)
                ];
                (0, _d3Transition.interrupt)(this);
                g.start();
            }
            (0, _noeventJsDefault.default)(event);
            g.wheel = setTimeout(wheelidled, wheelDelay);
            g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
            function wheelidled() {
                g.wheel = null;
                g.end();
            }
        }
        function mousedowned(event, ...args) {
            if (touchending || !filter.apply(this, arguments)) return;
            var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, _d3Selection.select)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, _d3Selection.pointer)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
            (0, _d3Drag.dragDisable)(event.view);
            (0, _noeventJs.nopropagation)(event);
            g.mouse = [
                p,
                this.__zoom.invert(p)
            ];
            (0, _d3Transition.interrupt)(this);
            g.start();
            function mousemoved(event) {
                (0, _noeventJsDefault.default)(event);
                if (!g.moved) {
                    var dx = event.clientX - x0, dy = event.clientY - y0;
                    g.moved = dx * dx + dy * dy > clickDistance2;
                }
                g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, _d3Selection.pointer)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
            }
            function mouseupped(event) {
                v.on("mousemove.zoom mouseup.zoom", null);
                (0, _d3Drag.dragEnable)(event.view, g.moved);
                (0, _noeventJsDefault.default)(event);
                g.event(event).end();
            }
        }
        function dblclicked(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var t0 = this.__zoom, p0 = (0, _d3Selection.pointer)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
            (0, _noeventJsDefault.default)(event);
            if (duration > 0) (0, _d3Selection.select)(this).transition().duration(duration).call(schedule, t1, p0, event);
            else (0, _d3Selection.select)(this).call(zoom.transform, t1, p0, event);
        }
        function touchstarted(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
            (0, _noeventJs.nopropagation)(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = (0, _d3Selection.pointer)(t, this);
                p = [
                    p,
                    this.__zoom.invert(p),
                    t.identifier
                ];
                if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
                else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
            }
            if (touchstarting) touchstarting = clearTimeout(touchstarting);
            if (started) {
                if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                    touchstarting = null;
                }, touchDelay);
                (0, _d3Transition.interrupt)(this);
                g.start();
            }
        }
        function touchmoved(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
            (0, _noeventJsDefault.default)(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = (0, _d3Selection.pointer)(t, this);
                if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
                else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
            }
            t = g.that.__zoom;
            if (g.touch1) {
                var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
                t = scale(t, Math.sqrt(dp / dl));
                p = [
                    (p0[0] + p1[0]) / 2,
                    (p0[1] + p1[1]) / 2
                ];
                l = [
                    (l0[0] + l1[0]) / 2,
                    (l0[1] + l1[1]) / 2
                ];
            } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
            else return;
            g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
        }
        function touchended(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
            (0, _noeventJs.nopropagation)(event);
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, touchDelay);
            for(i = 0; i < n; ++i){
                t = touches[i];
                if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
                else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
            }
            if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
            if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
            else {
                g.end();
                // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
                if (g.taps === 2) {
                    t = (0, _d3Selection.pointer)(t, this);
                    if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                        var p = (0, _d3Selection.select)(this).on("dblclick.zoom");
                        if (p) p.apply(this, arguments);
                    }
                }
            }
        }
        zoom.wheelDelta = function(_) {
            return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), zoom) : wheelDelta;
        };
        zoom.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), zoom) : filter;
        };
        zoom.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), zoom) : touchable;
        };
        zoom.extent = function(_) {
            return arguments.length ? (extent = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
                [
                    +_[0][0],
                    +_[0][1]
                ],
                [
                    +_[1][0],
                    +_[1][1]
                ]
            ]), zoom) : extent;
        };
        zoom.scaleExtent = function(_) {
            return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
                scaleExtent[0],
                scaleExtent[1]
            ];
        };
        zoom.translateExtent = function(_) {
            return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
                [
                    translateExtent[0][0],
                    translateExtent[0][1]
                ],
                [
                    translateExtent[1][0],
                    translateExtent[1][1]
                ]
            ];
        };
        zoom.constrain = function(_) {
            return arguments.length ? (constrain = _, zoom) : constrain;
        };
        zoom.duration = function(_) {
            return arguments.length ? (duration = +_, zoom) : duration;
        };
        zoom.interpolate = function(_) {
            return arguments.length ? (interpolate = _, zoom) : interpolate;
        };
        zoom.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? zoom : value;
        };
        zoom.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
        };
        zoom.tapDistance = function(_) {
            return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
        };
        return zoom;
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Drag = require("d3-drag");
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _d3Transition = require("d3-transition");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _transformJs = require("./transform.js");
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function defaultTransform() {
    return this.__zoom || (0, _transformJs.identity);
}
function defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}

},{"d3-dispatch":"2VwUr","d3-drag":"HHNYu","d3-interpolate":"5gJW0","d3-selection":"9PvvP","d3-transition":"aj1c5","./constant.js":"i5Vxu","./event.js":"aUnay","./transform.js":"boRyC","./noevent.js":"67dpU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2VwUr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dispatch", ()=>(0, _dispatchJsDefault.default));
var _dispatchJs = require("./dispatch.js");
var _dispatchJsDefault = parcelHelpers.interopDefault(_dispatchJs);

},{"./dispatch.js":"cWgMh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cWgMh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var noop = {
    value: ()=>{}
};
function dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new Dispatch(_);
}
function Dispatch(_) {
    this._ = _;
}
function parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
Dispatch.prototype = dispatch.prototype = {
    constructor: Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
exports.default = dispatch;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"HHNYu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "drag", ()=>(0, _dragJsDefault.default));
parcelHelpers.export(exports, "dragDisable", ()=>(0, _nodragJsDefault.default));
parcelHelpers.export(exports, "dragEnable", ()=>(0, _nodragJs.yesdrag));
var _dragJs = require("./drag.js");
var _dragJsDefault = parcelHelpers.interopDefault(_dragJs);
var _nodragJs = require("./nodrag.js");
var _nodragJsDefault = parcelHelpers.interopDefault(_nodragJs);

},{"./drag.js":"6a3PW","./nodrag.js":"kOGkY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6a3PW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var filter = defaultFilter, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable, gestures = {}, listeners = (0, _d3Dispatch.dispatch)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
        function drag(selection) {
            selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, (0, _noeventJs.nonpassive)).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        function mousedowned(event, d) {
            if (touchending || !filter.call(this, event, d)) return;
            var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
            if (!gesture) return;
            (0, _d3Selection.select)(event.view).on("mousemove.drag", mousemoved, (0, _noeventJs.nonpassivecapture)).on("mouseup.drag", mouseupped, (0, _noeventJs.nonpassivecapture));
            (0, _nodragJsDefault.default)(event.view);
            (0, _noeventJs.nopropagation)(event);
            mousemoving = false;
            mousedownx = event.clientX;
            mousedowny = event.clientY;
            gesture("start", event);
        }
        function mousemoved(event) {
            (0, _noeventJsDefault.default)(event);
            if (!mousemoving) {
                var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
                mousemoving = dx * dx + dy * dy > clickDistance2;
            }
            gestures.mouse("drag", event);
        }
        function mouseupped(event) {
            (0, _d3Selection.select)(event.view).on("mousemove.drag mouseup.drag", null);
            (0, _nodragJs.yesdrag)(event.view, mousemoving);
            (0, _noeventJsDefault.default)(event);
            gestures.mouse("end", event);
        }
        function touchstarted(event, d) {
            if (!filter.call(this, event, d)) return;
            var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
                (0, _noeventJs.nopropagation)(event);
                gesture("start", event, touches[i]);
            }
        }
        function touchmoved(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJsDefault.default)(event);
                gesture("drag", event, touches[i]);
            }
        }
        function touchended(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, 500); // Ghost clicks are delayed!
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJs.nopropagation)(event);
                gesture("end", event, touches[i]);
            }
        }
        function beforestart(that, container, event, d, identifier, touch) {
            var dispatch = listeners.copy(), p = (0, _d3Selection.pointer)(touch || event, container), dx, dy, s;
            if ((s = subject.call(that, new (0, _eventJsDefault.default)("beforestart", {
                sourceEvent: event,
                target: drag,
                identifier,
                active,
                x: p[0],
                y: p[1],
                dx: 0,
                dy: 0,
                dispatch
            }), d)) == null) return;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return function gesture(type, event, touch) {
                var p0 = p, n;
                switch(type){
                    case "start":
                        gestures[identifier] = gesture, n = active++;
                        break;
                    case "end":
                        delete gestures[identifier], --active; // falls through
                    case "drag":
                        p = (0, _d3Selection.pointer)(touch || event, container), n = active;
                        break;
                }
                dispatch.call(type, that, new (0, _eventJsDefault.default)(type, {
                    sourceEvent: event,
                    subject: s,
                    target: drag,
                    identifier,
                    active: n,
                    x: p[0] + dx,
                    y: p[1] + dy,
                    dx: p[0] - p0[0],
                    dy: p[1] - p0[1],
                    dispatch
                }), d);
            };
        }
        drag.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : filter;
        };
        drag.container = function(_) {
            return arguments.length ? (container = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : container;
        };
        drag.subject = function(_) {
            return arguments.length ? (subject = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : subject;
        };
        drag.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : touchable;
        };
        drag.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? drag : value;
        };
        drag.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
        };
        return drag;
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Selection = require("d3-selection");
var _nodragJs = require("./nodrag.js");
var _nodragJsDefault = parcelHelpers.interopDefault(_nodragJs);
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
// Ignore right-click, since that should open the context menu.
function defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function defaultContainer() {
    return this.parentNode;
}
function defaultSubject(event, d) {
    return d == null ? {
        x: event.x,
        y: event.y
    } : d;
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}

},{"d3-dispatch":"2VwUr","d3-selection":"9PvvP","./nodrag.js":"kOGkY","./noevent.js":"8rhnL","./constant.js":"gczea","./event.js":"6OX4n","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9PvvP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>(0, _createJsDefault.default));
parcelHelpers.export(exports, "creator", ()=>(0, _creatorJsDefault.default));
parcelHelpers.export(exports, "local", ()=>(0, _localJsDefault.default));
parcelHelpers.export(exports, "matcher", ()=>(0, _matcherJsDefault.default));
parcelHelpers.export(exports, "namespace", ()=>(0, _namespaceJsDefault.default));
parcelHelpers.export(exports, "namespaces", ()=>(0, _namespacesJsDefault.default));
parcelHelpers.export(exports, "pointer", ()=>(0, _pointerJsDefault.default));
parcelHelpers.export(exports, "pointers", ()=>(0, _pointersJsDefault.default));
parcelHelpers.export(exports, "select", ()=>(0, _selectJsDefault.default));
parcelHelpers.export(exports, "selectAll", ()=>(0, _selectAllJsDefault.default));
parcelHelpers.export(exports, "selection", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "selector", ()=>(0, _selectorJsDefault.default));
parcelHelpers.export(exports, "selectorAll", ()=>(0, _selectorAllJsDefault.default));
parcelHelpers.export(exports, "style", ()=>(0, _styleJs.styleValue));
parcelHelpers.export(exports, "window", ()=>(0, _windowJsDefault.default));
var _createJs = require("./create.js");
var _createJsDefault = parcelHelpers.interopDefault(_createJs);
var _creatorJs = require("./creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _localJs = require("./local.js");
var _localJsDefault = parcelHelpers.interopDefault(_localJs);
var _matcherJs = require("./matcher.js");
var _matcherJsDefault = parcelHelpers.interopDefault(_matcherJs);
var _namespaceJs = require("./namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
var _namespacesJs = require("./namespaces.js");
var _namespacesJsDefault = parcelHelpers.interopDefault(_namespacesJs);
var _pointerJs = require("./pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
var _pointersJs = require("./pointers.js");
var _pointersJsDefault = parcelHelpers.interopDefault(_pointersJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _indexJs = require("./selection/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _selectorJs = require("./selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);
var _selectorAllJs = require("./selectorAll.js");
var _selectorAllJsDefault = parcelHelpers.interopDefault(_selectorAllJs);
var _styleJs = require("./selection/style.js");
var _windowJs = require("./window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);

},{"./create.js":false,"./creator.js":false,"./local.js":false,"./matcher.js":"3cbxf","./namespace.js":"890X9","./namespaces.js":false,"./pointer.js":"3xcdW","./pointers.js":false,"./select.js":"2Rc7o","./selectAll.js":false,"./selection/index.js":"a5jDB","./selector.js":"hZ4f6","./selectorAll.js":"9WsMK","./selection/style.js":"4vnVK","./window.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9J1Uc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var fullname = (0, _namespaceJsDefault.default)(name);
        return (fullname.local ? creatorFixed : creatorInherit)(fullname);
    });
var _namespaceJs = require("./namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
var _namespacesJs = require("./namespaces.js");
function creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, _namespacesJs.xhtml) && document.documentElement.namespaceURI === (0, _namespacesJs.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}

},{"./namespace.js":"890X9","./namespaces.js":"1Q4PJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"890X9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var prefix = name += "", i = prefix.indexOf(":");
        if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
        return (0, _namespacesJsDefault.default).hasOwnProperty(prefix) ? {
            space: (0, _namespacesJsDefault.default)[prefix],
            local: name
        } : name; // eslint-disable-line no-prototype-builtins
    });
var _namespacesJs = require("./namespaces.js");
var _namespacesJsDefault = parcelHelpers.interopDefault(_namespacesJs);

},{"./namespaces.js":"1Q4PJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Q4PJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xhtml", ()=>xhtml);
var xhtml = "http://www.w3.org/1999/xhtml";
exports.default = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: xhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3cbxf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return function() {
            return this.matches(selector);
        };
    });
parcelHelpers.export(exports, "childMatcher", ()=>childMatcher);
function childMatcher(selector) {
    return function(node) {
        return node.matches(selector);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3xcdW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(event, node) {
        event = (0, _sourceEventJsDefault.default)(event);
        if (node === undefined) node = event.currentTarget;
        if (node) {
            var svg = node.ownerSVGElement || node;
            if (svg.createSVGPoint) {
                var point = svg.createSVGPoint();
                point.x = event.clientX, point.y = event.clientY;
                point = point.matrixTransform(node.getScreenCTM().inverse());
                return [
                    point.x,
                    point.y
                ];
            }
            if (node.getBoundingClientRect) {
                var rect = node.getBoundingClientRect();
                return [
                    event.clientX - rect.left - node.clientLeft,
                    event.clientY - rect.top - node.clientTop
                ];
            }
        }
        return [
            event.pageX,
            event.pageY
        ];
    });
var _sourceEventJs = require("./sourceEvent.js");
var _sourceEventJsDefault = parcelHelpers.interopDefault(_sourceEventJs);

},{"./sourceEvent.js":"fQtlW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fQtlW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(event) {
        let sourceEvent;
        while(sourceEvent = event.sourceEvent)event = sourceEvent;
        return event;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Rc7o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return typeof selector === "string" ? new (0, _indexJs.Selection)([
            [
                document.querySelector(selector)
            ]
        ], [
            document.documentElement
        ]) : new (0, _indexJs.Selection)([
            [
                selector
            ]
        ], (0, _indexJs.root));
    });
var _indexJs = require("./selection/index.js");

},{"./selection/index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a5jDB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "root", ()=>root);
parcelHelpers.export(exports, "Selection", ()=>Selection);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _selectChildJs = require("./selectChild.js");
var _selectChildJsDefault = parcelHelpers.interopDefault(_selectChildJs);
var _selectChildrenJs = require("./selectChildren.js");
var _selectChildrenJsDefault = parcelHelpers.interopDefault(_selectChildrenJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _dataJs = require("./data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _enterJs = require("./enter.js");
var _enterJsDefault = parcelHelpers.interopDefault(_enterJs);
var _exitJs = require("./exit.js");
var _exitJsDefault = parcelHelpers.interopDefault(_exitJs);
var _joinJs = require("./join.js");
var _joinJsDefault = parcelHelpers.interopDefault(_joinJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _orderJs = require("./order.js");
var _orderJsDefault = parcelHelpers.interopDefault(_orderJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _callJs = require("./call.js");
var _callJsDefault = parcelHelpers.interopDefault(_callJs);
var _nodesJs = require("./nodes.js");
var _nodesJsDefault = parcelHelpers.interopDefault(_nodesJs);
var _nodeJs = require("./node.js");
var _nodeJsDefault = parcelHelpers.interopDefault(_nodeJs);
var _sizeJs = require("./size.js");
var _sizeJsDefault = parcelHelpers.interopDefault(_sizeJs);
var _emptyJs = require("./empty.js");
var _emptyJsDefault = parcelHelpers.interopDefault(_emptyJs);
var _eachJs = require("./each.js");
var _eachJsDefault = parcelHelpers.interopDefault(_eachJs);
var _attrJs = require("./attr.js");
var _attrJsDefault = parcelHelpers.interopDefault(_attrJs);
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _propertyJs = require("./property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
var _classedJs = require("./classed.js");
var _classedJsDefault = parcelHelpers.interopDefault(_classedJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _htmlJs = require("./html.js");
var _htmlJsDefault = parcelHelpers.interopDefault(_htmlJs);
var _raiseJs = require("./raise.js");
var _raiseJsDefault = parcelHelpers.interopDefault(_raiseJs);
var _lowerJs = require("./lower.js");
var _lowerJsDefault = parcelHelpers.interopDefault(_lowerJs);
var _appendJs = require("./append.js");
var _appendJsDefault = parcelHelpers.interopDefault(_appendJs);
var _insertJs = require("./insert.js");
var _insertJsDefault = parcelHelpers.interopDefault(_insertJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _cloneJs = require("./clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _datumJs = require("./datum.js");
var _datumJsDefault = parcelHelpers.interopDefault(_datumJs);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
var _dispatchJs = require("./dispatch.js");
var _dispatchJsDefault = parcelHelpers.interopDefault(_dispatchJs);
var _iteratorJs = require("./iterator.js");
var _iteratorJsDefault = parcelHelpers.interopDefault(_iteratorJs);
var root = [
    null
];
function Selection(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function selection() {
    return new Selection([
        [
            document.documentElement
        ]
    ], root);
}
function selection_selection() {
    return this;
}
Selection.prototype = selection.prototype = {
    constructor: Selection,
    select: (0, _selectJsDefault.default),
    selectAll: (0, _selectAllJsDefault.default),
    selectChild: (0, _selectChildJsDefault.default),
    selectChildren: (0, _selectChildrenJsDefault.default),
    filter: (0, _filterJsDefault.default),
    data: (0, _dataJsDefault.default),
    enter: (0, _enterJsDefault.default),
    exit: (0, _exitJsDefault.default),
    join: (0, _joinJsDefault.default),
    merge: (0, _mergeJsDefault.default),
    selection: selection_selection,
    order: (0, _orderJsDefault.default),
    sort: (0, _sortJsDefault.default),
    call: (0, _callJsDefault.default),
    nodes: (0, _nodesJsDefault.default),
    node: (0, _nodeJsDefault.default),
    size: (0, _sizeJsDefault.default),
    empty: (0, _emptyJsDefault.default),
    each: (0, _eachJsDefault.default),
    attr: (0, _attrJsDefault.default),
    style: (0, _styleJsDefault.default),
    property: (0, _propertyJsDefault.default),
    classed: (0, _classedJsDefault.default),
    text: (0, _textJsDefault.default),
    html: (0, _htmlJsDefault.default),
    raise: (0, _raiseJsDefault.default),
    lower: (0, _lowerJsDefault.default),
    append: (0, _appendJsDefault.default),
    insert: (0, _insertJsDefault.default),
    remove: (0, _removeJsDefault.default),
    clone: (0, _cloneJsDefault.default),
    datum: (0, _datumJsDefault.default),
    on: (0, _onJsDefault.default),
    dispatch: (0, _dispatchJsDefault.default),
    [Symbol.iterator]: (0, _iteratorJsDefault.default)
};
exports.default = selection;

},{"./select.js":"4cEkx","./selectAll.js":"kCglL","./selectChild.js":"M1ElV","./selectChildren.js":"6txEr","./filter.js":"eNhDs","./data.js":"9DDr4","./enter.js":"gP2QE","./exit.js":"jH42X","./join.js":"1AmkZ","./merge.js":"4XmUG","./order.js":"hgq2c","./sort.js":"jZWGX","./call.js":"lf3EW","./nodes.js":"j05Td","./node.js":"8ksut","./size.js":"cMqWP","./empty.js":"jngRU","./each.js":"3Fax0","./attr.js":"4sWgc","./style.js":"4vnVK","./property.js":"gUsSc","./classed.js":"7umaZ","./text.js":"8vz6Q","./html.js":"fkrCd","./raise.js":"i9fD3","./lower.js":"cy1Ek","./append.js":"dA1zq","./insert.js":"kmSFy","./remove.js":"bjetH","./clone.js":"3ll3H","./datum.js":"i9Aev","./on.js":"Lh6iE","./dispatch.js":"4tSUD","./iterator.js":"8wNwM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4cEkx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select !== "function") select = (0, _selectorJsDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
            }
        }
        return new (0, _indexJs.Selection)(subgroups, this._parents);
    });
var _indexJs = require("./index.js");
var _selectorJs = require("../selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);

},{"./index.js":"a5jDB","../selector.js":"hZ4f6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hZ4f6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? none : function() {
            return this.querySelector(selector);
        };
    });
function none() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kCglL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select === "function") select = arrayAll(select);
        else select = (0, _selectorAllJsDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                subgroups.push(select.call(node, node.__data__, i, group));
                parents.push(node);
            }
        }
        return new (0, _indexJs.Selection)(subgroups, parents);
    });
var _indexJs = require("./index.js");
var _arrayJs = require("../array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _selectorAllJs = require("../selectorAll.js");
var _selectorAllJsDefault = parcelHelpers.interopDefault(_selectorAllJs);
function arrayAll(select) {
    return function() {
        return (0, _arrayJsDefault.default)(select.apply(this, arguments));
    };
}

},{"./index.js":"a5jDB","../array.js":"jeIHr","../selectorAll.js":"9WsMK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jeIHr":[function(require,module,exports,__globalThis) {
// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>array);
function array(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9WsMK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? empty : function() {
            return this.querySelectorAll(selector);
        };
    });
function empty() {
    return [];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"M1ElV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : (0, _matcherJs.childMatcher)(match)));
    });
var _matcherJs = require("../matcher.js");
var find = Array.prototype.find;
function childFind(match) {
    return function() {
        return find.call(this.children, match);
    };
}
function childFirst() {
    return this.firstElementChild;
}

},{"../matcher.js":"3cbxf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6txEr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : (0, _matcherJs.childMatcher)(match)));
    });
var _matcherJs = require("../matcher.js");
var filter = Array.prototype.filter;
function children() {
    return Array.from(this.children);
}
function childrenFilter(match) {
    return function() {
        return filter.call(this.children, match);
    };
}

},{"../matcher.js":"3cbxf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eNhDs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        if (typeof match !== "function") match = (0, _matcherJsDefault.default)(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new (0, _indexJs.Selection)(subgroups, this._parents);
    });
var _indexJs = require("./index.js");
var _matcherJs = require("../matcher.js");
var _matcherJsDefault = parcelHelpers.interopDefault(_matcherJs);

},{"./index.js":"a5jDB","../matcher.js":"3cbxf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9DDr4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value, key) {
        if (!arguments.length) return Array.from(this, datum);
        var bind = key ? bindKey : bindIndex, parents = this._parents, groups = this._groups;
        if (typeof value !== "function") value = (0, _constantJsDefault.default)(value);
        for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
            var parent = parents[j], group = groups[j], groupLength = group.length, data = arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
            bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
            // Now connect the enter nodes to their following update node, such that
            // appendChild can insert the materialized enter node before this node,
            // rather than at the end of the parent node.
            for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
                if (i0 >= i1) i1 = i0 + 1;
                while(!(next = updateGroup[i1]) && ++i1 < dataLength);
                previous._next = next || null;
            }
        }
        update = new (0, _indexJs.Selection)(update, parents);
        update._enter = enter;
        update._exit = exit;
        return update;
    });
var _indexJs = require("./index.js");
var _enterJs = require("./enter.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, _enterJs.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, _enterJs.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function datum(node) {
    return node.__data__;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}

},{"./index.js":"a5jDB","./enter.js":"gP2QE","../constant.js":"c7sKD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gP2QE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _indexJs.Selection)(this._enter || this._groups.map((0, _sparseJsDefault.default)), this._parents);
    });
parcelHelpers.export(exports, "EnterNode", ()=>EnterNode);
var _sparseJs = require("./sparse.js");
var _sparseJsDefault = parcelHelpers.interopDefault(_sparseJs);
var _indexJs = require("./index.js");
function EnterNode(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
EnterNode.prototype = {
    constructor: EnterNode,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

},{"./sparse.js":"4Dzlv","./index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Dzlv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(update) {
        return new Array(update.length);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c7sKD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jH42X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _indexJs.Selection)(this._exit || this._groups.map((0, _sparseJsDefault.default)), this._parents);
    });
var _sparseJs = require("./sparse.js");
var _sparseJsDefault = parcelHelpers.interopDefault(_sparseJs);
var _indexJs = require("./index.js");

},{"./sparse.js":"4Dzlv","./index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1AmkZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(onenter, onupdate, onexit) {
        var enter = this.enter(), update = this, exit = this.exit();
        if (typeof onenter === "function") {
            enter = onenter(enter);
            if (enter) enter = enter.selection();
        } else enter = enter.append(onenter + "");
        if (onupdate != null) {
            update = onupdate(update);
            if (update) update = update.selection();
        }
        if (onexit == null) exit.remove();
        else onexit(exit);
        return enter && update ? enter.merge(update).order() : update;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XmUG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        var selection = context.selection ? context.selection() : context;
        for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new (0, _indexJs.Selection)(merges, this._parents);
    });
var _indexJs = require("./index.js");

},{"./index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hgq2c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
            for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
                if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
                next = node;
            }
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jZWGX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        if (!compare) compare = ascending;
        function compareNode(a, b) {
            return a && b ? compare(a.__data__, b.__data__) : !a - !b;
        }
        for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
            sortgroup.sort(compareNode);
        }
        return new (0, _indexJs.Selection)(sortgroups, this._parents).order();
    });
var _indexJs = require("./index.js");
function ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{"./index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lf3EW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var callback = arguments[0];
        arguments[0] = this;
        callback.apply(null, arguments);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j05Td":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return Array.from(this);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8ksut":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
            var node = group[i];
            if (node) return node;
        }
        return null;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cMqWP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let size = 0;
        for (const node of this)++size; // eslint-disable-line no-unused-vars
        return size;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jngRU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return !this.node();
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Fax0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4sWgc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var fullname = (0, _namespaceJsDefault.default)(name);
        if (arguments.length < 2) {
            var node = this.node();
            return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
        }
        return this.each((value == null ? fullname.local ? attrRemoveNS : attrRemove : typeof value === "function" ? fullname.local ? attrFunctionNS : attrFunction : fullname.local ? attrConstantNS : attrConstant)(fullname, value));
    });
var _namespaceJs = require("../namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
function attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}

},{"../namespace.js":"890X9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4vnVK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        return arguments.length > 1 ? this.each((value == null ? styleRemove : typeof value === "function" ? styleFunction : styleConstant)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
    });
parcelHelpers.export(exports, "styleValue", ()=>styleValue);
var _windowJs = require("../window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);
function styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function styleValue(node, name) {
    return node.style.getPropertyValue(name) || (0, _windowJsDefault.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

},{"../window.js":"aXAiN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aXAiN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node) {
        return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
         || node.document && node // node is a Window
         || node.defaultView; // node is a Document
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gUsSc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
    });
function propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7umaZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var names = classArray(name + "");
        if (arguments.length < 2) {
            var list = classList(this.node()), i = -1, n = names.length;
            while(++i < n)if (!list.contains(names[i])) return false;
            return true;
        }
        return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
    });
function classArray(string) {
    return string.trim().split(/^|\s+/);
}
function classList(node) {
    return node.classList || new ClassList(node);
}
function ClassList(node) {
    this._node = node;
    this._names = classArray(node.getAttribute("class") || "");
}
ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function classedAdd(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function classedRemove(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function classedTrue(names) {
    return function() {
        classedAdd(this, names);
    };
}
function classedFalse(names) {
    return function() {
        classedRemove(this, names);
    };
}
function classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8vz6Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction : textConstant)(value)) : this.node().textContent;
    });
function textRemove() {
    this.textContent = "";
}
function textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fkrCd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
    });
function htmlRemove() {
    this.innerHTML = "";
}
function htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i9fD3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(raise);
    });
function raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cy1Ek":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(lower);
    });
function lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dA1zq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var create = typeof name === "function" ? name : (0, _creatorJsDefault.default)(name);
        return this.select(function() {
            return this.appendChild(create.apply(this, arguments));
        });
    });
var _creatorJs = require("../creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);

},{"../creator.js":"9J1Uc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kmSFy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, before) {
        var create = typeof name === "function" ? name : (0, _creatorJsDefault.default)(name), select = before == null ? constantNull : typeof before === "function" ? before : (0, _selectorJsDefault.default)(before);
        return this.select(function() {
            return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
        });
    });
var _creatorJs = require("../creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _selectorJs = require("../selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);
function constantNull() {
    return null;
}

},{"../creator.js":"9J1Uc","../selector.js":"hZ4f6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bjetH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(remove);
    });
function remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ll3H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(deep) {
        return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
    });
function selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i9Aev":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.property("__data__", value) : this.node().__data__;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Lh6iE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(typename, value, options) {
        var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
        if (arguments.length < 2) {
            var on = this.node().__on;
            if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
                if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
            }
            return;
        }
        on = value ? onAdd : onRemove;
        for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
        return this;
    });
function contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4tSUD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(type, params) {
        return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
    });
var _windowJs = require("../window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);
function dispatchEvent(node, type, params) {
    var window = (0, _windowJsDefault.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function dispatchConstant(type, params) {
    return function() {
        return dispatchEvent(this, type, params);
    };
}
function dispatchFunction(type, params) {
    return function() {
        return dispatchEvent(this, type, params.apply(this, arguments));
    };
}

},{"../window.js":"aXAiN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8wNwM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function*() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kOGkY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(view) {
        var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        if ("onselectstart" in root) selection.on("selectstart.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        else {
            root.__noselect = root.style.MozUserSelect;
            root.style.MozUserSelect = "none";
        }
    });
parcelHelpers.export(exports, "yesdrag", ()=>yesdrag);
var _d3Selection = require("d3-selection");
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
function yesdrag(view, noclick) {
    var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

},{"d3-selection":"9PvvP","./noevent.js":"8rhnL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8rhnL":[function(require,module,exports,__globalThis) {
// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nonpassive", ()=>nonpassive);
parcelHelpers.export(exports, "nonpassivecapture", ()=>nonpassivecapture);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
const nonpassive = {
    passive: false
};
const nonpassivecapture = {
    capture: true,
    passive: false
};
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gczea":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6OX4n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DragEvent);
function DragEvent(type, { sourceEvent, subject, target, identifier, active, x, y, dx, dy, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        subject: {
            value: subject,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        identifier: {
            value: identifier,
            enumerable: true,
            configurable: true
        },
        active: {
            value: active,
            enumerable: true,
            configurable: true
        },
        x: {
            value: x,
            enumerable: true,
            configurable: true
        },
        y: {
            value: y,
            enumerable: true,
            configurable: true
        },
        dx: {
            value: dx,
            enumerable: true,
            configurable: true
        },
        dy: {
            value: dy,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}
DragEvent.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5gJW0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", ()=>(0, _valueJsDefault.default));
parcelHelpers.export(exports, "interpolateArray", ()=>(0, _arrayJsDefault.default));
parcelHelpers.export(exports, "interpolateBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "interpolateBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "interpolateDate", ()=>(0, _dateJsDefault.default));
parcelHelpers.export(exports, "interpolateDiscrete", ()=>(0, _discreteJsDefault.default));
parcelHelpers.export(exports, "interpolateHue", ()=>(0, _hueJsDefault.default));
parcelHelpers.export(exports, "interpolateNumber", ()=>(0, _numberJsDefault.default));
parcelHelpers.export(exports, "interpolateNumberArray", ()=>(0, _numberArrayJsDefault.default));
parcelHelpers.export(exports, "interpolateObject", ()=>(0, _objectJsDefault.default));
parcelHelpers.export(exports, "interpolateRound", ()=>(0, _roundJsDefault.default));
parcelHelpers.export(exports, "interpolateString", ()=>(0, _stringJsDefault.default));
parcelHelpers.export(exports, "interpolateTransformCss", ()=>(0, _indexJs.interpolateTransformCss));
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>(0, _indexJs.interpolateTransformSvg));
parcelHelpers.export(exports, "interpolateZoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "interpolateRgb", ()=>(0, _rgbJsDefault.default));
parcelHelpers.export(exports, "interpolateRgbBasis", ()=>(0, _rgbJs.rgbBasis));
parcelHelpers.export(exports, "interpolateRgbBasisClosed", ()=>(0, _rgbJs.rgbBasisClosed));
parcelHelpers.export(exports, "interpolateHsl", ()=>(0, _hslJsDefault.default));
parcelHelpers.export(exports, "interpolateHslLong", ()=>(0, _hslJs.hslLong));
parcelHelpers.export(exports, "interpolateLab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "interpolateHcl", ()=>(0, _hclJsDefault.default));
parcelHelpers.export(exports, "interpolateHclLong", ()=>(0, _hclJs.hclLong));
parcelHelpers.export(exports, "interpolateCubehelix", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixLong", ()=>(0, _cubehelixJs.cubehelixLong));
parcelHelpers.export(exports, "piecewise", ()=>(0, _piecewiseJsDefault.default));
parcelHelpers.export(exports, "quantize", ()=>(0, _quantizeJsDefault.default));
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _discreteJs = require("./discrete.js");
var _discreteJsDefault = parcelHelpers.interopDefault(_discreteJs);
var _hueJs = require("./hue.js");
var _hueJsDefault = parcelHelpers.interopDefault(_hueJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _indexJs = require("./transform/index.js");
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _hslJs = require("./hsl.js");
var _hslJsDefault = parcelHelpers.interopDefault(_hslJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _hclJs = require("./hcl.js");
var _hclJsDefault = parcelHelpers.interopDefault(_hclJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _piecewiseJs = require("./piecewise.js");
var _piecewiseJsDefault = parcelHelpers.interopDefault(_piecewiseJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);

},{"./value.js":false,"./array.js":false,"./basis.js":false,"./basisClosed.js":false,"./date.js":false,"./discrete.js":false,"./hue.js":false,"./number.js":"j5icT","./numberArray.js":false,"./object.js":false,"./round.js":false,"./string.js":"fqpjr","./transform/index.js":"5Kwa1","./zoom.js":"dYZqs","./rgb.js":"f5JLR","./hsl.js":false,"./lab.js":false,"./hcl.js":false,"./cubehelix.js":false,"./piecewise.js":false,"./quantize.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6hdhZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", ()=>basis);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    });
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"pPwhQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    });
var _basisJs = require("./basis.js");

},{"./basis.js":"6hdhZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j5icT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fqpjr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, _numberJsDefault.default)(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    });
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}

},{"./number.js":"j5icT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Kwa1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolateTransformCss", ()=>interpolateTransformCss);
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>interpolateTransformSvg);
var _numberJs = require("../number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _parseJs = require("./parse.js");
function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, _numberJsDefault.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, _numberJsDefault.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var interpolateTransformCss = interpolateTransform((0, _parseJs.parseCss), "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform((0, _parseJs.parseSvg), ", ", ")", ")");

},{"../number.js":"j5icT","./parse.js":"lUixM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lUixM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable no-undef */ parcelHelpers.export(exports, "parseCss", ()=>parseCss);
parcelHelpers.export(exports, "parseSvg", ()=>parseSvg);
var _decomposeJs = require("./decompose.js");
var _decomposeJsDefault = parcelHelpers.interopDefault(_decomposeJs);
var svgNode;
function parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, _decomposeJs.identity) : (0, _decomposeJsDefault.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
    if (value == null) return 0, _decomposeJs.identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return 0, _decomposeJs.identity;
    value = value.matrix;
    return (0, _decomposeJsDefault.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

},{"./decompose.js":"fFCw3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fFCw3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>function(a, b, c, d, e, f) {
        var scaleX, scaleY, skewX;
        if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
        if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
        if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
        if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
        return {
            translateX: e,
            translateY: f,
            rotate: Math.atan2(b, a) * degrees,
            skewX: Math.atan(skewX) * degrees,
            scaleX: scaleX,
            scaleY: scaleY
        };
    });
var degrees = 180 / Math.PI;
var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dYZqs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var epsilon2 = 1e-12;
function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
exports.default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f5JLR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", ()=>rgbBasis);
parcelHelpers.export(exports, "rgbBasisClosed", ()=>rgbBasisClosed);
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"jv6Pr","./basis.js":"6hdhZ","./basisClosed.js":"pPwhQ","./color.js":"aoWOo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jv6Pr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", ()=>(0, _colorJsDefault.default));
parcelHelpers.export(exports, "rgb", ()=>(0, _colorJs.rgb));
parcelHelpers.export(exports, "hsl", ()=>(0, _colorJs.hsl));
parcelHelpers.export(exports, "lab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "hcl", ()=>(0, _labJs.hcl));
parcelHelpers.export(exports, "lch", ()=>(0, _labJs.lch));
parcelHelpers.export(exports, "gray", ()=>(0, _labJs.gray));
parcelHelpers.export(exports, "cubehelix", ()=>(0, _cubehelixJsDefault.default));
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);

},{"./color.js":"bQ7hd","./lab.js":false,"./cubehelix.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bQ7hd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "darker", ()=>darker);
parcelHelpers.export(exports, "brighter", ()=>brighter);
parcelHelpers.export(exports, "default", ()=>color);
parcelHelpers.export(exports, "rgbConvert", ()=>rgbConvert);
parcelHelpers.export(exports, "rgb", ()=>rgb);
parcelHelpers.export(exports, "Rgb", ()=>Rgb);
parcelHelpers.export(exports, "hslConvert", ()=>hslConvert);
parcelHelpers.export(exports, "hsl", ()=>hsl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"fhaY4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fhaY4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    });
parcelHelpers.export(exports, "extend", ()=>extend);
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aoWOo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", ()=>hue);
parcelHelpers.export(exports, "gamma", ()=>gamma);
parcelHelpers.export(exports, "default", ()=>nogamma);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"xDayq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"xDayq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aj1c5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transition", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "active", ()=>(0, _activeJsDefault.default));
parcelHelpers.export(exports, "interrupt", ()=>(0, _interruptJsDefault.default));
var _indexJs = require("./selection/index.js");
var _indexJs1 = require("./transition/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _activeJs = require("./active.js");
var _activeJsDefault = parcelHelpers.interopDefault(_activeJs);
var _interruptJs = require("./interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);

},{"./selection/index.js":"kZ3M7","./transition/index.js":false,"./active.js":false,"./interrupt.js":"3IFg8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kZ3M7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _d3Selection = require("d3-selection");
var _interruptJs = require("./interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
(0, _d3Selection.selection).prototype.interrupt = (0, _interruptJsDefault.default);
(0, _d3Selection.selection).prototype.transition = (0, _transitionJsDefault.default);

},{"d3-selection":"9PvvP","./interrupt.js":"coKKt","./transition.js":"a9oBa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"coKKt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        return this.each(function() {
            (0, _interruptJsDefault.default)(this, name);
        });
    });
var _interruptJs = require("../interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);

},{"../interrupt.js":"3IFg8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3IFg8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, name) {
        var schedules = node.__transition, schedule, active, empty = true, i;
        if (!schedules) return;
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).name !== name) {
                empty = false;
                continue;
            }
            active = schedule.state > (0, _scheduleJs.STARTING) && schedule.state < (0, _scheduleJs.ENDING);
            schedule.state = (0, _scheduleJs.ENDED);
            schedule.timer.stop();
            schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
            delete schedules[i];
        }
        if (empty) delete node.__transition;
    });
var _scheduleJs = require("./transition/schedule.js");

},{"./transition/schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2KS27":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CREATED", ()=>CREATED);
parcelHelpers.export(exports, "SCHEDULED", ()=>SCHEDULED);
parcelHelpers.export(exports, "STARTING", ()=>STARTING);
parcelHelpers.export(exports, "STARTED", ()=>STARTED);
parcelHelpers.export(exports, "RUNNING", ()=>RUNNING);
parcelHelpers.export(exports, "ENDING", ()=>ENDING);
parcelHelpers.export(exports, "ENDED", ()=>ENDED);
parcelHelpers.export(exports, "default", ()=>function(node, name, id, index, group, timing) {
        var schedules = node.__transition;
        if (!schedules) node.__transition = {};
        else if (id in schedules) return;
        create(node, id, {
            name: name,
            index: index,
            group: group,
            on: emptyOn,
            tween: emptyTween,
            time: timing.time,
            delay: timing.delay,
            duration: timing.duration,
            ease: timing.ease,
            timer: null,
            state: CREATED
        });
    });
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "get", ()=>get);
var _d3Dispatch = require("d3-dispatch");
var _d3Timer = require("d3-timer");
var emptyOn = (0, _d3Dispatch.dispatch)("start", "end", "cancel", "interrupt");
var emptyTween = [];
var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;
function init(node, id) {
    var schedule = get(node, id);
    if (schedule.state > CREATED) throw new Error("too late; already scheduled");
    return schedule;
}
function set(node, id) {
    var schedule = get(node, id);
    if (schedule.state > STARTED) throw new Error("too late; already running");
    return schedule;
}
function get(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, _d3Timer.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = SCHEDULED;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== SCHEDULED) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === STARTED) return (0, _d3Timer.timeout)(start);
            // Interrupt the active transition, if any.
            if (o.state === RUNNING) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, _d3Timer.timeout)(function() {
            if (self.state === STARTED) {
                self.state = RUNNING;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = STARTING;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== STARTING) return; // interrupted
        self.state = STARTED;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === ENDING) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = ENDED;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

},{"d3-dispatch":"2VwUr","d3-timer":"lpgSt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lpgSt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>(0, _timerJs.now));
parcelHelpers.export(exports, "timer", ()=>(0, _timerJs.timer));
parcelHelpers.export(exports, "timerFlush", ()=>(0, _timerJs.timerFlush));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeoutJsDefault.default));
parcelHelpers.export(exports, "interval", ()=>(0, _intervalJsDefault.default));
var _timerJs = require("./timer.js");
var _timeoutJs = require("./timeout.js");
var _timeoutJsDefault = parcelHelpers.interopDefault(_timeoutJs);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);

},{"./timer.js":"atLFA","./timeout.js":"h5YmT","./interval.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"atLFA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>now);
parcelHelpers.export(exports, "Timer", ()=>Timer);
parcelHelpers.export(exports, "timer", ()=>timer);
parcelHelpers.export(exports, "timerFlush", ()=>timerFlush);
var frame = 0, timeout = 0, interval = 0, pokeDelay = 1000, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function now() {
    return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
    clockNow = 0;
}
function Timer() {
    this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
    constructor: Timer,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && taskTail !== this) {
            if (taskTail) taskTail._next = this;
            else taskHead = this;
            taskTail = this;
        }
        this._call = callback;
        this._time = time;
        sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            sleep();
        }
    }
};
function timer(callback, delay, time) {
    var t = new Timer;
    t.restart(callback, delay, time);
    return t;
}
function timerFlush() {
    now(); // Get the current time, if not already set.
    ++frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = taskHead, e;
    while(t){
        if ((e = clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --frame;
}
function wake() {
    clockNow = (clockLast = clock.now()) + clockSkew;
    frame = timeout = 0;
    try {
        timerFlush();
    } finally{
        frame = 0;
        nap();
        clockNow = 0;
    }
}
function poke() {
    var now = clock.now(), delay = now - clockLast;
    if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}
function nap() {
    var t0, t1 = taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
    taskTail = t0;
    sleep(time);
}
function sleep(time) {
    if (frame) return; // Soonest alarm already set, or will be.
    if (timeout) timeout = clearTimeout(timeout);
    var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
        if (interval) interval = clearInterval(interval);
    } else {
        if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
        frame = 1, setFrame(wake);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h5YmT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, delay, time) {
        var t = new (0, _timerJs.Timer);
        delay = delay == null ? 0 : +delay;
        t.restart((elapsed)=>{
            t.stop();
            callback(elapsed + delay);
        }, delay, time);
        return t;
    });
var _timerJs = require("./timer.js");

},{"./timer.js":"atLFA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a9oBa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var id, timing;
        if (name instanceof (0, _indexJs.Transition)) id = name._id, name = name._name;
        else id = (0, _indexJs.newId)(), (timing = defaultTiming).time = (0, _d3Timer.now)(), name = name == null ? null : name + "";
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, _scheduleJsDefault.default)(node, name, id, i, group, timing || inherit(node, id));
        }
        return new (0, _indexJs.Transition)(groups, this._parents, name, id);
    });
var _indexJs = require("../transition/index.js");
var _scheduleJs = require("../transition/schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);
var _d3Ease = require("d3-ease");
var _d3Timer = require("d3-timer");
var defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, _d3Ease.easeCubicInOut)
};
function inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}

},{"../transition/index.js":"5tqW2","../transition/schedule.js":"2KS27","d3-ease":"djx4i","d3-timer":"lpgSt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5tqW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transition", ()=>Transition);
parcelHelpers.export(exports, "default", ()=>transition);
parcelHelpers.export(exports, "newId", ()=>newId);
var _d3Selection = require("d3-selection");
var _attrJs = require("./attr.js");
var _attrJsDefault = parcelHelpers.interopDefault(_attrJs);
var _attrTweenJs = require("./attrTween.js");
var _attrTweenJsDefault = parcelHelpers.interopDefault(_attrTweenJs);
var _delayJs = require("./delay.js");
var _delayJsDefault = parcelHelpers.interopDefault(_delayJs);
var _durationJs = require("./duration.js");
var _durationJsDefault = parcelHelpers.interopDefault(_durationJs);
var _easeJs = require("./ease.js");
var _easeJsDefault = parcelHelpers.interopDefault(_easeJs);
var _easeVaryingJs = require("./easeVarying.js");
var _easeVaryingJsDefault = parcelHelpers.interopDefault(_easeVaryingJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _selectionJs = require("./selection.js");
var _selectionJsDefault = parcelHelpers.interopDefault(_selectionJs);
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _styleTweenJs = require("./styleTween.js");
var _styleTweenJsDefault = parcelHelpers.interopDefault(_styleTweenJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _textTweenJs = require("./textTween.js");
var _textTweenJsDefault = parcelHelpers.interopDefault(_textTweenJs);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
var _tweenJs = require("./tween.js");
var _tweenJsDefault = parcelHelpers.interopDefault(_tweenJs);
var _endJs = require("./end.js");
var _endJsDefault = parcelHelpers.interopDefault(_endJs);
var id = 0;
function Transition(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function transition(name) {
    return (0, _d3Selection.selection)().transition(name);
}
function newId() {
    return ++id;
}
var selection_prototype = (0, _d3Selection.selection).prototype;
Transition.prototype = transition.prototype = {
    constructor: Transition,
    select: (0, _selectJsDefault.default),
    selectAll: (0, _selectAllJsDefault.default),
    selectChild: selection_prototype.selectChild,
    selectChildren: selection_prototype.selectChildren,
    filter: (0, _filterJsDefault.default),
    merge: (0, _mergeJsDefault.default),
    selection: (0, _selectionJsDefault.default),
    transition: (0, _transitionJsDefault.default),
    call: selection_prototype.call,
    nodes: selection_prototype.nodes,
    node: selection_prototype.node,
    size: selection_prototype.size,
    empty: selection_prototype.empty,
    each: selection_prototype.each,
    on: (0, _onJsDefault.default),
    attr: (0, _attrJsDefault.default),
    attrTween: (0, _attrTweenJsDefault.default),
    style: (0, _styleJsDefault.default),
    styleTween: (0, _styleTweenJsDefault.default),
    text: (0, _textJsDefault.default),
    textTween: (0, _textTweenJsDefault.default),
    remove: (0, _removeJsDefault.default),
    tween: (0, _tweenJsDefault.default),
    delay: (0, _delayJsDefault.default),
    duration: (0, _durationJsDefault.default),
    ease: (0, _easeJsDefault.default),
    easeVarying: (0, _easeVaryingJsDefault.default),
    end: (0, _endJsDefault.default),
    [Symbol.iterator]: selection_prototype[Symbol.iterator]
};

},{"d3-selection":"9PvvP","./attr.js":"ettza","./attrTween.js":"fKBNf","./delay.js":"3uMbw","./duration.js":"k5T03","./ease.js":"lDozG","./easeVarying.js":"hcVmw","./filter.js":"1mjyo","./merge.js":"lnzih","./on.js":"gvIIF","./remove.js":"1KRzH","./select.js":"5uH34","./selectAll.js":"ZI7Ih","./selection.js":"1VhQX","./style.js":"gijRh","./styleTween.js":"bC37S","./text.js":"6eNBo","./textTween.js":"cwqtH","./transition.js":"htXRp","./tween.js":"fPCiA","./end.js":"a4mEw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ettza":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var fullname = (0, _d3Selection.namespace)(name), i = fullname === "transform" ? (0, _d3Interpolate.interpolateTransformSvg) : (0, _interpolateJsDefault.default);
        return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, (0, _tweenJs.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
    });
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _tweenJs = require("./tween.js");
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
function attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}

},{"d3-interpolate":"5gJW0","d3-selection":"9PvvP","./tween.js":"fPCiA","./interpolate.js":"jmTgx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fPCiA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var id = this._id;
        name += "";
        if (arguments.length < 2) {
            var tween = (0, _scheduleJs.get)(this.node(), id).tween;
            for(var i = 0, n = tween.length, t; i < n; ++i){
                if ((t = tween[i]).name === name) return t.value;
            }
            return null;
        }
        return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
    });
parcelHelpers.export(exports, "tweenValue", ()=>tweenValue);
var _scheduleJs = require("./schedule.js");
function tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function tweenValue(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, _scheduleJs.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, _scheduleJs.get)(node, id).value[name];
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jmTgx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var c;
        return (typeof b === "number" ? (0, _d3Interpolate.interpolateNumber) : b instanceof (0, _d3Color.color) ? (0, _d3Interpolate.interpolateRgb) : (c = (0, _d3Color.color)(b)) ? (b = c, _d3Interpolate.interpolateRgb) : (0, _d3Interpolate.interpolateString))(a, b);
    });
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");

},{"d3-color":"jv6Pr","d3-interpolate":"5gJW0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fKBNf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var key = "attr." + name;
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        var fullname = (0, _d3Selection.namespace)(name);
        return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
    });
var _d3Selection = require("d3-selection");
function attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}

},{"d3-selection":"9PvvP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3uMbw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id, value)) : (0, _scheduleJs.get)(this.node(), id).delay;
    });
var _scheduleJs = require("./schedule.js");
function delayFunction(id, value) {
    return function() {
        (0, _scheduleJs.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function delayConstant(id, value) {
    return value = +value, function() {
        (0, _scheduleJs.init)(this, id).delay = value;
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k5T03":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id, value)) : (0, _scheduleJs.get)(this.node(), id).duration;
    });
var _scheduleJs = require("./schedule.js");
function durationFunction(id, value) {
    return function() {
        (0, _scheduleJs.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function durationConstant(id, value) {
    return value = +value, function() {
        (0, _scheduleJs.set)(this, id).duration = value;
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lDozG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each(easeConstant(id, value)) : (0, _scheduleJs.get)(this.node(), id).ease;
    });
var _scheduleJs = require("./schedule.js");
function easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, _scheduleJs.set)(this, id).ease = value;
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hcVmw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        if (typeof value !== "function") throw new Error;
        return this.each(easeVarying(this._id, value));
    });
var _scheduleJs = require("./schedule.js");
function easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, _scheduleJs.set)(this, id).ease = v;
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1mjyo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        if (typeof match !== "function") match = (0, _d3Selection.matcher)(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new (0, _indexJs.Transition)(subgroups, this._parents, this._name, this._id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");

},{"d3-selection":"9PvvP","./index.js":"5tqW2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lnzih":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(transition) {
        if (transition._id !== this._id) throw new Error;
        for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new (0, _indexJs.Transition)(merges, this._parents, this._name, this._id);
    });
var _indexJs = require("./index.js");

},{"./index.js":"5tqW2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gvIIF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, listener) {
        var id = this._id;
        return arguments.length < 2 ? (0, _scheduleJs.get)(this.node(), id).on.on(name) : this.each(onFunction(id, name, listener));
    });
var _scheduleJs = require("./schedule.js");
function start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function onFunction(id, name, listener) {
    var on0, on1, sit = start(name) ? (0, _scheduleJs.init) : (0, _scheduleJs.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1KRzH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.on("end.remove", removeFunction(this._id));
    });
function removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5uH34":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = (0, _d3Selection.selector)(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
                (0, _scheduleJsDefault.default)(subgroup[i], name, id, i, subgroup, (0, _scheduleJs.get)(node, id));
            }
        }
        return new (0, _indexJs.Transition)(subgroups, this._parents, name, id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"d3-selection":"9PvvP","./index.js":"5tqW2","./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ZI7Ih":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = (0, _d3Selection.selectorAll)(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, _scheduleJs.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, _scheduleJsDefault.default)(child, name, id, k, children, inherit);
                subgroups.push(children);
                parents.push(node);
            }
        }
        return new (0, _indexJs.Transition)(subgroups, parents, name, id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"d3-selection":"9PvvP","./index.js":"5tqW2","./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1VhQX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new Selection(this._groups, this._parents);
    });
var _d3Selection = require("d3-selection");
var Selection = (0, _d3Selection.selection).prototype.constructor;

},{"d3-selection":"9PvvP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gijRh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        var i = (name += "") === "transform" ? (0, _d3Interpolate.interpolateTransformCss) : (0, _interpolateJsDefault.default);
        return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value === "function" ? this.styleTween(name, styleFunction(name, i, (0, _tweenJs.tweenValue)(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value), priority).on("end.style." + name, null);
    });
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _scheduleJs = require("./schedule.js");
var _tweenJs = require("./tween.js");
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
function styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name), string1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}

},{"d3-interpolate":"5gJW0","d3-selection":"9PvvP","./schedule.js":"2KS27","./tween.js":"fPCiA","./interpolate.js":"jmTgx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bC37S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        var key = "style." + (name += "");
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
    });
function styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6eNBo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return this.tween("text", typeof value === "function" ? textFunction((0, _tweenJs.tweenValue)(this, "text", value)) : textConstant(value == null ? "" : value + ""));
    });
var _tweenJs = require("./tween.js");
function textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}

},{"./tween.js":"fPCiA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cwqtH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var key = "text";
        if (arguments.length < 1) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, textTween(value));
    });
function textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htXRp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var name = this._name, id0 = this._id, id1 = (0, _indexJs.newId)();
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                var inherit = (0, _scheduleJs.get)(node, id0);
                (0, _scheduleJsDefault.default)(node, name, id1, i, group, {
                    time: inherit.time + inherit.delay + inherit.duration,
                    delay: 0,
                    duration: inherit.duration,
                    ease: inherit.ease
                });
            }
        }
        return new (0, _indexJs.Transition)(groups, this._parents, name, id1);
    });
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"./index.js":"5tqW2","./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a4mEw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var on0, on1, that = this, id = that._id, size = that.size();
        return new Promise(function(resolve, reject) {
            var cancel = {
                value: reject
            }, end = {
                value: function() {
                    if (--size === 0) resolve();
                }
            };
            that.each(function() {
                var schedule = (0, _scheduleJs.set)(this, id), on = schedule.on;
                // If this node shared a dispatch with the previous node,
                // just assign the updated shared dispatch and we’re done!
                // Otherwise, copy-on-write.
                if (on !== on0) {
                    on1 = (on0 = on).copy();
                    on1._.cancel.push(cancel);
                    on1._.interrupt.push(cancel);
                    on1._.end.push(end);
                }
                schedule.on = on1;
            });
            // The selection was empty, resolve end immediately
            if (size === 0) resolve();
        });
    });
var _scheduleJs = require("./schedule.js");

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"djx4i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeLinear", ()=>(0, _linearJs.linear));
parcelHelpers.export(exports, "easeQuad", ()=>(0, _quadJs.quadInOut));
parcelHelpers.export(exports, "easeQuadIn", ()=>(0, _quadJs.quadIn));
parcelHelpers.export(exports, "easeQuadOut", ()=>(0, _quadJs.quadOut));
parcelHelpers.export(exports, "easeQuadInOut", ()=>(0, _quadJs.quadInOut));
parcelHelpers.export(exports, "easeCubic", ()=>(0, _cubicJs.cubicInOut));
parcelHelpers.export(exports, "easeCubicIn", ()=>(0, _cubicJs.cubicIn));
parcelHelpers.export(exports, "easeCubicOut", ()=>(0, _cubicJs.cubicOut));
parcelHelpers.export(exports, "easeCubicInOut", ()=>(0, _cubicJs.cubicInOut));
parcelHelpers.export(exports, "easePoly", ()=>(0, _polyJs.polyInOut));
parcelHelpers.export(exports, "easePolyIn", ()=>(0, _polyJs.polyIn));
parcelHelpers.export(exports, "easePolyOut", ()=>(0, _polyJs.polyOut));
parcelHelpers.export(exports, "easePolyInOut", ()=>(0, _polyJs.polyInOut));
parcelHelpers.export(exports, "easeSin", ()=>(0, _sinJs.sinInOut));
parcelHelpers.export(exports, "easeSinIn", ()=>(0, _sinJs.sinIn));
parcelHelpers.export(exports, "easeSinOut", ()=>(0, _sinJs.sinOut));
parcelHelpers.export(exports, "easeSinInOut", ()=>(0, _sinJs.sinInOut));
parcelHelpers.export(exports, "easeExp", ()=>(0, _expJs.expInOut));
parcelHelpers.export(exports, "easeExpIn", ()=>(0, _expJs.expIn));
parcelHelpers.export(exports, "easeExpOut", ()=>(0, _expJs.expOut));
parcelHelpers.export(exports, "easeExpInOut", ()=>(0, _expJs.expInOut));
parcelHelpers.export(exports, "easeCircle", ()=>(0, _circleJs.circleInOut));
parcelHelpers.export(exports, "easeCircleIn", ()=>(0, _circleJs.circleIn));
parcelHelpers.export(exports, "easeCircleOut", ()=>(0, _circleJs.circleOut));
parcelHelpers.export(exports, "easeCircleInOut", ()=>(0, _circleJs.circleInOut));
parcelHelpers.export(exports, "easeBounce", ()=>(0, _bounceJs.bounceOut));
parcelHelpers.export(exports, "easeBounceIn", ()=>(0, _bounceJs.bounceIn));
parcelHelpers.export(exports, "easeBounceOut", ()=>(0, _bounceJs.bounceOut));
parcelHelpers.export(exports, "easeBounceInOut", ()=>(0, _bounceJs.bounceInOut));
parcelHelpers.export(exports, "easeBack", ()=>(0, _backJs.backInOut));
parcelHelpers.export(exports, "easeBackIn", ()=>(0, _backJs.backIn));
parcelHelpers.export(exports, "easeBackOut", ()=>(0, _backJs.backOut));
parcelHelpers.export(exports, "easeBackInOut", ()=>(0, _backJs.backInOut));
parcelHelpers.export(exports, "easeElastic", ()=>(0, _elasticJs.elasticOut));
parcelHelpers.export(exports, "easeElasticIn", ()=>(0, _elasticJs.elasticIn));
parcelHelpers.export(exports, "easeElasticOut", ()=>(0, _elasticJs.elasticOut));
parcelHelpers.export(exports, "easeElasticInOut", ()=>(0, _elasticJs.elasticInOut));
var _linearJs = require("./linear.js");
var _quadJs = require("./quad.js");
var _cubicJs = require("./cubic.js");
var _polyJs = require("./poly.js");
var _sinJs = require("./sin.js");
var _expJs = require("./exp.js");
var _circleJs = require("./circle.js");
var _bounceJs = require("./bounce.js");
var _backJs = require("./back.js");
var _elasticJs = require("./elastic.js");

},{"./linear.js":false,"./quad.js":false,"./cubic.js":"kXdds","./poly.js":false,"./sin.js":false,"./exp.js":false,"./circle.js":false,"./bounce.js":false,"./back.js":false,"./elastic.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kXdds":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicIn", ()=>cubicIn);
parcelHelpers.export(exports, "cubicOut", ()=>cubicOut);
parcelHelpers.export(exports, "cubicInOut", ()=>cubicInOut);
function cubicIn(t) {
    return t * t * t;
}
function cubicOut(t) {
    return --t * t * t + 1;
}
function cubicInOut(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i5Vxu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aUnay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ZoomEvent);
function ZoomEvent(type, { sourceEvent, target, transform, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"boRyC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transform", ()=>Transform);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>transform);
function Transform(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
Transform.prototype = {
    constructor: Transform,
    scale: function(k) {
        return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var identity = new Transform(1, 0, 0);
transform.prototype = Transform.prototype;
function transform(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return identity;
    return node.__zoom;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67dpU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d9cb4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MiniMap", ()=>MiniMap$1);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classcat = require("classcat");
var _classcatDefault = parcelHelpers.interopDefault(_classcat);
var _shallow = require("zustand/shallow");
var _d3Zoom = require("d3-zoom");
var _d3Selection = require("d3-selection");
var _core = require("@reactflow/core");
const MiniMapNode = ({ id, x, y, width, height, style, color, strokeColor, strokeWidth, className, borderRadius, shapeRendering, onClick, selected })=>{
    const { background, backgroundColor } = style || {};
    const fill = color || background || backgroundColor;
    return (0, _reactDefault.default).createElement("rect", {
        className: (0, _classcatDefault.default)([
            'react-flow__minimap-node',
            {
                selected
            },
            className
        ]),
        x: x,
        y: y,
        rx: borderRadius,
        ry: borderRadius,
        width: width,
        height: height,
        fill: fill,
        stroke: strokeColor,
        strokeWidth: strokeWidth,
        shapeRendering: shapeRendering,
        onClick: onClick ? (event)=>onClick(event, id) : undefined
    });
};
MiniMapNode.displayName = 'MiniMapNode';
var MiniMapNode$1 = (0, _react.memo)(MiniMapNode);
/* eslint-disable @typescript-eslint/ban-ts-comment */ const selector$1 = (s)=>s.nodeOrigin;
const selectorNodes = (s)=>s.getNodes().filter((node)=>!node.hidden && node.width && node.height);
const getAttrFunction = (func)=>func instanceof Function ? func : ()=>func;
function MiniMapNodes({ nodeStrokeColor = 'transparent', nodeColor = '#e2e2e2', nodeClassName = '', nodeBorderRadius = 5, nodeStrokeWidth = 2, // We need to rename the prop to be `CapitalCase` so that JSX will render it as
// a component properly.
nodeComponent: NodeComponent = MiniMapNode$1, onClick }) {
    const nodes = (0, _core.useStore)(selectorNodes, (0, _shallow.shallow));
    const nodeOrigin = (0, _core.useStore)(selector$1);
    const nodeColorFunc = getAttrFunction(nodeColor);
    const nodeStrokeColorFunc = getAttrFunction(nodeStrokeColor);
    const nodeClassNameFunc = getAttrFunction(nodeClassName);
    const shapeRendering = typeof window === 'undefined' || !!window.chrome ? 'crispEdges' : 'geometricPrecision';
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, nodes.map((node)=>{
        const { x, y } = (0, _core.getNodePositionWithOrigin)(node, nodeOrigin).positionAbsolute;
        return (0, _reactDefault.default).createElement(NodeComponent, {
            key: node.id,
            x: x,
            y: y,
            width: node.width,
            height: node.height,
            style: node.style,
            selected: node.selected,
            className: nodeClassNameFunc(node),
            color: nodeColorFunc(node),
            borderRadius: nodeBorderRadius,
            strokeColor: nodeStrokeColorFunc(node),
            strokeWidth: nodeStrokeWidth,
            shapeRendering: shapeRendering,
            onClick: onClick,
            id: node.id
        });
    }));
}
var MiniMapNodes$1 = (0, _react.memo)(MiniMapNodes);
/* eslint-disable @typescript-eslint/ban-ts-comment */ const defaultWidth = 200;
const defaultHeight = 150;
const selector = (s)=>{
    const nodes = s.getNodes();
    const viewBB = {
        x: -s.transform[0] / s.transform[2],
        y: -s.transform[1] / s.transform[2],
        width: s.width / s.transform[2],
        height: s.height / s.transform[2]
    };
    return {
        viewBB,
        boundingRect: nodes.length > 0 ? (0, _core.getBoundsOfRects)((0, _core.getNodesBounds)(nodes, s.nodeOrigin), viewBB) : viewBB,
        rfId: s.rfId
    };
};
const ARIA_LABEL_KEY = 'react-flow__minimap-desc';
function MiniMap({ style, className, nodeStrokeColor = 'transparent', nodeColor = '#e2e2e2', nodeClassName = '', nodeBorderRadius = 5, nodeStrokeWidth = 2, // We need to rename the prop to be `CapitalCase` so that JSX will render it as
// a component properly.
nodeComponent, maskColor = 'rgb(240, 240, 240, 0.6)', maskStrokeColor = 'none', maskStrokeWidth = 1, position = 'bottom-right', onClick, onNodeClick, pannable = false, zoomable = false, ariaLabel = 'React Flow mini map', inversePan = false, zoomStep = 10, offsetScale = 5 }) {
    const store = (0, _core.useStoreApi)();
    const svg = (0, _react.useRef)(null);
    const { boundingRect, viewBB, rfId } = (0, _core.useStore)(selector, (0, _shallow.shallow));
    const elementWidth = style?.width ?? defaultWidth;
    const elementHeight = style?.height ?? defaultHeight;
    const scaledWidth = boundingRect.width / elementWidth;
    const scaledHeight = boundingRect.height / elementHeight;
    const viewScale = Math.max(scaledWidth, scaledHeight);
    const viewWidth = viewScale * elementWidth;
    const viewHeight = viewScale * elementHeight;
    const offset = offsetScale * viewScale;
    const x = boundingRect.x - (viewWidth - boundingRect.width) / 2 - offset;
    const y = boundingRect.y - (viewHeight - boundingRect.height) / 2 - offset;
    const width = viewWidth + offset * 2;
    const height = viewHeight + offset * 2;
    const labelledBy = `${ARIA_LABEL_KEY}-${rfId}`;
    const viewScaleRef = (0, _react.useRef)(0);
    viewScaleRef.current = viewScale;
    (0, _react.useEffect)(()=>{
        if (svg.current) {
            const selection = (0, _d3Selection.select)(svg.current);
            const zoomHandler = (event)=>{
                const { transform, d3Selection, d3Zoom } = store.getState();
                if (event.sourceEvent.type !== 'wheel' || !d3Selection || !d3Zoom) return;
                const pinchDelta = -event.sourceEvent.deltaY * (event.sourceEvent.deltaMode === 1 ? 0.05 : event.sourceEvent.deltaMode ? 1 : 0.002) * zoomStep;
                const zoom = transform[2] * Math.pow(2, pinchDelta);
                d3Zoom.scaleTo(d3Selection, zoom);
            };
            const panHandler = (event)=>{
                const { transform, d3Selection, d3Zoom, translateExtent, width, height } = store.getState();
                if (event.sourceEvent.type !== 'mousemove' || !d3Selection || !d3Zoom) return;
                // @TODO: how to calculate the correct next position? Math.max(1, transform[2]) is a workaround.
                const moveScale = viewScaleRef.current * Math.max(1, transform[2]) * (inversePan ? -1 : 1);
                const position = {
                    x: transform[0] - event.sourceEvent.movementX * moveScale,
                    y: transform[1] - event.sourceEvent.movementY * moveScale
                };
                const extent = [
                    [
                        0,
                        0
                    ],
                    [
                        width,
                        height
                    ]
                ];
                const nextTransform = (0, _d3Zoom.zoomIdentity).translate(position.x, position.y).scale(transform[2]);
                const constrainedTransform = d3Zoom.constrain()(nextTransform, extent, translateExtent);
                d3Zoom.transform(d3Selection, constrainedTransform);
            };
            const zoomAndPanHandler = (0, _d3Zoom.zoom)()// @ts-ignore
            .on('zoom', pannable ? panHandler : null)// @ts-ignore
            .on('zoom.wheel', zoomable ? zoomHandler : null);
            selection.call(zoomAndPanHandler);
            return ()=>{
                selection.on('zoom', null);
            };
        }
    }, [
        pannable,
        zoomable,
        inversePan,
        zoomStep
    ]);
    const onSvgClick = onClick ? (event)=>{
        const rfCoord = (0, _d3Selection.pointer)(event);
        onClick(event, {
            x: rfCoord[0],
            y: rfCoord[1]
        });
    } : undefined;
    const onSvgNodeClick = onNodeClick ? (event, nodeId)=>{
        const node = store.getState().nodeInternals.get(nodeId);
        onNodeClick(event, node);
    } : undefined;
    return (0, _reactDefault.default).createElement((0, _core.Panel), {
        position: position,
        style: style,
        className: (0, _classcatDefault.default)([
            'react-flow__minimap',
            className
        ]),
        "data-testid": "rf__minimap"
    }, (0, _reactDefault.default).createElement("svg", {
        width: elementWidth,
        height: elementHeight,
        viewBox: `${x} ${y} ${width} ${height}`,
        role: "img",
        "aria-labelledby": labelledBy,
        ref: svg,
        onClick: onSvgClick
    }, ariaLabel && (0, _reactDefault.default).createElement("title", {
        id: labelledBy
    }, ariaLabel), (0, _reactDefault.default).createElement(MiniMapNodes$1, {
        onClick: onSvgNodeClick,
        nodeColor: nodeColor,
        nodeStrokeColor: nodeStrokeColor,
        nodeBorderRadius: nodeBorderRadius,
        nodeClassName: nodeClassName,
        nodeStrokeWidth: nodeStrokeWidth,
        nodeComponent: nodeComponent
    }), (0, _reactDefault.default).createElement("path", {
        className: "react-flow__minimap-mask",
        d: `M${x - offset},${y - offset}h${width + offset * 2}v${height + offset * 2}h${-width - offset * 2}z
        M${viewBB.x},${viewBB.y}h${viewBB.width}v${viewBB.height}h${-viewBB.width}z`,
        fill: maskColor,
        fillRule: "evenodd",
        stroke: maskStrokeColor,
        strokeWidth: maskStrokeWidth,
        pointerEvents: "none"
    })));
}
MiniMap.displayName = 'MiniMap';
var MiniMap$1 = (0, _react.memo)(MiniMap);

},{"react":"9njXz","classcat":"1IIbb","zustand/shallow":"qIjDw","d3-zoom":"9wSnq","d3-selection":"9PvvP","@reactflow/core":"3rgpy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eTDWu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ControlButton", ()=>ControlButton);
parcelHelpers.export(exports, "Controls", ()=>Controls$1);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classcat = require("classcat");
var _classcatDefault = parcelHelpers.interopDefault(_classcat);
var _shallow = require("zustand/shallow");
var _core = require("@reactflow/core");
function PlusIcon() {
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M32 18.133H18.133V32h-4.266V18.133H0v-4.266h13.867V0h4.266v13.867H32z"
    }));
}
function MinusIcon() {
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 5"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M0 0h32v4.2H0z"
    }));
}
function FitViewIcon() {
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 30"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M3.692 4.63c0-.53.4-.938.939-.938h5.215V0H4.708C2.13 0 0 2.054 0 4.63v5.216h3.692V4.631zM27.354 0h-5.2v3.692h5.17c.53 0 .984.4.984.939v5.215H32V4.631A4.624 4.624 0 0027.354 0zm.954 24.83c0 .532-.4.94-.939.94h-5.215v3.768h5.215c2.577 0 4.631-2.13 4.631-4.707v-5.139h-3.692v5.139zm-23.677.94c-.531 0-.939-.4-.939-.94v-5.138H0v5.139c0 2.577 2.13 4.707 4.708 4.707h5.138V25.77H4.631z"
    }));
}
function LockIcon() {
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 32"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0 8 0 4.571 3.429 4.571 7.619v3.048H3.048A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047zm4.724-13.866H7.467V7.619c0-2.59 2.133-4.724 4.723-4.724 2.591 0 4.724 2.133 4.724 4.724v3.048z"
    }));
}
function UnlockIcon() {
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 32"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0c-4.114 1.828-1.37 2.133.305 2.438 1.676.305 4.42 2.59 4.42 5.181v3.048H3.047A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047z"
    }));
}
const ControlButton = ({ children, className, ...rest })=>(0, _reactDefault.default).createElement("button", {
        type: "button",
        className: (0, _classcatDefault.default)([
            'react-flow__controls-button',
            className
        ]),
        ...rest
    }, children);
ControlButton.displayName = 'ControlButton';
const selector = (s)=>({
        isInteractive: s.nodesDraggable || s.nodesConnectable || s.elementsSelectable,
        minZoomReached: s.transform[2] <= s.minZoom,
        maxZoomReached: s.transform[2] >= s.maxZoom
    });
const Controls = ({ style, showZoom = true, showFitView = true, showInteractive = true, fitViewOptions, onZoomIn, onZoomOut, onFitView, onInteractiveChange, className, children, position = 'bottom-left' })=>{
    const store = (0, _core.useStoreApi)();
    const [isVisible, setIsVisible] = (0, _react.useState)(false);
    const { isInteractive, minZoomReached, maxZoomReached } = (0, _core.useStore)(selector, (0, _shallow.shallow));
    const { zoomIn, zoomOut, fitView } = (0, _core.useReactFlow)();
    (0, _react.useEffect)(()=>{
        setIsVisible(true);
    }, []);
    if (!isVisible) return null;
    const onZoomInHandler = ()=>{
        zoomIn();
        onZoomIn?.();
    };
    const onZoomOutHandler = ()=>{
        zoomOut();
        onZoomOut?.();
    };
    const onFitViewHandler = ()=>{
        fitView(fitViewOptions);
        onFitView?.();
    };
    const onToggleInteractivity = ()=>{
        store.setState({
            nodesDraggable: !isInteractive,
            nodesConnectable: !isInteractive,
            elementsSelectable: !isInteractive
        });
        onInteractiveChange?.(!isInteractive);
    };
    return (0, _reactDefault.default).createElement((0, _core.Panel), {
        className: (0, _classcatDefault.default)([
            'react-flow__controls',
            className
        ]),
        position: position,
        style: style,
        "data-testid": "rf__controls"
    }, showZoom && (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(ControlButton, {
        onClick: onZoomInHandler,
        className: "react-flow__controls-zoomin",
        title: "zoom in",
        "aria-label": "zoom in",
        disabled: maxZoomReached
    }, (0, _reactDefault.default).createElement(PlusIcon, null)), (0, _reactDefault.default).createElement(ControlButton, {
        onClick: onZoomOutHandler,
        className: "react-flow__controls-zoomout",
        title: "zoom out",
        "aria-label": "zoom out",
        disabled: minZoomReached
    }, (0, _reactDefault.default).createElement(MinusIcon, null))), showFitView && (0, _reactDefault.default).createElement(ControlButton, {
        className: "react-flow__controls-fitview",
        onClick: onFitViewHandler,
        title: "fit view",
        "aria-label": "fit view"
    }, (0, _reactDefault.default).createElement(FitViewIcon, null)), showInteractive && (0, _reactDefault.default).createElement(ControlButton, {
        className: "react-flow__controls-interactive",
        onClick: onToggleInteractivity,
        title: "toggle interactivity",
        "aria-label": "toggle interactivity"
    }, isInteractive ? (0, _reactDefault.default).createElement(UnlockIcon, null) : (0, _reactDefault.default).createElement(LockIcon, null)), children);
};
Controls.displayName = 'Controls';
var Controls$1 = (0, _react.memo)(Controls);

},{"react":"9njXz","classcat":"1IIbb","zustand/shallow":"qIjDw","@reactflow/core":"3rgpy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6FeeA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Background", ()=>Background$1);
parcelHelpers.export(exports, "BackgroundVariant", ()=>BackgroundVariant);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classcat = require("classcat");
var _classcatDefault = parcelHelpers.interopDefault(_classcat);
var _core = require("@reactflow/core");
var _shallow = require("zustand/shallow");
var BackgroundVariant;
(function(BackgroundVariant) {
    BackgroundVariant["Lines"] = "lines";
    BackgroundVariant["Dots"] = "dots";
    BackgroundVariant["Cross"] = "cross";
})(BackgroundVariant || (BackgroundVariant = {}));
function LinePattern({ color, dimensions, lineWidth }) {
    return (0, _reactDefault.default).createElement("path", {
        stroke: color,
        strokeWidth: lineWidth,
        d: `M${dimensions[0] / 2} 0 V${dimensions[1]} M0 ${dimensions[1] / 2} H${dimensions[0]}`
    });
}
function DotPattern({ color, radius }) {
    return (0, _reactDefault.default).createElement("circle", {
        cx: radius,
        cy: radius,
        r: radius,
        fill: color
    });
}
const defaultColor = {
    [BackgroundVariant.Dots]: '#91919a',
    [BackgroundVariant.Lines]: '#eee',
    [BackgroundVariant.Cross]: '#e2e2e2'
};
const defaultSize = {
    [BackgroundVariant.Dots]: 1,
    [BackgroundVariant.Lines]: 1,
    [BackgroundVariant.Cross]: 6
};
const selector = (s)=>({
        transform: s.transform,
        patternId: `pattern-${s.rfId}`
    });
function Background({ id, variant = BackgroundVariant.Dots, // only used for dots and cross
gap = 20, // only used for lines and cross
size, lineWidth = 1, offset = 2, color, style, className }) {
    const ref = (0, _react.useRef)(null);
    const { transform, patternId } = (0, _core.useStore)(selector, (0, _shallow.shallow));
    const patternColor = color || defaultColor[variant];
    const patternSize = size || defaultSize[variant];
    const isDots = variant === BackgroundVariant.Dots;
    const isCross = variant === BackgroundVariant.Cross;
    const gapXY = Array.isArray(gap) ? gap : [
        gap,
        gap
    ];
    const scaledGap = [
        gapXY[0] * transform[2] || 1,
        gapXY[1] * transform[2] || 1
    ];
    const scaledSize = patternSize * transform[2];
    const patternDimensions = isCross ? [
        scaledSize,
        scaledSize
    ] : scaledGap;
    const patternOffset = isDots ? [
        scaledSize / offset,
        scaledSize / offset
    ] : [
        patternDimensions[0] / offset,
        patternDimensions[1] / offset
    ];
    return (0, _reactDefault.default).createElement("svg", {
        className: (0, _classcatDefault.default)([
            'react-flow__background',
            className
        ]),
        style: {
            ...style,
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0
        },
        ref: ref,
        "data-testid": "rf__background"
    }, (0, _reactDefault.default).createElement("pattern", {
        id: patternId + id,
        x: transform[0] % scaledGap[0],
        y: transform[1] % scaledGap[1],
        width: scaledGap[0],
        height: scaledGap[1],
        patternUnits: "userSpaceOnUse",
        patternTransform: `translate(-${patternOffset[0]},-${patternOffset[1]})`
    }, isDots ? (0, _reactDefault.default).createElement(DotPattern, {
        color: patternColor,
        radius: scaledSize / offset
    }) : (0, _reactDefault.default).createElement(LinePattern, {
        dimensions: patternDimensions,
        color: patternColor,
        lineWidth: lineWidth
    })), (0, _reactDefault.default).createElement("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: `url(#${patternId + id})`
    }));
}
Background.displayName = 'Background';
var Background$1 = (0, _react.memo)(Background);

},{"react":"9njXz","classcat":"1IIbb","@reactflow/core":"3rgpy","zustand/shallow":"qIjDw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jffgV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NodeToolbar", ()=>NodeToolbar);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _core = require("@reactflow/core");
var _classcat = require("classcat");
var _classcatDefault = parcelHelpers.interopDefault(_classcat);
var _shallow = require("zustand/shallow");
var _reactDom = require("react-dom");
const selector = (state)=>state.domNode?.querySelector('.react-flow__renderer');
function NodeToolbarPortal({ children }) {
    const wrapperRef = (0, _core.useStore)(selector);
    if (!wrapperRef) return null;
    return (0, _reactDom.createPortal)(children, wrapperRef);
}
const nodeEqualityFn = (a, b)=>a?.positionAbsolute?.x === b?.positionAbsolute?.x && a?.positionAbsolute?.y === b?.positionAbsolute?.y && a?.width === b?.width && a?.height === b?.height && a?.selected === b?.selected && a?.[0, _core.internalsSymbol]?.z === b?.[0, _core.internalsSymbol]?.z;
const nodesEqualityFn = (a, b)=>{
    return a.length === b.length && a.every((node, i)=>nodeEqualityFn(node, b[i]));
};
const storeSelector = (state)=>({
        transform: state.transform,
        nodeOrigin: state.nodeOrigin,
        selectedNodesCount: state.getNodes().filter((node)=>node.selected).length
    });
function getTransform(nodeRect, transform, position, offset, align) {
    let alignmentOffset = 0.5;
    if (align === 'start') alignmentOffset = 0;
    else if (align === 'end') alignmentOffset = 1;
    // position === Position.Top
    // we set the x any y position of the toolbar based on the nodes position
    let pos = [
        (nodeRect.x + nodeRect.width * alignmentOffset) * transform[2] + transform[0],
        nodeRect.y * transform[2] + transform[1] - offset
    ];
    // and than shift it based on the alignment. The shift values are in %.
    let shift = [
        -100 * alignmentOffset,
        -100
    ];
    switch(position){
        case (0, _core.Position).Right:
            pos = [
                (nodeRect.x + nodeRect.width) * transform[2] + transform[0] + offset,
                (nodeRect.y + nodeRect.height * alignmentOffset) * transform[2] + transform[1]
            ];
            shift = [
                0,
                -100 * alignmentOffset
            ];
            break;
        case (0, _core.Position).Bottom:
            pos[1] = (nodeRect.y + nodeRect.height) * transform[2] + transform[1] + offset;
            shift[1] = 0;
            break;
        case (0, _core.Position).Left:
            pos = [
                nodeRect.x * transform[2] + transform[0] - offset,
                (nodeRect.y + nodeRect.height * alignmentOffset) * transform[2] + transform[1]
            ];
            shift = [
                -100,
                -100 * alignmentOffset
            ];
            break;
    }
    return `translate(${pos[0]}px, ${pos[1]}px) translate(${shift[0]}%, ${shift[1]}%)`;
}
function NodeToolbar({ nodeId, children, className, style, isVisible, position = (0, _core.Position).Top, offset = 10, align = 'center', ...rest }) {
    const contextNodeId = (0, _core.useNodeId)();
    const nodesSelector = (0, _react.useCallback)((state)=>{
        const nodeIds = Array.isArray(nodeId) ? nodeId : [
            nodeId || contextNodeId || ''
        ];
        return nodeIds.reduce((acc, id)=>{
            const node = state.nodeInternals.get(id);
            if (node) acc.push(node);
            return acc;
        }, []);
    }, [
        nodeId,
        contextNodeId
    ]);
    const nodes = (0, _core.useStore)(nodesSelector, nodesEqualityFn);
    const { transform, nodeOrigin, selectedNodesCount } = (0, _core.useStore)(storeSelector, (0, _shallow.shallow));
    const isActive = typeof isVisible === 'boolean' ? isVisible : nodes.length === 1 && nodes[0].selected && selectedNodesCount === 1;
    if (!isActive || !nodes.length) return null;
    const nodeRect = (0, _core.getNodesBounds)(nodes, nodeOrigin);
    const zIndex = Math.max(...nodes.map((node)=>(node[0, _core.internalsSymbol]?.z || 1) + 1));
    const wrapperStyle = {
        position: 'absolute',
        transform: getTransform(nodeRect, transform, position, offset, align),
        zIndex,
        ...style
    };
    return (0, _reactDefault.default).createElement(NodeToolbarPortal, null, (0, _reactDefault.default).createElement("div", {
        style: wrapperStyle,
        className: (0, _classcatDefault.default)([
            'react-flow__node-toolbar',
            className
        ]),
        ...rest
    }, children));
}

},{"react":"9njXz","@reactflow/core":"3rgpy","classcat":"1IIbb","zustand/shallow":"qIjDw","react-dom":"2ApDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bV2OD":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"dc3gA","./de.json":"kpyMk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dc3gA":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineConditionWfl\":{\"title\":\"Condition\",\"description\":\"Restrict execution to meeting of a condition\"},\"mask\":{\"FormEngineConditionWfl\":{\"groupTitle\":\"Condition\"}}}");

},{}],"kpyMk":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"FormEngineConditionWfl":{"title":"Zustand","description":"Beschr\xe4nken Sie die Ausf\xfchrung auf die Erf\xfcllung einer Bedingung"},"mask":{"FormEngineConditionWfl":{"groupTitle":"Zustand"}}}');

},{}],"kbWTZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _signalWflMask = require("./components/signal-wfl-mask");
var _signalWflMaskDefault = parcelHelpers.interopDefault(_signalWflMask);
var _signal = require("./workflow-layers/signal");
var _signalDefault = parcelHelpers.interopDefault(_signal);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _signalWflNode = require("./components/signal-wfl-node");
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    workflowLayers: {
        [(0, _signalDefault.default).apiName]: {
            label: `${(0, _signalDefault.default).apiName}.title`,
            description: `${(0, _signalDefault.default).apiName}.description`,
            Icon: (0, _reactBootstrapIcons.LightningChargeFill),
            WorkflowLayer: (0, _signalDefault.default),
            Mask: (0, _signalWflMaskDefault.default),
            Node: (0, _signalWflNode.BuilderSignalWflNode)
        }
    }
};

},{"./components/signal-wfl-mask":"j38vA","./workflow-layers/signal":"abcXP","react-bootstrap-icons":"3TzoC","./components/signal-wfl-node":"a6Yeq","./builder-translations":"f0mJW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j38vA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderShowPageWflSetup", ()=>BuilderShowPageWflSetup);
parcelHelpers.export(exports, "default", ()=>BuilderShowPageWflMask);
var _jsxRuntime = require("react/jsx-runtime");
var _wflBehaviour = require("@form-engine/builder-mask/components/groups/wfl-behaviour");
var _wflBehaviourDefault = parcelHelpers.interopDefault(_wflBehaviour);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _enum = require("@form-engine/builder-mask/components/properties/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _fieldName = require("@form-engine/builder-mask/components/properties/field-name");
var _fieldNameDefault = parcelHelpers.interopDefault(_fieldName);
var _index = require("@form-engine/builder-application/index");
var _signal = require("../workflow-layers/signal");
function BuilderShowPageWflSetup() {
    const [signalType] = (0, _useMask.useMaskProperty)('signalType');
    const { c } = (0, _index.i18n).prefix(`mask.${(0, _signal.apiName)}.`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wflBehaviourDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                label: c('groupTitle'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                        propertyName: "signalType",
                        label: c('signalType'),
                        defaultValue: "default",
                        options: [
                            [
                                'default',
                                c('options.default')
                            ],
                            [
                                'onFieldChange',
                                c('options.onFieldChange')
                            ]
                        ]
                    }),
                    signalType === 'onFieldChange' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldNameDefault.default), {
                        propertyName: "signalOnChangeSource",
                        label: c('signalOnChangeSource')
                    })
                ]
            })
        ]
    });
}
function BuilderShowPageWflMask() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderShowPageWflSetup, {});
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-mask/components/groups/wfl-behaviour":"3PqZm","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/properties/enum":"2kNfK","@form-engine/builder-mask/hooks/use-mask":"72MTY","@form-engine/builder-mask/components/properties/field-name":"jTn53","@form-engine/builder-application/index":"7iKr0","../workflow-layers/signal":"abcXP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jTn53":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderFieldNameProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _coreApplication = require("@form-engine/core-application");
var _coreApplicationDefault = parcelHelpers.interopDefault(_coreApplication);
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _enum = require("./enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _builderApplication = require("@form-engine/builder-application");
function BuilderFieldNameProperty({ omit = [], ...props }) {
    const { state: elements } = (0, _useForm.useFormElements)();
    const required = 'required' in props && props.required !== false;
    delete props.required;
    const options = (0, _react.useMemo)(()=>{
        const fields = (0, _coreApplicationDefault.default).getFieldElements();
        const items = (elements || []).filter(({ type, name })=>name && !omit.includes(name) && type in fields).map(({ name })=>[
                name
            ]);
        if (required) return items;
        return [
            ...items
        ];
    }, [
        elements,
        omit,
        required
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
        label: (0, _builderApplication.i18n).c('mask.fieldNameProperty.title'),
        ...props,
        propertyName: props.propertyName ?? 'fieldName',
        options: options
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application":"fjN6J","@form-engine/core-application/hooks/use-form":"5PZyy","react":"9njXz","./enum":"2kNfK","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a6Yeq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderSignalWflNode", ()=>BuilderSignalWflNode);
var _jsxRuntime = require("react/jsx-runtime");
var _layerNode = require("@form-engine/builder-form-editor/components/workflow-editor/layer-node");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const BuilderSignalWflNode = /*#__PURE__*/ (0, _react.memo)(function BuilderSignalWflNode(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layerNode.BuilderWorkflowEditorLayerNode), {
        ...props,
        sources: {
            success: {}
        },
        targets: false
    });
});

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-form-editor/components/workflow-editor/layer-node":"kygrj","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f0mJW":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"kkJzo","./de.json":"fFj4B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kkJzo":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineSignalWfl\":{\"title\":\"Signal\",\"description\":\"Trigger Signals from within your form to start a Workflow\"},\"mask\":{\"FormEngineSignalWfl\":{\"groupTitle\":\"Signal\",\"signalType\":\"Signal Type\",\"signalOnChangeSource\":\"Source Field\",\"options\":{\"default\":\"Manually Triggered\",\"onFieldChange\":\"On Field Change\"}}}}");

},{}],"fFj4B":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"FormEngineSignalWfl":{"title":"Signal","description":"L\xf6sen Sie Signale aus Ihrem Formular aus, um einen Workflow zu starten"},"mask":{"FormEngineSignalWfl":{"groupTitle":"Signal","signalType":"Signal Typ","signalOnChangeSource":"Ausl\xf6sendes Feld","options":{"default":"Manuell ausgel\xf6st","onFieldChange":"Bei Feld\xe4nderung"}}}}');

},{}],"2ES9c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setterWflMask = require("./components/setter-wfl-mask");
var _setterWflMaskDefault = parcelHelpers.interopDefault(_setterWflMask);
var _setter = require("./workflow-layers/setter");
var _setterDefault = parcelHelpers.interopDefault(_setter);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _setterWflNode = require("./components/setter-wfl-node");
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    workflowLayers: {
        [(0, _setterDefault.default).apiName]: {
            label: `${(0, _setterDefault.default).apiName}.title`,
            description: `${(0, _setterDefault.default).apiName}.description`,
            Icon: (0, _reactBootstrapIcons.PencilSquare),
            WorkflowLayer: (0, _setterDefault.default),
            Mask: (0, _setterWflMaskDefault.default),
            Node: (0, _setterWflNode.BuilderSetterWflNode)
        }
    }
};

},{"./components/setter-wfl-mask":"9qKuU","./workflow-layers/setter":"iC4Ck","react-bootstrap-icons":"3TzoC","./components/setter-wfl-node":"aa79E","./builder-translations":"l5qFz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9qKuU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderSetterWflSetup", ()=>BuilderSetterWflSetup);
parcelHelpers.export(exports, "default", ()=>BuilderSetterWflMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _wflBehaviour = require("@form-engine/builder-mask/components/groups/wfl-behaviour");
var _wflBehaviourDefault = parcelHelpers.interopDefault(_wflBehaviour);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _builderApplication = require("@form-engine/builder-application");
var _setter = require("../workflow-layers/setter");
var _setterDefault = parcelHelpers.interopDefault(_setter);
var _object = require("@form-engine/builder-mask/components/properties/object");
var _objectDefault = parcelHelpers.interopDefault(_object);
function BuilderSetterWflSetup() {
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _setterDefault.default).apiName}.`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wflBehaviourDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupDefault.default), {
                label: c(`groupTitle`),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _objectDefault.default), {
                    propertyName: "assignments",
                    label: c(`assignments`)
                })
            })
        ]
    });
}
function BuilderSetterWflMask() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderSetterWflSetup, {});
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/groups/wfl-behaviour":"3PqZm","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-application":"7iKr0","../workflow-layers/setter":"iC4Ck","@form-engine/builder-mask/components/properties/object":"2qru1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aa79E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderSetterWflNode", ()=>BuilderSetterWflNode);
var _jsxRuntime = require("react/jsx-runtime");
var _layerNode = require("@form-engine/builder-form-editor/components/workflow-editor/layer-node");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrapIcons = require("react-bootstrap-icons");
const BuilderSetterWflNode = /*#__PURE__*/ (0, _react.memo)(function BuilderSetterWflNode(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layerNode.BuilderWorkflowEditorLayerNode), {
        ...props,
        sources: {
            success: {
                icon: (0, _reactBootstrapIcons.CheckCircleFill)
            }
        }
    });
});

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-form-editor/components/workflow-editor/layer-node":"kygrj","react":"9njXz","react-bootstrap-icons":"3TzoC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l5qFz":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"VkWKY","./de.json":"bmhYB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"VkWKY":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineSetterWfl\":{\"title\":\"Setter\",\"description\":\"Mutate the local variable stack\"},\"mask\":{\"FormEngineSetterWfl\":{\"groupTitle\":\"Setter\",\"assignments\":\"Assignments\"}}}");

},{}],"bmhYB":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineSetterWfl\":{\"title\":\"Zuweisung\",\"description\":\"Setzt lokale Variablen und Formfelder\"},\"mask\":{\"FormEngineSetterWfl\":{\"groupTitle\":\"Zuweisung\",\"assignments\":\"Werte\"}}}");

},{}],"a1z33":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpRequestWflMask = require("./components/http-request-wfl-mask");
var _httpRequestWflMaskDefault = parcelHelpers.interopDefault(_httpRequestWflMask);
var _client = require("./workflow-layers/http-request/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _httpRequestWflNode = require("./components/http-request-wfl-node");
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    workflowLayers: {
        [(0, _clientDefault.default).apiName]: {
            label: `${(0, _clientDefault.default).apiName}.title`,
            description: `${(0, _clientDefault.default).apiName}.description`,
            Icon: (0, _reactBootstrapIcons.Server),
            WorkflowLayer: (0, _clientDefault.default),
            Mask: (0, _httpRequestWflMaskDefault.default),
            Node: (0, _httpRequestWflNode.BuilderHttpRequestWflNode)
        }
    }
};

},{"./components/http-request-wfl-mask":"lVbZX","./workflow-layers/http-request/client":"EYNdn","react-bootstrap-icons":"3TzoC","./components/http-request-wfl-node":"fQtgC","./builder-translations":"5gXkH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lVbZX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderHttpRequestWflSetup", ()=>BuilderHttpRequestWflSetup);
parcelHelpers.export(exports, "default", ()=>BuilderHttpRequestWflMask);
var _jsxRuntime = require("react/jsx-runtime");
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _wflBehaviour = require("@form-engine/builder-mask/components/groups/wfl-behaviour");
var _wflBehaviourDefault = parcelHelpers.interopDefault(_wflBehaviour);
var _enum = require("@form-engine/builder-mask/components/properties/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _string = require("@form-engine/builder-mask/components/properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _requestPayload = require("@form-engine/builder-mask/components/groups/request-payload");
var _requestPayloadDefault = parcelHelpers.interopDefault(_requestPayload);
var _formatCase = require("@form-engine/core-util/format-case");
var _client = require("../workflow-layers/http-request/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _builderApplication = require("@form-engine/builder-application");
var _auth = require("@form-engine/builder-mask/components/properties/auth");
var _authDefault = parcelHelpers.interopDefault(_auth);
function BuilderHttpRequestWflSetup() {
    const { state } = (0, _useMask.useMaskContext)();
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _clientDefault.default).apiName}.`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wflBehaviourDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                label: c('requestGroupTitle'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        compilable: true,
                        propertyName: "url",
                        label: c('url')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                        propertyName: "method",
                        label: c('method'),
                        options: [
                            'GET',
                            'POST',
                            'PUT',
                            'PATCH',
                            'DELETE'
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                        propertyName: "responseType",
                        label: c('responseType'),
                        options: [
                            [
                                '',
                                'TEXT'
                            ],
                            [
                                'application/json',
                                'JSON'
                            ]
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "storeResultAs",
                        label: c('storeResultAs'),
                        placeholder: c('storeResultAsPlaceholder'),
                        formatter: (0, _formatCase.formatVariableCase)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "storeErrorAs",
                        label: c('storeErrorAs'),
                        placeholder: c('storeErrorAsPlaceholder'),
                        formatter: (0, _formatCase.formatVariableCase)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupDefault.default), {
                label: c('authGroupTitle'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authDefault.default), {})
            }),
            [
                'POST',
                'PUT',
                'PATCH'
            ].includes(String(state?.method)) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requestPayloadDefault.default), {})
        ]
    });
}
function BuilderHttpRequestWflMask() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderHttpRequestWflSetup, {});
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-mask/hooks/use-mask":"72MTY","react":"9njXz","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/groups/wfl-behaviour":"3PqZm","@form-engine/builder-mask/components/properties/enum":"2kNfK","@form-engine/builder-mask/components/properties/string":"e6M7S","@form-engine/builder-mask/components/groups/request-payload":"cUiDR","@form-engine/core-util/format-case":"2G0oK","../workflow-layers/http-request/client":"EYNdn","@form-engine/builder-application":"7iKr0","@form-engine/builder-mask/components/properties/auth":"g7ynP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fQtgC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderHttpRequestWflNode", ()=>BuilderHttpRequestWflNode);
var _jsxRuntime = require("react/jsx-runtime");
var _layerNode = require("@form-engine/builder-form-editor/components/workflow-editor/layer-node");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrapIcons = require("react-bootstrap-icons");
const BuilderHttpRequestWflNode = /*#__PURE__*/ (0, _react.memo)(function BuilderHttpRequestWflNode(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layerNode.BuilderWorkflowEditorLayerNode), {
        ...props,
        sources: {
            error: {
                icon: (0, _reactBootstrapIcons.ExclamationDiamondFill)
            },
            success: {
                icon: (0, _reactBootstrapIcons.CheckCircleFill)
            }
        }
    });
});

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-form-editor/components/workflow-editor/layer-node":"kygrj","react":"9njXz","react-bootstrap-icons":"3TzoC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5gXkH":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"cHQHc","./de.json":"bu5Q9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cHQHc":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineHttpRequestWfl\":{\"title\":\"Http Request\",\"description\":\"Transport Formdata via HTTP Request\"},\"mask\":{\"FormEngineHttpRequestWfl\":{\"description\":\"Description\",\"url\":\"Url\",\"method\":\"Method\",\"authGroupTitle\":\"Authorization\",\"requestGroupTitle\":\"Request\",\"responseType\":\"Response Type\",\"sourceType\":\"Source Type\",\"storeResultAs\":\"Result Path\",\"storeResultAsPlaceholder\":\"e.g. result\",\"storeErrorAs\":\"Error path\",\"storeErrorAsPlaceholder\":\"z.B. error\"}}}");

},{}],"bu5Q9":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineHttpRequestWfl\":{\"title\":\"HTTP-Anfrage\",\"description\":\"Formulardaten per HTTP-Request transportieren\"},\"mask\":{\"FormEngineHttpRequestWfl\":{\"description\":\"Beschreibung\",\"url\":\"URL\",\"method\":\"Methode\",\"authGroupTitle\":\"Genehmigung\",\"requestGroupTitle\":\"Anfrage\",\"responseType\":\"Antworttyp\",\"sourceType\":\"Quelle Typ\",\"storeResultAs\":\"Ergebnispfad\",\"storeResultAsPlaceholder\":\"z.B. Ergebnis\",\"storeErrorAs\":\"Fehlerpfad\",\"storeErrorAsPlaceholder\":\"z.B. Fehler\"}}}");

},{}],"21CZk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _sessionLogWflMask = require("./components/session-log-wfl-mask");
var _sessionLogWflMaskDefault = parcelHelpers.interopDefault(_sessionLogWflMask);
var _client = require("./workflow-layers/session-log/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _defaultLogging = require("./presets/default-logging");
var _defaultLoggingDefault = parcelHelpers.interopDefault(_defaultLogging);
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    workflowLayers: {
        [(0, _clientDefault.default).apiName]: {
            label: `${(0, _clientDefault.default).apiName}.title`,
            description: `${(0, _clientDefault.default).apiName}.description`,
            Icon: (0, _reactBootstrapIcons.Camera2),
            WorkflowLayer: (0, _clientDefault.default),
            Mask: (0, _sessionLogWflMaskDefault.default)
        }
    },
    formPresets: {
        SessionLogDefaultLogging: (0, _defaultLoggingDefault.default)
    }
};

},{"./components/session-log-wfl-mask":"d1jEH","./workflow-layers/session-log/client":"3JoJN","react-bootstrap-icons":"3TzoC","./presets/default-logging":"6Fjqs","./builder-translations":"jCTTN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d1jEH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderSessionLogWflSetup", ()=>BuilderSessionLogWflSetup);
parcelHelpers.export(exports, "default", ()=>BuilderHttpRequestWflMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _wflBehaviour = require("@form-engine/builder-mask/components/groups/wfl-behaviour");
var _wflBehaviourDefault = parcelHelpers.interopDefault(_wflBehaviour);
var _string = require("@form-engine/builder-mask/components/properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _builderApplication = require("@form-engine/builder-application");
function BuilderSessionLogWflSetup() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wflBehaviourDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                    label: (0, _builderApplication.i18n).c('FormEngineSessionLogWfl.retention'),
                    propertyName: "retention",
                    type: "number",
                    min: "1",
                    max: "30",
                    step: "1"
                })
            })
        ]
    });
}
function BuilderHttpRequestWflMask() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderSessionLogWflSetup, {});
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/groups/wfl-behaviour":"3PqZm","@form-engine/builder-mask/components/properties/string":"e6M7S","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Fjqs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _uuid = require("@form-engine/core-util/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _sessionLog = require("../workflow-layers/session-log");
exports.default = {
    name: 'Default Logging',
    required: true,
    init (form) {
        form?.workflowLayers?.push({
            id: (0, _uuidDefault.default)(),
            type: (0, _sessionLog.apiName),
            name: 'Log Session',
            enabled: true,
            events: [
                'form:submit@success'
            ],
            nodeX: 250,
            nodeY: 100,
            retention: '30'
        });
    }
};

},{"@form-engine/core-util/uuid":"eZttN","../workflow-layers/session-log":"icEoh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jCTTN":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"4wOlt","./de.json":"94nvN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4wOlt":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineSessionLogWfl\":{\"title\":\"Session Log\",\"description\":\"Take a snapshot of the current state of the form\",\"retention\":\"Retention (days)\"}}");

},{}],"94nvN":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineSessionLogWfl\":{\"title\":\"Sitzungsprotokoll\",\"description\":\"Erstellen Sie eine Momentaufnahme des aktuellen Status des Formulars\",\"retention\":\"Speicherung (Tage)\"}}");

},{}],"9OyPY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _showPageWflMask = require("./components/show-page-wfl-mask");
var _showPageWflMaskDefault = parcelHelpers.interopDefault(_showPageWflMask);
var _showPage = require("./workflow-layers/show-page");
var _showPageDefault = parcelHelpers.interopDefault(_showPage);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    workflowLayers: {
        [(0, _showPageDefault.default).apiName]: {
            label: `${(0, _showPageDefault.default).apiName}.title`,
            description: `${(0, _showPageDefault.default).apiName}.description`,
            Icon: (0, _reactBootstrapIcons.BoxArrowInRight),
            WorkflowLayer: (0, _showPageDefault.default),
            Mask: (0, _showPageWflMaskDefault.default)
        }
    }
};

},{"./components/show-page-wfl-mask":"lP5W4","./workflow-layers/show-page":"5TkcZ","react-bootstrap-icons":"3TzoC","./builder-translations":"BfGYX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lP5W4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderShowPageWflSetup", ()=>BuilderShowPageWflSetup);
parcelHelpers.export(exports, "default", ()=>BuilderShowPageWflMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _wflBehaviour = require("@form-engine/builder-mask/components/groups/wfl-behaviour");
var _wflBehaviourDefault = parcelHelpers.interopDefault(_wflBehaviour);
var _pageName = require("@form-engine/builder-mask/components/properties/page-name");
var _pageNameDefault = parcelHelpers.interopDefault(_pageName);
var _builderApplication = require("@form-engine/builder-application");
var _showPage = require("../workflow-layers/show-page");
var _showPageDefault = parcelHelpers.interopDefault(_showPage);
function BuilderShowPageWflSetup() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wflBehaviourDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupDefault.default), {
                label: (0, _builderApplication.i18n).c(`mask.${(0, _showPageDefault.default).apiName}.groupTitle`),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageNameDefault.default), {})
            })
        ]
    });
}
function BuilderShowPageWflMask() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderShowPageWflSetup, {});
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/groups/wfl-behaviour":"3PqZm","@form-engine/builder-mask/components/properties/page-name":"lLs1S","@form-engine/builder-application":"7iKr0","../workflow-layers/show-page":"5TkcZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"BfGYX":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"5zQBf","./de.json":"j0pW7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5zQBf":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineShowPageWfl\":{\"title\":\"Show Page\",\"description\":\"React to events by showing a configured page element\"},\"mask\":{\"FormEngineShowPageWfl\":{\"groupTitle\":\"Page\"}}}");

},{}],"j0pW7":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"FormEngineShowPageWfl\":{\"title\":\"Seite anzeigen\",\"description\":\"Reagieren Sie auf Ereignisse, indem Sie ein konfiguriertes Seitenelement anzeigen\"},\"mask\":{\"FormEngineShowPageWfl\":{\"groupTitle\":\"Buchseite\"}}}");

},{}],"6Xxeo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations
};

},{"./builder-translations":"kUfqK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kUfqK":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"01zMK","./de.json":"faEIo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"01zMK":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"mask\":{\"boundsGroup\":{\"title\":\"Boundaries\"},\"generalGroup\":{\"hidden\":\"Hidden\",\"disabled\":\"Disabled\"},\"conditionsGroup\":{\"title\":\"Conditions\",\"requiredExpressions\":\"Require when\",\"disabledExpressions\":\"Disable when\",\"hiddenExpressions\":\"Hide when\"},\"requestPayloadGroup\":{\"title\":\"Request Payload\",\"contentType\":\"Content Type\",\"body\":\"Body\",\"textPlain\":\"Plain Text\",\"textCsv\":\"Spreadsheet (CSV)\",\"applicationJson\":\"Json Data\",\"applicationXWwwFormUrlencoded\":\"Form Data\"},\"validationGroup\":{\"title\":\"Validation\",\"required\":\"Required\",\"validationMinLength\":\"Min. Length\",\"validationMaxLength\":\"Max. Length\"},\"wflBehaviourGroup\":{\"title\":\"Layer\",\"description\":\"Description\",\"enabled\":\"Enabled\"},\"authProperty\":{\"method\":\"Auth Method\",\"methods\":{\"none\":\"None / Global\",\"basic\":\"Basic\",\"bearer\":\"Bearer\"},\"basicAuthUsername\":\"Username\",\"basicAuthPassword\":\"Password\",\"authorization\":\"Bearer Token\"},\"boundsProperty\":{\"width\":\"Width\",\"marginTop\":\"Margin Top\",\"marginRight\":\"Margin Right\",\"marginBottom\":\"Margin Bottom\",\"marginLeft\":\"Margin Left\"},\"datasourceProperty\":{\"title\":\"Datasource\",\"static\":\"Static\",\"source\":\"Datasource\",\"optionValue\":\"Value\",\"optionLabel\":\"Label\"},\"expressionsProperty\":{\"title\":\"Expressions\",\"operator\":\"Operator\",\"leftOperand\":\"Left Operand\",\"rightOperand\":\"Right Operand\",\"disjunctor\":\"Disjunctor\"},\"fieldNameProperty\":{\"title\":\"Field\"},\"floatingLabelProperty\":{\"title\":\"Floating Label\"},\"inputTypeProperty\":{\"title\":\"Type\"},\"labelProperty\":{\"title\":\"Label\"},\"nameProperty\":{\"title\":\"Name\"},\"objectProperty\":{\"typeOptions\":{\"string\":\"String\",\"number\":\"Number\",\"boolean\":\"Boolean\",\"json\":\"Json\",\"raw-string\":\"Raw String\"},\"value\":\"Value\",\"key\":\"Key\",\"type\":\"Type\"},\"pageNameProperty\":{\"title\":\"Page\"},\"placeholderProperty\":{\"title\":\"Placeholder\"},\"requiredProperty\":{\"title\":\"Required\"},\"slugProperty\":{\"title\":\"Slug\"},\"tagsProperty\":{\"title\":\"Tags\",\"placeholder\":\"Tags\"},\"validationContentTypeProperty\":{\"validationContentType\":\"Content Type\",\"validateContentTypeRegex\":\"Regex\",\"validateContentTypeRegexPlaceholder\":\"e.g. ^[a-z0-9]+$\",\"validateContentTypeDateBefore\":\"Before\",\"validateContentTypeDateBeforePlaceholder\":\"e.g. {{date \\\"now\\\"}}\",\"validateContentTypeDateAfter\":\"After\",\"validateContentTypeDateAfterPlaceholder\":\"e.g. {{date \\\"now\\\"}}\",\"validateContentTypeMessage\":\"Content Type Message\"}}}");

},{}],"faEIo":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"mask":{"boundsGroup":{"title":"Grenzen"},"generalGroup":{"hidden":"Versteckt","disabled":"Deaktiviert"},"conditionsGroup":{"title":"Bedingungen","requiredExpressions":"Pflichtfeld wenn","disabledExpressions":"Deaktiviert wenn","hiddenExpressions":"Ausblenden wenn"},"requestPayloadGroup":{"title":"Nutzlast anfordern","contentType":"Inhaltstyp","body":"K\xf6rper","textPlain":"Einfacher Text","textCsv":"Tabellenkalkulation (CSV)","applicationJson":"Json-Daten","applicationXWwwFormUrlencoded":"Formulardaten"},"validationGroup":{"title":"Validierung","required":"Erforderlich","validationMinLength":"Mindest. L\xe4nge","validationMaxLength":"max. L\xe4nge"},"wflBehaviourGroup":{"title":"Schicht","description":"Beschreibung","enabled":"Erm\xf6glicht"},"authProperty":{"method":"Auth-Methode","methods":{"none":"Keine / Global","basic":"Basic","bearer":"Tr\xe4ger"},"basicAuthUsername":"Nutzername","basicAuthPassword":"Passwort","authorization":"Inhaber-Token"},"boundsProperty":{"width":"Breite","marginTop":"Rand oben","marginRight":"Rand rechts","marginBottom":"Rand unten","marginLeft":"Rand \xfcbrig"},"datasourceProperty":{"title":"Datenquelle","static":"Statisch","source":"Datenquelle","optionValue":"Wert","optionLabel":"Etikett"},"expressionsProperty":{"title":"Ausdr\xfccke","operator":"Operator","leftOperand":"Linker Operand","rightOperand":"Rechter Operand","disjunctor":"Disjunktor"},"fieldNameProperty":{"title":"Feld"},"floatingLabelProperty":{"title":"Schwebendes Etikett"},"inputTypeProperty":{"title":"Art"},"labelProperty":{"title":"Etikett"},"nameProperty":{"title":"Name"},"objectProperty":{"typeOptions":{"string":"Schnur","number":"Anzahl","boolean":"Boolesch","json":"Json","raw-string":"Rohe Zeichenfolge"},"value":"Wert","key":"Taste","type":"Art"},"pageNameProperty":{"title":"Buchseite"},"placeholderProperty":{"title":"Platzhalter"},"requiredProperty":{"title":"Erforderlich"},"slugProperty":{"title":"Schnecke"},"tagsProperty":{"title":"Stichworte","placeholder":"Stichworte"},"validationContentTypeProperty":{"validationContentType":"Inhaltstyp","validateContentTypeRegex":"Regex","validateContentTypeRegexPlaceholder":"z.B. ^[a-z0-9]+$","validateContentTypeDateBefore":"Vor","validateContentTypeDateBeforePlaceholder":"z.B. {{date \\"jetzt\\"}}","validateContentTypeDateAfter":"Nach","validateContentTypeDateAfterPlaceholder":"z.B. {{date \\"jetzt\\"}}","validateContentTypeMessage":"Inhaltstyp Nachricht"}}}');

},{}],"c4ZFi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _formNewView = require("./components/form-new-view");
var _formNewViewDefault = parcelHelpers.interopDefault(_formNewView);
var _formStudio = require("./components/form-studio");
var _formStudioDefault = parcelHelpers.interopDefault(_formStudio);
var _hyperlinkEmbed = require("./components/hyperlink-embed");
var _hyperlinkEmbedDefault = parcelHelpers.interopDefault(_hyperlinkEmbed);
var _inlineEmbed = require("./components/inline-embed");
var _inlineEmbedDefault = parcelHelpers.interopDefault(_inlineEmbed);
var _datasourcesEditor = require("./components/datasources-editor");
var _datasourcesEditorDefault = parcelHelpers.interopDefault(_datasourcesEditor);
var _layoutEditor = require("./components/layout-editor");
var _layoutEditorDefault = parcelHelpers.interopDefault(_layoutEditor);
var _workflowEditor = require("./components/workflow-editor");
var _workflowEditorDefault = parcelHelpers.interopDefault(_workflowEditor);
var _constantsEditor = require("./components/constants-editor");
var _constantsEditorDefault = parcelHelpers.interopDefault(_constantsEditor);
var _formEngine = require("./components/form-engine");
var _formEngineDefault = parcelHelpers.interopDefault(_formEngine);
var _outlineDrawer = require("./components/outline-drawer");
var _outlineDrawerDefault = parcelHelpers.interopDefault(_outlineDrawer);
var _elementsDrawer = require("./components/elements-drawer");
var _elementsDrawerDefault = parcelHelpers.interopDefault(_elementsDrawer);
var _settingsDrawer = require("./components/settings-drawer");
var _settingsDrawerDefault = parcelHelpers.interopDefault(_settingsDrawer);
var _sessionDrawer = require("./components/session-drawer");
var _sessionDrawerDefault = parcelHelpers.interopDefault(_sessionDrawer);
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _preview = require("./components/layout-editor/preview");
var _localeSelector = require("./components/layout-editor/locale-selector");
var _previewSettingsDrawer = require("./components/layout-editor/preview-settings-drawer");
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: // renderFormRoute: '/public/:formId',
    _builderTranslations,
    routes: {
        formEditor: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "forms/:formId",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formStudioDefault.default), {})
        }),
        formNew: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "new",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formNewViewDefault.default), {})
        })
    },
    formEmbeds: {
        BuilderHyperlinkEmbed: (0, _hyperlinkEmbedDefault.default),
        BuilderInlineEmbed: (0, _inlineEmbedDefault.default)
    },
    formStudioViews: {
        form: (0, _layoutEditorDefault.default),
        datasources: (0, _datasourcesEditorDefault.default),
        workflow: (0, _workflowEditorDefault.default),
        constants: (0, _constantsEditorDefault.default)
    },
    formLayoutEditorViews: {
        edit: {
            title: 'form-editor.layout.edit.title',
            component: (0, _formEngineDefault.default),
            leftDrawerTabs: {
                outline: {
                    title: 'form-editor.layout.edit.outline',
                    component: (0, _outlineDrawerDefault.default)
                },
                library: {
                    title: 'form-editor.layout.edit.components',
                    component: (0, _elementsDrawerDefault.default)
                }
            },
            rightDrawerTabs: {
                settings: {
                    title: 'form-editor.layout.edit.settings',
                    component: (0, _settingsDrawerDefault.default)
                }
            },
            defaultLeftDrawerTab: 'outline',
            defaultRightDrawerTab: 'settings'
        },
        translate: {
            title: 'form-editor.layout.translate.title',
            component: (0, _formEngineDefault.default),
            leftDrawerTabs: {
                outline: {
                    title: 'form-editor.layout.translate.outline',
                    component: (0, _outlineDrawerDefault.default)
                }
            },
            rightDrawerTabs: {
                settings: {
                    title: 'form-editor.layout.translate.settings',
                    component: (0, _settingsDrawerDefault.default)
                }
            },
            defaultLeftDrawerTab: 'outline',
            defaultRightDrawerTab: 'settings',
            navItemsComponent: ()=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Item, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _localeSelector.BuilderFormEditorLocaleSelector), {})
                    })
                });
            }
        },
        preview: {
            title: 'form-editor.layout.preview.title',
            component: (0, _preview.BuilderFormEditorPreviewFormEngine),
            navItemsComponent: ({ remote })=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Item, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Link, {
                                as: "button",
                                onClick: ()=>{
                                    remote?.current?.reset?.();
                                // immediately set preview options
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ArrowClockwise), {})
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Item, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _localeSelector.BuilderFormEditorLocaleSelector), {})
                        })
                    ]
                });
            },
            leftDrawerTabs: {
                outline: {
                    title: 'form-editor.layout.preview.outline',
                    component: (0, _outlineDrawerDefault.default)
                }
            },
            rightDrawerTabs: {
                settings: {
                    title: 'form-editor.layout.preview.settings',
                    component: (0, _previewSettingsDrawer.BuilderFormEditorPreviewSettings)
                },
                scope: {
                    title: 'form-editor.layout.preview.scope',
                    component: (0, _sessionDrawerDefault.default)
                }
            },
            defaultLeftDrawerTab: 'outline',
            defaultRightDrawerTab: 'scope'
        }
    },
    maskConfigurations: {
        BuilderFormMask: {
            edit: {
                permissions: {
                    name: 'write',
                    published: 'write',
                    slug: 'write',
                    tags: 'write',
                    showValidFeedback: 'write',
                    includeCoreResources: 'write',
                    includeBootstrapCdn: 'write',
                    bootstrapCdnUrl: 'write',
                    resources: 'write',
                    stylesheet: 'write'
                }
            },
            preview: {
                permissions: {
                    name: 'write',
                    published: 'write',
                    slug: 'write',
                    tags: 'write',
                    showValidFeedback: 'write',
                    includeCoreResources: 'write',
                    includeBootstrapCdn: 'write',
                    bootstrapCdnUrl: 'write',
                    resources: 'write',
                    stylesheet: 'write'
                }
            },
            translate: {
                permissions: {
                    name: 'read',
                    published: 'read',
                    slug: 'read',
                    tags: 'read',
                    showValidFeedback: 'read',
                    includeCoreResources: 'read',
                    includeBootstrapCdn: 'read',
                    bootstrapCdnUrl: 'read',
                    resources: 'read',
                    stylesheet: 'write'
                }
            }
        }
    }
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"cgBkD","./components/form-new-view":"8Mkzr","./components/form-studio":"4Shl6","./components/hyperlink-embed":"9H932","./components/inline-embed":"bW4am","./components/datasources-editor":"iwXEP","./components/layout-editor":"lNvsg","./components/workflow-editor":"fXsKO","./components/constants-editor":"QurK7","./components/form-engine":"3vR3Y","./components/outline-drawer":"cktQb","./components/elements-drawer":"1M5zCH","./components/settings-drawer":"9098t","./components/session-drawer":"fhe3j","react-bootstrap":"f5rnA","react-bootstrap-icons":"3TzoC","./components/layout-editor/preview":"8l9ux","./components/layout-editor/locale-selector":"i5AzK","./components/layout-editor/preview-settings-drawer":"4XTh0","./builder-translations":"jIoZs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cgBkD":[function(require,module,exports,__globalThis) {
/**
 * React Router DOM v6.26.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _reactRouter.AbortedDeferredError));
parcelHelpers.export(exports, "Await", ()=>(0, _reactRouter.Await));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Navigate", ()=>(0, _reactRouter.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _reactRouter.NavigationType));
parcelHelpers.export(exports, "Outlet", ()=>(0, _reactRouter.Outlet));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "Routes", ()=>(0, _reactRouter.Routes));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _reactRouter.UNSAFE_DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _reactRouter.UNSAFE_DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _reactRouter.UNSAFE_LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _reactRouter.UNSAFE_NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _reactRouter.UNSAFE_RouteContext));
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>(0, _reactRouter.UNSAFE_useRouteId));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _reactRouter.createMemoryRouter));
parcelHelpers.export(exports, "createPath", ()=>(0, _reactRouter.createPath));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _reactRouter.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _reactRouter.createRoutesFromElements));
parcelHelpers.export(exports, "defer", ()=>(0, _reactRouter.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _reactRouter.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _reactRouter.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _reactRouter.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _reactRouter.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _reactRouter.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _reactRouter.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _reactRouter.renderMatches));
parcelHelpers.export(exports, "replace", ()=>(0, _reactRouter.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _reactRouter.resolvePath));
parcelHelpers.export(exports, "useActionData", ()=>(0, _reactRouter.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _reactRouter.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _reactRouter.useAsyncValue));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _reactRouter.useBlocker));
parcelHelpers.export(exports, "useHref", ()=>(0, _reactRouter.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _reactRouter.useInRouterContext));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _reactRouter.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _reactRouter.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _reactRouter.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _reactRouter.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _reactRouter.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _reactRouter.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _reactRouter.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _reactRouter.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _reactRouter.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _reactRouter.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _reactRouter.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _reactRouter.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _reactRouter.useRoutes));
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>(0, _router.UNSAFE_ErrorResponseImpl));
//#endregion
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "unstable_usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "unstable_useViewTransitionState", ()=>useViewTransitionState);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
const _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const ViewTransitionContext = /*#__PURE__*/ _react.createContext({
    isTransitioning: false
});
const FetchersContext = /*#__PURE__*/ _react.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
const FLUSH_SYNC = "flushSync";
const flushSyncImpl = _reactDom[FLUSH_SYNC];
const USE_ID = "useId";
const useIdImpl = _react[USE_ID];
function startTransitionSafe(cb) {
    if (startTransitionImpl) startTransitionImpl(cb);
    else cb();
}
function flushSyncSafe(cb) {
    if (flushSyncImpl) flushSyncImpl(cb);
    else cb();
}
class Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(new Map());
    let { v7_startTransition } = future || {};
    let optInStartTransition = _react.useCallback((cb)=>{
        if (v7_startTransition) startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = _react.useCallback((newState, _ref2)=>{
        let { deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = _react.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const MemoizedDataRoutes = /*#__PURE__*/ _react.memo(DataRoutes);
function DataRoutes(_ref3) {
    let { routes, future, state } = _ref3;
    return (0, _reactRouter.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref4) {
    let { basename, children, future, window: window1 } = _ref4;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref5) {
    let { basename, children, future, window: window1 } = _ref5;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref6) {
    let { basename, children, future, history } = _ref6;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick, relative, reloadDocument, replace, state, target, to, preventScrollReset, unstable_viewTransition } = _ref7, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, _reactRouter.useHref)(to, {
        relative
    });
    let internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
        preventScrollReset,
        relative,
        unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, unstable_viewTransition, children } = _ref8, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, _reactRouter.useLocation)();
    let routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    let { navigator, basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, _router.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const Form = /*#__PURE__*/ _react.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey, navigate, reloadDocument, replace, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, unstable_viewTransition } = _ref9, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace,
            state,
            relative,
            preventScrollReset,
            unstable_viewTransition
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref10) {
    let { getKey, storageKey } = _ref10;
    useScrollRestoration({
        getKey,
        storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    let { target, replace: replaceProp, state, preventScrollReset, relative, unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, _reactRouter.useNavigate)();
    let location = (0, _reactRouter.useLocation)();
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace,
                state,
                preventScrollReset,
                relative,
                unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = (0, _reactRouter.useLocation)();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, _reactRouter.useNavigate)();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let fetcherId = 0;
let getUniqueFetcherId = ()=>"__" + String(++fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    let { router } = useDataRouterContext(DataRouterHook.UseSubmit);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher(_temp3) {
    var _route$matches;
    let { key } = _temp3 === void 0 ? {} : _temp3;
    let { router } = useDataRouterContext(DataRouterHook.UseFetcher);
    let state = useDataRouterState(DataRouterStateHook.UseFetcher);
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, _router.UNSAFE_invariant)(false);
    !route && (0, _router.UNSAFE_invariant)(false);
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = useIdImpl ? useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = _react.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey(getUniqueFetcherId());
    // Registration/cleanup
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = _react.useCallback((href, opts)=>{
        !routeId && (0, _router.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback((target, opts)=>{
        submitImpl(target, _extends({}, opts, {
            navigate: false,
            fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
            return /*#__PURE__*/ _react.createElement(Form, _extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, _router.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>_extends({
            Form: FetcherForm,
            submit,
            load
        }, fetcher, {
            data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    let state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return _extends({}, fetcher, {
            key
        });
    });
}
const SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp4) {
    let { getKey, storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router } = useDataRouterContext(DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState(DataRouterStateHook.UseScrollRestoration);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let location = (0, _reactRouter.useLocation)();
    let matches = (0, _reactRouter.useMatches)();
    let navigation = (0, _reactRouter.useNavigation)();
    // Trigger manual scroll restoration while we're active
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey(_extends({}, location, {
                    pathname: (0, _router.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref12) {
    let { when, message } = _ref12;
    let blocker = (0, _reactRouter.useBlocker)(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = _react.useContext(ViewTransitionContext);
    !(vtContext != null) && (0, _router.UNSAFE_invariant)(false);
    let { basename } = useDataRouterContext(DataRouterHook.useViewTransitionState);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, _router.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, _router.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, _router.matchPath)(path.pathname, nextPath) != null || (0, _router.matchPath)(path.pathname, currentPath) != null;
}

},{"react":"9njXz","react-dom":"2ApDx","react-router":"8TGRI","@remix-run/router":"6UEot","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8TGRI":[function(require,module,exports,__globalThis) {
/**
 * React Router v6.26.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _router.AbortedDeferredError));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _router.Action));
parcelHelpers.export(exports, "createPath", ()=>(0, _router.createPath));
parcelHelpers.export(exports, "defer", ()=>(0, _router.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _router.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _router.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _router.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _router.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _router.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _router.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _router.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _router.redirectDocument));
parcelHelpers.export(exports, "replace", ()=>(0, _router.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _router.resolvePath));
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>useRouteId);
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", ()=>useRoutesImpl);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const DataRouterContext = /*#__PURE__*/ _react.createContext(null);
const DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
const AwaitContext = /*#__PURE__*/ _react.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const NavigationContext = /*#__PURE__*/ _react.createContext(null);
const LocationContext = /*#__PURE__*/ _react.createContext(null);
const RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function useHref(to, _temp) {
    let { relative } = _temp === void 0 ? {} : _temp;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { pathname } = useLocation();
    return _react.useMemo(()=>(0, _router.matchPath)(pattern, (0, _router.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, future, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { future } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return _react.useMemo(()=>(0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { navigator } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
class RenderErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function RenderedRoute(_ref) {
    let { routeContext, match, children } = _ref;
    let dataRouterContext = _react.useContext(DataRouterContext);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData, errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet,
                    matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}(DataRouterHook || {});
var DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}(DataRouterStateHook || {});
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    let state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    let dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    let state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return _react.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    let { matches, loaderData } = useDataRouterState(DataRouterStateHook.UseMatches);
    return _react.useMemo(()=>matches.map((m)=>(0, _router.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    let state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    let state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    let state = useDataRouterState(DataRouterStateHook.UseActionData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState(DataRouterStateHook.UseRouteError);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
let blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext(DataRouterHook.UseBlocker);
    let state = useDataRouterState(DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: _extends({}, currentLocation, {
                pathname: (0, _router.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: _extends({}, nextLocation, {
                pathname: (0, _router.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, _router.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    let { router } = useDataRouterContext(DataRouterHook.UseNavigateStable);
    let id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        if (v7_startTransition && startTransitionImpl) startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    let { routes, future, state } = _ref2;
    return useRoutesImpl(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    let { basename, children, initialEntries, initialIndex, future } = _ref3;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function Navigate(_ref4) {
    let { to, replace, state, relative } = _ref4;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { future, static: isStatic } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace,
            state,
            relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function Router(_ref5) {
    let { basename: basenameProp = "/", children = null, location: locationProp, navigationType = (0, _router.Action).Pop, navigator, static: staticProp = false, future } = _ref5;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp,
            future: _extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function Routes(_ref6) {
    let { children, location } = _ref6;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    let { children, errorElement, resolve } = _ref7;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}(AwaitRenderStatus || {});
const neverSettledPromise = new Promise(()=>{});
class AwaitErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? AwaitRenderStatus.error : "_data" in promise ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw neverSettledPromise;
        if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function ResolveAwait(_ref8) {
    let { children } = _ref8;
    let data = useAsyncValue();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ _react.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ _react.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes,
        mapRouteProperties,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation
    }).initialize();
}

},{"react":"9njXz","@remix-run/router":"6UEot","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6UEot":[function(require,module,exports,__globalThis) {
/**
 * @remix-run/router v1.19.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AbortedDeferredError", ()=>AbortedDeferredError);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", ()=>UNSAFE_DEFERRED_SYMBOL);
parcelHelpers.export(exports, "UNSAFE_DeferredData", ()=>DeferredData);
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "UNSAFE_convertRouteMatchToUiMatch", ()=>convertRouteMatchToUiMatch);
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", ()=>convertRoutesToDataRoutes);
parcelHelpers.export(exports, "UNSAFE_decodePath", ()=>decodePath);
parcelHelpers.export(exports, "UNSAFE_getResolveToMatches", ()=>getResolveToMatches);
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>invariant);
parcelHelpers.export(exports, "UNSAFE_warning", ()=>warning);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler);
parcelHelpers.export(exports, "defer", ()=>defer);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "getStaticContextFromError", ()=>getStaticContextFromError);
parcelHelpers.export(exports, "getToPathname", ()=>getToPathname);
parcelHelpers.export(exports, "isDataWithResponseInit", ()=>isDataWithResponseInit);
parcelHelpers.export(exports, "isDeferredData", ()=>isDeferredData);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "joinPaths", ()=>joinPaths);
parcelHelpers.export(exports, "json", ()=>json);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "normalizePathname", ()=>normalizePathname);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "resolveTo", ()=>resolveTo);
parcelHelpers.export(exports, "stripBasename", ()=>stripBasename);
parcelHelpers.export(exports, "unstable_data", ()=>data);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
const PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = Action.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = Action.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = Action.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = Action.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname, search, hash } = window1.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    let { pathname = "/", search = "", hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = Action.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
const immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            let indexRoute = _extends({}, route, mapRouteProperties(route), {
                id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const paramRe = /^:[\w-]+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;
const isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName, isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        warning(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    let pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ const joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const json = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers
    }));
};
class DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class AbortedDeferredError extends Error {
}
class DeferredData {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new AbortedDeferredError("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const defer = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const replace = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class ErrorResponseImpl {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const validMutationMethods = new Set(validMutationMethodsArr);
const validRequestMethodsArr = [
    "get",
    ...validMutationMethodsArr
];
const validRequestMethods = new Set(validRequestMethodsArr);
const redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.unstable_patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // FIFO queue of previously discovered routes to prevent re-calling on
    // subsequent navigations to the same path
    let discoveredRoutesMaxSize = 1000;
    let discoveredRoutes = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnNavigation() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location, delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }), {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = Action.Push;
        if (userReplace === true) historyAction = Action.Replace;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = Action.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            findNearestBoundary(matches).route.id,
            {
                type: ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited, matches: updatedMatches, loaderData, errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, _extends({
            matches: updatedMatches || matches
        }, getActionDataForCommit(pendingActionResult), {
            loaderData,
            errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId, error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: ResultType.error,
                            error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches, error, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: ResultType.error,
                            error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: ResultType.error,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission,
                replace
            });
            return {
                shortCircuited: true
            };
        }
        if (isDeferredResult(result)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
            return {
                matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState(_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData
                } : {}), {
                    flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId, error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, _extends({
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return _extends({
            matches,
            loaderData,
            errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            }
        } else {
            if (isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if (isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false);
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false);
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if (isDeferredResult(result)) result = await resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission, fetcherSubmission, replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        invariant(location, "Expected a Location header on the redirect Response");
        location = normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: _extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if (isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: ResultType.redirect,
                response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: ResultType.error,
                    error: getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.add(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        invariant(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation, nextLocation, historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = getInternalRouterError(404, {
            pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches, route } = getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route,
            error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: findNearestBoundary(discoverResult.partialMatches).route.id,
            error: getInternalRouterError(400, {
                type: "route-discovery",
                pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            // Don't bother re-calling patchRouteOnMiss for a path we've already
            // processed.  the last execution would have patched the route tree
            // accordingly so `matches` here are already accurate.
            if (discoveredRoutes.has(pathname)) return {
                active: false,
                matches
            };
            if (!matches) {
                let fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await loadLazyRouteChildren(patchRoutesOnNavigationImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = matchRoutes(routesToUse, pathname, basename);
            if (newMatches) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: newMatches
                };
            }
            let newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: null
                };
            }
            partialMatches = newPartialMatches;
        }
    }
    function addToFifoQueue(path, queue) {
        if (queue.size >= discoveredRoutesMaxSize) {
            let first = queue.values().next().value;
            queue.delete(first);
        }
        queue.add(path);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose,
        getBlocker,
        deleteBlocker,
        patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    let future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext, skipLoaderErrorBubbling, unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if (isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return _extends({
            location,
            basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId, requestContext, unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) // This should never hit I don't think?
        throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return isResponse(result) ? result : _extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if (isDataStrategyResult(e) && isResponse(e.result)) {
                if (e.type === ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isDeferredResult(result)) {
            let error = getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return _extends({}, context, {
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: _extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return _extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return _extends({}, context, {
            matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await callDataStrategyImpl(unstable_dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if (isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    let newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnNavigation() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function loadLazyRouteChildren(patchRoutesOnNavigationImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnNavigationImpl({
                path,
                matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = convertRoutesToDataRoutes(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = convertRoutesToDataRoutes(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        warning(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function defaultDataStrategy(_ref6) {
    let { matches } = _ref6;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: ResultType.data,
                result: undefined
            });
        };
        return _extends({}, match, {
            shouldLoad,
            resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request,
        params: matches[0].params,
        fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
        invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result, type } = dataStrategyResult;
    if (isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: ResultType.error,
                error: e
            };
        }
        if (type === ResultType.error) return {
            type: ResultType.error,
            error: new ErrorResponseImpl(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: ResultType.data,
            data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === ResultType.error) {
        if (isDataWithResponseInit(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown unstable_data() to ErrorResponse instances
            result = new ErrorResponseImpl(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: ResultType.error,
            error: result,
            statusCode: isRouteErrorResponse(result) ? result.status : undefined
        };
    }
    if (isDeferredData(result)) {
        var _result$init3, _result$init4;
        return {
            type: ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if (isDataWithResponseInit(result)) {
        var _result$init5, _result$init6;
        return {
            type: ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData, errors } = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key, match, controller } = rf;
        let result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = _extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, _temp5) {
    let { pathname, routeId, method, type, message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = "Unable to match URL \"" + pathname + "\" - the `unstable_patchRoutesOnNavigation()` " + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if (isRedirectResult(result)) return {
            key,
            result
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
async function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if (isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key, routeId, controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if (isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: ResultType.error,
            error: e
        };
    }
    return {
        type: ResultType.data,
        data: result.deferredData.data
    };
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json: undefined,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Mkzr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderFormNewView);
var _jsxRuntime = require("react/jsx-runtime");
var _useFormApi = require("@form-engine/builder-application/hooks/use-form-api");
var _useFormApiDefault = parcelHelpers.interopDefault(_useFormApi);
var _useMounted = require("@form-engine/core-application/hooks/use-mounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _reactRouterDom = require("react-router-dom");
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
function FormStruct(overrides = {}) {
    const form = {
        name: 'Untitled Form',
        tags: [],
        elements: [],
        constants: [],
        datasources: [],
        workflowLayers: [],
        ...overrides
    };
    Object.values((0, _builderApplicationDefault.default)?.formPresets ?? {}).forEach((preset)=>{
        if (preset.required && preset.init) preset.init(form);
    });
    return form;
}
function BuilderFormNewView() {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { create } = (0, _useFormApiDefault.default)();
    const mounted = (0, _useMountedDefault.default)();
    const handleSubmit = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        const name = String(e.target[0]?.value).trim();
        create(FormStruct({
            name
        })).then(({ id })=>{
            if (!mounted.current) return;
            navigate(`/forms/${id}`);
        });
    }, [
        navigate,
        create
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex-grow-1 d-flex justify-content-center align-items-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Card).Body, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Title, {
                            children: "Create new Form"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Form), {
                            className: "mt-5",
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormGroup), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FloatingLabel), {
                                        label: "Name",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
                                            name: "formName",
                                            placeholder: "Name",
                                            required: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
                                    className: "mt-3",
                                    type: "submit",
                                    children: "Create"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-application/hooks/use-form-api":"3uteJ","@form-engine/core-application/hooks/use-mounted":"kHM7H","react":"9njXz","react-bootstrap":"f5rnA","react-router-dom":"cgBkD","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3uteJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useFormApi);
parcelHelpers.export(exports, "useFormEntity", ()=>useFormEntity);
parcelHelpers.export(exports, "DEFAULT_FORM_LIST_OPTIONS", ()=>DEFAULT_FORM_LIST_OPTIONS);
parcelHelpers.export(exports, "refreshForms", ()=>refreshForms);
parcelHelpers.export(exports, "useFormList", ()=>useFormList);
var _useApiModel = require("./use-api-model");
var _useApiModelDefault = parcelHelpers.interopDefault(_useApiModel);
var _emitter = require("@form-engine/core-util/emitter");
function useFormApi() {
    return (0, _useApiModelDefault.default)('form');
}
function useFormEntity(id) {
    return (0, _useApiModel.useEntity)(useFormApi(), id);
}
const DEFAULT_FORM_LIST_OPTIONS = {
    attributes: [
        'id',
        'name',
        'updatedAt',
        'createdAt',
        'tags',
        'thumbnail'
    ]
};
const emitter = (0, _emitter.createEmitter)();
const refreshForms = emitter.emit;
function useFormList(options = DEFAULT_FORM_LIST_OPTIONS) {
    const list = (0, _useApiModel.useList)(useFormApi(), options);
    (0, _emitter.useEmitter)(emitter, list.refresh);
    return list;
}

},{"./use-api-model":"fNNgP","@form-engine/core-util/emitter":"9G5Og","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fNNgP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useApiModel);
parcelHelpers.export(exports, "useEntity", ()=>useEntity);
parcelHelpers.export(exports, "useList", ()=>useList);
parcelHelpers.export(exports, "useProgressiveList", ()=>useProgressiveList);
var _useMounted = require("@form-engine/core-application/hooks/use-mounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _index = require("../index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _react = require("react");
var _useIdentity = require("./use-identity");
var _useIdentityDefault = parcelHelpers.interopDefault(_useIdentity);
function useApiModel(modelPath) {
    const { authorization } = (0, _useIdentityDefault.default)();
    const exec = (0, _react.useCallback)((path, options = {})=>{
        const headers = {};
        if (authorization) headers.authorization = authorization;
        return fetch(`${(0, _indexDefault.default).apiBaseUrl}/${modelPath}/${path}`, {
            credentials: 'include',
            ...options,
            headers: {
                ...headers,
                ...options.headers || {}
            }
        });
    }, [
        authorization,
        modelPath
    ]);
    const execJson = (0, _react.useCallback)((path, options = {})=>{
        return exec(path, options).then((response)=>response.json());
    }, [
        exec
    ]);
    const retrieve = (0, _react.useCallback)((id)=>{
        // if (!id) throw new Error('invalid argument id');
        return execJson(id);
    }, [
        execJson
    ]);
    const list = (0, _react.useCallback)((options = {})=>{
        const params = {
            filter: undefined,
            startAt: undefined,
            attributes: undefined,
            limit: undefined,
            sort: undefined,
            includeVersioningHistory: undefined,
            verbose: false,
            ...options
        };
        return execJson(`?params=${encodeURIComponent(JSON.stringify(params))}`);
    }, [
        execJson
    ]);
    const listProgressive = (0, _react.useCallback)((options = {})=>{
        const params = {
            filter: undefined,
            startAt: undefined,
            attributes: undefined,
            limit: undefined,
            sort: undefined,
            includeVersioningHistory: undefined,
            ...options,
            verbose: true
        };
        let state = [];
        let nextKey;
        async function fetchNext() {
            const { results, lastKey } = await list(nextKey ? {
                ...params,
                startAt: nextKey
            } : params);
            state = [
                ...state,
                ...results
            ];
            nextKey = lastKey;
            return {
                state: [
                    ...state
                ],
                complete: !lastKey,
                next: lastKey ? fetchNext : async ()=>Promise.reject(new Error(`cant refetch completed progressive list`))
            };
        }
        return fetchNext();
    }, [
        list
    ]);
    const _delete = (0, _react.useCallback)((id)=>{
        return exec(id, {
            method: 'DELETE'
        });
    }, [
        exec
    ]);
    const create = (0, _react.useCallback)((dto)=>{
        if (!dto) throw new Error('invalid argument dto');
        return execJson('', {
            method: 'POST',
            body: JSON.stringify(dto),
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }, [
        execJson
    ]);
    const update = (0, _react.useCallback)((dto)=>{
        if (!dto.id) throw new Error('invalid argument dto.id');
        return execJson(dto.id, {
            method: 'PATCH',
            body: JSON.stringify(dto),
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }, [
        execJson
    ]);
    return {
        exec,
        execJson,
        create,
        retrieve,
        list,
        listProgressive,
        update,
        delete: _delete
    };
}
function useEntity(apiModel, id) {
    const { retrieve, update } = apiModel;
    const [entity, setEntity] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(Boolean(id));
    const mounted = (0, _useMountedDefault.default)();
    (0, _react.useEffect)(()=>{
        if (!id) {
            setLoading(false);
            setEntity(null);
            return;
        }
        setLoading(true);
        retrieve(id).then((result)=>{
            if (!mounted.current) return;
            setLoading(false);
            setEntity(result);
        });
    }, [
        retrieve,
        id,
        setLoading,
        setEntity
    ]);
    const updateEntity = (0, _react.useCallback)((dto)=>{
        if (!id) {
            setLoading(false);
            setEntity(null);
            return;
        }
        setLoading(true);
        update({
            ...dto,
            id
        }).then((result)=>{
            if (!mounted.current) return;
            setLoading(false);
            setEntity(result);
        });
    }, [
        update,
        setEntity,
        setLoading,
        id
    ]);
    return {
        state: entity,
        setState: updateEntity,
        loading
    };
}
function useList(apiModel, options) {
    const { list } = apiModel;
    const [callId, setCallId] = (0, _react.useState)(0);
    const [state, setState] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(false);
    const mounted = (0, _useMountedDefault.default)();
    const refresh = (0, _react.useCallback)(()=>{
        setCallId(callId + 1);
    }, [
        callId,
        setCallId
    ]);
    (0, _react.useEffect)(()=>{
        setLoading(true);
        list({
            ...options || {},
            verbose: false
        }).then((result)=>{
            if (!mounted.current) return;
            setLoading(false);
            setState(result);
        });
    }, [
        setLoading,
        setState,
        callId,
        list,
        options
    ]);
    return {
        state,
        refresh,
        loading
    };
}
function useProgressiveList(apiModel, options) {
    const { listProgressive } = apiModel;
    const [callId, setCallId] = (0, _react.useState)(0);
    const [state, setState] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(false);
    const mounted = (0, _useMountedDefault.default)();
    const refresh = (0, _react.useCallback)(()=>{
        setCallId(callId + 1);
    }, [
        callId,
        setCallId
    ]);
    const next = (0, _react.useCallback)(()=>{
        state?.next();
    }, [
        state
    ]);
    (0, _react.useEffect)(()=>{
        setLoading(true);
        listProgressive(options).then((result)=>{
            if (!mounted.current) return;
            setLoading(false);
            setState(result);
        });
    }, [
        setLoading,
        setState,
        callId,
        listProgressive,
        options
    ]);
    return {
        state: state?.state ?? [],
        refresh,
        next,
        complete: state?.complete ?? false,
        loading
    };
}

},{"@form-engine/core-application/hooks/use-mounted":"kHM7H","../index":"7iKr0","react":"9njXz","./use-identity":"4vzl8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kHM7H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMounted);
var _react = require("react");
function useMounted() {
    const mounted = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return mounted;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4vzl8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useIdentity);
var _useMounted = require("@form-engine/core-application/hooks/use-mounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _index = require("../index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _react = require("react");
var _useApp = require("./use-app");
function useIdentity() {
    const [loading, setLoading] = (0, _react.useState)(false);
    const mounted = (0, _useMountedDefault.default)();
    const { state: { identity: currentIdentity = {} }, setItem } = (0, _useApp.useAppContext)();
    const identity = (0, _react.useMemo)(()=>{
        return {
            identity: null,
            identityType: null,
            identityError: null,
            authorization: null,
            ...currentIdentity
        };
    }, [
        currentIdentity
    ]);
    const identityUrl = `${(0, _indexDefault.default).apiBaseUrl}/identity`;
    const logout = (0, _react.useCallback)(async ()=>{
        setLoading(true);
        if ((0, _indexDefault.default).loginMethods.includes('oidc')) await fetch(`${identityUrl}/logout`, {
            credentials: 'include'
        });
        setItem('identity', {});
        setLoading(false);
    }, [
        setItem,
        setLoading
    ]);
    const syncAndRenewSession = (0, _react.useCallback)(async ()=>{
        const { authorization } = identity;
        const result = await fetch(identityUrl, {
            credentials: 'include',
            headers: authorization ? {
                authorization
            } : undefined
        });
        const state = await result.json();
        if (!state.identity) setItem('identity', {
            identity: undefined,
            identityType: 'none',
            identityError: undefined
        });
        else if (identity.identity?.id !== state.identity?.id) setItem('identity', state);
    }, [
        identity.identity?.id,
        identity.authorization,
        setItem
    ]);
    const authWithOidc = (0, _react.useCallback)(async ()=>{
        logout();
        setItem('identity', {});
        setLoading(true);
        try {
            const result = await fetch(identityUrl, {
                credentials: 'include'
            });
            const { identity, identityType, identityError } = await result.json();
            if (mounted.current) {
                setLoading(false);
                if (identityType === 'none' || !identity) {
                    const url = new URL(location.origin);
                    url.pathname = (0, _indexDefault.default).oidcRoute;
                    url.searchParams.set('retUrl', location.href);
                    location.href = url.toString();
                    return;
                }
                setItem('identity', {
                    identity,
                    identityType,
                    identityError
                });
            }
        } catch (e) {
            if (mounted.current) {
                setLoading(false);
                setItem('identity', {
                    identityError: e instanceof Error ? e.message : String(e)
                });
            }
        }
    }, [
        setItem,
        logout
    ]);
    const authWithCredentials = (0, _react.useCallback)(async (method = 'basic', credentials)=>{
        logout();
        setItem('identity', {});
        setLoading(true);
        const headers = {};
        if (method === 'basic') headers.authorization = `Basic ${btoa(`${credentials?.username || ''}:${credentials?.password || ''}`)}`;
        else if (method === 'bearer') headers.authorization = `Bearer ${credentials?.token}`;
        try {
            const result = await fetch(identityUrl, {
                headers
            });
            const { identity, identityType, identityError } = await result.json();
            if (mounted.current) {
                setLoading(false);
                setItem('identity', {
                    identity,
                    identityType,
                    identityError,
                    authorization: headers['authorization']
                });
            }
        } catch (e) {
            if (mounted.current) {
                setLoading(false);
                setItem('identity', {
                    identityError: e instanceof Error ? e.message : String(e)
                });
            }
        }
    }, [
        setItem,
        logout
    ]);
    return {
        ...identity,
        loggedIn: Boolean(identity.identity),
        loading,
        authWithCredentials,
        authWithOidc,
        syncAndRenewSession,
        logout
    };
}

},{"@form-engine/core-application/hooks/use-mounted":"kHM7H","../index":"7iKr0","react":"9njXz","./use-app":"8Rocb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Rocb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppContext", ()=>AppContext);
parcelHelpers.export(exports, "appStorage", ()=>appStorage);
parcelHelpers.export(exports, "AppProvider", ()=>AppProvider);
parcelHelpers.export(exports, "useAppContext", ()=>useAppContext);
parcelHelpers.export(exports, "useAppTabs", ()=>useAppTabs);
var _jsxRuntime = require("react/jsx-runtime");
var _useStore = require("@form-engine/core-application/hooks/use-store");
var _createObject = require("@form-engine/core-util/create-object");
var _localStorage = require("@form-engine/core-util/local-storage");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const DefaultAppState = {
    locale: 'default',
    appTabs: [],
    identity: undefined,
    keybindings: {},
    resizables: {}
};
const AppContext = /*#__PURE__*/ (0, _react.createContext)(null);
const appStorage = (0, _localStorage.getStorageNamespace)('febApp');
function AppProvider({ value: initialState, children }) {
    const store = (0, _useStore.useStore)((0, _createObject.useObjectDefaults)(DefaultAppState, initialState));
    if (!store) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AppContext.Provider, {
        value: store,
        children: typeof children === 'function' ? children(store) : children
    });
}
function useAppContext() {
    const context = (0, _react.useContext)(AppContext);
    if (!context) throw new Error('tried to use app context without provider');
    return context;
}
function useAppTabs() {
    const { state, setItem } = useAppContext();
    const tabs = (0, _react.useMemo)(()=>state?.appTabs || [], [
        state?.appTabs
    ]);
    const toggle = (0, _react.useCallback)((tab, force)=>{
        const index = tabs.findIndex((t)=>t.id === tab.id);
        const copy = [
            ...tabs
        ];
        // potentially update tab data
        if (index > -1) copy[index] = {
            ...copy[index],
            ...tab
        };
        if (force !== false && index < 0) copy.push({
            ...tab
        });
        else if (force !== true && index > -1) copy.splice(index, 1);
        setItem('appTabs', copy);
    }, [
        tabs,
        setItem
    ]);
    return {
        open: tabs,
        toggle
    };
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/hooks/use-store":"llHXk","@form-engine/core-util/create-object":"dBL9S","@form-engine/core-util/local-storage":"2m0Di","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9G5Og":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEmitter", ()=>createEmitter);
parcelHelpers.export(exports, "useEmitter", ()=>useEmitter);
var _react = require("react");
function createEmitter() {
    const listeners = [];
    function subscribe(listener) {
        if (!listeners.includes(listener)) listeners.push(listener);
    }
    function unsubscribe(listener) {
        const index = listeners.indexOf(listener);
        if (index > -1) listeners.splice(index, 1);
    }
    function emit(...args) {
        for (const listener of listeners)listener(...args);
    }
    return {
        listeners: [],
        subscribe,
        unsubscribe,
        emit
    };
}
function useEmitter(emitter, callback) {
    (0, _react.useEffect)(()=>{
        if (!emitter || !callback) return;
        let mounted = true;
        const emitWhenMounted = (...args)=>{
            mounted && callback(...args);
        };
        emitter.subscribe(emitWhenMounted);
        return ()=>{
            mounted = false;
            emitter.unsubscribe(emitWhenMounted);
        };
    }, [
        emitter,
        callback
    ]);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Shl6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderFormStudioHotkeys", ()=>BuilderFormStudioHotkeys);
parcelHelpers.export(exports, "BuilderFormStudioNavLink", ()=>BuilderFormStudioNavLink);
parcelHelpers.export(exports, "BuilderFormStudioNavViewToggle", ()=>BuilderFormStudioNavViewToggle);
parcelHelpers.export(exports, "BuilderFormStudioViewStencil", ()=>BuilderFormStudioViewStencil);
parcelHelpers.export(exports, "default", ()=>BuilderFormStudioView);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _reactRouterDom = require("react-router-dom");
var _formRouteContext = require("../form-route-context");
var _formRouteContextDefault = parcelHelpers.interopDefault(_formRouteContext);
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _useFormEditor = require("../../hooks/use-form-editor");
var _useApp = require("@form-engine/builder-application/hooks/use-app");
var _appViewNavbar = require("@form-engine/builder-application/components/app-view-navbar");
var _appViewNavbarDefault = parcelHelpers.interopDefault(_appViewNavbar);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _actionsDropdown = require("../actions-dropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
// import BuilderDragAndDropCursor from '../dnd/cursor';
var _actions = require("../../actions");
var _embedForm = require("../../actions/embed-form");
var _embedFormDefault = parcelHelpers.interopDefault(_embedForm);
var _undo = require("../../actions/undo");
var _undoDefault = parcelHelpers.interopDefault(_undo);
var _redo = require("../../actions/redo");
var _redoDefault = parcelHelpers.interopDefault(_redo);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useSaveOnViewUnload = require("./use-save-on-view-unload");
var _useFormStaleHandler = require("../../hooks/use-form-stale-handler");
var _useFormStaleHandlerDefault = parcelHelpers.interopDefault(_useFormStaleHandler);
var _dialog = require("@form-engine/builder-application/components/dialog");
var _deepDiff = require("deep-diff");
var _versionDiffs = require("../form-version-history/version-diffs");
var _versionDiffsDefault = parcelHelpers.interopDefault(_versionDiffs);
var _diffUtil = require("@form-engine/core-util/diff-util");
var _useFormHistory = require("../../hooks/use-form-history");
function BuilderFormStudioHotkeys() {
    Object.values(_actions).forEach(({ useActionHotkey })=>useActionHotkey && useActionHotkey());
    return null;
}
function BuilderFormStudioEditorStateWriter() {
    const { formId } = (0, _reactRouterDom.useParams)();
    const { state: form, set: setForm, setItem: setFormItem } = (0, _useForm.useFormContext)();
    const { state: editor } = (0, _useFormEditor.useFormEditorContext)();
    const { toggle } = (0, _useApp.useAppTabs)();
    /** @todo autosave */ /** @see https://www.npmjs.com/package/json-diff */ // useEffect(() => {
    //   /** @todo autosave */
    //   /** @see https://www.npmjs.com/package/json-diff */
    // }, [formId, form]);
    (0, _react.useEffect)(()=>{
        if (form && form.id && formId === form.id) (0, _useFormEditor.formEditorStorage).setItem(formId, editor);
    }, [
        form,
        formId,
        editor
    ]);
    (0, _react.useEffect)(()=>{
        if (form && form.id && formId === form.id) toggle({
            id: formId,
            name: form.name,
            path: `/forms/${formId}`
        }, true);
    }, [
        form,
        formId
    ]);
    (0, _useFormStaleHandlerDefault.default)(form, async (newForm)=>{
        const formDiff = (0, _diffUtil.filterIgnoredHistoryDiffs)((0, _deepDiff.diff)(form, newForm), (0, _useFormHistory.DEFAULT_IGNORE_PATHS));
        if (!formDiff?.length) return;
        const confirmed = await (0, _dialog.confirm)({
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: (0, _builderApplication.i18n).c('form-editor.confirmMergeDialog.message')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _versionDiffsDefault.default), {
                        diffs: formDiff
                    })
                ]
            }),
            size: 'lg'
        });
        if (confirmed) setForm(newForm);
        else // ignore future emits with that date
        setFormItem('updatedAt', newForm.updatedAt);
    });
    return null;
}
function BuilderFormStudioNavLink({ title, isActive = false, activeClass = 'active', className = '', children, ...linkProps }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Link, {
        title: title,
        className: `${className} ${isActive ? activeClass : ''}`,
        ...linkProps,
        children: children
    });
}
function BuilderFormStudioNavViewToggle({ id, ...props }) {
    const { state: { view = 'form' }, setItem } = (0, _useFormEditor.useFormEditorContext)();
    const handleClick = (0, _react.useCallback)(()=>{
        view !== id && setItem('view', id);
    }, [
        id,
        view,
        setItem
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormStudioNavLink, {
        ...props,
        isActive: view === id,
        onClick: handleClick
    });
}
function BuilderFormStudioLayout() {
    const { state: { view = 'form', formHistory = [], formRedoHistory = [] } } = (0, _useFormEditor.useFormEditorContext)();
    const { state: form } = (0, _useForm.useFormContext)();
    const embedForm = (0, _embedFormDefault.default)();
    const publicUrl = (0, _builderApplicationDefault.default).renderFormRoute.replace(':formId', form.slug || form.id || '');
    const undo = (0, _undoDefault.default)();
    const redo = (0, _redoDefault.default)();
    const views = (0, _react.useMemo)(()=>Object.entries((0, _builderApplicationDefault.default).formStudioViews || {}), []);
    const CurrentViewComponent = views.find(([key])=>key === view)?.at(1)?.Component;
    (0, _useSaveOnViewUnload.useSaveOnViewUnload)(view);
    const { c } = (0, _builderApplication.i18n).prefix('form-editor.nav.');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appViewNavbarDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "w-100",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
                                className: "d-flex",
                                sm: 4,
                                children: [
                                    views.map(([key, descriptor])=>{
                                        const { label, Icon } = descriptor;
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormStudioNavViewToggle, {
                                            id: key,
                                            title: (0, _builderApplication.i18n).c(label),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {})
                                        }, key);
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormStudioNavLink, {
                                        title: c('undo', {
                                            hotkey: (0, _keybindings.getHotkeyLabel)((0, _undo.ACTION_NAME))
                                        }),
                                        onClick: undo,
                                        className: `ms-2 ${formHistory.length ? '' : 'disabled'}`,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ArrowCounterclockwise), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormStudioNavLink, {
                                        title: c('redo', {
                                            hotkey: (0, _keybindings.getHotkeyLabel)((0, _redo.ACTION_NAME))
                                        }),
                                        onClick: redo,
                                        className: `ms-2 ${formRedoHistory.length ? '' : 'disabled'}`,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ArrowClockwise), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                                className: "d-flex",
                                sm: 4,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                                    menuVariant: "dark",
                                    className: "me-auto ms-auto",
                                    title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            form.published ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.Eye), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.EyeSlash), {}),
                                            ` ${form.name}`
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
                                className: "d-flex",
                                sm: 4,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormStudioNavLink, {
                                        title: c('embed', {
                                            hotkey: (0, _keybindings.getHotkeyLabel)((0, _embedForm.ACTION_NAME))
                                        }),
                                        className: "ms-auto",
                                        onClick: embedForm,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.BoxSeam), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormStudioNavLink, {
                                        title: c('open-in-browser'),
                                        href: publicUrl,
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.Play), {})
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Container), {
                fluid: true,
                className: "feb-form-editor-layout",
                children: CurrentViewComponent && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CurrentViewComponent, {})
            })
        ]
    });
}
function BuilderFormStudioViewStencil() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appViewNavbarDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "w-100",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                    className: "d-flex me-auto ms-auto",
                    sm: 4,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "me-auto ms-auto nav-item",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "nav-link",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ThreeDots), {})
                        })
                    })
                })
            })
        })
    });
}
function BuilderFormStudioView() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formRouteContextDefault.default), {
        spinnerBoundaryProps: {
            prepend: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormStudioViewStencil, {})
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormStudioHotkeys, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormStudioEditorStateWriter, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormStudioLayout, {})
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","react-router-dom":"cgBkD","../form-route-context":"7I1lN","@form-engine/core-application/hooks/use-form":"5PZyy","../../hooks/use-form-editor":"4pkiD","@form-engine/builder-application/hooks/use-app":"8Rocb","@form-engine/builder-application/components/app-view-navbar":"lExmn","react-bootstrap-icons":"3TzoC","../actions-dropdown":"fUxvQ","@form-engine/builder-application":"7iKr0","../../actions":"1NRA0","../../actions/embed-form":"ae5rk","../../actions/undo":"bWpKb","../../actions/redo":"48iuV","@form-engine/builder-application/keybindings":"3o7P8","./use-save-on-view-unload":"lcd2y","../../hooks/use-form-stale-handler":"xUzo0","@form-engine/builder-application/components/dialog":"e4X5a","deep-diff":"3ceMf","../form-version-history/version-diffs":"e8cXQ","@form-engine/core-util/diff-util":"bAstS","../../hooks/use-form-history":"1RTRx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7I1lN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderFormRouteContextProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _useFormEditor = require("../../hooks/use-form-editor");
var _spinnerBoundary = require("@form-engine/builder-application/components/spinner-boundary");
var _spinnerBoundaryDefault = parcelHelpers.interopDefault(_spinnerBoundary);
var _useFormApi = require("@form-engine/builder-application/hooks/use-form-api");
var _useOfflineEntity = require("@form-engine/builder-application/hooks/use-offline-entity");
var _useStore = require("@form-engine/core-application/hooks/use-store");
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _alert = require("@form-engine/core-application/components/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _useFormHistory = require("../../hooks/use-form-history");
var _useFormHistoryDefault = parcelHelpers.interopDefault(_useFormHistory);
function OfflineFormUpdater() {
    (0, _useStore.useStoreEffect)((0, _useForm.useFormContext)(), ({ state })=>{
        if (state && state.id) (0, _useForm.FormOfflineStorage).setItem(state.id, state);
    });
    return null;
}
function FormHistoryUpdater({ clearOnMount }) {
    (0, _useFormHistory.useWriteFormHistory)();
    const { clear } = (0, _useFormHistoryDefault.default)();
    (0, _react.useEffect)(()=>{
        if (clearOnMount) clear();
    }, [
        clearOnMount
    ]);
    return null;
}
function BuilderFormRouteContextProvider({ children, spinnerBoundaryProps = {} }) {
    const { formId } = (0, _reactRouterDom.useParams)();
    const { state: onlineEntity, loading } = (0, _useFormApi.useFormEntity)(formId);
    const { state, dirty } = (0, _useOfflineEntity.useOfflineEntity)((0, _useForm.FormOfflineStorage), onlineEntity);
    /** @todo clear history if server entity newer than local */ let content;
    if (formId && state) content = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useFormEditor.FormEditorProvider), {
        value: (0, _useFormEditor.formEditorStorage).getItem(formId, {}),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useForm.FormProvider), {
            value: state,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(OfflineFormUpdater, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormHistoryUpdater, {
                        clearOnMount: dirty
                    }),
                    children
                ]
            })
        })
    });
    else content = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Container), {
        className: "my-5",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
            variant: "danger-outline",
            title: "Form not found",
            aside: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.CloudLightningRainFill), {}),
            children: "This may happen if the Form was deleted by somebody else"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerBoundaryDefault.default), {
            ...spinnerBoundaryProps,
            show: loading,
            children: content
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"cgBkD","@form-engine/core-application/hooks/use-form":"5PZyy","../../hooks/use-form-editor":"4pkiD","@form-engine/builder-application/components/spinner-boundary":"eYtmG","@form-engine/builder-application/hooks/use-form-api":"3uteJ","@form-engine/builder-application/hooks/use-offline-entity":"fjiva","@form-engine/core-application/hooks/use-store":"llHXk","react-bootstrap":"f5rnA","react-bootstrap-icons":"3TzoC","@form-engine/core-application/components/alert":"4AHKQ","../../hooks/use-form-history":"1RTRx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fjiva":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_COMPARE_DIRTY", ()=>DEFAULT_COMPARE_DIRTY);
parcelHelpers.export(exports, "useOfflineEntity", ()=>useOfflineEntity);
var _react = require("react");
const DEFAULT_COMPARE_DIRTY = (offlineEntity, onlineEntity, field = 'updatedAt')=>{
    return !offlineEntity || !onlineEntity || new Date(offlineEntity[field]).getTime() < new Date(onlineEntity[field]).getTime();
};
function useOfflineEntity(offlineStorage, onlineEntity, dirtyFn = DEFAULT_COMPARE_DIRTY) {
    const [state, setState] = (0, _react.useState)(undefined);
    const [dirty, setDirty] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (!onlineEntity || !onlineEntity.id) {
            setState(undefined);
            return;
        }
        const offlineEntity = offlineStorage.getItem(onlineEntity.id);
        if (dirtyFn(offlineEntity, onlineEntity)) {
            offlineStorage.setItem(onlineEntity.id, onlineEntity);
            /** @todo attempt merge diverging states */ setState({
                ...onlineEntity
            });
            setDirty(true);
        } else if (offlineEntity) {
            setState({
                ...offlineEntity
            });
            setDirty(false);
        }
    }, [
        offlineStorage,
        onlineEntity,
        dirtyFn,
        setState,
        setDirty
    ]);
    return {
        state,
        dirty
    };
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1RTRx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_HISTORY_SIZE", ()=>DEFAULT_HISTORY_SIZE);
parcelHelpers.export(exports, "DEFAULT_IGNORE_PATHS", ()=>DEFAULT_IGNORE_PATHS);
parcelHelpers.export(exports, "useWriteFormHistory", ()=>useWriteFormHistory);
parcelHelpers.export(exports, "default", ()=>useFormHistory);
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _react = require("react");
var _deepDiff = require("deep-diff");
var _useFormEditor = require("./use-form-editor");
var _diffUtil = require("@form-engine/core-util/diff-util");
const DEFAULT_HISTORY_SIZE = 1024;
const DEFAULT_IGNORE_PATHS = [
    [
        'thumbnail'
    ],
    [
        'createdAt'
    ],
    [
        'updatedAt'
    ]
];
function useWriteFormHistory(historySize = DEFAULT_HISTORY_SIZE, ignorePaths = DEFAULT_IGNORE_PATHS) {
    const [currentDiff, setCurrentDiff] = (0, _react.useState)();
    const editorContext = (0, _useFormEditor.useFormEditorContext)();
    const formContext = (0, _useForm.useFormContext)();
    (0, _react.useEffect)(()=>{
        const { state, previousState, eventData: { ignoreHistory = false } } = formContext;
        if (ignoreHistory) return;
        if (previousState && state) {
            const result = (0, _diffUtil.filterIgnoredHistoryDiffs)((0, _deepDiff.diff)(state, previousState), ignorePaths);
            if (result) setCurrentDiff(result);
        }
    }, [
        formContext?.state,
        formContext?.previousState,
        ignorePaths
    ]);
    (0, _react.useEffect)(()=>{
        const { formHistory = [] } = editorContext?.state ?? {};
        if (!currentDiff || formHistory.includes(currentDiff) || editorContext?.eventData?.ignoreHistory) return;
        let result = [
            ...formHistory,
            currentDiff
        ];
        if (result.length > historySize) result = result.slice(1);
        editorContext?.setItem('formHistory', result);
        // remove redo history when branching off
        editorContext?.setItem('formRedoHistory', []);
    }, [
        currentDiff,
        editorContext?.state?.formHistory,
        editorContext?.setItem,
        historySize
    ]);
}
function useFormHistory() {
    const { state: editor, setItem: setEditorItem } = (0, _useFormEditor.useFormEditorContext)();
    const { state: currentState, set: setForm } = (0, _useForm.useFormContext)();
    const undo = (0, _react.useCallback)(()=>{
        const history = [
            ...editor?.formHistory ?? []
        ];
        if (!history.length || !currentState) return;
        const undoDiffs = history.pop();
        if (!undoDiffs || !Array.isArray(undoDiffs) || !undoDiffs.length) return;
        const revertedState = structuredClone(currentState);
        for (const undoDiff of undoDiffs)(0, _deepDiff.applyChange)(revertedState, undefined, undoDiff);
        const redoDiffs = (0, _deepDiff.diff)(revertedState, currentState);
        setForm(revertedState, {
            ignoreHistory: true
        });
        setEditorItem('formHistory', [
            ...history
        ], {
            ignoreHistory: true
        });
        setEditorItem('formRedoHistory', [
            ...editor?.formRedoHistory ?? [],
            redoDiffs
        ], {
            ignoreHistory: true
        });
    }, [
        editor,
        setEditorItem,
        setForm,
        currentState
    ]);
    const redo = (0, _react.useCallback)(()=>{
        const history = [
            ...editor?.formRedoHistory ?? []
        ];
        if (!history.length || !currentState) return;
        const redoDiffs = history.pop();
        if (!redoDiffs || !Array.isArray(redoDiffs) || !redoDiffs.length) return;
        const redoneState = structuredClone(currentState);
        for (const redoDiff of redoDiffs)(0, _deepDiff.applyChange)(redoneState, undefined, redoDiff);
        const undoDiffs = (0, _deepDiff.diff)(redoneState, currentState);
        setForm(redoneState, {
            ignoreHistory: true
        });
        setEditorItem('formHistory', [
            ...editor?.formHistory ?? [],
            undoDiffs
        ], {
            ignoreHistory: true
        });
        setEditorItem('formRedoHistory', [
            ...history
        ], {
            ignoreHistory: true
        });
    }, [
        editor?.formHistory,
        editor?.formRedoHistory,
        setEditorItem,
        setForm,
        currentState
    ]);
    const clear = (0, _react.useCallback)(()=>{
        setEditorItem('formHistory', [], {
            ignoreHistory: true
        });
        setEditorItem('formRedoHistory', [], {
            ignoreHistory: true
        });
    }, [
        setEditorItem
    ]);
    return {
        state: editor?.formHistory,
        clear,
        undo,
        redo
    };
}

},{"@form-engine/core-application/hooks/use-form":"5PZyy","react":"9njXz","deep-diff":"3ceMf","./use-form-editor":"4pkiD","@form-engine/core-util/diff-util":"bAstS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ceMf":[function(require,module,exports,__globalThis) {
(function(root, factory) {
    var deepDiff = factory(root);
    // eslint-disable-next-line no-undef
    if (typeof define === 'function' && define.amd) // AMD
    define('DeepDiff', function() {
        return deepDiff;
    });
    else {
        var _deepdiff;
        // Node.js or ReactNative
        module.exports = deepDiff;
    }
})(this, function(root) {
    var validKinds = [
        'N',
        'E',
        'A',
        'D'
    ];
    // nodejs compatible on server side and in the browser.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
    function Diff(kind, path) {
        Object.defineProperty(this, 'kind', {
            value: kind,
            enumerable: true
        });
        if (path && path.length) Object.defineProperty(this, 'path', {
            value: path,
            enumerable: true
        });
    }
    function DiffEdit(path, origin, value) {
        DiffEdit.super_.call(this, 'E', path);
        Object.defineProperty(this, 'lhs', {
            value: origin,
            enumerable: true
        });
        Object.defineProperty(this, 'rhs', {
            value: value,
            enumerable: true
        });
    }
    inherits(DiffEdit, Diff);
    function DiffNew(path, value) {
        DiffNew.super_.call(this, 'N', path);
        Object.defineProperty(this, 'rhs', {
            value: value,
            enumerable: true
        });
    }
    inherits(DiffNew, Diff);
    function DiffDeleted(path, value) {
        DiffDeleted.super_.call(this, 'D', path);
        Object.defineProperty(this, 'lhs', {
            value: value,
            enumerable: true
        });
    }
    inherits(DiffDeleted, Diff);
    function DiffArray(path, index, item) {
        DiffArray.super_.call(this, 'A', path);
        Object.defineProperty(this, 'index', {
            value: index,
            enumerable: true
        });
        Object.defineProperty(this, 'item', {
            value: item,
            enumerable: true
        });
    }
    inherits(DiffArray, Diff);
    function arrayRemove(arr, from, to) {
        var rest = arr.slice((to || from) + 1 || arr.length);
        arr.length = from < 0 ? arr.length + from : from;
        arr.push.apply(arr, rest);
        return arr;
    }
    function realTypeOf(subject) {
        var type = typeof subject;
        if (type !== 'object') return type;
        if (subject === Math) return 'math';
        else if (subject === null) return 'null';
        else if (Array.isArray(subject)) return 'array';
        else if (Object.prototype.toString.call(subject) === '[object Date]') return 'date';
        else if (typeof subject.toString === 'function' && /^\/.*\//.test(subject.toString())) return 'regexp';
        return 'object';
    }
    // http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
    function hashThisString(string) {
        var hash = 0;
        if (string.length === 0) return hash;
        for(var i = 0; i < string.length; i++){
            var char = string.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }
    // Gets a hash of the given object in an array order-independent fashion
    // also object key order independent (easier since they can be alphabetized)
    function getOrderIndependentHash(object) {
        var accum = 0;
        var type = realTypeOf(object);
        if (type === 'array') {
            object.forEach(function(item) {
                // Addition is commutative so this is order indep
                accum += getOrderIndependentHash(item);
            });
            var arrayString = '[type: array, hash: ' + accum + ']';
            return accum + hashThisString(arrayString);
        }
        if (type === 'object') {
            for(var key in object)if (object.hasOwnProperty(key)) {
                var keyValueString = '[ type: object, key: ' + key + ', value hash: ' + getOrderIndependentHash(object[key]) + ']';
                accum += hashThisString(keyValueString);
            }
            return accum;
        }
        // Non object, non array...should be good?
        var stringToHash = '[ type: ' + type + ' ; value: ' + object + ']';
        return accum + hashThisString(stringToHash);
    }
    function deepDiff(lhs, rhs, changes, prefilter, path, key, stack, orderIndependent) {
        changes = changes || [];
        path = path || [];
        stack = stack || [];
        var currentPath = path.slice(0);
        if (typeof key !== 'undefined' && key !== null) {
            if (prefilter) {
                if (typeof prefilter === 'function' && prefilter(currentPath, key)) return;
                else if (typeof prefilter === 'object') {
                    if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) return;
                    if (prefilter.normalize) {
                        var alt = prefilter.normalize(currentPath, key, lhs, rhs);
                        if (alt) {
                            lhs = alt[0];
                            rhs = alt[1];
                        }
                    }
                }
            }
            currentPath.push(key);
        }
        // Use string comparison for regexes
        if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
            lhs = lhs.toString();
            rhs = rhs.toString();
        }
        var ltype = typeof lhs;
        var rtype = typeof rhs;
        var i, j, k, other;
        var ldefined = ltype !== 'undefined' || stack && stack.length > 0 && stack[stack.length - 1].lhs && Object.getOwnPropertyDescriptor(stack[stack.length - 1].lhs, key);
        var rdefined = rtype !== 'undefined' || stack && stack.length > 0 && stack[stack.length - 1].rhs && Object.getOwnPropertyDescriptor(stack[stack.length - 1].rhs, key);
        if (!ldefined && rdefined) changes.push(new DiffNew(currentPath, rhs));
        else if (!rdefined && ldefined) changes.push(new DiffDeleted(currentPath, lhs));
        else if (realTypeOf(lhs) !== realTypeOf(rhs)) changes.push(new DiffEdit(currentPath, lhs, rhs));
        else if (realTypeOf(lhs) === 'date' && lhs - rhs !== 0) changes.push(new DiffEdit(currentPath, lhs, rhs));
        else if (ltype === 'object' && lhs !== null && rhs !== null) {
            for(i = stack.length - 1; i > -1; --i)if (stack[i].lhs === lhs) {
                other = true;
                break;
            }
            if (!other) {
                stack.push({
                    lhs: lhs,
                    rhs: rhs
                });
                if (Array.isArray(lhs)) {
                    // If order doesn't matter, we need to sort our arrays
                    if (orderIndependent) {
                        lhs.sort(function(a, b) {
                            return getOrderIndependentHash(a) - getOrderIndependentHash(b);
                        });
                        rhs.sort(function(a, b) {
                            return getOrderIndependentHash(a) - getOrderIndependentHash(b);
                        });
                    }
                    i = rhs.length - 1;
                    j = lhs.length - 1;
                    while(i > j)changes.push(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i--])));
                    while(j > i)changes.push(new DiffArray(currentPath, j, new DiffDeleted(undefined, lhs[j--])));
                    for(; i >= 0; --i)deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack, orderIndependent);
                } else {
                    var akeys = Object.keys(lhs);
                    var pkeys = Object.keys(rhs);
                    for(i = 0; i < akeys.length; ++i){
                        k = akeys[i];
                        other = pkeys.indexOf(k);
                        if (other >= 0) {
                            deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack, orderIndependent);
                            pkeys[other] = null;
                        } else deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack, orderIndependent);
                    }
                    for(i = 0; i < pkeys.length; ++i){
                        k = pkeys[i];
                        if (k) deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack, orderIndependent);
                    }
                }
                stack.length = stack.length - 1;
            } else if (lhs !== rhs) // lhs is contains a cycle at this element and it differs from rhs
            changes.push(new DiffEdit(currentPath, lhs, rhs));
        } else if (lhs !== rhs) {
            if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) changes.push(new DiffEdit(currentPath, lhs, rhs));
        }
    }
    function observableDiff(lhs, rhs, observer, prefilter, orderIndependent) {
        var changes = [];
        deepDiff(lhs, rhs, changes, prefilter, null, null, null, orderIndependent);
        if (observer) for(var i = 0; i < changes.length; ++i)observer(changes[i]);
        return changes;
    }
    function orderIndependentDeepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
        return deepDiff(lhs, rhs, changes, prefilter, path, key, stack, true);
    }
    function accumulateDiff(lhs, rhs, prefilter, accum) {
        var observer = accum ? function(difference) {
            if (difference) accum.push(difference);
        } : undefined;
        var changes = observableDiff(lhs, rhs, observer, prefilter);
        return accum ? accum : changes.length ? changes : undefined;
    }
    function accumulateOrderIndependentDiff(lhs, rhs, prefilter, accum) {
        var observer = accum ? function(difference) {
            if (difference) accum.push(difference);
        } : undefined;
        var changes = observableDiff(lhs, rhs, observer, prefilter, true);
        return accum ? accum : changes.length ? changes : undefined;
    }
    function applyArrayChange(arr, index, change) {
        if (change.path && change.path.length) {
            var it = arr[index], i, u = change.path.length - 1;
            for(i = 0; i < u; i++)it = it[change.path[i]];
            switch(change.kind){
                case 'A':
                    applyArrayChange(it[change.path[i]], change.index, change.item);
                    break;
                case 'D':
                    delete it[change.path[i]];
                    break;
                case 'E':
                case 'N':
                    it[change.path[i]] = change.rhs;
                    break;
            }
        } else switch(change.kind){
            case 'A':
                applyArrayChange(arr[index], change.index, change.item);
                break;
            case 'D':
                arr = arrayRemove(arr, index);
                break;
            case 'E':
            case 'N':
                arr[index] = change.rhs;
                break;
        }
        return arr;
    }
    function applyChange(target, source, change) {
        if (typeof change === 'undefined' && source && ~validKinds.indexOf(source.kind)) change = source;
        if (target && change && change.kind) {
            var it = target, i = -1, last = change.path ? change.path.length - 1 : 0;
            while(++i < last){
                if (typeof it[change.path[i]] === 'undefined') it[change.path[i]] = typeof change.path[i + 1] !== 'undefined' && typeof change.path[i + 1] === 'number' ? [] : {};
                it = it[change.path[i]];
            }
            switch(change.kind){
                case 'A':
                    if (change.path && typeof it[change.path[i]] === 'undefined') it[change.path[i]] = [];
                    applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
                    break;
                case 'D':
                    delete it[change.path[i]];
                    break;
                case 'E':
                case 'N':
                    it[change.path[i]] = change.rhs;
                    break;
            }
        }
    }
    function revertArrayChange(arr, index, change) {
        if (change.path && change.path.length) {
            // the structure of the object at the index has changed...
            var it = arr[index], i, u = change.path.length - 1;
            for(i = 0; i < u; i++)it = it[change.path[i]];
            switch(change.kind){
                case 'A':
                    revertArrayChange(it[change.path[i]], change.index, change.item);
                    break;
                case 'D':
                    it[change.path[i]] = change.lhs;
                    break;
                case 'E':
                    it[change.path[i]] = change.lhs;
                    break;
                case 'N':
                    delete it[change.path[i]];
                    break;
            }
        } else // the array item is different...
        switch(change.kind){
            case 'A':
                revertArrayChange(arr[index], change.index, change.item);
                break;
            case 'D':
                arr[index] = change.lhs;
                break;
            case 'E':
                arr[index] = change.lhs;
                break;
            case 'N':
                arr = arrayRemove(arr, index);
                break;
        }
        return arr;
    }
    function revertChange(target, source, change) {
        if (target && source && change && change.kind) {
            var it = target, i, u;
            u = change.path.length - 1;
            for(i = 0; i < u; i++){
                if (typeof it[change.path[i]] === 'undefined') it[change.path[i]] = {};
                it = it[change.path[i]];
            }
            switch(change.kind){
                case 'A':
                    // Array was modified...
                    // it will be an array...
                    revertArrayChange(it[change.path[i]], change.index, change.item);
                    break;
                case 'D':
                    // Item was deleted...
                    it[change.path[i]] = change.lhs;
                    break;
                case 'E':
                    // Item was edited...
                    it[change.path[i]] = change.lhs;
                    break;
                case 'N':
                    // Item is new...
                    delete it[change.path[i]];
                    break;
            }
        }
    }
    function applyDiff(target, source, filter) {
        if (target && source) {
            var onChange = function(change) {
                if (!filter || filter(target, source, change)) applyChange(target, source, change);
            };
            observableDiff(target, source, onChange);
        }
    }
    Object.defineProperties(accumulateDiff, {
        diff: {
            value: accumulateDiff,
            enumerable: true
        },
        orderIndependentDiff: {
            value: accumulateOrderIndependentDiff,
            enumerable: true
        },
        observableDiff: {
            value: observableDiff,
            enumerable: true
        },
        orderIndependentObservableDiff: {
            value: orderIndependentDeepDiff,
            enumerable: true
        },
        orderIndepHash: {
            value: getOrderIndependentHash,
            enumerable: true
        },
        applyDiff: {
            value: applyDiff,
            enumerable: true
        },
        applyChange: {
            value: applyChange,
            enumerable: true
        },
        revertChange: {
            value: revertChange,
            enumerable: true
        },
        isConflict: {
            value: function() {
                return typeof $conflict !== 'undefined';
            },
            enumerable: true
        }
    });
    // hackish...
    accumulateDiff.DeepDiff = accumulateDiff;
    // ...but works with:
    // import DeepDiff from 'deep-diff'
    // import { DeepDiff } from 'deep-diff'
    // const DeepDiff = require('deep-diff');
    // const { DeepDiff } = require('deep-diff');
    if (root) root.DeepDiff = accumulateDiff;
    return accumulateDiff;
});

},{}],"bAstS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pathEquals", ()=>pathEquals);
parcelHelpers.export(exports, "isIgnoredPath", ()=>isIgnoredPath);
parcelHelpers.export(exports, "filterIgnoredHistoryDiffs", ()=>filterIgnoredHistoryDiffs);
function pathEquals(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function isIgnoredPath(path, ignoredPaths) {
    for(let i = 0, l = ignoredPaths.length; i < l; ++i){
        if (pathEquals(path, ignoredPaths[i])) return true;
    }
    return false;
}
function filterIgnoredHistoryDiffs(diffs, ignorePaths = []) {
    if (!diffs) return undefined;
    const filtered = diffs.filter((diff)=>!diff.path || !isIgnoredPath(diff.path, ignorePaths));
    return filtered.length ? filtered : undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lExmn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderAppViewNavbar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
function BuilderAppViewNavbar({ children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Navbar), {
        className: "feb-app-view-navbar",
        bg: "dark",
        variant: "dark",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Container), {
            fluid: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav), {
                className: "w-100",
                children: children
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fUxvQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderFormActionsDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _actions = require("../../actions");
var _keybindings = require("@form-engine/builder-application/keybindings");
var _builderApplication = require("@form-engine/builder-application");
function useActions() {
    return Object.fromEntries(Object.entries(_actions).map(([key, { useAction, ACTION_NAME }])=>[
            key,
            {
                action: useAction(),
                hotkey: (0, _keybindings.getHotkeyLabel)(ACTION_NAME)
            }
        ]));
}
function NavDropdownButton({ suffix, children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.NavDropdown).Item, {
        as: "button",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "d-flex flex-row",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex-grow-1",
                    children: children
                }),
                suffix && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "ms-2 text-white-50",
                    children: suffix
                })
            ]
        })
    });
}
function BuilderFormActionsDropdown(props) {
    const { state: form } = (0, _useForm.useFormContext)();
    const actions = useActions();
    const { Node } = (0, _builderApplication.i18n).prefix('form-editor.nav.');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.NavDropdown), {
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavDropdownButton, {
                onClick: actions.formVersionHistory.action,
                suffix: actions.formVersionHistory.hotkey,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                    id: "formVersionHistory"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavDropdownButton, {
                onClick: form.published ? actions.unpublishForm.action : actions.publishForm.action,
                suffix: form.published ? actions.unpublishForm.hotkey : actions.publishForm.hotkey,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                    id: form.published ? 'unpublishForm' : 'publishForm'
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavDropdownButton, {
                onClick: actions.saveForm.action,
                suffix: actions.saveForm.hotkey,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                    id: "saveForm"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.NavDropdown).Divider, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavDropdownButton, {
                onClick: actions.saveFormAs.action,
                suffix: actions.saveFormAs.hotkey,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                    id: "saveFormAs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavDropdownButton, {
                onClick: actions.exportForm.action,
                suffix: actions.exportForm.hotkey,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                    id: "exportForm"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavDropdownButton, {
                onClick: actions.importFormFile.action,
                suffix: actions.importFormFile.hotkey,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                    id: "importFormFile"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavDropdownButton, {
                onClick: actions.exportL10n.action,
                suffix: actions.exportL10n.hotkey,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                    id: "exportL10n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavDropdownButton, {
                onClick: actions.importL10n.action,
                suffix: actions.importL10n.hotkey,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                    id: "importL10n"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavDropdownButton, {
                onClick: actions.renameForm.action,
                suffix: actions.renameForm.hotkey,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                    id: "renameForm"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavDropdownButton, {
                onClick: actions.deleteForm.action,
                suffix: actions.deleteForm.hotkey,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                    id: "deleteForm"
                })
            }),
            props.children
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/hooks/use-form":"5PZyy","react":"9njXz","react-bootstrap":"f5rnA","../../actions":"1NRA0","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1NRA0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copySelection", ()=>_copySelection);
parcelHelpers.export(exports, "pasteSelection", ()=>_pasteSelection);
parcelHelpers.export(exports, "cutSelection", ()=>_cutSelection);
parcelHelpers.export(exports, "deleteSelection", ()=>_deleteSelection);
parcelHelpers.export(exports, "selectNext", ()=>_selectNext);
parcelHelpers.export(exports, "selectPrev", ()=>_selectPrev);
parcelHelpers.export(exports, "unselect", ()=>_unselect);
parcelHelpers.export(exports, "saveForm", ()=>_saveForm);
parcelHelpers.export(exports, "saveFormAs", ()=>_saveFormAs);
parcelHelpers.export(exports, "renameForm", ()=>_renameForm);
parcelHelpers.export(exports, "deleteForm", ()=>_deleteForm);
parcelHelpers.export(exports, "publishForm", ()=>_publishForm);
parcelHelpers.export(exports, "exportForm", ()=>_exportForm);
parcelHelpers.export(exports, "unpublishForm", ()=>_unpublishForm);
parcelHelpers.export(exports, "embedForm", ()=>_embedForm);
parcelHelpers.export(exports, "undo", ()=>_undo);
parcelHelpers.export(exports, "redo", ()=>_redo);
parcelHelpers.export(exports, "formVersionHistory", ()=>_formVersionHistory);
parcelHelpers.export(exports, "savePreset", ()=>_savePreset);
parcelHelpers.export(exports, "importFormFile", ()=>_importFormFile);
parcelHelpers.export(exports, "exportL10n", ()=>_exportL10N);
parcelHelpers.export(exports, "importL10n", ()=>_importL10N);
var _copySelection = require("./copy-selection");
var _pasteSelection = require("./paste-selection");
var _cutSelection = require("./cut-selection");
var _deleteSelection = require("./delete-selection");
var _selectNext = require("./select-next");
var _selectPrev = require("./select-prev");
var _unselect = require("./unselect");
var _saveForm = require("./save-form");
var _saveFormAs = require("./save-form-as");
var _renameForm = require("./rename-form");
var _deleteForm = require("./delete-form");
var _publishForm = require("./publish-form");
var _exportForm = require("./export-form");
var _unpublishForm = require("./unpublish-form");
var _embedForm = require("./embed-form");
var _undo = require("./undo");
var _redo = require("./redo");
var _formVersionHistory = require("./form-version-history");
var _savePreset = require("./save-preset");
var _importFormFile = require("./import-form-file");
var _exportL10N = require("./export-l10n");
var _importL10N = require("./import-l10n");

},{"./copy-selection":"6cY8I","./paste-selection":"gJrW9","./cut-selection":"ikjgI","./delete-selection":"a6CDx","./select-next":"9pYro","./select-prev":"iU4AK","./unselect":"4JiEr","./save-form":"5cMl4","./save-form-as":"fVQav","./rename-form":"aYKut","./delete-form":"4QoBS","./publish-form":"kYfXH","./export-form":"8LE00","./unpublish-form":"gk7K2","./embed-form":"ae5rk","./undo":"bWpKb","./redo":"48iuV","./form-version-history":"5MSv0","./save-preset":"5oXec","./import-form-file":"kmVZl","./export-l10n":"6X8r4","./import-l10n":"8NkG9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6cY8I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clipboard", ()=>clipboard);
parcelHelpers.export(exports, "default", ()=>useCopySelectionAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _useFormEditor = require("../hooks/use-form-editor");
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _elementList = require("@form-engine/core-util/element-list");
var _react = require("react");
const clipboard = {
    targetId: undefined,
    value: undefined,
    isCut: false
};
function useCopySelectionAction() {
    const { state: elements } = (0, _useForm.useFormCollection)('elements');
    const { state: editor } = (0, _useFormEditor.useFormEditorContext)();
    return (0, _react.useCallback)(()=>{
        if (!editor?.selectedId) return;
        const index = (0, _elementList.getItemIndexById)(elements, editor?.selectedId);
        if (index > -1) {
            clipboard.targetId = editor.selectedId;
            clipboard.value = JSON.stringify(elements[index]);
            clipboard.isCut = false;
        }
    }, [
        editor?.selectedId,
        elements
    ]);
}
const ACTION_NAME = 'formEditor.selection.copy';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+c,meta+c');
const useAction = useCopySelectionAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction(), {
        editorFilter: 'editOnly'
    });
}

},{"../hooks/use-form-editor":"4pkiD","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-util/element-list":"e0ovy","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ii3Da":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HotkeyEditorFilters", ()=>HotkeyEditorFilters);
parcelHelpers.export(exports, "default", ()=>useFormEditorHotkey);
var _useHotkey = require("@form-engine/builder-application/hooks/use-hotkey");
var _useFormEditor = require("./use-form-editor");
var _react = require("react");
const HotkeyEditorFilters = {
    editOnly (editorState) {
        return editorState.view === 'form' && editorState.canvasTab === 'edit';
    }
};
function useFormEditorHotkey(hotkeyName, callback, options) {
    const { state: editorState } = (0, _useFormEditor.useFormEditorContext)();
    const innerOptions = {
        ...options ?? {}
    };
    delete innerOptions.editorFilter;
    const handler = (0, _react.useCallback)((e)=>{
        let filter = options?.editorFilter;
        if (filter && typeof filter !== 'function') filter = HotkeyEditorFilters[filter];
        if (!filter || filter(editorState)) {
            e.stopPropagation();
            e.preventDefault();
            callback();
        }
    }, [
        options,
        editorState,
        callback,
        hotkeyName
    ]);
    const handlerRef = (0, _react.useRef)(handler);
    (0, _react.useEffect)(()=>{
        handlerRef.current = handler;
    }, [
        handler
    ]);
    return (0, _useHotkey.useHotkey)(hotkeyName, (...args)=>{
        handlerRef?.current?.(...args);
    }, innerOptions);
}

},{"@form-engine/builder-application/hooks/use-hotkey":"cIBSk","./use-form-editor":"4pkiD","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cIBSk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHotkey", ()=>useHotkey);
var _reactHotkeysHook = require("react-hotkeys-hook");
var _useApp = require("./use-app");
var _keybindings = require("../keybindings");
var _keybindingsDefault = parcelHelpers.interopDefault(_keybindings);
function useHotkey(hotkeyName, callback, options) {
    const { state: { keybindings = {} } } = (0, _useApp.useAppContext)();
    const keys = keybindings[hotkeyName] || (0, _keybindingsDefault.default)()?.[hotkeyName];
    if (!keys) throw new Error(`unknown hotkey ${hotkeyName}`);
    return (0, _reactHotkeysHook.useHotkeys)(keys, (...args)=>{
        callback(...args);
    }, options);
}

},{"react-hotkeys-hook":"gikSy","./use-app":"8Rocb","../keybindings":"3o7P8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gikSy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HotkeysProvider", ()=>HotkeysProvider);
parcelHelpers.export(exports, "isHotkeyPressed", ()=>isHotkeyPressed);
parcelHelpers.export(exports, "useHotkeys", ()=>useHotkeys);
parcelHelpers.export(exports, "useHotkeysContext", ()=>useHotkeysContext);
parcelHelpers.export(exports, "useRecordHotkeys", ()=>useRecordHotkeys);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var reservedModifierKeywords = [
    'shift',
    'alt',
    'meta',
    'mod',
    'ctrl'
];
var mappedKeys = {
    esc: 'escape',
    "return": 'enter',
    '.': 'period',
    ',': 'comma',
    '-': 'slash',
    ' ': 'space',
    '`': 'backquote',
    '#': 'backslash',
    '+': 'bracketright',
    ShiftLeft: 'shift',
    ShiftRight: 'shift',
    AltLeft: 'alt',
    AltRight: 'alt',
    MetaLeft: 'meta',
    MetaRight: 'meta',
    OSLeft: 'meta',
    OSRight: 'meta',
    ControlLeft: 'ctrl',
    ControlRight: 'ctrl'
};
function mapKey(key) {
    return (key && mappedKeys[key] || key || '').trim().toLowerCase().replace(/key|digit|numpad|arrow/, '');
}
function isHotkeyModifier(key) {
    return reservedModifierKeywords.includes(key);
}
function parseKeysHookInput(keys, splitKey) {
    if (splitKey === void 0) splitKey = ',';
    return keys.split(splitKey);
}
function parseHotkey(hotkey, combinationKey, description) {
    if (combinationKey === void 0) combinationKey = '+';
    var keys = hotkey.toLocaleLowerCase().split(combinationKey).map(function(k) {
        return mapKey(k);
    });
    var modifiers = {
        alt: keys.includes('alt'),
        ctrl: keys.includes('ctrl') || keys.includes('control'),
        shift: keys.includes('shift'),
        meta: keys.includes('meta'),
        mod: keys.includes('mod')
    };
    var singleCharKeys = keys.filter(function(k) {
        return !reservedModifierKeywords.includes(k);
    });
    return _extends({}, modifiers, {
        keys: singleCharKeys,
        description: description
    });
}
(function() {
    if (typeof document !== 'undefined') {
        document.addEventListener('keydown', function(e) {
            if (e.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            pushToCurrentlyPressedKeys([
                mapKey(e.key),
                mapKey(e.code)
            ]);
        });
        document.addEventListener('keyup', function(e) {
            if (e.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            removeFromCurrentlyPressedKeys([
                mapKey(e.key),
                mapKey(e.code)
            ]);
        });
    }
    if (typeof window !== 'undefined') window.addEventListener('blur', function() {
        currentlyPressedKeys.clear();
    });
})();
var currentlyPressedKeys = /*#__PURE__*/ new Set();
// https://github.com/microsoft/TypeScript/issues/17002
function isReadonlyArray(value) {
    return Array.isArray(value);
}
function isHotkeyPressed(key, splitKey) {
    if (splitKey === void 0) splitKey = ',';
    var hotkeyArray = isReadonlyArray(key) ? key : key.split(splitKey);
    return hotkeyArray.every(function(hotkey) {
        return currentlyPressedKeys.has(hotkey.trim().toLowerCase());
    });
}
function pushToCurrentlyPressedKeys(key) {
    var hotkeyArray = Array.isArray(key) ? key : [
        key
    ];
    /*
  Due to a weird behavior on macOS we need to clear the set if the user pressed down the meta key and presses another key.
  https://stackoverflow.com/questions/11818637/why-does-javascript-drop-keyup-events-when-the-metakey-is-pressed-on-mac-browser
  Otherwise the set will hold all ever pressed keys while the meta key is down which leads to wrong results.
   */ if (currentlyPressedKeys.has('meta')) currentlyPressedKeys.forEach(function(key) {
        return !isHotkeyModifier(key) && currentlyPressedKeys["delete"](key.toLowerCase());
    });
    hotkeyArray.forEach(function(hotkey) {
        return currentlyPressedKeys.add(hotkey.toLowerCase());
    });
}
function removeFromCurrentlyPressedKeys(key) {
    var hotkeyArray = Array.isArray(key) ? key : [
        key
    ];
    /*
  Due to a weird behavior on macOS we need to clear the set if the user pressed down the meta key and presses another key.
  https://stackoverflow.com/questions/11818637/why-does-javascript-drop-keyup-events-when-the-metakey-is-pressed-on-mac-browser
  Otherwise the set will hold all ever pressed keys while the meta key is down which leads to wrong results.
   */ if (key === 'meta') currentlyPressedKeys.clear();
    else hotkeyArray.forEach(function(hotkey) {
        return currentlyPressedKeys["delete"](hotkey.toLowerCase());
    });
}
function maybePreventDefault(e, hotkey, preventDefault) {
    if (typeof preventDefault === 'function' && preventDefault(e, hotkey) || preventDefault === true) e.preventDefault();
}
function isHotkeyEnabled(e, hotkey, enabled) {
    if (typeof enabled === 'function') return enabled(e, hotkey);
    return enabled === true || enabled === undefined;
}
function isKeyboardEventTriggeredByInput(ev) {
    return isHotkeyEnabledOnTag(ev, [
        'input',
        'textarea',
        'select'
    ]);
}
function isHotkeyEnabledOnTag(_ref, enabledOnTags) {
    var target = _ref.target;
    if (enabledOnTags === void 0) enabledOnTags = false;
    var targetTagName = target && target.tagName;
    if (isReadonlyArray(enabledOnTags)) return Boolean(targetTagName && enabledOnTags && enabledOnTags.some(function(tag) {
        return tag.toLowerCase() === targetTagName.toLowerCase();
    }));
    return Boolean(targetTagName && enabledOnTags && enabledOnTags === true);
}
function isScopeActive(activeScopes, scopes) {
    if (activeScopes.length === 0 && scopes) {
        console.warn('A hotkey has the "scopes" option set, however no active scopes were found. If you want to use the global scopes feature, you need to wrap your app in a <HotkeysProvider>');
        return true;
    }
    if (!scopes) return true;
    return activeScopes.some(function(scope) {
        return scopes.includes(scope);
    }) || activeScopes.includes('*');
}
var isHotkeyMatchingKeyboardEvent = function isHotkeyMatchingKeyboardEvent(e, hotkey, ignoreModifiers) {
    if (ignoreModifiers === void 0) ignoreModifiers = false;
    var alt = hotkey.alt, meta = hotkey.meta, mod = hotkey.mod, shift = hotkey.shift, ctrl = hotkey.ctrl, keys = hotkey.keys;
    var pressedKeyUppercase = e.key, code = e.code, ctrlKey = e.ctrlKey, metaKey = e.metaKey, shiftKey = e.shiftKey, altKey = e.altKey;
    var keyCode = mapKey(code);
    var pressedKey = pressedKeyUppercase.toLowerCase();
    if (!(keys != null && keys.includes(keyCode)) && !(keys != null && keys.includes(pressedKey)) && ![
        'ctrl',
        'control',
        'unknown',
        'meta',
        'alt',
        'shift',
        'os'
    ].includes(keyCode)) return false;
    if (!ignoreModifiers) {
        // We check the pressed keys for compatibility with the keyup event. In keyup events the modifier flags are not set.
        if (alt === !altKey && pressedKey !== 'alt') return false;
        if (shift === !shiftKey && pressedKey !== 'shift') return false;
        // Mod is a special key name that is checking for meta on macOS and ctrl on other platforms
        if (mod) {
            if (!metaKey && !ctrlKey) return false;
        } else {
            if (meta === !metaKey && pressedKey !== 'meta' && pressedKey !== 'os') return false;
            if (ctrl === !ctrlKey && pressedKey !== 'ctrl' && pressedKey !== 'control') return false;
        }
    }
    // All modifiers are correct, now check the key
    // If the key is set, we check for the key
    if (keys && keys.length === 1 && (keys.includes(pressedKey) || keys.includes(keyCode))) return true;
    else if (keys) // Check if all keys are present in pressedDownKeys set
    return isHotkeyPressed(keys);
    else if (!keys) // If the key is not set, we only listen for modifiers, that check went alright, so we return true
    return true;
    // There is nothing that matches.
    return false;
};
var BoundHotkeysProxyProvider = /*#__PURE__*/ (0, _react.createContext)(undefined);
var useBoundHotkeysProxy = function useBoundHotkeysProxy() {
    return (0, _react.useContext)(BoundHotkeysProxyProvider);
};
function BoundHotkeysProxyProviderProvider(_ref) {
    var addHotkey = _ref.addHotkey, removeHotkey = _ref.removeHotkey, children = _ref.children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BoundHotkeysProxyProvider.Provider, {
        value: {
            addHotkey: addHotkey,
            removeHotkey: removeHotkey
        },
        children: children
    });
}
function deepEqual(x, y) {
    //@ts-ignore
    return x && y && typeof x === 'object' && typeof y === 'object' ? Object.keys(x).length === Object.keys(y).length && //@ts-ignore
    Object.keys(x).reduce(function(isEqual, key) {
        return isEqual && deepEqual(x[key], y[key]);
    }, true) : x === y;
}
var HotkeysContext = /*#__PURE__*/ (0, _react.createContext)({
    hotkeys: [],
    enabledScopes: [],
    toggleScope: function toggleScope() {},
    enableScope: function enableScope() {},
    disableScope: function disableScope() {}
});
var useHotkeysContext = function useHotkeysContext() {
    return (0, _react.useContext)(HotkeysContext);
};
var HotkeysProvider = function HotkeysProvider(_ref) {
    var _ref$initiallyActiveS = _ref.initiallyActiveScopes, initiallyActiveScopes = _ref$initiallyActiveS === void 0 ? [
        '*'
    ] : _ref$initiallyActiveS, children = _ref.children;
    var _useState = (0, _react.useState)((initiallyActiveScopes == null ? void 0 : initiallyActiveScopes.length) > 0 ? initiallyActiveScopes : [
        '*'
    ]), internalActiveScopes = _useState[0], setInternalActiveScopes = _useState[1];
    var _useState2 = (0, _react.useState)([]), boundHotkeys = _useState2[0], setBoundHotkeys = _useState2[1];
    var enableScope = (0, _react.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.includes('*')) return [
                scope
            ];
            return Array.from(new Set([].concat(prev, [
                scope
            ])));
        });
    }, []);
    var disableScope = (0, _react.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.filter(function(s) {
                return s !== scope;
            }).length === 0) return [
                '*'
            ];
            else return prev.filter(function(s) {
                return s !== scope;
            });
        });
    }, []);
    var toggleScope = (0, _react.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.includes(scope)) {
                if (prev.filter(function(s) {
                    return s !== scope;
                }).length === 0) return [
                    '*'
                ];
                else return prev.filter(function(s) {
                    return s !== scope;
                });
            } else {
                if (prev.includes('*')) return [
                    scope
                ];
                return Array.from(new Set([].concat(prev, [
                    scope
                ])));
            }
        });
    }, []);
    var addBoundHotkey = (0, _react.useCallback)(function(hotkey) {
        setBoundHotkeys(function(prev) {
            return [].concat(prev, [
                hotkey
            ]);
        });
    }, []);
    var removeBoundHotkey = (0, _react.useCallback)(function(hotkey) {
        setBoundHotkeys(function(prev) {
            return prev.filter(function(h) {
                return !deepEqual(h, hotkey);
            });
        });
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(HotkeysContext.Provider, {
        value: {
            enabledScopes: internalActiveScopes,
            hotkeys: boundHotkeys,
            enableScope: enableScope,
            disableScope: disableScope,
            toggleScope: toggleScope
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BoundHotkeysProxyProviderProvider, {
            addHotkey: addBoundHotkey,
            removeHotkey: removeBoundHotkey,
            children: children
        })
    });
};
function useDeepEqualMemo(value) {
    var ref = (0, _react.useRef)(undefined);
    if (!deepEqual(ref.current, value)) ref.current = value;
    return ref.current;
}
var stopPropagation = function stopPropagation(e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();
};
var useSafeLayoutEffect = typeof window !== 'undefined' ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
function useHotkeys(keys, callback, options, dependencies) {
    var _useState = (0, _react.useState)(null), ref = _useState[0], setRef = _useState[1];
    var hasTriggeredRef = (0, _react.useRef)(false);
    var _options = !(options instanceof Array) ? options : !(dependencies instanceof Array) ? dependencies : undefined;
    var _keys = isReadonlyArray(keys) ? keys.join(_options == null ? void 0 : _options.splitKey) : keys;
    var _deps = options instanceof Array ? options : dependencies instanceof Array ? dependencies : undefined;
    var memoisedCB = (0, _react.useCallback)(callback, _deps != null ? _deps : []);
    var cbRef = (0, _react.useRef)(memoisedCB);
    if (_deps) cbRef.current = memoisedCB;
    else cbRef.current = callback;
    var memoisedOptions = useDeepEqualMemo(_options);
    var _useHotkeysContext = useHotkeysContext(), enabledScopes = _useHotkeysContext.enabledScopes;
    var proxy = useBoundHotkeysProxy();
    useSafeLayoutEffect(function() {
        if ((memoisedOptions == null ? void 0 : memoisedOptions.enabled) === false || !isScopeActive(enabledScopes, memoisedOptions == null ? void 0 : memoisedOptions.scopes)) return;
        var listener = function listener(e, isKeyUp) {
            var _e$target;
            if (isKeyUp === void 0) isKeyUp = false;
            if (isKeyboardEventTriggeredByInput(e) && !isHotkeyEnabledOnTag(e, memoisedOptions == null ? void 0 : memoisedOptions.enableOnFormTags)) return;
            // TODO: SINCE THE EVENT IS NOW ATTACHED TO THE REF, THE ACTIVE ELEMENT CAN NEVER BE INSIDE THE REF. THE HOTKEY ONLY TRIGGERS IF THE
            // REF IS THE ACTIVE ELEMENT. THIS IS A PROBLEM SINCE FOCUSED SUB COMPONENTS WON'T TRIGGER THE HOTKEY.
            if (ref !== null) {
                var rootNode = ref.getRootNode();
                if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement !== ref && !ref.contains(rootNode.activeElement)) {
                    stopPropagation(e);
                    return;
                }
            }
            if ((_e$target = e.target) != null && _e$target.isContentEditable && !(memoisedOptions != null && memoisedOptions.enableOnContentEditable)) return;
            parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
                var _hotkey$keys;
                var hotkey = parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey);
                if (isHotkeyMatchingKeyboardEvent(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.ignoreModifiers) || (_hotkey$keys = hotkey.keys) != null && _hotkey$keys.includes('*')) {
                    if (memoisedOptions != null && memoisedOptions.ignoreEventWhen != null && memoisedOptions.ignoreEventWhen(e)) return;
                    if (isKeyUp && hasTriggeredRef.current) return;
                    maybePreventDefault(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.preventDefault);
                    if (!isHotkeyEnabled(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.enabled)) {
                        stopPropagation(e);
                        return;
                    }
                    // Execute the user callback for that hotkey
                    cbRef.current(e, hotkey);
                    if (!isKeyUp) hasTriggeredRef.current = true;
                }
            });
        };
        var handleKeyDown = function handleKeyDown(event) {
            if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            pushToCurrentlyPressedKeys(mapKey(event.code));
            if ((memoisedOptions == null ? void 0 : memoisedOptions.keydown) === undefined && (memoisedOptions == null ? void 0 : memoisedOptions.keyup) !== true || memoisedOptions != null && memoisedOptions.keydown) listener(event);
        };
        var handleKeyUp = function handleKeyUp(event) {
            if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            removeFromCurrentlyPressedKeys(mapKey(event.code));
            hasTriggeredRef.current = false;
            if (memoisedOptions != null && memoisedOptions.keyup) listener(event, true);
        };
        var domNode = ref || (_options == null ? void 0 : _options.document) || document;
        // @ts-ignore
        domNode.addEventListener('keyup', handleKeyUp);
        // @ts-ignore
        domNode.addEventListener('keydown', handleKeyDown);
        if (proxy) parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
            return proxy.addHotkey(parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey, memoisedOptions == null ? void 0 : memoisedOptions.description));
        });
        return function() {
            // @ts-ignore
            domNode.removeEventListener('keyup', handleKeyUp);
            // @ts-ignore
            domNode.removeEventListener('keydown', handleKeyDown);
            if (proxy) parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
                return proxy.removeHotkey(parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey, memoisedOptions == null ? void 0 : memoisedOptions.description));
            });
        };
    }, [
        ref,
        _keys,
        memoisedOptions,
        enabledScopes
    ]);
    return setRef;
}
function useRecordHotkeys() {
    var _useState = (0, _react.useState)(new Set()), keys = _useState[0], setKeys = _useState[1];
    var _useState2 = (0, _react.useState)(false), isRecording = _useState2[0], setIsRecording = _useState2[1];
    var handler = (0, _react.useCallback)(function(event) {
        if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
        return;
        event.preventDefault();
        event.stopPropagation();
        setKeys(function(prev) {
            var newKeys = new Set(prev);
            newKeys.add(mapKey(event.code));
            return newKeys;
        });
    }, []);
    var stop = (0, _react.useCallback)(function() {
        if (typeof document !== 'undefined') {
            document.removeEventListener('keydown', handler);
            setIsRecording(false);
        }
    }, [
        handler
    ]);
    var start = (0, _react.useCallback)(function() {
        setKeys(new Set());
        if (typeof document !== 'undefined') {
            stop();
            document.addEventListener('keydown', handler);
            setIsRecording(true);
        }
    }, [
        handler,
        stop
    ]);
    var resetKeys = (0, _react.useCallback)(function() {
        setKeys(new Set());
    }, []);
    return [
        keys,
        {
            start: start,
            stop: stop,
            resetKeys: resetKeys,
            isRecording: isRecording
        }
    ];
}

},{"react":"9njXz","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3o7P8":[function(require,module,exports,__globalThis) {
/** @todo investigate why Builder is not importable here */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getKeyBindings);
parcelHelpers.export(exports, "getHotkeyLabel", ()=>getHotkeyLabel);
parcelHelpers.export(exports, "setHotkey", ()=>setHotkey);
function getKeyBindings() {
    const Builder = window?.FormEngine?.Builder || {};
    if (!Builder.keybindings) Builder.keybindings = {};
    return Builder.keybindings;
}
const keySymbols = Object.entries({
    cmd: "\u2318",
    meta: "\u2318",
    option: "\u2325",
    alt: "\u2325",
    ctrl: "\u2303",
    shift: "\u21E7",
    capslock: "\u21EA",
    left: "\u2190",
    right: "\u2192",
    up: "\u2191",
    down: "\u2193",
    tab: "\u21E5",
    backtab: "\u21E4",
    return: "\u21A9",
    enter: "\u2324",
    forwarddelete: "\u2326",
    delete: "\u232B",
    backspace: "\u232B",
    pageup: "\u21DE",
    pagedown: "\u21DF",
    home: "\u2196",
    end: "\u2198",
    clear: "\u2327",
    space: "\u2423",
    escape: "\u238B",
    eject: "\u23CF",
    '+': ' '
});
function getHotkeyLabel(id, fallback = 'UNASSIGNED', symbols = true) {
    const resolve = ()=>{
        const keybindings = getKeyBindings();
        if (!(id in keybindings)) return fallback;
        const shortcuts = keybindings[id].split(',');
        // only show OS appropriate shortcuts
        if (shortcuts.length > 1) {
            const isWindows = navigator.userAgent.includes('Windows');
            const cmd = shortcuts.find((s)=>s.startsWith('cmd') || s.startsWith('meta'));
            const ctrl = shortcuts.find((s)=>s.startsWith('ctrl'));
            if (isWindows && ctrl) return ctrl.trim();
            if (!isWindows && cmd) return cmd.trim();
        }
        return keybindings[id];
    };
    const result = resolve();
    if (!symbols) return result;
    let withSymbols = result;
    for (const [key, symbol] of keySymbols)withSymbols = withSymbols.split(key).join(symbol);
    return withSymbols;
}
function setHotkey(name, mapping) {
    if (typeof name === 'object') {
        Object.entries(name).forEach(([key, value])=>setHotkey(key, value));
        return;
    }
    if (!mapping) throw new Error('invalid mapping');
    getKeyBindings()[name] = Array.isArray(mapping) ? mapping.join(',') : mapping;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gJrW9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePasteSelectionAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _useFormEditor = require("../hooks/use-form-editor");
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _elementList = require("@form-engine/core-util/element-list");
var _react = require("react");
var _copySelection = require("./copy-selection");
var _coreApplication = require("@form-engine/core-application");
var _coreApplicationDefault = parcelHelpers.interopDefault(_coreApplication);
function usePasteSelectionAction() {
    const { state: elements, set } = (0, _useForm.useFormElements)();
    const { state: editor, setItem: setEditorItem } = (0, _useFormEditor.useFormEditorContext)();
    return (0, _react.useCallback)(()=>{
        if (!(0, _copySelection.clipboard).value) return;
        const destination = editor?.selectedId ? elements[(0, _elementList.getItemIndexById)(elements, editor?.selectedId)] : undefined;
        const { id, parent: destParent, type } = destination || {};
        const parent = type && type in (0, _coreApplicationDefault.default).getContainerElements() ? id : destParent;
        const after = parent !== id ? id : null;
        const value = JSON.parse((0, _copySelection.clipboard).value);
        const source = {
            ...value,
            parent
        };
        if ((0, _copySelection.clipboard).isCut) {
            set((0, _elementList.relocateItemAfter)(elements, source, after));
            (0, _copySelection.clipboard).targetId = undefined;
            (0, _copySelection.clipboard).value = undefined;
            (0, _copySelection.clipboard).isCut = false;
        } else {
            // clone nested
            const [branchRoot, ...children] = (0, _elementList.cloneItemBranch)(elements, source);
            if (branchRoot) {
                branchRoot.parent = parent;
                // insert clone root
                const updatedItems = (0, _elementList.insertItemAfter)(elements, branchRoot, after);
                const index = (0, _elementList.getItemIndexById)(updatedItems, branchRoot.id);
                // insert clone children after root
                updatedItems.splice(index, 0, ...children);
                set(updatedItems);
            }
        }
        setEditorItem('selectedId', source.id);
    }, [
        editor?.selectedId,
        elements,
        set,
        setEditorItem
    ]);
}
const ACTION_NAME = 'formEditor.selection.paste';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+v,meta+v');
const useAction = usePasteSelectionAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction(), {
        editorFilter: 'editOnly'
    });
}

},{"../hooks/use-form-editor":"4pkiD","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-util/element-list":"e0ovy","react":"9njXz","./copy-selection":"6cY8I","@form-engine/core-application":"fjN6J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ikjgI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCutSelectionAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _useFormEditor = require("../hooks/use-form-editor");
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _elementList = require("@form-engine/core-util/element-list");
var _react = require("react");
var _copySelection = require("./copy-selection");
function useCutSelectionAction() {
    const { state: elements } = (0, _useForm.useFormCollection)('elements');
    const { state: editor } = (0, _useFormEditor.useFormEditorContext)();
    return (0, _react.useCallback)(()=>{
        if (!editor?.selectedId) return;
        const index = (0, _elementList.getItemIndexById)(elements, editor?.selectedId);
        if (index > -1) {
            (0, _copySelection.clipboard).targetId = editor.selectedId;
            (0, _copySelection.clipboard).value = JSON.stringify(elements[index]);
            (0, _copySelection.clipboard).isCut = true;
        }
    }, [
        editor?.selectedId,
        elements
    ]);
}
const ACTION_NAME = 'formEditor.selection.cut';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+x,meta+x');
const useAction = useCutSelectionAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction(), {
        editorFilter: 'editOnly'
    });
}

},{"../hooks/use-form-editor":"4pkiD","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-util/element-list":"e0ovy","react":"9njXz","./copy-selection":"6cY8I","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a6CDx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDeleteSelectionAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _useFormEditor = require("../hooks/use-form-editor");
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _elementList = require("@form-engine/core-util/element-list");
var _react = require("react");
function useDeleteSelectionAction() {
    const { state: elements, set } = (0, _useForm.useFormCollection)('elements');
    const { state: editor } = (0, _useFormEditor.useFormEditorContext)();
    return (0, _react.useCallback)(()=>{
        if (!editor?.selectedId) return;
        const target = (0, _elementList.getItemById)(elements, editor?.selectedId);
        if (target) set((0, _elementList.removeItem)(elements, target));
    }, [
        editor?.selectedId,
        elements,
        set
    ]);
}
const ACTION_NAME = 'formEditor.selection.delete';
(0, _keybindings.setHotkey)(ACTION_NAME, 'delete,backspace');
const useAction = useDeleteSelectionAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction(), {
        editorFilter: 'editOnly'
    });
}

},{"../hooks/use-form-editor":"4pkiD","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-util/element-list":"e0ovy","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9pYro":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useSelectNextAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _useFormEditor = require("../hooks/use-form-editor");
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _elementList = require("@form-engine/core-util/element-list");
var _react = require("react");
function useSelectNextAction() {
    const { state: elements } = (0, _useForm.useFormCollection)('elements');
    const { state: editor, setItem } = (0, _useFormEditor.useFormEditorContext)();
    return (0, _react.useCallback)(()=>{
        if (!editor?.selectedId) return;
        const index = (0, _elementList.getItemIndexById)(elements, editor?.selectedId);
        const nextIndex = index + 1;
        if (index > -1 && nextIndex < elements.length) setItem('selectedId', elements[nextIndex].id);
    }, [
        editor?.selectedId,
        elements,
        setItem
    ]);
}
const ACTION_NAME = 'formEditor.selection.next';
(0, _keybindings.setHotkey)(ACTION_NAME, 'down,tab');
const useAction = useSelectNextAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction(), {
        editorFilter: 'editOnly'
    });
}

},{"../hooks/use-form-editor":"4pkiD","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-util/element-list":"e0ovy","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iU4AK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useSelectPrevAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _useFormEditor = require("../hooks/use-form-editor");
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _elementList = require("@form-engine/core-util/element-list");
var _react = require("react");
function useSelectPrevAction() {
    const { state: elements } = (0, _useForm.useFormCollection)('elements');
    const { state: editor, setItem } = (0, _useFormEditor.useFormEditorContext)();
    return (0, _react.useCallback)(()=>{
        if (!editor?.selectedId) return;
        const index = (0, _elementList.getItemIndexById)(elements, editor?.selectedId);
        const nextIndex = index - 1;
        if (index > -1 && nextIndex > -1) setItem('selectedId', elements[nextIndex].id);
    }, [
        editor?.selectedId,
        elements,
        setItem
    ]);
}
const ACTION_NAME = 'formEditor.selection.prev';
(0, _keybindings.setHotkey)(ACTION_NAME, 'up');
const useAction = useSelectPrevAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction(), {
        editorFilter: 'editOnly'
    });
}

},{"../hooks/use-form-editor":"4pkiD","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-util/element-list":"e0ovy","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4JiEr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUnselectAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _useFormEditor = require("../hooks/use-form-editor");
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _react = require("react");
function useUnselectAction() {
    const { state: editor, setItem } = (0, _useFormEditor.useFormEditorContext)();
    return (0, _react.useCallback)(()=>{
        if (!editor?.selectedId) return;
        setItem('selectedId', undefined);
    }, [
        editor?.selectedId,
        setItem
    ]);
}
const ACTION_NAME = 'formEditor.selection.unselect';
(0, _keybindings.setHotkey)(ACTION_NAME, 'esc');
const useAction = useUnselectAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction(), {
        editorFilter: 'editOnly'
    });
}

},{"../hooks/use-form-editor":"4pkiD","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5cMl4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useSaveFormAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormApi = require("@form-engine/builder-application/hooks/use-form-api");
var _useFormApiDefault = parcelHelpers.interopDefault(_useFormApi);
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _reactToastify = require("react-toastify");
var _elementList = require("@form-engine/core-util/element-list");
/** @todo remove this, its only for cleaning legacy forms */ function sanitizeForm(form) {
    const copy = {
        ...form
    };
    if (copy.elements) copy.elements = (0, _elementList.removeOrphans)(copy.elements);
    return copy;
}
let hasSaveListener = false;
function useSaveFormAction() {
    const { state: form, setItem } = (0, _useForm.useFormContext)();
    const { update } = (0, _useFormApiDefault.default)();
    const callback = (0, _react.useCallback)(()=>{
        const toastId = (0, _reactToastify.toast)(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: "Saving..."
        }));
        update(sanitizeForm(form)).then(({ updatedAt })=>{
            setItem('updatedAt', updatedAt);
            (0, _reactToastify.toast).update(toastId, {
                render: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.CheckCircleFill), {
                            className: "me-2"
                        }),
                        " Saved"
                    ]
                })
            });
        });
    }, [
        update,
        form,
        (0, _reactToastify.toast),
        setItem
    ]);
    (0, _react.useEffect)(()=>{
        if (hasSaveListener) return;
        hasSaveListener = true;
        const disableNative = (e)=>{
            if ((e.ctrlKey || e.metaKey) && !e.altKey && !e.shiftKey && e.key === 's') {
                e.preventDefault();
                e.stopPropagation();
                callback();
            }
        };
        document.body.addEventListener('keydown', disableNative);
        return ()=>{
            hasSaveListener = false;
            document.body.removeEventListener('keydown', disableNative);
        };
    }, [
        callback
    ]);
    return callback;
}
const ACTION_NAME = 'formEditor.form.save';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+s,meta+s');
const useAction = useSaveFormAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction());
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-application/hooks/use-form-api":"3uteJ","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","react-bootstrap-icons":"3TzoC","react-toastify":"iWdY7","@form-engine/core-util/element-list":"e0ovy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iWdY7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bounce", ()=>H);
parcelHelpers.export(exports, "Flip", ()=>Y);
parcelHelpers.export(exports, "Icons", ()=>z);
parcelHelpers.export(exports, "Slide", ()=>F);
parcelHelpers.export(exports, "ToastContainer", ()=>Q);
parcelHelpers.export(exports, "Zoom", ()=>X);
parcelHelpers.export(exports, "collapseToast", ()=>f);
parcelHelpers.export(exports, "cssTransition", ()=>g);
parcelHelpers.export(exports, "toast", ()=>B);
parcelHelpers.export(exports, "useToast", ()=>N);
parcelHelpers.export(exports, "useToastContainer", ()=>L);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
'use client';
const c = (e)=>"number" == typeof e && !isNaN(e), d = (e)=>"string" == typeof e, u = (e)=>"function" == typeof e, p = (e)=>d(e) || u(e) ? e : null, m = (e)=>(0, _react.isValidElement)(e) || d(e) || u(e) || c(e);
function f(e, t, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = e;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(t, n);
        });
    });
}
function g(t) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = t;
    return function(t) {
        let { children: d, position: u, preventExitTransition: p, done: m, nodeRef: g, isIn: y, playToast: v } = t;
        const h = i ? `${a}--${u}` : a, T = i ? `${r}--${u}` : r, E = (0, _react.useRef)(0);
        return (0, _react.useLayoutEffect)(()=>{
            const e = g.current, t = h.split(" "), n = (o)=>{
                o.target === g.current && (v(), e.removeEventListener("animationend", n), e.removeEventListener("animationcancel", n), 0 === E.current && "animationcancel" !== o.type && e.classList.remove(...t));
            };
            e.classList.add(...t), e.addEventListener("animationend", n), e.addEventListener("animationcancel", n);
        }, []), (0, _react.useEffect)(()=>{
            const e = g.current, t = ()=>{
                e.removeEventListener("animationend", t), l ? f(e, m, c) : m();
            };
            y || (p ? t() : (E.current = 1, e.className += ` ${T}`, e.addEventListener("animationend", t)));
        }, [
            y
        ]), (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, d);
    };
}
function y(e, t) {
    return null != e ? {
        content: e.content,
        containerId: e.props.containerId,
        id: e.props.toastId,
        theme: e.props.theme,
        type: e.props.type,
        data: e.props.data || {},
        isLoading: e.props.isLoading,
        icon: e.props.icon,
        status: t
    } : {};
}
const v = new Map;
let h = [];
const T = new Set, E = (e)=>T.forEach((t)=>t(e)), b = ()=>v.size > 0;
function I(e, t) {
    var n;
    if (t) return !(null == (n = v.get(t)) || !n.isToastActive(e));
    let o = !1;
    return v.forEach((t)=>{
        t.isToastActive(e) && (o = !0);
    }), o;
}
function _(e, t) {
    m(e) && (b() || h.push({
        content: e,
        options: t
    }), v.forEach((n)=>{
        n.buildToast(e, t);
    }));
}
function C(e, t) {
    v.forEach((n)=>{
        null != t && null != t && t.containerId ? (null == t ? void 0 : t.containerId) === n.id && n.toggle(e, null == t ? void 0 : t.id) : n.toggle(e, null == t ? void 0 : t.id);
    });
}
function L(e) {
    const { subscribe: o, getSnapshot: s, setProps: i } = (0, _react.useRef)(function(e) {
        const n = e.containerId || 1;
        return {
            subscribe (o) {
                const s = function(e, n, o) {
                    let s = 1, r = 0, i = [], l = [], f = [], g = n;
                    const v = new Map, h = new Set, T = ()=>{
                        f = Array.from(v.values()), h.forEach((e)=>e());
                    }, E = (e)=>{
                        l = null == e ? [] : l.filter((t)=>t !== e), T();
                    }, b = (e)=>{
                        const { toastId: n, onOpen: s, updateId: a, children: r } = e.props, i = null == a;
                        e.staleId && v.delete(e.staleId), v.set(n, e), l = [
                            ...l,
                            e.props.toastId
                        ].filter((t)=>t !== e.staleId), T(), o(y(e, i ? "added" : "updated")), i && u(s) && s((0, _react.isValidElement)(r) && r.props);
                    };
                    return {
                        id: e,
                        props: g,
                        observe: (e)=>(h.add(e), ()=>h.delete(e)),
                        toggle: (e, t)=>{
                            v.forEach((n)=>{
                                null != t && t !== n.props.toastId || u(n.toggle) && n.toggle(e);
                            });
                        },
                        removeToast: E,
                        toasts: v,
                        clearQueue: ()=>{
                            r -= i.length, i = [];
                        },
                        buildToast: (n, l)=>{
                            if (((t)=>{
                                let { containerId: n, toastId: o, updateId: s } = t;
                                const a = n ? n !== e : 1 !== e, r = v.has(o) && null == s;
                                return a || r;
                            })(l)) return;
                            const { toastId: f, updateId: h, data: I, staleId: _, delay: C } = l, L = ()=>{
                                E(f);
                            }, N = null == h;
                            N && r++;
                            const $ = {
                                ...g,
                                style: g.toastStyle,
                                key: s++,
                                ...Object.fromEntries(Object.entries(l).filter((e)=>{
                                    let [t, n] = e;
                                    return null != n;
                                })),
                                toastId: f,
                                updateId: h,
                                data: I,
                                closeToast: L,
                                isIn: !1,
                                className: p(l.className || g.toastClassName),
                                bodyClassName: p(l.bodyClassName || g.bodyClassName),
                                progressClassName: p(l.progressClassName || g.progressClassName),
                                autoClose: !l.isLoading && (w = l.autoClose, k = g.autoClose, !1 === w || c(w) && w > 0 ? w : k),
                                deleteToast () {
                                    const e = v.get(f), { onClose: n, children: s } = e.props;
                                    u(n) && n((0, _react.isValidElement)(s) && s.props), o(y(e, "removed")), v.delete(f), r--, r < 0 && (r = 0), i.length > 0 ? b(i.shift()) : T();
                                }
                            };
                            var w, k;
                            $.closeButton = g.closeButton, !1 === l.closeButton || m(l.closeButton) ? $.closeButton = l.closeButton : !0 === l.closeButton && ($.closeButton = !m(g.closeButton) || g.closeButton);
                            let P = n;
                            (0, _react.isValidElement)(n) && !d(n.type) ? P = (0, _react.cloneElement)(n, {
                                closeToast: L,
                                toastProps: $,
                                data: I
                            }) : u(n) && (P = n({
                                closeToast: L,
                                toastProps: $,
                                data: I
                            }));
                            const M = {
                                content: P,
                                props: $,
                                staleId: _
                            };
                            g.limit && g.limit > 0 && r > g.limit && N ? i.push(M) : c(C) ? setTimeout(()=>{
                                b(M);
                            }, C) : b(M);
                        },
                        setProps (e) {
                            g = e;
                        },
                        setToggle: (e, t)=>{
                            v.get(e).toggle = t;
                        },
                        isToastActive: (e)=>l.some((t)=>t === e),
                        getSnapshot: ()=>g.newestOnTop ? f.reverse() : f
                    };
                }(n, e, E);
                v.set(n, s);
                const r = s.observe(o);
                return h.forEach((e)=>_(e.content, e.options)), h = [], ()=>{
                    r(), v.delete(n);
                };
            },
            setProps (e) {
                var t;
                null == (t = v.get(n)) || t.setProps(e);
            },
            getSnapshot () {
                var e;
                return null == (e = v.get(n)) ? void 0 : e.getSnapshot();
            }
        };
    }(e)).current;
    i(e);
    const l = (0, _react.useSyncExternalStore)(o, s, s);
    return {
        getToastToRender: function(e) {
            if (!l) return [];
            const t = new Map;
            return l.forEach((e)=>{
                const { position: n } = e.props;
                t.has(n) || t.set(n, []), t.get(n).push(e);
            }), Array.from(t, (t)=>e(t[0], t[1]));
        },
        isToastActive: I,
        count: null == l ? void 0 : l.length
    };
}
function N(e) {
    const [t, o] = (0, _react.useState)(!1), [a, r] = (0, _react.useState)(!1), l = (0, _react.useRef)(null), c = (0, _react.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: u, closeToast: p, onClick: m, closeOnClick: f } = e;
    var g, y;
    function h() {
        o(!0);
    }
    function T() {
        o(!1);
    }
    function E(n) {
        const o = l.current;
        c.canDrag && o && (c.didMove = !0, t && T(), c.delta = "x" === e.draggableDirection ? n.clientX - c.start : n.clientY - c.start, c.start !== n.clientX && (c.canCloseOnClick = !1), o.style.transform = `translate3d(${"x" === e.draggableDirection ? `${c.delta}px, var(--y)` : `0, calc(${c.delta}px + var(--y))`},0)`, o.style.opacity = "" + (1 - Math.abs(c.delta / c.removalDistance)));
    }
    function b() {
        document.removeEventListener("pointermove", E), document.removeEventListener("pointerup", b);
        const t = l.current;
        if (c.canDrag && c.didMove && t) {
            if (c.canDrag = !1, Math.abs(c.delta) > c.removalDistance) return r(!0), e.closeToast(), void e.collapseAll();
            t.style.transition = "transform 0.2s, opacity 0.2s", t.style.removeProperty("transform"), t.style.removeProperty("opacity");
        }
    }
    null == (y = v.get((g = {
        id: e.toastId,
        containerId: e.containerId,
        fn: o
    }).containerId || 1)) || y.setToggle(g.id, g.fn), (0, _react.useEffect)(()=>{
        if (e.pauseOnFocusLoss) return document.hasFocus() || T(), window.addEventListener("focus", h), window.addEventListener("blur", T), ()=>{
            window.removeEventListener("focus", h), window.removeEventListener("blur", T);
        };
    }, [
        e.pauseOnFocusLoss
    ]);
    const I = {
        onPointerDown: function(t) {
            if (!0 === e.draggable || e.draggable === t.pointerType) {
                c.didMove = !1, document.addEventListener("pointermove", E), document.addEventListener("pointerup", b);
                const n = l.current;
                c.canCloseOnClick = !0, c.canDrag = !0, n.style.transition = "none", "x" === e.draggableDirection ? (c.start = t.clientX, c.removalDistance = n.offsetWidth * (e.draggablePercent / 100)) : (c.start = t.clientY, c.removalDistance = n.offsetHeight * (80 === e.draggablePercent ? 1.5 * e.draggablePercent : e.draggablePercent) / 100);
            }
        },
        onPointerUp: function(t) {
            const { top: n, bottom: o, left: s, right: a } = l.current.getBoundingClientRect();
            "touchend" !== t.nativeEvent.type && e.pauseOnHover && t.clientX >= s && t.clientX <= a && t.clientY >= n && t.clientY <= o ? T() : h();
        }
    };
    return d && u && (I.onMouseEnter = T, e.stacked || (I.onMouseLeave = h)), f && (I.onClick = (e)=>{
        m && m(e), c.canCloseOnClick && p();
    }), {
        playToast: h,
        pauseToast: T,
        isRunning: t,
        preventExitTransition: a,
        toastRef: l,
        eventHandlers: I
    };
}
function $(t) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: c, controlledProgress: d, progress: p, rtl: m, isIn: f, theme: g } = t;
    const y = r || d && 0 === p, v = {
        ...c,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    d && (v.transform = `scaleX(${p})`);
    const h = (0, _clsxDefault.default)("Toastify__progress-bar", d ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = u(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: h
    }) : (0, _clsxDefault.default)(h, i), E = {
        [d && p >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: d && p < 1 ? null : ()=>{
            f && s();
        }
    };
    return (0, _reactDefault.default).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": y
    }, (0, _reactDefault.default).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${a}`
    }), (0, _reactDefault.default).createElement("div", {
        role: "progressbar",
        "aria-hidden": y ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: v,
        ...E
    }));
}
let w = 1;
const k = ()=>"" + w++;
function P(e) {
    return e && (d(e.toastId) || c(e.toastId)) ? e.toastId : k();
}
function M(e, t) {
    return _(e, t), t.toastId;
}
function x(e, t) {
    return {
        ...t,
        type: t && t.type || e,
        toastId: P(t)
    };
}
function A(e) {
    return (t, n)=>M(t, x(e, n));
}
function B(e, t) {
    return M(e, x("default", t));
}
B.loading = (e, t)=>M(e, x("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...t
    })), B.promise = function(e, t, n) {
    let o, { pending: s, error: a, success: r } = t;
    s && (o = d(s) ? B.loading(s, n) : B.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (e, t, s)=>{
        if (null == t) return void B.dismiss(o);
        const a = {
            type: e,
            ...i,
            ...n,
            data: s
        }, r = d(t) ? {
            render: t
        } : t;
        return o ? B.update(o, {
            ...a,
            ...r
        }) : B(r.render, {
            ...a,
            ...r
        }), s;
    }, c = u(e) ? e() : e;
    return c.then((e)=>l("success", r, e)).catch((e)=>l("error", a, e)), c;
}, B.success = A("success"), B.info = A("info"), B.error = A("error"), B.warning = A("warning"), B.warn = B.warning, B.dark = (e, t)=>M(e, x("default", {
        theme: "dark",
        ...t
    })), B.dismiss = function(e) {
    !function(e) {
        var t;
        if (b()) {
            if (null == e || d(t = e) || c(t)) v.forEach((t)=>{
                t.removeToast(e);
            });
            else if (e && ("containerId" in e || "id" in e)) {
                const t = v.get(e.containerId);
                t ? t.removeToast(e.id) : v.forEach((t)=>{
                    t.removeToast(e.id);
                });
            }
        } else h = h.filter((t)=>null != e && t.options.toastId !== e);
    }(e);
}, B.clearWaitingQueue = function(e) {
    void 0 === e && (e = {}), v.forEach((t)=>{
        !t.props.limit || e.containerId && t.id !== e.containerId || t.clearQueue();
    });
}, B.isActive = I, B.update = function(e, t) {
    void 0 === t && (t = {});
    const n = ((e, t)=>{
        var n;
        let { containerId: o } = t;
        return null == (n = v.get(o || 1)) ? void 0 : n.toasts.get(e);
    })(e, t);
    if (n) {
        const { props: o, content: s } = n, a = {
            delay: 100,
            ...o,
            ...t,
            toastId: t.toastId || e,
            updateId: k()
        };
        a.toastId !== e && (a.staleId = e);
        const r = a.render || s;
        delete a.render, M(r, a);
    }
}, B.done = (e)=>{
    B.update(e, {
        progress: 1
    });
}, B.onChange = function(e) {
    return T.add(e), ()=>{
        T.delete(e);
    };
}, B.play = (e)=>C(!0, e), B.pause = (e)=>C(!1, e);
const O = "undefined" != typeof window ? (0, _react.useLayoutEffect) : (0, _react.useEffect), D = (t)=>{
    let { theme: n, type: o, isLoading: s, ...a } = t;
    return (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...a
    });
}, z = {
    info: function(t) {
        return (0, _reactDefault.default).createElement(D, {
            ...t
        }, (0, _reactDefault.default).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(t) {
        return (0, _reactDefault.default).createElement(D, {
            ...t
        }, (0, _reactDefault.default).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(t) {
        return (0, _reactDefault.default).createElement(D, {
            ...t
        }, (0, _reactDefault.default).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(t) {
        return (0, _reactDefault.default).createElement(D, {
            ...t
        }, (0, _reactDefault.default).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, _reactDefault.default).createElement("div", {
            className: "Toastify__spinner"
        });
    }
}, R = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i, playToast: c } = N(n), { closeButton: d, children: p, autoClose: m, onClick: f, type: g, hideProgressBar: y, closeToast: v, transition: h, position: T, className: E, style: b, bodyClassName: I, bodyStyle: _, progressClassName: C, progressStyle: L, updateId: w, role: k, progress: P, rtl: M, toastId: x, deleteToast: A, isIn: B, isLoading: O, closeOnClick: D, theme: R } = n, S = (0, _clsxDefault.default)("Toastify__toast", `Toastify__toast-theme--${R}`, `Toastify__toast--${g}`, {
        "Toastify__toast--rtl": M
    }, {
        "Toastify__toast--close-on-click": D
    }), H = u(E) ? E({
        rtl: M,
        position: T,
        type: g,
        defaultClassName: S
    }) : (0, _clsxDefault.default)(S, E), F = function(e) {
        let { theme: n, type: o, isLoading: s, icon: r } = e, i = null;
        const l = {
            theme: n,
            type: o
        };
        return !1 === r || (u(r) ? i = r({
            ...l,
            isLoading: s
        }) : (0, _react.isValidElement)(r) ? i = (0, _react.cloneElement)(r, l) : s ? i = z.spinner() : ((e)=>e in z)(o) && (i = z[o](l))), i;
    }(n), X = !!P || !m, Y = {
        closeToast: v,
        type: g,
        theme: R
    };
    let q = null;
    return !1 === d || (q = u(d) ? d(Y) : (0, _react.isValidElement)(d) ? (0, _react.cloneElement)(d, Y) : function(t) {
        let { closeToast: n, theme: o, ariaLabel: s = "close" } = t;
        return (0, _reactDefault.default).createElement("button", {
            className: `Toastify__close-button Toastify__close-button--${o}`,
            type: "button",
            onClick: (e)=>{
                e.stopPropagation(), n(e);
            },
            "aria-label": s
        }, (0, _reactDefault.default).createElement("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 14 16"
        }, (0, _reactDefault.default).createElement("path", {
            fillRule: "evenodd",
            d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
        })));
    }(Y)), (0, _reactDefault.default).createElement(h, {
        isIn: B,
        done: A,
        position: T,
        preventExitTransition: s,
        nodeRef: r,
        playToast: c
    }, (0, _reactDefault.default).createElement("div", {
        id: x,
        onClick: f,
        "data-in": B,
        className: H,
        ...i,
        style: b,
        ref: r
    }, (0, _reactDefault.default).createElement("div", {
        ...B && {
            role: k
        },
        className: u(I) ? I({
            type: g
        }) : (0, _clsxDefault.default)("Toastify__toast-body", I),
        style: _
    }, null != F && (0, _reactDefault.default).createElement("div", {
        className: (0, _clsxDefault.default)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !O
        })
    }, F), (0, _reactDefault.default).createElement("div", null, p)), q, (0, _reactDefault.default).createElement($, {
        ...w && !X ? {
            key: `pb-${w}`
        } : {},
        rtl: M,
        theme: R,
        delay: m,
        isRunning: o,
        isIn: B,
        closeToast: v,
        hide: y,
        type: g,
        style: L,
        className: C,
        controlledProgress: X,
        progress: P || 0
    })));
}, S = function(e, t) {
    return void 0 === t && (t = !1), {
        enter: `Toastify--animate Toastify__${e}-enter`,
        exit: `Toastify--animate Toastify__${e}-exit`,
        appendPosition: t
    };
}, H = g(S("bounce", !0)), F = g(S("slide", !0)), X = g(S("zoom")), Y = g(S("flip")), q = {
    position: "top-right",
    transition: H,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
function Q(t) {
    let o = {
        ...q,
        ...t
    };
    const s = t.stacked, [a, r] = (0, _react.useState)(!0), c = (0, _react.useRef)(null), { getToastToRender: d, isToastActive: m, count: f } = L(o), { className: g, style: y, rtl: v, containerId: h } = o;
    function T(e) {
        const t = (0, _clsxDefault.default)("Toastify__toast-container", `Toastify__toast-container--${e}`, {
            "Toastify__toast-container--rtl": v
        });
        return u(g) ? g({
            position: e,
            rtl: v,
            defaultClassName: t
        }) : (0, _clsxDefault.default)(t, p(g));
    }
    function E() {
        s && (r(!0), B.play());
    }
    return O(()=>{
        if (s) {
            var e;
            const t = c.current.querySelectorAll('[data-in="true"]'), n = 12, s = null == (e = o.position) ? void 0 : e.includes("top");
            let r = 0, i = 0;
            Array.from(t).reverse().forEach((e, t)=>{
                const o = e;
                o.classList.add("Toastify__toast--stacked"), t > 0 && (o.dataset.collapsed = `${a}`), o.dataset.pos || (o.dataset.pos = s ? "top" : "bot");
                const l = r * (a ? .2 : 1) + (a ? 0 : n * t);
                o.style.setProperty("--y", `${s ? l : -1 * l}px`), o.style.setProperty("--g", `${n}`), o.style.setProperty("--s", "" + (1 - (a ? i : 0))), r += o.offsetHeight, i += .025;
            });
        }
    }, [
        a,
        f,
        s
    ]), (0, _reactDefault.default).createElement("div", {
        ref: c,
        className: "Toastify",
        id: h,
        onMouseEnter: ()=>{
            s && (r(!1), B.pause());
        },
        onMouseLeave: E
    }, d((t, n)=>{
        const o = n.length ? {
            ...y
        } : {
            ...y,
            pointerEvents: "none"
        };
        return (0, _reactDefault.default).createElement("div", {
            className: T(t),
            style: o,
            key: `container-${t}`
        }, n.map((t)=>{
            let { content: n, props: o } = t;
            return (0, _reactDefault.default).createElement(R, {
                ...o,
                stacked: s,
                collapseAll: E,
                isIn: m(o.toastId, o.containerId),
                style: o.style,
                key: `toast-${o.key}`
            }, n);
        }));
    }));
}

},{"react":"9njXz","clsx":"d2NWs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d2NWs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fVQav":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SaveFormAsDialog", ()=>SaveFormAsDialog);
parcelHelpers.export(exports, "default", ()=>useSaveFormAsAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormApi = require("@form-engine/builder-application/hooks/use-form-api");
var _useFormApiDefault = parcelHelpers.interopDefault(_useFormApi);
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _reactToastify = require("react-toastify");
var _useApp = require("@form-engine/builder-application/hooks/use-app");
var _useMounted = require("@form-engine/core-application/hooks/use-mounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _reactBootstrap = require("react-bootstrap");
var _reactRouterDom = require("react-router-dom");
var _builderApplication = require("@form-engine/builder-application");
var _modal = require("@form-engine/builder-application/components/modal");
var _dialog = require("@form-engine/builder-application/components/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
function SaveFormAsDialog({ title = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
    id: "form-editor.saveFormAsDialog.title"
}), onSuccess, onError, state, ...props }) {
    const { create } = (0, _useFormApiDefault.default)();
    const mounted = (0, _useMountedDefault.default)();
    const handleSubmit = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        const data = new FormData(e.target);
        const name = data.get('name')?.trim();
        const copy = {
            ...state,
            name
        };
        delete copy.id;
        const toastId = (0, _reactToastify.toast)(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: "Saving..."
        }));
        create(copy).then((duplicate)=>{
            if (!mounted.current) return;
            onSuccess && onSuccess(duplicate);
            (0, _reactToastify.toast).update(toastId, {
                render: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.CheckCircleFill), {
                            className: "me-2"
                        }),
                        ' ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                            id: "form-editor.saveFormAsDialog.successToast"
                        })
                    ]
                })
            });
        }, onError);
    }, [
        state,
        onSuccess,
        onError
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.BuilderFormModal), {
        ...props,
        onSubmit: handleSubmit,
        title: title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
            placeholder: (0, _builderApplication.i18n).c('form-editor.saveFormAsDialog.namePlaceholder'),
            name: "name",
            defaultValue: `${state?.name} Copy`
        })
    });
}
function useSaveFormAsAction() {
    const { state } = (0, _useForm.useFormContext)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { toggle: toggleTab } = (0, _useApp.useAppTabs)();
    return (0, _react.useCallback)(async ()=>{
        let duplicate;
        try {
            duplicate = await (0, _dialogDefault.default)({
                as: SaveFormAsDialog,
                state
            });
        } catch (e) {
            console.error(e);
            return;
        }
        if (duplicate && duplicate?.id) {
            const { id, name } = duplicate;
            const path = `/forms/${id}`;
            toggleTab({
                id,
                name,
                path
            }, true);
            navigate(path);
        }
    }, [
        state,
        navigate,
        toggleTab
    ]);
}
const ACTION_NAME = 'formEditor.form.saveAs';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+shift+s,meta+shift+s');
const useAction = useSaveFormAsAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction());
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-application/hooks/use-form-api":"3uteJ","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","react-bootstrap-icons":"3TzoC","react-toastify":"iWdY7","@form-engine/builder-application/hooks/use-app":"8Rocb","@form-engine/core-application/hooks/use-mounted":"kHM7H","react-bootstrap":"f5rnA","react-router-dom":"cgBkD","@form-engine/builder-application":"7iKr0","@form-engine/builder-application/components/modal":"fvHxn","@form-engine/builder-application/components/dialog":"e4X5a","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fvHxn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderModal);
parcelHelpers.export(exports, "BuilderConfirmModal", ()=>BuilderConfirmModal);
parcelHelpers.export(exports, "BuilderFormModal", ()=>BuilderFormModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _spinnerBoundary = require("../spinner-boundary");
var _spinnerBoundaryDefault = parcelHelpers.interopDefault(_spinnerBoundary);
var _ = require("../..");
function BuilderModal({ as: Component = (0, _reactBootstrap.Modal), title = null, wrap, children, size = 'sm', footer = null, dialogClassName = 'feb', loading = false, ...props }) {
    const bordered = 'bordered' in props && props.bordered !== false;
    delete props.bordered;
    delete props.onSuccess;
    delete props.onError;
    const modalContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Modal).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Modal).Title, {
                    as: "h6",
                    children: title
                })
            }),
            children && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Modal).Body, {
                children: children
            }),
            footer && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Modal).Footer, {
                children: footer
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        backdrop: "static",
        size: size,
        dialogClassName: dialogClassName,
        ...props,
        className: `feb-modal ${bordered ? 'bordered' : ''} ${loading ? 'loading' : ''} ${props.className || ''}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerBoundaryDefault.default), {
            show: loading,
            children: wrap ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(wrap.type, {
                ...wrap?.props ?? {},
                children: modalContent
            }) : modalContent
        })
    });
}
function BuilderConfirmModal(props) {
    const { as: Component = BuilderModal, confirm = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
        size: "sm",
        variant: "primary",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.i18n).Node, {
            id: "modal.confirm.ok"
        })
    }), abort = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
        size: "sm",
        variant: "outline-secondary",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.i18n).Node, {
            id: "modal.confirm.cancel"
        })
    }), onConfirm, onHide, appendFooter, prependFooter, disabled, ...restProps } = props;
    const { type: Confirm, props: confirmProps } = confirm;
    const { type: Abort, props: abortProps } = abort;
    const footer = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            prependFooter,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Abort, {
                ...abortProps,
                onClick: onHide
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Confirm, {
                ...confirmProps,
                disabled: disabled,
                onClick: ()=>onConfirm?.(props)
            }),
            appendFooter
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        footer: footer,
        ...restProps,
        onHide: onHide
    });
}
function BuilderFormModal({ confirm = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
    size: "sm",
    variant: "primary",
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.i18n).Node, {
        id: "modal.form.submit"
    })
}), formProps = {}, ...props }) {
    const formSubmit = {
        ...confirm,
        props: {
            ...typeof confirm.props === 'object' ? confirm.props : {},
            onClick: null,
            type: 'submit'
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderConfirmModal, {
        ...props,
        confirm: formSubmit,
        wrap: /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
            ...formProps ?? {}
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","../spinner-boundary":"eYtmG","../..":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e4X5a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DialogContainer", ()=>DialogContainer);
parcelHelpers.export(exports, "default", ()=>dialog);
parcelHelpers.export(exports, "confirm", ()=>confirm);
parcelHelpers.export(exports, "formDialog", ()=>formDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _uuid = require("@form-engine/core-util/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modal = require("../modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _emitter = require("@form-engine/core-util/emitter");
const dialogs = {};
const emitter = (0, _emitter.createEmitter)();
function DialogContainer() {
    const [children, setChildren] = (0, _react.useState)();
    (0, _react.useEffect)(()=>{
        let mounted = true;
        const listener = (id, child)=>{
            if (!mounted) return;
            const copy = {
                ...children
            };
            if (!child) delete copy[id];
            else copy[id] = child;
            setChildren(copy);
        };
        emitter.subscribe(listener);
        return ()=>{
            emitter.unsubscribe(listener);
            mounted = false;
        };
    }, [
        children,
        setChildren
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
        children: Object.entries(children).map(([key, child])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                children: child
            }, key))
    });
}
function Dialog({ as: Component = (0, _modalDefault.default), onSuccess, onError, children, ...innerProps }) {
    const [show, setShow] = (0, _react.useState)(true);
    const [result, setResult] = (0, _react.useState)();
    const [error, setError] = (0, _react.useState)();
    const handleExited = (0, _react.useCallback)(()=>{
        if (error) onError && onError(error);
        else onSuccess && onSuccess(result);
    }, [
        result,
        error,
        onSuccess,
        onError
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...innerProps,
        show: show,
        onSuccess: (result)=>{
            setResult(result);
            setShow(false);
        },
        onError: (error)=>{
            setError(error);
            setShow(false);
        },
        onHide: ()=>setShow(false),
        onExited: handleExited,
        children: children
    });
}
function dialog(props = {}) {
    const id = (0, _uuidDefault.default)();
    dialogs[id] = {
        props: {
            ...props
        },
        id
    };
    const promise = new Promise((resolve, reject)=>{
        emitter.emit(id, /*#__PURE__*/ (0, _jsxRuntime.jsx)(Dialog, {
            ...dialogs[id].props,
            onSuccess: resolve,
            onError: reject
        }));
    });
    dialogs[id].promise = promise;
    function destroy() {
        emitter.emit(id, null);
        delete dialogs[id];
    }
    promise.then(destroy, destroy);
    return promise;
}
async function confirm(props = {}) {
    const result = await dialog({
        as: (0, _modal.BuilderConfirmModal),
        ...props,
        onConfirm: (props)=>props?.onSuccess?.(true)
    });
    return Boolean(result);
}
function formDialog(props = {}) {
    return dialog({
        as: (0, _modal.BuilderFormModal),
        ...props
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-util/uuid":"eZttN","react":"9njXz","../modal":"fvHxn","@form-engine/core-util/emitter":"9G5Og","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aYKut":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RenameFormDialog", ()=>RenameFormDialog);
parcelHelpers.export(exports, "default", ()=>useRenameFormAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _reactBootstrap = require("react-bootstrap");
var _modal = require("@form-engine/builder-application/components/modal");
var _dialog = require("@form-engine/builder-application/components/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _builderApplication = require("@form-engine/builder-application");
function RenameFormDialog({ title = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
    id: "form-editor.renameFormDialog.title"
}), value = '', onSuccess, ...props }) {
    const handleSubmit = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        const data = new FormData(e.target);
        const name = data?.get('name')?.trim();
        onSuccess && onSuccess(name);
    }, [
        onSuccess
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.BuilderFormModal), {
        ...props,
        onSubmit: handleSubmit,
        title: title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
            placeholder: (0, _builderApplication.i18n).c('form-editor.renameFormDialog.namePlaceholder'),
            name: "name",
            defaultValue: value
        })
    });
}
function useRenameFormAction() {
    const { state, setItem } = (0, _useForm.useFormContext)();
    return (0, _react.useCallback)(async ()=>{
        let name;
        try {
            name = await (0, _dialogDefault.default)({
                as: RenameFormDialog,
                value: state?.name || ''
            });
        } catch (e) {
            console.error(e);
            return;
        }
        if (typeof name === 'string') setItem('name', name);
    }, [
        state,
        setItem
    ]);
}
const ACTION_NAME = 'formEditor.form.rename';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+alt+r,meta+alt+r');
const useAction = useRenameFormAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction());
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","react-bootstrap":"f5rnA","@form-engine/builder-application/components/modal":"fvHxn","@form-engine/builder-application/components/dialog":"e4X5a","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4QoBS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDeleteFormAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormApi = require("@form-engine/builder-application/hooks/use-form-api");
var _useFormApiDefault = parcelHelpers.interopDefault(_useFormApi);
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _reactToastify = require("react-toastify");
var _useApp = require("@form-engine/builder-application/hooks/use-app");
var _useMounted = require("@form-engine/core-application/hooks/use-mounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _reactRouterDom = require("react-router-dom");
var _modal = require("@form-engine/builder-application/components/modal");
var _dialog = require("@form-engine/builder-application/components/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _builderApplication = require("@form-engine/builder-application");
function DeleteFormDialog({ state, onSuccess, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.BuilderConfirmModal), {
        ...props,
        onConfirm: ()=>onSuccess && onSuccess(true),
        onHide: ()=>onSuccess && onSuccess(false),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
            id: "form-editor.deleteFormDialog.message",
            name: state?.name
        })
    });
}
function useDeleteFormAction() {
    const { state } = (0, _useForm.useFormContext)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { toggle: toggleTab } = (0, _useApp.useAppTabs)();
    const { delete: deleteForm } = (0, _useFormApiDefault.default)();
    const mounted = (0, _useMountedDefault.default)();
    return (0, _react.useCallback)(async ()=>{
        if (!state?.id) return;
        let confirm = false;
        try {
            confirm = await (0, _dialogDefault.default)({
                as: DeleteFormDialog,
                state
            });
        } catch (e) {
            console.error(e);
            return;
        }
        if (confirm) {
            const toastId = (0, _reactToastify.toast)((0, _builderApplication.i18n).c('form-editor.deleteFormDialog.busyToast', {
                name: state?.name
            }));
            toggleTab({
                id: state.id
            }, false);
            deleteForm(state.id).then(()=>{
                (0, _reactToastify.toast).update(toastId, {
                    render: (0, _builderApplication.i18n).c('form-editor.deleteFormDialog.doneToast', {
                        name: state?.name
                    })
                });
                if (mounted.current) navigate('/');
            });
        }
    }, [
        state,
        navigate,
        toggleTab,
        deleteForm
    ]);
}
const ACTION_NAME = 'formEditor.form.delete';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+alt+backspace,meta+alt+backspace');
const useAction = useDeleteFormAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction());
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-application/hooks/use-form-api":"3uteJ","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","react-toastify":"iWdY7","@form-engine/builder-application/hooks/use-app":"8Rocb","@form-engine/core-application/hooks/use-mounted":"kHM7H","react-router-dom":"cgBkD","@form-engine/builder-application/components/modal":"fvHxn","@form-engine/builder-application/components/dialog":"e4X5a","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kYfXH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTogglePublishFormAction", ()=>useTogglePublishFormAction);
parcelHelpers.export(exports, "default", ()=>usePublishFormAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormApi = require("@form-engine/builder-application/hooks/use-form-api");
var _useFormApiDefault = parcelHelpers.interopDefault(_useFormApi);
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _reactToastify = require("react-toastify");
var _useMounted = require("@form-engine/core-application/hooks/use-mounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
function useTogglePublishFormAction(force) {
    const { state: form, setItem } = (0, _useForm.useFormContext)();
    const { update } = (0, _useFormApiDefault.default)();
    const mounted = (0, _useMountedDefault.default)();
    return (0, _react.useCallback)(()=>{
        let published = !form.published;
        if (force !== undefined) published = Boolean(force);
        const toastId = (0, _reactToastify.toast)(published ? 'publishing...' : 'unpublishing...');
        update({
            ...form,
            published
        }).then((result)=>{
            if (!mounted) return;
            setItem('published', result.published);
            (0, _reactToastify.toast).update(toastId, {
                render: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.CheckCircleFill), {
                            className: "me-2"
                        }),
                        ' ',
                        result.published ? 'Form published' : 'Form unpublished'
                    ]
                })
            });
        });
    }, [
        update,
        form,
        (0, _reactToastify.toast),
        setItem,
        force
    ]);
}
function usePublishFormAction() {
    return useTogglePublishFormAction(true);
}
const ACTION_NAME = 'formEditor.form.publish';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+alt+p,meta+alt+p');
const useAction = usePublishFormAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction());
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-application/hooks/use-form-api":"3uteJ","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","react-bootstrap-icons":"3TzoC","react-toastify":"iWdY7","@form-engine/core-application/hooks/use-mounted":"kHM7H","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8LE00":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useExportFormAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _react = require("react");
var _coreApplication = require("@form-engine/core-application");
var _coreApplicationDefault = parcelHelpers.interopDefault(_coreApplication);
var _saveFile = require("@form-engine/builder-application/utilities/save-file");
var _saveFileDefault = parcelHelpers.interopDefault(_saveFile);
function exportFormAsXfe(source, filename = 'export.xfe', type = 'application/x-xfe') {
    (0, _saveFileDefault.default)(JSON.stringify(source, undefined, 2), filename, type);
}
function useExportFormAction() {
    const { state } = (0, _useForm.useFormContext)();
    return (0, _react.useCallback)(async ()=>{
        exportFormAsXfe({
            ...state,
            engineVersion: (0, _coreApplicationDefault.default).version
        }, `${state.name || 'untitled'}.xfe`);
    }, [
        state
    ]);
}
const ACTION_NAME = 'formEditor.form.export';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+alt+e,meta+alt+e');
const useAction = useExportFormAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction());
}

},{"../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","react":"9njXz","@form-engine/core-application":"fjN6J","@form-engine/builder-application/utilities/save-file":"1vzaN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1vzaN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>saveFile);
function saveFile(source, filename = 'export.txt', type = 'text/plain') {
    const data = new Blob([
        source
    ], {
        type
    });
    const toggle = document.createElement('a');
    toggle.download = filename;
    toggle.href = URL.createObjectURL(data);
    toggle.click();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gk7K2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUnpublishFormAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _publishForm = require("./publish-form");
function useUnpublishFormAction() {
    return (0, _publishForm.useTogglePublishFormAction)(false);
}
const ACTION_NAME = 'formEditor.form.unpublish';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+alt+u,meta+alt+u');
const useAction = useUnpublishFormAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction());
}

},{"../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","./publish-form":"kYfXH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ae5rk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmbedFormDialog", ()=>EmbedFormDialog);
parcelHelpers.export(exports, "default", ()=>useEmbedFormAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _modal = require("@form-engine/builder-application/components/modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _dialog = require("@form-engine/builder-application/components/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _formEmbedListing = require("../components/form-embed-listing");
var _formEmbedListingDefault = parcelHelpers.interopDefault(_formEmbedListing);
var _builderApplication = require("@form-engine/builder-application");
function EmbedFormDialog({ title = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
    id: "form-editor.formEmbedDialog.title"
}), state, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
        size: "lg",
        ...props,
        title: title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formEmbedListingDefault.default), {
            form: state
        })
    });
}
function useEmbedFormAction() {
    const { state } = (0, _useForm.useFormContext)();
    return (0, _react.useCallback)(async ()=>{
        try {
            await (0, _dialogDefault.default)({
                as: EmbedFormDialog,
                state
            });
        } catch (e) {
            console.error(e);
            return;
        }
    }, [
        state
    ]);
}
const ACTION_NAME = 'formEditor.form.embed';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+shift+e,meta+shift+e');
const useAction = useEmbedFormAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction());
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/builder-application/components/modal":"fvHxn","@form-engine/builder-application/components/dialog":"e4X5a","../components/form-embed-listing":"4IzwP","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4IzwP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderFormEmbedList", ()=>BuilderFormEmbedList);
parcelHelpers.export(exports, "default", ()=>BuilderFormEmbedListing);
var _jsxRuntime = require("react/jsx-runtime");
var _card = require("@form-engine/builder-application/components/card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _builderIconButton = require("@form-engine/builder-icon-button");
var _builderIconButtonDefault = parcelHelpers.interopDefault(_builderIconButton);
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
function BuilderFormEmbedList({ types = [], onSelect }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
        children: types.map(([key, def])=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                md: 6,
                lg: 4,
                xl: 4,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                    as: "button",
                    onClick: ()=>{
                        onSelect && onSelect(key);
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Card).Body, {
                        className: "row d-flex",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Title, {
                                        className: "text-xs",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                                            id: def.label
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Text, {
                                        className: "text-xs text-black-50",
                                        children: def.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                                            id: def.description
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                                xs: 2,
                                className: "align-self-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(def.Icon, {})
                            })
                        ]
                    })
                })
            }, key);
        })
    });
}
function BuilderFormEmbedListing({ form }) {
    const types = (0, _react.useMemo)(()=>Object.entries((0, _builderApplicationDefault.default).formEmbeds || {}), []);
    const [selected, setSelected] = (0, _react.useState)(null);
    const Mask = (0, _react.useMemo)(()=>{
        if (!selected) return null;
        return (0, _builderApplicationDefault.default).formEmbeds?.[selected]?.Mask;
    }, [
        selected
    ]);
    const maskApi = (0, _react.useMemo)(// eslint-disable-next-line @typescript-eslint/no-empty-function
    ()=>({
            state: form,
            setItem: ()=>{},
            setItemProperty: ()=>{}
        }), [
        form
    ]);
    if (!selected) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormEmbedList, {
        types: types,
        onSelect: setSelected
    });
    if (!Mask) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderIconButtonDefault.default), {
                    onClick: ()=>setSelected(null),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ArrowLeftCircleFill), {})
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useMask.MaskProvider), {
                value: maskApi,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Mask, {
                    form: form
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-application/components/card":"bbNfc","react":"9njXz","react-bootstrap":"f5rnA","react-bootstrap-icons":"3TzoC","@form-engine/builder-icon-button":"1BXFC","@form-engine/builder-application":"7iKr0","@form-engine/builder-mask/hooks/use-mask":"72MTY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bbNfc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
function BuilderCard({ className = '', ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card), {
        ...props,
        className: `${className} feb-card`
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bWpKb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUndoAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useFormHistory = require("../hooks/use-form-history");
var _useFormHistoryDefault = parcelHelpers.interopDefault(_useFormHistory);
function useUndoAction() {
    return (0, _useFormHistoryDefault.default)().undo;
}
const ACTION_NAME = 'formEditor.form.undo';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+z,meta+z');
const useAction = useUndoAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction());
}

},{"../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","../hooks/use-form-history":"1RTRx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"48iuV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useRedoAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useFormHistory = require("../hooks/use-form-history");
var _useFormHistoryDefault = parcelHelpers.interopDefault(_useFormHistory);
function useRedoAction() {
    return (0, _useFormHistoryDefault.default)().redo;
}
const ACTION_NAME = 'formEditor.form.redo';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+shift+z,meta+shift+z');
const useAction = useRedoAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction());
}

},{"../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","../hooks/use-form-history":"1RTRx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5MSv0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormVersionHistoryDialog", ()=>FormVersionHistoryDialog);
parcelHelpers.export(exports, "default", ()=>useFormVersionAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _modal = require("@form-engine/builder-application/components/modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _dialog = require("@form-engine/builder-application/components/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _formVersionHistory = require("../components/form-version-history");
var _formVersionHistoryDefault = parcelHelpers.interopDefault(_formVersionHistory);
var _builderApplication = require("@form-engine/builder-application");
function FormVersionHistoryDialog({ title = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
    id: "form-editor.formVersionHistoryDialog.title"
}), formStore, onSuccess, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
        size: "xl",
        ...props,
        title: title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formVersionHistoryDefault.default), {
            formStore: formStore,
            onActionComplete: onSuccess
        })
    });
}
function useFormVersionAction() {
    const storeReference = (0, _useForm.useFormContext)();
    return (0, _react.useCallback)(async ()=>{
        try {
            await (0, _dialogDefault.default)({
                as: FormVersionHistoryDialog,
                formStore: storeReference
            });
        } catch (e) {
            console.error(e);
            return;
        }
    }, [
        storeReference
    ]);
}
const ACTION_NAME = 'formEditor.form.versionHistory';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+h,meta+shift+h');
const useAction = useFormVersionAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction());
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/builder-application/components/modal":"fvHxn","@form-engine/builder-application/components/dialog":"e4X5a","../components/form-version-history":"aFNWJ","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aFNWJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderFormVersionHistory);
parcelHelpers.export(exports, "FormVersionItem", ()=>FormVersionItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _spinnerBoundary = require("@form-engine/builder-application/components/spinner-boundary");
var _spinnerBoundaryDefault = parcelHelpers.interopDefault(_spinnerBoundary);
var _reactBootstrap = require("react-bootstrap");
var _day = require("@form-engine/core-util/day");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _builderIconButton = require("@form-engine/builder-icon-button");
var _builderIconButtonDefault = parcelHelpers.interopDefault(_builderIconButton);
var _versionDiffs = require("./version-diffs");
var _versionDiffsDefault = parcelHelpers.interopDefault(_versionDiffs);
var _useFormVersionHistory = require("./use-form-version-history");
var _useFormVersionHistoryDefault = parcelHelpers.interopDefault(_useFormVersionHistory);
var _useRevertToVersionDialog = require("./use-revert-to-version-dialog");
var _useRevertToVersionDialogDefault = parcelHelpers.interopDefault(_useRevertToVersionDialog);
var _useDuplicateFromVersionDialog = require("./use-duplicate-from-version-dialog");
var _useDuplicateFromVersionDialogDefault = parcelHelpers.interopDefault(_useDuplicateFromVersionDialog);
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _builderApplication = require("@form-engine/builder-application");
function BuilderFormVersionHistory({ formStore, onActionComplete }) {
    if (!formStore?.state?.id) throw new Error('invalid form');
    const { state = [], loading } = (0, _useFormVersionHistoryDefault.default)(formStore?.state?.id);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useForm.FormStoreReferenceProvider), {
        value: formStore,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerBoundaryDefault.default), {
            show: loading,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.ListGroup), {
                children: state.map((version)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(FormVersionItem, {
                        version: version,
                        onActionComplete: onActionComplete
                    }, version.id))
            })
        })
    });
}
function FormVersionItem({ version, onActionComplete }) {
    const spawnRevertDialog = (0, _useRevertToVersionDialogDefault.default)();
    const handleRevert = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!version?.id) return;
        spawnRevertDialog(version.id).then(()=>{
            onActionComplete?.('revert');
        });
    }, [
        onActionComplete,
        spawnRevertDialog,
        version?.id
    ]);
    const spawnDuplicateDialog = (0, _useDuplicateFromVersionDialogDefault.default)();
    const handleDuplicate = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!version?.id) return;
        spawnDuplicateDialog(version.id).then(()=>{
            onActionComplete?.('duplicate');
        });
    }, [
        onActionComplete,
        spawnDuplicateDialog,
        version?.id
    ]);
    const createdAt = new Date(version.createdAt ?? '');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.ListGroup).Item, {
        className: "d-flex justify-content-between align-items-start",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "ms-2 flex-grow-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h6", {
                        className: "mb-2 mt-1 fw-bold",
                        children: [
                            (0, _day.formatDistanceToNow)(createdAt, false),
                            ', ',
                            (0, _day.formatDateTime)(createdAt)
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _versionDiffsDefault.default), {
                        diffs: version.versioningDiff
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderIconButtonDefault.default), {
                title: (0, _builderApplication.i18n).c('form-editor.formVersionHistory.revert'),
                color: "primary",
                onClick: handleRevert,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ArrowCounterclockwise), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderIconButtonDefault.default), {
                title: (0, _builderApplication.i18n).c('form-editor.formVersionHistory.duplicate'),
                color: "primary",
                onClick: handleDuplicate,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.FilePlus), {})
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-application/components/spinner-boundary":"eYtmG","react-bootstrap":"f5rnA","@form-engine/core-util/day":"fgtKF","react-bootstrap-icons":"3TzoC","@form-engine/builder-icon-button":"1BXFC","./version-diffs":"e8cXQ","./use-form-version-history":"fcpsX","./use-revert-to-version-dialog":"fhe20","./use-duplicate-from-version-dialog":"fL3Yu","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e8cXQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderFormVersionDiffs);
parcelHelpers.export(exports, "BuilderFormVersionDiff", ()=>BuilderFormVersionDiff);
parcelHelpers.export(exports, "BuilderFormVersionDiffArray", ()=>BuilderFormVersionDiffArray);
parcelHelpers.export(exports, "BuilderFormVersionDiffDeleted", ()=>BuilderFormVersionDiffDeleted);
parcelHelpers.export(exports, "BuilderFormVersionDiffNew", ()=>BuilderFormVersionDiffNew);
parcelHelpers.export(exports, "BuilderFormVersionDiffEdit", ()=>BuilderFormVersionDiffEdit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _startCase = require("lodash/startCase");
var _startCaseDefault = parcelHelpers.interopDefault(_startCase);
function BuilderFormVersionDiffs({ diffs = [] }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("ol", {
        children: diffs.map((diff, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormVersionDiff, {
                    diff: diff
                })
            }, index))
    });
}
function pathSegmentToHuman(segment) {
    if (typeof segment === 'number') return `#${segment}`;
    return (0, _startCaseDefault.default)(segment);
}
function pathToHuman(path, seperator = ' / ') {
    return path.map(pathSegmentToHuman).join(seperator);
}
function DiffText({ children, color = 'body' }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: `feb-diff-text text-${color}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: children
        })
    });
}
function BuilderFormVersionDiff({ diff }) {
    switch(diff.kind){
        case 'A':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormVersionDiffArray, {
                diff: diff
            });
        case 'D':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormVersionDiffDeleted, {
                diff: diff
            });
        case 'N':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormVersionDiffNew, {
                diff: diff
            });
        case 'E':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormVersionDiffEdit, {
                diff: diff
            });
        default:
            return null;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function parseDiffLabel(target) {
    if (target && typeof target === 'object') {
        if (typeof target.name === 'string') return target.name;
        if (typeof target.label === 'string') return target.label;
        if (typeof target.title === 'string') return target.title;
        return 'Object';
    }
    return String(target);
}
function BuilderFormVersionDiffArray({ diff }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            diff.path && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                className: "mb-2",
                children: pathToHuman([
                    ...diff.path,
                    diff.index
                ])
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormVersionDiff, {
                diff: diff.item
            })
        ]
    });
}
function BuilderFormVersionDiffDeleted({ diff }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            diff.path && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                className: "mb-2",
                children: pathToHuman(diff.path)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "d-flex flex-row mb-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.DashCircleFill), {
                        className: "text-danger me-2"
                    }),
                    ' ',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DiffText, {
                        children: parseDiffLabel(diff.lhs)
                    })
                ]
            })
        ]
    });
}
function BuilderFormVersionDiffNew({ diff }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            diff.path && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                className: "mb-2",
                children: pathToHuman(diff.path)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "d-flex flex-row mb-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.PlusCircleFill), {
                        className: "text-success me-2"
                    }),
                    ' ',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DiffText, {
                        children: parseDiffLabel(diff.rhs)
                    })
                ]
            })
        ]
    });
}
function BuilderFormVersionDiffEdit({ diff }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            diff.path && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                className: "mb-2",
                children: pathToHuman(diff.path)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "d-flex flex-row mb-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.Shuffle), {
                        className: "text-info me-2"
                    }),
                    ' ',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DiffText, {
                        children: parseDiffLabel(diff.lhs)
                    }),
                    ' ',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ArrowRight), {
                        className: "ms-2 me-2"
                    }),
                    ' ',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DiffText, {
                        children: parseDiffLabel(diff.rhs)
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap-icons":"3TzoC","lodash/startCase":"dymi1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dymi1":[function(require,module,exports,__globalThis) {
var createCompounder = require("f10c909a79ea4596"), upperFirst = require("2ac04918aee4665e");
/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */ var startCase = createCompounder(function(result, word, index) {
    return result + (index ? ' ' : '') + upperFirst(word);
});
module.exports = startCase;

},{"f10c909a79ea4596":"5MHyu","2ac04918aee4665e":"eSJZa"}],"5MHyu":[function(require,module,exports,__globalThis) {
var arrayReduce = require("cfc95c8ee08dfd6b"), deburr = require("b60ce6efa81a3cef"), words = require("40ddea9252aefad9");
/** Used to compose unicode capture groups. */ var rsApos = "['\u2019]";
/** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function createCompounder(callback) {
    return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
    };
}
module.exports = createCompounder;

},{"cfc95c8ee08dfd6b":"4xeZ0","b60ce6efa81a3cef":"a4Mc8","40ddea9252aefad9":"hIF8c"}],"4xeZ0":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = arrayReduce;

},{}],"a4Mc8":[function(require,module,exports,__globalThis) {
var deburrLetter = require("86c70dfa448b37ae"), toString = require("f68583105b85d455");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var rsCombo = '[' + rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var reComboMark = RegExp(rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function deburr(string) {
    string = toString(string);
    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}
module.exports = deburr;

},{"86c70dfa448b37ae":"ksfAW","f68583105b85d455":"iEDGT"}],"ksfAW":[function(require,module,exports,__globalThis) {
var basePropertyOf = require("c95029d8b26d3cfc");
/** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var deburrLetter = basePropertyOf(deburredLetters);
module.exports = deburrLetter;

},{"c95029d8b26d3cfc":"3tNBT"}],"3tNBT":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = basePropertyOf;

},{}],"hIF8c":[function(require,module,exports,__globalThis) {
var asciiWords = require("14a2bcc60f9c8c58"), hasUnicodeWord = require("12a5a56673332993"), toString = require("efbc56b55844c665"), unicodeWords = require("e27193a0a134859e");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function words(string, pattern, guard) {
    string = toString(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
    return string.match(pattern) || [];
}
module.exports = words;

},{"14a2bcc60f9c8c58":"djvHm","12a5a56673332993":"dETNW","efbc56b55844c665":"iEDGT","e27193a0a134859e":"2wgLs"}],"djvHm":[function(require,module,exports,__globalThis) {
/** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function asciiWords(string) {
    return string.match(reAsciiWord) || [];
}
module.exports = asciiWords;

},{}],"dETNW":[function(require,module,exports,__globalThis) {
/** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
}
module.exports = hasUnicodeWord;

},{}],"2wgLs":[function(require,module,exports,__globalThis) {
/** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
/** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
    rsDingbat,
    rsRegional,
    rsSurrPair
].join('|') + ')' + rsSeq;
/** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
        rsBreak,
        rsUpper,
        '$'
    ].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
        rsBreak,
        rsUpper + rsMiscLower,
        '$'
    ].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
}
module.exports = unicodeWords;

},{}],"eSJZa":[function(require,module,exports,__globalThis) {
var createCaseFirst = require("9f71ec962d19127");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var upperFirst = createCaseFirst('toUpperCase');
module.exports = upperFirst;

},{"9f71ec962d19127":"7uzpn"}],"7uzpn":[function(require,module,exports,__globalThis) {
var castSlice = require("6cc0e53be1623a5f"), hasUnicode = require("e28707473345265"), stringToArray = require("32980b84821a53a0"), toString = require("e00796f8e204e98");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function createCaseFirst(methodName) {
    return function(string) {
        string = toString(string);
        var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = createCaseFirst;

},{"6cc0e53be1623a5f":"dqkKJ","e28707473345265":"6LhZ8","32980b84821a53a0":"e34IY","e00796f8e204e98":"iEDGT"}],"dqkKJ":[function(require,module,exports,__globalThis) {
var baseSlice = require("19fbc2ab8fa927cd");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
}
module.exports = castSlice;

},{"19fbc2ab8fa927cd":"7H7oa"}],"7H7oa":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = baseSlice;

},{}],"6LhZ8":[function(require,module,exports,__globalThis) {
/** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function hasUnicode(string) {
    return reHasUnicode.test(string);
}
module.exports = hasUnicode;

},{}],"e34IY":[function(require,module,exports,__globalThis) {
var asciiToArray = require("55ec07d60faf873c"), hasUnicode = require("d3e31b390208b2ca"), unicodeToArray = require("2a468ebcd49732b9");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
module.exports = stringToArray;

},{"55ec07d60faf873c":"8IriL","d3e31b390208b2ca":"6LhZ8","2a468ebcd49732b9":"8eM3H"}],"8IriL":[function(require,module,exports,__globalThis) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function asciiToArray(string) {
    return string.split('');
}
module.exports = asciiToArray;

},{}],"8eM3H":[function(require,module,exports,__globalThis) {
/** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var rsAstral = '[' + rsAstralRange + ']', rsCombo = '[' + rsComboRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join('|') + ')' + rsOptVar + reOptMod + ')*', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = '(?:' + [
    rsNonAstral + rsCombo + '?',
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}
module.exports = unicodeToArray;

},{}],"fcpsX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useFormVersionHistory);
var _react = require("react");
var _useFormApi = require("@form-engine/builder-application/hooks/use-form-api");
var _useFormApiDefault = parcelHelpers.interopDefault(_useFormApi);
var _useApiModel = require("@form-engine/builder-application/hooks/use-api-model");
var _sorting = require("@form-engine/core-util/sorting");
const FORM_HISTORY_ATTRIBUTES = [
    'id',
    'version',
    'createdAt',
    'updatedAt',
    'versioningParentId',
    'versioningDiff'
];
function useFormVersionHistory(formId) {
    const listOptions = (0, _react.useMemo)(()=>{
        return {
            attributes: FORM_HISTORY_ATTRIBUTES,
            filter: {
                versioningParentId: formId
            },
            includeVersioningHistory: true
        };
    }, [
        formId
    ]);
    const list = (0, _useApiModel.useList)((0, _useFormApiDefault.default)(), listOptions);
    const state = (0, _react.useMemo)(()=>{
        return list?.state?.sort((0, _sorting.createObjectSort)('Date', 'createdAt', 'desc'));
    }, [
        list.state
    ]);
    return {
        ...list,
        state
    };
}

},{"react":"9njXz","@form-engine/builder-application/hooks/use-form-api":"3uteJ","@form-engine/builder-application/hooks/use-api-model":"fNNgP","@form-engine/core-util/sorting":"9tp3A","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9tp3A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createObjectSort", ()=>createObjectSort);
function createObjectSort(sortType, propertyName, order = 'asc') {
    if (sortType === 'String') return (a, b)=>{
        const comp = String(a?.[propertyName] ?? '').localeCompare(String(b?.[propertyName] ?? ''));
        return order === 'asc' ? comp : comp * -1;
    };
    else if (sortType === 'Number') return (a, b)=>{
        const numberA = Number(a?.[propertyName]);
        const numberB = Number(b?.[propertyName]);
        const comp = numberA - numberB;
        return order === 'asc' ? comp : comp * -1;
    };
    else if (sortType === 'Date') return (a, b)=>{
        const dateA = a?.[propertyName];
        const dateB = b?.[propertyName];
        const comp = Date.parse(String(dateA)) - Date.parse(String(dateB));
        return order === 'asc' ? comp : comp * -1;
    };
    else if (typeof sortType === 'function') return (a, b)=>{
        const valueA = a?.[propertyName];
        const valueB = b?.[propertyName];
        const comp = sortType(valueA, valueB);
        return order === 'asc' ? comp : comp * -1;
    };
    throw new Error(`unsupported sort type ${sortType}`);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fhe20":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RevertToVersionDialog", ()=>RevertToVersionDialog);
parcelHelpers.export(exports, "default", ()=>useRevertToVersionDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modal = require("@form-engine/builder-application/components/modal");
var _useFormApi = require("@form-engine/builder-application/hooks/use-form-api");
var _dialog = require("@form-engine/builder-application/components/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _reactRouterDom = require("react-router-dom");
var _useApp = require("@form-engine/builder-application/hooks/use-app");
var _useForm = require("@form-engine/core-application/hooks/use-form");
function RevertToVersionDialog({ title = 'Revert to previous version', onSuccess, onError, sourceFormId, targetFormId, ...props }) {
    const { state, loading } = (0, _useFormApi.useFormEntity)(sourceFormId);
    const handleConfirm = (0, _react.useCallback)(()=>{
        const copy = {
            ...state
        };
        delete copy.versioningParentId;
        delete copy.versioningDiff;
        copy.id = targetFormId;
        onSuccess?.(copy);
    }, [
        state,
        targetFormId,
        onSuccess,
        onError
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.BuilderConfirmModal), {
        ...props,
        loading: loading,
        onConfirm: handleConfirm,
        onHide: ()=>onError?.(new Error('aborted')),
        title: title,
        children: "Are you sure you want to revert this form its the previous version?"
    });
}
function useRevertToVersionDialog() {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { toggle: toggleTab } = (0, _useApp.useAppTabs)();
    const { state: { id }, set } = (0, _useForm.useFormContext)();
    return (0, _react.useCallback)(async (sourceFormId)=>{
        if (!id) throw new Error('invalid form id');
        let revertedFormState;
        try {
            revertedFormState = await (0, _dialogDefault.default)({
                as: RevertToVersionDialog,
                sourceFormId,
                targetFormId: id
            });
        } catch (e) {
            console.error(e);
            return;
        }
        set(revertedFormState);
    }, [
        set,
        id,
        navigate,
        toggleTab
    ]);
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-application/components/modal":"fvHxn","@form-engine/builder-application/hooks/use-form-api":"3uteJ","@form-engine/builder-application/components/dialog":"e4X5a","react-router-dom":"cgBkD","@form-engine/builder-application/hooks/use-app":"8Rocb","@form-engine/core-application/hooks/use-form":"5PZyy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fL3Yu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DuplicateFromVersionDialog", ()=>DuplicateFromVersionDialog);
parcelHelpers.export(exports, "default", ()=>useDuplicateFromVersionDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modal = require("@form-engine/builder-application/components/modal");
var _useFormApi = require("@form-engine/builder-application/hooks/use-form-api");
var _useFormApiDefault = parcelHelpers.interopDefault(_useFormApi);
var _useMounted = require("@form-engine/core-application/hooks/use-mounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _reactBootstrap = require("react-bootstrap");
var _dialog = require("@form-engine/builder-application/components/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _reactRouterDom = require("react-router-dom");
var _useApp = require("@form-engine/builder-application/hooks/use-app");
var _reactToastify = require("react-toastify");
var _spinnerBoundary = require("@form-engine/builder-application/components/spinner-boundary");
var _spinnerBoundaryDefault = parcelHelpers.interopDefault(_spinnerBoundary);
function DuplicateFromVersionDialog({ title = 'Duplicate version as new form', onSuccess, onError, sourceFormId, ...props }) {
    const { create } = (0, _useFormApiDefault.default)();
    const mounted = (0, _useMountedDefault.default)();
    const { state, loading } = (0, _useFormApi.useFormEntity)(sourceFormId);
    const handleSubmit = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        const data = new FormData(e.target);
        const name = data.get('name')?.trim();
        const copy = {
            ...state,
            name
        };
        delete copy.id;
        delete copy.versioningDiff;
        delete copy.versioningParentId;
        const toastId = (0, _reactToastify.toast)(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: "Saving..."
        }));
        create(copy).then((duplicate)=>{
            if (!mounted.current) return;
            onSuccess && onSuccess(duplicate);
            (0, _reactToastify.toast).update(toastId, {
                render: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.CheckCircleFill), {
                            className: "me-2"
                        }),
                        " Saved"
                    ]
                })
            });
        }, onError);
    }, [
        state,
        onSuccess,
        onError
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.BuilderFormModal), {
        ...props,
        onSubmit: handleSubmit,
        title: title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerBoundaryDefault.default), {
            show: loading,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
                placeholder: "Name",
                name: "name",
                defaultValue: `${state?.name} Copy`
            })
        })
    });
}
function useDuplicateFromVersionDialog() {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { toggle: toggleTab } = (0, _useApp.useAppTabs)();
    return (0, _react.useCallback)(async (sourceFormId)=>{
        let duplicate;
        try {
            duplicate = await (0, _dialogDefault.default)({
                as: DuplicateFromVersionDialog,
                sourceFormId
            });
        } catch (e) {
            console.error(e);
            return;
        }
        if (duplicate && duplicate?.id) {
            const { id, name } = duplicate;
            const path = `/forms/${id}`;
            toggleTab({
                id,
                name,
                path
            }, true);
            navigate(path);
        }
    }, [
        navigate,
        toggleTab
    ]);
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-application/components/modal":"fvHxn","@form-engine/builder-application/hooks/use-form-api":"3uteJ","@form-engine/core-application/hooks/use-mounted":"kHM7H","react-bootstrap-icons":"3TzoC","react-bootstrap":"f5rnA","@form-engine/builder-application/components/dialog":"e4X5a","react-router-dom":"cgBkD","@form-engine/builder-application/hooks/use-app":"8Rocb","react-toastify":"iWdY7","@form-engine/builder-application/components/spinner-boundary":"eYtmG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5oXec":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SavePresetDialog", ()=>SavePresetDialog);
parcelHelpers.export(exports, "default", ()=>useSavePresetAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _modal = require("@form-engine/builder-application/components/modal");
var _dialog = require("@form-engine/builder-application/components/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _builderApplication = require("@form-engine/builder-application");
var _useFormEditor = require("../hooks/use-form-editor");
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _useStore = require("@form-engine/core-application/hooks/use-store");
var _formPreset = require("../utilities/form-preset");
var _useFormPresetApi = require("@form-engine/builder-application/hooks/use-form-preset-api");
var _useFormPresetApiDefault = parcelHelpers.interopDefault(_useFormPresetApi);
var _mask = require("../components/form-preset-dialog/mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _zod = require("zod");
var _zodDefault = parcelHelpers.interopDefault(_zod);
var _schema = require("../components/form-preset-dialog/schema");
var _schemaDefault = parcelHelpers.interopDefault(_schema);
const schema = (0, _schemaDefault.default).omit({
    id: true
}).and((0, _zodDefault.default).object({
    id: (0, _zodDefault.default).string().default('')
}));
function useUpsertFormPreset() {
    const model = (0, _useFormPresetApiDefault.default)();
    return (0, _react.useCallback)(async (preset)=>{
        let prev;
        // if preset is not new, check if the server side still exists (otherwise treat this as new)
        if (preset?.id) prev = await model.retrieve(preset.id);
        else if (preset?.name) {
            [prev] = await model.list({
                filter: {
                    name: preset.name
                },
                attributes: [
                    'id'
                ],
                limit: 1,
                verbose: false
            });
            if (prev && !await (0, _dialog.confirm)({
                children: (0, _builderApplication.i18n).c('form-editor.savePresetDialog.confirmOverrideMessage', {
                    name: preset.name
                })
            })) return prev;
        }
        let result;
        if (prev?.id) result = await model.update(structuredClone({
            ...preset,
            id: prev?.id
        }));
        else {
            const dto = structuredClone(preset);
            delete dto.id;
            result = await model.create(dto);
        }
        return result;
    }, [
        model
    ]);
}
const defaultPreset = schema.parse({});
function SavePresetDialog({ title = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
    id: "form-editor.savePresetDialog.title"
}), form, selectedId, onSuccess, onError, ...props }) {
    const data = (0, _react.useMemo)(()=>{
        if (!form?.elements || !selectedId) return null;
        return (0, _formPreset.createPresetDataFromElement)(form, selectedId);
    }, [
        form,
        selectedId
    ]);
    const presetStore = (0, _useStore.useStore)(defaultPreset);
    (0, _react.useEffect)(()=>{
        if (data?.elements?.length && presetStore?.setItem) presetStore?.setItem('data', structuredClone(data));
    }, [
        presetStore?.setItem
    ]);
    const schemaError = (0, _react.useMemo)(()=>{
        const parseResult = schema.safeParse(presetStore?.state);
        if (parseResult.success) return null;
        return parseResult.error;
    }, [
        presetStore?.state
    ]);
    const upsert = useUpsertFormPreset();
    const handleSubmit = (0, _react.useCallback)(async ()=>{
        if (!presetStore?.state || schemaError) return;
        try {
            const result = await upsert(presetStore?.state);
            onSuccess?.(result);
        } catch (e) {
            onError?.(e);
        }
    }, [
        presetStore?.state,
        onSuccess,
        onError,
        upsert,
        schemaError
    ]);
    if (!presetStore) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.BuilderConfirmModal), {
        size: "lg",
        ...props,
        disabled: Boolean(schemaError),
        onConfirm: handleSubmit,
        title: title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useMask.StoreMaskProvider), {
            store: presetStore,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _maskDefault.default), {})
        })
    });
}
function useSavePresetAction() {
    const { state: form } = (0, _useForm.useFormContext)();
    const { state: editor } = (0, _useFormEditor.useFormEditorContext)();
    return (0, _react.useCallback)(async ()=>{
        try {
            // const preset =
            await (0, _dialogDefault.default)({
                as: SavePresetDialog,
                form,
                selectedId: editor?.selectedId
            });
            (0, _useFormPresetApi.refreshFormPresets)();
        } catch (e) {
            console.error(e);
            return;
        }
    }, [
        form,
        editor?.selectedId
    ]);
}
const ACTION_NAME = 'formEditor.selection.showPresetActions';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+p,meta+p');
const useAction = useSavePresetAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction());
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/builder-application/components/modal":"fvHxn","@form-engine/builder-application/components/dialog":"e4X5a","@form-engine/builder-application":"7iKr0","../hooks/use-form-editor":"4pkiD","@form-engine/builder-mask/hooks/use-mask":"72MTY","@form-engine/core-application/hooks/use-store":"llHXk","../utilities/form-preset":"UuTIr","@form-engine/builder-application/hooks/use-form-preset-api":"dgb87","../components/form-preset-dialog/mask":"3EUPl","zod":"lk66X","../components/form-preset-dialog/schema":"5AR5d","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dgb87":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useFormPresetApi);
parcelHelpers.export(exports, "useFormPresetEntity", ()=>useFormPresetEntity);
parcelHelpers.export(exports, "DEFAULT_FORM_PRESET_LIST_OPTIONS", ()=>DEFAULT_FORM_PRESET_LIST_OPTIONS);
parcelHelpers.export(exports, "refreshFormPresets", ()=>refreshFormPresets);
parcelHelpers.export(exports, "useFormPresetList", ()=>useFormPresetList);
var _useApiModel = require("./use-api-model");
var _useApiModelDefault = parcelHelpers.interopDefault(_useApiModel);
var _emitter = require("@form-engine/core-util/emitter");
function useFormPresetApi() {
    return (0, _useApiModelDefault.default)('form-preset');
}
function useFormPresetEntity(id) {
    return (0, _useApiModel.useEntity)(useFormPresetApi(), id);
}
const DEFAULT_FORM_PRESET_LIST_OPTIONS = {
    attributes: [
        'id',
        'name',
        'description',
        'updatedAt',
        'createdAt',
        'tags',
        'thumbnail',
        'data'
    ]
};
const emitter = (0, _emitter.createEmitter)();
const refreshFormPresets = emitter.emit;
function useFormPresetList(options = DEFAULT_FORM_PRESET_LIST_OPTIONS) {
    const list = (0, _useApiModel.useList)(useFormPresetApi(), options);
    (0, _emitter.useEmitter)(emitter, list.refresh);
    return list;
}

},{"./use-api-model":"fNNgP","@form-engine/core-util/emitter":"9G5Og","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3EUPl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderFormPresetMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _reactBootstrap = require("react-bootstrap");
var _formPresetPreview = require("../form-preset-preview");
var _formPresetPreviewDefault = parcelHelpers.interopDefault(_formPresetPreview);
var _name = require("@form-engine/builder-mask/components/properties/name");
var _nameDefault = parcelHelpers.interopDefault(_name);
// import BuilderTagsProperty from '@form-engine/builder-mask/components/properties/tags';
var _string = require("@form-engine/builder-mask/components/properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _useMaskConfig = require("@form-engine/builder-mask/hooks/use-mask-config");
var _schema = require("./schema");
var _schemaDefault = parcelHelpers.interopDefault(_schema);
const maskConfig = {
    schema: (0, _schemaDefault.default).pick({
        name: true,
        description: true
    })
};
function BuilderFormPresetMask() {
    const { state: preset } = (0, _useMask.useMaskContext)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useMaskConfig.MaskConfigProvider), {
        value: maskConfig,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                    sm: 6,
                    children: preset && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formPresetPreviewDefault.default), {
                        preset: preset
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
                    sm: 6,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nameDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                            as: "textarea",
                            rows: "3",
                            stacked: true,
                            propertyName: "description",
                            label: "Description"
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/hooks/use-mask":"72MTY","react-bootstrap":"f5rnA","../form-preset-preview":"ckxzr","@form-engine/builder-mask/components/properties/name":"cCuUh","@form-engine/builder-mask/components/properties/string":"e6M7S","@form-engine/builder-mask/hooks/use-mask-config":"daHU1","./schema":"5AR5d","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ckxzr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderFormPresetPreviewError", ()=>BuilderFormPresetPreviewError);
parcelHelpers.export(exports, "default", ()=>BuilderFormPresetPreview);
var _jsxRuntime = require("react/jsx-runtime");
var _container = require("@form-engine/core-application/components/container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _element = require("@form-engine/core-application/components/element");
var _elementDefault = parcelHelpers.interopDefault(_element);
var _engine = require("@form-engine/core-application/components/engine");
var _uuid = require("@form-engine/core-util/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _scaledContainer = require("./scaled-container");
var _scaledContainerDefault = parcelHelpers.interopDefault(_scaledContainer);
var _errorBoundary = require("@form-engine/builder-application/components/error-boundary");
var _errorBoundaryDefault = parcelHelpers.interopDefault(_errorBoundary);
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
function BuilderFormPresetPreviewError() {
    const { Node } = (0, _builderApplicationDefault.default).i18n;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
        id: "form-editor.formPresetPreview.notRenderable"
    });
}
function BuilderFormPresetPreview({ preset }) {
    const { form, session, workflow } = (0, _react.useMemo)(()=>{
        return {
            form: {
                ...preset?.data ?? {},
                id: (0, _uuidDefault.default)()
            },
            session: {
                isMock: true
            },
            workflow: {}
        };
    }, [
        preset
    ]);
    const handlePreviewSubmit = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
    }, []);
    if (!form?.elements?.length) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scaledContainerDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundaryDefault.default), {
            errorComponent: BuilderFormPresetPreviewError,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _engine.FormEngineStateProvider), {
                form,
                session,
                workflow,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                    onSubmit: handlePreviewSubmit,
                    className: "fe is-initialized",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "fe-elements",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _elementDefault.default), {
                            editMode: true,
                            id: form.elements[0].id,
                            elementComponent: (0, _elementDefault.default),
                            containerComponent: (0, _containerDefault.default)
                        })
                    })
                })
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-application/components/container":"hxA8J","@form-engine/core-application/components/element":"dt2u8","@form-engine/core-application/components/engine":"8IyYu","@form-engine/core-util/uuid":"eZttN","react":"9njXz","./scaled-container":"bIMCw","@form-engine/builder-application/components/error-boundary":"hRjxH","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bIMCw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderScaledContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _classNames = require("@form-engine/core-util/class-names");
var _classNamesDefault = parcelHelpers.interopDefault(_classNames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function BuilderScaledContainer({ width = 768, children, targetProps = {}, className, ...props }) {
    const container = (0, _react.useRef)(null);
    const target = (0, _react.useRef)(null);
    const [scale, setScale] = (0, _react.useState)(1);
    const [height, setHeight] = (0, _react.useState)(1);
    (0, _react.useEffect)(()=>{
        if (!container.current || !target.current) return;
        const containerElement = container.current;
        let mounted = true;
        const update = ()=>{
            if (!container.current || !target.current || !mounted) return;
            const { height: th } = target.current.getBoundingClientRect();
            const { width: cw } = containerElement.getBoundingClientRect();
            const newScale = cw / width;
            if (scale !== newScale) setScale(newScale);
            if (height !== th) setHeight(th);
        };
        const observer = new ResizeObserver(update);
        observer.observe(containerElement);
        update();
        return ()=>{
            mounted = false;
            observer.unobserve(containerElement);
        };
    }, [
        width,
        setScale,
        setHeight,
        height,
        scale
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...props,
        className: (0, _classNamesDefault.default)('feb-element-preview', className),
        ref: container,
        style: {
            '--height': `${height}px`,
            '--scale': scale,
            '--width': `${width}px`
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ...targetProps,
            className: (0, _classNamesDefault.default)('feb-element-preview__target', targetProps?.className),
            ref: target,
            children: children
        })
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-util/class-names":"fk8HN","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hRjxH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _error = require("./error");
var _errorDefault = parcelHelpers.interopDefault(_error);
class ErrorBoundary extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    componentDidCatch(error) {
        this.setState({
            error
        });
    }
    render() {
        const { error } = this.state;
        const { children, errorComponent: Error = (0, _errorDefault.default) } = this.props;
        if (error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Error, {
            error: error
        });
        else return children;
    }
}
exports.default = ErrorBoundary;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./error":"aYP6M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aYP6M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderAppError);
var _jsxRuntime = require("react/jsx-runtime");
var _reactBootstrap = require("react-bootstrap");
function BuilderAppError({ error }) {
    const { statusCode, stack, message } = error;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "d-flex align-items-center justify-content-center vh-100",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
            className: "w-100",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
                md: {
                    span: 10,
                    offset: 1
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "display-1 fw-bold",
                        children: statusCode ?? 500
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "fs-3 text-danger",
                        children: message ?? 'An unknown Error occured'
                    }),
                    Boolean(stack) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                        style: {
                            whiteSpace: 'pre-wrap'
                        },
                        className: "p-3 border bg-light text-secondary-emphasis",
                        children: String(stack).trim()
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react-bootstrap":"f5rnA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5AR5d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _uuid = require("@form-engine/core-util/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _zod = require("zod");
var _zodDefault = parcelHelpers.interopDefault(_zod);
exports.default = (0, _zodDefault.default).object({
    id: (0, _zodDefault.default).string().nonempty().default((0, _uuidDefault.default)),
    name: (0, _zodDefault.default).string().nonempty().default('NewPreset'),
    tags: (0, _zodDefault.default).string().array().optional().default(()=>[]),
    description: (0, _zodDefault.default).string().default(''),
    data: (0, _zodDefault.default).any().default(null).nullable()
});

},{"@form-engine/core-util/uuid":"eZttN","zod":"lk66X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kmVZl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useImportFormFileAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _jsxRuntime = require("react/jsx-runtime");
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useMounted = require("@form-engine/core-application/hooks/use-mounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _react = require("react");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _reactToastify = require("react-toastify");
var _importForm = require("../../hub/hooks/import-form");
var _index = require("@form-engine/builder-application/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
function useImportFormFileAction() {
    const { state: form, set } = (0, _useForm.useFormContext)();
    const mounted = (0, _useMountedDefault.default)();
    const importForm = (0, _importForm.useImportForm)();
    return (0, _react.useCallback)(async ()=>{
        const toastId = (0, _reactToastify.toast)((0, _indexDefault.default).i18n.c('import-form.importing'), {
            autoClose: false
        });
        let importedForm;
        try {
            importedForm = await importForm(false);
        } catch  {
            importedForm = null;
        }
        if (!importedForm) {
            (0, _reactToastify.toast).dismiss(toastId);
            return;
        }
        if (!mounted) return;
        importedForm.id = form.id;
        set(importedForm);
        (0, _reactToastify.toast).update(toastId, {
            autoClose: 1500,
            render: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.CheckCircleFill), {
                        className: "me-2"
                    }),
                    ' ',
                    (0, _indexDefault.default).i18n.c('import-form.success')
                ]
            })
        });
    }, [
        form,
        (0, _reactToastify.toast),
        set
    ]);
}
const ACTION_NAME = 'formEditor.form.importFile';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+alt+i,meta+alt+i');
const useAction = useImportFormFileAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction());
}

},{"react/jsx-runtime":"1dlk8","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-mounted":"kHM7H","react":"9njXz","@form-engine/core-application/hooks/use-form":"5PZyy","react-bootstrap-icons":"3TzoC","react-toastify":"iWdY7","../../hub/hooks/import-form":"btaml","@form-engine/builder-application/index":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btaml":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "importFormFromFile", ()=>importFormFromFile);
parcelHelpers.export(exports, "useImportForm", ()=>useImportForm);
var _uuid = require("@form-engine/core-util/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _useFormApi = require("@form-engine/builder-application/hooks/use-form-api");
var _useFormApiDefault = parcelHelpers.interopDefault(_useFormApi);
var _useMounted = require("@form-engine/core-application/hooks/use-mounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _react = require("react");
var _index = require("@form-engine/core-application/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _index1 = require("@form-engine/builder-application/index");
var _indexDefault1 = parcelHelpers.interopDefault(_index1);
var _reactToastify = require("react-toastify");
var _openFile = require("@form-engine/builder-application/utilities/open-file");
var _openFileDefault = parcelHelpers.interopDefault(_openFile);
async function importFormFromFile() {
    const fileContents = await (0, _openFileDefault.default)('Form Projects', {
        'application/x-form-engine-project': [
            '.xfe'
        ]
    });
    return JSON.parse(fileContents);
}
function useImportForm() {
    const formApi = (0, _useFormApiDefault.default)();
    const mounted = (0, _useMountedDefault.default)();
    const callback = (0, _react.useCallback)(async (persist = true)=>{
        let formDefinition;
        try {
            formDefinition = await importFormFromFile();
        } catch  {
            (0, _reactToastify.toast).error((0, _indexDefault1.default).i18n.c('import-form.corrupted-error'));
        }
        if (formDefinition?.engineVersion) {
            if (parseInt(formDefinition?.engineVersion.split('.')[0], 10) < parseInt((0, _indexDefault.default).version.split('.')[0], 10)) {
                (0, _reactToastify.toast).error((0, _indexDefault1.default).i18n.c('import-form.version-error'));
                return;
            }
            delete formDefinition.engineVersion;
        }
        if (!mounted || !formDefinition) return;
        if (!persist) return formDefinition;
        formDefinition.id = (0, _uuidDefault.default)();
        formDefinition.name = `${formDefinition.name} (Imported)`;
        return await formApi.create(formDefinition);
    }, [
        formApi
    ]);
    return callback;
}

},{"@form-engine/core-util/uuid":"eZttN","@form-engine/builder-application/hooks/use-form-api":"3uteJ","@form-engine/core-application/hooks/use-mounted":"kHM7H","react":"9njXz","@form-engine/core-application/index":"fjN6J","@form-engine/builder-application/index":"7iKr0","react-toastify":"iWdY7","@form-engine/builder-application/utilities/open-file":"2DwnK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2DwnK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>openFile);
async function openFile(description, accept) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [fileHandle] = await window.showOpenFilePicker({
        types: [
            {
                description,
                accept
            }
        ]
    });
    const file = await fileHandle?.getFile();
    return new Promise((res, rej)=>{
        const reader = new FileReader();
        reader.onerror = rej;
        reader.onabort = rej;
        reader.onload = ()=>{
            try {
                res(reader.result);
            } catch (e) {
                rej(e);
            }
        };
        reader.readAsText(file);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6X8r4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormL10nSchema", ()=>FormL10nSchema);
parcelHelpers.export(exports, "getFormL10nData", ()=>getFormL10nData);
parcelHelpers.export(exports, "default", ()=>useExportL10nAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _react = require("react");
var _coreApplication = require("@form-engine/core-application");
var _coreApplicationDefault = parcelHelpers.interopDefault(_coreApplication);
var _index = require("@form-engine/builder-application/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _saveFile = require("@form-engine/builder-application/utilities/save-file");
var _saveFileDefault = parcelHelpers.interopDefault(_saveFile);
var _zod = require("zod");
var _zodDefault = parcelHelpers.interopDefault(_zod);
const FormL10nSchema = (0, _zodDefault.default).record((0, _zodDefault.default).object({
    elementName: (0, _zodDefault.default).string(),
    l10n: (0, _zodDefault.default).record((0, _zodDefault.default).record((0, _zodDefault.default).any()))
}).strict());
function getFormL10nData(source) {
    const l10n = {};
    for (const element of source.elements ?? []){
        const translateableFields = Object.entries((0, _indexDefault.default).maskConfigurations[element.type]?.translate?.permissions ?? {}).filter(([, value])=>value === 'write').map(([key])=>key);
        if (!translateableFields.length) continue;
        const elementL10n = l10n[element.id] = {
            elementName: element.name ?? '',
            l10n: {}
        };
        for (const key of translateableFields){
            elementL10n.l10n[key] = {
                default: element[key]
            };
            for (const [locale, localeData] of Object.entries(element.locales ?? {}))if (key in localeData) elementL10n.l10n[key][locale] = localeData[key];
        }
    }
    return l10n;
}
function exportFormAsL10nJson(source, filename = 'export.l10n.json', type = 'application/json') {
    (0, _saveFileDefault.default)(JSON.stringify(getFormL10nData(source), undefined, 2), filename, type);
}
function useExportL10nAction() {
    const { state } = (0, _useForm.useFormContext)();
    return (0, _react.useCallback)(async ()=>{
        exportFormAsL10nJson({
            ...state,
            engineVersion: (0, _coreApplicationDefault.default).version
        }, `${state.name || 'untitled'}.l10n.json`);
    }, [
        state
    ]);
}
const ACTION_NAME = 'formEditor.form.exportL10n';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+alt+l,meta+alt+l');
const useAction = useExportL10nAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction());
}

},{"../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-form":"5PZyy","react":"9njXz","@form-engine/core-application":"fjN6J","@form-engine/builder-application/index":"7iKr0","@form-engine/builder-application/utilities/save-file":"1vzaN","zod":"lk66X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8NkG9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyL10nData", ()=>applyL10nData);
parcelHelpers.export(exports, "default", ()=>useImportL10nAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _jsxRuntime = require("react/jsx-runtime");
var _useHotkey = require("../hooks/use-hotkey");
var _useHotkeyDefault = parcelHelpers.interopDefault(_useHotkey);
var _keybindings = require("@form-engine/builder-application/keybindings");
var _useMounted = require("@form-engine/core-application/hooks/use-mounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _react = require("react");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _reactToastify = require("react-toastify");
var _index = require("@form-engine/builder-application/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _openFile = require("@form-engine/builder-application/utilities/open-file");
var _openFileDefault = parcelHelpers.interopDefault(_openFile);
var _exportL10N = require("./export-l10n");
var _elementList = require("@form-engine/core-util/element-list");
var _lodash = require("lodash");
function applyL10nData(form, l10nData) {
    const result = structuredClone(form);
    const updatedKeys = [];
    const ignoredElements = [];
    for (const [elementId, elementL10nData] of Object.entries(l10nData)){
        const element = (0, _elementList.getItemById)(result.elements ?? [], elementId);
        if (!element) {
            ignoredElements.push(elementId);
            console.warn(`l10n import contained unknown element ${elementId}`);
            continue;
        }
        if (!elementL10nData.l10n) {
            ignoredElements.push(elementId);
            console.warn(`l10n import contained empty element ${elementId}`);
            continue;
        }
        for (const [key, l10n] of Object.entries(elementL10nData.l10n)){
            if ('default' in l10n && !(0, _lodash.isEqual)(element[key], l10n.default)) {
                updatedKeys.push([
                    elementId,
                    'default',
                    key
                ]);
                element[key] = l10n.default;
            }
            for (const [locale, value] of Object.entries(l10n)){
                if (locale === 'default' || (0, _lodash.isEqual)(element?.locales?.[locale]?.[key], value)) continue;
                element.locales ??= {};
                element.locales[locale] ??= {};
                element.locales[locale][key] = value;
                updatedKeys.push([
                    elementId,
                    locale,
                    key
                ]);
            }
        }
    }
    return {
        result,
        updatedKeys,
        ignoredElements
    };
}
function useImportL10nAction() {
    const { state: form, set } = (0, _useForm.useFormContext)();
    const mounted = (0, _useMountedDefault.default)();
    return (0, _react.useCallback)(async ()=>{
        const toastId = (0, _reactToastify.toast)((0, _indexDefault.default).i18n.c('import-l10n.importing'), {
            autoClose: false
        });
        let importedL10nData;
        try {
            importedL10nData = (0, _exportL10N.FormL10nSchema).parse(JSON.parse(await (0, _openFileDefault.default)('L10n files', {
                'application/json': [
                    '.l10n.json'
                ]
            })));
        } catch (e) {
            console.warn(e);
            importedL10nData = null;
        }
        if (!importedL10nData) {
            (0, _reactToastify.toast).dismiss(toastId);
            return;
        }
        if (!mounted) return;
        const { result, ignoredElements, updatedKeys } = applyL10nData(form, importedL10nData);
        set(result);
        const { c } = (0, _indexDefault.default).i18n;
        let message = c(`import-l10n.success.${updatedKeys.length === 1 ? 'singular' : 'plural'}`, {
            count: updatedKeys.length
        });
        if (ignoredElements.length > 0) message = `${message} ${c(`import-l10n.unmatchedElementsMessage.${ignoredElements.length === 1 ? 'singular' : 'plural'}`, {
            count: ignoredElements.length
        })}`;
        (0, _reactToastify.toast).update(toastId, {
            autoClose: 3000,
            render: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.CheckCircleFill), {
                        className: "me-2"
                    }),
                    " ",
                    message
                ]
            })
        });
    }, [
        form,
        (0, _reactToastify.toast),
        set
    ]);
}
const ACTION_NAME = 'formEditor.form.importL10n';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+alt+j,meta+alt+j');
const useAction = useImportL10nAction;
function useActionHotkey() {
    (0, _useHotkeyDefault.default)(ACTION_NAME, useAction());
}

},{"react/jsx-runtime":"1dlk8","../hooks/use-hotkey":"ii3Da","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/core-application/hooks/use-mounted":"kHM7H","react":"9njXz","@form-engine/core-application/hooks/use-form":"5PZyy","react-bootstrap-icons":"3TzoC","react-toastify":"iWdY7","@form-engine/builder-application/index":"7iKr0","@form-engine/builder-application/utilities/open-file":"2DwnK","./export-l10n":"6X8r4","@form-engine/core-util/element-list":"e0ovy","lodash":"1qc47","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lcd2y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSaveOnViewUnload", ()=>useSaveOnViewUnload);
var _react = require("react");
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
var _saveForm = require("../../actions/save-form");
var _saveFormDefault = parcelHelpers.interopDefault(_saveForm);
var _useFormHistory = require("../../hooks/use-form-history");
var _useFormHistoryDefault = parcelHelpers.interopDefault(_useFormHistory);
// loosely compares the histories by value, not by reference where possible
function isHistoryDirty(prev, current) {
    if (prev === current) return false;
    if (!prev || !current) return true;
    return JSON.stringify(prev) !== JSON.stringify(current);
}
function useSaveOnViewUnload(currentView) {
    const [prevView, setPrevView] = (0, _react.useState)(currentView);
    const [historyDirty, setHistoryDirty] = (0, _react.useState)(false);
    const { state: history } = (0, _useFormHistoryDefault.default)();
    const [prevHistory, setPrevHistory] = (0, _react.useState)(history);
    const save = (0, _saveFormDefault.default)();
    (0, _react.useEffect)(()=>{
        if (isHistoryDirty(prevHistory, history)) setHistoryDirty(true);
    }, [
        history,
        setHistoryDirty,
        prevHistory,
        setPrevHistory
    ]);
    (0, _react.useEffect)(()=>{
        if (prevView === currentView) return;
        // save if the prev view requires it and the form has changes, that
        // require saving it (everything thats tracked in history)
        if (historyDirty && (0, _builderApplicationDefault.default).formStudioViews[prevView]?.shouldSaveOnUnload) {
            setHistoryDirty(false);
            save();
        }
        setPrevView(currentView);
    }, [
        currentView,
        prevView,
        setPrevView,
        save,
        setHistoryDirty,
        historyDirty
    ]);
}

},{"react":"9njXz","@form-engine/builder-application":"7iKr0","../../actions/save-form":"5cMl4","../../hooks/use-form-history":"1RTRx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"xUzo0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useFormStaleHandler);
var _useFormApi = require("@form-engine/builder-application/hooks/use-form-api");
var _useFormApiDefault = parcelHelpers.interopDefault(_useFormApi);
var _react = require("react");
function useFormStaleHandler(currentForm, handler, pollRate = 5000) {
    const { list, retrieve } = (0, _useFormApiDefault.default)();
    const { id, updatedAt } = currentForm;
    (0, _react.useEffect)(()=>{
        let mounted = true;
        let currentTimeout;
        async function poll() {
            if (!mounted || !id) return;
            const [dbFormState] = await list({
                attributes: [
                    'id',
                    'updatedAt'
                ],
                limit: 1,
                filter: {
                    id
                }
            });
            if (dbFormState?.updatedAt && updatedAt && new Date(dbFormState?.updatedAt) > new Date(updatedAt)) await handler(await retrieve(id));
            if (!mounted) return;
            currentTimeout = setTimeout(poll, pollRate);
        }
        poll();
        return ()=>{
            mounted = false;
            clearTimeout(currentTimeout);
        };
    }, [
        id,
        updatedAt,
        handler,
        pollRate,
        list,
        retrieve
    ]);
}

},{"@form-engine/builder-application/hooks/use-form-api":"3uteJ","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9H932":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _mask = require("./mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
exports.default = {
    label: 'form-editor.hyperlinkEmbed.title',
    description: 'form-editor.hyperlinkEmbed.description',
    Icon: (0, _reactBootstrapIcons.Link45deg),
    Mask: (0, _maskDefault.default)
};

},{"react-bootstrap-icons":"3TzoC","./mask":"5J3zg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5J3zg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderHyperlinkEmbedMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _property = require("@form-engine/builder-mask/components/mask/property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _reactToastify = require("react-toastify");
function ClipboardButton({ value }) {
    const handleCopy = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        navigator.clipboard.writeText(value);
        (0, _reactToastify.toast)(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: "copied to clipboard"
        }));
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
        size: "sm",
        variant: "dark",
        onClick: handleCopy,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.Clipboard), {})
    });
}
function BuilderHyperlinkEmbedMask({ form }) {
    const publicUrl = (0, _builderApplicationDefault.default).renderFormRoute.replace(':formId', form.slug || form.id || '') + '?language=default';
    const a = `<a href="${publicUrl}" target="_self">${form.name}</a>`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "feb-element-mask",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `feb-mask-group`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "feb-mask-group-body",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertyDefault.default), {
                        label: "Url",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.InputGroup), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
                                    size: "sm",
                                    defaultValue: publicUrl
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClipboardButton, {
                                    value: publicUrl
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertyDefault.default), {
                        label: "Hyperlink",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.InputGroup), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
                                    size: "sm",
                                    defaultValue: a
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClipboardButton, {
                                    value: a
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-application":"7iKr0","react-bootstrap":"f5rnA","react-bootstrap-icons":"3TzoC","@form-engine/builder-mask/components/mask/property":"dLorN","react-toastify":"iWdY7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bW4am":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _mask = require("./mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
exports.default = {
    label: 'form-editor.inlineEmbed.title',
    description: 'form-editor.inlineEmbed.description',
    Mask: (0, _maskDefault.default),
    Icon: (0, _reactBootstrapIcons.BoxSeam)
};

},{"react-bootstrap-icons":"3TzoC","./mask":"3Aa59","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Aa59":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderInlineEmbedMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _property = require("@form-engine/builder-mask/components/mask/property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _reactToastify = require("react-toastify");
var _useMarkdown = require("@form-engine/core-application/hooks/use-markdown");
var _useMarkdownDefault = parcelHelpers.interopDefault(_useMarkdown);
function ClipboardButton({ value }) {
    const handleCopy = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        navigator.clipboard.writeText(value);
        (0, _reactToastify.toast)(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: "copied to clipboard"
        }));
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
        size: "sm",
        variant: "dark",
        onClick: handleCopy,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.Clipboard), {})
    });
}
function BuilderInlineEmbedMask({ form }) {
    const url = new URL((0, _builderApplicationDefault.default).renderFormRoute.replace(':formId', form.slug || form.id || ''));
    url.searchParams.set('embed', 'true');
    const source = (0, _react.useMemo)(()=>`<!-- Form (put in content) -->
<script async src="${url}"></script>
<!-- /Form -->`, []);
    const { Node, c } = (0, _builderApplication.i18n).prefix(`mask.BuilderInlineEmbedMask.`);
    const markdown = (0, _useMarkdownDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "feb-element-mask",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `feb-mask-group`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "feb-mask-group-body",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "mb-5",
                        dangerouslySetInnerHTML: {
                            __html: markdown(c('description'))
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertyDefault.default), {
                        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                                    id: "code"
                                }),
                                ' ',
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClipboardButton, {
                                    value: source
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
                            type: "textarea",
                            value: source,
                            readOnly: true,
                            style: {
                                fontSize: 12,
                                fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace'
                            }
                        })
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-application":"7iKr0","react-bootstrap":"f5rnA","react-bootstrap-icons":"3TzoC","@form-engine/builder-mask/components/mask/property":"dLorN","react-toastify":"iWdY7","@form-engine/core-application/hooks/use-markdown":"lwtKh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iwXEP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _editor = require("./editor");
exports.default = {
    label: 'form-editor.datasources.title',
    description: 'form-editor.datasources.description',
    Component: (0, _editor.BuilderFormEditorViewDatasources),
    Icon: (0, _reactBootstrapIcons.Plug),
    shouldSaveOnUnload: true
};

},{"react-bootstrap-icons":"3TzoC","./editor":"gFJeg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gFJeg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatasourceMask", ()=>DatasourceMask);
parcelHelpers.export(exports, "BuilderDatasourceEditor", ()=>BuilderDatasourceEditor);
parcelHelpers.export(exports, "BuilderFormEditorViewDatasources", ()=>BuilderFormEditorViewDatasources);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormEditor = require("../../hooks/use-form-editor");
var _reactBootstrap = require("react-bootstrap");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _uuid = require("@form-engine/core-util/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _explorer = require("@form-engine/builder-application/components/explorer");
var _explorerDefault = parcelHelpers.interopDefault(_explorer);
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _useDatasource = require("@form-engine/core-application/hooks/use-datasource");
var _useDatasourceDefault = parcelHelpers.interopDefault(_useDatasource);
var _useDatasourceMask = require("@form-engine/builder-application/hooks/use-datasource-mask");
var _useDatasourceMaskDefault = parcelHelpers.interopDefault(_useDatasourceMask);
var _card = require("@form-engine/builder-application/components/card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
var _elementList = require("@form-engine/core-util/element-list");
var _dialog = require("@form-engine/builder-application/components/dialog");
var _useMounted = require("@form-engine/core-application/hooks/use-mounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
function DatasourceTypeItem({ label, description, icon: Icon = (0, _reactBootstrapIcons.PlusLg), ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
        md: 6,
        lg: 4,
        xl: 3,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
            as: "button",
            ...props,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Card).Body, {
                className: "row d-flex",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Title, {
                                className: "text-xs",
                                children: label
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Text, {
                                className: "text-xs text-black-50",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                        xs: 2,
                        className: "align-self-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {})
                    })
                ]
            })
        })
    });
}
function AddDatasourceMask({ onCreate }) {
    const datasourceTypes = (0, _react.useMemo)(()=>(0, _builderApplicationDefault.default).datasources, []);
    const { state, setItem } = (0, _useForm.useFormContext)();
    const addTypeInstance = (0, _react.useCallback)((type)=>{
        return (e)=>{
            e.preventDefault();
            e.stopPropagation();
            const id = (0, _uuidDefault.default)();
            setItem('datasources', [
                ...state?.datasources ?? [],
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                {
                    id,
                    type: type,
                    name: 'UntitledDatasource'
                }
            ]);
            onCreate && onCreate(id);
        };
    }, [
        state?.datasources,
        setItem,
        onCreate
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "feb-view",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "feb-view-inner p-0",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Container), {
                fluid: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                        className: "mb-3 mt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                            id: "form-editor.datasources.title"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
                        style: {
                            [`--bs-gutter-y`]: '1rem'
                        },
                        children: Object.values(datasourceTypes).map(({ label, description, Icon, Datasource })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(DatasourceTypeItem, {
                                label: (0, _builderApplication.i18n).c(label),
                                description: description ? (0, _builderApplication.i18n).c(description) : undefined,
                                onClick: addTypeInstance(Datasource.apiName),
                                icon: Icon
                            }, Datasource.apiName))
                    })
                ]
            })
        })
    });
}
function DatasourceMask({ id }) {
    const datasource = (0, _useDatasourceDefault.default)(id);
    const Mask = (0, _useDatasourceMaskDefault.default)(id);
    if (!Mask || !id) return null;
    const { type = '' } = datasource?.state ?? {};
    const { label } = (0, _builderApplicationDefault.default)?.datasources?.[type] ?? {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "feb-element-mask",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Badge), {
                    bg: "light",
                    text: "dark",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                        id: label
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useMask.MaskProvider), {
                value: datasource,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Mask, {
                    id: id
                })
            })
        ]
    });
}
function BuilderDatasourceEditor() {
    const { state: { selectedDatasourceId = null }, setItem } = (0, _useFormEditor.useFormEditorContext)();
    if (!selectedDatasourceId) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AddDatasourceMask, {
        onCreate: (id)=>setItem('selectedDatasourceId', id)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DatasourceMask, {
        id: selectedDatasourceId
    });
}
function BuilderFormEditorViewDatasources() {
    const datasourceTypes = (0, _react.useMemo)(()=>(0, _builderApplicationDefault.default).datasources, []);
    const { state: { selectedDatasourceId }, setItem } = (0, _useFormEditor.useFormEditorContext)();
    const { state: { datasources = [], elements = [] }, setItem: setFormItem } = (0, _useForm.useFormContext)();
    const mounted = (0, _useMountedDefault.default)();
    const unset = (0, _react.useCallback)((id)=>{
        const item = (0, _elementList.getItemById)(datasources, id);
        if (!item) return;
        const datasourcesUpdate = (0, _elementList.removeItem)(datasources, item);
        let hasDirtyElements = false;
        const elementsUpdate = elements.map((originalElement)=>{
            const element = {
                ...originalElement
            };
            if (element?.datasource?.datasourceId === id) {
                hasDirtyElements = true;
                element.datasource = {
                    mode: 'static',
                    staticOptions: []
                };
            }
            return element;
        });
        if (hasDirtyElements) (0, _dialog.confirm)({
            children: (0, _builderApplication.i18n).c('form-editor.datasources.confirmDeleteCascade')
        }).then((ack)=>{
            if (ack && mounted.current) {
                setFormItem('datasources', datasourcesUpdate);
                setFormItem('elements', elementsUpdate);
            }
        });
        else setFormItem('datasources', datasourcesUpdate);
    }, [
        datasources,
        elements,
        setFormItem,
        mounted
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _explorerDefault.default), {
        selectedId: selectedDatasourceId,
        items: datasources.map(({ id, name, type })=>{
            if (!(type in datasourceTypes)) return null;
            const { Icon } = datasourceTypes[type];
            return {
                id,
                type,
                label: name,
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {})
            };
        }).filter((item)=>Boolean(item)),
        onAdd: ()=>setItem('selectedDatasourceId', undefined),
        onUnset: unset,
        onSelect: (id)=>setItem('selectedDatasourceId', id ?? undefined),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderDatasourceEditor, {})
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../hooks/use-form-editor":"4pkiD","react-bootstrap":"f5rnA","@form-engine/core-application/hooks/use-form":"5PZyy","react-bootstrap-icons":"3TzoC","@form-engine/core-util/uuid":"eZttN","@form-engine/builder-application/components/explorer":"aCKP4","@form-engine/builder-mask/hooks/use-mask":"72MTY","@form-engine/core-application/hooks/use-datasource":"lz7AL","@form-engine/builder-application/hooks/use-datasource-mask":"cPS97","@form-engine/builder-application/components/card":"bbNfc","@form-engine/builder-application":"7iKr0","@form-engine/core-util/element-list":"e0ovy","@form-engine/builder-application/components/dialog":"e4X5a","@form-engine/core-application/hooks/use-mounted":"kHM7H","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aCKP4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderExplorer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _drawerNav = require("../drawer-nav");
var _drawerNavDefault = parcelHelpers.interopDefault(_drawerNav);
var _drawer = require("../drawer");
var _drawerDefault = parcelHelpers.interopDefault(_drawer);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _appCol = require("../app-col");
var _appColDefault = parcelHelpers.interopDefault(_appCol);
var _ = require("../..");
function UnsetButton({ id, onClick }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        onClick: ()=>{
            onClick && onClick(id);
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.X), {})
    });
}
function BuilderExplorer({ as: Component = (0, _reactBootstrap.Row), selectedId = null, onSelect, items = [], onUnset, onAdd, children, ...props }) {
    const toggle = (0, _react.useCallback)((id)=>{
        return (e)=>{
            e.stopPropagation();
            e.preventDefault();
            onSelect && onSelect(selectedId === id ? null : id);
        };
    }, [
        selectedId,
        onSelect
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Component, {
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appColDefault.default), {
                md: 2,
                border: "right",
                id: "appExplorerLeftCol",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _drawerNavDefault.default), {
                        children: [
                            onAdd && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerNav.BuilderDrawerNavItem), {
                                        active: !selectedId,
                                        label: (0, _.i18n).c('explorer.add'),
                                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.Plus), {}),
                                        buttonProps: {
                                            onClick: onAdd
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                                ]
                            }),
                            items.map(({ id, label, icon })=>{
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerNav.BuilderDrawerNavItem), {
                                    active: selectedId === id,
                                    buttonProps: {
                                        onClick: toggle(id)
                                    },
                                    label: label,
                                    icon: icon,
                                    actions: onUnset && /*#__PURE__*/ (0, _jsxRuntime.jsx)(UnsetButton, {
                                        id: id,
                                        onClick: onUnset
                                    })
                                }, id);
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                className: "feb-main-col",
                children: children
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","../drawer-nav":"7m4Gf","../drawer":"5q6lh","react-bootstrap-icons":"3TzoC","../app-col":"3S4TJ","../..":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7m4Gf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderDrawerNavItem", ()=>BuilderDrawerNavItem);
parcelHelpers.export(exports, "BuilderDrawerNavLink", ()=>BuilderDrawerNavLink);
parcelHelpers.export(exports, "default", ()=>BuilderDrawerNav);
parcelHelpers.export(exports, "BuilderDrawerNavHeader", ()=>BuilderDrawerNavHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _useRouteActive = require("../../hooks/use-route-active");
var _useRouteActiveDefault = parcelHelpers.interopDefault(_useRouteActive);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _reactRouterDom = require("react-router-dom");
var _ = require("../..");
var _classNames = require("@form-engine/core-util/class-names");
var _classNamesDefault = parcelHelpers.interopDefault(_classNames);
function BuilderDrawerNavItem({ active = false, as: Component = 'div', button: ButtonComponent = 'button', buttonProps = {}, wrap: WrapComponent = 'div', nav: NavComponent = BuilderDrawerNav, children, label = '', i18nLabel, icon = null, actions = null, collapse, onToggleCollapse, ...props }) {
    const collapseable = 'collapseable' in props && props.collapseable !== false;
    delete props.collapseable;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Component, {
        ...props,
        className: `feb-drawer-nav-item ${active ? 'active' : ''} ${props.className || ''}`,
        children: [
            WrapComponent !== false && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(WrapComponent, {
                className: "feb-drawer-nav-button",
                children: [
                    collapseable && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "feb-drawer-nav-collapse-button",
                        onClick: onToggleCollapse,
                        children: collapse ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.CaretRight), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.CaretDown), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ButtonComponent, {
                        ...buttonProps,
                        className: `${buttonProps.className || ''} label`,
                        children: [
                            icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "type-icon",
                                children: icon
                            }),
                            i18nLabel ? (0, _.i18n).c(i18nLabel) : label
                        ]
                    }),
                    actions && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "actions",
                        children: actions
                    })
                ]
            }),
            children && /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavComponent, {
                children: children
            })
        ]
    });
}
function BuilderDrawerNavLink({ to, caseSensitive, end, ...props }) {
    const active = (0, _useRouteActiveDefault.default)(to, caseSensitive, end);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderDrawerNavItem, {
        ...props,
        active: active,
        button: (0, _reactRouterDom.NavLink),
        buttonProps: {
            to,
            caseSensitive,
            end
        }
    });
}
function BuilderDrawerNav({ as: Component = 'div', className = '', ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        className: `feb-drawer-nav ${className}`
    });
}
function BuilderDrawerNavHeader({ as: Component = 'div', ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        className: (0, _classNamesDefault.default)('feb-drawer-nav__header', props.className)
    });
}

},{"react/jsx-runtime":"1dlk8","../../hooks/use-route-active":"cVRW4","react":"9njXz","react-bootstrap-icons":"3TzoC","react-router-dom":"cgBkD","../..":"7iKr0","@form-engine/core-util/class-names":"fk8HN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cVRW4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useRouteActive);
var _reactRouterDom = require("react-router-dom");
function useRouteActive(to, caseSensitive = false, end = false) {
    const location = (0, _reactRouterDom.useLocation)();
    const path = (0, _reactRouterDom.useResolvedPath)(to);
    let locationPathname = location.pathname;
    let toPathname = path.pathname;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        toPathname = toPathname.toLowerCase();
    }
    return locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === '/';
}

},{"react-router-dom":"cgBkD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5q6lh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Drawer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Drawer({ as: Component = 'div', className = '', ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        className: `feb-drawer ${className}`
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3S4TJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderAppCol);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _resizable = require("../resizable");
var _resizableDefault = parcelHelpers.interopDefault(_resizable);
function BuilderAppCol({ className = '', border = 'right', as: asProp = (0, _reactBootstrap.Col), minWidth = 200, maxWidth = '33vw', ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resizableDefault.default), {
        as: asProp,
        ...props,
        handles: border,
        minWidth: minWidth,
        maxWidth: maxWidth,
        className: `feb-app-col ${border && `feb-app-col--border-${border}`} ${className}`
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","../resizable":"8iXls","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8iXls":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderResizable);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useApp = require("../../hooks/use-app");
function styleValueToNumber(value, fallback = 0) {
    if (typeof value === 'number') return value;
    if (typeof value !== 'string') return fallback;
    const n = parseFloat(value);
    if (isNaN(n)) return fallback;
    return n;
}
function vwToNumber(vw, fallback = 0) {
    if (typeof vw === 'number') return vw;
    const n = styleValueToNumber(vw, fallback);
    if (isNaN(n)) return fallback;
    return n * 0.01 * window.innerWidth;
}
function vhToNumber(vh, fallback = 0) {
    if (typeof vh === 'number') return vh;
    const n = styleValueToNumber(vh, fallback);
    if (isNaN(n)) return fallback;
    return n * 0.01 * window.innerHeight;
}
function guardNumber(min, max, n) {
    return Math.min(max, Math.max(min, n));
}
function BuilderResizable({ id, as: Component = 'div', className = '', children, handles = [], width: initialWidth, height: initialHeight, minWidth: minWidthProp, maxWidth: maxWidthProp, minHeight: minHeightProp, maxHeight: maxHeightProp, onChange, ...props }) {
    const { state: app, setItem: setAppItem } = (0, _useApp.useAppContext)();
    const initialDimensions = (0, _react.useMemo)(()=>{
        const currentDimensions = id && app?.resizables?.[id];
        if (!currentDimensions) return {
            width: undefined,
            height: undefined
        };
        return {
            ...currentDimensions
        };
    }, [
        id,
        id && app?.resizables?.[id]
    ]);
    handles = typeof handles === 'string' ? [
        handles
    ] : handles;
    const ref = (0, _react.useRef)(undefined);
    const changeDimensions = (0, _react.useRef)(undefined);
    const [width, setWidth] = (0, _react.useState)(vwToNumber(initialDimensions?.width ?? initialWidth) || undefined);
    (0, _react.useEffect)(()=>{
        let mounted = true;
        const update = ()=>{
            if (mounted && id && app?.resizables[id]?.width !== width) setAppItem('resizables', {
                ...app?.resizables ?? {},
                [id]: {
                    ...app?.resizables[id] ?? {},
                    width
                }
            });
        };
        const t = setTimeout(update, 300);
        return ()=>{
            clearTimeout(t);
            mounted = false;
        };
    }, [
        width,
        setAppItem,
        id,
        app?.resizables
    ]);
    const [height, setHeight] = (0, _react.useState)(vhToNumber(initialDimensions?.height ?? initialHeight) || undefined);
    (0, _react.useEffect)(()=>{
        let mounted = true;
        const update = ()=>{
            if (mounted && id && app?.resizables[id]?.height !== height) setAppItem('resizables', {
                ...app?.resizables ?? {},
                [id]: {
                    ...app?.resizables[id] ?? {},
                    height
                }
            });
        };
        const t = setTimeout(update, 300);
        return ()=>{
            clearTimeout(t);
            mounted = false;
        };
    }, [
        height,
        setAppItem,
        id,
        app?.resizables
    ]);
    const [guards, setGuards] = (0, _react.useState)({
        minWidth: 0,
        maxWidth: Number.MAX_VALUE,
        minHeight: 0,
        maxHeight: Number.MAX_VALUE
    });
    const [initialState, setInitialState] = (0, _react.useState)(null);
    const handleStartDrag = (0, _react.useCallback)((e)=>{
        if (!ref.current || !e.target) return;
        setInitialState({
            mouseX: e.clientX,
            mouseY: e.clientY,
            rect: ref.current.getBoundingClientRect(),
            handles: e.target?.dataset?.handles?.split(',') || []
        });
    }, [
        setInitialState
    ]);
    const handleDragging = (0, _react.useCallback)((e)=>{
        if (!initialState || !ref.current) return;
        const { clientX: x, clientY: y } = e;
        const { mouseX, mouseY, rect, handles } = initialState;
        const dimensions = [
            x - mouseX,
            y - mouseY
        ];
        handles.forEach((handle)=>{
            switch(handle){
                case 'top':
                    setHeight(guardNumber(guards.minHeight, guards.maxHeight, rect.height - dimensions[1]));
                    break;
                case 'right':
                    setWidth(guardNumber(guards.minWidth, guards.maxWidth, rect.width + dimensions[0]));
                    break;
                case 'bottom':
                    setHeight(guardNumber(guards.minHeight, guards.maxHeight, rect.height + dimensions[1]));
                    break;
                case 'left':
                    setWidth(guardNumber(guards.minWidth, guards.maxWidth, rect.width - dimensions[0]));
                    break;
                default:
                    throw new Error(`unsupported handle ${handle}`);
            }
        });
    }, [
        initialState,
        setWidth,
        setHeight,
        guards
    ]);
    (0, _react.useEffect)(()=>{
        changeDimensions.current = [
            width,
            height
        ];
    }, [
        width,
        height
    ]);
    (0, _react.useEffect)(()=>{
        let mounted = true;
        function handleResize() {
            if (!mounted) return;
            const guards = {
                minWidth: vwToNumber(minWidthProp),
                maxWidth: vwToNumber(maxWidthProp, Number.MAX_VALUE),
                minHeight: vhToNumber(minHeightProp),
                maxHeight: vhToNumber(maxHeightProp, Number.MAX_VALUE)
            };
            setGuards(guards);
            if (typeof width === 'number' && !isNaN(width)) {
                const guardedWidth = guardNumber(guards.minWidth, guards.maxWidth, width);
                if (guardedWidth !== width) setWidth(guardedWidth);
            }
            if (typeof height === 'number' && !isNaN(height)) {
                const guardedHeight = guardNumber(guards.minHeight, guards.maxHeight, height);
                if (guardedHeight !== height) setHeight(guardedHeight);
            }
        }
        document.addEventListener('resize', handleResize);
        handleResize();
        return ()=>{
            mounted = false;
            document.removeEventListener('resize', handleResize);
        };
    }, [
        setGuards,
        width,
        setWidth,
        height,
        setHeight,
        minWidthProp,
        maxWidthProp,
        minHeightProp,
        maxHeightProp
    ]);
    (0, _react.useEffect)(()=>{
        let mounted = true;
        function stopDrag() {
            if (!mounted) return;
            setInitialState(null);
            const [changeWidth = 0, changeHeight = 0] = changeDimensions.current || [];
            const changeVw = `${!isNaN(changeWidth) ? changeWidth / window.innerWidth * 100 : 0}vw`;
            const changeVh = `${!isNaN(changeHeight) ? changeHeight / window.innerHeight * 100 : 0}vw`;
            onChange && onChange({
                width: changeWidth,
                height: changeHeight,
                vw: changeVw,
                vh: changeVh
            });
        }
        document.addEventListener('mouseup', stopDrag);
        document.addEventListener('blur', stopDrag);
        document.addEventListener('mousemove', handleDragging);
        return ()=>{
            mounted = false;
            document.removeEventListener('mouseup', stopDrag);
            document.removeEventListener('blur', stopDrag);
            document.removeEventListener('mousemove', handleDragging);
        };
    }, [
        handleDragging,
        setInitialState,
        onChange
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Component, {
        ref: ref,
        ...props,
        className: `feb-resizable ${className}`,
        style: {
            width,
            height
        },
        children: [
            children,
            handles.includes('top') && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "feb-resizable__top",
                "data-handles": "top",
                onMouseDown: handleStartDrag
            }),
            handles.includes('right') && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "feb-resizable__right",
                "data-handles": "right",
                onMouseDown: handleStartDrag
            }),
            handles.includes('bottom') && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "feb-resizable__bottom",
                "data-handles": "bottom",
                onMouseDown: handleStartDrag
            }),
            handles.includes('left') && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "feb-resizable__left",
                "data-handles": "left",
                onMouseDown: handleStartDrag
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../hooks/use-app":"8Rocb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cPS97":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDatasourceMask);
var _index = require("../index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _useDatasource = require("@form-engine/core-application/hooks/use-datasource");
var _useDatasourceDefault = parcelHelpers.interopDefault(_useDatasource);
var _react = require("react");
function useDatasourceMask(id) {
    const { state: datasource } = (0, _useDatasourceDefault.default)(id);
    return (0, _react.useMemo)(()=>{
        if (!datasource || !datasource.type) return null;
        const type = (0, _indexDefault.default)?.datasources?.[datasource.type];
        if (!type || !type.Mask) return null;
        return type.Mask;
    }, [
        datasource
    ]);
}

},{"../index":"7iKr0","@form-engine/core-application/hooks/use-datasource":"lz7AL","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lNvsg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _editor = require("./editor");
exports.default = {
    label: 'form-editor.layout.title',
    description: 'form-editor.layout.description',
    Component: (0, _editor.BuilderFormEditorViewForm),
    Icon: (0, _reactBootstrapIcons.Cursor)
};

},{"react-bootstrap-icons":"3TzoC","./editor":"cnC3h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cnC3h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderFormEditorViewForm", ()=>BuilderFormEditorViewForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _useFormEditor = require("../../hooks/use-form-editor");
var _drawerTabs = require("@form-engine/builder-application/components/drawer-tabs");
var _drawerTabsDefault = parcelHelpers.interopDefault(_drawerTabs);
var _drawer = require("@form-engine/builder-application/components/drawer");
var _drawerDefault = parcelHelpers.interopDefault(_drawer);
var _appCol = require("@form-engine/builder-application/components/app-col");
var _appColDefault = parcelHelpers.interopDefault(_appCol);
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
var _view = require("./view");
var _createObject = require("@form-engine/core-util/create-object");
function BuilderFormEditorViewForm() {
    const { state: { leftDrawerTab, canvasTab, rightDrawerTab }, setItem } = (0, _useFormEditor.useFormEditorContext)();
    const formRemote = (0, _react.useRef)(undefined);
    const editorViewDef = (0, _createObject.useObjectDefaults)((0, _view.BuilderFormLayoutEditorViewDefaults), (0, _react.useMemo)(()=>{
        const defs = (0, _builderApplicationDefault.default)?.formLayoutEditorViews ?? {};
        return defs[canvasTab] ?? {};
    }, [
        canvasTab
    ]));
    const leftDrawer = (0, _react.useMemo)(()=>{
        const items = Object.fromEntries(Object.entries(editorViewDef.leftDrawerTabs).map(([key, tab])=>[
                key,
                (0, _builderApplication.i18n).c(tab.title)
            ]));
        const activeKey = leftDrawerTab in items ? leftDrawerTab : editorViewDef.defaultLeftDrawerTab;
        return {
            items,
            activeKey,
            component: activeKey ? editorViewDef.leftDrawerTabs[activeKey]?.component : undefined
        };
    }, [
        editorViewDef.leftDrawerTabs,
        leftDrawerTab
    ]);
    const rightDrawer = (0, _react.useMemo)(()=>{
        const items = Object.fromEntries(Object.entries(editorViewDef.rightDrawerTabs).map(([key, tab])=>[
                key,
                (0, _builderApplication.i18n).c(tab.title)
            ]));
        const activeKey = rightDrawerTab in items ? rightDrawerTab : editorViewDef.defaultRightDrawerTab;
        return {
            items,
            activeKey,
            component: activeKey ? editorViewDef.rightDrawerTabs[activeKey]?.component : undefined
        };
    }, [
        editorViewDef.rightDrawerTabs,
        rightDrawerTab
    ]);
    const viewDrawer = (0, _react.useMemo)(()=>{
        const defs = (0, _builderApplicationDefault.default)?.formLayoutEditorViews ?? {};
        const items = Object.fromEntries(Object.entries(defs).map(([key, view])=>[
                key,
                (0, _builderApplication.i18n).c(view.title)
            ]));
        const component = defs[canvasTab]?.navItemsComponent;
        return {
            items,
            component
        };
    }, [
        canvasTab
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _appColDefault.default), {
                md: 2,
                border: "right",
                id: "layoutEditorLeftCol",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerTabsDefault.default), {
                        activeKey: leftDrawer.activeKey,
                        items: leftDrawer.items,
                        onChange: (key)=>setItem('leftDrawerTab', key)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "feb-view m-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "feb-view-inner p-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerDefault.default), {
                                children: leftDrawer.component && /*#__PURE__*/ (0, _jsxRuntime.jsx)(leftDrawer.component, {
                                    remote: formRemote,
                                    editMode: canvasTab
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
                className: "feb-main-col",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerTabsDefault.default), {
                        activeKey: canvasTab,
                        items: viewDrawer.items,
                        onChange: (key)=>{
                            setItem('canvasTab', key);
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ms-auto d-flex",
                            children: viewDrawer.component && /*#__PURE__*/ (0, _jsxRuntime.jsx)(viewDrawer.component, {
                                remote: formRemote,
                                editMode: canvasTab
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "feb-view",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "feb-view-inner",
                            children: editorViewDef.component && /*#__PURE__*/ (0, _jsxRuntime.jsx)(editorViewDef.component, {
                                remote: formRemote,
                                editMode: canvasTab
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _appColDefault.default), {
                md: 2,
                border: "left",
                id: "layoutEditorRightCol",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerTabsDefault.default), {
                        activeKey: rightDrawer.activeKey,
                        items: rightDrawer.items,
                        onChange: (key)=>setItem('rightDrawerTab', key)
                    }),
                    rightDrawer.component && /*#__PURE__*/ (0, _jsxRuntime.jsx)(rightDrawer.component, {
                        remote: formRemote,
                        editMode: canvasTab
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","../../hooks/use-form-editor":"4pkiD","@form-engine/builder-application/components/drawer-tabs":"5gJGr","@form-engine/builder-application/components/drawer":"5q6lh","@form-engine/builder-application/components/app-col":"3S4TJ","@form-engine/builder-application":"7iKr0","./view":"9Fd66","@form-engine/core-util/create-object":"dBL9S","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Fd66":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderFormLayoutEditorViewDefaults", ()=>BuilderFormLayoutEditorViewDefaults);
var _react = require("react");
const BuilderFormLayoutEditorViewDefaults = {
    title: '',
    component: (0, _react.Fragment),
    leftDrawerTabs: {},
    rightDrawerTabs: {},
    defaultLeftDrawerTab: undefined,
    defaultRightDrawerTab: undefined
};

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fXsKO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _editor = require("./editor");
exports.default = {
    label: 'form-editor.workflow.title',
    description: 'form-editor.workflow.description',
    Component: (0, _editor.BuilderWorkflowEditorView),
    Icon: (0, _reactBootstrapIcons.Diagram2Fill),
    shouldSaveOnUnload: true
};

},{"react-bootstrap-icons":"3TzoC","./editor":"lA9BQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lA9BQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderWorkflowEditorView", ()=>BuilderWorkflowEditorView);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("reactflow/dist/style.css");
var _useFormEditor = require("../../hooks/use-form-editor");
var _reactBootstrap = require("react-bootstrap");
var _appCol = require("@form-engine/builder-application/components/app-col");
var _appColDefault = parcelHelpers.interopDefault(_appCol);
var _drawerTabs = require("@form-engine/builder-application/components/drawer-tabs");
var _drawerTabsDefault = parcelHelpers.interopDefault(_drawerTabs);
var _drawer = require("@form-engine/builder-application/components/drawer");
var _drawerDefault = parcelHelpers.interopDefault(_drawer);
var _nodesDrawer = require("./nodes-drawer");
var _nodesDrawerDefault = parcelHelpers.interopDefault(_nodesDrawer);
var _flow = require("./flow");
var _settings = require("./settings");
var _builderApplication = require("@form-engine/builder-application");
function BuilderWorkflowEditorView() {
    const { state: { workflowLeftDrawerTab = 'library', workflowCanvasTab = 'flow', workflowRightDrawerTab = 'settings', selectedWorkflowLayerId }, setItem } = (0, _useFormEditor.useFormEditorContext)();
    const { c } = (0, _builderApplication.i18n).prefix('form-editor.workflow.');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _appColDefault.default), {
                md: 2,
                border: "right",
                id: "workflowEditorLeftCol",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerTabsDefault.default), {
                        activeKey: workflowLeftDrawerTab,
                        items: {
                            library: c('library')
                        },
                        onChange: (key)=>setItem('workflowLeftDrawerTab', key)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "feb-view m-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "feb-view-inner p-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerDefault.default), {
                                children: workflowLeftDrawerTab === 'library' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nodesDrawerDefault.default), {})
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
                className: "feb-main-col",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerTabsDefault.default), {
                        activeKey: workflowCanvasTab,
                        items: {
                            flow: c('flow')
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "feb-view",
                        children: workflowCanvasTab === 'flow' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flow.BuilderWorkflowEditorFlow), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _appColDefault.default), {
                md: 3,
                maxWidth: "50vw",
                border: "left",
                id: "workflowEditorRightCol",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerTabsDefault.default), {
                        activeKey: workflowRightDrawerTab,
                        items: {
                            settings: c('settings')
                        },
                        onChange: (key)=>setItem('rightDrawerTab', key)
                    }),
                    workflowRightDrawerTab === 'settings' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settings.BuilderWorkflowEditorSettingsDrawer), {
                        id: selectedWorkflowLayerId
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","reactflow/dist/style.css":"aHRCy","../../hooks/use-form-editor":"4pkiD","react-bootstrap":"f5rnA","@form-engine/builder-application/components/app-col":"3S4TJ","@form-engine/builder-application/components/drawer-tabs":"5gJGr","@form-engine/builder-application/components/drawer":"5q6lh","./nodes-drawer":"bJIAu","./flow":"gELSB","./settings":"88s3j","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aHRCy":[function() {},{}],"bJIAu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderWorkflowEditorNodesDrawer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
var _drawerNav = require("@form-engine/builder-application/components/drawer-nav");
var _drawerNavDefault = parcelHelpers.interopDefault(_drawerNav);
var _dragImage = require("../dnd/drag-image");
function BuilderWorkflowEditorNodesDrawer() {
    const workflowLayerTypes = (0, _react.useMemo)(()=>Object.entries((0, _builderApplicationDefault.default).workflowLayers), []);
    const handleDragStart = (0, _react.useCallback)((e)=>{
        const type = e.currentTarget?.getAttribute('data-type');
        const label = e.currentTarget?.getAttribute('data-label');
        if (type && e.dataTransfer) {
            e.dataTransfer.setData('application/reactflow', type);
            e.dataTransfer.effectAllowed = 'move';
            label && e.dataTransfer.setDragImage((0, _dragImage.getDragImageCanvas)(label), 0, 0);
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerNavDefault.default), {
        children: workflowLayerTypes.map(([type, { Icon, label }], index)=>{
            const i18nLabel = (0, _builderApplication.i18n).c(label);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerNav.BuilderDrawerNavItem), {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {}),
                label: i18nLabel,
                buttonProps: {
                    draggable: true,
                    onDragStart: handleDragStart,
                    'data-type': type,
                    'data-label': i18nLabel
                }
            }, index);
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-application":"7iKr0","@form-engine/builder-application/components/drawer-nav":"7m4Gf","../dnd/drag-image":"1iPvr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gELSB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderWorkflowEditorFlow", ()=>BuilderWorkflowEditorFlow);
var _jsxRuntime = require("react/jsx-runtime");
var _useBounds = require("@form-engine/builder-application/hooks/use-bounds");
var _useBoundsDefault = parcelHelpers.interopDefault(_useBounds);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactflow = require("reactflow");
var _reactflowDefault = parcelHelpers.interopDefault(_reactflow);
var _styleCss = require("reactflow/dist/style.css");
var _useWfl = require("@form-engine/core-application/hooks/use-wfl");
var _useFormEditor = require("../../hooks/use-form-editor");
var _layerNode = require("./layer-node");
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
var _elementList = require("@form-engine/core-util/element-list");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _uuid = require("@form-engine/core-util/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
const minimapStyle = {
    height: 120
};
const SIGNAL_TYPE_NAME = 'FormEngineSignalWfl';
const STATIC_NODES = [
    {
        id: 'form:ready',
        type: SIGNAL_TYPE_NAME,
        draggable: false,
        deletable: false,
        selectable: false,
        data: {
            label: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.LightningChargeFill), {}),
                        ' ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                            id: "form-editor.workflow.formReadyNode"
                        }),
                        ' ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.LockFill), {})
                    ]
                })
        },
        position: {
            x: 0,
            y: 0
        }
    },
    {
        id: 'form:submit',
        type: SIGNAL_TYPE_NAME,
        draggable: false,
        deletable: false,
        selectable: false,
        data: {
            label: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.LightningChargeFill), {}),
                        ' ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                            id: "form-editor.workflow.formSubmitNode"
                        }),
                        ' ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.LockFill), {})
                    ]
                })
        },
        position: {
            x: 250,
            y: 0
        }
    }
];
function castLayerToNode(layer) {
    if (!layer) throw new Error('invalid argument layer');
    const Icon = (0, _builderApplicationDefault.default).workflowLayers[layer.type]?.Icon ?? (0, _reactDefault.default).Fragment;
    return {
        id: layer.id,
        type: layer.type,
        draggable: true,
        deletable: true,
        data: {
            layer,
            label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {}),
                    " ",
                    layer.name
                ]
            }),
            body: layer.description
        },
        position: {
            x: isNaN(layer.nodeX) ? 0 : layer.nodeX,
            y: isNaN(layer.nodeY) ? 0 : layer.nodeY
        }
    };
}
function syncWorkflowLayersToNodes(workflowLayers, setter) {
    function updateNodeFromLayer(node, layer) {
        if (node && (node.data?.layer?.name !== layer.name || node.data?.layer?.description !== layer.description)) {
            const Icon = (0, _builderApplicationDefault.default).workflowLayers[layer.type]?.Icon;
            node.data = {
                ...node.data ?? {},
                layer,
                label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {}),
                        " ",
                        layer.name
                    ]
                }),
                body: layer.description
            };
            return true;
        }
        return false;
    }
    setter((nodes)=>{
        // ignore static nodes
        const staticNodes = [];
        const layerNodes = [];
        for (const node of nodes)if (node.data?.layer) layerNodes.push(node);
        else staticNodes.push(node);
        let isDirty = workflowLayers.length !== layerNodes.length;
        const nodesUpdate = [];
        for (const layer of workflowLayers){
            const node = (0, _elementList.getItemById)(layerNodes, layer.id);
            if (!node) {
                isDirty = true;
                nodesUpdate.push(castLayerToNode(layer));
            } else {
                if (updateNodeFromLayer(node, layer)) isDirty = true;
                nodesUpdate.push(node);
            }
        }
        if (isDirty) return [
            ...staticNodes,
            ...nodesUpdate
        ];
        return nodes;
    });
}
function syncWorkflowLayersToEdges(layers, setter) {
    setter((edges)=>{
        const edgesUpdate = [];
        let isDirty = false;
        for (const layer of layers){
            if (!Array.isArray(layer.events)) continue;
            for (const eventName of layer.events){
                const id = getEdgeId({
                    target: layer.id,
                    source: eventName
                });
                let edge = (0, _elementList.getItemById)(edges, id);
                if (!edge) {
                    isDirty = true;
                    edge = {
                        id: getEdgeId({
                            target: layer.id,
                            source: eventName
                        }),
                        source: eventName.split('@')[0],
                        sourceHandle: eventName,
                        target: layer.id,
                        animated: true
                    };
                }
                edgesUpdate.push(edge);
            }
        }
        if (edgesUpdate.length !== edges.length) isDirty = true;
        if (isDirty) return edgesUpdate;
        return edges;
    });
}
function useWorkflowNodesState() {
    const { state, set: setLayers } = (0, _useWfl.useWorkflowLayers)();
    const initialNodes = (0, _react.useMemo)(()=>{
        // the filter part is needed to sanitize legacy forms (prior to the flow editor)
        return [
            ...STATIC_NODES
        ];
    }, []);
    const [nodes, setNodes, onNodesChangeInternal] = (0, _reactflow.useNodesState)(initialNodes);
    (0, _react.useEffect)(()=>{
        syncWorkflowLayersToNodes(state, setNodes);
    }, [
        state,
        setNodes
    ]);
    const onNodesChange = (0, _react.useCallback)((changes)=>{
        let layersUpdate;
        for (const change of changes){
            if (change.type === 'position' && !change.dragging) {
                const layer = (0, _elementList.getItemById)(state, change.id);
                const node = (0, _elementList.getItemById)(nodes, change.id);
                if (layer && node) {
                    if (!layersUpdate) layersUpdate = [
                        ...state
                    ];
                    layersUpdate[layersUpdate.indexOf(layer)] = {
                        ...layer,
                        nodeX: node.position.x,
                        nodeY: node.position.y
                    };
                }
            }
            if (change.type === 'remove') {
                const layer = (0, _elementList.getItemById)(state, change.id);
                if (layer) {
                    if (!layersUpdate) layersUpdate = [
                        ...state
                    ];
                    layersUpdate = (0, _elementList.removeItem)(layersUpdate, layer);
                }
            }
        }
        layersUpdate && setLayers(layersUpdate);
        return onNodesChangeInternal(changes);
    }, [
        onNodesChangeInternal,
        setLayers,
        state,
        nodes
    ]);
    const addNode = (0, _react.useCallback)((params)=>{
        if (!params.type || !(0, _builderApplicationDefault.default).workflowLayers[params.type]) throw new Error(`unknown layer type ${params.type}`);
        const descriptor = (0, _builderApplicationDefault.default).workflowLayers[params.type];
        const layer = {
            id: (0, _uuidDefault.default)(),
            nodeX: 0,
            nodeY: 0,
            name: (0, _builderApplication.i18n).c(descriptor.label),
            enabled: true,
            ...params
        };
        if (!(0, _builderApplicationDefault.default).workflowLayers[layer.type]) throw new Error(`unknown layer type ${layer.type}`);
        const node = castLayerToNode(layer);
        setLayers((0, _elementList.addItem)(state, layer));
        setNodes((0, _elementList.addItem)(nodes, node));
    }, [
        setLayers,
        state,
        nodes,
        setNodes
    ]);
    return {
        nodes,
        setNodes,
        addNode,
        onNodesChange
    };
}
function getEdgeId(props) {
    return JSON.stringify(props);
}
function parseEdgeId(id) {
    try {
        const { target, source } = JSON.parse(id);
        return {
            target,
            source
        };
    } catch  {
        throw new Error(`malformed edge id ${id}`);
    }
}
function useWorkflowEdgesState() {
    const { state, setItem: setLayer, set: setLayers } = (0, _useWfl.useWorkflowLayers)();
    const [edges, setEdges, onEdgesChangeInternal] = (0, _reactflow.useEdgesState)([]);
    (0, _react.useEffect)(()=>{
        syncWorkflowLayersToEdges(state, setEdges);
    }, [
        state,
        setEdges
    ]);
    const onEdgesChange = (0, _react.useCallback)((changes)=>{
        const removed = changes.filter((change)=>change.type === 'remove');
        if (!removed.length) return onEdgesChangeInternal(changes);
        const layersUpdate = [
            ...state
        ];
        let layersDirty = false;
        for (const change of removed){
            const id = change?.id;
            if (!id) throw new Error('invalid id');
            const { target: layerId, source: eventName } = parseEdgeId(id);
            const layer = (0, _elementList.getItemById)(layersUpdate, layerId);
            if (!layer) throw new Error('edge target layer does not exist');
            const eventIndex = layer?.events?.indexOf(eventName) ?? -1;
            if (eventIndex > -1) {
                layersDirty = true;
                layersUpdate[layersUpdate.indexOf(layer)] = {
                    ...layer,
                    events: layer.events?.filter((currentEventName)=>currentEventName !== eventName)
                };
            }
        }
        layersDirty && setLayers(layersUpdate);
        return onEdgesChangeInternal(changes);
    }, [
        onEdgesChangeInternal,
        setLayers,
        state
    ]);
    const addEdgeAndFormState = (0, _react.useCallback)((edge)=>{
        const { sourceHandle: eventName, target } = edge;
        if (target && eventName) {
            const layer = (0, _elementList.getItemById)(state, target);
            if (!layer) throw new Error(`layer ${target} does not exist`);
            const index = state.indexOf(layer);
            if (!layer?.events?.includes(eventName)) setLayer(index, {
                ...layer,
                events: [
                    ...layer?.events ?? [],
                    eventName
                ]
            });
            setEdges((eds)=>{
                return (0, _reactflow.addEdge)({
                    ...edge,
                    id: getEdgeId({
                        target,
                        source: eventName
                    }),
                    animated: true
                }, eds);
            });
        }
    }, [
        setEdges,
        state,
        setLayer
    ]);
    return {
        edges,
        addEdge: addEdgeAndFormState,
        setEdges,
        onEdgesChange
    };
}
function BuilderWorkflowEditorFlow() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [reactFlowInstance, setReactFlowInstance] = (0, _react.useState)(null);
    const { bounds, ref } = (0, _useBoundsDefault.default)();
    const { nodes, addNode, onNodesChange } = useWorkflowNodesState();
    const { edges, addEdge, onEdgesChange } = useWorkflowEdgesState();
    const nodeTypes = (0, _react.useMemo)(()=>Object.fromEntries(Object.entries((0, _builderApplicationDefault.default).workflowLayers).map(([type, def])=>[
                type,
                def.Node ?? (0, _layerNode.BuilderWorkflowEditorLayerNode)
            ])), []);
    const onConnect = (0, _react.useCallback)((connection)=>{
        addEdge(connection);
    }, [
        addEdge
    ]);
    const { setItem: setFormEditorItem } = (0, _useFormEditor.useFormEditorContext)();
    const handleSelectionChange = (0, _react.useCallback)((data)=>{
        const [node] = data.nodes;
        if (node?.id) setFormEditorItem('selectedWorkflowLayerId', node.id);
        else setFormEditorItem('selectedWorkflowLayerId', undefined);
    }, [
        setFormEditorItem
    ]);
    const onDragOver = (0, _react.useCallback)((event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
    }, []);
    const onDrop = (0, _react.useCallback)((event)=>{
        event.preventDefault();
        const type = event.dataTransfer.getData('application/reactflow');
        // check if the dropped element is valid
        if (typeof type === 'undefined' || !type) return;
        const position = reactFlowInstance.project({
            x: event.clientX - bounds.left,
            y: event.clientY - bounds.top
        });
        addNode({
            type,
            nodeX: position.x,
            nodeY: position.y
        });
    }, [
        reactFlowInstance,
        bounds,
        addNode
    ]);
    const flow = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactflowDefault.default), {
        nodes: nodes,
        edges: edges,
        onNodesChange: onNodesChange,
        onSelectionChange: handleSelectionChange,
        onEdgesChange: onEdgesChange,
        onConnect: onConnect,
        onDragOver: onDragOver,
        onDrop: onDrop,
        onInit: setReactFlowInstance,
        fitView: true,
        nodeTypes: nodeTypes,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactflow.MiniMap), {
                style: minimapStyle,
                zoomable: true,
                pannable: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactflow.Controls), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactflow.Background), {
                color: "#aaa",
                gap: 16
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            display: 'flex',
            height: '100%',
            width: '100%',
            position: 'relative'
        },
        ref: ref,
        children: Boolean(bounds.width) && Boolean(bounds.height) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                width: bounds.width,
                height: bounds.height,
                position: 'absolute',
                top: '0',
                left: '0',
                overflow: 'hidden'
            },
            children: flow
        })
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-application/hooks/use-bounds":"jQMWQ","react":"9njXz","reactflow":"9KIiR","reactflow/dist/style.css":"aHRCy","@form-engine/core-application/hooks/use-wfl":"eobGp","../../hooks/use-form-editor":"4pkiD","./layer-node":"kygrj","@form-engine/builder-application":"7iKr0","@form-engine/core-util/element-list":"e0ovy","react-bootstrap-icons":"3TzoC","@form-engine/core-util/uuid":"eZttN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aHRCy":[function() {},{}],"88s3j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderWorkflowEditorSettingsDrawer", ()=>BuilderWorkflowEditorSettingsDrawer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _useWfl = require("@form-engine/core-application/hooks/use-wfl");
var _useWflDefault = parcelHelpers.interopDefault(_useWfl);
var _useWflMask = require("@form-engine/builder-application/hooks/use-wfl-mask");
var _useWflMaskDefault = parcelHelpers.interopDefault(_useWflMask);
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
function BuilderWorkflowEditorSettingsDrawer({ id }) {
    const workflowLayer = (0, _useWflDefault.default)(id);
    const Mask = (0, _useWflMaskDefault.default)(id);
    if (!Mask || !id) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        className: "text-muted text-center mt-3",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
            id: "form-editor.workflow.nothingSelected"
        })
    });
    const { type = '' } = workflowLayer?.state ?? {};
    const { label } = (0, _builderApplicationDefault.default)?.workflowLayers?.[type] ?? {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "feb-view m-0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "feb-view-inner p-0",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "feb-properties-drawer feb-element-mask",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _useMask.MaskProvider), {
                    value: workflowLayer,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Badge), {
                            bg: "light",
                            text: "dark",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                                id: label
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Mask, {
                            id: id
                        })
                    ]
                })
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","@form-engine/core-application/hooks/use-wfl":"eobGp","@form-engine/builder-application/hooks/use-wfl-mask":"aaJJX","@form-engine/builder-mask/hooks/use-mask":"72MTY","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aaJJX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useWorkflowLayerMask);
var _useWfl = require("@form-engine/core-application/hooks/use-wfl");
var _useWflDefault = parcelHelpers.interopDefault(_useWfl);
var _react = require("react");
var _index = require("../index");
var _indexDefault = parcelHelpers.interopDefault(_index);
function useWorkflowLayerMask(id) {
    const { state: workflowLayer } = (0, _useWflDefault.default)(id);
    return (0, _react.useMemo)(()=>{
        if (!workflowLayer || !workflowLayer.type) return null;
        const type = (0, _indexDefault.default)?.workflowLayers?.[workflowLayer.type];
        if (!type || !type.Mask) return null;
        return type.Mask;
    }, [
        workflowLayer
    ]);
}

},{"@form-engine/core-application/hooks/use-wfl":"eobGp","react":"9njXz","../index":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"QurK7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _editor = require("./editor");
exports.default = {
    label: 'form-editor.constants.title',
    description: 'form-editor.constants.description',
    Component: (0, _editor.BuilderFormEditorViewConstants),
    Icon: (0, _reactBootstrapIcons.List),
    shouldSaveOnUnload: true
};

},{"react-bootstrap-icons":"3TzoC","./editor":"67Xgd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67Xgd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderFormEditorViewConstants", ()=>BuilderFormEditorViewConstants);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _reactBootstrap = require("react-bootstrap");
var _builderArrayFormControl = require("@form-engine/builder-array-form-control");
var _builderArrayFormControlDefault = parcelHelpers.interopDefault(_builderArrayFormControl);
var _formatCase = require("@form-engine/core-util/format-case");
function BuilderFormEditorViewConstants() {
    const { state: constants = [], set } = (0, _useForm.useFormConstants)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
            className: "feb-main-col p-0",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderArrayFormControlDefault.default), {
                cols: {
                    id: {
                        label: 'Constant',
                        size: 200,
                        formatter: (0, _formatCase.formatResourceNameCase)
                    },
                    value: {
                        label: 'Value',
                        size: '33%'
                    },
                    notes: {
                        label: 'Notes',
                        size: 'auto'
                    }
                },
                value: constants,
                onChange: set
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/core-application/hooks/use-form":"5PZyy","react-bootstrap":"f5rnA","@form-engine/builder-array-form-control":"2zkEC","@form-engine/core-util/format-case":"2G0oK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3vR3Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderFormEngine);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _element = require("@form-engine/core-application/components/element");
var _elementDefault = parcelHelpers.interopDefault(_element);
var _engine = require("@form-engine/core-application/components/engine");
var _engineDefault = parcelHelpers.interopDefault(_engine);
var _index = require("@form-engine/core-application/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _dnd = require("../dnd");
var _useFormEditor = require("../../hooks/use-form-editor");
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _useElementDefault = parcelHelpers.interopDefault(_useElement);
var _container = require("@form-engine/core-application/components/container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _useDatasource = require("@form-engine/core-application/hooks/use-datasource");
var _dragImage = require("../dnd/drag-image");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _elementControls = require("./element-controls");
var _elementControlsDefault = parcelHelpers.interopDefault(_elementControls);
function BuilderFormEngineElement(props) {
    const { state } = (0, _useElementDefault.default)(props.id);
    const { state: editor, setItem } = (0, _useFormEditor.useFormEditorContext)();
    const isSelected = editor.selectedId === props.id;
    const toggle = (0, _react.useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        setItem('selectedId', isSelected ? undefined : props.id);
    }, [
        isSelected,
        setItem,
        props.id
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _elementDefault.default), {
        ...props,
        as: (0, _dnd.BuilderDragSource),
        source: state,
        dragImage: (0, _dragImage.getDragImageCanvas)(state?.name ?? ''),
        onClick: toggle,
        editMode: true,
        className: `${isSelected ? 'is-selected' : ''} ${props.className || ''}`,
        prepend: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.BuilderDropTarget), {
            id: props.id,
            parent: props.parent,
            placement: "before"
        }),
        append: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.BuilderDropTarget), {
                    id: props.id,
                    parent: props.parent,
                    placement: "after"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _elementControlsDefault.default), {
                    id: props.id
                })
            ]
        })
    });
}
function BuilderFormEngineContainer(props) {
    const { state: element } = (0, _useElement.useFormEngineElement)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _containerDefault.default), {
        ...props,
        className: `feb-fe-container ${props.className || ''}`,
        prepend: !props?.childElementIds?.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.BuilderDropTarget), {
            parent: element?.id,
            placement: "before"
        }) : undefined
    });
}
function LocaleUpdater() {
    const { state: editor } = (0, _useFormEditor.useFormEditorContext)();
    const { setItem: setSessionItem, state: session } = (0, _useFormsession.useFormSessionContext)();
    const resetDatasources = (0, _useDatasource.useInvalidateDatasourceData)();
    (0, _react.useEffect)(()=>{
        const locale = !editor?.translationLocale || editor?.canvasTab === 'edit' ? 'default' : editor?.translationLocale;
        if (session?.locals?.locale !== locale) {
            setSessionItem('locals', {
                ...session?.locals ?? {},
                locale
            });
            resetDatasources();
        }
    }, [
        editor?.translationLocale,
        editor?.canvasTab,
        setSessionItem,
        session,
        resetDatasources
    ]);
    return null;
}
function BuilderFormEngine({ editMode = 'edit' }) {
    const { state: editor } = (0, _useFormEditor.useFormEditorContext)();
    const value = (0, _react.useMemo)(()=>{
        if (editMode === 'edit') return {
            locals: {
                locale: 'default',
                environment: (0, _indexDefault.default).environment
            },
            editMode
        };
        return {
            locals: {
                locale: editor?.translationLocale ?? 'default',
                environment: (0, _indexDefault.default).environment
            },
            editMode
        };
    }, [
        editor?.translationLocale,
        editMode
    ]);
    const { state } = (0, _useForm.useFormContext)();
    const hasRootElements = (0, _react.useMemo)(()=>{
        return state?.elements?.find((element)=>!element?.parent);
    }, [
        state?.elements
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _engineDefault.default), {
        className: `feb-form-engine ${editor.isDragging ? 'is-dragging' : ''}`,
        elementComponent: BuilderFormEngineElement,
        containerComponent: BuilderFormEngineContainer,
        editMode: editMode,
        value: value,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(LocaleUpdater, {}),
                !hasRootElements && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.BuilderDropTarget), {
                    placement: "after"
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/core-application/components/element":"dt2u8","@form-engine/core-application/components/engine":"8IyYu","@form-engine/core-application/index":"fjN6J","../dnd":"1wcEC","../../hooks/use-form-editor":"4pkiD","@form-engine/core-application/hooks/use-element":"ehckF","@form-engine/core-application/components/container":"hxA8J","@form-engine/core-application/hooks/use-formsession":"2Th33","@form-engine/core-application/hooks/use-datasource":"lz7AL","../dnd/drag-image":"1iPvr","@form-engine/core-application/hooks/use-form":"5PZyy","./element-controls":"bHwgI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bHwgI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderFormEngineElementControls);
var _jsxRuntime = require("react/jsx-runtime");
var _builderIconButton = require("@form-engine/builder-icon-button");
var _builderIconButtonDefault = parcelHelpers.interopDefault(_builderIconButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _deleteSelection = require("../../actions/delete-selection");
var _deleteSelectionDefault = parcelHelpers.interopDefault(_deleteSelection);
var _copySelection = require("../../actions/copy-selection");
var _copySelectionDefault = parcelHelpers.interopDefault(_copySelection);
var _builderApplication = require("@form-engine/builder-application");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _pasteSelection = require("../../actions/paste-selection");
var _pasteSelectionDefault = parcelHelpers.interopDefault(_pasteSelection);
var _cutSelection = require("../../actions/cut-selection");
var _cutSelectionDefault = parcelHelpers.interopDefault(_cutSelection);
var _savePreset = require("../../actions/save-preset");
var _savePresetDefault = parcelHelpers.interopDefault(_savePreset);
function BuilderFormEngineElementControls({ id }) {
    const deleteSelection = (0, _deleteSelectionDefault.default)();
    const copySelection = (0, _copySelectionDefault.default)();
    const cutSelection = (0, _cutSelectionDefault.default)();
    const pasteAfter = (0, _pasteSelectionDefault.default)();
    const savePreset = (0, _savePresetDefault.default)();
    const useAction = (action)=>(e)=>{
            e.preventDefault();
            e.stopPropagation();
            action();
        };
    const { c } = (0, _builderApplication.i18n).prefix('elementControls.');
    const { state } = (0, _useForm.useFormElement)(id);
    const clipboardHasContents = Boolean((0, _copySelection.clipboard).targetId);
    const isInClipboard = (0, _copySelection.clipboard).targetId === state?.id;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "feb-element-controls d-flex flex-row",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderIconButtonDefault.default), {
                title: c('savePreset'),
                onClick: useAction(savePreset),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.CollectionFill), {})
            }),
            !isInClipboard && clipboardHasContents && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderIconButtonDefault.default), {
                onClick: useAction(pasteAfter),
                title: c('pasteElement'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ClipboardCheckFill), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderIconButtonDefault.default), {
                onClick: useAction(copySelection),
                title: c('copyElement'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ClipboardFill), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderIconButtonDefault.default), {
                onClick: useAction(cutSelection),
                title: c('cutElement'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.Scissors), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderIconButtonDefault.default), {
                onClick: useAction(deleteSelection),
                title: c('deleteElement'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.TrashFill), {})
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-icon-button":"1BXFC","react":"9njXz","react-bootstrap-icons":"3TzoC","../../actions/delete-selection":"a6CDx","../../actions/copy-selection":"6cY8I","@form-engine/builder-application":"7iKr0","@form-engine/core-application/hooks/use-form":"5PZyy","../../actions/paste-selection":"gJrW9","../../actions/cut-selection":"ikjgI","../../actions/save-preset":"5oXec","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cktQb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderOutlineDrawer);
var _jsxRuntime = require("react/jsx-runtime");
var _useFormEditor = require("../../hooks/use-form-editor");
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _useElementDefault = parcelHelpers.interopDefault(_useElement);
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dnd = require("../dnd");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _drawerNav = require("@form-engine/builder-application/components/drawer-nav");
var _drawerNavDefault = parcelHelpers.interopDefault(_drawerNav);
var _coreApplication = require("@form-engine/core-application");
var _coreApplicationDefault = parcelHelpers.interopDefault(_coreApplication);
var _elementList = require("@form-engine/core-util/element-list");
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
var _dragImage = require("../dnd/drag-image");
function useAutoExpandSelected() {
    const { state: { elements = [] } } = (0, _useForm.useFormContext)();
    const { state: { selectedId, outlineCollapseList = [] }, setItem } = (0, _useFormEditor.useFormEditorContext)();
    const [prevSelectedId, setPrevSelectedId] = (0, _react.useState)(selectedId);
    const ensureExpanded = (0, _react.useCallback)(()=>{
        if (!selectedId) return;
        const parents = (0, _elementList.getItemParents)(elements, selectedId).map(({ id })=>id);
        const collapseListUpdate = [];
        for (const id of outlineCollapseList)if (!parents.includes(id)) collapseListUpdate.push(id);
        setItem('outlineCollapseList', collapseListUpdate);
    }, [
        selectedId,
        outlineCollapseList,
        setItem,
        elements
    ]);
    (0, _react.useEffect)(()=>{
        if (!selectedId || prevSelectedId === selectedId) return;
        ensureExpanded();
        setPrevSelectedId(selectedId);
    }, [
        ensureExpanded,
        selectedId,
        prevSelectedId,
        setPrevSelectedId
    ]);
}
function OutlineNode({ id, ...props }) {
    const elementTypeIcons = (0, _react.useMemo)(()=>new Map(Object.entries((0, _builderApplicationDefault.default).elements).map(([key, def])=>[
                key,
                def.Icon
            ])), []);
    const elementTypeLabels = (0, _react.useMemo)(()=>new Map(Object.entries((0, _builderApplicationDefault.default).elements).map(([key, def])=>[
                key,
                def.label
            ])), []);
    const { state: { elements = [] } } = (0, _useForm.useFormContext)();
    const { state: currentElement, unsetItem } = (0, _useElementDefault.default)(id);
    const { state: { selectedId, outlineCollapseList: collapseList = [] }, setItem } = (0, _useFormEditor.useFormEditorContext)();
    useAutoExpandSelected();
    const isSelected = id === selectedId;
    const toggle = (0, _react.useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        setItem('selectedId', isSelected ? undefined : id);
    }, [
        isSelected,
        setItem,
        id
    ]);
    const toggleCollapse = (0, _react.useCallback)((force)=>{
        if (!id) return;
        const copy = [
            ...collapseList
        ];
        const index = copy.indexOf(id);
        if (index < 0) {
            if (force !== false) {
                copy.push(id);
                setItem('outlineCollapseList', copy);
            }
        } else if (force !== true) {
            copy.splice(index, 1);
            setItem('outlineCollapseList', copy);
        }
    }, [
        collapseList,
        setItem,
        id
    ]);
    const unset = (0, _react.useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        unsetItem();
    }, [
        unsetItem
    ]);
    const children = (0, _react.useMemo)(()=>{
        if (!id) return elements.filter((element)=>!element.parent);
        return elements.filter((element)=>element.parent === id);
    }, [
        elements,
        id
    ]);
    let label = '';
    let icon = null;
    if (currentElement) {
        const IconType = elementTypeIcons.get(currentElement.type) ?? null;
        if (IconType) icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconType, {});
        if (currentElement.name) label = currentElement.name;
        else if (currentElement.type) label = elementTypeLabels.get(currentElement.type) ?? currentElement.type;
        else label = 'Unnamed element';
    }
    const actions = /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        onClick: unset,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.X), {})
    });
    const collapse = id ? collapseList.includes(id) : false;
    const isContainer = currentElement && currentElement.type in (0, _coreApplicationDefault.default).getContainerElements();
    const containerContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isContainer && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.BuilderDropTarget), {
                placement: "before",
                parent: id
            }),
            !collapse && children.length > 0 && children.map((child)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(OutlineNode, {
                    id: child.id
                }, child.id))
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _drawerNav.BuilderDrawerNavItem), {
                ...props,
                wrap: currentElement ? 'div' : false,
                label: label,
                icon: icon,
                button: (0, _dnd.BuilderDragSource),
                buttonProps: {
                    as: 'button',
                    source: currentElement,
                    onClick: toggle,
                    dragImage: currentElement && (0, _dragImage.getDragImageCanvas)(currentElement?.name ?? 'Untitled')
                },
                active: isSelected,
                actions: actions,
                collapseable: children.length > 0,
                collapse: collapse,
                onToggleCollapse: toggleCollapse,
                children: [
                    !currentElement && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.BuilderDropTarget), {
                        placement: "before"
                    }),
                    containerContent
                ]
            }),
            currentElement && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.BuilderDropTarget), {
                id: id,
                parent: currentElement?.parent,
                placement: "after"
            })
        ]
    });
}
function BuilderOutlineDrawer() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerNavDefault.default), {
        className: "feb-outline-nav",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutlineNode, {})
    });
}

},{"react/jsx-runtime":"1dlk8","../../hooks/use-form-editor":"4pkiD","@form-engine/core-application/hooks/use-element":"ehckF","@form-engine/core-application/hooks/use-form":"5PZyy","react":"9njXz","../dnd":"1wcEC","react-bootstrap-icons":"3TzoC","@form-engine/builder-application/components/drawer-nav":"7m4Gf","@form-engine/core-application":"fjN6J","@form-engine/core-util/element-list":"e0ovy","@form-engine/builder-application":"7iKr0","../dnd/drag-image":"1iPvr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1M5zCH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderElementsDrawer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
var _drawerNav = require("@form-engine/builder-application/components/drawer-nav");
var _drawerNavDefault = parcelHelpers.interopDefault(_drawerNav);
var _useFormPresetApi = require("@form-engine/builder-application/hooks/use-form-preset-api");
var _presetButton = require("./preset-button");
var _presetButtonDefault = parcelHelpers.interopDefault(_presetButton);
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _formPresetDialog = require("../form-preset-dialog");
function PresetDrawerNavItem({ preset }) {
    const openDialog = (0, _formPresetDialog.useFormPresetDialog)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerNav.BuilderDrawerNavItem), {
        button: (0, _presetButtonDefault.default),
        actions: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
            onClick: ()=>openDialog(preset),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.PencilFill), {})
        }),
        buttonProps: {
            preset
        }
    });
}
function BuilderElementsDrawer() {
    const drawerButtons = (0, _react.useMemo)(()=>Object.values((0, _builderApplicationDefault.default).elements).filter((ns)=>ns.Element.enabled).map((ns)=>ns.DrawerButton).filter((Comp)=>Boolean(Comp)), []);
    const presets = (0, _useFormPresetApi.useFormPresetList)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _drawerNavDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerNav.BuilderDrawerNavHeader), {
                children: "Elements"
            }),
            drawerButtons.map((Comp, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerNav.BuilderDrawerNavItem), {
                    button: Comp
                }, index)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerNav.BuilderDrawerNavHeader), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "d-flex justify-content-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: "Presets"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: presets.loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Spinner), {
                                size: "sm"
                            })
                        })
                    ]
                })
            }),
            presets?.state?.map((preset)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(PresetDrawerNavItem, {
                    preset: preset
                }, preset.id))
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-application":"7iKr0","@form-engine/builder-application/components/drawer-nav":"7m4Gf","@form-engine/builder-application/hooks/use-form-preset-api":"dgb87","./preset-button":"dRCl0","react-bootstrap":"f5rnA","react-bootstrap-icons":"3TzoC","../form-preset-dialog":"lYEZP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dRCl0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderElementsDrawerPresetButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("./button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _formatCase = require("@form-engine/core-util/format-case");
function BuilderElementsDrawerPresetButton({ preset, ...props }) {
    const label = (0, _react.useMemo)(()=>(0, _formatCase.formatTitleCase)(preset?.name), [
        preset?.name
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
        ...props,
        preset: preset,
        dragLabel: label,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.CollectionFill), {}),
            " ",
            label
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./button":"lldAk","react-bootstrap-icons":"3TzoC","@form-engine/core-util/format-case":"2G0oK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lYEZP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderFormPresetDialog", ()=>BuilderFormPresetDialog);
parcelHelpers.export(exports, "useFormPresetDialog", ()=>useFormPresetDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _builderApplication = require("@form-engine/builder-application");
var _useFormPresetApi = require("@form-engine/builder-application/hooks/use-form-preset-api");
var _useFormPresetApiDefault = parcelHelpers.interopDefault(_useFormPresetApi);
var _modal = require("@form-engine/builder-application/components/modal");
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _dialog = require("@form-engine/builder-application/components/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _mask = require("./mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _useStore = require("@form-engine/core-application/hooks/use-store");
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _schema = require("./schema");
var _schemaDefault = parcelHelpers.interopDefault(_schema);
function BuilderFormPresetDialog({ preset, onSuccess, onError, ...props }) {
    const presetStore = (0, _useStore.useStore)(preset);
    const presetApi = (0, _useFormPresetApiDefault.default)();
    const schemaError = (0, _react.useMemo)(()=>{
        const parseResult = (0, _schemaDefault.default).safeParse(presetStore?.state);
        if (parseResult.success) return null;
        return parseResult.error;
    }, [
        presetStore?.state
    ]);
    const handleSubmit = (0, _react.useCallback)(async ()=>{
        if (schemaError) return;
        if (!presetStore?.state?.id) {
            onError?.(new Error('tried to save invalid form preset'));
            return;
        }
        try {
            const result = await presetApi.update(presetStore.state);
            (0, _useFormPresetApi.refreshFormPresets)();
            onSuccess?.(result);
        } catch (e) {
            onError?.(e);
        }
    }, [
        presetStore?.state,
        presetApi,
        onSuccess,
        onError,
        schemaError
    ]);
    const handleDelete = (0, _react.useCallback)(async ()=>{
        if (!preset?.id) return;
        if (await (0, _dialog.confirm)({
            children: (0, _builderApplication.i18n).c('form-editor.savePresetDialog.deleteMessage')
        })) try {
            await presetApi.delete(preset.id);
            (0, _useFormPresetApi.refreshFormPresets)();
            onSuccess?.(preset);
        } catch (e) {
            onError?.(e);
        }
    }, [
        preset?.id,
        presetApi,
        onSuccess,
        onError
    ]);
    const deleteButton = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Button), {
        size: "sm",
        variant: "danger",
        className: "me-auto",
        onClick: handleDelete,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.Trash2Fill), {}),
            " ",
            (0, _builderApplication.i18n).c('form-editor.savePresetDialog.deleteButton')
        ]
    });
    if (!presetStore) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.BuilderConfirmModal), {
        ...props,
        prependFooter: deleteButton,
        size: "lg",
        onConfirm: handleSubmit,
        disabled: Boolean(schemaError),
        title: (0, _builderApplication.i18n).c('form-editor.savePresetDialog.title'),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useMask.StoreMaskProvider), {
            store: presetStore,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _maskDefault.default), {})
        })
    });
}
async function openFormPresetDialog(preset) {
    try {
        return await (0, _dialogDefault.default)({
            as: BuilderFormPresetDialog,
            preset
        });
    } catch (e) {
        console.error(e);
        return preset;
    }
}
function useFormPresetDialog() {
    return (0, _react.useCallback)(openFormPresetDialog, []);
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-application":"7iKr0","@form-engine/builder-application/hooks/use-form-preset-api":"dgb87","@form-engine/builder-application/components/modal":"fvHxn","@form-engine/builder-mask/hooks/use-mask":"72MTY","@form-engine/builder-application/components/dialog":"e4X5a","./mask":"3EUPl","@form-engine/core-application/hooks/use-store":"llHXk","react-bootstrap":"f5rnA","react-bootstrap-icons":"3TzoC","./schema":"5AR5d","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9098t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InnerBuilderSettingsDrawer", ()=>InnerBuilderSettingsDrawer);
parcelHelpers.export(exports, "default", ()=>BuilderSettingsDrawer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormEditor = require("../../hooks/use-form-editor");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _useElement = require("@form-engine/core-application/hooks/use-element");
var _useElementDefault = parcelHelpers.interopDefault(_useElement);
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _formMask = require("../form-mask");
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
function InnerBuilderSettingsDrawer({ fallback: Fallback = (0, _formMask.BoundBuilderFormMask), editMode = 'edit' }) {
    const maskTypes = (0, _react.useMemo)(()=>Object.values((0, _builderApplicationDefault.default).elements).map((def)=>[
                def.Element,
                def.Mask
            ]), []);
    const { state: form } = (0, _useForm.useFormContext)();
    const { state: editor } = (0, _useFormEditor.useFormEditorContext)();
    const { selectedId: selectedElementId } = editor;
    const selectedElement = (0, _react.useMemo)(()=>{
        if (!selectedElementId) return null;
        return (form.elements || []).find((element)=>element.id === selectedElementId);
    }, [
        form.elements,
        selectedElementId
    ]);
    const Mask = (0, _react.useMemo)(()=>{
        if (!selectedElement) return null;
        const entry = maskTypes.find(([Element])=>Element.apiName === selectedElement.type);
        if (!entry) return null;
        return entry[1];
    }, [
        selectedElement
    ]);
    const element = (0, _useElementDefault.default)(selectedElementId || undefined);
    const setItemPropertyTranslation = (0, _react.useCallback)((propertyName, value)=>{
        const locale = editor?.translationLocale;
        if (editMode !== 'translate' || !locale || locale === 'default') return element.setItemProperty(propertyName, value);
        const locales = element?.state?.locales ?? {};
        return element.setItemProperty('locales', {
            ...locales,
            [locale]: {
                ...locales[locale] ?? {},
                [propertyName]: value
            }
        });
    }, [
        element,
        editMode,
        editor?.translationLocale
    ]);
    const elementApi = (0, _react.useMemo)(()=>({
            ...element,
            setItemProperty: setItemPropertyTranslation
        }), [
        element,
        setItemPropertyTranslation
    ]);
    const { setItem: setSessionItem, state: session } = (0, _useFormsession.useFormSessionContext)();
    (0, _react.useEffect)(()=>{
        const locale = editor?.canvasTab === 'edit' || !editor?.translationLocale ? 'default' : editor?.translationLocale;
        if (session?.locals?.locale !== locale) setSessionItem('locals', {
            ...session?.locals ?? {},
            locale
        });
    }, [
        editor?.translationLocale,
        editor?.canvasTab,
        setSessionItem,
        session?.locals
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "feb-view m-0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "feb-view-inner p-0",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "feb-properties-drawer",
                children: Mask ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useMask.MaskProvider), {
                    value: elementApi,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Mask, {
                        editMode: editMode
                    })
                }) : Fallback && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Fallback, {
                    editMode: editMode
                })
            })
        })
    });
}
function BuilderSettingsDrawer(props) {
    const { state: editor } = (0, _useFormEditor.useFormEditorContext)();
    const sessionData = (0, _react.useMemo)(()=>{
        return {
            locals: {
                locale: editor?.canvasTab === 'edit' || !editor?.translationLocale ? 'default' : editor?.translationLocale
            }
        };
    }, [
        editor?.translationLocale,
        editor?.canvasTab
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useFormsession.FormSessionProvider), {
        value: sessionData,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InnerBuilderSettingsDrawer, {
            ...props
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../hooks/use-form-editor":"4pkiD","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-application/hooks/use-element":"ehckF","@form-engine/builder-mask/hooks/use-mask":"72MTY","../form-mask":"8AYSd","@form-engine/builder-application":"7iKr0","@form-engine/core-application/hooks/use-formsession":"2Th33","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8AYSd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderFormMask);
parcelHelpers.export(exports, "BoundBuilderFormMask", ()=>BoundBuilderFormMask);
var _jsxRuntime = require("react/jsx-runtime");
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mask = require("@form-engine/builder-mask/components/mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _array = require("@form-engine/builder-mask/components/properties/array");
var _arrayDefault = parcelHelpers.interopDefault(_array);
var _boolean = require("@form-engine/builder-mask/components/properties/boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
var _code = require("@form-engine/builder-mask/components/properties/code");
var _codeDefault = parcelHelpers.interopDefault(_code);
var _slug = require("@form-engine/builder-mask/components/properties/slug");
var _slugDefault = parcelHelpers.interopDefault(_slug);
var _string = require("@form-engine/builder-mask/components/properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _useFormResources = require("@form-engine/core-application/hooks/use-form-resources");
var _tags = require("@form-engine/builder-mask/components/properties/tags");
var _tagsDefault = parcelHelpers.interopDefault(_tags);
var _builderApplication = require("@form-engine/builder-application");
function BuilderFormMask(props) {
    const { state } = (0, _useMask.useMaskContext)();
    const { c } = (0, _builderApplication.i18n).prefix('mask.BuilderFormMask.');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _maskDefault.default), {
        id: "BuilderFormMask",
        general: false,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "name",
                        label: c('name')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "published",
                        label: c('published')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slugDefault.default), {
                        defaultValue: state?.id
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagsDefault.default), {
                        stacked: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupDefault.default), {
                label: c('behaviourGroupTitle'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                    propertyName: "showValidFeedback",
                    label: c('showValidFeedback'),
                    defaultValue: true
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                label: c('customizationGroupTitle'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "includeCoreResources",
                        label: c('includeCoreResources'),
                        defaultValue: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "includeBootstrapCdn",
                        label: c('includeBootstrapCdn'),
                        defaultValue: true
                    }),
                    state?.includeBootstrapCdn !== false && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        propertyName: "bootstrapCdnUrl",
                        label: c('bootstrapCdnUrl'),
                        placeholder: (0, _useFormResources.DEFAULT_BOOTSTRAP_CDN_URL)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrayDefault.default), {
                        propertyName: "resources",
                        label: c('resources'),
                        cols: {
                            url: c('resourcesUrl')
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _codeDefault.default), {
                        language: "css",
                        propertyName: "stylesheet",
                        label: c('stylesheet'),
                        offCanvas: true
                    })
                ]
            })
        ]
    });
}
function BoundBuilderFormMask(props) {
    const { state, set: setItem, setItem: setStateItem } = (0, _useForm.useFormContext)();
    const setItemProperty = (0, _react.useCallback)((key, value)=>{
        setStateItem(key, value);
    }, [
        setStateItem
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useMask.MaskProvider), {
        value: {
            state,
            setItem,
            setItemProperty
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormMask, {
            ...props
        })
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-mask/hooks/use-mask":"72MTY","@form-engine/core-application/hooks/use-form":"5PZyy","react":"9njXz","@form-engine/builder-mask/components/mask":"kcLv4","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/properties/array":"iNhep","@form-engine/builder-mask/components/properties/boolean":"k2UVH","@form-engine/builder-mask/components/properties/code":"3j0at","@form-engine/builder-mask/components/properties/slug":"5dBfG","@form-engine/builder-mask/components/properties/string":"e6M7S","@form-engine/core-application/hooks/use-form-resources":"5sq5X","@form-engine/builder-mask/components/properties/tags":"e1XYL","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iNhep":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderArrayProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _property = require("../mask/property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _useMask = require("../../hooks/use-mask");
var _builderArrayFormControl = require("@form-engine/builder-array-form-control");
var _builderArrayFormControlDefault = parcelHelpers.interopDefault(_builderArrayFormControl);
var _useMaskConfig = require("../../hooks/use-mask-config");
var _useMaskValidation = require("../../hooks/use-mask-validation");
function BuilderArrayProperty({ label, propertyName, defaultValue = [], schema, cols, ...props }) {
    const { state, setItemProperty } = (0, _useMask.useMaskContext)();
    const value = Array.isArray(state?.[propertyName]) ? state?.[propertyName] : defaultValue;
    const permission = (0, _useMaskConfig.useMaskPropertyPermission)(propertyName);
    const error = (0, _useMaskValidation.useMaskPropertyError)(propertyName);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertyDefault.default), {
        className: "feb-array-property",
        stacked: true,
        label: label,
        error: error?.message,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderArrayFormControlDefault.default), {
            schema: schema,
            cols: cols,
            value: value,
            disabled: permission === 'read',
            onChange: (update)=>setItemProperty(propertyName, update)
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../mask/property":"dLorN","../../hooks/use-mask":"72MTY","@form-engine/builder-array-form-control":"2zkEC","../../hooks/use-mask-config":"daHU1","../../hooks/use-mask-validation":"cYKiY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5dBfG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderSlugProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _formatSlug = require("@form-engine/core-util/format-slug");
var _formatSlugDefault = parcelHelpers.interopDefault(_formatSlug);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _string = require("./string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _builderApplication = require("@form-engine/builder-application");
function BuilderSlugProperty(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
        label: (0, _builderApplication.i18n).c('mask.slugProperty.title'),
        formatter: (0, _formatSlugDefault.default),
        ...props,
        propertyName: props.propertyName ?? 'slug'
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/core-util/format-slug":"kvqXE","react":"9njXz","./string":"e6M7S","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kvqXE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatSlug);
const slugPatterns = {
    '\u00fc': 'ue',
    '\u00e4': 'ae',
    '\u00f6': 'oe',
    '\u00df': 'ss',
    ' ': '+'
};
const formatRegexp = new RegExp(Object.keys(slugPatterns).join('|'), 'gi');
function formatSlug(source) {
    let result = String(source || '').toLowerCase().trim();
    result = result.replace(formatRegexp, (matched)=>slugPatterns[matched]);
    result = result.replace(/[^a-zA-Z0-9+-_]/g, '');
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e1XYL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderTagsProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _property = require("../mask/property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _useMask = require("../../hooks/use-mask");
var _select = require("@form-engine/builder-application/components/select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _useMaskConfig = require("../../hooks/use-mask-config");
var _builderApplication = require("@form-engine/builder-application");
var _useMaskValidation = require("../../hooks/use-mask-validation");
function BuilderTagsProperty({ label = (0, _builderApplication.i18n).c('mask.tagsProperty.title'), propertyName = 'tags', options = [], defaultValue = [], ...props }) {
    const stacked = 'stacked' in props && props.stacked !== false;
    delete props.stacked;
    const { state, setItemProperty } = (0, _useMask.useMaskContext)();
    const required = 'required' in props && props.required !== false;
    delete props.required;
    const value = Array.isArray(state?.[propertyName]) ? state?.[propertyName] : [
        ...defaultValue
    ];
    const tagOptions = (0, _react.useMemo)(()=>(options ?? []).map((value)=>({
                value,
                label: value
            })), [
        options
    ]);
    const handleChange = (0, _react.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        const { action } = event?.actionMeta ?? {};
        if (action === 'create-option') {
            const createValue = event?.actionMeta?.option?.value;
            if (createValue && !value.includes(createValue)) setItemProperty(propertyName, [
                ...value,
                createValue
            ]);
        } else if (action === 'remove-value') {
            const removedValue = event?.actionMeta?.removedValue?.value;
            const index = value.indexOf(removedValue);
            if (index > -1) {
                const copy = [
                    ...value
                ];
                copy.splice(index, 1);
                setItemProperty(propertyName, copy);
            }
        } else if (action === 'clear') setItemProperty(propertyName, []);
    }, [
        state,
        propertyName,
        setItemProperty,
        value
    ]);
    const permission = (0, _useMaskConfig.useMaskPropertyPermission)(propertyName);
    const error = (0, _useMaskValidation.useMaskPropertyError)(propertyName);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertyDefault.default), {
        className: "feb-enum-property",
        label: label,
        error: error?.message,
        stacked: stacked,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "flex-grow-1",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default).Advanced, {
                creatable: true,
                className: "text-xs",
                value: value.map((value)=>({
                        value,
                        label: value
                    })),
                onChange: handleChange,
                placeholder: (0, _builderApplication.i18n).c('mask.tagsProperty.placeholder'),
                options: tagOptions,
                isMulti: true,
                required: required,
                isDisabled: permission === 'read'
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../mask/property":"dLorN","../../hooks/use-mask":"72MTY","@form-engine/builder-application/components/select":"38vFU","../../hooks/use-mask-config":"daHU1","@form-engine/builder-application":"7iKr0","../../hooks/use-mask-validation":"cYKiY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fhe3j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderSessionTree", ()=>BuilderSessionTree);
parcelHelpers.export(exports, "default", ()=>BuilderSessionDrawer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _engine = require("@form-engine/core-application/components/engine");
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _useFormRemoteState = require("@form-engine/core-application/hooks/use-form-remote-state");
var _useFormRemoteStateDefault = parcelHelpers.interopDefault(_useFormRemoteState);
var _tree = require("@form-engine/builder-application/components/tree");
var _useFormEditor = require("../../hooks/use-form-editor");
var _builderIconButton = require("@form-engine/builder-icon-button");
var _builderIconButtonDefault = parcelHelpers.interopDefault(_builderIconButton);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _reactToastify = require("react-toastify");
function ClipboardBtn({ value }) {
    const handleClick = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        value && navigator.clipboard.writeText(value);
        (0, _reactToastify.toast)(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: "copied to clipboard"
        }));
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderIconButtonDefault.default), {
        as: "span",
        title: value,
        onClick: handleClick,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.Clipboard), {})
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function generateScopeNode(key, value, path) {
    let label = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClipboardBtn, {
                value: `{{${path}}}`
            }),
            " ",
            key
        ]
    });
    if (typeof value !== 'object') label = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClipboardBtn, {
                        value: `{{${path}}}`
                    }),
                    " ",
                    key,
                    ":"
                ]
            }),
            ' ',
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "feb-tree-node-value",
                children: JSON.stringify(value)
            })
        ]
    });
    return {
        label
    };
}
function BuilderSessionTree() {
    const locals = (0, _useFormsession.useFormSessionLocals)();
    const { setItem, state } = (0, _useFormEditor.useFormEditorContext)();
    const handleToggleItem = (0, _react.useCallback)((id, force)=>{
        const copy = [
            ...state?.sessionDrawerState || []
        ];
        const index = copy.indexOf(id);
        if (force !== false && index < 0) copy.push(id);
        else if (force !== true && index > -1) copy.splice(index, 1);
        setItem('sessionDrawerState', copy);
    }, [
        state?.sessionDrawerState,
        setItem
    ]);
    const nodes = (0, _tree.useBuilderTreeNodes)(locals?.state ?? {}, generateScopeNode);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "feb-view m-0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "feb-view-inner p-0",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "feb-properties-drawer",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.BuilderTree), {
                    nodes: nodes,
                    state: state?.sessionDrawerState,
                    onToggle: handleToggleItem
                })
            })
        })
    });
}
function BuilderSessionDrawer({ remote }) {
    const formRemoteState = (0, _useFormRemoteStateDefault.default)(remote);
    if (!formRemoteState) return null;
    const { form, session, workflow } = formRemoteState;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _engine.FormEngineStateProvider), {
        form: form.state,
        session: session.state,
        workflow: workflow.state,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderSessionTree, {})
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/core-application/components/engine":"8IyYu","@form-engine/core-application/hooks/use-formsession":"2Th33","@form-engine/core-application/hooks/use-form-remote-state":"ctrOj","@form-engine/builder-application/components/tree":"f7P3O","../../hooks/use-form-editor":"4pkiD","@form-engine/builder-icon-button":"1BXFC","react-bootstrap-icons":"3TzoC","react-toastify":"iWdY7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ctrOj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useFormRemoteState);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function useFormRemoteState(ref) {
    const [remoteState, setRemoteState] = (0, _react.useState)();
    (0, _react.useEffect)(()=>{
        if (!ref || !ref.current) {
            setRemoteState(undefined);
            return;
        }
        let mounted = true;
        const listener = (state)=>{
            if (!mounted) return;
            if (state) setRemoteState({
                ...state
            });
            else setRemoteState(undefined);
        };
        ref?.current?.subscribe(listener);
        listener(ref?.current);
        return ()=>{
            mounted = false;
            setRemoteState(undefined);
            if (ref && ref.current) ref.current.unsubscribe(listener);
        };
    }, [
        ref?.current,
        setRemoteState
    ]);
    return remoteState;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f7P3O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBuilderTreeNodes", ()=>useBuilderTreeNodes);
parcelHelpers.export(exports, "BuilderTreeNode", ()=>BuilderTreeNode);
parcelHelpers.export(exports, "BuilderTree", ()=>BuilderTree);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrapIcons = require("react-bootstrap-icons");
function useBuilderTreeNodes(data, transformer) {
    return (0, _react.useMemo)(()=>{
        const nodes = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function traverse(state, parent) {
            if (Array.isArray(state)) state.forEach((item, index)=>{
                const id = `${parent ?? ''}[${index}]`;
                const node = {
                    label: String(index),
                    ...transformer ? transformer(index, item, id) : {},
                    id,
                    parent,
                    $data: item
                };
                nodes.push(node);
                traverse(item, node.id);
            });
            else if (typeof state === 'object' && state) for (const [key, value] of Object.entries(state)){
                const id = `${parent ? `${parent}.` : ''}${key}`;
                const node = {
                    label: key,
                    ...transformer ? transformer(key, value, id) : {},
                    id,
                    parent,
                    $data: value
                };
                nodes.push(node);
                traverse(value, node.id);
            }
        }
        traverse(data);
        return nodes;
    }, [
        data,
        transformer
    ]);
}
function BuilderTreeNode({ as: Component = 'li', id, children, label, expanded, onToggle }) {
    const handleToggle = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        onToggle?.(id, !expanded);
    }, [
        onToggle,
        id,
        expanded
    ]);
    let labelContent = label;
    if (children) labelContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        className: "feb-tree-collapse-btn",
        onClick: handleToggle,
        children: [
            expanded ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.CaretDown), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.CaretRight), {}),
            label
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Component, {
        className: `feb-tree-item ${expanded ? 'feb-tree-item--expanded' : ''}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "feb-tree-item__label",
                children: labelContent
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "feb-tree-item__children",
                children: children
            })
        ]
    });
}
function BuilderTree({ as: Component = 'ul', nodes, node: NodeComponent = BuilderTreeNode, state, onToggle }) {
    const traverse = (0, _react.useCallback)((parent)=>{
        const children = nodes?.filter((node)=>parent === node.parent) ?? [];
        return children.map((child)=>{
            let children;
            const childListItems = traverse(child.id);
            if (childListItems.length) children = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                className: "feb-tree-level",
                children: childListItems
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NodeComponent, {
                id: child.id,
                label: child.label,
                expanded: state?.includes(child.id),
                onToggle: onToggle,
                children: children
            }, child.id);
        });
    }, [
        nodes,
        NodeComponent,
        state,
        onToggle,
        Component
    ]);
    if (!nodes) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        className: "feb-tree feb-tree-level",
        children: traverse()
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap-icons":"3TzoC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8l9ux":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderFormEditorPreviewFormEngine", ()=>BuilderFormEditorPreviewFormEngine);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _engine = require("@form-engine/core-application/components/engine");
var _engineDefault = parcelHelpers.interopDefault(_engine);
var _index = require("@form-engine/core-application/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _useFormEditor = require("../../hooks/use-form-editor");
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _useDatasource = require("@form-engine/core-application/hooks/use-datasource");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _formToImage = require("./form-to-image");
function PreviewSessionUpdater({ dirty: dirtyProp = false, onWrite }) {
    const { state: session, setItem: setSessionItem } = (0, _useFormsession.useFormSessionContext)();
    const { state: { previewSettings = {} } } = (0, _useFormEditor.useFormEditorContext)();
    const resetDatasources = (0, _useDatasource.useInvalidateDatasourceData)();
    (0, _react.useEffect)(()=>{
        const { auth, basicAuthUsername, basicAuthPassword, bearerToken, customVariables } = previewSettings;
        const request = {
            ...session?.request || {},
            headers: {
                ...session?.request?.headers || {}
            }
        };
        if (auth === 'basic') request.headers.authorization = `Basic ${btoa(`${basicAuthUsername}:${basicAuthPassword}`)}`;
        else if (auth === 'bearer') request.headers.authorization = `Bearer ${bearerToken}`;
        let dirty = dirtyProp;
        if (session?.request?.headers?.authorization !== request?.headers?.authorization) {
            setSessionItem('request', request);
            dirty = true;
        }
        const localsUpdate = {};
        let hasDirtyLocals = dirtyProp;
        if (Array.isArray(customVariables)) {
            for (const { key, value } of customVariables)if (key && value && session?.locals?.[key] !== value) {
                localsUpdate[key] = value;
                hasDirtyLocals = true;
            }
        }
        if (hasDirtyLocals) {
            dirty = true;
            setSessionItem('locals', {
                ...session?.locals ?? {},
                ...localsUpdate
            });
        }
        if (dirty) resetDatasources();
        if (dirty || hasDirtyLocals) onWrite?.();
    }, [
        previewSettings,
        session,
        setSessionItem,
        resetDatasources,
        dirtyProp,
        onWrite
    ]);
    return null;
}
function FormThumbnailUpdater() {
    const ref = (0, _react.useRef)(null);
    const { state, setItem } = (0, _useForm.useFormContext)();
    const currentTimeoutRef = (0, _react.useRef)(undefined);
    (0, _react.useEffect)(()=>{
        let mounted = true;
        const target = ref?.current?.closest('form.fe');
        if (!target) return;
        if (currentTimeoutRef.current) clearTimeout(currentTimeoutRef.current);
        currentTimeoutRef.current = setTimeout(()=>{
            (0, _formToImage.formToImage)(target).then((dataUrl)=>{
                if (!mounted) return;
                setItem('thumbnail', dataUrl);
            });
            currentTimeoutRef.current = undefined;
        }, 500);
        return ()=>{
            mounted = false;
        };
    }, [
        state?.elements,
        setItem
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            visibility: 'hidden'
        },
        ref: ref
    });
}
function LocaleUpdater() {
    const { state: editor } = (0, _useFormEditor.useFormEditorContext)();
    const { setItem: setSessionItem, state: session } = (0, _useFormsession.useFormSessionContext)();
    const resetDatasources = (0, _useDatasource.useInvalidateDatasourceData)();
    (0, _react.useEffect)(()=>{
        const locale = editor?.translationLocale || 'default';
        if (locale !== session?.locals?.locale) {
            setSessionItem('locals', {
                ...session?.locals ?? {},
                locale
            });
            resetDatasources();
        }
    }, [
        editor?.translationLocale,
        setSessionItem,
        session,
        resetDatasources
    ]);
    return null;
}
function BuilderFormEditorPreviewFormEngine({ value: initialValue, children, ...props }) {
    const { state: editor } = (0, _useFormEditor.useFormEditorContext)();
    const [dirty, setDirty] = (0, _react.useState)(false);
    const value = (0, _react.useMemo)(()=>{
        return {
            ...initialValue ?? {},
            locals: {
                ...initialValue?.locals ?? {},
                locale: editor?.translationLocale ?? 'default',
                environment: (0, _indexDefault.default).environment
            },
            editMode: 'preview'
        };
    }, [
        editor?.translationLocale,
        initialValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _engineDefault.default), {
        ...props,
        value: value,
        onReset: ()=>setDirty(true),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PreviewSessionUpdater, {
                    dirty: dirty,
                    onWrite: ()=>setDirty(false)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(LocaleUpdater, {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormThumbnailUpdater, {}),
                children
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/core-application/components/engine":"8IyYu","@form-engine/core-application/index":"fjN6J","../../hooks/use-form-editor":"4pkiD","@form-engine/core-application/hooks/use-formsession":"2Th33","@form-engine/core-application/hooks/use-datasource":"lz7AL","@form-engine/core-application/hooks/use-form":"5PZyy","./form-to-image":"529iv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"529iv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formToImage", ()=>formToImage);
var _htmlToImage = require("html-to-image");
async function formToImage(root, options = {}) {
    const { domWidth = 1024, domHeight = 576, width = 240, height = 135, quality = 0.6 } = options;
    const container = document.createElement('div');
    Object.assign(container.style, {
        position: 'fixed',
        top: 0,
        left: 0,
        height: 0,
        width: 0,
        overflow: 'hidden'
    });
    document.body.appendChild(container);
    const frame = document.createElement('div');
    Object.assign(frame.style, {
        width: `${domWidth}px`,
        height: `${domHeight}px`,
        background: 'var(--bs-gray-200)',
        padding: '30px',
        overflow: 'hidden'
    });
    const form = root.cloneNode(true);
    form.classList.toggle('is-initialized', true);
    frame.appendChild(form);
    container.appendChild(frame);
    const img = await (0, _htmlToImage.toJpeg)(frame, {
        canvasWidth: width,
        canvasHeight: height,
        quality
    });
    // console.log('%c ', `font-size:240px; background:url('${img}') no-repeat; background-size: contain;`);
    // console.log(img);
    document.body.removeChild(container);
    return img;
}

},{"html-to-image":"dIhcm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dIhcm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toSvg", ()=>toSvg);
parcelHelpers.export(exports, "toCanvas", ()=>toCanvas);
parcelHelpers.export(exports, "toPixelData", ()=>toPixelData);
parcelHelpers.export(exports, "toPng", ()=>toPng);
parcelHelpers.export(exports, "toJpeg", ()=>toJpeg);
parcelHelpers.export(exports, "toBlob", ()=>toBlob);
parcelHelpers.export(exports, "getFontEmbedCSS", ()=>getFontEmbedCSS);
var _cloneNode = require("./clone-node");
var _embedImages = require("./embed-images");
var _applyStyle = require("./apply-style");
var _embedWebfonts = require("./embed-webfonts");
var _util = require("./util");
async function toSvg(node, options = {}) {
    const { width, height } = (0, _util.getImageSize)(node, options);
    const clonedNode = await (0, _cloneNode.cloneNode)(node, options, true);
    await (0, _embedWebfonts.embedWebFonts)(clonedNode, options);
    await (0, _embedImages.embedImages)(clonedNode, options);
    (0, _applyStyle.applyStyle)(clonedNode, options);
    const datauri = await (0, _util.nodeToDataURL)(clonedNode, width, height);
    return datauri;
}
async function toCanvas(node, options = {}) {
    const { width, height } = (0, _util.getImageSize)(node, options);
    const svg = await toSvg(node, options);
    const img = await (0, _util.createImage)(svg);
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const ratio = options.pixelRatio || (0, _util.getPixelRatio)();
    const canvasWidth = options.canvasWidth || width;
    const canvasHeight = options.canvasHeight || height;
    canvas.width = canvasWidth * ratio;
    canvas.height = canvasHeight * ratio;
    if (!options.skipAutoScale) (0, _util.checkCanvasDimensions)(canvas);
    canvas.style.width = `${canvasWidth}`;
    canvas.style.height = `${canvasHeight}`;
    if (options.backgroundColor) {
        context.fillStyle = options.backgroundColor;
        context.fillRect(0, 0, canvas.width, canvas.height);
    }
    context.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas;
}
async function toPixelData(node, options = {}) {
    const { width, height } = (0, _util.getImageSize)(node, options);
    const canvas = await toCanvas(node, options);
    const ctx = canvas.getContext('2d');
    return ctx.getImageData(0, 0, width, height).data;
}
async function toPng(node, options = {}) {
    const canvas = await toCanvas(node, options);
    return canvas.toDataURL();
}
async function toJpeg(node, options = {}) {
    const canvas = await toCanvas(node, options);
    return canvas.toDataURL('image/jpeg', options.quality || 1);
}
async function toBlob(node, options = {}) {
    const canvas = await toCanvas(node, options);
    const blob = await (0, _util.canvasToBlob)(canvas);
    return blob;
}
async function getFontEmbedCSS(node, options = {}) {
    return (0, _embedWebfonts.getWebFontCSS)(node, options);
}

},{"./clone-node":"2lT34","./embed-images":"3WIDE","./apply-style":"13cvB","./embed-webfonts":"2KlRp","./util":"ko58M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2lT34":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cloneNode", ()=>cloneNode);
var _clonePseudos = require("./clone-pseudos");
var _util = require("./util");
var _mimes = require("./mimes");
var _dataurl = require("./dataurl");
async function cloneCanvasElement(canvas) {
    const dataURL = canvas.toDataURL();
    if (dataURL === 'data:,') return canvas.cloneNode(false);
    return (0, _util.createImage)(dataURL);
}
async function cloneVideoElement(video, options) {
    if (video.currentSrc) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = video.clientWidth;
        canvas.height = video.clientHeight;
        ctx === null || ctx === void 0 || ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataURL = canvas.toDataURL();
        return (0, _util.createImage)(dataURL);
    }
    const poster = video.poster;
    const contentType = (0, _mimes.getMimeType)(poster);
    const dataURL = await (0, _dataurl.resourceToDataURL)(poster, contentType, options);
    return (0, _util.createImage)(dataURL);
}
async function cloneIFrameElement(iframe, options) {
    var _a;
    try {
        if ((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.body) return await cloneNode(iframe.contentDocument.body, options, true);
    } catch (_b) {
    // Failed to clone iframe
    }
    return iframe.cloneNode(false);
}
async function cloneSingleNode(node, options) {
    if ((0, _util.isInstanceOfElement)(node, HTMLCanvasElement)) return cloneCanvasElement(node);
    if ((0, _util.isInstanceOfElement)(node, HTMLVideoElement)) return cloneVideoElement(node, options);
    if ((0, _util.isInstanceOfElement)(node, HTMLIFrameElement)) return cloneIFrameElement(node, options);
    return node.cloneNode(isSVGElement(node));
}
const isSlotElement = (node)=>node.tagName != null && node.tagName.toUpperCase() === 'SLOT';
const isSVGElement = (node)=>node.tagName != null && node.tagName.toUpperCase() === 'SVG';
async function cloneChildren(nativeNode, clonedNode, options) {
    var _a, _b;
    if (isSVGElement(clonedNode)) return clonedNode;
    let children = [];
    if (isSlotElement(nativeNode) && nativeNode.assignedNodes) children = (0, _util.toArray)(nativeNode.assignedNodes());
    else if ((0, _util.isInstanceOfElement)(nativeNode, HTMLIFrameElement) && ((_a = nativeNode.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) children = (0, _util.toArray)(nativeNode.contentDocument.body.childNodes);
    else children = (0, _util.toArray)(((_b = nativeNode.shadowRoot) !== null && _b !== void 0 ? _b : nativeNode).childNodes);
    if (children.length === 0 || (0, _util.isInstanceOfElement)(nativeNode, HTMLVideoElement)) return clonedNode;
    await children.reduce((deferred, child)=>deferred.then(()=>cloneNode(child, options)).then((clonedChild)=>{
            if (clonedChild) clonedNode.appendChild(clonedChild);
        }), Promise.resolve());
    return clonedNode;
}
function cloneCSSStyle(nativeNode, clonedNode, options) {
    const targetStyle = clonedNode.style;
    if (!targetStyle) return;
    const sourceStyle = window.getComputedStyle(nativeNode);
    if (sourceStyle.cssText) {
        targetStyle.cssText = sourceStyle.cssText;
        targetStyle.transformOrigin = sourceStyle.transformOrigin;
    } else (0, _util.getStyleProperties)(options).forEach((name)=>{
        let value = sourceStyle.getPropertyValue(name);
        if (name === 'font-size' && value.endsWith('px')) {
            const reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
            value = `${reducedFont}px`;
        }
        if ((0, _util.isInstanceOfElement)(nativeNode, HTMLIFrameElement) && name === 'display' && value === 'inline') value = 'block';
        if (name === 'd' && clonedNode.getAttribute('d')) value = `path(${clonedNode.getAttribute('d')})`;
        targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
    });
}
function cloneInputValue(nativeNode, clonedNode) {
    if ((0, _util.isInstanceOfElement)(nativeNode, HTMLTextAreaElement)) clonedNode.innerHTML = nativeNode.value;
    if ((0, _util.isInstanceOfElement)(nativeNode, HTMLInputElement)) clonedNode.setAttribute('value', nativeNode.value);
}
function cloneSelectValue(nativeNode, clonedNode) {
    if ((0, _util.isInstanceOfElement)(nativeNode, HTMLSelectElement)) {
        const clonedSelect = clonedNode;
        const selectedOption = Array.from(clonedSelect.children).find((child)=>nativeNode.value === child.getAttribute('value'));
        if (selectedOption) selectedOption.setAttribute('selected', '');
    }
}
function decorate(nativeNode, clonedNode, options) {
    if ((0, _util.isInstanceOfElement)(clonedNode, Element)) {
        cloneCSSStyle(nativeNode, clonedNode, options);
        (0, _clonePseudos.clonePseudoElements)(nativeNode, clonedNode, options);
        cloneInputValue(nativeNode, clonedNode);
        cloneSelectValue(nativeNode, clonedNode);
    }
    return clonedNode;
}
async function ensureSVGSymbols(clone, options) {
    const uses = clone.querySelectorAll ? clone.querySelectorAll('use') : [];
    if (uses.length === 0) return clone;
    const processedDefs = {};
    for(let i = 0; i < uses.length; i++){
        const use = uses[i];
        const id = use.getAttribute('xlink:href');
        if (id) {
            const exist = clone.querySelector(id);
            const definition = document.querySelector(id);
            if (!exist && definition && !processedDefs[id]) // eslint-disable-next-line no-await-in-loop
            processedDefs[id] = await cloneNode(definition, options, true);
        }
    }
    const nodes = Object.values(processedDefs);
    if (nodes.length) {
        const ns = 'http://www.w3.org/1999/xhtml';
        const svg = document.createElementNS(ns, 'svg');
        svg.setAttribute('xmlns', ns);
        svg.style.position = 'absolute';
        svg.style.width = '0';
        svg.style.height = '0';
        svg.style.overflow = 'hidden';
        svg.style.display = 'none';
        const defs = document.createElementNS(ns, 'defs');
        svg.appendChild(defs);
        for(let i = 0; i < nodes.length; i++)defs.appendChild(nodes[i]);
        clone.appendChild(svg);
    }
    return clone;
}
async function cloneNode(node, options, isRoot) {
    if (!isRoot && options.filter && !options.filter(node)) return null;
    return Promise.resolve(node).then((clonedNode)=>cloneSingleNode(clonedNode, options)).then((clonedNode)=>cloneChildren(node, clonedNode, options)).then((clonedNode)=>decorate(node, clonedNode, options)).then((clonedNode)=>ensureSVGSymbols(clonedNode, options));
}

},{"./clone-pseudos":"YN9jd","./util":"ko58M","./mimes":"31ZUq","./dataurl":"6Cs6t","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"YN9jd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clonePseudoElements", ()=>clonePseudoElements);
var _util = require("./util");
function formatCSSText(style) {
    const content = style.getPropertyValue('content');
    return `${style.cssText} content: '${content.replace(/'|"/g, '')}';`;
}
function formatCSSProperties(style, options) {
    return (0, _util.getStyleProperties)(options).map((name)=>{
        const value = style.getPropertyValue(name);
        const priority = style.getPropertyPriority(name);
        return `${name}: ${value}${priority ? ' !important' : ''};`;
    }).join(' ');
}
function getPseudoElementStyle(className, pseudo, style, options) {
    const selector = `.${className}:${pseudo}`;
    const cssText = style.cssText ? formatCSSText(style) : formatCSSProperties(style, options);
    return document.createTextNode(`${selector}{${cssText}}`);
}
function clonePseudoElement(nativeNode, clonedNode, pseudo, options) {
    const style = window.getComputedStyle(nativeNode, pseudo);
    const content = style.getPropertyValue('content');
    if (content === '' || content === 'none') return;
    const className = (0, _util.uuid)();
    try {
        clonedNode.className = `${clonedNode.className} ${className}`;
    } catch (err) {
        return;
    }
    const styleElement = document.createElement('style');
    styleElement.appendChild(getPseudoElementStyle(className, pseudo, style, options));
    clonedNode.appendChild(styleElement);
}
function clonePseudoElements(nativeNode, clonedNode, options) {
    clonePseudoElement(nativeNode, clonedNode, ':before', options);
    clonePseudoElement(nativeNode, clonedNode, ':after', options);
}

},{"./util":"ko58M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ko58M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveUrl", ()=>resolveUrl);
parcelHelpers.export(exports, "uuid", ()=>uuid);
parcelHelpers.export(exports, "delay", ()=>delay);
parcelHelpers.export(exports, "toArray", ()=>toArray);
parcelHelpers.export(exports, "getStyleProperties", ()=>getStyleProperties);
parcelHelpers.export(exports, "getImageSize", ()=>getImageSize);
parcelHelpers.export(exports, "getPixelRatio", ()=>getPixelRatio);
parcelHelpers.export(exports, "checkCanvasDimensions", ()=>checkCanvasDimensions);
parcelHelpers.export(exports, "canvasToBlob", ()=>canvasToBlob);
parcelHelpers.export(exports, "createImage", ()=>createImage);
parcelHelpers.export(exports, "svgToDataURL", ()=>svgToDataURL);
parcelHelpers.export(exports, "nodeToDataURL", ()=>nodeToDataURL);
parcelHelpers.export(exports, "isInstanceOfElement", ()=>isInstanceOfElement);
var process = require("62fb822691d6ba40");
function resolveUrl(url, baseUrl) {
    // url is absolute already
    if (url.match(/^[a-z]+:\/\//i)) return url;
    // url is absolute already, without protocol
    if (url.match(/^\/\//)) return window.location.protocol + url;
    // dataURI, mailto:, tel:, etc.
    if (url.match(/^[a-z]+:/i)) return url;
    const doc = document.implementation.createHTMLDocument();
    const base = doc.createElement('base');
    const a = doc.createElement('a');
    doc.head.appendChild(base);
    doc.body.appendChild(a);
    if (baseUrl) base.href = baseUrl;
    a.href = url;
    return a.href;
}
const uuid = (()=>{
    // generate uuid for className of pseudo elements.
    // We should not use GUIDs, otherwise pseudo elements sometimes cannot be captured.
    let counter = 0;
    // ref: http://stackoverflow.com/a/6248722/2519373
    const random = ()=>// eslint-disable-next-line no-bitwise
        `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4);
    return ()=>{
        counter += 1;
        return `u${random()}${counter}`;
    };
})();
function delay(ms) {
    return (args)=>new Promise((resolve)=>{
            setTimeout(()=>resolve(args), ms);
        });
}
function toArray(arrayLike) {
    const arr = [];
    for(let i = 0, l = arrayLike.length; i < l; i++)arr.push(arrayLike[i]);
    return arr;
}
let styleProps = null;
function getStyleProperties(options = {}) {
    if (styleProps) return styleProps;
    if (options.includeStyleProperties) {
        styleProps = options.includeStyleProperties;
        return styleProps;
    }
    styleProps = toArray(window.getComputedStyle(document.documentElement));
    return styleProps;
}
function px(node, styleProperty) {
    const win = node.ownerDocument.defaultView || window;
    const val = win.getComputedStyle(node).getPropertyValue(styleProperty);
    return val ? parseFloat(val.replace('px', '')) : 0;
}
function getNodeWidth(node) {
    const leftBorder = px(node, 'border-left-width');
    const rightBorder = px(node, 'border-right-width');
    return node.clientWidth + leftBorder + rightBorder;
}
function getNodeHeight(node) {
    const topBorder = px(node, 'border-top-width');
    const bottomBorder = px(node, 'border-bottom-width');
    return node.clientHeight + topBorder + bottomBorder;
}
function getImageSize(targetNode, options = {}) {
    const width = options.width || getNodeWidth(targetNode);
    const height = options.height || getNodeHeight(targetNode);
    return {
        width,
        height
    };
}
function getPixelRatio() {
    let ratio;
    let FINAL_PROCESS;
    try {
        FINAL_PROCESS = process;
    } catch (e) {
    // pass
    }
    const val = FINAL_PROCESS && FINAL_PROCESS.env ? FINAL_PROCESS.env.devicePixelRatio : null;
    if (val) {
        ratio = parseInt(val, 10);
        if (Number.isNaN(ratio)) ratio = 1;
    }
    return ratio || window.devicePixelRatio || 1;
}
// @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/canvas#maximum_canvas_size
const canvasDimensionLimit = 16384;
function checkCanvasDimensions(canvas) {
    if (canvas.width > canvasDimensionLimit || canvas.height > canvasDimensionLimit) {
        if (canvas.width > canvasDimensionLimit && canvas.height > canvasDimensionLimit) {
            if (canvas.width > canvas.height) {
                canvas.height *= canvasDimensionLimit / canvas.width;
                canvas.width = canvasDimensionLimit;
            } else {
                canvas.width *= canvasDimensionLimit / canvas.height;
                canvas.height = canvasDimensionLimit;
            }
        } else if (canvas.width > canvasDimensionLimit) {
            canvas.height *= canvasDimensionLimit / canvas.width;
            canvas.width = canvasDimensionLimit;
        } else {
            canvas.width *= canvasDimensionLimit / canvas.height;
            canvas.height = canvasDimensionLimit;
        }
    }
}
function canvasToBlob(canvas, options = {}) {
    if (canvas.toBlob) return new Promise((resolve)=>{
        canvas.toBlob(resolve, options.type ? options.type : 'image/png', options.quality ? options.quality : 1);
    });
    return new Promise((resolve)=>{
        const binaryString = window.atob(canvas.toDataURL(options.type ? options.type : undefined, options.quality ? options.quality : undefined).split(',')[1]);
        const len = binaryString.length;
        const binaryArray = new Uint8Array(len);
        for(let i = 0; i < len; i += 1)binaryArray[i] = binaryString.charCodeAt(i);
        resolve(new Blob([
            binaryArray
        ], {
            type: options.type ? options.type : 'image/png'
        }));
    });
}
function createImage(url) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>{
            img.decode().then(()=>{
                requestAnimationFrame(()=>resolve(img));
            });
        };
        img.onerror = reject;
        img.crossOrigin = 'anonymous';
        img.decoding = 'async';
        img.src = url;
    });
}
async function svgToDataURL(svg) {
    return Promise.resolve().then(()=>new XMLSerializer().serializeToString(svg)).then(encodeURIComponent).then((html)=>`data:image/svg+xml;charset=utf-8,${html}`);
}
async function nodeToDataURL(node, width, height) {
    const xmlns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(xmlns, 'svg');
    const foreignObject = document.createElementNS(xmlns, 'foreignObject');
    svg.setAttribute('width', `${width}`);
    svg.setAttribute('height', `${height}`);
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    foreignObject.setAttribute('width', '100%');
    foreignObject.setAttribute('height', '100%');
    foreignObject.setAttribute('x', '0');
    foreignObject.setAttribute('y', '0');
    foreignObject.setAttribute('externalResourcesRequired', 'true');
    svg.appendChild(foreignObject);
    foreignObject.appendChild(node);
    return svgToDataURL(svg);
}
const isInstanceOfElement = (node, instance)=>{
    if (node instanceof instance) return true;
    const nodePrototype = Object.getPrototypeOf(node);
    if (nodePrototype === null) return false;
    return nodePrototype.constructor.name === instance.name || isInstanceOfElement(nodePrototype, instance);
};

},{"62fb822691d6ba40":"5jT8D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"31ZUq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMimeType", ()=>getMimeType);
const WOFF = 'application/font-woff';
const JPEG = 'image/jpeg';
const mimes = {
    woff: WOFF,
    woff2: WOFF,
    ttf: 'application/font-truetype',
    eot: 'application/vnd.ms-fontobject',
    png: 'image/png',
    jpg: JPEG,
    jpeg: JPEG,
    gif: 'image/gif',
    tiff: 'image/tiff',
    svg: 'image/svg+xml',
    webp: 'image/webp'
};
function getExtension(url) {
    const match = /\.([^./]*?)$/g.exec(url);
    return match ? match[1] : '';
}
function getMimeType(url) {
    const extension = getExtension(url).toLowerCase();
    return mimes[extension] || '';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Cs6t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDataUrl", ()=>isDataUrl);
parcelHelpers.export(exports, "makeDataUrl", ()=>makeDataUrl);
parcelHelpers.export(exports, "fetchAsDataURL", ()=>fetchAsDataURL);
parcelHelpers.export(exports, "resourceToDataURL", ()=>resourceToDataURL);
function getContentFromDataUrl(dataURL) {
    return dataURL.split(/,/)[1];
}
function isDataUrl(url) {
    return url.search(/^(data:)/) !== -1;
}
function makeDataUrl(content, mimeType) {
    return `data:${mimeType};base64,${content}`;
}
async function fetchAsDataURL(url, init, process) {
    const res = await fetch(url, init);
    if (res.status === 404) throw new Error(`Resource "${res.url}" not found`);
    const blob = await res.blob();
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = ()=>{
            try {
                resolve(process({
                    res,
                    result: reader.result
                }));
            } catch (error) {
                reject(error);
            }
        };
        reader.readAsDataURL(blob);
    });
}
const cache = {};
function getCacheKey(url, contentType, includeQueryParams) {
    let key = url.replace(/\?.*/, '');
    if (includeQueryParams) key = url;
    // font resource
    if (/ttf|otf|eot|woff2?/i.test(key)) key = key.replace(/.*\//, '');
    return contentType ? `[${contentType}]${key}` : key;
}
async function resourceToDataURL(resourceUrl, contentType, options) {
    const cacheKey = getCacheKey(resourceUrl, contentType, options.includeQueryParams);
    if (cache[cacheKey] != null) return cache[cacheKey];
    // ref: https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
    if (options.cacheBust) // eslint-disable-next-line no-param-reassign
    resourceUrl += (/\?/.test(resourceUrl) ? '&' : '?') + new Date().getTime();
    let dataURL;
    try {
        const content = await fetchAsDataURL(resourceUrl, options.fetchRequestInit, ({ res, result })=>{
            if (!contentType) // eslint-disable-next-line no-param-reassign
            contentType = res.headers.get('Content-Type') || '';
            return getContentFromDataUrl(result);
        });
        dataURL = makeDataUrl(content, contentType);
    } catch (error) {
        dataURL = options.imagePlaceholder || '';
        let msg = `Failed to fetch resource: ${resourceUrl}`;
        if (error) msg = typeof error === 'string' ? error : error.message;
        if (msg) console.warn(msg);
    }
    cache[cacheKey] = dataURL;
    return dataURL;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3WIDE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "embedImages", ()=>embedImages);
var _embedResources = require("./embed-resources");
var _util = require("./util");
var _dataurl = require("./dataurl");
var _mimes = require("./mimes");
async function embedProp(propName, node, options) {
    var _a;
    const propValue = (_a = node.style) === null || _a === void 0 ? void 0 : _a.getPropertyValue(propName);
    if (propValue) {
        const cssString = await (0, _embedResources.embedResources)(propValue, null, options);
        node.style.setProperty(propName, cssString, node.style.getPropertyPriority(propName));
        return true;
    }
    return false;
}
async function embedBackground(clonedNode, options) {
    await embedProp('background', clonedNode, options) || await embedProp('background-image', clonedNode, options);
    await embedProp('mask', clonedNode, options) || await embedProp('-webkit-mask', clonedNode, options) || await embedProp('mask-image', clonedNode, options) || await embedProp('-webkit-mask-image', clonedNode, options);
}
async function embedImageNode(clonedNode, options) {
    const isImageElement = (0, _util.isInstanceOfElement)(clonedNode, HTMLImageElement);
    if (!(isImageElement && !(0, _dataurl.isDataUrl)(clonedNode.src)) && !((0, _util.isInstanceOfElement)(clonedNode, SVGImageElement) && !(0, _dataurl.isDataUrl)(clonedNode.href.baseVal))) return;
    const url = isImageElement ? clonedNode.src : clonedNode.href.baseVal;
    const dataURL = await (0, _dataurl.resourceToDataURL)(url, (0, _mimes.getMimeType)(url), options);
    await new Promise((resolve, reject)=>{
        clonedNode.onload = resolve;
        clonedNode.onerror = options.onImageErrorHandler ? (...attributes)=>{
            try {
                resolve(options.onImageErrorHandler(...attributes));
            } catch (error) {
                reject(error);
            }
        } : reject;
        const image = clonedNode;
        if (image.decode) image.decode = resolve;
        if (image.loading === 'lazy') image.loading = 'eager';
        if (isImageElement) {
            clonedNode.srcset = '';
            clonedNode.src = dataURL;
        } else clonedNode.href.baseVal = dataURL;
    });
}
async function embedChildren(clonedNode, options) {
    const children = (0, _util.toArray)(clonedNode.childNodes);
    const deferreds = children.map((child)=>embedImages(child, options));
    await Promise.all(deferreds).then(()=>clonedNode);
}
async function embedImages(clonedNode, options) {
    if ((0, _util.isInstanceOfElement)(clonedNode, Element)) {
        await embedBackground(clonedNode, options);
        await embedImageNode(clonedNode, options);
        await embedChildren(clonedNode, options);
    }
}

},{"./embed-resources":"5Lukg","./util":"ko58M","./dataurl":"6Cs6t","./mimes":"31ZUq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Lukg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseURLs", ()=>parseURLs);
parcelHelpers.export(exports, "embed", ()=>embed);
parcelHelpers.export(exports, "shouldEmbed", ()=>shouldEmbed);
parcelHelpers.export(exports, "embedResources", ()=>embedResources);
var _util = require("./util");
var _mimes = require("./mimes");
var _dataurl = require("./dataurl");
const URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
const URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
const FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function toRegex(url) {
    // eslint-disable-next-line no-useless-escape
    const escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
    return new RegExp(`(url\\(['"]?)(${escaped})(['"]?\\))`, 'g');
}
function parseURLs(cssText) {
    const urls = [];
    cssText.replace(URL_REGEX, (raw, quotation, url)=>{
        urls.push(url);
        return raw;
    });
    return urls.filter((url)=>!(0, _dataurl.isDataUrl)(url));
}
async function embed(cssText, resourceURL, baseURL, options, getContentFromUrl) {
    try {
        const resolvedURL = baseURL ? (0, _util.resolveUrl)(resourceURL, baseURL) : resourceURL;
        const contentType = (0, _mimes.getMimeType)(resourceURL);
        let dataURL;
        if (getContentFromUrl) {
            const content = await getContentFromUrl(resolvedURL);
            dataURL = (0, _dataurl.makeDataUrl)(content, contentType);
        } else dataURL = await (0, _dataurl.resourceToDataURL)(resolvedURL, contentType, options);
        return cssText.replace(toRegex(resourceURL), `$1${dataURL}$3`);
    } catch (error) {
    // pass
    }
    return cssText;
}
function filterPreferredFontFormat(str, { preferredFontFormat }) {
    return !preferredFontFormat ? str : str.replace(FONT_SRC_REGEX, (match)=>{
        // eslint-disable-next-line no-constant-condition
        while(true){
            const [src, , format] = URL_WITH_FORMAT_REGEX.exec(match) || [];
            if (!format) return '';
            if (format === preferredFontFormat) return `src: ${src};`;
        }
    });
}
function shouldEmbed(url) {
    return url.search(URL_REGEX) !== -1;
}
async function embedResources(cssText, baseUrl, options) {
    if (!shouldEmbed(cssText)) return cssText;
    const filteredCSSText = filterPreferredFontFormat(cssText, options);
    const urls = parseURLs(filteredCSSText);
    return urls.reduce((deferred, url)=>deferred.then((css)=>embed(css, url, baseUrl, options)), Promise.resolve(filteredCSSText));
}

},{"./util":"ko58M","./mimes":"31ZUq","./dataurl":"6Cs6t","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"13cvB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyStyle", ()=>applyStyle);
function applyStyle(node, options) {
    const { style } = node;
    if (options.backgroundColor) style.backgroundColor = options.backgroundColor;
    if (options.width) style.width = `${options.width}px`;
    if (options.height) style.height = `${options.height}px`;
    const manual = options.style;
    if (manual != null) Object.keys(manual).forEach((key)=>{
        style[key] = manual[key];
    });
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2KlRp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWebFontCSS", ()=>getWebFontCSS);
parcelHelpers.export(exports, "embedWebFonts", ()=>embedWebFonts);
var _util = require("./util");
var _dataurl = require("./dataurl");
var _embedResources = require("./embed-resources");
const cssFetchCache = {};
async function fetchCSS(url) {
    let cache = cssFetchCache[url];
    if (cache != null) return cache;
    const res = await fetch(url);
    const cssText = await res.text();
    cache = {
        url,
        cssText
    };
    cssFetchCache[url] = cache;
    return cache;
}
async function embedFonts(data, options) {
    let cssText = data.cssText;
    const regexUrl = /url\(["']?([^"')]+)["']?\)/g;
    const fontLocs = cssText.match(/url\([^)]+\)/g) || [];
    const loadFonts = fontLocs.map(async (loc)=>{
        let url = loc.replace(regexUrl, '$1');
        if (!url.startsWith('https://')) url = new URL(url, data.url).href;
        return (0, _dataurl.fetchAsDataURL)(url, options.fetchRequestInit, ({ result })=>{
            cssText = cssText.replace(loc, `url(${result})`);
            return [
                loc,
                result
            ];
        });
    });
    return Promise.all(loadFonts).then(()=>cssText);
}
function parseCSS(source) {
    if (source == null) return [];
    const result = [];
    const commentsRegex = /(\/\*[\s\S]*?\*\/)/gi;
    // strip out comments
    let cssText = source.replace(commentsRegex, '');
    // eslint-disable-next-line prefer-regex-literals
    const keyframesRegex = new RegExp('((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})', 'gi');
    // eslint-disable-next-line no-constant-condition
    while(true){
        const matches = keyframesRegex.exec(cssText);
        if (matches === null) break;
        result.push(matches[0]);
    }
    cssText = cssText.replace(keyframesRegex, '');
    const importRegex = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi;
    // to match css & media queries together
    const combinedCSSRegex = "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})";
    // unified regex
    const unifiedRegex = new RegExp(combinedCSSRegex, 'gi');
    // eslint-disable-next-line no-constant-condition
    while(true){
        let matches = importRegex.exec(cssText);
        if (matches === null) {
            matches = unifiedRegex.exec(cssText);
            if (matches === null) break;
            else importRegex.lastIndex = unifiedRegex.lastIndex;
        } else unifiedRegex.lastIndex = importRegex.lastIndex;
        result.push(matches[0]);
    }
    return result;
}
async function getCSSRules(styleSheets, options) {
    const ret = [];
    const deferreds = [];
    // First loop inlines imports
    styleSheets.forEach((sheet)=>{
        if ('cssRules' in sheet) try {
            (0, _util.toArray)(sheet.cssRules || []).forEach((item, index)=>{
                if (item.type === CSSRule.IMPORT_RULE) {
                    let importIndex = index + 1;
                    const url = item.href;
                    const deferred = fetchCSS(url).then((metadata)=>embedFonts(metadata, options)).then((cssText)=>parseCSS(cssText).forEach((rule)=>{
                            try {
                                sheet.insertRule(rule, rule.startsWith('@import') ? importIndex += 1 : sheet.cssRules.length);
                            } catch (error) {
                                console.error('Error inserting rule from remote css', {
                                    rule,
                                    error
                                });
                            }
                        })).catch((e)=>{
                        console.error('Error loading remote css', e.toString());
                    });
                    deferreds.push(deferred);
                }
            });
        } catch (e) {
            const inline = styleSheets.find((a)=>a.href == null) || document.styleSheets[0];
            if (sheet.href != null) deferreds.push(fetchCSS(sheet.href).then((metadata)=>embedFonts(metadata, options)).then((cssText)=>parseCSS(cssText).forEach((rule)=>{
                    inline.insertRule(rule, inline.cssRules.length);
                })).catch((err)=>{
                console.error('Error loading remote stylesheet', err);
            }));
            console.error('Error inlining remote css file', e);
        }
    });
    return Promise.all(deferreds).then(()=>{
        // Second loop parses rules
        styleSheets.forEach((sheet)=>{
            if ('cssRules' in sheet) try {
                (0, _util.toArray)(sheet.cssRules || []).forEach((item)=>{
                    ret.push(item);
                });
            } catch (e) {
                console.error(`Error while reading CSS rules from ${sheet.href}`, e);
            }
        });
        return ret;
    });
}
function getWebFontRules(cssRules) {
    return cssRules.filter((rule)=>rule.type === CSSRule.FONT_FACE_RULE).filter((rule)=>(0, _embedResources.shouldEmbed)(rule.style.getPropertyValue('src')));
}
async function parseWebFontRules(node, options) {
    if (node.ownerDocument == null) throw new Error('Provided element is not within a Document');
    const styleSheets = (0, _util.toArray)(node.ownerDocument.styleSheets);
    const cssRules = await getCSSRules(styleSheets, options);
    return getWebFontRules(cssRules);
}
function normalizeFontFamily(font) {
    return font.trim().replace(/["']/g, '');
}
function getUsedFonts(node) {
    const fonts = new Set();
    function traverse(node) {
        const fontFamily = node.style.fontFamily || getComputedStyle(node).fontFamily;
        fontFamily.split(',').forEach((font)=>{
            fonts.add(normalizeFontFamily(font));
        });
        Array.from(node.children).forEach((child)=>{
            if (child instanceof HTMLElement) traverse(child);
        });
    }
    traverse(node);
    return fonts;
}
async function getWebFontCSS(node, options) {
    const rules = await parseWebFontRules(node, options);
    const usedFonts = getUsedFonts(node);
    const cssTexts = await Promise.all(rules.filter((rule)=>usedFonts.has(normalizeFontFamily(rule.style.fontFamily))).map((rule)=>{
        const baseUrl = rule.parentStyleSheet ? rule.parentStyleSheet.href : null;
        return (0, _embedResources.embedResources)(rule.cssText, baseUrl, options);
    }));
    return cssTexts.join('\n');
}
async function embedWebFonts(clonedNode, options) {
    const cssText = options.fontEmbedCSS != null ? options.fontEmbedCSS : options.skipFonts ? null : await getWebFontCSS(clonedNode, options);
    if (cssText) {
        const styleNode = document.createElement('style');
        const sytleContent = document.createTextNode(cssText);
        styleNode.appendChild(sytleContent);
        if (clonedNode.firstChild) clonedNode.insertBefore(styleNode, clonedNode.firstChild);
        else clonedNode.appendChild(styleNode);
    }
}

},{"./util":"ko58M","./dataurl":"6Cs6t","./embed-resources":"5Lukg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i5AzK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderFormEditorLocaleSelector", ()=>BuilderFormEditorLocaleSelector);
var _jsxRuntime = require("react/jsx-runtime");
var _advanced = require("@form-engine/builder-application/components/select/advanced");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _useFormEditor = require("../../hooks/use-form-editor");
var _locales = require("@form-engine/builder-application/data/locales");
var _localesDefault = parcelHelpers.interopDefault(_locales);
var _useForm = require("@form-engine/core-application/hooks/use-form");
const options = [
    [
        'default',
        'Default'
    ],
    ...(0, _localesDefault.default)
].map(([value, label])=>({
        label: `${label} (${value})`,
        value
    }));
function useTouchedLocales() {
    const { state } = (0, _useForm.useFormElements)();
    return (0, _react.useMemo)(()=>{
        const locales = [];
        for (const element of state)if (element.locales) {
            for (const locale of Object.keys(element.locales))if (!locales.includes(locale)) locales.push(locale);
        }
        return locales;
    }, [
        state
    ]);
}
function BuilderFormEditorLocaleSelector() {
    const { state: editor, setItem } = (0, _useFormEditor.useFormEditorContext)();
    const touchedLocales = useTouchedLocales();
    const currentValue = (0, _react.useMemo)(()=>{
        const locale = editor?.translationLocale || 'default';
        return options.find(({ value })=>value === locale)?.value ?? 'default';
    }, [
        editor?.translationLocale
    ]);
    const handleChange = (0, _react.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e)=>{
        setItem('translationLocale', e?.target?.value ?? 'default');
    }, [
        setItem
    ]);
    const highlightedOptions = (0, _react.useMemo)(()=>{
        return options.map((option)=>{
            return {
                ...option,
                label: touchedLocales.includes(option.value) ? `${option.label} *` : option.label
            };
        });
    }, [
        touchedLocales
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "feb-formeditor-locale-selector mt-1 me-1 ms-2 d-flex flex-row align-items-center",
        style: {
            minWidth: '300px'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.Translate), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _advanced.BuilderAdvancedFormSelect), {
                className: "ms-1 w-100",
                defaultValue: {
                    label: 'Default',
                    value: 'default'
                },
                options: highlightedOptions,
                value: currentValue,
                onChange: handleChange
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-application/components/select/advanced":"h5QTD","react":"9njXz","react-bootstrap-icons":"3TzoC","../../hooks/use-form-editor":"4pkiD","@form-engine/builder-application/data/locales":"9eqbY","@form-engine/core-application/hooks/use-form":"5PZyy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9eqbY":[function(require,module,exports,__globalThis) {
/**
 * For initial list of locales, refer to the linked resource.
 * Later additions:
 * - https://ebike.atlassian.net/browse/CSPI-898
 *   - no : what Formcycle used, what BDP uses
 *   - tw : what BDP uses (even if it is wrong)
 *   - zh-TW : the right code for Chinese for Taiwan
 * @see https://stackoverflow.com/questions/3191664/list-of-all-locales-and-their-short-codes */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    [
        'mr',
        'Marathi'
    ],
    [
        'bs',
        'Bosnian'
    ],
    [
        'ee-TG',
        'Ewe, Togo'
    ],
    [
        'ms',
        'Malay'
    ],
    [
        'kam-KE',
        'Kamba, Kenya'
    ],
    [
        'mt',
        'Maltese'
    ],
    [
        'ha',
        'Hausa'
    ],
    [
        'es-HN',
        'Spanish, Honduras'
    ],
    [
        'ml-IN',
        'Malayalam, India'
    ],
    [
        'ro-MD',
        'Romanian, Moldova'
    ],
    [
        'kab-DZ',
        'Kabyle, Algeria'
    ],
    [
        'he',
        'Hebrew'
    ],
    [
        'es-CO',
        'Spanish, Colombia'
    ],
    [
        'my',
        'Burmese'
    ],
    [
        'es-PA',
        'Spanish, Panama'
    ],
    [
        'az-Latn',
        'Azerbaijani, Latin'
    ],
    [
        'mer',
        'Meru'
    ],
    [
        'en-NZ',
        'English, New Zealand'
    ],
    [
        'xog-UG',
        'Soga, Uganda'
    ],
    [
        'sg',
        'Sango'
    ],
    [
        'fr-GP',
        'French, Guadeloupe'
    ],
    [
        'sr-Cyrl-BA',
        'Serbian, Cyrillic, Bosnia and Herzegovina'
    ],
    [
        'hi',
        'Hindi'
    ],
    [
        'fil-PH',
        'Filipino, Philippines'
    ],
    [
        'lt-LT',
        'Lithuanian, Lithuania'
    ],
    [
        'si',
        'Sinhala'
    ],
    [
        'en-MT',
        'English, Malta'
    ],
    [
        'si-LK',
        'Sinhala, Sri Lanka'
    ],
    [
        'luo-KE',
        'Luo, Kenya'
    ],
    [
        'it-CH',
        'Italian, Switzerland'
    ],
    [
        'teo',
        'Teso'
    ],
    [
        'mfe',
        'Morisyen'
    ],
    [
        'sk',
        'Slovak'
    ],
    [
        'uz-Cyrl-UZ',
        'Uzbek, Cyrillic, Uzbekistan'
    ],
    [
        'sl',
        'Slovenian'
    ],
    [
        'rm-CH',
        'Romansh, Switzerland'
    ],
    [
        'az-Cyrl-AZ',
        'Azerbaijani, Cyrillic, Azerbaijan'
    ],
    [
        'fr-GQ',
        'French, Equatorial Guinea'
    ],
    [
        'kde',
        'Makonde'
    ],
    [
        'sn',
        'Shona'
    ],
    [
        'cgg-UG',
        'Chiga, Uganda'
    ],
    [
        'so',
        'Somali'
    ],
    [
        'fr-RW',
        'French, Rwanda'
    ],
    [
        'es-SV',
        'Spanish, El Salvador'
    ],
    [
        'mas-TZ',
        'Masai, Tanzania'
    ],
    [
        'en-MU',
        'English, Mauritius'
    ],
    [
        'sq',
        'Albanian'
    ],
    [
        'hr',
        'Croatian'
    ],
    [
        'sr',
        'Serbian'
    ],
    [
        'en-PH',
        'English, Philippines'
    ],
    [
        'ca',
        'Catalan'
    ],
    [
        'hu',
        'Hungarian'
    ],
    [
        'mk-MK',
        'Macedonian, Macedonia'
    ],
    [
        'fr-TD',
        'French, Chad'
    ],
    [
        'nb',
        "Norwegian Bokm\xe5l"
    ],
    [
        'sv',
        'Swedish'
    ],
    [
        'kln-KE',
        'Kalenjin, Kenya'
    ],
    [
        'sw',
        'Swahili'
    ],
    [
        'nd',
        'North Ndebele'
    ],
    [
        'sr-Latn',
        'Serbian, Latin'
    ],
    [
        'el-GR',
        'Greek, Greece'
    ],
    [
        'hy',
        'Armenian'
    ],
    [
        'ne',
        'Nepali'
    ],
    [
        'el-CY',
        'Greek, Cyprus'
    ],
    [
        'es-CR',
        'Spanish, Costa Rica'
    ],
    [
        'fo-FO',
        'Faroese, Faroe Islands'
    ],
    [
        'pa-Arab-PK',
        'Punjabi, Arabic, Pakistan'
    ],
    [
        'seh',
        'Sena'
    ],
    [
        'ar-YE',
        'Arabic, Yemen'
    ],
    [
        'ja-JP',
        'Japanese, Japan'
    ],
    [
        'ur-PK',
        'Urdu, Pakistan'
    ],
    [
        'pa-Guru',
        'Punjabi, Gurmukhi'
    ],
    [
        'gl-ES',
        'Galician, Spain'
    ],
    [
        'zh-Hant-HK',
        'Chinese, Traditional Han, Hong Kong SAR China'
    ],
    [
        'ar-EG',
        'Arabic, Egypt'
    ],
    [
        'nl',
        'Dutch'
    ],
    [
        'th-TH',
        'Thai, Thailand'
    ],
    [
        'es-PE',
        'Spanish, Peru'
    ],
    [
        'fr-KM',
        'French, Comoros'
    ],
    [
        'nn',
        'Norwegian Nynorsk'
    ],
    [
        'kk-Cyrl-KZ',
        'Kazakh, Cyrillic, Kazakhstan'
    ],
    [
        'kea',
        'Kabuverdianu'
    ],
    [
        'lv-LV',
        'Latvian, Latvia'
    ],
    [
        'kln',
        'Kalenjin'
    ],
    [
        'tzm-Latn',
        'Central Morocco Tamazight, Latin'
    ],
    [
        'yo',
        'Yoruba'
    ],
    [
        'gsw-CH',
        'Swiss German, Switzerland'
    ],
    [
        'ha-Latn-GH',
        'Hausa, Latin, Ghana'
    ],
    [
        'is-IS',
        'Icelandic, Iceland'
    ],
    [
        'pt-BR',
        'Portuguese, Brazil'
    ],
    [
        'cs',
        'Czech'
    ],
    [
        'en-PK',
        'English, Pakistan'
    ],
    [
        'fa-IR',
        'Persian, Iran'
    ],
    [
        'zh-Hans-SG',
        'Chinese, Simplified Han, Singapore'
    ],
    [
        'luo',
        'Luo'
    ],
    [
        'ta',
        'Tamil'
    ],
    [
        'fr-TG',
        'French, Togo'
    ],
    [
        'kde-TZ',
        'Makonde, Tanzania'
    ],
    [
        'mr-IN',
        'Marathi, India'
    ],
    [
        'ar-SA',
        'Arabic, Saudi Arabia'
    ],
    [
        'ka-GE',
        'Georgian, Georgia'
    ],
    [
        'mfe-MU',
        'Morisyen, Mauritius'
    ],
    [
        'id',
        'Indonesian'
    ],
    [
        'fr-LU',
        'French, Luxembourg'
    ],
    [
        'de-LU',
        'German, Luxembourg'
    ],
    [
        'ru-MD',
        'Russian, Moldova'
    ],
    [
        'cy',
        'Welsh'
    ],
    [
        'zh-Hans-HK',
        'Chinese, Simplified Han, Hong Kong SAR China'
    ],
    [
        'te',
        'Telugu'
    ],
    [
        'bg-BG',
        'Bulgarian, Bulgaria'
    ],
    [
        'shi-Latn',
        'Tachelhit, Latin'
    ],
    [
        'ig',
        'Igbo'
    ],
    [
        'ses',
        'Koyraboro Senni'
    ],
    [
        'ii',
        'Sichuan Yi'
    ],
    [
        'es-BO',
        'Spanish, Bolivia'
    ],
    [
        'th',
        'Thai'
    ],
    [
        'ko-KR',
        'Korean, South Korea'
    ],
    [
        'ti',
        'Tigrinya'
    ],
    [
        'it-IT',
        'Italian, Italy'
    ],
    [
        'shi-Latn-MA',
        'Tachelhit, Latin, Morocco'
    ],
    [
        'pt-MZ',
        'Portuguese, Mozambique'
    ],
    [
        'ff-SN',
        'Fulah, Senegal'
    ],
    [
        'haw',
        'Hawaiian'
    ],
    [
        'zh-Hans',
        'Chinese, Simplified Han'
    ],
    [
        'so-KE',
        'Somali, Kenya'
    ],
    [
        'bn-IN',
        'Bengali, India'
    ],
    [
        'en-UM',
        'English, U.S. Minor Outlying Islands'
    ],
    [
        'to',
        'Tonga'
    ],
    [
        'id-ID',
        'Indonesian, Indonesia'
    ],
    [
        'uz-Cyrl',
        'Uzbek, Cyrillic'
    ],
    [
        'en-GU',
        'English, Guam'
    ],
    [
        'es-EC',
        'Spanish, Ecuador'
    ],
    [
        'en-US-POSIX',
        'English, United States, Computer'
    ],
    [
        'sr-Latn-BA',
        'Serbian, Latin, Bosnia and Herzegovina'
    ],
    [
        'is',
        'Icelandic'
    ],
    [
        'luy',
        'Luyia'
    ],
    [
        'tr',
        'Turkish'
    ],
    [
        'en-NA',
        'English, Namibia'
    ],
    [
        'it',
        'Italian'
    ],
    [
        'da',
        'Danish'
    ],
    [
        'bo-IN',
        'Tibetan, India'
    ],
    [
        'vun-TZ',
        'Vunjo, Tanzania'
    ],
    [
        'ar-SD',
        'Arabic, Sudan'
    ],
    [
        'uz-Latn-UZ',
        'Uzbek, Latin, Uzbekistan'
    ],
    [
        'az-Latn-AZ',
        'Azerbaijani, Latin, Azerbaijan'
    ],
    [
        'de',
        'German'
    ],
    [
        'es-GQ',
        'Spanish, Equatorial Guinea'
    ],
    [
        'ta-IN',
        'Tamil, India'
    ],
    [
        'de-DE',
        'German, Germany'
    ],
    [
        'fr-FR',
        'French, France'
    ],
    [
        'rof-TZ',
        'Rombo, Tanzania'
    ],
    [
        'ar-LY',
        'Arabic, Libya'
    ],
    [
        'en-BW',
        'English, Botswana'
    ],
    [
        'asa',
        'Asu'
    ],
    [
        'zh',
        'Chinese'
    ],
    [
        'ha-Latn',
        'Hausa, Latin'
    ],
    [
        'fr-NE',
        'French, Niger'
    ],
    [
        'es-MX',
        'Spanish, Mexico'
    ],
    [
        'bem-ZM',
        'Bemba, Zambia'
    ],
    [
        'zh-Hans-CN',
        'Chinese, Simplified Han, China'
    ],
    [
        'bn-BD',
        'Bengali, Bangladesh'
    ],
    [
        'pt-GW',
        'Portuguese, Guinea-Bissau'
    ],
    [
        'om',
        'Oromo'
    ],
    [
        'jmc',
        'Machame'
    ],
    [
        'de-AT',
        'German, Austria'
    ],
    [
        'kk-Cyrl',
        'Kazakh, Cyrillic'
    ],
    [
        'sw-TZ',
        'Swahili, Tanzania'
    ],
    [
        'ar-OM',
        'Arabic, Oman'
    ],
    [
        'et-EE',
        'Estonian, Estonia'
    ],
    [
        'or',
        'Oriya'
    ],
    [
        'da-DK',
        'Danish, Denmark'
    ],
    [
        'ro-RO',
        'Romanian, Romania'
    ],
    [
        'zh-Hant',
        'Chinese, Traditional Han'
    ],
    [
        'bm-ML',
        'Bambara, Mali'
    ],
    [
        'ja',
        'Japanese'
    ],
    [
        'fr-CA',
        'French, Canada'
    ],
    [
        'naq',
        'Nama'
    ],
    [
        'zu',
        'Zulu'
    ],
    [
        'en-IE',
        'English, Ireland'
    ],
    [
        'ar-MA',
        'Arabic, Morocco'
    ],
    [
        'es-GT',
        'Spanish, Guatemala'
    ],
    [
        'uz-Arab-AF',
        'Uzbek, Arabic, Afghanistan'
    ],
    [
        'en-AS',
        'English, American Samoa'
    ],
    [
        'bs-BA',
        'Bosnian, Bosnia and Herzegovina'
    ],
    [
        'am-ET',
        'Amharic, Ethiopia'
    ],
    [
        'ar-TN',
        'Arabic, Tunisia'
    ],
    [
        'haw-US',
        'Hawaiian, United States'
    ],
    [
        'ar-JO',
        'Arabic, Jordan'
    ],
    [
        'fa-AF',
        'Persian, Afghanistan'
    ],
    [
        'uz-Latn',
        'Uzbek, Latin'
    ],
    [
        'en-BZ',
        'English, Belize'
    ],
    [
        'nyn-UG',
        'Nyankole, Uganda'
    ],
    [
        'ebu-KE',
        'Embu, Kenya'
    ],
    [
        'te-IN',
        'Telugu, India'
    ],
    [
        'cy-GB',
        'Welsh, United Kingdom'
    ],
    [
        'uk',
        'Ukrainian'
    ],
    [
        'nyn',
        'Nyankole'
    ],
    [
        'en-JM',
        'English, Jamaica'
    ],
    [
        'en-US',
        'English, United States'
    ],
    [
        'fil',
        'Filipino'
    ],
    [
        'ar-KW',
        'Arabic, Kuwait'
    ],
    [
        'af-ZA',
        'Afrikaans, South Africa'
    ],
    [
        'en-CA',
        'English, Canada'
    ],
    [
        'fr-DJ',
        'French, Djibouti'
    ],
    [
        'ti-ER',
        'Tigrinya, Eritrea'
    ],
    [
        'ig-NG',
        'Igbo, Nigeria'
    ],
    [
        'en-AU',
        'English, Australia'
    ],
    [
        'ur',
        'Urdu'
    ],
    [
        'fr-MC',
        'French, Monaco'
    ],
    [
        'pt-PT',
        'Portuguese, Portugal'
    ],
    [
        'pa',
        'Punjabi'
    ],
    [
        'es-419',
        'Spanish, Latin America'
    ],
    [
        'fr-CD',
        'French, Congo - Kinshasa'
    ],
    [
        'en-SG',
        'English, Singapore'
    ],
    [
        'bo-CN',
        'Tibetan, China'
    ],
    [
        'kn-IN',
        'Kannada, India'
    ],
    [
        'sr-Cyrl-RS',
        'Serbian, Cyrillic, Serbia'
    ],
    [
        'lg-UG',
        'Ganda, Uganda'
    ],
    [
        'gu-IN',
        'Gujarati, India'
    ],
    [
        'ee',
        'Ewe'
    ],
    [
        'nd-ZW',
        'North Ndebele, Zimbabwe'
    ],
    [
        'bem',
        'Bemba'
    ],
    [
        'uz',
        'Uzbek'
    ],
    [
        'sw-KE',
        'Swahili, Kenya'
    ],
    [
        'sq-AL',
        'Albanian, Albania'
    ],
    [
        'hr-HR',
        'Croatian, Croatia'
    ],
    [
        'mas-KE',
        'Masai, Kenya'
    ],
    [
        'el',
        'Greek'
    ],
    [
        'ti-ET',
        'Tigrinya, Ethiopia'
    ],
    [
        'es-AR',
        'Spanish, Argentina'
    ],
    [
        'pl',
        'Polish'
    ],
    [
        'en',
        'English'
    ],
    [
        'eo',
        'Esperanto'
    ],
    [
        'shi',
        'Tachelhit'
    ],
    [
        'kok',
        'Konkani'
    ],
    [
        'fr-CF',
        'French, Central African Republic'
    ],
    [
        'fr-RE',
        "French, R\xe9union"
    ],
    [
        'mas',
        'Masai'
    ],
    [
        'rof',
        'Rombo'
    ],
    [
        'ru-UA',
        'Russian, Ukraine'
    ],
    [
        'yo-NG',
        'Yoruba, Nigeria'
    ],
    [
        'dav-KE',
        'Taita, Kenya'
    ],
    [
        'gv-GB',
        'Manx, United Kingdom'
    ],
    [
        'pa-Arab',
        'Punjabi, Arabic'
    ],
    [
        'es',
        'Spanish'
    ],
    [
        'teo-UG',
        'Teso, Uganda'
    ],
    [
        'ps',
        'Pashto'
    ],
    [
        'es-PR',
        'Spanish, Puerto Rico'
    ],
    [
        'fr-MF',
        'French, Saint Martin'
    ],
    [
        'et',
        'Estonian'
    ],
    [
        'pt',
        'Portuguese'
    ],
    [
        'eu',
        'Basque'
    ],
    [
        'ka',
        'Georgian'
    ],
    [
        'rwk-TZ',
        'Rwa, Tanzania'
    ],
    [
        'nb-NO',
        "Norwegian Bokm\xe5l, Norway"
    ],
    [
        'fr-CG',
        'French, Congo - Brazzaville'
    ],
    [
        'cgg',
        'Chiga'
    ],
    [
        'zh-Hant-TW',
        'Chinese, Traditional Han, Taiwan'
    ],
    [
        'sr-Cyrl-ME',
        'Serbian, Cyrillic, Montenegro'
    ],
    [
        'lag',
        'Langi'
    ],
    [
        'ses-ML',
        'Koyraboro Senni, Mali'
    ],
    [
        'en-ZW',
        'English, Zimbabwe'
    ],
    [
        'ak-GH',
        'Akan, Ghana'
    ],
    [
        'vi-VN',
        'Vietnamese, Vietnam'
    ],
    [
        'sv-FI',
        'Swedish, Finland'
    ],
    [
        'to-TO',
        'Tonga, Tonga'
    ],
    [
        'fr-MG',
        'French, Madagascar'
    ],
    [
        'fr-GA',
        'French, Gabon'
    ],
    [
        'fr-CH',
        'French, Switzerland'
    ],
    [
        'de-CH',
        'German, Switzerland'
    ],
    [
        'es-US',
        'Spanish, United States'
    ],
    [
        'ki',
        'Kikuyu'
    ],
    [
        'my-MM',
        'Burmese, Myanmar [Burma]'
    ],
    [
        'vi',
        'Vietnamese'
    ],
    [
        'ar-QA',
        'Arabic, Qatar'
    ],
    [
        'ga-IE',
        'Irish, Ireland'
    ],
    [
        'rwk',
        'Rwa'
    ],
    [
        'bez',
        'Bena'
    ],
    [
        'ee-GH',
        'Ewe, Ghana'
    ],
    [
        'kk',
        'Kazakh'
    ],
    [
        'as-IN',
        'Assamese, India'
    ],
    [
        'ca-ES',
        'Catalan, Spain'
    ],
    [
        'kl',
        'Kalaallisut'
    ],
    [
        'fr-SN',
        'French, Senegal'
    ],
    [
        'ne-IN',
        'Nepali, India'
    ],
    [
        'km',
        'Khmer'
    ],
    [
        'ms-BN',
        'Malay, Brunei'
    ],
    [
        'ar-LB',
        'Arabic, Lebanon'
    ],
    [
        'ta-LK',
        'Tamil, Sri Lanka'
    ],
    [
        'kn',
        'Kannada'
    ],
    [
        'ur-IN',
        'Urdu, India'
    ],
    [
        'fr-CI',
        "French, C\xf4te d\u2019Ivoire"
    ],
    [
        'ko',
        'Korean'
    ],
    [
        'ha-Latn-NG',
        'Hausa, Latin, Nigeria'
    ],
    [
        'sg-CF',
        'Sango, Central African Republic'
    ],
    [
        'om-ET',
        'Oromo, Ethiopia'
    ],
    [
        'zh-Hant-MO',
        'Chinese, Traditional Han, Macau SAR China'
    ],
    [
        'uk-UA',
        'Ukrainian, Ukraine'
    ],
    [
        'fa',
        'Persian'
    ],
    [
        'mt-MT',
        'Maltese, Malta'
    ],
    [
        'ki-KE',
        'Kikuyu, Kenya'
    ],
    [
        'luy-KE',
        'Luyia, Kenya'
    ],
    [
        'kw',
        'Cornish'
    ],
    [
        'pa-Guru-IN',
        'Punjabi, Gurmukhi, India'
    ],
    [
        'en-IN',
        'English, India'
    ],
    [
        'kab',
        'Kabyle'
    ],
    [
        'ar-IQ',
        'Arabic, Iraq'
    ],
    [
        'ff',
        'Fulah'
    ],
    [
        'en-TT',
        'English, Trinidad and Tobago'
    ],
    [
        'bez-TZ',
        'Bena, Tanzania'
    ],
    [
        'es-NI',
        'Spanish, Nicaragua'
    ],
    [
        'uz-Arab',
        'Uzbek, Arabic'
    ],
    [
        'ne-NP',
        'Nepali, Nepal'
    ],
    [
        'fi',
        'Finnish'
    ],
    [
        'khq',
        'Koyra Chiini'
    ],
    [
        'gsw',
        'Swiss German'
    ],
    [
        'zh-Hans-MO',
        'Chinese, Simplified Han, Macau SAR China'
    ],
    [
        'en-MH',
        'English, Marshall Islands'
    ],
    [
        'hu-HU',
        'Hungarian, Hungary'
    ],
    [
        'en-GB',
        'English, United Kingdom'
    ],
    [
        'fr-BE',
        'French, Belgium'
    ],
    [
        'de-BE',
        'German, Belgium'
    ],
    [
        'saq',
        'Samburu'
    ],
    [
        'be-BY',
        'Belarusian, Belarus'
    ],
    [
        'sl-SI',
        'Slovenian, Slovenia'
    ],
    [
        'sr-Latn-RS',
        'Serbian, Latin, Serbia'
    ],
    [
        'fo',
        'Faroese'
    ],
    [
        'fr',
        'French'
    ],
    [
        'xog',
        'Soga'
    ],
    [
        'fr-BF',
        'French, Burkina Faso'
    ],
    [
        'tzm',
        'Central Morocco Tamazight'
    ],
    [
        'sk-SK',
        'Slovak, Slovakia'
    ],
    [
        'fr-ML',
        'French, Mali'
    ],
    [
        'he-IL',
        'Hebrew, Israel'
    ],
    [
        'ha-Latn-NE',
        'Hausa, Latin, Niger'
    ],
    [
        'ru-RU',
        'Russian, Russia'
    ],
    [
        'fr-CM',
        'French, Cameroon'
    ],
    [
        'teo-KE',
        'Teso, Kenya'
    ],
    [
        'seh-MZ',
        'Sena, Mozambique'
    ],
    [
        'kl-GL',
        'Kalaallisut, Greenland'
    ],
    [
        'fi-FI',
        'Finnish, Finland'
    ],
    [
        'kam',
        'Kamba'
    ],
    [
        'es-ES',
        'Spanish, Spain'
    ],
    [
        'af',
        'Afrikaans'
    ],
    [
        'asa-TZ',
        'Asu, Tanzania'
    ],
    [
        'cs-CZ',
        'Czech, Czech Republic'
    ],
    [
        'tr-TR',
        'Turkish, Turkey'
    ],
    [
        'es-PY',
        'Spanish, Paraguay'
    ],
    [
        'tzm-Latn-MA',
        'Central Morocco Tamazight, Latin, Morocco'
    ],
    [
        'lg',
        'Ganda'
    ],
    [
        'ebu',
        'Embu'
    ],
    [
        'en-HK',
        'English, Hong Kong SAR China'
    ],
    [
        'nl-NL',
        'Dutch, Netherlands'
    ],
    [
        'en-BE',
        'English, Belgium'
    ],
    [
        'ms-MY',
        'Malay, Malaysia'
    ],
    [
        'es-UY',
        'Spanish, Uruguay'
    ],
    [
        'ar-BH',
        'Arabic, Bahrain'
    ],
    [
        'kw-GB',
        'Cornish, United Kingdom'
    ],
    [
        'ak',
        'Akan'
    ],
    [
        'chr',
        'Cherokee'
    ],
    [
        'dav',
        'Taita'
    ],
    [
        'lag-TZ',
        'Langi, Tanzania'
    ],
    [
        'am',
        'Amharic'
    ],
    [
        'so-DJ',
        'Somali, Djibouti'
    ],
    [
        'shi-Tfng-MA',
        'Tachelhit, Tifinagh, Morocco'
    ],
    [
        'sr-Latn-ME',
        'Serbian, Latin, Montenegro'
    ],
    [
        'sn-ZW',
        'Shona, Zimbabwe'
    ],
    [
        'or-IN',
        'Oriya, India'
    ],
    [
        'ar',
        'Arabic'
    ],
    [
        'as',
        'Assamese'
    ],
    [
        'fr-BI',
        'French, Burundi'
    ],
    [
        'jmc-TZ',
        'Machame, Tanzania'
    ],
    [
        'chr-US',
        'Cherokee, United States'
    ],
    [
        'eu-ES',
        'Basque, Spain'
    ],
    [
        'saq-KE',
        'Samburu, Kenya'
    ],
    [
        'vun',
        'Vunjo'
    ],
    [
        'lt',
        'Lithuanian'
    ],
    [
        'naq-NA',
        'Nama, Namibia'
    ],
    [
        'ga',
        'Irish'
    ],
    [
        'af-NA',
        'Afrikaans, Namibia'
    ],
    [
        'kea-CV',
        'Kabuverdianu, Cape Verde'
    ],
    [
        'es-DO',
        'Spanish, Dominican Republic'
    ],
    [
        'lv',
        'Latvian'
    ],
    [
        'kok-IN',
        'Konkani, India'
    ],
    [
        'de-LI',
        'German, Liechtenstein'
    ],
    [
        'fr-BJ',
        'French, Benin'
    ],
    [
        'az',
        'Azerbaijani'
    ],
    [
        'guz-KE',
        'Gusii, Kenya'
    ],
    [
        'rw-RW',
        'Kinyarwanda, Rwanda'
    ],
    [
        'mg-MG',
        'Malagasy, Madagascar'
    ],
    [
        'km-KH',
        'Khmer, Cambodia'
    ],
    [
        'gl',
        'Galician'
    ],
    [
        'shi-Tfng',
        'Tachelhit, Tifinagh'
    ],
    [
        'ar-AE',
        'Arabic, United Arab Emirates'
    ],
    [
        'fr-MQ',
        'French, Martinique'
    ],
    [
        'rm',
        'Romansh'
    ],
    [
        'sv-SE',
        'Swedish, Sweden'
    ],
    [
        'az-Cyrl',
        'Azerbaijani, Cyrillic'
    ],
    [
        'ro',
        'Romanian'
    ],
    [
        'so-ET',
        'Somali, Ethiopia'
    ],
    [
        'en-ZA',
        'English, South Africa'
    ],
    [
        'ii-CN',
        'Sichuan Yi, China'
    ],
    [
        'fr-BL',
        "French, Saint Barth\xe9lemy"
    ],
    [
        'hi-IN',
        'Hindi, India'
    ],
    [
        'gu',
        'Gujarati'
    ],
    [
        'mer-KE',
        'Meru, Kenya'
    ],
    [
        'nn-NO',
        'Norwegian Nynorsk, Norway'
    ],
    [
        'gv',
        'Manx'
    ],
    [
        'ru',
        'Russian'
    ],
    [
        'ar-DZ',
        'Arabic, Algeria'
    ],
    [
        'ar-SY',
        'Arabic, Syria'
    ],
    [
        'en-MP',
        'English, Northern Mariana Islands'
    ],
    [
        'nl-BE',
        'Dutch, Belgium'
    ],
    [
        'rw',
        'Kinyarwanda'
    ],
    [
        'be',
        'Belarusian'
    ],
    [
        'en-VI',
        'English, U.S. Virgin Islands'
    ],
    [
        'es-CL',
        'Spanish, Chile'
    ],
    [
        'bg',
        'Bulgarian'
    ],
    [
        'mg',
        'Malagasy'
    ],
    [
        'hy-AM',
        'Armenian, Armenia'
    ],
    [
        'zu-ZA',
        'Zulu, South Africa'
    ],
    [
        'guz',
        'Gusii'
    ],
    [
        'mk',
        'Macedonian'
    ],
    [
        'es-VE',
        'Spanish, Venezuela'
    ],
    [
        'ml',
        'Malayalam'
    ],
    [
        'bm',
        'Bambara'
    ],
    [
        'khq-ML',
        'Koyra Chiini, Mali'
    ],
    [
        'bn',
        'Bengali'
    ],
    [
        'ps-AF',
        'Pashto, Afghanistan'
    ],
    [
        'so-SO',
        'Somali, Somalia'
    ],
    [
        'sr-Cyrl',
        'Serbian, Cyrillic'
    ],
    [
        'pl-PL',
        'Polish, Poland'
    ],
    [
        'fr-GN',
        'French, Guinea'
    ],
    [
        'bo',
        'Tibetan'
    ],
    [
        'om-KE',
        'Oromo, Kenya'
    ],
    [
        'no',
        'Norwegian'
    ],
    [
        'tw',
        'Chinese (Taiwan)'
    ],
    [
        'zh-TW',
        'Chinese (Taiwan)'
    ]
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XTh0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderPreviewSettingsMask", ()=>BuilderPreviewSettingsMask);
parcelHelpers.export(exports, "BuilderFormEditorPreviewSettings", ()=>BuilderFormEditorPreviewSettings);
var _jsxRuntime = require("react/jsx-runtime");
var _mask = require("@form-engine/builder-mask/components/mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _array = require("@form-engine/builder-mask/components/properties/array");
var _arrayDefault = parcelHelpers.interopDefault(_array);
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _formatCase = require("@form-engine/core-util/format-case");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormEditor = require("../../hooks/use-form-editor");
var _builderApplication = require("@form-engine/builder-application");
var _auth = require("@form-engine/builder-mask/components/properties/auth");
var _authDefault = parcelHelpers.interopDefault(_auth);
function BuilderPreviewSettingsMask() {
    const { c } = (0, _builderApplication.i18n).prefix('form-editor.previewSettings.');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _maskDefault.default), {
        id: "BuilderPreviewSettingsMask",
        general: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupDefault.default), {
                label: c('authGroupTitle'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrayDefault.default), {
                    propertyName: "customVariables",
                    label: c('customLocals'),
                    cols: {
                        key: {
                            label: c('customLocalsVariable'),
                            formatter: (0, _formatCase.formatVariableCase)
                        },
                        value: c('customLocalsValue')
                    }
                })
            })
        ]
    });
}
function BuilderFormEditorPreviewSettings() {
    const { state: editor, setItem } = (0, _useFormEditor.useFormEditorContext)();
    const api = (0, _react.useMemo)(()=>{
        const state = editor?.previewSettings ?? {};
        return {
            state,
            setItem: (value)=>{
                setItem('previewSettings', value);
            },
            setItemProperty: (key, value)=>{
                setItem('previewSettings', {
                    ...state,
                    [key]: value
                });
            }
        };
    }, [
        editor,
        setItem
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useMask.MaskProvider), {
        value: api,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderPreviewSettingsMask, {})
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-mask/components/mask":"kcLv4","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/properties/array":"iNhep","@form-engine/builder-mask/hooks/use-mask":"72MTY","@form-engine/core-util/format-case":"2G0oK","react":"9njXz","../../hooks/use-form-editor":"4pkiD","@form-engine/builder-application":"7iKr0","@form-engine/builder-mask/components/properties/auth":"g7ynP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jIoZs":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"1B16C","./de.json":"fpUGT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1B16C":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"form-editor":{"nav":{"undo":"Undo ({{hotkey}})","redo":"Redo ({{hotkey}})","embed":"Embed ({{hotkey}})","open-in-browser":"Open Form in Browser","formVersionHistory":"Show Version History","unpublishForm":"Make private","publishForm":"Publish","saveForm":"Save","saveFormAs":"Save as\u2026","exportForm":"Export\u2026","importFormFile":"Import\u2026","renameForm":"Rename\u2026","deleteForm":"Delete\u2026","exportL10n":"Export Localization...","importL10n":"Import Localization..."},"layout":{"title":"Layout","description":"Drag and Drop Form Elements to create your desired structure","edit":{"title":"Edit","outline":"Outline","components":"Components","settings":"Settings"},"translate":{"title":"Translate","outline":"Outline","components":"Components","settings":"Settings"},"preview":{"title":"Preview","outline":"Outline","scope":"Scope","settings":"Settings"}},"datasources":{"title":"Datasources","description":"Configure static data needed in your form.","confirmDeleteCascade":"Elements will be affected by deleting this Datasource, do you want to continue?"},"workflow":{"title":"Workflow","description":"Control the behaviour of your form.","flow":"Flow","settings":"Settings","library":"Library","formReadyNode":"On Start","formSubmitNode":"On Submit","nothingSelected":"Nothing selected"},"constants":{"title":"Constants","description":"Configure constant values to be used anywhere in your form."},"saveFormAsDialog":{"title":"Save as","successToast":"Saved","namePlaceholder":"Name"},"renameFormDialog":{"title":"Rename","namePlaceholder":"Name"},"deleteFormDialog":{"message":"Do you want to permanently Delete {{name}}?","busyToast":"Deleting {{name}}\u2026","doneToast":"Deleted {{name}}\u2026"},"formVersionHistoryDialog":{"title":"Version History"},"formVersionHistory":{"revert":"Revert to this version","duplicate":"Create new project from this version"},"formEmbedDialog":{"title":"Embed"},"savePresetDialog":{"title":"Preset","deleteButton":"Delete","deleteMessage":"Are you sure yo want to delete this preset?","confirmOverrideMessage":"A Preset with the name \\"{{name}}\\" already exists, are you sure you want to override it?"},"formPresetPreview":{"notRenderable":"Preset not previewable"},"hyperlinkEmbed":{"title":"Hyperlink","description":"Simply link to the hosted form."},"inlineEmbed":{"title":"Inline Tag","description":"Embed a form into a HTML document with a provided custom tag."},"previewSettings":{"authGroupTitle":"Authorization","customLocals":"Custom Environment Variables","customLocalsVariable":"Variable Name","customLocalsValue":"Value"},"confirmMergeDialog":{"message":"A newer version of the form is available, do you want to apply the following changes?"}},"mask":{"BuilderFormMask":{"name":"Name (internal)","published":"Published","behaviourGroupTitle":"Behaviour","showValidFeedback":"Show valid field Feedback","customizationGroupTitle":"Customization","includeCoreResources":"Include Core Resources","includeBootstrapCdn":"Include Bootstrap CDN","bootstrapCdnUrl":"Bootstrap CDN Resource","resources":"Additional Resources","resourcesUrl":"Url","stylesheet":"Inline Stylesheet"},"BuilderInlineEmbedMask":{"description":"### Inline Embed\\nPaste the script tag in places where you want to display your form.\\nYou can pass variables to the form by adding a `data-session=\\"{YOUR_JSON_OBJECT_LITERAL}\\"` attribute or putting your json object literal into the body of the script tag.\\n\\rShould you want to authenticate from within a document where the `dodo` library is available, you can add the `data-identity-provider=\\"dodo\\"` attribute.\\n\\rShould you want to make the search parameters of the host document available in the form as variables, please add the `data-use-host-search-params` attribute to the script tag.\\n\\r","code":"Embed Code"}},"elementControls":{"deleteElement":"Delete this Element","copyElement":"Copy this Element","cutElement":"Cut this Element","pasteElement":"Paste after this Element","savePreset":"Create or Update Preset from this Element"},"import-l10n":{"importing":"Importing\u2026","success":{"singular":"Import successful. One localization key updated.","plural":"Import successful. {{count}} localization keys updated."},"unmatchedElementsMessage":{"singular":"One unmatched element was ignored.","plural":"{{count}} unmatched elements were ignored."}}}');

},{}],"fpUGT":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"form-editor":{"nav":{"undo":"R\xfcckg\xe4ngig machen ({{Hotkey}})","redo":"Wiederherstellen ({{Hotkey}})","embed":"Einbetten ({{Hotkey}})","open-in-browser":"Formular im Browser \xf6ffnen","formVersionHistory":"Versionsverlauf anzeigen","unpublishForm":"Privatisieren","publishForm":"Ver\xf6ffentlichen","saveForm":"Speichern","saveFormAs":"Speichern als\u2026","exportForm":"Export\u2026","importFormFile":"Import\u2026","renameForm":"Umbenennen\u2026","deleteForm":"L\xf6schen\u2026","exportL10n":"Lokalisierung exportieren...","importL10n":"Lokalisierung importieren..."},"layout":{"title":"Layout","description":"Ziehen Sie Formularelemente per Drag-and-Drop, um Ihre gew\xfcnschte Struktur zu erstellen","edit":{"title":"Bearbeiten","outline":"Umriss","components":"Komponenten","settings":"Einstellungen"},"translate":{"title":"\xdcbersetzen","outline":"Umriss","components":"Komponenten","settings":"Einstellungen"},"preview":{"title":"Vorschau","outline":"Umriss","scope":"Zielfernrohr","settings":"Einstellungen"}},"datasources":{"title":"Datenquellen","description":"Konfigurieren Sie statische Daten, die in Ihrem Formular ben\xf6tigt werden.","confirmDeleteCascade":"Von dieser L\xf6schung werden Elemente beeintr\xe4chtigt, fortfahren?"},"workflow":{"title":"Arbeitsablauf","description":"Steuern Sie das Verhalten Ihres Formulars.","flow":"Fluss","settings":"Einstellungen","library":"B\xfccherei","formReadyNode":"Am Start","formSubmitNode":"Auf Senden","nothingSelected":"Nichts ausgew\xe4hlt"},"constants":{"title":"Konstanten","description":"Konfigurieren Sie konstante Werte, die \xfcberall in Ihrem Formular verwendet werden sollen."},"saveFormAsDialog":{"title":"Speichern als","successToast":"Gerettet","namePlaceholder":"Name"},"renameFormDialog":{"title":"Umbenennen","namePlaceholder":"Name"},"deleteFormDialog":{"message":"M\xf6chten Sie {{name}} endg\xfcltig l\xf6schen?","busyToast":"{{Name}} wird gel\xf6scht\u2026","doneToast":"Gel\xf6scht {{name}}\u2026"},"formVersionHistoryDialog":{"title":"Versionsgeschichte"},"formVersionHistory":{"revert":"Kehren Sie zu dieser Version zur\xfcck","duplicate":"Neues Projekt aus dieser Version erstellen"},"formEmbedDialog":{"title":"Einbetten"},"hyperlinkEmbed":{"title":"Hyperlinks","description":"Einfach auf das gehostete Formular verlinken."},"inlineEmbed":{"title":"Inline-Tag","description":"Betten Sie ein Formular mit einem bereitgestellten benutzerdefinierten Tag in ein HTML-Dokument ein."},"previewSettings":{"authGroupTitle":"Authorisierung","customLocals":"Vorschau Umgebungsvariablen","customLocalsVariable":"Variablenname","customLocalsValue":"Wert"},"confirmMergeDialog":{"message":"Eine neuere Version des Formulars ist vorhanden, wollen Sie die folgenden \xc4nderungen \xfcbernehmen?"}},"mask":{"BuilderFormMask":{"name":"Name (intern)","published":"Ver\xf6ffentlicht","behaviourGroupTitle":"Verhalten","showValidFeedback":"G\xfcltiges Feld Feedback anzeigen","customizationGroupTitle":"Anpassung","includeCoreResources":"Kernressourcen einbeziehen","includeBootstrapCdn":"Bootstrap-CDN einschlie\xdfen","bootstrapCdnUrl":"Bootstrap-CDN-Ressource","resources":"Zus\xe4tzliche Ressourcen","resourcesUrl":"URL","stylesheet":"Inline-Stylesheet"},"BuilderInlineEmbedMask":{"description":"### Inline Embed\\nBetten Sie ein Formular mit einem bereitgestellten benutzerdefinierten Tag in ein HTML-Dokument ein.\\nSie k\xf6nnen Variablen an das Formular \xfcbergeben, indem Sie ein `data-session=\\"{YOUR_JSON_OBJECT_LITERAL}\\"-Attribut hinzuf\xfcgen oder Ihr Json-Objekt-Literal in den K\xf6rper des Skript-Tags einf\xfcgen.\\n\\rSollten Sie sich von einem Dokument aus authentifizieren wollen, in dem die `dodo`-Bibliothek verf\xfcgbar ist, k\xf6nnen Sie das `data-identity-provider=\\"dodo\\"-Attribut hinzuf\xfcgen.\\n\\rWenn Sie die Suchparameter des Host-Dokuments im Formular als Variablen zur Verf\xfcgung stellen m\xf6chten, f\xfcgen Sie bitte das Attribut `data-use-host-search-params` zum Script-Tag hinzu.\\n\\r","code":"Embed Code"}},"elementControls":{"deleteElement":"Dieses Element l\xf6schen","copyElement":"Dieses Element kopieren","cutElement":"Dieses Element ausschneiden","pasteElement":"Nach diesem Element einf\xfcgen","savePreset":"Vorlage mit diesem Element erstellen oder aktualisieren"},"import-l10n":{"importing":"Importiere...","success":{"singular":"Import erfolgreich. Ein Lokalisierungsschl\xfcssel wurde aktualisiert.","plural":"Import erfolgreich. {{count}} Lokalisierungsschl\xfcssel wurden aktualisiert."},"unmatchedElementsMessage":{"singular":"Ein Element wurde ignoriert.","plural":"{{count}} Elemente wurden ignoriert."}}}');

},{}],"g464e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _drawerNav = require("@form-engine/builder-application/components/drawer-nav");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _reactRouterDom = require("react-router-dom");
var _formListing = require("./components/form-listing");
var _hubView = require("./components/hub-view");
var _hubViewDefault = parcelHelpers.interopDefault(_hubView);
var _sessionLogsListing = require("./components/session-logs-listing");
var _sessionLogsListingDefault = parcelHelpers.interopDefault(_sessionLogsListing);
var _builderTranslations = require("./builder-translations");
exports.default = {
    defaultView: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hubViewDefault.default), {}),
    translations: _builderTranslations,
    routes: {
        hub: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "hub/*",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hubViewDefault.default), {})
        })
    },
    hubNavItems: {
        forms: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerNav.BuilderDrawerNavLink), {
            to: "/",
            i18nLabel: "hub.navItems.forms",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.Briefcase), {})
        }),
        logs: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerNav.BuilderDrawerNavLink), {
            to: "/hub/session-logs",
            i18nLabel: "hub.navItems.logs",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.Stack), {})
        })
    },
    hubRoutes: {
        forms: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formListing.BuilderFormListing), {
                as: (0, _reactBootstrap.Col),
                className: "feb-main-col"
            })
        }),
        logs: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "session-logs/*",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sessionLogsListingDefault.default), {
                as: (0, _reactBootstrap.Col),
                className: "feb-main-col"
            })
        })
    }
};

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-application/components/drawer-nav":"7m4Gf","react":"9njXz","react-bootstrap":"f5rnA","react-bootstrap-icons":"3TzoC","react-router-dom":"cgBkD","./components/form-listing":"6Thxh","./components/hub-view":"1osIm","./components/session-logs-listing":"5XQCn","./builder-translations":"aHXBr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Thxh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderFormListingSortControl", ()=>BuilderFormListingSortControl);
parcelHelpers.export(exports, "BuilderFormListingTagsControl", ()=>BuilderFormListingTagsControl);
parcelHelpers.export(exports, "BuilderFormListingControls", ()=>BuilderFormListingControls);
parcelHelpers.export(exports, "BuilderFormListing", ()=>BuilderFormListing);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _reactRouterDom = require("react-router-dom");
var _fallbackImage = require("./fallback-image");
var _fallbackImageDefault = parcelHelpers.interopDefault(_fallbackImage);
var _useFormApi = require("@form-engine/builder-application/hooks/use-form-api");
var _spinnerBoundary = require("@form-engine/builder-application/components/spinner-boundary");
var _spinnerBoundaryDefault = parcelHelpers.interopDefault(_spinnerBoundary);
var _card = require("@form-engine/builder-application/components/card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _viewHeader = require("../view-header");
var _viewHeaderDefault = parcelHelpers.interopDefault(_viewHeader);
var _advanced = require("@form-engine/builder-application/components/select/advanced");
var _useFormTags = require("@form-engine/builder-application/hooks/use-form-tags");
var _useFormTagsDefault = parcelHelpers.interopDefault(_useFormTags);
var _useApp = require("@form-engine/builder-application/hooks/use-app");
var _importForm = require("../../hooks/import-form");
var _useMounted = require("@form-engine/core-application/hooks/use-mounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _sorting = require("@form-engine/core-util/sorting");
var _builderApplication = require("@form-engine/builder-application");
var _day = require("@form-engine/core-util/day");
function BuilderFormListingItem({ to: toProp, as: asProp = (0, _reactRouterDom.Link), img, children, onClick }) {
    const props = {
        as: asProp
    };
    if (asProp === (0, _reactRouterDom.Link)) props.to = toProp;
    else props.onClick = onClick;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
        md: 6,
        lg: 4,
        xl: 3,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
            ...props,
            children: [
                img && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Img, {
                    variant: "top",
                    src: img
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Body, {
                    className: "w-100",
                    children: children
                })
            ]
        })
    });
}
function BuilderFormListingSortControl({ properties = {}, value = {}, onChange }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Dropdown), {
        className: "feb-sort-control",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Dropdown).Toggle, {
                variant: "link",
                size: "sm",
                children: value.sortProperty ? properties[value.sortProperty]?.label : ''
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Dropdown).Menu, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Dropdown).Header, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                            id: "form-listing.sort-by"
                        })
                    }),
                    Object.entries(properties).map(([sortProperty, { label, type: sortType }])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Dropdown).Item, {
                            disabled: value?.sortProperty === sortProperty,
                            as: "button",
                            onClick: ()=>onChange?.({
                                    sortProperty,
                                    sortType
                                }),
                            children: label
                        }, sortProperty)),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Dropdown).Divider, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Dropdown).Header, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                            id: "form-listing.order"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Dropdown).Item, {
                        disabled: value?.sortOrder === 'desc',
                        as: "button",
                        onClick: ()=>onChange?.({
                                sortOrder: 'desc'
                            }),
                        children: (0, _builderApplication.i18n).c(value?.sortType === 'Date' ? 'form-listing.newest-first' : 'form-listing.descending')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Dropdown).Item, {
                        disabled: value?.sortOrder === 'asc',
                        as: "button",
                        onClick: ()=>onChange?.({
                                sortOrder: 'asc'
                            }),
                        children: (0, _builderApplication.i18n).c(value?.sortType === 'Date' ? 'form-listing.oldest-first' : 'form-listing.ascending')
                    })
                ]
            })
        ]
    });
}
function BuilderFormListingTagsControl({ tags = [], value = [], onChange }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _advanced.BuilderAdvancedFormSelect), {
        className: "text-xs ms-2",
        value: value.map((v)=>({
                value: v,
                label: v
            })),
        onChange: ({ target })=>{
            onChange?.(target?.value?.map(({ value })=>value) ?? []);
        },
        placeholder: (0, _builderApplication.i18n).c('form-listing.tags'),
        options: tags.map((v)=>({
                value: v,
                label: v
            })),
        isMulti: true
    });
}
function BuilderFormListingControls({ tags, settings, onChange }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "feb-form-listing-controls text-xs pb-4 d-flex flex-row",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex-grow-1 d-flex flex-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "feb-formlisting-control-label",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                            id: "form-listing.filter"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormListingTagsControl, {
                        tags: tags,
                        value: settings?.currentTags ?? [],
                        onChange: (currentTags)=>onChange?.({
                                currentTags
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "ms-auto d-flex flex-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "feb-formlisting-control-label",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                            id: "form-listing.sort"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormListingSortControl, {
                        properties: {
                            name: {
                                label: (0, _builderApplication.i18n).c('form-listing.filter-name'),
                                type: 'String'
                            },
                            createdAt: {
                                label: (0, _builderApplication.i18n).c('form-listing.filter-createdAt'),
                                type: 'Date'
                            },
                            updatedAt: {
                                label: (0, _builderApplication.i18n).c('form-listing.filter-updatedAt'),
                                type: 'Date'
                            }
                        },
                        value: settings,
                        onChange: (settingsUpdate)=>onChange?.(settingsUpdate)
                    })
                ]
            })
        ]
    });
}
function useFormListingControl() {
    const { state = [], loading } = (0, _useFormApi.useFormList)();
    const tags = (0, _useFormTagsDefault.default)(state);
    const { state: appState, setItem: setAppStateItem } = (0, _useApp.useAppContext)();
    const controlSettings = appState?.formListingControlSettings ?? {
        sortProperty: 'updatedAt',
        sortType: 'Date',
        sortOrder: 'asc',
        currentTags: []
    };
    const setControlSettings = (0, _react.useCallback)((update)=>{
        setAppStateItem('formListingControlSettings', {
            ...controlSettings ?? {},
            ...update
        });
    }, [
        controlSettings,
        setAppStateItem
    ]);
    const forms = (0, _react.useMemo)(()=>{
        const { currentTags = [], sortProperty = 'updatedAt', sortType = 'Date', sortOrder = 'asc' } = controlSettings ?? {};
        let filteredForms = [
            ...state
        ];
        if (currentTags && currentTags.length) filteredForms = filteredForms.filter((form)=>{
            for (const tag of form?.tags ?? []){
                if (currentTags?.includes(tag)) return true;
            }
            return false;
        });
        if (sortProperty) filteredForms.sort((0, _sorting.createObjectSort)(sortType, sortProperty, sortOrder));
        return filteredForms;
    }, [
        controlSettings,
        state
    ]);
    return {
        tags,
        forms,
        loading,
        controlSettings,
        setControlSettings
    };
}
function BuilderFormListing({ as: Component = 'div', ...props }) {
    const { forms, tags, controlSettings, setControlSettings, loading } = useFormListingControl();
    const importForm = (0, _importForm.useImportForm)();
    const mounted = (0, _useMountedDefault.default)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleImport = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        importForm().then((formDefinition)=>{
            if (!formDefinition?.id || !mounted) return;
            navigate(`/forms/${formDefinition.id}`);
        });
    }, [
        importForm,
        navigate
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "feb-view",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "feb-view-inner p-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Container), {
                    fluid: true,
                    className: "pb-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _viewHeaderDefault.default), {
                            title: (0, _builderApplication.i18n).c('form-listing.title'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormListingItem, {
                                        to: "/new",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
                                            className: "d-flex",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Title, {
                                                            className: "text-xs",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                                                                id: "form-listing.new-form"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Text, {
                                                            className: "text-xs text-black-50",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                                                                id: "form-listing.new-form-subtitle"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                                                    xs: 2,
                                                    className: "align-self-center",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.PlusLg), {})
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormListingItem, {
                                        as: "button",
                                        onClick: handleImport,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
                                            className: "d-flex",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Title, {
                                                            className: "text-xs",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                                                                id: "form-listing.import-form"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Text, {
                                                            className: "text-xs text-black-50",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                                                                id: "form-listing.import-form-subtitle"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                                                    xs: 2,
                                                    className: "align-self-center",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.FileArrowDown), {})
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _spinnerBoundaryDefault.default), {
                            show: loading,
                            bar: false,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderFormListingControls, {
                                    tags: tags,
                                    settings: controlSettings,
                                    onChange: (update)=>setControlSettings(update)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
                                    style: {
                                        ['--bs-gutter-y']: '1.5rem'
                                    },
                                    children: forms.map(({ id, name, updatedAt, tags, thumbnail })=>{
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(BuilderFormListingItem, {
                                            img: thumbnail ?? (0, _fallbackImageDefault.default),
                                            to: `/forms/${id}`,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Title, {
                                                    className: "text-xs",
                                                    children: name
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Card).Text, {
                                                    className: "text-xs text-black-50",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                                                            id: "form-listing.edited",
                                                            date: (0, _day.formatDistanceToNow)(new Date(updatedAt ?? ''))
                                                        }),
                                                        ' ',
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        (tags ?? []).map((tag)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Badge), {
                                                                pill: true,
                                                                bg: "secondary",
                                                                className: "me-1 mt-1",
                                                                children: tag
                                                            }, tag))
                                                    ]
                                                })
                                            ]
                                        }, id);
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","react-bootstrap-icons":"3TzoC","react-router-dom":"cgBkD","./fallback-image":"e1mDQ","@form-engine/builder-application/hooks/use-form-api":"3uteJ","@form-engine/builder-application/components/spinner-boundary":"eYtmG","@form-engine/builder-application/components/card":"bbNfc","../view-header":"i9ALu","@form-engine/builder-application/components/select/advanced":"h5QTD","@form-engine/builder-application/hooks/use-form-tags":"dMj0H","@form-engine/builder-application/hooks/use-app":"8Rocb","../../hooks/import-form":"btaml","@form-engine/core-application/hooks/use-mounted":"kHM7H","@form-engine/core-util/sorting":"9tp3A","@form-engine/builder-application":"7iKr0","@form-engine/core-util/day":"fgtKF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e1mDQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = `data:image/svg+xml;utf8,
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 75">
  <g transform="translate(67,30)">
  <path fill="rgba(0,0,0,.2)" d="M2 10h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm9-9h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm0 9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3zm0-10a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-3zM2 9a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H2zm7 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3zM0 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.354.854a.5.5 0 1 0-.708-.708L3 3.793l-.646-.647a.5.5 0 1 0-.708.708l1 1a.5.5 0 0 0 .708 0l2-2z"></path>
  </g>
  <rect fill="rgba(233,236,239,.5)" width="150" height="75" />
</svg>`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i9ALu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderHubViewHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function BuilderHubViewHeader({ children, title, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ...props,
        className: `${props.className ?? ''} feb-view-header`,
        children: [
            title && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                className: "m-0 pb-3 pt-3",
                children: title
            }),
            children && /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                className: "mb-3 text-muted"
            }),
            children && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "pb-5",
                children: children
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dMj0H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useFormTags);
var _react = require("react");
function useFormTags(forms) {
    return (0, _react.useMemo)(()=>{
        const list = [];
        for (const { tags } of forms ?? [])if (Array.isArray(tags) && tags.length) {
            for (const tag of tags)if (!list.includes(tag)) list.push(tag);
        }
        list.sort((a, b)=>a.localeCompare(b));
        return list;
    }, [
        forms
    ]);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1osIm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderHubView);
var _jsxRuntime = require("react/jsx-runtime");
var _useIdentity = require("@form-engine/builder-application/hooks/use-identity");
var _useIdentityDefault = parcelHelpers.interopDefault(_useIdentity);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
// import { Search } from 'react-bootstrap-icons';
var _reactRouterDom = require("react-router-dom");
var _appViewNavbar = require("@form-engine/builder-application/components/app-view-navbar");
var _appViewNavbarDefault = parcelHelpers.interopDefault(_appViewNavbar);
var _drawer = require("@form-engine/builder-application/components/drawer");
var _drawerDefault = parcelHelpers.interopDefault(_drawer);
var _drawerNav = require("@form-engine/builder-application/components/drawer-nav");
var _drawerNavDefault = parcelHelpers.interopDefault(_drawerNav);
var _appCol = require("@form-engine/builder-application/components/app-col");
var _appColDefault = parcelHelpers.interopDefault(_appCol);
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
var _action = require("../app-settings/action");
var _actionDefault = parcelHelpers.interopDefault(_action);
function BuilderHubView() {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { logout, identity } = (0, _useIdentityDefault.default)();
    const handleLogout = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        logout();
        navigate('/');
    }, [
        navigate,
        logout
    ]);
    const showSettings = (0, _actionDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appViewNavbarDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "w-100",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                                className: "d-flex",
                                sm: 6
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                                className: "d-flex",
                                sm: 6,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.NavDropdown), {
                                    menuVariant: "dark",
                                    className: "ms-auto navdropdown-end",
                                    title: identity?.name || identity?.email,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.NavDropdown).Item, {
                                            as: "button",
                                            onClick: handleLogout,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                                                id: "hub.navbar-logout"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.NavDropdown).Item, {
                                            as: "button",
                                            onClick: showSettings,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                                                id: "hub.navbar-settings"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Container), {
                fluid: true,
                className: "feb-form-editor-layout",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
                    children: [
                        Boolean((0, _builderApplicationDefault.default)?.hubNavItems) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appColDefault.default), {
                            md: 2,
                            border: "right",
                            id: "hubLeftCol",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerDefault.default), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerNavDefault.default), {
                                    children: Boolean((0, _builderApplicationDefault.default)?.hubNavItems) && Object.entries((0, _builderApplicationDefault.default).hubNavItems).map(([key, navItem])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(navItem.type, {
                                            ...navItem?.props || {}
                                        }, key))
                                })
                            })
                        }),
                        Boolean((0, _builderApplicationDefault.default)?.hubRoutes) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Routes), {
                            children: Boolean((0, _builderApplicationDefault.default)?.hubRoutes) && Object.entries((0, _builderApplicationDefault.default).hubRoutes).map(([key, route])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(route.type, {
                                    ...route?.props ?? {}
                                }, key))
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-application/hooks/use-identity":"4vzl8","react":"9njXz","react-bootstrap":"f5rnA","react-router-dom":"cgBkD","@form-engine/builder-application/components/app-view-navbar":"lExmn","@form-engine/builder-application/components/drawer":"5q6lh","@form-engine/builder-application/components/drawer-nav":"7m4Gf","@form-engine/builder-application/components/app-col":"3S4TJ","@form-engine/builder-application":"7iKr0","../app-settings/action":"3UdE4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3UdE4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppSettingsDialog", ()=>AppSettingsDialog);
parcelHelpers.export(exports, "default", ()=>useAppSettingsAction);
parcelHelpers.export(exports, "ACTION_NAME", ()=>ACTION_NAME);
parcelHelpers.export(exports, "useAction", ()=>useAction);
parcelHelpers.export(exports, "useActionHotkey", ()=>useActionHotkey);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useHotkey = require("@form-engine/builder-application/hooks/use-hotkey");
var _keybindings = require("@form-engine/builder-application/keybindings");
var _builderApplication = require("@form-engine/builder-application");
var _modal = require("@form-engine/builder-application/components/modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _dialog = require("@form-engine/builder-application/components/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _useApp = require("@form-engine/builder-application/hooks/use-app");
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _enum = require("@form-engine/builder-mask/components/properties/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
function AppSettingsDialog({ title = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
    id: "app-settings.title"
}), ...props }) {
    const maskValue = (0, _useMask.getMaskProviderValueFromStore)((0, _useApp.useAppContext)());
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
        ...props,
        title: title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useMask.MaskProvider), {
            value: maskValue,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                propertyName: "locale",
                options: [
                    [
                        'default',
                        'English'
                    ],
                    [
                        'de',
                        'German'
                    ]
                ],
                required: true
            })
        })
    });
}
function useAppSettingsAction() {
    return (0, _react.useCallback)(()=>{
        (0, _dialogDefault.default)({
            as: AppSettingsDialog
        });
    }, []);
}
const ACTION_NAME = 'app.settings.show';
(0, _keybindings.setHotkey)(ACTION_NAME, 'ctrl+shift+p,meta+shift+p');
const useAction = useAppSettingsAction;
function useActionHotkey() {
    (0, _useHotkey.useHotkey)(ACTION_NAME, useAction());
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-application/hooks/use-hotkey":"cIBSk","@form-engine/builder-application/keybindings":"3o7P8","@form-engine/builder-application":"7iKr0","@form-engine/builder-application/components/modal":"fvHxn","@form-engine/builder-application/components/dialog":"e4X5a","@form-engine/builder-application/hooks/use-app":"8Rocb","@form-engine/builder-mask/hooks/use-mask":"72MTY","@form-engine/builder-mask/components/properties/enum":"2kNfK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5XQCn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exportLogsAsFile", ()=>exportLogsAsFile);
parcelHelpers.export(exports, "useExportLogsCallback", ()=>useExportLogsCallback);
parcelHelpers.export(exports, "default", ()=>BuilderSessionLogsListing);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _spinnerBoundary = require("@form-engine/builder-application/components/spinner-boundary");
var _spinnerBoundaryDefault = parcelHelpers.interopDefault(_spinnerBoundary);
var _day = require("@form-engine/core-util/day");
var _card = require("@form-engine/builder-application/components/card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _useApiModel = require("@form-engine/builder-application/hooks/use-api-model");
var _reactRouterDom = require("react-router-dom");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _useFormApi = require("@form-engine/builder-application/hooks/use-form-api");
var _select = require("@form-engine/builder-application/components/select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _viewHeader = require("../view-header");
var _viewHeaderDefault = parcelHelpers.interopDefault(_viewHeader);
var _builderApplication = require("@form-engine/builder-application");
var _useSessionLogApi = require("@form-engine/builder-application/hooks/use-session-log-api");
var _useSessionLogApiDefault = parcelHelpers.interopDefault(_useSessionLogApi);
var _builderIconButton = require("@form-engine/builder-icon-button");
var _builderIconButtonDefault = parcelHelpers.interopDefault(_builderIconButton);
var _detail = require("./detail");
var _detailDefault = parcelHelpers.interopDefault(_detail);
function exportLogsAsFile(source, filename = 'export.json', type = 'application/json') {
    const data = source.map((log)=>{
        try {
            return {
                ...log,
                value: log.value ? JSON.parse(log.value) : undefined
            };
        } catch  {
            console.warn('exporting invalid log ', log.id);
            return log;
        }
    });
    const blob = new Blob([
        JSON.stringify(data, undefined, 2)
    ], {
        type
    });
    const toggle = document.createElement('a');
    toggle.download = filename;
    toggle.href = URL.createObjectURL(blob);
    toggle.click();
}
function useExportLogsCallback(listOptions) {
    const logsApi = (0, _useSessionLogApiDefault.default)();
    return (0, _react.useCallback)(async ()=>{
        const logs = await logsApi.list(listOptions);
        console.log(logs);
        exportLogsAsFile(logs, `${logs[0]?.sessionId || 'untitled'}.json`);
    }, [
        listOptions
    ]);
}
function BuilderSessionLogsListingItem({ path, items, activeLogId }) {
    const [initialItem] = items;
    const handleExport = useExportLogsCallback((0, _react.useMemo)(()=>({
            attributes: [
                'id',
                'formId',
                'sessionId',
                'value',
                'createdAt'
            ],
            sort: {
                createdAt: 'asc'
            },
            filter: {
                sessionId: initialItem?.sessionId
            }
        }), []));
    if (!initialItem) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
        xs: 12,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h6", {
                className: "py-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "d-flex flex-row align-items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: initialItem.form?.name
                            }),
                            ' ',
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderIconButtonDefault.default), {
                                onClick: handleExport,
                                title: (0, _builderApplication.i18n).c('session-logs.group.export'),
                                className: "text-muted text-xs p-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ArrowDownCircle), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-muted text-xs mt-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                            id: "session-logs.item.submitted",
                            date: (0, _day.formatDistanceToNow)(new Date(initialItem.createdAt ?? ''))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "d-flex flex-column gap-2",
                children: items.map((item)=>{
                    const workflow = item.workflowId ? item.form?.workflowLayers?.find((wfl)=>wfl.id === item.workflowId) : undefined;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
                        as: (0, _reactRouterDom.Link),
                        to: `${path}/${item.id}`,
                        className: activeLogId === item.id ? 'active' : '',
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Card).Body, {
                            children: [
                                item.form && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Card).Title, {
                                    className: "text-xs",
                                    children: [
                                        workflow?.name ?? '',
                                        ' ',
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "text-muted",
                                            children: [
                                                "#",
                                                item.id?.slice(0, 8)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Text, {
                                    className: "text-xs text-black-50",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                                        id: "session-logs.item.submitted",
                                        date: (0, _day.formatDistanceToNow)(new Date(item.updatedAt ?? ''))
                                    })
                                })
                            ]
                        })
                    }, item.id);
                })
            })
        ]
    });
}
function useLogList() {
    const [formFilter, setFormFilter] = (0, _react.useState)([]);
    const { state: forms = [], loading: formsLoading } = (0, _useFormApi.useFormList)((0, _react.useMemo)(()=>({
            attributes: [
                'id',
                'name',
                'updatedAt',
                'createdAt',
                'tags',
                'thumbnail',
                'workflowLayers'
            ]
        }), []));
    const listParams = (0, _react.useMemo)(()=>{
        const params = {
            attributes: [
                'id',
                'createdAt',
                'updatedAt',
                'formId',
                'sessionId',
                'workflowId'
            ],
            filter: {
                sessionId: {
                    $ne: null
                }
            }
        };
        if (!formFilter.length) return params;
        params.filter ??= {};
        params.filter.formId = {
            $in: formFilter.map((option)=>option.value)
        };
        return params;
    }, [
        formFilter
    ]);
    const { state: logs = [], next, complete, loading: logsLoading } = (0, _useApiModel.useProgressiveList)((0, _useSessionLogApiDefault.default)(), listParams);
    const state = (0, _react.useMemo)(()=>{
        return logs.map((log)=>({
                ...log,
                form: forms.find((form)=>form.id === log.formId)
            })).filter((log)=>Boolean(log.form)).sort((a, b)=>new Date(b.createdAt ?? '').getTime() - new Date(a.createdAt ?? '').getTime());
    }, [
        forms,
        logs
    ]);
    return {
        loading: formsLoading || logsLoading,
        formFilter,
        setFormFilter,
        forms,
        logs: state,
        next,
        complete
    };
}
function BuilderSessionLogsListing({ as: Component = 'div', path = '/hub/session-logs', showDetail = true, detailProps = {}, ...props }) {
    const { logs = [], forms = [], loading, complete, next, formFilter, setFormFilter } = useLogList();
    const { '*': activeLogId } = (0, _reactRouterDom.useParams)();
    const sessionMap = (0, _react.useMemo)(()=>{
        const result = new Map();
        for (const log of logs){
            if (!log.sessionId) continue;
            if (!result.has(log.sessionId)) result.set(log.sessionId, []);
            result.get(log.sessionId)?.push(log);
        }
        for (const logs of result.values())logs.sort((a, b)=>Date.parse(a.createdAt ?? '') - Date.parse(b.createdAt ?? ''));
        return result;
    }, [
        logs
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                ...props,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "feb-view",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "feb-view-inner p-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Container), {
                            fluid: true,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _viewHeaderDefault.default), {
                                    title: (0, _builderApplication.i18n).c('session-logs.title'),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default).Advanced, {
                                        className: "text-xs",
                                        style: {
                                            position: 'sticky'
                                        },
                                        value: formFilter,
                                        onChange: ({ target })=>setFormFilter(target.value),
                                        placeholder: (0, _builderApplication.i18n).c('session-logs.filter'),
                                        options: forms.map((form)=>({
                                                value: form.id,
                                                label: form.name
                                            })),
                                        isMulti: true
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _spinnerBoundaryDefault.default), {
                                    show: loading,
                                    bar: false,
                                    children: [
                                        logs.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
                                            style: {
                                                ['--bs-gutter-y']: '.75rem'
                                            },
                                            children: Array.from(sessionMap.entries()).map(([sessionId, items])=>{
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderSessionLogsListingItem, {
                                                    items: items,
                                                    activeLogId: activeLogId,
                                                    path: path
                                                }, sessionId);
                                            })
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-center text-muted",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                                                id: "session-logs.no-logs"
                                            })
                                        }),
                                        !complete && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-center my-3",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Button), {
                                                size: "sm",
                                                onClick: next,
                                                variant: "outline-dark",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                                                        id: "session-logs.more"
                                                    }),
                                                    ' ',
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ArrowDownCircle), {})
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            showDetail && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Routes), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: ":id",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailDefault.default), {
                        id: "sessionLogDetailCol",
                        closePath: path,
                        ...detailProps
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-bootstrap":"f5rnA","@form-engine/builder-application/components/spinner-boundary":"eYtmG","@form-engine/core-util/day":"fgtKF","@form-engine/builder-application/components/card":"bbNfc","@form-engine/builder-application/hooks/use-api-model":"fNNgP","react-router-dom":"cgBkD","react-bootstrap-icons":"3TzoC","@form-engine/builder-application/hooks/use-form-api":"3uteJ","@form-engine/builder-application/components/select":"38vFU","../view-header":"i9ALu","@form-engine/builder-application":"7iKr0","@form-engine/builder-application/hooks/use-session-log-api":"ls471","@form-engine/builder-icon-button":"1BXFC","./detail":"3oLwP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ls471":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useSessionLogApi);
parcelHelpers.export(exports, "useSessionLogEntity", ()=>useSessionLogEntity);
parcelHelpers.export(exports, "DEFAULT_SESSION_LOG_LIST_OPTIONS", ()=>DEFAULT_SESSION_LOG_LIST_OPTIONS);
parcelHelpers.export(exports, "refreshSessionLogs", ()=>refreshSessionLogs);
parcelHelpers.export(exports, "useSessionLogList", ()=>useSessionLogList);
var _useApiModel = require("./use-api-model");
var _useApiModelDefault = parcelHelpers.interopDefault(_useApiModel);
var _emitter = require("@form-engine/core-util/emitter");
function useSessionLogApi() {
    return (0, _useApiModelDefault.default)('session-log');
}
function useSessionLogEntity(id) {
    return (0, _useApiModel.useEntity)(useSessionLogApi(), id);
}
const DEFAULT_SESSION_LOG_LIST_OPTIONS = {
    attributes: [
        'id',
        'createdAt',
        'updatedAt',
        'formId',
        'sessionId'
    ]
};
const emitter = (0, _emitter.createEmitter)();
const refreshSessionLogs = emitter.emit;
function useSessionLogList(options = DEFAULT_SESSION_LOG_LIST_OPTIONS) {
    const list = (0, _useApiModel.useList)(useSessionLogApi(), options);
    (0, _emitter.useEmitter)(emitter, list.refresh);
    return list;
}

},{"./use-api-model":"fNNgP","@form-engine/core-util/emitter":"9G5Og","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3oLwP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderSessionLogDetailView);
var _jsxRuntime = require("react/jsx-runtime");
var _appCol = require("@form-engine/builder-application/components/app-col");
var _appColDefault = parcelHelpers.interopDefault(_appCol);
var _drawer = require("@form-engine/builder-application/components/drawer");
var _drawerDefault = parcelHelpers.interopDefault(_drawer);
var _drawerTabs = require("@form-engine/builder-application/components/drawer-tabs");
var _drawerTabsDefault = parcelHelpers.interopDefault(_drawerTabs);
var _spinnerBoundary = require("@form-engine/builder-application/components/spinner-boundary");
var _spinnerBoundaryDefault = parcelHelpers.interopDefault(_spinnerBoundary);
var _useFormApi = require("@form-engine/builder-application/hooks/use-form-api");
var _useSessionLogApi = require("@form-engine/builder-application/hooks/use-session-log-api");
var _useForm = require("@form-engine/core-application/hooks/use-form");
var _useFormsession = require("@form-engine/core-application/hooks/use-formsession");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _reactRouterDom = require("react-router-dom");
var _builderApplication = require("@form-engine/builder-application");
var _ = require(".");
var _coreApplication = require("@form-engine/core-application");
var _coreApplicationDefault = parcelHelpers.interopDefault(_coreApplication);
var _engine = require("@form-engine/core-application/components/engine");
var _sessionDrawer = require("@form-engine/builder-form-editor/components/session-drawer");
var _useFormEditor = require("@form-engine/builder-form-editor/hooks/use-form-editor");
function BuilderFormSessionDataList({ children }) {
    const { state: elements = [] } = (0, _useForm.useFormElements)();
    const inputElements = (0, _react.useMemo)(()=>{
        const fields = (0, _coreApplicationDefault.default).getFieldElements();
        return elements.filter((element)=>element.type in fields);
    }, [
        elements
    ]);
    const values = (0, _useFormsession.useFormSessionValues)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Table), {
        striped: true,
        className: "mb-0 text-xs",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tbody", {
            children: [
                children,
                inputElements.map((element)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                children: (element?.label || element?.name) ?? ''
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                children: element?.name && (typeof values[element.name] === 'string' ? values[element.name] : JSON.stringify(values[element.name], null, 2))
                            })
                        ]
                    }, element.id);
                })
            ]
        })
    });
}
function BuilderSessionLogFormValues({ log = {}, form = {} }) {
    const info = (0, _react.useMemo)(()=>{
        try {
            return JSON.parse(log?.value ?? 'null');
        } catch  {
            return null;
        }
    }, [
        log?.value
    ]);
    if (!form) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "feb-view m-0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "feb-view-inner p-0",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useForm.FormProvider), {
                    value: form,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useFormsession.FormSessionProvider), {
                        value: info?.session || {},
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(BuilderFormSessionDataList, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Form"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            children: form?.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Workflow ID"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            children: info?.definition?.name
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}
function BuilderSessionLogScope({ log = {}, form = {} }) {
    const info = (0, _react.useMemo)(()=>{
        try {
            return JSON.parse(log?.value ?? 'null');
        } catch  {
            return null;
        }
    }, [
        log?.value
    ]);
    const workflow = (0, _react.useMemo)(()=>({}), []);
    const editor = (0, _react.useMemo)(()=>({}), []);
    if (!form) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useFormEditor.FormEditorProvider), {
        value: editor,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _engine.FormEngineStateProvider), {
            form: form,
            session: info.session,
            workflow: workflow,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sessionDrawer.BuilderSessionTree), {})
        })
    });
}
function BuilderSessionLogDetailView({ as: Component = (0, _appColDefault.default), closePath, ...props }) {
    const { id } = (0, _reactRouterDom.useParams)();
    const { state: log = {}, loading } = (0, _useSessionLogApi.useSessionLogEntity)(id);
    const { state: form = {}, loading: loadingForm } = (0, _useFormApi.useFormEntity)(log?.formId);
    const [view, setView] = (0, _reactDefault.default).useState('formValues');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Component, {
        md: 4,
        border: "left",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _drawerTabsDefault.default), {
                items: {
                    formValues: 'Form Values',
                    session: (0, _builderApplication.i18n).c('session-logs.item.session-info')
                },
                activeKey: view,
                onSelect: (key)=>setView(key),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Item, {
                        className: "ms-auto",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Link, {
                            as: 'button',
                            onClick: ()=>log && (0, _.exportLogsAsFile)([
                                    log
                                ], `${log.id}.json`),
                            title: (0, _builderApplication.i18n).c('session-logs.item.export'),
                            className: "pe-1",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.ArrowDownCircle), {})
                        })
                    }),
                    closePath && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Item, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Link, {
                            as: (0, _reactRouterDom.Link),
                            to: closePath,
                            className: "ps-1",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.XLg), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _spinnerBoundaryDefault.default), {
                show: loading || loadingForm,
                bar: false,
                children: [
                    view === 'formValues' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderSessionLogFormValues, {
                        log: log,
                        form: form
                    }),
                    view === 'session' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderSessionLogScope, {
                        log: log,
                        form: form
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/builder-application/components/app-col":"3S4TJ","@form-engine/builder-application/components/drawer":"5q6lh","@form-engine/builder-application/components/drawer-tabs":"5gJGr","@form-engine/builder-application/components/spinner-boundary":"eYtmG","@form-engine/builder-application/hooks/use-form-api":"3uteJ","@form-engine/builder-application/hooks/use-session-log-api":"ls471","@form-engine/core-application/hooks/use-form":"5PZyy","@form-engine/core-application/hooks/use-formsession":"2Th33","react":"9njXz","react-bootstrap":"f5rnA","react-bootstrap-icons":"3TzoC","react-router-dom":"cgBkD","@form-engine/builder-application":"7iKr0",".":"5XQCn","@form-engine/core-application":"fjN6J","@form-engine/core-application/components/engine":"8IyYu","@form-engine/builder-form-editor/components/session-drawer":"fhe3j","@form-engine/builder-form-editor/hooks/use-form-editor":"4pkiD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aHXBr":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"ik53l","./de.json":"jLOLA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ik53l":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"form-listing":{"title":"Form Projects","sort":"Sort","sort-by":"Sort by","order":"Order","newest-first":"Newest first","descending":"Descending","oldest-first":"Oldest first","ascending":"ascending","tags":"Tags","filter":"Filter:","filter-name":"Name","filter-createdAt":"Created At","filter-updatedAt":"Updated At","new-form":"New Form Project","new-form-subtitle":"Design and Prototype","import-form":"Import existing Project","import-form-subtitle":"Import a \\".xfe\\" file","edited":"Edited {{date}} ago"},"hub":{"navbar-logout":"Logout","navbar-settings":"Settings\u2026","navItems":{"forms":"Forms","logs":"Logs"}},"session-logs":{"title":"Logs","filter":"Filter Projects","no-logs":"No logs available","more":"More","item":{"submitted":"Submitted {{date}} ago","session-info":"Session Data","export":"Export this log"},"group":{"export":"Export all logs of this session"}},"app-settings":{"title":"Builder Settings","locale":"Locale","hotkeys":"Hotkeys"},"import-form":{"corrupted-error":"File could not be imported and might be corrupted.","version-error":"File is was created in an older version of Form Engine","importing":"Importing\u2026","success":"Import successful"}}');

},{}],"jLOLA":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"form-listing":{"title":"Formularprojekte","sort":"Sortieren","sort-by":"Sortieren nach","order":"Befehl","newest-first":"Das neuste zuerst","descending":"Absteigend","oldest-first":"Die \xe4ltesten zu erst","ascending":"aufsteigend","tags":"Stichworte","filter":"Filter:","filter-name":"Name","filter-createdAt":"Hergestellt in","filter-updatedAt":"Aktualisiert am","new-form":"Neues Formularprojekt","new-form-subtitle":"Design und Prototyp","import-form":"Vorhandenes Projekt importieren","import-form-subtitle":"Importieren Sie eine \u201E.xfe\u201C-Datei","edited":"Vor {{date}} bearbeitet"},"hub":{"navbar-logout":"Ausloggen","navItems":{"forms":"Formen","logs":"Protokolle"}},"session-logs":{"title":"Protokolle","filter":"Projekte filtern","no-logs":"Keine Protokolle verf\xfcgbar","more":"Mehr","item":{"submitted":"Vor {{date}} eingereicht","session-info":"Sitzungsdaten","export":"Dieses Ereignissprotokoll exportieren"},"group":{"export":"Alle Ereignissprotokolle dieser exportieren"}},"app-settings":{"title":"Builder Einstellungen","locale":"Sprache","hotkeys":"Hotkeys"},"import-form":{"corrupted-error":"Die Datei konnte nicht importiert werden und ist m\xf6glicherweise besch\xe4digt.","version-error":"Die Datei wurde in einer \xe4lteren Version von Form Engine erstellt.","importing":"Importiere\u2026","success":"Import erfolgreich"}}');

},{}],"gqrmd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _builderTranslations = require("./builder-translations");
var _formMaskExtension = require("./components/form-mask-extension");
var _formMaskExtensionDefault = parcelHelpers.interopDefault(_formMaskExtension);
exports.default = {
    translations: _builderTranslations,
    bsoThemes: {
        FlowApp: {
            className: 'fet-flowapp'
        },
        Bdp: {
            className: 'fet-bdp'
        },
        Portal: {
            className: 'fet-portal'
        },
        PortalGray: {
            className: 'fet-portal-gray'
        }
    },
    componentExtensions: {
        BuilderFormMask: {
            BsoFormMaskExtension: {
                placement: 'after',
                component: (0, _formMaskExtensionDefault.default)
            }
        }
    },
    maskConfigurations: {
        BuilderFormMask: {
            edit: {
                permissions: {
                    bsoEnvironment: 'write',
                    bsoAuth: 'write',
                    bsoBasicAuthUsername: 'write',
                    bsoBasicAuthPassword: 'write',
                    bsoBearerToken: 'write'
                }
            },
            preview: {
                permissions: {
                    bsoEnvironment: 'write',
                    bsoAuth: 'write',
                    bsoBasicAuthUsername: 'write',
                    bsoBasicAuthPassword: 'write',
                    bsoBearerToken: 'write'
                }
            },
            translate: {
                permissions: {
                    bsoEnvironment: 'read',
                    bsoAuth: 'read',
                    bsoBasicAuthUsername: 'read',
                    bsoBasicAuthPassword: 'read',
                    bsoBearerToken: 'read'
                }
            }
        }
    }
};

},{"./builder-translations":"hYtcl","./components/form-mask-extension":"dlKN3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYtcl":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"60jtV","./de.json":"8nVw1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"60jtV":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"mask\":{\"BsoCore\":{\"formGroupTitle\":\"BSO\",\"bsoEnvironment\":\"Environment\",\"bsoAuth\":\"Auth Method\",\"bsoBasicAuthUsername\":\"Username\",\"bsoBasicAuthPassword\":\"Password\",\"bsoBearerToken\":\"Bearer Token\",\"bsoTheme\":\"Theme\"}}}");

},{}],"8nVw1":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"mask\":{\"BsoCore\":{\"formGroupTitle\":\"BSO\",\"bsoEnvironment\":\"Umfeld\",\"bsoAuth\":\"Auth-Methode\",\"bsoBasicAuthUsername\":\"Nutzername\",\"bsoBasicAuthPassword\":\"Passwort\",\"bsoBearerToken\":\"Inhaber-Token\",\"bsoTheme\":\"Theme\"}}}");

},{}],"dlKN3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BsoFormMaskExtension);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _enum = require("@form-engine/builder-mask/components/properties/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _string = require("@form-engine/builder-mask/components/properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _builderApplication = require("@form-engine/builder-application");
var _themes = require("../../utilities/themes");
var _formatCase = require("@form-engine/core-util/format-case");
function BsoFormMaskExtension() {
    const { state } = (0, _useMask.useMaskContext)();
    const { c } = (0, _builderApplication.i18n).prefix('mask.BsoCore.');
    const themeOptions = (0, _react.useMemo)(()=>{
        return Object.entries((0, _themes.getBsoThemes)()).map(([value, def])=>[
                def.className ?? '',
                def.name ?? (0, _formatCase.formatTitleCase)(value)
            ]);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
        label: c('formGroupTitle'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                propertyName: "bsoEnvironment",
                label: c('bsoEnvironment'),
                options: [
                    [
                        ''
                    ],
                    [
                        'Dev'
                    ],
                    [
                        'Stage'
                    ],
                    [
                        'Qa'
                    ],
                    [
                        'Prod'
                    ]
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                propertyName: "bsoAuth",
                label: c('bsoAuth'),
                options: [
                    [
                        '',
                        'none'
                    ],
                    [
                        'basic'
                    ],
                    [
                        'bearer'
                    ]
                ]
            }),
            state?.bsoAuth === 'basic' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        compilable: true,
                        propertyName: "bsoBasicAuthUsername",
                        label: c('bsoBasicAuthUsername')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        compilable: true,
                        propertyName: "bsoBasicAuthPassword",
                        label: c('bsoBasicAuthPassword'),
                        type: "password"
                    })
                ]
            }),
            state?.bsoAuth === 'bearer' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                    compilable: true,
                    propertyName: "bsoBearerToken",
                    label: c('bsoBearerToken')
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                propertyName: "bsoTheme",
                label: c('bsoTheme'),
                options: themeOptions
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/properties/enum":"2kNfK","@form-engine/builder-mask/hooks/use-mask":"72MTY","@form-engine/builder-mask/components/properties/string":"e6M7S","@form-engine/builder-application":"7iKr0","../../utilities/themes":"avTaS","@form-engine/core-util/format-case":"2G0oK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avTaS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBsoThemes", ()=>getBsoThemes);
var _builderApplication = require("@form-engine/builder-application");
var _builderApplicationDefault = parcelHelpers.interopDefault(_builderApplication);
function getBsoThemes() {
    return (0, _builderApplicationDefault.default)?.bsoThemes ?? {};
}

},{"@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ewf5P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _attachmentsBuilderElement = require("./components/attachments-builder-element");
var _attachmentsBuilderElementDefault = parcelHelpers.interopDefault(_attachmentsBuilderElement);
var _builderTranslations = require("./builder-translations");
exports.default = {
    translations: _builderTranslations,
    elements: {
        [(0, _attachmentsBuilderElementDefault.default).Element.apiName]: (0, _attachmentsBuilderElementDefault.default)
    },
    maskConfigurations: {
        [(0, _attachmentsBuilderElementDefault.default).Element.apiName]: {
            edit: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    disabled: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    label: 'write',
                    showError: 'write',
                    bsoOrigin: 'write',
                    bsoCategory: 'write',
                    accept: 'write',
                    multiple: 'write',
                    renderAsList: 'write',
                    listSettings: 'write',
                    validationMaxAttachmentSize: 'write',
                    validationMaxAttachments: 'write',
                    required: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            preview: {
                permissions: {
                    name: 'write',
                    hidden: 'write',
                    disabled: 'write',
                    width: 'write',
                    marginTop: 'write',
                    marginRight: 'write',
                    marginBottom: 'write',
                    marginLeft: 'write',
                    label: 'write',
                    showError: 'write',
                    bsoOrigin: 'write',
                    bsoCategory: 'write',
                    accept: 'write',
                    multiple: 'write',
                    renderAsList: 'write',
                    listSettings: 'write',
                    validationMaxAttachmentSize: 'write',
                    validationMaxAttachments: 'write',
                    required: 'write',
                    requiredExpressions: 'write',
                    hiddenExpressions: 'write'
                }
            },
            translate: {
                permissions: {
                    name: 'read',
                    hidden: 'read',
                    disabled: 'read',
                    width: 'read',
                    marginTop: 'read',
                    marginRight: 'read',
                    marginBottom: 'read',
                    marginLeft: 'read',
                    label: 'write',
                    showError: 'read',
                    bsoOrigin: 'read',
                    bsoCategory: 'read',
                    accept: 'read',
                    multiple: 'read',
                    renderAsList: 'read',
                    listSettings: 'read',
                    validationMaxAttachmentSize: 'read',
                    validationMaxAttachments: 'read',
                    required: 'read',
                    requiredExpressions: 'read',
                    hiddenExpressions: 'read'
                }
            }
        }
    }
};

},{"./components/attachments-builder-element":"brMA8","./builder-translations":"9zMb7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"brMA8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "label", ()=>label);
parcelHelpers.export(exports, "Element", ()=>(0, _attachmentsElementDefault.default));
parcelHelpers.export(exports, "DrawerButton", ()=>(0, _drawerButtonDefault.default));
parcelHelpers.export(exports, "Mask", ()=>(0, _maskDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _reactBootstrapIcons.CloudUpload));
var _drawerButton = require("./drawer-button");
var _drawerButtonDefault = parcelHelpers.interopDefault(_drawerButton);
var _mask = require("./mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _attachmentsElement = require("../attachments-element");
var _attachmentsElementDefault = parcelHelpers.interopDefault(_attachmentsElement);
var _reactBootstrapIcons = require("react-bootstrap-icons");
const label = `${(0, _attachmentsElementDefault.default).apiName}.title`;
exports.default = {
    label,
    DrawerButton: (0, _drawerButtonDefault.default),
    Mask: (0, _maskDefault.default),
    Element: (0, _attachmentsElementDefault.default),
    Icon: (0, _reactBootstrapIcons.CloudUpload)
};

},{"./drawer-button":"65uBU","./mask":"3AiAV","../attachments-element":"3NvWx","react-bootstrap-icons":"3TzoC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"65uBU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderInputElementDrawerButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@form-engine/builder-form-editor/components/elements-drawer/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _index = require("./index");
var _builderApplication = require("@form-engine/builder-application");
const ctor = (overrides = {})=>({
        id: '',
        type: (0, _index.Element).apiName,
        ...overrides
    });
function BuilderInputElementDrawerButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
        ...props,
        constructor: ctor,
        dragLabel: (0, _builderApplication.i18n).c((0, _index.label)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {}),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderApplication.i18n).Node, {
                id: (0, _index.label)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-form-editor/components/elements-drawer/button":"lldAk","./index":"brMA8","@form-engine/builder-application":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3AiAV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderInputElementMask);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mask = require("@form-engine/builder-mask/components/mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _group = require("@form-engine/builder-mask/components/mask/group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _appearance = require("@form-engine/builder-mask/components/groups/appearance");
var _appearanceDefault = parcelHelpers.interopDefault(_appearance);
var _conditions = require("@form-engine/builder-mask/components/groups/conditions");
var _conditionsDefault = parcelHelpers.interopDefault(_conditions);
var _validation = require("@form-engine/builder-mask/components/groups/validation");
var _validationDefault = parcelHelpers.interopDefault(_validation);
var _boolean = require("@form-engine/builder-mask/components/properties/boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
var _enum = require("@form-engine/builder-mask/components/properties/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _label = require("@form-engine/builder-mask/components/properties/label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _string = require("@form-engine/builder-mask/components/properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _index = require("@form-engine/bso-cxp-attachments-client/dist/index");
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _ = require(".");
var _builderApplication = require("@form-engine/builder-application");
var _multiInputMask = require("./multi-input-mask");
var _multiInputMaskDefault = parcelHelpers.interopDefault(_multiInputMask);
const { FormHandler: DefaultOrigin, ...Origins } = (0, _index.AttachmentOriginEnum);
const { Other: DefaultCateogry, ...Categories } = (0, _index.AttachmentCategoryEnum);
function BuilderInputElementMask(props) {
    const { multiple = false, renderAsList = false } = (0, _useMask.useMaskContext)()?.state ?? {};
    const { c } = (0, _builderApplication.i18n).prefix(`mask.${(0, _.Element).apiName}.`);
    const isInputList = multiple && renderAsList;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _maskDefault.default), {
        id: (0, _.Element).apiName,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appearanceDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _groupDefault.default), {
                label: c('groupTitle'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "showError",
                        label: c('showError')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                        propertyName: "bsoOrigin",
                        label: c('bsoOrigin'),
                        options: [
                            [
                                '',
                                DefaultOrigin
                            ],
                            ...Object.values(Origins).map((value)=>[
                                    value
                                ])
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "multiple",
                        label: c('multiple')
                    }),
                    multiple && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                        propertyName: "renderAsList",
                        label: c('renderAsList')
                    }),
                    isInputList ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multiInputMaskDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                                propertyName: "bsoCategory",
                                label: c('bsoCategory'),
                                options: [
                                    [
                                        '',
                                        DefaultCateogry
                                    ],
                                    ...Object.values(Categories).map((value)=>[
                                            value
                                        ])
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                                propertyName: "accept",
                                label: c('accept'),
                                placeholder: c('acceptPlaceholder')
                            })
                        ]
                    })
                ]
            }),
            !renderAsList && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _validationDefault.default), {
                contentType: false,
                length: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        type: "number",
                        step: "1",
                        propertyName: "validationMaxAttachmentSize",
                        label: c('validationMaxAttachmentSize')
                    }),
                    multiple && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                        type: "number",
                        step: "1",
                        propertyName: "validationMaxAttachments",
                        label: c('validationMaxAttachments')
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditionsDefault.default), {
                requiredExpressions: !isInputList
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@form-engine/builder-mask/components/mask":"kcLv4","@form-engine/builder-mask/components/mask/group":"1nZOW","@form-engine/builder-mask/components/groups/appearance":"krT6N","@form-engine/builder-mask/components/groups/conditions":"cw0Md","@form-engine/builder-mask/components/groups/validation":"jzCix","@form-engine/builder-mask/components/properties/boolean":"k2UVH","@form-engine/builder-mask/components/properties/enum":"2kNfK","@form-engine/builder-mask/components/properties/label":"hDKxg","@form-engine/builder-mask/components/properties/string":"e6M7S","@form-engine/bso-cxp-attachments-client/dist/index":"hrWO4","@form-engine/builder-mask/hooks/use-mask":"72MTY",".":"brMA8","@form-engine/builder-application":"7iKr0","./multi-input-mask":"ew3BG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hrWO4":[function(require,module,exports,__globalThis) {
'use strict';
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ('get' in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== 'default' && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, '__esModule', {
    value: true
});
/* tslint:disable */ /* eslint-disable */ __exportStar(require("33770a93f67a0ab6"), exports);
__exportStar(require("3d701225adee93d2"), exports);
__exportStar(require("1cdf3205e7a3b4e3"), exports);
/* custom code */ __exportStar(require("d44bbcc0511137eb"), exports);
__exportStar(require("ea87c246330be420"), exports);

},{"33770a93f67a0ab6":"3c2jQ","3d701225adee93d2":"4lAch","1cdf3205e7a3b4e3":"cLhIP","d44bbcc0511137eb":"7mVm4","ea87c246330be420":"eUTfy"}],"3c2jQ":[function(require,module,exports,__globalThis) {
'use strict';
/* tslint:disable */ /* eslint-disable */ /**
 * Attachments API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator['throw'](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.TextApiResponse = exports.BlobApiResponse = exports.VoidApiResponse = exports.JSONApiResponse = exports.COLLECTION_FORMATS = exports.RequiredError = exports.FetchError = exports.ResponseError = exports.BaseAPI = exports.DefaultConfig = exports.Configuration = exports.BASE_PATH = void 0;
exports.exists = exists;
exports.querystring = querystring;
exports.mapValues = mapValues;
exports.canConsumeForm = canConsumeForm;
exports.BASE_PATH = 'https://crm-sf-attachments.prod.connected-biking.cloud/attachments'.replace(/\/+$/, '');
class Configuration {
    constructor(configuration = {}){
        this.configuration = configuration;
    }
    set config(configuration) {
        this.configuration = configuration;
    }
    get basePath() {
        return this.configuration.basePath != null ? this.configuration.basePath : exports.BASE_PATH;
    }
    get fetchApi() {
        return this.configuration.fetchApi;
    }
    get middleware() {
        return this.configuration.middleware || [];
    }
    get queryParamsStringify() {
        return this.configuration.queryParamsStringify || querystring;
    }
    get username() {
        return this.configuration.username;
    }
    get password() {
        return this.configuration.password;
    }
    get apiKey() {
        const apiKey = this.configuration.apiKey;
        if (apiKey) return typeof apiKey === 'function' ? apiKey : ()=>apiKey;
        return undefined;
    }
    get accessToken() {
        const accessToken = this.configuration.accessToken;
        if (accessToken) return typeof accessToken === 'function' ? accessToken : ()=>__awaiter(this, void 0, void 0, function*() {
                return accessToken;
            });
        return undefined;
    }
    get headers() {
        return this.configuration.headers;
    }
    get credentials() {
        return this.configuration.credentials;
    }
}
exports.Configuration = Configuration;
exports.DefaultConfig = new Configuration();
/**
 * This is the base class for all generated API classes.
 */ class BaseAPI {
    constructor(configuration = exports.DefaultConfig){
        this.configuration = configuration;
        this.fetchApi = (url, init)=>__awaiter(this, void 0, void 0, function*() {
                let fetchParams = {
                    url,
                    init
                };
                for (const middleware of this.middleware)if (middleware.pre) fetchParams = (yield middleware.pre(Object.assign({
                    fetch: this.fetchApi
                }, fetchParams))) || fetchParams;
                let response = undefined;
                try {
                    response = yield (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
                } catch (e) {
                    for (const middleware of this.middleware)if (middleware.onError) response = (yield middleware.onError({
                        fetch: this.fetchApi,
                        url: fetchParams.url,
                        init: fetchParams.init,
                        error: e,
                        response: response ? response.clone() : undefined
                    })) || response;
                    if (response !== undefined) throw new FetchError(e, 'The request failed and the interceptors did not return an alternative response');
                }
                for (const middleware of this.middleware)if (middleware.post) response = (yield middleware.post({
                    fetch: this.fetchApi,
                    url: fetchParams.url,
                    init: fetchParams.init,
                    response: response.clone()
                })) || response;
                return response;
            });
        this.middleware = configuration.middleware;
    }
    withMiddleware(...middlewares) {
        const next = this.clone();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }
    withPreMiddleware(...preMiddlewares) {
        const middlewares = preMiddlewares.map((pre)=>({
                pre
            }));
        return this.withMiddleware(...middlewares);
    }
    withPostMiddleware(...postMiddlewares) {
        const middlewares = postMiddlewares.map((post)=>({
                post
            }));
        return this.withMiddleware(...middlewares);
    }
    request(context, initOverrides) {
        return __awaiter(this, void 0, void 0, function*() {
            const { url, init } = yield this.createFetchParams(context, initOverrides);
            const response = yield this.fetchApi(url, init);
            if (response.status >= 200 && response.status < 300) return response;
            throw new ResponseError(response, 'Response returned an error code');
        });
    }
    createFetchParams(context, initOverrides) {
        return __awaiter(this, void 0, void 0, function*() {
            let url = this.configuration.basePath + context.path;
            if (context.query !== undefined && Object.keys(context.query).length !== 0) // only add the querystring to the URL if there are query parameters.
            // this is done to avoid urls ending with a "?" character which buggy webservers
            // do not handle correctly sometimes.
            url += '?' + this.configuration.queryParamsStringify(context.query);
            const headers = Object.assign({}, this.configuration.headers, context.headers);
            Object.keys(headers).forEach((key)=>headers[key] === undefined ? delete headers[key] : {});
            const initOverrideFn = typeof initOverrides === 'function' ? initOverrides : ()=>__awaiter(this, void 0, void 0, function*() {
                    return initOverrides;
                });
            const initParams = {
                method: context.method,
                headers,
                body: context.body,
                credentials: this.configuration.credentials
            };
            const overridedInit = Object.assign(Object.assign({}, initParams), (yield initOverrideFn({
                init: initParams,
                context
            })));
            const init = Object.assign(Object.assign({}, overridedInit), {
                body: isFormData(overridedInit.body) || overridedInit.body instanceof URLSearchParams || isBlob(overridedInit.body) ? overridedInit.body : JSON.stringify(overridedInit.body)
            });
            return {
                url,
                init
            };
        });
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */ clone() {
        const constructor = this.constructor;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
}
exports.BaseAPI = BaseAPI;
function isBlob(value) {
    return typeof Blob !== 'undefined' && value instanceof Blob;
}
function isFormData(value) {
    return typeof FormData !== 'undefined' && value instanceof FormData;
}
class ResponseError extends Error {
    constructor(response, msg){
        super(msg);
        this.response = response;
        this.name = 'ResponseError';
    }
}
exports.ResponseError = ResponseError;
class FetchError extends Error {
    constructor(cause, msg){
        super(msg);
        this.cause = cause;
        this.name = 'FetchError';
    }
}
exports.FetchError = FetchError;
class RequiredError extends Error {
    constructor(field, msg){
        super(msg);
        this.field = field;
        this.name = 'RequiredError';
    }
}
exports.RequiredError = RequiredError;
exports.COLLECTION_FORMATS = {
    csv: ',',
    ssv: ' ',
    tsv: '\t',
    pipes: '|'
};
function exists(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
}
function querystring(params, prefix = '') {
    return Object.keys(params).map((key)=>querystringSingleKey(key, params[key], prefix)).filter((part)=>part.length > 0).join('&');
}
function querystringSingleKey(key, value, keyPrefix = '') {
    const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
    if (value instanceof Array) {
        const multiValue = value.map((singleValue)=>encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
        return `${encodeURIComponent(fullKey)}=${multiValue}`;
    }
    if (value instanceof Set) {
        const valueAsArray = Array.from(value);
        return querystringSingleKey(key, valueAsArray, keyPrefix);
    }
    if (value instanceof Date) return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
    if (value instanceof Object) return querystring(value, fullKey);
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function mapValues(data, fn) {
    return Object.keys(data).reduce((acc, key)=>Object.assign(Object.assign({}, acc), {
            [key]: fn(data[key])
        }), {});
}
function canConsumeForm(consumes) {
    for (const consume of consumes){
        if ('multipart/form-data' === consume.contentType) return true;
    }
    return false;
}
class JSONApiResponse {
    constructor(raw, transformer = (jsonValue)=>jsonValue){
        this.raw = raw;
        this.transformer = transformer;
    }
    value() {
        return __awaiter(this, void 0, void 0, function*() {
            return this.transformer((yield this.raw.json()));
        });
    }
}
exports.JSONApiResponse = JSONApiResponse;
class VoidApiResponse {
    constructor(raw){
        this.raw = raw;
    }
    value() {
        return __awaiter(this, void 0, void 0, function*() {
            return undefined;
        });
    }
}
exports.VoidApiResponse = VoidApiResponse;
class BlobApiResponse {
    constructor(raw){
        this.raw = raw;
    }
    value() {
        return __awaiter(this, void 0, void 0, function*() {
            return yield this.raw.blob();
        });
    }
}
exports.BlobApiResponse = BlobApiResponse;
class TextApiResponse {
    constructor(raw){
        this.raw = raw;
    }
    value() {
        return __awaiter(this, void 0, void 0, function*() {
            return yield this.raw.text();
        });
    }
}
exports.TextApiResponse = TextApiResponse;

},{}],"4lAch":[function(require,module,exports,__globalThis) {
'use strict';
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ('get' in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== 'default' && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, '__esModule', {
    value: true
});
/* tslint:disable */ /* eslint-disable */ __exportStar(require("c91209b96bde67af"), exports);

},{"c91209b96bde67af":"ctFMt"}],"ctFMt":[function(require,module,exports,__globalThis) {
'use strict';
/* tslint:disable */ /* eslint-disable */ /**
 * Attachments API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator['throw'](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.AttachmentApi = void 0;
const runtime = require("5c352413bfe50c32");
const models_1 = require("49409b56377373a2");
/**
 *
 */ class AttachmentApi extends runtime.BaseAPI {
    /**
     * Add a new Attachment
     */ addAttachmentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function*() {
            if (requestParameters.body === null || requestParameters.body === undefined) throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling addAttachment.');
            const queryParameters = {};
            if (requestParameters.allOrNone !== undefined) queryParameters['allOrNone'] = requestParameters.allOrNone;
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) headerParameters['Authorization'] = 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password);
            if (this.configuration && this.configuration.accessToken) // oauth required
            headerParameters['Authorization'] = yield this.configuration.accessToken('ciam', [
                'crm:sf-api'
            ]);
            const response = yield this.request({
                path: `/`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body.map(models_1.AttachmentDTOToJSON)
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue)=>jsonValue.map(models_1.AttachmentResponseFromJSON));
        });
    }
    /**
     * Add a new Attachment
     */ addAttachment(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function*() {
            const response = yield this.addAttachmentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns a single Attachment
     * Find Attachment by ID
     */ getAttachmentByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function*() {
            if (requestParameters.id === null || requestParameters.id === undefined) throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getAttachmentById.');
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) headerParameters['Authorization'] = 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password);
            if (this.configuration && this.configuration.accessToken) // oauth required
            headerParameters['Authorization'] = yield this.configuration.accessToken('ciam', [
                'crm:sf-api'
            ]);
            const response = yield this.request({
                path: `/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue)=>(0, models_1.AttachmentResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Returns a single Attachment
     * Find Attachment by ID
     */ getAttachmentById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function*() {
            const response = yield this.getAttachmentByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.AttachmentApi = AttachmentApi;

},{"5c352413bfe50c32":"3c2jQ","49409b56377373a2":"cLhIP"}],"cLhIP":[function(require,module,exports,__globalThis) {
'use strict';
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ('get' in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== 'default' && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, '__esModule', {
    value: true
});
/* tslint:disable */ /* eslint-disable */ __exportStar(require("4503b4c878a1bdd"), exports);
__exportStar(require("125d97bdcf01658b"), exports);
__exportStar(require("2e808778d3dae6af"), exports);
__exportStar(require("980a82de2845487e"), exports);
__exportStar(require("502729940bbc34f8"), exports);

},{"4503b4c878a1bdd":"2R3Of","125d97bdcf01658b":"9zJj4","2e808778d3dae6af":"c7qB8","980a82de2845487e":"3f5Qj","502729940bbc34f8":"7gDVA"}],"2R3Of":[function(require,module,exports,__globalThis) {
'use strict';
/* tslint:disable */ /* eslint-disable */ /**
 * Attachments API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.AttachmentCategoryEnum = exports.AttachmentOriginEnum = void 0;
exports.instanceOfAttachment = instanceOfAttachment;
exports.AttachmentFromJSON = AttachmentFromJSON;
exports.AttachmentFromJSONTyped = AttachmentFromJSONTyped;
exports.AttachmentToJSON = AttachmentToJSON;
const runtime_1 = require("5a303fb02ef6d3f3");
const AttachmentRedirectUrls_1 = require("829e131fb472c06a");
/**
 * @export
 */ exports.AttachmentOriginEnum = {
    EmailAttachment: 'EmailAttachment',
    BdpTool: 'BdpTool',
    PcTool: 'PcTool',
    AgentUpload: 'AgentUpload',
    FormHandler: 'FormHandler',
    BusinessPortal: 'BusinessPortal'
};
/**
 * @export
 */ exports.AttachmentCategoryEnum = {
    DiagnosticReport: 'DiagnosticReport',
    InvoiceDocument: 'InvoiceDocument',
    ShippingDocument: 'ShippingDocument',
    Letter: 'Letter',
    PictureReference: 'PictureReference',
    BugReport: 'BugReport',
    Other: 'Other',
    Unclassified: 'Unclassified',
    ServiceForms: 'ServiceForms',
    RegistrationDocument: 'RegistrationDocument',
    ShopInside: 'ShopInside',
    ShopImageMigration: 'ShopImageMigration',
    ShopImage: 'ShopImage'
};
/**
 * Check if a given object implements the Attachment interface.
 */ function instanceOfAttachment(value) {
    let isInstance = true;
    return isInstance;
}
function AttachmentFromJSON(json) {
    return AttachmentFromJSONTyped(json, false);
}
function AttachmentFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        attachmentId: !(0, runtime_1.exists)(json, 'attachmentId') ? undefined : json['attachmentId'],
        bucket: !(0, runtime_1.exists)(json, 'bucket') ? undefined : json['bucket'],
        objectKey: !(0, runtime_1.exists)(json, 'objectKey') ? undefined : json['objectKey'],
        transactionId: !(0, runtime_1.exists)(json, 'transactionId') ? undefined : json['transactionId'],
        referenceId: !(0, runtime_1.exists)(json, 'referenceId') ? undefined : json['referenceId'],
        origin: !(0, runtime_1.exists)(json, 'origin') ? undefined : json['origin'],
        category: !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
        fileName: !(0, runtime_1.exists)(json, 'fileName') ? undefined : json['fileName'],
        fileExtension: !(0, runtime_1.exists)(json, 'fileExtension') ? undefined : json['fileExtension'],
        mimeType: !(0, runtime_1.exists)(json, 'mimeType') ? undefined : json['mimeType'],
        createdAt: !(0, runtime_1.exists)(json, 'createdAt') ? undefined : json['createdAt'],
        uploadUrl: !(0, runtime_1.exists)(json, 'uploadUrl') ? undefined : json['uploadUrl'],
        uploadUrlExpiration: !(0, runtime_1.exists)(json, 'uploadUrlExpiration') ? undefined : json['uploadUrlExpiration'],
        downloadUrl: !(0, runtime_1.exists)(json, 'downloadUrl') ? undefined : json['downloadUrl'],
        downloadUrlExpiration: !(0, runtime_1.exists)(json, 'downloadUrlExpiration') ? undefined : json['downloadUrlExpiration'],
        redirectUrls: !(0, runtime_1.exists)(json, 'redirectUrls') ? undefined : (0, AttachmentRedirectUrls_1.AttachmentRedirectUrlsFromJSON)(json['redirectUrls'])
    };
}
function AttachmentToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        attachmentId: value.attachmentId,
        bucket: value.bucket,
        objectKey: value.objectKey,
        transactionId: value.transactionId,
        referenceId: value.referenceId,
        origin: value.origin,
        category: value.category,
        fileName: value.fileName,
        fileExtension: value.fileExtension,
        mimeType: value.mimeType,
        createdAt: value.createdAt,
        uploadUrl: value.uploadUrl,
        uploadUrlExpiration: value.uploadUrlExpiration,
        downloadUrl: value.downloadUrl,
        downloadUrlExpiration: value.downloadUrlExpiration,
        redirectUrls: (0, AttachmentRedirectUrls_1.AttachmentRedirectUrlsToJSON)(value.redirectUrls)
    };
}

},{"5a303fb02ef6d3f3":"3c2jQ","829e131fb472c06a":"c7qB8"}],"c7qB8":[function(require,module,exports,__globalThis) {
'use strict';
/* tslint:disable */ /* eslint-disable */ /**
 * Attachments API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.instanceOfAttachmentRedirectUrls = instanceOfAttachmentRedirectUrls;
exports.AttachmentRedirectUrlsFromJSON = AttachmentRedirectUrlsFromJSON;
exports.AttachmentRedirectUrlsFromJSONTyped = AttachmentRedirectUrlsFromJSONTyped;
exports.AttachmentRedirectUrlsToJSON = AttachmentRedirectUrlsToJSON;
const runtime_1 = require("b581b6926deef289");
/**
 * Check if a given object implements the AttachmentRedirectUrls interface.
 */ function instanceOfAttachmentRedirectUrls(value) {
    let isInstance = true;
    return isInstance;
}
function AttachmentRedirectUrlsFromJSON(json) {
    return AttachmentRedirectUrlsFromJSONTyped(json, false);
}
function AttachmentRedirectUrlsFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        caseCreate: !(0, runtime_1.exists)(json, 'caseCreate') ? undefined : json['caseCreate'],
        caseUpdate: !(0, runtime_1.exists)(json, 'caseUpdate') ? undefined : json['caseUpdate']
    };
}
function AttachmentRedirectUrlsToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        caseCreate: value.caseCreate,
        caseUpdate: value.caseUpdate
    };
}

},{"b581b6926deef289":"3c2jQ"}],"9zJj4":[function(require,module,exports,__globalThis) {
'use strict';
/* tslint:disable */ /* eslint-disable */ /**
 * Attachments API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.AttachmentDTOCategoryEnum = exports.AttachmentDTOOriginEnum = void 0;
exports.instanceOfAttachmentDTO = instanceOfAttachmentDTO;
exports.AttachmentDTOFromJSON = AttachmentDTOFromJSON;
exports.AttachmentDTOFromJSONTyped = AttachmentDTOFromJSONTyped;
exports.AttachmentDTOToJSON = AttachmentDTOToJSON;
const runtime_1 = require("6bdbf16d21b9f877");
/**
 * @export
 */ exports.AttachmentDTOOriginEnum = {
    EmailAttachment: 'EmailAttachment',
    BdpTool: 'BdpTool',
    PcTool: 'PcTool',
    AgentUpload: 'AgentUpload',
    FormHandler: 'FormHandler',
    BusinessPortal: 'BusinessPortal'
};
/**
 * @export
 */ exports.AttachmentDTOCategoryEnum = {
    DiagnosticReport: 'DiagnosticReport',
    InvoiceDocument: 'InvoiceDocument',
    ShippingDocument: 'ShippingDocument',
    Letter: 'Letter',
    PictureReference: 'PictureReference',
    BugReport: 'BugReport',
    Other: 'Other',
    Unclassified: 'Unclassified',
    ServiceForms: 'ServiceForms',
    RegistrationDocument: 'RegistrationDocument',
    ShopInside: 'ShopInside',
    ShopImageMigration: 'ShopImageMigration',
    ShopImage: 'ShopImage'
};
/**
 * Check if a given object implements the AttachmentDTO interface.
 */ function instanceOfAttachmentDTO(value) {
    let isInstance = true;
    return isInstance;
}
function AttachmentDTOFromJSON(json) {
    return AttachmentDTOFromJSONTyped(json, false);
}
function AttachmentDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        transactionId: !(0, runtime_1.exists)(json, 'transactionId') ? undefined : json['transactionId'],
        referenceId: !(0, runtime_1.exists)(json, 'referenceId') ? undefined : json['referenceId'],
        origin: !(0, runtime_1.exists)(json, 'origin') ? undefined : json['origin'],
        category: !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
        fileName: !(0, runtime_1.exists)(json, 'fileName') ? undefined : json['fileName']
    };
}
function AttachmentDTOToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        transactionId: value.transactionId,
        referenceId: value.referenceId,
        origin: value.origin,
        category: value.category,
        fileName: value.fileName
    };
}

},{"6bdbf16d21b9f877":"3c2jQ"}],"3f5Qj":[function(require,module,exports,__globalThis) {
'use strict';
/* tslint:disable */ /* eslint-disable */ /**
 * Attachments API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.instanceOfAttachmentResponse = instanceOfAttachmentResponse;
exports.AttachmentResponseFromJSON = AttachmentResponseFromJSON;
exports.AttachmentResponseFromJSONTyped = AttachmentResponseFromJSONTyped;
exports.AttachmentResponseToJSON = AttachmentResponseToJSON;
const runtime_1 = require("2979f4fee1ffd48e");
const Attachment_1 = require("373c89eb84105b55");
/**
 * Check if a given object implements the AttachmentResponse interface.
 */ function instanceOfAttachmentResponse(value) {
    let isInstance = true;
    return isInstance;
}
function AttachmentResponseFromJSON(json) {
    return AttachmentResponseFromJSONTyped(json, false);
}
function AttachmentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        success: !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        attachmentId: !(0, runtime_1.exists)(json, 'attachmentId') ? undefined : json['attachmentId'],
        referenceId: !(0, runtime_1.exists)(json, 'referenceId') ? undefined : json['referenceId'],
        response: !(0, runtime_1.exists)(json, 'response') ? undefined : (0, Attachment_1.AttachmentFromJSON)(json['response'])
    };
}
function AttachmentResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        success: value.success,
        attachmentId: value.attachmentId,
        referenceId: value.referenceId,
        response: (0, Attachment_1.AttachmentToJSON)(value.response)
    };
}

},{"2979f4fee1ffd48e":"3c2jQ","373c89eb84105b55":"2R3Of"}],"7gDVA":[function(require,module,exports,__globalThis) {
'use strict';
/* tslint:disable */ /* eslint-disable */ /**
 * Attachments API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.instanceOfErrorResponse = instanceOfErrorResponse;
exports.ErrorResponseFromJSON = ErrorResponseFromJSON;
exports.ErrorResponseFromJSONTyped = ErrorResponseFromJSONTyped;
exports.ErrorResponseToJSON = ErrorResponseToJSON;
const runtime_1 = require("a8b631aac7c8ba39");
/**
 * Check if a given object implements the ErrorResponse interface.
 */ function instanceOfErrorResponse(value) {
    let isInstance = true;
    return isInstance;
}
function ErrorResponseFromJSON(json) {
    return ErrorResponseFromJSONTyped(json, false);
}
function ErrorResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        success: !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        message: !(0, runtime_1.exists)(json, 'message') ? undefined : json['message']
    };
}
function ErrorResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        success: value.success,
        message: value.message
    };
}

},{"a8b631aac7c8ba39":"3c2jQ"}],"7mVm4":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.Server = void 0;
var Server;
(function(Server) {
    Server['Sandbox'] = 'https://p9p3lf0b0l.execute-api.eu-central-1.amazonaws.com/dev/attachments';
    Server['Dev'] = 'https://crm-sf-attachments.dev.connected-biking.cloud/attachments';
    Server['Stage'] = 'https://crm-sf-attachments.stage.connected-biking.cloud/attachments';
    Server['Qa'] = 'https://crm-sf-attachments.qa.connected-biking.cloud/attachments';
    Server['Prod'] = 'https://crm-sf-attachments.prod.connected-biking.cloud/attachments';
})(Server || (exports.Server = Server = {}));

},{}],"eUTfy":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.createApi = createApi;
const server_1 = require("86f33c458926ab5f");
const runtime_1 = require("4f1ccb2d78708e2e");
const cross_fetch_1 = require("9612f3a71199abe5");
function createApi(type, options = {}) {
    var _a, _b, _c;
    const { server: basePath = server_1.Server.Sandbox, auth, username = '', password = '', accessToken = '', fetchApi = cross_fetch_1.default } = options;
    const config = Object.assign(Object.assign({
        fetchApi,
        basePath
    }, (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {}), {
        headers: Object.assign({
            accept: 'application/json'
        }, (_c = (_b = options === null || options === void 0 ? void 0 : options.config) === null || _b === void 0 ? void 0 : _b.headers) !== null && _c !== void 0 ? _c : {})
    });
    if (auth === 'basic') {
        config.username = username;
        config.password = password;
    } else if (auth === 'bearer') config.accessToken = accessToken;
    return new type(new runtime_1.Configuration(config));
}

},{"86f33c458926ab5f":"7mVm4","4f1ccb2d78708e2e":"3c2jQ","9612f3a71199abe5":"elqs3"}],"ew3BG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BsoAttachmentsInputListSettingsProperty);
var _jsxRuntime = require("react/jsx-runtime");
var _bsoCxpAttachmentsClient = require("@form-engine/bso-cxp-attachments-client");
var _index = require("@form-engine/builder-application/index");
var _builderArrayFormControl = require("@form-engine/builder-array-form-control");
var _builderArrayFormControlDefault = parcelHelpers.interopDefault(_builderArrayFormControl);
var _cell = require("@form-engine/builder-array-form-control/components/array-form-control/cell");
var _cellDefault = parcelHelpers.interopDefault(_cell);
var _property = require("@form-engine/builder-mask/components/mask/property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _enum = require("@form-engine/builder-mask/components/properties/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _string = require("@form-engine/builder-mask/components/properties/string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _useMask = require("@form-engine/builder-mask/hooks/use-mask");
var _useMaskConfig = require("@form-engine/builder-mask/hooks/use-mask-config");
var _useMaskValidation = require("@form-engine/builder-mask/hooks/use-mask-validation");
var _react = require("react");
var _attachmentsElement = require("../attachments-element");
var _boolean = require("@form-engine/builder-mask/components/properties/boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
const { Other: DefaultCateogry, ...Categories } = (0, _bsoCxpAttachmentsClient.AttachmentCategoryEnum);
function AttachmentsInputListSettingsCellMask({ value, onChange }) {
    const { c } = (0, _index.i18n).prefix(`mask.${(0, _attachmentsElement.apiName)}.`);
    const [state, setState] = (0, _react.useState)(value);
    (0, _react.useEffect)(()=>{
        setState(value);
    }, [
        value,
        setState
    ]);
    const setItem = (0, _react.useCallback)((newValue)=>{
        setState(newValue);
        onChange?.(newValue);
    }, [
        setState,
        onChange
    ]);
    const setItemProperty = (0, _react.useCallback)((propertyName, newValue)=>{
        setItem({
            ...value ?? {},
            [propertyName]: newValue
        });
    }, [
        setItem,
        value
    ]);
    const api = (0, _react.useMemo)(()=>({
            state,
            setItem,
            setItemProperty
        }), [
        state,
        setItem
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _useMask.MaskProvider), {
        value: api,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enumDefault.default), {
                propertyName: "bsoCategory",
                label: c('bsoCategory'),
                options: [
                    [
                        '',
                        DefaultCateogry
                    ],
                    ...Object.values(Categories).map((value)=>[
                            value
                        ])
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                propertyName: "accept",
                label: c('accept'),
                placeholder: c('acceptPlaceholder')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                type: "number",
                step: "1",
                propertyName: "validationMaxAttachmentSize",
                label: c('validationMaxAttachmentSize')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stringDefault.default), {
                type: "number",
                step: "1",
                defaultValue: "1",
                propertyName: "validationMaxAttachments",
                label: c('validationMaxAttachments')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanDefault.default), {
                propertyName: "required",
                label: c('required')
            })
        ]
    });
}
function AttachmentsInputListSettingsCell({ value, onChange, ...cellProps }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cellDefault.default), {
        ...cellProps,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AttachmentsInputListSettingsCellMask, {
            value,
            onChange
        })
    });
}
function BsoAttachmentsInputListSettingsProperty({ label, propertyName = 'listSettings', ...props }) {
    const { c } = (0, _index.i18n).prefix(`mask.${(0, _attachmentsElement.apiName)}.`);
    const error = (0, _useMaskValidation.useMaskPropertyError)(propertyName);
    const permission = (0, _useMaskConfig.useMaskPropertyPermission)(propertyName);
    const [value, setValue] = (0, _useMask.useMaskProperty)(propertyName, []);
    const cols = (0, _react.useMemo)(()=>{
        return {
            expressions: {
                asModel: true,
                cellComponent: AttachmentsInputListSettingsCell
            }
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertyDefault.default), {
        className: "feb-bso-attachments-input-list-settings-property",
        stacked: true,
        label: label ?? c(propertyName),
        error: error?.message,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _builderArrayFormControlDefault.default), {
            head: false,
            schema: 'object',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            cols: cols,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            value: value,
            onChange: setValue,
            disabled: permission === 'read'
        })
    });
}

},{"react/jsx-runtime":"1dlk8","@form-engine/bso-cxp-attachments-client":"6gOCH","@form-engine/builder-application/index":"7iKr0","@form-engine/builder-array-form-control":"2zkEC","@form-engine/builder-array-form-control/components/array-form-control/cell":"Lhb09","@form-engine/builder-mask/components/mask/property":"dLorN","@form-engine/builder-mask/components/properties/enum":"2kNfK","@form-engine/builder-mask/components/properties/string":"e6M7S","@form-engine/builder-mask/hooks/use-mask":"72MTY","@form-engine/builder-mask/hooks/use-mask-config":"daHU1","@form-engine/builder-mask/hooks/use-mask-validation":"cYKiY","react":"9njXz","../attachments-element":"3NvWx","@form-engine/builder-mask/components/properties/boolean":"k2UVH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6gOCH":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _runtime = require("./runtime");
parcelHelpers.exportAll(_runtime, exports);
var _apis = require("./apis");
parcelHelpers.exportAll(_apis, exports);
var _models = require("./models");
parcelHelpers.exportAll(_models, exports);
/* custom code */ var _server = require("./server");
parcelHelpers.exportAll(_server, exports);
var _createApi = require("./create-api");
parcelHelpers.exportAll(_createApi, exports);

},{"./runtime":false,"./apis":false,"./models":"9IkxR","./server":false,"./create-api":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcSm7":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Attachments API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BASE_PATH", ()=>BASE_PATH);
parcelHelpers.export(exports, "Configuration", ()=>Configuration);
parcelHelpers.export(exports, "DefaultConfig", ()=>DefaultConfig);
/**
 * This is the base class for all generated API classes.
 */ parcelHelpers.export(exports, "BaseAPI", ()=>BaseAPI);
parcelHelpers.export(exports, "ResponseError", ()=>ResponseError);
parcelHelpers.export(exports, "FetchError", ()=>FetchError);
parcelHelpers.export(exports, "RequiredError", ()=>RequiredError);
parcelHelpers.export(exports, "COLLECTION_FORMATS", ()=>COLLECTION_FORMATS);
parcelHelpers.export(exports, "exists", ()=>exists);
parcelHelpers.export(exports, "querystring", ()=>querystring);
parcelHelpers.export(exports, "mapValues", ()=>mapValues);
parcelHelpers.export(exports, "canConsumeForm", ()=>canConsumeForm);
parcelHelpers.export(exports, "JSONApiResponse", ()=>JSONApiResponse);
parcelHelpers.export(exports, "VoidApiResponse", ()=>VoidApiResponse);
parcelHelpers.export(exports, "BlobApiResponse", ()=>BlobApiResponse);
parcelHelpers.export(exports, "TextApiResponse", ()=>TextApiResponse);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator['throw'](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const BASE_PATH = 'https://crm-sf-attachments.prod.connected-biking.cloud/attachments'.replace(/\/+$/, '');
class Configuration {
    constructor(configuration = {}){
        this.configuration = configuration;
    }
    set config(configuration) {
        this.configuration = configuration;
    }
    get basePath() {
        return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
    }
    get fetchApi() {
        return this.configuration.fetchApi;
    }
    get middleware() {
        return this.configuration.middleware || [];
    }
    get queryParamsStringify() {
        return this.configuration.queryParamsStringify || querystring;
    }
    get username() {
        return this.configuration.username;
    }
    get password() {
        return this.configuration.password;
    }
    get apiKey() {
        const apiKey = this.configuration.apiKey;
        if (apiKey) return typeof apiKey === 'function' ? apiKey : ()=>apiKey;
        return undefined;
    }
    get accessToken() {
        const accessToken = this.configuration.accessToken;
        if (accessToken) return typeof accessToken === 'function' ? accessToken : ()=>__awaiter(this, void 0, void 0, function*() {
                return accessToken;
            });
        return undefined;
    }
    get headers() {
        return this.configuration.headers;
    }
    get credentials() {
        return this.configuration.credentials;
    }
}
const DefaultConfig = new Configuration();
class BaseAPI {
    constructor(configuration = DefaultConfig){
        this.configuration = configuration;
        this.fetchApi = (url, init)=>__awaiter(this, void 0, void 0, function*() {
                let fetchParams = {
                    url,
                    init
                };
                for (const middleware of this.middleware)if (middleware.pre) fetchParams = (yield middleware.pre(Object.assign({
                    fetch: this.fetchApi
                }, fetchParams))) || fetchParams;
                let response = undefined;
                try {
                    response = yield (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
                } catch (e) {
                    for (const middleware of this.middleware)if (middleware.onError) response = (yield middleware.onError({
                        fetch: this.fetchApi,
                        url: fetchParams.url,
                        init: fetchParams.init,
                        error: e,
                        response: response ? response.clone() : undefined
                    })) || response;
                    if (response !== undefined) throw new FetchError(e, 'The request failed and the interceptors did not return an alternative response');
                }
                for (const middleware of this.middleware)if (middleware.post) response = (yield middleware.post({
                    fetch: this.fetchApi,
                    url: fetchParams.url,
                    init: fetchParams.init,
                    response: response.clone()
                })) || response;
                return response;
            });
        this.middleware = configuration.middleware;
    }
    withMiddleware(...middlewares) {
        const next = this.clone();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }
    withPreMiddleware(...preMiddlewares) {
        const middlewares = preMiddlewares.map((pre)=>({
                pre
            }));
        return this.withMiddleware(...middlewares);
    }
    withPostMiddleware(...postMiddlewares) {
        const middlewares = postMiddlewares.map((post)=>({
                post
            }));
        return this.withMiddleware(...middlewares);
    }
    request(context, initOverrides) {
        return __awaiter(this, void 0, void 0, function*() {
            const { url, init } = yield this.createFetchParams(context, initOverrides);
            const response = yield this.fetchApi(url, init);
            if (response.status >= 200 && response.status < 300) return response;
            throw new ResponseError(response, 'Response returned an error code');
        });
    }
    createFetchParams(context, initOverrides) {
        return __awaiter(this, void 0, void 0, function*() {
            let url = this.configuration.basePath + context.path;
            if (context.query !== undefined && Object.keys(context.query).length !== 0) // only add the querystring to the URL if there are query parameters.
            // this is done to avoid urls ending with a "?" character which buggy webservers
            // do not handle correctly sometimes.
            url += '?' + this.configuration.queryParamsStringify(context.query);
            const headers = Object.assign({}, this.configuration.headers, context.headers);
            Object.keys(headers).forEach((key)=>headers[key] === undefined ? delete headers[key] : {});
            const initOverrideFn = typeof initOverrides === 'function' ? initOverrides : ()=>__awaiter(this, void 0, void 0, function*() {
                    return initOverrides;
                });
            const initParams = {
                method: context.method,
                headers,
                body: context.body,
                credentials: this.configuration.credentials
            };
            const overridedInit = Object.assign(Object.assign({}, initParams), (yield initOverrideFn({
                init: initParams,
                context
            })));
            const init = Object.assign(Object.assign({}, overridedInit), {
                body: isFormData(overridedInit.body) || overridedInit.body instanceof URLSearchParams || isBlob(overridedInit.body) ? overridedInit.body : JSON.stringify(overridedInit.body)
            });
            return {
                url,
                init
            };
        });
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */ clone() {
        const constructor = this.constructor;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
}
function isBlob(value) {
    return typeof Blob !== 'undefined' && value instanceof Blob;
}
function isFormData(value) {
    return typeof FormData !== 'undefined' && value instanceof FormData;
}
class ResponseError extends Error {
    constructor(response, msg){
        super(msg);
        this.response = response;
        this.name = 'ResponseError';
    }
}
class FetchError extends Error {
    constructor(cause, msg){
        super(msg);
        this.cause = cause;
        this.name = 'FetchError';
    }
}
class RequiredError extends Error {
    constructor(field, msg){
        super(msg);
        this.field = field;
        this.name = 'RequiredError';
    }
}
const COLLECTION_FORMATS = {
    csv: ',',
    ssv: ' ',
    tsv: '\t',
    pipes: '|'
};
function exists(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
}
function querystring(params, prefix = '') {
    return Object.keys(params).map((key)=>querystringSingleKey(key, params[key], prefix)).filter((part)=>part.length > 0).join('&');
}
function querystringSingleKey(key, value, keyPrefix = '') {
    const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
    if (value instanceof Array) {
        const multiValue = value.map((singleValue)=>encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
        return `${encodeURIComponent(fullKey)}=${multiValue}`;
    }
    if (value instanceof Set) {
        const valueAsArray = Array.from(value);
        return querystringSingleKey(key, valueAsArray, keyPrefix);
    }
    if (value instanceof Date) return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
    if (value instanceof Object) return querystring(value, fullKey);
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function mapValues(data, fn) {
    return Object.keys(data).reduce((acc, key)=>Object.assign(Object.assign({}, acc), {
            [key]: fn(data[key])
        }), {});
}
function canConsumeForm(consumes) {
    for (const consume of consumes){
        if ('multipart/form-data' === consume.contentType) return true;
    }
    return false;
}
class JSONApiResponse {
    constructor(raw, transformer = (jsonValue)=>jsonValue){
        this.raw = raw;
        this.transformer = transformer;
    }
    value() {
        return __awaiter(this, void 0, void 0, function*() {
            return this.transformer((yield this.raw.json()));
        });
    }
}
class VoidApiResponse {
    constructor(raw){
        this.raw = raw;
    }
    value() {
        return __awaiter(this, void 0, void 0, function*() {
            return undefined;
        });
    }
}
class BlobApiResponse {
    constructor(raw){
        this.raw = raw;
    }
    value() {
        return __awaiter(this, void 0, void 0, function*() {
            return yield this.raw.blob();
        });
    }
}
class TextApiResponse {
    constructor(raw){
        this.raw = raw;
    }
    value() {
        return __awaiter(this, void 0, void 0, function*() {
            return yield this.raw.text();
        });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9IkxR":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _attachment = require("./Attachment");
parcelHelpers.exportAll(_attachment, exports);
var _attachmentDTO = require("./AttachmentDTO");
parcelHelpers.exportAll(_attachmentDTO, exports);
var _attachmentRedirectUrls = require("./AttachmentRedirectUrls");
parcelHelpers.exportAll(_attachmentRedirectUrls, exports);
var _attachmentResponse = require("./AttachmentResponse");
parcelHelpers.exportAll(_attachmentResponse, exports);
var _errorResponse = require("./ErrorResponse");
parcelHelpers.exportAll(_errorResponse, exports);

},{"./Attachment":"dEZlx","./AttachmentDTO":false,"./AttachmentRedirectUrls":false,"./AttachmentResponse":false,"./ErrorResponse":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dEZlx":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Attachments API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AttachmentOriginEnum", ()=>AttachmentOriginEnum);
parcelHelpers.export(exports, "AttachmentCategoryEnum", ()=>AttachmentCategoryEnum);
/**
 * Check if a given object implements the Attachment interface.
 */ parcelHelpers.export(exports, "instanceOfAttachment", ()=>instanceOfAttachment);
parcelHelpers.export(exports, "AttachmentFromJSON", ()=>AttachmentFromJSON);
parcelHelpers.export(exports, "AttachmentFromJSONTyped", ()=>AttachmentFromJSONTyped);
parcelHelpers.export(exports, "AttachmentToJSON", ()=>AttachmentToJSON);
var _runtime = require("../runtime");
var _attachmentRedirectUrls = require("./AttachmentRedirectUrls");
const AttachmentOriginEnum = {
    EmailAttachment: 'EmailAttachment',
    BdpTool: 'BdpTool',
    PcTool: 'PcTool',
    AgentUpload: 'AgentUpload',
    FormHandler: 'FormHandler',
    BusinessPortal: 'BusinessPortal'
};
const AttachmentCategoryEnum = {
    DiagnosticReport: 'DiagnosticReport',
    InvoiceDocument: 'InvoiceDocument',
    ShippingDocument: 'ShippingDocument',
    Letter: 'Letter',
    PictureReference: 'PictureReference',
    BugReport: 'BugReport',
    Other: 'Other',
    Unclassified: 'Unclassified',
    ServiceForms: 'ServiceForms',
    RegistrationDocument: 'RegistrationDocument',
    ShopInside: 'ShopInside',
    ShopImageMigration: 'ShopImageMigration',
    ShopImage: 'ShopImage'
};
function instanceOfAttachment(value) {
    let isInstance = true;
    return isInstance;
}
function AttachmentFromJSON(json) {
    return AttachmentFromJSONTyped(json, false);
}
function AttachmentFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        attachmentId: !(0, _runtime.exists)(json, 'attachmentId') ? undefined : json['attachmentId'],
        bucket: !(0, _runtime.exists)(json, 'bucket') ? undefined : json['bucket'],
        objectKey: !(0, _runtime.exists)(json, 'objectKey') ? undefined : json['objectKey'],
        transactionId: !(0, _runtime.exists)(json, 'transactionId') ? undefined : json['transactionId'],
        referenceId: !(0, _runtime.exists)(json, 'referenceId') ? undefined : json['referenceId'],
        origin: !(0, _runtime.exists)(json, 'origin') ? undefined : json['origin'],
        category: !(0, _runtime.exists)(json, 'category') ? undefined : json['category'],
        fileName: !(0, _runtime.exists)(json, 'fileName') ? undefined : json['fileName'],
        fileExtension: !(0, _runtime.exists)(json, 'fileExtension') ? undefined : json['fileExtension'],
        mimeType: !(0, _runtime.exists)(json, 'mimeType') ? undefined : json['mimeType'],
        createdAt: !(0, _runtime.exists)(json, 'createdAt') ? undefined : json['createdAt'],
        uploadUrl: !(0, _runtime.exists)(json, 'uploadUrl') ? undefined : json['uploadUrl'],
        uploadUrlExpiration: !(0, _runtime.exists)(json, 'uploadUrlExpiration') ? undefined : json['uploadUrlExpiration'],
        downloadUrl: !(0, _runtime.exists)(json, 'downloadUrl') ? undefined : json['downloadUrl'],
        downloadUrlExpiration: !(0, _runtime.exists)(json, 'downloadUrlExpiration') ? undefined : json['downloadUrlExpiration'],
        redirectUrls: !(0, _runtime.exists)(json, 'redirectUrls') ? undefined : (0, _attachmentRedirectUrls.AttachmentRedirectUrlsFromJSON)(json['redirectUrls'])
    };
}
function AttachmentToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        attachmentId: value.attachmentId,
        bucket: value.bucket,
        objectKey: value.objectKey,
        transactionId: value.transactionId,
        referenceId: value.referenceId,
        origin: value.origin,
        category: value.category,
        fileName: value.fileName,
        fileExtension: value.fileExtension,
        mimeType: value.mimeType,
        createdAt: value.createdAt,
        uploadUrl: value.uploadUrl,
        uploadUrlExpiration: value.uploadUrlExpiration,
        downloadUrl: value.downloadUrl,
        downloadUrlExpiration: value.downloadUrlExpiration,
        redirectUrls: (0, _attachmentRedirectUrls.AttachmentRedirectUrlsToJSON)(value.redirectUrls)
    };
}

},{"../runtime":"gcSm7","./AttachmentRedirectUrls":"nP7Ix","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"nP7Ix":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Attachments API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Check if a given object implements the AttachmentRedirectUrls interface.
 */ parcelHelpers.export(exports, "instanceOfAttachmentRedirectUrls", ()=>instanceOfAttachmentRedirectUrls);
parcelHelpers.export(exports, "AttachmentRedirectUrlsFromJSON", ()=>AttachmentRedirectUrlsFromJSON);
parcelHelpers.export(exports, "AttachmentRedirectUrlsFromJSONTyped", ()=>AttachmentRedirectUrlsFromJSONTyped);
parcelHelpers.export(exports, "AttachmentRedirectUrlsToJSON", ()=>AttachmentRedirectUrlsToJSON);
var _runtime = require("../runtime");
function instanceOfAttachmentRedirectUrls(value) {
    let isInstance = true;
    return isInstance;
}
function AttachmentRedirectUrlsFromJSON(json) {
    return AttachmentRedirectUrlsFromJSONTyped(json, false);
}
function AttachmentRedirectUrlsFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        caseCreate: !(0, _runtime.exists)(json, 'caseCreate') ? undefined : json['caseCreate'],
        caseUpdate: !(0, _runtime.exists)(json, 'caseUpdate') ? undefined : json['caseUpdate']
    };
}
function AttachmentRedirectUrlsToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        caseCreate: value.caseCreate,
        caseUpdate: value.caseUpdate
    };
}

},{"../runtime":"gcSm7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9zMb7":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"847cz","./de.json":"4cIRL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"847cz":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"BsoAttachmentsElement\":{\"title\":\"Attachments Upload\"},\"mask\":{\"BsoAttachmentsElement\":{\"groupTitle\":\"Upload\",\"showError\":\"Show Error\",\"bsoOrigin\":\"Origin\",\"bsoCategory\":\"Category\",\"accept\":\"Accept\",\"acceptPlaceholder\":\"e.g. .doc,.docx,application/msword\",\"multiple\":\"Allow Multiple\",\"renderAsList\":\"Display as List of Inputs\",\"validationMaxAttachmentSize\":\"Max Filesize (MB)\",\"validationMaxAttachments\":\"Max Number of Files\",\"attachmentInputListSettings\":\"Upload Item Settings\",\"required\":\"Required\"}}}");

},{}],"4cIRL":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"BsoAttachmentsElement":{"title":"Anh\xe4nge hochladen"},"mask":{"BsoAttachmentsElement":{"groupTitle":"Hochladen","showError":"Fehler anzeigen","bsoOrigin":"Herkunft","bsoCategory":"Kategorie","accept":"Akzeptieren","acceptPlaceholder":"z.B. .doc,.docx,application/msword","multiple":"Mehrere zulassen","renderAsList":"Als Liste aus Upload-Feldern anzeigen","validationMaxAttachmentSize":"Max. Dateigr\xf6\xdfe (MB)","validationMaxAttachments":"Maximale Anzahl von Dateien","attachmentInputListSettings":"Upload Einstellungen","required":"Erforderlich"}}}');

},{}],"duaVn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderAppWrap);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _appNavbar = require("../app-navbar");
var _appNavbarDefault = parcelHelpers.interopDefault(_appNavbar);
var _useApp = require("../../hooks/use-app");
var _errorBoundary = require("../error-boundary");
var _errorBoundaryDefault = parcelHelpers.interopDefault(_errorBoundary);
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _useIdentity = require("../../hooks/use-identity");
var _useIdentityDefault = parcelHelpers.interopDefault(_useIdentity);
var _loginView = require("../login-view");
var _loginViewDefault = parcelHelpers.interopDefault(_loginView);
var _index = require("../../index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _reactToastify = require("react-toastify");
var _dialog = require("../dialog");
var _spinnerBoundary = require("../spinner-boundary");
function AppStateWriter() {
    const { state } = (0, _useApp.useAppContext)();
    (0, _react.useEffect)(()=>{
        (0, _useApp.appStorage).setItem('default', state);
    }, [
        state
    ]);
    return null;
}
function BuilderToastCloseBtn({ closeToast }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        onClick: closeToast,
        className: "feb-toast__close-btn",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.XLg), {})
    });
}
function useAppLocale() {
    const app = (0, _useApp.useAppContext)();
    const [, setForceUpdate] = (0, _react.useState)(0);
    (0, _react.useEffect)(()=>{
        (0, _indexDefault.default).i18n.setItem('locale', app?.state?.locale);
        setForceUpdate((u)=>u + 1);
    }, [
        app?.state?.locale,
        setForceUpdate
    ]);
    return app?.state?.locale ?? 'default';
}
function BuilderApp({ className = '', ...props }) {
    const { loggedIn, syncAndRenewSession } = (0, _useIdentityDefault.default)();
    const [didSync, setDidSync] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        let mounted = true;
        syncAndRenewSession().then(()=>{
            mounted && setDidSync(true);
        });
        // sync server side identity every minute or half of the default session max age (whatever is shorter)
        const id = setInterval(()=>{
            mounted && syncAndRenewSession();
        }, Math.min(60000, (0, _indexDefault.default).sessionMaxAge / 2));
        return ()=>{
            mounted = false;
            clearInterval(id);
        };
    }, [
        syncAndRenewSession,
        setDidSync
    ]);
    useAppLocale();
    const loggedInContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appNavbarDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Routes), {
                children: [
                    (0, _indexDefault.default).routes && Object.entries((0, _indexDefault.default).routes).map(([key, route])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(route.type, {
                            ...route.props
                        }, key)),
                    (0, _indexDefault.default).defaultView && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "*",
                        element: (0, _indexDefault.default).defaultView
                    })
                ]
            })
        ]
    });
    const loggedOutContent = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Routes), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "*",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginViewDefault.default), {})
        })
    });
    const content = didSync ? loggedIn ? loggedInContent : loggedOutContent : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerBoundary.BuilderSpinnerBar), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AppStateWriter, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
                basename: (0, _indexDefault.default).basename,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    ...props,
                    className: `feb feb-app ${className}`,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundaryDefault.default), {
                            children: content
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactToastify.ToastContainer), {
                            position: "bottom-center",
                            autoClose: 2000,
                            progressStyle: {
                                backgroundColor: 'var(--bs-primary)'
                            },
                            closeButton: BuilderToastCloseBtn
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.DialogContainer), {})
                    ]
                })
            })
        ]
    });
}
function BuilderAppWrap(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useApp.AppProvider), {
        value: (0, _useApp.appStorage).getItem('default', {}),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BuilderApp, {
            ...props
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"cgBkD","../app-navbar":"Njf5k","../../hooks/use-app":"8Rocb","../error-boundary":"hRjxH","react-bootstrap-icons":"3TzoC","../../hooks/use-identity":"4vzl8","../login-view":"ihCK4","../../index":"7iKr0","react-toastify":"iWdY7","../dialog":"e4X5a","../spinner-boundary":"eYtmG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Njf5k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuilderAppNavbar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _useApp = require("../../hooks/use-app");
var _useRouteActive = require("../../hooks/use-route-active");
var _useRouteActiveDefault = parcelHelpers.interopDefault(_useRouteActive);
function CloseTabButton({ id, to, ...props }) {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const active = (0, _useRouteActiveDefault.default)(to);
    const tabs = (0, _useApp.useAppTabs)();
    const handleClick = (0, _react.useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        tabs.toggle({
            id
        }, false);
        if (active) navigate('/');
    }, [
        id,
        active,
        navigate,
        tabs
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        ...props,
        className: "close-tab-btn",
        onClick: handleClick,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.X), {})
    });
}
function BuilderAppNavbar() {
    const tabs = (0, _useApp.useAppTabs)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Navbar), {
            className: "feb-app-navbar",
            bg: "dark",
            variant: "dark",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Container), {
                fluid: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Nav), {
                    className: "me-auto",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Link, {
                            as: (0, _reactRouterDom.NavLink),
                            to: '/',
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.HouseDoorFill), {})
                        }),
                        tabs.open.filter((tab)=>Boolean(tab?.path)).map((tab, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Nav).Link, {
                                as: (0, _reactRouterDom.NavLink),
                                to: tab.path,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: tab.name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CloseTabButton, {
                                        to: tab.path,
                                        id: tab.id
                                    })
                                ]
                            }, index)),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Link, {
                            as: (0, _reactRouterDom.NavLink),
                            to: "/new",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.Plus), {})
                        })
                    ]
                })
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"cgBkD","react-bootstrap":"f5rnA","react-bootstrap-icons":"3TzoC","../../hooks/use-app":"8Rocb","../../hooks/use-route-active":"cVRW4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ihCK4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuilderLogin", ()=>BuilderLogin);
parcelHelpers.export(exports, "BuilderOidcLogin", ()=>BuilderOidcLogin);
parcelHelpers.export(exports, "LOGIN_METHOD_COMPONENTS", ()=>LOGIN_METHOD_COMPONENTS);
parcelHelpers.export(exports, "default", ()=>BuilderLoginView);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useIdentity = require("../../hooks/use-identity");
var _useIdentityDefault = parcelHelpers.interopDefault(_useIdentity);
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapIcons = require("react-bootstrap-icons");
var _ = require("../..");
var _Default = parcelHelpers.interopDefault(_);
function BuilderLogin() {
    const { authWithCredentials, identityError, loading } = (0, _useIdentityDefault.default)();
    const handleSubmit = (0, _react.useCallback)((e)=>{
        if (loading) return;
        e.preventDefault();
        e.stopPropagation();
        const [username, password] = e.target;
        authWithCredentials('basic', {
            username: username.value,
            password: password.value
        });
    }, [
        authWithCredentials,
        loading
    ]);
    const { c, Node } = (0, _.i18n).prefix('login.');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Form), {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FloatingLabel), {
                        label: c('username'),
                        className: "mb-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
                            disabled: loading,
                            type: "text",
                            placeholder: c('usernamePlaceholder'),
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FloatingLabel), {
                        label: c('password'),
                        className: "mb-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.FormControl), {
                            type: "password",
                            placeholder: c('passwordPlaceholder'),
                            required: true,
                            disabled: loading
                        })
                    }),
                    identityError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-danger mb-3 small",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                            id: "identityError"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "d-grid gap-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
                            type: "submit",
                            size: "lg",
                            variant: "primary",
                            disabled: loading,
                            children: loading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Spinner), {
                                        as: "span",
                                        size: "sm",
                                        animation: "border",
                                        role: "status",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "ms-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                                            id: "signInLoading"
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                                id: "signInLabel"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "text-center small mt-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: "mailto:support@die-interaktiven.de",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                        id: "forgotLink"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "d-grid gap-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
                    as: "a",
                    variant: "secondary",
                    href: "mailto:support@die-interaktiven.de",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                        id: "registerLink"
                    })
                })
            })
        ]
    });
}
function BuilderOidcLogin() {
    const { authWithOidc, identityError, loading } = (0, _useIdentityDefault.default)();
    const handleSubmit = (0, _react.useCallback)((e)=>{
        if (loading) return;
        e.preventDefault();
        e.stopPropagation();
        authWithOidc();
    }, [
        authWithOidc,
        loading
    ]);
    const { Node } = (0, _.i18n).prefix('login.');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Form), {
        onSubmit: handleSubmit,
        children: [
            identityError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "text-danger mb-3 small",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                    id: "identityError"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "d-grid gap-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
                    type: "submit",
                    size: "sm",
                    variant: "primary",
                    disabled: loading,
                    children: loading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Spinner), {
                                as: "span",
                                size: "sm",
                                animation: "border",
                                role: "status",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "ms-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                                    id: "signInLoading"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                        id: "signInOidcLabel"
                    })
                })
            })
        ]
    });
}
const LOGIN_METHOD_COMPONENTS = {
    credentials: BuilderLogin,
    oidc: BuilderOidcLogin
};
function BuilderLoginView() {
    const { Node } = (0, _.i18n).prefix('login.');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex-grow-1 w-100 bg-light",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Container), {
            style: {
                marginTop: '25vh',
                maxWidth: '1024px'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
                        md: 8,
                        sm: 6,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                                className: "text-primary mb-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrapIcons.UiChecksGrid), {}),
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                                        id: "heading"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Node, {
                                    id: "lead"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Body, {
                                children: (0, _Default.default).loginMethods.map((method, index, all)=>{
                                    const Component = LOGIN_METHOD_COMPONENTS[method];
                                    if (!Component) throw new Error(`invalid login method ${method}`);
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                                        children: [
                                            Boolean(index !== all.length - 1) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {})
                                        ]
                                    }, index);
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../hooks/use-identity":"4vzl8","react-bootstrap":"f5rnA","react-bootstrap-icons":"3TzoC","../..":"7iKr0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kzXu8":[function() {},{}],"1py55":[function(require,module,exports,__globalThis) {
/**
 * Auto generated import statements, do not modify this file manually
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultJsonDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsonDefault.default));
var _defaultJson = require("./default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _deJson = require("./de.json");
var _deJsonDefault = parcelHelpers.interopDefault(_deJson);

},{"./default.json":"dG4L8","./de.json":"lQMah","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dG4L8":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"login":{"heading":"Form Builder","lead":"Build beautiful forms easily.","forgotLink":"Forgot Password?","registerLink":"Request Access","username":"Username","usernamePlaceholder":"name@mail.com","password":"Password","passwordPlaceholder":"Password","identityError":"The password you entered is incorrect.","signInLoading":"Signing in\u2026","signInLabel":"Sign in","signInOidcLabel":"Sign in with OIDC Provider"},"modal":{"confirm":{"ok":"Ok","cancel":"Cancel"},"form":{"submit":"Submit"}},"explorer":{"add":"Add"}}');

},{}],"lQMah":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"login":{"heading":"Formular-Generator","lead":"Erstellen Sie einfach sch\xf6ne Formulare.","forgotLink":"Passwort vergessen?","registerLink":"Anfrage Zugang","username":"Nutzername","usernamePlaceholder":"name@mail.com","password":"Passwort","passwordPlaceholder":"Passwort","identityError":"Das eingegebene Passwort ist falsch.","signInLoading":"Einloggen\u2026","signInLabel":"Einloggen"},"modal":{"confirm":{"ok":"Ok","cancel":"Absagen"},"form":{"submit":"einreichen"}},"explorer":{"add":"Hinzuf\xfcgen"}}');

},{}]},["7iKr0"], "7iKr0", "parcelRequire94c2")

//# sourceMappingURL=index.js.map
